const kybDetails = {
  "success": true,
  "message": "retrieve_kyb_by_id_success",
  "data": {
    "_id": "65df9b9059af913ca758dd29",
    "status": "APPROVED",
    "riskLevel": "MEDIUM",
    "companyDetails": {
      "name": "STARK BANK S.A. - INSTITUICAO DE PAGAMENTO",
      "documentNumber": "20018183000180",
      "dateOfRegistration": "03/04/2014",
      "emails": [
        "help@starkbank.com"
      ],
      "cnpj": "20.018.183/0001-80",
      "fantasia": "STARK BANK S.A.",
      "capitalSocial": 36494384,
      "responsavel": "",
      "responsavelQualificacao": {
        "id": 16,
        "descricao": "Presidente"
      },
      "simplesNacional": {
        "optante": "Não",
        "inicio": "03/04/2014",
        "fim": "30/09/2018"
      },
      "matrizfilial": {
        "id": 1,
        "tipo": "Matriz"
      },
      "telefones": [
        {
          "ddd": "11",
          "numero": "41164616"
        },
        {
          "ddd": null,
          "numero": null
        }
      ],
      "fax": {
        "ddd": null,
        "numero": null
      },
      "situacao": {
        "id": 2,
        "nome": "Ativa",
        "data": "03/04/2014",
        "motivo": null
      },
      "naturezaJuridica": {
        "codigo": "2054",
        "descricao": "Sociedade Anônima Fechada"
      },
      "cnae": {
        "fiscal": "6619399",
        "secao": "K",
        "divisao": "66",
        "grupo": "66.1",
        "classe": "66.19-3",
        "subClasse": "6619-3/99",
        "descricao": "Outras atividades auxiliares dos serviços financeiros não especificadas anteriormente",
        "secundarias": [
          {
            "id": "6202300",
            "secao": "J",
            "divisao": "62",
            "grupo": "62.0",
            "classe": "62.02-3",
            "subclasse": "6202-3/00",
            "descricao": "Desenvolvimento e licenciamento de programas de computador customizáveis"
          },
          {
            "id": "6203100",
            "secao": "J",
            "divisao": "62",
            "grupo": "62.0",
            "classe": "62.03-1",
            "subclasse": "6203-1/00",
            "descricao": "Desenvolvimento e licenciamento de programas de computador não customizáveis"
          },
          {
            "id": "6463800",
            "secao": "K",
            "divisao": "64",
            "grupo": "64.6",
            "classe": "64.63-8",
            "subclasse": "6463-8/00",
            "descricao": "Outras sociedades de participação, exceto holdings"
          },
          {
            "id": "6499999",
            "secao": "K",
            "divisao": "64",
            "grupo": "64.9",
            "classe": "64.99-9",
            "subclasse": "6499-9/99",
            "descricao": "Outras atividades de serviços financeiros não especificadas anteriormente"
          },
          {
            "id": "6613400",
            "secao": "K",
            "divisao": "66",
            "grupo": "66.1",
            "classe": "66.13-4",
            "subclasse": "6613-4/00",
            "descricao": "Administração de cartões de crédito"
          },
          {
            "id": "7490104",
            "secao": "M",
            "divisao": "74",
            "grupo": "74.9",
            "classe": "74.90-1",
            "subclasse": "7490-1/04",
            "descricao": "Atividades de intermediação e agenciamento de serviços e negócios em geral, exceto imobiliários"
          },
          {
            "id": "8299702",
            "secao": "N",
            "divisao": "82",
            "grupo": "82.9",
            "classe": "82.99-7",
            "subclasse": "8299-7/02",
            "descricao": "Emissão de vales-alimentação, vales-transporte e similares"
          },
          {
            "id": "8299799",
            "secao": "N",
            "divisao": "82",
            "grupo": "82.9",
            "classe": "82.99-7",
            "subclasse": "8299-7/99",
            "descricao": "Outras atividades de serviços prestados principalmente às empresas não especificadas anteriormente"
          }
        ]
      },
      "porte": {
        "id": "05",
        "descricao": "Demais"
      },
      "country": "BR",
      "addresses": [
        {
          "postcode": "01405-900",
          "street": "Rua Pamplona",
          "number": "145",
          "apt_suite": "-",
          "city": "São Paulo",
          "state": "SP",
          "country": "BR"
        }
      ]
    },
    "shareHolders": [
      {
        "_id": "65df9b8e59af913ca758dcd6",
        "emailClient": "superadmin@gueno.com",
        "name": "RAFAEL CASTRO DE MATOS",
        "nationality": "Brazil",
        "documentNumber": "02349014118",
        "type": "PERSON",
        "relationship": {
          "type": "QSA",
          "name": "PRESIDENTE",
          "startDate": "2014-04-03T00:00:00Z",
          "endDate": "2023-09-29T00:00:00Z"
        },
        "status": "IN_PROGRESS",
        "createdAt": "2024-02-28T20:46:06.899Z",
        "updatedAt": "2024-02-29T13:37:34.006Z",
        "relatedCompaniesOwnership": "65df9b9859af913ca758dec5"
      },
      {
        "_id": "65df9b8e59af913ca758dcd8",
        "emailClient": "superadmin@gueno.com",
        "name": "RAFAEL STARK",
        "nationality": "Brazil",
        "documentNumber": "02349014118",
        "type": "PERSON",
        "relationship": {
          "type": "QSA",
          "name": "PRESIDENTE",
          "startDate": "2014-04-03T00:00:00Z",
          "endDate": ""
        },
        "status": "IN_PROGRESS",
        "createdAt": "2024-02-28T20:46:06.903Z",
        "updatedAt": "2024-02-28T20:46:13.686Z",
        "relatedCompaniesOwnership": "65df9b9559af913ca758deb6"
      },
      {
        "_id": "65df9b8e59af913ca758dd02",
        "emailClient": "superadmin@gueno.com",
        "name": "DALTON FELIPE DE MENEZES",
        "nationality": "Brazil",
        "documentNumber": "07639480981",
        "type": "PERSON",
        "relationship": {
          "type": "QSA",
          "name": "DIRETOR",
          "startDate": "2014-04-03T00:00:00Z",
          "endDate": ""
        },
        "status": "IN_PROGRESS",
        "createdAt": "2024-02-28T20:46:06.927Z",
        "updatedAt": "2024-02-28T20:46:17.563Z",
        "relatedCompaniesOwnership": "65df9b9959af913ca758deca"
      },
      {
        "_id": "65df9b8e59af913ca758dd04",
        "emailClient": "superadmin@gueno.com",
        "name": "CAIO ROCHA DOTTORI GASPAR",
        "nationality": "Brazil",
        "documentNumber": "12916747729",
        "type": "PERSON",
        "relationship": {
          "type": "QSA",
          "name": "DIRETOR",
          "startDate": "2014-04-03T00:00:00Z",
          "endDate": ""
        },
        "status": "IN_PROGRESS",
        "createdAt": "2024-02-28T20:46:06.928Z",
        "updatedAt": "2024-02-28T20:46:13.483Z",
        "relatedCompaniesOwnership": "65df9b9559af913ca758dea7"
      },
      {
        "_id": "65df9b9059af913ca758dd26",
        "emailClient": "superadmin@gueno.com",
        "name": "BRUNO LUIZ FERREIRA BRAZ",
        "nationality": "Brazil",
        "documentNumber": "35823023855",
        "type": "PERSON",
        "relationship": {
          "type": "QSA",
          "name": "DIRETOR",
          "startDate": "2014-04-03T00:00:00Z",
          "endDate": ""
        },
        "status": "IN_PROGRESS",
        "createdAt": "2024-02-28T20:46:08.242Z",
        "updatedAt": "2024-02-28T20:46:14.750Z",
        "relatedCompaniesOwnership": "65df9b9659af913ca758dec0"
      },
      {
        "_id": "65df9b8e59af913ca758dcb8",
        "emailClient": "superadmin@gueno.com",
        "name": "MATHEUS COELHO FERRAZ",
        "nationality": "Brazil",
        "documentNumber": "41812844840",
        "type": "PERSON",
        "relationship": {
          "type": "QSA",
          "name": "DIRETOR",
          "startDate": "2014-04-03T00:00:00Z",
          "endDate": ""
        },
        "status": "IN_PROGRESS",
        "createdAt": "2024-02-28T20:46:06.881Z",
        "updatedAt": "2024-02-28T20:46:13.577Z",
        "relatedCompaniesOwnership": "65df9b9559af913ca758deac"
      },
      {
        "_id": "65df9b8e59af913ca758dd06",
        "emailClient": "superadmin@gueno.com",
        "name": "RAFAEL STARK",
        "nationality": "Brazil",
        "documentNumber": "02349014118",
        "type": "PERSON",
        "relationship": {
          "type": "REPRESENTANTELEGAL",
          "name": "",
          "startDate": "2019-06-26T00:00:00Z",
          "endDate": ""
        },
        "status": "IN_PROGRESS",
        "createdAt": "2024-02-28T20:46:06.931Z",
        "updatedAt": "2024-02-28T20:46:13.652Z",
        "relatedCompaniesOwnership": "65df9b9559af913ca758deb1"
      }
    ],
    "timeline": [
      {
        "_id": "65df9b9059af913ca758dd28",
        "emailClient": "superadmin@gueno.com",
        "email": "superadmin@gueno.com",
        "type": "CREATION",
        "description": "KYB process created for the cnpj: 20018183000180",
        "status": "SUCCESS",
        "createdAt": "2024-02-28T20:46:08.244Z",
        "updatedAt": "2024-02-28T20:46:08.244Z"
      },
      {
        "_id": "65df9bc459af913ca758ded5",
        "emailClient": "superadmin@gueno.com",
        "email": "superadmin@gueno.com",
        "type": "CADE",
        "description": "CADE Check for: 20018183000180",
        "status": "SUCCESS",
        "createdAt": "2024-02-28T20:47:00.487Z",
        "updatedAt": "2024-02-28T20:47:00.487Z"
      },
      {
        "_id": "65e07d3b3375e20c5ca4c4e6",
        "emailClient": "superadmin@gueno.com",
        "email": "superadmin@gueno.com",
        "type": "AML",
        "description": "AML Check for: 20018183000180",
        "status": "SUCCESS",
        "createdAt": "2024-02-29T12:48:59.419Z",
        "updatedAt": "2024-02-29T12:48:59.419Z"
      },
      {
        "_id": "65e07d663375e20c5ca4c504",
        "emailClient": "superadmin@gueno.com",
        "email": "superadmin@gueno.com",
        "type": "UPDATE_RISK_LEVEL_KYB",
        "description": "UPDATE_RISK_LEVEL_KYB for: 65df9b9059af913ca758dd29",
        "status": "SUCCESS",
        "createdAt": "2024-02-29T12:49:42.799Z",
        "updatedAt": "2024-02-29T12:49:42.799Z"
      },
      {
        "_id": "65e07d7d3375e20c5ca4c523",
        "emailClient": "superadmin@gueno.com",
        "email": "superadmin@gueno.com",
        "type": "UPDATE_KYB",
        "description": "UPDATE_KYB for: 65df9b9059af913ca758dd29",
        "status": "SUCCESS",
        "createdAt": "2024-02-29T12:50:05.580Z",
        "updatedAt": "2024-02-29T12:50:05.580Z"
      }
    ],
    "comments": [],
    "assignedUsers": [],
    "files": [],
    "createdAt": "2024-02-28T20:46:08.244Z",
    "updatedAt": "2024-02-29T12:50:05.580Z",
    "blacklists": {
      "_id": "65df9b9059af913ca758dd76",
      "emailClient": "superadmin@gueno.com",
      "email": "superadmin@gueno.com",
      "status": "IN_PROGRESS",
      "type": "BLACKLISTS",
      "entity": "BUSINESS",
      "checkDetails": {
        "cpfBlacklist": []
      },
      "createdAt": "2024-02-28T20:46:08.343Z",
      "updatedAt": "2024-02-28T20:46:08.343Z"
    },
    "aml": {
      "_id": "65e07d3b3375e20c5ca4c4e5",
      "emailClient": "superadmin@gueno.com",
      "email": "superadmin@gueno.com",
      "status": "IN_PROGRESS",
      "type": "AML",
      "entity": "BUSINESS",
      "checkDetails": {
        "id": 1648600804,
        "filters": {
          "country_codes": [],
          "entity_type": "company",
          "exact_match": true,
          "fuzziness": 0,
          "remove_deceased": 1,
          "types": [
            "pep-class-1",
            "pep-class-4",
            "pep-class-3",
            "pep",
            "warning",
            "sanction",
            "fitness-probity",
            "pep-class-2"
          ]
        },
        "match_status": "no_match",
        "search_term": "STARK BANK S.A. - INSTITUICAO DE PAGAMENTO",
        "submitted_term": "STARK BANK S.A. - INSTITUICAO DE PAGAMENTO",
        "total_hits": 0,
        "total_matches": 0,
        "total_blacklist_hits": 0,
        "share_url": "https://app.eu.complyadvantage.com/public/search/1709210940-f3W_h1us/e1791a91f684",
        "limit": 10,
        "hits": [],
        "blacklist_hits": []
      },
      "createdAt": "2024-02-29T12:48:59.418Z",
      "updatedAt": "2024-02-29T12:48:59.418Z"
    },
    "debtors": {
      "_id": "65df9b9159af913ca758dd85",
      "emailClient": "superadmin@gueno.com",
      "email": "superadmin@gueno.com",
      "status": "IN_PROGRESS",
      "type": "GOVERNMENT_DEBTORS",
      "entity": "BUSINESS",
      "checkDetails": {
        "TotalDebtValue": 0,
        "TotalDebts": 0,
        "Debts": []
      },
      "createdAt": "2024-02-28T20:46:09.567Z",
      "updatedAt": "2024-02-28T20:46:09.567Z"
    },
    "domains": {
      "_id": "65df9b9159af913ca758dda3",
      "emailClient": "superadmin@gueno.com",
      "email": "superadmin@gueno.com",
      "status": "IN_PROGRESS",
      "type": "DOMAINS",
      "entity": "BUSINESS",
      "checkDetails": {
        "HostName": "server-99-84-221-102.iad79.r.cloudfront.net",
        "DomainName": "methaenergia.com.br",
        "FinalDomainName": "https://www.methaenergia.com.br/",
        "DomainClass": "NEWS",
        "DomainMainSegment": "UTENSILS",
        "VisitorRange": "<1K",
        "ServerTechnology": "CloudFront",
        "DevelopmentLanguage": "",
        "Framework": "Unidentified or no framework",
        "PageCountRange": "0-50",
        "PaymentServices": "",
        "PaymentMethods": "PaymentNote",
        "CreditCards": "",
        "FinancialInstitutions": "",
        "IspName": "Amazon.com Inc.",
        "IspCountry": "United States of America",
        "IspRegion": "Virginia",
        "IspCity": "Dulles",
        "ProductRangeCount": "<10",
        "AvgPrice": "< $ 100",
        "AdNetworks": "",
        "SocialNetworks": "Facebook;Twitter;LinkedIn;Youtube;Instagram",
        "ChatProviders": "",
        "HelpDeskProviders": "",
        "FraudService": "",
        "MappingServices": "",
        "AnalyticsServices": "",
        "RecommendationEngine": "",
        "RegistrationStatus": "",
        "AvgLoadTime": 106.6198,
        "AvgPageSize": 74620,
        "CaptureDate": "2020-11-28T07:01:01.413Z",
        "RegistrationDate": "0001-01-01T00:00:00",
        "ExpirationDate": "9999-12-31T23:59:59.9999999",
        "IsActive": true,
        "HasSsl": true,
        "SslCeritificates": [
          {
            "Issuer": "CN=Amazon, OU=Server CA 1B, O=Amazon, C=US",
            "Subject": "CN=*.methaenergia.com.br",
            "ExpirationDate": "12/3/2021 11:59:59 PM"
          },
          {
            "Issuer": "CN=Amazon, OU=Server CA 1B, O=Amazon, C=US",
            "Subject": "CN=*.methaenergia.com.br",
            "ExpirationDate": "8/17/2021 12:00:00 PM"
          }
        ]
      },
      "createdAt": "2024-02-28T20:46:09.693Z",
      "updatedAt": "2024-02-28T20:46:09.693Z"
    },
    "cepim": {
      "_id": "65df9b9159af913ca758ddf3",
      "emailClient": "superadmin@gueno.com",
      "email": "superadmin@gueno.com",
      "status": "IN_PROGRESS",
      "type": "SANCTIONS_CEPIM",
      "entity": "BUSINESS",
      "checkDetails": {
        "informação": "Sanções de cepim para 20018183000180 não encontradas"
      },
      "createdAt": "2024-02-28T20:46:09.857Z",
      "updatedAt": "2024-02-28T20:46:09.857Z"
    },
    "ceis": {
      "_id": "65df9b9159af913ca758de0c",
      "emailClient": "superadmin@gueno.com",
      "email": "superadmin@gueno.com",
      "status": "IN_PROGRESS",
      "type": "SANCTIONS_CEIS",
      "entity": "BUSINESS",
      "checkDetails": {
        "informação": "Sanções de ceis para 20018183000180 não encontradas"
      },
      "createdAt": "2024-02-28T20:46:09.951Z",
      "updatedAt": "2024-02-28T20:46:09.951Z"
    },
    "kyc": {
      "_id": "65df9b9159af913ca758de11",
      "emailClient": "superadmin@gueno.com",
      "email": "superadmin@gueno.com",
      "status": "IN_PROGRESS",
      "type": "KYC_BUSINESS",
      "entity": "BUSINESS",
      "checkDetails": {
        "PEPHistory": [],
        "IsCurrentlyPEP": false,
        "SanctionsHistory": [
          {
            "Source": "ofac",
            "Type": "Money Laundering",
            "StandardizedSanctionType": "FINANCIAL CRIMES",
            "MatchRate": 61,
            "NameUniquenessScore": 1,
            "Details": {
              "OriginalName": "STARK BANK S.A.",
              "SanctionName": "STARK I",
              "SanctionAliases|MatchRate": "SEMNAN|0;CLOVE|0;SPARROW|0",
              "remarks": "(linked to: national iranian tanker company)"
            },
            "StartDate": "0001-01-01T00:00:00",
            "EndDate": "9999-12-31T23:59:59.9999999",
            "CreationDate": "2024-02-28T03:02:45.908",
            "LastUpdateDate": "2024-02-28T03:02:45.908",
            "IsCurrentlyPresentOnSource": true
          },
          {
            "Source": "ofac",
            "Type": "Money Laundering",
            "StandardizedSanctionType": "FINANCIAL CRIMES",
            "MatchRate": 31,
            "NameUniquenessScore": 1,
            "Details": {
              "OriginalName": "STARK BANK S.A.- INSTITUICAO DE PAGAMENTO",
              "SanctionName": "STARK I",
              "SanctionAliases|MatchRate": "SEMNAN|0;CLOVE|0;SPARROW|0",
              "remarks": "(linked to: national iranian tanker company)"
            },
            "StartDate": "0001-01-01T00:00:00",
            "EndDate": "9999-12-31T23:59:59.9999999",
            "CreationDate": "2024-02-28T03:02:45.908",
            "LastUpdateDate": "2024-02-28T03:02:45.908",
            "IsCurrentlyPresentOnSource": true
          }
        ],
        "IsCurrentlySanctioned": false,
        "WasPreviouslySanctioned": false,
        "Last30DaysSanctions": 0,
        "Last90DaysSanctions": 0,
        "Last180DaysSanctions": 0,
        "Last365DaysSanctions": 0,
        "LastYearPEPOccurence": 0,
        "Last3YearsPEPOccurence": 0,
        "Last5YearsPEPOccurence": 0,
        "Last5PlusYearsPEPOccurence": 0,
        "FirstSanctionDate": "0001-01-01T00:00:00",
        "LastSanctionDate": "0001-01-01T00:00:00"
      },
      "createdAt": "2024-02-28T20:46:09.991Z",
      "updatedAt": "2024-02-28T20:46:09.991Z"
    },
    "leniencyAgreements": {
      "_id": "65df9b9259af913ca758de20",
      "emailClient": "superadmin@gueno.com",
      "email": "superadmin@gueno.com",
      "status": "IN_PROGRESS",
      "type": "SANCTIONS_LENIENCY_AGREEMENTS",
      "entity": "BUSINESS",
      "checkDetails": {
        "informação": "Sanções de acordos-leniencia para 20018183000180 não encontradas"
      },
      "createdAt": "2024-02-28T20:46:10.031Z",
      "updatedAt": "2024-02-28T20:46:10.031Z"
    },
    "cnep": {
      "_id": "65df9b9259af913ca758de25",
      "emailClient": "superadmin@gueno.com",
      "email": "superadmin@gueno.com",
      "status": "IN_PROGRESS",
      "type": "SANCTIONS_CNEP",
      "entity": "BUSINESS",
      "checkDetails": {
        "informação": "Sanções de cnep para 20018183000180 não encontradas"
      },
      "createdAt": "2024-02-28T20:46:10.034Z",
      "updatedAt": "2024-02-28T20:46:10.034Z"
    },
    "serasa": {
      "_id": "65df9b9259af913ca758de8e",
      "emailClient": "superadmin@gueno.com",
      "email": "superadmin@gueno.com",
      "status": "IN_PROGRESS",
      "type": "SERASA_SCORE",
      "entity": "BUSINESS",
      "checkDetails": {
        "cnpj": "20.018.183/0001-80",
        "razao": "STARK BANK S A INSTITUICAO DE PAGAMENTO",
        "risco": {
          "nivel": 2,
          "descricao": "Médio",
          "score": "251-600"
        }
      },
      "createdAt": "2024-02-28T20:46:10.379Z",
      "updatedAt": "2024-02-28T20:46:10.379Z"
    },
    "cdn": {
      "_id": "65df9b9359af913ca758de9d",
      "emailClient": "superadmin@gueno.com",
      "email": "superadmin@gueno.com",
      "status": "IN_PROGRESS",
      "type": "NEGATIVE_DEBT_CERTIFICATES",
      "entity": "BUSINESS",
      "checkDetails": {
        "Status": 1,
        "Mensagem": "Processamento OK - Certidão Encontrada.",
        "Certidao": {
          "TipoContribuinte": 1,
          "ContribuinteCertidao": "20018183000180",
          "TipoCertidao": 1,
          "CodigoControle": "443B95F9D7BCB66A",
          "DataEmissao": "2024-01-22T15:02:46",
          "DataValidade": "2024-07-20"
        }
      },
      "createdAt": "2024-02-28T20:46:11.506Z",
      "updatedAt": "2024-02-28T20:46:11.506Z"
    },
    "negativeMedia": {
      "_id": "65df9b9459af913ca758dea2",
      "emailClient": "superadmin@gueno.com",
      "email": "superadmin@gueno.com",
      "status": "IN_PROGRESS",
      "type": "NEGATIVE_MEDIA_BUSINESS",
      "entity": "BUSINESS",
      "checkDetails": {
        "source1": {
          "MediaExposureLevel": "D",
          "CelebrityLevel": "C",
          "UnpopularityLevel": "H",
          "NewsItems": [],
          "CreationDate": "2019-06-11T17:03:39Z",
          "LastUpdateDate": "2024-02-26T21:57:41.748Z",
          "SearchLabels": {
            "OfficialName": "STARK BANK S.A.- INSTITUICAO DE PAGAMENTO",
            "OfficialNameUniquenessScore": 1,
            "TradeName": "STARK BANK S.A.",
            "TradeNameUniquenessScore": 1
          },
          "Next": "AoJwvO7i/owDP1RodHRwczovL2ZvcmJlcy5jb20uYnIvZm9yYmVzLW1vbmV5LzIwMjQvMDEvNi1pbnZlc3RpZG9yZXMtZS1lbXByZXNhcmlvcy1lbnNpbmFtLXN0YXJ0dXBzLWEtY2FwdGFyLXJlY3Vyc29zLWVtLTIwMjQv",
          "TotalPages": 22,
          "EntityStatistics": {
            "NewsByRangeDate": {
              "TotalNews": 215,
              "TotalNewsOnLast7Days": -1,
              "TotalNewsOnLast30Days": -1,
              "TotalNewsOnLast90Days": -1,
              "TotalNewsOnLast180Days": -1,
              "TotalNewsOnLast365Days": -1
            }
          }
        },
        "source2": [
          {
            "resultados": [
              {
                "url": "https://www.reclameaqui.com.br/stark-bank/titulo_QlaQDkYTCIB4bnv-/",
                "titulo": "[Editado pelo Reclame Aqui] - Stark Bank",
                "descricao": "[Editado pelo Reclame Aqui]. Stark Bank. Jaraguá do Sul - SC. 27/02/2024 às ... Stark Bank. Reputação da empresa: RUIM. 5.4/ 10. Ver página da ..."
              },
              {
                "url": "https://www.reclameaqui.com.br/empresa/stark-bank/lista-reclamacoes/?produto=0000000000000910",
                "titulo": "Todas as reclamações de Conta - Stark Bank",
                "descricao": "[Editado pelo Reclame Aqui] invasão de dados e transferência pix. Eu avia ... [Editado pelo Reclame Aqui] da Stark Bank S.A. no valor. RespondidaHá 18 dias ..."
              },
              {
                "url": "https://www.reclameaqui.com.br/stark-bank/titulo_vHv0zq9DrIEdcS_d/",
                "titulo": "[Editado pelo Reclame Aqui] - Stark Bank",
                "descricao": "Fui vítima de [Editado pelo Reclame Aqui] e essa é a instituição que está no meu comprovante ... Stark Bank. Reputação da empresa: RUIM. 5.1/ 10."
              },
              {
                "url": "https://www.reclameaqui.com.br/stark-bank/usam-o-stark-bank-para_l4Tu1Mr-0GfwmETj/",
                "titulo": "Usam o Stark Bank para [Editado pelo Reclame Aqui]",
                "descricao": "FIZ UM DEPOSITO PARA A CASA MEGAODDS O QUAL APARENTEMENTE É FAKE E O DEPÓSITO FOI PARA A STARK BANK S.A. (CNPJ: 29.639.420/0001-02 E APÓS O ..."
              },
              {
                "url": "https://www.reclameaqui.com.br/stark-bank/titulo_aZmMb8GaCVXOm8Om/",
                "titulo": "[Editado pelo Reclame Aqui] - Stark Bank",
                "descricao": "Acho que Stark Bank S.A esta conivente com [Editado pelo Reclame Aqui] que usuario vem aplicando no mercado inclusive ja resistrei BO e a ..."
              },
              {
                "url": "https://www.reclameaqui.com.br/stark-bank/titulo_s9tsSkLTqqheg-Ll/",
                "titulo": "[Editado pelo Reclame Aqui] - Stark Bank",
                "descricao": "Fiz uma tranferencia para um jogo, e no pix constatou que o nome era Stark bank S.A, fui sacar e não consegui, ou seja perdi 25 reais, quero meu ..."
              },
              {
                "url": "https://www.reclameaqui.com.br/stark-bank/titulo_Czb06SpoYJ-Q6t42/",
                "titulo": "[Editado pelo Reclame Aqui] - Stark Bank",
                "descricao": "[Editado pelo Reclame Aqui]. Stark Bank. Canguçu - RS. 12/02/2024 às 23:04. ID: 182441593. Meios de pagamentos eletrônicos · Propaganda Enganosa."
              },
              {
                "url": "https://www.reclameaqui.com.br/stark-bank/titulo_yHRud5JQ8WkVf7_0/",
                "titulo": "[Editado pelo Reclame Aqui] - Stark Bank",
                "descricao": "App do Reclame AQUILeia reclamações com mais facilidade! BAIXAR. [Editado pelo Reclame Aqui]. Stark Bank · Reclamar dessa ..."
              },
              {
                "url": "https://www.reclameaqui.com.br/stark-bank/titulo_v0dPzxHHSu_uyd69/",
                "titulo": "[Editado pelo Reclame Aqui] - Stark Bank",
                "descricao": "[Editado pelo Reclame Aqui]. Stark Bank. Cidade Gaúcha - PR. 15/02/2024 às 09:02. ID: 182572887. Bancos · Pagamentos eletrônicos · Propaganda enganosa."
              },
              {
                "url": "https://www.reclameaqui.com.br/stark-bank/tudo_9nMIiBHxXXdsqiGL/",
                "titulo": "Tudo [Editado pelo Reclame Aqui] - Stark Bank",
                "descricao": "Tudo [Editado pelo Reclame Aqui]. Stark Bank · Reclamar dessa empresa. São Paulo - SP. 13/02/2024 às 15:48. ID: 182467611. Publicidade Icone publicidade."
              }
            ],
            "resultados_sugeridos": false,
            "site_receipt": "https://storage.googleapis.com/infosimples-api-tmp/api/buscador/google/20240228174612/Touwvi2OdOVxyzzT-VVOTMVawsfIO6nD/4c571b6b3e81becd72902bca45533723_0_T9Q.html"
          }
        ]
      },
      "createdAt": "2024-02-28T20:46:12.080Z",
      "updatedAt": "2024-02-28T20:46:12.080Z"
    },
    "lawsuits": {
      "_id": "65df9b9659af913ca758debb",
      "emailClient": "superadmin@gueno.com",
      "email": "superadmin@gueno.com",
      "status": "IN_PROGRESS",
      "type": "OWNERS_LAWSUITS",
      "entity": "BUSINESS",
      "checkDetails": {
        "TotalLawsuits": 16,
        "TotalReplacedLawsuits": 0,
        "TotalLawsuitsAsAuthor": 11,
        "TotalLawsuitsAsDefendant": 5,
        "TotalLawsuitsAsOther": 0,
        "AverageLawsuitsPerOwner": 3,
        "OwnerMaxLawsuits": 14,
        "OwnerMinLawsuits": 0,
        "LawsuitsWithAllOwners": 0,
        "Last30DaysLawsuits": 0,
        "Last90DaysLawsuits": 0,
        "Last180DaysLawsuits": 0,
        "Last365DaysLawsuits": 0,
        "FirstLawsuitDate": "0001-01-01T00:00:00",
        "LastLawsuitDate": "2023-07-04T00:00:00",
        "Lawsuits": {
          "35823023855": {
            "Lawsuits": [],
            "TotalLawsuits": 0,
            "TotalLawsuitsAsAuthor": 0,
            "TotalLawsuitsAsDefendant": 0,
            "TotalLawsuitsAsOther": 0
          },
          "07639480981": {
            "Lawsuits": [],
            "TotalLawsuits": 0,
            "TotalLawsuitsAsAuthor": 0,
            "TotalLawsuitsAsDefendant": 0,
            "TotalLawsuitsAsOther": 0
          },
          "41812844840": {
            "Lawsuits": [
              {
                "Number": "50032707920208210132",
                "Type": "PROCEDIMENTO COMUM",
                "MainSubject": "INDENIZACAO POR DANO MATERIAL, RESPONSABILIDADE DO FORNECEDOR, DIREITO DO CONSUMIDOR",
                "CourtName": "TJRS",
                "CourtLevel": "1",
                "CourtType": "CIVEL",
                "CourtDistrict": "SAPIRANGA",
                "JudgingBody": "JUIZO DA 1 VARA CIVEL DA COMARCA DE SAPIRANGA",
                "State": "RS",
                "Status": "SUSPENSO",
                "LawsuitHostService": "EPROC",
                "InferredCNJSubjectName": "INDENIZAÇÃO POR DANO MATERIAL",
                "InferredCNJSubjectNumber": 7780,
                "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
                "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
                "InferredBroadCNJSubjectNumber": 1156,
                "OtherSubjects": [
                  "INDENIZACAO POR DANO MATERIAL, RESPONSABILIDADE DO FORNECEDOR, DIREITO DO CONSUMIDOR"
                ],
                "NumberOfVolumes": 0,
                "NumberOfPages": 0,
                "Value": -1,
                "ResJudicataDate": "0001-01-01T00:00:00",
                "CloseDate": "0001-01-01T00:00:00",
                "RedistributionDate": "0001-01-01T00:00:00",
                "PublicationDate": "0001-01-01T00:00:00",
                "NoticeDate": "2020-10-06T08:58:01",
                "LastMovementDate": "2022-02-16T00:00:00",
                "CaptureDate": "2022-04-10T19:27:07",
                "LastUpdate": "2022-04-10T19:27:07",
                "NumberOfParties": 10,
                "NumberOfUpdates": 95,
                "LawSuitAge": 1240,
                "AverageNumberOfUpdatesPerMonth": 2,
                "ReasonForConcealedData": 0,
                "Parties": [
                  {
                    "Doc": "51592541020",
                    "IsPartyActive": true,
                    "Name": "LUIZ CARLOS OLINDO DA SILVA",
                    "Polarity": "ACTIVE",
                    "Type": "AUTHOR",
                    "PartyDetails": {
                      "SpecificType": "AUTOR"
                    },
                    "LastCaptureDate": "2022-04-10T19:27:07"
                  },
                  {
                    "Doc": "25321930000178",
                    "IsPartyActive": true,
                    "Name": "ARENA FOMENTO MERCANTIL LTDA",
                    "Polarity": "PASSIVE",
                    "Type": "DEFENDANT",
                    "PartyDetails": {
                      "SpecificType": "REU"
                    },
                    "LastCaptureDate": "2022-04-10T19:27:07"
                  },
                  {
                    "Doc": "21160553000181",
                    "IsPartyActive": true,
                    "Name": "FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA",
                    "Polarity": "PASSIVE",
                    "Type": "DEFENDANT",
                    "PartyDetails": {
                      "SpecificType": "REU"
                    },
                    "LastCaptureDate": "2022-04-10T19:27:07"
                  },
                  {
                    "Doc": "10685786000181",
                    "IsPartyActive": true,
                    "Name": "FRI SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA",
                    "Polarity": "PASSIVE",
                    "Type": "DEFENDANT",
                    "PartyDetails": {
                      "SpecificType": "REU"
                    },
                    "LastCaptureDate": "2022-04-10T19:27:07"
                  },
                  {
                    "Doc": "18583984875",
                    "IsPartyActive": true,
                    "Name": "GILBERTO KLEY SILVA",
                    "Polarity": "PASSIVE",
                    "Type": "DEFENDANT",
                    "PartyDetails": {
                      "SpecificType": "REU"
                    },
                    "LastCaptureDate": "2022-04-10T19:27:07"
                  },
                  {
                    "Doc": "01383649669",
                    "IsPartyActive": true,
                    "Name": "LEANDRO VALVERDE BRITO",
                    "Polarity": "PASSIVE",
                    "Type": "DEFENDANT",
                    "PartyDetails": {
                      "SpecificType": "REU"
                    },
                    "LastCaptureDate": "2022-04-10T19:27:07"
                  },
                  {
                    "Doc": "41812844840",
                    "IsPartyActive": true,
                    "Name": "MATHEUS COELHO FERRAZ",
                    "Polarity": "PASSIVE",
                    "Type": "DEFENDANT",
                    "PartyDetails": {
                      "SpecificType": "REU"
                    },
                    "LastCaptureDate": "2022-04-10T19:27:07"
                  },
                  {
                    "IsPartyActive": true,
                    "Name": "RAFAEL CASTRO DE MATOS",
                    "Polarity": "PASSIVE",
                    "Type": "DEFENDANT",
                    "PartyDetails": {
                      "SpecificType": "REU"
                    },
                    "LastCaptureDate": "2022-04-10T19:27:07"
                  },
                  {
                    "Doc": "20018183000180",
                    "IsPartyActive": true,
                    "Name": "STARK BANK S A",
                    "Polarity": "PASSIVE",
                    "Type": "DEFENDANT",
                    "PartyDetails": {
                      "SpecificType": "REU"
                    },
                    "LastCaptureDate": "2022-04-10T19:27:07"
                  },
                  {
                    "IsPartyActive": true,
                    "Name": "ANTONIO FRANCISCO GOMES BARROS",
                    "Polarity": "NEUTRAL",
                    "Type": "OTHER",
                    "PartyDetails": {
                      "SpecificType": "REPRESENTANTE LEGAL"
                    },
                    "LastCaptureDate": "2022-04-10T19:27:07"
                  }
                ],
                "Updates": [
                  {
                    "Content": "PROCESSO SUSPENSO OU SOBRESTADO POR DECISAO JUDICIAL - DILIGENCIA (DEPRECADA/ ROGADA/ SOLICITADA A OUTRO JUIZO)",
                    "PublishDate": "2022-02-16T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "PETICAO PROTOCOLADA JUNTADA - REFER. AO EVENTO: 92 - PETICAO",
                    "PublishDate": "2022-02-03T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "CONFIRMADA A INTIMACAO ELETRONICA - REFER. AO EVENTO: 92",
                    "PublishDate": "2021-12-17T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "EXPEDIDA/CERTIFICADA A INTIMACAO ELETRONICA (AUTOR - LUIZ CARLOS OLINDO DA SILVA) PRAZO: 15 DIAS DATA FINAL: 10/02/2022 23:59:59",
                    "PublishDate": "2021-12-07T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "ATO ORDINATORIO PRATICADO",
                    "PublishDate": "2021-12-07T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "EXPEDICAO DE CARTA DE ORDEM/PRECATORIA/ROGATORIA",
                    "PublishDate": "2021-12-07T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "LEVANTAMENTO DA SUSPENSAO OU DESSOBRESTAMENTO",
                    "PublishDate": "2021-11-26T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "PETICAO PROTOCOLADA JUNTADA - REFER. AO EVENTO: 83 - PETICAO",
                    "PublishDate": "2021-10-26T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "PROCESSO SUSPENSO OU SOBRESTADO POR DECISAO JUDICIAL - DILIGENCIA (DEPRECADA/ ROGADA/ SOLICITADA A OUTRO JUIZO)",
                    "PublishDate": "2021-10-14T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "DECORRIDO PRAZO - REFER. AO EVENTO: 76",
                    "PublishDate": "2021-10-14T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "PETICAO PROTOCOLADA JUNTADA - PETICAO",
                    "PublishDate": "2021-10-13T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "CONFIRMADA A INTIMACAO ELETRONICA - REFER. AO EVENTO: 83",
                    "PublishDate": "2021-10-07T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "EXPEDIDA/CERTIFICADA A INTIMACAO ELETRONICA (AUTOR - LUIZ CARLOS OLINDO DA SILVA) PRAZO: 15 DIAS DATA FINAL: 29/10/2021 23:59:59",
                    "PublishDate": "2021-09-27T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "JUNTADA DE MANDADO CUMPRIDO NEGATIVO - REFER. AO EVENTO: 68",
                    "PublishDate": "2021-09-27T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "JUNTADA DE MANDADO CUMPRIDO NEGATIVO - REFER. AO EVENTO: 70",
                    "PublishDate": "2021-09-27T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "JUNTADA DE MANDADO CUMPRIDO NEGATIVO - REFER. AO EVENTO: 72",
                    "PublishDate": "2021-09-27T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "LEVANTAMENTO DA SUSPENSAO OU DESSOBRESTAMENTO",
                    "PublishDate": "2021-09-27T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "CONFIRMADA A INTIMACAO ELETRONICA - REFER. AO EVENTO: 76",
                    "PublishDate": "2021-09-20T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "PROCESSO SUSPENSO OU SOBRESTADO POR DECISAO JUDICIAL - DILIGENCIA (DEPRECADA/ ROGADA/ SOLICITADA A OUTRO JUIZO)",
                    "PublishDate": "2021-09-10T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "EXPEDIDA/CERTIFICADA A INTIMACAO ELETRONICA (AUTOR - LUIZ CARLOS OLINDO DA SILVA) PRAZO: 15 DIAS DATA FINAL: 13/10/2021 23:59:59",
                    "PublishDate": "2021-09-10T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "ATO ORDINATORIO PRATICADO",
                    "PublishDate": "2021-09-10T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "EXPEDICAO DE CARTA DE ORDEM/PRECATORIA/ROGATORIA",
                    "PublishDate": "2021-09-10T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "RECEBIDO O MANDADO PARA CUMPRIMENTO PELO OFICIAL DE JUSTICA - REFER. AO EVENTO: 72",
                    "PublishDate": "2021-09-08T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "EXPEDICAO DE MANDADO - CM0087",
                    "PublishDate": "2021-09-08T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "RECEBIDO O MANDADO PARA CUMPRIMENTO PELO OFICIAL DE JUSTICA - REFER. AO EVENTO: 70",
                    "PublishDate": "2021-09-08T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "EXPEDICAO DE MANDADO - CM0087",
                    "PublishDate": "2021-09-08T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "RECEBIDO O MANDADO PARA CUMPRIMENTO PELO OFICIAL DE JUSTICA - REFER. AO EVENTO: 68",
                    "PublishDate": "2021-09-08T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "EXPEDICAO DE MANDADO - CM0087",
                    "PublishDate": "2021-09-08T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "PETICAO PROTOCOLADA JUNTADA - REFER. AO EVENTO: 65 - PETICAO",
                    "PublishDate": "2021-08-25T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "CONFIRMADA A INTIMACAO ELETRONICA - REFER. AO EVENTO: 65",
                    "PublishDate": "2021-08-20T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "EXPEDIDA/CERTIFICADA A INTIMACAO ELETRONICA (AUTOR - LUIZ CARLOS OLINDO DA SILVA) PRAZO: 15 DIAS DATA FINAL: 13/09/2021 23:59:59",
                    "PublishDate": "2021-08-10T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "JUNTADA DE PECAS DIGITALIZADAS",
                    "PublishDate": "2021-08-10T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "DECORRIDO PRAZO - REFER. AO EVENTO: 57",
                    "PublishDate": "2021-07-24T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "DECORRIDO PRAZO - REFER. AO EVENTO: 52",
                    "PublishDate": "2021-07-20T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "JUNTADA DE CERTIDAO - SUSPENSAO DO PRAZO - 13/07/2021 ATE 14/07/2021 MOTIVO: SUSPENSAO DE PRAZOS - IMPOSSIBILIDADE TECNICA - ATO N037/2021-P DE 13 DE JULHO DE 2021.",
                    "PublishDate": "2021-07-13T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "JUNTADA DE CERTIDAO - SUSPENSAO DO PRAZO - 13/07/2021 ATE 14/07/2021 MOTIVO: SUSPENSAO DE PRAZOS - IMPOSSIBILIDADE TECNICA - ATO N037/2021-P DE 13 DE JULHO DE 2021.",
                    "PublishDate": "2021-07-13T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "JUNTADA DE CARTA PELO CORREIO - DEVOLVIDA SEM CUMPRIMENTO - REFER. AO EVENTO: 42",
                    "PublishDate": "2021-07-05T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "JUNTADA DE CARTA PELO CORREIO - DEVOLVIDA SEM CUMPRIMENTO - REFER. AO EVENTO: 42",
                    "PublishDate": "2021-07-05T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "JUNTADA DE CARTA PELO CORREIO - COMPROVANTE DE ENTREGA - REFER. AO EVENTO: 43 (REPRESENTANTE LEGAL - ANTONIO FRANCISCO GOMES BARROS) PRAZO: 15 DIAS DATA FINAL: 23/07/2021 23:59:59",
                    "PublishDate": "2021-06-30T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "JUNTADA DE PECAS DIGITALIZADAS",
                    "PublishDate": "2021-06-28T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "CONFIRMADA A INTIMACAO ELETRONICA - REFER. AO EVENTO: 52",
                    "PublishDate": "2021-06-24T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "DECORRIDO PRAZO - REFER. AO EVENTO: 47",
                    "PublishDate": "2021-06-23T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "PETICAO PROTOCOLADA JUNTADA - PETICAO",
                    "PublishDate": "2021-06-21T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "EXPEDIDA/CERTIFICADA A INTIMACAO ELETRONICA (AUTOR - LUIZ CARLOS OLINDO DA SILVA) PRAZO: 15 DIAS DATA FINAL: 19/07/2021 23:59:59",
                    "PublishDate": "2021-06-14T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "JUNTADA DE PECAS DIGITALIZADAS",
                    "PublishDate": "2021-06-14T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "JUNTADA DE CARTA PELO CORREIO - DEVOLVIDA SEM CUMPRIMENTO - REFER. AO EVENTO: 42",
                    "PublishDate": "2021-06-03T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "CONFIRMADA A INTIMACAO ELETRONICA - REFER. AO EVENTO: 47",
                    "PublishDate": "2021-05-29T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "LEVANTAMENTO DA SUSPENSAO OU DESSOBRESTAMENTO",
                    "PublishDate": "2021-05-20T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "EXPEDIDA/CERTIFICADA A INTIMACAO ELETRONICA (AUTOR - LUIZ CARLOS OLINDO DA SILVA) PRAZO: 15 DIAS DATA FINAL: 22/06/2021 23:59:59",
                    "PublishDate": "2021-05-19T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "PETICAO PROTOCOLADA JUNTADA - PETICAO",
                    "PublishDate": "2021-05-18T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "PROCESSO SUSPENSO OU SOBRESTADO POR DECISAO JUDICIAL - DILIGENCIA (DEPRECADA/ ROGADA/ SOLICITADA A OUTRO JUIZO)",
                    "PublishDate": "2021-04-19T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "EXPEDICAO DE CARTA DE ORDEM/PRECATORIA/ROGATORIA",
                    "PublishDate": "2021-04-19T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "EXPEDICAO DE CARTA PELO CORREIO - 1 CARTA",
                    "PublishDate": "2021-04-15T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "EXPEDICAO DE CARTA PELO CORREIO - 3 CARTAS",
                    "PublishDate": "2021-04-15T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "PETICAO PROTOCOLADA JUNTADA - REFER. AO EVENTO: 39 - PETICAO",
                    "PublishDate": "2021-03-03T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "CONFIRMADA A INTIMACAO ELETRONICA - REFER. AO EVENTO: 39",
                    "PublishDate": "2021-03-03T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "EXPEDIDA/CERTIFICADA A INTIMACAO ELETRONICA - DESPACHO/DECISAO (AUTOR - LUIZ CARLOS OLINDO DA SILVA) PRAZO: 15 DIAS DATA FINAL: 24/03/2021 23:59:59",
                    "PublishDate": "2021-02-22T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE | PODER JUDICIARIO TRIBUNAL DE JUSTICA DO ESTADO DO RIO GRANDE DO SUL 1 VARA CIVEL DA COMARCA DE SAPIRANGA RUA ALBERTO SCHMIDT, 441 - BAIRRO: CENTENARIO - CEP: 93800312 - FONE: (51) 3599-1289 PROCEDIMENTO COMUM CIVEL N 5003270-79.2020.8.21.0132/ RS AUTOR : LUIZ CARLOS OLINDO DA SILVA REU : STARK BANK S.A. REU : RAFAEL CASTRO DE MATOS REU : MATHEUS COELHO FERRAZ REU : LEANDRO VALVERDE BRITO REU : GILBERTO KLEY SILVA REU : FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA REU : FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA REU : ARENA FOMENTO MERCANTIL LTDA DESPACHO/DECISAO VISTOS. DIANTE DO RETORNO NEGATIVO DAS CARTAS AR CITATORIAS NOS EVENTOS 22, 25, 26, 27, 28, INTIME-SE O AUTOR PARA PROMOVER AS CITACOES FALTANTES, NO PRAZO DE QUINZE DIAS, SOB PENA DE EXTINCAO. DILIGENCIAS LEGAIS. DOCUMENTO ASSINADO ELETRONICAMENTE POR REBECCA ROQUETTI FERNANDES, JUIZA DE DIREITO , EM 22/2/2021, AS 16:35:14, CONFORME ART. 1, III, \"B\", DA LEI 11.419/2006. A AUTENTICIDADE DO DOCUMENTO PODE SER CONFERIDA NO SITE HTTPS://EPROC1G.TJRS.JUS.BR/EPROC/EXTERNO_CONTROLADOR.PHP?ACAO=CONSULTA_AUTENTICIDADE_DOCUMENTOS, INFORMANDO O CODIGO VERIFICADOR 10006097040V2 E O CODIGO CRC 6F38D98F . 5003270-79.2020.8.21.0132 10006097040 .V2",
                    "PublishDate": "2021-02-22T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:24"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO/DESPACHO",
                    "PublishDate": "2021-01-26T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:33"
                  },
                  {
                    "Content": "PETICAO PROTOCOLADA JUNTADA - REFER. AO EVENTO: 31 - PETICAO",
                    "PublishDate": "2021-01-25T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:33"
                  },
                  {
                    "Content": "DECORRIDO PRAZO - REFER. AO EVENTO: 26",
                    "PublishDate": "2021-01-22T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:33"
                  },
                  {
                    "Content": "DECORRIDO PRAZO - REFER. AO EVENTO: 25",
                    "PublishDate": "2020-12-18T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:33"
                  },
                  {
                    "Content": "DECORRIDO PRAZO - REFER. AOS EVENTOS: 23 E 24",
                    "PublishDate": "2020-12-17T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:33"
                  },
                  {
                    "Content": "CONFIRMADA A INTIMACAO ELETRONICA - REFER. AO EVENTO: 31",
                    "PublishDate": "2020-12-15T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:33"
                  },
                  {
                    "Content": "EXPEDIDA/CERTIFICADA A INTIMACAO ELETRONICA - DESPACHO/DECISAO (AUTOR - LUIZ CARLOS OLINDO DA SILVA) PRAZO: 15 DIAS DATA FINAL: 05/02/2021 23:59:59",
                    "PublishDate": "2020-12-14T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:33"
                  },
                  {
                    "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE | PODER JUDICIARIO TRIBUNAL DE JUSTICA DO ESTADO DO RIO GRANDE DO SUL 1 VARA CIVEL DA COMARCA DE SAPIRANGA RUA ALBERTO SCHMIDT, 441 - BAIRRO: CENTENARIO - CEP: 93800312 - FONE: (51) 3599-1289 PROCEDIMENTO COMUM CIVEL N 5003270-79.2020.8.21.0132/ RS AUTOR : LUIZ CARLOS OLINDO DA SILVA REU : STARK BANK S.A. REU : RAFAEL CASTRO DE MATOS REU : MATHEUS COELHO FERRAZ REU : LEANDRO VALVERDE BRITO REU : GILBERTO KLEY SILVA REU : FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA REU : FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA REU : ARENA FOMENTO MERCANTIL LTDA DESPACHO/DECISAO VISTOS. INTIME-SE A PARTE AUTORA ACERCA DA CONTESTACAO APORTADA NO EVENTO 29. OPORTUNAMENTE, VOLTEM PARA SANEAMENTO. DILIGENCIAS LEGAIS. DOCUMENTO ASSINADO ELETRONICAMENTE POR VIVIANE CASTALDELLO BUSATTO, JUIZA DE DIREITO , EM 14/12/2020, AS 11:24:20, CONFORME ART. 1, III, \"B\", DA LEI 11.419/2006. A AUTENTICIDADE DO DOCUMENTO PODE SER CONFERIDA NO SITE HTTPS://EPROC1G.TJRS.JUS.BR/EPROC/EXTERNO_CONTROLADOR.PHP?ACAO=CONSULTA_AUTENTICIDADE_DOCUMENTOS, INFORMANDO O CODIGO VERIFICADOR 10005117572V2 E O CODIGO CRC BF366D6C . 5003270-79.2020.8.21.0132 10005117572 .V2",
                    "PublishDate": "2020-12-14T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:33"
                  },
                  {
                    "Content": "PETICAO PROTOCOLADA JUNTADA - CONTESTACAO",
                    "PublishDate": "2020-12-05T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:45"
                  },
                  {
                    "Content": "JUNTADA DE CARTA PELO CORREIO - DEVOLVIDA SEM CUMPRIMENTO - REFER. AO EVENTO: 16",
                    "PublishDate": "2020-11-30T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:45"
                  },
                  {
                    "Content": "JUNTADA DE CARTA PELO CORREIO - DEVOLVIDA SEM CUMPRIMENTO - REFER. AO EVENTO: 15",
                    "PublishDate": "2020-11-27T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:45"
                  },
                  {
                    "Content": "JUNTADA DE CARTA PELO CORREIO - COMPROVANTE DE ENTREGA - REFER. AO EVENTO: 13 (REU - FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA) PRAZO: 15 DIAS DATA FINAL: 21/01/2021 23:59:59",
                    "PublishDate": "2020-11-27T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:45"
                  },
                  {
                    "Content": "JUNTADA DE CARTA PELO CORREIO - COMPROVANTE DE ENTREGA - REFER. AO EVENTO: 14 (REU - ARENA FOMENTO MERCANTIL LTDA) PRAZO: 15 DIAS DATA FINAL: 17/12/2020 23:59:59",
                    "PublishDate": "2020-11-25T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:45"
                  },
                  {
                    "Content": "JUNTADA DE CARTA PELO CORREIO - COMPROVANTE DE ENTREGA - REFER. AO EVENTO: 19 (REU - RAFAEL CASTRO DE MATOS) PRAZO: 15 DIAS DATA FINAL: 16/12/2020 23:59:59",
                    "PublishDate": "2020-11-24T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:45"
                  },
                  {
                    "Content": "JUNTADA DE CARTA PELO CORREIO - COMPROVANTE DE ENTREGA - REFER. AO EVENTO: 18 (REU - MATHEUS COELHO FERRAZ) PRAZO: 15 DIAS DATA FINAL: 16/12/2020 23:59:59",
                    "PublishDate": "2020-11-24T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:45"
                  },
                  {
                    "Content": "JUNTADA DE CARTA PELO CORREIO - DEVOLVIDA SEM CUMPRIMENTO - REFER. AO EVENTO: 17",
                    "PublishDate": "2020-11-24T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:45"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO/DESPACHO",
                    "PublishDate": "2020-11-17T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:45"
                  },
                  {
                    "Content": "PETICAO PROTOCOLADA JUNTADA - REFER. AO EVENTO: 11 - PETICAO",
                    "PublishDate": "2020-11-16T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:45"
                  },
                  {
                    "Content": "EXPEDICAO DE CARTA PELO CORREIO - 1 CARTA",
                    "PublishDate": "2020-11-11T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:45"
                  },
                  {
                    "Content": "EXPEDICAO DE CARTA PELO CORREIO - 1 CARTA",
                    "PublishDate": "2020-11-11T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:45"
                  },
                  {
                    "Content": "EXPEDICAO DE CARTA PELO CORREIO - 1 CARTA",
                    "PublishDate": "2020-11-11T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:45"
                  },
                  {
                    "Content": "EXPEDICAO DE CARTA PELO CORREIO - 1 CARTA",
                    "PublishDate": "2020-11-11T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:45"
                  },
                  {
                    "Content": "EXPEDICAO DE CARTA PELO CORREIO - 1 CARTA",
                    "PublishDate": "2020-11-11T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:45"
                  },
                  {
                    "Content": "EXPEDICAO DE CARTA PELO CORREIO - 1 CARTA",
                    "PublishDate": "2020-11-11T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:45"
                  },
                  {
                    "Content": "EXPEDICAO DE CARTA PELO CORREIO - 1 CARTA",
                    "PublishDate": "2020-11-11T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:45"
                  },
                  {
                    "Content": "CONFIRMADA A INTIMACAO ELETRONICA - REFER. AO EVENTO: 11",
                    "PublishDate": "2020-10-28T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:45"
                  },
                  {
                    "Content": "EXPEDIDA/CERTIFICADA A INTIMACAO ELETRONICA (AUTOR - LUIZ CARLOS OLINDO DA SILVA) PRAZO: 15 DIAS DATA FINAL: 19/11/2020 23:59:59",
                    "PublishDate": "2020-10-27T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:45"
                  },
                  {
                    "Content": "NAO CONCEDIDA A MEDIDA LIMINAR | PODER JUDICIARIO TRIBUNAL DE JUSTICA DO ESTADO DO RIO GRANDE DO SUL 1 VARA CIVEL DA COMARCA DE SAPIRANGA RUA ALBERTO SCHMIDT, 441 - BAIRRO: CENTENARIO - CEP: 93800312 - FONE: (51) 3599-1289 PROCEDIMENTO COMUM CIVEL N 5003270-79.2020.8.21.0132/ RS AUTOR : LUIZ CARLOS OLINDO DA SILVA REU : STARK BANK S.A. REU : RAFAEL CASTRO DE MATOS REU : MATHEUS COELHO FERRAZ REU : LEANDRO VALVERDE BRITO REU : GILBERTO KLEY SILVA REU : FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA REU : FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA REU : ARENA FOMENTO MERCANTIL LTDA DESPACHO/DECISAO VISTOS. 1. DO BENEFICIO DA AJG: CONCEDO A PARTE AUTORA O BENEFICIO DA AJG, UMA VEZ QUE COMPROVADA A ALEGADA NECESSIDADE. 2. DA TUTELA DE URGENCIA: A PARTE AUTORA POSTULA, EM SEDE LIMINAR, A CONCESSAO DE TUTELA DE URGENCIA DE NATUREZA CAUTELAR PARA ARRESTO DOS BENS DA PARTE DEMANDADA, COM O FITO DE RESERVAR BENS SUFICIENTES EM EVENTUAL PROCEDENCIA DO PEDIDO. OCORRE QUE, PARA CONCESSAO DA MEDIDA ANTECIPATORIA DA TUTELA, NA MODALIDADE DE URGENCIA, FAZ-SE NECESSARIA A PRESENCA DOS SEGUINTES REQUISITOS CUMULATIVOS: (I) ELEMENTOS QUE EVIDENCIEM A PROBABILIDADE DO DIREITO E (II) O PERIGO DE DANO OU O RISCO AO RESULTADO UTIL DO PROCESSO, A TEOR DO ART. 300 DO CPC. NO CASO DOS AUTOS, A PARTE AUTORA NAO LOGROU EXITO EM DEMONSTRAR A URGENCIA NA CONCESSAO DA MEDIDA, CARACTERIZADA NA EVENTUALIDADE DA PARTE DEMANDADA ESTAR SE DESFAZENDO DE SEUS BENS COM O DOLO DE FRUSTRAR FUTURA EXECUCAO. ADEMAIS, TAMBEM NAO LOGROU-SE DEMONSTRAR, EM SEDE DE COGNICAO SUMARIA, SEJA ATRAVES DE PROVA DOCUMENTAL OU DE ALEGACOES VEROSSIMEIS, A PARTICIPACAO DOS DEMANDADOS ARENA FOMENTO MERCANTIL LTDA, FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA, LEANDRO VALVERDE BRITO, MATHEUS COELHO FERRAZ E RAFAEL CASTRO DE MATOS NO ALEGADO \"SISTEMA CRIMINOSO DE PIRAMIDE\". EM CONVERGENCIA, COLACIONO O ARESTO: AGRAVO DE INSTRUMENTO. NEGOCIOS JURIDICOS BANCARIOS. ACAO DE EXECUCAO DE TITULO EXTRAJUDICIAL COM PEDIDO INCIDENTAL DE TUTELA DE URGENCIA DE NATUREZA CAUTELAR. ARRESTO. A PROBABILIDADE DO DIREITO ACAUTELADO ASSOCIADA AO PERIGO DE DANO OU AO RISCO AO RESULTADO UTIL DO PROCESSO SAO REQUISITOS QUE DEVEM SER PREENCHIDOS PARA O DEFERIMENTO DA TUTELA PROVISORIA DE URGENCIA CAUTELAR ANTECEDENTE. NA HIPOTESE DOS AUTOS, OS REQUISITOS LEGAIS PARA O DEFERIMENTO DA TUTELA DE URGENCIA CAUTELAR NAO FORAM SUFICIENTEMENTE PREENCHIDOS. DECISAO MANTIDA. AGRAVO DE INSTRUMENTO DESPROVIDO. (AGRAVO DE INSTRUMENTO N 70075022632, DECIMA NONA CAMARA CIVEL, TRIBUNAL DE JUSTICA DO RS, RELATOR: MARCO ANTONIO ANGELO, JULGADO EM 15/03/2018) ANTE O EXPOSTO, INDEFIRO OS PEDIDOS LIMINARES FORMULADOS NA INICIAL. 3. DO PROSSEGUIMENTO: DEIXO DE DESIGNAR A AUDIENCIA DE CONCILIACAO PREVISTA NO ART. 334 DO CPC, PORQUE A MATERIA TRAZIDA A DISCUSSAO POSSUI A NECESSIDADE DE INSTRUCAO PROBATORIA, SENDO INVIAVEL A REALIZACAO DESTA, NOS TERMOS DO ART. 334, 4, II, DO CPC. INTIME-SE A PARTE AUTORA ACERCA DAS MANIFESTACOES APORTADAS NOS EVENTOS 3 E 9. ADEMAIS, CITEM-SE OS REUS (A EXCECAO DA RE STARK BANK S.A., ANTE O COMPARECIMENTO ESPONTANEO NOS AUTOS) PARA, QUERENDO, APRESENTAR CONTESTACAO NO PRAZO DE 15 DIAS, CONTADOS DA JUNTADA DO MANDADO OU AVISO DE RECEBIMENTO DA CARTA AOS AUTOS (ART. 231, I E II, DO CPC). NAO HAVENDO CONTESTACAO NO PRAZO SUPRA, A PARTE RE SERA CONSIDERADA REVEL E SERAO PRESUMIDAS VERDADEIRAS AS ALEGACOES DE FATO FORMULADAS PELA PARTE AUTORA NA INICIAL, CUJA COPIA DEVERA INSTRUIR O MANDADO/CARTA DE CITACAO. DO MANDADO DEVERA CONSTAR QUE EVENTUAL INTERESSE NA REALIZACAO DA AUDIENCIA DE CONCILIACAO DEVERA SER INFORMADO AO JUIZO COM A CONTESTACAO. EM INTIMACOES ATINENTES AO IMPULSIONAMENTO DO FEITO, NAO HAVENDO MANIFESTACAO DO PROCURADOR CONSTITUIDO, FICA DESDE JA AUTORIZADA A INTIMACAO PESSOAL DO AUTOR/EXEQUENTE PARA DIZER SOBRE O PROSSEGUIMENTO DO FEITO, NO PRAZO DE 48 HORAS, SOB PENA DE EXTINCAO E ARQUIVAMENTO. INTIME-SE. CUMPRA-SE. DILIGENCIAS LEGAIS. DOCUMENTO ASSINADO ELETRONICAMENTE POR VIVIANE CASTALDELLO BUSATTO, JUIZA DE DIREITO , EM 27/10/2020, AS 19:33:40, CONFORME ART. 1, III, \"B\", DA LEI 11.419/2006. A AUTENTICIDADE DO DOCUMENTO PODE SER CONFERIDA NO SITE HTTPS://EPROC1G.TJRS.JUS.BR/EPROC/EXTERNO_CONTROLADOR.PHP?ACAO=CONSULTA_AUTENTICIDADE_DOCUMENTOS, INFORMANDO O CODIGO VERIFICADOR 10004289255V3 E O CODIGO CRC 89A3FAE4 . 5003270-79.2020.8.21.0132 10004289255 .V3",
                    "PublishDate": "2020-10-27T00:00:00",
                    "CaptureDate": "2022-04-10T19:27:45"
                  },
                  {
                    "Content": "PETICAO PROTOCOLADA JUNTADA - PETICAO",
                    "PublishDate": "2020-10-23T00:00:00",
                    "CaptureDate": "2022-04-10T19:28:01"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO/DESPACHO",
                    "PublishDate": "2020-10-16T00:00:00",
                    "CaptureDate": "2022-04-10T19:28:01"
                  },
                  {
                    "Content": "PETICAO PROTOCOLADA JUNTADA - REFER. AO EVENTO: 5 - PETICAO",
                    "PublishDate": "2020-10-15T00:00:00",
                    "CaptureDate": "2022-04-10T19:28:01"
                  },
                  {
                    "Content": "CONFIRMADA A INTIMACAO ELETRONICA - REFER. AO EVENTO: 5",
                    "PublishDate": "2020-10-14T00:00:00",
                    "CaptureDate": "2022-04-10T19:28:01"
                  },
                  {
                    "Content": "EXPEDIDA/CERTIFICADA A INTIMACAO ELETRONICA - DESPACHO/DECISAO (AUTOR - LUIZ CARLOS OLINDO DA SILVA) PRAZO: 15 DIAS DATA FINAL: 05/11/2020 23:59:59",
                    "PublishDate": "2020-10-13T00:00:00",
                    "CaptureDate": "2022-04-10T19:28:01"
                  },
                  {
                    "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE | PODER JUDICIARIO TRIBUNAL DE JUSTICA DO ESTADO DO RIO GRANDE DO SUL 1 VARA CIVEL DA COMARCA DE SAPIRANGA RUA ALBERTO SCHMIDT, 441 - BAIRRO: CENTENARIO - CEP: 93800312 - FONE: (51) 3599-1289 PROCEDIMENTO COMUM CIVEL N 5003270-79.2020.8.21.0132/ RS AUTOR : LUIZ CARLOS OLINDO DA SILVA REU : STARK BANK S.A. REU : RAFAEL CASTRO DE MATOS REU : MATHEUS COELHO FERRAZ REU : LEANDRO VALVERDE BRITO REU : GILBERTO KLEY SILVA REU : FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA REU : FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA REU : ARENA FOMENTO MERCANTIL LTDA DESPACHO/DECISAO VISTOS. INTIME-SE A PARTE AUTORA PARA, NO PRAZO DE QUINZE DIAS, EMENDAR A INICIAL APRESENTANDO INSTRUMENTO PROCURATORIO COM FINS DE AJUIZAMENTO DA PRESENTE ACAO, UMA VEZ QUE A PROCURACAO APRESENTADA NO EVENTO 1, PROC2 CONTEMPLA FINALIDADE ESPECIFICA PARA AJUIZAMENTO DE OUTRA DEMANDA, EM DESFAVOR DE PESSOA DIVERSA DOS REUS. OPORTUNAMENTE, VOLTEM PARA APRECIACAO DO PEDIDO LIMINAR, BEM COMO DA MANIFESTACAO APORTADA NO EVENTO 3. DILIGENCIAS LEGAIS. DOCUMENTO ASSINADO ELETRONICAMENTE POR VIVIANE CASTALDELLO BUSATTO, JUIZA DE DIREITO , EM 13/10/2020, AS 15:2:7, CONFORME ART. 1, III, \"B\", DA LEI 11.419/2006. A AUTENTICIDADE DO DOCUMENTO PODE SER CONFERIDA NO SITE HTTPS://EPROC1G.TJRS.JUS.BR/EPROC/EXTERNO_CONTROLADOR.PHP?ACAO=CONSULTA_AUTENTICIDADE_DOCUMENTOS, INFORMANDO O CODIGO VERIFICADOR 10004040471V2 E O CODIGO CRC B5A69D85 . 5003270-79.2020.8.21.0132 10004040471 .V2",
                    "PublishDate": "2020-10-13T00:00:00",
                    "CaptureDate": "2022-04-10T19:28:01"
                  },
                  {
                    "Content": "PETICAO PROTOCOLADA JUNTADA - PETICAO",
                    "PublishDate": "2020-10-06T00:00:00",
                    "CaptureDate": "2022-04-10T19:28:10"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO/DESPACHO",
                    "PublishDate": "2020-10-06T00:00:00",
                    "CaptureDate": "2022-04-10T19:28:10"
                  },
                  {
                    "Content": "DISTRIBUIDO POR SORTEIO (SPG1CIV1J)",
                    "PublishDate": "2020-10-06T00:00:00",
                    "CaptureDate": "2022-04-10T19:28:10"
                  }
                ],
                "Petitions": [],
                "Decisions": []
              }
            ],
            "TotalLawsuits": 1,
            "TotalLawsuitsAsAuthor": 0,
            "TotalLawsuitsAsDefendant": 1,
            "TotalLawsuitsAsOther": 0
          },
          "12916747729": {
            "Lawsuits": [
              {
                "Number": "11218872720208260100",
                "Type": "PROCEDIMENTO COMUM",
                "MainSubject": "LOCACAO DE IMOVEL",
                "CourtName": "TJSP",
                "CourtLevel": "1",
                "CourtType": "CIVEL",
                "CourtDistrict": "SAO PAULO",
                "Judge": "LUIZ GUSTAVO ESTEVES",
                "JudgingBody": "11 VARA CIVEL",
                "State": "SP",
                "Status": "ARQUIVADO",
                "LawsuitHostService": "ESAJ",
                "InferredCNJSubjectName": "LOCAÇÃO DE IMÓVEL",
                "InferredCNJSubjectNumber": 9593,
                "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
                "InferredBroadCNJSubjectName": "DIREITO CIVIL",
                "InferredBroadCNJSubjectNumber": 899,
                "OtherSubjects": [
                  "LOCACAO DE IMOVEL"
                ],
                "NumberOfVolumes": 0,
                "NumberOfPages": 0,
                "Value": 58338.84,
                "ResJudicataDate": "2021-03-10T00:00:00",
                "CloseDate": "2021-03-10T00:00:00",
                "RedistributionDate": "0001-01-01T00:00:00",
                "PublicationDate": "2022-05-17T00:00:00",
                "NoticeDate": "2020-12-16T00:00:00",
                "LastMovementDate": "2022-05-17T00:00:00",
                "CaptureDate": "2022-11-11T14:58:14",
                "LastUpdate": "2022-11-11T14:58:14",
                "NumberOfParties": 6,
                "NumberOfUpdates": 106,
                "LawSuitAge": 84,
                "AverageNumberOfUpdatesPerMonth": 2,
                "ReasonForConcealedData": 0,
                "Parties": [
                  {
                    "Doc": "12916747729",
                    "IsPartyActive": true,
                    "Name": "CAIO ROCHA DOTTORI GASPAR",
                    "Polarity": "ACTIVE",
                    "Type": "CLAIMANT",
                    "PartyDetails": {
                      "SpecificType": "REQTE"
                    },
                    "LastCaptureDate": "2022-11-11T14:58:14"
                  },
                  {
                    "Doc": "11532015771",
                    "IsPartyActive": true,
                    "Name": "CAROLINA CORREA KOURY DO VALLE",
                    "Polarity": "ACTIVE",
                    "Type": "CLAIMANT",
                    "PartyDetails": {
                      "SpecificType": "REQTE"
                    },
                    "LastCaptureDate": "2022-11-11T14:58:14"
                  },
                  {
                    "Doc": "35068411817",
                    "IsPartyActive": true,
                    "Name": "RAFAEL HIDEO NAZIMA",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "295443",
                      "State": "SP",
                      "SpecificType": "ADVOGADO (REQTE)"
                    },
                    "LastCaptureDate": "2022-11-11T14:58:14"
                  },
                  {
                    "Doc": "05256350000137",
                    "IsPartyActive": true,
                    "Name": "UNISERVICE CONSULTORIA E PLANEJAMENTO LTDA ME",
                    "Polarity": "PASSIVE",
                    "Type": "CLAIMED",
                    "PartyDetails": {
                      "SpecificType": "REQDO"
                    },
                    "LastCaptureDate": "2022-11-11T14:58:14"
                  },
                  {
                    "Doc": "14827593817",
                    "IsPartyActive": true,
                    "Name": "FABIO ROBERTO BERNARDO FERNANDES",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "177019",
                      "State": "SP",
                      "SpecificType": "ADVOGADO (REQDO)"
                    },
                    "LastCaptureDate": "2022-11-11T14:58:14"
                  },
                  {
                    "Doc": "26928315865",
                    "IsPartyActive": true,
                    "Name": "LUIZ GUSTAVO ESTEVES",
                    "Polarity": "NEUTRAL",
                    "Type": "REPORTER",
                    "PartyDetails": {
                      "OAB": "196506",
                      "State": "SP",
                      "SpecificType": "JUIZ"
                    },
                    "LastCaptureDate": "2022-11-11T14:58:14"
                  }
                ],
                "Updates": [
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0306/2022 DATA DA PUBLICACAO: 18/05/2022 NUMERO DO DIARIO: 3507",
                    "PublishDate": "2022-05-17T00:00:00",
                    "CaptureDate": "2022-11-11T14:58:16"
                  },
                  {
                    "Content": "PROCESSO 1121887-27.2020.8.26.0100 - PROCEDIMENTO COMUM CIVEL - LOCACAO DE IMOVEL - CAIO ROCHA DOTTORI GASPAR - - CAROLINA CORREA KOURY DO VALLE - UNISERVICE CONSULTORIA E PLANEJAMENTO LTDA. ME - VISTOS. FL. 130: CIENTE O JUIZO. REPORTO- ME AO ATO ORDINATORIO RETRO. INTIMEM-SE. - ADV: RAFAEL HIDEO NAZIMA (OAB 295443/SP), FABIO ROBERTO BERNARDO FERNANDES (OAB 177019/SP)",
                    "PublishDate": "2022-05-17T00:00:00",
                    "CaptureDate": "2022-11-11T14:58:14"
                  },
                  {
                    "Content": "REMETIDO AO DJE RELACAO: 0306/2022 TEOR DO ATO: VISTOS. FL. 130: CIENTE O JUIZO. REPORTO-ME AO ATO ORDINATORIO RETRO. INTIMEM-SE. ADVOGADOS(S): FABIO ROBERTO BERNARDO FERNANDES (OAB 177019/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2022-05-16T00:00:00",
                    "CaptureDate": "2022-11-11T14:58:16"
                  },
                  {
                    "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.22.40772256-6 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 13/05/2022 02:43",
                    "PublishDate": "2022-05-13T00:00:00",
                    "CaptureDate": "2022-11-11T14:58:16"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO",
                    "PublishDate": "2022-05-13T00:00:00",
                    "CaptureDate": "2022-11-11T14:58:16"
                  },
                  {
                    "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE VISTOS. FL. 130: CIENTE O JUIZO. REPORTO-ME AO ATO ORDINATORIO RETRO. INTIMEM-SE.",
                    "PublishDate": "2022-05-13T00:00:00",
                    "CaptureDate": "2022-11-11T14:58:16"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0285/2022 DATA DA PUBLICACAO: 12/05/2022 NUMERO DO DIARIO: 3503",
                    "PublishDate": "2022-05-11T00:00:00",
                    "CaptureDate": "2022-11-11T14:58:16"
                  },
                  {
                    "Content": "ATO ORDINATORIO - INTIMACAO - DJE VERIFICADA A EXISTENCIA PELA SERVENTIA DE DOCUMENTO GUARDADO NO BALCAO DE DOCUMENTO DO CARTORIO RELATIVO A PROCESSO ARQUIVADO, COM SENTENCA TRANSITADA EM JULGADO, PROVIDENCIE A PARTE OU SEUS PROCURADORES A SUA RETIRADA, NO PRAZO DE 30 (TRINTA) DIAS, SOB PENA DE DESTRUICAO, NOS TERMOS DO ART. 174 DAS NGCJ.",
                    "PublishDate": "2022-05-10T00:00:00",
                    "CaptureDate": "2022-11-11T14:58:16"
                  },
                  {
                    "Content": "REMETIDO AO DJE RELACAO: 0285/2022 TEOR DO ATO: VERIFICADA A EXISTENCIA PELA SERVENTIA DE DOCUMENTO GUARDADO NO BALCAO DE DOCUMENTO DO CARTORIO RELATIVO A PROCESSO ARQUIVADO, COM SENTENCA TRANSITADA EM JULGADO, PROVIDENCIE A PARTE OU SEUS PROCURADORES A SUA RETIRADA, NO PRAZO DE 30 (TRINTA) DIAS, SOB PENA DE DESTRUICAO, NOS TERMOS DO ART. 174 DAS NGCJ. ADVOGADOS(S): FABIO ROBERTO BERNARDO FERNANDES (OAB 177019/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2022-05-10T00:00:00",
                    "CaptureDate": "2022-11-11T14:58:16"
                  },
                  {
                    "Content": "CERTIDAO DE CARTORIO EXPEDIDA | CERTIDAO - GENERICA",
                    "PublishDate": "2021-03-10T00:00:00",
                    "CaptureDate": "2021-03-14T14:39:39"
                  },
                  {
                    "Content": "TRANSITO EM JULGADO AS PARTES - PROC. EM ANDAMENTO | CERTIDAO - TRANSITO EM JULGADO",
                    "PublishDate": "2021-03-10T00:00:00",
                    "CaptureDate": "2021-03-14T14:39:39"
                  },
                  {
                    "Content": "ARQUIVADO DEFINITIVAMENTE",
                    "PublishDate": "2021-03-10T00:00:00",
                    "CaptureDate": "2021-03-14T14:39:39"
                  },
                  {
                    "Content": "ARQUIVADO DEFINITIVAMENTE",
                    "PublishDate": "2021-03-10T00:00:00",
                    "CaptureDate": "2022-11-11T14:58:16"
                  },
                  {
                    "Content": "TRANSITO EM JULGADO AS PARTES - PROC. EM ANDAMENTO CERTIDAO - TRANSITO EM JULGADO",
                    "PublishDate": "2021-03-10T00:00:00",
                    "CaptureDate": "2022-11-11T14:58:16"
                  },
                  {
                    "Content": "CERTIDAO DE CARTORIO EXPEDIDA CERTIDAO - GENERICA",
                    "PublishDate": "2021-03-10T00:00:00",
                    "CaptureDate": "2022-11-11T14:58:16"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0041/2021 DATA DA DISPONIBILIZACAO: 04/03/2021 DATA DA PUBLICACAO: 05/03/2021 NUMERO DO DIARIO: 3230 PAGINA: 342/367",
                    "PublishDate": "2021-03-04T00:00:00",
                    "CaptureDate": "2021-03-14T14:39:39"
                  },
                  {
                    "Content": "PROCESSO 1121887-27.2020.8.26.0100 - PROCEDIMENTO COMUM CIVEL - LOCACAO DE IMOVEL - CAIO ROCHA DOTTORI GASPAR - - CAROLINA CORREA KOURY DO VALLE - UNISERVICE CONSULTORIA E PLANEJAMENTO LTDA. ME - VISTOS. DADA A SATISFACAO INTEGRAL DO DEBITO, JULGO EXTINTA A EXECUCAO, NOS TERMOS DO ART. 924, INCISO II DO CODIGO DE PROCESSO CIVIL. AUSENTE INTERESSE RECURSAL, CERTIFIQUE-SE DESDE LOGO O TRANSITO EM JULGADO. APOS E NADA MAIS SENDO REQUERIDO, ARQUIVEM-SE OS AUTOS. P.R.I.C. - ADV: FABIO ROBERTO BERNARDO FERNANDES (OAB 177019/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2021-03-04T00:00:00",
                    "CaptureDate": "2021-03-14T14:39:39"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0041/2021 DATA DA DISPONIBILIZACAO: 04/03/2021 DATA DA PUBLICACAO: 05/03/2021 NUMERO DO DIARIO: 3230 PAGINA: 342/367",
                    "PublishDate": "2021-03-04T00:00:00",
                    "CaptureDate": "2022-11-11T14:58:16"
                  },
                  {
                    "Content": "REMETIDO AO DJE | RELACAO: 0041/2021 TEOR DO ATO: VISTOS. DADA A SATISFACAO INTEGRAL DO DEBITO, JULGO EXTINTA A EXECUCAO, NOS TERMOS DO ART. 924, INCISO II DO CODIGO DE PROCESSO CIVIL. AUSENTE INTERESSE RECURSAL, CERTIFIQUE-SE DESDE LOGO O TRANSITO EM JULGADO. APOS E NADA MAIS SENDO REQUERIDO, ARQUIVEM-SE OS AUTOS. P.R.I.C. ADVOGADOS(S): FABIO ROBERTO BERNARDO FERNANDES (OAB 177019/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2021-03-03T00:00:00",
                    "CaptureDate": "2021-03-14T14:39:39"
                  },
                  {
                    "Content": "REMETIDO AO DJE RELACAO: 0041/2021 TEOR DO ATO: VISTOS. DADA A SATISFACAO INTEGRAL DO DEBITO, JULGO EXTINTA A EXECUCAO, NOS TERMOS DO ART. 924, INCISO II DO CODIGO DE PROCESSO CIVIL. AUSENTE INTERESSE RECURSAL, CERTIFIQUE-SE DESDE LOGO O TRANSITO EM JULGADO. APOS E NADA MAIS SENDO REQUERIDO, ARQUIVEM-SE OS AUTOS. P.R.I.C. ADVOGADOS(S): FABIO ROBERTO BERNARDO FERNANDES (OAB 177019/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2021-03-03T00:00:00",
                    "CaptureDate": "2022-11-11T14:58:16"
                  },
                  {
                    "Content": "EXTINTA A EXECUCAO/CUMPRIMENTO DA SENTENCA PELA SATISFACAO DA OBRIGACAO | VISTOS. DADA A SATISFACAO INTEGRAL DO DEBITO, JULGO EXTINTA A EXECUCAO, NOS TERMOS DO ART. 924, INCISO II DO CODIGO DE PROCESSO CIVIL. AUSENTE INTERESSE RECURSAL, CERTIFIQUE-SE DESDE LOGO O TRANSITO EM JULGADO. APOS E NADA MAIS SENDO REQUERIDO, ARQUIVEM-SE OS AUTOS. P.R.I.C.",
                    "PublishDate": "2021-03-02T00:00:00",
                    "CaptureDate": "2021-03-14T14:39:39"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO",
                    "PublishDate": "2021-03-02T00:00:00",
                    "CaptureDate": "2021-03-14T14:39:39"
                  },
                  {
                    "Content": "PEDIDO DE ARQUIVAMENTO JUNTADO | N PROTOCOLO: WJMJ.21.40300960-0 TIPO DA PETICAO: PEDIDO DE ARQUIVAMENTO DATA: 02/03/2021 01:09",
                    "PublishDate": "2021-03-02T00:00:00",
                    "CaptureDate": "2021-03-14T14:39:39"
                  },
                  {
                    "Content": "PEDIDO DE ARQUIVAMENTO JUNTADO N PROTOCOLO: WJMJ.21.40300960-0 TIPO DA PETICAO: PEDIDO DE ARQUIVAMENTO DATA: 02/03/2021 01:09",
                    "PublishDate": "2021-03-02T00:00:00",
                    "CaptureDate": "2022-11-11T14:58:16"
                  },
                  {
                    "Content": "EXTINTA A EXECUCAO/CUMPRIMENTO DA SENTENCA PELA SATISFACAO DA OBRIGACAO VISTOS. DADA A SATISFACAO INTEGRAL DO DEBITO, JULGO EXTINTA A EXECUCAO, NOS TERMOS DO ART. 924, INCISO II DO CODIGO DE PROCESSO CIVIL. AUSENTE INTERESSE RECURSAL, CERTIFIQUE-SE DESDE LOGO O TRANSITO EM JULGADO. APOS E NADA MAIS SENDO REQUERIDO, ARQUIVEM-SE OS AUTOS. P.R.I.C.",
                    "PublishDate": "2021-03-02T00:00:00",
                    "CaptureDate": "2022-11-11T14:58:16"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0036/2021 DATA DA DISPONIBILIZACAO: 24/02/2021 DATA DA PUBLICACAO: 25/02/2021 NUMERO DO DIARIO: 3224 PAGINA: 165/187",
                    "PublishDate": "2021-02-24T00:00:00",
                    "CaptureDate": "2021-03-14T14:39:39"
                  },
                  {
                    "Content": "PROCESSO 1121887-27.2020.8.26.0100 - PROCEDIMENTO COMUM CIVEL - LOCACAO DE IMOVEL - CAIO ROCHA DOTTORI GASPAR - - CAROLINA CORREA KOURY DO VALLE - UNISERVICE CONSULTORIA E PLANEJAMENTO LTDA. ME - VISTOS. FLS. 117:DIANTE DA ALEGACAO DA RE DO CUMPRIMENTO DO ACORDO, MANIFESTE-SE A PARTE AUTORA EM05 (CINCO) DIAS, INFORMANDO SE DA POR SATISFEITA A OBRIGACAO. ANOTE-SE QUE O SILENCIO SERA INTERPRETADO COMO CONCORDANCIA, HIPOTESE EM QUE OS AUTOS TORNARAO CONCLUSOS PARA EXTINCAO DA EXECUCAO (CPC, ART. 924, II). INTIMEM-SE. - ADV: RAFAEL HIDEO NAZIMA (OAB 295443/SP), FABIO ROBERTO BERNARDO FERNANDES (OAB 177019/SP)",
                    "PublishDate": "2021-02-24T00:00:00",
                    "CaptureDate": "2021-03-15T17:59:47"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0036/2021 DATA DA DISPONIBILIZACAO: 24/02/2021 DATA DA PUBLICACAO: 25/02/2021 NUMERO DO DIARIO: 3224 PAGINA: 165/187",
                    "PublishDate": "2021-02-24T00:00:00",
                    "CaptureDate": "2022-11-11T14:58:16"
                  },
                  {
                    "Content": "REMETIDO AO DJE | RELACAO: 0036/2021 TEOR DO ATO: VISTOS. FLS. 117:DIANTE DA ALEGACAO DA RE DO CUMPRIMENTO DO ACORDO, MANIFESTE-SE A PARTE AUTORA EM05 (CINCO) DIAS, INFORMANDO SE DA POR SATISFEITA A OBRIGACAO. ANOTE-SE QUE O SILENCIO SERA INTERPRETADO COMO CONCORDANCIA, HIPOTESE EM QUE OS AUTOS TORNARAO CONCLUSOS PARA EXTINCAO DA EXECUCAO (CPC, ART. 924, II). INTIMEM-SE. ADVOGADOS(S): FABIO ROBERTO BERNARDO FERNANDES (OAB 177019/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2021-02-23T00:00:00",
                    "CaptureDate": "2021-03-14T14:39:39"
                  },
                  {
                    "Content": "REMETIDO AO DJE RELACAO: 0036/2021 TEOR DO ATO: VISTOS. FLS. 117:DIANTE DA ALEGACAO DA RE DO CUMPRIMENTO DO ACORDO, MANIFESTE-SE A PARTE AUTORA EM05 (CINCO) DIAS, INFORMANDO SE DA POR SATISFEITA A OBRIGACAO. ANOTE-SE QUE O SILENCIO SERA INTERPRETADO COMO CONCORDANCIA, HIPOTESE EM QUE OS AUTOS TORNARAO CONCLUSOS PARA EXTINCAO DA EXECUCAO (CPC, ART. 924, II). INTIMEM-SE. ADVOGADOS(S): FABIO ROBERTO BERNARDO FERNANDES (OAB 177019/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2021-02-23T00:00:00",
                    "CaptureDate": "2022-11-11T14:58:16"
                  },
                  {
                    "Content": "DECISAO | VISTOS. FLS. 117:DIANTE DA ALEGACAO DA RE DO CUMPRIMENTO DO ACORDO, MANIFESTE-SE A PARTE AUTORA EM05 (CINCO) DIAS, INFORMANDO SE DA POR SATISFEITA A OBRIGACAO. ANOTE-SE QUE O SILENCIO SERA INTERPRETADO COMO CONCORDANCIA, HIPOTESE EM QUE OS AUTOS TORNARAO CONCLUSOS PARA EXTINCAO DA EXECUCAO (CPC, ART. 924, II). INTIMEM-SE.",
                    "PublishDate": "2021-02-22T00:00:00",
                    "CaptureDate": "2021-03-14T14:39:39"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO",
                    "PublishDate": "2021-02-22T00:00:00",
                    "CaptureDate": "2021-03-14T14:39:39"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO",
                    "PublishDate": "2021-02-22T00:00:00",
                    "CaptureDate": "2022-11-11T14:58:16"
                  },
                  {
                    "Content": "DECISAO VISTOS. FLS. 117:DIANTE DA ALEGACAO DA RE DO CUMPRIMENTO DO ACORDO, MANIFESTE-SE A PARTE AUTORA EM05 (CINCO) DIAS, INFORMANDO SE DA POR SATISFEITA A OBRIGACAO. ANOTE-SE QUE O SILENCIO SERA INTERPRETADO COMO CONCORDANCIA, HIPOTESE EM QUE OS AUTOS TORNARAO CONCLUSOS PARA EXTINCAO DA EXECUCAO (CPC, ART. 924, II). INTIMEM-SE.",
                    "PublishDate": "2021-02-22T00:00:00",
                    "CaptureDate": "2022-11-11T14:58:16"
                  },
                  {
                    "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.21.40240875-7 TIPO DA PETICAO: PETICAO INTERMEDIARIA DATA: 19/02/2021 20:45",
                    "PublishDate": "2021-02-19T00:00:00",
                    "CaptureDate": "2021-03-14T14:39:39"
                  },
                  {
                    "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.21.40240875-7 TIPO DA PETICAO: PETICAO INTERMEDIARIA DATA: 19/02/2021 20:45",
                    "PublishDate": "2021-02-19T00:00:00",
                    "CaptureDate": "2022-11-11T14:58:16"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0027/2021 DATA DA DISPONIBILIZACAO: 11/02/2021 DATA DA PUBLICACAO: 12/02/2021 NUMERO DO DIARIO: 3215 PAGINA: 205/228",
                    "PublishDate": "2021-02-11T00:00:00",
                    "CaptureDate": "2021-02-19T22:10:31"
                  },
                  {
                    "Content": "PROCESSO 1121887-27.2020.8.26.0100 - PROCEDIMENTO COMUM CIVEL - LOCACAO DE IMOVEL - CAIO ROCHA DOTTORI GASPAR - - CAROLINA CORREA KOURY DO VALLE - UNISERVICE CONSULTORIA E PLANEJAMENTO LTDA. ME - VISTOS. FLS. 109/110: CIENTE. POR ORA, REPORTO- ME A SENTENCA RETRO, ULTIMO PARAGRAFO. INTIMEM-SE. - ADV: FABIO ROBERTO BERNARDO FERNANDES (OAB 177019/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2021-02-11T00:00:00",
                    "CaptureDate": "2021-03-19T16:14:20"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0027/2021 DATA DA DISPONIBILIZACAO: 11/02/2021 DATA DA PUBLICACAO: 12/02/2021 NUMERO DO DIARIO: 3215 PAGINA: 205/228",
                    "PublishDate": "2021-02-11T00:00:00",
                    "CaptureDate": "2022-11-11T14:58:16"
                  },
                  {
                    "Content": "REMETIDO AO DJE | RELACAO: 0027/2021 TEOR DO ATO: VISTOS. FLS. 109/110: CIENTE. POR ORA, REPORTO-ME A SENTENCA RETRO, ULTIMO PARAGRAFO. INTIMEM-SE. ADVOGADOS(S): FABIO ROBERTO BERNARDO FERNANDES (OAB 177019/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2021-02-10T00:00:00",
                    "CaptureDate": "2021-02-19T22:10:31"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0026/2021 DATA DA DISPONIBILIZACAO: 10/02/2021 DATA DA PUBLICACAO: 11/02/2021 NUMERO DO DIARIO: 3214 PAGINA: 227/256",
                    "PublishDate": "2021-02-10T00:00:00",
                    "CaptureDate": "2021-02-19T22:10:31"
                  },
                  {
                    "Content": "PROCESSO 1121887-27.2020.8.26.0100 - PROCEDIMENTO COMUM CIVEL - LOCACAO DE IMOVEL - CAIO ROCHA DOTTORI GASPAR - - CAROLINA CORREA KOURY DO VALLE - UNISERVICE CONSULTORIA E PLANEJAMENTO LTDA. ME - VISTOS. FLS. 102/104: HOMOLOGO POR SENTENCA, PARA QUE PRODUZA SEUS JURIDICOS E LEGAIS EFEITOS, A TRANSACAO CELEBRADA ENTRE AS PARTES, COM O FIM DE POR TERMO AO PROCESSO (ART. 840, CC) QUE TEM POR OBJETO DIREITOS DISPONIVEIS (ART. 841, CC), COM FUNDAMENTO NO ARTIGO 487, INCISO III, ALINEA B, DO CODIGO DE PROCESSO CIVIL. AUSENTE O INTERESSE RECURSAL, CERTIFIQUE-SE DESDE LOGO O TRANSITO EM JULGADO. DIGA A PARTE CREDORA SE HOUVE O CUMPRIMENTO DO ACORDO, REPUTANDO-SE O SILENCIO COMO ANUENCIA TACITA A EXTINCAO PELA SATISFACAO DA OBRIGACAO. P.R.I.C. - ADV: FABIO ROBERTO BERNARDO FERNANDES (OAB 177019/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2021-02-10T00:00:00",
                    "CaptureDate": "2021-03-19T19:33:14"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0026/2021 DATA DA DISPONIBILIZACAO: 10/02/2021 DATA DA PUBLICACAO: 11/02/2021 NUMERO DO DIARIO: 3214 PAGINA: 227/256",
                    "PublishDate": "2021-02-10T00:00:00",
                    "CaptureDate": "2022-11-11T14:58:16"
                  },
                  {
                    "Content": "REMETIDO AO DJE RELACAO: 0027/2021 TEOR DO ATO: VISTOS. FLS. 109/110: CIENTE. POR ORA, REPORTO-ME A SENTENCA RETRO, ULTIMO PARAGRAFO. INTIMEM-SE. ADVOGADOS(S): FABIO ROBERTO BERNARDO FERNANDES (OAB 177019/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2021-02-10T00:00:00",
                    "CaptureDate": "2022-11-11T14:58:16"
                  },
                  {
                    "Content": "MERO EXPEDIENTE | VISTOS. FLS. 109/110: CIENTE. POR ORA, REPORTO-ME A SENTENCA RETRO, ULTIMO PARAGRAFO. INTIMEM-SE.",
                    "PublishDate": "2021-02-09T00:00:00",
                    "CaptureDate": "2021-02-19T22:10:31"
                  },
                  {
                    "Content": "REMETIDO AO DJE | RELACAO: 0026/2021 TEOR DO ATO: VISTOS. FLS. 102/104: HOMOLOGO POR SENTENCA, PARA QUE PRODUZA SEUS JURIDICOS E LEGAIS EFEITOS, A TRANSACAO CELEBRADA ENTRE AS PARTES, COM O FIM DE POR TERMO AO PROCESSO (ART. 840, CC) QUE TEM POR OBJETO DIREITOS DISPONIVEIS (ART. 841, CC), COM FUNDAMENTO NO ARTIGO 487, INCISO III, ALINEA B, DO CODIGO DE PROCESSO CIVIL. AUSENTE O INTERESSE RECURSAL, CERTIFIQUE-SE DESDE LOGO O TRANSITO EM JULGADO. DIGA A PARTE CREDORA SE HOUVE O CUMPRIMENTO DO ACORDO, REPUTANDO-SE O SILENCIO COMO ANUENCIA TACITA A EXTINCAO PELA SATISFACAO DA OBRIGACAO. P.R.I.C. ADVOGADOS(S): FABIO ROBERTO BERNARDO FERNANDES (OAB 177019/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2021-02-09T00:00:00",
                    "CaptureDate": "2021-02-19T22:10:31"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO",
                    "PublishDate": "2021-02-09T00:00:00",
                    "CaptureDate": "2021-02-19T22:10:31"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO",
                    "PublishDate": "2021-02-09T00:00:00",
                    "CaptureDate": "2022-11-11T14:58:16"
                  },
                  {
                    "Content": "REMETIDO AO DJE RELACAO: 0026/2021 TEOR DO ATO: VISTOS. FLS. 102/104: HOMOLOGO POR SENTENCA, PARA QUE PRODUZA SEUS JURIDICOS E LEGAIS EFEITOS, A TRANSACAO CELEBRADA ENTRE AS PARTES, COM O FIM DE POR TERMO AO PROCESSO (ART. 840, CC) QUE TEM POR OBJETO DIREITOS DISPONIVEIS (ART. 841, CC), COM FUNDAMENTO NO ARTIGO 487, INCISO III, ALINEA B, DO CODIGO DE PROCESSO CIVIL. AUSENTE O INTERESSE RECURSAL, CERTIFIQUE-SE DESDE LOGO O TRANSITO EM JULGADO. DIGA A PARTE CREDORA SE HOUVE O CUMPRIMENTO DO ACORDO, REPUTANDO-SE O SILENCIO COMO ANUENCIA TACITA A EXTINCAO PELA SATISFACAO DA OBRIGACAO. P.R.I.C. ADVOGADOS(S): FABIO ROBERTO BERNARDO FERNANDES (OAB 177019/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2021-02-09T00:00:00",
                    "CaptureDate": "2022-11-11T14:58:16"
                  },
                  {
                    "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE VISTOS. FLS. 109/110: CIENTE. POR ORA, REPORTO-ME A SENTENCA RETRO, ULTIMO PARAGRAFO. INTIMEM-SE.",
                    "PublishDate": "2021-02-09T00:00:00",
                    "CaptureDate": "2022-11-11T14:58:16"
                  },
                  {
                    "Content": "HOMOLOGADA A TRANSACAO DE ACORDO EXTRAJUDICIAL | VISTOS. FLS. 102/104: HOMOLOGO POR SENTENCA, PARA QUE PRODUZA SEUS JURIDICOS E LEGAIS EFEITOS, A TRANSACAO CELEBRADA ENTRE AS PARTES, COM O FIM DE POR TERMO AO PROCESSO (ART. 840, CC) QUE TEM POR OBJETO DIREITOS DISPONIVEIS (ART. 841, CC), COM FUNDAMENTO NO ARTIGO 487, INCISO III, ALINEA B, DO CODIGO DE PROCESSO CIVIL. AUSENTE O INTERESSE RECURSAL, CERTIFIQUE-SE DESDE LOGO O TRANSITO EM JULGADO. DIGA A PARTE CREDORA SE HOUVE O CUMPRIMENTO DO ACORDO, REPUTANDO-SE O SILENCIO COMO ANUENCIA TACITA A EXTINCAO PELA SATISFACAO DA OBRIGACAO. P.R.I.C.",
                    "PublishDate": "2021-02-08T00:00:00",
                    "CaptureDate": "2021-02-19T22:10:31"
                  },
                  {
                    "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.21.40149791-8 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 08/02/2021 13:55",
                    "PublishDate": "2021-02-08T00:00:00",
                    "CaptureDate": "2021-02-19T22:10:31"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO",
                    "PublishDate": "2021-02-08T00:00:00",
                    "CaptureDate": "2021-02-19T22:10:31"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO",
                    "PublishDate": "2021-02-08T00:00:00",
                    "CaptureDate": "2022-11-11T14:58:16"
                  },
                  {
                    "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.21.40149791-8 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 08/02/2021 13:55",
                    "PublishDate": "2021-02-08T00:00:00",
                    "CaptureDate": "2022-11-11T14:58:16"
                  },
                  {
                    "Content": "HOMOLOGADA A TRANSACAO DE ACORDO EXTRAJUDICIAL VISTOS. FLS. 102/104: HOMOLOGO POR SENTENCA, PARA QUE PRODUZA SEUS JURIDICOS E LEGAIS EFEITOS, A TRANSACAO CELEBRADA ENTRE AS PARTES, COM O FIM DE POR TERMO AO PROCESSO (ART. 840, CC) QUE TEM POR OBJETO DIREITOS DISPONIVEIS (ART. 841, CC), COM FUNDAMENTO NO ARTIGO 487, INCISO III, ALINEA B, DO CODIGO DE PROCESSO CIVIL. AUSENTE O INTERESSE RECURSAL, CERTIFIQUE-SE DESDE LOGO O TRANSITO EM JULGADO. DIGA A PARTE CREDORA SE HOUVE O CUMPRIMENTO DO ACORDO, REPUTANDO-SE O SILENCIO COMO ANUENCIA TACITA A EXTINCAO PELA SATISFACAO DA OBRIGACAO. P.R.I.C.",
                    "PublishDate": "2021-02-08T00:00:00",
                    "CaptureDate": "2022-11-11T14:58:16"
                  },
                  {
                    "Content": "PEDIDO DE HOMOLOGACAO DE ACORDO JUNTADO | N PROTOCOLO: WJMJ.21.40140405-7 TIPO DA PETICAO: PEDIDO DE HOMOLOGACAO DE ACORDO DATA: 05/02/2021 14:22",
                    "PublishDate": "2021-02-05T00:00:00",
                    "CaptureDate": "2021-02-19T22:10:31"
                  },
                  {
                    "Content": "PEDIDO DE HOMOLOGACAO DE ACORDO JUNTADO N PROTOCOLO: WJMJ.21.40140405-7 TIPO DA PETICAO: PEDIDO DE HOMOLOGACAO DE ACORDO DATA: 05/02/2021 14:22",
                    "PublishDate": "2021-02-05T00:00:00",
                    "CaptureDate": "2022-11-11T14:58:16"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0014/2021 DATA DA DISPONIBILIZACAO: 04/02/2021 DATA DA PUBLICACAO: 05/02/2021 NUMERO DO DIARIO: 3210 PAGINA: 251/280",
                    "PublishDate": "2021-02-04T00:00:00",
                    "CaptureDate": "2021-02-19T22:10:31"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0013/2021 DATA DA DISPONIBILIZACAO: 04/02/2021 DATA DA PUBLICACAO: 05/02/2021 NUMERO DO DIARIO: 3210 PAGINA: 218/251",
                    "PublishDate": "2021-02-04T00:00:00",
                    "CaptureDate": "2021-02-19T22:10:31"
                  },
                  {
                    "Content": "PROCESSO 1121887-27.2020.8.26.0100 - PROCEDIMENTO COMUM CIVEL - LOCACAO DE IMOVEL - CAIO ROCHA DOTTORI GASPAR - - CAROLINA CORREA KOURY DO VALLE - UNISERVICE CONSULTORIA E PLANEJAMENTO LTDA. ME - VISTOS. FL. 87: CIENTE O JUIZO. NO MAIS, REPORTO-ME AO DETERMINADO EM FL. 86. INTIMEM-SE. - ADV: FABIO ROBERTO BERNARDO FERNANDES (OAB 177019/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP) PROCESSO 1121887-27.2020.8.26.0100 - PROCEDIMENTO COMUM CIVEL - LOCACAO DE IMOVEL - CAIO ROCHA DOTTORI GASPAR - - CAROLINA CORREA KOURY DO VALLE - UNISERVICE CONSULTORIA E PLANEJAMENTO LTDA. ME - VISTOS. 1 - FLS. 91/94: RECEBO COMO EMENDA A INICIAL, FICANDO RETIFICADO O VALOR DA CAUSA PARA R$ 58.338,84. ANOTE-SE. 2 - FL. 95: CIENCIA A PARTE AUTORA. 3 INTIME-SE A RE, JA HABILITADA NOS AUTOS, PARA CONTESTAR O FEITO, NO PRAZO DE 15 (QUINZE) DIAS UTEIS. A AUSENCIA DE CONTESTACAO IMPLICARA REVELIA E PRESUNCAO DE VERACIDADE DA MATERIA FATICA APRESENTADA NA PETICAO INICIAL. INTIMEM-SE. - ADV: RAFAEL HIDEO NAZIMA (OAB 295443/SP), FABIO ROBERTO BERNARDO FERNANDES (OAB 177019/SP)",
                    "PublishDate": "2021-02-04T00:00:00",
                    "CaptureDate": "2021-03-20T18:47:23"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0013/2021 DATA DA DISPONIBILIZACAO: 04/02/2021 DATA DA PUBLICACAO: 05/02/2021 NUMERO DO DIARIO: 3210 PAGINA: 218/251",
                    "PublishDate": "2021-02-04T00:00:00",
                    "CaptureDate": "2022-11-11T14:58:16"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0014/2021 DATA DA DISPONIBILIZACAO: 04/02/2021 DATA DA PUBLICACAO: 05/02/2021 NUMERO DO DIARIO: 3210 PAGINA: 251/280",
                    "PublishDate": "2021-02-04T00:00:00",
                    "CaptureDate": "2022-11-11T14:58:16"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0011/2021 DATA DA DISPONIBILIZACAO: 03/02/2021 DATA DA PUBLICACAO: 04/02/2021 NUMERO DO DIARIO: 3209 PAGINA: 162/196",
                    "PublishDate": "2021-02-03T00:00:00",
                    "CaptureDate": "2021-02-19T22:10:31"
                  },
                  {
                    "Content": "PROCESSO 1121887-27.2020.8.26.0100 - PROCEDIMENTO COMUM CIVEL - LOCACAO DE IMOVEL - CAIO ROCHA DOTTORI GASPAR - - CAROLINA CORREA KOURY DO VALLE - UNISERVICE CONSULTORIA E PLANEJAMENTO LTDA. ME - VISTOS. FLS. 82/85: DIANTE DO COMPARECIMENTO ESPONTANEO DA RE, FICA HABILITADA NOS AUTOS, COM A ANOTACAO DE SEU PATRONO NO CADASTRO PROCESSUAL. NO PRAZO DE 10 DIAS, RECOLHA A REQUERIDA, AS CUSTAS DE MANDATO SOB PENA DE SER OFICIADO A OAB, PARA QUE SEJAM TOMADAS AS MEDIDAS ADMINISTRATIVAS NECESSARIAS. AINDA, DEFIRO A RE A RETIRADA DAS CHAVES DO IMOVEL DESOCUPADO, ARMAZENADAS NESTE OFICIO, CONFORME CERTIDAO DE FLS. 81. NO MAIS, AGUARDE-SE O DECURSO DO PRAZO DA DECISAO DE FL. 78. INTIMEM-SE. - ADV: RAFAEL HIDEO NAZIMA (OAB 295443/ SP), FABIO ROBERTO BERNARDO FERNANDES (OAB 177019/SP)",
                    "PublishDate": "2021-02-03T00:00:00",
                    "CaptureDate": "2021-03-20T22:35:18"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0011/2021 DATA DA DISPONIBILIZACAO: 03/02/2021 DATA DA PUBLICACAO: 04/02/2021 NUMERO DO DIARIO: 3209 PAGINA: 162/196",
                    "PublishDate": "2021-02-03T00:00:00",
                    "CaptureDate": "2022-11-11T14:58:16"
                  },
                  {
                    "Content": "REMETIDO AO DJE | RELACAO: 0014/2021 TEOR DO ATO: VISTOS. 1 - FLS. 91/94: RECEBO COMO EMENDA A INICIAL, FICANDO RETIFICADO O VALOR DA CAUSA PARA R$ 58.338,84. ANOTE-SE. 2 - FL. 95: CIENCIA A PARTE AUTORA. 3 INTIME-SE A RE, JA HABILITADA NOS AUTOS, PARA CONTESTAR O FEITO, NO PRAZO DE 15 (QUINZE) DIAS UTEIS. A AUSENCIA DE CONTESTACAO IMPLICARA REVELIA E PRESUNCAO DE VERACIDADE DA MATERIA FATICA APRESENTADA NA PETICAO INICIAL. INTIMEM-SE. ADVOGADOS(S): FABIO ROBERTO BERNARDO FERNANDES (OAB 177019/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2021-01-27T00:00:00",
                    "CaptureDate": "2021-02-19T22:10:31"
                  },
                  {
                    "Content": "CERTIDAO DE CARTORIO EXPEDIDA | CERTIDAO - GENERICA",
                    "PublishDate": "2021-01-27T00:00:00",
                    "CaptureDate": "2021-02-19T22:10:31"
                  },
                  {
                    "Content": "CERTIDAO DE CARTORIO EXPEDIDA CERTIDAO - GENERICA",
                    "PublishDate": "2021-01-27T00:00:00",
                    "CaptureDate": "2022-11-11T14:58:16"
                  },
                  {
                    "Content": "REMETIDO AO DJE RELACAO: 0014/2021 TEOR DO ATO: VISTOS. 1 - FLS. 91/94: RECEBO COMO EMENDA A INICIAL, FICANDO RETIFICADO O VALOR DA CAUSA PARA R$ 58.338,84. ANOTE-SE. 2 - FL. 95: CIENCIA A PARTE AUTORA. 3 INTIME-SE A RE, JA HABILITADA NOS AUTOS, PARA CONTESTAR O FEITO, NO PRAZO DE 15 (QUINZE) DIAS UTEIS. A AUSENCIA DE CONTESTACAO IMPLICARA REVELIA E PRESUNCAO DE VERACIDADE DA MATERIA FATICA APRESENTADA NA PETICAO INICIAL. INTIMEM-SE. ADVOGADOS(S): FABIO ROBERTO BERNARDO FERNANDES (OAB 177019/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2021-01-27T00:00:00",
                    "CaptureDate": "2022-11-11T14:58:16"
                  },
                  {
                    "Content": "DECISAO | VISTOS. 1 - FLS. 91/94: RECEBO COMO EMENDA A INICIAL, FICANDO RETIFICADO O VALOR DA CAUSA PARA R$ 58.338,84. ANOTE-SE. 2 - FL. 95: CIENCIA A PARTE AUTORA. 3 INTIME-SE A RE, JA HABILITADA NOS AUTOS, PARA CONTESTAR O FEITO, NO PRAZO DE 15 (QUINZE) DIAS UTEIS. A AUSENCIA DE CONTESTACAO IMPLICARA REVELIA E PRESUNCAO DE VERACIDADE DA MATERIA FATICA APRESENTADA NA PETICAO INICIAL. INTIMEM-SE.",
                    "PublishDate": "2021-01-26T00:00:00",
                    "CaptureDate": "2021-02-19T22:10:31"
                  },
                  {
                    "Content": "REMETIDO AO DJE | RELACAO: 0013/2021 TEOR DO ATO: VISTOS. FL. 87: CIENTE O JUIZO. NO MAIS, REPORTO-ME AO DETERMINADO EM FL. 86. INTIMEM-SE. ADVOGADOS(S): FABIO ROBERTO BERNARDO FERNANDES (OAB 177019/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2021-01-26T00:00:00",
                    "CaptureDate": "2021-02-19T22:10:31"
                  },
                  {
                    "Content": "CERTIDAO DE CARTORIO EXPEDIDA | CERTIDAO - GENERICA",
                    "PublishDate": "2021-01-26T00:00:00",
                    "CaptureDate": "2021-02-19T22:10:31"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO",
                    "PublishDate": "2021-01-26T00:00:00",
                    "CaptureDate": "2021-02-19T22:10:31"
                  },
                  {
                    "Content": "EMENDA A INICIAL JUNTADA | N PROTOCOLO: WJMJ.21.40066367-9 TIPO DA PETICAO: EMENDA A INICIAL DATA: 26/01/2021 02:09",
                    "PublishDate": "2021-01-26T00:00:00",
                    "CaptureDate": "2021-02-19T22:10:31"
                  },
                  {
                    "Content": "EMENDA A INICIAL JUNTADA N PROTOCOLO: WJMJ.21.40066367-9 TIPO DA PETICAO: EMENDA A INICIAL DATA: 26/01/2021 02:09",
                    "PublishDate": "2021-01-26T00:00:00",
                    "CaptureDate": "2022-11-11T14:58:16"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO",
                    "PublishDate": "2021-01-26T00:00:00",
                    "CaptureDate": "2022-11-11T14:58:16"
                  },
                  {
                    "Content": "CERTIDAO DE CARTORIO EXPEDIDA CERTIDAO - GENERICA",
                    "PublishDate": "2021-01-26T00:00:00",
                    "CaptureDate": "2022-11-11T14:58:16"
                  },
                  {
                    "Content": "REMETIDO AO DJE RELACAO: 0013/2021 TEOR DO ATO: VISTOS. FL. 87: CIENTE O JUIZO. NO MAIS, REPORTO-ME AO DETERMINADO EM FL. 86. INTIMEM-SE. ADVOGADOS(S): FABIO ROBERTO BERNARDO FERNANDES (OAB 177019/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2021-01-26T00:00:00",
                    "CaptureDate": "2022-11-11T14:58:16"
                  },
                  {
                    "Content": "DECISAO VISTOS. 1 - FLS. 91/94: RECEBO COMO EMENDA A INICIAL, FICANDO RETIFICADO O VALOR DA CAUSA PARA R$ 58.338,84. ANOTE-SE. 2 - FL. 95: CIENCIA A PARTE AUTORA. 3 INTIME-SE A RE, JA HABILITADA NOS AUTOS, PARA CONTESTAR O FEITO, NO PRAZO DE 15 (QUINZE) DIAS UTEIS. A AUSENCIA DE CONTESTACAO IMPLICARA REVELIA E PRESUNCAO DE VERACIDADE DA MATERIA FATICA APRESENTADA NA PETICAO INICIAL. INTIMEM-SE.",
                    "PublishDate": "2021-01-26T00:00:00",
                    "CaptureDate": "2022-11-11T14:58:16"
                  },
                  {
                    "Content": "MERO EXPEDIENTE | VISTOS. FL. 87: CIENTE O JUIZO. NO MAIS, REPORTO-ME AO DETERMINADO EM FL. 86. INTIMEM-SE.",
                    "PublishDate": "2021-01-22T00:00:00",
                    "CaptureDate": "2021-02-19T22:10:31"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO",
                    "PublishDate": "2021-01-22T00:00:00",
                    "CaptureDate": "2021-02-19T22:10:31"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO",
                    "PublishDate": "2021-01-22T00:00:00",
                    "CaptureDate": "2022-11-11T14:58:16"
                  },
                  {
                    "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE VISTOS. FL. 87: CIENTE O JUIZO. NO MAIS, REPORTO-ME AO DETERMINADO EM FL. 86. INTIMEM-SE.",
                    "PublishDate": "2021-01-22T00:00:00",
                    "CaptureDate": "2022-11-11T14:58:16"
                  },
                  {
                    "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.21.40055583-3 TIPO DA PETICAO: PETICAO INTERMEDIARIA DATA: 21/01/2021 22:13",
                    "PublishDate": "2021-01-21T00:00:00",
                    "CaptureDate": "2021-02-19T22:10:31"
                  },
                  {
                    "Content": "REMETIDO AO DJE | RELACAO: 0011/2021 TEOR DO ATO: VISTOS. FLS. 82/85: DIANTE DO COMPARECIMENTO ESPONTANEO DA RE, FICA HABILITADA NOS AUTOS, COM A ANOTACAO DE SEU PATRONO NO CADASTRO PROCESSUAL. NO PRAZO DE 10 DIAS, RECOLHA A REQUERIDA, AS CUSTAS DE MANDATO SOB PENA DE SER OFICIADO A OAB, PARA QUE SEJAM TOMADAS AS MEDIDAS ADMINISTRATIVAS NECESSARIAS. AINDA, DEFIRO A RE A RETIRADA DAS CHAVES DO IMOVEL DESOCUPADO, ARMAZENADAS NESTE OFICIO, CONFORME CERTIDAO DE FLS. 81. NO MAIS, AGUARDE-SE O DECURSO DO PRAZO DA DECISAO DE FL. 78. INTIMEM-SE. ADVOGADOS(S): FABIO ROBERTO BERNARDO FERNANDES (OAB 177019/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2021-01-21T00:00:00",
                    "CaptureDate": "2021-02-19T22:10:31"
                  },
                  {
                    "Content": "REMETIDO AO DJE RELACAO: 0011/2021 TEOR DO ATO: VISTOS. FLS. 82/85: DIANTE DO COMPARECIMENTO ESPONTANEO DA RE, FICA HABILITADA NOS AUTOS, COM A ANOTACAO DE SEU PATRONO NO CADASTRO PROCESSUAL. NO PRAZO DE 10 DIAS, RECOLHA A REQUERIDA, AS CUSTAS DE MANDATO SOB PENA DE SER OFICIADO A OAB, PARA QUE SEJAM TOMADAS AS MEDIDAS ADMINISTRATIVAS NECESSARIAS. AINDA, DEFIRO A RE A RETIRADA DAS CHAVES DO IMOVEL DESOCUPADO, ARMAZENADAS NESTE OFICIO, CONFORME CERTIDAO DE FLS. 81. NO MAIS, AGUARDE-SE O DECURSO DO PRAZO DA DECISAO DE FL. 78. INTIMEM-SE. ADVOGADOS(S): FABIO ROBERTO BERNARDO FERNANDES (OAB 177019/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2021-01-21T00:00:00",
                    "CaptureDate": "2022-11-11T14:58:16"
                  },
                  {
                    "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.21.40055583-3 TIPO DA PETICAO: PETICAO INTERMEDIARIA DATA: 21/01/2021 22:13",
                    "PublishDate": "2021-01-21T00:00:00",
                    "CaptureDate": "2022-11-11T14:58:16"
                  },
                  {
                    "Content": "DECISAO | VISTOS. FLS. 82/85: DIANTE DO COMPARECIMENTO ESPONTANEO DA RE, FICA HABILITADA NOS AUTOS, COM A ANOTACAO DE SEU PATRONO NO CADASTRO PROCESSUAL. NO PRAZO DE 10 DIAS, RECOLHA A REQUERIDA, AS CUSTAS DE MANDATO SOB PENA DE SER OFICIADO A OAB, PARA QUE SEJAM TOMADAS AS MEDIDAS ADMINISTRATIVAS NECESSARIAS. AINDA, DEFIRO A RE A RETIRADA DAS CHAVES DO IMOVEL DESOCUPADO, ARMAZENADAS NESTE OFICIO, CONFORME CERTIDAO DE FLS. 81. NO MAIS, AGUARDE-SE O DECURSO DO PRAZO DA DECISAO DE FL. 78. INTIMEM-SE.",
                    "PublishDate": "2021-01-20T00:00:00",
                    "CaptureDate": "2021-02-19T22:10:31"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO",
                    "PublishDate": "2021-01-20T00:00:00",
                    "CaptureDate": "2021-02-19T22:10:31"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO",
                    "PublishDate": "2021-01-20T00:00:00",
                    "CaptureDate": "2022-11-11T14:58:16"
                  },
                  {
                    "Content": "DECISAO VISTOS. FLS. 82/85: DIANTE DO COMPARECIMENTO ESPONTANEO DA RE, FICA HABILITADA NOS AUTOS, COM A ANOTACAO DE SEU PATRONO NO CADASTRO PROCESSUAL. NO PRAZO DE 10 DIAS, RECOLHA A REQUERIDA, AS CUSTAS DE MANDATO SOB PENA DE SER OFICIADO A OAB, PARA QUE SEJAM TOMADAS AS MEDIDAS ADMINISTRATIVAS NECESSARIAS. AINDA, DEFIRO A RE A RETIRADA DAS CHAVES DO IMOVEL DESOCUPADO, ARMAZENADAS NESTE OFICIO, CONFORME CERTIDAO DE FLS. 81. NO MAIS, AGUARDE-SE O DECURSO DO PRAZO DA DECISAO DE FL. 78. INTIMEM-SE.",
                    "PublishDate": "2021-01-20T00:00:00",
                    "CaptureDate": "2022-11-11T14:58:16"
                  },
                  {
                    "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.21.40042371-6 TIPO DA PETICAO: PETICAO INTERMEDIARIA DATA: 19/01/2021 21:35",
                    "PublishDate": "2021-01-19T00:00:00",
                    "CaptureDate": "2021-02-19T22:10:31"
                  },
                  {
                    "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.21.40042371-6 TIPO DA PETICAO: PETICAO INTERMEDIARIA DATA: 19/01/2021 21:35",
                    "PublishDate": "2021-01-19T00:00:00",
                    "CaptureDate": "2022-11-11T14:58:16"
                  },
                  {
                    "Content": "CERTIDAO DE CARTORIO EXPEDIDA | CERTIDAO - GENERICA",
                    "PublishDate": "2020-12-18T00:00:00",
                    "CaptureDate": "2021-02-19T22:10:31"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0396/2020 DATA DA DISPONIBILIZACAO: 18/12/2020 DATA DA PUBLICACAO: 21/01/2021 NUMERO DO DIARIO: 3190 PAGINA: 665/688",
                    "PublishDate": "2020-12-18T00:00:00",
                    "CaptureDate": "2021-02-19T22:10:31"
                  },
                  {
                    "Content": "PROCESSO :1121887-27.2020.8.26.0100 CLASSE :PROCEDIMENTO COMUM CIVEL REQTE : CAROLINA CORREA KOURY DO VALLE ADVOGADO : 295443/SP - RAFAEL HIDEO NAZIMA REQDO : UNISERVICE CONSULTORIA E PLANEJAMENTO LTDA. ME VARA :11 VARA CIVEL PROCESSO 1121887-27.2020.8.26.0100 - PROCEDIMENTO COMUM CIVEL - LOCACAO DE IMOVEL - CAIO ROCHA DOTTORI GASPAR - - CAROLINA CORREA KOURY DO VALLE - UNISERVICE CONSULTORIA E PLANEJAMENTO LTDA. ME - VISTOS. 1) PRESENTES OS REQUISITOS LEGAIS, NOTADAMENTE DIANTE DOS DOCUMENTOS JUNTADOS A FLS. 45/48, DEFIRO O PEDIDO LIMINAR FORMULADO, AUTORIZANDO O DEPOSITO DAS CHAVES EM JUIZO, MEDIANTE PREVIO AGENDAMENTO PARA ATENDIMENTO, CONSIDERANDO A ATUAL SITUACAO PELA QUAL PASSAMOS. 2) SEM PREJUIZO, EMENDA A PARTE AUTORA SUA PETICAO INICIAL, NO PRAZO DE 15 DIAS, ADEQUANDO O VALOR DADO A CAUSA, QUE DEVERA CORRESPONDER A SOMA DE DOZE MESES DO ALUGUEL (ARTIGO 58, III, DA LEI N. 8245/91), RECOLHENDO AS CUSTAS COMPLEMENTARES. DEVE O(A) ADVOGADO(A), AO PROCEDER A EMENDA A PETICAO INICIAL, POR MEIO DO LINK DE PETICAO INTERMEDIARIA DE 1 GRAU, CADASTRA-LA NA CATEGORIA PETICOES DIVERSAS, TIPO DE PETICAO: 8431 - EMENDA A INICIAL, A FIM DE CONFERIR MAIOR AGILIDADE NA IDENTIFICACAO NO FLUXO DE TRABALHO, ONDE SE PROCESSAM OS AUTOS DIGITAIS, SOB PENA DE A APRECIACAO DA PETICAO INICIAL AGUARDAR A ORDEM DE PROTOCOLO DOS DEMAIS AUTOS CONCLUSOS, ACARRETANDO PREJUIZOS E MOROSIDADE NO ANDAMENTO DOS AUTOS DIGITAIS. INT. - ADV: RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2020-12-18T00:00:00",
                    "CaptureDate": "2021-02-19T22:10:31"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0396/2020 DATA DA DISPONIBILIZACAO: 18/12/2020 DATA DA PUBLICACAO: 21/01/2021 NUMERO DO DIARIO: 3190 PAGINA: 665/688",
                    "PublishDate": "2020-12-18T00:00:00",
                    "CaptureDate": "2022-11-11T14:58:16"
                  },
                  {
                    "Content": "CERTIDAO DE CARTORIO EXPEDIDA CERTIDAO - GENERICA",
                    "PublishDate": "2020-12-18T00:00:00",
                    "CaptureDate": "2022-11-11T14:58:16"
                  },
                  {
                    "Content": "REMETIDO AO DJE | RELACAO: 0396/2020 TEOR DO ATO: VISTOS. 1) PRESENTES OS REQUISITOS LEGAIS, NOTADAMENTE DIANTE DOS DOCUMENTOS JUNTADOS A FLS. 45/48, DEFIRO O PEDIDO LIMINAR FORMULADO, AUTORIZANDO O DEPOSITO DAS CHAVES EM JUIZO, MEDIANTE PREVIO AGENDAMENTO PARA ATENDIMENTO, CONSIDERANDO A ATUAL SITUACAO PELA QUAL PASSAMOS. 2) SEM PREJUIZO, EMENDA A PARTE AUTORA SUA PETICAO INICIAL, NO PRAZO DE 15 DIAS, ADEQUANDO O VALOR DADO A CAUSA, QUE DEVERA CORRESPONDER A SOMA DE DOZE MESES DO ALUGUEL (ARTIGO 58, III, DA LEI N. 8245/91), RECOLHENDO AS CUSTAS COMPLEMENTARES. DEVE O(A) ADVOGADO(A), AO PROCEDER A EMENDA A PETICAO INICIAL, POR MEIO DO LINK DE \"PETICAO INTERMEDIARIA DE 1 GRAU\", CADASTRA-LA NA CATEGORIA \"PETICOES DIVERSAS\", TIPO DE PETICAO: \"8431 - EMENDA A INICIAL\", A FIM DE CONFERIR MAIOR AGILIDADE NA IDENTIFICACAO NO FLUXO DE TRABALHO, ONDE SE PROCESSAM OS AUTOS DIGITAIS, SOB PENA DE A APRECIACAO DA PETICAO INICIAL AGUARDAR A ORDEM DE PROTOCOLO DOS DEMAIS AUTOS CONCLUSOS, ACARRETANDO PREJUIZOS E MOROSIDADE NO ANDAMENTO DOS AUTOS DIGITAIS. INT. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2020-12-17T00:00:00",
                    "CaptureDate": "2021-02-19T22:10:31"
                  },
                  {
                    "Content": "REMETIDO AO DJE RELACAO: 0396/2020 TEOR DO ATO: VISTOS. 1) PRESENTES OS REQUISITOS LEGAIS, NOTADAMENTE DIANTE DOS DOCUMENTOS JUNTADOS A FLS. 45/48, DEFIRO O PEDIDO LIMINAR FORMULADO, AUTORIZANDO O DEPOSITO DAS CHAVES EM JUIZO, MEDIANTE PREVIO AGENDAMENTO PARA ATENDIMENTO, CONSIDERANDO A ATUAL SITUACAO PELA QUAL PASSAMOS. 2) SEM PREJUIZO, EMENDA A PARTE AUTORA SUA PETICAO INICIAL, NO PRAZO DE 15 DIAS, ADEQUANDO O VALOR DADO A CAUSA, QUE DEVERA CORRESPONDER A SOMA DE DOZE MESES DO ALUGUEL (ARTIGO 58, III, DA LEI N. 8245/91), RECOLHENDO AS CUSTAS COMPLEMENTARES. DEVE O(A) ADVOGADO(A), AO PROCEDER A EMENDA A PETICAO INICIAL, POR MEIO DO LINK DE \"PETICAO INTERMEDIARIA DE 1 GRAU\", CADASTRA-LA NA CATEGORIA \"PETICOES DIVERSAS\", TIPO DE PETICAO: \"8431 - EMENDA A INICIAL\", A FIM DE CONFERIR MAIOR AGILIDADE NA IDENTIFICACAO NO FLUXO DE TRABALHO, ONDE SE PROCESSAM OS AUTOS DIGITAIS, SOB PENA DE A APRECIACAO DA PETICAO INICIAL AGUARDAR A ORDEM DE PROTOCOLO DOS DEMAIS AUTOS CONCLUSOS, ACARRETANDO PREJUIZOS E MOROSIDADE NO ANDAMENTO DOS AUTOS DIGITAIS. INT. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2020-12-17T00:00:00",
                    "CaptureDate": "2022-11-11T14:58:16"
                  },
                  {
                    "Content": "DETERMINADA A EMENDA A PETICAO INICIAL | VISTOS. 1) PRESENTES OS REQUISITOS LEGAIS, NOTADAMENTE DIANTE DOS DOCUMENTOS JUNTADOS A FLS. 45/48, DEFIRO O PEDIDO LIMINAR FORMULADO, AUTORIZANDO O DEPOSITO DAS CHAVES EM JUIZO, MEDIANTE PREVIO AGENDAMENTO PARA ATENDIMENTO, CONSIDERANDO A ATUAL SITUACAO PELA QUAL PASSAMOS. 2) SEM PREJUIZO, EMENDA A PARTE AUTORA SUA PETICAO INICIAL, NO PRAZO DE 15 DIAS, ADEQUANDO O VALOR DADO A CAUSA, QUE DEVERA CORRESPONDER A SOMA DE DOZE MESES DO ALUGUEL (ARTIGO 58, III, DA LEI N. 8245/91), RECOLHENDO AS CUSTAS COMPLEMENTARES. DEVE O(A) ADVOGADO(A), AO PROCEDER A EMENDA A PETICAO INICIAL, POR MEIO DO LINK DE \"PETICAO INTERMEDIARIA DE 1 GRAU\", CADASTRA-LA NA CATEGORIA \"PETICOES DIVERSAS\", TIPO DE PETICAO: \"8431 - EMENDA A INICIAL\", A FIM DE CONFERIR MAIOR AGILIDADE NA IDENTIFICACAO NO FLUXO DE TRABALHO, ONDE SE PROCESSAM OS AUTOS DIGITAIS, SOB PENA DE A APRECIACAO DA PETICAO INICIAL AGUARDAR A ORDEM DE PROTOCOLO DOS DEMAIS AUTOS CONCLUSOS, ACARRETANDO PREJUIZOS E MOROSIDADE NO ANDAMENTO DOS AUTOS DIGITAIS. INT.",
                    "PublishDate": "2020-12-16T00:00:00",
                    "CaptureDate": "2021-02-19T22:10:31"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO",
                    "PublishDate": "2020-12-16T00:00:00",
                    "CaptureDate": "2021-02-19T22:10:31"
                  },
                  {
                    "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                    "PublishDate": "2020-12-16T00:00:00",
                    "CaptureDate": "2021-02-19T22:10:31"
                  },
                  {
                    "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                    "PublishDate": "2020-12-16T00:00:00",
                    "CaptureDate": "2022-11-11T14:58:16"
                  },
                  {
                    "Content": "DETERMINADA A EMENDA A PETICAO INICIAL VISTOS. 1) PRESENTES OS REQUISITOS LEGAIS, NOTADAMENTE DIANTE DOS DOCUMENTOS JUNTADOS A FLS. 45/48, DEFIRO O PEDIDO LIMINAR FORMULADO, AUTORIZANDO O DEPOSITO DAS CHAVES EM JUIZO, MEDIANTE PREVIO AGENDAMENTO PARA ATENDIMENTO, CONSIDERANDO A ATUAL SITUACAO PELA QUAL PASSAMOS. 2) SEM PREJUIZO, EMENDA A PARTE AUTORA SUA PETICAO INICIAL, NO PRAZO DE 15 DIAS, ADEQUANDO O VALOR DADO A CAUSA, QUE DEVERA CORRESPONDER A SOMA DE DOZE MESES DO ALUGUEL (ARTIGO 58, III, DA LEI N. 8245/91), RECOLHENDO AS CUSTAS COMPLEMENTARES. DEVE O(A) ADVOGADO(A), AO PROCEDER A EMENDA A PETICAO INICIAL, POR MEIO DO LINK DE \"PETICAO INTERMEDIARIA DE 1 GRAU\", CADASTRA-LA NA CATEGORIA \"PETICOES DIVERSAS\", TIPO DE PETICAO: \"8431 - EMENDA A INICIAL\", A FIM DE CONFERIR MAIOR AGILIDADE NA IDENTIFICACAO NO FLUXO DE TRABALHO, ONDE SE PROCESSAM OS AUTOS DIGITAIS, SOB PENA DE A APRECIACAO DA PETICAO INICIAL AGUARDAR A ORDEM DE PROTOCOLO DOS DEMAIS AUTOS CONCLUSOS, ACARRETANDO PREJUIZOS E MOROSIDADE NO ANDAMENTO DOS AUTOS DIGITAIS. INT.",
                    "PublishDate": "2020-12-16T00:00:00",
                    "CaptureDate": "2022-11-11T14:58:16"
                  }
                ],
                "Petitions": [
                  {
                    "Type": "PETICAO INTERMEDIARIA",
                    "Author": "",
                    "CreationDate": "2021-01-19T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  },
                  {
                    "Type": "PETICAO INTERMEDIARIA",
                    "Author": "",
                    "CreationDate": "2021-01-21T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  },
                  {
                    "Type": "EMENDA A INICIAL",
                    "Author": "",
                    "CreationDate": "2021-01-26T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  },
                  {
                    "Type": "PEDIDO DE HOMOLOGACAO DE ACORDO",
                    "Author": "",
                    "CreationDate": "2021-02-05T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  },
                  {
                    "Type": "PETICOES DIVERSAS",
                    "Author": "",
                    "CreationDate": "2021-02-08T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  },
                  {
                    "Type": "PETICAO INTERMEDIARIA",
                    "Author": "",
                    "CreationDate": "2021-02-19T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  },
                  {
                    "Type": "PEDIDO DE ARQUIVAMENTO",
                    "Author": "",
                    "CreationDate": "2021-03-02T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  },
                  {
                    "Type": "PETICOES DIVERSAS",
                    "Author": "",
                    "CreationDate": "2022-05-13T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  }
                ],
                "Decisions": [
                  {
                    "DecisionContent": "JULGO EXTINTA A EXECUCAO, NOS TERMOS DO ART. 924, INCISO II DO CODIGO DE PROCESSO CIVIL.",
                    "DecisionDate": "2021-03-04T00:00:00"
                  },
                  {
                    "DecisionContent": "JULGO EXTINTA A EXECUCAO, NOS TERMOS DO ART. 924, INCISO II DO CODIGO DE PROCESSO CIVIL.",
                    "DecisionDate": "2021-03-03T00:00:00"
                  },
                  {
                    "DecisionContent": "JULGO EXTINTA A EXECUCAO, NOS TERMOS DO ART. 924, INCISO II DO CODIGO DE PROCESSO CIVIL.",
                    "DecisionDate": "2021-03-03T00:00:00"
                  },
                  {
                    "DecisionContent": "JULGO EXTINTA A EXECUCAO, NOS TERMOS DO ART. 924, INCISO II DO CODIGO DE PROCESSO CIVIL.",
                    "DecisionDate": "2021-03-02T00:00:00"
                  },
                  {
                    "DecisionContent": "JULGO EXTINTA A EXECUCAO, NOS TERMOS DO ART. 924, INCISO II DO CODIGO DE PROCESSO CIVIL.",
                    "DecisionDate": "2021-03-02T00:00:00"
                  },
                  {
                    "DecisionContent": "HOMOLOGO POR SENTENCA, PARA QUE PRODUZA SEUS JURIDICOS E LEGAIS EFEITOS, A TRANSACAO CELEBRADA ENTRE AS PARTES, COM O FIM DE POR TERMO AO PROCESSO (ART. 840, CC) QUE TEM POR OBJETO DIREITOS DISPONIVEIS (ART. 841, CC), COM FUNDAMENTO NO ARTIGO 487, INCISO III, ALINEA B, DO CODIGO DE PROCESSO CIVIL.",
                    "DecisionDate": "2021-02-10T00:00:00"
                  },
                  {
                    "DecisionContent": "HOMOLOGO POR SENTENCA, PARA QUE PRODUZA SEUS JURIDICOS E LEGAIS EFEITOS, A TRANSACAO CELEBRADA ENTRE AS PARTES, COM O FIM DE POR TERMO AO PROCESSO (ART. 840, CC) QUE TEM POR OBJETO DIREITOS DISPONIVEIS (ART. 841, CC), COM FUNDAMENTO NO ARTIGO 487, INCISO III, ALINEA B, DO CODIGO DE PROCESSO CIVIL.",
                    "DecisionDate": "2021-02-09T00:00:00"
                  },
                  {
                    "DecisionContent": "HOMOLOGO POR SENTENCA, PARA QUE PRODUZA SEUS JURIDICOS E LEGAIS EFEITOS, A TRANSACAO CELEBRADA ENTRE AS PARTES, COM O FIM DE POR TERMO AO PROCESSO (ART. 840, CC) QUE TEM POR OBJETO DIREITOS DISPONIVEIS (ART. 841, CC), COM FUNDAMENTO NO ARTIGO 487, INCISO III, ALINEA B, DO CODIGO DE PROCESSO CIVIL.",
                    "DecisionDate": "2021-02-09T00:00:00"
                  },
                  {
                    "DecisionContent": "HOMOLOGO POR SENTENCA, PARA QUE PRODUZA SEUS JURIDICOS E LEGAIS EFEITOS, A TRANSACAO CELEBRADA ENTRE AS PARTES, COM O FIM DE POR TERMO AO PROCESSO (ART. 840, CC) QUE TEM POR OBJETO DIREITOS DISPONIVEIS (ART. 841, CC), COM FUNDAMENTO NO ARTIGO 487, INCISO III, ALINEA B, DO CODIGO DE PROCESSO CIVIL.",
                    "DecisionDate": "2021-02-08T00:00:00"
                  },
                  {
                    "DecisionContent": "HOMOLOGO POR SENTENCA, PARA QUE PRODUZA SEUS JURIDICOS E LEGAIS EFEITOS, A TRANSACAO CELEBRADA ENTRE AS PARTES, COM O FIM DE POR TERMO AO PROCESSO (ART. 840, CC) QUE TEM POR OBJETO DIREITOS DISPONIVEIS (ART. 841, CC), COM FUNDAMENTO NO ARTIGO 487, INCISO III, ALINEA B, DO CODIGO DE PROCESSO CIVIL.",
                    "DecisionDate": "2021-02-08T00:00:00"
                  },
                  {
                    "DecisionContent": "DEFIRO A RE A RETIRADA DAS CHAVES DO IMOVEL DESOCUPADO, ARMAZENADAS NESTE OFICIO, CONFORME CERTIDAO DE FLS. 81.",
                    "DecisionDate": "2021-02-03T00:00:00"
                  },
                  {
                    "DecisionContent": "DEFIRO A RE A RETIRADA DAS CHAVES DO IMOVEL DESOCUPADO, ARMAZENADAS NESTE OFICIO, CONFORME CERTIDAO DE FLS. 81.",
                    "DecisionDate": "2021-01-21T00:00:00"
                  },
                  {
                    "DecisionContent": "DEFIRO A RE A RETIRADA DAS CHAVES DO IMOVEL DESOCUPADO, ARMAZENADAS NESTE OFICIO, CONFORME CERTIDAO DE FLS. 81.",
                    "DecisionDate": "2021-01-21T00:00:00"
                  },
                  {
                    "DecisionContent": "DEFIRO A RE A RETIRADA DAS CHAVES DO IMOVEL DESOCUPADO, ARMAZENADAS NESTE OFICIO, CONFORME CERTIDAO DE FLS. 81.",
                    "DecisionDate": "2021-01-20T00:00:00"
                  },
                  {
                    "DecisionContent": "DEFIRO A RE A RETIRADA DAS CHAVES DO IMOVEL DESOCUPADO, ARMAZENADAS NESTE OFICIO, CONFORME CERTIDAO DE FLS. 81.",
                    "DecisionDate": "2021-01-20T00:00:00"
                  },
                  {
                    "DecisionContent": "DEFIRO O PEDIDO LIMINAR FORMULADO, AUTORIZANDO O DEPOSITO DAS CHAVES EM JUIZO, MEDIANTE PREVIO AGENDAMENTO PARA ATENDIMENTO, CONSIDERANDO A ATUAL SITUACAO PELA QUAL PASSAMOS.",
                    "DecisionDate": "2020-12-18T00:00:00"
                  },
                  {
                    "DecisionContent": "DEFIRO O PEDIDO LIMINAR FORMULADO, AUTORIZANDO O DEPOSITO DAS CHAVES EM JUIZO, MEDIANTE PREVIO AGENDAMENTO PARA ATENDIMENTO, CONSIDERANDO A ATUAL SITUACAO PELA QUAL PASSAMOS.",
                    "DecisionDate": "2020-12-17T00:00:00"
                  },
                  {
                    "DecisionContent": "DEFIRO O PEDIDO LIMINAR FORMULADO, AUTORIZANDO O DEPOSITO DAS CHAVES EM JUIZO, MEDIANTE PREVIO AGENDAMENTO PARA ATENDIMENTO, CONSIDERANDO A ATUAL SITUACAO PELA QUAL PASSAMOS.",
                    "DecisionDate": "2020-12-17T00:00:00"
                  },
                  {
                    "DecisionContent": "DEFIRO O PEDIDO LIMINAR FORMULADO, AUTORIZANDO O DEPOSITO DAS CHAVES EM JUIZO, MEDIANTE PREVIO AGENDAMENTO PARA ATENDIMENTO, CONSIDERANDO A ATUAL SITUACAO PELA QUAL PASSAMOS.",
                    "DecisionDate": "2020-12-16T00:00:00"
                  },
                  {
                    "DecisionContent": "DEFIRO O PEDIDO LIMINAR FORMULADO, AUTORIZANDO O DEPOSITO DAS CHAVES EM JUIZO, MEDIANTE PREVIO AGENDAMENTO PARA ATENDIMENTO, CONSIDERANDO A ATUAL SITUACAO PELA QUAL PASSAMOS.",
                    "DecisionDate": "2020-12-16T00:00:00"
                  }
                ]
              }
            ],
            "TotalLawsuits": 1,
            "TotalLawsuitsAsAuthor": 1,
            "TotalLawsuitsAsDefendant": 0,
            "TotalLawsuitsAsOther": 0
          },
          "02349014118": {
            "Lawsuits": [
              {
                "Number": "00144160320198260100",
                "Type": "CUMPRIMENTO DE SENTENCA",
                "MainSubject": "INDENIZACAO POR DANO MORAL",
                "CourtName": "TJSP",
                "CourtLevel": "1",
                "CourtType": "CIVEL",
                "CourtDistrict": "SAO PAULO",
                "JudgingBody": "12 VARA CIVEL - FORO CENTRAL CIVEL",
                "State": "SP",
                "Status": "ARQUIVADO",
                "LawsuitHostService": "ESAJ",
                "InferredCNJSubjectName": "INDENIZAÇÃO POR DANO MORAL",
                "InferredCNJSubjectNumber": 7779,
                "InferredCNJProcedureTypeName": "CUMPRIMENTO DE SENTENÇA",
                "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
                "InferredBroadCNJSubjectNumber": 1156,
                "OtherSubjects": [
                  "INDENIZACAO POR DANO MORAL"
                ],
                "NumberOfVolumes": 0,
                "NumberOfPages": 0,
                "Value": 15760.02,
                "ResJudicataDate": "2019-05-17T00:00:00",
                "CloseDate": "2019-08-30T00:00:00",
                "RedistributionDate": "0001-01-01T00:00:00",
                "PublicationDate": "2019-06-10T00:00:00",
                "NoticeDate": "2019-02-19T00:00:00",
                "LastMovementDate": "2019-08-30T00:00:00",
                "CaptureDate": "2020-02-19T19:56:06",
                "LastUpdate": "2020-02-19T19:56:06",
                "NumberOfParties": 5,
                "NumberOfUpdates": 23,
                "LawSuitAge": 192,
                "AverageNumberOfUpdatesPerMonth": 0,
                "ReasonForConcealedData": 0,
                "Parties": [
                  {
                    "IsPartyActive": true,
                    "Name": "HUMMINGBIRD PRODUCT STUDIO EIRELLI",
                    "Polarity": "ACTIVE",
                    "Type": "CLAIMANT",
                    "PartyDetails": {
                      "SpecificType": "EXEQTE"
                    },
                    "LastCaptureDate": "2020-02-19T19:56:06"
                  },
                  {
                    "Doc": "02349014118",
                    "IsPartyActive": true,
                    "Name": "RAFAEL CASTRO DE MATOS",
                    "Polarity": "ACTIVE",
                    "Type": "CLAIMANT",
                    "PartyDetails": {
                      "SpecificType": "EXEQTE"
                    },
                    "LastCaptureDate": "2020-02-19T19:56:06"
                  },
                  {
                    "IsPartyActive": true,
                    "Name": "COMPANHIA BRASILEIRA DE SOLUCOES E SERVICOS S A",
                    "Polarity": "PASSIVE",
                    "Type": "CLAIMED",
                    "PartyDetails": {
                      "SpecificType": "EXECTDO"
                    },
                    "LastCaptureDate": "2020-02-19T19:56:06"
                  },
                  {
                    "Doc": "35068411817",
                    "IsPartyActive": true,
                    "Name": "RAFAEL HIDEO NAZIMA",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "SpecificType": "ADVOGADO REQUERENTE"
                    },
                    "LastCaptureDate": "2020-02-19T19:56:06"
                  },
                  {
                    "IsPartyActive": true,
                    "Name": "ALFREDO ZUCCA NETO",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "SpecificType": "ADVOGADO REQUERIDO"
                    },
                    "LastCaptureDate": "2020-02-19T19:56:06"
                  }
                ],
                "Updates": [
                  {
                    "Content": "ARQUIVADO DEFINITIVAMENTE |",
                    "PublishDate": "2019-08-30T00:00:00",
                    "CaptureDate": "2020-02-19T19:56:06"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0239/2019 DATA DA DISPONIBILIZACAO: 10/06/2019 DATA DA PUBLICACAO: 11/06/2019 NUMERO DO DIARIO: 2826 PAGINA: 227/244",
                    "PublishDate": "2019-06-10T00:00:00",
                    "CaptureDate": "2020-02-19T19:56:06"
                  },
                  {
                    "Content": "REMETIDO AO DJE | RELACAO: 0239/2019 TEOR DO ATO: CERTIFICO E DOU FE QUE EXPEDI MANDADO DE LEVANTAMENTO ELETRONICO NO VALOR DE R$ 15.892,65, EM FAVOR DE HUMMINGBIRD PRODUCT STUDIO EIRELLI. RAFAEL CASTRO DE MATOS., NESTA DATA. A VERIFICACAO DA REGULARIDADE DO PAGAMENTO COMPETIRA A PARTE INTERESSADA QUE, PARA TANTO, PODERA FAZER USO DO MANDADO ASSINADO ELETRONICAMENTE QUE SERA JUNTADO AOS AUTOS OPORTUNAMENTE. ADVOGADOS(S): ALFREDO ZUCCA NETO (OAB 154694/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2019-06-07T00:00:00",
                    "CaptureDate": "2020-02-19T19:56:06"
                  },
                  {
                    "Content": "MANDADO JUNTADO |",
                    "PublishDate": "2019-06-06T00:00:00",
                    "CaptureDate": "2020-02-19T19:56:06"
                  },
                  {
                    "Content": "ATO ORDINATORIO - PUBLICAVEL | CERTIFICO E DOU FE QUE EXPEDI MANDADO DE LEVANTAMENTO ELETRONICO NO VALOR DE R$ 15.892,65, EM FAVOR DE HUMMINGBIRD PRODUCT STUDIO EIRELLI. RAFAEL CASTRO DE MATOS., NESTA DATA. A VERIFICACAO DA REGULARIDADE DO PAGAMENTO COMPETIRA A PARTE INTERESSADA QUE, PARA TANTO, PODERA FAZER USO DO MANDADO ASSINADO ELETRONICAMENTE QUE SERA JUNTADO AOS AUTOS OPORTUNAMENTE.",
                    "PublishDate": "2019-06-06T00:00:00",
                    "CaptureDate": "2020-02-19T19:56:06"
                  },
                  {
                    "Content": "TRANSITO EM JULGADO AS PARTES - PROC. EM ANDAMENTO | CERTIDAO - TRANSITO EM JULGADO",
                    "PublishDate": "2019-05-17T00:00:00",
                    "CaptureDate": "2020-02-19T19:56:06"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0155/2019 DATA DA DISPONIBILIZACAO: 16/04/2019 DATA DA PUBLICACAO: 17/04/2019 NUMERO DO DIARIO: 2790 PAGINA: 223/236",
                    "PublishDate": "2019-04-16T00:00:00",
                    "CaptureDate": "2020-02-19T19:56:06"
                  },
                  {
                    "Content": "REMETIDO AO DJE | RELACAO: 0155/2019 TEOR DO ATO: VISTOS. 1) TENDO EM VISTA O PAGAMENTO NO PROCESSO PRINCIPAL, NOTICIADO PELA PARTE EXEQUENTE, JULGO EXTINTA A PRESENTE EXECUCAO, COM FUNDAMENTO NO ART. 924, INCISO II, DO CODIGO DE PROCESSO CIVIL. 2) COM O TRANSITO EM JULGADO, EXPECA-SE O NECESSARIO PARA O LEVANTAMENTO DO VALOR DEPOSITADO AS FLS. 238/239 DO PROCESSO PRINCIPAL, CONFORME FORMULARIO DE FLS. 241 DO MESMO PROCESSO PRINCIPAL, SE O MESMO FOR EM NOME DA PARTE EXEQUENTE OU REPRESENTANTE PROCESSUAL DA REFERIDA PARTE E TIVER PODERES PARA TANTO. 3) APOS, ANOTE-SE A EXTINCAO E ARQUIVE-SE, TUDO COM AS DEVIDAS CAUTELAS. P.R.I.C. SAO PAULO, 12 DE ABRIL DE 2019. ADVOGADOS(S): ALFREDO ZUCCA NETO (OAB 154694/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2019-04-15T00:00:00",
                    "CaptureDate": "2020-02-19T19:56:06"
                  },
                  {
                    "Content": "EXTINTA A EXECUCAO/CUMPRIMENTO DA SENTENCA PELA SATISFACAO DA OBRIGACAO | VISTOS. 1) TENDO EM VISTA O PAGAMENTO NO PROCESSO PRINCIPAL, NOTICIADO PELA PARTE EXEQUENTE, JULGO EXTINTA A PRESENTE EXECUCAO, COM FUNDAMENTO NO ART. 924, INCISO II, DO CODIGO DE PROCESSO CIVIL. 2) COM O TRANSITO EM JULGADO, EXPECA-SE O NECESSARIO PARA O LEVANTAMENTO DO VALOR DEPOSITADO AS FLS. 238/239 DO PROCESSO PRINCIPAL, CONFORME FORMULARIO DE FLS. 241 DO MESMO PROCESSO PRINCIPAL, SE O MESMO FOR EM NOME DA PARTE EXEQUENTE OU REPRESENTANTE PROCESSUAL DA REFERIDA PARTE E TIVER PODERES PARA TANTO. 3) APOS, ANOTE-SE A EXTINCAO E ARQUIVE-SE, TUDO COM AS DEVIDAS CAUTELAS. P.R.I.C. SAO PAULO, 12 DE ABRIL DE 2019.",
                    "PublishDate": "2019-04-12T00:00:00",
                    "CaptureDate": "2020-02-19T19:56:06"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO |",
                    "PublishDate": "2019-04-12T00:00:00",
                    "CaptureDate": "2020-02-19T19:56:06"
                  },
                  {
                    "Content": "CONCLUSOS PARA DESPACHO |",
                    "PublishDate": "2019-04-11T00:00:00",
                    "CaptureDate": "2020-02-19T19:56:06"
                  },
                  {
                    "Content": "PEDIDO DE EXTINCAO - OBRIGACAO SATISFEITA (ART. 924, II, DO CPC) | N PROTOCOLO: WJMJ.19.40498625-9 TIPO DA PETICAO: PEDIDO DE EXTINCAO (ART. 924, II, DO CPC) DATA: 10/04/2019 19:42",
                    "PublishDate": "2019-04-10T00:00:00",
                    "CaptureDate": "2020-02-19T19:56:06"
                  },
                  {
                    "Content": "PROCESSO 0014416-03.2019.8.26.0100 (PROCESSO PRINCIPAL 1000744-42.2018.8.26.0100) - CUMPRIMENTO DE SENTENCA - INDENIZACAO POR DANO MORAL - RAFAEL CASTRO DE MATOS. - - HUMMINGBIRD PRODUCT STUDIO EIRELLI. - COMPANHIA BRASILEIRA DE SOLUCOES E SERVICOS S.A. (ALELO) - VISTOS. 1) PROMOVA A EXECUTADA COMPANHIA BRASILEIRA DE SOLUCOES E SERVICOS S.A. (ALELO), CNPJ 04.740.876/0001-25 O PAGAMENTO VOLUNTARIO DA CONDENACAO DEFINITIVA, NO IMPORTE DE R$15.760,02 EM FEVEREIRO/2019, QUE DEVERA SER ATUALIZADO E ACRESCIDO DOS JUROS LEGAIS ATE O EFETIVO PAGAMENTO, EM QUINZE DIAS, SOB PENA DE INCIDENCIA DE MULTA DE DEZ POR CENTO SOBRE O DEBITO E, TAMBEM, HONORARIOS ADVOCATICIOS EM DEZ POR CENTO, NOS TERMOS DO ART. 523 DO CODIGO DE PROCESSO CIVIL. NO PONTO, FICA ADVERTIDO(A)(S) O(A)(S) EXECUTADO(A)(S) QUE, TRANSCORRIDO O PRAZO SEM O PAGAMENTO VOLUNTARIO, SERA EXPEDIDO, DESDE LOGO, MANDADO DE PENHORA E AVALIACAO. 2) PARA FINS DO ITEM PRECEDENTE, OBSERVAR- SE-A O SEGUINTE: (I) O EXECUTADO NAO REVEL SERA INTIMADO NA PESSOA DO SEU ADVOGADO, SE CONSTITUIDO; DO CONTRARIO, PESSOALMENTE, NESTA HIPOTESE POR CARTA COM AVISO DE RECEBIMENTO OU, SUBSIDIARIAMENTE, POR OFICIAL DE JUSTICA; (II) O EXECUTADO CITADO POR EDITAL E REVEL SERA INTIMADO POR EDITAL , FORTE NO ART. 513,  2, IV, DO MESMO CODIGO; (III) O EXECUTADO CADASTRADO NO SISTEMA ELETRONICO REFERIDO NO  1 DO ARTIGO 246 DO NOVEL CODIGO DE PROCESSO CIVIL E QUE NAO TIVER PROCURADOR NOS AUTOS SERA INTIMADO POR MEIO ELETRONICO, NOS TERMOS DO ART. 513,  2, III, DO CODIGO A BAILA; E (IV) O EXECUTADO SEM PATRONO OU REPRESENTADO PELA DEFENSORIA PUBLICA - RESSALVADO O ITEM (II) -, SERA INTIMADO VIA POSTAL, SEGUNDO INTELIGENCIA DO ART. 513,  2, II, DO CODIGO DE PROCESSO CIVIL. NESTA ESTEIRA, CURIAL A ATENCAO AOS ARTIGOS 275, CAPUT, E 513,  3 E 4, AMBOS DO CODIGO DE PROCESSO CIVIL. 3) EM NAO OCORRENDO O PAGAMENTO DO VALOR DA CONDENACAO NO PRAZO ALHURES (CPC, ART. 523), QUEDA(M) O(A)(S) EXECUTADO(A)(S) EXORTADO(A)(S) QUE, INDEPENDENTEMENTE DE PENHORA OU NOVA INTIMACAO, INICIAR-SE-A O PRAZO DE QUINZE DIAS PARA APRESENTACAO DE IMPUGNACAO, SEGUNDO INTELIGENCIA DO ARTIGO 525 DO CODIGO DE PROCESSO CIVIL. INT. - ADV: ALFREDO ZUCCA NETO (OAB 154694/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2019-03-19T00:00:00",
                    "CaptureDate": "2019-03-27T09:36:04"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0103/2019 DATA DA DISPONIBILIZACAO: 19/03/2019 DATA DA PUBLICACAO: 20/03/2019 NUMERO DO DIARIO: 2770 PAGINA: 223/241",
                    "PublishDate": "2019-03-19T00:00:00",
                    "CaptureDate": "2019-03-27T09:40:12"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0103/2019 DATA DA DISPONIBILIZACAO: 19/03/2019 DATA DA PUBLICACAO: 20/03/2019 NUMERO DO DIARIO: 2770 PAGINA: 223/241",
                    "PublishDate": "2019-03-19T00:00:00",
                    "CaptureDate": "2020-02-19T19:56:06"
                  },
                  {
                    "Content": "REMETIDO AO DJE RELACAO: 0103/2019 TEOR DO ATO: VISTOS. 1) PROMOVA A EXECUTADA COMPANHIA BRASILEIRA DE SOLUCOES E SERVICOS S.A. (ALELO), CNPJ 04.740.876/0001-25 O PAGAMENTO VOLUNTARIO DA CONDENACAO DEFINITIVA, NO IMPORTE DE R$15.760,02 EM FEVEREIRO/2019, QUE DEVERA SER ATUALIZADO E ACRESCIDO DOS JUROS LEGAIS ATE O EFETIVO PAGAMENTO, EM QUINZE DIAS, SOB PENA DE INCIDENCIA DE MULTA DE DEZ POR CENTO SOBRE O DEBITO E, TAMBEM, HONORARIOS ADVOCATICIOS EM DEZ POR CENTO, NOS TERMOS DO ART. 523 DO CODIGO DE PROCESSO CIVIL. NO PONTO, FICA ADVERTIDO(A)(S) O(A)(S) EXECUTADO(A)(S) QUE, TRANSCORRIDO O PRAZO SEM O PAGAMENTO VOLUNTARIO, SERA EXPEDIDO, DESDE LOGO, MANDADO DE PENHORA E AVALIACAO. 2) PARA FINS DO ITEM PRECEDENTE, OBSERVAR-SE-A O SEGUINTE: (I) O EXECUTADO NAO REVEL SERA INTIMADO NA PESSOA DO SEU ADVOGADO, SE CONSTITUIDO; DO CONTRARIO, PESSOALMENTE, NESTA HIPOTESE POR CARTA COM AVISO DE RECEBIMENTO OU, SUBSIDIARIAMENTE, POR OFICIAL DE JUSTICA; (II) O EXECUTADO CITADO POR EDITAL E REVEL SERA INTIMADO POR EDITAL , FORTE NO ART. 513,  2, IV, DO MESMO CODIGO; (III) O EXECUTADO CADASTRADO NO SISTEMA ELETRONICO REFERIDO NO  1 DO ARTIGO 246 DO NOVEL CODIGO DE PROCESSO CIVIL E QUE NAO TIVER PROCURADOR NOS AUTOS SERA INTIMADO POR MEIO ELETRONICO, NOS TERMOS DO ART. 513,  2, III, DO CODIGO A BAILA; E (IV) O EXECUTADO SEM PATRONO OU REPRESENTADO PELA DEFENSORIA PUBLICA - RESSALVADO O ITEM (II) -, SERA INTIMADO VIA POSTAL, SEGUNDO INTELIGENCIA DO ART. 513,  2, II, DO CODIGO DE PROCESSO CIVIL. NESTA ESTEIRA, CURIAL A ATENCAO AOS ARTIGOS 275, CAPUT, E 513,  3 E 4, AMBOS DO CODIGO DE PROCESSO CIVIL. 3) EM NAO OCORRENDO O PAGAMENTO DO VALOR DA CONDENACAO NO PRAZO ALHURES (CPC, ART. 523), QUEDA(M) O(A)(S) EXECUTADO(A)(S) EXORTADO(A)(S) QUE, INDEPENDENTEMENTE DE PENHORA OU NOVA INTIMACAO, INICIAR-SE-A O PRAZO DE QUINZE DIAS PARA APRESENTACAO DE IMPUGNACAO, SEGUNDO INTELIGENCIA DO ARTIGO 525 DO CODIGO DE PROCESSO CIVIL. INT. ADVOGADOS(S): ALFREDO ZUCCA NETO (OAB 154694/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2019-03-15T00:00:00",
                    "CaptureDate": "2019-03-27T09:40:12"
                  },
                  {
                    "Content": "REMETIDO AO DJE | RELACAO: 0103/2019 TEOR DO ATO: VISTOS. 1) PROMOVA A EXECUTADA COMPANHIA BRASILEIRA DE SOLUCOES E SERVICOS S.A. (ALELO), CNPJ 04.740.876/0001-25 O PAGAMENTO VOLUNTARIO DA CONDENACAO DEFINITIVA, NO IMPORTE DE R$15.760,02 EM FEVEREIRO/2019, QUE DEVERA SER ATUALIZADO E ACRESCIDO DOS JUROS LEGAIS ATE O EFETIVO PAGAMENTO, EM QUINZE DIAS, SOB PENA DE INCIDENCIA DE MULTA DE DEZ POR CENTO SOBRE O DEBITO E, TAMBEM, HONORARIOS ADVOCATICIOS EM DEZ POR CENTO, NOS TERMOS DO ART. 523 DO CODIGO DE PROCESSO CIVIL. NO PONTO, FICA ADVERTIDO(A)(S) O(A)(S) EXECUTADO(A)(S) QUE, TRANSCORRIDO O PRAZO SEM O PAGAMENTO VOLUNTARIO, SERA EXPEDIDO, DESDE LOGO, MANDADO DE PENHORA E AVALIACAO. 2) PARA FINS DO ITEM PRECEDENTE, OBSERVAR-SE-A O SEGUINTE: (I) O EXECUTADO NAO REVEL SERA INTIMADO NA PESSOA DO SEU ADVOGADO, SE CONSTITUIDO; DO CONTRARIO, PESSOALMENTE, NESTA HIPOTESE POR CARTA COM AVISO DE RECEBIMENTO OU, SUBSIDIARIAMENTE, POR OFICIAL DE JUSTICA; (II) O EXECUTADO CITADO POR EDITAL E REVEL SERA INTIMADO POR EDITAL , FORTE NO ART. 513,  2, IV, DO MESMO CODIGO; (III) O EXECUTADO CADASTRADO NO SISTEMA ELETRONICO REFERIDO NO  1 DO ARTIGO 246 DO NOVEL CODIGO DE PROCESSO CIVIL E QUE NAO TIVER PROCURADOR NOS AUTOS SERA INTIMADO POR MEIO ELETRONICO, NOS TERMOS DO ART. 513,  2, III, DO CODIGO A BAILA; E (IV) O EXECUTADO SEM PATRONO OU REPRESENTADO PELA DEFENSORIA PUBLICA - RESSALVADO O ITEM (II) -, SERA INTIMADO VIA POSTAL, SEGUNDO INTELIGENCIA DO ART. 513,  2, II, DO CODIGO DE PROCESSO CIVIL. NESTA ESTEIRA, CURIAL A ATENCAO AOS ARTIGOS 275, CAPUT, E 513,  3 E 4, AMBOS DO CODIGO DE PROCESSO CIVIL. 3) EM NAO OCORRENDO O PAGAMENTO DO VALOR DA CONDENACAO NO PRAZO ALHURES (CPC, ART. 523), QUEDA(M) O(A)(S) EXECUTADO(A)(S) EXORTADO(A)(S) QUE, INDEPENDENTEMENTE DE PENHORA OU NOVA INTIMACAO, INICIAR-SE-A O PRAZO DE QUINZE DIAS PARA APRESENTACAO DE IMPUGNACAO, SEGUNDO INTELIGENCIA DO ARTIGO 525 DO CODIGO DE PROCESSO CIVIL. INT. ADVOGADOS(S): ALFREDO ZUCCA NETO (OAB 154694/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2019-03-15T00:00:00",
                    "CaptureDate": "2020-02-19T19:56:06"
                  },
                  {
                    "Content": "CONCLUSOS PARA DESPACHO",
                    "PublishDate": "2019-03-14T00:00:00",
                    "CaptureDate": "2019-03-27T09:36:04"
                  },
                  {
                    "Content": "DECISAO VISTOS. 1) PROMOVA A EXECUTADA COMPANHIA BRASILEIRA DE SOLUCOES E SERVICOS S.A. (ALELO), CNPJ 04.740.876/0001-25 O PAGAMENTO VOLUNTARIO DA CONDENACAO DEFINITIVA, NO IMPORTE DE R$15.760,02 EM FEVEREIRO/2019, QUE DEVERA SER ATUALIZADO E ACRESCIDO DOS JUROS LEGAIS ATE O EFETIVO PAGAMENTO, EM QUINZE DIAS, SOB PENA DE INCIDENCIA DE MULTA DE DEZ POR CENTO SOBRE O DEBITO E, TAMBEM, HONORARIOS ADVOCATICIOS EM DEZ POR CENTO, NOS TERMOS DO ART. 523 DO CODIGO DE PROCESSO CIVIL. NO PONTO, FICA ADVERTIDO(A)(S) O(A)(S) EXECUTADO(A)(S) QUE, TRANSCORRIDO O PRAZO SEM O PAGAMENTO VOLUNTARIO, SERA EXPEDIDO, DESDE LOGO, MANDADO DE PENHORA E AVALIACAO. 2) PARA FINS DO ITEM PRECEDENTE, OBSERVAR-SE-A O SEGUINTE: (I) O EXECUTADO NAO REVEL SERA INTIMADO NA PESSOA DO SEU ADVOGADO, SE CONSTITUIDO; DO CONTRARIO, PESSOALMENTE, NESTA HIPOTESE POR CARTA COM AVISO DE RECEBIMENTO OU, SUBSIDIARIAMENTE, POR OFICIAL DE JUSTICA; (II) O EXECUTADO CITADO POR EDITAL E REVEL SERA INTIMADO POR EDITAL , FORTE NO ART. 513,  2, IV, DO MESMO CODIGO; (III) O EXECUTADO CADASTRADO NO SISTEMA ELETRONICO REFERIDO NO  1 DO ARTIGO 246 DO NOVEL CODIGO DE PROCESSO CIVIL E QUE NAO TIVER PROCURADOR NOS AUTOS SERA INTIMADO POR MEIO ELETRONICO, NOS TERMOS DO ART. 513,  2, III, DO CODIGO A BAILA; E (IV) O EXECUTADO SEM PATRONO OU REPRESENTADO PELA DEFENSORIA PUBLICA - RESSALVADO O ITEM (II) -, SERA INTIMADO VIA POSTAL, SEGUNDO INTELIGENCIA DO ART. 513,  2, II, DO CODIGO DE PROCESSO CIVIL. NESTA ESTEIRA, CURIAL A ATENCAO AOS ARTIGOS 275, CAPUT, E 513,  3 E 4, AMBOS DO CODIGO DE PROCESSO CIVIL. 3) EM NAO OCORRENDO O PAGAMENTO DO VALOR DA CONDENACAO NO PRAZO ALHURES (CPC, ART. 523), QUEDA(M) O(A)(S) EXECUTADO(A)(S) EXORTADO(A)(S) QUE, INDEPENDENTEMENTE DE PENHORA OU NOVA INTIMACAO, INICIAR-SE-A O PRAZO DE QUINZE DIAS PARA APRESENTACAO DE IMPUGNACAO, SEGUNDO INTELIGENCIA DO ARTIGO 525 DO CODIGO DE PROCESSO CIVIL. INT.",
                    "PublishDate": "2019-03-14T00:00:00",
                    "CaptureDate": "2019-03-27T09:36:04"
                  },
                  {
                    "Content": "DECISAO | VISTOS. 1) PROMOVA A EXECUTADA COMPANHIA BRASILEIRA DE SOLUCOES E SERVICOS S.A. (ALELO), CNPJ 04.740.876/0001-25 O PAGAMENTO VOLUNTARIO DA CONDENACAO DEFINITIVA, NO IMPORTE DE R$15.760,02 EM FEVEREIRO/2019, QUE DEVERA SER ATUALIZADO E ACRESCIDO DOS JUROS LEGAIS ATE O EFETIVO PAGAMENTO, EM QUINZE DIAS, SOB PENA DE INCIDENCIA DE MULTA DE DEZ POR CENTO SOBRE O DEBITO E, TAMBEM, HONORARIOS ADVOCATICIOS EM DEZ POR CENTO, NOS TERMOS DO ART. 523 DO CODIGO DE PROCESSO CIVIL. NO PONTO, FICA ADVERTIDO(A)(S) O(A)(S) EXECUTADO(A)(S) QUE, TRANSCORRIDO O PRAZO SEM O PAGAMENTO VOLUNTARIO, SERA EXPEDIDO, DESDE LOGO, MANDADO DE PENHORA E AVALIACAO. 2) PARA FINS DO ITEM PRECEDENTE, OBSERVAR-SE-A O SEGUINTE: (I) O EXECUTADO NAO REVEL SERA INTIMADO NA PESSOA DO SEU ADVOGADO, SE CONSTITUIDO; DO CONTRARIO, PESSOALMENTE, NESTA HIPOTESE POR CARTA COM AVISO DE RECEBIMENTO OU, SUBSIDIARIAMENTE, POR OFICIAL DE JUSTICA; (II) O EXECUTADO CITADO POR EDITAL E REVEL SERA INTIMADO POR EDITAL , FORTE NO ART. 513,  2, IV, DO MESMO CODIGO; (III) O EXECUTADO CADASTRADO NO SISTEMA ELETRONICO REFERIDO NO  1 DO ARTIGO 246 DO NOVEL CODIGO DE PROCESSO CIVIL E QUE NAO TIVER PROCURADOR NOS AUTOS SERA INTIMADO POR MEIO ELETRONICO, NOS TERMOS DO ART. 513,  2, III, DO CODIGO A BAILA; E (IV) O EXECUTADO SEM PATRONO OU REPRESENTADO PELA DEFENSORIA PUBLICA - RESSALVADO O ITEM (II) -, SERA INTIMADO VIA POSTAL, SEGUNDO INTELIGENCIA DO ART. 513,  2, II, DO CODIGO DE PROCESSO CIVIL. NESTA ESTEIRA, CURIAL A ATENCAO AOS ARTIGOS 275, CAPUT, E 513,  3 E 4, AMBOS DO CODIGO DE PROCESSO CIVIL. 3) EM NAO OCORRENDO O PAGAMENTO DO VALOR DA CONDENACAO NO PRAZO ALHURES (CPC, ART. 523), QUEDA(M) O(A)(S) EXECUTADO(A)(S) EXORTADO(A)(S) QUE, INDEPENDENTEMENTE DE PENHORA OU NOVA INTIMACAO, INICIAR-SE-A O PRAZO DE QUINZE DIAS PARA APRESENTACAO DE IMPUGNACAO, SEGUNDO INTELIGENCIA DO ARTIGO 525 DO CODIGO DE PROCESSO CIVIL. INT.",
                    "PublishDate": "2019-03-14T00:00:00",
                    "CaptureDate": "2020-02-19T19:56:06"
                  },
                  {
                    "Content": "CONCLUSOS PARA DESPACHO |",
                    "PublishDate": "2019-03-14T00:00:00",
                    "CaptureDate": "2020-02-19T19:56:06"
                  },
                  {
                    "Content": "INICIO DA EXECUCAO JUNTADO PROCESSO PRINCIPAL: 1000744-42.2018.8.26.0100",
                    "PublishDate": "2019-03-11T00:00:00",
                    "CaptureDate": "2019-03-27T09:36:04"
                  },
                  {
                    "Content": "INICIO DA EXECUCAO JUNTADO | PROCESSO PRINCIPAL: 1000744-42.2018.8.26.0100",
                    "PublishDate": "2019-03-11T00:00:00",
                    "CaptureDate": "2020-02-19T19:56:06"
                  }
                ],
                "Petitions": [
                  {
                    "Type": "PEDIDO DE EXTINCAO (ART. 924, II, DO CPC)",
                    "Author": "",
                    "CreationDate": "2019-04-10T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  }
                ],
                "Decisions": [
                  {
                    "DecisionContent": "JULGO EXTINTA A PRESENTE EXECUCAO, COM FUNDAMENTO NO ART. 924, INCISO II, DO CODIGO DE PROCESSO CIVIL.",
                    "DecisionDate": "2019-04-15T00:00:00"
                  },
                  {
                    "DecisionContent": "JULGO EXTINTA A PRESENTE EXECUCAO, COM FUNDAMENTO NO ART. 924, INCISO II, DO CODIGO DE PROCESSO CIVIL.",
                    "DecisionDate": "2019-04-12T00:00:00"
                  }
                ]
              },
              {
                "Number": "00407969720188260100",
                "Type": "CUMPRIMENTO DE SENTENCA",
                "MainSubject": "TURISMO",
                "CourtName": "TJSP",
                "CourtLevel": "1",
                "CourtType": "CIVEL",
                "CourtDistrict": "SAO PAULO",
                "JudgingBody": "1 VARA CIVEL - FORO CENTRAL CIVEL",
                "State": "SP",
                "Status": "ARQUIVADO",
                "LawsuitHostService": "ESAJ",
                "InferredCNJSubjectName": "TURISMO",
                "InferredCNJSubjectNumber": 7618,
                "InferredCNJProcedureTypeName": "CUMPRIMENTO DE SENTENÇA",
                "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
                "InferredBroadCNJSubjectNumber": 1156,
                "OtherSubjects": [
                  "TURISMO"
                ],
                "NumberOfVolumes": 0,
                "NumberOfPages": 0,
                "Value": -1,
                "ResJudicataDate": "2018-11-30T00:00:00",
                "CloseDate": "2018-11-30T00:00:00",
                "RedistributionDate": "0001-01-01T00:00:00",
                "PublicationDate": "2018-06-08T00:00:00",
                "NoticeDate": "2018-05-27T00:00:00",
                "LastMovementDate": "2019-01-08T00:00:00",
                "CaptureDate": "2021-06-08T15:46:52",
                "LastUpdate": "2021-06-08T15:46:52",
                "NumberOfParties": 4,
                "NumberOfUpdates": 50,
                "LawSuitAge": 187,
                "AverageNumberOfUpdatesPerMonth": 0,
                "ReasonForConcealedData": 0,
                "Parties": [
                  {
                    "Doc": "02349014118",
                    "IsPartyActive": true,
                    "Name": "RAFAEL CASTRO DE MATOS",
                    "Polarity": "ACTIVE",
                    "Type": "CLAIMANT",
                    "PartyDetails": {
                      "SpecificType": "EXEQTE"
                    },
                    "LastCaptureDate": "2021-06-08T15:46:52"
                  },
                  {
                    "IsPartyActive": true,
                    "Name": "DECOLAR COM LTDA",
                    "Polarity": "PASSIVE",
                    "Type": "CLAIMED",
                    "PartyDetails": {
                      "SpecificType": "REQDO"
                    },
                    "LastCaptureDate": "2021-06-08T15:46:52"
                  },
                  {
                    "Doc": "35068411817",
                    "IsPartyActive": true,
                    "Name": "RAFAEL HIDEO NAZIMA",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "295443",
                      "State": "SP",
                      "SpecificType": "ADVOGADO (EXEQTE)"
                    },
                    "LastCaptureDate": "2021-06-08T15:46:52"
                  },
                  {
                    "IsPartyActive": true,
                    "Name": "JOAO BATISTA DE LIMA JUNIOR",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "SpecificType": "ADVOGADO (REQDO)"
                    },
                    "LastCaptureDate": "2021-06-08T15:46:52"
                  }
                ],
                "Updates": [
                  {
                    "Content": "GUIA JUNTADA",
                    "PublishDate": "2019-01-08T00:00:00",
                    "CaptureDate": "2021-06-08T15:46:52"
                  },
                  {
                    "Content": "PEDIDO DE EXTINCAO - OBRIGACAO SATISFEITA (ART. 924, II, DO CPC) | N PROTOCOLO: WJMJ.18.41682056-2 TIPO DA PETICAO: PEDIDO DE EXTINCAO (ART. 924, II, DO CPC) DATA: 11/12/2018 23:23",
                    "PublishDate": "2018-12-11T00:00:00",
                    "CaptureDate": "2021-06-08T15:46:52"
                  },
                  {
                    "Content": "ARQUIVADO DEFINITIVAMENTE | R. SENTENCA DE FLS. 57 TRANSITOU EM JULGADO EM 56.",
                    "PublishDate": "2018-11-30T00:00:00",
                    "CaptureDate": "2021-06-08T15:46:52"
                  },
                  {
                    "Content": "TRANSITO EM JULGADO AS PARTES - COM BAIXA",
                    "PublishDate": "2018-11-30T00:00:00",
                    "CaptureDate": "2021-06-08T15:46:52"
                  },
                  {
                    "Content": "CERTIDAO DE TRANSITO EM JULGADO COM BAIXA EXPEDIDA | CERTIDAO - TRANSITO EM JULGADO COM BAIXA - PROCESSO DIGITAL",
                    "PublishDate": "2018-11-30T00:00:00",
                    "CaptureDate": "2021-06-08T15:46:52"
                  },
                  {
                    "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.18.41292405-3 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 26/09/2018 22:38",
                    "PublishDate": "2018-09-26T00:00:00",
                    "CaptureDate": "2018-09-30T07:03:19"
                  },
                  {
                    "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.18.41292405-3 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 26/09/2018 22:38",
                    "PublishDate": "2018-09-26T00:00:00",
                    "CaptureDate": "2021-06-08T15:46:52"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0342/2018 DATA DA DISPONIBILIZACAO: 24/09/2018 DATA DA PUBLICACAO: 25/09/2018 NUMERO DO DIARIO: 2665 PAGINA: 1",
                    "PublishDate": "2018-09-24T00:00:00",
                    "CaptureDate": "2018-09-30T07:03:19"
                  },
                  {
                    "Content": "PROCESSO 0040796-97.2018.8.26.0100 (APENSADO AO PROCESSO 1107715-85.2017.8.26.0100) (PROCESSO PRINCIPAL 1107715- 85.2017.8.26.0100) - CUMPRIMENTO DE SENTENCA - TURISMO - RAFAEL CASTRO DE MATOS. - DECOLAR.COM LTDA - VISTOS. DADA A SATISFACAO INTEGRAL DO DEBITO (PENHORA AS FLS.48/50), JULGO EXTINTA A ACAO QUE RAFAEL CASTRO DE MATOS PROMOVE A DECOLAR. COM LTDA, COM FUNDAMENTO NO DISPOSTO PELO ARTIGO 924, INCISO II, DO NOVO CODIGO DE PROCESSO CIVIL. EXPECA-SE MANDADO DE LEVANTAMENTO ELETRONICO EM FAVOR DO EXEQUENTE (FORMULARIO AS FLS.56). TRANSITADA EM JULGADO, ARQUIVEM-SE OS AUTOS COM AS ANOTACOES DE BAIXA E EXTINCAO. SE O CASO, PROVIDENCIE A SERVENTIA A BAIXA E O ARQUIVAMENTO DEFINITIVO DOS AUTOS PRINCIPAIS, SEJA FISICO OU DIGITAL. P. R. I. - ADV: JOAO BATISTA DE LIMA JUNIOR (OAB 317336/SP), RAFAEL HIDEO NAZIMA (OAB 295443/ SP)",
                    "PublishDate": "2018-09-24T00:00:00",
                    "CaptureDate": "2018-09-30T07:02:13"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0342/2018 DATA DA DISPONIBILIZACAO: 24/09/2018 DATA DA PUBLICACAO: 25/09/2018 NUMERO DO DIARIO: 2665 PAGINA: 1",
                    "PublishDate": "2018-09-24T00:00:00",
                    "CaptureDate": "2021-06-08T15:46:52"
                  },
                  {
                    "Content": "REMETIDO AO DJE RELACAO: 0342/2018 TEOR DO ATO: VISTOS. DADA A SATISFACAO INTEGRAL DO DEBITO (PENHORA AS FLS.48/50), JULGO EXTINTA A ACAO QUE RAFAEL CASTRO DE MATOS PROMOVE A DECOLAR.COM LTDA, COM FUNDAMENTO NO DISPOSTO PELO ARTIGO 924, INCISO II, DO NOVO CODIGO DE PROCESSO CIVIL. EXPECA-SE MANDADO DE LEVANTAMENTO ELETRONICO EM FAVOR DO EXEQUENTE (FORMULARIO AS FLS.56). TRANSITADA EM JULGADO, ARQUIVEM-SE OS AUTOS COM AS ANOTACOES DE BAIXA E EXTINCAO. SE O CASO, PROVIDENCIE A SERVENTIA A BAIXA E O ARQUIVAMENTO DEFINITIVO DOS AUTOS PRINCIPAIS, SEJA FISICO OU DIGITAL. P. R. I. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP), JOAO BATISTA DE LIMA JUNIOR (OAB 317336/SP)",
                    "PublishDate": "2018-09-21T00:00:00",
                    "CaptureDate": "2018-09-30T07:03:19"
                  },
                  {
                    "Content": "REMETIDO AO DJE | RELACAO: 0342/2018 TEOR DO ATO: VISTOS. DADA A SATISFACAO INTEGRAL DO DEBITO (PENHORA AS FLS.48/50), JULGO EXTINTA A ACAO QUE RAFAEL CASTRO DE MATOS PROMOVE A DECOLAR.COM LTDA, COM FUNDAMENTO NO DISPOSTO PELO ARTIGO 924, INCISO II, DO NOVO CODIGO DE PROCESSO CIVIL. EXPECA-SE MANDADO DE LEVANTAMENTO ELETRONICO EM FAVOR DO EXEQUENTE (FORMULARIO AS FLS.56). TRANSITADA EM JULGADO, ARQUIVEM-SE OS AUTOS COM AS ANOTACOES DE BAIXA E EXTINCAO. SE O CASO, PROVIDENCIE A SERVENTIA A BAIXA E O ARQUIVAMENTO DEFINITIVO DOS AUTOS PRINCIPAIS, SEJA FISICO OU DIGITAL. P. R. I. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP), JOAO BATISTA DE LIMA JUNIOR (OAB 317336/SP)",
                    "PublishDate": "2018-09-21T00:00:00",
                    "CaptureDate": "2021-06-08T15:46:52"
                  },
                  {
                    "Content": "FLS. 57 TRIBUNAL DE JUSTICA DO ESTADO DE SAO PAULO COMARCA DE SAO PAULO FORO CENTRAL CIVEL 1 VARA CIVEL PRACA JOAO MENDES S/N, SAO PAULO - SP - CEP 01501-900 SENTENCA PROCESSO N: 0040796-97.2018.8.26.0100 CLASSE - ASSUNTO CUMPRIMENTO DE SENTENCA - TURISMO EXEQUENTE: RAFAEL CASTRO DE MATOS. REQUERIDO: DECOLAR.COM LTDA JUIZ(A) DE DIREITO: DR(A). PAULA NARIMATU DE ALMEIDA VISTOS. DADA A SATISFACAO INTEGRAL DO DEBITO (PENHORA AS FLS.48/50), JULGO EXTINTA A ACAO QUE RAFAEL CASTRO DE MATOS PROMOVE A DECOLAR.COM LTDA, COM FUNDAMENTO NO DISPOSTO PELO ARTIGO 924, INCISO II, DO NOVO CODIGO DE PROCESSO CIVIL. EXPECA-SE MANDADO DE LEVANTAMENTO ELETRONICO EM FAVOR DO EXEQUENTE (FORMULARIO AS FLS.56). TRANSITADA EM JULGADO, ARQUIVEM-SE OS AUTOS COM AS ANOTACOES DE BAIXA E EXTINCAO. SE O CASO, PROVIDENCIE A SERVENTIA A BAIXA E O ARQUIVAMENTO DEFINITIVO DOS AUTOS PRINCIPAIS, SEJA FISICO OU DIGITAL. P. R. I. SAO PAULO, 19 DE SETEMBRO DE 2018. DOCUMENTO ASSINADO DIGITALMENTE NOS TERMOS DA LEI 11.419/2006, CONFORME IMPRESSAO A MARGEM DIREITA 0040796-97.2018.8.26.0100 - LAUDA 1 ESTE DOCUMENTO E COPIA DO ORIGINAL, ASSINADO DIGITALMENTE POR PAULA NARIMATU DE ALMEIDA, LIBERADO NOS AUTOS EM 20/09/2018 AS 16:10 . PARA CONFERIR O ORIGINAL, ACESSE SITE HTTPS://ESAJ.TJSP.JUS.BR/PASTADIGITAL/PG/ABRIRCONFERENCIADOCUMENTO.DO, INFORME PROCESSO 0040796-97.2018.8.26.0100 E CODIGO 4F11738.",
                    "PublishDate": "2018-09-20T00:00:00",
                    "CaptureDate": "2018-09-30T07:03:03"
                  },
                  {
                    "Content": "EXTINTA A EXECUCAO/CUMPRIMENTO DA SENTENCA PELA SATISFACAO DA OBRIGACAO | VISTOS. DADA A SATISFACAO INTEGRAL DO DEBITO (PENHORA AS FLS.48/50), JULGO EXTINTA A ACAO QUE RAFAEL CASTRO DE MATOS PROMOVE A DECOLAR.COM LTDA, COM FUNDAMENTO NO DISPOSTO PELO ARTIGO 924, INCISO II, DO NOVO CODIGO DE PROCESSO CIVIL. EXPECA-SE MANDADO DE LEVANTAMENTO ELETRONICO EM FAVOR DO EXEQUENTE (FORMULARIO AS FLS.56). TRANSITADA EM JULGADO, ARQUIVEM-SE OS AUTOS COM AS ANOTACOES DE BAIXA E EXTINCAO. SE O CASO, PROVIDENCIE A SERVENTIA A BAIXA E O ARQUIVAMENTO DEFINITIVO DOS AUTOS PRINCIPAIS, SEJA FISICO OU DIGITAL. P. R. I.",
                    "PublishDate": "2018-09-20T00:00:00",
                    "CaptureDate": "2021-06-08T15:46:52"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO",
                    "PublishDate": "2018-09-19T00:00:00",
                    "CaptureDate": "2018-09-30T07:03:03"
                  },
                  {
                    "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.18.41235819-8 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 17/09/2018 16:10",
                    "PublishDate": "2018-09-17T00:00:00",
                    "CaptureDate": "2018-09-30T07:03:03"
                  },
                  {
                    "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.18.41235819-8 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 17/09/2018 16:10",
                    "PublishDate": "2018-09-17T00:00:00",
                    "CaptureDate": "2021-06-08T15:46:52"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0287/2018 DATA DA DISPONIBILIZACAO: 16/08/2018 DATA DA PUBLICACAO: 17/08/2018 NUMERO DO DIARIO: 2639 PAGINA: 329",
                    "PublishDate": "2018-08-16T00:00:00",
                    "CaptureDate": "2018-08-17T15:33:18"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0287/2018 DATA DA DISPONIBILIZACAO: 16/08/2018 DATA DA PUBLICACAO: 17/08/2018 NUMERO DO DIARIO: 2639 PAGINA: 329",
                    "PublishDate": "2018-08-16T00:00:00",
                    "CaptureDate": "2018-08-17T15:33:18"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0287/2018 DATA DA DISPONIBILIZACAO: 16/08/2018 DATA DA PUBLICACAO: 17/08/2018 NUMERO DO DIARIO: 2639 PAGINA: 329",
                    "PublishDate": "2018-08-16T00:00:00",
                    "CaptureDate": "2021-06-08T15:46:52"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0287/2018 DATA DA DISPONIBILIZACAO: 16/08/2018 DATA DA PUBLICACAO: 17/08/2018 NUMERO DO DIARIO: 2639 PAGINA: 329",
                    "PublishDate": "2018-08-16T00:00:00",
                    "CaptureDate": "2021-06-08T15:46:52"
                  },
                  {
                    "Content": "REMETIDO AO DJE RELACAO: 0287/2018 TEOR DO ATO: VISTOS. ANOTO QUE A PARTE EXECUTADA TEM ADVOGADO CONSTITUIDO NOS AUTOS. UMA VEZ QUE A PARTE EXECUTADA, EMBORA REGULARMENTE INTIMADA, NAO REALIZOU O PAGAMENTO ESPONTANEO, DEFIRO O REQUERIMENTO DA PARTE EXEQUENTE E, NA FORMA DO DISPOSTO PELO ARTIGO 854 DO CPC, COMANDO BLOQUEIO DE ATIVOS FINANCEIROS PERTENCENTES A EXECUTADA, ACIMA QUALIFICADA, POR MEIO DO SISTEMA BACENJUD, ATE O LIMITE DO DEBITO EM EXECUCAO, O QUAL, MERAMENTE ATUALIZADO PELO ULTIMO INDICE DIVULGADO DA TABELA DEPRE (07/2018), ALCANCA O VALOR DE R$ 21.553,32. INTIMEM-SE OPORTUNAMENTE. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP), JOAO BATISTA DE LIMA JUNIOR (OAB 317336/SP)",
                    "PublishDate": "2018-08-15T00:00:00",
                    "CaptureDate": "2018-08-17T15:33:18"
                  },
                  {
                    "Content": "REMETIDO AO DJE RELACAO: 0287/2018 TEOR DO ATO: VISTOS. BLOQUEADOS ATIVOS FINANCEIROS SUFICIENTES PARA A SATISFACAO DO DEBITO (DECOLAR .COM.LTDA - R$ 21.553,32) FLS 48/50, REQUISITEI SUA TRANSFERENCIA PARA CONTA JUDICIAL, CONVERTENDO O BLOQUEIO EM PENHORA, E O DESBLOQUEIO DO VALOR EXCEDENTE. CONVERTIDO O BLOQUEIO EM PENHORA, FICA A PARTE EXECUTADA INTIMADA DA CONSTRICAO PELA PUBLICACAO DESTA DECISAO NO DJE EM NOME DE SEU ADVOGADO. INTIME-SE. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP), JOAO BATISTA DE LIMA JUNIOR (OAB 317336/SP)",
                    "PublishDate": "2018-08-15T00:00:00",
                    "CaptureDate": "2018-08-17T15:33:18"
                  },
                  {
                    "Content": "REMETIDO AO DJE | RELACAO: 0287/2018 TEOR DO ATO: VISTOS. BLOQUEADOS ATIVOS FINANCEIROS SUFICIENTES PARA A SATISFACAO DO DEBITO (DECOLAR .COM.LTDA - R$ 21.553,32) FLS 48/50, REQUISITEI SUA TRANSFERENCIA PARA CONTA JUDICIAL, CONVERTENDO O BLOQUEIO EM PENHORA, E O DESBLOQUEIO DO VALOR EXCEDENTE. CONVERTIDO O BLOQUEIO EM PENHORA, FICA A PARTE EXECUTADA INTIMADA DA CONSTRICAO PELA PUBLICACAO DESTA DECISAO NO DJE EM NOME DE SEU ADVOGADO. INTIME-SE. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP), JOAO BATISTA DE LIMA JUNIOR (OAB 317336/SP)",
                    "PublishDate": "2018-08-15T00:00:00",
                    "CaptureDate": "2021-06-08T15:46:52"
                  },
                  {
                    "Content": "REMETIDO AO DJE | RELACAO: 0287/2018 TEOR DO ATO: VISTOS. ANOTO QUE A PARTE EXECUTADA TEM ADVOGADO CONSTITUIDO NOS AUTOS. UMA VEZ QUE A PARTE EXECUTADA, EMBORA REGULARMENTE INTIMADA, NAO REALIZOU O PAGAMENTO ESPONTANEO, DEFIRO O REQUERIMENTO DA PARTE EXEQUENTE E, NA FORMA DO DISPOSTO PELO ARTIGO 854 DO CPC, COMANDO BLOQUEIO DE ATIVOS FINANCEIROS PERTENCENTES A EXECUTADA, ACIMA QUALIFICADA, POR MEIO DO SISTEMA BACENJUD, ATE O LIMITE DO DEBITO EM EXECUCAO, O QUAL, MERAMENTE ATUALIZADO PELO ULTIMO INDICE DIVULGADO DA TABELA DEPRE (07/2018), ALCANCA O VALOR DE R$ 21.553,32. INTIMEM-SE OPORTUNAMENTE. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP), JOAO BATISTA DE LIMA JUNIOR (OAB 317336/SP)",
                    "PublishDate": "2018-08-15T00:00:00",
                    "CaptureDate": "2021-06-08T15:46:52"
                  },
                  {
                    "Content": "DECISAO VISTOS. BLOQUEADOS ATIVOS FINANCEIROS SUFICIENTES PARA A SATISFACAO DO DEBITO (DECOLAR .COM.LTDA - R$ 21.553,32) FLS 48/50, REQUISITEI SUA TRANSFERENCIA PARA CONTA JUDICIAL, CONVERTENDO O BLOQUEIO EM PENHORA, E O DESBLOQUEIO DO VALOR EXCEDENTE. CONVERTIDO O BLOQUEIO EM PENHORA, FICA A PARTE EXECUTADA INTIMADA DA CONSTRICAO PELA PUBLICACAO DESTA DECISAO NO DJE EM NOME DE SEU ADVOGADO. INTIME-SE.",
                    "PublishDate": "2018-08-14T00:00:00",
                    "CaptureDate": "2018-08-17T15:33:18"
                  },
                  {
                    "Content": "FLS. 51 TRIBUNAL DE JUSTICA DO ESTADO DE SAO PAULO COMARCA DE SAO PAULO FORO CENTRAL CIVEL 1 VARA CIVEL PRACA JOAO MENDES S/N, 6 ANDAR - SALAS N 607/609 - CENTRO CEP: 01501-900 - SAO PAULO - SP TELEFONE: 2171-6065 - E-MAIL: SP1CV@TJ.SP.GOV.BR CONCLUSAO EM 10/08/2018 FACO ESTES AUTOS CONCLUSOS A MERITISSIMA JUIZA DE DIREITO DESTA 1 VARA CIVEL CENTRAL DA CAPITAL. EU __________________CATIA MEDEIROS FORTE, ESCREVENTE TECNICO JUDICIARIO, M812606, SUBSCREVI. DECISAO PROCESSO N: 0040796-97.2018.8.26.0100 CLASSE - ASSUNTO CUMPRIMENTO DE SENTENCA - TURISMO EXEQUENTE: RAFAEL CASTRO DE MATOS. REQUERIDO: DECOLAR.COM LTDA JUIZA DE DIREITO: DRA. DENISE CAVALCANTE FORTES MARTINS VISTOS. BLOQUEADOS ATIVOS FINANCEIROS SUFICIENTES PARA A SATISFACAO DO DEBITO (DECOLAR .COM.LTDA - R$ 21.553,32) FLS 48/50, REQUISITEI SUA TRANSFERENCIA PARA CONTA JUDICIAL, CONVERTENDO O BLOQUEIO EM PENHORA, E O DESBLOQUEIO DO VALOR EXCEDENTE. CONVERTIDO O BLOQUEIO EM PENHORA, FICA A PARTE EXECUTADA INTIMADA DA CONSTRICAO PELA PUBLICACAO DESTA DECISAO NO DJE EM NOME DE SEU ADVOGADO. INTIME-SE. SAO PAULO, 10 DE AGOSTO DE 2018 DENISE CAVALCANTE FORTES MARTINS JUIZA DE DIREITO DOCUMENTO ASSINADO DIGITALMENTE NOS TERMOS DA LEI 11.419/2006, CONFORME IMPRESSAO A MARGEM DIREITA PROCESSO N 0040796-97.2018.8.26.0100 - P. 1 ESTE DOCUMENTO E COPIA DO ORIGINAL, ASSINADO DIGITALMENTE POR DENISE CAVALCANTE FORTES MARTINS, LIBERADO NOS AUTOS EM 14/08/2018 AS 17:54 . PARA CONFERIR O ORIGINAL, ACESSE SITE HTTPS://ESAJ.TJSP.JUS.BR/PASTADIGITAL/PG/ABRIRCONFERENCIADOCUMENTO.DO, INFORME PROCESSO 0040796-97.2018.8.26.0100 E CODIGO 4C56C29.",
                    "PublishDate": "2018-08-14T00:00:00",
                    "CaptureDate": "2018-09-30T07:02:46"
                  },
                  {
                    "Content": "DECISAO | VISTOS. BLOQUEADOS ATIVOS FINANCEIROS SUFICIENTES PARA A SATISFACAO DO DEBITO (DECOLAR .COM.LTDA - R$ 21.553,32) FLS 48/50, REQUISITEI SUA TRANSFERENCIA PARA CONTA JUDICIAL, CONVERTENDO O BLOQUEIO EM PENHORA, E O DESBLOQUEIO DO VALOR EXCEDENTE. CONVERTIDO O BLOQUEIO EM PENHORA, FICA A PARTE EXECUTADA INTIMADA DA CONSTRICAO PELA PUBLICACAO DESTA DECISAO NO DJE EM NOME DE SEU ADVOGADO. INTIME-SE.",
                    "PublishDate": "2018-08-14T00:00:00",
                    "CaptureDate": "2021-06-08T15:46:52"
                  },
                  {
                    "Content": "DETERMINADO NOVO BLOQUEIO/PENHORA ON LINE VISTOS. ANOTO QUE A PARTE EXECUTADA TEM ADVOGADO CONSTITUIDO NOS AUTOS. UMA VEZ QUE A PARTE EXECUTADA, EMBORA REGULARMENTE INTIMADA, NAO REALIZOU O PAGAMENTO ESPONTANEO, DEFIRO O REQUERIMENTO DA PARTE EXEQUENTE E, NA FORMA DO DISPOSTO PELO ARTIGO 854 DO CPC, COMANDO BLOQUEIO DE ATIVOS FINANCEIROS PERTENCENTES A EXECUTADA, ACIMA QUALIFICADA, POR MEIO DO SISTEMA BACENJUD, ATE O LIMITE DO DEBITO EM EXECUCAO, O QUAL, MERAMENTE ATUALIZADO PELO ULTIMO INDICE DIVULGADO DA TABELA DEPRE (07/2018), ALCANCA O VALOR DE R$ 21.553,32. INTIMEM-SE OPORTUNAMENTE.",
                    "PublishDate": "2018-08-10T00:00:00",
                    "CaptureDate": "2018-08-17T15:33:18"
                  },
                  {
                    "Content": "BLOQUEIO/PENHORA ON LINE - POSITIVO JUNTADO",
                    "PublishDate": "2018-08-10T00:00:00",
                    "CaptureDate": "2018-08-17T15:33:18"
                  },
                  {
                    "Content": "FLS. 47 TRIBUNAL DE JUSTICA DO ESTADO DE SAO PAULO COMARCA DE SAO PAULO FORO CENTRAL CIVEL 1 VARA CIVEL PRACA JOAO MENDES S/N, 6 ANDAR - SALAS N 607/609, CENTRO - CEP 01501-900, FONE: 2171-6065, SAO PAULO-SP - E- MAIL: SP1CV@TJ.SP.GOV.BR DECISAO PROCESSO N: 0040796-97.2018.8.26.0100 CLASSE - ASSUNTO CUMPRIMENTO DE SENTENCA - TURISMO EXEQUENTE: RAFAEL CASTRO DE MATOS. REQUERIDO: DECOLAR.COM LTDA - CNPJ N 03.563.689/0002-31 VISTOS. ANOTO QUE A PARTE EXECUTADA TEM ADVOGADO CONSTITUIDO NOS AUTOS. UMA VEZ QUE A PARTE EXECUTADA, EMBORA REGULARMENTE INTIMADA, NAO REALIZOU O PAGAMENTO ESPONTANEO, DEFIRO O REQUERIMENTO DA PARTE EXEQUENTE E, NA FORMA DO DISPOSTO PELO ARTIGO 854 DO CPC, COMANDO BLOQUEIO DE ATIVOS FINANCEIROS PERTENCENTES A EXECUTADA, ACIMA QUALIFICADA, POR MEIO DO SISTEMA BACENJUD, ATE O LIMITE DO DEBITO EM EXECUCAO, O QUAL, MERAMENTE ATUALIZADO PELO ULTIMO INDICE DIVULGADO DA TABELA DEPRE (07/2018), ALCANCA O VALOR DE R$ 21.553,32. INTIMEM-SE OPORTUNAMENTE. SAO PAULO, 05 DE JULHO DE 2018. DENISE CAVALCANTE FORTES MARTINS JUIZA DE DIREITO DOCUMENTO ASSINADO DIGITALMENTE NOS TERMOS DA LEI 11.419/2006, CONFORME IMPRESSAO A MARGEM DIREITA PROCESSO N [NUMERO DO PROCESSO] - P. 1 ESTE DOCUMENTO E COPIA DO ORIGINAL, ASSINADO DIGITALMENTE POR DENISE CAVALCANTE FORTES MARTINS, LIBERADO NOS AUTOS EM 10/08/2018 AS 16:14 . PARA CONFERIR O ORIGINAL, ACESSE SITE HTTPS://ESAJ.TJSP.JUS.BR/PASTADIGITAL/PG/ABRIRCONFERENCIADOCUMENTO.DO, INFORME PROCESSO 0040796-97.2018.8.26.0100 E CODIGO 49206B7.",
                    "PublishDate": "2018-08-10T00:00:00",
                    "CaptureDate": "2018-09-30T07:02:29"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO",
                    "PublishDate": "2018-08-10T00:00:00",
                    "CaptureDate": "2018-08-17T15:33:18"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO",
                    "PublishDate": "2018-08-10T00:00:00",
                    "CaptureDate": "2021-06-08T15:46:52"
                  },
                  {
                    "Content": "DETERMINADO NOVO BLOQUEIO/PENHORA ON LINE | VISTOS. ANOTO QUE A PARTE EXECUTADA TEM ADVOGADO CONSTITUIDO NOS AUTOS. UMA VEZ QUE A PARTE EXECUTADA, EMBORA REGULARMENTE INTIMADA, NAO REALIZOU O PAGAMENTO ESPONTANEO, DEFIRO O REQUERIMENTO DA PARTE EXEQUENTE E, NA FORMA DO DISPOSTO PELO ARTIGO 854 DO CPC, COMANDO BLOQUEIO DE ATIVOS FINANCEIROS PERTENCENTES A EXECUTADA, ACIMA QUALIFICADA, POR MEIO DO SISTEMA BACENJUD, ATE O LIMITE DO DEBITO EM EXECUCAO, O QUAL, MERAMENTE ATUALIZADO PELO ULTIMO INDICE DIVULGADO DA TABELA DEPRE (07/2018), ALCANCA O VALOR DE R$ 21.553,32. INTIMEM-SE OPORTUNAMENTE.",
                    "PublishDate": "2018-08-10T00:00:00",
                    "CaptureDate": "2021-06-08T15:46:52"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO",
                    "PublishDate": "2018-07-05T00:00:00",
                    "CaptureDate": "2018-08-17T15:33:18"
                  },
                  {
                    "Content": "CERTIDAO DE CARTORIO EXPEDIDA CERTIDAO - GENERICA",
                    "PublishDate": "2018-07-04T00:00:00",
                    "CaptureDate": "2018-08-17T15:33:18"
                  },
                  {
                    "Content": "CERTIDAO DE CARTORIO EXPEDIDA | CERTIDAO - GENERICA",
                    "PublishDate": "2018-07-04T00:00:00",
                    "CaptureDate": "2021-06-08T15:46:52"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0186/2018 DATA DA DISPONIBILIZACAO: 08/06/2018 DATA DA PUBLICACAO: 11/06/2018 NUMERO DO DIARIO: 2591 PAGINA: 25",
                    "PublishDate": "2018-06-08T00:00:00",
                    "CaptureDate": "2018-06-09T07:48:46"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0186/2018 DATA DA DISPONIBILIZACAO: 08/06/2018 DATA DA PUBLICACAO: 11/06/2018 NUMERO DO DIARIO: 2591 PAGINA: 25",
                    "PublishDate": "2018-06-08T00:00:00",
                    "CaptureDate": "2021-06-08T15:46:52"
                  },
                  {
                    "Content": "REMETIDO AO DJE RELACAO: 0186/2018 TEOR DO ATO: VISTOS.NA FORMA DO ARTIGO 513 2, INTIME-SE O EXECUTADO, PELO DJE, PARA QUE, NO PRAZO DE 15 (QUINZE) DIAS, PAGUE O VALOR INDICADO NO DEMONSTRATIVO DISCRIMINADO E ATUALIZADO DO CREDITO, ACRESCIDO DE CUSTAS, SE HOUVER.FICA A PARTE EXECUTADA ADVERTIDA DE QUE, TRANSCORRIDO O PRAZO PREVISTO NO ART. 523 SEM O PAGAMENTO VOLUNTARIO, INICIA-SE O PRAZO DE 15 (QUINZE) DIAS PARA QUE, INDEPENDENTEMENTE DE PENHORA OU NOVA INTIMACAO, APRESENTE, NOS PROPRIOS AUTOS, SUA IMPUGNACAO.NAO OCORRENDO PAGAMENTO VOLUNTARIO NO PRAZO DO ARTIGO 523 DO CPC, O DEBITO SERA ACRESCIDO DE MULTA DE DEZ POR CENTO E, TAMBEM, DE HONORARIOS DE ADVOGADO DE DEZ POR CENTO.ADEMAIS, NAO EFETUADO O PAGAMENTO VOLUNTARIO NO PRAZO DE 15 (QUINZE) DIAS, INDEPENDENTEMENTE DE NOVA INTIMACAO DO CREDOR, PODERA A PARTE EXEQUENTE EFETUAR PEDIDO DE PESQUISAS JUNTO AOS SISTEMAS INFORMATIZADOS A DISPOSICAO DO JUIZO, DEVENDO COMPROVAR O PREVIO RECOLHIMENTO DAS TAXAS PREVISTAS NO ART. 2, INC. XI, DA LEI ESTADUAL 14.838/12, CALCULADAS POR CADA DILIGENCIA A SER EFETUADA.POR FIM, CERTIFICADO O TRANSITO EM JULGADO DA DECISAO E TRANSCORRIDO O PRAZO DO ART. 523, A PARTE EXEQUENTE PODERA REQUERER DIRETAMENTE A SERVENTIA A EXPEDICAO DE CERTIDAO, NOS TERMOS DO ART. 517 DO CPC, QUE SERVIRA TAMBEM AOS FINS PREVISTOS NO ART. 782, 3, TODOS DO CODIGO DE PROCESSO CIVIL.INTIME-SE. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP), JOAO BATISTA DE LIMA JUNIOR (OAB 317336/SP)",
                    "PublishDate": "2018-06-07T00:00:00",
                    "CaptureDate": "2018-06-09T07:48:46"
                  },
                  {
                    "Content": "REMETIDO AO DJE | RELACAO: 0186/2018 TEOR DO ATO: VISTOS.NA FORMA DO ARTIGO 513 2, INTIME-SE O EXECUTADO, PELO DJE, PARA QUE, NO PRAZO DE 15 (QUINZE) DIAS, PAGUE O VALOR INDICADO NO DEMONSTRATIVO DISCRIMINADO E ATUALIZADO DO CREDITO, ACRESCIDO DE CUSTAS, SE HOUVER.FICA A PARTE EXECUTADA ADVERTIDA DE QUE, TRANSCORRIDO O PRAZO PREVISTO NO ART. 523 SEM O PAGAMENTO VOLUNTARIO, INICIA-SE O PRAZO DE 15 (QUINZE) DIAS PARA QUE, INDEPENDENTEMENTE DE PENHORA OU NOVA INTIMACAO, APRESENTE, NOS PROPRIOS AUTOS, SUA IMPUGNACAO.NAO OCORRENDO PAGAMENTO VOLUNTARIO NO PRAZO DO ARTIGO 523 DO CPC, O DEBITO SERA ACRESCIDO DE MULTA DE DEZ POR CENTO E, TAMBEM, DE HONORARIOS DE ADVOGADO DE DEZ POR CENTO.ADEMAIS, NAO EFETUADO O PAGAMENTO VOLUNTARIO NO PRAZO DE 15 (QUINZE) DIAS, INDEPENDENTEMENTE DE NOVA INTIMACAO DO CREDOR, PODERA A PARTE EXEQUENTE EFETUAR PEDIDO DE PESQUISAS JUNTO AOS SISTEMAS INFORMATIZADOS A DISPOSICAO DO JUIZO, DEVENDO COMPROVAR O PREVIO RECOLHIMENTO DAS TAXAS PREVISTAS NO ART. 2, INC. XI, DA LEI ESTADUAL 14.838/12, CALCULADAS POR CADA DILIGENCIA A SER EFETUADA.POR FIM, CERTIFICADO O TRANSITO EM JULGADO DA DECISAO E TRANSCORRIDO O PRAZO DO ART. 523, A PARTE EXEQUENTE PODERA REQUERER DIRETAMENTE A SERVENTIA A EXPEDICAO DE CERTIDAO, NOS TERMOS DO ART. 517 DO CPC, QUE SERVIRA TAMBEM AOS FINS PREVISTOS NO ART. 782, 3, TODOS DO CODIGO DE PROCESSO CIVIL.INTIME-SE. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP), JOAO BATISTA DE LIMA JUNIOR (OAB 317336/SP)",
                    "PublishDate": "2018-06-07T00:00:00",
                    "CaptureDate": "2021-06-08T15:46:52"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO",
                    "PublishDate": "2018-06-06T00:00:00",
                    "CaptureDate": "2018-06-09T07:48:46"
                  },
                  {
                    "Content": "FLS. 38 TRIBUNAL DE JUSTICA DO ESTADO DE SAO PAULO COMARCA DE SAO PAULO FORO CENTRAL CIVEL 1 VARA CIVEL PRACA JOAO MENDES S/N, 6 ANDAR - SALAS N 607/609, CENTRO - CEP 01501- 900, FONE: 2171-6065, SAO PAULO-SP - E-MAIL: SP1CV@TJ.SP.GOV.BR HORARIO DE ATENDIMENTO AO PUBLICO: DAS 12H30MIN AS19H00MIN DECISAO PROCESSO DIGITAL N: 0040796-97.2018.8.26.0100 CLASSE  ASSUNTO: CUMPRIMENTO DE SENTENCA - TURISMO EXEQUENTE: RAFAEL CASTRO DE MATOS. REQUERIDO: DECOLAR.COM LTDA JUIZ(A) DE DIREITO: DR(A). DENISE CAVALCANTE FORTES MARTINS VISTOS. NA FORMA DO ARTIGO 513 2, INTIME-SE O EXECUTADO, PELO DJE, PARA QUE, NO PRAZO DE 15 (QUINZE) DIAS, PAGUE O VALOR INDICADO NO DEMONSTRATIVO DISCRIMINADO E ATUALIZADO DO CREDITO, ACRESCIDO DE CUSTAS, SE HOUVER. FICA A PARTE EXECUTADA ADVERTIDA DE QUE, TRANSCORRIDO O PRAZO PREVISTO NO ART. 523 SEM O PAGAMENTO VOLUNTARIO, INICIA-SE O PRAZO DE 15 (QUINZE) DIAS PARA QUE, INDEPENDENTEMENTE DE PENHORA OU NOVA INTIMACAO, APRESENTE, NOS PROPRIOS AUTOS, SUA IMPUGNACAO. NAO OCORRENDO PAGAMENTO VOLUNTARIO NO PRAZO DO ARTIGO 523 DO CPC, O DEBITO SERA ACRESCIDO DE MULTA DE DEZ POR CENTO E, TAMBEM, DE HONORARIOS DE ADVOGADO DE DEZ POR CENTO. ADEMAIS, NAO EFETUADO O PAGAMENTO VOLUNTARIO NO PRAZO DE 15 (QUINZE) DIAS, INDEPENDENTEMENTE DE NOVA INTIMACAO DO CREDOR, PODERA A PARTE EXEQUENTE EFETUAR PEDIDO DE PESQUISAS JUNTO AOS SISTEMAS INFORMATIZADOS A DISPOSICAO DO JUIZO, DEVENDO COMPROVAR O PREVIO RECOLHIMENTO DAS TAXAS PREVISTAS NO ART. 2, INC. XI, DA LEI ESTADUAL 14.838/12, CALCULADAS POR CADA DILIGENCIA A SER EFETUADA. POR FIM, CERTIFICADO O TRANSITO EM JULGADO DA DECISAO E TRANSCORRIDO O PRAZO DO ART. 523, A PARTE EXEQUENTE PODERA REQUERER DIRETAMENTE A SERVENTIA A EXPEDICAO DE CERTIDAO, NOS TERMOS DO ART. 517 DO CPC, QUE SERVIRA TAMBEM AOS FINS PREVISTOS NO ART. 782, 3, TODOS DO CODIGO DE PROCESSO CIVIL. INTIME-SE. SAO PAULO, 06 DE JUNHO DE 2018. DOCUMENTO ASSINADO DIGITALMENTE NOS TERMOS DA LEI 11.419/2006, CONFORME IMPRESSAO A MARGEM DIREITA ESTE DOCUMENTO E COPIA DO ORIGINAL, ASSINADO DIGITALMENTE POR DENISE CAVALCANTE FORTES MARTINS, LIBERADO NOS AUTOS EM 06/06/2018 AS 18:21 . PARA CONFERIR O ORIGINAL, ACESSE SITE HTTPS://ESAJ.TJSP.JUS.BR/PASTADIGITAL/PG/ABRIRCONFERENCIADOCUMENTO.DO, INFORME PROCESSO 0040796-97.2018.8.26.0100 E CODIGO 467796D.",
                    "PublishDate": "2018-06-06T00:00:00",
                    "CaptureDate": "2018-09-30T07:02:13"
                  },
                  {
                    "Content": "DECISAO VISTOS.NA FORMA DO ARTIGO 513 2, INTIME-SE O EXECUTADO, PELO DJE, PARA QUE, NO PRAZO DE 15 (QUINZE) DIAS, PAGUE O VALOR INDICADO NO DEMONSTRATIVO DISCRIMINADO E ATUALIZADO DO CREDITO, ACRESCIDO DE CUSTAS, SE HOUVER.FICA A PARTE EXECUTADA ADVERTIDA DE QUE, TRANSCORRIDO O PRAZO PREVISTO NO ART. 523 SEM O PAGAMENTO VOLUNTARIO, INICIA-SE O PRAZO DE 15 (QUINZE) DIAS PARA QUE, INDEPENDENTEMENTE DE PENHORA OU NOVA INTIMACAO, APRESENTE, NOS PROPRIOS AUTOS, SUA IMPUGNACAO.NAO OCORRENDO PAGAMENTO VOLUNTARIO NO PRAZO DO ARTIGO 523 DO CPC, O DEBITO SERA ACRESCIDO DE MULTA DE DEZ POR CENTO E, TAMBEM, DE HONORARIOS DE ADVOGADO DE DEZ POR CENTO.ADEMAIS, NAO EFETUADO O PAGAMENTO VOLUNTARIO NO PRAZO DE 15 (QUINZE) DIAS, INDEPENDENTEMENTE DE NOVA INTIMACAO DO CREDOR, PODERA A PARTE EXEQUENTE EFETUAR PEDIDO DE PESQUISAS JUNTO AOS SISTEMAS INFORMATIZADOS A DISPOSICAO DO JUIZO, DEVENDO COMPROVAR O PREVIO RECOLHIMENTO DAS TAXAS PREVISTAS NO ART. 2, INC. XI, DA LEI ESTADUAL 14.838/12, CALCULADAS POR CADA DILIGENCIA A SER EFETUADA.POR FIM, CERTIFICADO O TRANSITO EM JULGADO DA DECISAO E TRANSCORRIDO O PRAZO DO ART. 523, A PARTE EXEQUENTE PODERA REQUERER DIRETAMENTE A SERVENTIA A EXPEDICAO DE CERTIDAO, NOS TERMOS DO ART. 517 DO CPC, QUE SERVIRA TAMBEM AOS FINS PREVISTOS NO ART. 782, 3, TODOS DO CODIGO DE PROCESSO CIVIL.INTIME-SE.",
                    "PublishDate": "2018-06-06T00:00:00",
                    "CaptureDate": "2018-06-09T07:48:46"
                  },
                  {
                    "Content": "DECISAO | VISTOS.NA FORMA DO ARTIGO 513 2, INTIME-SE O EXECUTADO, PELO DJE, PARA QUE, NO PRAZO DE 15 (QUINZE) DIAS, PAGUE O VALOR INDICADO NO DEMONSTRATIVO DISCRIMINADO E ATUALIZADO DO CREDITO, ACRESCIDO DE CUSTAS, SE HOUVER.FICA A PARTE EXECUTADA ADVERTIDA DE QUE, TRANSCORRIDO O PRAZO PREVISTO NO ART. 523 SEM O PAGAMENTO VOLUNTARIO, INICIA-SE O PRAZO DE 15 (QUINZE) DIAS PARA QUE, INDEPENDENTEMENTE DE PENHORA OU NOVA INTIMACAO, APRESENTE, NOS PROPRIOS AUTOS, SUA IMPUGNACAO.NAO OCORRENDO PAGAMENTO VOLUNTARIO NO PRAZO DO ARTIGO 523 DO CPC, O DEBITO SERA ACRESCIDO DE MULTA DE DEZ POR CENTO E, TAMBEM, DE HONORARIOS DE ADVOGADO DE DEZ POR CENTO.ADEMAIS, NAO EFETUADO O PAGAMENTO VOLUNTARIO NO PRAZO DE 15 (QUINZE) DIAS, INDEPENDENTEMENTE DE NOVA INTIMACAO DO CREDOR, PODERA A PARTE EXEQUENTE EFETUAR PEDIDO DE PESQUISAS JUNTO AOS SISTEMAS INFORMATIZADOS A DISPOSICAO DO JUIZO, DEVENDO COMPROVAR O PREVIO RECOLHIMENTO DAS TAXAS PREVISTAS NO ART. 2, INC. XI, DA LEI ESTADUAL 14.838/12, CALCULADAS POR CADA DILIGENCIA A SER EFETUADA.POR FIM, CERTIFICADO O TRANSITO EM JULGADO DA DECISAO E TRANSCORRIDO O PRAZO DO ART. 523, A PARTE EXEQUENTE PODERA REQUERER DIRETAMENTE A SERVENTIA A EXPEDICAO DE CERTIDAO, NOS TERMOS DO ART. 517 DO CPC, QUE SERVIRA TAMBEM AOS FINS PREVISTOS NO ART. 782, 3, TODOS DO CODIGO DE PROCESSO CIVIL.INTIME-SE.",
                    "PublishDate": "2018-06-06T00:00:00",
                    "CaptureDate": "2021-06-08T15:46:52"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO",
                    "PublishDate": "2018-06-06T00:00:00",
                    "CaptureDate": "2021-06-08T15:46:52"
                  },
                  {
                    "Content": "INICIO DA EXECUCAO JUNTADO PROCESSO PRINCIPAL: 1107715-85.2017.8.26.0100",
                    "PublishDate": "2018-05-28T00:00:00",
                    "CaptureDate": "2018-06-09T07:48:46"
                  },
                  {
                    "Content": "APENSADO AO PROCESSO APENSADO AO PROCESSO 1107715-85.2017.8.26.0100 - CLASSE: PROCEDIMENTO COMUM - ASSUNTO PRINCIPAL: TURISMO",
                    "PublishDate": "2018-05-28T00:00:00",
                    "CaptureDate": "2018-06-09T07:48:46"
                  },
                  {
                    "Content": "APENSADO AO PROCESSO | APENSADO AO PROCESSO 1107715-85.2017.8.26.0100 - CLASSE: PROCEDIMENTO COMUM - ASSUNTO PRINCIPAL: TURISMO",
                    "PublishDate": "2018-05-28T00:00:00",
                    "CaptureDate": "2021-06-08T15:46:52"
                  },
                  {
                    "Content": "INICIO DA EXECUCAO JUNTADO | PROCESSO PRINCIPAL: 1107715-85.2017.8.26.0100",
                    "PublishDate": "2018-05-28T00:00:00",
                    "CaptureDate": "2021-06-08T15:46:52"
                  }
                ],
                "Petitions": [
                  {
                    "Type": "PRIMEIRO PEDIDO DE BLOQUEIO DE VALORES  SISTEMA SISBAJUD",
                    "Author": "",
                    "CreationDate": "2018-07-03T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  },
                  {
                    "Type": "PETICOES DIVERSAS",
                    "Author": "",
                    "CreationDate": "2018-09-17T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  },
                  {
                    "Type": "PETICOES DIVERSAS",
                    "Author": "",
                    "CreationDate": "2018-09-26T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  },
                  {
                    "Type": "PEDIDO DE EXTINCAO (ART. 924, II, DO CPC)",
                    "Author": "",
                    "CreationDate": "2018-12-11T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  }
                ],
                "Decisions": [
                  {
                    "DecisionContent": "JULGO EXTINTA A ACAO QUE RAFAEL CASTRO DE MATOS PROMOVE A DECOLAR.COM LTDA, COM FUNDAMENTO NO DISPOSTO PELO ARTIGO 924, INCISO II, DO NOVO CODIGO DE PROCESSO CIVIL.",
                    "DecisionDate": "2018-09-21T00:00:00"
                  },
                  {
                    "DecisionContent": "JULGO EXTINTA A ACAO QUE RAFAEL CASTRO DE MATOS PROMOVE A DECOLAR.COM LTDA, COM FUNDAMENTO NO DISPOSTO PELO ARTIGO 924, INCISO II, DO NOVO CODIGO DE PROCESSO CIVIL.",
                    "DecisionDate": "2018-09-20T00:00:00"
                  },
                  {
                    "DecisionContent": "DEFIRO O REQUERIMENTO DA PARTE EXEQUENTE E, NA FORMA DO DISPOSTO PELO ARTIGO 854 DO CPC, COMANDO BLOQUEIO DE ATIVOS FINANCEIROS PERTENCENTES A EXECUTADA, ACIMA QUALIFICADA, POR MEIO DO SISTEMA BACENJUD, ATE O LIMITE DO DEBITO EM EXECUCAO, O QUAL, MERAMENTE ATUALIZADO PELO ULTIMO INDICE DIVULGADO DA TABELA DEPRE (07/2018), ALCANCA O VALOR DE R$ 21.553,32.",
                    "DecisionDate": "2018-08-15T00:00:00"
                  },
                  {
                    "DecisionContent": "DEFIRO O REQUERIMENTO DA PARTE EXEQUENTE E, NA FORMA DO DISPOSTO PELO ARTIGO 854 DO CPC, COMANDO BLOQUEIO DE ATIVOS FINANCEIROS PERTENCENTES A EXECUTADA, ACIMA QUALIFICADA, POR MEIO DO SISTEMA BACENJUD, ATE O LIMITE DO DEBITO EM EXECUCAO, O QUAL, MERAMENTE ATUALIZADO PELO ULTIMO INDICE DIVULGADO DA TABELA DEPRE (07/2018), ALCANCA O VALOR DE R$ 21.553,32.",
                    "DecisionDate": "2018-08-10T00:00:00"
                  }
                ]
              },
              {
                "Number": "10007444220188260100",
                "Type": "PROCEDIMENTO COMUM",
                "MainSubject": "INDENIZACAO POR DANO MORAL",
                "CourtName": "TJSP",
                "CourtLevel": "1",
                "CourtType": "CIVEL",
                "CourtDistrict": "",
                "Judge": "FERNANDO JOSE CUNICO",
                "JudgingBody": "12 VARA CIVEL - FORO CENTRAL CIVEL",
                "State": "SP",
                "Status": "INDEFINIDO",
                "LawsuitHostService": "ESAJ",
                "InferredCNJSubjectName": "INDENIZAÇÃO POR DANO MORAL",
                "InferredCNJSubjectNumber": 14010,
                "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
                "InferredBroadCNJSubjectName": "DIREITO DO TRABALHO",
                "InferredBroadCNJSubjectNumber": 864,
                "OtherSubjects": [
                  "INDENIZACAO POR DANO MORAL",
                  "INDENIZACAO POR DANO MATERIAL"
                ],
                "NumberOfVolumes": 0,
                "NumberOfPages": 0,
                "Value": 27121.64,
                "ResJudicataDate": "0001-01-01T00:00:00",
                "CloseDate": "0001-01-01T00:00:00",
                "RedistributionDate": "0001-01-01T00:00:00",
                "PublicationDate": "2019-03-19T00:00:00",
                "NoticeDate": "2018-01-09T00:00:00",
                "LastMovementDate": "2019-07-16T00:00:00",
                "CaptureDate": "2019-03-27T10:36:10",
                "LastUpdate": "2019-03-27T10:36:10",
                "NumberOfParties": 8,
                "NumberOfUpdates": 80,
                "LawSuitAge": 2241,
                "AverageNumberOfUpdatesPerMonth": 1,
                "ReasonForConcealedData": 0,
                "Parties": [
                  {
                    "IsPartyActive": true,
                    "Name": "HUMMINGBIRD PRODUCT STUDIO EIRELLI",
                    "Polarity": "ACTIVE",
                    "Type": "CLAIMANT",
                    "PartyDetails": {
                      "SpecificType": "REQTE"
                    },
                    "LastCaptureDate": "2019-03-27T10:36:10"
                  },
                  {
                    "IsPartyActive": true,
                    "Name": "FERNANDO JOSE CUNICO",
                    "Polarity": "NEUTRAL",
                    "Type": "REPORTER",
                    "PartyDetails": {
                      "SpecificType": "JUIZ"
                    },
                    "LastCaptureDate": "2019-03-27T10:36:10"
                  },
                  {
                    "IsPartyActive": true,
                    "Name": "ALFREDO ZUCCA NETO",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "154694",
                      "State": "SP",
                      "SpecificType": "ADVOGADO"
                    },
                    "LastCaptureDate": "2019-03-27T10:36:10"
                  },
                  {
                    "IsPartyActive": true,
                    "Name": "COMPANHIA BRASILEIRA DE SOLUCOES E SERVICOS S A",
                    "Polarity": "PASSIVE",
                    "Type": "CLAIMED",
                    "PartyDetails": {
                      "SpecificType": "REQDO"
                    },
                    "LastCaptureDate": "2019-03-27T10:36:10"
                  },
                  {
                    "Doc": "35068411817",
                    "IsPartyActive": true,
                    "Name": "RAFAEL HIDEO NAZIMA",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "295443",
                      "State": "SP",
                      "SpecificType": "ADVOGADO"
                    },
                    "LastCaptureDate": "2019-03-27T10:36:10"
                  },
                  {
                    "Doc": "02349014118",
                    "IsPartyActive": true,
                    "Name": "RAFAEL CASTRO DE MATOS",
                    "Polarity": "ACTIVE",
                    "Type": "CLAIMANT",
                    "PartyDetails": {
                      "SpecificType": "REQTE"
                    },
                    "LastCaptureDate": "2019-03-27T10:36:10"
                  },
                  {
                    "Doc": "35068411817",
                    "IsPartyActive": true,
                    "Name": "RAFAEL HIDEO NAZIMA",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "295443",
                      "State": "SP",
                      "SpecificType": "ADVOGADO (REQTE)"
                    },
                    "LastCaptureDate": "2019-03-27T10:36:10"
                  },
                  {
                    "Doc": "13349079865",
                    "IsPartyActive": true,
                    "Name": "ALFREDO ZUCCA NETO",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "154694",
                      "State": "SP",
                      "SpecificType": "ADVOGADO (REQDO)"
                    },
                    "LastCaptureDate": "2019-03-27T10:36:10"
                  }
                ],
                "Updates": [
                  {
                    "Content": "ARQUIVADO DEFINITIVAMENTE",
                    "PublishDate": "2019-07-16T00:00:00",
                    "CaptureDate": "2021-07-04T23:31:55"
                  },
                  {
                    "Content": "BAIXA DEFINITIVA",
                    "PublishDate": "2019-07-16T00:00:00",
                    "CaptureDate": "2021-07-04T23:31:55"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0155/2019 DATA DA DISPONIBILIZACAO: 16/04/2019 DATA DA PUBLICACAO: 17/04/2019 NUMERO DO DIARIO: 2790 PAGINA: 223/236",
                    "PublishDate": "2019-04-16T00:00:00",
                    "CaptureDate": "2021-07-04T23:31:55"
                  },
                  {
                    "Content": "REMETIDO AO DJE | RELACAO: 0155/2019 TEOR DO ATO: VISTOS. PETICOES DE FLS. 237/239 E FLS. 240/241 FORAM DECIDIDAS NO CUMPRIMENTO DE SENTENCA. COM O LEVANTAMENTO LA DETERMINADO, PROVIDENCIE A Z. SERVENTIA A BAIXA E ARQUIVAMENTO DO FEITO COM AS DEVIDAS CAUTELAS. INTIME-SE. ADVOGADOS(S): ALFREDO ZUCCA NETO (OAB 154694/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2019-04-15T00:00:00",
                    "CaptureDate": "2021-07-04T23:31:55"
                  },
                  {
                    "Content": "DECISAO | VISTOS. PETICOES DE FLS. 237/239 E FLS. 240/241 FORAM DECIDIDAS NO CUMPRIMENTO DE SENTENCA. COM O LEVANTAMENTO LA DETERMINADO, PROVIDENCIE A Z. SERVENTIA A BAIXA E ARQUIVAMENTO DO FEITO COM AS DEVIDAS CAUTELAS. INTIME-SE.",
                    "PublishDate": "2019-04-12T00:00:00",
                    "CaptureDate": "2021-07-04T23:31:55"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO",
                    "PublishDate": "2019-04-12T00:00:00",
                    "CaptureDate": "2021-07-04T23:31:55"
                  },
                  {
                    "Content": "PEDIDO DE EXPEDICAO DE MANDADO DE LEVANTAMENTO JUNTADO | N PROTOCOLO: WJMJ.19.40498650-0 TIPO DA PETICAO: PEDIDO DE EXPEDICAO DE GUIA DE LEVANTAMENTO DATA: 10/04/2019 19:47",
                    "PublishDate": "2019-04-10T00:00:00",
                    "CaptureDate": "2021-07-04T23:31:55"
                  },
                  {
                    "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.19.40454662-3 TIPO DA PETICAO: JUNTADA DE COMPROVANTE DE DEPOSITO - GESTAO - DEPRE DATA: 03/04/2019 16:48",
                    "PublishDate": "2019-04-03T00:00:00",
                    "CaptureDate": "2021-07-04T23:31:55"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0104/2019 DATA DA DISPONIBILIZACAO: 19/03/2019 DATA DA PUBLICACAO: 20/03/2019 NUMERO DO DIARIO: 2770 PAGINA: 242/251",
                    "PublishDate": "2019-03-19T00:00:00",
                    "CaptureDate": "2019-03-27T10:37:33"
                  },
                  {
                    "Content": "PROCESSO 1000744-42.2018.8.26.0100 - PROCEDIMENTO COMUM CIVEL - INDENIZACAO POR DANO MORAL - RAFAEL CASTRO DE MATOS. - - HUMMINGBIRD PRODUCT STUDIO EIRELLI. - COMPANHIA BRASILEIRA DE SOLUCOES E SERVICOS S.A. (ALELO) - VISTOS. CUMPRA-SE O V. ACORDAO. TENDO EM VISTA QUE FOI DISTRIBUIDO O CUMPRIMENTO DE SENTENCA, REMETAM-SE OS AUTOS AO ARQUIVO, COM AS COMUNICACOES DE PRAXE. INT. - ADV: RAFAEL HIDEO NAZIMA (OAB 295443/SP), ALFREDO ZUCCA NETO (OAB 154694/SP)",
                    "PublishDate": "2019-03-19T00:00:00",
                    "CaptureDate": "2019-03-27T10:36:10"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0104/2019 DATA DA DISPONIBILIZACAO: 19/03/2019 DATA DA PUBLICACAO: 20/03/2019 NUMERO DO DIARIO: 2770 PAGINA: 242/251",
                    "PublishDate": "2019-03-19T00:00:00",
                    "CaptureDate": "2021-07-04T23:31:55"
                  },
                  {
                    "Content": "REMETIDO AO DJE RELACAO: 0104/2019 TEOR DO ATO: VISTOS. CUMPRA-SE O V. ACORDAO. TENDO EM VISTA QUE FOI DISTRIBUIDO O CUMPRIMENTO DE SENTENCA, REMETAM-SE OS AUTOS AO ARQUIVO, COM AS COMUNICACOES DE PRAXE. INT. ADVOGADOS(S): ALFREDO ZUCCA NETO (OAB 154694/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2019-03-18T00:00:00",
                    "CaptureDate": "2019-03-27T10:37:33"
                  },
                  {
                    "Content": "REMETIDO AO DJE | RELACAO: 0104/2019 TEOR DO ATO: VISTOS. CUMPRA-SE O V. ACORDAO. TENDO EM VISTA QUE FOI DISTRIBUIDO O CUMPRIMENTO DE SENTENCA, REMETAM-SE OS AUTOS AO ARQUIVO, COM AS COMUNICACOES DE PRAXE. INT. ADVOGADOS(S): ALFREDO ZUCCA NETO (OAB 154694/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2019-03-18T00:00:00",
                    "CaptureDate": "2021-07-04T23:31:55"
                  },
                  {
                    "Content": "CONCLUSOS PARA DESPACHO",
                    "PublishDate": "2019-03-15T00:00:00",
                    "CaptureDate": "2019-03-27T10:37:17"
                  },
                  {
                    "Content": "FLS. 234 TRIBUNAL DE JUSTICA DO ESTADO DE SAO PAULO COMARCA DE SAO PAULO FORO CENTRAL CIVEL 12 VARA CIVEL PRACA JOAO MENDES S/N, 8 ANDAR - SALAS N 805/807 - CENTRO CEP: 01501-900 - SAO PAULO - SP TELEFONE: 21716121 - E-MAIL: SP12CV@TJSP.JUS.BR DESPACHO PROCESSO N: 1000744-42.2018.8.26.0100 CLASSE  ASSUNTO: PROCEDIMENTO COMUM CIVEL - INDENIZACAO POR DANO MORAL REQUERENTE: RAFAEL CASTRO DE MATOS. E OUTRO REQUERIDO: COMPANHIA BRASILEIRA DE SOLUCOES E SERVICOS S.A. (ALELO) JUIZ(A) DE DIREITO: DR(A). FERNANDO JOSE CUNICO VISTOS. CUMPRA-SE O V. ACORDAO. TENDO EM VISTA QUE FOI DISTRIBUIDO O CUMPRIMENTO DE SENTENCA, REMETAM-SE OS AUTOS AO ARQUIVO, COM AS COMUNICACOES DE PRAXE. INT. SAO PAULO, 15 DE MARCO DE 2019. DOCUMENTO ASSINADO DIGITALMENTE NOS TERMOS DA LEI 11.419/2006, CONFORME IMPRESSAO A MARGEM DIREITA PROCESSO N 1000744-42.2018.8.26.0100 - P. 1 ESTE DOCUMENTO E COPIA DO ORIGINAL, ASSINADO DIGITALMENTE POR FERNANDO JOSE CUNICO, LIBERADO NOS AUTOS EM 15/03/2019 AS 16:58 . PARA CONFERIR O ORIGINAL, ACESSE SITE HTTPS://ESAJ.TJSP.JUS.BR/PASTADIGITAL/PG/ABRIRCONFERENCIADOCUMENTO.DO, INFORME PROCESSO 1000744-42.2018.8.26.0100 E CODIGO 69A94F4.",
                    "PublishDate": "2019-03-15T00:00:00",
                    "CaptureDate": "2019-03-27T10:37:17"
                  },
                  {
                    "Content": "PROFERIDO DESPACHO | VISTOS. CUMPRA-SE O V. ACORDAO. TENDO EM VISTA QUE FOI DISTRIBUIDO O CUMPRIMENTO DE SENTENCA, REMETAM-SE OS AUTOS AO ARQUIVO, COM AS COMUNICACOES DE PRAXE. INT.",
                    "PublishDate": "2019-03-15T00:00:00",
                    "CaptureDate": "2021-07-04T23:31:55"
                  },
                  {
                    "Content": "CONCLUSOS PARA DESPACHO",
                    "PublishDate": "2019-03-15T00:00:00",
                    "CaptureDate": "2021-07-04T23:31:55"
                  },
                  {
                    "Content": "INICIO DA EXECUCAO JUNTADO 0014416-03.2019.8.26.0100 - CUMPRIMENTO DE SENTENCA",
                    "PublishDate": "2019-03-11T00:00:00",
                    "CaptureDate": "2019-03-27T10:37:17"
                  },
                  {
                    "Content": "INICIO DA EXECUCAO JUNTADO | 0014416-03.2019.8.26.0100 - CUMPRIMENTO DE SENTENCA",
                    "PublishDate": "2019-03-11T00:00:00",
                    "CaptureDate": "2021-07-04T23:31:55"
                  },
                  {
                    "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.19.40211529-3 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 19/02/2019 13:46",
                    "PublishDate": "2019-02-19T00:00:00",
                    "CaptureDate": "2019-03-27T10:37:17"
                  },
                  {
                    "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.19.40211529-3 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 19/02/2019 13:46",
                    "PublishDate": "2019-02-19T00:00:00",
                    "CaptureDate": "2021-07-04T23:31:55"
                  },
                  {
                    "Content": "RECEBIDOS OS AUTOS DO TRIBUNAL DE JUSTICA",
                    "PublishDate": "2019-02-15T00:00:00",
                    "CaptureDate": "2019-03-27T10:37:17"
                  },
                  {
                    "Content": "CERTIDAO DE CARTORIO EXPEDIDA CERTIDAO - GENERICA",
                    "PublishDate": "2018-07-27T00:00:00",
                    "CaptureDate": "2019-03-27T10:37:17"
                  },
                  {
                    "Content": "REMETIDOS OS AUTOS PARA O TRIBUNAL DE JUSTICA/COLEGIO RECURSAL - PROCESSO DIGITAL",
                    "PublishDate": "2018-07-27T00:00:00",
                    "CaptureDate": "2019-03-27T10:37:17"
                  },
                  {
                    "Content": "REMETIDOS OS AUTOS PARA O TRIBUNAL DE JUSTICA/COLEGIO RECURSAL - PROCESSO DIGITAL",
                    "PublishDate": "2018-07-27T00:00:00",
                    "CaptureDate": "2021-07-04T23:31:55"
                  },
                  {
                    "Content": "CERTIDAO DE CARTORIO EXPEDIDA | CERTIDAO - GENERICA",
                    "PublishDate": "2018-07-27T00:00:00",
                    "CaptureDate": "2021-07-04T23:31:55"
                  },
                  {
                    "Content": "CONTRARRAZOES JUNTADA N PROTOCOLO: WJMJ.18.40901148-4 TIPO DA PETICAO: CONTRARRAZOES DE APELACAO DATA: 17/07/2018 09:08",
                    "PublishDate": "2018-07-17T00:00:00",
                    "CaptureDate": "2019-03-27T10:37:17"
                  },
                  {
                    "Content": "CONTRARRAZOES JUNTADA | N PROTOCOLO: WJMJ.18.40901148-4 TIPO DA PETICAO: CONTRARRAZOES DE APELACAO DATA: 17/07/2018 09:08",
                    "PublishDate": "2018-07-17T00:00:00",
                    "CaptureDate": "2021-07-04T23:31:55"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0311/2018 DATA DA DISPONIBILIZACAO: 05/07/2018 DATA DA PUBLICACAO: 06/07/2018 NUMERO DO DIARIO: 2610 PAGINA: 203/220",
                    "PublishDate": "2018-07-05T00:00:00",
                    "CaptureDate": "2019-03-27T10:37:17"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0311/2018 DATA DA DISPONIBILIZACAO: 05/07/2018 DATA DA PUBLICACAO: 06/07/2018 NUMERO DO DIARIO: 2610 PAGINA: 203/220",
                    "PublishDate": "2018-07-05T00:00:00",
                    "CaptureDate": "2021-07-04T23:31:55"
                  },
                  {
                    "Content": "REMETIDO AO DJE RELACAO: 0311/2018 TEOR DO ATO: A CONTRARAZOES. APOS SUBAM OS AUTOS AO EGREGIO TRIBUNAL DE JUSTICA. ADVOGADOS(S): ALFREDO ZUCCA NETO (OAB 154694/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2018-07-04T00:00:00",
                    "CaptureDate": "2019-03-27T10:37:17"
                  },
                  {
                    "Content": "REMETIDO AO DJE | RELACAO: 0311/2018 TEOR DO ATO: A CONTRARAZOES. APOS SUBAM OS AUTOS AO EGREGIO TRIBUNAL DE JUSTICA. ADVOGADOS(S): ALFREDO ZUCCA NETO (OAB 154694/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2018-07-04T00:00:00",
                    "CaptureDate": "2021-07-04T23:31:55"
                  },
                  {
                    "Content": "ATO ORDINATORIO - PUBLICAVEL A CONTRARAZOES. APOS SUBAM OS AUTOS AO EGREGIO TRIBUNAL DE JUSTICA.",
                    "PublishDate": "2018-07-03T00:00:00",
                    "CaptureDate": "2019-03-27T10:37:17"
                  },
                  {
                    "Content": "ATO ORDINATORIO - PUBLICAVEL | A CONTRARAZOES. APOS SUBAM OS AUTOS AO EGREGIO TRIBUNAL DE JUSTICA.",
                    "PublishDate": "2018-07-03T00:00:00",
                    "CaptureDate": "2021-07-04T23:31:55"
                  },
                  {
                    "Content": "APELACAO/RAZOES JUNTADA N PROTOCOLO: WJMJ.18.40806882-2 TIPO DA PETICAO: RAZOES DE APELACAO DATA: 27/06/2018 00:07",
                    "PublishDate": "2018-06-27T00:00:00",
                    "CaptureDate": "2019-03-27T10:37:17"
                  },
                  {
                    "Content": "APELACAO/RAZOES JUNTADA | N PROTOCOLO: WJMJ.18.40806882-2 TIPO DA PETICAO: RAZOES DE APELACAO DATA: 27/06/2018 00:07",
                    "PublishDate": "2018-06-27T00:00:00",
                    "CaptureDate": "2021-07-04T23:31:55"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0239/2018 DATA DA DISPONIBILIZACAO: 05/06/2018 DATA DA PUBLICACAO: 06/06/2018 NUMERO DO DIARIO: 2588 PAGINA: 404/417",
                    "PublishDate": "2018-06-05T00:00:00",
                    "CaptureDate": "2019-03-27T10:37:17"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0239/2018 DATA DA DISPONIBILIZACAO: 05/06/2018 DATA DA PUBLICACAO: 06/06/2018 NUMERO DO DIARIO: 2588 PAGINA: 404/417",
                    "PublishDate": "2018-06-05T00:00:00",
                    "CaptureDate": "2021-07-04T23:31:55"
                  },
                  {
                    "Content": "REMETIDO AO DJE RELACAO: 0239/2018 TEOR DO ATO: VISTOS.CONHECO DOS EMBARGOS DE DECLARACAO OPOSTOS CONTRA A SENTENCA, PORQUANTO TEMPESTIVOS.TODAVIA, NEGO-LHES PROVIMENTO, POIS AUSENTES REQUISITOS DO ARTIGO 1022 DO CODIGO DE PROCESSO CIVIL; NAO HAVENDO CONTRADICAO, OMISSAO OU OBSCURIDADE NA SENTENCA ATACADA, VISANDO TAO-SOMENTE A REFORMA PELO MERITO DA DECISAO, SOMENTE ADMISSIVEL EM RECURSO DE COGNICAO AMPLA, SENDO NITIDO O CARATER INFRINGENCIAL DA QUESTAO EMBARGADA.INT. ADVOGADOS(S): ALFREDO ZUCCA NETO (OAB 154694/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2018-06-04T00:00:00",
                    "CaptureDate": "2019-03-27T10:37:17"
                  },
                  {
                    "Content": "REMETIDO AO DJE | RELACAO: 0239/2018 TEOR DO ATO: VISTOS.CONHECO DOS EMBARGOS DE DECLARACAO OPOSTOS CONTRA A SENTENCA, PORQUANTO TEMPESTIVOS.TODAVIA, NEGO-LHES PROVIMENTO, POIS AUSENTES REQUISITOS DO ARTIGO 1022 DO CODIGO DE PROCESSO CIVIL; NAO HAVENDO CONTRADICAO, OMISSAO OU OBSCURIDADE NA SENTENCA ATACADA, VISANDO TAO-SOMENTE A REFORMA PELO MERITO DA DECISAO, SOMENTE ADMISSIVEL EM RECURSO DE COGNICAO AMPLA, SENDO NITIDO O CARATER INFRINGENCIAL DA QUESTAO EMBARGADA.INT. ADVOGADOS(S): ALFREDO ZUCCA NETO (OAB 154694/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2018-06-04T00:00:00",
                    "CaptureDate": "2021-07-04T23:31:55"
                  },
                  {
                    "Content": "FLS. 186 TRIBUNAL DE JUSTICA DO ESTADO DE SAO PAULO COMARCA DE SAO PAULO FORO CENTRAL CIVEL 12 VARA CIVEL PRACA JOAO MENDES S/N, 8 ANDAR - SALAS N 805/807 - CENTRO CEP: 01501-900 - SAO PAULO - SP TELEFONE: 21716121 - E-MAIL: SP12CV@TJSP.JUS.BR DECISAO PROCESSO N: 1000744-42.2018.8.26.0100 CLASSE - ASSUNTO PROCEDIMENTO COMUM - INDENIZACAO POR DANO MORAL REQUERENTE: RAFAEL CASTRO DE MATOS. E OUTRO REQUERIDO: COMPANHIA BRASILEIRA DE SOLUCOES E SERVICOS S.A. (ALELO) JUIZ DE DIREITO: DR. FERNANDO JOSE CUNICO VISTOS. CONHECO DOS EMBARGOS DE DECLARACAO OPOSTOS CONTRA A SENTENCA, PORQUANTO TEMPESTIVOS. TODAVIA, NEGO-LHES PROVIMENTO, POIS AUSENTES REQUISITOS DO ARTIGO 1022 DO CODIGO DE PROCESSO CIVIL; NAO HAVENDO CONTRADICAO, OMISSAO OU OBSCURIDADE NA SENTENCA ATACADA, VISANDO TAO-SOMENTE A REFORMA PELO MERITO DA DECISAO, SOMENTE ADMISSIVEL EM RECURSO DE COGNICAO AMPLA, SENDO NITIDO O CARATER INFRINGENCIAL DA QUESTAO EMBARGADA. INT. SAO PAULO 30 DE MAIO DE 2018. FERNANDO JOSE CUNICO DOCUMENTO ASSINADO DIGITALMENTE NOS TERMOS DA LEI 11.419/2006, CONFORME IMPRESSAO A MARGEM DIREITA PROCESSO N 1000744-42.2018.8.26.0100 - P. 1 ESTE DOCUMENTO E COPIA DO ORIGINAL, ASSINADO DIGITALMENTE POR FERNANDO JOSE CUNICO, LIBERADO NOS AUTOS EM 30/05/2018 AS 15:05 . PARA CONFERIR O ORIGINAL, ACESSE SITE HTTPS://ESAJ.TJSP.JUS.BR/PASTADIGITAL/PG/ABRIRCONFERENCIADOCUMENTO.DO, INFORME PROCESSO 1000744-42.2018.8.26.0100 E CODIGO 4616457.",
                    "PublishDate": "2018-05-30T00:00:00",
                    "CaptureDate": "2019-03-27T10:37:00"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO",
                    "PublishDate": "2018-05-30T00:00:00",
                    "CaptureDate": "2019-03-27T10:37:00"
                  },
                  {
                    "Content": "EMBARGOS DE DECLARACAO NAO-ACOLHIDOS | VISTOS.CONHECO DOS EMBARGOS DE DECLARACAO OPOSTOS CONTRA A SENTENCA, PORQUANTO TEMPESTIVOS.TODAVIA, NEGO-LHES PROVIMENTO, POIS AUSENTES REQUISITOS DO ARTIGO 1022 DO CODIGO DE PROCESSO CIVIL; NAO HAVENDO CONTRADICAO, OMISSAO OU OBSCURIDADE NA SENTENCA ATACADA, VISANDO TAO-SOMENTE A REFORMA PELO MERITO DA DECISAO, SOMENTE ADMISSIVEL EM RECURSO DE COGNICAO AMPLA, SENDO NITIDO O CARATER INFRINGENCIAL DA QUESTAO EMBARGADA.INT.",
                    "PublishDate": "2018-05-30T00:00:00",
                    "CaptureDate": "2021-07-04T23:31:55"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO",
                    "PublishDate": "2018-05-30T00:00:00",
                    "CaptureDate": "2021-07-04T23:31:55"
                  },
                  {
                    "Content": "EMBARGOS DE DECLARACAO JUNTADOS N PROTOCOLO: WJMJ.18.40607895-2 TIPO DA PETICAO: EMBARGOS DE DECLARACAO DATA: 17/05/2018 20:22",
                    "PublishDate": "2018-05-17T00:00:00",
                    "CaptureDate": "2019-03-27T10:37:00"
                  },
                  {
                    "Content": "EMBARGOS DE DECLARACAO JUNTADOS | N PROTOCOLO: WJMJ.18.40607895-2 TIPO DA PETICAO: EMBARGOS DE DECLARACAO DATA: 17/05/2018 20:22",
                    "PublishDate": "2018-05-17T00:00:00",
                    "CaptureDate": "2021-07-04T23:31:55"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0212/2018 DATA DA DISPONIBILIZACAO: 15/05/2018 DATA DA PUBLICACAO: 16/05/2018 NUMERO DO DIARIO: 2575 PAGINA: 246/257",
                    "PublishDate": "2018-05-15T00:00:00",
                    "CaptureDate": "2019-03-27T10:37:00"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0212/2018 DATA DA DISPONIBILIZACAO: 15/05/2018 DATA DA PUBLICACAO: 16/05/2018 NUMERO DO DIARIO: 2575 PAGINA: 246/257",
                    "PublishDate": "2018-05-15T00:00:00",
                    "CaptureDate": "2021-07-04T23:31:55"
                  },
                  {
                    "Content": "REMETIDO AO DJE RELACAO: 0212/2018 TEOR DO ATO: VISTOS.RAFAEL CASTRO DE MATTOS E HUMMINGBIRD PRODUCT STUDIO EIRELLI HUMMINGBIRD AJUIZARAM ACAO DE INDENIZACAO POR DANOS MORAIS E MATERIAIS EM FACE COMPANHIA BRASILEIRA DE SOLUCOES E SERVICOS ALELO. ALEGANDO, EM SINTESE, QUE DIANTE DE UMA PROGRAMACAO PARA A REALIZACAO DE VIAGEM PARA O ESTADOS UNIDOS DA AMERICA, COM O INTUITO DE COMPRAR EQUIPAMENTOS PARA A SUA EMPRESA, CONTRATOU A EMPRESA RE PARA A COMPRA DE DOLARES AMERICANOS, ATRAVES DA CORRETORA SOCOPA. SEGUE NARRANDO QUE, PARA AS DESPESAS DE ESTADIA E COMPRA DE EQUIPAMENTOS FOI SOLICITADA A QUANTIA DE US$ 16.210,00, SENDO US$ 12.510,00, NO CARTAO PRE-PAGO, VISA TRAVEL MONEY, E O RESTANTE US$ 3.700,00, EM ESPECIE, DESEMBOLSANDO A QUANTIA TOTAL DE R$ 54.385,79. ADUZ QUE AO CHEGAR EM UMA DAS LOJAS DA APPLE NO ESTADO AMERICANO DE OREGON, COMECOU A EFETUAR SUAS COMPRAS, CONTUDO, AO CHEGAR AO CAIXA PASSOU POR UM GRANDE VEXAME E HUMILHACAO, DIANTE A RECUSA DA NAO APROVACAO DO CARTAO PRE-PAGO. MENCIONA QUE FORAM VARIAS TENTATIVAS PARA TENTAR EFETUAR O PAGAMENTO, POREM TODAS INFRUTIFERAS. ALEGA QUE DIANTE A RECUSA DA RE, EM NAO RESOLVER A QUESTAO SOLICITADA, FOI OBRIGADO SACAR DURANTE VARIOS DIAS A QUANTIA US$ 1.000,00, PARA CONSEGUIR EFETUAR SUAS COMPRAS, ARCANDO AINDA COM AS TAXAS DE IOF. DISCORRE ACERCA DA APLICACAO DO CODIGO DE DEFESA DO CONSUMIDOR, BEM COMO DOS DANOS MORAIS E MATERIAIS, E DOS LUCROS CESSANTES ORA SOFRIDOS. TECE CONSIDERACOES ACERCA DA RESPONSABILIDADE OBJETIVA DA RE. DIANTE DISSO, POSTULA PELA CONDENACAO DA RE AO PAGAMENTO DE DANOS MORAIS E MATERIAS SUPORTADOS, BEM COMO DOS LUCROS CESSANTES SOFRIDOS. JUNTOU DOCUMENTOS (FLS. 30/74).DEVIDAMENTE CITADO AS (FLS. 88), O REQUERIDO OFERTOU CONTESTACAO (FLS. 90/96), E NO MERITO, ALEGOU A AUSENCIA DE QUALQUER ATO ILICITO PRATICADO, POIS DESTACAS QUE AS RECUSAS JAMAIS OCORRERAM POR AUSENCIA DE SALDO NO CARTAO DE VIAGEM DOS AUTORES, E SIM TAL NEGATIVA SE DEU EM QUESTAO DE FRAUDE NO MOMENTO DA TRANSACAO. ALEGA QUE NAO A QUALQUER EXISTENCIA DE DANOS MORAIS E MATERIAIS SUPORTADOS PELO AUTOR, BEM COMO NAO HAVER A EXISTENCIA DE LUCROS CESSANTES. POR FIM, POSTULA PELA IMPROCEDENCIA DA DEMANDA. JUNTOU DOCUMENTOS (FLS. 97/142). REPLICA (FLS. 146/167).E A SINTESE DO NECESSARIO.FUNDAMENTO E DECIDO.O FEITO COMPORTA JULGAMENTO ANTECIPADO NOS TERMOS DO ARTIGO 355, INCISO I DO CODIGO DE PROCESSO CIVIL, PORQUANTO A MATERIA EM COMENTO E DE DIREITO, SENDO QUE OS FATOS RELEVANTES JA SE ENCONTRAM COMPROVADOS DOCUMENTALMENTE.A PRELIMINAR DE ILEGITIMIDADE PASSIVA ARGUIDA PELA PARTE AUTORA, AS FLS. 175/176, NAO MERECE PROSPERAR, UMA VEZ QUE, MESMO QUE HAJA ALGUMA DIFERENCIA NA NOMENCLATURA NA SIGLA FINAL DO NOME DA EMPRESA, VERIFICA-SE QUE OS CNPJ SAO OS MESMO, PORTANTO, SE TRATA DE UMA UNICA PESSOA JURIDICA. SEM MAIS PRELIMINARES, PASSO A ANALISE DO MERITO. NO MERITO A PRETENSAO INICIAL E IMPROCEDENTETRATA-SE DE ACAO DE INDENIZACAO MATERIAL E MORAL CUMULADA COM LUCROS CESSANTES, EM QUE PRETENDE A PARTE AUTORA A CONDENACAO DA RE, REFERENTE A FALHA NA PRESTACAO DE SERVICOS, AO ALEGAR QUE, NAO CONSEGUIU UTILIZAR O SEU CARTAO DE CREDITO PARA A REALIZACAO DE COMPRAS DE EQUIPAMENTOS EM OUTRO PAIS. A PRIMEIRO MOMENTO, OBSERVO QUE A RELACAO JURIDICA ENTRE AS PARTES DEVE SER ANALISADA COM BASE NO CODIGO DE DEFESA DO CONSUMIDOR, TENDO EM VISTA QUE A PARTE AUTORA, AO CONTRATAR COM A EMPRESA REQUERIDA, ADQUIRIU SERVICO NA QUALIDADE DE DESTINATARIA FINAL (CDC, ART. 2, CAPUT).POIS BEM. SUSTENTA OS REQUERENTES, QUE TERIAM REALIZADO UMA VIAGEM PARA OS ESTADOS UNIDOS DA AMERICA, COM O INTUITO DE REALIZAR COMPRAS DE EQUIPAMENTOS PARA O DESENVOLVIMENTO DE SUA EMPRESA. CONTUDO, MENCIONAM QUE AO TENTAREM POR DIVERSAS VEZES EFETUAREM O PAGAMENTO COM O CARTAO PRE-PAGO FORNECIDO PELA EMPRESA RE, O MESMO FORA RECUSADO, AO QUAL ALTEROU TODA SUA LOGISTICA DE COMPRA, POIS TAL FATO ALTEROU O QUE TERIA SIDO PLANEJADO. TODAVIA, EM QUE PESE A NARRATIVA AUTORAL, E CERTO QUE SUAS ALEGACOES NAO MERECEM PREVALECER NO PRESENTE CASO, ISSO PORQUE, RELATA A RE QUE NAO AUTORIZOU A LIBERACAO DO PAGAMENTO COM CARTAO PRE-PAGO, POR SUPOSTOS MOTIVOS DE FRAUDE NO MOMENTO DE TRANSACAO. ADEMAIS, E IMPORTANTE RESSALTAR QUE TAL PROCEDIMENTO ACONTECE PARA EVITAR MAIORES TRANSTORNOS AO CLIENTE, POIS SE ENTENDE QUE ESSAS EMPRESAS POSSUEM UMA ALTA TECNOLOGIA CAPAZ DE GARANTIR A SEGURANCA DE SEUS PORTADORES. E NO MAIS, RESSALTO QUE NO PRESENTE CASO NAO VEJO QUE A EMPRESA, ORA RE, NAO AGIU DE FORMA DOLOSA, E SIM COM O INTUITO DE EVITAR MAIORES TRANSTORNOS AOS AUTORES. PORTANTO, MESMO DIANTE DE TAL MUDANCA, QUAL SERIA A LOGISTICA DE COMPRAS DOS AUTORES, PERCEBO QUE ESTES CONSEGUIRAM SEGUIR COM SUAS COMPRAS, MESMO QUE REALIZADAS DE FORMA DIVERSA, O OBJETIVO FINAL FORA ALCANCADA, QUAL SEJA, A REALIZACAO DA COMPRA DE SEUS EQUIPAMENTOS. SENDO ASSIM, EM ANALISE AOS AUTOS, NAO ENCONTRO QUALQUER ATO ILICITO PRATICADO PELA EMPRESA RE, NO ENTANTO, SOBRE OS LUCROS CESSANTE, E CERTO QUE TAL PEDIDO NAO MERECE ACOLHIMENTO, POIS NO PRESENTE NAO ENCONTRO FUNDAMENTOS QUE ALCANCE TAL PEDIDO. RESTA A QUESTAO DOS DANOS MORAIS E MATERIAS.COM RELACAO AO PEDIDO DE DANOS MORAIS E MATERIAIS, EM QUE PESE A PARTE AUTORA TENHA ALEGADO CONSTRANGIMENTO EM RAZAO DE NAO TER CONSIGO EFETUAR SUA COMPRAS, NAQUELE MOMENTO, OBSERVANDO OS QUE TAL CONDUTA NAO CONSEGUE ALCANCAR O DEVER DE INDENIZAR POR PARTE DA RE. DESTA FORMA, A MEDIDA QUE SE IMPOE E DE IMPROCEDENCIA DA DEMANDA.ANTE O EXPOSTO, JULGO IMPROCEDENTE A PRETENSAO INICIAL COM FUNDAMENTO NO ART. 487, I, CPC.CONDENO OS AUTORES AO PAGAMENTO DAS CUSTAS, DESPESAS PROCESSUAIS E HONORARIOS ADVOCATICIOS DO REU, QUE ARBITRO EM 10% DO VALOR DA CAUSA, TENDO EM VISTA OS ELEMENTOS BALIZADORES QUE CONSTAM NO ART. 85, 2 DO CODIGO DE PROCESSO CIVIL. P.R.I. ADVOGADOS(S): ALFREDO ZUCCA NETO (OAB 154694/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2018-05-14T00:00:00",
                    "CaptureDate": "2019-03-27T10:37:00"
                  },
                  {
                    "Content": "REMETIDO AO DJE | RELACAO: 0212/2018 TEOR DO ATO: VISTOS.RAFAEL CASTRO DE MATTOS E HUMMINGBIRD PRODUCT STUDIO EIRELLI HUMMINGBIRD AJUIZARAM ACAO DE INDENIZACAO POR DANOS MORAIS E MATERIAIS EM FACE COMPANHIA BRASILEIRA DE SOLUCOES E SERVICOS ALELO. ALEGANDO, EM SINTESE, QUE DIANTE DE UMA PROGRAMACAO PARA A REALIZACAO DE VIAGEM PARA O ESTADOS UNIDOS DA AMERICA, COM O INTUITO DE COMPRAR EQUIPAMENTOS PARA A SUA EMPRESA, CONTRATOU A EMPRESA RE PARA A COMPRA DE DOLARES AMERICANOS, ATRAVES DA CORRETORA SOCOPA. SEGUE NARRANDO QUE, PARA AS DESPESAS DE ESTADIA E COMPRA DE EQUIPAMENTOS FOI SOLICITADA A QUANTIA DE US$ 16.210,00, SENDO US$ 12.510,00, NO CARTAO PRE-PAGO, VISA TRAVEL MONEY, E O RESTANTE US$ 3.700,00, EM ESPECIE, DESEMBOLSANDO A QUANTIA TOTAL DE R$ 54.385,79. ADUZ QUE AO CHEGAR EM UMA DAS LOJAS DA APPLE NO ESTADO AMERICANO DE OREGON, COMECOU A EFETUAR SUAS COMPRAS, CONTUDO, AO CHEGAR AO CAIXA PASSOU POR UM GRANDE VEXAME E HUMILHACAO, DIANTE A RECUSA DA NAO APROVACAO DO CARTAO PRE-PAGO. MENCIONA QUE FORAM VARIAS TENTATIVAS PARA TENTAR EFETUAR O PAGAMENTO, POREM TODAS INFRUTIFERAS. ALEGA QUE DIANTE A RECUSA DA RE, EM NAO RESOLVER A QUESTAO SOLICITADA, FOI OBRIGADO SACAR DURANTE VARIOS DIAS A QUANTIA US$ 1.000,00, PARA CONSEGUIR EFETUAR SUAS COMPRAS, ARCANDO AINDA COM AS TAXAS DE IOF. DISCORRE ACERCA DA APLICACAO DO CODIGO DE DEFESA DO CONSUMIDOR, BEM COMO DOS DANOS MORAIS E MATERIAIS, E DOS LUCROS CESSANTES ORA SOFRIDOS. TECE CONSIDERACOES ACERCA DA RESPONSABILIDADE OBJETIVA DA RE. DIANTE DISSO, POSTULA PELA CONDENACAO DA RE AO PAGAMENTO DE DANOS MORAIS E MATERIAS SUPORTADOS, BEM COMO DOS LUCROS CESSANTES SOFRIDOS. JUNTOU DOCUMENTOS (FLS. 30/74).DEVIDAMENTE CITADO AS (FLS. 88), O REQUERIDO OFERTOU CONTESTACAO (FLS. 90/96), E NO MERITO, ALEGOU A AUSENCIA DE QUALQUER ATO ILICITO PRATICADO, POIS DESTACAS QUE AS RECUSAS JAMAIS OCORRERAM POR AUSENCIA DE SALDO NO CARTAO DE VIAGEM DOS AUTORES, E SIM TAL NEGATIVA SE DEU EM QUESTAO DE FRAUDE NO MOMENTO DA TRANSACAO. ALEGA QUE NAO A QUALQUER EXISTENCIA DE DANOS MORAIS E MATERIAIS SUPORTADOS PELO AUTOR, BEM COMO NAO HAVER A EXISTENCIA DE LUCROS CESSANTES. POR FIM, POSTULA PELA IMPROCEDENCIA DA DEMANDA. JUNTOU DOCUMENTOS (FLS. 97/142). REPLICA (FLS. 146/167).E A SINTESE DO NECESSARIO.FUNDAMENTO E DECIDO.O FEITO COMPORTA JULGAMENTO ANTECIPADO NOS TERMOS DO ARTIGO 355, INCISO I DO CODIGO DE PROCESSO CIVIL, PORQUANTO A MATERIA EM COMENTO E DE DIREITO, SENDO QUE OS FATOS RELEVANTES JA SE ENCONTRAM COMPROVADOS DOCUMENTALMENTE.A PRELIMINAR DE ILEGITIMIDADE PASSIVA ARGUIDA PELA PARTE AUTORA, AS FLS. 175/176, NAO MERECE PROSPERAR, UMA VEZ QUE, MESMO QUE HAJA ALGUMA DIFERENCIA NA NOMENCLATURA NA SIGLA FINAL DO NOME DA EMPRESA, VERIFICA-SE QUE OS CNPJ SAO OS MESMO, PORTANTO, SE TRATA DE UMA UNICA PESSOA JURIDICA. SEM MAIS PRELIMINARES, PASSO A ANALISE DO MERITO. NO MERITO A PRETENSAO INICIAL E IMPROCEDENTETRATA-SE DE ACAO DE INDENIZACAO MATERIAL E MORAL CUMULADA COM LUCROS CESSANTES, EM QUE PRETENDE A PARTE AUTORA A CONDENACAO DA RE, REFERENTE A FALHA NA PRESTACAO DE SERVICOS, AO ALEGAR QUE, NAO CONSEGUIU UTILIZAR O SEU CARTAO DE CREDITO PARA A REALIZACAO DE COMPRAS DE EQUIPAMENTOS EM OUTRO PAIS. A PRIMEIRO MOMENTO, OBSERVO QUE A RELACAO JURIDICA ENTRE AS PARTES DEVE SER ANALISADA COM BASE NO CODIGO DE DEFESA DO CONSUMIDOR, TENDO EM VISTA QUE A PARTE AUTORA, AO CONTRATAR COM A EMPRESA REQUERIDA, ADQUIRIU SERVICO NA QUALIDADE DE DESTINATARIA FINAL (CDC, ART. 2, CAPUT).POIS BEM. SUSTENTA OS REQUERENTES, QUE TERIAM REALIZADO UMA VIAGEM PARA OS ESTADOS UNIDOS DA AMERICA, COM O INTUITO DE REALIZAR COMPRAS DE EQUIPAMENTOS PARA O DESENVOLVIMENTO DE SUA EMPRESA. CONTUDO, MENCIONAM QUE AO TENTAREM POR DIVERSAS VEZES EFETUAREM O PAGAMENTO COM O CARTAO PRE-PAGO FORNECIDO PELA EMPRESA RE, O MESMO FORA RECUSADO, AO QUAL ALTEROU TODA SUA LOGISTICA DE COMPRA, POIS TAL FATO ALTEROU O QUE TERIA SIDO PLANEJADO. TODAVIA, EM QUE PESE A NARRATIVA AUTORAL, E CERTO QUE SUAS ALEGACOES NAO MERECEM PREVALECER NO PRESENTE CASO, ISSO PORQUE, RELATA A RE QUE NAO AUTORIZOU A LIBERACAO DO PAGAMENTO COM CARTAO PRE-PAGO, POR SUPOSTOS MOTIVOS DE FRAUDE NO MOMENTO DE TRANSACAO. ADEMAIS, E IMPORTANTE RESSALTAR QUE TAL PROCEDIMENTO ACONTECE PARA EVITAR MAIORES TRANSTORNOS AO CLIENTE, POIS SE ENTENDE QUE ESSAS EMPRESAS POSSUEM UMA ALTA TECNOLOGIA CAPAZ DE GARANTIR A SEGURANCA DE SEUS PORTADORES. E NO MAIS, RESSALTO QUE NO PRESENTE CASO NAO VEJO QUE A EMPRESA, ORA RE, NAO AGIU DE FORMA DOLOSA, E SIM COM O INTUITO DE EVITAR MAIORES TRANSTORNOS AOS AUTORES. PORTANTO, MESMO DIANTE DE TAL MUDANCA, QUAL SERIA A LOGISTICA DE COMPRAS DOS AUTORES, PERCEBO QUE ESTES CONSEGUIRAM SEGUIR COM SUAS COMPRAS, MESMO QUE REALIZADAS DE FORMA DIVERSA, O OBJETIVO FINAL FORA ALCANCADA, QUAL SEJA, A REALIZACAO DA COMPRA DE SEUS EQUIPAMENTOS. SENDO ASSIM, EM ANALISE AOS AUTOS, NAO ENCONTRO QUALQUER ATO ILICITO PRATICADO PELA EMPRESA RE, NO ENTANTO, SOBRE OS LUCROS CESSANTE, E CERTO QUE TAL PEDIDO NAO MERECE ACOLHIMENTO, POIS NO PRESENTE NAO ENCONTRO FUNDAMENTOS QUE ALCANCE TAL PEDIDO. RESTA A QUESTAO DOS DANOS MORAIS E MATERIAS.COM RELACAO AO PEDIDO DE DANOS MORAIS E MATERIAIS, EM QUE PESE A PARTE AUTORA TENHA ALEGADO CONSTRANGIMENTO EM RAZAO DE NAO TER CONSIGO EFETUAR SUA COMPRAS, NAQUELE MOMENTO, OBSERVANDO OS QUE TAL CONDUTA NAO CONSEGUE ALCANCAR O DEVER DE INDENIZAR POR PARTE DA RE. DESTA FORMA, A MEDIDA QUE SE IMPOE E DE IMPROCEDENCIA DA DEMANDA.ANTE O EXPOSTO, JULGO IMPROCEDENTE A PRETENSAO INICIAL COM FUNDAMENTO NO ART. 487, I, CPC.CONDENO OS AUTORES AO PAGAMENTO DAS CUSTAS, DESPESAS PROCESSUAIS E HONORARIOS ADVOCATICIOS DO REU, QUE ARBITRO EM 10% DO VALOR DA CAUSA, TENDO EM VISTA OS ELEMENTOS BALIZADORES QUE CONSTAM NO ART. 85, 2 DO CODIGO DE PROCESSO CIVIL. P.R.I. ADVOGADOS(S): ALFREDO ZUCCA NETO (OAB 154694/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2018-05-14T00:00:00",
                    "CaptureDate": "2021-07-04T23:31:55"
                  },
                  {
                    "Content": "FLS. 177 TRIBUNAL DE JUSTICA DO ESTADO DE SAO PAULO COMARCA DE SAO PAULO FORO CENTRAL CIVEL 12 VARA CIVEL PRACA JOAO MENDES S/N, SAO PAULO - SP - CEP 01501-900 HORARIO DE ATENDIMENTO AO PUBLICO: DAS 12H30MIN AS19H00MIN SENTENCA PROCESSO DIGITAL N: 1000744-42.2018.8.26.0100 CLASSE - ASSUNTO PROCEDIMENTO COMUM - INDENIZACAO POR DANO MORAL REQUERENTE: RAFAEL CASTRO DE MATOS. E OUTRO REQUERIDO: COMPANHIA BRASILEIRA DE SOLUCOES E SERVICOS S.A. (ALELO) JUIZ DE DIREITO: DR. FERNANDO JOSE CUNICO VISTOS. RAFAEL CASTRO DE MATTOS E HUMMINGBIRD PRODUCT STUDIO EIRELLI HUMMINGBIRD AJUIZARAM ACAO DE INDENIZACAO POR DANOS MORAIS E MATERIAIS EM FACE COMPANHIA BRASILEIRA DE SOLUCOES E SERVICOS ALELO. ALEGANDO, EM SINTESE, QUE DIANTE DE UMA PROGRAMACAO PARA A REALIZACAO DE VIAGEM PARA O ESTADOS UNIDOS DA AMERICA, COM O INTUITO DE COMPRAR EQUIPAMENTOS PARA A SUA EMPRESA, CONTRATOU A EMPRESA RE PARA A COMPRA DE DOLARES AMERICANOS, ATRAVES DA CORRETORA SOCOPA. SEGUE NARRANDO QUE, PARA AS DESPESAS DE ESTADIA E COMPRA DE EQUIPAMENTOS FOI SOLICITADA A QUANTIA DE US$ 16.210,00, SENDO US$ 12.510,00, NO CARTAO PRE-PAGO, VISA TRAVEL MONEY, E O RESTANTE US$ 3.700,00, EM ESPECIE, DESEMBOLSANDO A QUANTIA TOTAL DE R$ 54.385,79. ADUZ QUE AO CHEGAR EM UMA DAS LOJAS DA APPLE NO ESTADO AMERICANO DE OREGON, COMECOU A EFETUAR SUAS COMPRAS, CONTUDO, AO CHEGAR AO CAIXA PASSOU POR UM GRANDE VEXAME E HUMILHACAO, DIANTE A RECUSA DA NAO APROVACAO DO CARTAO PRE-PAGO. MENCIONA QUE FORAM VARIAS TENTATIVAS PARA TENTAR EFETUAR O PAGAMENTO, POREM TODAS INFRUTIFERAS. ALEGA QUE DIANTE A RECUSA DA RE, EM NAO RESOLVER A QUESTAO SOLICITADA, FOI OBRIGADO SACAR DURANTE VARIOS DIAS A QUANTIA US$ 1.000,00, PARA CONSEGUIR EFETUAR SUAS COMPRAS, ARCANDO AINDA COM AS TAXAS DE IOF. DISCORRE ACERCA DA APLICACAO DO CODIGO DE DEFESA DO CONSUMIDOR, BEM COMO DOS DANOS MORAIS E 1000744-42.2018.8.26.0100 - LAUDA 1 ESTE DOCUMENTO E COPIA DO ORIGINAL, ASSINADO DIGITALMENTE POR FERNANDO JOSE CUNICO, LIBERADO NOS AUTOS EM 11/05/2018 AS 17:21 . PARA CONFERIR O ORIGINAL, ACESSE SITE HTTPS://ESAJ.TJSP.JUS.BR/PASTADIGITAL/PG/ABRIRCONFERENCIADOCUMENTO.DO, INFORME PROCESSO 1000744-42.2018.8.26.0100 E CODIGO 44BCF74. FLS. 178 TRIBUNAL DE JUSTICA DO ESTADO DE SAO PAULO COMARCA DE SAO PAULO FORO CENTRAL CIVEL 12 VARA CIVEL PRACA JOAO MENDES S/N, SAO PAULO - SP - CEP 01501-900 HORARIO DE ATENDIMENTO AO PUBLICO: DAS 12H30MIN AS19H00MIN MATERIAIS, E DOS LUCROS CESSANTES ORA SOFRIDOS. TECE CONSIDERACOES ACERCA DA RESPONSABILIDADE OBJETIVA DA RE. DIANTE DISSO, POSTULA PELA CONDENACAO DA RE AO PAGAMENTO DE DANOS MORAIS E MATERIAS SUPORTADOS, BEM COMO DOS LUCROS CESSANTES SOFRIDOS. JUNTOU DOCUMENTOS (FLS. 30/74). DEVIDAMENTE CITADO AS (FLS. 88), O REQUERIDO OFERTOU CONTESTACAO (FLS. 90/96), E NO MERITO, ALEGOU A AUSENCIA DE QUALQUER ATO ILICITO PRATICADO, POIS DESTACAS QUE AS RECUSAS JAMAIS OCORRERAM POR AUSENCIA DE SALDO NO CARTAO DE VIAGEM DOS AUTORES, E SIM TAL NEGATIVA SE DEU EM QUESTAO DE FRAUDE NO MOMENTO DA TRANSACAO. ALEGA QUE NAO A QUALQUER EXISTENCIA DE DANOS MORAIS E MATERIAIS SUPORTADOS PELO AUTOR, BEM COMO NAO HAVER A EXISTENCIA DE LUCROS CESSANTES. POR FIM, POSTULA PELA IMPROCEDENCIA DA DEMANDA. JUNTOU DOCUMENTOS (FLS. 97/142). REPLICA (FLS. 146/167). E A SINTESE DO NECESSARIO. FUNDAMENTO E DECIDO. O FEITO COMPORTA JULGAMENTO ANTECIPADO NOS TERMOS DO ARTIGO 355, INCISO I DO CODIGO DE PROCESSO CIVIL, PORQUANTO A MATERIA EM COMENTO E DE DIREITO, SENDO QUE OS FATOS RELEVANTES JA SE ENCONTRAM COMPROVADOS DOCUMENTALMENTE. A PRELIMINAR DE ILEGITIMIDADE PASSIVA ARGUIDA PELA PARTE AUTORA, AS FLS. 175/176, NAO MERECE PROSPERAR, UMA VEZ QUE, MESMO QUE HAJA ALGUMA DIFERENCIA NA NOMENCLATURA NA SIGLA FINAL DO NOME DA EMPRESA, VERIFICA-SE QUE OS CNPJ SAO OS MESMO, PORTANTO, SE TRATA DE UMA UNICA PESSOA JURIDICA. SEM MAIS PRELIMINARES, PASSO A ANALISE DO MERITO. NO MERITO A PRETENSAO INICIAL E IMPROCEDENTE TRATA-SE DE ACAO DE INDENIZACAO MATERIAL E MORAL CUMULADA COM LUCROS CESSANTES, EM QUE PRETENDE A PARTE AUTORA A CONDENACAO DA RE, REFERENTE A FALHA NA PRESTACAO DE SERVICOS, AO ALEGAR QUE, NAO CONSEGUIU UTILIZAR O SEU CARTAO DE CREDITO PARA A REALIZACAO DE COMPRAS DE EQUIPAMENTOS EM OUTRO PAIS. A PRIMEIRO MOMENTO, OBSERVO QUE A RELACAO JURIDICA ENTRE AS PARTES DEVE SER ANALISADA COM BASE NO CODIGO DE DEFESA DO CONSUMIDOR, TENDO EM VISTA QUE A PARTE AUTORA, AO CONTRATAR COM A EMPRESA REQUERIDA, ADQUIRIU SERVICO NA QUALIDADE DE DESTINATARIA FINAL (CDC, ART. 2, CAPUT). POIS BEM. SUSTENTA OS REQUERENTES, QUE TERIAM REALIZADO UMA 1000744-42.2018.8.26.0100 - LAUDA 2 ESTE DOCUMENTO E COPIA DO ORIGINAL, ASSINADO DIGITALMENTE POR FERNANDO JOSE CUNICO, LIBERADO NOS AUTOS EM 11/05/2018 AS 17:21 . PARA CONFERIR O ORIGINAL, ACESSE SITE HTTPS://ESAJ.TJSP.JUS.BR/PASTADIGITAL/PG/ABRIRCONFERENCIADOCUMENTO.DO, INFORME PROCESSO 1000744-42.2018.8.26.0100 E CODIGO 44BCF74. FLS. 179 TRIBUNAL DE JUSTICA DO ESTADO DE SAO PAULO COMARCA DE SAO PAULO FORO CENTRAL CIVEL 12 VARA CIVEL PRACA JOAO MENDES S/N, SAO PAULO - SP - CEP 01501-900 HORARIO DE ATENDIMENTO AO PUBLICO: DAS 12H30MIN AS19H00MIN VIAGEM PARA OS ESTADOS UNIDOS DA AMERICA, COM O INTUITO DE REALIZAR COMPRAS DE EQUIPAMENTOS PARA O DESENVOLVIMENTO DE SUA EMPRESA. CONTUDO, MENCIONAM QUE AO TENTAREM POR DIVERSAS VEZES EFETUAREM O PAGAMENTO COM O CARTAO PRE-PAGO FORNECIDO PELA EMPRESA RE, O MESMO FORA RECUSADO, AO QUAL ALTEROU TODA SUA LOGISTICA DE COMPRA, POIS TAL FATO ALTEROU O QUE TERIA SIDO PLANEJADO. TODAVIA, EM QUE PESE A NARRATIVA AUTORAL, E CERTO QUE SUAS ALEGACOES NAO MERECEM PREVALECER NO PRESENTE CASO, ISSO PORQUE, RELATA A RE QUE NAO AUTORIZOU A LIBERACAO DO PAGAMENTO COM CARTAO PRE-PAGO, POR SUPOSTOS MOTIVOS DE FRAUDE NO MOMENTO DE TRANSACAO. ADEMAIS, E IMPORTANTE RESSALTAR QUE TAL PROCEDIMENTO ACONTECE PARA EVITAR MAIORES TRANSTORNOS AO CLIENTE, POIS SE ENTENDE QUE ESSAS EMPRESAS POSSUEM UMA ALTA TECNOLOGIA CAPAZ DE GARANTIR A SEGURANCA DE SEUS PORTADORES. E NO MAIS, RESSALTO QUE NO PRESENTE CASO NAO VEJO QUE A EMPRESA, ORA RE, NAO AGIU DE FORMA DOLOSA, E SIM COM O INTUITO DE EVITAR MAIORES TRANSTORNOS AOS AUTORES. PORTANTO, MESMO DIANTE DE TAL MUDANCA, QUAL SERIA A LOGISTICA DE COMPRAS DOS AUTORES, PERCEBO QUE ESTES CONSEGUIRAM SEGUIR COM SUAS COMPRAS, MESMO QUE REALIZADAS DE FORMA DIVERSA, O OBJETIVO FINAL FORA ALCANCADA, QUAL SEJA, A REALIZACAO DA COMPRA DE SEUS EQUIPAMENTOS. SENDO ASSIM, EM ANALISE AOS AUTOS, NAO ENCONTRO QUALQUER ATO ILICITO PRATICADO PELA EMPRESA RE, NO ENTANTO, SOBRE OS LUCROS CESSANTE, E CERTO QUE TAL PEDIDO NAO MERECE ACOLHIMENTO, POIS NO PRESENTE NAO ENCONTRO FUNDAMENTOS QUE ALCANCE TAL PEDIDO. RESTA A QUESTAO DOS DANOS MORAIS E MATERIAS. COM RELACAO AO PEDIDO DE DANOS MORAIS E MATERIAIS, EM QUE PESE A PARTE AUTORA TENHA ALEGADO CONSTRANGIMENTO EM RAZAO DE NAO TER CONSIGO EFETUAR SUA COMPRAS, NAQUELE MOMENTO, OBSERVANDO OS QUE TAL CONDUTA NAO CONSEGUE ALCANCAR O DEVER DE INDENIZAR POR PARTE DA RE. DESTA FORMA, A MEDIDA QUE SE IMPOE E DE IMPROCEDENCIA DA DEMANDA. ANTE O EXPOSTO, JULGO IMPROCEDENTE A PRETENSAO INICIAL COM FUNDAMENTO NO ART. 487, I, CPC. 1000744-42.2018.8.26.0100 - LAUDA 3 ESTE DOCUMENTO E COPIA DO ORIGINAL, ASSINADO DIGITALMENTE POR FERNANDO JOSE CUNICO, LIBERADO NOS AUTOS EM 11/05/2018 AS 17:21 . PARA CONFERIR O ORIGINAL, ACESSE SITE HTTPS://ESAJ.TJSP.JUS.BR/PASTADIGITAL/PG/ABRIRCONFERENCIADOCUMENTO.DO, INFORME PROCESSO 1000744-42.2018.8.26.0100 E CODIGO 44BCF74. FLS. 180 TRIBUNAL DE JUSTICA DO ESTADO DE SAO PAULO COMARCA DE SAO PAULO FORO CENTRAL CIVEL 12 VARA CIVEL PRACA JOAO MENDES S/N, SAO PAULO - SP - CEP 01501-900 HORARIO DE ATENDIMENTO AO PUBLICO: DAS 12H30MIN AS19H00MIN CONDENO OS AUTORES AO PAGAMENTO DAS CUSTAS, DESPESAS PROCESSUAIS E HONORARIOS ADVOCATICIOS DO REU, QUE ARBITRO EM 10% DO VALOR DA CAUSA, TENDO EM VISTA OS ELEMENTOS BALIZADORES QUE CONSTAM NO ART. 85, 2 DO CODIGO DE PROCESSO CIVIL. P.R.I. SAO PAULO, 10 DE MAIO DE 2018. DOCUMENTO ASSINADO DIGITALMENTE NOS TERMOS DA LEI 11.419/2006, CONFORME IMPRESSAO A MARGEM DIREITA 1000744-42.2018.8.26.0100 - LAUDA 4 ESTE DOCUMENTO E COPIA DO ORIGINAL, ASSINADO DIGITALMENTE POR FERNANDO JOSE CUNICO, LIBERADO NOS AUTOS EM 11/05/2018 AS 17:21 . PARA CONFERIR O ORIGINAL, ACESSE SITE HTTPS://ESAJ.TJSP.JUS.BR/PASTADIGITAL/PG/ABRIRCONFERENCIADOCUMENTO.DO, INFORME PROCESSO 1000744-42.2018.8.26.0100 E CODIGO 44BCF74.",
                    "PublishDate": "2018-05-11T00:00:00",
                    "CaptureDate": "2019-03-27T10:36:42"
                  },
                  {
                    "Content": "CONCLUSOS PARA SENTENCA",
                    "PublishDate": "2018-05-11T00:00:00",
                    "CaptureDate": "2019-03-27T10:36:42"
                  },
                  {
                    "Content": "JULGADA IMPROCEDENTE A ACAO | VISTOS.RAFAEL CASTRO DE MATTOS E HUMMINGBIRD PRODUCT STUDIO EIRELLI HUMMINGBIRD AJUIZARAM ACAO DE INDENIZACAO POR DANOS MORAIS E MATERIAIS EM FACE COMPANHIA BRASILEIRA DE SOLUCOES E SERVICOS ALELO. ALEGANDO, EM SINTESE, QUE DIANTE DE UMA PROGRAMACAO PARA A REALIZACAO DE VIAGEM PARA O ESTADOS UNIDOS DA AMERICA, COM O INTUITO DE COMPRAR EQUIPAMENTOS PARA A SUA EMPRESA, CONTRATOU A EMPRESA RE PARA A COMPRA DE DOLARES AMERICANOS, ATRAVES DA CORRETORA SOCOPA. SEGUE NARRANDO QUE, PARA AS DESPESAS DE ESTADIA E COMPRA DE EQUIPAMENTOS FOI SOLICITADA A QUANTIA DE US$ 16.210,00, SENDO US$ 12.510,00, NO CARTAO PRE-PAGO, VISA TRAVEL MONEY, E O RESTANTE US$ 3.700,00, EM ESPECIE, DESEMBOLSANDO A QUANTIA TOTAL DE R$ 54.385,79. ADUZ QUE AO CHEGAR EM UMA DAS LOJAS DA APPLE NO ESTADO AMERICANO DE OREGON, COMECOU A EFETUAR SUAS COMPRAS, CONTUDO, AO CHEGAR AO CAIXA PASSOU POR UM GRANDE VEXAME E HUMILHACAO, DIANTE A RECUSA DA NAO APROVACAO DO CARTAO PRE-PAGO. MENCIONA QUE FORAM VARIAS TENTATIVAS PARA TENTAR EFETUAR O PAGAMENTO, POREM TODAS INFRUTIFERAS. ALEGA QUE DIANTE A RECUSA DA RE, EM NAO RESOLVER A QUESTAO SOLICITADA, FOI OBRIGADO SACAR DURANTE VARIOS DIAS A QUANTIA US$ 1.000,00, PARA CONSEGUIR EFETUAR SUAS COMPRAS, ARCANDO AINDA COM AS TAXAS DE IOF. DISCORRE ACERCA DA APLICACAO DO CODIGO DE DEFESA DO CONSUMIDOR, BEM COMO DOS DANOS MORAIS E MATERIAIS, E DOS LUCROS CESSANTES ORA SOFRIDOS. TECE CONSIDERACOES ACERCA DA RESPONSABILIDADE OBJETIVA DA RE. DIANTE DISSO, POSTULA PELA CONDENACAO DA RE AO PAGAMENTO DE DANOS MORAIS E MATERIAS SUPORTADOS, BEM COMO DOS LUCROS CESSANTES SOFRIDOS. JUNTOU DOCUMENTOS (FLS. 30/74).DEVIDAMENTE CITADO AS (FLS. 88), O REQUERIDO OFERTOU CONTESTACAO (FLS. 90/96), E NO MERITO, ALEGOU A AUSENCIA DE QUALQUER ATO ILICITO PRATICADO, POIS DESTACAS QUE AS RECUSAS JAMAIS OCORRERAM POR AUSENCIA DE SALDO NO CARTAO DE VIAGEM DOS AUTORES, E SIM TAL NEGATIVA SE DEU EM QUESTAO DE FRAUDE NO MOMENTO DA TRANSACAO. ALEGA QUE NAO A QUALQUER EXISTENCIA DE DANOS MORAIS E MATERIAIS SUPORTADOS PELO AUTOR, BEM COMO NAO HAVER A EXISTENCIA DE LUCROS CESSANTES. POR FIM, POSTULA PELA IMPROCEDENCIA DA DEMANDA. JUNTOU DOCUMENTOS (FLS. 97/142). REPLICA (FLS. 146/167).E A SINTESE DO NECESSARIO.FUNDAMENTO E DECIDO.O FEITO COMPORTA JULGAMENTO ANTECIPADO NOS TERMOS DO ARTIGO 355, INCISO I DO CODIGO DE PROCESSO CIVIL, PORQUANTO A MATERIA EM COMENTO E DE DIREITO, SENDO QUE OS FATOS RELEVANTES JA SE ENCONTRAM COMPROVADOS DOCUMENTALMENTE.A PRELIMINAR DE ILEGITIMIDADE PASSIVA ARGUIDA PELA PARTE AUTORA, AS FLS. 175/176, NAO MERECE PROSPERAR, UMA VEZ QUE, MESMO QUE HAJA ALGUMA DIFERENCIA NA NOMENCLATURA NA SIGLA FINAL DO NOME DA EMPRESA, VERIFICA-SE QUE OS CNPJ SAO OS MESMO, PORTANTO, SE TRATA DE UMA UNICA PESSOA JURIDICA. SEM MAIS PRELIMINARES, PASSO A ANALISE DO MERITO. NO MERITO A PRETENSAO INICIAL E IMPROCEDENTETRATA-SE DE ACAO DE INDENIZACAO MATERIAL E MORAL CUMULADA COM LUCROS CESSANTES, EM QUE PRETENDE A PARTE AUTORA A CONDENACAO DA RE, REFERENTE A FALHA NA PRESTACAO DE SERVICOS, AO ALEGAR QUE, NAO CONSEGUIU UTILIZAR O SEU CARTAO DE CREDITO PARA A REALIZACAO DE COMPRAS DE EQUIPAMENTOS EM OUTRO PAIS. A PRIMEIRO MOMENTO, OBSERVO QUE A RELACAO JURIDICA ENTRE AS PARTES DEVE SER ANALISADA COM BASE NO CODIGO DE DEFESA DO CONSUMIDOR, TENDO EM VISTA QUE A PARTE AUTORA, AO CONTRATAR COM A EMPRESA REQUERIDA, ADQUIRIU SERVICO NA QUALIDADE DE DESTINATARIA FINAL (CDC, ART. 2, CAPUT).POIS BEM. SUSTENTA OS REQUERENTES, QUE TERIAM REALIZADO UMA VIAGEM PARA OS ESTADOS UNIDOS DA AMERICA, COM O INTUITO DE REALIZAR COMPRAS DE EQUIPAMENTOS PARA O DESENVOLVIMENTO DE SUA EMPRESA. CONTUDO, MENCIONAM QUE AO TENTAREM POR DIVERSAS VEZES EFETUAREM O PAGAMENTO COM O CARTAO PRE-PAGO FORNECIDO PELA EMPRESA RE, O MESMO FORA RECUSADO, AO QUAL ALTEROU TODA SUA LOGISTICA DE COMPRA, POIS TAL FATO ALTEROU O QUE TERIA SIDO PLANEJADO. TODAVIA, EM QUE PESE A NARRATIVA AUTORAL, E CERTO QUE SUAS ALEGACOES NAO MERECEM PREVALECER NO PRESENTE CASO, ISSO PORQUE, RELATA A RE QUE NAO AUTORIZOU A LIBERACAO DO PAGAMENTO COM CARTAO PRE-PAGO, POR SUPOSTOS MOTIVOS DE FRAUDE NO MOMENTO DE TRANSACAO. ADEMAIS, E IMPORTANTE RESSALTAR QUE TAL PROCEDIMENTO ACONTECE PARA EVITAR MAIORES TRANSTORNOS AO CLIENTE, POIS SE ENTENDE QUE ESSAS EMPRESAS POSSUEM UMA ALTA TECNOLOGIA CAPAZ DE GARANTIR A SEGURANCA DE SEUS PORTADORES. E NO MAIS, RESSALTO QUE NO PRESENTE CASO NAO VEJO QUE A EMPRESA, ORA RE, NAO AGIU DE FORMA DOLOSA, E SIM COM O INTUITO DE EVITAR MAIORES TRANSTORNOS AOS AUTORES. PORTANTO, MESMO DIANTE DE TAL MUDANCA, QUAL SERIA A LOGISTICA DE COMPRAS DOS AUTORES, PERCEBO QUE ESTES CONSEGUIRAM SEGUIR COM SUAS COMPRAS, MESMO QUE REALIZADAS DE FORMA DIVERSA, O OBJETIVO FINAL FORA ALCANCADA, QUAL SEJA, A REALIZACAO DA COMPRA DE SEUS EQUIPAMENTOS. SENDO ASSIM, EM ANALISE AOS AUTOS, NAO ENCONTRO QUALQUER ATO ILICITO PRATICADO PELA EMPRESA RE, NO ENTANTO, SOBRE OS LUCROS CESSANTE, E CERTO QUE TAL PEDIDO NAO MERECE ACOLHIMENTO, POIS NO PRESENTE NAO ENCONTRO FUNDAMENTOS QUE ALCANCE TAL PEDIDO. RESTA A QUESTAO DOS DANOS MORAIS E MATERIAS.COM RELACAO AO PEDIDO DE DANOS MORAIS E MATERIAIS, EM QUE PESE A PARTE AUTORA TENHA ALEGADO CONSTRANGIMENTO EM RAZAO DE NAO TER CONSIGO EFETUAR SUA COMPRAS, NAQUELE MOMENTO, OBSERVANDO OS QUE TAL CONDUTA NAO CONSEGUE ALCANCAR O DEVER DE INDENIZAR POR PARTE DA RE. DESTA FORMA, A MEDIDA QUE SE IMPOE E DE IMPROCEDENCIA DA DEMANDA.ANTE O EXPOSTO, JULGO IMPROCEDENTE A PRETENSAO INICIAL COM FUNDAMENTO NO ART. 487, I, CPC.CONDENO OS AUTORES AO PAGAMENTO DAS CUSTAS, DESPESAS PROCESSUAIS E HONORARIOS ADVOCATICIOS DO REU, QUE ARBITRO EM 10% DO VALOR DA CAUSA, TENDO EM VISTA OS ELEMENTOS BALIZADORES QUE CONSTAM NO ART. 85, 2 DO CODIGO DE PROCESSO CIVIL. P.R.I.",
                    "PublishDate": "2018-05-11T00:00:00",
                    "CaptureDate": "2021-07-04T23:31:55"
                  },
                  {
                    "Content": "CONCLUSOS PARA SENTENCA",
                    "PublishDate": "2018-05-11T00:00:00",
                    "CaptureDate": "2021-07-04T23:31:55"
                  },
                  {
                    "Content": "REPLICA JUNTADA N PROTOCOLO: WJMJ.18.40516706-4 TIPO DA PETICAO: MANIFESTACAO SOBRE A CONTESTACAO DATA: 01/05/2018 13:31",
                    "PublishDate": "2018-05-01T00:00:00",
                    "CaptureDate": "2019-03-27T10:36:42"
                  },
                  {
                    "Content": "ESPECIFICACAO DE PROVAS JUNTADA N PROTOCOLO: WJMJ.18.40516924-5 TIPO DA PETICAO: INDICACAO DE PROVAS DATA: 01/05/2018 20:34",
                    "PublishDate": "2018-05-01T00:00:00",
                    "CaptureDate": "2019-03-27T10:36:42"
                  },
                  {
                    "Content": "ESPECIFICACAO DE PROVAS JUNTADA | N PROTOCOLO: WJMJ.18.40516924-5 TIPO DA PETICAO: INDICACAO DE PROVAS DATA: 01/05/2018 20:34",
                    "PublishDate": "2018-05-01T00:00:00",
                    "CaptureDate": "2021-07-04T23:31:55"
                  },
                  {
                    "Content": "REPLICA JUNTADA | N PROTOCOLO: WJMJ.18.40516706-4 TIPO DA PETICAO: MANIFESTACAO SOBRE A CONTESTACAO DATA: 01/05/2018 13:31",
                    "PublishDate": "2018-05-01T00:00:00",
                    "CaptureDate": "2021-07-04T23:31:55"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0148/2018 DATA DA DISPONIBILIZACAO: 05/04/2018 DATA DA PUBLICACAO: 06/04/2018 NUMERO DO DIARIO: 2549 PAGINA: 264/272",
                    "PublishDate": "2018-04-05T00:00:00",
                    "CaptureDate": "2019-03-27T10:36:42"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0148/2018 DATA DA DISPONIBILIZACAO: 05/04/2018 DATA DA PUBLICACAO: 06/04/2018 NUMERO DO DIARIO: 2549 PAGINA: 264/272",
                    "PublishDate": "2018-04-05T00:00:00",
                    "CaptureDate": "2021-07-04T23:31:55"
                  },
                  {
                    "Content": "REMETIDO AO DJE RELACAO: 0148/2018 TEOR DO ATO: VISTOS.MANIFESTE-SE A PARTE AUTORA EM REPLICA, TENDO EM VISTA A CONTESTACAO APRESENTADA.INTIME-SE. ADVOGADOS(S): ALFREDO ZUCCA NETO (OAB 154694/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2018-04-04T00:00:00",
                    "CaptureDate": "2019-03-27T10:36:42"
                  },
                  {
                    "Content": "REMETIDO AO DJE | RELACAO: 0148/2018 TEOR DO ATO: VISTOS.MANIFESTE-SE A PARTE AUTORA EM REPLICA, TENDO EM VISTA A CONTESTACAO APRESENTADA.INTIME-SE. ADVOGADOS(S): ALFREDO ZUCCA NETO (OAB 154694/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2018-04-04T00:00:00",
                    "CaptureDate": "2021-07-04T23:31:55"
                  },
                  {
                    "Content": "FLS. 143 TRIBUNAL DE JUSTICA DO ESTADO DE SAO PAULO COMARCA DE SAO PAULO FORO CENTRAL CIVEL 12 VARA CIVEL PRACA JOAO MENDES S/N, 8 ANDAR - SALAS N 805/807, CENTRO - CEP 01501- 900, FONE: 21716121, SAO PAULO-SP - E-MAIL: SP12CV@TJSP.JUS.BR HORARIO DE ATENDIMENTO AO PUBLICO: DAS 12H30MIN AS19H00MIN DECISAO PROCESSO DIGITAL N: 1000744-42.2018.8.26.0100 CLASSE - ASSUNTO PROCEDIMENTO COMUM - INDENIZACAO POR DANO MORAL REQUERENTE: RAFAEL CASTRO DE MATOS. E OUTRO REQUERIDO: COMPANHIA BRASILEIRA DE SOLUCOES E SERVICOS S.A. (ALELO) JUIZ DE DIREITO: DR. FERNANDO JOSE CUNICO VISTOS. MANIFESTE-SE A PARTE AUTORA EM REPLICA, TENDO EM VISTA A CONTESTACAO APRESENTADA. INTIME-SE. SAO PAULO, 02 DE ABRIL DE 2018. DOCUMENTO ASSINADO DIGITALMENTE NOS TERMOS DA LEI 11.419/2006, CONFORME IMPRESSAO A MARGEM DIREITA ESTE DOCUMENTO E COPIA DO ORIGINAL, ASSINADO DIGITALMENTE POR FERNANDO JOSE CUNICO, LIBERADO NOS AUTOS EM 03/04/2018 AS 14:56 . PARA CONFERIR O ORIGINAL, ACESSE SITE HTTPS://ESAJ.TJSP.JUS.BR/PASTADIGITAL/PG/ABRIRCONFERENCIADOCUMENTO.DO, INFORME PROCESSO 1000744-42.2018.8.26.0100 E CODIGO 41FDE2C.",
                    "PublishDate": "2018-04-03T00:00:00",
                    "CaptureDate": "2019-03-27T10:36:27"
                  },
                  {
                    "Content": "DECISAO | VISTOS.MANIFESTE-SE A PARTE AUTORA EM REPLICA, TENDO EM VISTA A CONTESTACAO APRESENTADA.INTIME-SE.",
                    "PublishDate": "2018-04-03T00:00:00",
                    "CaptureDate": "2021-07-04T23:31:55"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO",
                    "PublishDate": "2018-04-02T00:00:00",
                    "CaptureDate": "2019-03-27T10:36:27"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0005/2018 DATA DA DISPONIBILIZACAO: 23/01/2018 DATA DA PUBLICACAO: 24/01/2018 NUMERO DO DIARIO: 2503 PAGINA: 553/560",
                    "PublishDate": "2018-03-06T00:00:00",
                    "CaptureDate": "2019-03-27T10:36:27"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0005/2018 DATA DA DISPONIBILIZACAO: 23/01/2018 DATA DA PUBLICACAO: 24/01/2018 NUMERO DO DIARIO: 2503 PAGINA: 553/560",
                    "PublishDate": "2018-03-06T00:00:00",
                    "CaptureDate": "2021-07-04T23:31:55"
                  },
                  {
                    "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.18.40137136-8 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 15/02/2018 14:06",
                    "PublishDate": "2018-02-15T00:00:00",
                    "CaptureDate": "2019-03-27T10:36:27"
                  },
                  {
                    "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.18.40137136-8 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 15/02/2018 14:06",
                    "PublishDate": "2018-02-15T00:00:00",
                    "CaptureDate": "2021-07-04T23:31:55"
                  },
                  {
                    "Content": "AR POSITIVO JUNTADO JUNTADA DE AR : AR751068712TJ SITUACAO : CUMPRIDO MODELO : PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC DESTINATARIO : COMPANHIA BRASILEIRA DE SOLUCOES E SERVICOS S.A. (ALELO) DILIGENCIA : 16/01/2018",
                    "PublishDate": "2018-01-20T00:00:00",
                    "CaptureDate": "2019-03-27T10:36:27"
                  },
                  {
                    "Content": "AR POSITIVO JUNTADO | JUNTADA DE AR : AR751068712TJ SITUACAO : CUMPRIDO MODELO : PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC DESTINATARIO : COMPANHIA BRASILEIRA DE SOLUCOES E SERVICOS S.A. (ALELO) DILIGENCIA : 16/01/2018",
                    "PublishDate": "2018-01-20T00:00:00",
                    "CaptureDate": "2021-07-04T23:31:55"
                  },
                  {
                    "Content": "REMETIDO AO DJE RELACAO: 0005/2018 TEOR DO ATO: VISTOS.DIANTE DAS ESPECIFICIDADES DA CAUSA E DE MODO A ADEQUAR O RITO PROCESSUAL AS NECESSIDADES DO CONFLITO, DEIXO PARA MOMENTO OPORTUNO A ANALISE DA CONVENIENCIA DA AUDIENCIA DE CONCILIACAO (CPC, ART. 139, VI, COM O ELASTERIO QUE PROPOE O ENUNCIADO N 35 DA ENFAM). ADEMAIS, NADA IMPEDE A AUTOCOMPOSICAO DAS PARTES POR SI SOS OU COM AUXILIO DE SEUS ADVOGADOS, INCLUSIVE COM A APRESENTACAO DE PROPOSTA NO BOJO DOS AUTOS QUE SERA SUBMETIDA A ANALISE DA PARTE ADVERSA. POR ESSAS RAZOES E CUMPRINDO-SE O MANDAMENTO CONSTITUCIONAL DE CELERIDADE, QUE SE SOBREPOE AS NORMAS INFRACONSTITUCIONAIS, SUPRIMO POR ORA A AUDIENCIA DE CONCILIACAO, SEM PREJUIZO DE SUA TENTATIVA EM OUTRO MOMENTO PROCESSUAL, DESDE QUE FAVORAVEIS AMBAS AS PARTES. CITE(M)-SE PARA CONTESTAR, FICANDO ADVERTIDO QUE, NOS TERMOS DO ARTIGO 344 DO CODIGO DE PROCESSO CIVIL, SE O REU NAO CONTESTAR A ACAO, NO PRAZO DE 15 DIAS UTEIS, SERA CONSIDERADO REVEL E PRESUMIR-SE-AO VERDADEIRAS AS ALEGACOES DE FATO FORMULADAS PELO AUTOR, FICANDO, AINDA, CIENTE DE QUE O RECIBO QUE ACOMPANHA ESTA CARTA VALERA COMO COMPROVANTE QUE ESTA CITACAO SE EFETIVOU COM AS ADVERTENCIAS LEGAIS.ESTA DECISAO SERVIRA TAMBEM, POR COPIA DIGITADA, COMO CARTA DE CITACAO.INT.SAO PAULO, 10 DE JANEIRO DE 2018. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2018-01-11T00:00:00",
                    "CaptureDate": "2019-03-27T10:36:27"
                  },
                  {
                    "Content": "REMETIDO AO DJE | RELACAO: 0005/2018 TEOR DO ATO: VISTOS.DIANTE DAS ESPECIFICIDADES DA CAUSA E DE MODO A ADEQUAR O RITO PROCESSUAL AS NECESSIDADES DO CONFLITO, DEIXO PARA MOMENTO OPORTUNO A ANALISE DA CONVENIENCIA DA AUDIENCIA DE CONCILIACAO (CPC, ART. 139, VI, COM O ELASTERIO QUE PROPOE O ENUNCIADO N 35 DA ENFAM). ADEMAIS, NADA IMPEDE A AUTOCOMPOSICAO DAS PARTES POR SI SOS OU COM AUXILIO DE SEUS ADVOGADOS, INCLUSIVE COM A APRESENTACAO DE PROPOSTA NO BOJO DOS AUTOS QUE SERA SUBMETIDA A ANALISE DA PARTE ADVERSA. POR ESSAS RAZOES E CUMPRINDO-SE O MANDAMENTO CONSTITUCIONAL DE CELERIDADE, QUE SE SOBREPOE AS NORMAS INFRACONSTITUCIONAIS, SUPRIMO POR ORA A AUDIENCIA DE CONCILIACAO, SEM PREJUIZO DE SUA TENTATIVA EM OUTRO MOMENTO PROCESSUAL, DESDE QUE FAVORAVEIS AMBAS AS PARTES. CITE(M)-SE PARA CONTESTAR, FICANDO ADVERTIDO QUE, NOS TERMOS DO ARTIGO 344 DO CODIGO DE PROCESSO CIVIL, SE O REU NAO CONTESTAR A ACAO, NO PRAZO DE 15 DIAS UTEIS, SERA CONSIDERADO REVEL E PRESUMIR-SE-AO VERDADEIRAS AS ALEGACOES DE FATO FORMULADAS PELO AUTOR, FICANDO, AINDA, CIENTE DE QUE O RECIBO QUE ACOMPANHA ESTA CARTA VALERA COMO COMPROVANTE QUE ESTA CITACAO SE EFETIVOU COM AS ADVERTENCIAS LEGAIS.ESTA DECISAO SERVIRA TAMBEM, POR COPIA DIGITADA, COMO CARTA DE CITACAO.INT.SAO PAULO, 10 DE JANEIRO DE 2018. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2018-01-11T00:00:00",
                    "CaptureDate": "2021-07-04T23:31:55"
                  },
                  {
                    "Content": "FLS. 85 TRIBUNAL DE JUSTICA DO ESTADO DE SAO PAULO COMARCA DE SAO PAULO FORO CENTRAL CIVEL 12 VARA CIVEL PRACA JOAO MENDES S/N, 8 ANDAR - SALAS N 805/807 - CENTRO CEP: 01501-900 - SAO PAULO - SP TELEFONE: 21716121 - E-MAIL: SP12CV@TJSP.JUS.BR DECISAO PROCESSO N: 1000744-42.2018.8.26.0100 CLASSE - ASSUNTO PROCEDIMENTO COMUM - INDENIZACAO POR DANO MORAL REQUERENTE: RAFAEL CASTRO DE MATOS. E OUTRO REQUERIDO: COMPANHIA BRASILEIRA DE SOLUCOES E SERVICOS S.A. (ALELO) JUIZ(A) DE DIREITO: DR(A). FERNANDO JOSE CUNICO VISTOS. DIANTE DAS ESPECIFICIDADES DA CAUSA E DE MODO A ADEQUAR O RITO PROCESSUAL AS NECESSIDADES DO CONFLITO, DEIXO PARA MOMENTO OPORTUNO A ANALISE DA CONVENIENCIA DA AUDIENCIA DE CONCILIACAO (CPC, ART. 139, VI, COM O ELASTERIO QUE PROPOE O ENUNCIADO N 35 DA ENFAM). ADEMAIS, NADA IMPEDE A AUTOCOMPOSICAO DAS PARTES POR SI SOS OU COM AUXILIO DE SEUS ADVOGADOS, INCLUSIVE COM A APRESENTACAO DE PROPOSTA NO BOJO DOS AUTOS QUE SERA SUBMETIDA A ANALISE DA PARTE ADVERSA. POR ESSAS RAZOES E CUMPRINDO-SE O MANDAMENTO CONSTITUCIONAL DE CELERIDADE, QUE SE SOBREPOE AS NORMAS INFRACONSTITUCIONAIS, SUPRIMO POR ORA A AUDIENCIA DE CONCILIACAO, SEM PREJUIZO DE SUA TENTATIVA EM OUTRO MOMENTO PROCESSUAL, DESDE QUE FAVORAVEIS AMBAS AS PARTES. CITE(M)-SE PARA CONTESTAR, FICANDO ADVERTIDO QUE, NOS TERMOS DO ARTIGO 344 DO CODIGO DE PROCESSO CIVIL, SE O REU NAO CONTESTAR A ACAO, NO PRAZO DE 15 DIAS UTEIS, SERA CONSIDERADO REVEL E PRESUMIR-SE-AO VERDADEIRAS AS ALEGACOES DE FATO FORMULADAS PELO AUTOR, FICANDO, AINDA, CIENTE DE QUE O RECIBO QUE ACOMPANHA ESTA CARTA VALERA COMO COMPROVANTE QUE ESTA CITACAO SE EFETIVOU COM AS ADVERTENCIAS LEGAIS. ESTA DECISAO SERVIRA TAMBEM, POR COPIA DIGITADA, COMO CARTA DE CITACAO. INT. SAO PAULO, 10 DE JANEIRO DE 2018. DOCUMENTO ASSINADO DIGITALMENTE NOS TERMOS DA LEI 11.419/2006, CONFORME IMPRESSAO A MARGEM DIREITA ART. 105, III, DAS NSCGJ: E VEDADO AO OFICIAL DE JUSTICA O RECEBIMENTO DE QUALQUER NUMERARIO DIRETAMENTE DA PARTE. A IDENTIFICACAO DO OFICIAL DE JUSTICA, NO DESEMPENHO DE SUAS FUNCOES, SERA FEITA MEDIANTE APRESENTACAO DE CARTEIRA FUNCIONAL, OBRIGATORIA EM TODAS AS DILIGENCIAS\". ADVERTENCIA: OPOR-SE A EXECUCAO DE ATO LEGAL, MEDIANTE VIOLENCIA OU AMEACA A FUNCIONARIO COMPETENTE PARA EXECUTA-LO OU A QUEM LHE ESTEJA PRESTANDO AUXILIO: PENA DETENCAO, DE 2 (DOIS) MESES A 2 (DOIS) ANOS, DESACATAR FUNCIONARIO PUBLICO NO EXERCICIO DA FUNCAO OU EM RAZAO DELA: PENA DETENCAO, DE 6 (SEIS) MESES A 2 (DOIS) ANOS, OU MULTA. TEXTO EXTRAIDO DO CODIGO PENAL, ARTIGOS 329 CAPUT E 331. PROCESSO N 1000744-42.2018.8.26.0100 - P. 1 ESTE DOCUMENTO E COPIA DO ORIGINAL, ASSINADO DIGITALMENTE POR FERNANDO JOSE CUNICO, LIBERADO NOS AUTOS EM 10/01/2018 AS 16:09 . PARA CONFERIR O ORIGINAL, ACESSE SITE HTTPS://ESAJ.TJSP.JUS.BR/PASTADIGITAL/PG/ABRIRCONFERENCIADOCUMENTO.DO, INFORME PROCESSO 1000744-42.2018.8.26.0100 E CODIGO 3D435DB.",
                    "PublishDate": "2018-01-10T00:00:00",
                    "CaptureDate": "2019-03-27T10:36:10"
                  },
                  {
                    "Content": "CONCLUSOS PARA DESPACHO",
                    "PublishDate": "2018-01-10T00:00:00",
                    "CaptureDate": "2019-03-27T10:36:10"
                  },
                  {
                    "Content": "CARTA EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                    "PublishDate": "2018-01-10T00:00:00",
                    "CaptureDate": "2019-03-27T10:36:27"
                  },
                  {
                    "Content": "CARTA EXPEDIDA | PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                    "PublishDate": "2018-01-10T00:00:00",
                    "CaptureDate": "2021-07-04T23:31:55"
                  },
                  {
                    "Content": "RECEBIDA A PETICAO INICIAL | VISTOS.DIANTE DAS ESPECIFICIDADES DA CAUSA E DE MODO A ADEQUAR O RITO PROCESSUAL AS NECESSIDADES DO CONFLITO, DEIXO PARA MOMENTO OPORTUNO A ANALISE DA CONVENIENCIA DA AUDIENCIA DE CONCILIACAO (CPC, ART. 139, VI, COM O ELASTERIO QUE PROPOE O ENUNCIADO N 35 DA ENFAM). ADEMAIS, NADA IMPEDE A AUTOCOMPOSICAO DAS PARTES POR SI SOS OU COM AUXILIO DE SEUS ADVOGADOS, INCLUSIVE COM A APRESENTACAO DE PROPOSTA NO BOJO DOS AUTOS QUE SERA SUBMETIDA A ANALISE DA PARTE ADVERSA. POR ESSAS RAZOES E CUMPRINDO-SE O MANDAMENTO CONSTITUCIONAL DE CELERIDADE, QUE SE SOBREPOE AS NORMAS INFRACONSTITUCIONAIS, SUPRIMO POR ORA A AUDIENCIA DE CONCILIACAO, SEM PREJUIZO DE SUA TENTATIVA EM OUTRO MOMENTO PROCESSUAL, DESDE QUE FAVORAVEIS AMBAS AS PARTES. CITE(M)-SE PARA CONTESTAR, FICANDO ADVERTIDO QUE, NOS TERMOS DO ARTIGO 344 DO CODIGO DE PROCESSO CIVIL, SE O REU NAO CONTESTAR A ACAO, NO PRAZO DE 15 DIAS UTEIS, SERA CONSIDERADO REVEL E PRESUMIR-SE-AO VERDADEIRAS AS ALEGACOES DE FATO FORMULADAS PELO AUTOR, FICANDO, AINDA, CIENTE DE QUE O RECIBO QUE ACOMPANHA ESTA CARTA VALERA COMO COMPROVANTE QUE ESTA CITACAO SE EFETIVOU COM AS ADVERTENCIAS LEGAIS.ESTA DECISAO SERVIRA TAMBEM, POR COPIA DIGITADA, COMO CARTA DE CITACAO.INT.SAO PAULO, 10 DE JANEIRO DE 2018.",
                    "PublishDate": "2018-01-10T00:00:00",
                    "CaptureDate": "2021-07-04T23:31:55"
                  },
                  {
                    "Content": "CONCLUSOS PARA DESPACHO",
                    "PublishDate": "2018-01-10T00:00:00",
                    "CaptureDate": "2021-07-04T23:31:55"
                  },
                  {
                    "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                    "PublishDate": "2018-01-09T00:00:00",
                    "CaptureDate": "2019-03-27T10:36:10"
                  }
                ],
                "Petitions": [
                  {
                    "Type": "PETICOES DIVERSAS",
                    "Author": "",
                    "CreationDate": "2018-02-15T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  },
                  {
                    "Type": "MANIFESTACAO SOBRE A CONTESTACAO",
                    "Author": "",
                    "CreationDate": "2018-05-01T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  },
                  {
                    "Type": "INDICACAO DE PROVAS",
                    "Author": "",
                    "CreationDate": "2018-05-01T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  },
                  {
                    "Type": "EMBARGOS DE DECLARACAO",
                    "Author": "",
                    "CreationDate": "2018-05-17T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  },
                  {
                    "Type": "RAZOES DE APELACAO",
                    "Author": "",
                    "CreationDate": "2018-06-27T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  },
                  {
                    "Type": "CONTRARRAZOES DE APELACAO",
                    "Author": "",
                    "CreationDate": "2018-07-17T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  },
                  {
                    "Type": "PETICOES DIVERSAS",
                    "Author": "",
                    "CreationDate": "2019-02-19T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  },
                  {
                    "Type": "JUNTADA DE COMPROVANTE DE DEPOSITO - GESTAO - DEPRE",
                    "Author": "",
                    "CreationDate": "2019-04-03T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  },
                  {
                    "Type": "PEDIDO DE EXPEDICAO DE MANDADO DE LEVANTAMENTO",
                    "Author": "",
                    "CreationDate": "2019-04-10T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  }
                ],
                "Decisions": [
                  {
                    "DecisionContent": "JULGO IMPROCEDENTE A PRETENSAO INICIAL COM FUNDAMENTO NO ART. 487, I, CPC.CONDENO OS AUTORES AO PAGAMENTO DAS CUSTAS, DESPESAS PROCESSUAIS E HONORARIOS ADVOCATICIOS DO REU, QUE ARBITRO EM 10% DO VALOR DA CAUSA, TENDO EM VISTA OS ELEMENTOS BALIZADORES QUE CONSTAM NO ART. 85, 2 DO CODIGO DE PROCESSO CIVIL.",
                    "DecisionDate": "2018-05-14T00:00:00"
                  },
                  {
                    "DecisionContent": "JULGO IMPROCEDENTE A PRETENSAO INICIAL COM FUNDAMENTO NO ART. 487, I, CPC.CONDENO OS AUTORES AO PAGAMENTO DAS CUSTAS, DESPESAS PROCESSUAIS E HONORARIOS ADVOCATICIOS DO REU, QUE ARBITRO EM 10% DO VALOR DA CAUSA, TENDO EM VISTA OS ELEMENTOS BALIZADORES QUE CONSTAM NO ART. 85, 2 DO CODIGO DE PROCESSO CIVIL.",
                    "DecisionDate": "2018-05-11T00:00:00"
                  }
                ]
              },
              {
                "Number": "11077158520178260100",
                "Type": "PROCEDIMENTO COMUM",
                "MainSubject": "TURISMO",
                "CourtName": "TJSP",
                "CourtLevel": "1",
                "CourtType": "CIVEL",
                "CourtDistrict": "",
                "Judge": "DENISE CAVALCANTE FORTES MARTINS",
                "JudgingBody": "1 VARA CIVEL - FORO CENTRAL CIVEL",
                "State": "SP",
                "Status": "INDEFINIDO",
                "LawsuitHostService": "ESAJ",
                "InferredCNJSubjectName": "TURISMO",
                "InferredCNJSubjectNumber": 7618,
                "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM",
                "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
                "InferredBroadCNJSubjectNumber": 1156,
                "OtherSubjects": [
                  "TURISMO",
                  "INDENIZACAO POR DANO MORAL"
                ],
                "NumberOfVolumes": 0,
                "NumberOfPages": 0,
                "Value": 23711.23,
                "ResJudicataDate": "0001-01-01T00:00:00",
                "CloseDate": "0001-01-01T00:00:00",
                "RedistributionDate": "0001-01-01T00:00:00",
                "PublicationDate": "2018-08-16T00:00:00",
                "NoticeDate": "2017-10-31T02:00:00",
                "LastMovementDate": "2018-11-19T00:00:00",
                "CaptureDate": "2018-08-17T15:34:42",
                "LastUpdate": "2018-08-17T15:34:42",
                "NumberOfParties": 8,
                "NumberOfUpdates": 95,
                "LawSuitAge": 2311,
                "AverageNumberOfUpdatesPerMonth": 1,
                "ReasonForConcealedData": 0,
                "Parties": [
                  {
                    "Doc": "41125929812",
                    "IsPartyActive": true,
                    "Name": "BEATRIZ BALAZINA DOMINGUES",
                    "Polarity": "ACTIVE",
                    "Type": "CLAIMANT",
                    "PartyDetails": {
                      "SpecificType": "REQTE"
                    },
                    "LastCaptureDate": "2018-08-17T15:34:42"
                  },
                  {
                    "IsPartyActive": true,
                    "Name": "JOAO BATISTA DE LIMA JUNIOR",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "317336",
                      "State": "SP",
                      "SpecificType": "ADVOGADO"
                    },
                    "LastCaptureDate": "2018-08-17T15:34:42"
                  },
                  {
                    "Doc": "35068411817",
                    "IsPartyActive": true,
                    "Name": "RAFAEL HIDEO NAZIMA",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "295443",
                      "State": "SP",
                      "SpecificType": "ADVOGADO"
                    },
                    "LastCaptureDate": "2018-08-17T15:34:42"
                  },
                  {
                    "Doc": "03563689000231",
                    "IsPartyActive": true,
                    "Name": "DECOLAR COM LTDA",
                    "Polarity": "PASSIVE",
                    "Type": "CLAIMED",
                    "PartyDetails": {
                      "SpecificType": "REQDO"
                    },
                    "LastCaptureDate": "2018-08-17T15:34:42"
                  },
                  {
                    "Doc": "02349014118",
                    "IsPartyActive": true,
                    "Name": "RAFAEL CASTRO DE MATOS",
                    "Polarity": "ACTIVE",
                    "Type": "CLAIMANT",
                    "PartyDetails": {
                      "SpecificType": "REQTE"
                    },
                    "LastCaptureDate": "2018-08-17T15:34:42"
                  },
                  {
                    "Doc": "12555110879",
                    "IsPartyActive": true,
                    "Name": "DENISE CAVALCANTE FORTES MARTINS",
                    "Polarity": "NEUTRAL",
                    "Type": "REPORTER",
                    "PartyDetails": {
                      "SpecificType": "JUIZ"
                    },
                    "LastCaptureDate": "2018-08-17T15:34:42"
                  },
                  {
                    "Doc": "35068411817",
                    "IsPartyActive": true,
                    "Name": "RAFAEL HIDEO NAZIMA",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "295443",
                      "State": "SP",
                      "SpecificType": "ADVOGADO (REQTE)"
                    },
                    "LastCaptureDate": "2018-08-17T15:34:42"
                  },
                  {
                    "Doc": "80579353834",
                    "IsPartyActive": true,
                    "Name": "FRANCISCO ANTONIO FRAGATA JUNIOR",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "39768",
                      "State": "SP",
                      "SpecificType": "ADVOGADO (REQDO)"
                    },
                    "LastCaptureDate": "2018-08-17T15:34:42"
                  }
                ],
                "Updates": [
                  {
                    "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.18.41557501-7 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 19/11/2018 13:13",
                    "PublishDate": "2018-11-19T00:00:00",
                    "CaptureDate": "2021-11-18T03:26:54"
                  },
                  {
                    "Content": "ARQUIVADO PROVISORIAMENTE",
                    "PublishDate": "2018-05-28T00:00:00",
                    "CaptureDate": "2018-06-09T07:54:11"
                  },
                  {
                    "Content": "APENSADO AO PROCESSO APENSO O PROCESSO 0040796-97.2018.8.26.0100 - CLASSE: CUMPRIMENTO DE SENTENCA - ASSUNTO PRINCIPAL: TURISMO",
                    "PublishDate": "2018-05-28T00:00:00",
                    "CaptureDate": "2018-06-09T07:54:11"
                  },
                  {
                    "Content": "INICIO DA EXECUCAO JUNTADO 0040796-97.2018.8.26.0100 - CUMPRIMENTO DE SENTENCA",
                    "PublishDate": "2018-05-28T00:00:00",
                    "CaptureDate": "2018-06-09T07:54:11"
                  },
                  {
                    "Content": "APENSADO AO PROCESSO | APENSO O PROCESSO 0040796-97.2018.8.26.0100 - CLASSE: CUMPRIMENTO DE SENTENCA - ASSUNTO PRINCIPAL: TURISMO",
                    "PublishDate": "2018-05-28T00:00:00",
                    "CaptureDate": "2021-11-18T03:26:54"
                  },
                  {
                    "Content": "INICIO DA EXECUCAO JUNTADO | 0040796-97.2018.8.26.0100 - CUMPRIMENTO DE SENTENCA",
                    "PublishDate": "2018-05-28T00:00:00",
                    "CaptureDate": "2021-11-18T03:26:54"
                  },
                  {
                    "Content": "ARQUIVADO PROVISORIAMENTE",
                    "PublishDate": "2018-05-28T00:00:00",
                    "CaptureDate": "2021-11-18T03:26:54"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0171/2018 DATA DA DISPONIBILIZACAO: 25/05/2018 DATA DA PUBLICACAO: 28/05/2018 NUMERO DO DIARIO: 2583 PAGINA: 5",
                    "PublishDate": "2018-05-25T00:00:00",
                    "CaptureDate": "2018-06-09T07:54:11"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0171/2018 DATA DA DISPONIBILIZACAO: 25/05/2018 DATA DA PUBLICACAO: 28/05/2018 NUMERO DO DIARIO: 2583 PAGINA: 5",
                    "PublishDate": "2018-05-25T00:00:00",
                    "CaptureDate": "2021-11-18T03:26:54"
                  },
                  {
                    "Content": "REMETIDO AO DJE RELACAO: 0171/2018 TEOR DO ATO: VISTOS.CUMPRA-SE A SENTENCA.MANIFESTE-SE A PARTE VENCEDORA EM TERMOS DE PROSSEGUIMENTO DO FEITO.NOS TERMOS DO ART. 1286 DAS NSCGJ, EVENTUAL INICIO DA FASE DE EXECUCAO DEVE SE DAR POR MEIO DE PETICAO PROTOCOLADA SOB A CLASSE \"CUMPRIMENTO DE SENTENCA\", INSTRUIDA COM AS SEGUINTES PECAS, PARA POSTERIOR AUTUACAO E PROCESSAMENTO EM APARTADO:SENTENCA E ACORDAO, SE EXISTENTE;CERTIDAO DE TRANSITO EM JULGADO (SE O CASO);DEMONSTRATIVO DO DEBITO ATUALIZADO OU PLANILHA DO ORGAO PAGADOR, QUANDO SE TRATAR DE EXECUCAO POR QUANTIA CERTA;MANDADO DE CITACAO CUMPRIDO E PROCURACOES OUTORGADAS AOS ADVOGADOS DAS PARTES, ALEM DE OUTRAS PECAS PROCESSUAIS QUE O EXEQUENTE CONSIDERE NECESSARIAS.ARQUIVEM-SE OS AUTOS.INTIMEM-SE. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP), JOAO BATISTA DE LIMA JUNIOR (OAB 317336/SP)",
                    "PublishDate": "2018-05-24T00:00:00",
                    "CaptureDate": "2018-06-09T07:54:11"
                  },
                  {
                    "Content": "REMETIDO AO DJE | RELACAO: 0171/2018 TEOR DO ATO: VISTOS.CUMPRA-SE A SENTENCA.MANIFESTE-SE A PARTE VENCEDORA EM TERMOS DE PROSSEGUIMENTO DO FEITO.NOS TERMOS DO ART. 1286 DAS NSCGJ, EVENTUAL INICIO DA FASE DE EXECUCAO DEVE SE DAR POR MEIO DE PETICAO PROTOCOLADA SOB A CLASSE \"CUMPRIMENTO DE SENTENCA\", INSTRUIDA COM AS SEGUINTES PECAS, PARA POSTERIOR AUTUACAO E PROCESSAMENTO EM APARTADO:SENTENCA E ACORDAO, SE EXISTENTE;CERTIDAO DE TRANSITO EM JULGADO (SE O CASO);DEMONSTRATIVO DO DEBITO ATUALIZADO OU PLANILHA DO ORGAO PAGADOR, QUANDO SE TRATAR DE EXECUCAO POR QUANTIA CERTA;MANDADO DE CITACAO CUMPRIDO E PROCURACOES OUTORGADAS AOS ADVOGADOS DAS PARTES, ALEM DE OUTRAS PECAS PROCESSUAIS QUE O EXEQUENTE CONSIDERE NECESSARIAS.ARQUIVEM-SE OS AUTOS.INTIMEM-SE. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP), JOAO BATISTA DE LIMA JUNIOR (OAB 317336/SP)",
                    "PublishDate": "2018-05-24T00:00:00",
                    "CaptureDate": "2021-11-18T03:26:54"
                  },
                  {
                    "Content": "DECISAO VISTOS.CUMPRA-SE A SENTENCA.MANIFESTE-SE A PARTE VENCEDORA EM TERMOS DE PROSSEGUIMENTO DO FEITO.NOS TERMOS DO ART. 1286 DAS NSCGJ, EVENTUAL INICIO DA FASE DE EXECUCAO DEVE SE DAR POR MEIO DE PETICAO PROTOCOLADA SOB A CLASSE \"CUMPRIMENTO DE SENTENCA\", INSTRUIDA COM AS SEGUINTES PECAS, PARA POSTERIOR AUTUACAO E PROCESSAMENTO EM APARTADO:SENTENCA E ACORDAO, SE EXISTENTE;CERTIDAO DE TRANSITO EM JULGADO (SE O CASO);DEMONSTRATIVO DO DEBITO ATUALIZADO OU PLANILHA DO ORGAO PAGADOR, QUANDO SE TRATAR DE EXECUCAO POR QUANTIA CERTA;MANDADO DE CITACAO CUMPRIDO E PROCURACOES OUTORGADAS AOS ADVOGADOS DAS PARTES, ALEM DE OUTRAS PECAS PROCESSUAIS QUE O EXEQUENTE CONSIDERE NECESSARIAS.ARQUIVEM-SE OS AUTOS.INTIMEM-SE.",
                    "PublishDate": "2018-05-23T00:00:00",
                    "CaptureDate": "2018-06-09T07:54:11"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO",
                    "PublishDate": "2018-05-23T00:00:00",
                    "CaptureDate": "2018-06-09T07:54:11"
                  },
                  {
                    "Content": "DECISAO | VISTOS.CUMPRA-SE A SENTENCA.MANIFESTE-SE A PARTE VENCEDORA EM TERMOS DE PROSSEGUIMENTO DO FEITO.NOS TERMOS DO ART. 1286 DAS NSCGJ, EVENTUAL INICIO DA FASE DE EXECUCAO DEVE SE DAR POR MEIO DE PETICAO PROTOCOLADA SOB A CLASSE \"CUMPRIMENTO DE SENTENCA\", INSTRUIDA COM AS SEGUINTES PECAS, PARA POSTERIOR AUTUACAO E PROCESSAMENTO EM APARTADO:SENTENCA E ACORDAO, SE EXISTENTE;CERTIDAO DE TRANSITO EM JULGADO (SE O CASO);DEMONSTRATIVO DO DEBITO ATUALIZADO OU PLANILHA DO ORGAO PAGADOR, QUANDO SE TRATAR DE EXECUCAO POR QUANTIA CERTA;MANDADO DE CITACAO CUMPRIDO E PROCURACOES OUTORGADAS AOS ADVOGADOS DAS PARTES, ALEM DE OUTRAS PECAS PROCESSUAIS QUE O EXEQUENTE CONSIDERE NECESSARIAS.ARQUIVEM-SE OS AUTOS.INTIMEM-SE.",
                    "PublishDate": "2018-05-23T00:00:00",
                    "CaptureDate": "2021-11-18T03:26:54"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO",
                    "PublishDate": "2018-05-23T00:00:00",
                    "CaptureDate": "2021-11-18T03:26:54"
                  },
                  {
                    "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.18.40349445-9 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 27/03/2018 12:16",
                    "PublishDate": "2018-03-27T00:00:00",
                    "CaptureDate": "2018-06-09T07:54:11"
                  },
                  {
                    "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.18.40349445-9 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 27/03/2018 12:16",
                    "PublishDate": "2018-03-27T00:00:00",
                    "CaptureDate": "2021-11-18T03:26:54"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0038/2018 DATA DA DISPONIBILIZACAO: 22/02/2018 DATA DA PUBLICACAO: 23/02/2018 NUMERO DO DIARIO: 2521 PAGINA: 74",
                    "PublishDate": "2018-02-22T00:00:00",
                    "CaptureDate": "2018-06-09T07:54:11"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0038/2018 DATA DA DISPONIBILIZACAO: 22/02/2018 DATA DA PUBLICACAO: 23/02/2018 NUMERO DO DIARIO: 2521 PAGINA: 74",
                    "PublishDate": "2018-02-22T00:00:00",
                    "CaptureDate": "2018-02-27T12:56:07"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0038/2018 DATA DA DISPONIBILIZACAO: 22/02/2018 DATA DA PUBLICACAO: 23/02/2018 NUMERO DO DIARIO: 2521 PAGINA: 74",
                    "PublishDate": "2018-02-22T00:00:00",
                    "CaptureDate": "2018-02-27T06:39:48"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0038/2018 DATA DA DISPONIBILIZACAO: 22/02/2018 DATA DA PUBLICACAO: 23/02/2018 NUMERO DO DIARIO: 2521 PAGINA: 74",
                    "PublishDate": "2018-02-22T00:00:00",
                    "CaptureDate": "2018-03-02T11:52:42"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0038/2018 DATA DA DISPONIBILIZACAO: 22/02/2018 DATA DA PUBLICACAO: 23/02/2018 NUMERO DO DIARIO: 2521 PAGINA: 74",
                    "PublishDate": "2018-02-22T00:00:00",
                    "CaptureDate": "2021-11-18T03:26:54"
                  },
                  {
                    "Content": "REMETIDO AO DJE RELACAO: 0038/2018 TEOR DO ATO: DIANTE DO EXPOSTO, JULGO PARCIALMENTE PROCEDENTE O PEDIDO DA PRESENTE ACAO PARA CONDENAR A RE AO PAGAMENTO INDENIZACAO POR DANOS MORAIS AOS AUTORES, NO MONTANTE TOTAL DE R$ 10.000,00 (DEZ MIL REAIS), QUE DEVERAO SER CORRIGIDOS MONETARIAMENTE A CONTAR DA DATA DESTA SENTENCA E ACRESCIDOS DE JUROS DE MORA DE 1% (UM POR CENTO) AO MES A CONTAR DA CITACAO, BEM COMO NA RESTITUICAO DA QUANTIA PAGA PARA A AQUISICAO DE NOVAS PASSAGENS, CORRIGIDA MONETARIAMENTE A CONTAR DO DESEMBOLSO E ACRESCIDA DE JUROS LEGAIS DE MORA A CONTAR DA CITACAO.FICAM PARTILHADAS PROPORCIONALMENTE AS CUSTAS E DESPESAS PROCESSUAIS, DADA A SUCUMBENCIA RECIPROCA.ARCARA A RE COM O PAGAMENTO DE HONORARIOS ADVOCATICIOS DA PARTE AUTORA, QUE ARBITRO EM 10% DO VALOR DA CONDENACAO.ARCARAO OS AUTORES COM HONORARIOS ADVOCATICIOS DA PARTE CONTRARIA, QUE ARBITRO EM 10% SOBRE A PARTE QUE SUCUMBIU (DIFERENCA ENTRE O VALOR POSTULADO A TITULO DE DANOS MORAIS E AQUELE EFETIVAMENTE DEFERIDO). P.R.I.SAO PAULO, 16 DE FEVEREIRO DE 2018. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP), JOAO BATISTA DE LIMA JUNIOR (OAB 317336/SP)",
                    "PublishDate": "2018-02-21T00:00:00",
                    "CaptureDate": "2018-06-09T07:54:11"
                  },
                  {
                    "Content": "REMETIDO AO DJE RELACAO: 0038/2018 TEOR DO ATO: DIANTE DO EXPOSTO, JULGO PARCIALMENTE PROCEDENTE O PEDIDO DA PRESENTE ACAO PARA CONDENAR A RE AO PAGAMENTO INDENIZACAO POR DANOS MORAIS AOS AUTORES, NO MONTANTE TOTAL DE R$ 10.000,00 (DEZ MIL REAIS), QUE DEVERAO SER CORRIGIDOS MONETARIAMENTE A CONTAR DA DATA DESTA SENTENCA E ACRESCIDOS DE JUROS DE MORA DE 1% (UM POR CENTO) AO MES A CONTAR DA CITACAO, BEM COMO NA RESTITUICAO DA QUANTIA PAGA PARA A AQUISICAO DE NOVAS PASSAGENS, CORRIGIDA MONETARIAMENTE A CONTAR DO DESEMBOLSO E ACRESCIDA DE JUROS LEGAIS DE MORA A CONTAR DA CITACAO.FICAM PARTILHADAS PROPORCIONALMENTE AS CUSTAS E DESPESAS PROCESSUAIS, DADA A SUCUMBENCIA RECIPROCA.ARCARA A RE COM O PAGAMENTO DE HONORARIOS ADVOCATICIOS DA PARTE AUTORA, QUE ARBITRO EM 10% DO VALOR DA CONDENACAO.ARCARAO OS AUTORES COM HONORARIOS ADVOCATICIOS DA PARTE CONTRARIA, QUE ARBITRO EM 10% SOBRE A PARTE QUE SUCUMBIU (DIFERENCA ENTRE O VALOR POSTULADO A TITULO DE DANOS MORAIS E AQUELE EFETIVAMENTE DEFERIDO). P.R.I.SAO PAULO, 16 DE FEVEREIRO DE 2018. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP), JOAO BATISTA DE LIMA JUNIOR (OAB 317336/SP)",
                    "PublishDate": "2018-02-21T00:00:00",
                    "CaptureDate": "2018-03-02T11:52:41"
                  },
                  {
                    "Content": "REMETIDO AO DJE RELACAO: 0038/2018 TEOR DO ATO: DIANTE DO EXPOSTO, JULGO PARCIALMENTE PROCEDENTE O PEDIDO DA PRESENTE ACAO PARA CONDENAR A RE AO PAGAMENTO INDENIZACAO POR DANOS MORAIS AOS AUTORES, NO MONTANTE TOTAL DE R$ 10.000,00 (DEZ MIL REAIS), QUE DEVERAO SER CORRIGIDOS MONETARIAMENTE A CONTAR DA DATA DESTA SENTENCA E ACRESCIDOS DE JUROS DE MORA DE 1% (UM POR CENTO) AO MES A CONTAR DA CITACAO, BEM COMO NA RESTITUICAO DA QUANTIA PAGA PARA A AQUISICAO DE NOVAS PASSAGENS, CORRIGIDA MONETARIAMENTE A CONTAR DO DESEMBOLSO E ACRESCIDA DE JUROS LEGAIS DE MORA A CONTAR DA CITACAO.FICAM PARTILHADAS PROPORCIONALMENTE AS CUSTAS E DESPESAS PROCESSUAIS, DADA A SUCUMBENCIA RECIPROCA.ARCARA A RE COM O PAGAMENTO DE HONORARIOS ADVOCATICIOS DA PARTE AUTORA, QUE ARBITRO EM 10% DO VALOR DA CONDENACAO.ARCARAO OS AUTORES COM HONORARIOS ADVOCATICIOS DA PARTE CONTRARIA, QUE ARBITRO EM 10% SOBRE A PARTE QUE SUCUMBIU (DIFERENCA ENTRE O VALOR POSTULADO A TITULO DE DANOS MORAIS E AQUELE EFETIVAMENTE DEFERIDO). P.R.I.SAO PAULO, 16 DE FEVEREIRO DE 2018. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP), JOAO BATISTA DE LIMA JUNIOR (OAB 317336/SP)",
                    "PublishDate": "2018-02-21T00:00:00",
                    "CaptureDate": "2018-02-27T12:56:07"
                  },
                  {
                    "Content": "REMETIDO AO DJE RELACAO: 0038/2018 TEOR DO ATO: DIANTE DO EXPOSTO, JULGO PARCIALMENTE PROCEDENTE O PEDIDO DA PRESENTE ACAO PARA CONDENAR A RE AO PAGAMENTO INDENIZACAO POR DANOS MORAIS AOS AUTORES, NO MONTANTE TOTAL DE R$ 10.000,00 (DEZ MIL REAIS), QUE DEVERAO SER CORRIGIDOS MONETARIAMENTE A CONTAR DA DATA DESTA SENTENCA E ACRESCIDOS DE JUROS DE MORA DE 1% (UM POR CENTO) AO MES A CONTAR DA CITACAO, BEM COMO NA RESTITUICAO DA QUANTIA PAGA PARA A AQUISICAO DE NOVAS PASSAGENS, CORRIGIDA MONETARIAMENTE A CONTAR DO DESEMBOLSO E ACRESCIDA DE JUROS LEGAIS DE MORA A CONTAR DA CITACAO.FICAM PARTILHADAS PROPORCIONALMENTE AS CUSTAS E DESPESAS PROCESSUAIS, DADA A SUCUMBENCIA RECIPROCA.ARCARA A RE COM O PAGAMENTO DE HONORARIOS ADVOCATICIOS DA PARTE AUTORA, QUE ARBITRO EM 10% DO VALOR DA CONDENACAO.ARCARAO OS AUTORES COM HONORARIOS ADVOCATICIOS DA PARTE CONTRARIA, QUE ARBITRO EM 10% SOBRE A PARTE QUE SUCUMBIU (DIFERENCA ENTRE O VALOR POSTULADO A TITULO DE DANOS MORAIS E AQUELE EFETIVAMENTE DEFERIDO). P.R.I.SAO PAULO, 16 DE FEVEREIRO DE 2018. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP), JOAO BATISTA DE LIMA JUNIOR (OAB 317336/SP)",
                    "PublishDate": "2018-02-21T00:00:00",
                    "CaptureDate": "2018-02-27T06:39:48"
                  },
                  {
                    "Content": "REMETIDO AO DJE | RELACAO: 0038/2018 TEOR DO ATO: DIANTE DO EXPOSTO, JULGO PARCIALMENTE PROCEDENTE O PEDIDO DA PRESENTE ACAO PARA CONDENAR A RE AO PAGAMENTO INDENIZACAO POR DANOS MORAIS AOS AUTORES, NO MONTANTE TOTAL DE R$ 10.000,00 (DEZ MIL REAIS), QUE DEVERAO SER CORRIGIDOS MONETARIAMENTE A CONTAR DA DATA DESTA SENTENCA E ACRESCIDOS DE JUROS DE MORA DE 1% (UM POR CENTO) AO MES A CONTAR DA CITACAO, BEM COMO NA RESTITUICAO DA QUANTIA PAGA PARA A AQUISICAO DE NOVAS PASSAGENS, CORRIGIDA MONETARIAMENTE A CONTAR DO DESEMBOLSO E ACRESCIDA DE JUROS LEGAIS DE MORA A CONTAR DA CITACAO.FICAM PARTILHADAS PROPORCIONALMENTE AS CUSTAS E DESPESAS PROCESSUAIS, DADA A SUCUMBENCIA RECIPROCA.ARCARA A RE COM O PAGAMENTO DE HONORARIOS ADVOCATICIOS DA PARTE AUTORA, QUE ARBITRO EM 10% DO VALOR DA CONDENACAO.ARCARAO OS AUTORES COM HONORARIOS ADVOCATICIOS DA PARTE CONTRARIA, QUE ARBITRO EM 10% SOBRE A PARTE QUE SUCUMBIU (DIFERENCA ENTRE O VALOR POSTULADO A TITULO DE DANOS MORAIS E AQUELE EFETIVAMENTE DEFERIDO). P.R.I.SAO PAULO, 16 DE FEVEREIRO DE 2018. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP), JOAO BATISTA DE LIMA JUNIOR (OAB 317336/SP)",
                    "PublishDate": "2018-02-21T00:00:00",
                    "CaptureDate": "2021-11-18T03:26:54"
                  },
                  {
                    "Content": "JULGADA PROCEDENTE EM PARTE A AO DIANTE DO EXPOSTO, JULGO PARCIALMENTE PROCEDENTE O PEDIDO DA PRESENTE ACAO PARA CONDENAR A RE AO PAGAMENTO INDENIZACAO POR DANOS MORAIS AOS AUTORES, NO MONTANTE TOTAL DE R$ 10.000,00 (DEZ MIL REAIS), QUE DEVERAO SER CORRIGIDOS MONETARIAMENTE A CONTAR DA DATA DESTA SENTENCA E ACRESCIDOS DE JUROS DE MORA DE 1% (UM POR CENTO) AO MES A CONTAR DA CITACAO, BEM COMO NA RESTITUICAO DA QUANTIA PAGA PARA A AQUISICAO DE NOVAS PASSAGENS, CORRIGIDA MONETARIAMENTE A CONTAR DO DESEMBOLSO E ACRESCIDA DE JUROS LEGAIS DE MORA A CONTAR DA CITACAO.FICAM PARTILHADAS PROPORCIONALMENTE AS CUSTAS E DESPESAS PROCESSUAIS, DADA A SUCUMBENCIA RECIPROCA.ARCARA A RE COM O PAGAMENTO DE HONORARIOS ADVOCATICIOS DA PARTE AUTORA, QUE ARBITRO EM 10% DO VALOR DA CONDENACAO.ARCARAO OS AUTORES COM HONORARIOS ADVOCATICIOS DA PARTE CONTRARIA, QUE ARBITRO EM 10% SOBRE A PARTE QUE SUCUMBIU (DIFERENCA ENTRE O VALOR POSTULADO A TITULO DE DANOS MORAIS E AQUELE EFETIVAMENTE DEFERIDO). P.R.I.SAO PAULO, 16 DE FEVEREIRO DE 2018.",
                    "PublishDate": "2018-02-16T00:00:00",
                    "CaptureDate": "2018-02-27T06:39:48"
                  },
                  {
                    "Content": "JULGADA PROCEDENTE EM PARTE A AO DIANTE DO EXPOSTO, JULGO PARCIALMENTE PROCEDENTE O PEDIDO DA PRESENTE ACAO PARA CONDENAR A RE AO PAGAMENTO INDENIZACAO POR DANOS MORAIS AOS AUTORES, NO MONTANTE TOTAL DE R$ 10.000,00 (DEZ MIL REAIS), QUE DEVERAO SER CORRIGIDOS MONETARIAMENTE A CONTAR DA DATA DESTA SENTENCA E ACRESCIDOS DE JUROS DE MORA DE 1% (UM POR CENTO) AO MES A CONTAR DA CITACAO, BEM COMO NA RESTITUICAO DA QUANTIA PAGA PARA A AQUISICAO DE NOVAS PASSAGENS, CORRIGIDA MONETARIAMENTE A CONTAR DO DESEMBOLSO E ACRESCIDA DE JUROS LEGAIS DE MORA A CONTAR DA CITACAO.FICAM PARTILHADAS PROPORCIONALMENTE AS CUSTAS E DESPESAS PROCESSUAIS, DADA A SUCUMBENCIA RECIPROCA.ARCARA A RE COM O PAGAMENTO DE HONORARIOS ADVOCATICIOS DA PARTE AUTORA, QUE ARBITRO EM 10% DO VALOR DA CONDENACAO.ARCARAO OS AUTORES COM HONORARIOS ADVOCATICIOS DA PARTE CONTRARIA, QUE ARBITRO EM 10% SOBRE A PARTE QUE SUCUMBIU (DIFERENCA ENTRE O VALOR POSTULADO A TITULO DE DANOS MORAIS E AQUELE EFETIVAMENTE DEFERIDO). P.R.I.SAO PAULO, 16 DE FEVEREIRO DE 2018.",
                    "PublishDate": "2018-02-16T00:00:00",
                    "CaptureDate": "2018-02-27T12:56:07"
                  },
                  {
                    "Content": "JULGADA PROCEDENTE EM PARTE A AO DIANTE DO EXPOSTO, JULGO PARCIALMENTE PROCEDENTE O PEDIDO DA PRESENTE ACAO PARA CONDENAR A RE AO PAGAMENTO INDENIZACAO POR DANOS MORAIS AOS AUTORES, NO MONTANTE TOTAL DE R$ 10.000,00 (DEZ MIL REAIS), QUE DEVERAO SER CORRIGIDOS MONETARIAMENTE A CONTAR DA DATA DESTA SENTENCA E ACRESCIDOS DE JUROS DE MORA DE 1% (UM POR CENTO) AO MES A CONTAR DA CITACAO, BEM COMO NA RESTITUICAO DA QUANTIA PAGA PARA A AQUISICAO DE NOVAS PASSAGENS, CORRIGIDA MONETARIAMENTE A CONTAR DO DESEMBOLSO E ACRESCIDA DE JUROS LEGAIS DE MORA A CONTAR DA CITACAO.FICAM PARTILHADAS PROPORCIONALMENTE AS CUSTAS E DESPESAS PROCESSUAIS, DADA A SUCUMBENCIA RECIPROCA.ARCARA A RE COM O PAGAMENTO DE HONORARIOS ADVOCATICIOS DA PARTE AUTORA, QUE ARBITRO EM 10% DO VALOR DA CONDENACAO.ARCARAO OS AUTORES COM HONORARIOS ADVOCATICIOS DA PARTE CONTRARIA, QUE ARBITRO EM 10% SOBRE A PARTE QUE SUCUMBIU (DIFERENCA ENTRE O VALOR POSTULADO A TITULO DE DANOS MORAIS E AQUELE EFETIVAMENTE DEFERIDO). P.R.I.SAO PAULO, 16 DE FEVEREIRO DE 2018.",
                    "PublishDate": "2018-02-16T00:00:00",
                    "CaptureDate": "2018-03-02T11:52:41"
                  },
                  {
                    "Content": "JULGADA PROCEDENTE EM PARTE A ACAO DIANTE DO EXPOSTO, JULGO PARCIALMENTE PROCEDENTE O PEDIDO DA PRESENTE ACAO PARA CONDENAR A RE AO PAGAMENTO INDENIZACAO POR DANOS MORAIS AOS AUTORES, NO MONTANTE TOTAL DE R$ 10.000,00 (DEZ MIL REAIS), QUE DEVERAO SER CORRIGIDOS MONETARIAMENTE A CONTAR DA DATA DESTA SENTENCA E ACRESCIDOS DE JUROS DE MORA DE 1% (UM POR CENTO) AO MES A CONTAR DA CITACAO, BEM COMO NA RESTITUICAO DA QUANTIA PAGA PARA A AQUISICAO DE NOVAS PASSAGENS, CORRIGIDA MONETARIAMENTE A CONTAR DO DESEMBOLSO E ACRESCIDA DE JUROS LEGAIS DE MORA A CONTAR DA CITACAO.FICAM PARTILHADAS PROPORCIONALMENTE AS CUSTAS E DESPESAS PROCESSUAIS, DADA A SUCUMBENCIA RECIPROCA.ARCARA A RE COM O PAGAMENTO DE HONORARIOS ADVOCATICIOS DA PARTE AUTORA, QUE ARBITRO EM 10% DO VALOR DA CONDENACAO.ARCARAO OS AUTORES COM HONORARIOS ADVOCATICIOS DA PARTE CONTRARIA, QUE ARBITRO EM 10% SOBRE A PARTE QUE SUCUMBIU (DIFERENCA ENTRE O VALOR POSTULADO A TITULO DE DANOS MORAIS E AQUELE EFETIVAMENTE DEFERIDO). P.R.I.SAO PAULO, 16 DE FEVEREIRO DE 2018.",
                    "PublishDate": "2018-02-16T00:00:00",
                    "CaptureDate": "2018-06-09T07:54:11"
                  },
                  {
                    "Content": "JULGADA PROCEDENTE EM PARTE A ACAO | DIANTE DO EXPOSTO, JULGO PARCIALMENTE PROCEDENTE O PEDIDO DA PRESENTE ACAO PARA CONDENAR A RE AO PAGAMENTO INDENIZACAO POR DANOS MORAIS AOS AUTORES, NO MONTANTE TOTAL DE R$ 10.000,00 (DEZ MIL REAIS), QUE DEVERAO SER CORRIGIDOS MONETARIAMENTE A CONTAR DA DATA DESTA SENTENCA E ACRESCIDOS DE JUROS DE MORA DE 1% (UM POR CENTO) AO MES A CONTAR DA CITACAO, BEM COMO NA RESTITUICAO DA QUANTIA PAGA PARA A AQUISICAO DE NOVAS PASSAGENS, CORRIGIDA MONETARIAMENTE A CONTAR DO DESEMBOLSO E ACRESCIDA DE JUROS LEGAIS DE MORA A CONTAR DA CITACAO.FICAM PARTILHADAS PROPORCIONALMENTE AS CUSTAS E DESPESAS PROCESSUAIS, DADA A SUCUMBENCIA RECIPROCA.ARCARA A RE COM O PAGAMENTO DE HONORARIOS ADVOCATICIOS DA PARTE AUTORA, QUE ARBITRO EM 10% DO VALOR DA CONDENACAO.ARCARAO OS AUTORES COM HONORARIOS ADVOCATICIOS DA PARTE CONTRARIA, QUE ARBITRO EM 10% SOBRE A PARTE QUE SUCUMBIU (DIFERENCA ENTRE O VALOR POSTULADO A TITULO DE DANOS MORAIS E AQUELE EFETIVAMENTE DEFERIDO). P.R.I.SAO PAULO, 16 DE FEVEREIRO DE 2018.",
                    "PublishDate": "2018-02-16T00:00:00",
                    "CaptureDate": "2021-11-18T03:26:54"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO",
                    "PublishDate": "2018-02-01T00:00:00",
                    "CaptureDate": "2018-03-02T11:52:41"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO",
                    "PublishDate": "2018-02-01T00:00:00",
                    "CaptureDate": "2018-02-27T12:56:07"
                  },
                  {
                    "Content": "CONCLUSOS PARA SENTENCA",
                    "PublishDate": "2018-02-01T00:00:00",
                    "CaptureDate": "2018-06-09T07:54:11"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO",
                    "PublishDate": "2018-02-01T00:00:00",
                    "CaptureDate": "2018-02-27T06:39:48"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO",
                    "PublishDate": "2018-02-01T00:00:00",
                    "CaptureDate": "2018-06-09T07:54:11"
                  },
                  {
                    "Content": "CONCLUSOS PARA SENTENCA",
                    "PublishDate": "2018-02-01T00:00:00",
                    "CaptureDate": "2018-03-02T11:52:41"
                  },
                  {
                    "Content": "CONCLUSOS PARA SENTENCA",
                    "PublishDate": "2018-02-01T00:00:00",
                    "CaptureDate": "2018-02-27T06:39:48"
                  },
                  {
                    "Content": "CONCLUSOS PARA SENTENCA",
                    "PublishDate": "2018-02-01T00:00:00",
                    "CaptureDate": "2018-02-27T12:56:07"
                  },
                  {
                    "Content": "CONCLUSOS PARA SENTENCA",
                    "PublishDate": "2018-02-01T00:00:00",
                    "CaptureDate": "2021-11-18T03:26:54"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO",
                    "PublishDate": "2018-02-01T00:00:00",
                    "CaptureDate": "2021-11-18T03:26:54"
                  },
                  {
                    "Content": "REPLICA JUNTADA N PROTOCOLO: WJMJ.17.41481806-3 TIPO DA PETICAO: MANIFESTACAO SOBRE A CONTESTACAO DATA: 19/12/2017 21:12",
                    "PublishDate": "2017-12-20T00:00:00",
                    "CaptureDate": "2018-03-02T11:52:41"
                  },
                  {
                    "Content": "REPLICA JUNTADA N PROTOCOLO: WJMJ.17.41481806-3 TIPO DA PETICAO: MANIFESTACAO SOBRE A CONTESTACAO DATA: 19/12/2017 21:12",
                    "PublishDate": "2017-12-20T00:00:00",
                    "CaptureDate": "2018-06-09T07:54:11"
                  },
                  {
                    "Content": "REPLICA JUNTADA N PROTOCOLO: WJMJ.17.41481806-3 TIPO DA PETICAO: MANIFESTACAO SOBRE A CONTESTACAO DATA: 19/12/2017 21:12",
                    "PublishDate": "2017-12-20T00:00:00",
                    "CaptureDate": "2018-02-27T06:39:48"
                  },
                  {
                    "Content": "REPLICA JUNTADA N PROTOCOLO: WJMJ.17.41481806-3 TIPO DA PETICAO: MANIFESTACAO SOBRE A CONTESTACAO DATA: 19/12/2017 21:12",
                    "PublishDate": "2017-12-20T00:00:00",
                    "CaptureDate": "2018-02-27T12:56:07"
                  },
                  {
                    "Content": "ESPECIFICACAO DE PROVAS JUNTADA N PROTOCOLO: WJMJ.17.41481809-8 TIPO DA PETICAO: INDICACAO DE PROVAS DATA: 19/12/2017 21:14",
                    "PublishDate": "2017-12-20T00:00:00",
                    "CaptureDate": "2018-03-02T11:52:41"
                  },
                  {
                    "Content": "ESPECIFICACAO DE PROVAS JUNTADA N PROTOCOLO: WJMJ.17.41481809-8 TIPO DA PETICAO: INDICACAO DE PROVAS DATA: 19/12/2017 21:14",
                    "PublishDate": "2017-12-20T00:00:00",
                    "CaptureDate": "2018-06-09T07:54:11"
                  },
                  {
                    "Content": "ESPECIFICACAO DE PROVAS JUNTADA N PROTOCOLO: WJMJ.17.41481809-8 TIPO DA PETICAO: INDICACAO DE PROVAS DATA: 19/12/2017 21:14",
                    "PublishDate": "2017-12-20T00:00:00",
                    "CaptureDate": "2018-02-27T06:39:48"
                  },
                  {
                    "Content": "ESPECIFICACAO DE PROVAS JUNTADA | N PROTOCOLO: WJMJ.17.41481809-8 TIPO DA PETICAO: INDICACAO DE PROVAS DATA: 19/12/2017 21:14",
                    "PublishDate": "2017-12-20T00:00:00",
                    "CaptureDate": "2021-11-18T03:26:54"
                  },
                  {
                    "Content": "REPLICA JUNTADA | N PROTOCOLO: WJMJ.17.41481806-3 TIPO DA PETICAO: MANIFESTACAO SOBRE A CONTESTACAO DATA: 19/12/2017 21:12",
                    "PublishDate": "2017-12-20T00:00:00",
                    "CaptureDate": "2021-11-18T03:26:54"
                  },
                  {
                    "Content": "CONTESTACAO JUNTADA N PROTOCOLO: WJMJ.17.41393465-5 TIPO DA PETICAO: CONTESTACAO DATA: 30/11/2017 16:52",
                    "PublishDate": "2017-11-30T00:00:00",
                    "CaptureDate": "2018-03-02T11:52:41"
                  },
                  {
                    "Content": "CONTESTACAO JUNTADA N PROTOCOLO: WJMJ.17.41393465-5 TIPO DA PETICAO: CONTESTACAO DATA: 30/11/2017 16:52",
                    "PublishDate": "2017-11-30T00:00:00",
                    "CaptureDate": "2018-02-27T06:39:48"
                  },
                  {
                    "Content": "CONTESTACAO JUNTADA N PROTOCOLO: WJMJ.17.41393465-5 TIPO DA PETICAO: CONTESTACAO DATA: 30/11/2017 16:52",
                    "PublishDate": "2017-11-30T00:00:00",
                    "CaptureDate": "2018-06-09T07:54:11"
                  },
                  {
                    "Content": "CONTESTACAO JUNTADA N PROTOCOLO: WJMJ.17.41393465-5 TIPO DA PETICAO: CONTESTACAO DATA: 30/11/2017 16:52",
                    "PublishDate": "2017-11-30T00:00:00",
                    "CaptureDate": "2018-02-27T12:56:07"
                  },
                  {
                    "Content": "CONTESTACAO JUNTADA | N PROTOCOLO: WJMJ.17.41393465-5 TIPO DA PETICAO: CONTESTACAO DATA: 30/11/2017 16:52",
                    "PublishDate": "2017-11-30T00:00:00",
                    "CaptureDate": "2021-11-18T03:26:54"
                  },
                  {
                    "Content": "AR POSITIVO JUNTADO JUNTADA DE AR : AR750855474TJ SITUACAO : CUMPRIDO MODELO : PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC DESTINATARIO : DECOLAR.COM LTDA DILIGENCIA : 22/11/2017",
                    "PublishDate": "2017-11-28T00:00:00",
                    "CaptureDate": "2018-03-02T11:52:41"
                  },
                  {
                    "Content": "AR POSITIVO JUNTADO JUNTADA DE AR : AR750855474TJ SITUACAO : CUMPRIDO MODELO : PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC DESTINATARIO : DECOLAR.COM LTDA DILIGENCIA : 22/11/2017",
                    "PublishDate": "2017-11-28T00:00:00",
                    "CaptureDate": "2018-02-27T06:39:48"
                  },
                  {
                    "Content": "AR POSITIVO JUNTADO JUNTADA DE AR : AR750855474TJ SITUACAO : CUMPRIDO MODELO : PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC DESTINATARIO : DECOLAR.COM LTDA DILIGENCIA : 22/11/2017",
                    "PublishDate": "2017-11-28T00:00:00",
                    "CaptureDate": "2018-02-27T12:56:07"
                  },
                  {
                    "Content": "AR POSITIVO JUNTADO JUNTADA DE AR : AR750855474TJ SITUACAO : CUMPRIDO MODELO : PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC DESTINATARIO : DECOLAR.COM LTDA DILIGENCIA : 22/11/2017",
                    "PublishDate": "2017-11-28T00:00:00",
                    "CaptureDate": "2018-06-09T07:54:11"
                  },
                  {
                    "Content": "AR POSITIVO JUNTADO | JUNTADA DE AR : AR750855474TJ SITUACAO : CUMPRIDO MODELO : PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC DESTINATARIO : DECOLAR.COM LTDA DILIGENCIA : 22/11/2017",
                    "PublishDate": "2017-11-28T00:00:00",
                    "CaptureDate": "2021-11-18T03:26:54"
                  },
                  {
                    "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.17.41330029-0 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 16/11/2017 15:29",
                    "PublishDate": "2017-11-16T00:00:00",
                    "CaptureDate": "2018-06-09T07:54:11"
                  },
                  {
                    "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.17.41330029-0 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 16/11/2017 15:29",
                    "PublishDate": "2017-11-16T00:00:00",
                    "CaptureDate": "2018-03-02T11:52:41"
                  },
                  {
                    "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.17.41330029-0 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 16/11/2017 15:29",
                    "PublishDate": "2017-11-16T00:00:00",
                    "CaptureDate": "2018-02-27T12:56:07"
                  },
                  {
                    "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.17.41330029-0 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 16/11/2017 15:29",
                    "PublishDate": "2017-11-16T00:00:00",
                    "CaptureDate": "2018-02-27T06:39:48"
                  },
                  {
                    "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.17.41330029-0 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 16/11/2017 15:29",
                    "PublishDate": "2017-11-16T00:00:00",
                    "CaptureDate": "2021-11-18T03:26:54"
                  },
                  {
                    "Content": "CARTA EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                    "PublishDate": "2017-11-08T00:00:00",
                    "CaptureDate": "2018-02-27T06:39:48"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0445/2017 DATA DA DISPONIBILIZACAO: 08/11/2017 DATA DA PUBLICACAO: 09/11/2017 NUMERO DO DIARIO: 2465 PAGINA: 72",
                    "PublishDate": "2017-11-08T00:00:00",
                    "CaptureDate": "2018-02-27T06:39:48"
                  },
                  {
                    "Content": "CARTA EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                    "PublishDate": "2017-11-08T00:00:00",
                    "CaptureDate": "2018-03-02T11:52:41"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0445/2017 DATA DA DISPONIBILIZACAO: 08/11/2017 DATA DA PUBLICACAO: 09/11/2017 NUMERO DO DIARIO: 2465 PAGINA: 72",
                    "PublishDate": "2017-11-08T00:00:00",
                    "CaptureDate": "2018-02-27T12:56:07"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0445/2017 DATA DA DISPONIBILIZACAO: 08/11/2017 DATA DA PUBLICACAO: 09/11/2017 NUMERO DO DIARIO: 2465 PAGINA: 72",
                    "PublishDate": "2017-11-08T00:00:00",
                    "CaptureDate": "2018-06-09T07:54:11"
                  },
                  {
                    "Content": "CERTIDO DE PUBLICACAO EXPEDIDA RELACAO :0445/2017 DATA DA DISPONIBILIZACAO: 08/11/2017 DATA DA PUBLICACAO: 09/11/2017 NUMERO DO DIARIO: 2465 PAGINA: 72",
                    "PublishDate": "2017-11-08T00:00:00",
                    "CaptureDate": "2018-08-17T15:34:42"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0445/2017 DATA DA DISPONIBILIZACAO: 08/11/2017 DATA DA PUBLICACAO: 09/11/2017 NUMERO DO DIARIO: 2465 PAGINA: 72",
                    "PublishDate": "2017-11-08T00:00:00",
                    "CaptureDate": "2018-03-02T11:52:41"
                  },
                  {
                    "Content": "CARTA EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                    "PublishDate": "2017-11-08T00:00:00",
                    "CaptureDate": "2018-02-27T12:56:07"
                  },
                  {
                    "Content": "CARTA EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                    "PublishDate": "2017-11-08T00:00:00",
                    "CaptureDate": "2018-06-09T07:54:11"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0445/2017 DATA DA DISPONIBILIZACAO: 08/11/2017 DATA DA PUBLICACAO: 09/11/2017 NUMERO DO DIARIO: 2465 PAGINA: 72",
                    "PublishDate": "2017-11-08T00:00:00",
                    "CaptureDate": "2021-11-18T03:26:54"
                  },
                  {
                    "Content": "CARTA EXPEDIDA | PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                    "PublishDate": "2017-11-08T00:00:00",
                    "CaptureDate": "2021-11-18T03:26:54"
                  },
                  {
                    "Content": "RECEBIDA A PETICAO INICIAL - CITACAO POR CARTA AR VISTOS. INICIALMENTE, ADVIRTO AO PROCURADOR DA PARTE AUTORA QUE A FORMACAO CORRETA DOS AUTOS DIGITAIS E DE SUA RESPONSABILIDADE. ASSIM, DEVERA CADASTRAR CADA PETICAO COM SEU CORRESPONDENTE TITULO (EMENDA A INICIAL, APELACAO, PEDIDO DE TUTELA, DILIGENCIA EM OUTRO ENDERECO, PEDIDO DE BLOQUEIO BACEN, DECLARACAO DE IMPOSTO DE RENDA, ETC.) E EVITAR O USO DOS CLASSIFICADORES GENERICOS \"PETICAO DIVERSA\", \"PETICAO INTERMEDIARIA\", PORQUE O USO INDISCRIMINADO DESSAS CATEGORIAS DIFICULTA O TRABALHO CARTORARIO E COMO CONSEQUENCIA CAUSA DEMORA NO ANDAMENTO PROCESSUAL. PROVIDENCIE, NO PRAZO DE 5 DIAS, O RECOLHIMENTO DAS CUSTAS REFERENTES A TAXA DE MANDATO. DIANTE DAS ESPECIFICIDADES DA CAUSA E DE MODO A ADEQUAR O RITO PROCESSUAL AS NECESSIDADES DO CONFLITO, DEIXO PARA MOMENTO OPORTUNO A ANALISE DA CONVENIENCIA DA AUDIENCIA DE CONCILIACAO. (CPC, ART. 139, VI E ENUNCIADO N 35 DA ENFAM: \"ALEM DAS SITUACOES EM QUE A FLEXIBILIZACAO DO PROCEDIMENTO E AUTORIZADA PELO ART. 139, VI, DO CPC/2015, PODE O JUIZ, DE OFICIO, PRESERVADA A PREVISIBILIDADE DO RITO, ADAPTA-LO AS ESPECIFICIDADES DA CAUSA, OBSERVADAS AS GARANTIAS FUNDAMENTAIS DO PROCESSO\"). CITE-SE E INTIME-SE A PARTE RE PARA CONTESTAR O FEITO NO PRAZO DE 15 (QUINZE) DIAS UTEIS. A AUSENCIA DE CONTESTACAO IMPLICARA REVELIA E PRESUNCAO DE VERACIDADE DA MATERIA FATICA APRESENTADA NA PETICAO INICIAL. TRATANDO-SE DE PROCESSO ELETRONICO, EM PRESTIGIO AS REGRAS FUNDAMENTAIS DOS ARTIGOS 4 E 6 DO CPC, FICA VEDADO O EXERCICIO DA FACULDADE PREVISTA NO ARTIGO 340 DO CPC. INTIMEM-SE.",
                    "PublishDate": "2017-11-07T00:00:00",
                    "CaptureDate": "2018-02-27T06:39:48"
                  },
                  {
                    "Content": "REMETIDO AO DJE RELACAO: 0445/2017 TEOR DO ATO: VISTOS. INICIALMENTE, ADVIRTO AO PROCURADOR DA PARTE AUTORA QUE A FORMACAO CORRETA DOS AUTOS DIGITAIS E DE SUA RESPONSABILIDADE. ASSIM, DEVERA CADASTRAR CADA PETICAO COM SEU CORRESPONDENTE TITULO (EMENDA A INICIAL, APELACAO, PEDIDO DE TUTELA, DILIGENCIA EM OUTRO ENDERECO, PEDIDO DE BLOQUEIO BACEN, DECLARACAO DE IMPOSTO DE RENDA, ETC.) E EVITAR O USO DOS CLASSIFICADORES GENERICOS \"PETICAO DIVERSA\", \"PETICAO INTERMEDIARIA\", PORQUE O USO INDISCRIMINADO DESSAS CATEGORIAS DIFICULTA O TRABALHO CARTORARIO E COMO CONSEQUENCIA CAUSA DEMORA NO ANDAMENTO PROCESSUAL. PROVIDENCIE, NO PRAZO DE 5 DIAS, O RECOLHIMENTO DAS CUSTAS REFERENTES A TAXA DE MANDATO. DIANTE DAS ESPECIFICIDADES DA CAUSA E DE MODO A ADEQUAR O RITO PROCESSUAL AS NECESSIDADES DO CONFLITO, DEIXO PARA MOMENTO OPORTUNO A ANALISE DA CONVENIENCIA DA AUDIENCIA DE CONCILIACAO. (CPC, ART. 139, VI E ENUNCIADO N 35 DA ENFAM: \"ALEM DAS SITUACOES EM QUE A FLEXIBILIZACAO DO PROCEDIMENTO E AUTORIZADA PELO ART. 139, VI, DO CPC/2015, PODE O JUIZ, DE OFICIO, PRESERVADA A PREVISIBILIDADE DO RITO, ADAPTA-LO AS ESPECIFICIDADES DA CAUSA, OBSERVADAS AS GARANTIAS FUNDAMENTAIS DO PROCESSO\"). CITE-SE E INTIME-SE A PARTE RE PARA CONTESTAR O FEITO NO PRAZO DE 15 (QUINZE) DIAS UTEIS. A AUSENCIA DE CONTESTACAO IMPLICARA REVELIA E PRESUNCAO DE VERACIDADE DA MATERIA FATICA APRESENTADA NA PETICAO INICIAL. TRATANDO-SE DE PROCESSO ELETRONICO, EM PRESTIGIO AS REGRAS FUNDAMENTAIS DOS ARTIGOS 4 E 6 DO CPC, FICA VEDADO O EXERCICIO DA FACULDADE PREVISTA NO ARTIGO 340 DO CPC. INTIMEM-SE. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2017-11-07T00:00:00",
                    "CaptureDate": "2018-06-09T07:54:11"
                  },
                  {
                    "Content": "REMETIDO AO DJE RELACAO: 0445/2017 TEOR DO ATO: VISTOS. INICIALMENTE, ADVIRTO AO PROCURADOR DA PARTE AUTORA QUE A FORMACAO CORRETA DOS AUTOS DIGITAIS E DE SUA RESPONSABILIDADE. ASSIM, DEVERA CADASTRAR CADA PETICAO COM SEU CORRESPONDENTE TITULO (EMENDA A INICIAL, APELACAO, PEDIDO DE TUTELA, DILIGENCIA EM OUTRO ENDERECO, PEDIDO DE BLOQUEIO BACEN, DECLARACAO DE IMPOSTO DE RENDA, ETC.) E EVITAR O USO DOS CLASSIFICADORES GENERICOS \"PETICAO DIVERSA\", \"PETICAO INTERMEDIARIA\", PORQUE O USO INDISCRIMINADO DESSAS CATEGORIAS DIFICULTA O TRABALHO CARTORARIO E COMO CONSEQUENCIA CAUSA DEMORA NO ANDAMENTO PROCESSUAL. PROVIDENCIE, NO PRAZO DE 5 DIAS, O RECOLHIMENTO DAS CUSTAS REFERENTES A TAXA DE MANDATO. DIANTE DAS ESPECIFICIDADES DA CAUSA E DE MODO A ADEQUAR O RITO PROCESSUAL AS NECESSIDADES DO CONFLITO, DEIXO PARA MOMENTO OPORTUNO A ANALISE DA CONVENIENCIA DA AUDIENCIA DE CONCILIACAO. (CPC, ART. 139, VI E ENUNCIADO N 35 DA ENFAM: \"ALEM DAS SITUACOES EM QUE A FLEXIBILIZACAO DO PROCEDIMENTO E AUTORIZADA PELO ART. 139, VI, DO CPC/2015, PODE O JUIZ, DE OFICIO, PRESERVADA A PREVISIBILIDADE DO RITO, ADAPTA-LO AS ESPECIFICIDADES DA CAUSA, OBSERVADAS AS GARANTIAS FUNDAMENTAIS DO PROCESSO\"). CITE-SE E INTIME-SE A PARTE RE PARA CONTESTAR O FEITO NO PRAZO DE 15 (QUINZE) DIAS UTEIS. A AUSENCIA DE CONTESTACAO IMPLICARA REVELIA E PRESUNCAO DE VERACIDADE DA MATERIA FATICA APRESENTADA NA PETICAO INICIAL. TRATANDO-SE DE PROCESSO ELETRONICO, EM PRESTIGIO AS REGRAS FUNDAMENTAIS DOS ARTIGOS 4 E 6 DO CPC, FICA VEDADO O EXERCICIO DA FACULDADE PREVISTA NO ARTIGO 340 DO CPC. INTIMEM-SE. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2017-11-07T00:00:00",
                    "CaptureDate": "2018-02-27T12:56:07"
                  },
                  {
                    "Content": "REMETIDO AO DJE RELACAO: 0445/2017 TEOR DO ATO: VISTOS. INICIALMENTE, ADVIRTO AO PROCURADOR DA PARTE AUTORA QUE A FORMACAO CORRETA DOS AUTOS DIGITAIS E DE SUA RESPONSABILIDADE. ASSIM, DEVERA CADASTRAR CADA PETICAO COM SEU CORRESPONDENTE TITULO (EMENDA A INICIAL, APELACAO, PEDIDO DE TUTELA, DILIGENCIA EM OUTRO ENDERECO, PEDIDO DE BLOQUEIO BACEN, DECLARACAO DE IMPOSTO DE RENDA, ETC.) E EVITAR O USO DOS CLASSIFICADORES GENERICOS \"PETICAO DIVERSA\", \"PETICAO INTERMEDIARIA\", PORQUE O USO INDISCRIMINADO DESSAS CATEGORIAS DIFICULTA O TRABALHO CARTORARIO E COMO CONSEQUENCIA CAUSA DEMORA NO ANDAMENTO PROCESSUAL. PROVIDENCIE, NO PRAZO DE 5 DIAS, O RECOLHIMENTO DAS CUSTAS REFERENTES A TAXA DE MANDATO. DIANTE DAS ESPECIFICIDADES DA CAUSA E DE MODO A ADEQUAR O RITO PROCESSUAL AS NECESSIDADES DO CONFLITO, DEIXO PARA MOMENTO OPORTUNO A ANALISE DA CONVENIENCIA DA AUDIENCIA DE CONCILIACAO. (CPC, ART. 139, VI E ENUNCIADO N 35 DA ENFAM: \"ALEM DAS SITUACOES EM QUE A FLEXIBILIZACAO DO PROCEDIMENTO E AUTORIZADA PELO ART. 139, VI, DO CPC/2015, PODE O JUIZ, DE OFICIO, PRESERVADA A PREVISIBILIDADE DO RITO, ADAPTA-LO AS ESPECIFICIDADES DA CAUSA, OBSERVADAS AS GARANTIAS FUNDAMENTAIS DO PROCESSO\"). CITE-SE E INTIME-SE A PARTE RE PARA CONTESTAR O FEITO NO PRAZO DE 15 (QUINZE) DIAS UTEIS. A AUSENCIA DE CONTESTACAO IMPLICARA REVELIA E PRESUNCAO DE VERACIDADE DA MATERIA FATICA APRESENTADA NA PETICAO INICIAL. TRATANDO-SE DE PROCESSO ELETRONICO, EM PRESTIGIO AS REGRAS FUNDAMENTAIS DOS ARTIGOS 4 E 6 DO CPC, FICA VEDADO O EXERCICIO DA FACULDADE PREVISTA NO ARTIGO 340 DO CPC. INTIMEM-SE. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2017-11-07T00:00:00",
                    "CaptureDate": "2018-03-02T11:52:41"
                  },
                  {
                    "Content": "RECEBIDA A PETICAO INICIAL - CITACAO POR CARTA AR VISTOS. INICIALMENTE, ADVIRTO AO PROCURADOR DA PARTE AUTORA QUE A FORMACAO CORRETA DOS AUTOS DIGITAIS E DE SUA RESPONSABILIDADE. ASSIM, DEVERA CADASTRAR CADA PETICAO COM SEU CORRESPONDENTE TITULO (EMENDA A INICIAL, APELACAO, PEDIDO DE TUTELA, DILIGENCIA EM OUTRO ENDERECO, PEDIDO DE BLOQUEIO BACEN, DECLARACAO DE IMPOSTO DE RENDA, ETC.) E EVITAR O USO DOS CLASSIFICADORES GENERICOS \"PETICAO DIVERSA\", \"PETICAO INTERMEDIARIA\", PORQUE O USO INDISCRIMINADO DESSAS CATEGORIAS DIFICULTA O TRABALHO CARTORARIO E COMO CONSEQUENCIA CAUSA DEMORA NO ANDAMENTO PROCESSUAL. PROVIDENCIE, NO PRAZO DE 5 DIAS, O RECOLHIMENTO DAS CUSTAS REFERENTES A TAXA DE MANDATO. DIANTE DAS ESPECIFICIDADES DA CAUSA E DE MODO A ADEQUAR O RITO PROCESSUAL AS NECESSIDADES DO CONFLITO, DEIXO PARA MOMENTO OPORTUNO A ANALISE DA CONVENIENCIA DA AUDIENCIA DE CONCILIACAO. (CPC, ART. 139, VI E ENUNCIADO N 35 DA ENFAM: \"ALEM DAS SITUACOES EM QUE A FLEXIBILIZACAO DO PROCEDIMENTO E AUTORIZADA PELO ART. 139, VI, DO CPC/2015, PODE O JUIZ, DE OFICIO, PRESERVADA A PREVISIBILIDADE DO RITO, ADAPTA-LO AS ESPECIFICIDADES DA CAUSA, OBSERVADAS AS GARANTIAS FUNDAMENTAIS DO PROCESSO\"). CITE-SE E INTIME-SE A PARTE RE PARA CONTESTAR O FEITO NO PRAZO DE 15 (QUINZE) DIAS UTEIS. A AUSENCIA DE CONTESTACAO IMPLICARA REVELIA E PRESUNCAO DE VERACIDADE DA MATERIA FATICA APRESENTADA NA PETICAO INICIAL. TRATANDO-SE DE PROCESSO ELETRONICO, EM PRESTIGIO AS REGRAS FUNDAMENTAIS DOS ARTIGOS 4 E 6 DO CPC, FICA VEDADO O EXERCICIO DA FACULDADE PREVISTA NO ARTIGO 340 DO CPC. INTIMEM-SE.",
                    "PublishDate": "2017-11-07T00:00:00",
                    "CaptureDate": "2018-02-27T12:56:07"
                  },
                  {
                    "Content": "RECEBIDA A PETICAO INICIAL - CITACAO POR CARTA AR VISTOS. INICIALMENTE, ADVIRTO AO PROCURADOR DA PARTE AUTORA QUE A FORMACAO CORRETA DOS AUTOS DIGITAIS E DE SUA RESPONSABILIDADE. ASSIM, DEVERA CADASTRAR CADA PETICAO COM SEU CORRESPONDENTE TITULO (EMENDA A INICIAL, APELACAO, PEDIDO DE TUTELA, DILIGENCIA EM OUTRO ENDERECO, PEDIDO DE BLOQUEIO BACEN, DECLARACAO DE IMPOSTO DE RENDA, ETC.) E EVITAR O USO DOS CLASSIFICADORES GENERICOS \"PETICAO DIVERSA\", \"PETICAO INTERMEDIARIA\", PORQUE O USO INDISCRIMINADO DESSAS CATEGORIAS DIFICULTA O TRABALHO CARTORARIO E COMO CONSEQUENCIA CAUSA DEMORA NO ANDAMENTO PROCESSUAL. PROVIDENCIE, NO PRAZO DE 5 DIAS, O RECOLHIMENTO DAS CUSTAS REFERENTES A TAXA DE MANDATO. DIANTE DAS ESPECIFICIDADES DA CAUSA E DE MODO A ADEQUAR O RITO PROCESSUAL AS NECESSIDADES DO CONFLITO, DEIXO PARA MOMENTO OPORTUNO A ANALISE DA CONVENIENCIA DA AUDIENCIA DE CONCILIACAO. (CPC, ART. 139, VI E ENUNCIADO N 35 DA ENFAM: \"ALEM DAS SITUACOES EM QUE A FLEXIBILIZACAO DO PROCEDIMENTO E AUTORIZADA PELO ART. 139, VI, DO CPC/2015, PODE O JUIZ, DE OFICIO, PRESERVADA A PREVISIBILIDADE DO RITO, ADAPTA-LO AS ESPECIFICIDADES DA CAUSA, OBSERVADAS AS GARANTIAS FUNDAMENTAIS DO PROCESSO\"). CITE-SE E INTIME-SE A PARTE RE PARA CONTESTAR O FEITO NO PRAZO DE 15 (QUINZE) DIAS UTEIS. A AUSENCIA DE CONTESTACAO IMPLICARA REVELIA E PRESUNCAO DE VERACIDADE DA MATERIA FATICA APRESENTADA NA PETICAO INICIAL. TRATANDO-SE DE PROCESSO ELETRONICO, EM PRESTIGIO AS REGRAS FUNDAMENTAIS DOS ARTIGOS 4 E 6 DO CPC, FICA VEDADO O EXERCICIO DA FACULDADE PREVISTA NO ARTIGO 340 DO CPC. INTIMEM-SE.",
                    "PublishDate": "2017-11-07T00:00:00",
                    "CaptureDate": "2018-06-09T07:54:11"
                  },
                  {
                    "Content": "RECEBIDA A PETICAO INICIAL - CITACAO POR CARTA AR VISTOS. INICIALMENTE, ADVIRTO AO PROCURADOR DA PARTE AUTORA QUE A FORMACAO CORRETA DOS AUTOS DIGITAIS E DE SUA RESPONSABILIDADE. ASSIM, DEVERA CADASTRAR CADA PETICAO COM SEU CORRESPONDENTE TITULO (EMENDA A INICIAL, APELACAO, PEDIDO DE TUTELA, DILIGENCIA EM OUTRO ENDERECO, PEDIDO DE BLOQUEIO BACEN, DECLARACAO DE IMPOSTO DE RENDA, ETC.) E EVITAR O USO DOS CLASSIFICADORES GENERICOS \"PETICAO DIVERSA\", \"PETICAO INTERMEDIARIA\", PORQUE O USO INDISCRIMINADO DESSAS CATEGORIAS DIFICULTA O TRABALHO CARTORARIO E COMO CONSEQUENCIA CAUSA DEMORA NO ANDAMENTO PROCESSUAL. PROVIDENCIE, NO PRAZO DE 5 DIAS, O RECOLHIMENTO DAS CUSTAS REFERENTES A TAXA DE MANDATO. DIANTE DAS ESPECIFICIDADES DA CAUSA E DE MODO A ADEQUAR O RITO PROCESSUAL AS NECESSIDADES DO CONFLITO, DEIXO PARA MOMENTO OPORTUNO A ANALISE DA CONVENIENCIA DA AUDIENCIA DE CONCILIACAO. (CPC, ART. 139, VI E ENUNCIADO N 35 DA ENFAM: \"ALEM DAS SITUACOES EM QUE A FLEXIBILIZACAO DO PROCEDIMENTO E AUTORIZADA PELO ART. 139, VI, DO CPC/2015, PODE O JUIZ, DE OFICIO, PRESERVADA A PREVISIBILIDADE DO RITO, ADAPTA-LO AS ESPECIFICIDADES DA CAUSA, OBSERVADAS AS GARANTIAS FUNDAMENTAIS DO PROCESSO\"). CITE-SE E INTIME-SE A PARTE RE PARA CONTESTAR O FEITO NO PRAZO DE 15 (QUINZE) DIAS UTEIS. A AUSENCIA DE CONTESTACAO IMPLICARA REVELIA E PRESUNCAO DE VERACIDADE DA MATERIA FATICA APRESENTADA NA PETICAO INICIAL. TRATANDO-SE DE PROCESSO ELETRONICO, EM PRESTIGIO AS REGRAS FUNDAMENTAIS DOS ARTIGOS 4 E 6 DO CPC, FICA VEDADO O EXERCICIO DA FACULDADE PREVISTA NO ARTIGO 340 DO CPC. INTIMEM-SE.",
                    "PublishDate": "2017-11-07T00:00:00",
                    "CaptureDate": "2018-03-02T11:52:41"
                  },
                  {
                    "Content": "REMETIDO AO DJE RELACAO: 0445/2017 TEOR DO ATO: VISTOS. INICIALMENTE, ADVIRTO AO PROCURADOR DA PARTE AUTORA QUE A FORMACAO CORRETA DOS AUTOS DIGITAIS E DE SUA RESPONSABILIDADE. ASSIM, DEVERA CADASTRAR CADA PETICAO COM SEU CORRESPONDENTE TITULO (EMENDA A INICIAL, APELACAO, PEDIDO DE TUTELA, DILIGENCIA EM OUTRO ENDERECO, PEDIDO DE BLOQUEIO BACEN, DECLARACAO DE IMPOSTO DE RENDA, ETC.) E EVITAR O USO DOS CLASSIFICADORES GENERICOS \"PETICAO DIVERSA\", \"PETICAO INTERMEDIARIA\", PORQUE O USO INDISCRIMINADO DESSAS CATEGORIAS DIFICULTA O TRABALHO CARTORARIO E COMO CONSEQUENCIA CAUSA DEMORA NO ANDAMENTO PROCESSUAL. PROVIDENCIE, NO PRAZO DE 5 DIAS, O RECOLHIMENTO DAS CUSTAS REFERENTES A TAXA DE MANDATO. DIANTE DAS ESPECIFICIDADES DA CAUSA E DE MODO A ADEQUAR O RITO PROCESSUAL AS NECESSIDADES DO CONFLITO, DEIXO PARA MOMENTO OPORTUNO A ANALISE DA CONVENIENCIA DA AUDIENCIA DE CONCILIACAO. (CPC, ART. 139, VI E ENUNCIADO N 35 DA ENFAM: \"ALEM DAS SITUACOES EM QUE A FLEXIBILIZACAO DO PROCEDIMENTO E AUTORIZADA PELO ART. 139, VI, DO CPC/2015, PODE O JUIZ, DE OFICIO, PRESERVADA A PREVISIBILIDADE DO RITO, ADAPTA-LO AS ESPECIFICIDADES DA CAUSA, OBSERVADAS AS GARANTIAS FUNDAMENTAIS DO PROCESSO\"). CITE-SE E INTIME-SE A PARTE RE PARA CONTESTAR O FEITO NO PRAZO DE 15 (QUINZE) DIAS UTEIS. A AUSENCIA DE CONTESTACAO IMPLICARA REVELIA E PRESUNCAO DE VERACIDADE DA MATERIA FATICA APRESENTADA NA PETICAO INICIAL. TRATANDO-SE DE PROCESSO ELETRONICO, EM PRESTIGIO AS REGRAS FUNDAMENTAIS DOS ARTIGOS 4 E 6 DO CPC, FICA VEDADO O EXERCICIO DA FACULDADE PREVISTA NO ARTIGO 340 DO CPC. INTIMEM-SE. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2017-11-07T00:00:00",
                    "CaptureDate": "2018-02-27T06:39:48"
                  },
                  {
                    "Content": "REMETIDO AO DJE | RELACAO: 0445/2017 TEOR DO ATO: VISTOS. INICIALMENTE, ADVIRTO AO PROCURADOR DA PARTE AUTORA QUE A FORMACAO CORRETA DOS AUTOS DIGITAIS E DE SUA RESPONSABILIDADE. ASSIM, DEVERA CADASTRAR CADA PETICAO COM SEU CORRESPONDENTE TITULO (EMENDA A INICIAL, APELACAO, PEDIDO DE TUTELA, DILIGENCIA EM OUTRO ENDERECO, PEDIDO DE BLOQUEIO BACEN, DECLARACAO DE IMPOSTO DE RENDA, ETC.) E EVITAR O USO DOS CLASSIFICADORES GENERICOS \"PETICAO DIVERSA\", \"PETICAO INTERMEDIARIA\", PORQUE O USO INDISCRIMINADO DESSAS CATEGORIAS DIFICULTA O TRABALHO CARTORARIO E COMO CONSEQUENCIA CAUSA DEMORA NO ANDAMENTO PROCESSUAL. PROVIDENCIE, NO PRAZO DE 5 DIAS, O RECOLHIMENTO DAS CUSTAS REFERENTES A TAXA DE MANDATO. DIANTE DAS ESPECIFICIDADES DA CAUSA E DE MODO A ADEQUAR O RITO PROCESSUAL AS NECESSIDADES DO CONFLITO, DEIXO PARA MOMENTO OPORTUNO A ANALISE DA CONVENIENCIA DA AUDIENCIA DE CONCILIACAO. (CPC, ART. 139, VI E ENUNCIADO N 35 DA ENFAM: \"ALEM DAS SITUACOES EM QUE A FLEXIBILIZACAO DO PROCEDIMENTO E AUTORIZADA PELO ART. 139, VI, DO CPC/2015, PODE O JUIZ, DE OFICIO, PRESERVADA A PREVISIBILIDADE DO RITO, ADAPTA-LO AS ESPECIFICIDADES DA CAUSA, OBSERVADAS AS GARANTIAS FUNDAMENTAIS DO PROCESSO\"). CITE-SE E INTIME-SE A PARTE RE PARA CONTESTAR O FEITO NO PRAZO DE 15 (QUINZE) DIAS UTEIS. A AUSENCIA DE CONTESTACAO IMPLICARA REVELIA E PRESUNCAO DE VERACIDADE DA MATERIA FATICA APRESENTADA NA PETICAO INICIAL. TRATANDO-SE DE PROCESSO ELETRONICO, EM PRESTIGIO AS REGRAS FUNDAMENTAIS DOS ARTIGOS 4 E 6 DO CPC, FICA VEDADO O EXERCICIO DA FACULDADE PREVISTA NO ARTIGO 340 DO CPC. INTIMEM-SE. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2017-11-07T00:00:00",
                    "CaptureDate": "2021-11-18T03:26:54"
                  },
                  {
                    "Content": "RECEBIDA A PETICAO INICIAL - CITACAO POR CARTA AR | VISTOS. INICIALMENTE, ADVIRTO AO PROCURADOR DA PARTE AUTORA QUE A FORMACAO CORRETA DOS AUTOS DIGITAIS E DE SUA RESPONSABILIDADE. ASSIM, DEVERA CADASTRAR CADA PETICAO COM SEU CORRESPONDENTE TITULO (EMENDA A INICIAL, APELACAO, PEDIDO DE TUTELA, DILIGENCIA EM OUTRO ENDERECO, PEDIDO DE BLOQUEIO BACEN, DECLARACAO DE IMPOSTO DE RENDA, ETC.) E EVITAR O USO DOS CLASSIFICADORES GENERICOS \"PETICAO DIVERSA\", \"PETICAO INTERMEDIARIA\", PORQUE O USO INDISCRIMINADO DESSAS CATEGORIAS DIFICULTA O TRABALHO CARTORARIO E COMO CONSEQUENCIA CAUSA DEMORA NO ANDAMENTO PROCESSUAL. PROVIDENCIE, NO PRAZO DE 5 DIAS, O RECOLHIMENTO DAS CUSTAS REFERENTES A TAXA DE MANDATO. DIANTE DAS ESPECIFICIDADES DA CAUSA E DE MODO A ADEQUAR O RITO PROCESSUAL AS NECESSIDADES DO CONFLITO, DEIXO PARA MOMENTO OPORTUNO A ANALISE DA CONVENIENCIA DA AUDIENCIA DE CONCILIACAO. (CPC, ART. 139, VI E ENUNCIADO N 35 DA ENFAM: \"ALEM DAS SITUACOES EM QUE A FLEXIBILIZACAO DO PROCEDIMENTO E AUTORIZADA PELO ART. 139, VI, DO CPC/2015, PODE O JUIZ, DE OFICIO, PRESERVADA A PREVISIBILIDADE DO RITO, ADAPTA-LO AS ESPECIFICIDADES DA CAUSA, OBSERVADAS AS GARANTIAS FUNDAMENTAIS DO PROCESSO\"). CITE-SE E INTIME-SE A PARTE RE PARA CONTESTAR O FEITO NO PRAZO DE 15 (QUINZE) DIAS UTEIS. A AUSENCIA DE CONTESTACAO IMPLICARA REVELIA E PRESUNCAO DE VERACIDADE DA MATERIA FATICA APRESENTADA NA PETICAO INICIAL. TRATANDO-SE DE PROCESSO ELETRONICO, EM PRESTIGIO AS REGRAS FUNDAMENTAIS DOS ARTIGOS 4 E 6 DO CPC, FICA VEDADO O EXERCICIO DA FACULDADE PREVISTA NO ARTIGO 340 DO CPC. INTIMEM-SE.",
                    "PublishDate": "2017-11-07T00:00:00",
                    "CaptureDate": "2021-11-18T03:26:54"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO",
                    "PublishDate": "2017-11-06T00:00:00",
                    "CaptureDate": "2018-06-09T07:54:11"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO",
                    "PublishDate": "2017-11-06T00:00:00",
                    "CaptureDate": "2018-03-02T11:52:41"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO",
                    "PublishDate": "2017-11-06T00:00:00",
                    "CaptureDate": "2018-02-27T12:56:07"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO",
                    "PublishDate": "2017-11-06T00:00:00",
                    "CaptureDate": "2018-02-27T06:39:48"
                  },
                  {
                    "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                    "PublishDate": "2017-10-31T00:00:00",
                    "CaptureDate": "2018-02-27T12:56:07"
                  },
                  {
                    "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                    "PublishDate": "2017-10-31T00:00:00",
                    "CaptureDate": "2018-02-27T06:39:48"
                  },
                  {
                    "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                    "PublishDate": "2017-10-31T00:00:00",
                    "CaptureDate": "2018-06-09T07:54:11"
                  },
                  {
                    "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                    "PublishDate": "2017-10-31T00:00:00",
                    "CaptureDate": "2018-03-02T11:52:41"
                  }
                ],
                "Petitions": [
                  {
                    "Type": "PETICOES DIVERSAS",
                    "Author": "",
                    "CreationDate": "2017-11-16T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  },
                  {
                    "Type": "CONTESTACAO",
                    "Author": "",
                    "CreationDate": "2017-11-30T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  },
                  {
                    "Type": "MANIFESTACAO SOBRE A CONTESTACAO",
                    "Author": "",
                    "CreationDate": "2017-12-19T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  },
                  {
                    "Type": "INDICACAO DE PROVAS",
                    "Author": "",
                    "CreationDate": "2017-12-19T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  },
                  {
                    "Type": "PETICOES DIVERSAS",
                    "Author": "",
                    "CreationDate": "2018-03-27T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  }
                ],
                "Decisions": [
                  {
                    "DecisionContent": "JULGO PARCIALMENTE PROCEDENTE O PEDIDO DA PRESENTE ACAO PARA CONDENAR A RE AO PAGAMENTO INDENIZACAO POR DANOS MORAIS AOS AUTORES, NO MONTANTE TOTAL DE R$ 10.000,00 (DEZ MIL REAIS), QUE DEVERAO SER CORRIGIDOS MONETARIAMENTE A CONTAR DA DATA DESTA SENTENCA E ACRESCIDOS DE JUROS DE MORA DE 1% (UM POR CENTO) AO MES A CONTAR DA CITACAO, BEM COMO NA RESTITUICAO DA QUANTIA PAGA PARA A AQUISICAO DE NOVAS PASSAGENS, CORRIGIDA MONETARIAMENTE A CONTAR DO DESEMBOLSO E ACRESCIDA DE JUROS LEGAIS DE MORA A CONTAR DA CITACAO.FICAM PARTILHADAS PROPORCIONALMENTE AS CUSTAS E DESPESAS PROCESSUAIS, DADA A SUCUMBENCIA RECIPROCA.ARCARA A RE COM O PAGAMENTO DE HONORARIOS ADVOCATICIOS DA PARTE AUTORA, QUE ARBITRO EM 10% DO VALOR DA CONDENACAO.ARCARAO OS AUTORES COM HONORARIOS ADVOCATICIOS DA PARTE CONTRARIA, QUE ARBITRO EM 10% SOBRE A PARTE QUE SUCUMBIU (DIFERENCA ENTRE O VALOR POSTULADO A TITULO DE DANOS MORAIS E AQUELE EFETIVAMENTE DEFERIDO).",
                    "DecisionDate": "2018-02-21T00:00:00"
                  },
                  {
                    "DecisionContent": "JULGO PARCIALMENTE PROCEDENTE O PEDIDO DA PRESENTE ACAO PARA CONDENAR A RE AO PAGAMENTO INDENIZACAO POR DANOS MORAIS AOS AUTORES, NO MONTANTE TOTAL DE R$ 10.000,00 (DEZ MIL REAIS), QUE DEVERAO SER CORRIGIDOS MONETARIAMENTE A CONTAR DA DATA DESTA SENTENCA E ACRESCIDOS DE JUROS DE MORA DE 1% (UM POR CENTO) AO MES A CONTAR DA CITACAO, BEM COMO NA RESTITUICAO DA QUANTIA PAGA PARA A AQUISICAO DE NOVAS PASSAGENS, CORRIGIDA MONETARIAMENTE A CONTAR DO DESEMBOLSO E ACRESCIDA DE JUROS LEGAIS DE MORA A CONTAR DA CITACAO.FICAM PARTILHADAS PROPORCIONALMENTE AS CUSTAS E DESPESAS PROCESSUAIS, DADA A SUCUMBENCIA RECIPROCA.ARCARA A RE COM O PAGAMENTO DE HONORARIOS ADVOCATICIOS DA PARTE AUTORA, QUE ARBITRO EM 10% DO VALOR DA CONDENACAO.ARCARAO OS AUTORES COM HONORARIOS ADVOCATICIOS DA PARTE CONTRARIA, QUE ARBITRO EM 10% SOBRE A PARTE QUE SUCUMBIU (DIFERENCA ENTRE O VALOR POSTULADO A TITULO DE DANOS MORAIS E AQUELE EFETIVAMENTE DEFERIDO).",
                    "DecisionDate": "2018-02-16T00:00:00"
                  }
                ]
              },
              {
                "Number": "10007444220188260100",
                "Type": "APELACAO CIVEL",
                "MainSubject": "DIREITO DO CONSUMIDOR - CONTRATOS DE CONSUMO - CARTAO DE CREDITO",
                "CourtName": "TJSP",
                "CourtLevel": "2",
                "CourtType": "CIVEL",
                "CourtDistrict": "",
                "Judge": "ELOI ESTEVAO TROLY",
                "JudgingBody": "15 CAMARA DE DIREITO PRIVADO",
                "State": "SP",
                "Status": "ARQUIVADO",
                "LawsuitHostService": "ESAJ",
                "InferredCNJSubjectName": "CARTÃO DE CRÉDITO",
                "InferredCNJSubjectNumber": 7772,
                "InferredCNJProcedureTypeName": "APELAÇÃO CÍVEL",
                "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
                "InferredBroadCNJSubjectNumber": 1156,
                "OtherSubjects": [
                  "DIREITO DO CONSUMIDOR - CONTRATOS DE CONSUMO - CARTAO DE CREDITO"
                ],
                "NumberOfVolumes": 0,
                "NumberOfPages": 0,
                "Value": 27121.64,
                "ResJudicataDate": "0001-01-01T00:00:00",
                "CloseDate": "2019-02-15T00:00:00",
                "RedistributionDate": "0001-01-01T00:00:00",
                "PublicationDate": "2019-03-19T00:00:00",
                "NoticeDate": "2018-07-27T00:00:00",
                "LastMovementDate": "2019-02-15T00:00:00",
                "CaptureDate": "2021-07-04T23:32:14",
                "LastUpdate": "2021-07-04T23:32:14",
                "NumberOfParties": 7,
                "NumberOfUpdates": 39,
                "LawSuitAge": 203,
                "AverageNumberOfUpdatesPerMonth": 0,
                "ReasonForConcealedData": 0,
                "Parties": [
                  {
                    "IsPartyActive": true,
                    "Name": "COMPANHIA BRASILEIRA DE SOLUCOES E SERVICOS S A",
                    "Polarity": "PASSIVE",
                    "Type": "CLAIMED",
                    "PartyDetails": {
                      "SpecificType": "APELADO"
                    },
                    "LastCaptureDate": "2021-07-04T23:32:14"
                  },
                  {
                    "Doc": "03587317801",
                    "IsPartyActive": true,
                    "Name": "ELOI ESTEVAO TROLY",
                    "Polarity": "NEUTRAL",
                    "Type": "REPORTER",
                    "PartyDetails": {
                      "SpecificType": "RELATOR"
                    },
                    "LastCaptureDate": "2021-07-04T23:32:14"
                  },
                  {
                    "IsPartyActive": true,
                    "Name": "HUMMINGBIRD PRODUCT STUDIO EIRELLI",
                    "Polarity": "ACTIVE",
                    "Type": "CLAIMANT",
                    "PartyDetails": {
                      "SpecificType": "APELANTE"
                    },
                    "LastCaptureDate": "2021-07-04T23:32:14"
                  },
                  {
                    "IsPartyActive": false,
                    "Name": "ALFREDO ZUCCA NETO",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "SpecificType": "ADVOGADO"
                    },
                    "LastCaptureDate": "2019-03-27T10:37:57"
                  },
                  {
                    "Doc": "02349014118",
                    "IsPartyActive": true,
                    "Name": "RAFAEL CASTRO DE MATOS",
                    "Polarity": "ACTIVE",
                    "Type": "CLAIMANT",
                    "PartyDetails": {
                      "SpecificType": "APELANTE"
                    },
                    "LastCaptureDate": "2021-07-04T23:32:14"
                  },
                  {
                    "Doc": "35068411817",
                    "IsPartyActive": true,
                    "Name": "RAFAEL HIDEO NAZIMA",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "295443",
                      "State": "SP",
                      "SpecificType": "ADVOGADO (APELANTE)"
                    },
                    "LastCaptureDate": "2021-07-04T23:32:14"
                  },
                  {
                    "Doc": "13349079865",
                    "IsPartyActive": true,
                    "Name": "ALFREDO ZUCCA NETO",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "154694",
                      "State": "SP",
                      "SpecificType": "ADVOGADO (APELADO)"
                    },
                    "LastCaptureDate": "2021-07-04T23:32:14"
                  }
                ],
                "Updates": [
                  {
                    "Content": "EXPEDIDO CERTIDAO CERTIDAO DE TRANSITO EM JULGADO [DIGITAL]",
                    "PublishDate": "2019-02-15T00:00:00",
                    "CaptureDate": "2019-03-27T10:38:01"
                  },
                  {
                    "Content": "BAIXA DEFINITIVA",
                    "PublishDate": "2019-02-15T00:00:00",
                    "CaptureDate": "2019-03-27T10:38:01"
                  },
                  {
                    "Content": "EXPEDIDO CERTIDAO DE BAIXA DE RECURSO CERTIDAO DE BAIXA DE RECURSO - [DIGITAL]",
                    "PublishDate": "2019-02-15T00:00:00",
                    "CaptureDate": "2019-03-27T10:38:01"
                  },
                  {
                    "Content": "EXPEDIDO CERTIDAO DE BAIXA DE RECURSO | CERTIDAO DE BAIXA DE RECURSO - [DIGITAL]",
                    "PublishDate": "2019-02-15T00:00:00",
                    "CaptureDate": "2021-07-04T23:32:14"
                  },
                  {
                    "Content": "EXPEDIDO CERTIDAO | CERTIDAO DE TRANSITO EM JULGADO [DIGITAL]",
                    "PublishDate": "2019-02-15T00:00:00",
                    "CaptureDate": "2021-07-04T23:32:14"
                  },
                  {
                    "Content": "PUBLICADO EM DISPONIBILIZADO EM 21/01/2019 TIPO DE PUBLICACAO: INTIMACAO DE ACORDAO NUMERO DO DIARIO ELETRONICO: 2732",
                    "PublishDate": "2019-01-22T00:00:00",
                    "CaptureDate": "2019-03-27T10:38:01"
                  },
                  {
                    "Content": "PUBLICADO EM | DISPONIBILIZADO EM 21/01/2019 TIPO DE PUBLICACAO: INTIMACAO DE ACORDAO NUMERO DO DIARIO ELETRONICO: 2732",
                    "PublishDate": "2019-01-22T00:00:00",
                    "CaptureDate": "2021-07-04T23:32:14"
                  },
                  {
                    "Content": "EXPEDIDO CERTIDAO CERTIDAO DE PUBLICACAO DE ACORDAO [DIGITAL]",
                    "PublishDate": "2019-01-21T00:00:00",
                    "CaptureDate": "2019-03-27T10:38:01"
                  },
                  {
                    "Content": "N 1000744-42.2018.8.26.0100 - PROCESSO DIGITAL. PETICOES PARA JUNTADA DEVEM SER APRESENTADAS EXCLUSIVAMENTE POR MEIO ELETRONICO, NOS TERMOS DO ARTIGO 7 DA RES. 551/2011 - APELACAO - SAO PAULO - APELANTE: RAFAEL CASTRO DE MATOS. E OUTRO - APELADO: COMPANHIA BRASILEIRA DE SOLUCOES E SERVICOS S.A. (ALELO) - MAGISTRADO(A) ELOI ESTEVAO TROLY - DERAM PROVIMENTO EM PARTE AO RECURSO. V. U. - APELACAO. CARTAO PRE-PAGO (VISA TRAVEL MONEY). RELACAO DE CONSUMO. APLICACAO DO CDC. INVIABILIDADE DA UTILIZACAO DE CARTAO, ADQUIRIDO PARA USO NO EXTERIOR. RE ALEGA QUE A RECUSA SE DEU POR INDICIOS DE FRAUDE NO MOMENTO DA TRANSACAO. RESPONSABILIDADE OBJETIVA DA RE (ART. 14, 3, I E II, DO CDC) QUE SOMENTE E AFASTADA NOS CASOS EM QUE O DEFEITO INEXISTE OU COMPROVADA A CULPA EXCLUSIVA DO CONSUMIDOR OU DE TERCEIRO, O QUE NAO FOI DEMONSTRADO NOS AUTOS. DANO MORAL, QUE SE COMPROVA COM O PROPRIO FATO (IN RE IPSA), FIXADO EM R$ 10.000,00. DIFERENCA DA ALIQUOTA DO IOF DEVIDA, VISTO QUE OS AUTORES FICARAM IMPOSSIBILITADOS DE UTILIZAR O CARTAO NA FUNCAO DEBITO, FUNCAO PELA QUAL SE ESCOLHE ESTA MODALIDADE DE COMPRA. LUCROS CESSANTES NAO CONFIGURADOS E INDEVIDOS. SUCUMBENCIA RECIPROCA. SENTENCA DE IMPROCEDENCIA MODIFICADA. RECURSO PROVIDO EM PARTE. ART. 1007 CPC - EVENTUAL RECURSO - SE AO STJ: CUSTAS R$ 179,37 - (GUIA GRU NO SITE HTTP://WWW.STJ.JUS.BR) - RESOLUCAO N 2 DE 01/02/2017 DO STJ; SE AO STF: CUSTAS R$ 198,95 - GUIA GRU - COBRANCA - FICHA DE COMPENSACAO - (EMITIDA ATRAVES DO SITE WWW.STF.JUS.BR) E PORTE DE REMESSA E RETORNO R$ 116,20 - GUIA FEDTJ - COD 140-6 - BANCO DO BRASIL OU INTERNET - RESOLUCAO N 609 DE 23/04/2018 DO STF. OS VALORES REFERENTES AO PORTE DE REMESSA E RETORNO, NAO SE APLICAM AOS PROCESSOS ELETRONICOS, DE ACORDO COM O ART. 4, INCISO II, DA RESOLUCAO N 609/2018 DO STF DE 23/04/2018. - ADVS: RAFAEL HIDEO NAZIMA (OAB: 295443/SP) - ALFREDO ZUCCA NETO (OAB: 154694/SP) - PATEO DO COLEGIO - SALAS 211/213",
                    "PublishDate": "2019-01-21T00:00:00",
                    "CaptureDate": "2019-01-25T18:26:58"
                  },
                  {
                    "Content": "PRAZO",
                    "PublishDate": "2019-01-21T00:00:00",
                    "CaptureDate": "2019-03-27T10:38:01"
                  },
                  {
                    "Content": "PRAZO",
                    "PublishDate": "2019-01-21T00:00:00",
                    "CaptureDate": "2021-07-04T23:32:14"
                  },
                  {
                    "Content": "EXPEDIDO CERTIDAO | CERTIDAO DE PUBLICACAO DE ACORDAO [DIGITAL]",
                    "PublishDate": "2019-01-21T00:00:00",
                    "CaptureDate": "2021-07-04T23:32:14"
                  },
                  {
                    "Content": "ACORDAO REGISTRADO ACORDAO REGISTRADO SOB N 20180001003111, COM 7 FOLHAS.",
                    "PublishDate": "2018-12-18T00:00:00",
                    "CaptureDate": "2019-03-27T10:38:01"
                  },
                  {
                    "Content": "ACORDAO REGISTRADO | ACORDAO REGISTRADO SOB N 20180001003111, COM 7 FOLHAS.",
                    "PublishDate": "2018-12-18T00:00:00",
                    "CaptureDate": "2021-07-04T23:32:14"
                  },
                  {
                    "Content": "PROCESSO ENCAMINHADO PARA O PROCESSAMENTO DE GRUPOS E CAMARAS PARA INTIMACAO DO ACORDAO - JULGAMENTO VIRTUAL",
                    "PublishDate": "2018-12-17T00:00:00",
                    "CaptureDate": "2019-03-27T10:38:01"
                  },
                  {
                    "Content": "JULGADO VIRTUALMENTE DERAM PROVIMENTO EM PARTE AO RECURSO. V. U.",
                    "PublishDate": "2018-12-17T00:00:00",
                    "CaptureDate": "2019-03-27T10:37:57"
                  },
                  {
                    "Content": "PROCESSO ENCAMINHADO PARA O PROCESSAMENTO DE GRUPOS E CAMARAS PARA INTIMACAO DO ACORDAO - JULGAMENTO VIRTUAL",
                    "PublishDate": "2018-12-17T00:00:00",
                    "CaptureDate": "2021-07-04T23:32:14"
                  },
                  {
                    "Content": "JULGADO VIRTUALMENTE | DERAM PROVIMENTO EM PARTE AO RECURSO. V. U.",
                    "PublishDate": "2018-12-17T00:00:00",
                    "CaptureDate": "2021-07-04T23:32:14"
                  },
                  {
                    "Content": "JULGAMENTO VIRTUAL INICIADO",
                    "PublishDate": "2018-12-10T00:00:00",
                    "CaptureDate": "2019-03-27T10:37:57"
                  },
                  {
                    "Content": "EXPEDIDO TERMO TERMO DE JUNTADA - AUTOMATICA",
                    "PublishDate": "2018-08-13T00:00:00",
                    "CaptureDate": "2019-03-27T10:37:57"
                  },
                  {
                    "Content": "PETICAO INTERMEDIARIA JUNTADA N PROTOCOLO: WPRO.18.00752975-6 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 09/08/2018 21:42",
                    "PublishDate": "2018-08-13T00:00:00",
                    "CaptureDate": "2019-03-27T10:37:57"
                  },
                  {
                    "Content": "PETICAO INTERMEDIARIA JUNTADA | N PROTOCOLO: WPRO.18.00752975-6 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 09/08/2018 21:42",
                    "PublishDate": "2018-08-13T00:00:00",
                    "CaptureDate": "2021-07-04T23:32:14"
                  },
                  {
                    "Content": "EXPEDIDO TERMO | TERMO DE JUNTADA - AUTOMATICA",
                    "PublishDate": "2018-08-13T00:00:00",
                    "CaptureDate": "2021-07-04T23:32:14"
                  },
                  {
                    "Content": "PUBLICADO EM DISPONIBILIZADO EM 03/08/2018 TIPO DE PUBLICACAO: DISTRIBUIDOS NUMERO DO DIARIO ELETRONICO: 2630",
                    "PublishDate": "2018-08-06T00:00:00",
                    "CaptureDate": "2019-03-27T10:37:57"
                  },
                  {
                    "Content": "PUBLICADO EM | DISPONIBILIZADO EM 03/08/2018 TIPO DE PUBLICACAO: DISTRIBUIDOS NUMERO DO DIARIO ELETRONICO: 2630",
                    "PublishDate": "2018-08-06T00:00:00",
                    "CaptureDate": "2021-07-04T23:32:14"
                  },
                  {
                    "Content": "CONCLUSOS PARA O RELATOR (EXPEDIDO TERMO COM CONCLUSAO) ELOI ESTEVAO TROLY",
                    "PublishDate": "2018-08-02T00:00:00",
                    "CaptureDate": "2019-03-27T10:37:57"
                  },
                  {
                    "Content": "PUBLICADO EM DISPONIBILIZADO EM 01/08/2018 TIPO DE PUBLICACAO: ENTRADOS NUMERO DO DIARIO ELETRONICO: 2628",
                    "PublishDate": "2018-08-02T00:00:00",
                    "CaptureDate": "2019-03-27T10:37:57"
                  },
                  {
                    "Content": "CONCLUSOS PARA O RELATOR (EXPEDIDO TERMO COM CONCLUSAO) | ELOI ESTEVAO TROLY",
                    "PublishDate": "2018-08-02T00:00:00",
                    "CaptureDate": "2021-07-04T23:32:14"
                  },
                  {
                    "Content": "PUBLICADO EM | DISPONIBILIZADO EM 01/08/2018 TIPO DE PUBLICACAO: ENTRADOS NUMERO DO DIARIO ELETRONICO: 2628",
                    "PublishDate": "2018-08-02T00:00:00",
                    "CaptureDate": "2021-07-04T23:32:14"
                  },
                  {
                    "Content": "DISTRIBUICAO POR SORTEIO ORGAO JULGADOR: 24 - 15 CAMARA DE DIREITO PRIVADO RELATOR: 11153 - ELOI ESTEVAO TROLY",
                    "PublishDate": "2018-08-01T00:00:00",
                    "CaptureDate": "2019-03-27T10:37:57"
                  },
                  {
                    "Content": "DISTRIBUICAO POR SORTEIO | ORGAO JULGADOR: 24 - 15 CAMARA DE DIREITO PRIVADO RELATOR: 11153 - ELOI ESTEVAO TROLY",
                    "PublishDate": "2018-08-01T00:00:00",
                    "CaptureDate": "2021-07-04T23:32:14"
                  },
                  {
                    "Content": "PROCESSO ENCAMINHADO PARA OUTRA SECAO MOTIVO: . SECAO ANTERIOR: FEITOS EM GRAU DE RECURSO - TRIAGEM SUBSECAO ANTERIOR: FEITOS EM GRAU DE RECURSO - TRIAGEM SECAO ATUAL: DIREITO PRIVADO SUBSECAO ATUAL: DIREITO PRIVADO 2",
                    "PublishDate": "2018-07-30T00:00:00",
                    "CaptureDate": "2019-03-27T10:37:57"
                  },
                  {
                    "Content": "PROCESSO ENCAMINHADO PARA A DISTRIBUICAO DE RECURSOS",
                    "PublishDate": "2018-07-30T00:00:00",
                    "CaptureDate": "2019-03-27T10:37:57"
                  },
                  {
                    "Content": "PROCESSO CADASTRADO SJ 2.1.2 - SERVICO DE ENTRADA DE AUTOS DE DIREITO PRIVADO 2",
                    "PublishDate": "2018-07-30T00:00:00",
                    "CaptureDate": "2019-03-27T10:37:57"
                  },
                  {
                    "Content": "PROCESSO ENCAMINHADO PARA A DISTRIBUICAO DE RECURSOS",
                    "PublishDate": "2018-07-30T00:00:00",
                    "CaptureDate": "2021-07-04T23:32:14"
                  },
                  {
                    "Content": "PROCESSO CADASTRADO | SJ 2.1.2 - SERVICO DE ENTRADA DE AUTOS DE DIREITO PRIVADO 2",
                    "PublishDate": "2018-07-30T00:00:00",
                    "CaptureDate": "2021-07-04T23:32:14"
                  },
                  {
                    "Content": "PROCESSO ENCAMINHADO PARA OUTRA SECAO | MOTIVO: . SECAO ANTERIOR: FEITOS EM GRAU DE RECURSO - TRIAGEM SUBSECAO ANTERIOR: FEITOS EM GRAU DE RECURSO - TRIAGEM SECAO ATUAL: DIREITO PRIVADO SUBSECAO ATUAL: DIREITO PRIVADO 2",
                    "PublishDate": "2018-07-30T00:00:00",
                    "CaptureDate": "2021-07-04T23:32:14"
                  },
                  {
                    "Content": "RECEBIDOS OS AUTOS PELA ENTRADA DE RECURSOS FORO DE ORIGEM: FORO CENTRAL CIVEL VARA DE ORIGEM: 12 VARA CIVEL",
                    "PublishDate": "2018-07-27T00:00:00",
                    "CaptureDate": "2019-03-27T10:37:57"
                  },
                  {
                    "Content": "RECEBIDOS OS AUTOS PELA ENTRADA DE RECURSOS | FORO DE ORIGEM: FORO CENTRAL CIVEL VARA DE ORIGEM: 12 VARA CIVEL",
                    "PublishDate": "2018-07-27T00:00:00",
                    "CaptureDate": "2021-07-04T23:32:14"
                  }
                ],
                "Petitions": [
                  {
                    "Type": "PETICOES DIVERSAS",
                    "Author": "",
                    "CreationDate": "2018-08-09T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  }
                ],
                "Decisions": []
              },
              {
                "Number": "10682751420198260100",
                "Type": "PROCEDIMENTO COMUM",
                "MainSubject": "PRODUTO IMPROPRIO",
                "CourtName": "TJSP",
                "CourtLevel": "1",
                "CourtType": "CIVEL",
                "CourtDistrict": "",
                "Judge": "GUSTAVO COUBE DE CARVALHO",
                "JudgingBody": "5 VARA CIVEL - FORO CENTRAL CIVEL",
                "State": "SP",
                "Status": "INDEFINIDO",
                "LawsuitHostService": "ESAJ",
                "InferredCNJSubjectName": "PRODUTO IMPRÓPRIO",
                "InferredCNJSubjectNumber": 11867,
                "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
                "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
                "InferredBroadCNJSubjectNumber": 1156,
                "OtherSubjects": [
                  "PRODUTO IMPROPRIO"
                ],
                "NumberOfVolumes": 0,
                "NumberOfPages": 0,
                "Value": 10554,
                "ResJudicataDate": "0001-01-01T00:00:00",
                "CloseDate": "0001-01-01T00:00:00",
                "RedistributionDate": "0001-01-01T00:00:00",
                "PublicationDate": "2019-11-26T00:00:00",
                "NoticeDate": "2019-07-17T00:00:00",
                "LastMovementDate": "2021-03-09T00:00:00",
                "CaptureDate": "2019-11-27T01:51:07",
                "LastUpdate": "2019-11-27T01:51:07",
                "NumberOfParties": 23,
                "NumberOfUpdates": 95,
                "LawSuitAge": 1687,
                "AverageNumberOfUpdatesPerMonth": 1,
                "ReasonForConcealedData": 0,
                "Parties": [
                  {
                    "Doc": "29331802862",
                    "IsPartyActive": true,
                    "Name": "GUSTAVO COUBE DE CARVALHO",
                    "Polarity": "NEUTRAL",
                    "Type": "REPORTER",
                    "PartyDetails": {
                      "OAB": "209198",
                      "State": "SP",
                      "SpecificType": "JUIZ"
                    },
                    "LastCaptureDate": "2019-11-27T01:51:07"
                  },
                  {
                    "Doc": "02349014118",
                    "IsPartyActive": true,
                    "Name": "RAFAEL CASTRO DE MATOS",
                    "Polarity": "ACTIVE",
                    "Type": "CLAIMANT",
                    "PartyDetails": {
                      "SpecificType": "REQTE"
                    },
                    "LastCaptureDate": "2019-11-27T01:51:07"
                  },
                  {
                    "Doc": "35068411817",
                    "IsPartyActive": true,
                    "Name": "RAFAEL HIDEO NAZIMA",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "295443",
                      "State": "SP",
                      "SpecificType": "ADVOGADO"
                    },
                    "LastCaptureDate": "2019-11-27T01:51:07"
                  },
                  {
                    "Doc": "12043596001915",
                    "IsPartyActive": true,
                    "Name": "AQUILON TELECOMUNICACOES LTDA",
                    "Polarity": "PASSIVE",
                    "Type": "CLAIMED",
                    "PartyDetails": {
                      "SpecificType": "REQDO"
                    },
                    "LastCaptureDate": "2019-11-27T01:51:07"
                  },
                  {
                    "Doc": "02349014118",
                    "IsPartyActive": true,
                    "Name": "RAFAEL CASTRO DE MATOS",
                    "Polarity": "ACTIVE",
                    "Type": "CLAIMANT",
                    "PartyDetails": {
                      "SpecificType": "REQTE"
                    },
                    "LastCaptureDate": "2019-11-27T01:51:07"
                  },
                  {
                    "Doc": "35068411817",
                    "IsPartyActive": true,
                    "Name": "RAFAEL HIDEO NAZIMA",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "295443",
                      "State": "SP",
                      "SpecificType": "ADVOGADO REQUERENTE"
                    },
                    "LastCaptureDate": "2019-11-27T01:51:07"
                  },
                  {
                    "Doc": "40247570915",
                    "IsPartyActive": true,
                    "Name": "GABRIEL ANTONIO HENKE NEIVA DE LIMA FILHO",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "420786",
                      "State": "SP",
                      "SpecificType": "ADVOGADO REQUERIDO"
                    },
                    "LastCaptureDate": "2019-11-27T01:51:07"
                  },
                  {
                    "Doc": "04859002970",
                    "IsPartyActive": true,
                    "Name": "TIAGO GODOY ZANICOTTI",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "437516",
                      "State": "SP",
                      "SpecificType": "ADVOGADO REQUERIDO"
                    },
                    "LastCaptureDate": "2019-11-27T01:51:07"
                  },
                  {
                    "Doc": "40247570915",
                    "IsPartyActive": true,
                    "Name": "GABRIEL ANTONIO HENKE NEIVA DE LIMA FILHO",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "23378",
                      "State": "PR",
                      "SpecificType": "ADVOGADO"
                    },
                    "LastCaptureDate": "2019-11-27T01:51:07"
                  },
                  {
                    "Doc": "04859002970",
                    "IsPartyActive": true,
                    "Name": "TIAGO GODOY ZANICOTTI",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "437516",
                      "State": "SP",
                      "SpecificType": "ADVOGADO"
                    },
                    "LastCaptureDate": "2019-11-27T01:51:07"
                  },
                  {
                    "Doc": "29331802862",
                    "IsPartyActive": true,
                    "Name": "GUSTAVO COUBE DE CARVALHO",
                    "Polarity": "NEUTRAL",
                    "Type": "REPORTER",
                    "PartyDetails": {
                      "OAB": "209198",
                      "State": "SP",
                      "SpecificType": "JUIZ"
                    },
                    "LastCaptureDate": "2019-11-27T01:51:07"
                  },
                  {
                    "Doc": "35068411817",
                    "IsPartyActive": true,
                    "Name": "RAFAEL HIDEO NAZIMA",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "295443",
                      "State": "SP",
                      "SpecificType": "ADVOGADO (REQTE)"
                    },
                    "LastCaptureDate": "2019-11-27T01:51:07"
                  },
                  {
                    "Doc": "40247570915",
                    "IsPartyActive": true,
                    "Name": "GABRIEL ANTONIO HENKE NEIVA DE LIMA FILHO",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "420786",
                      "State": "SP",
                      "SpecificType": "ADVOGADO (REQDO)"
                    },
                    "LastCaptureDate": "2019-11-27T01:51:07"
                  },
                  {
                    "Doc": "04859002970",
                    "IsPartyActive": true,
                    "Name": "TIAGO GODOY ZANICOTTI",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "437516",
                      "State": "SP",
                      "SpecificType": "ADVOGADO (REQDO)"
                    },
                    "LastCaptureDate": "2019-11-27T01:51:07"
                  },
                  {
                    "Doc": "35068411817",
                    "IsPartyActive": true,
                    "Name": "RAFAEL HIDEO NAZIMA",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "295443",
                      "State": "SP",
                      "SpecificType": "ADVOGADO (REQTE)"
                    },
                    "LastCaptureDate": "2019-11-27T01:51:07"
                  },
                  {
                    "Doc": "40247570915",
                    "IsPartyActive": true,
                    "Name": "GABRIEL ANTONIO HENKE NEIVA DE LIMA FILHO",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "420786",
                      "State": "SP",
                      "SpecificType": "ADVOGADO (REQDO)"
                    },
                    "LastCaptureDate": "2019-11-27T01:51:07"
                  },
                  {
                    "Doc": "04859002970",
                    "IsPartyActive": true,
                    "Name": "TIAGO GODOY ZANICOTTI",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "437516",
                      "State": "SP",
                      "SpecificType": "ADVOGADO (REQDO)"
                    },
                    "LastCaptureDate": "2019-11-27T01:51:07"
                  },
                  {
                    "Doc": "35068411817",
                    "IsPartyActive": true,
                    "Name": "RAFAEL HIDEO NAZIMA",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "295443",
                      "State": "SP",
                      "SpecificType": "ADVOGADO (REQTE)"
                    },
                    "LastCaptureDate": "2019-11-27T01:51:07"
                  },
                  {
                    "Doc": "40247570915",
                    "IsPartyActive": true,
                    "Name": "GABRIEL ANTONIO HENKE NEIVA DE LIMA FILHO",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "420786",
                      "State": "SP",
                      "SpecificType": "ADVOGADO (REQDO)"
                    },
                    "LastCaptureDate": "2019-11-27T01:51:07"
                  },
                  {
                    "Doc": "04859002970",
                    "IsPartyActive": true,
                    "Name": "TIAGO GODOY ZANICOTTI",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "437516",
                      "State": "SP",
                      "SpecificType": "ADVOGADO (REQDO)"
                    },
                    "LastCaptureDate": "2019-11-27T01:51:07"
                  },
                  {
                    "Doc": "35068411817",
                    "IsPartyActive": true,
                    "Name": "RAFAEL HIDEO NAZIMA",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "295443",
                      "State": "SP",
                      "SpecificType": "ADVOGADO (REQTE)"
                    },
                    "LastCaptureDate": "2019-11-27T01:51:07"
                  },
                  {
                    "Doc": "40247570915",
                    "IsPartyActive": true,
                    "Name": "GABRIEL ANTONIO HENKE NEIVA DE LIMA FILHO",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "420786",
                      "State": "SP",
                      "SpecificType": "ADVOGADO (REQDO)"
                    },
                    "LastCaptureDate": "2019-11-27T01:51:07"
                  },
                  {
                    "Doc": "04859002970",
                    "IsPartyActive": true,
                    "Name": "TIAGO GODOY ZANICOTTI",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "437516",
                      "State": "SP",
                      "SpecificType": "ADVOGADO (REQDO)"
                    },
                    "LastCaptureDate": "2019-11-27T01:51:07"
                  }
                ],
                "Updates": [
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0045/2021 DATA DA DISPONIBILIZACAO: 09/03/2021 DATA DA PUBLICACAO: 10/03/2021 NUMERO DO DIARIO: 3233 PAGINA: 865-873",
                    "PublishDate": "2021-03-09T00:00:00",
                    "CaptureDate": "2021-03-14T02:01:18"
                  },
                  {
                    "Content": "PROCESSO 1068275-14.2019.8.26.0100 - PROCEDIMENTO COMUM CIVEL - PRODUTO IMPROPRIO - RAFAEL CASTRO DE MATOS - AQUILON TELECOMUNICACOES LTDA. - FLS.144/145: DEFIRO, MEDIANTE RECIBO (FLS.49/50). FLS.146/148: CUMPRIMENTO DE SENTENCA DEVERA SER INICIADO NOS TERMOS DO COMUNICADO CG N. 1789/2017. OPORTUNAMENTE, ANOTE-SE A EXTINCAO E AO ARQUIVO. - ADV: TIAGO GODOY ZANICOTTI (OAB 437516/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP), GABRIEL ANTONIO HENKE NEIVA DE LIMA FILHO (OAB 420786/SP)",
                    "PublishDate": "2021-03-09T00:00:00",
                    "CaptureDate": "2021-03-14T02:01:18"
                  },
                  {
                    "Content": "REMETIDO AO DJE | RELACAO: 0045/2021 TEOR DO ATO: FLS.144/145: DEFIRO, MEDIANTE RECIBO (FLS.49/50). FLS.146/148: CUMPRIMENTO DE SENTENCA DEVERA SER INICIADO NOS TERMOS DO COMUNICADO CG N. 1789/2017. OPORTUNAMENTE, ANOTE-SE A EXTINCAO E AO ARQUIVO. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP), GABRIEL ANTONIO HENKE NEIVA DE LIMA FILHO (OAB 420786/SP), TIAGO GODOY ZANICOTTI (OAB 437516/SP)",
                    "PublishDate": "2021-03-08T00:00:00",
                    "CaptureDate": "2021-03-14T02:01:18"
                  },
                  {
                    "Content": "DECISAO | FLS.144/145: DEFIRO, MEDIANTE RECIBO (FLS.49/50). FLS.146/148: CUMPRIMENTO DE SENTENCA DEVERA SER INICIADO NOS TERMOS DO COMUNICADO CG N. 1789/2017. OPORTUNAMENTE, ANOTE-SE A EXTINCAO E AO ARQUIVO.",
                    "PublishDate": "2021-03-05T00:00:00",
                    "CaptureDate": "2021-03-14T02:01:18"
                  },
                  {
                    "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.21.40238249-9 TIPO DA PETICAO: PETICAO INTERMEDIARIA DATA: 19/02/2021 16:39",
                    "PublishDate": "2021-02-19T00:00:00",
                    "CaptureDate": "2021-03-14T02:01:18"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO",
                    "PublishDate": "2021-02-16T00:00:00",
                    "CaptureDate": "2021-03-14T02:01:18"
                  },
                  {
                    "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.21.40181604-5 TIPO DA PETICAO: PETICAO INTERMEDIARIA DATA: 11/02/2021 14:55",
                    "PublishDate": "2021-02-11T00:00:00",
                    "CaptureDate": "2021-03-14T02:01:18"
                  },
                  {
                    "Content": "INICIO DA EXECUCAO JUNTADO | 0000908-19.2021.8.26.0100 - CUMPRIMENTO DE SENTENCA",
                    "PublishDate": "2021-01-12T00:00:00",
                    "CaptureDate": "2021-03-14T02:01:18"
                  },
                  {
                    "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.21.40015501-0 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 11/01/2021 23:11",
                    "PublishDate": "2021-01-12T00:00:00",
                    "CaptureDate": "2021-03-14T02:01:18"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0317/2020 DATA DA DISPONIBILIZACAO: 26/11/2020 DATA DA PUBLICACAO: 27/11/2020 NUMERO DO DIARIO: 3176 PAGINA: 88-96",
                    "PublishDate": "2020-11-26T00:00:00",
                    "CaptureDate": "2020-11-27T06:14:28"
                  },
                  {
                    "Content": "PROCESSO 1068275-14.2019.8.26.0100 - PROCEDIMENTO COMUM CIVEL - PRODUTO IMPROPRIO - RAFAEL CASTRO DE MATOS - AQUILON TELECOMUNICACOES LTDA. - MOTIVO DO ATO: PROCESSO EXTINTO. CONTEUDO DO ATO: CIENCIA AS PARTES DO TRANSITO EM JULGADO. EVENTUAL CUMPRIMENTO DE SENTENCA DEVERA SER OBJETO DE INCIDENTE PROPRIO INICIADO POR PETICAO INTERMEDIARIA, NOS TERMOS DO COMUNICADO CG N. 1789/2017. OS PRESENTES AUTOS SERAO ARQUIVADOS COM ANOTACAO DE BAIXA. FIM DO ATO. - ADV: GABRIEL ANTONIO HENKE NEIVA DE LIMA FILHO (OAB 420786/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP), TIAGO GODOY ZANICOTTI (OAB 437516/SP)",
                    "PublishDate": "2020-11-26T00:00:00",
                    "CaptureDate": "2020-11-27T06:14:28"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0317/2020 DATA DA DISPONIBILIZACAO: 26/11/2020 DATA DA PUBLICACAO: 27/11/2020 NUMERO DO DIARIO: 3176 PAGINA: 88-96",
                    "PublishDate": "2020-11-26T00:00:00",
                    "CaptureDate": "2021-03-14T02:01:18"
                  },
                  {
                    "Content": "REMETIDO AO DJE RELACAO: 0317/2020 TEOR DO ATO: MOTIVO DO ATO: PROCESSO EXTINTO. CONTEUDO DO ATO: CIENCIA AS PARTES DO TRANSITO EM JULGADO. EVENTUAL CUMPRIMENTO DE SENTENCA DEVERA SER OBJETO DE INCIDENTE PROPRIO INICIADO POR PETICAO INTERMEDIARIA, NOS TERMOS DO COMUNICADO CG N. 1789/2017. OS PRESENTES AUTOS SERAO ARQUIVADOS COM ANOTACAO DE BAIXA. FIM DO ATO. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP), GABRIEL ANTONIO HENKE NEIVA DE LIMA FILHO (OAB 420786/SP), TIAGO GODOY ZANICOTTI (OAB 437516/SP)",
                    "PublishDate": "2020-11-25T00:00:00",
                    "CaptureDate": "2020-11-27T06:14:28"
                  },
                  {
                    "Content": "REMETIDO AO DJE | RELACAO: 0317/2020 TEOR DO ATO: MOTIVO DO ATO: PROCESSO EXTINTO. CONTEUDO DO ATO: CIENCIA AS PARTES DO TRANSITO EM JULGADO. EVENTUAL CUMPRIMENTO DE SENTENCA DEVERA SER OBJETO DE INCIDENTE PROPRIO INICIADO POR PETICAO INTERMEDIARIA, NOS TERMOS DO COMUNICADO CG N. 1789/2017. OS PRESENTES AUTOS SERAO ARQUIVADOS COM ANOTACAO DE BAIXA. FIM DO ATO. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP), GABRIEL ANTONIO HENKE NEIVA DE LIMA FILHO (OAB 420786/SP), TIAGO GODOY ZANICOTTI (OAB 437516/SP)",
                    "PublishDate": "2020-11-25T00:00:00",
                    "CaptureDate": "2021-03-14T02:01:18"
                  },
                  {
                    "Content": "RECEBIDOS OS AUTOS DO TRIBUNAL DE JUSTICA",
                    "PublishDate": "2020-11-23T00:00:00",
                    "CaptureDate": "2020-11-27T06:14:28"
                  },
                  {
                    "Content": "ATO ORDINATORIO - PUBLICAVEL MOTIVO DO ATO: PROCESSO EXTINTO. CONTEUDO DO ATO: CIENCIA AS PARTES DO TRANSITO EM JULGADO. EVENTUAL CUMPRIMENTO DE SENTENCA DEVERA SER OBJETO DE INCIDENTE PROPRIO INICIADO POR PETICAO INTERMEDIARIA, NOS TERMOS DO COMUNICADO CG N. 1789/2017. OS PRESENTES AUTOS SERAO ARQUIVADOS COM ANOTACAO DE BAIXA. FIM DO ATO.",
                    "PublishDate": "2020-11-23T00:00:00",
                    "CaptureDate": "2020-11-27T06:14:28"
                  },
                  {
                    "Content": "ATO ORDINATORIO - PUBLICAVEL | MOTIVO DO ATO: PROCESSO EXTINTO. CONTEUDO DO ATO: CIENCIA AS PARTES DO TRANSITO EM JULGADO. EVENTUAL CUMPRIMENTO DE SENTENCA DEVERA SER OBJETO DE INCIDENTE PROPRIO INICIADO POR PETICAO INTERMEDIARIA, NOS TERMOS DO COMUNICADO CG N. 1789/2017. OS PRESENTES AUTOS SERAO ARQUIVADOS COM ANOTACAO DE BAIXA. FIM DO ATO.",
                    "PublishDate": "2020-11-23T00:00:00",
                    "CaptureDate": "2021-03-14T02:01:18"
                  },
                  {
                    "Content": "RECEBIDOS OS AUTOS DO TRIBUNAL DE JUSTICA",
                    "PublishDate": "2020-11-23T00:00:00",
                    "CaptureDate": "2021-03-14T02:01:18"
                  },
                  {
                    "Content": "N 1068275-14.2019.8.26.0100 - PROCESSO DIGITAL. PETICOES PARA JUNTADA DEVEM SER APRESENTADAS EXCLUSIVAMENTE POR MEIO ELETRONICO, NOS TERMOS DO ARTIGO 7 DA RES. 551/2011 - APELACAO CIVEL - SAO PAULO - APELANTE: RAFAEL CASTRO DE MATOS - APELADO: AQUILON TELECOMUNICACOES LTDA. - MAGISTRADO(A) ROSANGELA TELLES - NEGARAM PROVIMENTO AO RECURSO. V. U. - APELACAO. ACAO INDENIZATORIA. DANOS MORAIS. INOCORRENCIA. APELADA QUE VENDEU AO APELANTE CELULAR USADO COMO SE NOVO FOSSE. AUSENCIA DE LESAO A DIREITO DA PERSONALIDADE. O MERO DESCUMPRIMENTO DE CLAUSULAS CONTRATUAIS NAO IMPLICA POR SI SO, NA CONFIGURACAO DE DANOS MORAIS, NOTADAMENTE NA HIPOTESE SUB JUDICE. O APELANTE, COM EFEITO, NAO DEMONSTROU NENHUM ABALO EXCEPCIONAL, DERIVADO DA ENTREGA DE PRODUTO EM DESCONFORMIDADE COM A OFERTA, ALEM DO DESCONFORTO, QUE LHE E INSITO. AS DIMENSOES PEDAGOGICAS E PUNITIVAS DA INDENIZACAO POR DANOS MORAIS APENAS PODERAO INCIDIR QUANDO HOUVER ABALO A DIMENSAO EXTRAPATRIMONIAL DO SUJEITO DE DIREITO. SUCUMBENCIA. MANUTENCAO DA SUCUMBENCIA RECIPROCA E IMPOSICAO DE HONORARIOS RECURSAIS, NOS TERMOS DO ART. 85,  11 DO CPC/15. SENTENCA MANTIDA. RECURSO NAO PROVIDO. ART. 1007 CPC - EVENTUAL RECURSO - SE AO STJ: CUSTAS R$ 194,12 - (GUIA GRU NO SITE HTTP://WWW.STJ.JUS.BR) - RESOLUCAO N. 02 DE 02/01/2020 DO STJ; SE AO STF: CUSTAS R$ 214,71 - GUIA GRU - COBRANCA - FICHA DE COMPENSACAO - (EMITIDA ATRAVES DO SITE WWW.STF.JUS.BR) E PORTE DE REMESSA E RETORNO R$ 118,90 - GUIA FEDTJ - COD 140-6 - BANCO DO BRASIL OU INTERNET - RESOLUCAO N. 662 DE 10/02/2020 DO STF. OS VALORES REFERENTES AO PORTE DE REMESSA E RETORNO, NAO SE APLICAM AOS PROCESSOS ELETRONICOS, DE ACORDO COM O ART. 4, INCISO II, DA RESOLUCAO N. 662 DE 10/02/2020 DO STF. - ADVS: RAFAEL HIDEO NAZIMA (OAB: 295443/SP) - GABRIEL ANTONIO HENKE NEIVA DE LIMA FILHO (OAB: 23378/PR) - TIAGO GODOY ZANICOTTI (OAB: 44170/PR) - CONSELHEIRO FURTADO, N 503 - 4 ANDAR",
                    "PublishDate": "2020-10-22T00:00:00",
                    "CaptureDate": "2020-10-23T00:51:54"
                  },
                  {
                    "Content": "1068275-14.2019.8.26.0100; PROCESSO DIGITAL. PETICOES PARA JUNTADA DEVEM SER APRESENTADAS EXCLUSIVAMENTE POR MEIO ELETRONICO, NOS TERMOS DO ARTIGO 7 DA RES. 551/2011; APELACAO CIVEL; 27 CAMARA DE DIREITO PRIVADO; ROSANGELA TELLES; FORO CENTRAL CIVEL; 5 VARA CIVEL; PROCEDIMENTO COMUM CIVEL; 1068275-14.2019.8.26.0100; COMPRA E VENDA; APELANTE: RAFAEL CASTRO DE MATOS; ADVOGADO: RAFAEL HIDEO NAZIMA (OAB: 295443/SP); APELADO: AQUILON TELECOMUNICACOES LTDA.; ADVOGADO: GABRIEL ANTONIO HENKE NEIVA DE LIMA FILHO (OAB: 23378/PR); ADVOGADO: TIAGO GODOY ZANICOTTI (OAB: 44170/PR); FICAM AS PARTES INTIMADAS PARA MANIFESTAREM-SE ACERCA DE EVENTUAL OPOSICAO AO JULGAMENTO VIRTUAL, NOS TERMOS DO ART. 1 DA RESOLUCAO 549/2011, COM REDACAO ESTABELECIDA PELA RESOLUCAO 772/2017, AMBAS DO ORGAO ESPECIAL DESTE TRIBUNAL.",
                    "PublishDate": "2020-10-08T00:00:00",
                    "CaptureDate": "2020-10-14T20:30:13"
                  },
                  {
                    "Content": "1068275-14.2019.8.26.0100; PROCESSO DIGITAL. PETICOES PARA JUNTADA DEVEM SER APRESENTADAS EXCLUSIVAMENTE POR MEIO ELETRONICO, NOS TERMOS DO ARTIGO 7 DA RES. 551/2011; APELACAO CIVEL; COMARCA: SAO PAULO; VARA: 5 VARA CIVEL; ACAO : PROCEDIMENTO COMUM CIVEL; N ORIGEM: 1068275-14.2019.8.26.0100; ASSUNTO: COMPRA E VENDA; APELANTE: RAFAEL CASTRO DE MATOS; ADVOGADO: RAFAEL HIDEO NAZIMA (OAB: 295443/SP); APELADO: AQUILON TELECOMUNICACOES LTDA.; ADVOGADO: GABRIEL ANTONIO HENKE NEIVA DE LIMA FILHO (OAB: 23378/PR); ADVOGADO: TIAGO GODOY ZANICOTTI (OAB: 44170/PR); HAVENDO INTERESSE NA TENTATIVA DE CONCILIACAO, AS PARTES DEVERAO SE MANIFESTAR NESSE SENTIDO (POR PETICAO OU, PREFERENCIALMENTE, PELO FORMULARIO ELETRONICO DISPONIVEL NO SITE WWW.TJSP.JUS.BR). TERAO PRIORIDADE NO AGENDAMENTO OS PROCESSOS EM QUE TODAS AS PARTES SE MANIFESTAREM POSITIVAMENTE, FICANDO, CONTUDO, ESCLARECIDO QUE A SESSAO CONCILIATORIA TAMBEM PODERA SER DESIGNADA POR INICIATIVA DO PROPRIO TRIBUNAL.",
                    "PublishDate": "2020-09-29T00:00:00",
                    "CaptureDate": "2020-10-29T09:28:23"
                  },
                  {
                    "Content": "CERTIDAO DE CARTORIO EXPEDIDA CERTIDAO - REMESSA DOS AUTOS A 2 INSTANCIA - ART. 102 - NSCGJ",
                    "PublishDate": "2020-09-25T00:00:00",
                    "CaptureDate": "2020-10-02T21:17:58"
                  },
                  {
                    "Content": "REMETIDOS OS AUTOS PARA O TRIBUNAL DE JUSTICA/COLEGIO RECURSAL - PROCESSO DIGITAL",
                    "PublishDate": "2020-09-25T00:00:00",
                    "CaptureDate": "2020-10-02T21:17:58"
                  },
                  {
                    "Content": "REMETIDOS OS AUTOS PARA O TRIBUNAL DE JUSTICA/COLEGIO RECURSAL - PROCESSO DIGITAL",
                    "PublishDate": "2020-09-25T00:00:00",
                    "CaptureDate": "2021-03-14T02:01:18"
                  },
                  {
                    "Content": "CERTIDAO DE CARTORIO EXPEDIDA | CERTIDAO - REMESSA DOS AUTOS A 2 INSTANCIA - ART. 102 - NSCGJ",
                    "PublishDate": "2020-09-25T00:00:00",
                    "CaptureDate": "2021-03-14T02:01:18"
                  },
                  {
                    "Content": "CONTRARRAZOES JUNTADA N PROTOCOLO: WJMJ.20.41071711-8 TIPO DA PETICAO: CONTRARRAZOES DE APELACAO DATA: 22/07/2020 16:10",
                    "PublishDate": "2020-07-22T00:00:00",
                    "CaptureDate": "2020-10-02T21:17:58"
                  },
                  {
                    "Content": "CONTRARRAZOES JUNTADA | N PROTOCOLO: WJMJ.20.41071711-8 TIPO DA PETICAO: CONTRARRAZOES DE APELACAO DATA: 22/07/2020 16:10",
                    "PublishDate": "2020-07-22T00:00:00",
                    "CaptureDate": "2021-03-14T02:01:18"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0173/2020 DATA DA DISPONIBILIZACAO: 02/07/2020 DATA DA PUBLICACAO: 03/07/2020 NUMERO DO DIARIO: 3075 PAGINA: 69-78",
                    "PublishDate": "2020-07-02T00:00:00",
                    "CaptureDate": "2020-10-02T21:17:58"
                  },
                  {
                    "Content": "PROCESSO 1068275-14.2019.8.26.0100 - PROCEDIMENTO COMUM CIVEL - PRODUTO IMPROPRIO - RAFAEL CASTRO DE MATOS - AQUILON TELECOMUNICACOES LTDA. - ATO ORDINATORIO: CIENCIA QUANTO A INTERPOSICAO DE APELACAO PELA PARTE AUTORA, BEM COMO QUANTO AO PRAZO DE 15 DIAS PARA APRESENTACAO DE CONTRARRAZOES. ESCOADO O PRAZO, OS AUTOS SERAO REMETIDOS AO E. TRIBUNAL DE JUSTICA.. - ADV: RAFAEL HIDEO NAZIMA (OAB 295443/SP), TIAGO GODOY ZANICOTTI (OAB 437516/SP), GABRIEL ANTONIO HENKE NEIVA DE LIMA FILHO (OAB 420786/SP)",
                    "PublishDate": "2020-07-02T00:00:00",
                    "CaptureDate": "2020-10-02T21:17:58"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0173/2020 DATA DA DISPONIBILIZACAO: 02/07/2020 DATA DA PUBLICACAO: 03/07/2020 NUMERO DO DIARIO: 3075 PAGINA: 69-78",
                    "PublishDate": "2020-07-02T00:00:00",
                    "CaptureDate": "2021-03-14T02:01:18"
                  },
                  {
                    "Content": "REMETIDO AO DJE RELACAO: 0173/2020 TEOR DO ATO: ATO ORDINATORIO: \"CIENCIA QUANTO A INTERPOSICAO DE APELACAO PELA PARTE AUTORA, BEM COMO QUANTO AO PRAZO DE 15 DIAS PARA APRESENTACAO DE CONTRARRAZOES. ESCOADO O PRAZO, OS AUTOS SERAO REMETIDOS AO E. TRIBUNAL DE JUSTICA.\". ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP), GABRIEL ANTONIO HENKE NEIVA DE LIMA FILHO (OAB 420786/SP), TIAGO GODOY ZANICOTTI (OAB 437516/SP)",
                    "PublishDate": "2020-07-01T00:00:00",
                    "CaptureDate": "2020-10-02T21:17:58"
                  },
                  {
                    "Content": "REMETIDO AO DJE | RELACAO: 0173/2020 TEOR DO ATO: ATO ORDINATORIO: \"CIENCIA QUANTO A INTERPOSICAO DE APELACAO PELA PARTE AUTORA, BEM COMO QUANTO AO PRAZO DE 15 DIAS PARA APRESENTACAO DE CONTRARRAZOES. ESCOADO O PRAZO, OS AUTOS SERAO REMETIDOS AO E. TRIBUNAL DE JUSTICA.\". ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP), GABRIEL ANTONIO HENKE NEIVA DE LIMA FILHO (OAB 420786/SP), TIAGO GODOY ZANICOTTI (OAB 437516/SP)",
                    "PublishDate": "2020-07-01T00:00:00",
                    "CaptureDate": "2021-03-14T02:01:18"
                  },
                  {
                    "Content": "ATO ORDINATORIO - PUBLICAVEL ATO ORDINATORIO: \"CIENCIA QUANTO A INTERPOSICAO DE APELACAO PELA PARTE AUTORA, BEM COMO QUANTO AO PRAZO DE 15 DIAS PARA APRESENTACAO DE CONTRARRAZOES. ESCOADO O PRAZO, OS AUTOS SERAO REMETIDOS AO E. TRIBUNAL DE JUSTICA.\".",
                    "PublishDate": "2020-06-30T00:00:00",
                    "CaptureDate": "2020-10-02T21:17:58"
                  },
                  {
                    "Content": "ATO ORDINATORIO - PUBLICAVEL | ATO ORDINATORIO: \"CIENCIA QUANTO A INTERPOSICAO DE APELACAO PELA PARTE AUTORA, BEM COMO QUANTO AO PRAZO DE 15 DIAS PARA APRESENTACAO DE CONTRARRAZOES. ESCOADO O PRAZO, OS AUTOS SERAO REMETIDOS AO E. TRIBUNAL DE JUSTICA.\".",
                    "PublishDate": "2020-06-30T00:00:00",
                    "CaptureDate": "2021-03-14T02:01:18"
                  },
                  {
                    "Content": "APELACAO/RAZOES JUNTADA N PROTOCOLO: WJMJ.20.40915735-0 TIPO DA PETICAO: RAZOES DE APELACAO DATA: 29/06/2020 23:16",
                    "PublishDate": "2020-06-29T00:00:00",
                    "CaptureDate": "2020-10-02T21:17:58"
                  },
                  {
                    "Content": "APELACAO/RAZOES JUNTADA | N PROTOCOLO: WJMJ.20.40915735-0 TIPO DA PETICAO: RAZOES DE APELACAO DATA: 29/06/2020 23:16",
                    "PublishDate": "2020-06-29T00:00:00",
                    "CaptureDate": "2021-03-14T02:01:18"
                  },
                  {
                    "Content": "SUSPENSAO DO PRAZO PRAZO REFERENTE AO USUARIO FOI ALTERADO PARA 29/06/2020 DEVIDO A ALTERACAO DA TABELA DE FERIADOS PRAZO REFERENTE AO USUARIO FOI ALTERADO PARA 29/06/2020 DEVIDO A ALTERACAO DA TABELA DE FERIADOS",
                    "PublishDate": "2020-06-16T00:00:00",
                    "CaptureDate": "2020-10-02T21:17:58"
                  },
                  {
                    "Content": "SUSPENSAO DO PRAZO | PRAZO REFERENTE AO USUARIO FOI ALTERADO PARA 29/06/2020 DEVIDO A ALTERACAO DA TABELA DE FERIADOS PRAZO REFERENTE AO USUARIO FOI ALTERADO PARA 29/06/2020 DEVIDO A ALTERACAO DA TABELA DE FERIADOS",
                    "PublishDate": "2020-06-16T00:00:00",
                    "CaptureDate": "2021-03-14T02:01:18"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0150/2020 DATA DA DISPONIBILIZACAO: 08/06/2020 DATA DA PUBLICACAO: 09/06/2020 NUMERO DO DIARIO: 3057 PAGINA: 86-100",
                    "PublishDate": "2020-06-08T00:00:00",
                    "CaptureDate": "2020-10-02T21:17:58"
                  },
                  {
                    "Content": "PROCESSO 1068275-14.2019.8.26.0100 - PROCEDIMENTO COMUM CIVEL - PRODUTO IMPROPRIO - RAFAEL CASTRO DE MATOS - AQUILON TELECOMUNICACOES LTDA. - ANTE O EXPOSTO, JULGO PARCIALMENTE PROCEDENTE O PEDIDO E CONDENO A RE AQUILON TELECOMUNICACOES LTDAA PAGAR AO AUTOR RAFAEL CASTRO DE MATOS A QUANTIA DE R$554,00 (QUINHENTOS E CINQUENTA E QUATRO REAIS), ATUALIZADA DO DESEMBOLSO COM BASE NA TABELA DO TJSP E, A PARTIR DA CITACAO, ACRESCIDA DE JUROS DE MORA A TAXA LEGAL. CONDENO A RE AO PAGAMENTO DE METADE DAS CUSTAS E DESPESAS PROCESSUAIS, E DE HONORARIOS ADVOCATICIOS QUE FIXO EM R$300,00 (TREZENTOS REAIS), ATUALIZADOS DA PRESENTE DATA COM BASE NA TABELA DO TJSP E, A PARTIR DO TRANSITO EM JULGADO, ACRESCIDOS DE JUROS DE MORA DE UM POR CENTO AO MES. PELA SUCUMBENCIA PARCIAL, CONDENO O AUTOR A PAGAR HONORARIOS ADVOCATICIOS QUE FIXO EM R$300,00 (TREZENTOS REAIS), ATUALIZADOS DA PRESENTE DATA COM BASE NA TABELA DO TJSP E, A PARTIR DO TRANSITO EM JULGADO, ACRESCIDOS DE JUROS DE MORA DE UM POR CENTO AO MES. JULGO EXTINTO O PROCESSO, COM RESOLUCAO DE MERITO, COM BASE NO ART. 487, CAPUT, I, DO CODIGO DE PROCESSO CIVIL. COM O TRANSITO EM JULGADO, FICA AUTORIZADA A RETIRADA DO APARELHO CELULAR PELA RE (FLS.49/50). - ADV: TIAGO GODOY ZANICOTTI (OAB 437516/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP), GABRIEL ANTONIO HENKE NEIVA DE LIMA FILHO (OAB 420786/SP)",
                    "PublishDate": "2020-06-08T00:00:00",
                    "CaptureDate": "2020-10-05T18:58:53"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0150/2020 DATA DA DISPONIBILIZACAO: 08/06/2020 DATA DA PUBLICACAO: 09/06/2020 NUMERO DO DIARIO: 3057 PAGINA: 86-100",
                    "PublishDate": "2020-06-08T00:00:00",
                    "CaptureDate": "2021-03-14T02:01:18"
                  },
                  {
                    "Content": "CERTIDAO DE CARTORIO EXPEDIDA CERTIDAO - CONFERENCIA - ADVOGADOS",
                    "PublishDate": "2020-06-05T00:00:00",
                    "CaptureDate": "2020-10-02T21:17:58"
                  },
                  {
                    "Content": "REMETIDO AO DJE RELACAO: 0150/2020 TEOR DO ATO: ANTE O EXPOSTO, JULGO PARCIALMENTE PROCEDENTE O PEDIDO E CONDENO A RE AQUILON TELECOMUNICACOES LTDA A PAGAR AO AUTOR RAFAEL CASTRO DE MATOS A QUANTIA DE R$554,00 (QUINHENTOS E CINQUENTA E QUATRO REAIS), ATUALIZADA DO DESEMBOLSO COM BASE NA TABELA DO TJSP E, A PARTIR DA CITACAO, ACRESCIDA DE JUROS DE MORA A TAXA LEGAL. CONDENO A RE AO PAGAMENTO DE METADE DAS CUSTAS E DESPESAS PROCESSUAIS, E DE HONORARIOS ADVOCATICIOS QUE FIXO EM R$300,00 (TREZENTOS REAIS), ATUALIZADOS DA PRESENTE DATA COM BASE NA TABELA DO TJSP E, A PARTIR DO TRANSITO EM JULGADO, ACRESCIDOS DE JUROS DE MORA DE UM POR CENTO AO MES. PELA SUCUMBENCIA PARCIAL, CONDENO O AUTOR A PAGAR HONORARIOS ADVOCATICIOS QUE FIXO EM R$300,00 (TREZENTOS REAIS), ATUALIZADOS DA PRESENTE DATA COM BASE NA TABELA DO TJSP E, A PARTIR DO TRANSITO EM JULGADO, ACRESCIDOS DE JUROS DE MORA DE UM POR CENTO AO MES. JULGO EXTINTO O PROCESSO, COM RESOLUCAO DE MERITO, COM BASE NO ART. 487, CAPUT, I, DO CODIGO DE PROCESSO CIVIL. COM O TRANSITO EM JULGADO, FICA AUTORIZADA A RETIRADA DO APARELHO CELULAR PELA RE (FLS.49/50). ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP), GABRIEL ANTONIO HENKE NEIVA DE LIMA FILHO (OAB 420786/SP), TIAGO GODOY ZANICOTTI (OAB 437516/SP)",
                    "PublishDate": "2020-06-05T00:00:00",
                    "CaptureDate": "2020-10-02T21:17:58"
                  },
                  {
                    "Content": "REMETIDO AO DJE | RELACAO: 0150/2020 TEOR DO ATO: ANTE O EXPOSTO, JULGO PARCIALMENTE PROCEDENTE O PEDIDO E CONDENO A RE AQUILON TELECOMUNICACOES LTDA A PAGAR AO AUTOR RAFAEL CASTRO DE MATOS A QUANTIA DE R$554,00 (QUINHENTOS E CINQUENTA E QUATRO REAIS), ATUALIZADA DO DESEMBOLSO COM BASE NA TABELA DO TJSP E, A PARTIR DA CITACAO, ACRESCIDA DE JUROS DE MORA A TAXA LEGAL. CONDENO A RE AO PAGAMENTO DE METADE DAS CUSTAS E DESPESAS PROCESSUAIS, E DE HONORARIOS ADVOCATICIOS QUE FIXO EM R$300,00 (TREZENTOS REAIS), ATUALIZADOS DA PRESENTE DATA COM BASE NA TABELA DO TJSP E, A PARTIR DO TRANSITO EM JULGADO, ACRESCIDOS DE JUROS DE MORA DE UM POR CENTO AO MES. PELA SUCUMBENCIA PARCIAL, CONDENO O AUTOR A PAGAR HONORARIOS ADVOCATICIOS QUE FIXO EM R$300,00 (TREZENTOS REAIS), ATUALIZADOS DA PRESENTE DATA COM BASE NA TABELA DO TJSP E, A PARTIR DO TRANSITO EM JULGADO, ACRESCIDOS DE JUROS DE MORA DE UM POR CENTO AO MES. JULGO EXTINTO O PROCESSO, COM RESOLUCAO DE MERITO, COM BASE NO ART. 487, CAPUT, I, DO CODIGO DE PROCESSO CIVIL. COM O TRANSITO EM JULGADO, FICA AUTORIZADA A RETIRADA DO APARELHO CELULAR PELA RE (FLS.49/50). ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP), GABRIEL ANTONIO HENKE NEIVA DE LIMA FILHO (OAB 420786/SP), TIAGO GODOY ZANICOTTI (OAB 437516/SP)",
                    "PublishDate": "2020-06-05T00:00:00",
                    "CaptureDate": "2021-03-14T02:01:18"
                  },
                  {
                    "Content": "CERTIDAO DE CARTORIO EXPEDIDA | CERTIDAO - CONFERENCIA - ADVOGADOS",
                    "PublishDate": "2020-06-05T00:00:00",
                    "CaptureDate": "2021-03-14T02:01:18"
                  },
                  {
                    "Content": "JULGADA PROCEDENTE EM PARTE A ACAO ANTE O EXPOSTO, JULGO PARCIALMENTE PROCEDENTE O PEDIDO E CONDENO A RE AQUILON TELECOMUNICACOES LTDA A PAGAR AO AUTOR RAFAEL CASTRO DE MATOS A QUANTIA DE R$554,00 (QUINHENTOS E CINQUENTA E QUATRO REAIS), ATUALIZADA DO DESEMBOLSO COM BASE NA TABELA DO TJSP E, A PARTIR DA CITACAO, ACRESCIDA DE JUROS DE MORA A TAXA LEGAL. CONDENO A RE AO PAGAMENTO DE METADE DAS CUSTAS E DESPESAS PROCESSUAIS, E DE HONORARIOS ADVOCATICIOS QUE FIXO EM R$300,00 (TREZENTOS REAIS), ATUALIZADOS DA PRESENTE DATA COM BASE NA TABELA DO TJSP E, A PARTIR DO TRANSITO EM JULGADO, ACRESCIDOS DE JUROS DE MORA DE UM POR CENTO AO MES. PELA SUCUMBENCIA PARCIAL, CONDENO O AUTOR A PAGAR HONORARIOS ADVOCATICIOS QUE FIXO EM R$300,00 (TREZENTOS REAIS), ATUALIZADOS DA PRESENTE DATA COM BASE NA TABELA DO TJSP E, A PARTIR DO TRANSITO EM JULGADO, ACRESCIDOS DE JUROS DE MORA DE UM POR CENTO AO MES. JULGO EXTINTO O PROCESSO, COM RESOLUCAO DE MERITO, COM BASE NO ART. 487, CAPUT, I, DO CODIGO DE PROCESSO CIVIL. COM O TRANSITO EM JULGADO, FICA AUTORIZADA A RETIRADA DO APARELHO CELULAR PELA RE (FLS.49/50).",
                    "PublishDate": "2020-06-03T00:00:00",
                    "CaptureDate": "2020-10-02T21:17:58"
                  },
                  {
                    "Content": "JULGADA PROCEDENTE EM PARTE A ACAO | ANTE O EXPOSTO, JULGO PARCIALMENTE PROCEDENTE O PEDIDO E CONDENO A RE AQUILON TELECOMUNICACOES LTDA A PAGAR AO AUTOR RAFAEL CASTRO DE MATOS A QUANTIA DE R$554,00 (QUINHENTOS E CINQUENTA E QUATRO REAIS), ATUALIZADA DO DESEMBOLSO COM BASE NA TABELA DO TJSP E, A PARTIR DA CITACAO, ACRESCIDA DE JUROS DE MORA A TAXA LEGAL. CONDENO A RE AO PAGAMENTO DE METADE DAS CUSTAS E DESPESAS PROCESSUAIS, E DE HONORARIOS ADVOCATICIOS QUE FIXO EM R$300,00 (TREZENTOS REAIS), ATUALIZADOS DA PRESENTE DATA COM BASE NA TABELA DO TJSP E, A PARTIR DO TRANSITO EM JULGADO, ACRESCIDOS DE JUROS DE MORA DE UM POR CENTO AO MES. PELA SUCUMBENCIA PARCIAL, CONDENO O AUTOR A PAGAR HONORARIOS ADVOCATICIOS QUE FIXO EM R$300,00 (TREZENTOS REAIS), ATUALIZADOS DA PRESENTE DATA COM BASE NA TABELA DO TJSP E, A PARTIR DO TRANSITO EM JULGADO, ACRESCIDOS DE JUROS DE MORA DE UM POR CENTO AO MES. JULGO EXTINTO O PROCESSO, COM RESOLUCAO DE MERITO, COM BASE NO ART. 487, CAPUT, I, DO CODIGO DE PROCESSO CIVIL. COM O TRANSITO EM JULGADO, FICA AUTORIZADA A RETIRADA DO APARELHO CELULAR PELA RE (FLS.49/50).",
                    "PublishDate": "2020-06-03T00:00:00",
                    "CaptureDate": "2021-03-14T02:01:18"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO",
                    "PublishDate": "2020-01-10T00:00:00",
                    "CaptureDate": "2020-10-02T21:17:58"
                  },
                  {
                    "Content": "REPLICA JUNTADA N PROTOCOLO: WJMJ.19.41980122-5 TIPO DA PETICAO: MANIFESTACAO SOBRE A CONTESTACAO DATA: 17/12/2019 16:43",
                    "PublishDate": "2019-12-17T00:00:00",
                    "CaptureDate": "2020-10-02T21:17:58"
                  },
                  {
                    "Content": "REPLICA JUNTADA | N PROTOCOLO: WJMJ.19.41980122-5 TIPO DA PETICAO: MANIFESTACAO SOBRE A CONTESTACAO DATA: 17/12/2019 16:43",
                    "PublishDate": "2019-12-17T00:00:00",
                    "CaptureDate": "2021-03-14T02:01:18"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0469/2019 DATA DA DISPONIBILIZACAO: 26/11/2019 DATA DA PUBLICACAO: 27/11/2019 NUMERO DO DIARIO: 2940 PAGINA: 96/114",
                    "PublishDate": "2019-11-26T00:00:00",
                    "CaptureDate": "2019-11-27T01:51:07"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0469/2019 DATA DA DISPONIBILIZACAO: 26/11/2019 DATA DA PUBLICACAO: 27/11/2019 NUMERO DO DIARIO: 2940 PAGINA: 96/114",
                    "PublishDate": "2019-11-26T00:00:00",
                    "CaptureDate": "2020-10-02T21:17:58"
                  },
                  {
                    "Content": "REMETIDO AO DJE | RELACAO: 0469/2019 TEOR DO ATO: A REPLICA. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP), GABRIEL ANTONIO HENKE NEIVA DE LIMA FILHO (OAB 23378/PR), TIAGO GODOY ZANICOTTI (OAB 437516/SP)",
                    "PublishDate": "2019-11-25T00:00:00",
                    "CaptureDate": "2019-11-27T01:51:07"
                  },
                  {
                    "Content": "REMETIDO AO DJE RELACAO: 0469/2019 TEOR DO ATO: A REPLICA. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP), GABRIEL ANTONIO HENKE NEIVA DE LIMA FILHO (OAB 23378/PR), TIAGO GODOY ZANICOTTI (OAB 437516/SP)",
                    "PublishDate": "2019-11-25T00:00:00",
                    "CaptureDate": "2020-10-02T21:17:58"
                  },
                  {
                    "Content": "ATO ORDINATORIO - PUBLICAVEL | A REPLICA.",
                    "PublishDate": "2019-10-24T00:00:00",
                    "CaptureDate": "2019-11-27T01:51:07"
                  },
                  {
                    "Content": "CONTESTACAO JUNTADA | N PROTOCOLO: WJMJ.19.41661676-1 TIPO DA PETICAO: CONTESTACAO DATA: 24/10/2019 14:25",
                    "PublishDate": "2019-10-24T00:00:00",
                    "CaptureDate": "2019-11-27T01:51:07"
                  },
                  {
                    "Content": "CONTESTACAO JUNTADA N PROTOCOLO: WJMJ.19.41661676-1 TIPO DA PETICAO: CONTESTACAO DATA: 24/10/2019 14:25",
                    "PublishDate": "2019-10-24T00:00:00",
                    "CaptureDate": "2020-10-02T21:17:58"
                  },
                  {
                    "Content": "ATO ORDINATORIO - PUBLICAVEL A REPLICA.",
                    "PublishDate": "2019-10-24T00:00:00",
                    "CaptureDate": "2020-10-02T21:17:58"
                  },
                  {
                    "Content": "AR POSITIVO JUNTADO | JUNTADA DE AR : AR015324643TJ SITUACAO : CUMPRIDO MODELO : PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC DESTINATARIO : AQUILON TELECOMUNICACOES LTDA. DILIGENCIA : 03/10/2019",
                    "PublishDate": "2019-10-08T00:00:00",
                    "CaptureDate": "2019-11-27T01:51:07"
                  },
                  {
                    "Content": "AR POSITIVO JUNTADO JUNTADA DE AR : AR015324643TJ SITUACAO : CUMPRIDO MODELO : PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC DESTINATARIO : AQUILON TELECOMUNICACOES LTDA. DILIGENCIA : 03/10/2019",
                    "PublishDate": "2019-10-08T00:00:00",
                    "CaptureDate": "2020-10-02T21:17:58"
                  },
                  {
                    "Content": "CARTA EXPEDIDA | PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                    "PublishDate": "2019-09-26T00:00:00",
                    "CaptureDate": "2019-11-27T01:51:07"
                  },
                  {
                    "Content": "CARTA EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                    "PublishDate": "2019-09-26T00:00:00",
                    "CaptureDate": "2020-10-02T21:17:58"
                  },
                  {
                    "Content": "ATO ORDINATORIO - NAO PUBLICAVEL | EXPEDICAO DE CARTA.",
                    "PublishDate": "2019-09-25T00:00:00",
                    "CaptureDate": "2019-11-27T01:51:07"
                  },
                  {
                    "Content": "ATO ORDINATORIO - NAO PUBLICAVEL EXPEDICAO DE CARTA.",
                    "PublishDate": "2019-09-25T00:00:00",
                    "CaptureDate": "2020-10-02T21:17:58"
                  },
                  {
                    "Content": "CERTIDAO DE CARTORIO EXPEDIDA C E R T I D A O - R E C E B I M E N T O CERTIFICO E DOU FE QUE, NESTA DATA, COMPARECEU EM CARTORIO O(A) SR(A). RAFAEL HILDEO NAZIMA, OAB/SP 295.443, ADVOGADO (A) DO (A) AUTOR (A), A FIM DE ENTREGAR AS 2 MIDIAS, SENDO UMA DE SEGURANCA, ARMAZENADA EM CAIXA PROPRIA, E A 2 MIDIA DIGITAL E O CELULAR MARCA LG, MODELO K9, AMBOS MENCIONADOS NA PETICAO DE FLS.45, FORAM DEVIDAMENTE ARMAZENADOS NA CAIXA NUMERO 15. CERTIFICO AINDA, QUE NAO FOI CONFERIDO O SEUS CONTEUDOS POR ESTA SERVENTIA E QUE O PATRONO SUPRA CITADO, APOS SER QUESTIONADO, INFORMOU QUE POSSUI COPIAS DO CONTEUDO DAS MIDIAS QUE PRETENDE DISPONIBILIZAR. NADA MAIS. SAO PAULO, 30 DE AGOSTO DE 2019. EU, ___, LUCIANO DA SILVA MOTA, ESCREVENTE TECNICO JUDICIARIO.",
                    "PublishDate": "2019-08-30T00:00:00",
                    "CaptureDate": "2019-09-03T19:00:45"
                  },
                  {
                    "Content": "CERTIDAO DE CARTORIO EXPEDIDA CERTIDAO - GENERICA",
                    "PublishDate": "2019-08-30T00:00:00",
                    "CaptureDate": "2019-09-03T19:00:45"
                  },
                  {
                    "Content": "CERTIDAO DE CARTORIO EXPEDIDA | CERTIDAO - GENERICA",
                    "PublishDate": "2019-08-30T00:00:00",
                    "CaptureDate": "2019-11-27T01:51:07"
                  },
                  {
                    "Content": "CERTIDAO DE CARTORIO EXPEDIDA | C E R T I D A O - R E C E B I M E N T O CERTIFICO E DOU FE QUE, NESTA DATA, COMPARECEU EM CARTORIO O(A) SR(A). RAFAEL HILDEO NAZIMA, OAB/SP 295.443, ADVOGADO (A) DO (A) AUTOR (A), A FIM DE ENTREGAR AS 2 MIDIAS, SENDO UMA DE SEGURANCA, ARMAZENADA EM CAIXA PROPRIA, E A 2 MIDIA DIGITAL E O CELULAR MARCA LG, MODELO K9, AMBOS MENCIONADOS NA PETICAO DE FLS.45, FORAM DEVIDAMENTE ARMAZENADOS NA CAIXA NUMERO 15. CERTIFICO AINDA, QUE NAO FOI CONFERIDO O SEUS CONTEUDOS POR ESTA SERVENTIA E QUE O PATRONO SUPRA CITADO, APOS SER QUESTIONADO, INFORMOU QUE POSSUI COPIAS DO CONTEUDO DAS MIDIAS QUE PRETENDE DISPONIBILIZAR. NADA MAIS. SAO PAULO, 30 DE AGOSTO DE 2019. EU, ___, LUCIANO DA SILVA MOTA, ESCREVENTE TECNICO JUDICIARIO.",
                    "PublishDate": "2019-08-30T00:00:00",
                    "CaptureDate": "2019-11-27T01:51:07"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0356/2019 DATA DA DISPONIBILIZACAO: 22/08/2019 DATA DA PUBLICACAO: 23/08/2019 NUMERO DO DIARIO: 2875 PAGINA: 76/86",
                    "PublishDate": "2019-08-22T00:00:00",
                    "CaptureDate": "2019-09-03T19:00:45"
                  },
                  {
                    "Content": "PROCESSO 1068275-14.2019.8.26.0100 - PROCEDIMENTO COMUM CIVEL - PRODUTO IMPROPRIO - RAFAEL CASTRO DE MATOS - AQUILON TELECOMUNICACOES LTDA. - DEFIRO A ENTREGA E ARMAZENAMENTO EM CARTORIO DO TELEFONE CELULAR E DE DUAS VIAS IDENTICAS DA MIDIA OTICA CONTENDO O AUDIO DA CONVERSA. - ADV: RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2019-08-22T00:00:00",
                    "CaptureDate": "2019-09-03T19:00:14"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0356/2019 DATA DA DISPONIBILIZACAO: 22/08/2019 DATA DA PUBLICACAO: 23/08/2019 NUMERO DO DIARIO: 2875 PAGINA: 76/86",
                    "PublishDate": "2019-08-22T00:00:00",
                    "CaptureDate": "2019-11-27T01:51:07"
                  },
                  {
                    "Content": "FLS. 46 PODER JUDICIARIO DO ESTADO DE SAO PAULO QUINTA VARA CIVEL DO FORO CENTRAL DA COMARCA DA CAPITAL CONCLUSAO EM 20 DE AGOSTO DE 2019, FACO ESTES AUTOS CONCLUSOS AO MM. JUIZ DE DIREITO. EU, FRANCELY CHEVALIER, MATR. 363.056, ESCRIVA JUDICIAL I, LAVREI O PRESENTE TERMO. DECISAO PROCESSO: 1068275-14.2019.8.26.0100 CLASSE: PROCEDIMENTO COMUM CIVEL PARTE ATIVA: RAFAEL CASTRO DE MATOS PARTE PASSIVA: AQUILON TELECOMUNICACOES LTDA. VISTOS. DEFIRO A ENTREGA E ARMAZENAMENTO EM CARTORIO DO TELEFONE CELULAR E DE DUAS VIAS IDENTICAS DA MIDIA OTICA CONTENDO O AUDIO DA CONVERSA. INT. SAO PAULO, 20 DE AGOSTO DE 2019. GUSTAVO COUBE DE CARVALHO JUIZ DE DIREITO [ASSINATURA DIGITAL] 1068275-14.2019.8.26.0100 ESTE DOCUMENTO E COPIA DO ORIGINAL, ASSINADO DIGITALMENTE POR GUSTAVO COUBE DE CARVALHO, LIBERADO NOS AUTOS EM 21/08/2019 AS 13:25 . PARA CONFERIR O ORIGINAL, ACESSE SITE HTTPS://ESAJ.TJSP.JUS.BR/PASTADIGITAL/PG/ABRIRCONFERENCIADOCUMENTO.DO, INFORME PROCESSO 1068275-14.2019.8.26.0100 E CODIGO 7B60EE7.",
                    "PublishDate": "2019-08-21T00:00:00",
                    "CaptureDate": "2019-09-03T19:00:30"
                  },
                  {
                    "Content": "REMETIDO AO DJE RELACAO: 0356/2019 TEOR DO ATO: DEFIRO A ENTREGA E ARMAZENAMENTO EM CARTORIO DO TELEFONE CELULAR E DE DUAS VIAS IDENTICAS DA MIDIA OTICA CONTENDO O AUDIO DA CONVERSA. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2019-08-21T00:00:00",
                    "CaptureDate": "2019-09-03T19:00:45"
                  },
                  {
                    "Content": "REMETIDO AO DJE | RELACAO: 0356/2019 TEOR DO ATO: DEFIRO A ENTREGA E ARMAZENAMENTO EM CARTORIO DO TELEFONE CELULAR E DE DUAS VIAS IDENTICAS DA MIDIA OTICA CONTENDO O AUDIO DA CONVERSA. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2019-08-21T00:00:00",
                    "CaptureDate": "2019-11-27T01:51:07"
                  },
                  {
                    "Content": "DECISAO | DEFIRO A ENTREGA E ARMAZENAMENTO EM CARTORIO DO TELEFONE CELULAR E DE DUAS VIAS IDENTICAS DA MIDIA OTICA CONTENDO O AUDIO DA CONVERSA.",
                    "PublishDate": "2019-08-21T00:00:00",
                    "CaptureDate": "2019-11-27T01:51:07"
                  },
                  {
                    "Content": "DECISAO DEFIRO A ENTREGA E ARMAZENAMENTO EM CARTORIO DO TELEFONE CELULAR E DE DUAS VIAS IDENTICAS DA MIDIA OTICA CONTENDO O AUDIO DA CONVERSA.",
                    "PublishDate": "2019-08-21T00:00:00",
                    "CaptureDate": "2020-10-02T21:17:58"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO",
                    "PublishDate": "2019-08-13T00:00:00",
                    "CaptureDate": "2019-09-03T19:00:30"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO |",
                    "PublishDate": "2019-08-13T00:00:00",
                    "CaptureDate": "2019-11-27T01:51:07"
                  },
                  {
                    "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.19.41133868-2 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 01/08/2019 02:44",
                    "PublishDate": "2019-08-01T00:00:00",
                    "CaptureDate": "2019-09-03T19:00:30"
                  },
                  {
                    "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.19.41133868-2 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 01/08/2019 02:44",
                    "PublishDate": "2019-08-01T00:00:00",
                    "CaptureDate": "2019-11-27T01:51:07"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0304/2019 DATA DA DISPONIBILIZACAO: 25/07/2019 DATA DA PUBLICACAO: 26/07/2019 NUMERO DO DIARIO: 2855 PAGINA: 532/539",
                    "PublishDate": "2019-07-25T00:00:00",
                    "CaptureDate": "2019-09-03T19:00:30"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0304/2019 DATA DA DISPONIBILIZACAO: 25/07/2019 DATA DA PUBLICACAO: 26/07/2019 NUMERO DO DIARIO: 2855 PAGINA: 532/539",
                    "PublishDate": "2019-07-25T00:00:00",
                    "CaptureDate": "2019-11-27T01:51:07"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO",
                    "PublishDate": "2019-07-23T00:00:00",
                    "CaptureDate": "2019-09-03T19:00:14"
                  },
                  {
                    "Content": "FLS. 42 PODER JUDICIARIO DO ESTADO DE SAO PAULO QUINTA VARA CIVEL DO FORO CENTRAL DA COMARCA DA CAPITAL CONCLUSAO EM 23 DE JULHO DE 2019, FACO ESTES AUTOS CONCLUSOS AO MM. JUIZ DE DIREITO. EU, FRANCELY CHEVALIER, MATR. 363.056, ESCRIVA JUDICIAL I, LAVREI O PRESENTE TERMO. DECISAO PROCESSO: 1068275-14.2019.8.26.0100 CLASSE: PROCEDIMENTO COMUM CIVEL PARTE ATIVA: RAFAEL CASTRO DE MATOS. PARTE PASSIVA: AQUILON TELECOMUNICACOES LTDA. VISTOS. CITE-SE PARA CONTESTAR EM QUINZE DIAS CONTADOS NA FORMA DO ART. 231 DO CODIGO DE PROCESSO CIVIL, COM A ADVERTENCIA DE SEU ART. 344. INT. SAO PAULO, 23 DE JULHO DE 2019. GUSTAVO COUBE DE CARVALHO JUIZ DE DIREITO [ASSINATURA DIGITAL] 1068275-14.2019.8.26.0100 ESTE DOCUMENTO E COPIA DO ORIGINAL, ASSINADO DIGITALMENTE POR GUSTAVO COUBE DE CARVALHO, LIBERADO NOS AUTOS EM 23/07/2019 AS 13:37 . PARA CONFERIR O ORIGINAL, ACESSE SITE HTTPS://ESAJ.TJSP.JUS.BR/PASTADIGITAL/PG/ABRIRCONFERENCIADOCUMENTO.DO, INFORME PROCESSO 1068275-14.2019.8.26.0100 E CODIGO 78FA803.",
                    "PublishDate": "2019-07-23T00:00:00",
                    "CaptureDate": "2019-09-03T19:00:14"
                  },
                  {
                    "Content": "REMETIDO AO DJE RELACAO: 0304/2019 TEOR DO ATO: CITE-SE PARA CONTESTAR EM QUINZE DIAS CONTADOS NA FORMA DO ART. 231 DO CODIGO DE PROCESSO CIVIL, COM A ADVERTENCIA DE SEU ART. 344. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2019-07-23T00:00:00",
                    "CaptureDate": "2019-09-03T19:00:30"
                  },
                  {
                    "Content": "REMETIDO AO DJE | RELACAO: 0304/2019 TEOR DO ATO: CITE-SE PARA CONTESTAR EM QUINZE DIAS CONTADOS NA FORMA DO ART. 231 DO CODIGO DE PROCESSO CIVIL, COM A ADVERTENCIA DE SEU ART. 344. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2019-07-23T00:00:00",
                    "CaptureDate": "2019-11-27T01:51:07"
                  },
                  {
                    "Content": "RECEBIDA A PETICAO INICIAL - CITACAO POR CARTA AR | CITE-SE PARA CONTESTAR EM QUINZE DIAS CONTADOS NA FORMA DO ART. 231 DO CODIGO DE PROCESSO CIVIL, COM A ADVERTENCIA DE SEU ART. 344.",
                    "PublishDate": "2019-07-23T00:00:00",
                    "CaptureDate": "2019-11-27T01:51:07"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO |",
                    "PublishDate": "2019-07-23T00:00:00",
                    "CaptureDate": "2019-11-27T01:51:07"
                  },
                  {
                    "Content": "RECEBIDA A PETICAO INICIAL - CITACAO POR CARTA AR CITE-SE PARA CONTESTAR EM QUINZE DIAS CONTADOS NA FORMA DO ART. 231 DO CODIGO DE PROCESSO CIVIL, COM A ADVERTENCIA DE SEU ART. 344.",
                    "PublishDate": "2019-07-23T00:00:00",
                    "CaptureDate": "2020-10-02T21:17:58"
                  },
                  {
                    "Content": "REMETIDO AO DJE RELACAO: 0304/2019 TEOR DO ATO: CITE-SE PARA CONTESTAR EM QUINZE DIAS CONTADOS NA FORMA DO ART. 231 DO CODIGO DE PROCESSO CIVIL, COM A ADVERTENCIA DE SEU ART. 344. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2019-07-23T00:00:00",
                    "CaptureDate": "2020-10-02T21:17:58"
                  },
                  {
                    "Content": "REMETIDO AO DJE | RELACAO: 0304/2019 TEOR DO ATO: CITE-SE PARA CONTESTAR EM QUINZE DIAS CONTADOS NA FORMA DO ART. 231 DO CODIGO DE PROCESSO CIVIL, COM A ADVERTENCIA DE SEU ART. 344. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2019-07-23T00:00:00",
                    "CaptureDate": "2021-03-14T02:01:18"
                  },
                  {
                    "Content": "RECEBIDA A PETICAO INICIAL - CITACAO POR CARTA AR | CITE-SE PARA CONTESTAR EM QUINZE DIAS CONTADOS NA FORMA DO ART. 231 DO CODIGO DE PROCESSO CIVIL, COM A ADVERTENCIA DE SEU ART. 344.",
                    "PublishDate": "2019-07-23T00:00:00",
                    "CaptureDate": "2021-03-14T02:01:18"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO",
                    "PublishDate": "2019-07-23T00:00:00",
                    "CaptureDate": "2021-03-14T02:01:18"
                  },
                  {
                    "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                    "PublishDate": "2019-07-17T00:00:00",
                    "CaptureDate": "2019-09-03T19:00:14"
                  },
                  {
                    "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR) |",
                    "PublishDate": "2019-07-17T00:00:00",
                    "CaptureDate": "2019-11-27T01:51:07"
                  }
                ],
                "Petitions": [
                  {
                    "Type": "PETICOES DIVERSAS",
                    "Author": "",
                    "CreationDate": "2019-08-01T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  },
                  {
                    "Type": "CONTESTACAO",
                    "Author": "",
                    "CreationDate": "2019-10-24T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  },
                  {
                    "Type": "MANIFESTACAO SOBRE A CONTESTACAO",
                    "Author": "",
                    "CreationDate": "2019-12-17T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  },
                  {
                    "Type": "RAZOES DE APELACAO",
                    "Author": "",
                    "CreationDate": "2020-06-29T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  },
                  {
                    "Type": "CONTRARRAZOES DE APELACAO",
                    "Author": "",
                    "CreationDate": "2020-07-22T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  },
                  {
                    "Type": "PETICOES DIVERSAS",
                    "Author": "",
                    "CreationDate": "2021-01-11T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  },
                  {
                    "Type": "PETICAO INTERMEDIARIA",
                    "Author": "",
                    "CreationDate": "2021-02-11T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  },
                  {
                    "Type": "PETICAO INTERMEDIARIA",
                    "Author": "",
                    "CreationDate": "2021-02-19T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  }
                ],
                "Decisions": [
                  {
                    "DecisionContent": "JULGO PARCIALMENTE PROCEDENTE O PEDIDO E CONDENO A RE AQUILON TELECOMUNICACOES LTDAA PAGAR AO AUTOR RAFAEL CASTRO DE MATOS A QUANTIA DE R$554,00 (QUINHENTOS E CINQUENTA E QUATRO REAIS), ATUALIZADA DO DESEMBOLSO COM BASE NA TABELA DO TJSP E, A PARTIR DA CITACAO, ACRESCIDA DE JUROS DE MORA A TAXA LEGAL.",
                    "DecisionDate": "2020-06-08T00:00:00"
                  },
                  {
                    "DecisionContent": "CONDENO A RE AO PAGAMENTO DE METADE DAS CUSTAS E DESPESAS PROCESSUAIS, E DE HONORARIOS ADVOCATICIOS QUE FIXO EM R$300,00 (TREZENTOS REAIS), ATUALIZADOS DA PRESENTE DATA COM BASE NA TABELA DO TJSP E, A PARTIR DO TRANSITO EM JULGADO, ACRESCIDOS DE JUROS DE MORA DE UM POR CENTO AO MES.",
                    "DecisionDate": "2020-06-08T00:00:00"
                  },
                  {
                    "DecisionContent": "CONDENO O AUTOR A PAGAR HONORARIOS ADVOCATICIOS QUE FIXO EM R$300,00 (TREZENTOS REAIS), ATUALIZADOS DA PRESENTE DATA COM BASE NA TABELA DO TJSP E, A PARTIR DO TRANSITO EM JULGADO, ACRESCIDOS DE JUROS DE MORA DE UM POR CENTO AO MES.",
                    "DecisionDate": "2020-06-08T00:00:00"
                  },
                  {
                    "DecisionContent": "JULGO EXTINTO O PROCESSO, COM RESOLUCAO DE MERITO, COM BASE NO ART. 487, CAPUT, I, DO CODIGO DE PROCESSO CIVIL.",
                    "DecisionDate": "2020-06-08T00:00:00"
                  },
                  {
                    "DecisionContent": "JULGO PARCIALMENTE PROCEDENTE O PEDIDO E CONDENO A RE AQUILON TELECOMUNICACOES LTDA A PAGAR AO AUTOR RAFAEL CASTRO DE MATOS A QUANTIA DE R$554,00 (QUINHENTOS E CINQUENTA E QUATRO REAIS), ATUALIZADA DO DESEMBOLSO COM BASE NA TABELA DO TJSP E, A PARTIR DA CITACAO, ACRESCIDA DE JUROS DE MORA A TAXA LEGAL.",
                    "DecisionDate": "2020-06-05T00:00:00"
                  },
                  {
                    "DecisionContent": "CONDENO A RE AO PAGAMENTO DE METADE DAS CUSTAS E DESPESAS PROCESSUAIS, E DE HONORARIOS ADVOCATICIOS QUE FIXO EM R$300,00 (TREZENTOS REAIS), ATUALIZADOS DA PRESENTE DATA COM BASE NA TABELA DO TJSP E, A PARTIR DO TRANSITO EM JULGADO, ACRESCIDOS DE JUROS DE MORA DE UM POR CENTO AO MES.",
                    "DecisionDate": "2020-06-05T00:00:00"
                  },
                  {
                    "DecisionContent": "CONDENO O AUTOR A PAGAR HONORARIOS ADVOCATICIOS QUE FIXO EM R$300,00 (TREZENTOS REAIS), ATUALIZADOS DA PRESENTE DATA COM BASE NA TABELA DO TJSP E, A PARTIR DO TRANSITO EM JULGADO, ACRESCIDOS DE JUROS DE MORA DE UM POR CENTO AO MES.",
                    "DecisionDate": "2020-06-05T00:00:00"
                  },
                  {
                    "DecisionContent": "JULGO EXTINTO O PROCESSO, COM RESOLUCAO DE MERITO, COM BASE NO ART. 487, CAPUT, I, DO CODIGO DE PROCESSO CIVIL.",
                    "DecisionDate": "2020-06-05T00:00:00"
                  },
                  {
                    "DecisionContent": "JULGO PARCIALMENTE PROCEDENTE O PEDIDO E CONDENO A RE AQUILON TELECOMUNICACOES LTDA A PAGAR AO AUTOR RAFAEL CASTRO DE MATOS A QUANTIA DE R$554,00 (QUINHENTOS E CINQUENTA E QUATRO REAIS), ATUALIZADA DO DESEMBOLSO COM BASE NA TABELA DO TJSP E, A PARTIR DA CITACAO, ACRESCIDA DE JUROS DE MORA A TAXA LEGAL.",
                    "DecisionDate": "2020-06-05T00:00:00"
                  },
                  {
                    "DecisionContent": "CONDENO A RE AO PAGAMENTO DE METADE DAS CUSTAS E DESPESAS PROCESSUAIS, E DE HONORARIOS ADVOCATICIOS QUE FIXO EM R$300,00 (TREZENTOS REAIS), ATUALIZADOS DA PRESENTE DATA COM BASE NA TABELA DO TJSP E, A PARTIR DO TRANSITO EM JULGADO, ACRESCIDOS DE JUROS DE MORA DE UM POR CENTO AO MES.",
                    "DecisionDate": "2020-06-05T00:00:00"
                  },
                  {
                    "DecisionContent": "CONDENO O AUTOR A PAGAR HONORARIOS ADVOCATICIOS QUE FIXO EM R$300,00 (TREZENTOS REAIS), ATUALIZADOS DA PRESENTE DATA COM BASE NA TABELA DO TJSP E, A PARTIR DO TRANSITO EM JULGADO, ACRESCIDOS DE JUROS DE MORA DE UM POR CENTO AO MES.",
                    "DecisionDate": "2020-06-05T00:00:00"
                  },
                  {
                    "DecisionContent": "JULGO EXTINTO O PROCESSO, COM RESOLUCAO DE MERITO, COM BASE NO ART. 487, CAPUT, I, DO CODIGO DE PROCESSO CIVIL.",
                    "DecisionDate": "2020-06-05T00:00:00"
                  },
                  {
                    "DecisionContent": "JULGO PARCIALMENTE PROCEDENTE O PEDIDO E CONDENO A RE AQUILON TELECOMUNICACOES LTDA A PAGAR AO AUTOR RAFAEL CASTRO DE MATOS A QUANTIA DE R$554,00 (QUINHENTOS E CINQUENTA E QUATRO REAIS), ATUALIZADA DO DESEMBOLSO COM BASE NA TABELA DO TJSP E, A PARTIR DA CITACAO, ACRESCIDA DE JUROS DE MORA A TAXA LEGAL.",
                    "DecisionDate": "2020-06-03T00:00:00"
                  },
                  {
                    "DecisionContent": "CONDENO A RE AO PAGAMENTO DE METADE DAS CUSTAS E DESPESAS PROCESSUAIS, E DE HONORARIOS ADVOCATICIOS QUE FIXO EM R$300,00 (TREZENTOS REAIS), ATUALIZADOS DA PRESENTE DATA COM BASE NA TABELA DO TJSP E, A PARTIR DO TRANSITO EM JULGADO, ACRESCIDOS DE JUROS DE MORA DE UM POR CENTO AO MES.",
                    "DecisionDate": "2020-06-03T00:00:00"
                  },
                  {
                    "DecisionContent": "CONDENO O AUTOR A PAGAR HONORARIOS ADVOCATICIOS QUE FIXO EM R$300,00 (TREZENTOS REAIS), ATUALIZADOS DA PRESENTE DATA COM BASE NA TABELA DO TJSP E, A PARTIR DO TRANSITO EM JULGADO, ACRESCIDOS DE JUROS DE MORA DE UM POR CENTO AO MES.",
                    "DecisionDate": "2020-06-03T00:00:00"
                  },
                  {
                    "DecisionContent": "JULGO EXTINTO O PROCESSO, COM RESOLUCAO DE MERITO, COM BASE NO ART. 487, CAPUT, I, DO CODIGO DE PROCESSO CIVIL.",
                    "DecisionDate": "2020-06-03T00:00:00"
                  },
                  {
                    "DecisionContent": "JULGO PARCIALMENTE PROCEDENTE O PEDIDO E CONDENO A RE AQUILON TELECOMUNICACOES LTDA A PAGAR AO AUTOR RAFAEL CASTRO DE MATOS A QUANTIA DE R$554,00 (QUINHENTOS E CINQUENTA E QUATRO REAIS), ATUALIZADA DO DESEMBOLSO COM BASE NA TABELA DO TJSP E, A PARTIR DA CITACAO, ACRESCIDA DE JUROS DE MORA A TAXA LEGAL.",
                    "DecisionDate": "2020-06-03T00:00:00"
                  },
                  {
                    "DecisionContent": "CONDENO A RE AO PAGAMENTO DE METADE DAS CUSTAS E DESPESAS PROCESSUAIS, E DE HONORARIOS ADVOCATICIOS QUE FIXO EM R$300,00 (TREZENTOS REAIS), ATUALIZADOS DA PRESENTE DATA COM BASE NA TABELA DO TJSP E, A PARTIR DO TRANSITO EM JULGADO, ACRESCIDOS DE JUROS DE MORA DE UM POR CENTO AO MES.",
                    "DecisionDate": "2020-06-03T00:00:00"
                  },
                  {
                    "DecisionContent": "CONDENO O AUTOR A PAGAR HONORARIOS ADVOCATICIOS QUE FIXO EM R$300,00 (TREZENTOS REAIS), ATUALIZADOS DA PRESENTE DATA COM BASE NA TABELA DO TJSP E, A PARTIR DO TRANSITO EM JULGADO, ACRESCIDOS DE JUROS DE MORA DE UM POR CENTO AO MES.",
                    "DecisionDate": "2020-06-03T00:00:00"
                  },
                  {
                    "DecisionContent": "JULGO EXTINTO O PROCESSO, COM RESOLUCAO DE MERITO, COM BASE NO ART. 487, CAPUT, I, DO CODIGO DE PROCESSO CIVIL.",
                    "DecisionDate": "2020-06-03T00:00:00"
                  },
                  {
                    "DecisionContent": "DEFIRO A ENTREGA E ARMAZENAMENTO EM CARTORIO DO TELEFONE CELULAR E DE DUAS VIAS IDENTICAS DA MIDIA OTICA CONTENDO O AUDIO DA CONVERSA.",
                    "DecisionDate": "2019-08-21T00:00:00"
                  },
                  {
                    "DecisionContent": "DEFIRO A ENTREGA E ARMAZENAMENTO EM CARTORIO DO TELEFONE CELULAR E DE DUAS VIAS IDENTICAS DA MIDIA OTICA CONTENDO O AUDIO DA CONVERSA.",
                    "DecisionDate": "2019-08-21T00:00:00"
                  }
                ]
              },
              {
                "Number": "10104784620208260100",
                "Type": "PROCEDIMENTO COMUM",
                "MainSubject": "INDENIZACAO POR DANO MORAL",
                "CourtName": "TJSP",
                "CourtLevel": "1",
                "CourtType": "CIVEL",
                "CourtDistrict": "",
                "JudgingBody": "4 VARA CIVEL - FORO CENTRAL CIVEL",
                "State": "SP",
                "Status": "INDEFINIDO",
                "LawsuitHostService": "ESAJ",
                "InferredCNJSubjectName": "INDENIZAÇÃO POR DANO MORAL",
                "InferredCNJSubjectNumber": 14010,
                "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
                "InferredBroadCNJSubjectName": "DIREITO DO TRABALHO",
                "InferredBroadCNJSubjectNumber": 864,
                "OtherSubjects": [
                  "INDENIZACAO POR DANO MORAL"
                ],
                "NumberOfVolumes": 0,
                "NumberOfPages": 0,
                "Value": 10167.16,
                "ResJudicataDate": "0001-01-01T00:00:00",
                "CloseDate": "0001-01-01T00:00:00",
                "RedistributionDate": "0001-01-01T00:00:00",
                "PublicationDate": "2022-04-19T00:00:00",
                "NoticeDate": "2020-02-07T00:00:00",
                "LastMovementDate": "2022-05-15T00:00:00",
                "CaptureDate": "2022-05-20T13:06:19",
                "LastUpdate": "2022-05-20T13:06:19",
                "NumberOfParties": 10,
                "NumberOfUpdates": 146,
                "LawSuitAge": 1482,
                "AverageNumberOfUpdatesPerMonth": 2,
                "ReasonForConcealedData": 0,
                "Parties": [
                  {
                    "Doc": "02349014118",
                    "IsPartyActive": true,
                    "Name": "RAFAEL CASTRO DE MATOS",
                    "Polarity": "ACTIVE",
                    "Type": "CLAIMANT",
                    "PartyDetails": {
                      "SpecificType": "REQTE"
                    },
                    "LastCaptureDate": "2022-05-20T13:06:19"
                  },
                  {
                    "Doc": "35068411817",
                    "IsPartyActive": true,
                    "Name": "RAFAEL HIDEO NAZIMA",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "SpecificType": "ADVOGADO REQUERENTE"
                    },
                    "LastCaptureDate": "2022-05-20T13:06:19"
                  },
                  {
                    "Doc": "66970229000167",
                    "IsPartyActive": true,
                    "Name": "NEXTEL TELECOMUNICACOES LTDA",
                    "Polarity": "PASSIVE",
                    "Type": "CLAIMED",
                    "PartyDetails": {
                      "SpecificType": "REQDA"
                    },
                    "LastCaptureDate": "2022-05-20T13:06:19"
                  },
                  {
                    "Doc": "09152582779",
                    "IsPartyActive": true,
                    "Name": "PATRICIA NABINGER DE ALMEIDA SENA",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "SpecificType": "ADVOGADO REQUERIDO"
                    },
                    "LastCaptureDate": "2022-05-20T13:06:19"
                  },
                  {
                    "IsPartyActive": true,
                    "Name": "RODRIGO EMILIANO DA SILVA",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "SpecificType": "ADVOGADO REQUERIDO"
                    },
                    "LastCaptureDate": "2022-05-20T13:06:19"
                  },
                  {
                    "Doc": "25486270801",
                    "IsPartyActive": false,
                    "Name": "RODRIGO CESAR FERNANDES MARINHO",
                    "Polarity": "NEUTRAL",
                    "Type": "REPORTER",
                    "PartyDetails": {
                      "OAB": "195882",
                      "State": "SP",
                      "SpecificType": "JUIZ"
                    },
                    "LastCaptureDate": "2020-04-04T04:35:46"
                  },
                  {
                    "Doc": "11138152722",
                    "IsPartyActive": false,
                    "Name": "RODRIGO EMILIANO DA SILVA",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "172309",
                      "State": "RJ",
                      "SpecificType": "ADVOGADO"
                    },
                    "LastCaptureDate": "2020-04-04T04:35:46"
                  },
                  {
                    "Doc": "25486270801",
                    "IsPartyActive": false,
                    "Name": "RODRIGO CESAR FERNANDES MARINHO",
                    "Polarity": "NEUTRAL",
                    "Type": "REPORTER",
                    "PartyDetails": {
                      "OAB": "195882",
                      "State": "SP",
                      "SpecificType": "JUIZ"
                    },
                    "LastCaptureDate": "2020-04-04T04:35:46"
                  },
                  {
                    "IsPartyActive": true,
                    "Name": "SILVANA MANZI GRANJA",
                    "Polarity": "NEUTRAL",
                    "Type": "OTHER",
                    "PartyDetails": {
                      "SpecificType": "PERITO"
                    },
                    "LastCaptureDate": "2022-05-20T13:06:19"
                  },
                  {
                    "Doc": "77857119768",
                    "IsPartyActive": true,
                    "Name": "JOAO THOMAZ PRAZERES GONDIM",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "270757",
                      "State": "SP",
                      "SpecificType": "ADVOGADO (REQDA)"
                    },
                    "LastCaptureDate": "2022-05-20T13:06:19"
                  }
                ],
                "Updates": [
                  {
                    "Content": "SUSPENSAO DO PRAZO | PRAZO REFERENTE AO USUARIO FOI ALTERADO PARA 09/05/2022 DEVIDO A ALTERACAO DA TABELA DE FERIADOS",
                    "PublishDate": "2022-05-15T00:00:00",
                    "CaptureDate": "2022-05-20T13:06:19"
                  },
                  {
                    "Content": "APENSADO AO PROCESSO | APENSO O PROCESSO 0017274-02.2022.8.26.0100 - CLASSE: CUMPRIMENTO DE SENTENCA - ASSUNTO PRINCIPAL: INDENIZACAO POR DANO MORAL",
                    "PublishDate": "2022-04-29T00:00:00",
                    "CaptureDate": "2022-05-20T13:06:19"
                  },
                  {
                    "Content": "INICIO DA EXECUCAO JUNTADO | 0017274-02.2022.8.26.0100 - CUMPRIMENTO DE SENTENCA",
                    "PublishDate": "2022-04-29T00:00:00",
                    "CaptureDate": "2022-05-20T13:06:19"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO: 0240/2022 DATA DA PUBLICACAO: 20/04/2022 NUMERO DO DIARIO: 3489",
                    "PublishDate": "2022-04-18T00:00:00",
                    "CaptureDate": "2022-05-20T13:06:19"
                  },
                  {
                    "Content": "REMETIDO AO DJE | RELACAO: 0240/2022 TEOR DO ATO: CUMPRA-SE O V. ACORDAO, DEVENDO A PARTE VENCEDORA INSTAURAR INCIDENTE PARA INICIO DO CUMPRIMENTO, OBSERVANDO-SE, DESDE LOGO, SE TRATAR DE EXECUCAO DEFINITIVA, ANTE O TRANSITO EM JULGADO O CUMPRIMENTO DE SENTENCA DEVE PROCEDER DE FORMA ELETRONICA NOS TERMOS DO COMUNICADO CG N 438/2016, DEVENDO ACOMPANHAR EM ANEXO OS DOCUMENTOS MENCIONADOS NO CG N 16/2016, NA SEGUINTE ORDEM: PETICAO, SENTENCA, ACORDAO, CERTIDAO DE TRANSITO EM JULGADO, PROCURACOES E SE O CASO, DOCUMENTOS PERTINENTES AO PEDIDO DA FASE EXECUTIVA. RESSALTA-SE AINDA QUE, EM CONSONANCIA AOS ARTIGOS 509,  2, E 524 DO CODIGO DE PROCESSO CIVIL, O PLEITO DE CUMPRIMENTO DE SENTENCA NAO PRESCINDE DE DEMONSTRATIVO ATUALIZADO DO DEBITO. CASO A PARTE VENCIDA SEJA BENEFICIARIA DA JUSTICA GRATUITA, A EXECUCAO DOS HONORARIOS E DESPESAS PROCESSUAIS FICA SUJEITA A SUA ALTERACAO NESTA CONDICAO. APOS 5 DIAS DA PUBLICACAO DA CORRENTE, SERAO ESTES AUTOS ARQUIVADOS. ADVOGADOS(S): JOAO THOMAZ PRAZERES GONDIM (OAB 270757/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP), PATRICIA NABINGER DE ALMEIDA SENA (OAB 155004/RJ), RODRIGO EMILIANO DA SILVA (OAB 172309/RJ)",
                    "PublishDate": "2022-04-18T00:00:00",
                    "CaptureDate": "2022-05-20T13:06:19"
                  },
                  {
                    "Content": "ATO ORDINATORIO | CUMPRA-SE O V. ACORDAO, DEVENDO A PARTE VENCEDORA INSTAURAR INCIDENTE PARA INICIO DO CUMPRIMENTO, OBSERVANDO-SE, DESDE LOGO, SE TRATAR DE EXECUCAO DEFINITIVA, ANTE O TRANSITO EM JULGADO O CUMPRIMENTO DE SENTENCA DEVE PROCEDER DE FORMA ELETRONICA NOS TERMOS DO COMUNICADO CG N 438/2016, DEVENDO ACOMPANHAR EM ANEXO OS DOCUMENTOS MENCIONADOS NO CG N 16/2016, NA SEGUINTE ORDEM: PETICAO, SENTENCA, ACORDAO, CERTIDAO DE TRANSITO EM JULGADO, PROCURACOES E SE O CASO, DOCUMENTOS PERTINENTES AO PEDIDO DA FASE EXECUTIVA. RESSALTA-SE AINDA QUE, EM CONSONANCIA AOS ARTIGOS 509,  2, E 524 DO CODIGO DE PROCESSO CIVIL, O PLEITO DE CUMPRIMENTO DE SENTENCA NAO PRESCINDE DE DEMONSTRATIVO ATUALIZADO DO DEBITO. CASO A PARTE VENCIDA SEJA BENEFICIARIA DA JUSTICA GRATUITA, A EXECUCAO DOS HONORARIOS E DESPESAS PROCESSUAIS FICA SUJEITA A SUA ALTERACAO NESTA CONDICAO. APOS 5 DIAS DA PUBLICACAO DA CORRENTE, SERAO ESTES AUTOS ARQUIVADOS.",
                    "PublishDate": "2022-04-17T00:00:00",
                    "CaptureDate": "2022-05-20T13:06:19"
                  },
                  {
                    "Content": "CERTIDAO DE CARTORIO EXPEDIDA | CERTIDAO - RECEBIMENTO DOS AUTOS DO TJ - 4 OFICIO CIVEL",
                    "PublishDate": "2022-04-12T00:00:00",
                    "CaptureDate": "2022-04-16T05:48:26"
                  },
                  {
                    "Content": "RECEBIDOS OS AUTOS DO TRIBUNAL DE JUSTICA | DATA DO JULGAMENTO: 08/03/2022 TRANSITO EM JULGADO: TIPO DE JULGAMENTO: ACORDAO DECISAO: DERAM PROVIMENTO AO RECURSO. V. U. SUSTENTARAM ORALMENTE OS(AS) ADVOGADOS(AS) DE AMBAS AS PARTES, JULIANA VIEIRA BARBOSA BUSS OAB/DF 45.151 E RAFAEL HIDEO NAZIMA OAB/SP 295.443 SITUACAO DO PROVIMENTO: PROVIMENTO RELATOR: ELOI ESTEVAO TROLY",
                    "PublishDate": "2022-04-12T00:00:00",
                    "CaptureDate": "2022-04-16T05:48:26"
                  },
                  {
                    "Content": "REMETIDOS OS AUTOS PARA O TRIBUNAL DE JUSTICA/COLEGIO RECURSAL - PROCESSO DIGITAL",
                    "PublishDate": "2021-11-08T00:00:00",
                    "CaptureDate": "2021-12-01T22:35:07"
                  },
                  {
                    "Content": "CERTIDAO DE CARTORIO EXPEDIDA | CERTIDAO - GENERICA",
                    "PublishDate": "2021-11-08T00:00:00",
                    "CaptureDate": "2021-12-01T22:35:07"
                  },
                  {
                    "Content": "CERTIDAO DE CARTORIO EXPEDIDA | CERTIDAO - REMESSA DOS AUTOS A 2 INSTANCIA - ART. 102 - NSCGJ",
                    "PublishDate": "2021-11-08T00:00:00",
                    "CaptureDate": "2021-12-01T22:35:07"
                  },
                  {
                    "Content": "CERTIDAO DE CARTORIO EXPEDIDA | CERTIDAO - GUIAS QUEIMADAS",
                    "PublishDate": "2021-11-08T00:00:00",
                    "CaptureDate": "2021-12-01T22:35:07"
                  },
                  {
                    "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.21.41651959-9 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 05/10/2021 19:27",
                    "PublishDate": "2021-10-05T00:00:00",
                    "CaptureDate": "2021-12-01T22:35:07"
                  },
                  {
                    "Content": "CONTRARRAZOES JUNTADA | N PROTOCOLO: WJMJ.21.41650112-6 TIPO DA PETICAO: CONTRARRAZOES DE APELACAO DATA: 05/10/2021 17:10",
                    "PublishDate": "2021-10-05T00:00:00",
                    "CaptureDate": "2021-12-01T22:35:07"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0300/2021 DATA DA DISPONIBILIZACAO: 13/09/2021 DATA DA PUBLICACAO: 14/09/2021 NUMERO DO DIARIO: 3359 PAGINA: 75 A 90",
                    "PublishDate": "2021-09-13T00:00:00",
                    "CaptureDate": "2021-09-23T02:15:08"
                  },
                  {
                    "Content": "PROCESSO 1010478-46.2020.8.26.0100 - PROCEDIMENTO COMUM CIVEL - INDENIZACAO POR DANO MORAL - RAFAEL CASTRO DE MATOS - NEXTEL TELECOMUNICACOES LTDA - SILVANA MANZI GRANJA - FLS. 261/270: CIENCIA DO RECURSO DE APELACAO INTERPOSTO POR NEXTEL TELECOMUNICACOES LTDA, DEVENDO AS CONTRARRAZOES SEREM APRESENTADAS PELA PARTE ADVERSA NO PRAZO LEGAL. APOS, REMETAM-SE OS AUTOS AO EGREGIO TRIBUNAL DE JUSTICA DO ESTADO DE SAO PAULO SECAO DE DIREITO PRIVADO. - ADV: RODRIGO EMILIANO DA SILVA (OAB 172309/RJ), RAFAEL HIDEO NAZIMA (OAB 295443/SP), PATRICIA NABINGER DE ALMEIDA SENA (OAB 155004/ RJ), JOAO THOMAZ PRAZERES GONDIM (OAB 270757/SP)",
                    "PublishDate": "2021-09-13T00:00:00",
                    "CaptureDate": "2021-09-23T02:15:08"
                  },
                  {
                    "Content": "REMETIDO AO DJE | RELACAO: 0300/2021 TEOR DO ATO: FLS. 261/270: CIENCIA DO RECURSO DE APELACAO INTERPOSTO POR NEXTEL TELECOMUNICACOES LTDA, DEVENDO AS CONTRARRAZOES SEREM APRESENTADAS PELA PARTE ADVERSA NO PRAZO LEGAL. APOS, REMETAM-SE OS AUTOS AO EGREGIO TRIBUNAL DE JUSTICA DO ESTADO DE SAO PAULO SECAO DE DIREITO PRIVADO. ADVOGADOS(S): JOAO THOMAZ PRAZERES GONDIM (OAB 270757/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP), PATRICIA NABINGER DE ALMEIDA SENA (OAB 155004/RJ), RODRIGO EMILIANO DA SILVA (OAB 172309/RJ)",
                    "PublishDate": "2021-09-09T00:00:00",
                    "CaptureDate": "2021-09-23T02:15:08"
                  },
                  {
                    "Content": "ATO ORDINATORIO | FLS. 261/270: CIENCIA DO RECURSO DE APELACAO INTERPOSTO POR NEXTEL TELECOMUNICACOES LTDA, DEVENDO AS CONTRARRAZOES SEREM APRESENTADAS PELA PARTE ADVERSA NO PRAZO LEGAL. APOS, REMETAM-SE OS AUTOS AO EGREGIO TRIBUNAL DE JUSTICA DO ESTADO DE SAO PAULO SECAO DE DIREITO PRIVADO.",
                    "PublishDate": "2021-09-09T00:00:00",
                    "CaptureDate": "2021-09-23T02:15:08"
                  },
                  {
                    "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.21.41474974-0 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 08/09/2021 13:03",
                    "PublishDate": "2021-09-09T00:00:00",
                    "CaptureDate": "2021-09-23T02:15:08"
                  },
                  {
                    "Content": "APELACAO/RAZOES JUNTADA | N PROTOCOLO: WJMJ.21.41473618-5 TIPO DA PETICAO: RAZOES DE APELACAO DATA: 08/09/2021 11:34",
                    "PublishDate": "2021-09-09T00:00:00",
                    "CaptureDate": "2021-09-23T02:15:08"
                  },
                  {
                    "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.21.41361969-0 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 19/08/2021 03:34",
                    "PublishDate": "2021-08-19T00:00:00",
                    "CaptureDate": "2021-09-02T13:30:17"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0265/2021 DATA DA DISPONIBILIZACAO: 18/08/2021 DATA DA PUBLICACAO: 19/08/2021 NUMERO DO DIARIO: 3343 PAGINA: 748 A 784",
                    "PublishDate": "2021-08-18T00:00:00",
                    "CaptureDate": "2021-09-02T13:30:17"
                  },
                  {
                    "Content": "PROCESSO 1010478-46.2020.8.26.0100 - PROCEDIMENTO COMUM CIVEL - INDENIZACAO POR DANO MORAL - RAFAEL CASTRO DE MATOS - NEXTEL TELECOMUNICACOES LTDA - SILVANA MANZI GRANJA - VISTOS. NAO HA OMISSAO, CONTRADICAO OU OBSCURIDADE NA SENTENCA PROFERIDA A FLS. 240/242. O RECURSO INTERPOSTO, SOB O ROTULO DE EMBARGOS DE DECLARACAO, OBJETIVA DISCUTIR A CORRECAO DO JULGADO, TENDO, POIS, NITIDO CARATER INFRINGENTE. LOGO, DEVERA A PARTE INCONFORMADA RECORRER UTILIZANDO-SE DOS MEIOS ADEQUADOS, RAZAO PELA QUAL CONHECO DO RECURSO, MAS NEGO-LHE PROVIMENTO. FLS. 250/256: CIENCIA AO AUTOR. INTIME-SE. - ADV: RAFAEL HIDEO NAZIMA (OAB 295443/SP), PATRICIA NABINGER DE ALMEIDA SENA (OAB 155004/RJ), RODRIGO EMILIANO DA SILVA (OAB 172309/RJ), JOAO THOMAZ PRAZERES GONDIM (OAB 270757/SP)",
                    "PublishDate": "2021-08-18T00:00:00",
                    "CaptureDate": "2021-09-02T13:30:17"
                  },
                  {
                    "Content": "REMETIDO AO DJE | RELACAO: 0265/2021 TEOR DO ATO: VISTOS. NAO HA OMISSAO, CONTRADICAO OU OBSCURIDADE NA SENTENCA PROFERIDA A FLS. 240/242. O RECURSO INTERPOSTO, SOB O ROTULO DE EMBARGOS DE DECLARACAO, OBJETIVA DISCUTIR A CORRECAO DO JULGADO, TENDO, POIS, NITIDO CARATER INFRINGENTE. LOGO, DEVERA A PARTE INCONFORMADA RECORRER UTILIZANDO-SE DOS MEIOS ADEQUADOS, RAZAO PELA QUAL CONHECO DO RECURSO, MAS NEGO-LHE PROVIMENTO. FLS. 250/256: CIENCIA AO AUTOR. INTIME-SE. ADVOGADOS(S): JOAO THOMAZ PRAZERES GONDIM (OAB 270757/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP), PATRICIA NABINGER DE ALMEIDA SENA (OAB 155004/RJ), RODRIGO EMILIANO DA SILVA (OAB 172309/RJ)",
                    "PublishDate": "2021-08-16T00:00:00",
                    "CaptureDate": "2021-09-02T13:30:17"
                  },
                  {
                    "Content": "EMBARGOS DE DECLARACAO NAO-ACOLHIDOS | VISTOS. NAO HA OMISSAO, CONTRADICAO OU OBSCURIDADE NA SENTENCA PROFERIDA A FLS. 240/242. O RECURSO INTERPOSTO, SOB O ROTULO DE EMBARGOS DE DECLARACAO, OBJETIVA DISCUTIR A CORRECAO DO JULGADO, TENDO, POIS, NITIDO CARATER INFRINGENTE. LOGO, DEVERA A PARTE INCONFORMADA RECORRER UTILIZANDO-SE DOS MEIOS ADEQUADOS, RAZAO PELA QUAL CONHECO DO RECURSO, MAS NEGO-LHE PROVIMENTO. FLS. 250/256: CIENCIA AO AUTOR. INTIME-SE.",
                    "PublishDate": "2021-08-13T00:00:00",
                    "CaptureDate": "2021-09-02T13:30:17"
                  },
                  {
                    "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.21.41206426-0 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 26/07/2021 10:47",
                    "PublishDate": "2021-07-26T00:00:00",
                    "CaptureDate": "2021-09-02T13:30:17"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO",
                    "PublishDate": "2021-07-12T00:00:00",
                    "CaptureDate": "2021-09-02T13:30:17"
                  },
                  {
                    "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.21.41089991-8 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 06/07/2021 01:01",
                    "PublishDate": "2021-07-06T00:00:00",
                    "CaptureDate": "2021-09-02T13:30:17"
                  },
                  {
                    "Content": "EMBARGOS DE DECLARACAO JUNTADOS | N PROTOCOLO: WJMJ.21.41077858-4 TIPO DA PETICAO: EMBARGOS DE DECLARACAO DATA: 02/07/2021 17:41",
                    "PublishDate": "2021-07-02T00:00:00",
                    "CaptureDate": "2021-09-02T13:30:17"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0221/2021 DATA DA DISPONIBILIZACAO: 28/06/2021 DATA DA PUBLICACAO: 29/06/2021 NUMERO DO DIARIO: 3307 PAGINA: 104 A 111",
                    "PublishDate": "2021-06-28T00:00:00",
                    "CaptureDate": "2021-07-01T13:52:59"
                  },
                  {
                    "Content": "PROCESSO 1010478-46.2020.8.26.0100 - PROCEDIMENTO COMUM CIVEL - INDENIZACAO POR DANO MORAL - RAFAEL CASTRO DE MATOS - NEXTEL TELECOMUNICACOES LTDA - SILVANA MANZI GRANJA - ANTE O EXPOSTO, JULGO PROCEDENTE O PEDIDO DA PRESENTE ACAO PROPOSTA POR RAFAEL CASTRO DE MATOS CONTRA NEXTEL TELECOMUNICACOES LTDA. PARA, CONFIRMANDO A TUTELA DE URGENCIA, DECLARAR A INEXISTENCIA DE RELACAO JURIDICA ENTRE AS PARTES E A INEXIGIBILIDADE DO DEBITO APONTADO NA INICIAL, DETERMINANDO A EXCLUSAO DO NOME DO AUTOR DOS CADASTROS DE INADIMPLENTES, ALEM DE CONDENAR A RE AO PAGAMENTO DE INDENIZACAO POR DANOS MORAIS, NO VALOR DE R$ 6.000,00,COM CORRECAO MONETARIA PELA TABELA PRATICA DO TRIBUNAL DE JUSTICA A PARTIR DESTA DATA E JUROS DE MORA, DE 1% AO MES, A CONTAR DA CITACAO. PELO PRINCIPIO DA CAUSALIDADE, ARCARA A RE COM AS CUSTAS E DESPESAS PROCESSUAIS E COM OS HONORARIOS ADVOCATICIOS DO PATRONO DO AUTOR, ARBITRADOS EM 15% DO VALOR DA CONDENACAO. P.R.I - ADV: JOAO THOMAZ PRAZERES GONDIM (OAB 270757/SP), PATRICIA NABINGER DE ALMEIDA SENA (OAB 155004/RJ), RODRIGO EMILIANO DA SILVA (OAB 172309/RJ), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2021-06-28T00:00:00",
                    "CaptureDate": "2021-07-01T13:52:59"
                  },
                  {
                    "Content": "REMETIDO AO DJE | RELACAO: 0221/2021 TEOR DO ATO: ANTE O EXPOSTO, JULGO PROCEDENTE O PEDIDO DA PRESENTE ACAO PROPOSTA POR RAFAEL CASTRO DE MATOS CONTRA NEXTEL TELECOMUNICACOES LTDA. PARA, CONFIRMANDO A TUTELA DE URGENCIA, DECLARAR A INEXISTENCIA DE RELACAO JURIDICA ENTRE AS PARTES E A INEXIGIBILIDADE DO DEBITO APONTADO NA INICIAL, DETERMINANDO A EXCLUSAO DO NOME DO AUTOR DOS CADASTROS DE INADIMPLENTES, ALEM DE CONDENAR A RE AO PAGAMENTO DE INDENIZACAO POR DANOS MORAIS, NO VALOR DE R$ 6.000,00,COM CORRECAO MONETARIA PELA TABELA PRATICA DO TRIBUNAL DE JUSTICA A PARTIR DESTA DATA E JUROS DE MORA, DE 1% AO MES, A CONTAR DA CITACAO. PELO PRINCIPIO DA CAUSALIDADE, ARCARA A RE COM AS CUSTAS E DESPESAS PROCESSUAIS E COM OS HONORARIOS ADVOCATICIOS DO PATRONO DO AUTOR, ARBITRADOS EM 15% DO VALOR DA CONDENACAO. P.R.I ADVOGADOS(S): JOAO THOMAZ PRAZERES GONDIM (OAB 270757/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP), PATRICIA NABINGER DE ALMEIDA SENA (OAB 155004/RJ), RODRIGO EMILIANO DA SILVA (OAB 172309/RJ)",
                    "PublishDate": "2021-06-25T00:00:00",
                    "CaptureDate": "2021-07-01T13:52:59"
                  },
                  {
                    "Content": "CERTIDAO DE CARTORIO EXPEDIDA | CERTIDAO - CUSTAS DE PREPARO DA APELACAO",
                    "PublishDate": "2021-06-24T00:00:00",
                    "CaptureDate": "2021-07-01T13:52:59"
                  },
                  {
                    "Content": "JULGADA PROCEDENTE A ACAO | ANTE O EXPOSTO, JULGO PROCEDENTE O PEDIDO DA PRESENTE ACAO PROPOSTA POR RAFAEL CASTRO DE MATOS CONTRA NEXTEL TELECOMUNICACOES LTDA. PARA, CONFIRMANDO A TUTELA DE URGENCIA, DECLARAR A INEXISTENCIA DE RELACAO JURIDICA ENTRE AS PARTES E A INEXIGIBILIDADE DO DEBITO APONTADO NA INICIAL, DETERMINANDO A EXCLUSAO DO NOME DO AUTOR DOS CADASTROS DE INADIMPLENTES, ALEM DE CONDENAR A RE AO PAGAMENTO DE INDENIZACAO POR DANOS MORAIS, NO VALOR DE R$ 6.000,00,COM CORRECAO MONETARIA PELA TABELA PRATICA DO TRIBUNAL DE JUSTICA A PARTIR DESTA DATA E JUROS DE MORA, DE 1% AO MES, A CONTAR DA CITACAO. PELO PRINCIPIO DA CAUSALIDADE, ARCARA A RE COM AS CUSTAS E DESPESAS PROCESSUAIS E COM OS HONORARIOS ADVOCATICIOS DO PATRONO DO AUTOR, ARBITRADOS EM 15% DO VALOR DA CONDENACAO. P.R.I",
                    "PublishDate": "2021-06-24T00:00:00",
                    "CaptureDate": "2021-07-01T13:52:59"
                  },
                  {
                    "Content": "CONCLUSOS PARA SENTENCA",
                    "PublishDate": "2021-06-18T00:00:00",
                    "CaptureDate": "2021-07-01T13:52:59"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO",
                    "PublishDate": "2021-06-18T00:00:00",
                    "CaptureDate": "2021-07-01T13:52:59"
                  },
                  {
                    "Content": "CERTIDAO DE CARTORIO EXPEDIDA | CERTIDAO - GENERICA",
                    "PublishDate": "2021-05-21T00:00:00",
                    "CaptureDate": "2021-07-01T13:52:59"
                  },
                  {
                    "Content": "SUSPENSAO DO PRAZO | PRAZO REFERENTE AO USUARIO FOI ALTERADO PARA 06/05/2021 DEVIDO A ALTERACAO DA TABELA DE FERIADOS",
                    "PublishDate": "2021-04-14T00:00:00",
                    "CaptureDate": "2021-04-29T00:36:57"
                  },
                  {
                    "Content": "SUSPENSAO DO PRAZO | PRAZO REFERENTE AO USUARIO FOI ALTERADO PARA 06/05/2021 DEVIDO A ALTERACAO DA TABELA DE FERIADOS",
                    "PublishDate": "2021-04-14T00:00:00",
                    "CaptureDate": "2021-04-29T00:36:57"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0102/2021 DATA DA DISPONIBILIZACAO: 30/03/2021 DATA DA PUBLICACAO: 31/03/2021 NUMERO DO DIARIO: 3248 PAGINA: 72 A 97",
                    "PublishDate": "2021-03-30T00:00:00",
                    "CaptureDate": "2021-04-29T00:36:57"
                  },
                  {
                    "Content": "PROCESSO 1010478-46.2020.8.26.0100 - PROCEDIMENTO COMUM CIVEL - INDENIZACAO POR DANO MORAL - RAFAEL CASTRO DE MATOS - NEXTEL TELECOMUNICACOES LTDA - SILVANA MANZI GRANJA - VISTOS. MANTENHO A DECISAO ANTERIOR NOS SEUS TERMOS, DEVENDO EVENTUAL PRETENSAO DE REFORMA SER DEDUZIDA POR MEIO DE RECURSO. A FIXACAO DE HONORARIOS PERICIAIS E MATERIA QUE SE INCLUI DENTRE AQUELAS SUJEITAS AO PRUDENTE CRITERIOI DO MAGISTRADO. O ARBITRAMENTO DOS HONORARIOS, SEGUNDO ORIENTACAO DE NOSSOS TRIBUNAIS, DEVE LEVAR EM CONSIDERACAO A NATUREZA, ESPECIALIDADE E DIFICULDADE DO TRABALHO EFETIVAMENTE REALIZADO PELO TECNICO. NO CASO VERTENTE, CONSIDERANDO OS CRITERIOS ACIMA INDICADOS E A ESTIMATIVA APRESENTADA, ARBITRO OS HONORARIOS DO PERITO EM R$ 2.600,00. AGUARDE-SE A COMPROVACAO DO DEPOSITO. INTIME-SE. - ADV: PATRICIA NABINGER DE ALMEIDA SENA (OAB 155004/RJ), RAFAEL HIDEO NAZIMA (OAB 295443/SP), JOAO THOMAZ PRAZERES GONDIM (OAB 270757/SP), RODRIGO EMILIANO DA SILVA (OAB 172309/RJ)",
                    "PublishDate": "2021-03-30T00:00:00",
                    "CaptureDate": "2021-04-29T00:36:57"
                  },
                  {
                    "Content": "REMETIDO AO DJE | RELACAO: 0102/2021 TEOR DO ATO: VISTOS. MANTENHO A DECISAO ANTERIOR NOS SEUS TERMOS, DEVENDO EVENTUAL PRETENSAO DE REFORMA SER DEDUZIDA POR MEIO DE RECURSO. A FIXACAO DE HONORARIOS PERICIAIS E MATERIA QUE SE INCLUI DENTRE AQUELAS SUJEITAS AO PRUDENTE CRITERIOI DO MAGISTRADO. O ARBITRAMENTO DOS HONORARIOS, SEGUNDO ORIENTACAO DE NOSSOS TRIBUNAIS, DEVE LEVAR EM CONSIDERACAO A NATUREZA, ESPECIALIDADE E DIFICULDADE DO TRABALHO EFETIVAMENTE REALIZADO PELO TECNICO. NO CASO VERTENTE, CONSIDERANDO OS CRITERIOS ACIMA INDICADOS E A ESTIMATIVA APRESENTADA, ARBITRO OS HONORARIOS DO PERITO EM R$ 2.600,00. AGUARDE-SE A COMPROVACAO DO DEPOSITO. INTIME-SE. ADVOGADOS(S): JOAO THOMAZ PRAZERES GONDIM (OAB 270757/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP), PATRICIA NABINGER DE ALMEIDA SENA (OAB 155004/RJ), RODRIGO EMILIANO DA SILVA (OAB 172309/RJ)",
                    "PublishDate": "2021-03-29T00:00:00",
                    "CaptureDate": "2021-04-29T00:36:57"
                  },
                  {
                    "Content": "DECISAO | VISTOS. MANTENHO A DECISAO ANTERIOR NOS SEUS TERMOS, DEVENDO EVENTUAL PRETENSAO DE REFORMA SER DEDUZIDA POR MEIO DE RECURSO. A FIXACAO DE HONORARIOS PERICIAIS E MATERIA QUE SE INCLUI DENTRE AQUELAS SUJEITAS AO PRUDENTE CRITERIOI DO MAGISTRADO. O ARBITRAMENTO DOS HONORARIOS, SEGUNDO ORIENTACAO DE NOSSOS TRIBUNAIS, DEVE LEVAR EM CONSIDERACAO A NATUREZA, ESPECIALIDADE E DIFICULDADE DO TRABALHO EFETIVAMENTE REALIZADO PELO TECNICO. NO CASO VERTENTE, CONSIDERANDO OS CRITERIOS ACIMA INDICADOS E A ESTIMATIVA APRESENTADA, ARBITRO OS HONORARIOS DO PERITO EM R$ 2.600,00. AGUARDE-SE A COMPROVACAO DO DEPOSITO. INTIME-SE.",
                    "PublishDate": "2021-03-29T00:00:00",
                    "CaptureDate": "2021-04-29T00:36:57"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO",
                    "PublishDate": "2021-02-24T00:00:00",
                    "CaptureDate": "2021-03-20T12:56:34"
                  },
                  {
                    "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.21.40213171-2 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 16/02/2021 21:19",
                    "PublishDate": "2021-02-16T00:00:00",
                    "CaptureDate": "2021-03-20T12:56:34"
                  },
                  {
                    "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.21.40174653-5 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 10/02/2021 17:34",
                    "PublishDate": "2021-02-10T00:00:00",
                    "CaptureDate": "2021-03-20T12:56:34"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0040/2021 DATA DA DISPONIBILIZACAO: 08/02/2021 DATA DA PUBLICACAO: 09/02/2021 NUMERO DO DIARIO: 3212 PAGINA: 1044 A 106",
                    "PublishDate": "2021-02-08T00:00:00",
                    "CaptureDate": "2021-03-20T12:56:34"
                  },
                  {
                    "Content": "PROCESSO 1010478-46.2020.8.26.0100 - PROCEDIMENTO COMUM CIVEL - INDENIZACAO POR DANO MORAL - RAFAEL CASTRO DE MATOS - NEXTEL TELECOMUNICACOES LTDA - SILVANA MANZI GRANJA - FLS. 227/228: MANIFESTEM-SE AS PARTES SOBRE A ESTIMATIVA DOS HONORARIOS DA PERITA. - ADV: PATRICIA NABINGER DE ALMEIDA SENA (OAB 155004/RJ), RAFAEL HIDEO NAZIMA (OAB 295443/SP), JOAO THOMAZ PRAZERES GONDIM (OAB 270757/SP), RODRIGO EMILIANO DA SILVA (OAB 172309/RJ)",
                    "PublishDate": "2021-02-08T00:00:00",
                    "CaptureDate": "2021-03-20T12:56:34"
                  },
                  {
                    "Content": "REMETIDO AO DJE | RELACAO: 0040/2021 TEOR DO ATO: FLS. 227/228: MANIFESTEM-SE AS PARTES SOBRE A ESTIMATIVA DOS HONORARIOS DA PERITA. ADVOGADOS(S): JOAO THOMAZ PRAZERES GONDIM (OAB 270757/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP), PATRICIA NABINGER DE ALMEIDA SENA (OAB 155004/RJ), RODRIGO EMILIANO DA SILVA (OAB 172309/RJ)",
                    "PublishDate": "2021-02-05T00:00:00",
                    "CaptureDate": "2021-03-20T12:56:34"
                  },
                  {
                    "Content": "ATO ORDINATORIO | FLS. 227/228: MANIFESTEM-SE AS PARTES SOBRE A ESTIMATIVA DOS HONORARIOS DA PERITA.",
                    "PublishDate": "2021-02-04T00:00:00",
                    "CaptureDate": "2021-03-20T12:56:34"
                  },
                  {
                    "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.21.40013669-5 TIPO DA PETICAO: APRESENTACAO DE PROPOSTA DE HONORARIO PERICIAIS DATA: 11/01/2021 15:30",
                    "PublishDate": "2021-01-12T00:00:00",
                    "CaptureDate": "2021-03-20T12:56:34"
                  },
                  {
                    "Content": "MENSAGEM ELETRONICA (E-MAIL) JUNTADA",
                    "PublishDate": "2020-12-14T00:00:00",
                    "CaptureDate": "2021-03-20T12:56:34"
                  },
                  {
                    "Content": "MENSAGEM ELETRONICA (E-MAIL) JUNTADA",
                    "PublishDate": "2020-12-10T00:00:00",
                    "CaptureDate": "2021-03-20T12:56:34"
                  },
                  {
                    "Content": "DOCUMENTO JUNTADO | N PROTOCOLO: WJMJ.20.41635171-9 TIPO DA PETICAO: APRESENTACAO DE QUESITOS/INDICACAO DE ASSISTENTE TECNICO DATA: 16/10/2020 21:29",
                    "PublishDate": "2020-10-16T00:00:00",
                    "CaptureDate": "2021-03-20T12:56:34"
                  },
                  {
                    "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.20.41625948-0 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 15/10/2020 19:27",
                    "PublishDate": "2020-10-15T00:00:00",
                    "CaptureDate": "2021-03-20T12:56:34"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0279/2020 DATA DA DISPONIBILIZACAO: 24/09/2020 DATA DA PUBLICACAO: 25/09/2020 NUMERO DO DIARIO: 3134 PAGINA: 61 A 74",
                    "PublishDate": "2020-09-24T00:00:00",
                    "CaptureDate": "2020-10-04T23:23:27"
                  },
                  {
                    "Content": "PROCESSO 1010478-46.2020.8.26.0100 - PROCEDIMENTO COMUM CIVEL - INDENIZACAO POR DANO MORAL - RAFAEL CASTRO DE MATOS - NEXTEL TELECOMUNICACOES LTDA - VISTOS. RAFAEL CASTRO DE MATOS AJUIZOU A PRESENTE CONTRA NEXTEL TELECOMUNICACOES LTDA., ALEGANDO, EM SUMA, QUE TEVE SEU NOME INSCRITO EM CADASTROS DE INADIMPLENTES EM DECORRENCIA DE SUPOSTA DIVIDA CONTRAIDA JUNTO A RE, NO VALOR TOTAL DE R$ 167,16. ADUZ NAO RECONHECER O DEBITO, DE MODO QUE AS INSCRICOES INDEVIDAS LHE CAUSOU DANOS MORAIS. POR TAIS MOTIVOS, REQUER A CONCESSAO DA TUTELA DE URGENCIA E A PROCEDENCIA DO PEDIDO PARA QUE SEJA DECLARADA A INEXIGIBILIDADE DO DEBITO, CONDENANDO-SE A RE AO PAGAMENTO DE INDENIZACAO POR DANOS MORAIS NA QUANTIA DE R$ 10.000,00. A PETICAO INICIAL VEIO INSTRUIDA COM DOCUMENTOS (FLS. 15/45). O JUIZO DEFERIU A ANTECIPACAO DOS EFEITOS DA TUTELA (FLS. 65). CITADA, A RE OFERTOU CONTESTACAO (FLS. 82/91), ALEGANDO, EM MATERIA PRELIMINAR, A FALTA DE INTERESSE DE AGIR. EM RELACAO AO MERITO, ADUZ BASICAMENTE A EXIGIBILIDADE DO DEBITO. NARRA TER O AUTOR SOLICITADO O CANCELAMENTO DOS SERVICOS DA RE EM 06 DE MAIO DE 2016, POREM, DEIXOU DE PAGAR A FATURA CORRESPONDENTE AO VALOR PROPORCIONAL COM VENCIMENTO NO DIA 25 DO MESMO MES. ADUZ A INEXISTENCIA DE ATO ILICITO, BEM COMO NAO TER O REQUERENTE SOFRIDO DANO MORAL. PUGNA PELA IMPROCEDENCIA DA PRETENSAO. ACOMPANHA OS DOCUMENTOS DE FLS. 92/124. REPLICA A FLS. 146/159. JUNTOU DOCUMENTOS (FLS. 160/207). INICIALMENTE, AFASTO A PRELIMINAR DE FALTA DE INTERESSE DE AGIR, UMA VEZ QUE A AUSENCIA DE REQUERIMENTO ADMINISTRATIVO NAO ERA OBICE AO AJUIZAMENTO DESTA ACAO, MORMENTE DIANTE DA EFETIVA RESISTENCIA APRESENTADA PELA RE, SOB PENA DE OFENSA AO ART. 5, INCISO XXXV, DA CONSTITUICAO FEDERAL. O DOCUMENTO EXIBIDO A FLS. 16 E SUFICIENTE PARA COMPROVAR O ENDERECO INFORMADO PELO AUTOR. CONSIDERANDO AS PARTES LEGITIMAS, ESTANDO BEM REPRESENTADAS E LITIGANDO COM INTERESSE, ALEM DA AUSENCIA DE FALHAS OU NULIDADES A SUPRIR, DOU O FEITO POR SANEADO. O AUTOR ALEGA UTILIZACAO FRAUDULENTA DE SEUS DADOS E A FALSIDADE DA ASSINATURA NA CONDICAO DE CONTRATANTE DOS SERVICOS PRESTADOS PELA RE. EM RAZAO DE CONSTITUIR PONTO CONTROVERTIDO A RELACAO JURIDICA EXISTENTE ENTRE O AUTOR E A RE, PARA DETERMINAR A EXIGIBILIDADE DO DEBITO, NECESSARIA A PRODUCAO DE PROVA PERICIAL GRAFOTECNICA COM O OBJETIVO DE VERIFICAR A AUTENTICIDADE DA ASSINATURA ATRIBUIDA AO AUTOR NO DOCUMENTO DE FLS. 92/93. ASSIM, NOMEIO A PERITA SILVANA MANZI GRANJA. INTIMEM-SE AS PARTES PARA QUE FORMULEM QUESITOS E INDIQUEM ASSISTENTES TECNICOS EM QUINZE DIAS. APOS, INTIME-SE A PERITA NOMEADO PARA QUE ESTIME O VALOR DOS HONORARIOS, EM DEZ DIAS. E RELEVANTE SALIENTAR QUE SE TRATA DE CONTESTACAO DE ASSINATURA CONSTANTE EM CONTRATO, DE MODO QUE O ONUS DA PROVA INCUMBE A PARTE QUE APRESENTOU O REFERIDO DOCUMENTO. ASSIM, O ONUS DA PROVA DA AUTENTICIDADE DA ASSINATURA PERTENCE A EMPRESA DE TELEFONIA, QUE PRODUZIU O DOCUMENTO MENCIONADO, NOS TERMOS DO ARTIGO 429, INCISO II, DO CODIGO DE PROCESSO CIVIL. TAL REGRA NAO SE APLICA AO CUSTEIO DA PERICIA DETERMINADA, NA FORMA DOS ARTIGOS 82 E 95 DO CODIGO DE PROCESSO CIVIL. NO PRESENTE CASO, A PRODUCAO DA PROVA PERICIAL GRAFOTECNICA FOI DETERMINADA PELO JUIZO. PORTANTO, O VALOR ARBITRADO DEVE SER ANTECIPADO POR AMBAS AS PARTES NA PROPORCAO DE 50% PARA CADA UMA. EFETUADO O DEPOSITO E DECORRIDO O PRAZO ACIMA, INTIME-SE O SR. PERITO PARA DAR INICIO AOS TRABALHOS. PRAZO PARA A JUNTADA DO LAUDO: QUARENTA DIAS APOS A INTIMACAO DO PERITO. CONSIGNO, POR FIM, QUE A PROVA TECNICA E A DOCUMENTAL COMPLEMENTAR SAO AS UNICAS PERTINENTES A SOLUCAO DO LITIGIO, FICANDO INDEFERIDA A PRODUCAO DE PROVA ORAL. INTIME-SE - ADV: RAFAEL HIDEO NAZIMA (OAB 295443/SP), PATRICIA NABINGER DE ALMEIDA SENA (OAB 155004/RJ), RODRIGO EMILIANO DA SILVA (OAB 172309/RJ)",
                    "PublishDate": "2020-09-24T00:00:00",
                    "CaptureDate": "2020-10-07T14:19:02"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0279/2020 DATA DA DISPONIBILIZACAO: 24/09/2020 DATA DA PUBLICACAO: 25/09/2020 NUMERO DO DIARIO: 3134 PAGINA: 61 A 74",
                    "PublishDate": "2020-09-24T00:00:00",
                    "CaptureDate": "2021-03-20T12:56:34"
                  },
                  {
                    "Content": "REMETIDO AO DJE RELACAO: 0279/2020 TEOR DO ATO: VISTOS. RAFAEL CASTRO DE MATOS AJUIZOU A PRESENTE CONTRA NEXTEL TELECOMUNICACOES LTDA., ALEGANDO, EM SUMA, QUE TEVE SEU NOME INSCRITO EM CADASTROS DE INADIMPLENTES EM DECORRENCIA DE SUPOSTA DIVIDA CONTRAIDA JUNTO A RE, NO VALOR TOTAL DE R$ 167,16. ADUZ NAO RECONHECER O DEBITO, DE MODO QUE AS INSCRICOES INDEVIDAS LHE CAUSOU DANOS MORAIS. POR TAIS MOTIVOS, REQUER A CONCESSAO DA TUTELA DE URGENCIA E A PROCEDENCIA DO PEDIDO PARA QUE SEJA DECLARADA A INEXIGIBILIDADE DO DEBITO, CONDENANDO-SE A RE AO PAGAMENTO DE INDENIZACAO POR DANOS MORAIS NA QUANTIA DE R$ 10.000,00. A PETICAO INICIAL VEIO INSTRUIDA COM DOCUMENTOS (FLS. 15/45). O JUIZO DEFERIU A ANTECIPACAO DOS EFEITOS DA TUTELA (FLS. 65). CITADA, A RE OFERTOU CONTESTACAO (FLS. 82/91), ALEGANDO, EM MATERIA PRELIMINAR, A FALTA DE INTERESSE DE AGIR. EM RELACAO AO MERITO, ADUZ BASICAMENTE A EXIGIBILIDADE DO DEBITO. NARRA TER O AUTOR SOLICITADO O CANCELAMENTO DOS SERVICOS DA RE EM 06 DE MAIO DE 2016, POREM, DEIXOU DE PAGAR A FATURA CORRESPONDENTE AO VALOR PROPORCIONAL COM VENCIMENTO NO DIA 25 DO MESMO MES. ADUZ A INEXISTENCIA DE ATO ILICITO, BEM COMO NAO TER O REQUERENTE SOFRIDO DANO MORAL. PUGNA PELA IMPROCEDENCIA DA PRETENSAO. ACOMPANHA OS DOCUMENTOS DE FLS. 92/124. REPLICA A FLS. 146/159. JUNTOU DOCUMENTOS (FLS. 160/207). INICIALMENTE, AFASTO A PRELIMINAR DE FALTA DE INTERESSE DE AGIR, UMA VEZ QUE A AUSENCIA DE REQUERIMENTO ADMINISTRATIVO NAO ERA OBICE AO AJUIZAMENTO DESTA ACAO, MORMENTE DIANTE DA EFETIVA RESISTENCIA APRESENTADA PELA RE, SOB PENA DE OFENSA AO ART. 5, INCISO XXXV, DA CONSTITUICAO FEDERAL. O DOCUMENTO EXIBIDO A FLS. 16 E SUFICIENTE PARA COMPROVAR O ENDERECO INFORMADO PELO AUTOR. CONSIDERANDO AS PARTES LEGITIMAS, ESTANDO BEM REPRESENTADAS E LITIGANDO COM INTERESSE, ALEM DA AUSENCIA DE FALHAS OU NULIDADES A SUPRIR, DOU O FEITO POR SANEADO. O AUTOR ALEGA UTILIZACAO FRAUDULENTA DE SEUS DADOS E A FALSIDADE DA ASSINATURA NA CONDICAO DE CONTRATANTE DOS SERVICOS PRESTADOS PELA RE. EM RAZAO DE CONSTITUIR PONTO CONTROVERTIDO A RELACAO JURIDICA EXISTENTE ENTRE O AUTOR E A RE, PARA DETERMINAR A EXIGIBILIDADE DO DEBITO, NECESSARIA A PRODUCAO DE PROVA PERICIAL GRAFOTECNICA COM O OBJETIVO DE VERIFICAR A AUTENTICIDADE DA ASSINATURA ATRIBUIDA AO AUTOR NO DOCUMENTO DE FLS. 92/93. ASSIM, NOMEIO A PERITA SILVANA MANZI GRANJA. INTIMEM-SE AS PARTES PARA QUE FORMULEM QUESITOS E INDIQUEM ASSISTENTES TECNICOS EM QUINZE DIAS. APOS, INTIME-SE A PERITA NOMEADO PARA QUE ESTIME O VALOR DOS HONORARIOS, EM DEZ DIAS. E RELEVANTE SALIENTAR QUE SE TRATA DE CONTESTACAO DE ASSINATURA CONSTANTE EM CONTRATO, DE MODO QUE O ONUS DA PROVA INCUMBE A PARTE QUE APRESENTOU O REFERIDO DOCUMENTO. ASSIM, O ONUS DA PROVA DA AUTENTICIDADE DA ASSINATURA PERTENCE A EMPRESA DE TELEFONIA, QUE PRODUZIU O DOCUMENTO MENCIONADO, NOS TERMOS DO ARTIGO 429, INCISO II, DO CODIGO DE PROCESSO CIVIL. TAL REGRA NAO SE APLICA AO CUSTEIO DA PERICIA DETERMINADA, NA FORMA DOS ARTIGOS 82 E 95 DO CODIGO DE PROCESSO CIVIL. NO PRESENTE CASO, A PRODUCAO DA PROVA PERICIAL GRAFOTECNICA FOI DETERMINADA PELO JUIZO. PORTANTO, O VALOR ARBITRADO DEVE SER ANTECIPADO POR AMBAS AS PARTES NA PROPORCAO DE 50% PARA CADA UMA. EFETUADO O DEPOSITO E DECORRIDO O PRAZO ACIMA, INTIME-SE O SR. PERITO PARA DAR INICIO AOS TRABALHOS. PRAZO PARA A JUNTADA DO LAUDO: QUARENTA DIAS APOS A INTIMACAO DO PERITO. CONSIGNO, POR FIM, QUE A PROVA TECNICA E A DOCUMENTAL COMPLEMENTAR SAO AS UNICAS PERTINENTES A SOLUCAO DO LITIGIO, FICANDO INDEFERIDA A PRODUCAO DE PROVA ORAL. INTIME-SE ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP), PATRICIA NABINGER DE ALMEIDA SENA (OAB 155004/RJ), RODRIGO EMILIANO DA SILVA (OAB 172309/RJ)",
                    "PublishDate": "2020-09-23T00:00:00",
                    "CaptureDate": "2020-10-04T23:23:27"
                  },
                  {
                    "Content": "REMETIDO AO DJE | RELACAO: 0279/2020 TEOR DO ATO: VISTOS. RAFAEL CASTRO DE MATOS AJUIZOU A PRESENTE CONTRA NEXTEL TELECOMUNICACOES LTDA., ALEGANDO, EM SUMA, QUE TEVE SEU NOME INSCRITO EM CADASTROS DE INADIMPLENTES EM DECORRENCIA DE SUPOSTA DIVIDA CONTRAIDA JUNTO A RE, NO VALOR TOTAL DE R$ 167,16. ADUZ NAO RECONHECER O DEBITO, DE MODO QUE AS INSCRICOES INDEVIDAS LHE CAUSOU DANOS MORAIS. POR TAIS MOTIVOS, REQUER A CONCESSAO DA TUTELA DE URGENCIA E A PROCEDENCIA DO PEDIDO PARA QUE SEJA DECLARADA A INEXIGIBILIDADE DO DEBITO, CONDENANDO-SE A RE AO PAGAMENTO DE INDENIZACAO POR DANOS MORAIS NA QUANTIA DE R$ 10.000,00. A PETICAO INICIAL VEIO INSTRUIDA COM DOCUMENTOS (FLS. 15/45). O JUIZO DEFERIU A ANTECIPACAO DOS EFEITOS DA TUTELA (FLS. 65). CITADA, A RE OFERTOU CONTESTACAO (FLS. 82/91), ALEGANDO, EM MATERIA PRELIMINAR, A FALTA DE INTERESSE DE AGIR. EM RELACAO AO MERITO, ADUZ BASICAMENTE A EXIGIBILIDADE DO DEBITO. NARRA TER O AUTOR SOLICITADO O CANCELAMENTO DOS SERVICOS DA RE EM 06 DE MAIO DE 2016, POREM, DEIXOU DE PAGAR A FATURA CORRESPONDENTE AO VALOR PROPORCIONAL COM VENCIMENTO NO DIA 25 DO MESMO MES. ADUZ A INEXISTENCIA DE ATO ILICITO, BEM COMO NAO TER O REQUERENTE SOFRIDO DANO MORAL. PUGNA PELA IMPROCEDENCIA DA PRETENSAO. ACOMPANHA OS DOCUMENTOS DE FLS. 92/124. REPLICA A FLS. 146/159. JUNTOU DOCUMENTOS (FLS. 160/207). INICIALMENTE, AFASTO A PRELIMINAR DE FALTA DE INTERESSE DE AGIR, UMA VEZ QUE A AUSENCIA DE REQUERIMENTO ADMINISTRATIVO NAO ERA OBICE AO AJUIZAMENTO DESTA ACAO, MORMENTE DIANTE DA EFETIVA RESISTENCIA APRESENTADA PELA RE, SOB PENA DE OFENSA AO ART. 5, INCISO XXXV, DA CONSTITUICAO FEDERAL. O DOCUMENTO EXIBIDO A FLS. 16 E SUFICIENTE PARA COMPROVAR O ENDERECO INFORMADO PELO AUTOR. CONSIDERANDO AS PARTES LEGITIMAS, ESTANDO BEM REPRESENTADAS E LITIGANDO COM INTERESSE, ALEM DA AUSENCIA DE FALHAS OU NULIDADES A SUPRIR, DOU O FEITO POR SANEADO. O AUTOR ALEGA UTILIZACAO FRAUDULENTA DE SEUS DADOS E A FALSIDADE DA ASSINATURA NA CONDICAO DE CONTRATANTE DOS SERVICOS PRESTADOS PELA RE. EM RAZAO DE CONSTITUIR PONTO CONTROVERTIDO A RELACAO JURIDICA EXISTENTE ENTRE O AUTOR E A RE, PARA DETERMINAR A EXIGIBILIDADE DO DEBITO, NECESSARIA A PRODUCAO DE PROVA PERICIAL GRAFOTECNICA COM O OBJETIVO DE VERIFICAR A AUTENTICIDADE DA ASSINATURA ATRIBUIDA AO AUTOR NO DOCUMENTO DE FLS. 92/93. ASSIM, NOMEIO A PERITA SILVANA MANZI GRANJA. INTIMEM-SE AS PARTES PARA QUE FORMULEM QUESITOS E INDIQUEM ASSISTENTES TECNICOS EM QUINZE DIAS. APOS, INTIME-SE A PERITA NOMEADO PARA QUE ESTIME O VALOR DOS HONORARIOS, EM DEZ DIAS. E RELEVANTE SALIENTAR QUE SE TRATA DE CONTESTACAO DE ASSINATURA CONSTANTE EM CONTRATO, DE MODO QUE O ONUS DA PROVA INCUMBE A PARTE QUE APRESENTOU O REFERIDO DOCUMENTO. ASSIM, O ONUS DA PROVA DA AUTENTICIDADE DA ASSINATURA PERTENCE A EMPRESA DE TELEFONIA, QUE PRODUZIU O DOCUMENTO MENCIONADO, NOS TERMOS DO ARTIGO 429, INCISO II, DO CODIGO DE PROCESSO CIVIL. TAL REGRA NAO SE APLICA AO CUSTEIO DA PERICIA DETERMINADA, NA FORMA DOS ARTIGOS 82 E 95 DO CODIGO DE PROCESSO CIVIL. NO PRESENTE CASO, A PRODUCAO DA PROVA PERICIAL GRAFOTECNICA FOI DETERMINADA PELO JUIZO. PORTANTO, O VALOR ARBITRADO DEVE SER ANTECIPADO POR AMBAS AS PARTES NA PROPORCAO DE 50% PARA CADA UMA. EFETUADO O DEPOSITO E DECORRIDO O PRAZO ACIMA, INTIME-SE O SR. PERITO PARA DAR INICIO AOS TRABALHOS. PRAZO PARA A JUNTADA DO LAUDO: QUARENTA DIAS APOS A INTIMACAO DO PERITO. CONSIGNO, POR FIM, QUE A PROVA TECNICA E A DOCUMENTAL COMPLEMENTAR SAO AS UNICAS PERTINENTES A SOLUCAO DO LITIGIO, FICANDO INDEFERIDA A PRODUCAO DE PROVA ORAL. INTIME-SE ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP), PATRICIA NABINGER DE ALMEIDA SENA (OAB 155004/RJ), RODRIGO EMILIANO DA SILVA (OAB 172309/RJ)",
                    "PublishDate": "2020-09-23T00:00:00",
                    "CaptureDate": "2021-03-20T12:56:34"
                  },
                  {
                    "Content": "DECISAO VISTOS. RAFAEL CASTRO DE MATOS AJUIZOU A PRESENTE CONTRA NEXTEL TELECOMUNICACOES LTDA., ALEGANDO, EM SUMA, QUE TEVE SEU NOME INSCRITO EM CADASTROS DE INADIMPLENTES EM DECORRENCIA DE SUPOSTA DIVIDA CONTRAIDA JUNTO A RE, NO VALOR TOTAL DE R$ 167,16. ADUZ NAO RECONHECER O DEBITO, DE MODO QUE AS INSCRICOES INDEVIDAS LHE CAUSOU DANOS MORAIS. POR TAIS MOTIVOS, REQUER A CONCESSAO DA TUTELA DE URGENCIA E A PROCEDENCIA DO PEDIDO PARA QUE SEJA DECLARADA A INEXIGIBILIDADE DO DEBITO, CONDENANDO-SE A RE AO PAGAMENTO DE INDENIZACAO POR DANOS MORAIS NA QUANTIA DE R$ 10.000,00. A PETICAO INICIAL VEIO INSTRUIDA COM DOCUMENTOS (FLS. 15/45). O JUIZO DEFERIU A ANTECIPACAO DOS EFEITOS DA TUTELA (FLS. 65). CITADA, A RE OFERTOU CONTESTACAO (FLS. 82/91), ALEGANDO, EM MATERIA PRELIMINAR, A FALTA DE INTERESSE DE AGIR. EM RELACAO AO MERITO, ADUZ BASICAMENTE A EXIGIBILIDADE DO DEBITO. NARRA TER O AUTOR SOLICITADO O CANCELAMENTO DOS SERVICOS DA RE EM 06 DE MAIO DE 2016, POREM, DEIXOU DE PAGAR A FATURA CORRESPONDENTE AO VALOR PROPORCIONAL COM VENCIMENTO NO DIA 25 DO MESMO MES. ADUZ A INEXISTENCIA DE ATO ILICITO, BEM COMO NAO TER O REQUERENTE SOFRIDO DANO MORAL. PUGNA PELA IMPROCEDENCIA DA PRETENSAO. ACOMPANHA OS DOCUMENTOS DE FLS. 92/124. REPLICA A FLS. 146/159. JUNTOU DOCUMENTOS (FLS. 160/207). INICIALMENTE, AFASTO A PRELIMINAR DE FALTA DE INTERESSE DE AGIR, UMA VEZ QUE A AUSENCIA DE REQUERIMENTO ADMINISTRATIVO NAO ERA OBICE AO AJUIZAMENTO DESTA ACAO, MORMENTE DIANTE DA EFETIVA RESISTENCIA APRESENTADA PELA RE, SOB PENA DE OFENSA AO ART. 5, INCISO XXXV, DA CONSTITUICAO FEDERAL. O DOCUMENTO EXIBIDO A FLS. 16 E SUFICIENTE PARA COMPROVAR O ENDERECO INFORMADO PELO AUTOR. CONSIDERANDO AS PARTES LEGITIMAS, ESTANDO BEM REPRESENTADAS E LITIGANDO COM INTERESSE, ALEM DA AUSENCIA DE FALHAS OU NULIDADES A SUPRIR, DOU O FEITO POR SANEADO. O AUTOR ALEGA UTILIZACAO FRAUDULENTA DE SEUS DADOS E A FALSIDADE DA ASSINATURA NA CONDICAO DE CONTRATANTE DOS SERVICOS PRESTADOS PELA RE. EM RAZAO DE CONSTITUIR PONTO CONTROVERTIDO A RELACAO JURIDICA EXISTENTE ENTRE O AUTOR E A RE, PARA DETERMINAR A EXIGIBILIDADE DO DEBITO, NECESSARIA A PRODUCAO DE PROVA PERICIAL GRAFOTECNICA COM O OBJETIVO DE VERIFICAR A AUTENTICIDADE DA ASSINATURA ATRIBUIDA AO AUTOR NO DOCUMENTO DE FLS. 92/93. ASSIM, NOMEIO A PERITA SILVANA MANZI GRANJA. INTIMEM-SE AS PARTES PARA QUE FORMULEM QUESITOS E INDIQUEM ASSISTENTES TECNICOS EM QUINZE DIAS. APOS, INTIME-SE A PERITA NOMEADO PARA QUE ESTIME O VALOR DOS HONORARIOS, EM DEZ DIAS. E RELEVANTE SALIENTAR QUE SE TRATA DE CONTESTACAO DE ASSINATURA CONSTANTE EM CONTRATO, DE MODO QUE O ONUS DA PROVA INCUMBE A PARTE QUE APRESENTOU O REFERIDO DOCUMENTO. ASSIM, O ONUS DA PROVA DA AUTENTICIDADE DA ASSINATURA PERTENCE A EMPRESA DE TELEFONIA, QUE PRODUZIU O DOCUMENTO MENCIONADO, NOS TERMOS DO ARTIGO 429, INCISO II, DO CODIGO DE PROCESSO CIVIL. TAL REGRA NAO SE APLICA AO CUSTEIO DA PERICIA DETERMINADA, NA FORMA DOS ARTIGOS 82 E 95 DO CODIGO DE PROCESSO CIVIL. NO PRESENTE CASO, A PRODUCAO DA PROVA PERICIAL GRAFOTECNICA FOI DETERMINADA PELO JUIZO. PORTANTO, O VALOR ARBITRADO DEVE SER ANTECIPADO POR AMBAS AS PARTES NA PROPORCAO DE 50% PARA CADA UMA. EFETUADO O DEPOSITO E DECORRIDO O PRAZO ACIMA, INTIME-SE O SR. PERITO PARA DAR INICIO AOS TRABALHOS. PRAZO PARA A JUNTADA DO LAUDO: QUARENTA DIAS APOS A INTIMACAO DO PERITO. CONSIGNO, POR FIM, QUE A PROVA TECNICA E A DOCUMENTAL COMPLEMENTAR SAO AS UNICAS PERTINENTES A SOLUCAO DO LITIGIO, FICANDO INDEFERIDA A PRODUCAO DE PROVA ORAL. INTIME-SE",
                    "PublishDate": "2020-09-22T00:00:00",
                    "CaptureDate": "2020-10-04T23:23:27"
                  },
                  {
                    "Content": "DECISAO | VISTOS. RAFAEL CASTRO DE MATOS AJUIZOU A PRESENTE CONTRA NEXTEL TELECOMUNICACOES LTDA., ALEGANDO, EM SUMA, QUE TEVE SEU NOME INSCRITO EM CADASTROS DE INADIMPLENTES EM DECORRENCIA DE SUPOSTA DIVIDA CONTRAIDA JUNTO A RE, NO VALOR TOTAL DE R$ 167,16. ADUZ NAO RECONHECER O DEBITO, DE MODO QUE AS INSCRICOES INDEVIDAS LHE CAUSOU DANOS MORAIS. POR TAIS MOTIVOS, REQUER A CONCESSAO DA TUTELA DE URGENCIA E A PROCEDENCIA DO PEDIDO PARA QUE SEJA DECLARADA A INEXIGIBILIDADE DO DEBITO, CONDENANDO-SE A RE AO PAGAMENTO DE INDENIZACAO POR DANOS MORAIS NA QUANTIA DE R$ 10.000,00. A PETICAO INICIAL VEIO INSTRUIDA COM DOCUMENTOS (FLS. 15/45). O JUIZO DEFERIU A ANTECIPACAO DOS EFEITOS DA TUTELA (FLS. 65). CITADA, A RE OFERTOU CONTESTACAO (FLS. 82/91), ALEGANDO, EM MATERIA PRELIMINAR, A FALTA DE INTERESSE DE AGIR. EM RELACAO AO MERITO, ADUZ BASICAMENTE A EXIGIBILIDADE DO DEBITO. NARRA TER O AUTOR SOLICITADO O CANCELAMENTO DOS SERVICOS DA RE EM 06 DE MAIO DE 2016, POREM, DEIXOU DE PAGAR A FATURA CORRESPONDENTE AO VALOR PROPORCIONAL COM VENCIMENTO NO DIA 25 DO MESMO MES. ADUZ A INEXISTENCIA DE ATO ILICITO, BEM COMO NAO TER O REQUERENTE SOFRIDO DANO MORAL. PUGNA PELA IMPROCEDENCIA DA PRETENSAO. ACOMPANHA OS DOCUMENTOS DE FLS. 92/124. REPLICA A FLS. 146/159. JUNTOU DOCUMENTOS (FLS. 160/207). INICIALMENTE, AFASTO A PRELIMINAR DE FALTA DE INTERESSE DE AGIR, UMA VEZ QUE A AUSENCIA DE REQUERIMENTO ADMINISTRATIVO NAO ERA OBICE AO AJUIZAMENTO DESTA ACAO, MORMENTE DIANTE DA EFETIVA RESISTENCIA APRESENTADA PELA RE, SOB PENA DE OFENSA AO ART. 5, INCISO XXXV, DA CONSTITUICAO FEDERAL. O DOCUMENTO EXIBIDO A FLS. 16 E SUFICIENTE PARA COMPROVAR O ENDERECO INFORMADO PELO AUTOR. CONSIDERANDO AS PARTES LEGITIMAS, ESTANDO BEM REPRESENTADAS E LITIGANDO COM INTERESSE, ALEM DA AUSENCIA DE FALHAS OU NULIDADES A SUPRIR, DOU O FEITO POR SANEADO. O AUTOR ALEGA UTILIZACAO FRAUDULENTA DE SEUS DADOS E A FALSIDADE DA ASSINATURA NA CONDICAO DE CONTRATANTE DOS SERVICOS PRESTADOS PELA RE. EM RAZAO DE CONSTITUIR PONTO CONTROVERTIDO A RELACAO JURIDICA EXISTENTE ENTRE O AUTOR E A RE, PARA DETERMINAR A EXIGIBILIDADE DO DEBITO, NECESSARIA A PRODUCAO DE PROVA PERICIAL GRAFOTECNICA COM O OBJETIVO DE VERIFICAR A AUTENTICIDADE DA ASSINATURA ATRIBUIDA AO AUTOR NO DOCUMENTO DE FLS. 92/93. ASSIM, NOMEIO A PERITA SILVANA MANZI GRANJA. INTIMEM-SE AS PARTES PARA QUE FORMULEM QUESITOS E INDIQUEM ASSISTENTES TECNICOS EM QUINZE DIAS. APOS, INTIME-SE A PERITA NOMEADO PARA QUE ESTIME O VALOR DOS HONORARIOS, EM DEZ DIAS. E RELEVANTE SALIENTAR QUE SE TRATA DE CONTESTACAO DE ASSINATURA CONSTANTE EM CONTRATO, DE MODO QUE O ONUS DA PROVA INCUMBE A PARTE QUE APRESENTOU O REFERIDO DOCUMENTO. ASSIM, O ONUS DA PROVA DA AUTENTICIDADE DA ASSINATURA PERTENCE A EMPRESA DE TELEFONIA, QUE PRODUZIU O DOCUMENTO MENCIONADO, NOS TERMOS DO ARTIGO 429, INCISO II, DO CODIGO DE PROCESSO CIVIL. TAL REGRA NAO SE APLICA AO CUSTEIO DA PERICIA DETERMINADA, NA FORMA DOS ARTIGOS 82 E 95 DO CODIGO DE PROCESSO CIVIL. NO PRESENTE CASO, A PRODUCAO DA PROVA PERICIAL GRAFOTECNICA FOI DETERMINADA PELO JUIZO. PORTANTO, O VALOR ARBITRADO DEVE SER ANTECIPADO POR AMBAS AS PARTES NA PROPORCAO DE 50% PARA CADA UMA. EFETUADO O DEPOSITO E DECORRIDO O PRAZO ACIMA, INTIME-SE O SR. PERITO PARA DAR INICIO AOS TRABALHOS. PRAZO PARA A JUNTADA DO LAUDO: QUARENTA DIAS APOS A INTIMACAO DO PERITO. CONSIGNO, POR FIM, QUE A PROVA TECNICA E A DOCUMENTAL COMPLEMENTAR SAO AS UNICAS PERTINENTES A SOLUCAO DO LITIGIO, FICANDO INDEFERIDA A PRODUCAO DE PROVA ORAL. INTIME-SE",
                    "PublishDate": "2020-09-22T00:00:00",
                    "CaptureDate": "2021-03-20T12:56:34"
                  },
                  {
                    "Content": "CERTIDAO DE CARTORIO EXPEDIDA CERTIDAO - GENERICA",
                    "PublishDate": "2020-09-18T00:00:00",
                    "CaptureDate": "2020-10-04T23:23:27"
                  },
                  {
                    "Content": "CONCLUSOS PARA SENTENCA",
                    "PublishDate": "2020-09-18T00:00:00",
                    "CaptureDate": "2020-10-04T23:23:27"
                  },
                  {
                    "Content": "CONCLUSOS PARA SENTENCA",
                    "PublishDate": "2020-09-18T00:00:00",
                    "CaptureDate": "2021-03-20T12:56:34"
                  },
                  {
                    "Content": "CERTIDAO DE CARTORIO EXPEDIDA | CERTIDAO - GENERICA",
                    "PublishDate": "2020-09-18T00:00:00",
                    "CaptureDate": "2021-03-20T12:56:34"
                  },
                  {
                    "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.20.40867977-8 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 22/06/2020 23:46",
                    "PublishDate": "2020-06-22T00:00:00",
                    "CaptureDate": "2020-10-04T23:23:27"
                  },
                  {
                    "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.20.40867977-8 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 22/06/2020 23:46",
                    "PublishDate": "2020-06-22T00:00:00",
                    "CaptureDate": "2021-03-20T12:56:34"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0162/2020 DATA DA DISPONIBILIZACAO: 12/06/2020 DATA DA PUBLICACAO: 15/06/2020 NUMERO DO DIARIO: 3061 PAGINA: 64 A 80",
                    "PublishDate": "2020-06-12T00:00:00",
                    "CaptureDate": "2020-10-04T23:23:27"
                  },
                  {
                    "Content": "PROCESSO 1010478-46.2020.8.26.0100 - PROCEDIMENTO COMUM CIVEL - INDENIZACAO POR DANO MORAL - RAFAEL CASTRO DE MATOS - NEXTEL TELECOMUNICACOES LTDA - VISTOS. SEM PREJUIZO DE EVENTUAL JULGAMENTO NO ESTADO, ESPECIFIQUEM AS PARTES AS PROVAS QUE PRETENDEM PRODUZIR, JUSTIFICANDO-AS. FICAM AS PARTES INTIMADAS A APRESENTAR EM JUIZO, PARA HOMOLOGACAO, A DELIMITACAO CONSENSUAL DAS QUESTOES DE FATO E DE DIREITO RELEVANTES PARA DECISAO DE MERITO, NOS TERMOS DO ARTIGO 357,  2, DO CODIGO DE PROCESSO CIVIL. DIGAM, AINDA, SOBRE O INTERESSE NA DESIGNACAO DE AUDIENCIA DE CONCILIACAO. INTIME-SE. - ADV: RAFAEL HIDEO NAZIMA (OAB 295443/SP), PATRICIA NABINGER DE ALMEIDA SENA (OAB 155004/RJ), RODRIGO EMILIANO DA SILVA (OAB 172309/RJ)",
                    "PublishDate": "2020-06-12T00:00:00",
                    "CaptureDate": "2020-10-04T23:23:27"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0162/2020 DATA DA DISPONIBILIZACAO: 12/06/2020 DATA DA PUBLICACAO: 15/06/2020 NUMERO DO DIARIO: 3061 PAGINA: 64 A 80",
                    "PublishDate": "2020-06-12T00:00:00",
                    "CaptureDate": "2021-03-20T12:56:34"
                  },
                  {
                    "Content": "DECISAO VISTOS. SEM PREJUIZO DE EVENTUAL JULGAMENTO NO ESTADO, ESPECIFIQUEM AS PARTES AS PROVAS QUE PRETENDEM PRODUZIR, JUSTIFICANDO-AS. FICAM AS PARTES INTIMADAS A APRESENTAR EM JUIZO, PARA HOMOLOGACAO, A DELIMITACAO CONSENSUAL DAS QUESTOES DE FATO E DE DIREITO RELEVANTES PARA DECISAO DE MERITO, NOS TERMOS DO ARTIGO 357,  2, DO CODIGO DE PROCESSO CIVIL. DIGAM, AINDA, SOBRE O INTERESSE NA DESIGNACAO DE AUDIENCIA DE CONCILIACAO. INTIME-SE.",
                    "PublishDate": "2020-06-10T00:00:00",
                    "CaptureDate": "2020-10-04T23:23:27"
                  },
                  {
                    "Content": "REMETIDO AO DJE RELACAO: 0162/2020 TEOR DO ATO: VISTOS. SEM PREJUIZO DE EVENTUAL JULGAMENTO NO ESTADO, ESPECIFIQUEM AS PARTES AS PROVAS QUE PRETENDEM PRODUZIR, JUSTIFICANDO-AS. FICAM AS PARTES INTIMADAS A APRESENTAR EM JUIZO, PARA HOMOLOGACAO, A DELIMITACAO CONSENSUAL DAS QUESTOES DE FATO E DE DIREITO RELEVANTES PARA DECISAO DE MERITO, NOS TERMOS DO ARTIGO 357,  2, DO CODIGO DE PROCESSO CIVIL. DIGAM, AINDA, SOBRE O INTERESSE NA DESIGNACAO DE AUDIENCIA DE CONCILIACAO. INTIME-SE. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP), PATRICIA NABINGER DE ALMEIDA SENA (OAB 155004/RJ), RODRIGO EMILIANO DA SILVA (OAB 172309/RJ)",
                    "PublishDate": "2020-06-10T00:00:00",
                    "CaptureDate": "2020-10-04T23:23:27"
                  },
                  {
                    "Content": "REMETIDO AO DJE | RELACAO: 0162/2020 TEOR DO ATO: VISTOS. SEM PREJUIZO DE EVENTUAL JULGAMENTO NO ESTADO, ESPECIFIQUEM AS PARTES AS PROVAS QUE PRETENDEM PRODUZIR, JUSTIFICANDO-AS. FICAM AS PARTES INTIMADAS A APRESENTAR EM JUIZO, PARA HOMOLOGACAO, A DELIMITACAO CONSENSUAL DAS QUESTOES DE FATO E DE DIREITO RELEVANTES PARA DECISAO DE MERITO, NOS TERMOS DO ARTIGO 357,  2, DO CODIGO DE PROCESSO CIVIL. DIGAM, AINDA, SOBRE O INTERESSE NA DESIGNACAO DE AUDIENCIA DE CONCILIACAO. INTIME-SE. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP), PATRICIA NABINGER DE ALMEIDA SENA (OAB 155004/RJ), RODRIGO EMILIANO DA SILVA (OAB 172309/RJ)",
                    "PublishDate": "2020-06-10T00:00:00",
                    "CaptureDate": "2021-03-20T12:56:34"
                  },
                  {
                    "Content": "DECISAO | VISTOS. SEM PREJUIZO DE EVENTUAL JULGAMENTO NO ESTADO, ESPECIFIQUEM AS PARTES AS PROVAS QUE PRETENDEM PRODUZIR, JUSTIFICANDO-AS. FICAM AS PARTES INTIMADAS A APRESENTAR EM JUIZO, PARA HOMOLOGACAO, A DELIMITACAO CONSENSUAL DAS QUESTOES DE FATO E DE DIREITO RELEVANTES PARA DECISAO DE MERITO, NOS TERMOS DO ARTIGO 357,  2, DO CODIGO DE PROCESSO CIVIL. DIGAM, AINDA, SOBRE O INTERESSE NA DESIGNACAO DE AUDIENCIA DE CONCILIACAO. INTIME-SE.",
                    "PublishDate": "2020-06-10T00:00:00",
                    "CaptureDate": "2021-03-20T12:56:34"
                  },
                  {
                    "Content": "CONCLUSOS PARA SENTENCA",
                    "PublishDate": "2020-06-03T00:00:00",
                    "CaptureDate": "2020-10-04T23:23:27"
                  },
                  {
                    "Content": "SUSPENSAO DO PRAZO PRAZO REFERENTE AO USUARIO FOI ALTERADO PARA 10/06/2020 DEVIDO A ALTERACAO DA TABELA DE FERIADOS",
                    "PublishDate": "2020-05-31T00:00:00",
                    "CaptureDate": "2020-10-04T23:23:27"
                  },
                  {
                    "Content": "SUSPENSAO DO PRAZO | PRAZO REFERENTE AO USUARIO FOI ALTERADO PARA 10/06/2020 DEVIDO A ALTERACAO DA TABELA DE FERIADOS",
                    "PublishDate": "2020-05-31T00:00:00",
                    "CaptureDate": "2021-03-20T12:56:34"
                  },
                  {
                    "Content": "REPLICA JUNTADA N PROTOCOLO: WJMJ.20.40681133-4 TIPO DA PETICAO: MANIFESTACAO SOBRE A CONTESTACAO DATA: 22/05/2020 23:24",
                    "PublishDate": "2020-05-23T00:00:00",
                    "CaptureDate": "2020-10-04T23:23:27"
                  },
                  {
                    "Content": "REPLICA JUNTADA | N PROTOCOLO: WJMJ.20.40681133-4 TIPO DA PETICAO: MANIFESTACAO SOBRE A CONTESTACAO DATA: 22/05/2020 23:24",
                    "PublishDate": "2020-05-23T00:00:00",
                    "CaptureDate": "2021-03-20T12:56:34"
                  },
                  {
                    "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.20.40479279-0 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 14/04/2020 13:16",
                    "PublishDate": "2020-04-14T00:00:00",
                    "CaptureDate": "2020-10-04T23:23:27"
                  },
                  {
                    "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.20.40479279-0 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 14/04/2020 13:16",
                    "PublishDate": "2020-04-14T00:00:00",
                    "CaptureDate": "2021-03-20T12:56:34"
                  },
                  {
                    "Content": "AR POSITIVO JUNTADO JUNTADA DE AR : AR095908941TJ SITUACAO : CUMPRIDO MODELO : PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC DESTINATARIO : 'NEXTEL TELECOMUNICACOES LTDA DILIGENCIA : 13/03/2020",
                    "PublishDate": "2020-04-13T00:00:00",
                    "CaptureDate": "2020-10-04T23:23:27"
                  },
                  {
                    "Content": "AR POSITIVO JUNTADO | JUNTADA DE AR : AR095908941TJ SITUACAO : CUMPRIDO MODELO : PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC DESTINATARIO : 'NEXTEL TELECOMUNICACOES LTDA DILIGENCIA : 13/03/2020",
                    "PublishDate": "2020-04-13T00:00:00",
                    "CaptureDate": "2021-03-20T12:56:34"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0099/2020 DATA DA DISPONIBILIZACAO: 02/04/2020 DATA DA PUBLICACAO: 03/04/2020 NUMERO DO DIARIO: 3018 PAGINA: 78 A 121",
                    "PublishDate": "2020-04-02T00:00:00",
                    "CaptureDate": "2020-04-04T04:35:46"
                  },
                  {
                    "Content": "PROCESSO 1010478-46.2020.8.26.0100 - PROCEDIMENTO COMUM CIVEL - INDENIZACAO POR DANO MORAL - RAFAEL CASTRO DE MATOS - NEXTEL TELECOMUNICACOES LTDA - FLS. 82/137: MANIFESTE(M)-SE O(A)(S) AUTOR(A)(S) ACERCA DA CONTESTACAO E DOCUMENTOS. REGULARIZE(M) O(A)(S) REQUERIDO(A)(S) SUA REPRESENTACAO PROCESSUAL, RECOLHENDO A TAXA PREVIDENCIARIA DA OAB REFERENTE AOS INSTRUMENTOS DE PROCURACAO E/OU SUBSTABELECIMENTO DE SEUS PATRONOS, SOB PENA DE SER OFICIADO A OAB PARA COMUNICACAO E PROVIDENCIAS CABIVEIS. - ADV: RAFAEL HIDEO NAZIMA (OAB 295443/SP), PATRICIA NABINGER DE ALMEIDA SENA (OAB 155004/RJ), RODRIGO EMILIANO DA SILVA (OAB 172309/RJ)",
                    "PublishDate": "2020-04-02T00:00:00",
                    "CaptureDate": "2020-04-04T04:35:46"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0099/2020 DATA DA DISPONIBILIZACAO: 02/04/2020 DATA DA PUBLICACAO: 03/04/2020 NUMERO DO DIARIO: 3018 PAGINA: 78 A 121",
                    "PublishDate": "2020-04-02T00:00:00",
                    "CaptureDate": "2020-10-04T23:23:27"
                  },
                  {
                    "Content": "REMETIDO AO DJE | RELACAO: 0099/2020 TEOR DO ATO: FLS. 82/137: MANIFESTE(M)-SE O(A)(S) AUTOR(A)(S) ACERCA DA CONTESTACAO E DOCUMENTOS. REGULARIZE(M) O(A)(S) REQUERIDO(A)(S) SUA REPRESENTACAO PROCESSUAL, RECOLHENDO A TAXA PREVIDENCIARIA DA OAB REFERENTE AOS INSTRUMENTOS DE PROCURACAO E/OU SUBSTABELECIMENTO DE SEUS PATRONOS, SOB PENA DE SER OFICIADO A OAB PARA COMUNICACAO E PROVIDENCIAS CABIVEIS. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP), PATRICIA NABINGER DE ALMEIDA SENA (OAB 155004/RJ), RODRIGO EMILIANO DA SILVA (OAB 172309/RJ)",
                    "PublishDate": "2020-03-31T00:00:00",
                    "CaptureDate": "2020-04-04T04:35:46"
                  },
                  {
                    "Content": "ATO ORDINATORIO | FLS. 82/137: MANIFESTE(M)-SE O(A)(S) AUTOR(A)(S) ACERCA DA CONTESTACAO E DOCUMENTOS. REGULARIZE(M) O(A)(S) REQUERIDO(A)(S) SUA REPRESENTACAO PROCESSUAL, RECOLHENDO A TAXA PREVIDENCIARIA DA OAB REFERENTE AOS INSTRUMENTOS DE PROCURACAO E/OU SUBSTABELECIMENTO DE SEUS PATRONOS, SOB PENA DE SER OFICIADO A OAB PARA COMUNICACAO E PROVIDENCIAS CABIVEIS.",
                    "PublishDate": "2020-03-31T00:00:00",
                    "CaptureDate": "2020-04-04T04:35:46"
                  },
                  {
                    "Content": "ATO ORDINATORIO FLS. 82/137: MANIFESTE(M)-SE O(A)(S) AUTOR(A)(S) ACERCA DA CONTESTACAO E DOCUMENTOS. REGULARIZE(M) O(A)(S) REQUERIDO(A)(S) SUA REPRESENTACAO PROCESSUAL, RECOLHENDO A TAXA PREVIDENCIARIA DA OAB REFERENTE AOS INSTRUMENTOS DE PROCURACAO E/OU SUBSTABELECIMENTO DE SEUS PATRONOS, SOB PENA DE SER OFICIADO A OAB PARA COMUNICACAO E PROVIDENCIAS CABIVEIS.",
                    "PublishDate": "2020-03-31T00:00:00",
                    "CaptureDate": "2020-10-04T23:23:27"
                  },
                  {
                    "Content": "REMETIDO AO DJE RELACAO: 0099/2020 TEOR DO ATO: FLS. 82/137: MANIFESTE(M)-SE O(A)(S) AUTOR(A)(S) ACERCA DA CONTESTACAO E DOCUMENTOS. REGULARIZE(M) O(A)(S) REQUERIDO(A)(S) SUA REPRESENTACAO PROCESSUAL, RECOLHENDO A TAXA PREVIDENCIARIA DA OAB REFERENTE AOS INSTRUMENTOS DE PROCURACAO E/OU SUBSTABELECIMENTO DE SEUS PATRONOS, SOB PENA DE SER OFICIADO A OAB PARA COMUNICACAO E PROVIDENCIAS CABIVEIS. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP), PATRICIA NABINGER DE ALMEIDA SENA (OAB 155004/RJ), RODRIGO EMILIANO DA SILVA (OAB 172309/RJ)",
                    "PublishDate": "2020-03-31T00:00:00",
                    "CaptureDate": "2020-10-04T23:23:27"
                  },
                  {
                    "Content": "CONTESTACAO JUNTADA | N PROTOCOLO: WJMJ.20.40422498-9 TIPO DA PETICAO: CONTESTACAO DATA: 27/03/2020 08:19",
                    "PublishDate": "2020-03-27T00:00:00",
                    "CaptureDate": "2020-04-04T04:35:46"
                  },
                  {
                    "Content": "CONTESTACAO JUNTADA N PROTOCOLO: WJMJ.20.40422498-9 TIPO DA PETICAO: CONTESTACAO DATA: 27/03/2020 08:19",
                    "PublishDate": "2020-03-27T00:00:00",
                    "CaptureDate": "2020-10-04T23:23:27"
                  },
                  {
                    "Content": "CARTA EXPEDIDA | PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                    "PublishDate": "2020-03-09T00:00:00",
                    "CaptureDate": "2020-04-04T04:35:46"
                  },
                  {
                    "Content": "CARTA EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                    "PublishDate": "2020-03-09T00:00:00",
                    "CaptureDate": "2020-10-04T23:23:27"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0060/2020 DATA DA DISPONIBILIZACAO: 28/02/2020 DATA DA PUBLICACAO: 02/03/2020 NUMERO DO DIARIO: 2994 PAGINA: 108 A 122",
                    "PublishDate": "2020-02-28T00:00:00",
                    "CaptureDate": "2020-02-22T00:34:24"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0060/2020 DATA DA DISPONIBILIZACAO: 28/02/2020 DATA DA PUBLICACAO: 02/03/2020 NUMERO DO DIARIO: 2994 PAGINA: 108 A 122",
                    "PublishDate": "2020-02-28T00:00:00",
                    "CaptureDate": "2020-10-04T23:23:27"
                  },
                  {
                    "Content": "REMETIDO AO DJE | RELACAO: 0060/2020 TEOR DO ATO: VISTOS. EM ATENCAO AO PRINCIPIO CONSTITUCIONAL DA RAZOAVEL DURACAO DO PROCESSO (CF, ART. 5, INCISO LXXVII), A AUDIENCIA PREVISTA NO ARTIGO 334 DO CODIGO DE PROCESSO CIVIL SERA DESIGNADA FUTURAMENTE, NA HIPOTESE DE MANIFESTACAO DE INTERESSE DE AMBAS AS PARTES. CITE-SE A PARTE DEMANDADA ('NEXTEL TELECOMUNICACOES LTDA) POR MEIO DE CARTA, PARA QUE, QUERENDO, OFERECA RESPOSTA A DEMANDA, NO PRAZO DE QUINZE DIAS. NAO SENDO CONTESTADA A PRESENTE ACAO, NO PRAZO LEGAL, POR ADVOGADO LEGALMENTE HABILITADO, PRESUMIR-SE-AO ACEITOS OS FATOS ARTICULADOS NA PETICAO INICIAL, CONSOANTE O DISPOSTO NO ARTIGO 344 DO CODIGO DE PROCESSO CIVIL. INTIME-SE. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2020-02-27T00:00:00",
                    "CaptureDate": "2020-02-22T00:34:24"
                  },
                  {
                    "Content": "REMETIDO AO DJE RELACAO: 0060/2020 TEOR DO ATO: VISTOS. EM ATENCAO AO PRINCIPIO CONSTITUCIONAL DA RAZOAVEL DURACAO DO PROCESSO (CF, ART. 5, INCISO LXXVII), A AUDIENCIA PREVISTA NO ARTIGO 334 DO CODIGO DE PROCESSO CIVIL SERA DESIGNADA FUTURAMENTE, NA HIPOTESE DE MANIFESTACAO DE INTERESSE DE AMBAS AS PARTES. CITE-SE A PARTE DEMANDADA ('NEXTEL TELECOMUNICACOES LTDA) POR MEIO DE CARTA, PARA QUE, QUERENDO, OFERECA RESPOSTA A DEMANDA, NO PRAZO DE QUINZE DIAS. NAO SENDO CONTESTADA A PRESENTE ACAO, NO PRAZO LEGAL, POR ADVOGADO LEGALMENTE HABILITADO, PRESUMIR-SE-AO ACEITOS OS FATOS ARTICULADOS NA PETICAO INICIAL, CONSOANTE O DISPOSTO NO ARTIGO 344 DO CODIGO DE PROCESSO CIVIL. INTIME-SE. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2020-02-27T00:00:00",
                    "CaptureDate": "2020-10-04T23:23:27"
                  },
                  {
                    "Content": "RECEBIDA A PETICAO INICIAL - CITACAO POR CARTA AR | VISTOS. EM ATENCAO AO PRINCIPIO CONSTITUCIONAL DA RAZOAVEL DURACAO DO PROCESSO (CF, ART. 5, INCISO LXXVII), A AUDIENCIA PREVISTA NO ARTIGO 334 DO CODIGO DE PROCESSO CIVIL SERA DESIGNADA FUTURAMENTE, NA HIPOTESE DE MANIFESTACAO DE INTERESSE DE AMBAS AS PARTES. CITE-SE A PARTE DEMANDADA ('NEXTEL TELECOMUNICACOES LTDA) POR MEIO DE CARTA, PARA QUE, QUERENDO, OFERECA RESPOSTA A DEMANDA, NO PRAZO DE QUINZE DIAS. NAO SENDO CONTESTADA A PRESENTE ACAO, NO PRAZO LEGAL, POR ADVOGADO LEGALMENTE HABILITADO, PRESUMIR-SE-AO ACEITOS OS FATOS ARTICULADOS NA PETICAO INICIAL, CONSOANTE O DISPOSTO NO ARTIGO 344 DO CODIGO DE PROCESSO CIVIL. INTIME-SE.",
                    "PublishDate": "2020-02-26T00:00:00",
                    "CaptureDate": "2020-02-22T00:34:24"
                  },
                  {
                    "Content": "RECEBIDA A PETICAO INICIAL - CITACAO POR CARTA AR VISTOS. EM ATENCAO AO PRINCIPIO CONSTITUCIONAL DA RAZOAVEL DURACAO DO PROCESSO (CF, ART. 5, INCISO LXXVII), A AUDIENCIA PREVISTA NO ARTIGO 334 DO CODIGO DE PROCESSO CIVIL SERA DESIGNADA FUTURAMENTE, NA HIPOTESE DE MANIFESTACAO DE INTERESSE DE AMBAS AS PARTES. CITE-SE A PARTE DEMANDADA ('NEXTEL TELECOMUNICACOES LTDA) POR MEIO DE CARTA, PARA QUE, QUERENDO, OFERECA RESPOSTA A DEMANDA, NO PRAZO DE QUINZE DIAS. NAO SENDO CONTESTADA A PRESENTE ACAO, NO PRAZO LEGAL, POR ADVOGADO LEGALMENTE HABILITADO, PRESUMIR-SE-AO ACEITOS OS FATOS ARTICULADOS NA PETICAO INICIAL, CONSOANTE O DISPOSTO NO ARTIGO 344 DO CODIGO DE PROCESSO CIVIL. INTIME-SE.",
                    "PublishDate": "2020-02-26T00:00:00",
                    "CaptureDate": "2020-10-04T23:23:27"
                  },
                  {
                    "Content": "PEDIDO DE CITACAO - ENDERECO LOCALIZADO JUNTADO | N PROTOCOLO: WJMJ.20.40258299-3 TIPO DA PETICAO: PEDIDO DE CITACAO - ENDERECO LOCALIZADO DATA: 22/02/2020 01:12",
                    "PublishDate": "2020-02-22T00:00:00",
                    "CaptureDate": "2020-02-22T00:34:24"
                  },
                  {
                    "Content": "PEDIDO DE CITACAO - ENDERECO LOCALIZADO JUNTADO N PROTOCOLO: WJMJ.20.40258299-3 TIPO DA PETICAO: PEDIDO DE CITACAO - ENDERECO LOCALIZADO DATA: 22/02/2020 01:12",
                    "PublishDate": "2020-02-22T00:00:00",
                    "CaptureDate": "2020-10-04T23:23:27"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0056/2020 DATA DA DISPONIBILIZACAO: 21/02/2020 DATA DA PUBLICACAO: 26/02/2020 NUMERO DO DIARIO: 2991 PAGINA: 142 A 156",
                    "PublishDate": "2020-02-21T00:00:00",
                    "CaptureDate": "2020-02-22T00:34:24"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0056/2020 DATA DA DISPONIBILIZACAO: 21/02/2020 DATA DA PUBLICACAO: 26/02/2020 NUMERO DO DIARIO: 2991 PAGINA: 142 A 156",
                    "PublishDate": "2020-02-21T00:00:00",
                    "CaptureDate": "2020-10-04T23:23:27"
                  },
                  {
                    "Content": "REMETIDO AO DJE | RELACAO: 0056/2020 TEOR DO ATO: FLS. 71/72: CIENCIA DA EXCLUSAO DA(S) PARTE(S) NO CADASTRO DE INADIMPLENTES DA SERASA POR MEIO DO SISTEMA SERASAJUD, CONFORME DECISAO DE FLS. 65. MANIFESTE-SE EM TERMOS DE PROSSEGUIMENTO. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2020-02-20T00:00:00",
                    "CaptureDate": "2020-02-22T00:34:24"
                  },
                  {
                    "Content": "REMETIDO AO DJE RELACAO: 0056/2020 TEOR DO ATO: FLS. 71/72: CIENCIA DA EXCLUSAO DA(S) PARTE(S) NO CADASTRO DE INADIMPLENTES DA SERASA POR MEIO DO SISTEMA SERASAJUD, CONFORME DECISAO DE FLS. 65. MANIFESTE-SE EM TERMOS DE PROSSEGUIMENTO. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2020-02-20T00:00:00",
                    "CaptureDate": "2020-10-04T23:23:27"
                  },
                  {
                    "Content": "ATO ORDINATORIO | FLS. 71/72: CIENCIA DA EXCLUSAO DA(S) PARTE(S) NO CADASTRO DE INADIMPLENTES DA SERASA POR MEIO DO SISTEMA SERASAJUD, CONFORME DECISAO DE FLS. 65. MANIFESTE-SE EM TERMOS DE PROSSEGUIMENTO.",
                    "PublishDate": "2020-02-19T00:00:00",
                    "CaptureDate": "2020-02-22T00:34:24"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO |",
                    "PublishDate": "2020-02-19T00:00:00",
                    "CaptureDate": "2020-02-22T00:34:24"
                  },
                  {
                    "Content": "CERTIDAO DE CARTORIO EXPEDIDA | CERTIDAO - GUIAS QUEIMADAS",
                    "PublishDate": "2020-02-19T00:00:00",
                    "CaptureDate": "2020-02-22T00:34:24"
                  },
                  {
                    "Content": "DOCUMENTO JUNTADO |",
                    "PublishDate": "2020-02-19T00:00:00",
                    "CaptureDate": "2020-02-22T00:34:24"
                  },
                  {
                    "Content": "PROTOCOLO JUNTADO |",
                    "PublishDate": "2020-02-19T00:00:00",
                    "CaptureDate": "2020-02-22T00:34:24"
                  },
                  {
                    "Content": "PEDIDO DE LIMINAR/TUTELA ANTECIPADA JUNTADO | N PROTOCOLO: WJMJ.20.40230388-1 TIPO DA PETICAO: PEDIDO DE LIMINAR/ANTECIPACAO DE TUTELA DATA: 19/02/2020 02:50",
                    "PublishDate": "2020-02-19T00:00:00",
                    "CaptureDate": "2020-02-22T00:34:24"
                  },
                  {
                    "Content": "PEDIDO DE LIMINAR/TUTELA ANTECIPADA JUNTADO N PROTOCOLO: WJMJ.20.40230388-1 TIPO DA PETICAO: PEDIDO DE LIMINAR/ANTECIPACAO DE TUTELA DATA: 19/02/2020 02:50",
                    "PublishDate": "2020-02-19T00:00:00",
                    "CaptureDate": "2020-10-04T23:23:27"
                  },
                  {
                    "Content": "PROTOCOLO JUNTADO",
                    "PublishDate": "2020-02-19T00:00:00",
                    "CaptureDate": "2020-10-04T23:23:27"
                  },
                  {
                    "Content": "DOCUMENTO JUNTADO",
                    "PublishDate": "2020-02-19T00:00:00",
                    "CaptureDate": "2020-10-04T23:23:27"
                  },
                  {
                    "Content": "CERTIDAO DE CARTORIO EXPEDIDA CERTIDAO - GUIAS QUEIMADAS",
                    "PublishDate": "2020-02-19T00:00:00",
                    "CaptureDate": "2020-10-04T23:23:27"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO",
                    "PublishDate": "2020-02-19T00:00:00",
                    "CaptureDate": "2020-10-04T23:23:27"
                  },
                  {
                    "Content": "ATO ORDINATORIO FLS. 71/72: CIENCIA DA EXCLUSAO DA(S) PARTE(S) NO CADASTRO DE INADIMPLENTES DA SERASA POR MEIO DO SISTEMA SERASAJUD, CONFORME DECISAO DE FLS. 65. MANIFESTE-SE EM TERMOS DE PROSSEGUIMENTO.",
                    "PublishDate": "2020-02-19T00:00:00",
                    "CaptureDate": "2020-10-04T23:23:27"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO",
                    "PublishDate": "2020-02-19T00:00:00",
                    "CaptureDate": "2021-03-20T12:56:34"
                  },
                  {
                    "Content": "DOCUMENTO JUNTADO",
                    "PublishDate": "2020-02-19T00:00:00",
                    "CaptureDate": "2021-03-20T12:56:34"
                  },
                  {
                    "Content": "PROTOCOLO JUNTADO",
                    "PublishDate": "2020-02-19T00:00:00",
                    "CaptureDate": "2021-03-20T12:56:34"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0041/2020 DATA DA DISPONIBILIZACAO: 12/02/2020 DATA DA PUBLICACAO: 13/02/2020 NUMERO DO DIARIO: 2984 PAGINA: 86 A 109",
                    "PublishDate": "2020-02-12T00:00:00",
                    "CaptureDate": "2020-02-13T00:31:47"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0041/2020 DATA DA DISPONIBILIZACAO: 12/02/2020 DATA DA PUBLICACAO: 13/02/2020 NUMERO DO DIARIO: 2984 PAGINA: 86 A 109",
                    "PublishDate": "2020-02-12T00:00:00",
                    "CaptureDate": "2020-02-13T00:31:47"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0041/2020 DATA DA DISPONIBILIZACAO: 12/02/2020 DATA DA PUBLICACAO: 13/02/2020 NUMERO DO DIARIO: 2984 PAGINA: 86 A 109",
                    "PublishDate": "2020-02-12T00:00:00",
                    "CaptureDate": "2020-10-04T23:23:27"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0041/2020 DATA DA DISPONIBILIZACAO: 12/02/2020 DATA DA PUBLICACAO: 13/02/2020 NUMERO DO DIARIO: 2984 PAGINA: 86 A 109",
                    "PublishDate": "2020-02-12T00:00:00",
                    "CaptureDate": "2020-10-04T23:23:27"
                  },
                  {
                    "Content": "REMETIDO AO DJE | RELACAO: 0041/2020 TEOR DO ATO: - TAXA JUDICIARIA COM VALOR INCORRETO (VALOR MINIMO DE R$ 138,05 OU 1% DO VALOR DA CAUSA). REGULARIZAR NOS TERMOS DO COMUNICADO CG N 1307/2007 (GUIA DARE - CODIGO 230-6), NO PRAZO DE 30 DIAS, SOB PENA DE CANCELAMENTO DA DISTRIBUICAO; - TAXA DA OAB COM VALOR INCORRETO; O RECOLHIMENTO DEVE SER NO VALOR DE R$ 23,66 E POR CADA PROCURACAO OU SUBSTABELECIMENTO JUNTADO. REGULARIZAR NOS TERMOS DO COMUNICADO CG N 1307/2007 (GUIA DARE - CODIGO 304-9), NO PRAZO DE 15 DIAS, SOB PENA DE EXPEDICAO DE OFICIO INFORMANDO A OAB. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2020-02-11T00:00:00",
                    "CaptureDate": "2020-02-13T00:31:47"
                  },
                  {
                    "Content": "REMETIDO AO DJE | RELACAO: 0041/2020 TEOR DO ATO: VISTOS. NOS TERMOS DO ARTIGO 300 DO CODIGO DE PROCESSO CIVIL, A TUTELA DE URGENCIA SERA CONCEDIDA QUANDO HOUVER ELEMENTOS QUE EVIDENCIEM A PROBABILIDADE DO DIREITO E O PERIGO DE DANO OU RISCO AO RESULTADO UTIL DO PROCESSO. NO CASO EM ANALISE, ALEM DA AUSENCIA DE OUTRAS RESTRICOES, O AUTOR APRESENTOU GARANTIA DO VALOR DO DEBITO, RAZAO PELA QUAL NAO SE JUSTIFICA A MANUTENCAO DO NOME DO AUTOR NOS CADASTROS DE INADIMPLENTES, MORMENTE PORQUE CONSTITUI ONUS DA RE A COMPROVACAO DA EXISTENCIA E EXIGIBILIDADE DO DEBITO IMPUGNADO. POR TAIS RAZOES, DEFIRO A LIMINAR PARA DETERMINAR A EXCLUSAO DO NOME DO AUTOR DOS CADASTROS DE INADIMPLENTES QUANTO AO DEBITO OBJETO DA PRESENTE ACAO, POR MEIO DO SERASAJUD E, QUANTO A OUTROS EVENTUAIS CADASTROS, A PRESENTE SERVIRA COMO OFICIO A SER ENCAMINHADO DIRETAMENTE PELO REQUERENTE. AGUARDE-SE O CUMPRIMENTO DO INDICADO NO ATO ORDINATORIO DE FLS. 58. INTIME-SE. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2020-02-11T00:00:00",
                    "CaptureDate": "2020-02-13T00:31:47"
                  },
                  {
                    "Content": "REMETIDO AO DJE RELACAO: 0041/2020 TEOR DO ATO: VISTOS. NOS TERMOS DO ARTIGO 300 DO CODIGO DE PROCESSO CIVIL, A TUTELA DE URGENCIA SERA CONCEDIDA QUANDO HOUVER ELEMENTOS QUE EVIDENCIEM A PROBABILIDADE DO DIREITO E O PERIGO DE DANO OU RISCO AO RESULTADO UTIL DO PROCESSO. NO CASO EM ANALISE, ALEM DA AUSENCIA DE OUTRAS RESTRICOES, O AUTOR APRESENTOU GARANTIA DO VALOR DO DEBITO, RAZAO PELA QUAL NAO SE JUSTIFICA A MANUTENCAO DO NOME DO AUTOR NOS CADASTROS DE INADIMPLENTES, MORMENTE PORQUE CONSTITUI ONUS DA RE A COMPROVACAO DA EXISTENCIA E EXIGIBILIDADE DO DEBITO IMPUGNADO. POR TAIS RAZOES, DEFIRO A LIMINAR PARA DETERMINAR A EXCLUSAO DO NOME DO AUTOR DOS CADASTROS DE INADIMPLENTES QUANTO AO DEBITO OBJETO DA PRESENTE ACAO, POR MEIO DO SERASAJUD E, QUANTO A OUTROS EVENTUAIS CADASTROS, A PRESENTE SERVIRA COMO OFICIO A SER ENCAMINHADO DIRETAMENTE PELO REQUERENTE. AGUARDE-SE O CUMPRIMENTO DO INDICADO NO ATO ORDINATORIO DE FLS. 58. INTIME-SE. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2020-02-11T00:00:00",
                    "CaptureDate": "2020-10-04T23:23:27"
                  },
                  {
                    "Content": "REMETIDO AO DJE RELACAO: 0041/2020 TEOR DO ATO: - TAXA JUDICIARIA COM VALOR INCORRETO (VALOR MINIMO DE R$ 138,05 OU 1% DO VALOR DA CAUSA). REGULARIZAR NOS TERMOS DO COMUNICADO CG N 1307/2007 (GUIA DARE - CODIGO 230-6), NO PRAZO DE 30 DIAS, SOB PENA DE CANCELAMENTO DA DISTRIBUICAO; - TAXA DA OAB COM VALOR INCORRETO; O RECOLHIMENTO DEVE SER NO VALOR DE R$ 23,66 E POR CADA PROCURACAO OU SUBSTABELECIMENTO JUNTADO. REGULARIZAR NOS TERMOS DO COMUNICADO CG N 1307/2007 (GUIA DARE - CODIGO 304-9), NO PRAZO DE 15 DIAS, SOB PENA DE EXPEDICAO DE OFICIO INFORMANDO A OAB. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2020-02-11T00:00:00",
                    "CaptureDate": "2020-10-04T23:23:27"
                  },
                  {
                    "Content": "DECISAO | VISTOS. NOS TERMOS DO ARTIGO 300 DO CODIGO DE PROCESSO CIVIL, A TUTELA DE URGENCIA SERA CONCEDIDA QUANDO HOUVER ELEMENTOS QUE EVIDENCIEM A PROBABILIDADE DO DIREITO E O PERIGO DE DANO OU RISCO AO RESULTADO UTIL DO PROCESSO. NO CASO EM ANALISE, ALEM DA AUSENCIA DE OUTRAS RESTRICOES, O AUTOR APRESENTOU GARANTIA DO VALOR DO DEBITO, RAZAO PELA QUAL NAO SE JUSTIFICA A MANUTENCAO DO NOME DO AUTOR NOS CADASTROS DE INADIMPLENTES, MORMENTE PORQUE CONSTITUI ONUS DA RE A COMPROVACAO DA EXISTENCIA E EXIGIBILIDADE DO DEBITO IMPUGNADO. POR TAIS RAZOES, DEFIRO A LIMINAR PARA DETERMINAR A EXCLUSAO DO NOME DO AUTOR DOS CADASTROS DE INADIMPLENTES QUANTO AO DEBITO OBJETO DA PRESENTE ACAO, POR MEIO DO SERASAJUD E, QUANTO A OUTROS EVENTUAIS CADASTROS, A PRESENTE SERVIRA COMO OFICIO A SER ENCAMINHADO DIRETAMENTE PELO REQUERENTE. AGUARDE-SE O CUMPRIMENTO DO INDICADO NO ATO ORDINATORIO DE FLS. 58. INTIME-SE.",
                    "PublishDate": "2020-02-10T00:00:00",
                    "CaptureDate": "2020-02-13T00:31:47"
                  },
                  {
                    "Content": "DECISAO VISTOS. NOS TERMOS DO ARTIGO 300 DO CODIGO DE PROCESSO CIVIL, A TUTELA DE URGENCIA SERA CONCEDIDA QUANDO HOUVER ELEMENTOS QUE EVIDENCIEM A PROBABILIDADE DO DIREITO E O PERIGO DE DANO OU RISCO AO RESULTADO UTIL DO PROCESSO. NO CASO EM ANALISE, ALEM DA AUSENCIA DE OUTRAS RESTRICOES, O AUTOR APRESENTOU GARANTIA DO VALOR DO DEBITO, RAZAO PELA QUAL NAO SE JUSTIFICA A MANUTENCAO DO NOME DO AUTOR NOS CADASTROS DE INADIMPLENTES, MORMENTE PORQUE CONSTITUI ONUS DA RE A COMPROVACAO DA EXISTENCIA E EXIGIBILIDADE DO DEBITO IMPUGNADO. POR TAIS RAZOES, DEFIRO A LIMINAR PARA DETERMINAR A EXCLUSAO DO NOME DO AUTOR DOS CADASTROS DE INADIMPLENTES QUANTO AO DEBITO OBJETO DA PRESENTE ACAO, POR MEIO DO SERASAJUD E, QUANTO A OUTROS EVENTUAIS CADASTROS, A PRESENTE SERVIRA COMO OFICIO A SER ENCAMINHADO DIRETAMENTE PELO REQUERENTE. AGUARDE-SE O CUMPRIMENTO DO INDICADO NO ATO ORDINATORIO DE FLS. 58. INTIME-SE.",
                    "PublishDate": "2020-02-10T00:00:00",
                    "CaptureDate": "2020-10-04T23:23:27"
                  },
                  {
                    "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.20.40162971-6 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 07/02/2020 14:42",
                    "PublishDate": "2020-02-07T00:00:00",
                    "CaptureDate": "2020-02-13T00:31:47"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO |",
                    "PublishDate": "2020-02-07T00:00:00",
                    "CaptureDate": "2020-02-13T00:31:47"
                  },
                  {
                    "Content": "ATO ORDINATORIO | - TAXA JUDICIARIA COM VALOR INCORRETO (VALOR MINIMO DE R$ 138,05 OU 1% DO VALOR DA CAUSA). REGULARIZAR NOS TERMOS DO COMUNICADO CG N 1307/2007 (GUIA DARE - CODIGO 230-6), NO PRAZO DE 30 DIAS, SOB PENA DE CANCELAMENTO DA DISTRIBUICAO; - TAXA DA OAB COM VALOR INCORRETO; O RECOLHIMENTO DEVE SER NO VALOR DE R$ 23,66 E POR CADA PROCURACAO OU SUBSTABELECIMENTO JUNTADO. REGULARIZAR NOS TERMOS DO COMUNICADO CG N 1307/2007 (GUIA DARE - CODIGO 304-9), NO PRAZO DE 15 DIAS, SOB PENA DE EXPEDICAO DE OFICIO INFORMANDO A OAB.",
                    "PublishDate": "2020-02-07T00:00:00",
                    "CaptureDate": "2020-02-13T00:31:47"
                  },
                  {
                    "Content": "CERTIDAO DE CARTORIO EXPEDIDA | CERTIDAO - GUIAS QUEIMADAS",
                    "PublishDate": "2020-02-07T00:00:00",
                    "CaptureDate": "2020-02-13T00:31:47"
                  },
                  {
                    "Content": "PEDIDO DE LIMINAR/TUTELA ANTECIPADA JUNTADO | N PROTOCOLO: WJMJ.20.40159253-7 TIPO DA PETICAO: PEDIDO DE LIMINAR/ANTECIPACAO DE TUTELA DATA: 07/02/2020 01:19",
                    "PublishDate": "2020-02-07T00:00:00",
                    "CaptureDate": "2020-02-13T00:31:47"
                  },
                  {
                    "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR) |",
                    "PublishDate": "2020-02-07T00:00:00",
                    "CaptureDate": "2020-02-13T00:31:47"
                  },
                  {
                    "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                    "PublishDate": "2020-02-07T00:00:00",
                    "CaptureDate": "2020-10-04T23:23:27"
                  },
                  {
                    "Content": "PEDIDO DE LIMINAR/TUTELA ANTECIPADA JUNTADO N PROTOCOLO: WJMJ.20.40159253-7 TIPO DA PETICAO: PEDIDO DE LIMINAR/ANTECIPACAO DE TUTELA DATA: 07/02/2020 01:19",
                    "PublishDate": "2020-02-07T00:00:00",
                    "CaptureDate": "2020-10-04T23:23:27"
                  },
                  {
                    "Content": "CERTIDAO DE CARTORIO EXPEDIDA CERTIDAO - GUIAS QUEIMADAS",
                    "PublishDate": "2020-02-07T00:00:00",
                    "CaptureDate": "2020-10-04T23:23:27"
                  },
                  {
                    "Content": "ATO ORDINATORIO - TAXA JUDICIARIA COM VALOR INCORRETO (VALOR MINIMO DE R$ 138,05 OU 1% DO VALOR DA CAUSA). REGULARIZAR NOS TERMOS DO COMUNICADO CG N 1307/2007 (GUIA DARE - CODIGO 230-6), NO PRAZO DE 30 DIAS, SOB PENA DE CANCELAMENTO DA DISTRIBUICAO; - TAXA DA OAB COM VALOR INCORRETO; O RECOLHIMENTO DEVE SER NO VALOR DE R$ 23,66 E POR CADA PROCURACAO OU SUBSTABELECIMENTO JUNTADO. REGULARIZAR NOS TERMOS DO COMUNICADO CG N 1307/2007 (GUIA DARE - CODIGO 304-9), NO PRAZO DE 15 DIAS, SOB PENA DE EXPEDICAO DE OFICIO INFORMANDO A OAB.",
                    "PublishDate": "2020-02-07T00:00:00",
                    "CaptureDate": "2020-10-04T23:23:27"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO",
                    "PublishDate": "2020-02-07T00:00:00",
                    "CaptureDate": "2020-10-04T23:23:27"
                  },
                  {
                    "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.20.40162971-6 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 07/02/2020 14:42",
                    "PublishDate": "2020-02-07T00:00:00",
                    "CaptureDate": "2020-10-04T23:23:27"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO",
                    "PublishDate": "2020-02-07T00:00:00",
                    "CaptureDate": "2021-03-20T12:56:34"
                  },
                  {
                    "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                    "PublishDate": "2020-02-07T00:00:00",
                    "CaptureDate": "2021-03-20T12:56:34"
                  }
                ],
                "Petitions": [
                  {
                    "Type": "PEDIDO DE LIMINAR/ANTECIPACAO DE TUTELA",
                    "Author": "",
                    "CreationDate": "2020-02-07T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  },
                  {
                    "Type": "PETICOES DIVERSAS",
                    "Author": "",
                    "CreationDate": "2020-02-07T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  },
                  {
                    "Type": "PEDIDO DE LIMINAR/ANTECIPACAO DE TUTELA",
                    "Author": "",
                    "CreationDate": "2020-02-19T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  },
                  {
                    "Type": "PEDIDO DE CITACAO - ENDERECO LOCALIZADO",
                    "Author": "",
                    "CreationDate": "2020-02-22T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  },
                  {
                    "Type": "CONTESTACAO",
                    "Author": "",
                    "CreationDate": "2020-03-27T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  },
                  {
                    "Type": "PETICOES DIVERSAS",
                    "Author": "",
                    "CreationDate": "2020-04-14T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  },
                  {
                    "Type": "MANIFESTACAO SOBRE A CONTESTACAO",
                    "Author": "",
                    "CreationDate": "2020-05-22T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  },
                  {
                    "Type": "PETICOES DIVERSAS",
                    "Author": "",
                    "CreationDate": "2020-06-22T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  },
                  {
                    "Type": "PETICOES DIVERSAS",
                    "Author": "",
                    "CreationDate": "2020-10-15T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  },
                  {
                    "Type": "APRESENTACAO DE QUESITOS/INDICACAO DE ASSISTENTE TECNICO",
                    "Author": "",
                    "CreationDate": "2020-10-16T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  },
                  {
                    "Type": "APRESENTACAO DE PROPOSTA DE HONORARIO PERICIAIS",
                    "Author": "",
                    "CreationDate": "2021-01-11T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  },
                  {
                    "Type": "PETICOES DIVERSAS",
                    "Author": "",
                    "CreationDate": "2021-02-10T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  },
                  {
                    "Type": "PETICOES DIVERSAS",
                    "Author": "",
                    "CreationDate": "2021-02-16T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  }
                ],
                "Decisions": [
                  {
                    "DecisionContent": "JULGO PROCEDENTE O PEDIDO DA PRESENTE ACAO PROPOSTA POR RAFAEL CASTRO DE MATOS CONTRA NEXTEL TELECOMUNICACOES LTDA.",
                    "DecisionDate": "2021-06-28T00:00:00"
                  },
                  {
                    "DecisionContent": "JULGO PROCEDENTE O PEDIDO DA PRESENTE ACAO PROPOSTA POR RAFAEL CASTRO DE MATOS CONTRA NEXTEL TELECOMUNICACOES LTDA.",
                    "DecisionDate": "2021-06-25T00:00:00"
                  },
                  {
                    "DecisionContent": "JULGO PROCEDENTE O PEDIDO DA PRESENTE ACAO PROPOSTA POR RAFAEL CASTRO DE MATOS CONTRA NEXTEL TELECOMUNICACOES LTDA.",
                    "DecisionDate": "2021-06-24T00:00:00"
                  },
                  {
                    "DecisionContent": "DEFIRO A LIMINAR PARA DETERMINAR A EXCLUSAO DO NOME DO AUTOR DOS CADASTROS DE INADIMPLENTES QUANTO AO DEBITO OBJETO DA PRESENTE ACAO, POR MEIO DO SERASAJUD E, QUANTO A OUTROS EVENTUAIS CADASTROS, A PRESENTE SERVIRA COMO OFICIO A SER ENCAMINHADO DIRETAMENTE PELO REQUERENTE.",
                    "DecisionDate": "2020-02-11T00:00:00"
                  },
                  {
                    "DecisionContent": "DEFIRO A LIMINAR PARA DETERMINAR A EXCLUSAO DO NOME DO AUTOR DOS CADASTROS DE INADIMPLENTES QUANTO AO DEBITO OBJETO DA PRESENTE ACAO, POR MEIO DO SERASAJUD E, QUANTO A OUTROS EVENTUAIS CADASTROS, A PRESENTE SERVIRA COMO OFICIO A SER ENCAMINHADO DIRETAMENTE PELO REQUERENTE.",
                    "DecisionDate": "2020-02-11T00:00:00"
                  },
                  {
                    "DecisionContent": "DEFIRO A LIMINAR PARA DETERMINAR A EXCLUSAO DO NOME DO AUTOR DOS CADASTROS DE INADIMPLENTES QUANTO AO DEBITO OBJETO DA PRESENTE ACAO, POR MEIO DO SERASAJUD E, QUANTO A OUTROS EVENTUAIS CADASTROS, A PRESENTE SERVIRA COMO OFICIO A SER ENCAMINHADO DIRETAMENTE PELO REQUERENTE.",
                    "DecisionDate": "2020-02-10T00:00:00"
                  },
                  {
                    "DecisionContent": "DEFIRO A LIMINAR PARA DETERMINAR A EXCLUSAO DO NOME DO AUTOR DOS CADASTROS DE INADIMPLENTES QUANTO AO DEBITO OBJETO DA PRESENTE ACAO, POR MEIO DO SERASAJUD E, QUANTO A OUTROS EVENTUAIS CADASTROS, A PRESENTE SERVIRA COMO OFICIO A SER ENCAMINHADO DIRETAMENTE PELO REQUERENTE.",
                    "DecisionDate": "2020-02-10T00:00:00"
                  }
                ]
              },
              {
                "Number": "00009081920218260100",
                "Type": "CUMPRIMENTO DE SENTENCA",
                "MainSubject": "PRODUTO IMPROPRIO",
                "CourtName": "TJSP",
                "CourtLevel": "1",
                "CourtType": "CIVEL",
                "CourtDistrict": "SAO PAULO",
                "JudgingBody": "5 VARA CIVEL - FORO CENTRAL CIVEL",
                "State": "SP",
                "Status": "INDEFINIDO",
                "LawsuitHostService": "ESAJ",
                "InferredCNJSubjectName": "PRODUTO IMPRÓPRIO",
                "InferredCNJSubjectNumber": 11867,
                "InferredCNJProcedureTypeName": "CUMPRIMENTO DE SENTENÇA",
                "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
                "InferredBroadCNJSubjectNumber": 1156,
                "OtherSubjects": [
                  "PRODUTO IMPROPRIO"
                ],
                "NumberOfVolumes": 0,
                "NumberOfPages": 0,
                "Value": -1,
                "ResJudicataDate": "0001-01-01T00:00:00",
                "CloseDate": "0001-01-01T00:00:00",
                "RedistributionDate": "0001-01-01T00:00:00",
                "PublicationDate": "2021-02-23T00:00:00",
                "NoticeDate": "2021-01-11T00:00:00",
                "LastMovementDate": "2021-03-03T00:00:00",
                "CaptureDate": "2021-03-16T01:18:08",
                "LastUpdate": "2021-03-16T01:18:08",
                "NumberOfParties": 5,
                "NumberOfUpdates": 17,
                "LawSuitAge": 1143,
                "AverageNumberOfUpdatesPerMonth": 0,
                "ReasonForConcealedData": 0,
                "Parties": [
                  {
                    "Doc": "02349014118",
                    "IsPartyActive": true,
                    "Name": "RAFAEL CASTRO DE MATOS",
                    "Polarity": "ACTIVE",
                    "Type": "CLAIMANT",
                    "PartyDetails": {
                      "SpecificType": "EXEQTE"
                    },
                    "LastCaptureDate": "2021-03-16T01:18:08"
                  },
                  {
                    "Doc": "35068411817",
                    "IsPartyActive": true,
                    "Name": "RAFAEL HIDEO NAZIMA",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "295443",
                      "State": "SP",
                      "SpecificType": "ADVOGADO (EXEQTE)"
                    },
                    "LastCaptureDate": "2021-03-16T01:18:08"
                  },
                  {
                    "Doc": "12043596000196",
                    "IsPartyActive": true,
                    "Name": "AQUILON TELECOMUNICACOES LTDA",
                    "Polarity": "PASSIVE",
                    "Type": "CLAIMED",
                    "PartyDetails": {
                      "SpecificType": "EXECTDO"
                    },
                    "LastCaptureDate": "2021-03-16T01:18:08"
                  },
                  {
                    "Doc": "40247570915",
                    "IsPartyActive": true,
                    "Name": "GABRIEL ANTONIO HENKE NEIVA DE LIMA FILHO",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "420786",
                      "State": "SP",
                      "SpecificType": "ADVOGADO (EXECTDO)"
                    },
                    "LastCaptureDate": "2021-03-16T01:18:08"
                  },
                  {
                    "Doc": "04859002970",
                    "IsPartyActive": true,
                    "Name": "TIAGO GODOY ZANICOTTI",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "437516",
                      "State": "SP",
                      "SpecificType": "ADVOGADO (EXECTDO)"
                    },
                    "LastCaptureDate": "2021-03-16T01:18:08"
                  }
                ],
                "Updates": [
                  {
                    "Content": "CERTIDAO DE CARTORIO EXPEDIDA | CERTIDAO - GENERICA",
                    "PublishDate": "2021-03-03T00:00:00",
                    "CaptureDate": "2021-03-16T01:18:08"
                  },
                  {
                    "Content": "PEDIDO DE EXPEDICAO DE MANDADO DE LEVANTAMENTO JUNTADO | N PROTOCOLO: WJMJ.21.40300973-2 TIPO DA PETICAO: PEDIDO DE EXPEDICAO DE GUIA DE LEVANTAMENTO DATA: 02/03/2021 01:40",
                    "PublishDate": "2021-03-02T00:00:00",
                    "CaptureDate": "2021-03-16T01:18:08"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0032/2021 DATA DA DISPONIBILIZACAO: 23/02/2021 DATA DA PUBLICACAO: 24/02/2021 NUMERO DO DIARIO: 3223 PAGINA: 115-127",
                    "PublishDate": "2021-02-23T00:00:00",
                    "CaptureDate": "2021-03-16T01:18:08"
                  },
                  {
                    "Content": "PROCESSO 0000908-19.2021.8.26.0100 (PROCESSO PRINCIPAL 1068275-14.2019.8.26.0100) - CUMPRIMENTO DE SENTENCA - PRODUTO IMPROPRIO - RAFAEL CASTRO DE MATOS - AQUILON TELECOMUNICACOES LTDA. - MOTIVO DO ATO: PARTE PRECISA APRESENTAR INFORMACOES PARA LEVANTAR DINHEIRO. CONTEUDO DO ATO: INFORME A PARTE BENEFICIARIA OS DADOS PARA EXPEDICAO DO MANDADO DE LEVANTAMENTO ELETRONICO (MLE), MEDIANTE PREENCHIMENTO E APRESENTACAO NESTE PROCESSO ELETRONICO DO FORMULARIO DISPONIVEL NO SEGUINTE ENDERECO: HTTP://WWW.TJSP.JUS.BR/DOWNLOAD/FORMULARIOS/FORMULARIOMLE.DOCX FIM DO ATO. - ADV: RAFAEL HIDEO NAZIMA (OAB 295443/SP), TIAGO GODOY ZANICOTTI (OAB 437516/SP), GABRIEL ANTONIO HENKE NEIVA DE LIMA FILHO (OAB 420786/SP)",
                    "PublishDate": "2021-02-23T00:00:00",
                    "CaptureDate": "2021-03-16T01:18:08"
                  },
                  {
                    "Content": "REMETIDO AO DJE | RELACAO: 0032/2021 TEOR DO ATO: MOTIVO DO ATO: PARTE PRECISA APRESENTAR INFORMACOES PARA LEVANTAR DINHEIRO. CONTEUDO DO ATO: INFORME A PARTE BENEFICIARIA OS DADOS PARA EXPEDICAO DO MANDADO DE LEVANTAMENTO ELETRONICO (MLE), MEDIANTE PREENCHIMENTO E APRESENTACAO NESTE PROCESSO ELETRONICO DO FORMULARIO DISPONIVEL NO SEGUINTE ENDERECO: HTTP://WWW.TJSP.JUS.BR/DOWNLOAD/FORMULARIOS/FORMULARIOMLE.DOCX FIM DO ATO. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP), GABRIEL ANTONIO HENKE NEIVA DE LIMA FILHO (OAB 420786/SP), TIAGO GODOY ZANICOTTI (OAB 437516/SP)",
                    "PublishDate": "2021-02-22T00:00:00",
                    "CaptureDate": "2021-03-16T01:18:08"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0031/2021 DATA DA DISPONIBILIZACAO: 22/02/2021 DATA DA PUBLICACAO: 23/02/2021 NUMERO DO DIARIO: 3222 PAGINA: 54-65",
                    "PublishDate": "2021-02-22T00:00:00",
                    "CaptureDate": "2021-03-16T01:18:08"
                  },
                  {
                    "Content": "ATO ORDINATORIO - PUBLICAVEL | MOTIVO DO ATO: PARTE PRECISA APRESENTAR INFORMACOES PARA LEVANTAR DINHEIRO. CONTEUDO DO ATO: INFORME A PARTE BENEFICIARIA OS DADOS PARA EXPEDICAO DO MANDADO DE LEVANTAMENTO ELETRONICO (MLE), MEDIANTE PREENCHIMENTO E APRESENTACAO NESTE PROCESSO ELETRONICO DO FORMULARIO DISPONIVEL NO SEGUINTE ENDERECO: HTTP://WWW.TJSP.JUS.BR/DOWNLOAD/FORMULARIOS/FORMULARIOMLE.DOCX FIM DO ATO.",
                    "PublishDate": "2021-02-19T00:00:00",
                    "CaptureDate": "2021-03-16T01:18:08"
                  },
                  {
                    "Content": "REMETIDO AO DJE | RELACAO: 0031/2021 TEOR DO ATO: JULGO EXTINTA A EXECUCAO COM BASE NO ART.924, II, DO CODIGO DE PROCESSO CIVIL. EXPECA-SE GUIA DE LEVANTAMENTO EM FAVOR DA PARTE CREDORA. JUNTADA AOS AUTOS COMPROVACAO DO LEVANTAMENTO, ANOTE-SE A EXTINCAO E AO ARQUIVO. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP), GABRIEL ANTONIO HENKE NEIVA DE LIMA FILHO (OAB 420786/SP), TIAGO GODOY ZANICOTTI (OAB 437516/SP)",
                    "PublishDate": "2021-02-19T00:00:00",
                    "CaptureDate": "2021-03-16T01:18:08"
                  },
                  {
                    "Content": "CERTIDAO DE CARTORIO EXPEDIDA | CERTIDAO - CONFERENCIA - ADVOGADOS",
                    "PublishDate": "2021-02-17T00:00:00",
                    "CaptureDate": "2021-03-16T01:18:08"
                  },
                  {
                    "Content": "EXTINTA A EXECUCAO/CUMPRIMENTO DA SENTENCA PELA SATISFACAO DA OBRIGACAO | JULGO EXTINTA A EXECUCAO COM BASE NO ART.924, II, DO CODIGO DE PROCESSO CIVIL. EXPECA-SE GUIA DE LEVANTAMENTO EM FAVOR DA PARTE CREDORA. JUNTADA AOS AUTOS COMPROVACAO DO LEVANTAMENTO, ANOTE-SE A EXTINCAO E AO ARQUIVO.",
                    "PublishDate": "2021-02-17T00:00:00",
                    "CaptureDate": "2021-03-16T01:18:08"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO",
                    "PublishDate": "2021-02-16T00:00:00",
                    "CaptureDate": "2021-03-16T01:18:08"
                  },
                  {
                    "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.21.40181677-0 TIPO DA PETICAO: PETICAO INTERMEDIARIA DATA: 11/02/2021 14:59",
                    "PublishDate": "2021-02-11T00:00:00",
                    "CaptureDate": "2021-03-16T01:18:08"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0007/2021 DATA DA DISPONIBILIZACAO: 22/01/2021 DATA DA PUBLICACAO: 26/01/2021 NUMERO DO DIARIO: 3202 PAGINA: 133-149",
                    "PublishDate": "2021-01-22T00:00:00",
                    "CaptureDate": "2021-03-16T01:18:08"
                  },
                  {
                    "Content": "REMETIDO AO DJE | RELACAO: 0007/2021 TEOR DO ATO: FICA CADA PARTE DEVEDORA INTIMADA, NA PESSOA DO ADVOGADO VIA DJSP, A PAGAR O VALOR INDICADO PELA PARTE CREDORA, DEVIDAMENTE ATUALIZADO, EM QUINZE DIAS. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP), GABRIEL ANTONIO HENKE NEIVA DE LIMA FILHO (OAB 420786/SP), TIAGO GODOY ZANICOTTI (OAB 437516/SP)",
                    "PublishDate": "2021-01-21T00:00:00",
                    "CaptureDate": "2021-03-16T01:18:08"
                  },
                  {
                    "Content": "DECISAO | FICA CADA PARTE DEVEDORA INTIMADA, NA PESSOA DO ADVOGADO VIA DJSP, A PAGAR O VALOR INDICADO PELA PARTE CREDORA, DEVIDAMENTE ATUALIZADO, EM QUINZE DIAS.",
                    "PublishDate": "2021-01-13T00:00:00",
                    "CaptureDate": "2021-03-16T01:18:08"
                  },
                  {
                    "Content": "CONCLUSOS PARA DESPACHO",
                    "PublishDate": "2021-01-12T00:00:00",
                    "CaptureDate": "2021-03-16T01:18:08"
                  },
                  {
                    "Content": "INICIO DA EXECUCAO JUNTADO | PROCESSO PRINCIPAL: 1068275-14.2019.8.26.0100",
                    "PublishDate": "2021-01-12T00:00:00",
                    "CaptureDate": "2021-03-16T01:18:08"
                  }
                ],
                "Petitions": [
                  {
                    "Type": "PETICAO INTERMEDIARIA",
                    "Author": "",
                    "CreationDate": "2021-02-11T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  },
                  {
                    "Type": "PEDIDO DE EXPEDICAO DE GUIA DE LEVANTAMENTO",
                    "Author": "",
                    "CreationDate": "2021-03-02T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  }
                ],
                "Decisions": [
                  {
                    "DecisionContent": "JULGO EXTINTA A EXECUCAO COM BASE NO ART.924, II, DO CODIGO DE PROCESSO CIVIL.",
                    "DecisionDate": "2021-02-19T00:00:00"
                  },
                  {
                    "DecisionContent": "JULGO EXTINTA A EXECUCAO COM BASE NO ART.924, II, DO CODIGO DE PROCESSO CIVIL.",
                    "DecisionDate": "2021-02-17T00:00:00"
                  }
                ]
              },
              {
                "Number": "07038856120238070015",
                "Type": "RETIFICACAO OU SUPRIMENTO OU RESTAURACAO DE REGISTRO CIVIL",
                "MainSubject": "REGISTROS PUBLICOS (7724) - REGISTRO CIVIL DAS PESSOAS NATURAIS (7725) - RETIFICACAO DE NOME (7735",
                "CourtName": "TJDF",
                "CourtLevel": "1",
                "CourtType": "CIVEL",
                "CourtDistrict": "BRASILIA",
                "JudgingBody": "VARA DE REGISTROS PUBLICOS DO DF",
                "State": "DF",
                "Status": "ARQUIVADO",
                "LawsuitHostService": "PJE",
                "InferredCNJSubjectName": "RETIFICAÇÃO DE NOME",
                "InferredCNJSubjectNumber": 7735,
                "InferredCNJProcedureTypeName": "RETIFICAÇÃO OU SUPRIMENTO OU RESTAURAÇÃO DE REGISTRO CIVIL",
                "InferredBroadCNJSubjectName": "REGISTROS PÚBLICOS",
                "InferredBroadCNJSubjectNumber": 7724,
                "OtherSubjects": [
                  "REGISTROS PUBLICOS (7724) - REGISTRO CIVIL DAS PESSOAS NATURAIS (7725) - RETIFICACAO DE NOME (7735"
                ],
                "NumberOfVolumes": 0,
                "NumberOfPages": 0,
                "Value": -1,
                "ResJudicataDate": "2023-08-21T00:00:00",
                "CloseDate": "2023-11-13T00:00:00",
                "RedistributionDate": "0001-01-01T00:00:00",
                "PublicationDate": "2023-07-04T00:00:00",
                "NoticeDate": "2023-02-23T00:00:00",
                "LastMovementDate": "2023-11-13T00:00:00",
                "CaptureDate": "2023-12-16T16:34:40",
                "LastUpdate": "2023-12-16T16:34:40",
                "NumberOfParties": 6,
                "NumberOfUpdates": 98,
                "LawSuitAge": 263,
                "AverageNumberOfUpdatesPerMonth": 7,
                "ReasonForConcealedData": 0,
                "Parties": [
                  {
                    "Doc": "02349014118",
                    "IsPartyActive": true,
                    "Name": "RAFAEL CASTRO DE MATOS",
                    "Polarity": "ACTIVE",
                    "Type": "CLAIMANT",
                    "PartyDetails": {
                      "SpecificType": "REQUERENTE"
                    },
                    "LastCaptureDate": "2023-12-16T16:34:40"
                  },
                  {
                    "Doc": "00038684195",
                    "IsPartyActive": true,
                    "Name": "GUILHERME SILVEIRA COELHO",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "33133-A",
                      "State": "DF",
                      "SpecificType": "ADVOGADO (REQUERENTE)"
                    },
                    "LastCaptureDate": "2023-12-16T16:34:40"
                  },
                  {
                    "Doc": "05607994112",
                    "IsPartyActive": true,
                    "Name": "ROBSON LAPOENTE NOVAES JUNIOR",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "67399",
                      "State": "DF",
                      "SpecificType": "ADVOGADO (REQUERENTE)"
                    },
                    "LastCaptureDate": "2023-12-16T16:34:40"
                  },
                  {
                    "Doc": "03058770111",
                    "IsPartyActive": true,
                    "Name": "MATEUS ROCHA TOMAZ",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "0050213A",
                      "State": "DF",
                      "SpecificType": "ADVOGADO (REQUERENTE)"
                    },
                    "LastCaptureDate": "2023-12-16T16:34:40"
                  },
                  {
                    "Doc": "52872157115",
                    "IsPartyActive": true,
                    "Name": "ANDRE LUIZ SOUZA DA SILVEIRA",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "16379-A",
                      "State": "DF",
                      "SpecificType": "ADVOGADO (REQUERENTE)"
                    },
                    "LastCaptureDate": "2023-12-16T16:34:40"
                  },
                  {
                    "Doc": "26989715000293",
                    "IsPartyActive": true,
                    "Name": "MINISTERIO PUBLICO DO DISTRITO FEDERAL E DOS TERRITORIOS",
                    "Polarity": "NEUTRAL",
                    "Type": "OTHER",
                    "PartyDetails": {
                      "SpecificType": "FISCAL DA LEI"
                    },
                    "LastCaptureDate": "2023-12-16T16:34:40"
                  }
                ],
                "Updates": [
                  {
                    "Content": "ARQUIVADO DEFINITIVAMENTE",
                    "PublishDate": "2023-11-13T00:00:00",
                    "CaptureDate": "2023-12-16T16:34:40"
                  },
                  {
                    "Content": "PODER JUDICIARIO DA UNIAO TRIBUNAL DE JUSTICA DO DISTRITO FEDERAL E DOS TERRITORIOS VARA DE REGISTROS PUBLICOS DO DF. NUMERO DO PROCESSO: 0703885-61.2023.8.07.0015 CLASSE: RETIFICACAO OU SUPRIMENTO OU RESTAURACAO DE REGISTRO CIVIL (1682) POLO ATIVO: REQUERENTE: RAFAEL CASTRO DE MATOS POLO PASSIVO: CERTIDAO CERTIFICO QUE TODAS AS PENDENCIAS PROCESSUAIS FORAM SANADAS E QUE NAO HA NENHUM OBICE AO ARQUIVAMENTO DEFINITIVO DOS AUTOS, TORNANDO-OS APTOS AO TRATAMENTO ARQUIVISTICO, QUE CULMINARA EM SUA DESTINACAO FINAL, SEJA ELIMINACAO OU GUARDA PERMANENTE, EM CONFORMIDADE COM A TABELA DE TEMPORALIDADE ADOTADA POR ESTE TRIBUNAL. * VALIDACOES MANUAIS - NAO HA RECOMENDACAO DE SELO HISTORICO (FUNDAMENTADO PELO MAGISTRADO). - ESSE PROCESSO NAO ORIGINOU PRECEDENTE DE SUMULAS DO TJDFT, RECURSOS REPETITIVOS, REPERCUSSAO GERAL, IRDR OU IAC (PROCESSO PARADIGMA). - NAO HA PENDENCIAS DE PAGAMENTOS DE VERBAS DE SUCUMBENCIA. - NAO HA PENDENCIAS DE PAGAMENTOS DE CUSTAS E DESPESAS PROCESSUAIS. - NAO EXISTEM PENDENCIAS EM SISTEMAS EXTERNOS BACENJUD, CADASTRO DE IMPROBIDADE-CNJ, ERIDF, INFOJUD, RENAJUD, SERASAJUD, DENTRE OUTROS. - NAO HA PRECATORIO OU RPV PENDENTE DE SENTENCA EXTINTIVA OU NAO SE APLICA A ESTE PROCESSO. - NAO HA PENDENCIA DE ENVIO DE OFICIO AO TRE E A CAPITANIA DOS PORTOS OU NAO SE APLICA A ESTE PROCESSO. - NAO HA TRASLADO DE RECURSOS DE PROCESSOS DIGITALIZADOS A SEREM EFETUADOS, NO CASO DE RECURSO/AGRAVO/INCIDENTES PROCESSUAIS AUTUADOS EM APARTADO OU NAO SE APLICA A ESTE PROCESSO. VALIDACOES AUTOMATICAS - O PROCESSO POSSUI MOVIMENTO DE JULGAMENTO OU DECISAO. - NAO EXISTEM EXPEDIENTES COM PRAZO EM ABERTO. - O PROCESSO NAO POSSUI PARTES ATIVAS NO POLO PASSIVO. - NAO EXISTEM DOCUMENTOS NAO LIDOS PARA O PROCESSO. - O PROCESSO NAO POSSUI TAREFAS PENDENTES. - O PROCESSO NAO POSSUI PENDENCIAS DE MATERIAIS SOB GUARDA. - JA EXISTE TRANSITO EM JULGADO PARA O PROCESSO. PROCESSO SEM ALERTAS. BRASILIA, 13 DE NOVEMBRO DE 2023. HEVILA MACIEL MENDES VIEIRA ASSINADO ELETRONICAMENTE POR: HEVILA MACIEL MENDES VIEIRA 13/11/2023 13:42:41 HTTPS://PJE.TJDFT.JUS.BR/CONSULTAPUBLICA/PROCESSO/CONSULTADOCUMENTO/LISTVIEW.SEAM ID DO DOCUMENTO: 178011725 23111313424165200000163137787",
                    "PublishDate": "2023-11-13T00:00:00",
                    "CaptureDate": "2023-12-16T16:34:40"
                  },
                  {
                    "Content": "JUNTADA DE CERTIDAO PODER JUDICIARIO DA UNIAO TRIBUNAL DE JUSTICA DO DISTRITO FEDERAL E DOS TERRITORIOS VREGPUBDF VARA DE REGISTROS PUBLICOS DO DF NUMERO DO PROCESSO: 0703885-61.2023.8.07.0015 CLASSE JUDICIAL: RETIFICACAO OU SUPRIMENTO OU RESTAURACAO DE REGISTRO CIVIL (1682) REQUERENTE: RAFAEL CASTRO DE MATOS CERTIDAO CERTIFICO E DOU FE QUE, NESTA DATA, JUNTEI OFICIO ENVIADO PELA RECEITA FEDERAL, VIA EMAIL INSTITUCIONAL. DOCUMENTO ASSINADO E DATADO DIGITALMENTE CONFORME ASSINATURA DIGITAL ASSINADO ELETRONICAMENTE POR: HEVILA MACIEL MENDES VIEIRA 26/10/2023 17:41:52 HTTPS://PJE.TJDFT.JUS.BR/CONSULTAPUBLICA/PROCESSO/CONSULTADOCUMENTO/LISTVIEW.SEAM ID DO DOCUMENTO: 23102617415238100000161770755",
                    "PublishDate": "2023-10-26T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "EXPEDICAO DE CERTIDAO. PODER JUDICIARIO DA UNIAO TRIBUNAL DE JUSTICA DO DISTRITO FEDERAL E DOS TERRITORIOS VREGPUBDF VARA DE REGISTROS P?BLICOS DO DF NUMERO DO PROCESSO: 0703885-61.2023.8.07.0015 CLASSE JUDICIAL: RETIFICA??O OU SUPRIMENTO OU RESTAURA??O DE REGISTRO CIVIL (1682) REQUERENTE: RAFAEL CASTRO DE MATOS CERTIDAO DE ENCERRAMENTO DE EXPEDIENTE ESTA SECRETARIA ENCERROU MANUALMENTE O(S) EXPEDIENTE(S) ABERTO(S) (ID(S) 31533955) PARA FINS DE CONTINUIDADE DO TRAMITE PROCESSUAL. 18 DE OUTUBRO DE 2023. HEVILA MACIEL MENDES VIEIRA DIRETOR DE SECRETARIA ASSINADO ELETRONICAMENTE POR: USUARIO DO SISTEMA 18/10/2023 17:32:19 USUARIO DO SISTEMA 18/10/2023 17:32:20 HTTPS://PJE.TJDFT.JUS.BR/CONSULTAPUBLICA/PROCESSO/CONSULTADOCUMENTO/LISTVIEW.SEAM ID DO DOCUMENTO: 23101817321968200000160977340",
                    "PublishDate": "2023-10-18T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "JUNTADA DE CERTIDAO PODER JUDICIARIO DA UNIAO TRIBUNAL DE JUSTICA DO DISTRITO FEDERAL E DOS TERRITORIOS VREGPUBDF VARA DE REGISTROS PUBLICOS DO DF NUMERO DO PROCESSO: 0703885-61.2023.8.07.0015 CLASSE JUDICIAL: RETIFICACAO OU SUPRIMENTO OU RESTAURACAO DE REGISTRO CIVIL (1682) REQUERENTE: RAFAEL CASTRO DE MATOS CERTIDAO CERTIFICO QUE ANEXEI MALOTE RECEBIDO REFERENTE AO OFICIO N  1371 / 2023 / VRP ID170704762. BRASILIA, 18 DE OUTUBRO DE 2023. KAYLANE ALVES BONFIM ESTAGIARIO CARTORIO ASSINADO ELETRONICAMENTE POR: HEVILA MACIEL MENDES VIEIRA 18/10/2023 17:29:35 HTTPS://PJE.TJDFT.JUS.BR/CONSULTAPUBLICA/PROCESSO/CONSULTADOCUMENTO/LISTVIEW.SEAM ID DO DOCUMENTO: 23101817293526100000160922332",
                    "PublishDate": "2023-10-18T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "JUNTADA DE CERTIDAO PODER JUDICIARIO DA UNIAO TRIBUNAL DE JUSTICA DO DISTRITO FEDERAL E DOS TERRITORIOS VREGPUBDF VARA DE REGISTROS PUBLICOS DO DF NUMERO DO PROCESSO: 0703885-61.2023.8.07.0015 CLASSE JUDICIAL: RETIFICACAO OU SUPRIMENTO OU RESTAURACAO DE REGISTRO CIVIL (1682) REQUERENTE: RAFAEL CASTRO DE MATOS CERTIDAO CERTIFICO E DOU FE QUE, NESTA DATA, JUNTEI OFICIO ENVIADO PELO CARTORIO DA COMARCA DE GOIANIA-GO, VIA EMAIL INSTITUCIONAL. DOCUMENTO ASSINADO E DATADO DIGITALMENTE CONFORME ASSINATURA DIGITAL ASSINADO ELETRONICAMENTE POR: HEVILA MACIEL MENDES VIEIRA 17/10/2023 16:07:49 HTTPS://PJE.TJDFT.JUS.BR/CONSULTAPUBLICA/PROCESSO/CONSULTADOCUMENTO/LISTVIEW.SEAM ID DO DOCUMENTO: 23101716074937600000160822837",
                    "PublishDate": "2023-10-17T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "PUBLICADO PORTARIA EM 17/10/2023.",
                    "PublishDate": "2023-10-17T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "DISPONIBILIZADO NO DJ ELETRONICO EM 16/10/2023",
                    "PublishDate": "2023-10-17T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "JUNTADA DE PETICAO DE PETICAO",
                    "PublishDate": "2023-10-11T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "EXPEDICAO DE PORTARIA.",
                    "PublishDate": "2023-10-11T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "JUNTADA DE CERTIDAO PODER JUDICIARIO DA UNIAO TRIBUNAL DE JUSTICA DO DISTRITO FEDERAL E DOS TERRITORIOS VREGPUBDF VARA DE REGISTROS PUBLICOS DO DF NUMERO DO PROCESSO: 0703885-61.2023.8.07.0015 CLASSE JUDICIAL: RETIFICACAO OU SUPRIMENTO OU RESTAURACAO DE REGISTRO CIVIL (1682) REQUERENTE: RAFAEL CASTRO DE MATOS CERTIDAO CERTIFICO QUE: O AR REFERENTE AO OFICIO N  1373 / 2023 / VRP ID170716617 RETORNOU COMO RECEBIDO, CONFORME O ANEXO; O AR REFERENTE AO OFICIO N  1375 / 2023 / VRP ID170721032 RETORNOU COMO RECEBIDO, CONFORME O ANEXO. BRASILIA, 11 DE OUTUBRO DE 2023. KEYLA DIAS DE OLIVEIRA ESTAGIARIO CARTORIO ASSINADO ELETRONICAMENTE POR: VANESSA DE MIRANDA ALVES SOARES 11/10/2023 15:59:18 HTTPS://PJE.TJDFT.JUS.BR/CONSULTAPUBLICA/PROCESSO/CONSULTADOCUMENTO/LISTVIEW.SEAM ID DO DOCUMENTO: 23101115591834200000160453305",
                    "PublishDate": "2023-10-11T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "JUNTADA DE CERTIDAO PODER JUDICIARIO DA UNIAO TRIBUNAL DE JUSTICA DO DISTRITO FEDERAL E DOS TERRITORIOS VREGPUBDF VARA DE REGISTROS PUBLICOS DO DF NUMERO DO PROCESSO: 0703885-61.2023.8.07.0015 CLASSE JUDICIAL: RETIFICACAO OU SUPRIMENTO OU RESTAURACAO DE REGISTRO CIVIL (1682) REQUERENTE: RAFAEL CASTRO DE MATOS CERTIDAO CERTIFICO QUE O AR REFERENTE AO OFICIO N  1374 / 2023 / VRP ID170718743 RETORNOU COMO RECEBIDO, CONFORME O ANEXO. BRASILIA, 9 DE OUTUBRO DE 2023. KEYLA DIAS DE OLIVEIRA ESTAGIARIO CARTORIO ASSINADO ELETRONICAMENTE POR: VANESSA DE MIRANDA ALVES SOARES 09/10/2023 19:00:07 HTTPS://PJE.TJDFT.JUS.BR/CONSULTAPUBLICA/PROCESSO/CONSULTADOCUMENTO/LISTVIEW.SEAM ID DO DOCUMENTO: 23100919000659100000160178586",
                    "PublishDate": "2023-10-09T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "JUNTADA DE CERTIDAO PODER JUDICIARIO DA UNIAO TRIBUNAL DE JUSTICA DO DISTRITO FEDERAL E DOS TERRITORIOS VREGPUBDF VARA DE REGISTROS PUBLICOS DO DF NUMERO DO PROCESSO: 0703885-61.2023.8.07.0015 CLASSE JUDICIAL: RETIFICACAO OU SUPRIMENTO OU RESTAURACAO DE REGISTRO CIVIL (1682) REQUERENTE: RAFAEL CASTRO DE MATOS CERTIDAO CERTIFICO QUE: O AR REFERENTE AO OFICIO N  1374 / 2023 / VRP ID170718743 RETORNOU COMO RECEBIDO, CONFORME O ANEXO; O AR REFERENTE AO OFICIO N  1373 / 2023 / VRP ID170716617 RETORNOU COMO RECEBIDO, CONFORME O ANEXO. BRASILIA, 3 DE OUTUBRO DE 2023. KEYLA DIAS DE OLIVEIRA ESTAGIARIO CARTORIO ASSINADO ELETRONICAMENTE POR: VANESSA DE MIRANDA ALVES SOARES 03/10/2023 17:34:12 HTTPS://PJE.TJDFT.JUS.BR/CONSULTAPUBLICA/PROCESSO/CONSULTADOCUMENTO/LISTVIEW.SEAM ID DO DOCUMENTO: 23100317341187700000159623810",
                    "PublishDate": "2023-10-03T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "PUBLICADO PORTARIA EM 03/10/2023.",
                    "PublishDate": "2023-10-03T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "DISPONIBILIZADO NO DJ ELETRONICO EM 02/10/2023",
                    "PublishDate": "2023-10-03T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "JUNTADA DE PORTARIA",
                    "PublishDate": "2023-09-28T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "DECORRIDO PRAZO DE POLICIA CIVIL DO ESTADO DE GOIAS EM 19/09/2023 23:59.",
                    "PublishDate": "2023-09-20T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "PUBLICADO PORTARIA EM 20/09/2023.",
                    "PublishDate": "2023-09-20T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "DISPONIBILIZADO NO DJ ELETRONICO EM 19/09/2023",
                    "PublishDate": "2023-09-19T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "PODER JUDICIARIO DA UNIAO TRIBUNAL DE JUSTICA DO DISTRITO FEDERAL E DOS TERRITORIOS VARA DE REGISTROS P?BLICOS DO DF NUMERO DO PROCESSO: 0703885-61.2023.8.07.0015 CERTIDAO DE DISPONIBILIZACAO DJE O A TO JUDICIAL PORTARIA ID 172130031 FOI DISPONIBILIZADO NO DIARIO DA JUSTICA ELETRONICO (DJE) EM 19/09/2023, E SERA PUBLICADO NO PRIMEIRO DIA UTIL SUBSEQUENTE . 19 DE SETEMBRO DE 2023 ASSINADO ELETRONICAMENTE POR: USUARIO DO SISTEMA 19/09/2023 03:01:00 USUARIO DO SISTEMA 19/09/2023 03:01:00 HTTPS://PJE.TJDFT.JUS.BR/CONSULTAPUBLICA/PROCESSO/CONSULTADOCUMENTO/LISTVIEW.SEAM ID DO DOCUMENTO: 172364383 23091903010074300000158137024",
                    "PublishDate": "2023-09-19T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "EXPEDICAO DE PORTARIA.",
                    "PublishDate": "2023-09-15T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "DECORRIDO PRAZO DE RAFAEL CASTRO DE MATOS EM 14/09/2023 23:59.",
                    "PublishDate": "2023-09-15T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "JUNTADA DE CERTIDAO PODER JUDICIARIO DA UNIAO TRIBUNAL DE JUSTICA DO DISTRITO FEDERAL E DOS TERRITORIOS VREGPUBDF VARA DE REGISTROS PUBLICOS DO DF NUMERO DO PROCESSO: 0703885-61.2023.8.07.0015 CLASSE JUDICIAL: RETIFICACAO OU SUPRIMENTO OU RESTAURACAO DE REGISTRO CIVIL (1682) REQUERENTE: RAFAEL CASTRO DE MATOS CERTIDAO CERTIFICO QUE ENCAMINHEI VIA CORREIOS: OFICIO 1371 / 2023 / VRP ID170704762, COM O CODIGO DE POSTAGEM BR458721387BR; OFICIO 1373 / 2023 / VRP ID170716617, COM O CODIGO DE POSTAGEM BR458721342BR; OFICIO 1374 / 2023 / VRP ID170718743, COM O CODIGO DE POSTAGEM BR458721308BR; OFICIO 1375 / 2023 / VRP ID170721032, COM O CODIGO DE POSTAGEM BR458721254BR; BRASILIA, 8 DE SETEMBRO DE 2023. KEYLA DIAS DE OLIVEIRA ESTAGIARIO CARTORIO ASSINADO ELETRONICAMENTE POR: HEVILA MACIEL MENDES VIEIRA 14/09/2023 18:30:57 HTTPS://PJE.TJDFT.JUS.BR/CONSULTAPUBLICA/PROCESSO/CONSULTADOCUMENTO/LISTVIEW.SEAM ID DO DOCUMENTO: 23091418305702400000157238402",
                    "PublishDate": "2023-09-14T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "JUNTADA DE CERTIDAO PODER JUDICIARIO DA UNIAO TRIBUNAL DE JUSTICA DO DISTRITO FEDERAL E DOS TERRITORIOS VREGPUBDF VARA DE REGISTROS PUBLICOS DO DF NUMERO DO PROCESSO: 0703885-61.2023.8.07.0015 CLASSE JUDICIAL: RETIFICACAO OU SUPRIMENTO OU RESTAURACAO DE REGISTRO CIVIL (1682) REQUERENTE: RAFAEL CASTRO DE MATOS CERTIDAO CERTIFICO QUE ENCAMINHEI, VIA E-MAIL(",
                    "PublishDate": "2023-09-06T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "DECORRIDO PRAZO DE RAFAEL CASTRO DE MATOS EM 04/09/2023 23:59.",
                    "PublishDate": "2023-09-05T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "EXPEDICAO DE OFICIO.",
                    "PublishDate": "2023-09-04T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "EXPEDICAO DE OFICIO.",
                    "PublishDate": "2023-09-04T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "EXPEDICAO DE OFICIO.",
                    "PublishDate": "2023-09-04T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "EXPEDICAO DE OFICIO.",
                    "PublishDate": "2023-09-04T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "EXPEDICAO DE OFICIO.",
                    "PublishDate": "2023-09-04T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "DECORRIDO PRAZO DE RAFAEL CASTRO DE MATOS EM 31/08/2023 23:59.",
                    "PublishDate": "2023-09-01T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "PUBLICADO INTIMACAO EM 28/08/2023.",
                    "PublishDate": "2023-08-28T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "EXPEDICAO DE PORTARIA.",
                    "PublishDate": "2023-08-25T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "DISPONIBILIZADO NO DJ ELETRONICO EM 25/08/2023",
                    "PublishDate": "2023-08-25T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "PODER JUDICIARIO DA UNIAO TRIBUNAL DE JUSTICA DO DISTRITO FEDERAL E DOS TERRITORIOS VARA DE REGISTROS P?BLICOS DO DF NUMERO DO PROCESSO: 0703885-61.2023.8.07.0015 CERTIDAO DE DISPONIBILIZACAO DJE O A TO JUDICIAL PORTARIA ID 169609916 FOI DISPONIBILIZADO NO DIARIO DA JUSTICA ELETRONICO (DJE) EM 25/08/2023, E SERA PUBLICADO NO PRIMEIRO DIA UTIL SUBSEQUENTE . 25 DE AGOSTO DE 2023 ASSINADO ELETRONICAMENTE POR: USUARIO DO SISTEMA 25/08/2023 02:54:44 USUARIO DO SISTEMA 25/08/2023 02:54:44 HTTPS://PJE.TJDFT.JUS.BR/CONSULTAPUBLICA/PROCESSO/CONSULTADOCUMENTO/LISTVIEW.SEAM ID DO DOCUMENTO: 169818327 23082502544474100000155876618",
                    "PublishDate": "2023-08-25T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "PUBLICADO PORTARIA EM 24/08/2023.",
                    "PublishDate": "2023-08-24T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "DISPONIBILIZADO NO DJ ELETRONICO EM 23/08/2023",
                    "PublishDate": "2023-08-24T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "PODER JUDICIARIO DA UNIAO TRIBUNAL DE JUSTICA DO DISTRITO FEDERAL E DOS TERRITORIOS VARA DE REGISTROS P?BLICOS DO DF NUMERO DO PROCESSO: 0703885-61.2023.8.07.0015 CERTIDAO DE DISPONIBILIZACAO DJE O A TO JUDICIAL PORTARIA ID 169423513 FOI DISPONIBILIZADO NO DIARIO DA JUSTICA ELETRONICO (DJE) EM 23/08/2023, E SERA PUBLICADO NO PRIMEIRO DIA UTIL SUBSEQUENTE . 24 DE AGOSTO DE 2023 ASSINADO ELETRONICAMENTE POR: USUARIO DO SISTEMA 24/08/2023 09:09:48 USUARIO DO SISTEMA 24/08/2023 09:09:49 HTTPS://PJE.TJDFT.JUS.BR/CONSULTAPUBLICA/PROCESSO/CONSULTADOCUMENTO/LISTVIEW.SEAM ID DO DOCUMENTO: 169667392 23082409094899900000155743950",
                    "PublishDate": "2023-08-24T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "JUNTADA DE PETICAO DE PETICAO",
                    "PublishDate": "2023-08-23T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "EXPEDICAO DE PORTARIA.",
                    "PublishDate": "2023-08-23T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "EXPEDICAO DE CERTIDAO. PODER JUDICIARIO DA UNIAO TRIBUNAL DE JUSTICA DO DISTRITO FEDERAL E DOS TERRITORIOS VARA DE REGISTROS PUBLICOS DO DF SRTVS BLOCO N LOTE 8, SALA 4.20, 4 ANDAR, ASA SUL, BRASILIA - DF - CEP: 70340-903 TELEFONE: (61) 3103-1838 / 3103-1842; FAX: (61) 3103-0314; EMAIL: 02VFAMILIA.BSB@TJDFT.JUS.BR HORARIO DE ATENDIMENTO: SEGUNDA-FEIRA A SEXTA-FEIRA, DAS 12:00 AS 19:00 CERTIDAO DE OBJETO E PE PROCESSO N 0703885-61.2023.8.07.0015 ACAO DE RETIFICACAO OU SUPRIMENTO OU RESTAURACAO DE REGISTRO CIVIL (1682) REQUERENTE: RAFAEL CASTRO DE MATOS VANESSA DE MIRANDA ALVES SOARES, DIRETORA DE SECRETARIA DA VARA DE REGISTROS PUBLICOS DO DF , EM PLENO EXERCICIO DE SEU CARGO E NA FORMA DA LEI, ETC. CERTIFICA , A REQUERIMENTO DA PARTE INTERESSADA, QUE, REVENDO OS REGISTROS DESTA SECRETARIA, NELES VERIFICOU CONSTAR O PROCESSO ELETRONICO N. 0703885-61.2023.8.07.0015 , ACAO DE RETIFICACAO OU SUPRIMENTO OU RESTAURACAO DE REGISTRO CIVIL (1682), TENDO COMO ASSUNTO PRINCIPAL RETIFICACAO DE NOME (7735), DISTRIBUIDO EM 23/02/2023 19:21:18, PROPOSTO POR RAFAEL CASTRO DE MATOS, CPF 023.490.141-18, TENDO COMO OBJETO ALTERACAO DO NOME DELE. CERTIFICA, AINDA, QUE EM 17/8/2023 FOI PROFERIDA A SENTENCA DE ID 168642862 DEFERINDO O PEDIDO PARA ALTERAR O REGISTRO DE NASCIMENTO DE RAFAEL CASTRO DE MATOS, ID152919968, PAGINA 2, E NELE FAZER CONSTAR QUE O REGISTRADO SE CHAMA RAFAEL STARK, INALTERADOS OS DEMAIS DADOS, DEVIDAMENTE TRANSITADA EM JULGADO EM 21/8/2023. CERTIFICO, POR FIM, QUE O PROCESSO AGUARDA PAGAMENTO DAS CUSTAS FINAIS PARA EXPEDICAO DOS DOCUMENTOS DECORRENTES DA SENTENCA. DADA E PASSADA NESTA CIDADE DE BRASILIA, DF, 23 DE AGOSTO DE 2023 16:53:25. EU, VANESSA DE MIRANDA ALVES SOARES, DIRETORA DE SECRETARIA, A CONFERI E ASSINO DIGITALMENTE. DOCUMENTO ASSINADO E DATADO DIGITALMENTE CONFORME ASSINATURA DIGITAL ASSINADO ELETRONICAMENTE POR: VANESSA DE MIRANDA ALVES SOARES 23/08/2023 17:07:09 HTTPS://PJE.TJDFT.JUS.BR/CONSULTAPUBLICA/PROCESSO/CONSULTADOCUMENTO/LISTVIEW.SEAM ID DO DOCUMENTO: 23082317070896900000155683030",
                    "PublishDate": "2023-08-23T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "EXPEDICAO DE PORTARIA.",
                    "PublishDate": "2023-08-22T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "RECEBIDOS OS AUTOS",
                    "PublishDate": "2023-08-22T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "REMETIDOS OS AUTOS DA CONTADORIA AO VARA DE REGISTROS PUBLICOS DO DF.",
                    "PublishDate": "2023-08-22T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "PUBLICADO SENTENCA EM 22/08/2023. PODER JUDICIARIO DA UNIAO TRIBUNAL DE JUSTICA DO DISTRITO FEDERAL E DOS TERRITORIOS VREGPUBDF VARA DE REGISTROS PUBLICOS DO DF NUMERO DO PROCESSO: 0703885-61.2023.8.07.0015 CLASSE JUDICIAL: RETIFICACAO OU SUPRIMENTO OU RESTAURACAO DE REGISTRO CIVIL (1682) REQUERENTE: RAFAEL CASTRO DE MATOS SENTENCA CUIDA-SE DE PEDIDO FORMULADO POR RAFAEL CASTRO DE MATOS PARA ALTERAR O NOME PARA RAFAEL STARK. INFORMA O REQUERENTE, PARA TANTO, QUE NAO SE IDENTIFICA COM OS SOBRENOMES ORIUNDOS DOS GENITORES, JOAQUIM DE MATOS FILHO E ROSANE DE FATIMA LEITE CASTRO, EM RAZAO DO ABANDONO AFETIVO E MATERIAL DO QUAL FOI VITIMA. POR TAL RAZAO, PEDE A EXCLUSAO DOS SOBRENOMES FAMILIARES E A INCLUSAO DO NOME STARK, PROVENIENTE DE SUA EMPRESA (STARK BANK), HAJA VISTA JA SER RECONHECIDO MUNDIALMENTE DESSA FORMA. O MINISTERIO PUBLICO OFICIOU PELA PROCEDENCIA DO PEDIDO, ID 163297949. E O RELATORIO. DECIDO. AS DISPOSICOES PREVISTAS NO ARTIGO 57 DA LEI DE REGISTROS PUBLICOS ACERCA DO NOME FORAM ALTERADAS PELA LEI 14.382/2022. TODAVIA, O PRESENTE CASO NAO SE ENQUADRA NAS HIPOTESES DE PROCESSAMENTO PELA VIA EXTRAJUDICIAL, UMA VEZ QUE A PRETENSAO E DE EXCLUSAO DE SOBRENOME FAMILIAR. POSTO ISSO, A CONTRARIO SENSU, AS HIPOTESES NAO CONTEMPLADAS NO ROL DO ARTIGO 57, COMO O PRESENTE CASO, DEVERAO SER, NECESSARIAMENTE, PROCESSADAS PELA VIA JUDICIAL. NO QUE TANGE A SUPRESSAO DOS SOBRENOMES FAMILIARES, EM QUE PESE A LEI 6.015/1973 NAO ELENCAR TAL POSSIBILIDADE, A JURISPRUDENCIA, DE MODO EXCEPCIONAL, ADMITE-A SOB O SEGUINTE FUNDAMENTO: APELACAO CIVEL. DIREITO CIVIL. DIREITO DE FAMILIA. DIREITO PROCESSUAL CIVIL. ACAO DE ALTERACAO DE REGISTRO CIVIL. PRELIMINAR. ILEGITIMIDADE ATIVA. AFASTADA. MENOR. REPRESENTACAO. GENITOR. CITACAO. GENITORA DA AUTORA. DESNECESSIDADE. MERITO. ALTERACAO ASSENTO NASCIMENTO. MEDIDA EXCEPCIONAL. ABANDONO AFETIVO. CARACTERIZADO. PREJUIZO. INEXISTENTE. RECURSO CONHECIDO E NAO PROVIDO. 1. COMPETE A AMBOS OS PAIS O PLENO EXERCICIO DO PODER FAMILIAR, QUE CONSISTE EM, QUANTO AOS FILHOS, REPRESENTA-LOS JUDICIALMENTE, DENTRE OUTROS. ART. 1.634, VII, CC. 1.1. IN CASU, O GENITOR POSSUI LEGITIMIDADE ATIVA PARA APRESENTAR DEFESA EM FAVOR DA INFANTE. PRELIMINAR REJEITADA. 2. O SISTEMA REGISTRARIO IMPOE A CITACAO DE TODOS OS INTERESSADOS NOS PROCEDIMENTOS DE JURISDICAO VOLUNTARIA DE ALTERACAO DE ASSENTAMENTO NO REGISTRO CIVIL 2.1. NA HIPOTESE DOS AUTOS, NAO FIGURA A GENITORA DA AUTORA COMO INTERESSADA NO FEITO, POR NAO OBJETIVAR A LIDE A SUPRESSAO DO NOME DESTA DO ASSENTO DE NASCIMENTO DA AUTORA, MAS APENAS EXCLUSAO DO SOBRENOME. CITACAO DESNECESSARIA. 3. A LEI DE REGISTROS PUBLICOS TRAZ A REGRA DE QUE O PRENOME E SOBRENOME SAO DEFINITIVOS, CONTUDO, NAO IMUTAVEIS, OBSERVADA A INEXISTENCIA DE PREJUIZO AOS APELIDOS DE FAMILIA E JUSTO MOTIVO. 4. A JURISPRUDENCIA, DE MODO EXCEPCIONAL, PERFILHA NO SENTIDO DE ADMITIR A SUPRESSAO DO SOBRENOME PATERNO OU MATERNO, DEMONSTRADO O ABANDONO AFETIVO . PRECEDENTES. 4.1. NO CASO EM TELA, O ABANDONO AFETIVO DE FAMILIA MATERNA DA AUTORA, EM ESPECIAL DA SUA MAE, CARACTERIZADA HIPOTESE EXCEPCIONAL A AUTORIZAR A ALTERACAO DO NOME , INEXISTINDO QUALQUER PREJUIZO A LINHA ANCESTRAL E A TERCEIROS, TAMPOUCO EM INTERFERENCIA NO ESTADO DE FILIACAO. 5. PRELIMINAR DE ILEGITIMIDADE ATIVA REJEITADA. RECURSOS CONHECIDOS E NAO PROVIDOS. SENTENCA MANTIDA. (TJ-DF 07129644020188070015 DF 0712964-40.2018.8.07.0015, RELATOR: ROMULO DE ARAUJO MENDES, DATA DE JULGAMENTO: 16/09/2020, 1 TURMA CIVEL, DATA DE PUBLICACAO: PUBLICADO NO DJE : 01/10/2020 . PAG.: SEM PAGINA CADASTRADA.) RESSALTE-SE QUE, PARA A EXCLUSAO DO SOBRENOME FAMILIAR, E IMPRESCINDIVEL MOTIVO QUE A JUSTIFIQUE, HAJA VISTA QUE O DIREITO AO NOME DIZ RESPEITO A PROPRIA IDENTIDADE PESSOAL DO INDIVIDUO, BEM COMO AO NUCLEO FAMILIAR AO QUAL ELE PERTENCE. NO CASO DOS AUTOS, A SITUACAO NARRADA PELO REQUERENTE JUSTIFICA O CONSTRANGIMENTO EM UTILIZAR OS SOBRENOMES DOS GENITORES. ESTES, AO QUE PARECE, NUNCA EXERCERAM O SEU PAPEL NA VIDA DO FILHO, CONFORME SE VERIFICA PELAS DECLARACOES DE ID 161102131, PAGINAS 3/4/6/8/12/13. ALEM DISSO, AS INUMERAS ENTREVISTAS JUNTADAS PELO REQUERENTE, ID 150337638, PAGINAS 2/26, DEMONSTRAM QUE ELE JA E RECONHECIDO NACIONAL E INTERNACIONALMENTE PELO NOME PRETENDIDO, RAFAEL STARK, O QUE AFASTA EVENTUAL PREJUIZO AO MEIO SOCIAL. FACE AO EXPOSTO, ACOLHO O PARECER DO MINISTERIO PUBLICO E, COM FUNDAMENTO NOS ARTIGOS 56, 57 E 109, TODOS DA LEI 6.015/73, DEFIRO O PEDIDO PARA ALTERAR O REGISTRO DE NASCIMENTO DE RAFAEL CASTRO DE MATOS, ID152919968, PAGINA 2, E NELE FAZER CONSTAR QUE O REGISTRADO SE CHAMA RAFAEL STARK, INALTERADOS OS DEMAIS DADOS. OFICIE-SE A POLICIA CIVIL DO ESTADO DE GOIAS (ID 168471439), A JUSTICA ELEITORAL (ID 166597013), A RECEITA FEDERAL (CPF 023.490.141-18) E A POLICIA FEDERAL (ID 166597014) PARA TOMAREM CIENCIA ACERCA DA ALTERACAO DO NOME DE RAFAEL CASTRO DE MATOS PARA RAFAEL STARK. CUSTAS PELO REQUERENTE. APOS O PAGAMENTO DAS CUSTAS, EXPECA-SE O RESPECTIVO MANDADO. TRANSITADA EM JULGADO, FEITAS AS DEVIDAS ANOTACOES E COMUNICACOES, ARQUIVEM-SE OS AUTOS. BRASILIA/DF, DATA E HORA DA ASSINATURA DIGITAL . LUCIANA MARIA PIMENTEL GARCIA JUIZA DE DIREITO 4 ASSINADO ELETRONICAMENTE POR: LUCIANA MARIA PIMENTEL GARCIA 17/08/2023 14:29:59 HTTPS://PJE.TJDFT.JUS.BR/CONSULTAPUBLICA/PROCESSO/CONSULTADOCUMENTO/LISTVIEW.SEAM ID DO DOCUMENTO: 23081714295937900000154835507",
                    "PublishDate": "2023-08-22T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "JUNTADA DE PETICAO DE PETICAO",
                    "PublishDate": "2023-08-21T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "REMETIDOS OS AUTOS (EM DILIGENCIA) PARA CONTADORIA",
                    "PublishDate": "2023-08-21T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "TRANSITADO EM JULGADO EM 21/08/2023 PODER JUDICIARIO DA UNIAO TRIBUNAL DE JUSTICA DO DISTRITO FEDERAL E DOS TERRITORIOS VREGPUBDF VARA DE REGISTROS PUBLICOS DO DF NUMERO DO PROCESSO: 0703885-61.2023.8.07.0015 CLASSE JUDICIAL: RETIFICACAO OU SUPRIMENTO OU RESTAURACAO DE REGISTRO CIVIL (1682) POLO ATIVO: REQUERENTE: RAFAEL CASTRO DE MATOS POLO PASSIVO: CERTIDAO DE TRANSITO EM JULGADO CERTIFICO E DOU FE QUE A SENTENCA DE ID 168642862 TRANSITOU EM JULGADO EM 21/8/2023. POR CONSEGUINTE, FACO REMESSA DOS AUTOS A CONTADORIA PARA CALCULO DAS CUSTAS FINAIS. DOCUMENTO ASSINADO E DATADO ELETRONICAMENTE CONFORME ASSINATURA DIGITAL ASSINADO ELETRONICAMENTE POR: HEVILA MACIEL MENDES VIEIRA 21/08/2023 17:30:07 HTTPS://PJE.TJDFT.JUS.BR/CONSULTAPUBLICA/PROCESSO/CONSULTADOCUMENTO/LISTVIEW.SEAM ID DO DOCUMENTO: 23082117300722300000155442522",
                    "PublishDate": "2023-08-21T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "JUNTADA DE PETICAO DE PETICAO",
                    "PublishDate": "2023-08-21T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "DISPONIBILIZADO NO DJ ELETRONICO EM 21/08/2023 PODER JUDICIARIO DA UNIAO TRIBUNAL DE JUSTICA DO DISTRITO FEDERAL E DOS TERRITORIOS VREGPUBDF VARA DE REGISTROS PUBLICOS DO DF NUMERO DO PROCESSO: 0703885-61.2023.8.07.0015 CLASSE JUDICIAL: RETIFICACAO OU SUPRIMENTO OU RESTAURACAO DE REGISTRO CIVIL (1682) REQUERENTE: RAFAEL CASTRO DE MATOS SENTENCA CUIDA-SE DE PEDIDO FORMULADO POR RAFAEL CASTRO DE MATOS PARA ALTERAR O NOME PARA RAFAEL STARK. INFORMA O REQUERENTE, PARA TANTO, QUE NAO SE IDENTIFICA COM OS SOBRENOMES ORIUNDOS DOS GENITORES, JOAQUIM DE MATOS FILHO E ROSANE DE FATIMA LEITE CASTRO, EM RAZAO DO ABANDONO AFETIVO E MATERIAL DO QUAL FOI VITIMA. POR TAL RAZAO, PEDE A EXCLUSAO DOS SOBRENOMES FAMILIARES E A INCLUSAO DO NOME STARK, PROVENIENTE DE SUA EMPRESA (STARK BANK), HAJA VISTA JA SER RECONHECIDO MUNDIALMENTE DESSA FORMA. O MINISTERIO PUBLICO OFICIOU PELA PROCEDENCIA DO PEDIDO, ID 163297949. E O RELATORIO. DECIDO. AS DISPOSICOES PREVISTAS NO ARTIGO 57 DA LEI DE REGISTROS PUBLICOS ACERCA DO NOME FORAM ALTERADAS PELA LEI 14.382/2022. TODAVIA, O PRESENTE CASO NAO SE ENQUADRA NAS HIPOTESES DE PROCESSAMENTO PELA VIA EXTRAJUDICIAL, UMA VEZ QUE A PRETENSAO E DE EXCLUSAO DE SOBRENOME FAMILIAR. POSTO ISSO, A CONTRARIO SENSU, AS HIPOTESES NAO CONTEMPLADAS NO ROL DO ARTIGO 57, COMO O PRESENTE CASO, DEVERAO SER, NECESSARIAMENTE, PROCESSADAS PELA VIA JUDICIAL. NO QUE TANGE A SUPRESSAO DOS SOBRENOMES FAMILIARES, EM QUE PESE A LEI 6.015/1973 NAO ELENCAR TAL POSSIBILIDADE, A JURISPRUDENCIA, DE MODO EXCEPCIONAL, ADMITE-A SOB O SEGUINTE FUNDAMENTO: APELACAO CIVEL. DIREITO CIVIL. DIREITO DE FAMILIA. DIREITO PROCESSUAL CIVIL. ACAO DE ALTERACAO DE REGISTRO CIVIL. PRELIMINAR. ILEGITIMIDADE ATIVA. AFASTADA. MENOR. REPRESENTACAO. GENITOR. CITACAO. GENITORA DA AUTORA. DESNECESSIDADE. MERITO. ALTERACAO ASSENTO NASCIMENTO. MEDIDA EXCEPCIONAL. ABANDONO AFETIVO. CARACTERIZADO. PREJUIZO. INEXISTENTE. RECURSO CONHECIDO E NAO PROVIDO. 1. COMPETE A AMBOS OS PAIS O PLENO EXERCICIO DO PODER FAMILIAR, QUE CONSISTE EM, QUANTO AOS FILHOS, REPRESENTA-LOS JUDICIALMENTE, DENTRE OUTROS. ART. 1.634, VII, CC. 1.1. IN CASU, O GENITOR POSSUI LEGITIMIDADE ATIVA PARA APRESENTAR DEFESA EM FAVOR DA INFANTE. PRELIMINAR REJEITADA. 2. O SISTEMA REGISTRARIO IMPOE A CITACAO DE TODOS OS INTERESSADOS NOS PROCEDIMENTOS DE JURISDICAO VOLUNTARIA DE ALTERACAO DE ASSENTAMENTO NO REGISTRO CIVIL 2.1. NA HIPOTESE DOS AUTOS, NAO FIGURA A GENITORA DA AUTORA COMO INTERESSADA NO FEITO, POR NAO OBJETIVAR A LIDE A SUPRESSAO DO NOME DESTA DO ASSENTO DE NASCIMENTO DA AUTORA, MAS APENAS EXCLUSAO DO SOBRENOME. CITACAO DESNECESSARIA. 3. A LEI DE REGISTROS PUBLICOS TRAZ A REGRA DE QUE O PRENOME E SOBRENOME SAO DEFINITIVOS, CONTUDO, NAO IMUTAVEIS, OBSERVADA A INEXISTENCIA DE PREJUIZO AOS APELIDOS DE FAMILIA E JUSTO MOTIVO. 4. A JURISPRUDENCIA, DE MODO EXCEPCIONAL, PERFILHA NO SENTIDO DE ADMITIR A SUPRESSAO DO SOBRENOME PATERNO OU MATERNO, DEMONSTRADO O ABANDONO AFETIVO . PRECEDENTES. 4.1. NO CASO EM TELA, O ABANDONO AFETIVO DE FAMILIA MATERNA DA AUTORA, EM ESPECIAL DA SUA MAE, CARACTERIZADA HIPOTESE EXCEPCIONAL A AUTORIZAR A ALTERACAO DO NOME , INEXISTINDO QUALQUER PREJUIZO A LINHA ANCESTRAL E A TERCEIROS, TAMPOUCO EM INTERFERENCIA NO ESTADO DE FILIACAO. 5. PRELIMINAR DE ILEGITIMIDADE ATIVA REJEITADA. RECURSOS CONHECIDOS E NAO PROVIDOS. SENTENCA MANTIDA. (TJ-DF 07129644020188070015 DF 0712964-40.2018.8.07.0015, RELATOR: ROMULO DE ARAUJO MENDES, DATA DE JULGAMENTO: 16/09/2020, 1 TURMA CIVEL, DATA DE PUBLICACAO: PUBLICADO NO DJE : 01/10/2020 . PAG.: SEM PAGINA CADASTRADA.) RESSALTE-SE QUE, PARA A EXCLUSAO DO SOBRENOME FAMILIAR, E IMPRESCINDIVEL MOTIVO QUE A JUSTIFIQUE, HAJA VISTA QUE O DIREITO AO NOME DIZ RESPEITO A PROPRIA IDENTIDADE PESSOAL DO INDIVIDUO, BEM COMO AO NUCLEO FAMILIAR AO QUAL ELE PERTENCE. NO CASO DOS AUTOS, A SITUACAO NARRADA PELO REQUERENTE JUSTIFICA O CONSTRANGIMENTO EM UTILIZAR OS SOBRENOMES DOS GENITORES. ESTES, AO QUE PARECE, NUNCA EXERCERAM O SEU PAPEL NA VIDA DO FILHO, CONFORME SE VERIFICA PELAS DECLARACOES DE ID 161102131, PAGINAS 3/4/6/8/12/13. ALEM DISSO, AS INUMERAS ENTREVISTAS JUNTADAS PELO REQUERENTE, ID 150337638, PAGINAS 2/26, DEMONSTRAM QUE ELE JA E RECONHECIDO NACIONAL E INTERNACIONALMENTE PELO NOME PRETENDIDO, RAFAEL STARK, O QUE AFASTA EVENTUAL PREJUIZO AO MEIO SOCIAL. FACE AO EXPOSTO, ACOLHO O PARECER DO MINISTERIO PUBLICO E, COM FUNDAMENTO NOS ARTIGOS 56, 57 E 109, TODOS DA LEI 6.015/73, DEFIRO O PEDIDO PARA ALTERAR O REGISTRO DE NASCIMENTO DE RAFAEL CASTRO DE MATOS, ID152919968, PAGINA 2, E NELE FAZER CONSTAR QUE O REGISTRADO SE CHAMA RAFAEL STARK, INALTERADOS OS DEMAIS DADOS. OFICIE-SE A POLICIA CIVIL DO ESTADO DE GOIAS (ID 168471439), A JUSTICA ELEITORAL (ID 166597013), A RECEITA FEDERAL (CPF 023.490.141-18) E A POLICIA FEDERAL (ID 166597014) PARA TOMAREM CIENCIA ACERCA DA ALTERACAO DO NOME DE RAFAEL CASTRO DE MATOS PARA RAFAEL STARK. CUSTAS PELO REQUERENTE. APOS O PAGAMENTO DAS CUSTAS, EXPECA-SE O RESPECTIVO MANDADO. TRANSITADA EM JULGADO, FEITAS AS DEVIDAS ANOTACOES E COMUNICACOES, ARQUIVEM-SE OS AUTOS. BRASILIA/DF, DATA E HORA DA ASSINATURA DIGITAL . LUCIANA MARIA PIMENTEL GARCIA JUIZA DE DIREITO 4 ASSINADO ELETRONICAMENTE POR: LUCIANA MARIA PIMENTEL GARCIA 17/08/2023 14:29:59 HTTPS://PJE.TJDFT.JUS.BR/CONSULTAPUBLICA/PROCESSO/CONSULTADOCUMENTO/LISTVIEW.SEAM ID DO DOCUMENTO: 23081714295937900000154835507",
                    "PublishDate": "2023-08-21T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "JUNTADA DE PETICAO DE MANIFESTACAO DO MPDFT",
                    "PublishDate": "2023-08-17T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "EXPEDICAO DE OUTROS DOCUMENTOS. PODER JUDICIARIO DA UNIAO TRIBUNAL DE JUSTICA DO DISTRITO FEDERAL E DOS TERRITORIOS VREGPUBDF VARA DE REGISTROS PUBLICOS DO DF NUMERO DO PROCESSO: 0703885-61.2023.8.07.0015 CLASSE JUDICIAL: RETIFICACAO OU SUPRIMENTO OU RESTAURACAO DE REGISTRO CIVIL (1682) REQUERENTE: RAFAEL CASTRO DE MATOS SENTENCA CUIDA-SE DE PEDIDO FORMULADO POR RAFAEL CASTRO DE MATOS PARA ALTERAR O NOME PARA RAFAEL STARK. INFORMA O REQUERENTE, PARA TANTO, QUE NAO SE IDENTIFICA COM OS SOBRENOMES ORIUNDOS DOS GENITORES, JOAQUIM DE MATOS FILHO E ROSANE DE FATIMA LEITE CASTRO, EM RAZAO DO ABANDONO AFETIVO E MATERIAL DO QUAL FOI VITIMA. POR TAL RAZAO, PEDE A EXCLUSAO DOS SOBRENOMES FAMILIARES E A INCLUSAO DO NOME STARK, PROVENIENTE DE SUA EMPRESA (STARK BANK), HAJA VISTA JA SER RECONHECIDO MUNDIALMENTE DESSA FORMA. O MINISTERIO PUBLICO OFICIOU PELA PROCEDENCIA DO PEDIDO, ID 163297949. E O RELATORIO. DECIDO. AS DISPOSICOES PREVISTAS NO ARTIGO 57 DA LEI DE REGISTROS PUBLICOS ACERCA DO NOME FORAM ALTERADAS PELA LEI 14.382/2022. TODAVIA, O PRESENTE CASO NAO SE ENQUADRA NAS HIPOTESES DE PROCESSAMENTO PELA VIA EXTRAJUDICIAL, UMA VEZ QUE A PRETENSAO E DE EXCLUSAO DE SOBRENOME FAMILIAR. POSTO ISSO, A CONTRARIO SENSU, AS HIPOTESES NAO CONTEMPLADAS NO ROL DO ARTIGO 57, COMO O PRESENTE CASO, DEVERAO SER, NECESSARIAMENTE, PROCESSADAS PELA VIA JUDICIAL. NO QUE TANGE A SUPRESSAO DOS SOBRENOMES FAMILIARES, EM QUE PESE A LEI 6.015/1973 NAO ELENCAR TAL POSSIBILIDADE, A JURISPRUDENCIA, DE MODO EXCEPCIONAL, ADMITE-A SOB O SEGUINTE FUNDAMENTO: APELACAO CIVEL. DIREITO CIVIL. DIREITO DE FAMILIA. DIREITO PROCESSUAL CIVIL. ACAO DE ALTERACAO DE REGISTRO CIVIL. PRELIMINAR. ILEGITIMIDADE ATIVA. AFASTADA. MENOR. REPRESENTACAO. GENITOR. CITACAO. GENITORA DA AUTORA. DESNECESSIDADE. MERITO. ALTERACAO ASSENTO NASCIMENTO. MEDIDA EXCEPCIONAL. ABANDONO AFETIVO. CARACTERIZADO. PREJUIZO. INEXISTENTE. RECURSO CONHECIDO E NAO PROVIDO. 1. COMPETE A AMBOS OS PAIS O PLENO EXERCICIO DO PODER FAMILIAR, QUE CONSISTE EM, QUANTO AOS FILHOS, REPRESENTA-LOS JUDICIALMENTE, DENTRE OUTROS. ART. 1.634, VII, CC. 1.1. IN CASU, O GENITOR POSSUI LEGITIMIDADE ATIVA PARA APRESENTAR DEFESA EM FAVOR DA INFANTE. PRELIMINAR REJEITADA. 2. O SISTEMA REGISTRARIO IMPOE A CITACAO DE TODOS OS INTERESSADOS NOS PROCEDIMENTOS DE JURISDICAO VOLUNTARIA DE ALTERACAO DE ASSENTAMENTO NO REGISTRO CIVIL 2.1. NA HIPOTESE DOS AUTOS, NAO FIGURA A GENITORA DA AUTORA COMO INTERESSADA NO FEITO, POR NAO OBJETIVAR A LIDE A SUPRESSAO DO NOME DESTA DO ASSENTO DE NASCIMENTO DA AUTORA, MAS APENAS EXCLUSAO DO SOBRENOME. CITACAO DESNECESSARIA. 3. A LEI DE REGISTROS PUBLICOS TRAZ A REGRA DE QUE O PRENOME E SOBRENOME SAO DEFINITIVOS, CONTUDO, NAO IMUTAVEIS, OBSERVADA A INEXISTENCIA DE PREJUIZO AOS APELIDOS DE FAMILIA E JUSTO MOTIVO. 4. A JURISPRUDENCIA, DE MODO EXCEPCIONAL, PERFILHA NO SENTIDO DE ADMITIR A SUPRESSAO DO SOBRENOME PATERNO OU MATERNO, DEMONSTRADO O ABANDONO AFETIVO . PRECEDENTES. 4.1. NO CASO EM TELA, O ABANDONO AFETIVO DE FAMILIA MATERNA DA AUTORA, EM ESPECIAL DA SUA MAE, CARACTERIZADA HIPOTESE EXCEPCIONAL A AUTORIZAR A ALTERACAO DO NOME , INEXISTINDO QUALQUER PREJUIZO A LINHA ANCESTRAL E A TERCEIROS, TAMPOUCO EM INTERFERENCIA NO ESTADO DE FILIACAO. 5. PRELIMINAR DE ILEGITIMIDADE ATIVA REJEITADA. RECURSOS CONHECIDOS E NAO PROVIDOS. SENTENCA MANTIDA. (TJ-DF 07129644020188070015 DF 0712964-40.2018.8.07.0015, RELATOR: ROMULO DE ARAUJO MENDES, DATA DE JULGAMENTO: 16/09/2020, 1 TURMA CIVEL, DATA DE PUBLICACAO: PUBLICADO NO DJE : 01/10/2020 . PAG.: SEM PAGINA CADASTRADA.) RESSALTE-SE QUE, PARA A EXCLUSAO DO SOBRENOME FAMILIAR, E IMPRESCINDIVEL MOTIVO QUE A JUSTIFIQUE, HAJA VISTA QUE O DIREITO AO NOME DIZ RESPEITO A PROPRIA IDENTIDADE PESSOAL DO INDIVIDUO, BEM COMO AO NUCLEO FAMILIAR AO QUAL ELE PERTENCE. NO CASO DOS AUTOS, A SITUACAO NARRADA PELO REQUERENTE JUSTIFICA O CONSTRANGIMENTO EM UTILIZAR OS SOBRENOMES DOS GENITORES. ESTES, AO QUE PARECE, NUNCA EXERCERAM O SEU PAPEL NA VIDA DO FILHO, CONFORME SE VERIFICA PELAS DECLARACOES DE ID 161102131, PAGINAS 3/4/6/8/12/13. ALEM DISSO, AS INUMERAS ENTREVISTAS JUNTADAS PELO REQUERENTE, ID 150337638, PAGINAS 2/26, DEMONSTRAM QUE ELE JA E RECONHECIDO NACIONAL E INTERNACIONALMENTE PELO NOME PRETENDIDO, RAFAEL STARK, O QUE AFASTA EVENTUAL PREJUIZO AO MEIO SOCIAL. FACE AO EXPOSTO, ACOLHO O PARECER DO MINISTERIO PUBLICO E, COM FUNDAMENTO NOS ARTIGOS 56, 57 E 109, TODOS DA LEI 6.015/73, DEFIRO O PEDIDO PARA ALTERAR O REGISTRO DE NASCIMENTO DE RAFAEL CASTRO DE MATOS, ID152919968, PAGINA 2, E NELE FAZER CONSTAR QUE O REGISTRADO SE CHAMA RAFAEL STARK, INALTERADOS OS DEMAIS DADOS. OFICIE-SE A POLICIA CIVIL DO ESTADO DE GOIAS (ID 168471439), A JUSTICA ELEITORAL (ID 166597013), A RECEITA FEDERAL (CPF 023.490.141-18) E A POLICIA FEDERAL (ID 166597014) PARA TOMAREM CIENCIA ACERCA DA ALTERACAO DO NOME DE RAFAEL CASTRO DE MATOS PARA RAFAEL STARK. CUSTAS PELO REQUERENTE. APOS O PAGAMENTO DAS CUSTAS, EXPECA-SE O RESPECTIVO MANDADO. TRANSITADA EM JULGADO, FEITAS AS DEVIDAS ANOTACOES E COMUNICACOES, ARQUIVEM-SE OS AUTOS. BRASILIA/DF, DATA E HORA DA ASSINATURA DIGITAL . LUCIANA MARIA PIMENTEL GARCIA JUIZA DE DIREITO 4 ASSINADO ELETRONICAMENTE POR: LUCIANA MARIA PIMENTEL GARCIA 17/08/2023 14:29:59 HTTPS://PJE.TJDFT.JUS.BR/CONSULTAPUBLICA/PROCESSO/CONSULTADOCUMENTO/LISTVIEW.SEAM ID DO DOCUMENTO: 23081714295937900000154835507",
                    "PublishDate": "2023-08-17T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "RECEBIDOS OS AUTOS",
                    "PublishDate": "2023-08-17T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "JULGADO PROCEDENTE O PEDIDO PODER JUDICIARIO DA UNIAO TRIBUNAL DE JUSTICA DO DISTRITO FEDERAL E DOS TERRITORIOS VREGPUBDF VARA DE REGISTROS PUBLICOS DO DF NUMERO DO PROCESSO: 0703885-61.2023.8.07.0015 CLASSE JUDICIAL: RETIFICACAO OU SUPRIMENTO OU RESTAURACAO DE REGISTRO CIVIL (1682) REQUERENTE: RAFAEL CASTRO DE MATOS SENTENCA CUIDA-SE DE PEDIDO FORMULADO POR RAFAEL CASTRO DE MATOS PARA ALTERAR O NOME PARA RAFAEL STARK. INFORMA O REQUERENTE, PARA TANTO, QUE NAO SE IDENTIFICA COM OS SOBRENOMES ORIUNDOS DOS GENITORES, JOAQUIM DE MATOS FILHO E ROSANE DE FATIMA LEITE CASTRO, EM RAZAO DO ABANDONO AFETIVO E MATERIAL DO QUAL FOI VITIMA. POR TAL RAZAO, PEDE A EXCLUSAO DOS SOBRENOMES FAMILIARES E A INCLUSAO DO NOME STARK, PROVENIENTE DE SUA EMPRESA (STARK BANK), HAJA VISTA JA SER RECONHECIDO MUNDIALMENTE DESSA FORMA. O MINISTERIO PUBLICO OFICIOU PELA PROCEDENCIA DO PEDIDO, ID 163297949. E O RELATORIO. DECIDO. AS DISPOSICOES PREVISTAS NO ARTIGO 57 DA LEI DE REGISTROS PUBLICOS ACERCA DO NOME FORAM ALTERADAS PELA LEI 14.382/2022. TODAVIA, O PRESENTE CASO NAO SE ENQUADRA NAS HIPOTESES DE PROCESSAMENTO PELA VIA EXTRAJUDICIAL, UMA VEZ QUE A PRETENSAO E DE EXCLUSAO DE SOBRENOME FAMILIAR. POSTO ISSO, A CONTRARIO SENSU, AS HIPOTESES NAO CONTEMPLADAS NO ROL DO ARTIGO 57, COMO O PRESENTE CASO, DEVERAO SER, NECESSARIAMENTE, PROCESSADAS PELA VIA JUDICIAL. NO QUE TANGE A SUPRESSAO DOS SOBRENOMES FAMILIARES, EM QUE PESE A LEI 6.015/1973 NAO ELENCAR TAL POSSIBILIDADE, A JURISPRUDENCIA, DE MODO EXCEPCIONAL, ADMITE-A SOB O SEGUINTE FUNDAMENTO: APELACAO CIVEL. DIREITO CIVIL. DIREITO DE FAMILIA. DIREITO PROCESSUAL CIVIL. ACAO DE ALTERACAO DE REGISTRO CIVIL. PRELIMINAR. ILEGITIMIDADE ATIVA. AFASTADA. MENOR. REPRESENTACAO. GENITOR. CITACAO. GENITORA DA AUTORA. DESNECESSIDADE. MERITO. ALTERACAO ASSENTO NASCIMENTO. MEDIDA EXCEPCIONAL. ABANDONO AFETIVO. CARACTERIZADO. PREJUIZO. INEXISTENTE. RECURSO CONHECIDO E NAO PROVIDO. 1. COMPETE A AMBOS OS PAIS O PLENO EXERCICIO DO PODER FAMILIAR, QUE CONSISTE EM, QUANTO AOS FILHOS, REPRESENTA-LOS JUDICIALMENTE, DENTRE OUTROS. ART. 1.634, VII, CC. 1.1. IN CASU, O GENITOR POSSUI LEGITIMIDADE ATIVA PARA APRESENTAR DEFESA EM FAVOR DA INFANTE. PRELIMINAR REJEITADA. 2. O SISTEMA REGISTRARIO IMPOE A CITACAO DE TODOS OS INTERESSADOS NOS PROCEDIMENTOS DE JURISDICAO VOLUNTARIA DE ALTERACAO DE ASSENTAMENTO NO REGISTRO CIVIL 2.1. NA HIPOTESE DOS AUTOS, NAO FIGURA A GENITORA DA AUTORA COMO INTERESSADA NO FEITO, POR NAO OBJETIVAR A LIDE A SUPRESSAO DO NOME DESTA DO ASSENTO DE NASCIMENTO DA AUTORA, MAS APENAS EXCLUSAO DO SOBRENOME. CITACAO DESNECESSARIA. 3. A LEI DE REGISTROS PUBLICOS TRAZ A REGRA DE QUE O PRENOME E SOBRENOME SAO DEFINITIVOS, CONTUDO, NAO IMUTAVEIS, OBSERVADA A INEXISTENCIA DE PREJUIZO AOS APELIDOS DE FAMILIA E JUSTO MOTIVO. 4. A JURISPRUDENCIA, DE MODO EXCEPCIONAL, PERFILHA NO SENTIDO DE ADMITIR A SUPRESSAO DO SOBRENOME PATERNO OU MATERNO, DEMONSTRADO O ABANDONO AFETIVO . PRECEDENTES. 4.1. NO CASO EM TELA, O ABANDONO AFETIVO DE FAMILIA MATERNA DA AUTORA, EM ESPECIAL DA SUA MAE, CARACTERIZADA HIPOTESE EXCEPCIONAL A AUTORIZAR A ALTERACAO DO NOME , INEXISTINDO QUALQUER PREJUIZO A LINHA ANCESTRAL E A TERCEIROS, TAMPOUCO EM INTERFERENCIA NO ESTADO DE FILIACAO. 5. PRELIMINAR DE ILEGITIMIDADE ATIVA REJEITADA. RECURSOS CONHECIDOS E NAO PROVIDOS. SENTENCA MANTIDA. (TJ-DF 07129644020188070015 DF 0712964-40.2018.8.07.0015, RELATOR: ROMULO DE ARAUJO MENDES, DATA DE JULGAMENTO: 16/09/2020, 1 TURMA CIVEL, DATA DE PUBLICACAO: PUBLICADO NO DJE : 01/10/2020 . PAG.: SEM PAGINA CADASTRADA.) RESSALTE-SE QUE, PARA A EXCLUSAO DO SOBRENOME FAMILIAR, E IMPRESCINDIVEL MOTIVO QUE A JUSTIFIQUE, HAJA VISTA QUE O DIREITO AO NOME DIZ RESPEITO A PROPRIA IDENTIDADE PESSOAL DO INDIVIDUO, BEM COMO AO NUCLEO FAMILIAR AO QUAL ELE PERTENCE. NO CASO DOS AUTOS, A SITUACAO NARRADA PELO REQUERENTE JUSTIFICA O CONSTRANGIMENTO EM UTILIZAR OS SOBRENOMES DOS GENITORES. ESTES, AO QUE PARECE, NUNCA EXERCERAM O SEU PAPEL NA VIDA DO FILHO, CONFORME SE VERIFICA PELAS DECLARACOES DE ID 161102131, PAGINAS 3/4/6/8/12/13. ALEM DISSO, AS INUMERAS ENTREVISTAS JUNTADAS PELO REQUERENTE, ID 150337638, PAGINAS 2/26, DEMONSTRAM QUE ELE JA E RECONHECIDO NACIONAL E INTERNACIONALMENTE PELO NOME PRETENDIDO, RAFAEL STARK, O QUE AFASTA EVENTUAL PREJUIZO AO MEIO SOCIAL. FACE AO EXPOSTO, ACOLHO O PARECER DO MINISTERIO PUBLICO E, COM FUNDAMENTO NOS ARTIGOS 56, 57 E 109, TODOS DA LEI 6.015/73, DEFIRO O PEDIDO PARA ALTERAR O REGISTRO DE NASCIMENTO DE RAFAEL CASTRO DE MATOS, ID152919968, PAGINA 2, E NELE FAZER CONSTAR QUE O REGISTRADO SE CHAMA RAFAEL STARK, INALTERADOS OS DEMAIS DADOS. OFICIE-SE A POLICIA CIVIL DO ESTADO DE GOIAS (ID 168471439), A JUSTICA ELEITORAL (ID 166597013), A RECEITA FEDERAL (CPF 023.490.141-18) E A POLICIA FEDERAL (ID 166597014) PARA TOMAREM CIENCIA ACERCA DA ALTERACAO DO NOME DE RAFAEL CASTRO DE MATOS PARA RAFAEL STARK. CUSTAS PELO REQUERENTE. APOS O PAGAMENTO DAS CUSTAS, EXPECA-SE O RESPECTIVO MANDADO. TRANSITADA EM JULGADO, FEITAS AS DEVIDAS ANOTACOES E COMUNICACOES, ARQUIVEM-SE OS AUTOS. BRASILIA/DF, DATA E HORA DA ASSINATURA DIGITAL . LUCIANA MARIA PIMENTEL GARCIA JUIZA DE DIREITO 4 ASSINADO ELETRONICAMENTE POR: LUCIANA MARIA PIMENTEL GARCIA 17/08/2023 14:29:59 HTTPS://PJE.TJDFT.JUS.BR/CONSULTAPUBLICA/PROCESSO/CONSULTADOCUMENTO/LISTVIEW.SEAM ID DO DOCUMENTO: 23081714295937900000154835507",
                    "PublishDate": "2023-08-17T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "CONCLUSOS PARA JULGAMENTO PARA JUIZ(A) LUCIANA MARIA PIMENTEL GARCIA",
                    "PublishDate": "2023-08-14T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "RECEBIDOS OS AUTOS",
                    "PublishDate": "2023-08-14T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE PODER JUDICIARIO DA UNIAO TRIBUNAL DE JUSTICA DO DISTRITO FEDERAL E DOS TERRITORIOS VREGPUBDF VARA DE REGISTROS PUBLICOS DO DF NUMERO DO PROCESSO: 0703885-61.2023.8.07.0015 CLASSE JUDICIAL: RETIFICACAO OU SUPRIMENTO OU RESTAURACAO DE REGISTRO CIVIL (1682) REQUERENTE: RAFAEL CASTRO DE MATOS DESPACHO RETIRE-SE O SIGILO DOS DOCUMENTOS DE IDS 166597013, 166597014 E 166597019. APOS, VENHAM OS AUTOS CONCLUSOS PARA SENTENCA. BRASILIA/DF, DATA E HORA DA ASSINATURA DIGITAL . LUCIANA MARIA PIMENTEL GARCIA JUIZA DE DIREITO 4 ASSINADO ELETRONICAMENTE POR: LUCIANA MARIA PIMENTEL GARCIA 14/08/2023 16:39:32 HTTPS://PJE.TJDFT.JUS.BR/CONSULTAPUBLICA/PROCESSO/CONSULTADOCUMENTO/LISTVIEW.SEAM ID DO DOCUMENTO: 23081416393208300000154727472",
                    "PublishDate": "2023-08-14T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "CONCLUSOS PARA JULGAMENTO PARA JUIZ(A) LUCIANA MARIA PIMENTEL GARCIA",
                    "PublishDate": "2023-08-14T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "JUNTADA DE CERTIDAO PODER JUDICIARIO DA UNIAO TRIBUNAL DE JUSTICA DO DISTRITO FEDERAL E DOS TERRITORIOS VREGPUBDF VARA DE REGISTROS PUBLICOS DO DF NUMERO DO PROCESSO: 0703885-61.2023.8.07.0015 CLASSE JUDICIAL: RETIFICACAO OU SUPRIMENTO OU RESTAURACAO DE REGISTRO CIVIL (1682) REQUERENTE: RAFAEL CASTRO DE MATOS CERTIDAO CERTIFICO E DOU FE QUE, NESTA DATA, JUNTEI OFICIO ENVIADO PELA PCGO, VIA EMAIL INSTITUCIONAL. DOCUMENTO ASSINADO E DATADO ELETRONICAMENTE CONFORME ASSINATURA DIGITAL ASSINADO ELETRONICAMENTE POR: HEVILA MACIEL MENDES VIEIRA 14/08/2023 13:05:45 HTTPS://PJE.TJDFT.JUS.BR/CONSULTAPUBLICA/PROCESSO/CONSULTADOCUMENTO/LISTVIEW.SEAM ID DO DOCUMENTO: 23081413054490500000154686598",
                    "PublishDate": "2023-08-14T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "JUNTADA DE CERTIDAO PODER JUDICIARIO DA UNIAO TRIBUNAL DE JUSTICA DO DISTRITO FEDERAL E DOS TERRITORIOS VREGPUBDF VARA DE REGISTROS PUBLICOS DO DF NUMERO DO PROCESSO: 0703885-61.2023.8.07.0015 CLASSE JUDICIAL: RETIFICACAO OU SUPRIMENTO OU RESTAURACAO DE REGISTRO CIVIL (1682) REQUERENTE: RAFAEL CASTRO DE MATOS CERTIDAO CERTIFICO QUE O AR REFERENTE AO OFICIO N  999 / 2023 / VRP ID164855086 RETORNOU COMO RECEBIDO, CONFORME O ANEXO. BRASILIA, 9 DE AGOSTO DE 2023. KAYLANE ALVES BONFIM ESTAGIARIO CARTORIO ASSINADO ELETRONICAMENTE POR: HEVILA MACIEL MENDES VIEIRA 09/08/2023 15:43:00 HTTPS://PJE.TJDFT.JUS.BR/CONSULTAPUBLICA/PROCESSO/CONSULTADOCUMENTO/LISTVIEW.SEAM ID DO DOCUMENTO: 23080915430012200000154381630",
                    "PublishDate": "2023-08-09T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "JUNTADA DE PETICAO DE ENTREGUE (ECARTA) ASSINADO ELETRONICAMENTE POR: PROCESSO JUDICIAL ELETRONICO PJE 1.4.3 04/08/2023 05:45:25 HTTPS://PJE.TJDFT.JUS.BR/CONSULTAPUBLICA/PROCESSO/CONSULTADOCUMENTO/LISTVIEW.SEAM ID DO DOCUMENTO: 23080405452500000000153910034",
                    "PublishDate": "2023-08-04T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "JUNTADA DE PETICAO DE PETICAO",
                    "PublishDate": "2023-07-26T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "EXPEDICAO DE AVISO DE RECEBIMENTO (AR).",
                    "PublishDate": "2023-07-12T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "JUNTADA DE CERTIDAO PODER JUDICIARIO DA UNIAO TRIBUNAL DE JUSTICA DO DISTRITO FEDERAL E DOS TERRITORIOS VREGPUBDF VARA DE REGISTROS PUBLICOS DO DF NUMERO DO PROCESSO: 0703885-61.2023.8.07.0015 CLASSE JUDICIAL: RETIFICACAO OU SUPRIMENTO OU RESTAURACAO DE REGISTRO CIVIL (1682) REQUERENTE: RAFAEL CASTRO DE MATOS CERTIDAO CERTIFICO QUE ENCAMINHEI, VIA CORREIOS, O OFICIO N  999 / 2023 / VRP ID164855086, COM CODIGO DE POSTAGEM BR458720069BR. BRASILIA, 11 DE JULHO DE 2023. KAYLANE ALVES BONFIM ESTAGIARIO CARTORIO ASSINADO ELETRONICAMENTE POR: HEVILA MACIEL MENDES VIEIRA 12/07/2023 14:58:05 HTTPS://PJE.TJDFT.JUS.BR/CONSULTAPUBLICA/PROCESSO/CONSULTADOCUMENTO/LISTVIEW.SEAM ID DO DOCUMENTO: 23071214580537400000151572151",
                    "PublishDate": "2023-07-12T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "EXPEDICAO DE OFICIO.",
                    "PublishDate": "2023-07-11T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "PUBLICADO DESPACHO EM 05/07/2023. PODER JUDICIARIO DA UNIAO TRIBUNAL DE JUSTICA DO DISTRITO FEDERAL E DOS TERRITORIOS VREGPUBDF VARA DE REGISTROS PUBLICOS DO DF NUMERO DO PROCESSO: 0703885-61.2023.8.07.0015 CLASSE JUDICIAL: RETIFICACAO OU SUPRIMENTO OU RESTAURACAO DE REGISTRO CIVIL (1682) REQUERENTE: RAFAEL CASTRO DE MATOS DESPACHO AO CARTORIO PARA ADOCAO DAS SEGUINTES PROVIDENCIAS: 1. OFICIE-SE A POLICIA CIVIL DO ESTADO DE GOIAS PARA ENVIAR A ESTE JUIZO O PRONTUARIO CIVIL DE RAFAEL CASTRO DE MATOS, CPF 023.490.141-18, RG 5153142 -SPTC/GO; 2. INTIME-SE O REQUERENTE PARA JUNTAR, NO PRAZO DE QUINZE DIAS, O TITULO DE ELEITOR E O PASSAPORTE. APOS, VENHAM OS AUTOS CONCLUSOS PARA SENTENCA. BRASILIA/DF, DATA E HORA DA ASSINATURA DIGITAL . LUCIANA MARIA PIMENTEL GARCIA JUIZA DE DIREITO 4 ASSINADO ELETRONICAMENTE POR: LUCIANA MARIA PIMENTEL GARCIA 30/06/2023 16:05:23 HTTPS://PJE.TJDFT.JUS.BR/CONSULTAPUBLICA/PROCESSO/CONSULTADOCUMENTO/LISTVIEW.SEAM ID DO DOCUMENTO: 23063016052334200000150603413",
                    "PublishDate": "2023-07-05T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "DISPONIBILIZADO NO DJ ELETRONICO EM 04/07/2023 PODER JUDICIARIO DA UNIAO TRIBUNAL DE JUSTICA DO DISTRITO FEDERAL E DOS TERRITORIOS VREGPUBDF VARA DE REGISTROS PUBLICOS DO DF NUMERO DO PROCESSO: 0703885-61.2023.8.07.0015 CLASSE JUDICIAL: RETIFICACAO OU SUPRIMENTO OU RESTAURACAO DE REGISTRO CIVIL (1682) REQUERENTE: RAFAEL CASTRO DE MATOS DESPACHO AO CARTORIO PARA ADOCAO DAS SEGUINTES PROVIDENCIAS: 1. OFICIE-SE A POLICIA CIVIL DO ESTADO DE GOIAS PARA ENVIAR A ESTE JUIZO O PRONTUARIO CIVIL DE RAFAEL CASTRO DE MATOS, CPF 023.490.141-18, RG 5153142 -SPTC/GO; 2. INTIME-SE O REQUERENTE PARA JUNTAR, NO PRAZO DE QUINZE DIAS, O TITULO DE ELEITOR E O PASSAPORTE. APOS, VENHAM OS AUTOS CONCLUSOS PARA SENTENCA. BRASILIA/DF, DATA E HORA DA ASSINATURA DIGITAL . LUCIANA MARIA PIMENTEL GARCIA JUIZA DE DIREITO 4 ASSINADO ELETRONICAMENTE POR: LUCIANA MARIA PIMENTEL GARCIA 30/06/2023 16:05:23 HTTPS://PJE.TJDFT.JUS.BR/CONSULTAPUBLICA/PROCESSO/CONSULTADOCUMENTO/LISTVIEW.SEAM ID DO DOCUMENTO: 23063016052334200000150603413",
                    "PublishDate": "2023-07-04T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "N. 0703885-61.2023.8.07.0015 - RETIFICACAO OU SUPRIMENTO OU RESTAURACAO DE REGISTRO CIVIL - A: RAFAEL CASTRO DE MATOS. ADV(S).: DF33133 - GUILHERME SILVEIRA COELHO, DF0050213A - MATEUS ROCHA TOMAZ, DF67399 - ROBSON LAPOENTE NOVAES JUNIOR, DF16379 - ANDRE LUIZ SOUZA DA SILVEIRA. T: MINISTERIO PUBLICO DO DISTRITO FEDERAL E DOS TERRITORIOS. ADV(S).: NAO CONSTA ADVOGADO. PODER JUDICIARIO DA UNIAO TRIBUNAL DE JUSTICA DO DISTRITO FEDERAL E DOS TERRITORIOS VREGPUBDF VARA DE REGISTROS PUBLICOS DO DF NUMERO DO PROCESSO: 0703885-61.2023.8.07.0015 CLASSE JUDICIAL: RETIFICACAO OU SUPRIMENTO OU RESTAURACAO DE REGISTRO CIVIL (1682) REQUERENTE: RAFAEL CASTRO DE MATOS DESPACHO AO CARTORIO PARA ADOCAO DAS SEGUINTES PROVIDENCIAS: 1. OFICIE-SE A POLICIA CIVIL DO ESTADO DE GOIAS PARA ENVIAR A ESTE JUIZO O PRONTUARIO CIVIL DE RAFAEL CASTRO DE MATOS, CPF 023.490.141-18, RG 5153142 -SPTC/GO; 2. INTIME-SE O REQUERENTE PARA JUNTAR, NO PRAZO DE QUINZE DIAS, O TITULO DE ELEITOR E O PASSAPORTE. APOS, VENHAM OS AUTOS CONCLUSOS PARA SENTENCA. BRASILIA/DF, DATA E HORA DA ASSINATURA DIGITAL. LUCIANA MARIA PIMENTEL GARCIA JUIZA DE DIREITO 4",
                    "PublishDate": "2023-07-04T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "RECEBIDOS OS AUTOS",
                    "PublishDate": "2023-06-30T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE PODER JUDICIARIO DA UNIAO TRIBUNAL DE JUSTICA DO DISTRITO FEDERAL E DOS TERRITORIOS VREGPUBDF VARA DE REGISTROS PUBLICOS DO DF NUMERO DO PROCESSO: 0703885-61.2023.8.07.0015 CLASSE JUDICIAL: RETIFICACAO OU SUPRIMENTO OU RESTAURACAO DE REGISTRO CIVIL (1682) REQUERENTE: RAFAEL CASTRO DE MATOS DESPACHO AO CARTORIO PARA ADOCAO DAS SEGUINTES PROVIDENCIAS: 1. OFICIE-SE A POLICIA CIVIL DO ESTADO DE GOIAS PARA ENVIAR A ESTE JUIZO O PRONTUARIO CIVIL DE RAFAEL CASTRO DE MATOS, CPF 023.490.141-18, RG 5153142 -SPTC/GO; 2. INTIME-SE O REQUERENTE PARA JUNTAR, NO PRAZO DE QUINZE DIAS, O TITULO DE ELEITOR E O PASSAPORTE. APOS, VENHAM OS AUTOS CONCLUSOS PARA SENTENCA. BRASILIA/DF, DATA E HORA DA ASSINATURA DIGITAL . LUCIANA MARIA PIMENTEL GARCIA JUIZA DE DIREITO 4 ASSINADO ELETRONICAMENTE POR: LUCIANA MARIA PIMENTEL GARCIA 30/06/2023 16:05:23 HTTPS://PJE.TJDFT.JUS.BR/CONSULTAPUBLICA/PROCESSO/CONSULTADOCUMENTO/LISTVIEW.SEAM ID DO DOCUMENTO: 23063016052334200000150603413",
                    "PublishDate": "2023-06-30T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "CONCLUSOS PARA JULGAMENTO PARA JUIZ(A) LUCIANA MARIA PIMENTEL GARCIA",
                    "PublishDate": "2023-06-28T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "JUNTADA DE PETICAO DE MANIFESTACAO DO MPDFT",
                    "PublishDate": "2023-06-26T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "EXPEDICAO DE OUTROS DOCUMENTOS.",
                    "PublishDate": "2023-06-12T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "EXPEDICAO DE PORTARIA.",
                    "PublishDate": "2023-06-12T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "JUNTADA DE PETICAO DE PETICAO",
                    "PublishDate": "2023-06-05T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "PUBLICADO PORTARIA EM 15/05/2023.",
                    "PublishDate": "2023-05-15T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "DISPONIBILIZADO NO DJ ELETRONICO EM 12/05/2023",
                    "PublishDate": "2023-05-12T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "PODER JUDICIARIO DA UNIAO TRIBUNAL DE JUSTICA DO DISTRITO FEDERAL E DOS TERRITORIOS VARA DE REGISTROS P?BLICOS DO DF NUMERO DO PROCESSO: 0703885-61.2023.8.07.0015 CERTIDAO DE DISPONIBILIZACAO DJE O A TO JUDICIAL PORTARIA ID 158247816 FOI DISPONIBILIZADO NO DIARIO DA JUSTICA ELETRONICO (DJE) EM 12/05/2023, E SERA PUBLICADO NO PRIMEIRO DIA UTIL SUBSEQUENTE . 12 DE MAIO DE 2023 ASSINADO ELETRONICAMENTE POR: USUARIO DO SISTEMA 12/05/2023 00:35:36 USUARIO DO SISTEMA 12/05/2023 00:35:36 HTTPS://PJE.TJDFT.JUS.BR/CONSULTAPUBLICA/PROCESSO/CONSULTADOCUMENTO/LISTVIEW.SEAM ID DO DOCUMENTO: 158412574 23051200353603800000145770665",
                    "PublishDate": "2023-05-12T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "EXPEDICAO DE PORTARIA.",
                    "PublishDate": "2023-05-10T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "JUNTADA DE PETICAO DE PETICAO",
                    "PublishDate": "2023-05-05T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "JUNTADA DE PETICAO DE MANIFESTACAO DO MPDFT",
                    "PublishDate": "2023-05-05T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "EXPEDICAO DE OUTROS DOCUMENTOS.",
                    "PublishDate": "2023-05-02T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "EXPEDICAO DE PORTARIA.",
                    "PublishDate": "2023-05-02T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "JUNTADA DE PETICAO DE PETICAO",
                    "PublishDate": "2023-04-27T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "PUBLICADO PORTARIA EM 12/04/2023.",
                    "PublishDate": "2023-04-12T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "DISPONIBILIZADO NO DJ ELETRONICO EM 11/04/2023",
                    "PublishDate": "2023-04-11T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "PODER JUDICIARIO DA UNIAO TRIBUNAL DE JUSTICA DO DISTRITO FEDERAL E DOS TERRITORIOS VARA DE REGISTROS P?BLICOS DO DF NUMERO DO PROCESSO: 0703885-61.2023.8.07.0015 CERTIDAO DE DISPONIBILIZACAO DJE O A TO JUDICIAL PORTARIA ID 154730914 FOI DISPONIBILIZADO NO DIARIO DA JUSTICA ELETRONICO (DJE) EM 11/04/2023, E SERA PUBLICADO NO PRIMEIRO DIA UTIL SUBSEQUENTE . 11 DE ABRIL DE 2023 ASSINADO ELETRONICAMENTE POR: USUARIO DO SISTEMA 11/04/2023 00:56:43 USUARIO DO SISTEMA 11/04/2023 00:56:43 HTTPS://PJE.TJDFT.JUS.BR/CONSULTAPUBLICA/PROCESSO/CONSULTADOCUMENTO/LISTVIEW.SEAM ID DO DOCUMENTO: 155063601 23041100564347400000142796533",
                    "PublishDate": "2023-04-11T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "EXPEDICAO DE PORTARIA.",
                    "PublishDate": "2023-04-04T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "JUNTADA DE PETICAO DE MANIFESTACAO DO MPDFT",
                    "PublishDate": "2023-03-31T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "EXPEDICAO DE OUTROS DOCUMENTOS.",
                    "PublishDate": "2023-03-23T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "EXPEDICAO DE PORTARIA.",
                    "PublishDate": "2023-03-23T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "JUNTADA DE CERTIDAO PODER JUDICIARIO DA UNIAO TRIBUNAL DE JUSTICA DO DISTRITO FEDERAL E DOS TERRITORIOS VREGPUBDF VARA DE REGISTROS PUBLICOS DO DF NUMERO DO PROCESSO: 0703885-61.2023.8.07.0015 CLASSE JUDICIAL: RETIFICACAO OU SUPRIMENTO OU RESTAURACAO DE REGISTRO CIVIL (1682) REQUERENTE: RAFAEL CASTRO DE MATOS CERTIDAO CERTIFICO E DOU FE QUE ANEXEI INI EM NOME DO(A) REQUERENTE. BRASILIA, DF, 23 DE MARCO DE 2023 15:06:14. DANIEL SERPA OLIVEIRA SERVIDOR GERAL ASSINADO ELETRONICAMENTE POR: DANIEL SERPA OLIVEIRA 23/03/2023 15:06:55 HTTPS://PJE.TJDFT.JUS.BR/CONSULTAPUBLICA/PROCESSO/CONSULTADOCUMENTO/LISTVIEW.SEAM ID DO DOCUMENTO: 23032315065520800000141285344",
                    "PublishDate": "2023-03-23T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "JUNTADA DE PETICAO DE PETICAO",
                    "PublishDate": "2023-03-20T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "PUBLICADO DESPACHO EM 28/02/2023. PODER JUDICIARIO DA UNIAO TRIBUNAL DE JUSTICA DO DISTRITO FEDERAL E DOS TERRITORIOS VREGPUBDF VARA DE REGISTROS PUBLICOS DO DF NUMERO DO PROCESSO: 0703885-61.2023.8.07.0015 CLASSE JUDICIAL: RETIFICACAO OU SUPRIMENTO OU RESTAURACAO DE REGISTRO CIVIL (1682) REQUERENTE: RAFAEL CASTRO DE MATOS DESPACHO CUIDA-SE DE PEDIDO DE ALTERACAO DE NOME FORMULADO POR RAFAEL CASTRO DE MATOS PARA SE CHAMAR RAFAEL STARK. O ARTIGO 57,  6 DA LEI DE REGISTROS PUBLICOS FOI REVOGADO PELA LEI 14.382/2022. NAO MAIS TRAMITAM EM SEGREDO DE JUSTICA AS ACOES REFERENTES A MUDANCA DE NOME. RETIRE-SE, POIS, O SIGILO. VENHAM AOS AUTOS AS SEGUINTES CERTIDOES EM NOME DO REQUERENTE: 1. NASCIMENTO E CASAMENTO; 2. UNIFICADA DE PROTESTO (ESTA PODE SER OBTIDA POR MEIO DO LINK: HTTPS://CENTRALDECERTIDOESDF.COM.BR/CERTIDAO-PUBLICA/PEDIDO/); 3. JUSTICA MILITAR (CRIMES MILITARES); 4. NEGATIVA OU POSITIVA DE DEBITOS TRIBUTARIOS DISTRITAIS (HTTPS://WW1.RECEITA.FAZENDA.DF.GOV.BR/CIDADAO/CERTIDOES/CERTIDAO). PRAZO: 15 DIAS. APOS A JUNTADA DOS DOCUMENTOS, EXPECA-SE CERTIDAO DO INI EM NOME DO REQUERENTE. TUDO CUMPRIDO, DE-SE VISTA AO MINISTERIO PUBLICO. BRASILIA/DF, DATA E HORA DA ASSINATURA DIGITAL . LUCIANA MARIA PIMENTEL GARCIA JUIZA DE DIREITO 7 ASSINADO ELETRONICAMENTE POR: LUCIANA MARIA PIMENTEL GARCIA 24/02/2023 13:20:11 HTTPS://PJE.TJDFT.JUS.BR/CONSULTAPUBLICA/PROCESSO/CONSULTADOCUMENTO/LISTVIEW.SEAM ID DO DOCUMENTO: 23022413201159600000138616934",
                    "PublishDate": "2023-02-28T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "DISPONIBILIZADO NO DJ ELETRONICO EM 27/02/2023 PODER JUDICIARIO DA UNIAO TRIBUNAL DE JUSTICA DO DISTRITO FEDERAL E DOS TERRITORIOS VREGPUBDF VARA DE REGISTROS PUBLICOS DO DF NUMERO DO PROCESSO: 0703885-61.2023.8.07.0015 CLASSE JUDICIAL: RETIFICACAO OU SUPRIMENTO OU RESTAURACAO DE REGISTRO CIVIL (1682) REQUERENTE: RAFAEL CASTRO DE MATOS DESPACHO CUIDA-SE DE PEDIDO DE ALTERACAO DE NOME FORMULADO POR RAFAEL CASTRO DE MATOS PARA SE CHAMAR RAFAEL STARK. O ARTIGO 57,  6 DA LEI DE REGISTROS PUBLICOS FOI REVOGADO PELA LEI 14.382/2022. NAO MAIS TRAMITAM EM SEGREDO DE JUSTICA AS ACOES REFERENTES A MUDANCA DE NOME. RETIRE-SE, POIS, O SIGILO. VENHAM AOS AUTOS AS SEGUINTES CERTIDOES EM NOME DO REQUERENTE: 1. NASCIMENTO E CASAMENTO; 2. UNIFICADA DE PROTESTO (ESTA PODE SER OBTIDA POR MEIO DO LINK: HTTPS://CENTRALDECERTIDOESDF.COM.BR/CERTIDAO-PUBLICA/PEDIDO/); 3. JUSTICA MILITAR (CRIMES MILITARES); 4. NEGATIVA OU POSITIVA DE DEBITOS TRIBUTARIOS DISTRITAIS (HTTPS://WW1.RECEITA.FAZENDA.DF.GOV.BR/CIDADAO/CERTIDOES/CERTIDAO). PRAZO: 15 DIAS. APOS A JUNTADA DOS DOCUMENTOS, EXPECA-SE CERTIDAO DO INI EM NOME DO REQUERENTE. TUDO CUMPRIDO, DE-SE VISTA AO MINISTERIO PUBLICO. BRASILIA/DF, DATA E HORA DA ASSINATURA DIGITAL . LUCIANA MARIA PIMENTEL GARCIA JUIZA DE DIREITO 7 ASSINADO ELETRONICAMENTE POR: LUCIANA MARIA PIMENTEL GARCIA 24/02/2023 13:20:11 HTTPS://PJE.TJDFT.JUS.BR/CONSULTAPUBLICA/PROCESSO/CONSULTADOCUMENTO/LISTVIEW.SEAM ID DO DOCUMENTO: 23022413201159600000138616934",
                    "PublishDate": "2023-02-28T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "RECEBIDOS OS AUTOS",
                    "PublishDate": "2023-02-24T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE PODER JUDICIARIO DA UNIAO TRIBUNAL DE JUSTICA DO DISTRITO FEDERAL E DOS TERRITORIOS VREGPUBDF VARA DE REGISTROS PUBLICOS DO DF NUMERO DO PROCESSO: 0703885-61.2023.8.07.0015 CLASSE JUDICIAL: RETIFICACAO OU SUPRIMENTO OU RESTAURACAO DE REGISTRO CIVIL (1682) REQUERENTE: RAFAEL CASTRO DE MATOS DESPACHO CUIDA-SE DE PEDIDO DE ALTERACAO DE NOME FORMULADO POR RAFAEL CASTRO DE MATOS PARA SE CHAMAR RAFAEL STARK. O ARTIGO 57,  6 DA LEI DE REGISTROS PUBLICOS FOI REVOGADO PELA LEI 14.382/2022. NAO MAIS TRAMITAM EM SEGREDO DE JUSTICA AS ACOES REFERENTES A MUDANCA DE NOME. RETIRE-SE, POIS, O SIGILO. VENHAM AOS AUTOS AS SEGUINTES CERTIDOES EM NOME DO REQUERENTE: 1. NASCIMENTO E CASAMENTO; 2. UNIFICADA DE PROTESTO (ESTA PODE SER OBTIDA POR MEIO DO LINK: HTTPS://CENTRALDECERTIDOESDF.COM.BR/CERTIDAO-PUBLICA/PEDIDO/); 3. JUSTICA MILITAR (CRIMES MILITARES); 4. NEGATIVA OU POSITIVA DE DEBITOS TRIBUTARIOS DISTRITAIS (HTTPS://WW1.RECEITA.FAZENDA.DF.GOV.BR/CIDADAO/CERTIDOES/CERTIDAO). PRAZO: 15 DIAS. APOS A JUNTADA DOS DOCUMENTOS, EXPECA-SE CERTIDAO DO INI EM NOME DO REQUERENTE. TUDO CUMPRIDO, DE-SE VISTA AO MINISTERIO PUBLICO. BRASILIA/DF, DATA E HORA DA ASSINATURA DIGITAL . LUCIANA MARIA PIMENTEL GARCIA JUIZA DE DIREITO 7 ASSINADO ELETRONICAMENTE POR: LUCIANA MARIA PIMENTEL GARCIA 24/02/2023 13:20:11 HTTPS://PJE.TJDFT.JUS.BR/CONSULTAPUBLICA/PROCESSO/CONSULTADOCUMENTO/LISTVIEW.SEAM ID DO DOCUMENTO: 23022413201159600000138616934",
                    "PublishDate": "2023-02-24T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  },
                  {
                    "Content": "DISTRIBUIDO POR SORTEIO",
                    "PublishDate": "2023-02-23T00:00:00",
                    "CaptureDate": "2023-11-02T04:48:28"
                  }
                ],
                "Petitions": [],
                "Decisions": [
                  {
                    "DecisionContent": "ACOLHO O PARECER DO MINISTERIO PUBLICO E, COM FUNDAMENTO NOS ARTIGOS 56, 57 E 109, TODOS DA LEI 6.015/73, DEFIRO O PEDIDO PARA ALTERAR O REGISTRO DE NASCIMENTO DE RAFAEL CASTRO DE MATOS, ID152919968, PAGINA 2, E NELE FAZER CONSTAR QUE O REGISTRADO SE CHAMA RAFAEL STARK, INALTERADOS OS DEMAIS DADOS.",
                    "DecisionDate": "2023-08-22T00:00:00"
                  },
                  {
                    "DecisionContent": "ACOLHO O PARECER DO MINISTERIO PUBLICO E, COM FUNDAMENTO NOS ARTIGOS 56, 57 E 109, TODOS DA LEI 6.015/73, DEFIRO O PEDIDO PARA ALTERAR O REGISTRO DE NASCIMENTO DE RAFAEL CASTRO DE MATOS, ID152919968, PAGINA 2, E NELE FAZER CONSTAR QUE O REGISTRADO SE CHAMA RAFAEL STARK, INALTERADOS OS DEMAIS DADOS.",
                    "DecisionDate": "2023-08-21T00:00:00"
                  },
                  {
                    "DecisionContent": "ACOLHO O PARECER DO MINISTERIO PUBLICO E, COM FUNDAMENTO NOS ARTIGOS 56, 57 E 109, TODOS DA LEI 6.015/73, DEFIRO O PEDIDO PARA ALTERAR O REGISTRO DE NASCIMENTO DE RAFAEL CASTRO DE MATOS, ID152919968, PAGINA 2, E NELE FAZER CONSTAR QUE O REGISTRADO SE CHAMA RAFAEL STARK, INALTERADOS OS DEMAIS DADOS.",
                    "DecisionDate": "2023-08-17T00:00:00"
                  },
                  {
                    "DecisionContent": "ACOLHO O PARECER DO MINISTERIO PUBLICO E, COM FUNDAMENTO NOS ARTIGOS 56, 57 E 109, TODOS DA LEI 6.015/73, DEFIRO O PEDIDO PARA ALTERAR O REGISTRO DE NASCIMENTO DE RAFAEL CASTRO DE MATOS, ID152919968, PAGINA 2, E NELE FAZER CONSTAR QUE O REGISTRADO SE CHAMA RAFAEL STARK, INALTERADOS OS DEMAIS DADOS.",
                    "DecisionDate": "2023-08-17T00:00:00"
                  }
                ]
              },
              {
                "Number": "10093557620218260100",
                "Type": "CUMPRIMENTO DE SENTENCA",
                "MainSubject": "CAUSAS SUPERVENIENTES A SENTENCA",
                "CourtName": "TJSP",
                "CourtLevel": "1",
                "CourtType": "CIVEL",
                "CourtDistrict": "SAO PAULO",
                "JudgingBody": "5 VARA CIVEL - FORO CENTRAL CIVEL",
                "State": "SP",
                "Status": "ARQUIVADO",
                "LawsuitHostService": "ESAJ",
                "InferredCNJSubjectName": "CAUSAS SUPERVENIENTES À SENTENÇA",
                "InferredCNJSubjectNumber": 9517,
                "InferredCNJProcedureTypeName": "CUMPRIMENTO DE SENTENÇA",
                "InferredBroadCNJSubjectName": "DIREITO PROCESSUAL CIVIL E DO TRABALHO",
                "InferredBroadCNJSubjectNumber": 8826,
                "OtherSubjects": [
                  "CAUSAS SUPERVENIENTES A SENTENCA"
                ],
                "NumberOfVolumes": 0,
                "NumberOfPages": 0,
                "Value": 425.76,
                "ResJudicataDate": "2021-03-01T00:00:00",
                "CloseDate": "2021-03-01T00:00:00",
                "RedistributionDate": "0001-01-01T00:00:00",
                "PublicationDate": "2021-02-17T00:00:00",
                "NoticeDate": "2021-02-02T00:00:00",
                "LastMovementDate": "2021-03-01T00:00:00",
                "CaptureDate": "2021-03-17T18:06:10",
                "LastUpdate": "2021-03-17T18:06:10",
                "NumberOfParties": 3,
                "NumberOfUpdates": 8,
                "LawSuitAge": 27,
                "AverageNumberOfUpdatesPerMonth": 0,
                "ReasonForConcealedData": 0,
                "Parties": [
                  {
                    "Doc": "08883063000145",
                    "IsPartyActive": true,
                    "Name": "NEIVA DE LIMA, ZANICOTTI  ADVOGADOS",
                    "Polarity": "ACTIVE",
                    "Type": "CLAIMANT",
                    "PartyDetails": {
                      "SpecificType": "EXEQTE"
                    },
                    "LastCaptureDate": "2021-03-17T18:06:10"
                  },
                  {
                    "Doc": "40247570915",
                    "IsPartyActive": true,
                    "Name": "GABRIEL ANTONIO HENKE NEIVA DE LIMA FILHO",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "420786",
                      "State": "SP",
                      "SpecificType": "ADVOGADO (EXEQTE)"
                    },
                    "LastCaptureDate": "2021-03-17T18:06:10"
                  },
                  {
                    "Doc": "02349014118",
                    "IsPartyActive": true,
                    "Name": "RAFAEL CASTRO DE MATOS",
                    "Polarity": "PASSIVE",
                    "Type": "CLAIMED",
                    "PartyDetails": {
                      "SpecificType": "EXECTDO"
                    },
                    "LastCaptureDate": "2021-03-17T18:06:10"
                  }
                ],
                "Updates": [
                  {
                    "Content": "TRANSITO EM JULGADO AS PARTES - COM BAIXA",
                    "PublishDate": "2021-03-01T00:00:00",
                    "CaptureDate": "2021-03-17T18:06:10"
                  },
                  {
                    "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.21.40277187-8 TIPO DA PETICAO: PETICAO INTERMEDIARIA DATA: 25/02/2021 15:31",
                    "PublishDate": "2021-02-25T00:00:00",
                    "CaptureDate": "2021-03-17T18:06:10"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0027/2021 DATA DA DISPONIBILIZACAO: 17/02/2021 DATA DA PUBLICACAO: 18/02/2021 NUMERO DO DIARIO: 3219 PAGINA: 527-535",
                    "PublishDate": "2021-02-17T00:00:00",
                    "CaptureDate": "2021-03-17T18:06:10"
                  },
                  {
                    "Content": "PROCESSO 1009355-76.2021.8.26.0100 - CUMPRIMENTO DE SENTENCA - CAUSAS SUPERVENIENTES A SENTENCA - NEIVA DE LIMA, ZANICOTTI ADVOGADOS - DETERMINO O CANCELAMENTO DA DISTRIBUICAO. PROVIDENCIE O EXEQUENTE NOVO PETICIONAMENTO ELETRONICO DO CUMPRIMENTO DE SENTENCA, DESTA VEZ COMO PETICAO INTERMEDIARIA (NAO PETICAO INICIAL), A FIM DE QUE SEJA CORRETAMENTE CADASTRADO COMO INCIDENTE DO PROCESSO PRINCIPAL, NOS TERMOS DO COMUNICADO CG N. 1789/2017. - ADV: GABRIEL ANTONIO HENKE NEIVA DE LIMA FILHO (OAB 420786/SP)",
                    "PublishDate": "2021-02-17T00:00:00",
                    "CaptureDate": "2021-03-17T18:06:10"
                  },
                  {
                    "Content": "REMETIDO AO DJE | RELACAO: 0027/2021 TEOR DO ATO: DETERMINO O CANCELAMENTO DA DISTRIBUICAO. PROVIDENCIE O EXEQUENTE NOVO PETICIONAMENTO ELETRONICO DO CUMPRIMENTO DE SENTENCA, DESTA VEZ COMO PETICAO INTERMEDIARIA (NAO PETICAO INICIAL), A FIM DE QUE SEJA CORRETAMENTE CADASTRADO COMO INCIDENTE DO PROCESSO PRINCIPAL, NOS TERMOS DO COMUNICADO CG N. 1789/2017. ADVOGADOS(S): GABRIEL ANTONIO HENKE NEIVA DE LIMA FILHO (OAB 420786/SP)",
                    "PublishDate": "2021-02-16T00:00:00",
                    "CaptureDate": "2021-03-17T18:06:10"
                  },
                  {
                    "Content": "DECISAO | DETERMINO O CANCELAMENTO DA DISTRIBUICAO. PROVIDENCIE O EXEQUENTE NOVO PETICIONAMENTO ELETRONICO DO CUMPRIMENTO DE SENTENCA, DESTA VEZ COMO PETICAO INTERMEDIARIA (NAO PETICAO INICIAL), A FIM DE QUE SEJA CORRETAMENTE CADASTRADO COMO INCIDENTE DO PROCESSO PRINCIPAL, NOS TERMOS DO COMUNICADO CG N. 1789/2017.",
                    "PublishDate": "2021-02-11T00:00:00",
                    "CaptureDate": "2021-03-17T18:06:10"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO",
                    "PublishDate": "2021-02-03T00:00:00",
                    "CaptureDate": "2021-03-17T18:06:10"
                  },
                  {
                    "Content": "DISTRIBUIDO POR DEPENDENCIA (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR) | ARTIGO 523, CAPUT DO CPC",
                    "PublishDate": "2021-02-02T00:00:00",
                    "CaptureDate": "2021-03-17T18:06:10"
                  }
                ],
                "Petitions": [
                  {
                    "Type": "PETICAO INTERMEDIARIA",
                    "Author": "",
                    "CreationDate": "2021-02-25T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  }
                ],
                "Decisions": []
              },
              {
                "Number": "00107719620218260100",
                "Type": "CUMPRIMENTO DE SENTENCA",
                "MainSubject": "PRODUTO IMPROPRIO",
                "CourtName": "TJSP",
                "CourtLevel": "1",
                "CourtType": "CIVEL",
                "CourtDistrict": "SAO PAULO",
                "JudgingBody": "5 VARA CIVEL - FORO CENTRAL CIVEL",
                "State": "SP",
                "Status": "INDEFINIDO",
                "LawsuitHostService": "ESAJ",
                "InferredCNJSubjectName": "PRODUTO IMPRÓPRIO",
                "InferredCNJSubjectNumber": 11867,
                "InferredCNJProcedureTypeName": "CUMPRIMENTO DE SENTENÇA",
                "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
                "InferredBroadCNJSubjectNumber": 1156,
                "OtherSubjects": [
                  "PRODUTO IMPROPRIO"
                ],
                "NumberOfVolumes": 0,
                "NumberOfPages": 0,
                "Value": -1,
                "ResJudicataDate": "0001-01-01T00:00:00",
                "CloseDate": "0001-01-01T00:00:00",
                "RedistributionDate": "0001-01-01T00:00:00",
                "PublicationDate": "2021-04-30T00:00:00",
                "NoticeDate": "2021-03-16T00:00:00",
                "LastMovementDate": "2021-05-31T00:00:00",
                "CaptureDate": "2021-05-03T13:00:58",
                "LastUpdate": "2021-05-03T13:00:58",
                "NumberOfParties": 8,
                "NumberOfUpdates": 30,
                "LawSuitAge": 1079,
                "AverageNumberOfUpdatesPerMonth": 0,
                "ReasonForConcealedData": 0,
                "Parties": [
                  {
                    "Doc": "08883063000145",
                    "IsPartyActive": true,
                    "Name": "NEIVA DE LIMA, ZANICOTTI  ADVOGADOS",
                    "Polarity": "ACTIVE",
                    "Type": "CLAIMANT",
                    "PartyDetails": {
                      "SpecificType": "EXEQTE"
                    },
                    "LastCaptureDate": "2021-05-03T13:00:58"
                  },
                  {
                    "Doc": "02349014118",
                    "IsPartyActive": true,
                    "Name": "RAFAEL CASTRO DE MATOS",
                    "Polarity": "PASSIVE",
                    "Type": "CLAIMED",
                    "PartyDetails": {
                      "SpecificType": "EXECTDO"
                    },
                    "LastCaptureDate": "2021-05-03T13:00:58"
                  },
                  {
                    "Doc": "40247570915",
                    "IsPartyActive": true,
                    "Name": "GABRIEL ANTONIO HENKE NEIVA DE LIMA FILHO",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "420786",
                      "State": "SP",
                      "SpecificType": "ADVOGADO (EXEQTE)"
                    },
                    "LastCaptureDate": "2021-05-03T13:00:58"
                  },
                  {
                    "Doc": "04859002970",
                    "IsPartyActive": true,
                    "Name": "TIAGO GODOY ZANICOTTI",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "437516",
                      "State": "SP",
                      "SpecificType": "ADVOGADO (EXEQTE)"
                    },
                    "LastCaptureDate": "2021-05-03T13:00:58"
                  },
                  {
                    "Doc": "35068411817",
                    "IsPartyActive": true,
                    "Name": "RAFAEL HIDEO NAZIMA",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "295443",
                      "State": "SP",
                      "SpecificType": "ADVOGADO (EXECTDO)"
                    },
                    "LastCaptureDate": "2021-05-03T13:00:58"
                  },
                  {
                    "Doc": "40247570915",
                    "IsPartyActive": true,
                    "Name": "GABRIEL ANTONIO HENKE NEIVA DE LIMA FILHO",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "420786",
                      "State": "SP",
                      "SpecificType": "ADVOGADO (EXEQTE)"
                    },
                    "LastCaptureDate": "2021-05-03T13:00:58"
                  },
                  {
                    "Doc": "04859002970",
                    "IsPartyActive": true,
                    "Name": "TIAGO GODOY ZANICOTTI",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "437516",
                      "State": "SP",
                      "SpecificType": "ADVOGADO (EXEQTE)"
                    },
                    "LastCaptureDate": "2021-05-03T13:00:58"
                  },
                  {
                    "Doc": "35068411817",
                    "IsPartyActive": true,
                    "Name": "RAFAEL HIDEO NAZIMA",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "295443",
                      "State": "SP",
                      "SpecificType": "ADVOGADO (EXECTDO)"
                    },
                    "LastCaptureDate": "2021-05-03T13:00:58"
                  }
                ],
                "Updates": [
                  {
                    "Content": "ARQUIVADO DEFINITIVAMENTE | SENTENCA FL. 32",
                    "PublishDate": "2021-05-31T00:00:00",
                    "CaptureDate": "2021-06-02T16:16:42"
                  },
                  {
                    "Content": "TRANSITO EM JULGADO AS PARTES - COM BAIXA",
                    "PublishDate": "2021-05-31T00:00:00",
                    "CaptureDate": "2021-06-02T16:16:42"
                  },
                  {
                    "Content": "CERTIDAO DE TRANSITO EM JULGADO COM BAIXA EXPEDIDA | CERTIDAO - TRANSITO EM JULGADO COM BAIXA - PROCESSO DIGITAL",
                    "PublishDate": "2021-05-31T00:00:00",
                    "CaptureDate": "2021-06-02T16:16:42"
                  },
                  {
                    "Content": "RECIBO JUNTADO",
                    "PublishDate": "2021-05-31T00:00:00",
                    "CaptureDate": "2021-06-02T16:16:42"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0106/2021 DATA DA DISPONIBILIZACAO: 27/05/2021 DATA DA PUBLICACAO: 28/05/2021 NUMERO DO DIARIO: 3287 PAGINA: 861-871",
                    "PublishDate": "2021-05-27T00:00:00",
                    "CaptureDate": "2021-06-02T16:16:42"
                  },
                  {
                    "Content": "PROCESSO 0010771-96.2021.8.26.0100 (PROCESSO PRINCIPAL 1068275-14.2019.8.26.0100) - CUMPRIMENTO DE SENTENCA - PRODUTO IMPROPRIO - NEIVA DE LIMA, ZANICOTTI ADVOGADOS - RAFAEL CASTRO DE MATOS - ATO ORDINATORIO: ANTE A MANIFESTACAO DE FLS. 36, CIENCIA A PARTE EXEQUENTE COM RELACAO AO HISTORICO JUNTADO A FLS. 37.. - ADV: GABRIEL ANTONIO HENKE NEIVA DE LIMA FILHO (OAB 420786/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP), TIAGO GODOY ZANICOTTI (OAB 437516/SP)",
                    "PublishDate": "2021-05-27T00:00:00",
                    "CaptureDate": "2021-06-02T16:16:42"
                  },
                  {
                    "Content": "REMETIDO AO DJE | RELACAO: 0106/2021 TEOR DO ATO: ATO ORDINATORIO: \"ANTE A MANIFESTACAO DE FLS. 36, CIENCIA A PARTE EXEQUENTE COM RELACAO AO HISTORICO JUNTADO A FLS. 37.\". ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP), GABRIEL ANTONIO HENKE NEIVA DE LIMA FILHO (OAB 420786/SP), TIAGO GODOY ZANICOTTI (OAB 437516/SP)",
                    "PublishDate": "2021-05-26T00:00:00",
                    "CaptureDate": "2021-06-02T16:16:42"
                  },
                  {
                    "Content": "ATO ORDINATORIO - PUBLICAVEL | ATO ORDINATORIO: \"ANTE A MANIFESTACAO DE FLS. 36, CIENCIA A PARTE EXEQUENTE COM RELACAO AO HISTORICO JUNTADO A FLS. 37.\".",
                    "PublishDate": "2021-05-25T00:00:00",
                    "CaptureDate": "2021-06-02T16:16:42"
                  },
                  {
                    "Content": "RECIBO JUNTADO",
                    "PublishDate": "2021-05-25T00:00:00",
                    "CaptureDate": "2021-06-02T16:16:42"
                  },
                  {
                    "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.21.40823022-4 TIPO DA PETICAO: PETICAO INTERMEDIARIA DATA: 21/05/2021 18:11",
                    "PublishDate": "2021-05-21T00:00:00",
                    "CaptureDate": "2021-06-02T16:16:42"
                  },
                  {
                    "Content": "CERTIDAO DE CARTORIO EXPEDIDA | CERTIDAO - GENERICA",
                    "PublishDate": "2021-04-30T00:00:00",
                    "CaptureDate": "2021-05-03T13:00:58"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0085/2021 DATA DA DISPONIBILIZACAO: 30/04/2021 DATA DA PUBLICACAO: 03/05/2021 NUMERO DO DIARIO: 3268 PAGINA: 64-72",
                    "PublishDate": "2021-04-30T00:00:00",
                    "CaptureDate": "2021-05-03T13:00:58"
                  },
                  {
                    "Content": "PROCESSO 0010771-96.2021.8.26.0100 (PROCESSO PRINCIPAL 1068275-14.2019.8.26.0100) - CUMPRIMENTO DE SENTENCA - PRODUTO IMPROPRIO - NEIVA DE LIMA, ZANICOTTI ADVOGADOS - RAFAEL CASTRO DE MATOS - JULGO EXTINTA A EXECUCAO COM BASE NO ART.924, II, DO CODIGO DE PROCESSO CIVIL. EXPECA-SE GUIA DE LEVANTAMENTO EM FAVOR DA PARTE CREDORA. JUNTADA AOS AUTOS COMPROVACAO DO LEVANTAMENTO, ANOTE-SE A EXTINCAO E AO ARQUIVO. - ADV: GABRIEL ANTONIO HENKE NEIVA DE LIMA FILHO (OAB 420786/SP), TIAGO GODOY ZANICOTTI (OAB 437516/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2021-04-30T00:00:00",
                    "CaptureDate": "2021-05-03T13:00:58"
                  },
                  {
                    "Content": "REMETIDO AO DJE | RELACAO: 0085/2021 TEOR DO ATO: JULGO EXTINTA A EXECUCAO COM BASE NO ART.924, II, DO CODIGO DE PROCESSO CIVIL. EXPECA-SE GUIA DE LEVANTAMENTO EM FAVOR DA PARTE CREDORA. JUNTADA AOS AUTOS COMPROVACAO DO LEVANTAMENTO, ANOTE-SE A EXTINCAO E AO ARQUIVO. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP), GABRIEL ANTONIO HENKE NEIVA DE LIMA FILHO (OAB 420786/SP), TIAGO GODOY ZANICOTTI (OAB 437516/SP)",
                    "PublishDate": "2021-04-29T00:00:00",
                    "CaptureDate": "2021-05-03T13:00:58"
                  },
                  {
                    "Content": "CERTIDAO DE CARTORIO EXPEDIDA | CERTIDAO - CONFERENCIA - ADVOGADOS",
                    "PublishDate": "2021-04-27T00:00:00",
                    "CaptureDate": "2021-05-03T13:00:58"
                  },
                  {
                    "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.21.40646041-9 TIPO DA PETICAO: PETICAO INTERMEDIARIA DATA: 26/04/2021 15:01",
                    "PublishDate": "2021-04-26T00:00:00",
                    "CaptureDate": "2021-04-26T19:26:10"
                  },
                  {
                    "Content": "EXTINTA A EXECUCAO/CUMPRIMENTO DA SENTENCA PELA SATISFACAO DA OBRIGACAO | JULGO EXTINTA A EXECUCAO COM BASE NO ART.924, II, DO CODIGO DE PROCESSO CIVIL. EXPECA-SE GUIA DE LEVANTAMENTO EM FAVOR DA PARTE CREDORA. JUNTADA AOS AUTOS COMPROVACAO DO LEVANTAMENTO, ANOTE-SE A EXTINCAO E AO ARQUIVO.",
                    "PublishDate": "2021-04-26T00:00:00",
                    "CaptureDate": "2021-05-03T13:00:58"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO",
                    "PublishDate": "2021-04-26T00:00:00",
                    "CaptureDate": "2021-05-03T13:00:58"
                  },
                  {
                    "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.21.40646041-9 TIPO DA PETICAO: PETICAO INTERMEDIARIA DATA: 26/04/2021 15:01",
                    "PublishDate": "2021-04-26T00:00:00",
                    "CaptureDate": "2021-05-03T13:00:58"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0074/2021 DATA DA DISPONIBILIZACAO: 16/04/2021 DATA DA PUBLICACAO: 19/04/2021 NUMERO DO DIARIO: 3259 PAGINA: 58-67",
                    "PublishDate": "2021-04-16T00:00:00",
                    "CaptureDate": "2021-04-26T19:26:10"
                  },
                  {
                    "Content": "PROCESSO 0010771-96.2021.8.26.0100 (PROCESSO PRINCIPAL 1068275-14.2019.8.26.0100) - CUMPRIMENTO DE SENTENCA - PRODUTO IMPROPRIO - NEIVA DE LIMA, ZANICOTTI ADVOGADOS - RAFAEL CASTRO DE MATOS - ATO ORDINATORIO: CIENCIA A PARTE EXEQUENTE COM RELACAO AO PAGAMENTO NOTICIADO A FLS. 24/27, DEVENDO ESCLARECER SE COM O LEVANTAMENTO OUTORGA QUITACAO A DIVIDA, BEM COMO APRESENTAR NOS AUTOS O RESPECTIVO FORMULARIO MLE.. - ADV: TIAGO GODOY ZANICOTTI (OAB 437516/SP), GABRIEL ANTONIO HENKE NEIVA DE LIMA FILHO (OAB 420786/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2021-04-16T00:00:00",
                    "CaptureDate": "2021-04-26T19:26:10"
                  },
                  {
                    "Content": "REMETIDO AO DJE | RELACAO: 0074/2021 TEOR DO ATO: ATO ORDINATORIO: \"CIENCIA A PARTE EXEQUENTE COM RELACAO AO PAGAMENTO NOTICIADO A FLS. 24/27, DEVENDO ESCLARECER SE COM O LEVANTAMENTO OUTORGA QUITACAO A DIVIDA, BEM COMO APRESENTAR NOS AUTOS O RESPECTIVO FORMULARIO MLE.\". ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP), GABRIEL ANTONIO HENKE NEIVA DE LIMA FILHO (OAB 420786/SP), TIAGO GODOY ZANICOTTI (OAB 437516/SP)",
                    "PublishDate": "2021-04-15T00:00:00",
                    "CaptureDate": "2021-04-26T19:26:10"
                  },
                  {
                    "Content": "ATO ORDINATORIO - PUBLICAVEL | ATO ORDINATORIO: \"CIENCIA A PARTE EXEQUENTE COM RELACAO AO PAGAMENTO NOTICIADO A FLS. 24/27, DEVENDO ESCLARECER SE COM O LEVANTAMENTO OUTORGA QUITACAO A DIVIDA, BEM COMO APRESENTAR NOS AUTOS O RESPECTIVO FORMULARIO MLE.\".",
                    "PublishDate": "2021-04-13T00:00:00",
                    "CaptureDate": "2021-04-26T19:26:10"
                  },
                  {
                    "Content": "PEDIDO DE EXTINCAO - OBRIGACAO SATISFEITA (ART. 924, II, DO CPC) | N PROTOCOLO: WJMJ.21.40563662-9 TIPO DA PETICAO: PEDIDO DE EXTINCAO (ART. 924, II, DO CPC) DATA: 12/04/2021 23:49",
                    "PublishDate": "2021-04-13T00:00:00",
                    "CaptureDate": "2021-04-26T19:26:10"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0055/2021 DATA DA DISPONIBILIZACAO: 23/03/2021 DATA DA PUBLICACAO: 24/03/2021 NUMERO DO DIARIO: 3243 PAGINA: 106-118",
                    "PublishDate": "2021-03-23T00:00:00",
                    "CaptureDate": "2021-04-04T21:02:15"
                  },
                  {
                    "Content": "PROCESSO 0010771-96.2021.8.26.0100 (PROCESSO PRINCIPAL 1068275-14.2019.8.26.0100) - CUMPRIMENTO DE SENTENCA - PRODUTO IMPROPRIO - NEIVA DE LIMA, ZANICOTTI ADVOGADOS - RAFAEL CASTRO DE MATOS - FICA CADA PARTE DEVEDORA INTIMADA, NA PESSOA DO ADVOGADO VIA DJSP, A PAGAR O VALOR INDICADO PELA PARTE CREDORA, DEVIDAMENTE ATUALIZADO, EM QUINZE DIAS. - ADV: TIAGO GODOY ZANICOTTI (OAB 437516/SP), GABRIEL ANTONIO HENKE NEIVA DE LIMA FILHO (OAB 420786/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2021-03-23T00:00:00",
                    "CaptureDate": "2021-04-04T21:02:15"
                  },
                  {
                    "Content": "REMETIDO AO DJE | RELACAO: 0055/2021 TEOR DO ATO: FICA CADA PARTE DEVEDORA INTIMADA, NA PESSOA DO ADVOGADO VIA DJSP, A PAGAR O VALOR INDICADO PELA PARTE CREDORA, DEVIDAMENTE ATUALIZADO, EM QUINZE DIAS. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP), GABRIEL ANTONIO HENKE NEIVA DE LIMA FILHO (OAB 420786/SP), TIAGO GODOY ZANICOTTI (OAB 437516/SP)",
                    "PublishDate": "2021-03-22T00:00:00",
                    "CaptureDate": "2021-04-04T21:02:15"
                  },
                  {
                    "Content": "DECISAO | FICA CADA PARTE DEVEDORA INTIMADA, NA PESSOA DO ADVOGADO VIA DJSP, A PAGAR O VALOR INDICADO PELA PARTE CREDORA, DEVIDAMENTE ATUALIZADO, EM QUINZE DIAS.",
                    "PublishDate": "2021-03-18T00:00:00",
                    "CaptureDate": "2021-04-04T21:02:15"
                  },
                  {
                    "Content": "CONCLUSOS PARA DESPACHO",
                    "PublishDate": "2021-03-17T00:00:00",
                    "CaptureDate": "2021-04-04T21:02:15"
                  },
                  {
                    "Content": "INICIO DA EXECUCAO JUNTADO | PROCESSO PRINCIPAL: 1068275-14.2019.8.26.0100",
                    "PublishDate": "2021-03-17T00:00:00",
                    "CaptureDate": "2021-04-04T21:02:15"
                  }
                ],
                "Petitions": [
                  {
                    "Type": "PEDIDO DE EXTINCAO (ART. 924, II, DO CPC)",
                    "Author": "",
                    "CreationDate": "2021-04-12T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  },
                  {
                    "Type": "PETICAO INTERMEDIARIA",
                    "Author": "",
                    "CreationDate": "2021-04-26T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  },
                  {
                    "Type": "PETICAO INTERMEDIARIA",
                    "Author": "",
                    "CreationDate": "2021-05-21T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  }
                ],
                "Decisions": [
                  {
                    "DecisionContent": "JULGO EXTINTA A EXECUCAO COM BASE NO ART.924, II, DO CODIGO DE PROCESSO CIVIL.",
                    "DecisionDate": "2021-04-30T00:00:00"
                  },
                  {
                    "DecisionContent": "JULGO EXTINTA A EXECUCAO COM BASE NO ART.924, II, DO CODIGO DE PROCESSO CIVIL.",
                    "DecisionDate": "2021-04-29T00:00:00"
                  },
                  {
                    "DecisionContent": "JULGO EXTINTA A EXECUCAO COM BASE NO ART.924, II, DO CODIGO DE PROCESSO CIVIL.",
                    "DecisionDate": "2021-04-26T00:00:00"
                  }
                ]
              },
              {
                "Number": "00172740220228260100",
                "Type": "CUMPRIMENTO DE SENTENCA",
                "MainSubject": "INDENIZACAO POR DANO MORAL",
                "CourtName": "TJSP",
                "CourtLevel": "1",
                "CourtType": "CIVEL",
                "CourtDistrict": "",
                "JudgingBody": "4 VARA CIVEL",
                "State": "SP",
                "Status": "INDEFINIDO",
                "LawsuitHostService": "ESAJ",
                "RelatedLawsuits": [
                  "1010478-46.2020.8.26.0100"
                ],
                "InferredCNJSubjectName": "INDENIZAÇÃO POR DANO MORAL",
                "InferredCNJSubjectNumber": 14010,
                "InferredCNJProcedureTypeName": "CUMPRIMENTO DE SENTENÇA",
                "InferredBroadCNJSubjectName": "DIREITO DO TRABALHO",
                "InferredBroadCNJSubjectNumber": 864,
                "OtherSubjects": [
                  "INDENIZACAO POR DANO MORAL"
                ],
                "NumberOfVolumes": 0,
                "NumberOfPages": 0,
                "Value": -1,
                "ResJudicataDate": "0001-01-01T00:00:00",
                "CloseDate": "0001-01-01T00:00:00",
                "RedistributionDate": "0001-01-01T00:00:00",
                "PublicationDate": "2022-06-06T00:00:00",
                "NoticeDate": "2022-04-28T00:00:00",
                "LastMovementDate": "2022-07-06T00:00:00",
                "CaptureDate": "2022-08-04T23:07:24",
                "LastUpdate": "2022-08-04T23:07:24",
                "NumberOfParties": 6,
                "NumberOfUpdates": 19,
                "LawSuitAge": 671,
                "AverageNumberOfUpdatesPerMonth": 0,
                "ReasonForConcealedData": 0,
                "Parties": [
                  {
                    "Doc": "08856681000104",
                    "IsPartyActive": true,
                    "Name": "NEXTEL TELECOMUNICACOES LTDA",
                    "Polarity": "ACTIVE",
                    "Type": "CLAIMANT",
                    "PartyDetails": {
                      "SpecificType": "EXEQTE"
                    },
                    "LastCaptureDate": "2022-08-04T23:07:24"
                  },
                  {
                    "Doc": "77857119768",
                    "IsPartyActive": true,
                    "Name": "JOAO THOMAZ PRAZERES GONDIM",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "270757",
                      "State": "SP",
                      "SpecificType": "ADVOGADO (EXEQTE)"
                    },
                    "LastCaptureDate": "2022-08-04T23:07:24"
                  },
                  {
                    "Doc": "09152582779",
                    "IsPartyActive": true,
                    "Name": "PATRICIA NABINGER DE ALMEIDA SENA",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "155004",
                      "State": "RJ",
                      "SpecificType": "ADVOGADA (EXEQTE)"
                    },
                    "LastCaptureDate": "2022-08-04T23:07:24"
                  },
                  {
                    "Doc": "11138152722",
                    "IsPartyActive": true,
                    "Name": "RODRIGO EMILIANO DA SILVA",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "172309",
                      "State": "RJ",
                      "SpecificType": "ADVOGADO (EXEQTE)"
                    },
                    "LastCaptureDate": "2022-08-04T23:07:24"
                  },
                  {
                    "Doc": "02349014118",
                    "IsPartyActive": true,
                    "Name": "RAFAEL CASTRO DE MATOS",
                    "Polarity": "PASSIVE",
                    "Type": "CLAIMED",
                    "PartyDetails": {
                      "SpecificType": "EXECTDO"
                    },
                    "LastCaptureDate": "2022-08-04T23:07:24"
                  },
                  {
                    "Doc": "35068411817",
                    "IsPartyActive": true,
                    "Name": "RAFAEL HIDEO NAZIMA",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "295443",
                      "State": "SP",
                      "SpecificType": "ADVOGADO (EXECTDO)"
                    },
                    "LastCaptureDate": "2022-08-04T23:07:24"
                  }
                ],
                "Updates": [
                  {
                    "Content": "DOCUMENTO JUNTADO",
                    "PublishDate": "2022-07-06T00:00:00",
                    "CaptureDate": "2022-08-04T23:07:24"
                  },
                  {
                    "Content": "CERTIDAO DE CARTORIO EXPEDIDA MLE - EXPEDIDO",
                    "PublishDate": "2022-07-06T00:00:00",
                    "CaptureDate": "2022-08-04T23:07:24"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0391/2022 DATA DA PUBLICACAO: 07/06/2022 NUMERO DO DIARIO: 3521",
                    "PublishDate": "2022-06-06T00:00:00",
                    "CaptureDate": "2022-08-04T23:07:24"
                  },
                  {
                    "Content": "PROCESSO 0017274-02.2022.8.26.0100 (APENSADO AO PROCESSO 1010478-46.2020.8.26.0100) (PROCESSO PRINCIPAL 1010478- 46.2020.8.26.0100) - CUMPRIMENTO DE SENTENCA - INDENIZACAO POR DANO MORAL - NEXTEL TELECOMUNICACOES LTDA - RAFAEL CASTRO DE MATOS - VISTOS. DIANTE DA CONCORDANCIA DA EXEQUENTE COM O VALOR DEPOSITADO PELO EXECUTADO (FLS. 76), JULGO EXTINTO O PROCESSO MOVIDO POR NEXTEL TELECOMUNICACOES LTDA CONTRA RAFAEL CASTRO DE MATOS, COM FUNDAMENTO NO ARTIGO 924, INCISO II, DO CODIGO DE PROCESSO CIVIL. INEXISTINDO INTERESSE RECURSAL, VERIFICA-SE DESDE LOGO O TRANSITO EM JULGADO, EXPEDINDO-SE MANDADO DE LEVANTAMENTO EM FAVOR DA PARTE EXEQUENTE (FLS. 68). APOS, ARQUIVEM-SE OS AUTOS, COM AS CAUTELAS DE PRAXE. PUBLIQUE-SE, REGISTRE-SE E INTIME-SE. - ADV: RAFAEL HIDEO NAZIMA (OAB 295443/SP), PATRICIA NABINGER DE ALMEIDA SENA (OAB 155004/RJ), JOAO THOMAZ PRAZERES GONDIM (OAB 270757/SP), RODRIGO EMILIANO DA SILVA (OAB 172309/RJ)",
                    "PublishDate": "2022-06-06T00:00:00",
                    "CaptureDate": "2022-08-04T23:07:24"
                  },
                  {
                    "Content": "REMETIDO AO DJE RELACAO: 0391/2022 TEOR DO ATO: VISTOS. DIANTE DA CONCORDANCIA DA EXEQUENTE COM O VALOR DEPOSITADO PELO EXECUTADO (FLS. 76), JULGO EXTINTO O PROCESSO MOVIDO POR NEXTEL TELECOMUNICACOES LTDA CONTRA RAFAEL CASTRO DE MATOS, COM FUNDAMENTO NO ARTIGO 924, INCISO II, DO CODIGO DE PROCESSO CIVIL. INEXISTINDO INTERESSE RECURSAL, VERIFICA-SE DESDE LOGO O TRANSITO EM JULGADO, EXPEDINDO-SE MANDADO DE LEVANTAMENTO EM FAVOR DA PARTE EXEQUENTE (FLS. 68). APOS, ARQUIVEM-SE OS AUTOS, COM AS CAUTELAS DE PRAXE. PUBLIQUE-SE, REGISTRE-SE E INTIME-SE. ADVOGADOS(S): JOAO THOMAZ PRAZERES GONDIM (OAB 270757/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP), PATRICIA NABINGER DE ALMEIDA SENA (OAB 155004/RJ), RODRIGO EMILIANO DA SILVA (OAB 172309/RJ)",
                    "PublishDate": "2022-06-03T00:00:00",
                    "CaptureDate": "2022-08-04T23:07:24"
                  },
                  {
                    "Content": "CONCLUSOS PARA SENTENCA",
                    "PublishDate": "2022-06-02T00:00:00",
                    "CaptureDate": "2022-08-04T23:07:24"
                  },
                  {
                    "Content": "EXTINTA A EXECUCAO/CUMPRIMENTO DA SENTENCA PELA SATISFACAO DA OBRIGACAO VISTOS. DIANTE DA CONCORDANCIA DA EXEQUENTE COM O VALOR DEPOSITADO PELO EXECUTADO (FLS. 76), JULGO EXTINTO O PROCESSO MOVIDO POR NEXTEL TELECOMUNICACOES LTDA CONTRA RAFAEL CASTRO DE MATOS, COM FUNDAMENTO NO ARTIGO 924, INCISO II, DO CODIGO DE PROCESSO CIVIL. INEXISTINDO INTERESSE RECURSAL, VERIFICA-SE DESDE LOGO O TRANSITO EM JULGADO, EXPEDINDO-SE MANDADO DE LEVANTAMENTO EM FAVOR DA PARTE EXEQUENTE (FLS. 68). APOS, ARQUIVEM-SE OS AUTOS, COM AS CAUTELAS DE PRAXE. PUBLIQUE-SE, REGISTRE-SE E INTIME-SE.",
                    "PublishDate": "2022-06-02T00:00:00",
                    "CaptureDate": "2022-08-04T23:07:24"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0379/2022 DATA DA PUBLICACAO: 02/06/2022 NUMERO DO DIARIO: 3518",
                    "PublishDate": "2022-06-01T00:00:00",
                    "CaptureDate": "2022-08-04T23:07:24"
                  },
                  {
                    "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.22.40904674-6 TIPO DA PETICAO: PETICAO INTERMEDIARIA DATA: 01/06/2022 16:04",
                    "PublishDate": "2022-06-01T00:00:00",
                    "CaptureDate": "2022-08-04T23:07:24"
                  },
                  {
                    "Content": "REMETIDO AO DJE RELACAO: 0379/2022 TEOR DO ATO: EM DEZ DIAS, MANIFESTE-SE A PARTE EXEQUENTE SOBRE O VALOR DEPOSITADO PELA PARTE EXECUTADA (FLS. 67/74), SOB PENA DE PRESUMIR-SE DO SILENCIO ANUENCIA COM A SATISFACAO DA FASE DE CUMPRIMENTO DE SENTENCA, POR CONTA DA SATISFACAO DE SEU CREDITO. ADVOGADOS(S): JOAO THOMAZ PRAZERES GONDIM (OAB 270757/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP), PATRICIA NABINGER DE ALMEIDA SENA (OAB 155004/RJ), RODRIGO EMILIANO DA SILVA (OAB 172309/RJ)",
                    "PublishDate": "2022-05-31T00:00:00",
                    "CaptureDate": "2022-08-04T23:07:24"
                  },
                  {
                    "Content": "ATO ORDINATORIO EM DEZ DIAS, MANIFESTE-SE A PARTE EXEQUENTE SOBRE O VALOR DEPOSITADO PELA PARTE EXECUTADA (FLS. 67/74), SOB PENA DE PRESUMIR-SE DO SILENCIO ANUENCIA COM A SATISFACAO DA FASE DE CUMPRIMENTO DE SENTENCA, POR CONTA DA SATISFACAO DE SEU CREDITO.",
                    "PublishDate": "2022-05-30T00:00:00",
                    "CaptureDate": "2022-08-04T23:07:24"
                  },
                  {
                    "Content": "PEDIDO DE EXTINCAO - OBRIGACAO SATISFEITA (ART. 924, II, DO CPC) N PROTOCOLO: WJMJ.22.40877587-6 TIPO DA PETICAO: PEDIDO DE EXTINCAO (ART. 924, II, DO CPC) DATA: 27/05/2022 23:49",
                    "PublishDate": "2022-05-27T00:00:00",
                    "CaptureDate": "2022-08-04T23:07:24"
                  },
                  {
                    "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0288/2022 DATA DA PUBLICACAO: 06/05/2022 NUMERO DO DIARIO: 3499",
                    "PublishDate": "2022-05-05T00:00:00",
                    "CaptureDate": "2022-08-04T23:07:24"
                  },
                  {
                    "Content": "REMETIDO AO DJE RELACAO: 0288/2022 TEOR DO ATO: VISTOS. TENDO EM VISTA O TRANSITO EM JULGADO (FLS. 13), TORNANDO-SE DEFINITIVA A EXECUCAO, INTIME-SE A PARTE EXECUTADA (RAFAEL CASTRO DE MATOS), NA PESSOA DO PATRONO CONSTITUIDO NOS AUTOS, PARA, CONSOANTE AO ARTIGO 523, CAPUT, DO CODIGO DE PROCESSO CIVIL, EFETUAR, NO PRAZO DE QUINZE DIAS, O PAGAMENTO DO MONTANTE ATUALIZADO DO DEBITO (R$ 2.072,37, A INCIDIR ATUALIZACAO MONETARIA E ENCARGOS MORATORIOS A CONTAR DO MES DE ABRIL/2022), SOB PENA DE INCIDENCIA DE MULTA NA RAZAO DE 10% (DEZ POR CENTO) E DE HONORARIOS ADVOCATICIOS DE 10%, NOS TERMOS DE SEU  1, OBSERVANDO-SE QUE, EM CASO DE PAGAMENTO PARCIAL, A MULTA E OS HONORARIOS INCIDIRAO SOBRE O RESTANTE (ART. 523,  2, DO CPC). SUPERADO O PRAZO ASSINALADO PARA CUMPRIMENTO DA OBRIGACAO, APRESENTE O EXEQUENTE, NO PRAZO DE DEZ DIAS, SOB PENA DE EXTINCAO, DEMONSTRATIVO ATUALIZADO DO DEBITO, COM A INCIDENCIA DA MULTA NA RAZAO DE 10% (DEZ POR CENTO) E DOS HONORARIOS ADVOCATICIOS DE 10% (DEZ POR CENTO), ALEM DO MONTANTE DE 1%, A TITULO DE TAXA JUDICIARIA, EM CONSONANCIA AO ARTIGO 4O, INCISO III, DA LEI ESTADUAL NO 11.608/03, SOB PENA DA PARTE EXEQUENTE SUPORTAR SEU PAGAMENTO, POR OCASIAO DE SUA SATISFACAO, INDICANDO, AINDA, BENS DO EXECUTADO PASSIVEIS DE PENHORA, COM OBSERVANCIA DA ORDEM PREVISTA NO ARTIGO 835 DO CODIGO DE PROCESSO CIVIL. FICA O EXECUTADO TAMBEM INTIMADO A OFERECER IMPUGNACAO AO CUMPRIMENTO DE SENTENCA, SALIENTANDO-SE QUE NOS TERMOS DO ARTIGO 525 DO CODIGO DE PROCESSO CIVIL \"TRANSCORRIDO O PRAZO PREVISTO NO ART. 523 SEM O PAGAMENTO VOLUNTARIO, INICIA-SE O PRAZO DE 15 (QUINZE) DIAS PARA QUE O EXECUTADO, INDEPENDENTEMENTE DE PENHORA OU NOVA INTIMACAO, APRESENTE, NOS PROPRIOS AUTOS, SUA IMPUGNACAO\", OBSERVANDO-SE QUE \"SERA CONSIDERADO TEMPESTIVO O ATO PRATICADO ANTES DO TERMO INICIAL DO PRAZO\" (CPC, ARTIGO 218,  4). NO SILENCIO, INCONTINENTI, AO ARQUIVO. INTIME-SE. ADVOGADOS(S): JOAO THOMAZ PRAZERES GONDIM (OAB 270757/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP), PATRICIA NABINGER DE ALMEIDA SENA (OAB 155004/RJ), RODRIGO EMILIANO DA SILVA (OAB 172309/RJ)",
                    "PublishDate": "2022-05-03T00:00:00",
                    "CaptureDate": "2022-08-04T23:07:24"
                  },
                  {
                    "Content": "CONCLUSOS PARA DECISAO",
                    "PublishDate": "2022-05-02T00:00:00",
                    "CaptureDate": "2022-08-04T23:07:24"
                  },
                  {
                    "Content": "PROFERIDAS OUTRAS DECISOES NAO ESPECIFICADAS VISTOS. TENDO EM VISTA O TRANSITO EM JULGADO (FLS. 13), TORNANDO-SE DEFINITIVA A EXECUCAO, INTIME-SE A PARTE EXECUTADA (RAFAEL CASTRO DE MATOS), NA PESSOA DO PATRONO CONSTITUIDO NOS AUTOS, PARA, CONSOANTE AO ARTIGO 523, CAPUT, DO CODIGO DE PROCESSO CIVIL, EFETUAR, NO PRAZO DE QUINZE DIAS, O PAGAMENTO DO MONTANTE ATUALIZADO DO DEBITO (R$ 2.072,37, A INCIDIR ATUALIZACAO MONETARIA E ENCARGOS MORATORIOS A CONTAR DO MES DE ABRIL/2022), SOB PENA DE INCIDENCIA DE MULTA NA RAZAO DE 10% (DEZ POR CENTO) E DE HONORARIOS ADVOCATICIOS DE 10%, NOS TERMOS DE SEU  1, OBSERVANDO-SE QUE, EM CASO DE PAGAMENTO PARCIAL, A MULTA E OS HONORARIOS INCIDIRAO SOBRE O RESTANTE (ART. 523,  2, DO CPC). SUPERADO O PRAZO ASSINALADO PARA CUMPRIMENTO DA OBRIGACAO, APRESENTE O EXEQUENTE, NO PRAZO DE DEZ DIAS, SOB PENA DE EXTINCAO, DEMONSTRATIVO ATUALIZADO DO DEBITO, COM A INCIDENCIA DA MULTA NA RAZAO DE 10% (DEZ POR CENTO) E DOS HONORARIOS ADVOCATICIOS DE 10% (DEZ POR CENTO), ALEM DO MONTANTE DE 1%, A TITULO DE TAXA JUDICIARIA, EM CONSONANCIA AO ARTIGO 4O, INCISO III, DA LEI ESTADUAL NO 11.608/03, SOB PENA DA PARTE EXEQUENTE SUPORTAR SEU PAGAMENTO, POR OCASIAO DE SUA SATISFACAO, INDICANDO, AINDA, BENS DO EXECUTADO PASSIVEIS DE PENHORA, COM OBSERVANCIA DA ORDEM PREVISTA NO ARTIGO 835 DO CODIGO DE PROCESSO CIVIL. FICA O EXECUTADO TAMBEM INTIMADO A OFERECER IMPUGNACAO AO CUMPRIMENTO DE SENTENCA, SALIENTANDO-SE QUE NOS TERMOS DO ARTIGO 525 DO CODIGO DE PROCESSO CIVIL \"TRANSCORRIDO O PRAZO PREVISTO NO ART. 523 SEM O PAGAMENTO VOLUNTARIO, INICIA-SE O PRAZO DE 15 (QUINZE) DIAS PARA QUE O EXECUTADO, INDEPENDENTEMENTE DE PENHORA OU NOVA INTIMACAO, APRESENTE, NOS PROPRIOS AUTOS, SUA IMPUGNACAO\", OBSERVANDO-SE QUE \"SERA CONSIDERADO TEMPESTIVO O ATO PRATICADO ANTES DO TERMO INICIAL DO PRAZO\" (CPC, ARTIGO 218,  4). NO SILENCIO, INCONTINENTI, AO ARQUIVO. INTIME-SE.VENCIMENTO: 13/06/2022",
                    "PublishDate": "2022-05-02T00:00:00",
                    "CaptureDate": "2022-08-04T23:07:24"
                  },
                  {
                    "Content": "INICIO DA EXECUCAO JUNTADO PROCESSO PRINCIPAL: 1010478-46.2020.8.26.0100",
                    "PublishDate": "2022-04-29T00:00:00",
                    "CaptureDate": "2022-08-04T23:07:24"
                  },
                  {
                    "Content": "APENSADO AO PROCESSO APENSADO AO PROCESSO 1010478-46.2020.8.26.0100 - CLASSE: PROCEDIMENTO COMUM CIVEL - ASSUNTO PRINCIPAL: INDENIZACAO POR DANO MORAL",
                    "PublishDate": "2022-04-29T00:00:00",
                    "CaptureDate": "2022-08-04T23:07:24"
                  },
                  {
                    "Content": "CONCLUSOS PARA DESPACHO",
                    "PublishDate": "2022-04-29T00:00:00",
                    "CaptureDate": "2022-08-04T23:07:24"
                  }
                ],
                "Petitions": [
                  {
                    "Type": "PEDIDO DE EXTINCAO (ART. 924, II, DO CPC)",
                    "Author": "",
                    "CreationDate": "2022-05-27T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  },
                  {
                    "Type": "PETICAO INTERMEDIARIA",
                    "Author": "",
                    "CreationDate": "2022-06-01T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  }
                ],
                "Decisions": [
                  {
                    "DecisionContent": "JULGO EXTINTO O PROCESSO MOVIDO POR NEXTEL TELECOMUNICACOES LTDA CONTRA RAFAEL CASTRO DE MATOS, COM FUNDAMENTO NO ARTIGO 924, INCISO II, DO CODIGO DE PROCESSO CIVIL.",
                    "DecisionDate": "2022-06-06T00:00:00"
                  },
                  {
                    "DecisionContent": "JULGO EXTINTO O PROCESSO MOVIDO POR NEXTEL TELECOMUNICACOES LTDA CONTRA RAFAEL CASTRO DE MATOS, COM FUNDAMENTO NO ARTIGO 924, INCISO II, DO CODIGO DE PROCESSO CIVIL.",
                    "DecisionDate": "2022-06-03T00:00:00"
                  },
                  {
                    "DecisionContent": "JULGO EXTINTO O PROCESSO MOVIDO POR NEXTEL TELECOMUNICACOES LTDA CONTRA RAFAEL CASTRO DE MATOS, COM FUNDAMENTO NO ARTIGO 924, INCISO II, DO CODIGO DE PROCESSO CIVIL.",
                    "DecisionDate": "2022-06-02T00:00:00"
                  }
                ]
              },
              {
                "Number": "10682751420198260100",
                "Type": "APELACAO CIVEL",
                "MainSubject": "DIREITO CIVIL - OBRIGACOES - ESPECIES DE CONTRATOS - COMPRA E VENDA",
                "CourtName": "TJSP",
                "CourtLevel": "2",
                "CourtType": "CIVEL",
                "CourtDistrict": "SAO PAULO",
                "Judge": "ROSANGELA MARIA TELLES",
                "JudgingBody": "27 CAMARA DE DIREITO PRIVADO",
                "State": "SP",
                "Status": "ARQUIVADO",
                "LawsuitHostService": "ESAJ",
                "InferredCNJSubjectName": "COMPRA E VENDA",
                "InferredCNJSubjectNumber": 9587,
                "InferredCNJProcedureTypeName": "APELAÇÃO CÍVEL",
                "InferredBroadCNJSubjectName": "DIREITO CIVIL",
                "InferredBroadCNJSubjectNumber": 899,
                "OtherSubjects": [
                  "DIREITO CIVIL - OBRIGACOES - ESPECIES DE CONTRATOS - COMPRA E VENDA"
                ],
                "NumberOfVolumes": 0,
                "NumberOfPages": 0,
                "Value": 10554,
                "ResJudicataDate": "0001-01-01T00:00:00",
                "CloseDate": "2020-11-23T00:00:00",
                "RedistributionDate": "0001-01-01T00:00:00",
                "PublicationDate": "2021-03-09T00:00:00",
                "NoticeDate": "2020-09-25T00:00:00",
                "LastMovementDate": "2020-11-23T00:00:00",
                "CaptureDate": "2021-03-14T06:19:25",
                "LastUpdate": "2021-03-14T06:19:25",
                "NumberOfParties": 6,
                "NumberOfUpdates": 25,
                "LawSuitAge": 59,
                "AverageNumberOfUpdatesPerMonth": 0,
                "ReasonForConcealedData": 0,
                "Parties": [
                  {
                    "Doc": "08852415840",
                    "IsPartyActive": true,
                    "Name": "ROSANGELA MARIA TELLES",
                    "Polarity": "NEUTRAL",
                    "Type": "REPORTER",
                    "PartyDetails": {
                      "SpecificType": "JUIZ"
                    },
                    "LastCaptureDate": "2021-03-14T06:19:25"
                  },
                  {
                    "Doc": "02349014118",
                    "IsPartyActive": true,
                    "Name": "RAFAEL CASTRO DE MATOS",
                    "Polarity": "ACTIVE",
                    "Type": "CLAIMANT",
                    "PartyDetails": {
                      "SpecificType": "APELANTE"
                    },
                    "LastCaptureDate": "2021-03-14T06:19:25"
                  },
                  {
                    "Doc": "12043596001915",
                    "IsPartyActive": true,
                    "Name": "AQUILON TELECOMUNICACOES LTDA",
                    "Polarity": "PASSIVE",
                    "Type": "CLAIMED",
                    "PartyDetails": {
                      "SpecificType": "APELADO"
                    },
                    "LastCaptureDate": "2021-03-14T06:19:25"
                  },
                  {
                    "Doc": "35068411817",
                    "IsPartyActive": true,
                    "Name": "RAFAEL HIDEO NAZIMA",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "295443",
                      "State": "SP",
                      "SpecificType": "ADVOGADO (APELANTE)"
                    },
                    "LastCaptureDate": "2021-03-14T06:19:25"
                  },
                  {
                    "Doc": "40247570915",
                    "IsPartyActive": true,
                    "Name": "GABRIEL ANTONIO HENKE NEIVA DE LIMA FILHO",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "420786",
                      "State": "SP",
                      "SpecificType": "ADVOGADO (APELADO)"
                    },
                    "LastCaptureDate": "2021-03-14T06:19:25"
                  },
                  {
                    "Doc": "04859002970",
                    "IsPartyActive": true,
                    "Name": "TIAGO GODOY ZANICOTTI",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "437516",
                      "State": "SP",
                      "SpecificType": "ADVOGADO (APELADO)"
                    },
                    "LastCaptureDate": "2021-03-14T06:19:25"
                  }
                ],
                "Updates": [
                  {
                    "Content": "EXPEDIDO CERTIDAO DE BAIXA DE RECURSO | CERTIDAO DE BAIXA DE RECURSO - [DIGITAL]",
                    "PublishDate": "2020-11-23T00:00:00",
                    "CaptureDate": "2021-03-14T02:01:36"
                  },
                  {
                    "Content": "BAIXA DEFINITIVA",
                    "PublishDate": "2020-11-23T00:00:00",
                    "CaptureDate": "2021-03-14T02:01:36"
                  },
                  {
                    "Content": "EXPEDIDO CERTIDAO DE BAIXA DE RECURSO | TRANSITO EM JULGADO DIRETO_27 CAMARA_DIGITAL",
                    "PublishDate": "2020-11-23T00:00:00",
                    "CaptureDate": "2021-03-14T02:01:36"
                  },
                  {
                    "Content": "TRANSITO EM JULGADO | TRANSITOU EM JULGADO EM 17/11/2020",
                    "PublishDate": "2020-11-23T00:00:00",
                    "CaptureDate": "2021-03-14T02:01:36"
                  },
                  {
                    "Content": "PUBLICADO EM | DISPONIBILIZADO EM 22/10/2020 TIPO DE PUBLICACAO: INTIMACAO DE ACORDAO NUMERO DO DIARIO ELETRONICO: 3153",
                    "PublishDate": "2020-10-23T00:00:00",
                    "CaptureDate": "2021-03-14T02:01:36"
                  },
                  {
                    "Content": "PRAZO",
                    "PublishDate": "2020-10-22T00:00:00",
                    "CaptureDate": "2021-03-14T02:01:36"
                  },
                  {
                    "Content": "EXPEDIDO CERTIDAO | CERTIDAO DE PUBLICACAO DE ACORDAO [DIGITAL]",
                    "PublishDate": "2020-10-22T00:00:00",
                    "CaptureDate": "2021-03-14T02:01:36"
                  },
                  {
                    "Content": "PROCESSO ENCAMINHADO PARA O PROCESSAMENTO DE GRUPOS E CAMARAS PARA INTIMACAO DO ACORDAO - JULGAMENTO VIRTUAL",
                    "PublishDate": "2020-10-20T00:00:00",
                    "CaptureDate": "2021-03-14T02:01:36"
                  },
                  {
                    "Content": "ACORDAO REGISTRADO | ACORDAO REGISTRADO SOB N 20200000856695, COM 5 FOLHAS.",
                    "PublishDate": "2020-10-20T00:00:00",
                    "CaptureDate": "2021-03-14T02:01:36"
                  },
                  {
                    "Content": "JULGADO VIRTUALMENTE | NEGARAM PROVIMENTO AO RECURSO. V. U.",
                    "PublishDate": "2020-10-20T00:00:00",
                    "CaptureDate": "2021-03-14T02:01:36"
                  },
                  {
                    "Content": "PETICAO INTERMEDIARIA JUNTADA | N PROTOCOLO: WPRO.20.01221401-9 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 19/10/2020 18:04",
                    "PublishDate": "2020-10-19T00:00:00",
                    "CaptureDate": "2021-03-14T02:01:36"
                  },
                  {
                    "Content": "EXPEDIDO TERMO | TERMO DE JUNTADA - AUTOMATICA",
                    "PublishDate": "2020-10-19T00:00:00",
                    "CaptureDate": "2021-03-14T02:01:36"
                  },
                  {
                    "Content": "JULGAMENTO VIRTUAL INICIADO",
                    "PublishDate": "2020-10-17T00:00:00",
                    "CaptureDate": "2021-03-14T02:01:36"
                  },
                  {
                    "Content": "PETICAO INTERMEDIARIA JUNTADA | N PROTOCOLO: WPRO.20.01214162-3 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 16/10/2020 20:29",
                    "PublishDate": "2020-10-16T00:00:00",
                    "CaptureDate": "2021-03-14T02:01:36"
                  },
                  {
                    "Content": "EXPEDIDO TERMO | TERMO DE JUNTADA - AUTOMATICA",
                    "PublishDate": "2020-10-16T00:00:00",
                    "CaptureDate": "2021-03-14T02:01:36"
                  },
                  {
                    "Content": "PUBLICADO EM | DISPONIBILIZADO EM 08/10/2020 TIPO DE PUBLICACAO: DISTRIBUIDOS NUMERO DO DIARIO ELETRONICO: 3144",
                    "PublishDate": "2020-10-09T00:00:00",
                    "CaptureDate": "2021-03-14T02:01:36"
                  },
                  {
                    "Content": "PETICAO INTERMEDIARIA JUNTADA | N PROTOCOLO: WPRO.20.01170884-0 TIPO DA PETICAO: NAO HA INTERESSE NA CONCILIACAO DATA: 07/10/2020 18:28",
                    "PublishDate": "2020-10-07T00:00:00",
                    "CaptureDate": "2021-03-14T02:01:36"
                  },
                  {
                    "Content": "EXPEDIDO TERMO | TERMO DE JUNTADA - AUTOMATICA",
                    "PublishDate": "2020-10-07T00:00:00",
                    "CaptureDate": "2021-03-14T02:01:36"
                  },
                  {
                    "Content": "CONCLUSOS PARA O RELATOR (EXPEDIDO TERMO COM CONCLUSAO) | ROSANGELA TELLES",
                    "PublishDate": "2020-10-07T00:00:00",
                    "CaptureDate": "2021-03-14T02:01:36"
                  },
                  {
                    "Content": "DISTRIBUICAO POR SORTEIO | ORGAO JULGADOR: 42 - 27 CAMARA DE DIREITO PRIVADO RELATOR: 13576 - ROSANGELA TELLES",
                    "PublishDate": "2020-10-06T00:00:00",
                    "CaptureDate": "2021-03-14T02:01:36"
                  },
                  {
                    "Content": "PUBLICADO EM | DISPONIBILIZADO EM 29/09/2020 TIPO DE PUBLICACAO: ENTRADOS NUMERO DO DIARIO ELETRONICO: 3137",
                    "PublishDate": "2020-09-30T00:00:00",
                    "CaptureDate": "2021-03-14T02:01:36"
                  },
                  {
                    "Content": "PROCESSO ENCAMINHADO PARA A DISTRIBUICAO DE RECURSOS",
                    "PublishDate": "2020-09-25T00:00:00",
                    "CaptureDate": "2021-03-14T02:01:36"
                  },
                  {
                    "Content": "PROCESSO CADASTRADO | SJ 2.1.3 - SERVICO DE ENTRADA DE AUTOS DE DIREITO PRIVADO 3",
                    "PublishDate": "2020-09-25T00:00:00",
                    "CaptureDate": "2021-03-14T02:01:36"
                  },
                  {
                    "Content": "PROCESSO ENCAMINHADO PARA OUTRA SECAO | MOTIVO: . SECAO ANTERIOR: FEITOS EM GRAU DE RECURSO - TRIAGEM SUBSECAO ANTERIOR: FEITOS EM GRAU DE RECURSO - TRIAGEM SECAO ATUAL: DIREITO PRIVADO SUBSECAO ATUAL: DIREITO PRIVADO 3",
                    "PublishDate": "2020-09-25T00:00:00",
                    "CaptureDate": "2021-03-14T02:01:36"
                  },
                  {
                    "Content": "RECEBIDOS OS AUTOS PELA ENTRADA DE RECURSOS | FORO DE ORIGEM: FORO CENTRAL CIVEL VARA DE ORIGEM: 5 VARA CIVEL",
                    "PublishDate": "2020-09-25T00:00:00",
                    "CaptureDate": "2021-03-14T02:01:36"
                  }
                ],
                "Petitions": [
                  {
                    "Type": "NAO HA INTERESSE NA CONCILIACAO",
                    "Author": "",
                    "CreationDate": "2020-10-07T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  },
                  {
                    "Type": "PETICOES DIVERSAS",
                    "Author": "",
                    "CreationDate": "2020-10-16T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  },
                  {
                    "Type": "PETICOES DIVERSAS",
                    "Author": "",
                    "CreationDate": "2020-10-19T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  }
                ],
                "Decisions": []
              },
              {
                "Number": "10104784620208260100",
                "Type": "APELACAO CIVEL",
                "MainSubject": "DIREITO DO CONSUMIDOR - CONTRATOS DE CONSUMO - TELEFONIA",
                "CourtName": "TJSP",
                "CourtLevel": "2",
                "CourtType": "CIVEL",
                "CourtDistrict": "SAO PAULO",
                "Judge": "ELOI ESTEVAO TROLY",
                "JudgingBody": "15 CAMARA DE DIREITO PRIVADO",
                "State": "SP",
                "Status": "ARQUIVADO",
                "LawsuitHostService": "ESAJ",
                "InferredCNJSubjectName": "TELEFONIA",
                "InferredCNJSubjectNumber": 7617,
                "InferredCNJProcedureTypeName": "APELAÇÃO CÍVEL",
                "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
                "InferredBroadCNJSubjectNumber": 1156,
                "OtherSubjects": [
                  "DIREITO DO CONSUMIDOR - CONTRATOS DE CONSUMO - TELEFONIA"
                ],
                "NumberOfVolumes": 0,
                "NumberOfPages": 0,
                "Value": 10167.16,
                "ResJudicataDate": "0001-01-01T00:00:00",
                "CloseDate": "2022-04-12T00:00:00",
                "RedistributionDate": "0001-01-01T00:00:00",
                "PublicationDate": "2022-04-19T00:00:00",
                "NoticeDate": "2021-11-08T00:00:00",
                "LastMovementDate": "2022-04-19T00:00:00",
                "CaptureDate": "2022-05-20T13:05:42",
                "LastUpdate": "2022-05-20T13:05:42",
                "NumberOfParties": 7,
                "NumberOfUpdates": 61,
                "LawSuitAge": 155,
                "AverageNumberOfUpdatesPerMonth": 2,
                "ReasonForConcealedData": 0,
                "Parties": [
                  {
                    "Doc": "03587317801",
                    "IsPartyActive": true,
                    "Name": "ELOI ESTEVAO TROLY",
                    "Polarity": "NEUTRAL",
                    "Type": "REPORTER",
                    "PartyDetails": {
                      "SpecificType": "JUIZ"
                    },
                    "LastCaptureDate": "2022-05-20T13:05:42"
                  },
                  {
                    "Doc": "08856681000104",
                    "IsPartyActive": true,
                    "Name": "NEXTEL TELECOMUNICACOES LTDA",
                    "Polarity": "ACTIVE",
                    "Type": "CLAIMANT",
                    "PartyDetails": {
                      "SpecificType": "APELANTE"
                    },
                    "LastCaptureDate": "2022-05-20T13:05:42"
                  },
                  {
                    "Doc": "02349014118",
                    "IsPartyActive": true,
                    "Name": "RAFAEL CASTRO DE MATOS",
                    "Polarity": "PASSIVE",
                    "Type": "CLAIMED",
                    "PartyDetails": {
                      "SpecificType": "APELADO"
                    },
                    "LastCaptureDate": "2022-05-20T13:05:42"
                  },
                  {
                    "Doc": "08746746897",
                    "IsPartyActive": true,
                    "Name": "JAIRO BRAZIL FONTES OLIVEIRA",
                    "Polarity": "NEUTRAL",
                    "Type": "JUDGE",
                    "PartyDetails": {
                      "SpecificType": "2"
                    },
                    "LastCaptureDate": "2022-05-20T13:05:42"
                  },
                  {
                    "IsPartyActive": true,
                    "Name": "VICENTINI BARROSO",
                    "Polarity": "NEUTRAL",
                    "Type": "JUDGE",
                    "PartyDetails": {
                      "SpecificType": "3"
                    },
                    "LastCaptureDate": "2022-05-20T13:05:42"
                  },
                  {
                    "Doc": "77857119768",
                    "IsPartyActive": true,
                    "Name": "JOAO THOMAZ PRAZERES GONDIM",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "270757",
                      "State": "SP",
                      "SpecificType": "ADVOGADO (APELANTE)"
                    },
                    "LastCaptureDate": "2022-05-20T13:05:42"
                  },
                  {
                    "Doc": "35068411817",
                    "IsPartyActive": true,
                    "Name": "RAFAEL HIDEO NAZIMA",
                    "Polarity": "NEUTRAL",
                    "Type": "LAWYER",
                    "PartyDetails": {
                      "OAB": "295443",
                      "State": "SP",
                      "SpecificType": "ADVOGADO (APELADO)"
                    },
                    "LastCaptureDate": "2022-05-20T13:05:42"
                  }
                ],
                "Updates": [
                  {
                    "Content": "PROCESSO 1010478-46.2020.8.26.0100 - PROCEDIMENTO COMUM CIVEL - INDENIZACAO POR DANO MORAL - RAFAEL CASTRO DE MATOS - NEXTEL TELECOMUNICACOES LTDA - CUMPRA-SE O V. ACORDAO, DEVENDO A PARTE VENCEDORA INSTAURAR INCIDENTE PARA INICIO DO CUMPRIMENTO, OBSERVANDO-SE, DESDE LOGO, SE TRATAR DE EXECUCAO DEFINITIVA, ANTE O TRANSITO EM JULGADO O CUMPRIMENTO DE SENTENCA DEVE PROCEDER DE FORMA ELETRONICA NOS TERMOS DO COMUNICADO CG N 438/2016, DEVENDO ACOMPANHAR EM ANEXO OS DOCUMENTOS MENCIONADOS NO CG N 16/2016, NA SEGUINTE ORDEM: PETICAO, SENTENCA, ACORDAO, CERTIDAO DE TRANSITO EM JULGADO, PROCURACOES E SE O CASO, DOCUMENTOS PERTINENTES AO PEDIDO DA FASE EXECUTIVA. RESSALTA-SE AINDA QUE, EM CONSONANCIA AOS ARTIGOS 509,  2, E 524 DO CODIGO DE PROCESSO CIVIL, O PLEITO DE CUMPRIMENTO DE SENTENCA NAO PRESCINDE DE DEMONSTRATIVO ATUALIZADO DO DEBITO. CASO A PARTE VENCIDA SEJA BENEFICIARIA DA JUSTICA GRATUITA, A EXECUCAO DOS HONORARIOS E DESPESAS PROCESSUAIS FICA SUJEITA A SUA ALTERACAO NESTA CONDICAO. APOS 5 DIAS DA PUBLICACAO DA CORRENTE, SERAO ESTES AUTOS ARQUIVADOS. - ADV: JOAO THOMAZ PRAZERES GONDIM (OAB 270757/SP), RODRIGO EMILIANO DA SILVA (OAB 172309/RJ), PATRICIA NABINGER DE ALMEIDA SENA (OAB 155004/RJ), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                    "PublishDate": "2022-04-19T00:00:00",
                    "CaptureDate": "2022-05-20T13:05:42"
                  },
                  {
                    "Content": "EXPEDIDO CERTIDAO DE BAIXA DE RECURSO | CERTIDAO DE BAIXA DE RECURSO - [DIGITAL]",
                    "PublishDate": "2022-04-12T00:00:00",
                    "CaptureDate": "2022-04-16T05:48:41"
                  },
                  {
                    "Content": "BAIXA DEFINITIVA",
                    "PublishDate": "2022-04-12T00:00:00",
                    "CaptureDate": "2022-04-16T05:48:41"
                  },
                  {
                    "Content": "EXPEDIDO CERTIDAO | CERTIDAO DE TRANSITO EM JULGADO [DIGITAL]",
                    "PublishDate": "2022-04-12T00:00:00",
                    "CaptureDate": "2022-04-16T05:48:41"
                  },
                  {
                    "Content": "EXPEDIDO CERTIDAO CERTIDAO DE TRANSITO EM JULGADO [DIGITAL]",
                    "PublishDate": "2022-04-12T00:00:00",
                    "CaptureDate": "2022-05-20T13:05:42"
                  },
                  {
                    "Content": "EXPEDIDO CERTIDAO DE BAIXA DE RECURSO CERTIDAO DE BAIXA DE RECURSO - [DIGITAL]",
                    "PublishDate": "2022-04-12T00:00:00",
                    "CaptureDate": "2022-05-20T13:05:42"
                  },
                  {
                    "Content": "PUBLICADO EM | DISPONIBILIZADO EM 15/03/2022 TIPO DE PUBLICACAO: INTIMACAO DE ACORDAO NUMERO DO DIARIO ELETRONICO: 3466",
                    "PublishDate": "2022-03-16T00:00:00",
                    "CaptureDate": "2022-04-16T05:48:41"
                  },
                  {
                    "Content": "PUBLICADO EM DISPONIBILIZADO EM 15/03/2022 TIPO DE PUBLICACAO: INTIMACAO DE ACORDAO NUMERO DO DIARIO ELETRONICO: 3466",
                    "PublishDate": "2022-03-16T00:00:00",
                    "CaptureDate": "2022-05-20T13:05:42"
                  },
                  {
                    "Content": "PRAZO",
                    "PublishDate": "2022-03-15T00:00:00",
                    "CaptureDate": "2022-04-16T05:48:41"
                  },
                  {
                    "Content": "EXPEDIDO CERTIDAO | CERTIDAO DE PUBLICACAO DE ACORDAO [DIGITAL]",
                    "PublishDate": "2022-03-15T00:00:00",
                    "CaptureDate": "2022-04-16T05:48:41"
                  },
                  {
                    "Content": "N 1010478-46.2020.8.26.0100 - PROCESSO DIGITAL. PETICOES PARA JUNTADA DEVEM SER APRESENTADAS EXCLUSIVAMENTE POR MEIO ELETRONICO, NOS TERMOS DO ARTIGO 7 DA RES. 551/2011 - APELACAO CIVEL - SAO PAULO - APELANTE: NEXTEL TELECOMUNICACOES LTDA - APELADO: RAFAEL CASTRO DE MATOS - MAGISTRADO(A) ELOI ESTEVAO TROLY - DERAM PROVIMENTO AO RECURSO. V. U. SUSTENTARAM ORALMENTE OS(AS) ADVOGADOS(AS) DE AMBAS AS PARTES, JULIANA VIEIRA BARBOSA BUSS OAB/DF 45.151 E RAFAEL HIDEO NAZIMA OAB/ SP 295.443 - APELACAO. ACAO DECLARATORIA DE INEXIGIBILIDADE DE DEBITO CUMULADA COM INDENIZATORIA POR DANO MORAL. SERVICOS DE TELEFONIA. SENTENCA DE PROCEDENCIA. RECURSO DA PARTE RE.1. DEBITO EXIGIVEL. A DOCUMENTACAO APRESENTADA PELA CONCESSIONARIA DE PRESTACAO DE SERVICOS DE TELEFONIA RE COMPROVA A CONTRATACAO E ORIGEM DO DEBITO. RELACAO DE CONSUMO QUE, POR SI SO, NAO AUTORIZA A AUTOMATICA PROCEDENCIA DA DEMANDA, CONSIDERANDO OS ELEMENTOS PROBATORIOS NOS AUTOS. PARTE AUTORA QUE NAO SE DESINCUMBIU DE SEU ONUS PROBATORIO (ART. 373, INC. I, DO CPC). NEGATIVACAO QUE REVELA EXERCICIO REGULAR DE DIREITO POR PARTE DA CREDORA (CC, ART. 188, I). DANOS MORAIS NAO CARACTERIZADOS POR FALTA DE ATO ILICITO OU PRESTACAO DE SERVICO DEFEITUOSO.2. LITIGANCIA DE MA-FE CARACTERIZADA. ALEGACAO DE DESCONHECIMENTO DE ORIGEM DA DIVIDA, DA QUAL ERA INEQUIVOCAMENTE SABEDOR, TAMPOUCO MUDOU SUA POSICAO (APELACAO) DEPOIS DAS PROVAS TRAZIDAS PELO REU EM CONTESTACAO.3. INEXISTENCIA DE INDICIOS CONCRETOS DE QUE SE ENQUADRE NA CATEGORIA DE ACAO MASSIVA E COM SINAL DE FINALIDADE FRAUDULENTA, CONFORME O MONITORAMENTO PELO NUCLEO DE MONITORAMENTO DE PERFIS DE DEMANDA (NUMOPEDE). SENTENCA DE PROCEDENCIA REFORMADA. ACAO IMPROCEDENTE. RECURSO PROVIDO. ART. 1007 CPC - EVENTUAL RECURSO - SE AO STJ: CUSTAS R$ 194,12 - (GUIA GRU NO SITE HTTP://WWW.STJ.JUS.BR) - RESOLUCAO N. 02 DE 02/01/2020 DO STJ; SE AO STF: CUSTAS R$ 214,71 - GUIA GRU - COBRANCA - FICHA DE COMPENSACAO - (EMITIDA ATRAVES DO SITE WWW.STF.JUS.BR) E PORTE DE REMESSA E RETORNO R$ 140,90 - GUIA FEDTJ - COD 140-6 - BANCO DO BRASIL OU INTERNET - RESOLUCAO N. 662 DE 10/02/2020 DO STF. OS VALORES REFERENTES AO PORTE DE REMESSA E RETORNO, NAO SE APLICAM AOS PROCESSOS ELETRONICOS, DE ACORDO COM O ART. 4, INCISO II, DA RESOLUCAO N. 662 DE 10/02/2020 DO STF. - ADVS: JOAO THOMAZ PRAZERES GONDIM (OAB: 270757/SP) - RAFAEL HIDEO NAZIMA (OAB: 295443/SP) - PATEO DO COLEGIO - SALAS 211/213",
                    "PublishDate": "2022-03-15T00:00:00",
                    "CaptureDate": "2022-04-16T05:48:41"
                  },
                  {
                    "Content": "N 1010478-46.2020.8.26.0100 - PROCESSO DIGITAL. PETICOES PARA JUNTADA DEVEM SER APRESENTADAS EXCLUSIVAMENTE POR MEIO ELETRONICO, NOS TERMOS DO ARTIGO 7 DA RES. 551/2011 - APELACAO CIVEL - SAO PAULO - APELANTE: NEXTEL TELECOMUNICACOES LTDA - APELADO: RAFAEL CASTRO DE MATOS - MAGISTRADO(A) ELOI ESTEVAO TROLY - DERAM PROVIMENTO AO RECURSO. V. U. SUSTENTARAM ORALMENTE OS(AS) ADVOGADOS(AS) DE AMBAS AS PARTES, JULIANA VIEIRA BARBOSA BUSS OAB/DF 45.151 E RAFAEL HIDEO NAZIMA OAB/ SP 295.443 - APELACAO. ACAO DECLARATORIA DE INEXIGIBILIDADE DE DEBITO CUMULADA COM INDENIZATORIA POR DANO MORAL. SERVICOS DE TELEFONIA. SENTENCA DE PROCEDENCIA. RECURSO DA PARTE RE.1. DEBITO EXIGIVEL. A DOCUMENTACAO APRESENTADA PELA CONCESSIONARIA DE PRESTACAO DE SERVICOS DE TELEFONIA RE COMPROVA A CONTRATACAO E ORIGEM DO DEBITO. RELACAO DE CONSUMO QUE, POR SI SO, NAO AUTORIZA A AUTOMATICA PROCEDENCIA DA DEMANDA, CONSIDERANDO OS ELEMENTOS PROBATORIOS NOS AUTOS. PARTE AUTORA QUE NAO SE DESINCUMBIU DE SEU ONUS PROBATORIO (ART. 373, INC. I, DO CPC). NEGATIVACAO QUE REVELA EXERCICIO REGULAR DE DIREITO POR PARTE DA CREDORA (CC, ART. 188, I). DANOS MORAIS NAO CARACTERIZADOS POR FALTA DE ATO ILICITO OU PRESTACAO DE SERVICO DEFEITUOSO.2. LITIGANCIA DE MA-FE CARACTERIZADA. ALEGACAO DE DESCONHECIMENTO DE ORIGEM DA DIVIDA, DA QUAL ERA INEQUIVOCAMENTE SABEDOR, TAMPOUCO MUDOU SUA POSICAO (APELACAO) DEPOIS DAS PROVAS TRAZIDAS PELO REU EM CONTESTACAO.3. INEXISTENCIA DE INDICIOS CONCRETOS DE QUE SE ENQUADRE NA CATEGORIA DE ACAO MASSIVA E COM SINAL DE FINALIDADE FRAUDULENTA, CONFORME O MONITORAMENTO PELO NUCLEO DE MONITORAMENTO DE PERFIS DE DEMANDA (NUMOPEDE). SENTENCA DE PROCEDENCIA REFORMADA. ACAO IMPROCEDENTE. RECURSO PROVIDO. ART. 1007 CPC - EVENTUAL RECURSO - SE AO STJ: CUSTAS R$ 194,12 - (GUIA GRU NO SITE HTTP://WWW.STJ.JUS.BR) - RESOLUCAO N. 02 DE 02/01/2020 DO STJ; SE AO STF: CUSTAS R$ 214,71 - GUIA GRU - COBRANCA - FICHA DE COMPENSACAO - (EMITIDA ATRAVES DO SITE WWW.STF.JUS.BR) E PORTE DE REMESSA E RETORNO R$ 140,90 - GUIA FEDTJ - COD 140-6 - BANCO DO BRASIL OU INTERNET - RESOLUCAO N. 662 DE 10/02/2020 DO STF. OS VALORES REFERENTES AO PORTE DE REMESSA E RETORNO, NAO SE APLICAM AOS PROCESSOS ELETRONICOS, DE ACORDO COM O ART. 4, INCISO II, DA RESOLUCAO N. 662 DE 10/02/2020 DO STF. - ADVS: JOAO THOMAZ PRAZERES GONDIM (OAB: 270757/SP) - RAFAEL HIDEO NAZIMA (OAB: 295443/SP) - PATEO DO COLEGIO - SALAS 211/213",
                    "PublishDate": "2022-03-15T00:00:00",
                    "CaptureDate": "2022-04-16T05:48:41"
                  },
                  {
                    "Content": "EXPEDIDO CERTIDAO CERTIDAO DE PUBLICACAO DE ACORDAO [DIGITAL]",
                    "PublishDate": "2022-03-15T00:00:00",
                    "CaptureDate": "2022-05-20T13:05:42"
                  },
                  {
                    "Content": "PRAZO",
                    "PublishDate": "2022-03-15T00:00:00",
                    "CaptureDate": "2022-05-20T13:05:42"
                  },
                  {
                    "Content": "PUBLICADO EM | DISPONIBILIZADO EM 11/03/2022 TIPO DE PUBLICACAO: JULGADOS NUMERO DO DIARIO ELETRONICO: 3464",
                    "PublishDate": "2022-03-14T00:00:00",
                    "CaptureDate": "2022-04-16T05:48:41"
                  },
                  {
                    "Content": "PUBLICADO EM DISPONIBILIZADO EM 11/03/2022 TIPO DE PUBLICACAO: JULGADOS NUMERO DO DIARIO ELETRONICO: 3464",
                    "PublishDate": "2022-03-14T00:00:00",
                    "CaptureDate": "2022-05-20T13:05:42"
                  },
                  {
                    "Content": "ACORDAO REGISTRADO | ACORDAO REGISTRADO SOB N 20220000165377, COM 7 FOLHAS.",
                    "PublishDate": "2022-03-10T00:00:00",
                    "CaptureDate": "2022-04-16T05:48:41"
                  },
                  {
                    "Content": "ACORDAO FINALIZADO | DERAM PROVIMENTO AO RECURSO. V. U. SUSTENTARAM ORALMENTE OS(AS) ADVOGADOS(AS) DE AMBAS AS PARTES, JULIANA VIEIRA BARBOSA BUSS OAB/DF 45.151 E RAFAEL HIDEO NAZIMA OAB/SP 295.443",
                    "PublishDate": "2022-03-10T00:00:00",
                    "CaptureDate": "2022-04-16T05:48:41"
                  },
                  {
                    "Content": "ACORDAO FINALIZADO DERAM PROVIMENTO AO RECURSO. V. U. SUSTENTARAM ORALMENTE OS(AS) ADVOGADOS(AS) DE AMBAS AS PARTES, JULIANA VIEIRA BARBOSA BUSS OAB/DF 45.151 E RAFAEL HIDEO NAZIMA OAB/SP 295.443",
                    "PublishDate": "2022-03-10T00:00:00",
                    "CaptureDate": "2022-05-20T13:05:42"
                  },
                  {
                    "Content": "ACORDAO REGISTRADO ACORDAO REGISTRADO SOB N 20220000165377, COM 7 FOLHAS.",
                    "PublishDate": "2022-03-10T00:00:00",
                    "CaptureDate": "2022-05-20T13:05:42"
                  },
                  {
                    "Content": "PROVIMENTO",
                    "PublishDate": "2022-03-08T00:00:00",
                    "CaptureDate": "2022-04-16T05:48:41"
                  },
                  {
                    "Content": "JULGADO | DERAM PROVIMENTO AO RECURSO. V. U. SUSTENTARAM ORALMENTE OS(AS) ADVOGADOS(AS) DE AMBAS AS PARTES, JULIANA VIEIRA BARBOSA BUSS OAB/DF 45.151 E RAFAEL HIDEO NAZIMA OAB/SP 295.443",
                    "PublishDate": "2022-03-08T00:00:00",
                    "CaptureDate": "2022-04-16T05:48:41"
                  },
                  {
                    "Content": "JULGADO DERAM PROVIMENTO AO RECURSO. V. U. SUSTENTARAM ORALMENTE OS(AS) ADVOGADOS(AS) DE AMBAS AS PARTES, JULIANA VIEIRA BARBOSA BUSS OAB/DF 45.151 E RAFAEL HIDEO NAZIMA OAB/SP 295.443",
                    "PublishDate": "2022-03-08T00:00:00",
                    "CaptureDate": "2022-05-20T13:05:42"
                  },
                  {
                    "Content": "PROVIMENTO",
                    "PublishDate": "2022-03-08T00:00:00",
                    "CaptureDate": "2022-05-20T13:05:42"
                  },
                  {
                    "Content": "JUNTADA DE PETICAO | N PROTOCOLO: WPRO.22.00221129-9 TIPO DA PETICAO: SUSTENTACAO ORAL DATA: 03/03/2022 19:30",
                    "PublishDate": "2022-03-03T00:00:00",
                    "CaptureDate": "2022-04-16T05:48:41"
                  },
                  {
                    "Content": "EXPEDIDO TERMO | TERMO DE JUNTADA - AUTOMATICA",
                    "PublishDate": "2022-03-03T00:00:00",
                    "CaptureDate": "2022-04-16T05:48:41"
                  },
                  {
                    "Content": "EXPEDIDO TERMO TERMO DE JUNTADA - AUTOMATICA",
                    "PublishDate": "2022-03-03T00:00:00",
                    "CaptureDate": "2022-05-20T13:05:42"
                  },
                  {
                    "Content": "JUNTADA DE PETICAO N PROTOCOLO: WPRO.22.00221129-9 TIPO DA PETICAO: SUSTENTACAO ORAL DATA: 03/03/2022 19:30",
                    "PublishDate": "2022-03-03T00:00:00",
                    "CaptureDate": "2022-05-20T13:05:42"
                  },
                  {
                    "Content": "PUBLICADO EM | DISPONIBILIZADO EM 22/02/2022 TIPO DE PUBLICACAO: PROXIMOS JULGADOS NUMERO DO DIARIO ELETRONICO: 3453",
                    "PublishDate": "2022-02-23T00:00:00",
                    "CaptureDate": "2022-04-16T05:48:41"
                  },
                  {
                    "Content": "PUBLICADO EM DISPONIBILIZADO EM 22/02/2022 TIPO DE PUBLICACAO: PROXIMOS JULGADOS NUMERO DO DIARIO ELETRONICO: 3453",
                    "PublishDate": "2022-02-23T00:00:00",
                    "CaptureDate": "2022-05-20T13:05:42"
                  },
                  {
                    "Content": "INCLUSAO EM PAUTA | PARA 08/03/2022",
                    "PublishDate": "2022-02-21T00:00:00",
                    "CaptureDate": "2022-04-16T05:48:41"
                  },
                  {
                    "Content": "INCLUSAO EM PAUTA PARA 08/03/2022",
                    "PublishDate": "2022-02-21T00:00:00",
                    "CaptureDate": "2022-05-20T13:05:42"
                  },
                  {
                    "Content": "PROCESSO ENCAMINHADO PARA O PROCESSAMENTO DE GRUPOS E CAMARAS - A MESA",
                    "PublishDate": "2022-01-11T00:00:00",
                    "CaptureDate": "2022-04-16T05:48:41"
                  },
                  {
                    "Content": "DESPACHO A MESA | VOTO N 9712 VISTOS. A MESA.",
                    "PublishDate": "2022-01-10T00:00:00",
                    "CaptureDate": "2022-04-16T05:48:41"
                  },
                  {
                    "Content": "DESPACHO A MESA VOTO N 9712 VISTOS. A MESA.",
                    "PublishDate": "2022-01-10T00:00:00",
                    "CaptureDate": "2022-05-20T13:05:42"
                  },
                  {
                    "Content": "JUNTADA DE PETICAO | N PROTOCOLO: WPRO.21.01434580-4 TIPO DA PETICAO: SUSTENTACAO ORAL DATA: 25/11/2021 21:14",
                    "PublishDate": "2021-11-26T00:00:00",
                    "CaptureDate": "2021-12-01T22:35:21"
                  },
                  {
                    "Content": "EXPEDIDO TERMO | TERMO DE JUNTADA - AUTOMATICA",
                    "PublishDate": "2021-11-26T00:00:00",
                    "CaptureDate": "2021-12-01T22:35:21"
                  },
                  {
                    "Content": "EXPEDIDO TERMO TERMO DE JUNTADA - AUTOMATICA",
                    "PublishDate": "2021-11-25T00:00:00",
                    "CaptureDate": "2022-05-20T13:05:42"
                  },
                  {
                    "Content": "JUNTADA DE PETICAO N PROTOCOLO: WPRO.21.01434580-4 TIPO DA PETICAO: SUSTENTACAO ORAL DATA: 25/11/2021 21:14",
                    "PublishDate": "2021-11-25T00:00:00",
                    "CaptureDate": "2022-05-20T13:05:42"
                  },
                  {
                    "Content": "PUBLICADO EM | DISPONIBILIZADO EM 18/11/2021 TIPO DE PUBLICACAO: DISTRIBUIDOS NUMERO DO DIARIO ELETRONICO: 3401",
                    "PublishDate": "2021-11-19T00:00:00",
                    "CaptureDate": "2021-12-01T22:35:21"
                  },
                  {
                    "Content": "PUBLICADO EM DISPONIBILIZADO EM 18/11/2021 TIPO DE PUBLICACAO: DISTRIBUIDOS NUMERO DO DIARIO ELETRONICO: 3401",
                    "PublishDate": "2021-11-19T00:00:00",
                    "CaptureDate": "2022-05-20T13:05:42"
                  },
                  {
                    "Content": "1010478-46.2020.8.26.0100; PROCESSO DIGITAL. PETICOES PARA JUNTADA DEVEM SER APRESENTADAS EXCLUSIVAMENTE POR MEIO ELETRONICO, NOS TERMOS DO ARTIGO 7 DA RES. 551/2011; APELACAO CIVEL; 15 CAMARA DE DIREITO PRIVADO; ELOI ESTEVAO TROLY; FORO CENTRAL CIVEL; 4 VARA CIVEL; PROCEDIMENTO COMUM CIVEL; 1010478-46.2020.8.26.0100; TELEFONIA; APELANTE: NEXTEL TELECOMUNICACOES LTDA; ADVOGADO: JOAO THOMAZ PRAZERES GONDIM (OAB: 270757/SP); APELADO: RAFAEL CASTRO DE MATOS; ADVOGADO: RAFAEL HIDEO NAZIMA (OAB: 295443/SP); FICAM AS PARTES INTIMADAS PARA MANIFESTAREM-SE ACERCA DE EVENTUAL OPOSICAO AO JULGAMENTO VIRTUAL, NOS TERMOS DO ART. 1 DA RESOLUCAO 549/2011, COM REDACAO ESTABELECIDA PELA RESOLUCAO 772/2017, AMBAS DO ORGAO ESPECIAL DESTE TRIBUNAL.",
                    "PublishDate": "2021-11-18T00:00:00",
                    "CaptureDate": "2021-12-01T22:35:21"
                  },
                  {
                    "Content": "JUNTADA DE PETICAO | N PROTOCOLO: WPRO.21.01391838-0 TIPO DA PETICAO: SUSTENTACAO ORAL DATA: 17/11/2021 08:31",
                    "PublishDate": "2021-11-17T00:00:00",
                    "CaptureDate": "2021-12-01T22:35:21"
                  },
                  {
                    "Content": "EXPEDIDO TERMO | TERMO DE JUNTADA - AUTOMATICA",
                    "PublishDate": "2021-11-17T00:00:00",
                    "CaptureDate": "2021-12-01T22:35:21"
                  },
                  {
                    "Content": "JUNTADA DE PETICAO | N PROTOCOLO: WPRO.21.01391838-0 TIPO DA PETIC??O: SUSTENTACAO ORAL DATA: 17/11/2021 08:31",
                    "PublishDate": "2021-11-17T00:00:00",
                    "CaptureDate": "2022-04-16T05:48:41"
                  },
                  {
                    "Content": "EXPEDIDO TERMO TERMO DE JUNTADA - AUTOMATICA",
                    "PublishDate": "2021-11-17T00:00:00",
                    "CaptureDate": "2022-05-20T13:05:42"
                  },
                  {
                    "Content": "JUNTADA DE PETICAO N PROTOCOLO: WPRO.21.01391838-0 TIPO DA PETICAO: SUSTENTACAO ORAL DATA: 17/11/2021 08:31",
                    "PublishDate": "2021-11-17T00:00:00",
                    "CaptureDate": "2022-05-20T13:05:42"
                  },
                  {
                    "Content": "CONCLUSOS PARA O RELATOR (EXPEDIDO TERMO COM CONCLUSAO) | ELOI ESTEVAO TROLY",
                    "PublishDate": "2021-11-16T00:00:00",
                    "CaptureDate": "2021-12-01T22:35:21"
                  },
                  {
                    "Content": "DISTRIBUICAO POR SORTEIO | ORGAO JULGADOR: 24 - 15 CAMARA DE DIREITO PRIVADO RELATOR: 11153 - ELOI ESTEVAO TROLY",
                    "PublishDate": "2021-11-16T00:00:00",
                    "CaptureDate": "2021-12-01T22:35:21"
                  },
                  {
                    "Content": "PROCESSO ENCAMINHADO PARA OUTRA SECAO | MOTIVO: PS SECAO ANTERIOR: DIREITO PRIVADO SUBSECAO ANTERIOR: DIREITO PRIVADO 3 SECAO ATUAL: DIREITO PRIVADO SUBSECAO ATUAL: DIREITO PRIVADO 2",
                    "PublishDate": "2021-11-16T00:00:00",
                    "CaptureDate": "2021-12-01T22:35:21"
                  },
                  {
                    "Content": "PROCESSO ENCAMINHADO PARA OUTRA SECAO MOTIVO: PS SECAO ANTERIOR: DIREITO PRIVADO SUBSECAO ANTERIOR: DIREITO PRIVADO 3 SECAO ATUAL: DIREITO PRIVADO SUBSECAO ATUAL: DIREITO PRIVADO 2",
                    "PublishDate": "2021-11-16T00:00:00",
                    "CaptureDate": "2022-05-20T13:05:42"
                  },
                  {
                    "Content": "DISTRIBUICAO POR SORTEIO ORGAO JULGADOR: 24 - 15 CAMARA DE DIREITO PRIVADO RELATOR: 11153 - ELOI ESTEVAO TROLY",
                    "PublishDate": "2021-11-16T00:00:00",
                    "CaptureDate": "2022-05-20T13:05:42"
                  },
                  {
                    "Content": "CONCLUSOS PARA O RELATOR (EXPEDIDO TERMO COM CONCLUSAO) ELOI ESTEVAO TROLY",
                    "PublishDate": "2021-11-16T00:00:00",
                    "CaptureDate": "2022-05-20T13:05:42"
                  },
                  {
                    "Content": "PUBLICADO EM | DISPONIBILIZADO EM 10/11/2021 TIPO DE PUBLICACAO: ENTRADOS NUMERO DO DIARIO ELETRONICO: 3396",
                    "PublishDate": "2021-11-11T00:00:00",
                    "CaptureDate": "2021-12-01T22:35:21"
                  },
                  {
                    "Content": "PUBLICADO EM DISPONIBILIZADO EM 10/11/2021 TIPO DE PUBLICACAO: ENTRADOS NUMERO DO DIARIO ELETRONICO: 3396",
                    "PublishDate": "2021-11-11T00:00:00",
                    "CaptureDate": "2022-05-20T13:05:42"
                  },
                  {
                    "Content": "PROCESSO ENCAMINHADO PARA A DISTRIBUICAO DE RECURSOS",
                    "PublishDate": "2021-11-08T00:00:00",
                    "CaptureDate": "2021-12-01T22:35:21"
                  },
                  {
                    "Content": "PROCESSO CADASTRADO | SJ 2.1.3 - SERVICO DE ENTRADA DE AUTOS DE DIREITO PRIVADO 3",
                    "PublishDate": "2021-11-08T00:00:00",
                    "CaptureDate": "2021-12-01T22:35:21"
                  },
                  {
                    "Content": "RECEBIDOS OS AUTOS PELA ENTRADA DE RECURSOS | FORO DE ORIGEM: FORO CENTRAL CIVEL VARA DE ORIGEM: 4 VARA CIVEL",
                    "PublishDate": "2021-11-08T00:00:00",
                    "CaptureDate": "2021-12-01T22:35:21"
                  },
                  {
                    "Content": "RECEBIDOS OS AUTOS PELA ENTRADA DE RECURSOS FORO DE ORIGEM: FORO CENTRAL CIVEL VARA DE ORIGEM: 4 VARA CIVEL",
                    "PublishDate": "2021-11-08T00:00:00",
                    "CaptureDate": "2022-05-20T13:05:42"
                  },
                  {
                    "Content": "PROCESSO CADASTRADO SJ 2.1.3 - SERVICO DE ENTRADA DE AUTOS DE DIREITO PRIVADO 3",
                    "PublishDate": "2021-11-08T00:00:00",
                    "CaptureDate": "2022-05-20T13:05:42"
                  },
                  {
                    "Content": "PROCESSO ENCAMINHADO PARA A DISTRIBUICAO DE RECURSOS",
                    "PublishDate": "2021-11-08T00:00:00",
                    "CaptureDate": "2022-05-20T13:05:42"
                  }
                ],
                "Petitions": [
                  {
                    "Type": "SUSTENTACAO ORAL",
                    "Author": "",
                    "CreationDate": "2021-11-17T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  },
                  {
                    "Type": "SUSTENTACAO ORAL",
                    "Author": "",
                    "CreationDate": "2021-11-25T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  },
                  {
                    "Type": "SUSTENTACAO ORAL",
                    "Author": "",
                    "CreationDate": "2022-03-03T00:00:00",
                    "JoinedDate": "0001-01-01T00:00:00"
                  }
                ],
                "Decisions": []
              }
            ],
            "TotalLawsuits": 14,
            "TotalLawsuitsAsAuthor": 10,
            "TotalLawsuitsAsDefendant": 4,
            "TotalLawsuitsAsOther": 0
          }
        },
        "ActiveOwners": [
          "07639480981",
          "12916747729",
          "35823023855",
          "41812844840"
        ],
        "InactiveOwners": [
          "02349014118"
        ]
      },
      "createdAt": "2024-02-28T20:46:14.183Z",
      "updatedAt": "2024-02-28T20:46:14.183Z"
    },
    "jap": {
      "_id": "65df9b9959af913ca758decf",
      "emailClient": "superadmin@gueno.com",
      "email": "superadmin@gueno.com",
      "status": "IN_PROGRESS",
      "type": "JUDICIAL_ADMINISTRATIVE_PROCESSES",
      "entity": "BUSINESS",
      "checkDetails": {
        "Lawsuits": [
          {
            "Number": "11179369320188260100",
            "Type": "PROCEDIMENTO COMUM",
            "MainSubject": "PROTESTO INDEVIDO DE TITULO",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "",
            "JudgingBody": "8 VARA CIVEL - FORO CENTRAL CIVEL",
            "State": "SP",
            "Status": "INDEFINIDO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "PROTESTO INDEVIDO DE TÍTULO",
            "InferredCNJSubjectNumber": 7781,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "PROTESTO INDEVIDO DE TITULO"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 8710.91,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2019-11-19T00:00:00",
            "NoticeDate": "2018-11-15T00:00:00",
            "LastMovementDate": "2020-01-30T00:00:00",
            "CaptureDate": "2019-11-20T04:24:38",
            "LastUpdate": "2019-11-20T04:24:38",
            "NumberOfParties": 7,
            "NumberOfUpdates": 114,
            "LawSuitAge": 1931,
            "AverageNumberOfUpdatesPerMonth": 1,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "18987233898",
                "IsPartyActive": false,
                "Name": "VANESSA RIBEIRO MATEUS",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2019-10-03T06:22:33"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Doc": "26462064000106",
                "IsPartyActive": true,
                "Name": "ADVISOR BOOKEEPING SERVICES LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Doc": "35068411817",
                "IsPartyActive": true,
                "Name": "RAFAEL HIDEO NAZIMA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "295443",
                  "State": "SP",
                  "SpecificType": "ADVOGADO REQUERENTE"
                },
                "LastCaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Doc": "30915522845",
                "IsPartyActive": true,
                "Name": "CAROLINE NITTO FERNANDES",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "276522",
                  "State": "SP",
                  "SpecificType": "ADVOGADO REQUERIDO"
                },
                "LastCaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Doc": "35068411817",
                "IsPartyActive": true,
                "Name": "RAFAEL HIDEO NAZIMA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "295443",
                  "State": "SP",
                  "SpecificType": "ADVOGADO (REQTE)"
                },
                "LastCaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Doc": "30915522845",
                "IsPartyActive": true,
                "Name": "CAROLINE NITTO FERNANDES",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "276522",
                  "State": "SP",
                  "SpecificType": "ADVOGADO (REQDO)"
                },
                "LastCaptureDate": "2019-11-20T04:24:38"
              }
            ],
            "Updates": [
              {
                "Content": "INCIDENTE PROCESSUAL INSTAURADO | 0005867-67.2020.8.26.0100 - CUMPRIMENTO PROVISORIO DE DECISAO",
                "PublishDate": "2020-01-30T00:00:00",
                "CaptureDate": "2021-11-18T05:08:35"
              },
              {
                "Content": "ARQUIVADO DEFINITIVAMENTE",
                "PublishDate": "2019-11-25T00:00:00",
                "CaptureDate": "2021-11-18T05:08:35"
              },
              {
                "Content": "INICIO DA EXECUCAO JUNTADO | 0082738-75.2019.8.26.0100 - CUMPRIMENTO DE SENTENCA",
                "PublishDate": "2019-11-22T00:00:00",
                "CaptureDate": "2021-11-18T05:08:35"
              },
              {
                "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.19.41827903-7 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 22/11/2019 16:30",
                "PublishDate": "2019-11-22T00:00:00",
                "CaptureDate": "2021-11-18T05:08:35"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0371/2019 DATA DA DISPONIBILIZACAO: 19/11/2019 DATA DA PUBLICACAO: 21/11/2019 NUMERO DO DIARIO: 2936 PAGINA: 179/190",
                "PublishDate": "2019-11-19T00:00:00",
                "CaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0371/2019 TEOR DO ATO: ANTE O TRANSITO EM JULGADO, ARQUIVEM-SE OS AUTOS COM AS ANOTACOES DE BAIXA NOS TERMOS DO COMUNICADO CG N 1789/2017. PROVIDENCIE A PARTE INTERESSADA O CUMPRIMENTO DA SENTENCA NOS TERMOS DO ART. 1285 DAS NORMAS DE SERVICO DA CORREGEDORIA GERAL DE JUSTICA, PETICIONANDO SOB A DENOMINACAO \"CUMPRIMENTO DE SENTENCA\" DE MODO A GERAR UM INCIDENTE AUTOMATICO. AS PETICOES SEGUINTES DEVEM SER DIRECIONADAS PELAS PARTES A ESTE INCIDENTE DE CUMPRIMENTO DE SENTENCA GERADO, SOB A DENOMINACAO \"PETICOES DIVERSAS\". APRESENTE OS CALCULOS RELATIVOS A SEU CREDITO, EM 10 DIAS, NOS TERMOS DO ART. 524 DO CODIGO DE PROCESSO CIVIL, COMPUTANDO A TAXA DE 1% SOBRE O VALOR INTEGRAL DA EXECUCAO, ART. 4, III, DA LEI ESTADUAL 11.608/03. APOS, INTIME-SE EM EXECUCAO, ART. 523 DO CODIGO DE PROCESSO CIVIL, PELA IMPRENSA NA PESSOA DO ADVOGADO, PARA PAGAMENTO EM 15 DIAS, SOB PENA DE MULTA DE 10% SOBRE O VALOR DO DEBITO, CIENTE DE QUE A CONTINUIDADE DA EXECUCAO ENSEJARA HONORARIOS. TRANSCORRIDO SEM PAGAMENTO VOLUNTARIO, FICA DESDE LOGO O EXECUTADO INTIMADO DO PRAZO DE 15 DIAS A APRESENTACAO DE IMPUGNACAO, NOS TERMOS DO ART. 525 DO CPC. FRUSTRADA A PROVIDENCIA, E, SE REQUERIDOS PELO CREDOR, FORMALIZE-SE A PENHORA, OBEDECIDA A ORDEM DO ART. 835 DO CODIGO DE PROCESSO CIVIL, , PROVIDENCIANDO O CREDOR O RECOLHIMENTO PREVISTO NO PROVIMENTO 1864/2011. SE INFRUTIFERAS AS PROVIDENCIAS, DIGA O CREDOR SOBRE A SUSPENSAO DA EXECUCAO ART. 921, III, DO CODIGO DE PROCESSO CIVIL, NO PRAZO DE TRINTA, SOB PENA DE ARQUIVAMENTO. CASO NAO SEJA DADO INICIO DA EXECUCAO EM 30 DIAS, ARQUIVEM-SE OS AUTOS. ADVOGADOS(S): CAROLINE NITTO FERNANDES (OAB 276522/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2019-11-14T00:00:00",
                "CaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Content": "DECISAO | ANTE O TRANSITO EM JULGADO, ARQUIVEM-SE OS AUTOS COM AS ANOTACOES DE BAIXA NOS TERMOS DO COMUNICADO CG N 1789/2017. PROVIDENCIE A PARTE INTERESSADA O CUMPRIMENTO DA SENTENCA NOS TERMOS DO ART. 1285 DAS NORMAS DE SERVICO DA CORREGEDORIA GERAL DE JUSTICA, PETICIONANDO SOB A DENOMINACAO \"CUMPRIMENTO DE SENTENCA\" DE MODO A GERAR UM INCIDENTE AUTOMATICO. AS PETICOES SEGUINTES DEVEM SER DIRECIONADAS PELAS PARTES A ESTE INCIDENTE DE CUMPRIMENTO DE SENTENCA GERADO, SOB A DENOMINACAO \"PETICOES DIVERSAS\". APRESENTE OS CALCULOS RELATIVOS A SEU CREDITO, EM 10 DIAS, NOS TERMOS DO ART. 524 DO CODIGO DE PROCESSO CIVIL, COMPUTANDO A TAXA DE 1% SOBRE O VALOR INTEGRAL DA EXECUCAO, ART. 4, III, DA LEI ESTADUAL 11.608/03. APOS, INTIME-SE EM EXECUCAO, ART. 523 DO CODIGO DE PROCESSO CIVIL, PELA IMPRENSA NA PESSOA DO ADVOGADO, PARA PAGAMENTO EM 15 DIAS, SOB PENA DE MULTA DE 10% SOBRE O VALOR DO DEBITO, CIENTE DE QUE A CONTINUIDADE DA EXECUCAO ENSEJARA HONORARIOS. TRANSCORRIDO SEM PAGAMENTO VOLUNTARIO, FICA DESDE LOGO O EXECUTADO INTIMADO DO PRAZO DE 15 DIAS A APRESENTACAO DE IMPUGNACAO, NOS TERMOS DO ART. 525 DO CPC. FRUSTRADA A PROVIDENCIA, E, SE REQUERIDOS PELO CREDOR, FORMALIZE-SE A PENHORA, OBEDECIDA A ORDEM DO ART. 835 DO CODIGO DE PROCESSO CIVIL, , PROVIDENCIANDO O CREDOR O RECOLHIMENTO PREVISTO NO PROVIMENTO 1864/2011. SE INFRUTIFERAS AS PROVIDENCIAS, DIGA O CREDOR SOBRE A SUSPENSAO DA EXECUCAO ART. 921, III, DO CODIGO DE PROCESSO CIVIL, NO PRAZO DE TRINTA, SOB PENA DE ARQUIVAMENTO. CASO NAO SEJA DADO INICIO DA EXECUCAO EM 30 DIAS, ARQUIVEM-SE OS AUTOS.",
                "PublishDate": "2019-11-14T00:00:00",
                "CaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO |",
                "PublishDate": "2019-11-13T00:00:00",
                "CaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO |",
                "PublishDate": "2019-11-13T00:00:00",
                "CaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2019-11-13T00:00:00",
                "CaptureDate": "2021-11-18T05:08:35"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2019-11-13T00:00:00",
                "CaptureDate": "2021-11-18T05:08:35"
              },
              {
                "Content": "RECEBIDOS OS AUTOS DO TRIBUNAL DE JUSTICA |",
                "PublishDate": "2019-11-12T00:00:00",
                "CaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Content": "RECEBIDOS OS AUTOS DO TRIBUNAL DE JUSTICA",
                "PublishDate": "2019-11-12T00:00:00",
                "CaptureDate": "2021-11-18T05:08:35"
              },
              {
                "Content": "1117936-93.2018.8.26.0100; PROCESSO DIGITAL. PETICOES PARA JUNTADA DEVEM SER APRESENTADAS EXCLUSIVAMENTE POR MEIO ELETRONICO, NOS TERMOS DO ARTIGO 7 DA RES. 551/2011; APELACAO CIVEL; 37 CAMARA DE DIREITO PRIVADO; SERGIO GOMES; FORO CENTRAL CIVEL; 8 VARA CIVEL; PROCEDIMENTO COMUM CIVEL; 1117936-93.2018.8.26.0100; DUPLICATA; APTE/APDO: STARK BANK S/A; ADVOGADO: RAFAEL HIDEO NAZIMA (OAB: 295443/SP); APDO/APTE: ADVISOR BOOKEEPING SERVICES LTDA.; ADVOGADA: CAROLINE NITTO FERNANDES (OAB: 276522/SP); FICAM AS PARTES INTIMADAS PARA MANIFESTAREM-SE ACERCA DE EVENTUAL OPOSICAO AO JULGAMENTO VIRTUAL, NOS TERMOS DO ART. 1 DA RESOLUCAO 549/2011, COM REDACAO ESTABELECIDA PELA RESOLUCAO 772/2017, AMBAS DO ORGAO ESPECIAL DESTE TRIBUNAL.",
                "PublishDate": "2019-09-25T00:00:00",
                "CaptureDate": "2019-10-03T06:22:33"
              },
              {
                "Content": "1117936-93.2018.8.26.0100; PROCESSO DIGITAL. PETICOES PARA JUNTADA DEVEM SER APRESENTADAS EXCLUSIVAMENTE POR MEIO ELETRONICO, NOS TERMOS DO ARTIGO 7 DA RES. 551/2011; APELACAO CIVEL; COMARCA: SAO PAULO; VARA: 8 VARA CIVEL; ACAO : PROCEDIMENTO COMUM CIVEL; N ORIGEM: 1117936-93.2018.8.26.0100; ASSUNTO: DUPLICATA; APTE/APDO: STARK BANK S/A; ADVOGADO: RAFAEL HIDEO NAZIMA (OAB: 295443/SP); APDO/APTE: ADVISOR BOOKEEPING SERVICES LTDA.; ADVOGADA: CAROLINE NITTO FERNANDES (OAB: 276522/SP); HAVENDO INTERESSE NA TENTATIVA DE CONCILIACAO, AS PARTES DEVERAO SE MANIFESTAR NESSE SENTIDO (POR PETICAO OU, PREFERENCIALMENTE, PELO FORMULARIO ELETRONICO DISPONIVEL NO SITE WWW.TJSP.JUS.BR). TERAO PRIORIDADE NO AGENDAMENTO OS PROCESSOS EM QUE TODAS AS PARTES SE MANIFESTAREM POSITIVAMENTE, FICANDO, CONTUDO, ESCLARECIDO QUE A SESSAO CONCILIATORIA TAMBEM PODERA SER DESIGNADA POR INICIATIVA DO PROPRIO TRIBUNAL.",
                "PublishDate": "2019-09-19T00:00:00",
                "CaptureDate": "2019-09-27T17:37:34"
              },
              {
                "Content": "REMETIDOS OS AUTOS PARA O TRIBUNAL DE JUSTICA/COLEGIO RECURSAL - PROCESSO DIGITAL",
                "PublishDate": "2019-09-17T00:00:00",
                "CaptureDate": "2019-09-19T09:16:12"
              },
              {
                "Content": "REMETIDOS OS AUTOS PARA O TRIBUNAL DE JUSTICA/COLEGIO RECURSAL - PROCESSO DIGITAL |",
                "PublishDate": "2019-09-17T00:00:00",
                "CaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Content": "CONTRARRAZOES DO RECURSO ADESIVO JUNTADO N PROTOCOLO: WJMJ.19.41415689-5 TIPO DA PETICAO: CONTRARRAZOES DO RECURSO ADESIVO DATA: 16/09/2019 14:55",
                "PublishDate": "2019-09-16T00:00:00",
                "CaptureDate": "2019-09-19T09:16:12"
              },
              {
                "Content": "CONTRARRAZOES DO RECURSO ADESIVO JUNTADO | N PROTOCOLO: WJMJ.19.41415689-5 TIPO DA PETICAO: CONTRARRAZOES DO RECURSO ADESIVO DATA: 16/09/2019 14:55",
                "PublishDate": "2019-09-16T00:00:00",
                "CaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0265/2019 DATA DA DISPONIBILIZACAO: 23/08/2019 DATA DA PUBLICACAO: 26/08/2019 NUMERO DO DIARIO: 2876 PAGINA: 59/76",
                "PublishDate": "2019-08-23T00:00:00",
                "CaptureDate": "2019-09-19T09:16:12"
              },
              {
                "Content": "PROCESSO 1117936-93.2018.8.26.0100 - PROCEDIMENTO COMUM CIVEL - PROTESTO INDEVIDO DE TITULO - STARK BANK S.A. - ADVISOR BOOKEEPING SERVICES LTDA. - CIENCIA DO RECURSO ADESIVO APRESENTADO (FLS. 409 E SS.). FICA A PARTE INTIMADA A APRESENTAR CONTRARRAZOES, NO PRAZO LEGAL. APOS, OS AUTOS SERAO REMETIDOS AO EGREGIO TRIBUNAL DE JUSTICA NOS TERMOS DO ART. 196, INCISO XXVII, NSCGJ. - ADV: CAROLINE NITTO FERNANDES (OAB 276522/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2019-08-23T00:00:00",
                "CaptureDate": "2019-09-19T09:15:16"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0265/2019 DATA DA DISPONIBILIZACAO: 23/08/2019 DATA DA PUBLICACAO: 26/08/2019 NUMERO DO DIARIO: 2876 PAGINA: 59/76",
                "PublishDate": "2019-08-23T00:00:00",
                "CaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Content": "ATO ORDINATORIO - PUBLICAVEL CIENCIA DO RECURSO ADESIVO APRESENTADO (FLS. 409 E SS.). FICA A PARTE INTIMADA A APRESENTAR CONTRARRAZOES, NO PRAZO LEGAL. APOS, OS AUTOS SERAO REMETIDOS AO EGREGIO TRIBUNAL DE JUSTICA NOS TERMOS DO ART. 196, INCISO XXVII, NSCGJ.",
                "PublishDate": "2019-08-21T00:00:00",
                "CaptureDate": "2019-09-19T09:16:12"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0265/2019 TEOR DO ATO: CIENCIA DO RECURSO ADESIVO APRESENTADO (FLS. 409 E SS.). FICA A PARTE INTIMADA A APRESENTAR CONTRARRAZOES, NO PRAZO LEGAL. APOS, OS AUTOS SERAO REMETIDOS AO EGREGIO TRIBUNAL DE JUSTICA NOS TERMOS DO ART. 196, INCISO XXVII, NSCGJ. ADVOGADOS(S): CAROLINE NITTO FERNANDES (OAB 276522/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2019-08-21T00:00:00",
                "CaptureDate": "2019-09-19T09:16:12"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0265/2019 TEOR DO ATO: CIENCIA DO RECURSO ADESIVO APRESENTADO (FLS. 409 E SS.). FICA A PARTE INTIMADA A APRESENTAR CONTRARRAZOES, NO PRAZO LEGAL. APOS, OS AUTOS SERAO REMETIDOS AO EGREGIO TRIBUNAL DE JUSTICA NOS TERMOS DO ART. 196, INCISO XXVII, NSCGJ. ADVOGADOS(S): CAROLINE NITTO FERNANDES (OAB 276522/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2019-08-21T00:00:00",
                "CaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Content": "ATO ORDINATORIO - PUBLICAVEL | CIENCIA DO RECURSO ADESIVO APRESENTADO (FLS. 409 E SS.). FICA A PARTE INTIMADA A APRESENTAR CONTRARRAZOES, NO PRAZO LEGAL. APOS, OS AUTOS SERAO REMETIDOS AO EGREGIO TRIBUNAL DE JUSTICA NOS TERMOS DO ART. 196, INCISO XXVII, NSCGJ.",
                "PublishDate": "2019-08-21T00:00:00",
                "CaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Content": "CONTRARRAZOES JUNTADA N PROTOCOLO: WJMJ.19.41249731-8 TIPO DA PETICAO: CONTRARRAZOES DE APELACAO DATA: 20/08/2019 14:46",
                "PublishDate": "2019-08-20T00:00:00",
                "CaptureDate": "2019-09-19T09:16:12"
              },
              {
                "Content": "RECURSO ADESIVO JUNTADO N PROTOCOLO: WJMJ.19.41249793-8 TIPO DA PETICAO: RAZOES DO RECURSO ADESIVO DATA: 20/08/2019 14:51",
                "PublishDate": "2019-08-20T00:00:00",
                "CaptureDate": "2019-09-19T09:16:12"
              },
              {
                "Content": "RECURSO ADESIVO JUNTADO | N PROTOCOLO: WJMJ.19.41249793-8 TIPO DA PETICAO: RAZOES DO RECURSO ADESIVO DATA: 20/08/2019 14:51",
                "PublishDate": "2019-08-20T00:00:00",
                "CaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Content": "CONTRARRAZOES JUNTADA | N PROTOCOLO: WJMJ.19.41249731-8 TIPO DA PETICAO: CONTRARRAZOES DE APELACAO DATA: 20/08/2019 14:46",
                "PublishDate": "2019-08-20T00:00:00",
                "CaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0229/2019 DATA DA DISPONIBILIZACAO: 30/07/2019 DATA DA PUBLICACAO: 31/07/2019 NUMERO DO DIARIO: 2858 PAGINA: 131/149",
                "PublishDate": "2019-07-30T00:00:00",
                "CaptureDate": "2019-09-19T09:16:12"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0229/2019 DATA DA DISPONIBILIZACAO: 30/07/2019 DATA DA PUBLICACAO: 31/07/2019 NUMERO DO DIARIO: 2858 PAGINA: 131/149",
                "PublishDate": "2019-07-30T00:00:00",
                "CaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Content": "ATO ORDINATORIO CIENCIA DO RECURSO DE APELACAO APRESENTADO. FICA A PARTE INTIMADA A APRESENTAR CONTRARRAZOES, NO PRAZO LEGAL. APOS, OS AUTOS SERAO REMETIDOS AO EGREGIO TRIBUNAL DE JUSTICA NOS TERMOS DO ART. 196, INCISO XXVII, NSCGJ.",
                "PublishDate": "2019-07-26T00:00:00",
                "CaptureDate": "2019-09-19T09:16:12"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0229/2019 TEOR DO ATO: CIENCIA DO RECURSO DE APELACAO APRESENTADO. FICA A PARTE INTIMADA A APRESENTAR CONTRARRAZOES, NO PRAZO LEGAL. APOS, OS AUTOS SERAO REMETIDOS AO EGREGIO TRIBUNAL DE JUSTICA NOS TERMOS DO ART. 196, INCISO XXVII, NSCGJ. ADVOGADOS(S): CAROLINE NITTO FERNANDES (OAB 276522/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2019-07-26T00:00:00",
                "CaptureDate": "2019-09-19T09:16:12"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0229/2019 TEOR DO ATO: CIENCIA DO RECURSO DE APELACAO APRESENTADO. FICA A PARTE INTIMADA A APRESENTAR CONTRARRAZOES, NO PRAZO LEGAL. APOS, OS AUTOS SERAO REMETIDOS AO EGREGIO TRIBUNAL DE JUSTICA NOS TERMOS DO ART. 196, INCISO XXVII, NSCGJ. ADVOGADOS(S): CAROLINE NITTO FERNANDES (OAB 276522/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2019-07-26T00:00:00",
                "CaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Content": "ATO ORDINATORIO | CIENCIA DO RECURSO DE APELACAO APRESENTADO. FICA A PARTE INTIMADA A APRESENTAR CONTRARRAZOES, NO PRAZO LEGAL. APOS, OS AUTOS SERAO REMETIDOS AO EGREGIO TRIBUNAL DE JUSTICA NOS TERMOS DO ART. 196, INCISO XXVII, NSCGJ.",
                "PublishDate": "2019-07-26T00:00:00",
                "CaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Content": "APELACAO/RAZOES JUNTADA N PROTOCOLO: WJMJ.19.41095095-3 TIPO DA PETICAO: RAZOES DE APELACAO DATA: 25/07/2019 14:19",
                "PublishDate": "2019-07-25T00:00:00",
                "CaptureDate": "2019-09-19T09:16:12"
              },
              {
                "Content": "APELACAO/RAZOES JUNTADA | N PROTOCOLO: WJMJ.19.41095095-3 TIPO DA PETICAO: RAZOES DE APELACAO DATA: 25/07/2019 14:19",
                "PublishDate": "2019-07-25T00:00:00",
                "CaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0196/2019 DATA DA DISPONIBILIZACAO: 02/07/2019 DATA DA PUBLICACAO: 03/07/2019 NUMERO DO DIARIO: 2840 PAGINA: 147/160",
                "PublishDate": "2019-07-02T00:00:00",
                "CaptureDate": "2019-09-19T09:16:12"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0196/2019 DATA DA DISPONIBILIZACAO: 02/07/2019 DATA DA PUBLICACAO: 03/07/2019 NUMERO DO DIARIO: 2840 PAGINA: 147/160",
                "PublishDate": "2019-07-02T00:00:00",
                "CaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2019-06-28T00:00:00",
                "CaptureDate": "2019-09-19T09:15:53"
              },
              {
                "Content": "FLS. 358 TRIBUNAL DE JUSTICA DO ESTADO DE SAO PAULO COMARCA DE SAO PAULO FORO CENTRAL CIVEL 8 VARA CIVEL PRACA JOAO MENDES S/N, 7 ANDAR - SALAS N 701/704 - CENTRO CEP: 01501-900 - SAO PAULO - SP TELEFONE: 2171-6101 - E-MAIL: SP8CV@TJSP.JUS.BR DECISAO PROCESSO N: 1117936-93.2018.8.26.0100 REQUERENTE: STARK BANK S.A. REQUERIDO: ADVISOR BOOKEEPING SERVICES LTDA. JUIZ(A) DE DIREITO: DR(A). VANESSA RIBEIRO MATEUS VISTOS. FLS. 356: TRATA-SE DE EMBARGOS DECLARATORIOS OPOSTOS PELA PARTE AUTORA CONTRA A SENTENCA DE FLS. 351/354. DECIDO. ASSISTE RAZAO A EMBARGANTE. COM EFEITO, A SENTENCA FOI OMISSA AO NAO APRECIAR A QUESTAO RELATIVA AO TITULO PROTESTADO. NESSA TOADA, ACLARO A SENTENCA DE FLS. 351/354, CUJO DISPOSITIVO PASSA A CONTAR COM A SEGUINTE REDACAO: \"ANTE O EXPOSTO, JULGO PARCIALMENTE PROCEDENTE A DEMANDA, PARA O FIM DE DECLARAR INEXIGIVEL A METADE DO DEBITO PROTESTADO, NO IMPORTE DE R$ 600,00, COM CONSEQUENTE CANCELAMENTO DO TITULO N 1557, RESOLVENDO O MERITO, COM FUNDAMENTO NO ART. 487, I, DO CPC\". NO MAIS, MANTENHO A SENTENCA COMO LANCADA. INT. SAO PAULO, 28 DE JUNHO DE 2019. VANESSA RIBEIRO MATEUS JUIZA DE DIREITO DOCUMENTO ASSINADO DIGITALMENTE NOS TERMOS DA LEI 11.419/2006, CONFORME IMPRESSAO A MARGEM DIREITA PROCESSO N 1117936-93.2018.8.26.0100 - P. 1 ESTE DOCUMENTO E COPIA DO ORIGINAL, ASSINADO DIGITALMENTE POR VANESSA RIBEIRO MATEUS, LIBERADO NOS AUTOS EM 28/06/2019 AS 16:38 . PARA CONFERIR O ORIGINAL, ACESSE SITE HTTPS://ESAJ.TJSP.JUS.BR/PASTADIGITAL/PG/ABRIRCONFERENCIADOCUMENTO.DO, INFORME PROCESSO 1117936-93.2018.8.26.0100 E CODIGO 7577602. FLS. 359 TRIBUNAL DE JUSTICA DO ESTADO DE SAO PAULO COMARCA DE SAO PAULO FORO CENTRAL CIVEL 8 VARA CIVEL PRACA JOAO MENDES S/N, 7 ANDAR - SALAS N 701/704 - CENTRO CEP: 01501-900 - SAO PAULO - SP TELEFONE: 2171-6101 - E-MAIL: SP8CV@TJSP.JUS.BR PROCESSO N 1117936-93.2018.8.26.0100 - P. 2 ESTE DOCUMENTO E COPIA DO ORIGINAL, ASSINADO DIGITALMENTE POR VANESSA RIBEIRO MATEUS, LIBERADO NOS AUTOS EM 28/06/2019 AS 16:38 . PARA CONFERIR O ORIGINAL, ACESSE SITE HTTPS://ESAJ.TJSP.JUS.BR/PASTADIGITAL/PG/ABRIRCONFERENCIADOCUMENTO.DO, INFORME PROCESSO 1117936-93.2018.8.26.0100 E CODIGO 7577602.",
                "PublishDate": "2019-06-28T00:00:00",
                "CaptureDate": "2019-09-19T09:15:53"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0196/2019 TEOR DO ATO: VISTOS. FLS. 356: TRATA-SE DE EMBARGOS DECLARATORIOS OPOSTOS PELA PARTE AUTORA CONTRA A SENTENCA DE FLS. 351/354. DECIDO. ASSISTE RAZAO A EMBARGANTE. COM EFEITO, A SENTENCA FOI OMISSA AO NAO APRECIAR A QUESTAO RELATIVA AO TITULO PROTESTADO. NESSA TOADA, ACLARO A SENTENCA DE FLS. 351/354, CUJO DISPOSITIVO PASSA A CONTAR COM A SEGUINTE REDACAO: \"ANTE O EXPOSTO, JULGO PARCIALMENTE PROCEDENTE A DEMANDA, PARA O FIM DE DECLARAR INEXIGIVEL A METADE DO DEBITO PROTESTADO, NO IMPORTE DE R$ 600,00, COM CONSEQUENTE CANCELAMENTO DO TITULO N 1557, RESOLVENDO O MERITO, COM FUNDAMENTO NO ART. 487, I, DO CPC\". NO MAIS, MANTENHO A SENTENCA COMO LANCADA. INT. ADVOGADOS(S): CAROLINE NITTO FERNANDES (OAB 276522/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2019-06-28T00:00:00",
                "CaptureDate": "2019-09-19T09:16:12"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0196/2019 TEOR DO ATO: VISTOS. FLS. 356: TRATA-SE DE EMBARGOS DECLARATORIOS OPOSTOS PELA PARTE AUTORA CONTRA A SENTENCA DE FLS. 351/354. DECIDO. ASSISTE RAZAO A EMBARGANTE. COM EFEITO, A SENTENCA FOI OMISSA AO NAO APRECIAR A QUESTAO RELATIVA AO TITULO PROTESTADO. NESSA TOADA, ACLARO A SENTENCA DE FLS. 351/354, CUJO DISPOSITIVO PASSA A CONTAR COM A SEGUINTE REDACAO: \"ANTE O EXPOSTO, JULGO PARCIALMENTE PROCEDENTE A DEMANDA, PARA O FIM DE DECLARAR INEXIGIVEL A METADE DO DEBITO PROTESTADO, NO IMPORTE DE R$ 600,00, COM CONSEQUENTE CANCELAMENTO DO TITULO N 1557, RESOLVENDO O MERITO, COM FUNDAMENTO NO ART. 487, I, DO CPC\". NO MAIS, MANTENHO A SENTENCA COMO LANCADA. INT. ADVOGADOS(S): CAROLINE NITTO FERNANDES (OAB 276522/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2019-06-28T00:00:00",
                "CaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Content": "EMBARGOS DE DECLARACAO ACOLHIDOS | VISTOS. FLS. 356: TRATA-SE DE EMBARGOS DECLARATORIOS OPOSTOS PELA PARTE AUTORA CONTRA A SENTENCA DE FLS. 351/354. DECIDO. ASSISTE RAZAO A EMBARGANTE. COM EFEITO, A SENTENCA FOI OMISSA AO NAO APRECIAR A QUESTAO RELATIVA AO TITULO PROTESTADO. NESSA TOADA, ACLARO A SENTENCA DE FLS. 351/354, CUJO DISPOSITIVO PASSA A CONTAR COM A SEGUINTE REDACAO: \"ANTE O EXPOSTO, JULGO PARCIALMENTE PROCEDENTE A DEMANDA, PARA O FIM DE DECLARAR INEXIGIVEL A METADE DO DEBITO PROTESTADO, NO IMPORTE DE R$ 600,00, COM CONSEQUENTE CANCELAMENTO DO TITULO N 1557, RESOLVENDO O MERITO, COM FUNDAMENTO NO ART. 487, I, DO CPC\". NO MAIS, MANTENHO A SENTENCA COMO LANCADA. INT.",
                "PublishDate": "2019-06-28T00:00:00",
                "CaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO |",
                "PublishDate": "2019-06-28T00:00:00",
                "CaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2019-06-28T00:00:00",
                "CaptureDate": "2021-11-18T05:08:35"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2019-06-24T00:00:00",
                "CaptureDate": "2019-09-19T09:15:53"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO |",
                "PublishDate": "2019-06-24T00:00:00",
                "CaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Content": "CERTIDAO DE CARTORIO EXPEDIDA CERTIDAO - GENERICA",
                "PublishDate": "2019-06-19T00:00:00",
                "CaptureDate": "2019-09-19T09:15:53"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2019-06-19T00:00:00",
                "CaptureDate": "2019-09-19T09:15:53"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO |",
                "PublishDate": "2019-06-19T00:00:00",
                "CaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Content": "CERTIDAO DE CARTORIO EXPEDIDA | CERTIDAO - GENERICA",
                "PublishDate": "2019-06-19T00:00:00",
                "CaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2019-06-19T00:00:00",
                "CaptureDate": "2021-11-18T05:08:35"
              },
              {
                "Content": "EMBARGOS DE DECLARACAO JUNTADOS N PROTOCOLO: WJMJ.19.40890549-0 TIPO DA PETICAO: EMBARGOS DE DECLARACAO DATA: 18/06/2019 14:44",
                "PublishDate": "2019-06-18T00:00:00",
                "CaptureDate": "2019-09-19T09:15:53"
              },
              {
                "Content": "EMBARGOS DE DECLARACAO JUNTADOS | N PROTOCOLO: WJMJ.19.40890549-0 TIPO DA PETICAO: EMBARGOS DE DECLARACAO DATA: 18/06/2019 14:44",
                "PublishDate": "2019-06-18T00:00:00",
                "CaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0171/2019 DATA DA DISPONIBILIZACAO: 10/06/2019 DATA DA PUBLICACAO: 11/06/2019 NUMERO DO DIARIO: 2826 PAGINA: 177/192",
                "PublishDate": "2019-06-10T00:00:00",
                "CaptureDate": "2019-09-19T09:15:53"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0171/2019 DATA DA DISPONIBILIZACAO: 10/06/2019 DATA DA PUBLICACAO: 11/06/2019 NUMERO DO DIARIO: 2826 PAGINA: 177/192",
                "PublishDate": "2019-06-10T00:00:00",
                "CaptureDate": "2019-09-19T09:15:53"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0171/2019 DATA DA DISPONIBILIZACAO: 10/06/2019 DATA DA PUBLICACAO: 11/06/2019 NUMERO DO DIARIO: 2826 PAGINA: 177/192",
                "PublishDate": "2019-06-10T00:00:00",
                "CaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0171/2019 DATA DA DISPONIBILIZACAO: 10/06/2019 DATA DA PUBLICACAO: 11/06/2019 NUMERO DO DIARIO: 2826 PAGINA: 177/192",
                "PublishDate": "2019-06-10T00:00:00",
                "CaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0171/2019 TEOR DO ATO: ANTE O EXPOSTO, JULGO PARCIALMENTE PROCEDENTE A DEMANDA, PARA O FIM DE DECLARAR INEXIGIVEL A METADE DO DEBITO PROTESTADO, NO IMPORTE DE R$ 600,00, RESOLVENDO O MERITO, COM FUNDAMENTO NO ART. 487, I, DO CPC. RECIPROCAMENTE SUCUMBENTES, CADA PARTE ARCARA COM O PAGAMENTO DAS CUSTAS PROCESSUAIS EM QUE INCORRERAM E HONORARIOS ADVOCATICIOS, ORA FIXADOS EM 10% SOBRE A DIFERENCA ENTRE O VALOR ATUALIZADO DA CAUSA E O PROVEITO ECONOMICO OBTIDO PELA AUTORA, PARA OS PATRONOS DA REQUERIDA; E EM R$ 400,00, AOS PATRONOS DA REQUERENTE, ATENTA AO GRAU DE ZELO, AO TEMPO DECORRIDO E A COMPLEXIDADE DA DEMANDA. OS HONORARIOS SERAO ATUALIZADOS A PARTIR DA DATA DA FIXACAO, PELOS INDICES DA TABELA PRATICA DO TRIBUNAL DE JUSTICA. SOBRE ELES INCIDIRAO JUROS MORATORIOS DE 1% AO MES A PARTIR DO TRANSITO EM JULGADO. P. R. I. ADVOGADOS(S): CAROLINE NITTO FERNANDES (OAB 276522/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2019-06-06T00:00:00",
                "CaptureDate": "2019-09-19T09:15:53"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0171/2019 TEOR DO ATO: ANTE O EXPOSTO, JULGO PARCIALMENTE PROCEDENTE A DEMANDA, PARA O FIM DE DECLARAR INEXIGIVEL A METADE DO DEBITO PROTESTADO, NO IMPORTE DE R$ 600,00, RESOLVENDO O MERITO, COM FUNDAMENTO NO ART. 487, I, DO CPC. RECIPROCAMENTE SUCUMBENTES, CADA PARTE ARCARA COM O PAGAMENTO DAS CUSTAS PROCESSUAIS EM QUE INCORRERAM E HONORARIOS ADVOCATICIOS, ORA FIXADOS EM 10% SOBRE A DIFERENCA ENTRE O VALOR ATUALIZADO DA CAUSA E O PROVEITO ECONOMICO OBTIDO PELA AUTORA, PARA OS PATRONOS DA REQUERIDA; E EM R$ 400,00, AOS PATRONOS DA REQUERENTE, ATENTA AO GRAU DE ZELO, AO TEMPO DECORRIDO E A COMPLEXIDADE DA DEMANDA. OS HONORARIOS SERAO ATUALIZADOS A PARTIR DA DATA DA FIXACAO, PELOS INDICES DA TABELA PRATICA DO TRIBUNAL DE JUSTICA. SOBRE ELES INCIDIRAO JUROS MORATORIOS DE 1% AO MES A PARTIR DO TRANSITO EM JULGADO. P. R. I. ADVOGADOS(S): CAROLINE NITTO FERNANDES (OAB 276522/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2019-06-06T00:00:00",
                "CaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Content": "FLS. 351 TRIBUNAL DE JUSTICA DO ESTADO DE SAO PAULO COMARCA DE SAO PAULO FORO CENTRAL CIVEL 8 VARA CIVEL SENTENCA PROCESSO N: 1117936-93.2018.8.26.0100 CLASSE - ASSUNTO PROCEDIMENTO COMUM CIVEL - PROTESTO INDEVIDO DE TITULO REQUERENTE: STARK BANK S.A. REQUERIDO: ADVISOR BOOKEEPING SERVICES LTDA. JUIZ(A) DE DIREITO: DR(A). VANESSA RIBEIRO MATEUS VISTOS. STARK BANK S.A. AJUIZOU ACAO DECLARATORIA DE INEXIGIBILIDADE DE DEBITO, CUMULADA COM DANOS MATERIAIS E MORAIS, EM FACE DE ADVISOR BOOKEEPING SERVICES LTDA. ADUZ, EM SINTESE, QUE A REQUERIDA FOI CONTRATADA PARA EFETUAR A TRANSFORMACAO SOCIETARIA DE UMA EIRELI EM S.A. APOS INICIADOS OS TRABALHOS, A RE DEIXOU DE CUMPRIR COM O OBJETO DE CONTRATO, ALEGANDO QUE NAO PODERIA SER FEITO MEDIANTE \"CAPA MARROM\", ASSIM COMO NAO PODERIA SER FEITO EM UMA UNICA FASE. A AUTORA, ENTAO, CONTRATOU EMPRESA TERCEIRA, QUE REALIZOU O SERVICO EXATAMENTE NESSES TERMOS, SEM UTILIZAR QUALQUER DOCUMENTO PROVIDENCIADO PELA RE. ALEGA QUE, MESMO NAO PRESTADO O SERVICO, A RE EFETUOU PROTESTO DO VALOR, O QUE TERIA OCASIONADO ABALO MORAL. REQUER A DECLARACAO DE INEXIGIBILIDADE DO VALOR PROTESTADO, INDENIZACAO POR DANOS MORAIS, E REPETICAO EM DOBRO DO INDEBITO. JUNTOU DOCUMENTOS (FLS. 13/103). DEFERIDA A LIMINAR PARA SUSTACAO DO PROTESTO (FLS. 107/108) A PARTE REQUERIDA, EM CONTESTACAO ENCARTADA A FLS. 115/125, ALEGA QUE SEGUIU OS PROCEDIMENTOS PREVISTOS NA LEGISLACAO E TECNICA CONTABIL, NAO HAVENDO PROVAS DO PROCEDIMENTO ADOTADO PELA EMPRESA TERCEIRA. SUSTENTA, 1117936-93.2018.8.26.0100 - LAUDA 1 ESTE DOCUMENTO E COPIA DO ORIGINAL, ASSINADO DIGITALMENTE POR VANESSA RIBEIRO MATEUS, LIBERADO NOS AUTOS EM 05/06/2019 AS 20:01 . PARA CONFERIR O ORIGINAL, ACESSE SITE HTTPS://ESAJ.TJSP.JUS.BR/PASTADIGITAL/PG/ABRIRCONFERENCIADOCUMENTO.DO, INFORME PROCESSO 1117936-93.2018.8.26.0100 E CODIGO 6C66777. FLS. 352 TRIBUNAL DE JUSTICA DO ESTADO DE SAO PAULO COMARCA DE SAO PAULO FORO CENTRAL CIVEL 8 VARA CIVEL AINDA, QUE A AUTORA REAPROVEITOU OS DOCUMENTOS ENVIADOS PELA REQUERIDA. REQUER A TOTAL IMPROCEDENCIA DA ACAO, E A CONDENACAO DA PARTE AUTORA A MULTA POR LITIGANCIA DE MA-FE. JUNTOU DOCUMENTOS (FLS. 126/280). HOUVE REPLICA (FLS. 283/294), COM DOCUMENTOS (FLS. 295/343). ASSIM OS AUTOS. DECIDO. A LIDE COMPORTA JULGAMENTO NO ESTADO, NOS TERMOS DO ART. 355, I, DO CPC, ESTANDO A MATERIA FATICA DEMONSTRADA PELA PROVA DOCUMENTAL CARREADA AOS AUTOS. PRESENTES AS CONDICOES DA ACAO E OS PRESSUPOSTOS PROCESSUAIS, PASSO A ANALISE DO MERITO. A EMPRESA AUTORA FIRMOU CONTRATO COM A RE COM A FINALIDADE DE PROMOVER SUA ALTERACAO SOCIETARIA, O QUE ENVOLVIA PROVIDENCIAS COM DOCUMENTACAO PARA REGULAR PROCEDIMENTO. NAO SE NEGA QUE A AUTORA TENHA CONTRATADO OUTRA EMPRESA QUE REALIZOU O MESMO SERVICO PROPOSTO PELA RE, DE FORMA MAIS CELERE. OCORRE QUE NAO SE DISCUTE, NESTES AUTOS, O METODO MAIS ADEQUADO PARA CONSECUCAO DO SERVICO, MAS SIM SE ESTE FOI, DE ALGUMA FORMA, PRESTADO OU NAO PELA REQUERIDA. QUANTO A ISSO, DE FATO, O OBJETIVO DA TRANSFORMACAO FOI EXECUTADO ANTES POR EMPRESA TERCEIRA, MAS ISSO NAO IMPLICA EM COMPLETA AUSENCIA DE PRESTACAO DE SERVICO PELA RE. PELO CONTRARIO, VERIFICA-SE QUE HOUVE ADIMPLEMENTO PARCIAL, NO QUE TANGE A PARTE DA DOCUMENTACAO NECESSARIA. VEJAMOS. 1117936-93.2018.8.26.0100 - LAUDA 2 ESTE DOCUMENTO E COPIA DO ORIGINAL, ASSINADO DIGITALMENTE POR VANESSA RIBEIRO MATEUS, LIBERADO NOS AUTOS EM 05/06/2019 AS 20:01 . PARA CONFERIR O ORIGINAL, ACESSE SITE HTTPS://ESAJ.TJSP.JUS.BR/PASTADIGITAL/PG/ABRIRCONFERENCIADOCUMENTO.DO, INFORME PROCESSO 1117936-93.2018.8.26.0100 E CODIGO 6C66777. FLS. 353 TRIBUNAL DE JUSTICA DO ESTADO DE SAO PAULO COMARCA DE SAO PAULO FORO CENTRAL CIVEL 8 VARA CIVEL LOGO NA INICIAL, A PROPRIA AUTORA ADMITE QUE A RE TERIA PROVIDENCIADO O \"DOCUMENTO BASICO DE ENTRADA\". AINDA QUE ARGUMENTE ESTAR INCORRETO, TAL FATO NAO RESTOU COMPROVADO, EIS QUE SEQUER JUNTADO O DBE AOS AUTOS. NAO BASTASSE, AS CONVERSAS ENTRE AS PARTES DEMONSTRAM QUE A AUTORA CHEGOU A RETIRAR DOCUMENTOS EMITIDOS PELA RE, COMO DEMONSTRA O PRINT DE FLS. 77, EM QUE AFIRMA QUE IRIA \"PEGAR A PAPELADA\". EMBORA SUSTENTE QUE OS DOCUMENTOS TERIAM SIDO PRODUZIDOS PELO ESCRITORIO DE ADVOCACIA, A TROCA DE E- MAILS DE FLS. 211/213 AFASTA TAL ARGUMENTO, NA MEDIDA EM QUE E A REQUERIDA QUE ENCAMINHA A VERSAO FINAL DO CONTRATO SOCIAL DA EMPRESA AUTORA. DE TODO O EXPOSTO, O QUE SE AFERE E QUE O CONTRATO COM A RE FOI ADMITIDO, NAO FOI RESCINDIDO E O SERVICO FOI PARCIALMENTE PRESTADO, AINDA QUE FINALIZADO POR TERCEIRO ALHEIO A RELACAO JURIDICA ORA DISCUTIDA, E DISSO DECORRE O DEVER DE EFETUAR A DEVIDA CONTRAPRESTACAO. ESTA, POR SUA VEZ, DEVE TER CORRELACAO COM O QUANTO EFETIVAMENTE PRESTADO, NAO SENDO CABIVEL A EXIGENCIA DE TODO O DEBITO QUANDO O SERVICO NAO TENHA SIDO INTEGRALMENTE REALIZADO, SOB PENA DE ENRIQUECIMENTO ILICITO. DIANTE DISSO, ENTENDO SER DEVIDA A METADE DO VALOR DO CONTRATO FIRMADO, MOTIVO PELO QUAL DECLARO INEXIGIVEL O RESTANTE DA DIVIDA COBRADA. NO MAIS, TENDO EM VISTA QUE A AUTORA ERA, DE FATO, DEVEDORA, AINDA QUE SOMENTE DE PARTE DO DEBITO, REPUTO LEGITIMA A COBRANCA EFETUADA PELA REQUERIDA, RAZAO PELA QUAL NAO HA QUE SE FALAR EM DANO MORAL, EIS QUE AUSENTE O ATO ILICITO. TAMBEM DESCABIDO O PLEITO DE REPETICAO DO INDEBITO. NADA HAVIA 1117936-93.2018.8.26.0100 - LAUDA 3 ESTE DOCUMENTO E COPIA DO ORIGINAL, ASSINADO DIGITALMENTE POR VANESSA RIBEIRO MATEUS, LIBERADO NOS AUTOS EM 05/06/2019 AS 20:01 . PARA CONFERIR O ORIGINAL, ACESSE SITE HTTPS://ESAJ.TJSP.JUS.BR/PASTADIGITAL/PG/ABRIRCONFERENCIADOCUMENTO.DO, INFORME PROCESSO 1117936-93.2018.8.26.0100 E CODIGO 6C66777. FLS. 354 TRIBUNAL DE JUSTICA DO ESTADO DE SAO PAULO COMARCA DE SAO PAULO FORO CENTRAL CIVEL 8 VARA CIVEL SIDO PAGO E NAO HOUVE MA-FE DA REQUERIDA EM EFETUAR A COBRANCA, ATE PORQUE FAZIA JUS AO PAGAMENTO, MESMO QUE NAO INTEGRAL. ANTE O EXPOSTO, JULGO PARCIALMENTE PROCEDENTE A DEMANDA, PARA O FIM DE DECLARAR INEXIGIVEL A METADE DO DEBITO PROTESTADO, NO IMPORTE DE R$ 600,00, RESOLVENDO O MERITO, COM FUNDAMENTO NO ART. 487, I, DO CPC. RECIPROCAMENTE SUCUMBENTES, CADA PARTE ARCARA COM O PAGAMENTO DAS CUSTAS PROCESSUAIS EM QUE INCORRERAM E HONORARIOS ADVOCATICIOS, ORA FIXADOS EM 10% SOBRE A DIFERENCA ENTRE O VALOR ATUALIZADO DA CAUSA E O PROVEITO ECONOMICO OBTIDO PELA AUTORA, PARA OS PATRONOS DA REQUERIDA; E EM R$ 400,00, AOS PATRONOS DA REQUERENTE, ATENTA AO GRAU DE ZELO, AO TEMPO DECORRIDO E A COMPLEXIDADE DA DEMANDA. OS HONORARIOS SERAO ATUALIZADOS A PARTIR DA DATA DA FIXACAO, PELOS INDICES DA TABELA PRATICA DO TRIBUNAL DE JUSTICA. SOBRE ELES INCIDIRAO JUROS MORATORIOS DE 1% AO MES A PARTIR DO TRANSITO EM JULGADO. P. R. I. SAO PAULO, 05 DE JUNHO DE 2019. VANESSA RIBEIRO MATEUS JUIZA DE DIREITO DOCUMENTO ASSINADO DIGITALMENTE NOS TERMOS DA LEI 11.419/2006, CONFORME IMPRESSAO A MARGEM DIREITA 1117936-93.2018.8.26.0100 - LAUDA 4 ESTE DOCUMENTO E COPIA DO ORIGINAL, ASSINADO DIGITALMENTE POR VANESSA RIBEIRO MATEUS, LIBERADO NOS AUTOS EM 05/06/2019 AS 20:01 . PARA CONFERIR O ORIGINAL, ACESSE SITE HTTPS://ESAJ.TJSP.JUS.BR/PASTADIGITAL/PG/ABRIRCONFERENCIADOCUMENTO.DO, INFORME PROCESSO 1117936-93.2018.8.26.0100 E CODIGO 6C66777.",
                "PublishDate": "2019-06-05T00:00:00",
                "CaptureDate": "2019-09-19T09:15:35"
              },
              {
                "Content": "JULGADA PROCEDENTE EM PARTE A ACAO | ANTE O EXPOSTO, JULGO PARCIALMENTE PROCEDENTE A DEMANDA, PARA O FIM DE DECLARAR INEXIGIVEL A METADE DO DEBITO PROTESTADO, NO IMPORTE DE R$ 600,00, RESOLVENDO O MERITO, COM FUNDAMENTO NO ART. 487, I, DO CPC. RECIPROCAMENTE SUCUMBENTES, CADA PARTE ARCARA COM O PAGAMENTO DAS CUSTAS PROCESSUAIS EM QUE INCORRERAM E HONORARIOS ADVOCATICIOS, ORA FIXADOS EM 10% SOBRE A DIFERENCA ENTRE O VALOR ATUALIZADO DA CAUSA E O PROVEITO ECONOMICO OBTIDO PELA AUTORA, PARA OS PATRONOS DA REQUERIDA; E EM R$ 400,00, AOS PATRONOS DA REQUERENTE, ATENTA AO GRAU DE ZELO, AO TEMPO DECORRIDO E A COMPLEXIDADE DA DEMANDA. OS HONORARIOS SERAO ATUALIZADOS A PARTIR DA DATA DA FIXACAO, PELOS INDICES DA TABELA PRATICA DO TRIBUNAL DE JUSTICA. SOBRE ELES INCIDIRAO JUROS MORATORIOS DE 1% AO MES A PARTIR DO TRANSITO EM JULGADO. P. R. I.",
                "PublishDate": "2019-06-05T00:00:00",
                "CaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Content": "CONCLUSOS PARA SENTENCA",
                "PublishDate": "2019-04-01T00:00:00",
                "CaptureDate": "2019-09-19T09:15:35"
              },
              {
                "Content": "CONCLUSOS PARA SENTENCA |",
                "PublishDate": "2019-04-01T00:00:00",
                "CaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2019-03-25T00:00:00",
                "CaptureDate": "2019-09-19T09:15:35"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO |",
                "PublishDate": "2019-03-25T00:00:00",
                "CaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2019-03-21T00:00:00",
                "CaptureDate": "2019-09-19T09:15:35"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO |",
                "PublishDate": "2019-03-21T00:00:00",
                "CaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.19.40368124-1 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 20/03/2019 14:01",
                "PublishDate": "2019-03-20T00:00:00",
                "CaptureDate": "2019-09-19T09:15:35"
              },
              {
                "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.19.40368124-1 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 20/03/2019 14:01",
                "PublishDate": "2019-03-20T00:00:00",
                "CaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Content": "SUSPENSAO DO PRAZO PRAZO REFERENTE AO USUARIO FOI ALTERADO PARA 28/03/2019 DEVIDO A ALTERACAO DA TABELA DE FERIADOS",
                "PublishDate": "2019-03-11T00:00:00",
                "CaptureDate": "2019-09-19T09:15:35"
              },
              {
                "Content": "SUSPENSAO DO PRAZO | PRAZO REFERENTE AO USUARIO FOI ALTERADO PARA 28/03/2019 DEVIDO A ALTERACAO DA TABELA DE FERIADOS",
                "PublishDate": "2019-03-11T00:00:00",
                "CaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Content": "PROCESSO 1117936-93.2018.8.26.0100 - PROCEDIMENTO COMUM CIVEL - PROTESTO INDEVIDO DE TITULO - STARK BANK S.A. - ADVISOR BOOKEEPING SERVICES LTDA. - CIENCIA A PARTE RE DA DOCUMENTACAO APRESENTADA COM A REPLICA (ART. 437, 1 , DO CODIGO DE PROCESSO CIVIL). - ADV: RAFAEL HIDEO NAZIMA (OAB 295443/SP), CAROLINE NITTO FERNANDES (OAB 276522/SP)",
                "PublishDate": "2019-03-01T00:00:00",
                "CaptureDate": "2019-03-06T22:44:53"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0058/2019 DATA DA DISPONIBILIZACAO: 01/03/2019 DATA DA PUBLICACAO: 06/03/2019 NUMERO DO DIARIO: 2760 PAGINA: 183/194",
                "PublishDate": "2019-03-01T00:00:00",
                "CaptureDate": "2019-03-06T22:45:09"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0058/2019 DATA DA DISPONIBILIZACAO: 01/03/2019 DATA DA PUBLICACAO: 06/03/2019 NUMERO DO DIARIO: 2760 PAGINA: 183/194",
                "PublishDate": "2019-03-01T00:00:00",
                "CaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0058/2019 TEOR DO ATO: CIENCIA A PARTE RE DA DOCUMENTACAO APRESENTADA COM A REPLICA (ART. 437, 1 , DO CODIGO DE PROCESSO CIVIL). ADVOGADOS(S): CAROLINE NITTO FERNANDES (OAB 276522/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2019-02-28T00:00:00",
                "CaptureDate": "2019-03-06T22:45:09"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0058/2019 TEOR DO ATO: CIENCIA A PARTE RE DA DOCUMENTACAO APRESENTADA COM A REPLICA (ART. 437, 1 , DO CODIGO DE PROCESSO CIVIL). ADVOGADOS(S): CAROLINE NITTO FERNANDES (OAB 276522/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2019-02-28T00:00:00",
                "CaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Content": "ATO ORDINATORIO CIENCIA A PARTE RE DA DOCUMENTACAO APRESENTADA COM A REPLICA (ART. 437, 1 , DO CODIGO DE PROCESSO CIVIL).",
                "PublishDate": "2019-02-27T00:00:00",
                "CaptureDate": "2019-03-06T22:45:09"
              },
              {
                "Content": "ATO ORDINATORIO | CIENCIA A PARTE RE DA DOCUMENTACAO APRESENTADA COM A REPLICA (ART. 437, 1 , DO CODIGO DE PROCESSO CIVIL).",
                "PublishDate": "2019-02-27T00:00:00",
                "CaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Content": "REPLICA JUNTADA N PROTOCOLO: WJMJ.19.40246549-9 TIPO DA PETICAO: MANIFESTACAO SOBRE A CONTESTACAO DATA: 25/02/2019 15:13",
                "PublishDate": "2019-02-25T00:00:00",
                "CaptureDate": "2019-03-06T22:45:09"
              },
              {
                "Content": "REPLICA JUNTADA | N PROTOCOLO: WJMJ.19.40246549-9 TIPO DA PETICAO: MANIFESTACAO SOBRE A CONTESTACAO DATA: 25/02/2019 15:13",
                "PublishDate": "2019-02-25T00:00:00",
                "CaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0019/2019 DATA DA DISPONIBILIZACAO: 01/02/2019 DATA DA PUBLICACAO: 04/02/2019 NUMERO DO DIARIO: 2740 PAGINA: 244/253",
                "PublishDate": "2019-02-01T00:00:00",
                "CaptureDate": "2019-03-06T22:45:09"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0019/2019 DATA DA DISPONIBILIZACAO: 01/02/2019 DATA DA PUBLICACAO: 04/02/2019 NUMERO DO DIARIO: 2740 PAGINA: 244/253",
                "PublishDate": "2019-02-01T00:00:00",
                "CaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Content": "SUSPENSAO DO PRAZO PRAZO REFERENTE AO USUARIO FOI ALTERADO PARA 23/01/2019 DEVIDO A ALTERACAO DA TABELA DE FERIADOS",
                "PublishDate": "2019-01-28T00:00:00",
                "CaptureDate": "2019-03-06T22:45:09"
              },
              {
                "Content": "SUSPENSAO DO PRAZO | PRAZO REFERENTE AO USUARIO FOI ALTERADO PARA 23/01/2019 DEVIDO A ALTERACAO DA TABELA DE FERIADOS",
                "PublishDate": "2019-01-28T00:00:00",
                "CaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Content": "ATO ORDINATORIO - REPLICA DA CONTESTACAO MANIFESTE-SE EM REPLICA, NO PRAZO LEGAL.",
                "PublishDate": "2019-01-22T00:00:00",
                "CaptureDate": "2019-03-06T22:45:09"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0019/2019 TEOR DO ATO: MANIFESTE-SE EM REPLICA, NO PRAZO LEGAL. ADVOGADOS(S): CAROLINE NITTO FERNANDES (OAB 276522/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2019-01-22T00:00:00",
                "CaptureDate": "2019-03-06T22:45:09"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0019/2019 TEOR DO ATO: MANIFESTE-SE EM REPLICA, NO PRAZO LEGAL. ADVOGADOS(S): CAROLINE NITTO FERNANDES (OAB 276522/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2019-01-22T00:00:00",
                "CaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Content": "ATO ORDINATORIO - REPLICA DA CONTESTACAO | MANIFESTE-SE EM REPLICA, NO PRAZO LEGAL.",
                "PublishDate": "2019-01-22T00:00:00",
                "CaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Content": "CONTESTACAO JUNTADA N PROTOCOLO: WJMJ.19.40045765-0 TIPO DA PETICAO: CONTESTACAO DATA: 21/01/2019 17:31",
                "PublishDate": "2019-01-21T00:00:00",
                "CaptureDate": "2019-03-06T22:45:09"
              },
              {
                "Content": "CONTESTACAO JUNTADA | N PROTOCOLO: WJMJ.19.40045765-0 TIPO DA PETICAO: CONTESTACAO DATA: 21/01/2019 17:31",
                "PublishDate": "2019-01-21T00:00:00",
                "CaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Content": "SUSPENSAO DO PRAZO PRAZO REFERENTE AO USUARIO FOI ALTERADO PARA 28/01/2019 DEVIDO A ALTERACAO DA TABELA DE FERIADOS PRAZO REFERENTE AO USUARIO FOI ALTERADO PARA 09/01/2019 DEVIDO A ALTERACAO DA TABELA DE FERIADOS",
                "PublishDate": "2018-12-30T00:00:00",
                "CaptureDate": "2019-03-06T22:45:09"
              },
              {
                "Content": "SUSPENSAO DO PRAZO | PRAZO REFERENTE AO USUARIO FOI ALTERADO PARA 28/01/2019 DEVIDO A ALTERACAO DA TABELA DE FERIADOS PRAZO REFERENTE AO USUARIO FOI ALTERADO PARA 09/01/2019 DEVIDO A ALTERACAO DA TABELA DE FERIADOS",
                "PublishDate": "2018-12-30T00:00:00",
                "CaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Content": "AR POSITIVO JUNTADO JUNTADA DE AR : AR937931786TJ SITUACAO : CUMPRIDO MODELO : PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC DESTINATARIO : ADVISOR BOOKEEPING SERVICES LTDA. DILIGENCIA : 28/11/2018",
                "PublishDate": "2018-12-01T00:00:00",
                "CaptureDate": "2019-03-06T22:45:09"
              },
              {
                "Content": "AR POSITIVO JUNTADO | JUNTADA DE AR : AR937931786TJ SITUACAO : CUMPRIDO MODELO : PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC DESTINATARIO : ADVISOR BOOKEEPING SERVICES LTDA. DILIGENCIA : 28/11/2018",
                "PublishDate": "2018-12-01T00:00:00",
                "CaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0394/2018 DATA DA DISPONIBILIZACAO: 26/11/2018 DATA DA PUBLICACAO: 27/11/2018 NUMERO DO DIARIO: 2704 PAGINA: 133/147",
                "PublishDate": "2018-11-26T00:00:00",
                "CaptureDate": "2019-03-06T22:45:09"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0394/2018 DATA DA DISPONIBILIZACAO: 26/11/2018 DATA DA PUBLICACAO: 27/11/2018 NUMERO DO DIARIO: 2704 PAGINA: 133/147",
                "PublishDate": "2018-11-26T00:00:00",
                "CaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.18.41582490-4 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 23/11/2018 16:49",
                "PublishDate": "2018-11-23T00:00:00",
                "CaptureDate": "2019-03-06T22:45:09"
              },
              {
                "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.18.41582490-4 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 23/11/2018 16:49",
                "PublishDate": "2018-11-23T00:00:00",
                "CaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0394/2018 TEOR DO ATO: VISTOS. GARANTIDO O JUIZO, DEFIRO O PEDIDO DE ANTECIPACAO DE TUTELA DE FLS. 104. O DIREITO ALEGADO E PROVAVEL NA MEDIDA QUE EXISTEM SERIAS DUVIDAS SOBRE A CULPA PELA RESCISAO DO CONTRATO CELEBRADO ENTRE AS PARTES. DE OUTRO LADO, EXISTE RISCO DE DANO GRAVE E IRREPARAVEL DECORRENTE DA NATUREZA DELETERIA DO PROTESTO. ANTE O EXPOSTO, DEFIRO A ANTECIPACAO DE TUTELA PARA DETERMINAR AO 8 TABELIAO DE PROTESTO DE LETRAS E TITULO DE SAO PAULO QUE SUSTE OU SUSPENDA OS EFEITOS DA ANOTACAO PROTOCOLADA SOB N 2018.10.31.0690-5 EM DESFAVOR DA AUTORA NO LIVRO N 6333, FL. 109. CONSIDERANDO A URGENCIA DA MEDIDA, A COMUNICACAO AO CARTORIO PODERA SER PROVIDENCIADA PELA PROPRIA PARTE, MEDIANTE A EXTRACAO DE COPIA DESTA DECISAO, QUE SERVIRA COMO OFICIO, POR MEIO DO SITIO ELETRONICO DO E. TRIBUNAL DE JUSTICA DE SAO PAULO, LOCAL ONDE, ALIAS, PODERA SER CONFERIDA A AUTENTICIDADE DA ASSINATURA DIGITAL DESTA MAGISTRADA. A DESPEITO DA PREVISAO DE DESIGNACAO DE AUDIENCIA DE CONCILIACAO OU DE MEDIACAO (ART. 334, CPC), TAL EXPEDIENTE, APLICADO DE FORMA PEREMPTORIA E INFLEXIVEL, IMPLICARA COLAPSO DO CEJUSC LOCAL E MESMO DA PAUTA DE AUDIENCIAS DESTE JUIZO, SEM CORRESPONDENTE GANHO EM CELERIDADE E EFETIVIDADE PROCESSUAIS. ASSIM, IMPERIOSO PONDERAR QUE E DEDUTIVEL DO NOVO SISTEMA A ATRIBUICAO AO JUIZ DE PODER GERAL DE ADAPTABILIDADE PROCEDIMENTAL AS ESPECIFICIDADES DO LITIGIO (ART. 139, VI, DO CPC), DE MODO QUE, NAO SE NOS MOSTRA PREJUDICIAL A QUALQUER DOS LITIGANTES OU MESMO AO OBJETIVO DA LEI, RELEGAR A SOLENIDADE PARA MOMENTO POSTERIOR. E ISTO SE FAZ EM CONSIDERACAO AO DEVER DO JUIZ DE VELAR PELA DURACAO RAZOAVEL DO PROCESSO E PELA POSSIBILIDADE DE PROMOVER A QUALQUER TEMPO, A AUTOCOMPOSICAO (ART. 139, II E V, CPC). POR ISSO, ATE QUE SEJA ESTRUTURADA DE FORMA EFICIENTE O SETOR DESTINADO A COMPOSICAO ENTRE OS LITIGANTES, POR ORA, DEIXO DE DESIGNAR AUDIENCIA, DESDE JA ALVITRANDO QUE A TENTATIVA DE COMPOSICAO SE DE APOS A FIXACAO DOS PONTOS CONTROVERTIDOS E ESTABILIZACAO DA DEMANDA, DE MODO MAIS EFICIENTE E PROVEITOSO. NESTES TERMOS, CITE-SE O REQUERIDO PARA QUERENDO CONTESTAR EM 15 DIAS (ARTS. 335, III, C.C. 231, CPC), SOB PENA DE SEREM PRESUMIDOS VERDADEIROS OS FATOS ALEGADOS NA INICIAL. INTIME-SE. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2018-11-22T00:00:00",
                "CaptureDate": "2019-03-06T22:45:09"
              },
              {
                "Content": "CARTA EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                "PublishDate": "2018-11-22T00:00:00",
                "CaptureDate": "2019-03-06T22:45:09"
              },
              {
                "Content": "FLS. 107 TRIBUNAL DE JUSTICA DO ESTADO DE SAO PAULO COMARCA DE SAO PAULO FORO CENTRAL CIVEL 8 VARA CIVEL PRACA JOAO MENDES S/N, 7 ANDAR - SALAS N 701/704, CENTRO - CEP 01501- 900, FONE: 2171-6101, SAO PAULO-SP - E-MAIL: SP8CV@TJSP.JUS.BR HORARIO DE ATENDIMENTO AO PUBLICO: DAS 12H30MIN AS19H00MIN DECISAO PROCESSO DIGITAL N: 1117936-93.2018.8.26.0100 CLASSE - ASSUNTO PROCEDIMENTO COMUM - PROTESTO INDEVIDO DE TITULO REQUERENTE: STARK BANK S.A. REQUERIDO: ADVISOR BOOKEEPING SERVICES LTDA. VISTOS. GARANTIDO O JUIZO, DEFIRO O PEDIDO DE ANTECIPACAO DE TUTELA DE FLS. 104. O DIREITO ALEGADO E PROVAVEL NA MEDIDA QUE EXISTEM SERIAS DUVIDAS SOBRE A CULPA PELA RESCISAO DO CONTRATO CELEBRADO ENTRE AS PARTES. DE OUTRO LADO, EXISTE RISCO DE DANO GRAVE E IRREPARAVEL DECORRENTE DA NATUREZA DELETERIA DO PROTESTO. ANTE O EXPOSTO, DEFIRO A ANTECIPACAO DE TUTELA PARA DETERMINAR AO 8 TABELIAO DE PROTESTO DE LETRAS E TITULO DE SAO PAULO QUE SUSTE OU SUSPENDA OS EFEITOS DA ANOTACAO PROTOCOLADA SOB N 2018.10.31.0690-5 EM DESFAVOR DA AUTORA NO LIVRO N 6333, FL. 109. CONSIDERANDO A URGENCIA DA MEDIDA, A COMUNICACAO AO CARTORIO PODERA SER PROVIDENCIADA PELA PROPRIA PARTE, MEDIANTE A EXTRACAO DE COPIA DESTA DECISAO, QUE SERVIRA COMO OFICIO, POR MEIO DO SITIO ELETRONICO DO E. TRIBUNAL DE JUSTICA DE SAO PAULO, LOCAL ONDE, ALIAS, PODERA SER CONFERIDA A AUTENTICIDADE DA ASSINATURA DIGITAL DESTA MAGISTRADA. A DESPEITO DA PREVISAO DE DESIGNACAO DE AUDIENCIA DE CONCILIACAO OU DE MEDIACAO (ART. 334, CPC), TAL EXPEDIENTE, APLICADO DE FORMA PEREMPTORIA E INFLEXIVEL, IMPLICARA COLAPSO DO CEJUSC LOCAL E MESMO DA PAUTA DE AUDIENCIAS DESTE JUIZO, SEM CORRESPONDENTE GANHO EM CELERIDADE E EFETIVIDADE PROCESSUAIS. ASSIM, IMPERIOSO PONDERAR QUE E DEDUTIVEL DO NOVO SISTEMA A ATRIBUICAO AO JUIZ DE PODER GERAL DE ADAPTABILIDADE PROCEDIMENTAL AS ESTE DOCUMENTO E COPIA DO ORIGINAL, ASSINADO DIGITALMENTE POR HELMER AUGUSTO TOQUETON AMARAL, LIBERADO NOS AUTOS EM 22/11/2018 AS 17:04 . PARA CONFERIR O ORIGINAL, ACESSE SITE HTTPS://ESAJ.TJSP.JUS.BR/PASTADIGITAL/PG/ABRIRCONFERENCIADOCUMENTO.DO, INFORME PROCESSO 1117936-93.2018.8.26.0100 E CODIGO 5FA5D29. FLS. 108 TRIBUNAL DE JUSTICA DO ESTADO DE SAO PAULO COMARCA DE SAO PAULO FORO CENTRAL CIVEL 8 VARA CIVEL PRACA JOAO MENDES S/N, 7 ANDAR - SALAS N 701/704, CENTRO - CEP 01501- 900, FONE: 2171-6101, SAO PAULO-SP - E-MAIL: SP8CV@TJSP.JUS.BR HORARIO DE ATENDIMENTO AO PUBLICO: DAS 12H30MIN AS19H00MIN ESPECIFICIDADES DO LITIGIO (ART. 139, VI, DO CPC), DE MODO QUE, NAO SE NOS MOSTRA PREJUDICIAL A QUALQUER DOS LITIGANTES OU MESMO AO OBJETIVO DA LEI, RELEGAR A SOLENIDADE PARA MOMENTO POSTERIOR. E ISTO SE FAZ EM CONSIDERACAO AO DEVER DO JUIZ DE VELAR PELA DURACAO RAZOAVEL DO PROCESSO E PELA POSSIBILIDADE DE PROMOVER A QUALQUER TEMPO, A AUTOCOMPOSICAO (ART. 139, II E V, CPC). POR ISSO, ATE QUE SEJA ESTRUTURADA DE FORMA EFICIENTE O SETOR DESTINADO A COMPOSICAO ENTRE OS LITIGANTES, POR ORA, DEIXO DE DESIGNAR AUDIENCIA, DESDE JA ALVITRANDO QUE A TENTATIVA DE COMPOSICAO SE DE APOS A FIXACAO DOS PONTOS CONTROVERTIDOS E ESTABILIZACAO DA DEMANDA, DE MODO MAIS EFICIENTE E PROVEITOSO. NESTES TERMOS, CITE-SE O REQUERIDO PARA QUERENDO CONTESTAR EM 15 DIAS (ARTS. 335, III, C.C. 231, CPC), SOB PENA DE SEREM PRESUMIDOS VERDADEIROS OS FATOS ALEGADOS NA INICIAL. INTIME-SE. SAO PAULO, 21 DE NOVEMBRO DE 2018. VANESSA RIBEIRO MATEUS JUIZ(A) DE DIREITO DOCUMENTO ASSINADO DIGITALMENTE NOS TERMOS DA LEI 11.419/2006, CONFORME IMPRESSAO A MARGEM DIREITA ESTE DOCUMENTO E COPIA DO ORIGINAL, ASSINADO DIGITALMENTE POR HELMER AUGUSTO TOQUETON AMARAL, LIBERADO NOS AUTOS EM 22/11/2018 AS 17:04 . PARA CONFERIR O ORIGINAL, ACESSE SITE HTTPS://ESAJ.TJSP.JUS.BR/PASTADIGITAL/PG/ABRIRCONFERENCIADOCUMENTO.DO, INFORME PROCESSO 1117936-93.2018.8.26.0100 E CODIGO 5FA5D29.",
                "PublishDate": "2018-11-22T00:00:00",
                "CaptureDate": "2019-03-06T22:44:53"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0394/2018 TEOR DO ATO: VISTOS. GARANTIDO O JUIZO, DEFIRO O PEDIDO DE ANTECIPACAO DE TUTELA DE FLS. 104. O DIREITO ALEGADO E PROVAVEL NA MEDIDA QUE EXISTEM SERIAS DUVIDAS SOBRE A CULPA PELA RESCISAO DO CONTRATO CELEBRADO ENTRE AS PARTES. DE OUTRO LADO, EXISTE RISCO DE DANO GRAVE E IRREPARAVEL DECORRENTE DA NATUREZA DELETERIA DO PROTESTO. ANTE O EXPOSTO, DEFIRO A ANTECIPACAO DE TUTELA PARA DETERMINAR AO 8 TABELIAO DE PROTESTO DE LETRAS E TITULO DE SAO PAULO QUE SUSTE OU SUSPENDA OS EFEITOS DA ANOTACAO PROTOCOLADA SOB N 2018.10.31.0690-5 EM DESFAVOR DA AUTORA NO LIVRO N 6333, FL. 109. CONSIDERANDO A URGENCIA DA MEDIDA, A COMUNICACAO AO CARTORIO PODERA SER PROVIDENCIADA PELA PROPRIA PARTE, MEDIANTE A EXTRACAO DE COPIA DESTA DECISAO, QUE SERVIRA COMO OFICIO, POR MEIO DO SITIO ELETRONICO DO E. TRIBUNAL DE JUSTICA DE SAO PAULO, LOCAL ONDE, ALIAS, PODERA SER CONFERIDA A AUTENTICIDADE DA ASSINATURA DIGITAL DESTA MAGISTRADA. A DESPEITO DA PREVISAO DE DESIGNACAO DE AUDIENCIA DE CONCILIACAO OU DE MEDIACAO (ART. 334, CPC), TAL EXPEDIENTE, APLICADO DE FORMA PEREMPTORIA E INFLEXIVEL, IMPLICARA COLAPSO DO CEJUSC LOCAL E MESMO DA PAUTA DE AUDIENCIAS DESTE JUIZO, SEM CORRESPONDENTE GANHO EM CELERIDADE E EFETIVIDADE PROCESSUAIS. ASSIM, IMPERIOSO PONDERAR QUE E DEDUTIVEL DO NOVO SISTEMA A ATRIBUICAO AO JUIZ DE PODER GERAL DE ADAPTABILIDADE PROCEDIMENTAL AS ESPECIFICIDADES DO LITIGIO (ART. 139, VI, DO CPC), DE MODO QUE, NAO SE NOS MOSTRA PREJUDICIAL A QUALQUER DOS LITIGANTES OU MESMO AO OBJETIVO DA LEI, RELEGAR A SOLENIDADE PARA MOMENTO POSTERIOR. E ISTO SE FAZ EM CONSIDERACAO AO DEVER DO JUIZ DE VELAR PELA DURACAO RAZOAVEL DO PROCESSO E PELA POSSIBILIDADE DE PROMOVER A QUALQUER TEMPO, A AUTOCOMPOSICAO (ART. 139, II E V, CPC). POR ISSO, ATE QUE SEJA ESTRUTURADA DE FORMA EFICIENTE O SETOR DESTINADO A COMPOSICAO ENTRE OS LITIGANTES, POR ORA, DEIXO DE DESIGNAR AUDIENCIA, DESDE JA ALVITRANDO QUE A TENTATIVA DE COMPOSICAO SE DE APOS A FIXACAO DOS PONTOS CONTROVERTIDOS E ESTABILIZACAO DA DEMANDA, DE MODO MAIS EFICIENTE E PROVEITOSO. NESTES TERMOS, CITE-SE O REQUERIDO PARA QUERENDO CONTESTAR EM 15 DIAS (ARTS. 335, III, C.C. 231, CPC), SOB PENA DE SEREM PRESUMIDOS VERDADEIROS OS FATOS ALEGADOS NA INICIAL. INTIME-SE. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2018-11-22T00:00:00",
                "CaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Content": "CARTA EXPEDIDA | PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                "PublishDate": "2018-11-22T00:00:00",
                "CaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Content": "RECEBIDA A PETICAO INICIAL | VISTOS. GARANTIDO O JUIZO, DEFIRO O PEDIDO DE ANTECIPACAO DE TUTELA DE FLS. 104. O DIREITO ALEGADO E PROVAVEL NA MEDIDA QUE EXISTEM SERIAS DUVIDAS SOBRE A CULPA PELA RESCISAO DO CONTRATO CELEBRADO ENTRE AS PARTES. DE OUTRO LADO, EXISTE RISCO DE DANO GRAVE E IRREPARAVEL DECORRENTE DA NATUREZA DELETERIA DO PROTESTO. ANTE O EXPOSTO, DEFIRO A ANTECIPACAO DE TUTELA PARA DETERMINAR AO 8 TABELIAO DE PROTESTO DE LETRAS E TITULO DE SAO PAULO QUE SUSTE OU SUSPENDA OS EFEITOS DA ANOTACAO PROTOCOLADA SOB N 2018.10.31.0690-5 EM DESFAVOR DA AUTORA NO LIVRO N 6333, FL. 109. CONSIDERANDO A URGENCIA DA MEDIDA, A COMUNICACAO AO CARTORIO PODERA SER PROVIDENCIADA PELA PROPRIA PARTE, MEDIANTE A EXTRACAO DE COPIA DESTA DECISAO, QUE SERVIRA COMO OFICIO, POR MEIO DO SITIO ELETRONICO DO E. TRIBUNAL DE JUSTICA DE SAO PAULO, LOCAL ONDE, ALIAS, PODERA SER CONFERIDA A AUTENTICIDADE DA ASSINATURA DIGITAL DESTA MAGISTRADA. A DESPEITO DA PREVISAO DE DESIGNACAO DE AUDIENCIA DE CONCILIACAO OU DE MEDIACAO (ART. 334, CPC), TAL EXPEDIENTE, APLICADO DE FORMA PEREMPTORIA E INFLEXIVEL, IMPLICARA COLAPSO DO CEJUSC LOCAL E MESMO DA PAUTA DE AUDIENCIAS DESTE JUIZO, SEM CORRESPONDENTE GANHO EM CELERIDADE E EFETIVIDADE PROCESSUAIS. ASSIM, IMPERIOSO PONDERAR QUE E DEDUTIVEL DO NOVO SISTEMA A ATRIBUICAO AO JUIZ DE PODER GERAL DE ADAPTABILIDADE PROCEDIMENTAL AS ESPECIFICIDADES DO LITIGIO (ART. 139, VI, DO CPC), DE MODO QUE, NAO SE NOS MOSTRA PREJUDICIAL A QUALQUER DOS LITIGANTES OU MESMO AO OBJETIVO DA LEI, RELEGAR A SOLENIDADE PARA MOMENTO POSTERIOR. E ISTO SE FAZ EM CONSIDERACAO AO DEVER DO JUIZ DE VELAR PELA DURACAO RAZOAVEL DO PROCESSO E PELA POSSIBILIDADE DE PROMOVER A QUALQUER TEMPO, A AUTOCOMPOSICAO (ART. 139, II E V, CPC). POR ISSO, ATE QUE SEJA ESTRUTURADA DE FORMA EFICIENTE O SETOR DESTINADO A COMPOSICAO ENTRE OS LITIGANTES, POR ORA, DEIXO DE DESIGNAR AUDIENCIA, DESDE JA ALVITRANDO QUE A TENTATIVA DE COMPOSICAO SE DE APOS A FIXACAO DOS PONTOS CONTROVERTIDOS E ESTABILIZACAO DA DEMANDA, DE MODO MAIS EFICIENTE E PROVEITOSO. NESTES TERMOS, CITE-SE O REQUERIDO PARA QUERENDO CONTESTAR EM 15 DIAS (ARTS. 335, III, C.C. 231, CPC), SOB PENA DE SEREM PRESUMIDOS VERDADEIROS OS FATOS ALEGADOS NA INICIAL. INTIME-SE.",
                "PublishDate": "2018-11-22T00:00:00",
                "CaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2018-11-21T00:00:00",
                "CaptureDate": "2019-03-06T22:44:53"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO |",
                "PublishDate": "2018-11-21T00:00:00",
                "CaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2018-11-16T00:00:00",
                "CaptureDate": "2019-03-06T22:44:53"
              },
              {
                "Content": "PEDIDO DE LIMINAR/TUTELA ANTECIPADA JUNTADO N PROTOCOLO: WJMJ.18.41553288-1 TIPO DA PETICAO: PEDIDO DE LIMINAR/ANTECIPACAO DE TUTELA DATA: 16/11/2018 01:19",
                "PublishDate": "2018-11-16T00:00:00",
                "CaptureDate": "2019-03-06T22:44:53"
              },
              {
                "Content": "PEDIDO DE LIMINAR/TUTELA ANTECIPADA JUNTADO | N PROTOCOLO: WJMJ.18.41553288-1 TIPO DA PETICAO: PEDIDO DE LIMINAR/ANTECIPACAO DE TUTELA DATA: 16/11/2018 01:19",
                "PublishDate": "2018-11-16T00:00:00",
                "CaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR) |",
                "PublishDate": "2018-11-16T00:00:00",
                "CaptureDate": "2019-11-20T04:24:38"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2018-11-16T00:00:00",
                "CaptureDate": "2021-11-18T05:08:35"
              }
            ],
            "Petitions": [
              {
                "Type": "PEDIDO DE LIMINAR/ANTECIPACAO DE TUTELA",
                "Author": "",
                "CreationDate": "2018-11-16T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2018-11-23T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "CONTESTACAO",
                "Author": "",
                "CreationDate": "2019-01-21T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "MANIFESTACAO SOBRE A CONTESTACAO",
                "Author": "",
                "CreationDate": "2019-02-25T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2019-03-20T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "EMBARGOS DE DECLARACAO",
                "Author": "",
                "CreationDate": "2019-06-18T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "RAZOES DE APELACAO",
                "Author": "",
                "CreationDate": "2019-07-25T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "CONTRARRAZOES DE APELACAO",
                "Author": "",
                "CreationDate": "2019-08-20T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "RAZOES DO RECURSO ADESIVO",
                "Author": "",
                "CreationDate": "2019-08-20T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "CONTRARRAZOES DO RECURSO ADESIVO",
                "Author": "",
                "CreationDate": "2019-09-16T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              }
            ],
            "Decisions": [
              {
                "DecisionContent": "JULGO PARCIALMENTE PROCEDENTE A DEMANDA, PARA O FIM DE DECLARAR INEXIGIVEL A METADE DO DEBITO PROTESTADO, NO IMPORTE DE R$ 600,00, COM CONSEQUENTE CANCELAMENTO DO TITULO N 1557, RESOLVENDO O MERITO, COM FUNDAMENTO NO ART. 487, I, DO CPC\".",
                "DecisionDate": "2019-06-28T00:00:00"
              },
              {
                "DecisionContent": "JULGO PARCIALMENTE PROCEDENTE A DEMANDA, PARA O FIM DE DECLARAR INEXIGIVEL A METADE DO DEBITO PROTESTADO, NO IMPORTE DE R$ 600,00, COM CONSEQUENTE CANCELAMENTO DO TITULO N 1557, RESOLVENDO O MERITO, COM FUNDAMENTO NO ART. 487, I, DO CPC\".",
                "DecisionDate": "2019-06-28T00:00:00"
              },
              {
                "DecisionContent": "JULGO PARCIALMENTE PROCEDENTE A DEMANDA, PARA O FIM DE DECLARAR INEXIGIVEL A METADE DO DEBITO PROTESTADO, NO IMPORTE DE R$ 600,00, RESOLVENDO O MERITO, COM FUNDAMENTO NO ART. 487, I, DO CPC.",
                "DecisionDate": "2019-06-06T00:00:00"
              },
              {
                "DecisionContent": "JULGO PARCIALMENTE PROCEDENTE A DEMANDA, PARA O FIM DE DECLARAR INEXIGIVEL A METADE DO DEBITO PROTESTADO, NO IMPORTE DE R$ 600,00, RESOLVENDO O MERITO, COM FUNDAMENTO NO ART. 487, I, DO CPC.",
                "DecisionDate": "2019-06-05T00:00:00"
              },
              {
                "DecisionContent": "JULGO PARCIALMENTE PROCEDENTE A DEMANDA, PARA O FIM DE DECLARAR INEXIGIVEL A METADE DO DEBITO PROTESTADO, NO IMPORTE DE R$ 600,00, RESOLVENDO O MERITO, COM FUNDAMENTO NO ART. 487, I, DO CPC.",
                "DecisionDate": "2019-06-05T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO O PEDIDO DE ANTECIPACAO DE TUTELA DE FLS. 104.",
                "DecisionDate": "2018-11-22T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO A ANTECIPACAO DE TUTELA PARA DETERMINAR AO 8 TABELIAO DE PROTESTO DE LETRAS E TITULO DE SAO PAULO QUE SUSTE OU SUSPENDA OS EFEITOS DA ANOTACAO PROTOCOLADA SOB N 2018.10.31.0690-5 EM DESFAVOR DA AUTORA NO LIVRO N 6333, FL. 109.",
                "DecisionDate": "2018-11-22T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO O PEDIDO DE ANTECIPACAO DE TUTELA DE FLS. 104.",
                "DecisionDate": "2018-11-22T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO A ANTECIPACAO DE TUTELA PARA DETERMINAR AO 8 TABELIAO DE PROTESTO DE LETRAS E TITULO DE SAO PAULO QUE SUSTE OU SUSPENDA OS EFEITOS DA ANOTACAO PROTOCOLADA SOB N 2018.10.31.0690-5 EM DESFAVOR DA AUTORA NO LIVRO N 6333, FL. 109.",
                "DecisionDate": "2018-11-22T00:00:00"
              }
            ]
          },
          {
            "Number": "00827387520198260100",
            "Type": "CUMPRIMENTO DE SENTENCA",
            "MainSubject": "PROTESTO INDEVIDO DE TITULO",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "SAO PAULO",
            "JudgingBody": "8 VARA CIVEL - FORO CENTRAL CIVEL",
            "State": "SP",
            "Status": "INDEFINIDO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "PROTESTO INDEVIDO DE TÍTULO",
            "InferredCNJSubjectNumber": 7781,
            "InferredCNJProcedureTypeName": "CUMPRIMENTO DE SENTENÇA",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "PROTESTO INDEVIDO DE TITULO"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": -1,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2020-03-10T00:00:00",
            "NoticeDate": "2019-11-22T00:00:00",
            "LastMovementDate": "2020-09-15T00:00:00",
            "CaptureDate": "2020-03-11T04:30:19",
            "LastUpdate": "2020-03-11T04:30:19",
            "NumberOfParties": 6,
            "NumberOfUpdates": 109,
            "LawSuitAge": 1559,
            "AverageNumberOfUpdatesPerMonth": 2,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "EXEQTE"
                },
                "LastCaptureDate": "2020-03-11T04:30:19"
              },
              {
                "Doc": "35068411817",
                "IsPartyActive": true,
                "Name": "RAFAEL HIDEO NAZIMA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "295443",
                  "State": "SP",
                  "SpecificType": "ADVOGADO REQUERENTE"
                },
                "LastCaptureDate": "2020-03-11T04:30:19"
              },
              {
                "IsPartyActive": true,
                "Name": "ADVISOR BOOKEEPING SERVICES LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "EXECTDO"
                },
                "LastCaptureDate": "2020-03-11T04:30:19"
              },
              {
                "Doc": "30915522845",
                "IsPartyActive": true,
                "Name": "CAROLINE NITTO FERNANDES",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "276522",
                  "State": "SP",
                  "SpecificType": "ADVOGADO REQUERIDO"
                },
                "LastCaptureDate": "2020-03-11T04:30:19"
              },
              {
                "Doc": "35068411817",
                "IsPartyActive": true,
                "Name": "RAFAEL HIDEO NAZIMA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "295443",
                  "State": "SP",
                  "SpecificType": "ADVOGADO"
                },
                "LastCaptureDate": "2020-03-11T04:30:19"
              },
              {
                "Doc": "30915522845",
                "IsPartyActive": true,
                "Name": "CAROLINE NITTO FERNANDES",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "276522",
                  "State": "SP",
                  "SpecificType": "ADVOGADO"
                },
                "LastCaptureDate": "2020-03-11T04:30:19"
              }
            ],
            "Updates": [
              {
                "Content": "CERTIDAO DE CARTORIO EXPEDIDA CERTIFICO E DOU FE QUE A TAXA JUDICIARIA (CUSTAS FINAIS) FOI RECOLHIDA, CONFORME GUIA SOB N 200590046856652 E 200590048388375, AS FLS. 107 E 113, E QUE EFETUEI A VINCULACAO DAREFERIDAGUIA AESTEPROCESSO, NO SISTEMA DO PORTAL DE CUSTAS, NO ACESSO \"RECOLHIMENTOS E DEPOSITOS\".",
                "PublishDate": "2020-09-15T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "ARQUIVADO DEFINITIVAMENTE",
                "PublishDate": "2020-09-15T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.20.41382065-3 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 07/09/2020 16:11",
                "PublishDate": "2020-09-07T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0235/2020 DATA DA DISPONIBILIZACAO: 02/09/2020 DATA DA PUBLICACAO: 03/09/2020 NUMERO DO DIARIO: 3119 PAGINA: 129/153",
                "PublishDate": "2020-09-02T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0235/2020 DATA DA DISPONIBILIZACAO: 02/09/2020 DATA DA PUBLICACAO: 03/09/2020 NUMERO DO DIARIO: 3119 PAGINA: 129/153",
                "PublishDate": "2020-09-02T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "PROCESSO 0082738-75.2019.8.26.0100 (PROCESSO PRINCIPAL 1117936-93.2018.8.26.0100) - CUMPRIMENTO DE SENTENCA - PROTESTO INDEVIDO DE TITULO - STARK BANK S.A. - ADVISOR BOOKEEPING SERVICES LTDA. - DEVE A PARTE REQUERIDA RECOLHER A DIFERENCA, OBSERVADO CALCULO JUNTADO A FLS 94. - ADV: RAFAEL HIDEO NAZIMA (OAB 295443/SP), CAROLINE NITTO FERNANDES (OAB 276522/SP)",
                "PublishDate": "2020-09-02T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "PEDIDO DE ARQUIVAMENTO JUNTADO N PROTOCOLO: WJMJ.20.41335088-6 TIPO DA PETICAO: PEDIDO DE ARQUIVAMENTO DATA: 31/08/2020 01:02",
                "PublishDate": "2020-08-31T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.20.41338806-9 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 31/08/2020 14:30",
                "PublishDate": "2020-08-31T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "ATO ORDINATORIO - PUBLICAVEL DEVE A PARTE REQUERIDA RECOLHER A DIFERENCA, OBSERVADO CALCULO JUNTADO A FLS 94.",
                "PublishDate": "2020-08-31T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0235/2020 TEOR DO ATO: DEVE A PARTE REQUERIDA RECOLHER A DIFERENCA, OBSERVADO CALCULO JUNTADO A FLS 94. ADVOGADOS(S): CAROLINE NITTO FERNANDES (OAB 276522/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-08-31T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0230/2020 DATA DA DISPONIBILIZACAO: 28/08/2020 DATA DA PUBLICACAO: 31/08/2020 NUMERO DO DIARIO: 3116 PAGINA: 183/197",
                "PublishDate": "2020-08-28T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "ATO ORDINATORIO - NAO PUBLICAVEL NA PRESENTE DATA ENCAMINHEI OS AUTOS A DIGITACAO/DATILOGRAFIA.",
                "PublishDate": "2020-08-28T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "PROCESSO 0082738-75.2019.8.26.0100 (PROCESSO PRINCIPAL 1117936-93.2018.8.26.0100) - CUMPRIMENTO DE SENTENCA - PROTESTO INDEVIDO DE TITULO - STARK BANK S.A. - ADVISOR BOOKEEPING SERVICES LTDA. - EXPEDIDO MANDADO DE LEVANTAMENTO ELETRONICO NO VALOR DE R$1.310,91, REFERENTE AO DEPOSITO DE FLS.105/106, EM FAVOR DE RAFAEL HIDEO NAZIMA, CONFORME DETERMINADO A FLS.96. - ADV: RAFAEL HIDEO NAZIMA (OAB 295443/SP), CAROLINE NITTO FERNANDES (OAB 276522/SP)",
                "PublishDate": "2020-08-28T00:00:00",
                "CaptureDate": "2020-09-24T07:54:33"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0230/2020 TEOR DO ATO: EXPEDIDO MANDADO DE LEVANTAMENTO ELETRONICO NO VALOR DE R$1.310,91, REFERENTE AO DEPOSITO DE FLS.105/106, EM FAVOR DE RAFAEL HIDEO NAZIMA, CONFORME DETERMINADO A FLS.96. ADVOGADOS(S): CAROLINE NITTO FERNANDES (OAB 276522/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-08-26T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0224/2020 DATA DA DISPONIBILIZACAO: 24/08/2020 DATA DA PUBLICACAO: 25/08/2020 NUMERO DO DIARIO: 3112 PAGINA: 115/131",
                "PublishDate": "2020-08-24T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "DOCUMENTO JUNTADO",
                "PublishDate": "2020-08-24T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "ATO ORDINATORIO - PUBLICAVEL EXPEDIDO MANDADO DE LEVANTAMENTO ELETRONICO NO VALOR DE R$1.310,91, REFERENTE AO DEPOSITO DE FLS.105/106, EM FAVOR DE RAFAEL HIDEO NAZIMA, CONFORME DETERMINADO A FLS.96.",
                "PublishDate": "2020-08-24T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "PROCESSO 0082738-75.2019.8.26.0100 (PROCESSO PRINCIPAL 1117936-93.2018.8.26.0100) - CUMPRIMENTO DE SENTENCA - PROTESTO INDEVIDO DE TITULO - STARK BANK S.A. - ADVISOR BOOKEEPING SERVICES LTDA. - VISTOS. 1 - FLS. 95: ANTE O SILENCIO DA PARTE EXECUTADA QUANTO AO RECOLHIMENTO DAS CUSTAS FINAIS, PROVIDENCIE-SE A SUA DEVIDA INSCRICAO EM DIVIDA ATIVA DA FAZENDA PUBLICA, NOS TERMOS DO ART. 1.098 DAS NSCGJ. 2 - AINDA EM RAZAO DO SILENCIO DA PARTE EXECUTADA, A QUAL FOI DEVIDAMENTE INTIMADA DOS EFEITOS DA SUA INERCIA, NOS TERMOS DO ITEM 3 DA SENTENCA DE FLS. 91, DEFIRO O LEVANTAMENTO DOS VALORES DEPOSITADOS A TITULO DE CAUCAO NA FASE DE CONHECIMENTO (FLS. 105/106) EM FAVOR DA PARTE EXEQUENTE. PROVIDENCIE A Z. SERVENTIA O NECESSARIO, OBSERVANDO-SE O FORMULARIO JUNTADO AS FLS. 77. 3 - OPORTUNAMENTE, NADA MAIS HAVENDO, ARQUIVEM-SE OS AUTOS, COM AS CAUTELAS DE PRAXE. INTIME-SE. - ADV: RAFAEL HIDEO NAZIMA (OAB 295443/SP), CAROLINE NITTO FERNANDES (OAB 276522/SP)",
                "PublishDate": "2020-08-24T00:00:00",
                "CaptureDate": "2020-09-26T11:09:22"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0224/2020 TEOR DO ATO: VISTOS. 1 - FLS. 95: ANTE O SILENCIO DA PARTE EXECUTADA QUANTO AO RECOLHIMENTO DAS CUSTAS FINAIS, PROVIDENCIE-SE A SUA DEVIDA INSCRICAO EM DIVIDA ATIVA DA FAZENDA PUBLICA, NOS TERMOS DO ART. 1.098 DAS NSCGJ. 2 - AINDA EM RAZAO DO SILENCIO DA PARTE EXECUTADA, A QUAL FOI DEVIDAMENTE INTIMADA DOS EFEITOS DA SUA INERCIA, NOS TERMOS DO ITEM 3 DA SENTENCA DE FLS. 91, DEFIRO O LEVANTAMENTO DOS VALORES DEPOSITADOS A TITULO DE CAUCAO NA FASE DE CONHECIMENTO (FLS. 105/106) EM FAVOR DA PARTE EXEQUENTE. PROVIDENCIE A Z. SERVENTIA O NECESSARIO, OBSERVANDO-SE O FORMULARIO JUNTADO AS FLS. 77. 3 - OPORTUNAMENTE, NADA MAIS HAVENDO, ARQUIVEM-SE OS AUTOS, COM AS CAUTELAS DE PRAXE. INTIME-SE. ADVOGADOS(S): CAROLINE NITTO FERNANDES (OAB 276522/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-08-21T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "ATO ORDINATORIO - NAO PUBLICAVEL NA PRESENTE DATA ENCAMINHEI OS AUTOS A DATILOGRAFIA PARA EXPEDICAO DE GUIA DE LEVANTAMENTO/MANDADO DE LEVANTAMENTO ELETRONICO. DEVERA O INTERESSADO AGUARDAR NOVA PUBLICACAO COM INTIMACAO PARA RETIRADA DA GUIA (MLJ)/CIENCIA DA EXPEDICAO (MLE).",
                "PublishDate": "2020-08-21T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "REALIZADO CALCULO DE CUSTAS",
                "PublishDate": "2020-08-20T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "CERTIDAO DE TRANSITO EM JULGADO COM BAIXA EXPEDIDA CERTIDAO - TRANSITO EM JULGADO COM BAIXA - PROCESSO DIGITAL",
                "PublishDate": "2020-08-20T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "TRANSITO EM JULGADO AS PARTES - COM BAIXA",
                "PublishDate": "2020-08-20T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2020-08-20T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2020-08-20T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "DECISAO VISTOS. 1 - FLS. 95: ANTE O SILENCIO DA PARTE EXECUTADA QUANTO AO RECOLHIMENTO DAS CUSTAS FINAIS, PROVIDENCIE-SE A SUA DEVIDA INSCRICAO EM DIVIDA ATIVA DA FAZENDA PUBLICA, NOS TERMOS DO ART. 1.098 DAS NSCGJ. 2 - AINDA EM RAZAO DO SILENCIO DA PARTE EXECUTADA, A QUAL FOI DEVIDAMENTE INTIMADA DOS EFEITOS DA SUA INERCIA, NOS TERMOS DO ITEM 3 DA SENTENCA DE FLS. 91, DEFIRO O LEVANTAMENTO DOS VALORES DEPOSITADOS A TITULO DE CAUCAO NA FASE DE CONHECIMENTO (FLS. 105/106) EM FAVOR DA PARTE EXEQUENTE. PROVIDENCIE A Z. SERVENTIA O NECESSARIO, OBSERVANDO-SE O FORMULARIO JUNTADO AS FLS. 77. 3 - OPORTUNAMENTE, NADA MAIS HAVENDO, ARQUIVEM-SE OS AUTOS, COM AS CAUTELAS DE PRAXE. INTIME-SE.",
                "PublishDate": "2020-08-20T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "PEDIDO DE EXPEDICAO DE MANDADO DE LEVANTAMENTO JUNTADO N PROTOCOLO: WJMJ.20.41038032-6 TIPO DA PETICAO: PEDIDO DE EXPEDICAO DE GUIA DE LEVANTAMENTO DATA: 17/07/2020 00:54",
                "PublishDate": "2020-07-17T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "SUSPENSAO DO PRAZO PRAZO REFERENTE AO USUARIO FOI ALTERADO PARA 11/09/2020 DEVIDO A ALTERACAO DA TABELA DE FERIADOS",
                "PublishDate": "2020-06-20T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "SUSPENSAO DO PRAZO PRAZO REFERENTE AO USUARIO FOI ALTERADO PARA 12/06/2020 DEVIDO A ALTERACAO DA TABELA DE FERIADOS",
                "PublishDate": "2020-05-31T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0137/2020 DATA DA DISPONIBILIZACAO: 15/05/2020 DATA DA PUBLICACAO: 18/05/2020 NUMERO DO DIARIO: 3044 PAGINA: 238/254",
                "PublishDate": "2020-05-15T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "PROCESSO 0082738-75.2019.8.26.0100 (PROCESSO PRINCIPAL 1117936-93.2018.8.26.0100) - CUMPRIMENTO DE SENTENCA - PROTESTO INDEVIDO DE TITULO - STARK BANK S.A. - ADVISOR BOOKEEPING SERVICES LTDA. - VISTOS. 1 - FLS. 83: DIANTE DA SATISFACAO DA OBRIGACAO, JULGO EXTINTA A EXECUCAO, COM FUNDAMENTO NO ARTIGO 924, INCISO II, DO CODIGO DE PROCESSO CIVIL. 2 - PROVIDENCIE A PARTE EXECUTADA O RECOLHIMENTO DAS CUSTAS FINAIS, EM GUIA PROPRIA, NO PRAZO DE 15 DIAS. DECORRIDO O PRAZO ASSINALADO, SEM O CUMPRIMENTO, EXPECA-SE CERTIDAO PARA INSCRICAO EM DIVIDA ATIVA, NOS TERMOS DO ART. 1.098 DAS NSCGJ. 3 - NO MAIS, MANIFESTE-SE A EXECUTADA, NO PRAZO DE CINCO DIAS, QUANTO AO PEDIDO FORMULADO AS FLS. 83 PARA LEVANTAMENTO DOS VALORES DEPOSITADOS A TITULO DE CAUCAO NA FASE DE CONHECIMENTO (FLS. 105/106), FICANDO DESDE JA CIENTE QUE SEU SILENCIO IMPORTARA ANUENCIA. P.R.I.C. - ADV: RAFAEL HIDEO NAZIMA (OAB 295443/SP), CAROLINE NITTO FERNANDES (OAB 276522/SP)",
                "PublishDate": "2020-05-15T00:00:00",
                "CaptureDate": "2020-10-12T22:15:00"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2020-05-13T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2020-05-13T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "EXTINTA A EXECUCAO/CUMPRIMENTO DA SENTENCA PELA SATISFACAO DA OBRIGACAO VISTOS. 1 - FLS. 83: DIANTE DA SATISFACAO DA OBRIGACAO, JULGO EXTINTA A EXECUCAO, COM FUNDAMENTO NO ARTIGO 924, INCISO II, DO CODIGO DE PROCESSO CIVIL. 2 - PROVIDENCIE A PARTE EXECUTADA O RECOLHIMENTO DAS CUSTAS FINAIS, EM GUIA PROPRIA, NO PRAZO DE 15 DIAS. DECORRIDO O PRAZO ASSINALADO, SEM O CUMPRIMENTO, EXPECA-SE CERTIDAO PARA INSCRICAO EM DIVIDA ATIVA, NOS TERMOS DO ART. 1.098 DAS NSCGJ. 3 - NO MAIS, MANIFESTE-SE A EXECUTADA, NO PRAZO DE CINCO DIAS, QUANTO AO PEDIDO FORMULADO AS FLS. 83 PARA LEVANTAMENTO DOS VALORES DEPOSITADOS A TITULO DE CAUCAO NA FASE DE CONHECIMENTO (FLS. 105/106), FICANDO DESDE JA CIENTE QUE SEU SILENCIO IMPORTARA ANUENCIA. P.R.I.C.",
                "PublishDate": "2020-05-13T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0137/2020 TEOR DO ATO: VISTOS. 1 - FLS. 83: DIANTE DA SATISFACAO DA OBRIGACAO, JULGO EXTINTA A EXECUCAO, COM FUNDAMENTO NO ARTIGO 924, INCISO II, DO CODIGO DE PROCESSO CIVIL. 2 - PROVIDENCIE A PARTE EXECUTADA O RECOLHIMENTO DAS CUSTAS FINAIS, EM GUIA PROPRIA, NO PRAZO DE 15 DIAS. DECORRIDO O PRAZO ASSINALADO, SEM O CUMPRIMENTO, EXPECA-SE CERTIDAO PARA INSCRICAO EM DIVIDA ATIVA, NOS TERMOS DO ART. 1.098 DAS NSCGJ. 3 - NO MAIS, MANIFESTE-SE A EXECUTADA, NO PRAZO DE CINCO DIAS, QUANTO AO PEDIDO FORMULADO AS FLS. 83 PARA LEVANTAMENTO DOS VALORES DEPOSITADOS A TITULO DE CAUCAO NA FASE DE CONHECIMENTO (FLS. 105/106), FICANDO DESDE JA CIENTE QUE SEU SILENCIO IMPORTARA ANUENCIA. P.R.I.C. ADVOGADOS(S): CAROLINE NITTO FERNANDES (OAB 276522/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-05-13T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0068/2020 DATA DA DISPONIBILIZACAO: 10/03/2020 DATA DA PUBLICACAO: 11/03/2020 NUMERO DO DIARIO: 3001 PAGINA: 118/142",
                "PublishDate": "2020-03-10T00:00:00",
                "CaptureDate": "2020-03-11T04:00:34"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0068/2020 DATA DA DISPONIBILIZACAO: 10/03/2020 DATA DA PUBLICACAO: 11/03/2020 NUMERO DO DIARIO: 3001 PAGINA: 118/142",
                "PublishDate": "2020-03-10T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0068/2020 TEOR DO ATO: FLS. 86: CIENCIA SOBRE O COMPROVANTE DE PAGAMENTO. ADVOGADOS(S): CAROLINE NITTO FERNANDES (OAB 276522/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-03-06T00:00:00",
                "CaptureDate": "2020-03-07T01:04:36"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0065/2020 DATA DA DISPONIBILIZACAO: 06/03/2020 DATA DA PUBLICACAO: 09/03/2020 NUMERO DO DIARIO: 2999 PAGINA: 193/219",
                "PublishDate": "2020-03-06T00:00:00",
                "CaptureDate": "2020-03-07T01:04:36"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0065/2020 DATA DA DISPONIBILIZACAO: 06/03/2020 DATA DA PUBLICACAO: 09/03/2020 NUMERO DO DIARIO: 2999 PAGINA: 193/219",
                "PublishDate": "2020-03-06T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0068/2020 TEOR DO ATO: FLS. 86: CIENCIA SOBRE O COMPROVANTE DE PAGAMENTO. ADVOGADOS(S): CAROLINE NITTO FERNANDES (OAB 276522/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-03-06T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "ATO ORDINATORIO | FLS. 86: CIENCIA SOBRE O COMPROVANTE DE PAGAMENTO.",
                "PublishDate": "2020-03-05T00:00:00",
                "CaptureDate": "2020-03-07T01:04:36"
              },
              {
                "Content": "ATO ORDINATORIO FLS. 86: CIENCIA SOBRE O COMPROVANTE DE PAGAMENTO.",
                "PublishDate": "2020-03-05T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0065/2020 TEOR DO ATO: VISTOS. 1 - COM A DEVIDA VENIA, NAO ASSISTE RAZAO AO PLEITO FORMULADO PELO EXEQUENTE AS FLS. 71/72. COM EFEITO, O MERO FATO DE TER GARANTIDO O JUIZO AO AJUIZAR O FEITO (AUTOS N 1117936-93.2018.8.26.0100, FASE DE CONHECIMENTO) NAO SIGNIFICA QUE TENHA EFETUADO O PAGAMENTO AO EXECUTADO DOS VALORES DEVIDOS EM RAZAO DO TITULO PROTESTADO, DESTACANDO-SE QUE, CONFORME DISPOE O ART. 308 DO CC, O PAGAMENTO DEVE SER FEITO AO CREDOR, NAO HAVENDO QUE SE FALAR NA GARANTIA DO JUIZO COMO FORMA DE PAGAMENTO. ASSIM, DEVE SER AFASTADA A INCIDENCIA DO ART. 940 DO CC, UMA VEZ QUE, AO AJUIZAR O CUMPRIMENTO DE SENTENCA EM APENSO (AUTOS N 0005867-67.2020.8.26.0100), A EXECUTADA NAO DEMANDOU POR DIVIDA JA PAGA. 2 - TENDO EM VISTA QUE AINDA NAO HOUVE O PAGAMENTO DO CUMPRIMENTO DO DEBITO PERSEGUIDO NO CUMPRIMENTO DE SENTENCA ACIMA MENCIONADO, INDEFIRO, POR ORA, O LEVANTAMENTO DOS VALORES DEPOSITADOS A TITULO DE GARANTIA DO JUIZO, OS QUAIS, NO CASO DE EVENTUAL INADIMPLENCIA DO EXEQUENTE, PODEM SER UTILIZADOS PARA SATISFACAO DA OBRIGACAO. 3 - NO MAIS, CONSIDERANDO-SE O PAGAMENTO EFETUADO AS FLS. 55/56, CUJO LEVANTAMENTO JA FOI DEFERIDO PELA DECISAO DE FLS. 64, CONSIDERANDO-SE AINDA QUE O PEDIDO PARA LEVANTAMENTO DOS VALORES DEPOSITADOS A TITULO DE GARANTIA DO JUIZO FOGE DOS ESTREITOS LIMITES DO PRESENTE CUMPRIMENTO DE SENTENCA, CONCEDO AO EXEQUENTE O PRAZO DE CINCO DIAS PARA INFORMAR SE CONSIDERA SATISFEITA A OBRIGACAO, FICANDO DESDE JA CIENTE QUE SEU SILENCIO IMPORTARA ANUENCIA, COM A CONSEQUENTE EXTINCAO PELA SATISFACAO DA OBRIGACA ADVOGADOS(S): CAROLINE NITTO FERNANDES (OAB 276522/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-03-04T00:00:00",
                "CaptureDate": "2020-03-07T01:04:36"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0065/2020 TEOR DO ATO: VISTOS. 1 - COM A DEVIDA VENIA, NAO ASSISTE RAZAO AO PLEITO FORMULADO PELO EXEQUENTE AS FLS. 71/72. COM EFEITO, O MERO FATO DE TER GARANTIDO O JUIZO AO AJUIZAR O FEITO (AUTOS N 1117936-93.2018.8.26.0100, FASE DE CONHECIMENTO) NAO SIGNIFICA QUE TENHA EFETUADO O PAGAMENTO AO EXECUTADO DOS VALORES DEVIDOS EM RAZAO DO TITULO PROTESTADO, DESTACANDO-SE QUE, CONFORME DISPOE O ART. 308 DO CC, O PAGAMENTO DEVE SER FEITO AO CREDOR, NAO HAVENDO QUE SE FALAR NA GARANTIA DO JUIZO COMO FORMA DE PAGAMENTO. ASSIM, DEVE SER AFASTADA A INCIDENCIA DO ART. 940 DO CC, UMA VEZ QUE, AO AJUIZAR O CUMPRIMENTO DE SENTENCA EM APENSO (AUTOS N 0005867-67.2020.8.26.0100), A EXECUTADA NAO DEMANDOU POR DIVIDA JA PAGA. 2 - TENDO EM VISTA QUE AINDA NAO HOUVE O PAGAMENTO DO CUMPRIMENTO DO DEBITO PERSEGUIDO NO CUMPRIMENTO DE SENTENCA ACIMA MENCIONADO, INDEFIRO, POR ORA, O LEVANTAMENTO DOS VALORES DEPOSITADOS A TITULO DE GARANTIA DO JUIZO, OS QUAIS, NO CASO DE EVENTUAL INADIMPLENCIA DO EXEQUENTE, PODEM SER UTILIZADOS PARA SATISFACAO DA OBRIGACAO. 3 - NO MAIS, CONSIDERANDO-SE O PAGAMENTO EFETUADO AS FLS. 55/56, CUJO LEVANTAMENTO JA FOI DEFERIDO PELA DECISAO DE FLS. 64, CONSIDERANDO-SE AINDA QUE O PEDIDO PARA LEVANTAMENTO DOS VALORES DEPOSITADOS A TITULO DE GARANTIA DO JUIZO FOGE DOS ESTREITOS LIMITES DO PRESENTE CUMPRIMENTO DE SENTENCA, CONCEDO AO EXEQUENTE O PRAZO DE CINCO DIAS PARA INFORMAR SE CONSIDERA SATISFEITA A OBRIGACAO, FICANDO DESDE JA CIENTE QUE SEU SILENCIO IMPORTARA ANUENCIA, COM A CONSEQUENTE EXTINCAO PELA SATISFACAO DA OBRIGACA ADVOGADOS(S): CAROLINE NITTO FERNANDES (OAB 276522/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-03-04T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "PEDIDO DE EXPEDICAO DE MANDADO DE LEVANTAMENTO JUNTADO | N PROTOCOLO: WJMJ.20.40302710-1 TIPO DA PETICAO: PEDIDO DE EXPEDICAO DE GUIA DE LEVANTAMENTO DATA: 03/03/2020 20:08",
                "PublishDate": "2020-03-03T00:00:00",
                "CaptureDate": "2020-03-07T01:04:36"
              },
              {
                "Content": "DECISAO | VISTOS. 1 - COM A DEVIDA VENIA, NAO ASSISTE RAZAO AO PLEITO FORMULADO PELO EXEQUENTE AS FLS. 71/72. COM EFEITO, O MERO FATO DE TER GARANTIDO O JUIZO AO AJUIZAR O FEITO (AUTOS N 1117936-93.2018.8.26.0100, FASE DE CONHECIMENTO) NAO SIGNIFICA QUE TENHA EFETUADO O PAGAMENTO AO EXECUTADO DOS VALORES DEVIDOS EM RAZAO DO TITULO PROTESTADO, DESTACANDO-SE QUE, CONFORME DISPOE O ART. 308 DO CC, O PAGAMENTO DEVE SER FEITO AO CREDOR, NAO HAVENDO QUE SE FALAR NA GARANTIA DO JUIZO COMO FORMA DE PAGAMENTO. ASSIM, DEVE SER AFASTADA A INCIDENCIA DO ART. 940 DO CC, UMA VEZ QUE, AO AJUIZAR O CUMPRIMENTO DE SENTENCA EM APENSO (AUTOS N 0005867-67.2020.8.26.0100), A EXECUTADA NAO DEMANDOU POR DIVIDA JA PAGA. 2 - TENDO EM VISTA QUE AINDA NAO HOUVE O PAGAMENTO DO CUMPRIMENTO DO DEBITO PERSEGUIDO NO CUMPRIMENTO DE SENTENCA ACIMA MENCIONADO, INDEFIRO, POR ORA, O LEVANTAMENTO DOS VALORES DEPOSITADOS A TITULO DE GARANTIA DO JUIZO, OS QUAIS, NO CASO DE EVENTUAL INADIMPLENCIA DO EXEQUENTE, PODEM SER UTILIZADOS PARA SATISFACAO DA OBRIGACAO. 3 - NO MAIS, CONSIDERANDO-SE O PAGAMENTO EFETUADO AS FLS. 55/56, CUJO LEVANTAMENTO JA FOI DEFERIDO PELA DECISAO DE FLS. 64, CONSIDERANDO-SE AINDA QUE O PEDIDO PARA LEVANTAMENTO DOS VALORES DEPOSITADOS A TITULO DE GARANTIA DO JUIZO FOGE DOS ESTREITOS LIMITES DO PRESENTE CUMPRIMENTO DE SENTENCA, CONCEDO AO EXEQUENTE O PRAZO DE CINCO DIAS PARA INFORMAR SE CONSIDERA SATISFEITA A OBRIGACAO, FICANDO DESDE JA CIENTE QUE SEU SILENCIO IMPORTARA ANUENCIA, COM A CONSEQUENTE EXTINCAO PELA SATISFACAO DA OBRIGACA",
                "PublishDate": "2020-03-03T00:00:00",
                "CaptureDate": "2020-03-07T01:04:36"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO |",
                "PublishDate": "2020-03-03T00:00:00",
                "CaptureDate": "2020-03-07T01:04:36"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2020-03-03T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "DECISAO VISTOS. 1 - COM A DEVIDA VENIA, NAO ASSISTE RAZAO AO PLEITO FORMULADO PELO EXEQUENTE AS FLS. 71/72. COM EFEITO, O MERO FATO DE TER GARANTIDO O JUIZO AO AJUIZAR O FEITO (AUTOS N 1117936-93.2018.8.26.0100, FASE DE CONHECIMENTO) NAO SIGNIFICA QUE TENHA EFETUADO O PAGAMENTO AO EXECUTADO DOS VALORES DEVIDOS EM RAZAO DO TITULO PROTESTADO, DESTACANDO-SE QUE, CONFORME DISPOE O ART. 308 DO CC, O PAGAMENTO DEVE SER FEITO AO CREDOR, NAO HAVENDO QUE SE FALAR NA GARANTIA DO JUIZO COMO FORMA DE PAGAMENTO. ASSIM, DEVE SER AFASTADA A INCIDENCIA DO ART. 940 DO CC, UMA VEZ QUE, AO AJUIZAR O CUMPRIMENTO DE SENTENCA EM APENSO (AUTOS N 0005867-67.2020.8.26.0100), A EXECUTADA NAO DEMANDOU POR DIVIDA JA PAGA. 2 - TENDO EM VISTA QUE AINDA NAO HOUVE O PAGAMENTO DO CUMPRIMENTO DO DEBITO PERSEGUIDO NO CUMPRIMENTO DE SENTENCA ACIMA MENCIONADO, INDEFIRO, POR ORA, O LEVANTAMENTO DOS VALORES DEPOSITADOS A TITULO DE GARANTIA DO JUIZO, OS QUAIS, NO CASO DE EVENTUAL INADIMPLENCIA DO EXEQUENTE, PODEM SER UTILIZADOS PARA SATISFACAO DA OBRIGACAO. 3 - NO MAIS, CONSIDERANDO-SE O PAGAMENTO EFETUADO AS FLS. 55/56, CUJO LEVANTAMENTO JA FOI DEFERIDO PELA DECISAO DE FLS. 64, CONSIDERANDO-SE AINDA QUE O PEDIDO PARA LEVANTAMENTO DOS VALORES DEPOSITADOS A TITULO DE GARANTIA DO JUIZO FOGE DOS ESTREITOS LIMITES DO PRESENTE CUMPRIMENTO DE SENTENCA, CONCEDO AO EXEQUENTE O PRAZO DE CINCO DIAS PARA INFORMAR SE CONSIDERA SATISFEITA A OBRIGACAO, FICANDO DESDE JA CIENTE QUE SEU SILENCIO IMPORTARA ANUENCIA, COM A CONSEQUENTE EXTINCAO PELA SATISFACAO DA OBRIGACA",
                "PublishDate": "2020-03-03T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "PEDIDO DE EXPEDICAO DE MANDADO DE LEVANTAMENTO JUNTADO N PROTOCOLO: WJMJ.20.40302710-1 TIPO DA PETICAO: PEDIDO DE EXPEDICAO DE GUIA DE LEVANTAMENTO DATA: 03/03/2020 20:08",
                "PublishDate": "2020-03-03T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO |",
                "PublishDate": "2020-02-21T00:00:00",
                "CaptureDate": "2020-03-07T01:04:36"
              },
              {
                "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.20.40250434-8 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 21/02/2020 10:19",
                "PublishDate": "2020-02-21T00:00:00",
                "CaptureDate": "2020-03-07T01:04:36"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.20.40250434-8 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 21/02/2020 10:19",
                "PublishDate": "2020-02-21T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2020-02-21T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0042/2020 DATA DA DISPONIBILIZACAO: 14/02/2020 DATA DA PUBLICACAO: 17/02/2020 NUMERO DO DIARIO: 2986 PAGINA: 135/156",
                "PublishDate": "2020-02-14T00:00:00",
                "CaptureDate": "2020-02-14T23:55:44"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0042/2020 DATA DA DISPONIBILIZACAO: 14/02/2020 DATA DA PUBLICACAO: 17/02/2020 NUMERO DO DIARIO: 2986 PAGINA: 135/156",
                "PublishDate": "2020-02-14T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0042/2020 TEOR DO ATO: SEM PREJUIZO DO PROSSEGUIMENTO DO INCIDENTE DE CUMPRIMENTO DE SENTENCA EM APENSO, MANIFESTE-SE A EXECUTADA QUANTO AS FLS. 71/77, NO PRAZO DE CINCO DIAS. APOS, CONCLUSOS PARA DECISAO. INTIME-SE. ADVOGADOS(S): CAROLINE NITTO FERNANDES (OAB 276522/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-02-12T00:00:00",
                "CaptureDate": "2020-02-14T23:55:44"
              },
              {
                "Content": "DECISAO | SEM PREJUIZO DO PROSSEGUIMENTO DO INCIDENTE DE CUMPRIMENTO DE SENTENCA EM APENSO, MANIFESTE-SE A EXECUTADA QUANTO AS FLS. 71/77, NO PRAZO DE CINCO DIAS. APOS, CONCLUSOS PARA DECISAO. INTIME-SE.",
                "PublishDate": "2020-02-12T00:00:00",
                "CaptureDate": "2020-02-14T23:55:44"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO |",
                "PublishDate": "2020-02-12T00:00:00",
                "CaptureDate": "2020-02-14T23:55:44"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2020-02-12T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "DECISAO SEM PREJUIZO DO PROSSEGUIMENTO DO INCIDENTE DE CUMPRIMENTO DE SENTENCA EM APENSO, MANIFESTE-SE A EXECUTADA QUANTO AS FLS. 71/77, NO PRAZO DE CINCO DIAS. APOS, CONCLUSOS PARA DECISAO. INTIME-SE.",
                "PublishDate": "2020-02-12T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0042/2020 TEOR DO ATO: SEM PREJUIZO DO PROSSEGUIMENTO DO INCIDENTE DE CUMPRIMENTO DE SENTENCA EM APENSO, MANIFESTE-SE A EXECUTADA QUANTO AS FLS. 71/77, NO PRAZO DE CINCO DIAS. APOS, CONCLUSOS PARA DECISAO. INTIME-SE. ADVOGADOS(S): CAROLINE NITTO FERNANDES (OAB 276522/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-02-12T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO |",
                "PublishDate": "2020-02-07T00:00:00",
                "CaptureDate": "2020-02-14T23:55:44"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2020-02-07T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "PEDIDO DE EXPEDICAO DE MANDADO DE LEVANTAMENTO JUNTADO | N PROTOCOLO: WJMJ.20.40158301-5 TIPO DA PETICAO: PEDIDO DE EXPEDIC??O DE GUIA DE LEVANTAMENTO DATA: 06/02/2020 19:11",
                "PublishDate": "2020-02-06T00:00:00",
                "CaptureDate": "2020-02-14T23:55:44"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0033/2020 DATA DA DISPONIBILIZACAO: 06/02/2020 DATA DA PUBLICACAO: 07/02/2020 NUMERO DO DIARIO: 2980 PAGINA: 123/139",
                "PublishDate": "2020-02-06T00:00:00",
                "CaptureDate": "2020-02-14T23:55:44"
              },
              {
                "Content": "PEDIDO DE EXPEDICAO DE MANDADO DE LEVANTAMENTO JUNTADO | N PROTOCOLO: WJMJ.20.40158301-5 TIPO DA PETICAO: PEDIDO DE EXPEDICAO DE GUIA DE LEVANTAMENTO DATA: 06/02/2020 19:11",
                "PublishDate": "2020-02-06T00:00:00",
                "CaptureDate": "2020-03-07T01:04:36"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0033/2020 DATA DA DISPONIBILIZACAO: 06/02/2020 DATA DA PUBLICACAO: 07/02/2020 NUMERO DO DIARIO: 2980 PAGINA: 123/139",
                "PublishDate": "2020-02-06T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "PEDIDO DE EXPEDICAO DE MANDADO DE LEVANTAMENTO JUNTADO N PROTOCOLO: WJMJ.20.40158301-5 TIPO DA PETICAO: PEDIDO DE EXPEDICAO DE GUIA DE LEVANTAMENTO DATA: 06/02/2020 19:11",
                "PublishDate": "2020-02-06T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0033/2020 TEOR DO ATO: EXPEDIDO MANDADO DE LEVANTAMENTO ELETRONICO NO VALOR DE R$6.354,80, REFERENTE AO DEPOSITO DE FLS.55/56, EM FAVOR DE RAFAEL HIDEO NAZIMA, CONFORME DETERMINADO A FLS.64. ADVOGADOS(S): CAROLINE NITTO FERNANDES (OAB 276522/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-02-04T00:00:00",
                "CaptureDate": "2020-02-14T23:55:44"
              },
              {
                "Content": "ATO ORDINATORIO - PUBLICAVEL | EXPEDIDO MANDADO DE LEVANTAMENTO ELETRONICO NO VALOR DE R$6.354,80, REFERENTE AO DEPOSITO DE FLS.55/56, EM FAVOR DE RAFAEL HIDEO NAZIMA, CONFORME DETERMINADO A FLS.64.",
                "PublishDate": "2020-02-04T00:00:00",
                "CaptureDate": "2020-02-14T23:55:44"
              },
              {
                "Content": "DOCUMENTO JUNTADO |",
                "PublishDate": "2020-02-04T00:00:00",
                "CaptureDate": "2020-02-14T23:55:44"
              },
              {
                "Content": "DOCUMENTO JUNTADO",
                "PublishDate": "2020-02-04T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "ATO ORDINATORIO - PUBLICAVEL EXPEDIDO MANDADO DE LEVANTAMENTO ELETRONICO NO VALOR DE R$6.354,80, REFERENTE AO DEPOSITO DE FLS.55/56, EM FAVOR DE RAFAEL HIDEO NAZIMA, CONFORME DETERMINADO A FLS.64.",
                "PublishDate": "2020-02-04T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0033/2020 TEOR DO ATO: EXPEDIDO MANDADO DE LEVANTAMENTO ELETRONICO NO VALOR DE R$6.354,80, REFERENTE AO DEPOSITO DE FLS.55/56, EM FAVOR DE RAFAEL HIDEO NAZIMA, CONFORME DETERMINADO A FLS.64. ADVOGADOS(S): CAROLINE NITTO FERNANDES (OAB 276522/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-02-04T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "ATO ORDINATORIO - NAO PUBLICAVEL | NA PRESENTE DATA ENCAMINHEI OS AUTOS A DATILOGRAFIA PARA EXPEDICAO DE GUIA DE LEVANTAMENTO/MANDADO DE LEVANTAMENTO ELETRONICO. DEVERA O INTERESSADO AGUARDAR NOVA PUBLICACAO COM INTIMACAO PARA RETIRADA DA GUIA (MLJ)/CIENCIA DA EXPEDICAO (MLE).",
                "PublishDate": "2020-01-30T00:00:00",
                "CaptureDate": "2020-01-31T00:54:45"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0023/2020 DATA DA DISPONIBILIZACAO: 30/01/2020 DATA DA PUBLICACAO: 31/01/2020 NUMERO DO DIARIO: 2975 PAGINA: 156/166",
                "PublishDate": "2020-01-30T00:00:00",
                "CaptureDate": "2020-01-31T00:54:45"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0023/2020 DATA DA DISPONIBILIZACAO: 30/01/2020 DATA DA PUBLICACAO: 31/01/2020 NUMERO DO DIARIO: 2975 PAGINA: 156/166",
                "PublishDate": "2020-01-30T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "ATO ORDINATORIO - NAO PUBLICAVEL NA PRESENTE DATA ENCAMINHEI OS AUTOS A DATILOGRAFIA PARA EXPEDICAO DE GUIA DE LEVANTAMENTO/MANDADO DE LEVANTAMENTO ELETRONICO. DEVERA O INTERESSADO AGUARDAR NOVA PUBLICACAO COM INTIMACAO PARA RETIRADA DA GUIA (MLJ)/CIENCIA DA EXPEDICAO (MLE).",
                "PublishDate": "2020-01-30T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0023/2020 TEOR DO ATO: VISTOS. 1 - TENDO EM VISTA QUE SE TRATA DE VALORES INCONTROVERSOS, DEFIRO A EXPEDICAO DE MANDADO DE LEVANTAMENTO, REFERENTE AOS VALORES DEPOSITADOS AS FLS. 55/56, EM FAVOR DO EXEQUENTE, OBSERVANDO-SE O FORMULARIO JUNTADO AS FLS. 62. PROVIDENCIE-SE O NECESSARIO. 2 - INDEFIRO OS PEDIDOS ELENCADOS PELO EXECUTADO AS FLS. 54, VEZ QUE DEVEM SER DEDUZIDOS POR MEIO DO RESPECTIVO INCIDENTE DE CUMPRIMENTO DE SENTENCA. 3 - FLS. 60/61: POR ORA, ESCLARECA A EXEQUENTE, NO PRAZO DE CINCO DIAS, O SEU PEDIDO DE LEVANTAMENTO DE VALORES DEPOSITADOS NA FASE DE CONHECIMENTO, O QUAL NAO FOI DEVIDAMENTE FUNDAMENTADO. INTIME-SE. ADVOGADOS(S): CAROLINE NITTO FERNANDES (OAB 276522/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-01-27T00:00:00",
                "CaptureDate": "2020-01-31T00:54:45"
              },
              {
                "Content": "DECISAO | VISTOS. 1 - TENDO EM VISTA QUE SE TRATA DE VALORES INCONTROVERSOS, DEFIRO A EXPEDICAO DE MANDADO DE LEVANTAMENTO, REFERENTE AOS VALORES DEPOSITADOS AS FLS. 55/56, EM FAVOR DO EXEQUENTE, OBSERVANDO-SE O FORMULARIO JUNTADO AS FLS. 62. PROVIDENCIE-SE O NECESSARIO. 2 - INDEFIRO OS PEDIDOS ELENCADOS PELO EXECUTADO AS FLS. 54, VEZ QUE DEVEM SER DEDUZIDOS POR MEIO DO RESPECTIVO INCIDENTE DE CUMPRIMENTO DE SENTENCA. 3 - FLS. 60/61: POR ORA, ESCLARECA A EXEQUENTE, NO PRAZO DE CINCO DIAS, O SEU PEDIDO DE LEVANTAMENTO DE VALORES DEPOSITADOS NA FASE DE CONHECIMENTO, O QUAL NAO FOI DEVIDAMENTE FUNDAMENTADO. INTIME-SE.",
                "PublishDate": "2020-01-27T00:00:00",
                "CaptureDate": "2020-01-31T00:54:45"
              },
              {
                "Content": "DECISAO VISTOS. 1 - TENDO EM VISTA QUE SE TRATA DE VALORES INCONTROVERSOS, DEFIRO A EXPEDICAO DE MANDADO DE LEVANTAMENTO, REFERENTE AOS VALORES DEPOSITADOS AS FLS. 55/56, EM FAVOR DO EXEQUENTE, OBSERVANDO-SE O FORMULARIO JUNTADO AS FLS. 62. PROVIDENCIE-SE O NECESSARIO. 2 - INDEFIRO OS PEDIDOS ELENCADOS PELO EXECUTADO AS FLS. 54, VEZ QUE DEVEM SER DEDUZIDOS POR MEIO DO RESPECTIVO INCIDENTE DE CUMPRIMENTO DE SENTENCA. 3 - FLS. 60/61: POR ORA, ESCLARECA A EXEQUENTE, NO PRAZO DE CINCO DIAS, O SEU PEDIDO DE LEVANTAMENTO DE VALORES DEPOSITADOS NA FASE DE CONHECIMENTO, O QUAL NAO FOI DEVIDAMENTE FUNDAMENTADO. INTIME-SE.",
                "PublishDate": "2020-01-27T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0023/2020 TEOR DO ATO: VISTOS. 1 - TENDO EM VISTA QUE SE TRATA DE VALORES INCONTROVERSOS, DEFIRO A EXPEDICAO DE MANDADO DE LEVANTAMENTO, REFERENTE AOS VALORES DEPOSITADOS AS FLS. 55/56, EM FAVOR DO EXEQUENTE, OBSERVANDO-SE O FORMULARIO JUNTADO AS FLS. 62. PROVIDENCIE-SE O NECESSARIO. 2 - INDEFIRO OS PEDIDOS ELENCADOS PELO EXECUTADO AS FLS. 54, VEZ QUE DEVEM SER DEDUZIDOS POR MEIO DO RESPECTIVO INCIDENTE DE CUMPRIMENTO DE SENTENCA. 3 - FLS. 60/61: POR ORA, ESCLARECA A EXEQUENTE, NO PRAZO DE CINCO DIAS, O SEU PEDIDO DE LEVANTAMENTO DE VALORES DEPOSITADOS NA FASE DE CONHECIMENTO, O QUAL NAO FOI DEVIDAMENTE FUNDAMENTADO. INTIME-SE. ADVOGADOS(S): CAROLINE NITTO FERNANDES (OAB 276522/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-01-27T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO |",
                "PublishDate": "2020-01-24T00:00:00",
                "CaptureDate": "2020-01-31T00:54:45"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO |",
                "PublishDate": "2020-01-24T00:00:00",
                "CaptureDate": "2020-01-31T00:54:45"
              },
              {
                "Content": "PEDIDO DE EXPEDICAO DE MANDADO DE LEVANTAMENTO JUNTADO | N PROTOCOLO: WJMJ.20.40068549-3 TIPO DA PETICAO: PEDIDO DE EXPEDICAO DE GUIA DE LEVANTAMENTO DATA: 24/01/2020 00:54",
                "PublishDate": "2020-01-24T00:00:00",
                "CaptureDate": "2020-01-31T00:54:45"
              },
              {
                "Content": "PEDIDO DE EXPEDICAO DE MANDADO DE LEVANTAMENTO JUNTADO N PROTOCOLO: WJMJ.20.40068549-3 TIPO DA PETICAO: PEDIDO DE EXPEDICAO DE GUIA DE LEVANTAMENTO DATA: 24/01/2020 00:54",
                "PublishDate": "2020-01-24T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2020-01-24T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2020-01-24T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0408/2019 DATA DA DISPONIBILIZACAO: 17/12/2019 DATA DA PUBLICACAO: 18/12/2019 NUMERO DO DIARIO: 2955 PAGINA: 95/108",
                "PublishDate": "2019-12-17T00:00:00",
                "CaptureDate": "2019-12-18T03:13:35"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0408/2019 DATA DA DISPONIBILIZACAO: 17/12/2019 DATA DA PUBLICACAO: 18/12/2019 NUMERO DO DIARIO: 2955 PAGINA: 95/108",
                "PublishDate": "2019-12-17T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0408/2019 TEOR DO ATO: FLS. 55: CIENCIA SOBRE O COMPROVANTE DE PAGAMENTO. ADVOGADOS(S): CAROLINE NITTO FERNANDES (OAB 276522/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2019-12-13T00:00:00",
                "CaptureDate": "2019-12-18T03:13:35"
              },
              {
                "Content": "ATO ORDINATORIO | FLS. 55: CIENCIA SOBRE O COMPROVANTE DE PAGAMENTO.",
                "PublishDate": "2019-12-13T00:00:00",
                "CaptureDate": "2019-12-18T03:13:35"
              },
              {
                "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.19.41956020-1 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 13/12/2019 09:42",
                "PublishDate": "2019-12-13T00:00:00",
                "CaptureDate": "2019-12-18T03:13:35"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.19.41956020-1 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 13/12/2019 09:42",
                "PublishDate": "2019-12-13T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "ATO ORDINATORIO FLS. 55: CIENCIA SOBRE O COMPROVANTE DE PAGAMENTO.",
                "PublishDate": "2019-12-13T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0408/2019 TEOR DO ATO: FLS. 55: CIENCIA SOBRE O COMPROVANTE DE PAGAMENTO. ADVOGADOS(S): CAROLINE NITTO FERNANDES (OAB 276522/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2019-12-13T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0386/2019 DATA DA DISPONIBILIZACAO: 27/11/2019 DATA DA PUBLICACAO: 28/11/2019 NUMERO DO DIARIO: 2941 PAGINA: 155/173",
                "PublishDate": "2019-11-27T00:00:00",
                "CaptureDate": "2019-11-28T01:27:59"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0386/2019 DATA DA DISPONIBILIZACAO: 27/11/2019 DATA DA PUBLICAC??O: 28/11/2019 NUMERO DO DIARIO: 2941 PAGINA: 155/173",
                "PublishDate": "2019-11-27T00:00:00",
                "CaptureDate": "2020-01-31T00:54:45"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0386/2019 DATA DA DISPONIBILIZACAO: 27/11/2019 DATA DA PUBLICACAO: 28/11/2019 NUMERO DO DIARIO: 2941 PAGINA: 155/173",
                "PublishDate": "2019-11-27T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0386/2019 TEOR DO ATO: FICA O EXECUTADO INTIMADO EM EXECUCAO, NOS TERMOS DO ART. 523, DO CODIGO DE PROCESSO CIVIL, PARA QUE REALIZE O PAGAMENTO DO MONTANTE DE R$ 6.354,80 EM 15 DIAS, SOB PENA DE MULTA DE 10% SOBRE O VALOR DO DEBITO E HONORARIOS SUCUMBENCIAIS DE 10%. ADVOGADOS(S): CAROLINE NITTO FERNANDES (OAB 276522/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2019-11-26T00:00:00",
                "CaptureDate": "2019-11-28T01:27:59"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0386/2019 TEOR DO ATO: FICA O EXECUTADO INTIMADO EM EXECUCAO, NOS TERMOS DO ART. 523, DO CODIGO DE PROCESSO CIVIL, PARA QUE REALIZE O PAGAMENTO DO MONTANTE DE R$ 6.354,80 EM 15 DIAS, SOB PENA DE MULTA DE 10% SOBRE O VALOR DO DEBITO E HONORARIOS SUCUMBENCIAIS DE 10%. ADVOGADOS(S): CAROLINE NITTO FERNANDES (OAB 276522/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2019-11-26T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "ATO ORDINATORIO | FICA O EXECUTADO INTIMADO EM EXECUCAO, NOS TERMOS DO ART. 523, DO CODIGO DE PROCESSO CIVIL, PARA QUE REALIZE O PAGAMENTO DO MONTANTE DE R$ 6.354,80 EM 15 DIAS, SOB PENA DE MULTA DE 10% SOBRE O VALOR DO DEBITO E HONORARIOS SUCUMBENCIAIS DE 10%.",
                "PublishDate": "2019-11-25T00:00:00",
                "CaptureDate": "2019-11-28T01:27:59"
              },
              {
                "Content": "CERTIDAO DE CARTORIO EXPEDIDA | CERTIDAO - GENERICA",
                "PublishDate": "2019-11-25T00:00:00",
                "CaptureDate": "2019-11-28T01:27:59"
              },
              {
                "Content": "CERTIDAO DE CARTORIO EXPEDIDA CERTIDAO - GENERICA",
                "PublishDate": "2019-11-25T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "ATO ORDINATORIO FICA O EXECUTADO INTIMADO EM EXECUCAO, NOS TERMOS DO ART. 523, DO CODIGO DE PROCESSO CIVIL, PARA QUE REALIZE O PAGAMENTO DO MONTANTE DE R$ 6.354,80 EM 15 DIAS, SOB PENA DE MULTA DE 10% SOBRE O VALOR DO DEBITO E HONORARIOS SUCUMBENCIAIS DE 10%.",
                "PublishDate": "2019-11-25T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              },
              {
                "Content": "INICIO DA EXECUCAO JUNTADO | PROCESSO PRINCIPAL: 1117936-93.2018.8.26.0100",
                "PublishDate": "2019-11-22T00:00:00",
                "CaptureDate": "2019-11-28T01:27:59"
              },
              {
                "Content": "INICIO DA EXECUCAO JUNTADO PROCESSO PRINCIPAL: 1117936-93.2018.8.26.0100",
                "PublishDate": "2019-11-22T00:00:00",
                "CaptureDate": "2020-09-23T11:35:10"
              }
            ],
            "Petitions": [
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2019-12-13T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PEDIDO DE EXPEDICAO DE GUIA DE LEVANTAMENTO",
                "Author": "",
                "CreationDate": "2020-01-24T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PEDIDO DE EXPEDICAO DE GUIA DE LEVANTAMENTO",
                "Author": "",
                "CreationDate": "2020-02-06T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2020-02-21T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PEDIDO DE EXPEDICAO DE GUIA DE LEVANTAMENTO",
                "Author": "",
                "CreationDate": "2020-03-03T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PEDIDO DE EXPEDICAO DE GUIA DE LEVANTAMENTO",
                "Author": "",
                "CreationDate": "2020-07-17T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PEDIDO DE ARQUIVAMENTO",
                "Author": "",
                "CreationDate": "2020-08-31T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2020-08-31T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2020-09-07T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              }
            ],
            "Decisions": [
              {
                "DecisionContent": "DEFIRO O LEVANTAMENTO DOS VALORES DEPOSITADOS A TITULO DE CAUCAO NA FASE DE CONHECIMENTO (FLS. 105/106) EM FAVOR DA PARTE EXEQUENTE.",
                "DecisionDate": "2020-08-24T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO O LEVANTAMENTO DOS VALORES DEPOSITADOS A TITULO DE CAUCAO NA FASE DE CONHECIMENTO (FLS. 105/106) EM FAVOR DA PARTE EXEQUENTE.",
                "DecisionDate": "2020-08-21T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO O LEVANTAMENTO DOS VALORES DEPOSITADOS A TITULO DE CAUCAO NA FASE DE CONHECIMENTO (FLS. 105/106) EM FAVOR DA PARTE EXEQUENTE.",
                "DecisionDate": "2020-08-20T00:00:00"
              },
              {
                "DecisionContent": "JULGO EXTINTA A EXECUCAO, COM FUNDAMENTO NO ARTIGO 924, INCISO II, DO CODIGO DE PROCESSO CIVIL.",
                "DecisionDate": "2020-05-15T00:00:00"
              },
              {
                "DecisionContent": "JULGO EXTINTA A EXECUCAO, COM FUNDAMENTO NO ARTIGO 924, INCISO II, DO CODIGO DE PROCESSO CIVIL.",
                "DecisionDate": "2020-05-13T00:00:00"
              },
              {
                "DecisionContent": "JULGO EXTINTA A EXECUCAO, COM FUNDAMENTO NO ARTIGO 924, INCISO II, DO CODIGO DE PROCESSO CIVIL.",
                "DecisionDate": "2020-05-13T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO A EXPEDICAO DE MANDADO DE LEVANTAMENTO, REFERENTE AOS VALORES DEPOSITADOS AS FLS. 55/56, EM FAVOR DO EXEQUENTE, OBSERVANDO-SE O FORMULARIO JUNTADO AS FLS. 62.",
                "DecisionDate": "2020-01-27T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO A EXPEDICAO DE MANDADO DE LEVANTAMENTO, REFERENTE AOS VALORES DEPOSITADOS AS FLS. 55/56, EM FAVOR DO EXEQUENTE, OBSERVANDO-SE O FORMULARIO JUNTADO AS FLS. 62.",
                "DecisionDate": "2020-01-27T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO A EXPEDICAO DE MANDADO DE LEVANTAMENTO, REFERENTE AOS VALORES DEPOSITADOS AS FLS. 55/56, EM FAVOR DO EXEQUENTE, OBSERVANDO-SE O FORMULARIO JUNTADO AS FLS. 62.",
                "DecisionDate": "2020-01-27T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO A EXPEDICAO DE MANDADO DE LEVANTAMENTO, REFERENTE AOS VALORES DEPOSITADOS AS FLS. 55/56, EM FAVOR DO EXEQUENTE, OBSERVANDO-SE O FORMULARIO JUNTADO AS FLS. 62.",
                "DecisionDate": "2020-01-27T00:00:00"
              }
            ]
          },
          {
            "Number": "00348801420208260100",
            "Type": "CUMPRIMENTO DE SENTENCA",
            "MainSubject": "PRATICAS ABUSIVAS",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "SAO PAULO",
            "JudgingBody": "24 VARA CIVEL - FORO CENTRAL CIVEL",
            "State": "SP",
            "Status": "INDEFINIDO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "PRÁTICAS ABUSIVAS",
            "InferredCNJSubjectNumber": 11811,
            "InferredCNJProcedureTypeName": "CUMPRIMENTO DE SENTENÇA",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "PRATICAS ABUSIVAS"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": -1,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2020-09-17T00:00:00",
            "NoticeDate": "2020-08-01T00:00:00",
            "LastMovementDate": "2020-11-03T00:00:00",
            "CaptureDate": "2020-10-08T13:24:59",
            "LastUpdate": "2020-10-08T13:24:59",
            "NumberOfParties": 6,
            "NumberOfUpdates": 31,
            "LawSuitAge": 1306,
            "AverageNumberOfUpdatesPerMonth": 0,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "EXEQTE"
                },
                "LastCaptureDate": "2020-10-08T13:24:59"
              },
              {
                "Doc": "35068411817",
                "IsPartyActive": true,
                "Name": "RAFAEL HIDEO NAZIMA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "295443",
                  "State": "SP",
                  "SpecificType": "ADVOGADO"
                },
                "LastCaptureDate": "2020-10-08T13:24:59"
              },
              {
                "Doc": "12930677848",
                "IsPartyActive": true,
                "Name": "JOAO CARLOS PUJOL FOGACA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "148874",
                  "State": "SP",
                  "SpecificType": "ADVOGADO"
                },
                "LastCaptureDate": "2020-10-08T13:24:59"
              },
              {
                "Doc": "21297042808",
                "IsPartyActive": true,
                "Name": "HYE MIN CHOI",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "EXECTDA"
                },
                "LastCaptureDate": "2020-10-08T13:24:59"
              },
              {
                "Doc": "07625343898",
                "IsPartyActive": true,
                "Name": "ROBERTO SUCHAN KIM",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "EXECTDO"
                },
                "LastCaptureDate": "2020-10-08T13:24:59"
              },
              {
                "IsPartyActive": true,
                "Name": "SUNG EUN LEE",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "EXECTDA"
                },
                "LastCaptureDate": "2020-10-08T13:24:59"
              }
            ],
            "Updates": [
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0416/2020 DATA DA DISPONIBILIZACAO: 03/11/2020 DATA DA PUBLICACAO: 04/11/2020 NUMERO DO DIARIO: 3159 PAGINA: 417/422",
                "PublishDate": "2020-11-03T00:00:00",
                "CaptureDate": "2020-11-04T00:22:04"
              },
              {
                "Content": "PROCESSO 0034880-14.2020.8.26.0100 (PROCESSO PRINCIPAL 1041736-74.2020.8.26.0100) - CUMPRIMENTO DE SENTENCA - PRATICAS ABUSIVAS - STARK BANK S.A. - HYE MIN CHOI - - ROBERTO SUCHAN KIM - - SUNG EUN LEE - : EMITI MANDADO DE LEVANTAMENTO ELETRONICO NOS TERMOS DA SENTENCA/DECISAO DE FLS. 60, CONFORME FORMULARIO DE FLS. 59. AINDA, NA DATA DA PUBLICACAO DO PRESENTE ATO, REFERIDO MANDADO DE LEVANTAMENTO ELETRONICO FOI ENCAMINHADO PARA ASSINATURA. NO MAIS, APOS A PUBLICACAO DESTE ATO ORDINATORIO NO DJE, OS AUTOS SERAO EXTINTOS E ARQUIVADOS DEFINITIVAMENTE NOS TERMOS DA SENTENCA PROFERIDA NOS AUTOS. - ADV: JOAO CARLOS PUJOL FOGACA (OAB 148874/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-11-03T00:00:00",
                "CaptureDate": "2020-11-04T00:22:04"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0416/2020 TEOR DO ATO: : EMITI MANDADO DE LEVANTAMENTO ELETRONICO NOS TERMOS DA SENTENCA/DECISAO DE FLS. 60, CONFORME FORMULARIO DE FLS. 59. AINDA, NA DATA DA PUBLICACAO DO PRESENTE ATO, REFERIDO MANDADO DE LEVANTAMENTO ELETRONICO FOI ENCAMINHADO PARA ASSINATURA. NO MAIS, APOS A PUBLICACAO DESTE ATO ORDINATORIO NO DJE, OS AUTOS SERAO EXTINTOS E ARQUIVADOS DEFINITIVAMENTE NOS TERMOS DA SENTENCA PROFERIDA NOS AUTOS. ADVOGADOS(S): JOAO CARLOS PUJOL FOGACA (OAB 148874/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-10-28T00:00:00",
                "CaptureDate": "2020-11-04T00:22:04"
              },
              {
                "Content": "ATO ORDINATORIO - PUBLICAVEL : EMITI MANDADO DE LEVANTAMENTO ELETRONICO NOS TERMOS DA SENTENCA/DECISAO DE FLS. 60, CONFORME FORMULARIO DE FLS. 59. AINDA, NA DATA DA PUBLICACAO DO PRESENTE ATO, REFERIDO MANDADO DE LEVANTAMENTO ELETRONICO FOI ENCAMINHADO PARA ASSINATURA. NO MAIS, APOS A PUBLICACAO DESTE ATO ORDINATORIO NO DJE, OS AUTOS SERAO EXTINTOS E ARQUIVADOS DEFINITIVAMENTE NOS TERMOS DA SENTENCA PROFERIDA NOS AUTOS.",
                "PublishDate": "2020-10-27T00:00:00",
                "CaptureDate": "2020-11-04T00:22:04"
              },
              {
                "Content": "TRANSITO EM JULGADO AS PARTES CERTIDAO - TRANSITO EM JULGADO",
                "PublishDate": "2020-10-26T00:00:00",
                "CaptureDate": "2020-11-04T00:22:04"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0349/2020 DATA DA DISPONIBILIZACAO: 17/09/2020 DATA DA PUBLICACAO: 18/09/2020 NUMERO DO DIARIO: 3129 PAGINA: 366/374",
                "PublishDate": "2020-09-17T00:00:00",
                "CaptureDate": "2020-09-21T15:49:58"
              },
              {
                "Content": "PROCESSO 0034880-14.2020.8.26.0100 (PROCESSO PRINCIPAL 1041736-74.2020.8.26.0100) - CUMPRIMENTO DE SENTENCA - PRATICAS ABUSIVAS - STARK BANK S.A. - HYE MIN CHOI - - ROBERTO SUCHAN KIM - - SUNG EUN LEE - VISTOS. SATISFEITA A OBRIGACAO, JULGO EXTINTO ESTE INCIDENTE, COM FUNDAMENTO NO ART. 924, II DO CODIGO DE PROCESSO CIVIL. TRANSITADA EM JULGADO, EXPECA-SE MANDADO DE LEVANTAMENTO DO DEPOSITO DE FLS. 53 EM FAVOR DO EXEQUENTE. APOS, COMUNIQUE-SE A EXTINCAO E ARQUIVE-SE ESTE INCIDENTE. SEM CUSTAS FINAIS, DIANTE DO PAGAMENTO VOLUNTARIO. INT. - ADV: RAFAEL HIDEO NAZIMA (OAB 295443/SP), JOAO CARLOS PUJOL FOGACA (OAB 148874/SP)",
                "PublishDate": "2020-09-17T00:00:00",
                "CaptureDate": "2020-10-08T13:24:59"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0349/2020 TEOR DO ATO: VISTOS. SATISFEITA A OBRIGACAO, JULGO EXTINTO ESTE INCIDENTE, COM FUNDAMENTO NO ART. 924, II DO CODIGO DE PROCESSO CIVIL. TRANSITADA EM JULGADO, EXPECA-SE MANDADO DE LEVANTAMENTO DO DEPOSITO DE FLS. 53 EM FAVOR DO EXEQUENTE. APOS, COMUNIQUE-SE A EXTINCAO E ARQUIVE-SE ESTE INCIDENTE. SEM CUSTAS FINAIS, DIANTE DO PAGAMENTO VOLUNTARIO. INT. ADVOGADOS(S): JOAO CARLOS PUJOL FOGACA (OAB 148874/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-09-15T00:00:00",
                "CaptureDate": "2020-09-21T15:49:58"
              },
              {
                "Content": "EXTINTA A EXECUCAO/CUMPRIMENTO DA SENTENCA PELA SATISFACAO DA OBRIGACAO VISTOS. SATISFEITA A OBRIGACAO, JULGO EXTINTO ESTE INCIDENTE, COM FUNDAMENTO NO ART. 924, II DO CODIGO DE PROCESSO CIVIL. TRANSITADA EM JULGADO, EXPECA-SE MANDADO DE LEVANTAMENTO DO DEPOSITO DE FLS. 53 EM FAVOR DO EXEQUENTE. APOS, COMUNIQUE-SE A EXTINCAO E ARQUIVE-SE ESTE INCIDENTE. SEM CUSTAS FINAIS, DIANTE DO PAGAMENTO VOLUNTARIO. INT.",
                "PublishDate": "2020-09-14T00:00:00",
                "CaptureDate": "2020-09-21T15:49:58"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2020-09-11T00:00:00",
                "CaptureDate": "2020-09-21T15:49:58"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2020-09-11T00:00:00",
                "CaptureDate": "2020-09-21T15:49:58"
              },
              {
                "Content": "PEDIDO DE EXPEDICAO DE MANDADO DE LEVANTAMENTO JUNTADO N PROTOCOLO: WJMJ.20.41410924-4 TIPO DA PETICAO: PEDIDO DE EXPEDICAO DE GUIA DE LEVANTAMENTO DATA: 10/09/2020 23:36",
                "PublishDate": "2020-09-10T00:00:00",
                "CaptureDate": "2020-09-21T15:49:58"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0336/2020 DATA DA DISPONIBILIZACAO: 09/09/2020 DATA DA PUBLICACAO: 10/09/2020 NUMERO DO DIARIO: 3123 PAGINA: 388/393",
                "PublishDate": "2020-09-09T00:00:00",
                "CaptureDate": "2020-09-21T15:49:58"
              },
              {
                "Content": "PROCESSO 0034880-14.2020.8.26.0100 (PROCESSO PRINCIPAL 1041736-74.2020.8.26.0100) - CUMPRIMENTO DE SENTENCA - PRATICAS ABUSIVAS - STARK BANK S.A. - HYE MIN CHOI - - ROBERTO SUCHAN KIM - - SUNG EUN LEE - VISTOS. FLS 52: MANIFESTE-SE O EXEQUENTE SOBRE O PAGAMENTO EFETUADO. INTIME-SE. - ADV: JOAO CARLOS PUJOL FOGACA (OAB 148874/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-09-09T00:00:00",
                "CaptureDate": "2020-09-21T15:49:58"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0336/2020 TEOR DO ATO: VISTOS. FLS 52: MANIFESTE-SE O EXEQUENTE SOBRE O PAGAMENTO EFETUADO. INTIME-SE. ADVOGADOS(S): JOAO CARLOS PUJOL FOGACA (OAB 148874/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-09-04T00:00:00",
                "CaptureDate": "2020-09-21T15:49:58"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2020-09-03T00:00:00",
                "CaptureDate": "2020-09-21T15:49:58"
              },
              {
                "Content": "DECISAO VISTOS. FLS 52: MANIFESTE-SE O EXEQUENTE SOBRE O PAGAMENTO EFETUADO. INTIME-SE.",
                "PublishDate": "2020-09-03T00:00:00",
                "CaptureDate": "2020-09-21T15:49:58"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.20.41359889-6 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 02/09/2020 16:50",
                "PublishDate": "2020-09-02T00:00:00",
                "CaptureDate": "2020-09-21T15:49:58"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0317/2020 DATA DA DISPONIBILIZACAO: 27/08/2020 DATA DA PUBLICACAO: 28/08/2020 NUMERO DO DIARIO: 3115 PAGINA: 909/918",
                "PublishDate": "2020-08-27T00:00:00",
                "CaptureDate": "2020-09-21T15:49:58"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0317/2020 TEOR DO ATO: VISTOS. REJEITO A IMPUGNACAO, UMA VEZ QUE AS CUSTAS E DESPESAS PROCESSUAIS INCLUEM-SE NA CONDENACAO SUCUMBENCIAL INDEPENDENTEMENTE DE MENCAO EXPRESSA (ART. 322,  1 DO CPC) E NADA IMPEDE A EXECUCAO DOS HONORARIOS ADVOCATICIOS EM NOME DA PARTE ASSISTIDA NO PROCESSO QUE OS FIXOU. CIENCIA AOS EXECUTADOS DA RECUSA DA PROPOSTA DE PARCELAMENTO. AGUARDE-SE O PAGAMENTO VOLUNTARIO. DECORRIDO O PRAZO CONCEDIDO A FLS. 40/41 SEM O PAGAMENTO, MANIFESTE-SE O EXEQUENTE EM TERMOS DE PROSSEGUIMENTO INDEPENDENTEMENTE DE NOVA INTIMACAO. INTIME-SE. ADVOGADOS(S): JOAO CARLOS PUJOL FOGACA (OAB 148874/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-08-25T00:00:00",
                "CaptureDate": "2020-09-21T15:49:58"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2020-08-24T00:00:00",
                "CaptureDate": "2020-09-21T15:49:58"
              },
              {
                "Content": "DECISAO VISTOS. REJEITO A IMPUGNACAO, UMA VEZ QUE AS CUSTAS E DESPESAS PROCESSUAIS INCLUEM-SE NA CONDENACAO SUCUMBENCIAL INDEPENDENTEMENTE DE MENCAO EXPRESSA (ART. 322,  1 DO CPC) E NADA IMPEDE A EXECUCAO DOS HONORARIOS ADVOCATICIOS EM NOME DA PARTE ASSISTIDA NO PROCESSO QUE OS FIXOU. CIENCIA AOS EXECUTADOS DA RECUSA DA PROPOSTA DE PARCELAMENTO. AGUARDE-SE O PAGAMENTO VOLUNTARIO. DECORRIDO O PRAZO CONCEDIDO A FLS. 40/41 SEM O PAGAMENTO, MANIFESTE-SE O EXEQUENTE EM TERMOS DE PROSSEGUIMENTO INDEPENDENTEMENTE DE NOVA INTIMACAO. INTIME-SE.",
                "PublishDate": "2020-08-24T00:00:00",
                "CaptureDate": "2020-09-21T15:49:58"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2020-08-10T00:00:00",
                "CaptureDate": "2020-09-21T15:49:58"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0286/2020 DATA DA DISPONIBILIZACAO: 10/08/2020 DATA DA PUBLICACAO: 11/08/2020 NUMERO DO DIARIO: 3102 PAGINA: 296/305",
                "PublishDate": "2020-08-10T00:00:00",
                "CaptureDate": "2020-09-21T15:49:58"
              },
              {
                "Content": "REPLICA JUNTADA N PROTOCOLO: WJMJ.20.41191489-8 TIPO DA PETICAO: MANIFESTACAO SOBRE A CONTESTACAO DATA: 09/08/2020 15:31",
                "PublishDate": "2020-08-09T00:00:00",
                "CaptureDate": "2020-09-21T15:49:58"
              },
              {
                "Content": "IMPUGNACAO AO CUMPRIMENTO DE SENTENCA JUNTADA N PROTOCOLO: WJMJ.20.41191053-1 TIPO DA PETICAO: IMPUGNACAO AO CUMPRIMENTO DA SENTENCA DATA: 08/08/2020 12:03",
                "PublishDate": "2020-08-08T00:00:00",
                "CaptureDate": "2020-09-21T15:49:58"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0286/2020 TEOR DO ATO: VISTOS. INTIMEM-SE OS EXECUTADOS, NA PESSOA DE SEUS PROCURADORS, VIA PUBLICACAO NO DJE (ART. 513, 2, I DO CPC), PARA PAGAMENTO DO DEBITO (R$ 2.299,52), NO PRAZO DE 15 DIAS DEVIDAMENTE ATUALIZADO, SOB PENA DE SER ACRESCIDO DE MULTA DE 10%, ALEM DE HONORARIOS ADVOCATICIOS, TAMBEM DE 10% SOBRE O TOTAL (ART. 523, CAPUT E 1 E ART. 85, 1 E 2 DO CPC). FICAM OS DEVEDORES DESDE JA INTIMADOS A INDICAR BENS A PENHORA, NO PRAZO DE 15 DIAS, SOB PENA DE APLICACAO DE MULTA POR ATO ATENTATORIO A DIGNIDADE DA JUSTICA, NA FORMA DO ART. 772, II C/C 774, V E  UNICO DO CPC, NO IMPORTE DE 10% DO VALOR DO DEBITO, CASO SEJA VERIFICADO QUE POSSUI BENS PENHORAVEIS. NAO EFETUADO O PAGAMENTO, MEDIANTE DEPOSITO JUDICIAL, NEM INDICADOS BENS A PENHORA, FICA DESDE LOGO AUTORIZADO: 1-) O ACRESCIMO AO DEBITO DE MULTA DE 10% E HONORARIOS ADVOCATICIOS DE 10% SOBRE O VALOR TOTAL (ART. 523, 1 DO CPC), DEVENDO O EXEQUENTE APRESENTAR NOVA MEMORIA DE CALCULO PORMENORIZADA, COM INDICE DE CORRECAO MONETARIA ADOTADO; OS JUROS APLICADOS E AS RESPECTIVAS TAXAS; O TERMO INICIAL E O TERMO FINAL DOS JUROS E DA CORRECAO MONETARIA UTILIZADOS; E A PERIODICIDADE DA CAPITALIZACAO DOS JUROS, SE FOR O CASO; 2-) A EXPEDICAO DE CERTIDAO PARA PROTESTO DO TITULO JUDICIAL, NA FORMA DO ART. 517 DO CPC, E, APOS O PAGAMENTO DAS CUSTAS, INCLUSAO DO NOME DO EXECUTADO EM CADASTROS DE INADIMPLENTES VIA SERASAJUD; 3-) A PENHORA ONLINE, PESQUISA PELO INFOJUD E RENAJUD, MEDIANTE PREVIO PAGAMENTO DAS CUSTAS NECESSARIAS, SE O CASO; 4-) EXPEDICAO DE MANDADO DE PENHORA E AVALIACAO NO ENDERECO DO DEVEDOR, RECOLHIDAS AS DILIGENCIAS. A HIPOTECA JUDICIARIA DECORRE DA LEI E PODE SER PROVIDENCIADA PELO PROPRIO EXEQUENTE MEDIANTE APRESENTACAO DE COPIA DA SENTENCA NO CARTORIO DE REGISTRO IMOBILIARIO, CABENDO AO INTERESSADO DILIGENCIAR BUSCA PELO PATRIMONIO IMOBILIARIO DO DEVEDOR, DEVENDO SER INFORMADA NOS AUTOS PELO EXEQUENTE NO PRAZO DE 15 DIAS APOS SUA REALIZACAO (CPC, ART. 495, 3) E COMPROVADA MEDIANTE APRESENTACAO DE COPIA DA MATRICULA ATUALIZADA DO BEM ONERADO, INTIMANDO-SE A PARTE CONTRARIA PARA TOME CIENCIA DO ATO. FACULTA-SE A APRESENTACAO DE IMPUGNACAO AO CUMPRIMENTO DE SENTENCA, NO PRAZO DE 15 DIAS APOS DECORRIDO O PRAZO PARA PAGAMENTO VOLUNTARIO, NA FORMA DO ART. 525 DO CPC. DECORRIDO O PRAZO SEM O PAGAMENTO, MANIFESTE-SE O EXEQUENTE EM TERMOS DE PROSSEGUIMENTO INDEPENDENTEMENTE DE NOVA INTIMACAO. INTIME-SE. ADVOGADOS(S): JOAO CARLOS PUJOL FOGACA (OAB 148874/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-08-06T00:00:00",
                "CaptureDate": "2020-09-21T15:49:58"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2020-08-05T00:00:00",
                "CaptureDate": "2020-09-21T15:49:58"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2020-08-05T00:00:00",
                "CaptureDate": "2020-09-21T15:49:58"
              },
              {
                "Content": "DECISAO VISTOS. INTIMEM-SE OS EXECUTADOS, NA PESSOA DE SEUS PROCURADORS, VIA PUBLICACAO NO DJE (ART. 513, 2, I DO CPC), PARA PAGAMENTO DO DEBITO (R$ 2.299,52), NO PRAZO DE 15 DIAS DEVIDAMENTE ATUALIZADO, SOB PENA DE SER ACRESCIDO DE MULTA DE 10%, ALEM DE HONORARIOS ADVOCATICIOS, TAMBEM DE 10% SOBRE O TOTAL (ART. 523, CAPUT E 1 E ART. 85, 1 E 2 DO CPC). FICAM OS DEVEDORES DESDE JA INTIMADOS A INDICAR BENS A PENHORA, NO PRAZO DE 15 DIAS, SOB PENA DE APLICACAO DE MULTA POR ATO ATENTATORIO A DIGNIDADE DA JUSTICA, NA FORMA DO ART. 772, II C/C 774, V E  UNICO DO CPC, NO IMPORTE DE 10% DO VALOR DO DEBITO, CASO SEJA VERIFICADO QUE POSSUI BENS PENHORAVEIS. NAO EFETUADO O PAGAMENTO, MEDIANTE DEPOSITO JUDICIAL, NEM INDICADOS BENS A PENHORA, FICA DESDE LOGO AUTORIZADO: 1-) O ACRESCIMO AO DEBITO DE MULTA DE 10% E HONORARIOS ADVOCATICIOS DE 10% SOBRE O VALOR TOTAL (ART. 523, 1 DO CPC), DEVENDO O EXEQUENTE APRESENTAR NOVA MEMORIA DE CALCULO PORMENORIZADA, COM INDICE DE CORRECAO MONETARIA ADOTADO; OS JUROS APLICADOS E AS RESPECTIVAS TAXAS; O TERMO INICIAL E O TERMO FINAL DOS JUROS E DA CORRECAO MONETARIA UTILIZADOS; E A PERIODICIDADE DA CAPITALIZACAO DOS JUROS, SE FOR O CASO; 2-) A EXPEDICAO DE CERTIDAO PARA PROTESTO DO TITULO JUDICIAL, NA FORMA DO ART. 517 DO CPC, E, APOS O PAGAMENTO DAS CUSTAS, INCLUSAO DO NOME DO EXECUTADO EM CADASTROS DE INADIMPLENTES VIA SERASAJUD; 3-) A PENHORA ONLINE, PESQUISA PELO INFOJUD E RENAJUD, MEDIANTE PREVIO PAGAMENTO DAS CUSTAS NECESSARIAS, SE O CASO; 4-) EXPEDICAO DE MANDADO DE PENHORA E AVALIACAO NO ENDERECO DO DEVEDOR, RECOLHIDAS AS DILIGENCIAS. A HIPOTECA JUDICIARIA DECORRE DA LEI E PODE SER PROVIDENCIADA PELO PROPRIO EXEQUENTE MEDIANTE APRESENTACAO DE COPIA DA SENTENCA NO CARTORIO DE REGISTRO IMOBILIARIO, CABENDO AO INTERESSADO DILIGENCIAR BUSCA PELO PATRIMONIO IMOBILIARIO DO DEVEDOR, DEVENDO SER INFORMADA NOS AUTOS PELO EXEQUENTE NO PRAZO DE 15 DIAS APOS SUA REALIZACAO (CPC, ART. 495, 3) E COMPROVADA MEDIANTE APRESENTACAO DE COPIA DA MATRICULA ATUALIZADA DO BEM ONERADO, INTIMANDO-SE A PARTE CONTRARIA PARA TOME CIENCIA DO ATO. FACULTA-SE A APRESENTACAO DE IMPUGNACAO AO CUMPRIMENTO DE SENTENCA, NO PRAZO DE 15 DIAS APOS DECORRIDO O PRAZO PARA PAGAMENTO VOLUNTARIO, NA FORMA DO ART. 525 DO CPC. DECORRIDO O PRAZO SEM O PAGAMENTO, MANIFESTE-SE O EXEQUENTE EM TERMOS DE PROSSEGUIMENTO INDEPENDENTEMENTE DE NOVA INTIMACAO. INTIME-SE.",
                "PublishDate": "2020-08-05T00:00:00",
                "CaptureDate": "2020-09-21T15:49:58"
              },
              {
                "Content": "INICIO DA EXECUCAO JUNTADO PROCESSO PRINCIPAL: 1041736-74.2020.8.26.0100",
                "PublishDate": "2020-08-04T00:00:00",
                "CaptureDate": "2020-09-21T15:49:58"
              }
            ],
            "Petitions": [
              {
                "Type": "IMPUGNACAO AO CUMPRIMENTO DA SENTENCA",
                "Author": "",
                "CreationDate": "2020-08-08T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "MANIFESTACAO SOBRE A CONTESTACAO",
                "Author": "",
                "CreationDate": "2020-08-09T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2020-09-02T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PEDIDO DE EXPEDICAO DE GUIA DE LEVANTAMENTO",
                "Author": "",
                "CreationDate": "2020-09-10T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              }
            ],
            "Decisions": [
              {
                "DecisionContent": "JULGO EXTINTO ESTE INCIDENTE, COM FUNDAMENTO NO ART. 924, II DO CODIGO DE PROCESSO CIVIL.",
                "DecisionDate": "2020-09-17T00:00:00"
              },
              {
                "DecisionContent": "JULGO EXTINTO ESTE INCIDENTE, COM FUNDAMENTO NO ART. 924, II DO CODIGO DE PROCESSO CIVIL.",
                "DecisionDate": "2020-09-15T00:00:00"
              },
              {
                "DecisionContent": "JULGO EXTINTO ESTE INCIDENTE, COM FUNDAMENTO NO ART. 924, II DO CODIGO DE PROCESSO CIVIL.",
                "DecisionDate": "2020-09-14T00:00:00"
              }
            ]
          },
          {
            "Number": "10492256520208260100",
            "Type": "PROCEDIMENTO COMUM",
            "MainSubject": "PROPRIEDADE INTELECTUAL / INDUSTRIAL",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "SAO PAULO",
            "Judge": "LUIS FELIPE FERRARI BEDENDI",
            "JudgingBody": "2 VARA EMPRESARIAL E CONFLITOS DE ARBITRAGEM",
            "State": "SP",
            "Status": "EM GRAU DE RECURSO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "PROPRIEDADE INTELECTUAL / INDUSTRIAL",
            "InferredCNJSubjectNumber": 4654,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO CIVIL",
            "InferredBroadCNJSubjectNumber": 899,
            "OtherSubjects": [
              "PROPRIEDADE INTELECTUAL / INDUSTRIAL"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 20000,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2022-06-09T00:00:00",
            "NoticeDate": "2020-06-15T00:00:00",
            "LastMovementDate": "2021-11-08T00:00:00",
            "CaptureDate": "2022-12-23T18:22:03",
            "LastUpdate": "2022-12-23T18:22:03",
            "NumberOfParties": 6,
            "NumberOfUpdates": 137,
            "LawSuitAge": 1353,
            "AverageNumberOfUpdatesPerMonth": 3,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2022-12-23T18:22:03"
              },
              {
                "Doc": "11488605000190",
                "IsPartyActive": true,
                "Name": "EMPRESA BRASILEIRA DE CARTOES START BANK EIRELI",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2022-12-23T18:22:03"
              },
              {
                "Doc": "35068411817",
                "IsPartyActive": true,
                "Name": "RAFAEL HIDEO NAZIMA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "295443",
                  "State": "SP",
                  "SpecificType": "ADVOGADO (REQTE)"
                },
                "LastCaptureDate": "2022-12-23T18:22:03"
              },
              {
                "Doc": "26902410801",
                "IsPartyActive": true,
                "Name": "JULIANO MELO DUARTE",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "193405",
                  "State": "SP",
                  "SpecificType": "ADVOGADO (REQDO)"
                },
                "LastCaptureDate": "2022-12-23T18:22:03"
              },
              {
                "Doc": "26902410801",
                "IsPartyActive": false,
                "Name": "JULIANO MELO DUARTE",
                "Polarity": "NEUTRAL",
                "Type": "OTHER",
                "PartyDetails": {
                  "OAB": "193405",
                  "State": "SP",
                  "SpecificType": "ADVOGADO (REQDO)"
                },
                "LastCaptureDate": "2020-09-23T03:00:45"
              },
              {
                "Doc": "21600788831",
                "IsPartyActive": true,
                "Name": "LUIS FELIPE FERRARI BEDENDI",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "OAB": "207170",
                  "State": "SP",
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2022-12-23T18:22:03"
              }
            ],
            "Updates": [
              {
                "Content": "REMETIDOS OS AUTOS PARA O TRIBUNAL DE JUSTICA/COLEGIO RECURSAL - PROCESSO DIGITAL",
                "PublishDate": "2021-11-08T00:00:00",
                "CaptureDate": "2021-12-01T22:10:41"
              },
              {
                "Content": "EXPEDICAO DE DOCUMENTO | EM ATENDIMENTO AO ARTIGO 1.275, 4 DAS NORMAS JUDICIAIS CORREGEDORIA DE JUSTICA, REMETO OS PRESENTES AUTOS AO SEGUNDO GRAU, INEXISTINDO MIDIA/DOCUMENTOS JUNTADOS PELAS PARTES A SEREM ENCAMINHADOS. NADA MAIS.",
                "PublishDate": "2021-11-08T00:00:00",
                "CaptureDate": "2021-12-01T22:10:41"
              },
              {
                "Content": "CERTIDAO DE CARTORIO EXPEDIDA | CERTIFICO E DOU FE QUE O VALOR CORRETO A TITULO DE PREPARO RECURSAL E DE R$ 800,00, SENDO RECOLHIDO O DE R$ 957,80 (FLS. 442/443), DE ACORDO COM O PROVIMENTO CG N 01/2020. NADA MAIS.",
                "PublishDate": "2021-11-08T00:00:00",
                "CaptureDate": "2021-12-01T22:10:41"
              },
              {
                "Content": "CERTIDAO DE CARTORIO EXPEDIDA | VECA_CERTIDAO_CONFERENCIA GUIA DARE_PORTAL DE CUSTAS_COMUNICADO CG N 2199.2021",
                "PublishDate": "2021-11-08T00:00:00",
                "CaptureDate": "2021-12-01T22:10:41"
              },
              {
                "Content": "CERTIDAO DE CARTORIO EXPEDIDA VECA_CERTIDAO_CONFERENCIA GUIA DARE_PORTAL DE CUSTAS_COMUNICADO CG N 2199.2021",
                "PublishDate": "2021-11-08T00:00:00",
                "CaptureDate": "2022-12-23T18:22:04"
              },
              {
                "Content": "CERTIDAO DE CARTORIO EXPEDIDA CERTIFICO E DOU FE QUE O VALOR CORRETO A TITULO DE PREPARO RECURSAL E DE R$ 800,00, SENDO RECOLHIDO O DE R$ 957,80 (FLS. 442/443), DE ACORDO COM O PROVIMENTO CG N 01/2020. NADA MAIS.",
                "PublishDate": "2021-11-08T00:00:00",
                "CaptureDate": "2022-12-23T18:22:04"
              },
              {
                "Content": "EXPEDICAO DE DOCUMENTO EM ATENDIMENTO AO ARTIGO 1.275, 4 DAS NORMAS JUDICIAIS CORREGEDORIA DE JUSTICA, REMETO OS PRESENTES AUTOS AO SEGUNDO GRAU, INEXISTINDO MIDIA/DOCUMENTOS JUNTADOS PELAS PARTES A SEREM ENCAMINHADOS. NADA MAIS.",
                "PublishDate": "2021-11-08T00:00:00",
                "CaptureDate": "2022-12-23T18:22:04"
              },
              {
                "Content": "REMETIDOS OS AUTOS PARA O TRIBUNAL DE JUSTICA/COLEGIO RECURSAL - PROCESSO DIGITAL",
                "PublishDate": "2021-11-08T00:00:00",
                "CaptureDate": "2022-12-23T18:22:04"
              },
              {
                "Content": "CONTRARRAZOES JUNTADA | N PROTOCOLO: WJMJ.21.41189676-9 TIPO DA PETICAO: CONTRARRAZOES DE APELACAO DATA: 22/07/2021 10:23",
                "PublishDate": "2021-07-22T00:00:00",
                "CaptureDate": "2021-12-01T22:10:41"
              },
              {
                "Content": "CONTRARRAZOES JUNTADA N PROTOCOLO: WJMJ.21.41189676-9 TIPO DA PETICAO: CONTRARRAZOES DE APELACAO DATA: 22/07/2021 10:23",
                "PublishDate": "2021-07-22T00:00:00",
                "CaptureDate": "2022-12-23T18:22:04"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0118/2021 DATA DA DISPONIBILIZACAO: 29/06/2021 DATA DA PUBLICACAO: 30/06/2021 NUMERO DO DIARIO: 3308 PAGINA: 989/1003",
                "PublishDate": "2021-07-01T00:00:00",
                "CaptureDate": "2021-12-01T22:10:41"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0118/2021 DATA DA DISPONIBILIZACAO: 29/06/2021 DATA DA PUBLICACAO: 30/06/2021 NUMERO DO DIARIO: 3308 PAGINA: 989/1003",
                "PublishDate": "2021-07-01T00:00:00",
                "CaptureDate": "2022-12-23T18:22:04"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0118/2021 TEOR DO ATO: NOS TERMOS DO ARTIGO 1.010,  1 DO CPC, FICA O APELADO INTIMADO A APRESENTAR CONTRARRAZOES AO RECURSO DE APELACAO, NO PRAZO DE 15 DIAS. APOS, REMETAM-SE OS AUTOS AO E. TRIBUNAL DE JUSTICA DE SAO PAULO, COM AS CAUTELAS DE PRAXE. NOS TERMOS DO ARTIGO 1.010, 3 DO CPC, O JUIZO DE ADMISSIBILIDADE DO RECURSO SERA PROFERIDO PELO TRIBUNAL. QUANTO AOS EFEITOS, DEVE-SE OBSERVAR O QUE DISPOE O ARTIGO 1.012 DO CODIGO DE PROCESSO CIVIL. DECORRIDO O PRAZO PARA APRESENTACAO DE CONTRARRAZOES, COM OU SEM ELAS, O PROCESSO SERA REMETIDO AO EGREGIO TRIBUNAL DE JUSTICA DO ESTADO DE SAO PAULO. ADVOGADOS(S): JULIANO MELO DUARTE (OAB 193405/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2021-06-28T00:00:00",
                "CaptureDate": "2021-07-01T05:03:34"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0118/2021 TEOR DO ATO: NOS TERMOS DO ARTIGO 1.010,  1 DO CPC, FICA O APELADO INTIMADO A APRESENTAR CONTRARRAZOES AO RECURSO DE APELACAO, NO PRAZO DE 15 DIAS. APOS, REMETAM-SE OS AUTOS AO E. TRIBUNAL DE JUSTICA DE SAO PAULO, COM AS CAUTELAS DE PRAXE. NOS TERMOS DO ARTIGO 1.010, 3 DO CPC, O JUIZO DE ADMISSIBILIDADE DO RECURSO SERA PROFERIDO PELO TRIBUNAL. QUANTO AOS EFEITOS, DEVE-SE OBSERVAR O QUE DISPOE O ARTIGO 1.012 DO CODIGO DE PROCESSO CIVIL. DECORRIDO O PRAZO PARA APRESENTACAO DE CONTRARRAZOES, COM OU SEM ELAS, O PROCESSO SERA REMETIDO AO EGREGIO TRIBUNAL DE JUSTICA DO ESTADO DE SAO PAULO. ADVOGADOS(S): JULIANO MELO DUARTE (OAB 193405/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2021-06-28T00:00:00",
                "CaptureDate": "2022-12-23T18:22:04"
              },
              {
                "Content": "ATO ORDINATORIO - PUBLICAVEL | NOS TERMOS DO ARTIGO 1.010,  1 DO CPC, FICA O APELADO INTIMADO A APRESENTAR CONTRARRAZOES AO RECURSO DE APELACAO, NO PRAZO DE 15 DIAS. APOS, REMETAM-SE OS AUTOS AO E. TRIBUNAL DE JUSTICA DE SAO PAULO, COM AS CAUTELAS DE PRAXE. NOS TERMOS DO ARTIGO 1.010, 3 DO CPC, O JUIZO DE ADMISSIBILIDADE DO RECURSO SERA PROFERIDO PELO TRIBUNAL. QUANTO AOS EFEITOS, DEVE-SE OBSERVAR O QUE DISPOE O ARTIGO 1.012 DO CODIGO DE PROCESSO CIVIL. DECORRIDO O PRAZO PARA APRESENTACAO DE CONTRARRAZOES, COM OU SEM ELAS, O PROCESSO SERA REMETIDO AO EGREGIO TRIBUNAL DE JUSTICA DO ESTADO DE SAO PAULO.",
                "PublishDate": "2021-06-25T00:00:00",
                "CaptureDate": "2021-07-01T05:03:34"
              },
              {
                "Content": "ATO ORDINATORIO - INTIMACAO - DJE | NOS TERMOS DO ARTIGO 1.010,  1 DO CPC, FICA O APELADO INTIMADO A APRESENTAR CONTRARRAZOES AO RECURSO DE APELACAO, NO PRAZO DE 15 DIAS. APOS, REMETAM-SE OS AUTOS AO E. TRIBUNAL DE JUSTICA DE SAO PAULO, COM AS CAUTELAS DE PRAXE. NOS TERMOS DO ARTIGO 1.010, 3 DO CPC, O JUIZO DE ADMISSIBILIDADE DO RECURSO SERA PROFERIDO PELO TRIBUNAL. QUANTO AOS EFEITOS, DEVE-SE OBSERVAR O QUE DISPOE O ARTIGO 1.012 DO CODIGO DE PROCESSO CIVIL. DECORRIDO O PRAZO PARA APRESENTACAO DE CONTRARRAZOES, COM OU SEM ELAS, O PROCESSO SERA REMETIDO AO EGREGIO TRIBUNAL DE JUSTICA DO ESTADO DE SAO PAULO.",
                "PublishDate": "2021-06-25T00:00:00",
                "CaptureDate": "2022-04-28T02:10:22"
              },
              {
                "Content": "ATO ORDINATORIO - INTIMACAO - DJE NOS TERMOS DO ARTIGO 1.010,  1 DO CPC, FICA O APELADO INTIMADO A APRESENTAR CONTRARRAZOES AO RECURSO DE APELACAO, NO PRAZO DE 15 DIAS. APOS, REMETAM-SE OS AUTOS AO E. TRIBUNAL DE JUSTICA DE SAO PAULO, COM AS CAUTELAS DE PRAXE. NOS TERMOS DO ARTIGO 1.010, 3 DO CPC, O JUIZO DE ADMISSIBILIDADE DO RECURSO SERA PROFERIDO PELO TRIBUNAL. QUANTO AOS EFEITOS, DEVE-SE OBSERVAR O QUE DISPOE O ARTIGO 1.012 DO CODIGO DE PROCESSO CIVIL. DECORRIDO O PRAZO PARA APRESENTACAO DE CONTRARRAZOES, COM OU SEM ELAS, O PROCESSO SERA REMETIDO AO EGREGIO TRIBUNAL DE JUSTICA DO ESTADO DE SAO PAULO.",
                "PublishDate": "2021-06-25T00:00:00",
                "CaptureDate": "2022-12-23T18:22:04"
              },
              {
                "Content": "APELACAO/RAZOES JUNTADA | N PROTOCOLO: WJMJ.21.40868593-0 TIPO DA PETICAO: RAZOES DE APELACAO DATA: 28/05/2021 20:38",
                "PublishDate": "2021-05-28T00:00:00",
                "CaptureDate": "2021-07-01T05:03:34"
              },
              {
                "Content": "APELACAO/RAZOES JUNTADA N PROTOCOLO: WJMJ.21.40868593-0 TIPO DA PETICAO: RAZOES DE APELACAO DATA: 28/05/2021 20:38",
                "PublishDate": "2021-05-28T00:00:00",
                "CaptureDate": "2022-12-23T18:22:04"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0078/2021 DATA DA DISPONIBILIZACAO: 06/05/2021 DATA DA PUBLICACAO: 07/05/2021 NUMERO DO DIARIO: 3272 PAGINA: 946/966",
                "PublishDate": "2021-05-06T00:00:00",
                "CaptureDate": "2021-05-10T13:18:58"
              },
              {
                "Content": "PROCESSO 1049225-65.2020.8.26.0100 - PROCEDIMENTO COMUM CIVEL - PROPRIEDADE INTELECTUAL / INDUSTRIAL - STARK BANK S.A. - EMPRESA BRASILEIRA DE CARTOES START BANK EIRELI - VISTOS. TRATA-SE DE DEMANDA AJUIZADA POR STARK BANK S.A. CONTRA EMPRESA BRASILEIRA DE CARTOES START BANK EIRELI. SUSTENTA A AUTORA TER SIDO CONSTITUIDA EM 2018 COM NOME EMPRESARIAL STARK BANK E FORNECER TECNOLOGIA PARA EMPRESAS REALIZAREM OPERACOES FINANCEIRAS, ATUANDO COMO FACILITADORA JUNTO AOS BANCOS. AFIRMA QUE, DESDE MAIO DESTE ANO, COMECOU A RECEBER INUMERAS RECLAMACOES DE CONSUMIDORES QUE A CONFUNDEM COM A RE, QUE UTILIZA A EXPRESSAO START BANK PARA ATUAR NO MESMO SEGMENTO DE MERCADO [BANCARIO/FINANCEIRO]. REQUER: (1) A CONFIRMACAO DA CONCESSAO DA TUTELA DE URGENCIA PARA QUE SEJA DETERMINADA LIMINARMENTE QUE A RE SE ABSTENHA DE USAR O NOME EMPRESARIAL E SINAIS DISTINTIVOS SEMELHANTES AO DA AUTORA ('STARK BANK') DE FORMA ISOLADA OU EM CONJUNTO COM OUTRAS EXPRESSOES, MARCAS OU VARIACOES EM SUAS ATIVIDADES OU POR QUALQUER OUTRO MOTIVO, ESPECIALMENTE COMO TITULO DE ESTABELECIMENTO, NOME DE DOMINIO NA INTERNET, NOME DE EMPRESA, MARCA OU LOGOMARCA DISTINTA DE PRODUTOS, SERVICOS, COMERCIALIZACAO, MATERIAIS DE DIVULGACAO/PUBLICIDADE/PROPAGANDA, ESTABELECIMENTOS OU EM QUALQUER OUTRO SINAL DISTINTIVO FISICO (COMO FACHADAS, LETREIRO, MATERIAL PUBLICITARIO, NOTAS FISCAIS, TOTENS, UNIFORMES, IMPRESSOS, DENTRE OUTROS) OU DIGITAL (EM SITIO DE INTERNET, ENDERECO DE E-MAIL ETC.)'; BEM COMO (2) A CONDENACAO EM DANOS MORAIS. INTIMADA, A RE APRESENTOU MANIFESTACAO SOBRE O PEDIDO DE TUTELA DE URGENCIA A FLS. 185/193. AFIRMOU SER DEPOSITANTE SAJ/PG5 SOFTPLAN TJ/SP - COMARCA DE SAO PAULO EMITIDO EM : 04/05/2021 - 19:57:37 DO PEDIDO DE REGISTRO DA MARCA START BANK BRASIL PERANTE O INPI E A POSSIBILIDADE DE CONVIVENCIA ENTRE AS MARCAS. A TUTELA DE URGENCIA FOI INDEFERIDA A FLS. 218/220, DECISAO MANTIDA EM SEDE DE AGRAVO DE INSTRUMENTO [FLS. 328/339]. CITADA, A RE APRESENTOU A CONTESTACAO DE FLS. 238/262 NA QUAL REFORCOU OS ARGUMENTOS DA MANIFESTACAO, BEM COMO INFORMOU QUE O DEPOSITO DA MARCA START BANK BRASIL FOI REALIZADO JUNTO AO INPI ATRAVES DA EMPRESA CONSOLIDE ASSESSORIA EMPRESARIAL ONLINE LTDA (FLS. 200), CUJO TITULAR E MERSON NOR JUNIOR, FILHO DE MERSON NOR, DIRETOR PRESIDENTE DA RE, EMPRESA BRASILEIRA DE CARTOES START BANK EIRELI, QUE EXPRESSAMENTE CONCEDEU AOS REUS DECLARACAO DE USO DE MARCA, PERMITINDO A RE LIVREMENTE DELA SE VALER. DEFENDEU A INEXISTENCIA DE COLIDENCIA GRAFICA, SONORA E VISUAL ENTRE AS MARCAS, BEM COMO A INEXISTENCIA DE CONCORRENCIA DESLEAL, REQUERENDO A IMPROCEDENCIA DOS PEDIDOS. JUNTOU OS DOCUMENTOS DE FLS. 263/270. REPLICA A FLS. 274/292. A FLS. 344/347 A AUTORA REQUEREU A DESIGNACAO DE PROVA PERICIAL E ORAL ALEM DISSO, A AUTORA E A RE CONTINUARAM A DISCUTIR SOBRE A QUESTAO DA LEGALIDADE DAS ATIVIDADES DA SEGUNDA E DA TENTATIVA DE ATUAR NA MESMA AREA [FLS. 348/350, 364/365, 364/365, 366/367, 371/372 E 383/384]. EIS A SINTESE DO NECESSARIO. FUNDAMENTO E DECIDO. PASSO AO JULGAMENTO ANTECIPADO DA LIDE, JA QUE INEXISTE A NECESSIDADE DE PRODUCAO DE OUTRAS PROVAS ALEM DAQUELAS CONSTANTES NOS AUTOS, NOS TERMOS DO ART. 355, I, DO CPC. RESSALTO SER CASO DE JULGAMENTO ANTECIPADO DO FEITO, POIS AS PROVAS REQUERIDAS NAO SAO APTAS A COMPROVAR A OCORRENCIA DE VIOLACAO DA MARCA E DO NOME EMPRESARIAL NO CASO, POIS A QUESTAO E APENAS DE DIREITO. OS PEDIDOS SAO IMPROCEDENTES. OS ARTIGOS 123, I, E 129 DA LEI N 9.279/96, SEGUNDO OS QUAIS, RESPECTIVAMENTE, PARA OS EFEITOS DESTA LEI, CONSIDERA-SE: I - MARCA DE PRODUTO OU SERVICO: AQUELA USADA PARA DISTINGUIR PRODUTO OU SERVICO DE OUTRO IDENTICO, SEMELHANTE OU AFIM, DE ORIGEM DIVERSA; E A PROPRIEDADE DA MARCA ADQUIRE-SE PELO REGISTRO VALIDAMENTE EXPEDIDO, CONFORME AS DISPOSICOES DESTA LEI, SENDO ASSEGURADO AO TITULAR SEU USO EXCLUSIVO EM TODO O TERRITORIO NACIONAL, OBSERVADO QUANTO AS MARCAS COLETIVAS E DE CERTIFICACAO O DISPOSTO NOS ARTS. 147 E 148. PELA CONJUGACAO DOS DISPOSITIVOS, MARCA E SINAL DISTINTIVO DE PRODUTO OU SERVICO DESTINADO A DIFERENCIA-LO DE OUTRO IDENTICO OU SEMELHANTE, E ASSEGURA AO SEU TITULAR O USO EXCLUSIVO EM TODO O PAIS. EM RELACAO A MARCA, CONFORME JA ENFRENTADO EM TUTELA DE URGENCIA, VERIFICO, EM CONSULTA AO BANCO DE DADOS DO INPI, QUE A AUTORA TEVE DOIS PEDIDOS DE REGISTRO DE MARCAS NOMINATIVAS DE SERVICOS INDEFERIDOS: STARK BANK [PROCESSO N 917521773] E STARK [PROCESSO N 914799436]. A RE, POR SUA VEZ, APESAR DE NAO POSSUIR QUALQUER DEPOSITO [O REFERIDO PROCESSO N 918959632 PARA REGISTRO DE MARCA MISTA START BANK BRASIL PERTENCE A TERCEIRO], DEMONSTROU POSSUIR AUTORIZACAO DE USO DA MARCA START BANK BRASIL\", CONFORME SE VERIFICA NO TERMO DE AUTORIZACAO DE USO [FLS. 234]. POR FIM, EXISTE MAIS UM ELEMENTO A AFASTAR EVENTUAL COLIDENCIA ENTRE AS EXPRESSOES STARK BANK E START BANK: E QUE O INPI JA CONCEDEU REGISTRO AS MARCAS NOMINATIVAS STARK E START NUMA MESMA CLASSE DE PRODUTO, POSSIBILITANDO A COEXISTENCIA ENTRE AMBAS [VEJA-SE OS PROCESSOS N 908084668 E 818458720]. EVIDENTEMENTE, NESSA HIPOTESE, A AUTARQUIA FEDERAL NAO VISLUMBROU REPRODUCAO OU IMITACAO ENTRE AS MARCAS, RAZAO PELA QUAL AS REGISTROU. LOGO, A QUESTAO SE ENCONTRA ENCERRADA DO PONTO DE VISTA MARCARIO. QUANTO A SUPOSTA COLIDENCIA ENTRE OS NOMES EMPRESARIAIS DAS PARTES, DISPOE O CC/02 E A INDREI 15/13, RESPECTIVAMENTE: ART. 1.163. O NOME DE EMPRESARIO DEVE DISTINGUIR-SE DE QUALQUER OUTRO JA INSCRITO NO MESMO REGISTRO. PARAGRAFO UNICO. SE O EMPRESARIO TIVER NOME IDENTICO AO DE OUTROS JA INSCRITOS, DEVERA ACRESCENTAR DESIGNACAO QUE O DISTINGA. ART. 6 OBSERVADO O PRINCIPIO DA NOVIDADE, NAO PODERAO COEXISTIR, NA MESMA UNIDADE FEDERATIVA, DOIS NOMES EMPRESARIAIS IDENTICOS OU SEMELHANTES.  1 SE A FIRMA OU DENOMINACAO FOR IDENTICA OU SEMELHANTE A DE OUTRA EMPRESA JA REGISTRADA, DEVERA SER MODIFICADA OU ACRESCIDA DE DESIGNACAO QUE A DISTINGA.  2 SERA ADMITIDO O USO DA EXPRESSAO DE FANTASIA INCOMUM, DESDE QUE EXPRESSAMENTE AUTORIZADA PELOS SOCIOS DA SOCIEDADE ANTERIORMENTE REGISTRADA. ART. 8 FICAM ESTABELECIDOS OS SEGUINTES CRITERIOS PARA A ANALISE DE IDENTIDADE E SEMELHANCA DOS NOMES EMPRESARIAIS, PELOS ORGAOS INTEGRANTES DO SISTEMA NACIONAL DE REGISTRO DE EMPRESAS MERCANTIS - SINREM: I - ENTRE FIRMAS, CONSIDERAM-SE OS NOMES POR INTEIRO, HAVENDO IDENTIDADE SE HOMOGRAFOS E SEMELHANCA SE HOMOFONOS; II - ENTRE DENOMINACOES: A) CONSIDERAM-SE OS NOMES POR INTEIRO, QUANDO COMPOSTOS POR EXPRESSOES COMUNS, DE FANTASIA, DE USO GENERALIZADO OU VULGAR, OCORRENDO IDENTIDADE SE HOMOGRAFOS E SEMELHANCA SE HOMOFONOS; B) QUANDO CONTIVEREM EXPRESSOES DE FANTASIA INCOMUNS, SERAO ELAS ANALISADAS ISOLADAMENTE, OCORRENDO IDENTIDADE SE HOMOGRAFAS E SEMELHANCA SE HOMOFONAS. PORTANTO, NA ANALISE DO NOME EMPRESARIAL LEVA-SE EM CONSIDERACAO O NOME INTEIRO QUANDO EXISTEM EXPRESSOES COMUNS DE FANTASIA. NO CASO A AUTORA TEM COMO DENOMINACAO STARK BANK S.A. E A RE EMPRESA BRASILEIRA DE CARTOES START BANK EIRELI, DE FORMA QUE O NOME EMPRESARIAL NA SUA INTEGRALIDADE NAO E HOMOGRAFO OU HOMOFONO. A AUTORA PRETENDE QUE A RE EFETUE A SUPRESSAO DO START POR SER HOMOFONO A STARK, MAS A PROPRIA LEI DETERMINA QUE A FORMA DE CORRIGIR EVENTUAIS NOMES COLIDENTES E INCLUINDO DESIGNACAO QUE OS DISTINGAM. POR TAL RAZAO E NECESSARIO O COTEJO ENTRE OS NOMES NA SUA INTEGRALIDADE, NAO PODENDO SE AFIRMAR QUE HA COLIDENCIA PORTANTO. OS DEMAIS ARGUMENTOS LEVANTADOS PELA PARTE AUTORA SAO IRRELEVANTES. O FATO DE NAO ESTAR CREDENCIADA JUNTO AO BACEN E SUPOSTAMENTE ADOTAR PRATICAS ABUSIVAS OU PUBLICIDADE ENGANOSA FOGE TOTALMENTE A ANALISE DA COLIDENCIA ENTRE MARCAS E NOME EMPRESARIAL, NAO CONSTITUINDO CAUSA DE PEDIR APTA PARA A ANALISE DE TAIS PEDIDOS. ANTE O EXPOSTO, JULGO IMPROCEDENTES OS PEDIDOS FORMULADOS NA INICIAL DESTA ACAO PROPOSTA POR STARK BANK S.A. CONTRA EMPRESA BRASILEIRA DE CARTOES START BANK EIRELI. NO MAIS, EXTINGO A ACAO COM RESOLUCAO DO MERITO, FUNDAMENTADO NO ART. 487, I, DO CPC. SUCUMBENTE, ARCARA A PARTE AUTORA COM AS DESPESAS E CUSTAS PROCESSUAIS, BEM COMO OS HONORARIOS ADVOCATICIOS DA PARTE RE, QUE FIXO, EM 10% DO VALOR DA CAUSA, ATUALIZADOS PELA TABELA PRATICA DO TRIBUNAL DE JUSTICA DE SAO PAULO, DESDE O AJUIZAMENTO [SUMULA N 14 DO STJ], COM JUROS MORATORIOS DE 1% AO MES, A CONTAR DO TRANSITO EM JULGADO, CONFORME ART. 85, 16, DO CPC. P.R.I. - ADV: JULIANO MELO DUARTE (OAB 193405/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2021-05-06T00:00:00",
                "CaptureDate": "2021-05-10T13:18:58"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0078/2021 DATA DA DISPONIBILIZACAO: 06/05/2021 DATA DA PUBLICACAO: 07/05/2021 NUMERO DO DIARIO: 3272 PAGINA: 946/966",
                "PublishDate": "2021-05-06T00:00:00",
                "CaptureDate": "2022-12-23T18:22:04"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0078/2021 TEOR DO ATO: VISTOS. TRATA-SE DE DEMANDA AJUIZADA POR STARK BANK S.A. CONTRA EMPRESA BRASILEIRA DE CARTOES START BANK EIRELI. SUSTENTA A AUTORA TER SIDO CONSTITUIDA EM 2018 COM NOME EMPRESARIAL STARK BANK E FORNECER TECNOLOGIA PARA EMPRESAS REALIZAREM OPERACOES FINANCEIRAS, ATUANDO COMO FACILITADORA JUNTO AOS BANCOS. AFIRMA QUE, DESDE MAIO DESTE ANO, COMECOU A RECEBER INUMERAS RECLAMACOES DE CONSUMIDORES QUE A CONFUNDEM COM A RE, QUE UTILIZA A EXPRESSAO START BANK PARA ATUAR NO MESMO SEGMENTO DE MERCADO [BANCARIO/FINANCEIRO]. REQUER: (1) A CONFIRMACAO DA CONCESSAO DA TUTELA DE URGENCIA PARA QUE SEJA DETERMINADA LIMINARMENTE QUE A RE SE ABSTENHA DE USAR O NOME EMPRESARIAL E SINAIS DISTINTIVOS SEMELHANTES AO DA AUTORA ('STARK BANK') DE FORMA ISOLADA OU EM CONJUNTO COM OUTRAS EXPRESSOES, MARCAS OU VARIACOES EM SUAS ATIVIDADES OU POR QUALQUER OUTRO MOTIVO, ESPECIALMENTE COMO TITULO DE ESTABELECIMENTO, NOME DE DOMINIO NA INTERNET, NOME DE EMPRESA, MARCA OU LOGOMARCA DISTINTA DE PRODUTOS, SERVICOS, COMERCIALIZACAO, MATERIAIS DE DIVULGACAO/PUBLICIDADE/PROPAGANDA, ESTABELECIMENTOS OU EM QUALQUER OUTRO SINAL DISTINTIVO FISICO (COMO FACHADAS, LETREIRO, MATERIAL PUBLICITARIO, NOTAS FISCAIS, TOTENS, UNIFORMES, IMPRESSOS, DENTRE OUTROS) OU DIGITAL (EM SITIO DE INTERNET, ENDERECO DE E-MAIL ETC.)'; BEM COMO (2) A CONDENACAO EM DANOS MORAIS. INTIMADA, A RE APRESENTOU MANIFESTACAO SOBRE O PEDIDO DE TUTELA DE URGENCIA A FLS. 185/193. AFIRMOU SER DEPOSITANTE DO PEDIDO DE REGISTRO DA MARCA START BANK BRASIL PERANTE O INPI E A POSSIBILIDADE DE CONVIVENCIA ENTRE AS MARCAS. A TUTELA DE URGENCIA FOI INDEFERIDA A FLS. 218/220, DECISAO MANTIDA EM SEDE DE AGRAVO DE INSTRUMENTO [FLS. 328/339]. CITADA, A RE APRESENTOU A CONTESTACAO DE FLS. 238/262 NA QUAL REFORCOU OS ARGUMENTOS DA MANIFESTACAO, BEM COMO INFORMOU QUE O DEPOSITO DA MARCA START BANK BRASIL FOI REALIZADO JUNTO AO INPI ATRAVES DA EMPRESA CONSOLIDE ASSESSORIA EMPRESARIAL ONLINE LTDA (FLS. 200), CUJO TITULAR E MERSON NOR JUNIOR, FILHO DE MERSON NOR, DIRETOR PRESIDENTE DA RE, EMPRESA BRASILEIRA DE CARTOES START BANK EIRELI, QUE EXPRESSAMENTE CONCEDEU AOS REUS DECLARACAO DE USO DE MARCA, PERMITINDO A RE LIVREMENTE DELA SE VALER. DEFENDEU A INEXISTENCIA DE COLIDENCIA GRAFICA, SONORA E VISUAL ENTRE AS MARCAS, BEM COMO A INEXISTENCIA DE CONCORRENCIA DESLEAL, REQUERENDO A IMPROCEDENCIA DOS PEDIDOS. JUNTOU OS DOCUMENTOS DE FLS. 263/270. REPLICA A FLS. 274/292. A FLS. 344/347 A AUTORA REQUEREU A DESIGNACAO DE PROVA PERICIAL E ORAL ALEM DISSO, A AUTORA E A RE CONTINUARAM A DISCUTIR SOBRE A QUESTAO DA LEGALIDADE DAS ATIVIDADES DA SEGUNDA E DA TENTATIVA DE ATUAR NA MESMA AREA [FLS. 348/350, 364/365, 364/365, 366/367, 371/372 E 383/384]. EIS A SINTESE DO NECESSARIO. FUNDAMENTO E DECIDO. PASSO AO JULGAMENTO ANTECIPADO DA LIDE, JA QUE INEXISTE A NECESSIDADE DE PRODUCAO DE OUTRAS PROVAS ALEM DAQUELAS CONSTANTES NOS AUTOS, NOS TERMOS DO ART. 355, I, DO CPC. RESSALTO SER CASO DE JULGAMENTO ANTECIPADO DO FEITO, POIS AS PROVAS REQUERIDAS NAO SAO APTAS A COMPROVAR A OCORRENCIA DE VIOLACAO DA MARCA E DO NOME EMPRESARIAL NO CASO, POIS A QUESTAO E APENAS DE DIREITO. OS PEDIDOS SAO IMPROCEDENTES. OS ARTIGOS 123, I, E 129 DA LEI N 9.279/96, SEGUNDO OS QUAIS, RESPECTIVAMENTE, PARA OS EFEITOS DESTA LEI, CONSIDERA-SE: I - MARCA DE PRODUTO OU SERVICO: AQUELA USADA PARA DISTINGUIR PRODUTO OU SERVICO DE OUTRO IDENTICO, SEMELHANTE OU AFIM, DE ORIGEM DIVERSA; E A PROPRIEDADE DA MARCA ADQUIRE-SE PELO REGISTRO VALIDAMENTE EXPEDIDO, CONFORME AS DISPOSICOES DESTA LEI, SENDO ASSEGURADO AO TITULAR SEU USO EXCLUSIVO EM TODO O TERRITORIO NACIONAL, OBSERVADO QUANTO AS MARCAS COLETIVAS E DE CERTIFICACAO O DISPOSTO NOS ARTS. 147 E 148. PELA CONJUGACAO DOS DISPOSITIVOS, MARCA E SINAL DISTINTIVO DE PRODUTO OU SERVICO DESTINADO A DIFERENCIA-LO DE OUTRO IDENTICO OU SEMELHANTE, E ASSEGURA AO SEU TITULAR O USO EXCLUSIVO EM TODO O PAIS. EM RELACAO A MARCA, CONFORME JA ENFRENTADO EM TUTELA DE URGENCIA, VERIFICO, EM CONSULTA AO BANCO DE DADOS DO INPI, QUE A AUTORA TEVE DOIS PEDIDOS DE REGISTRO DE MARCAS NOMINATIVAS DE SERVICOS INDEFERIDOS: STARK BANK [PROCESSO N 917521773] E STARK [PROCESSO N 914799436]. A RE, POR SUA VEZ, APESAR DE NAO POSSUIR QUALQUER DEPOSITO [O REFERIDO PROCESSO N 918959632 PARA REGISTRO DE MARCA MISTA START BANK BRASIL PERTENCE A TERCEIRO], DEMONSTROU POSSUIR AUTORIZACAO DE USO DA MARCA START BANK BRASIL\", CONFORME SE VERIFICA NO TERMO DE AUTORIZACAO DE USO [FLS. 234]. POR FIM, EXISTE MAIS UM ELEMENTO A AFASTAR EVENTUAL COLIDENCIA ENTRE AS EXPRESSOES STARK BANK E START BANK: E QUE O INPI JA CONCEDEU REGISTRO AS MARCAS NOMINATIVAS STARK E START NUMA MESMA CLASSE DE PRODUTO, POSSIBILITANDO A COEXISTENCIA ENTRE AMBAS [VEJA-SE OS PROCESSOS N 908084668 E 818458720]. EVIDENTEMENTE, NESSA HIPOTESE, A AUTARQUIA FEDERAL NAO VISLUMBROU REPRODUCAO OU IMITACAO ENTRE AS MARCAS, RAZAO PELA QUAL AS REGISTROU. LOGO, A QUESTAO SE ENCONTRA ENCERRADA DO PONTO DE VISTA MARCARIO. QUANTO A SUPOSTA COLIDENCIA ENTRE OS NOMES EMPRESARIAIS DAS PARTES, DISPOE O CC/02 E A INDREI 15/13, RESPECTIVAMENTE: ART. 1.163. O NOME DE EMPRESARIO DEVE DISTINGUIR-SE DE QUALQUER OUTRO JA INSCRITO NO MESMO REGISTRO. PARAGRAFO UNICO. SE O EMPRESARIO TIVER NOME IDENTICO AO DE OUTROS JA INSCRITOS, DEVERA ACRESCENTAR DESIGNACAO QUE O DISTINGA. ART. 6 OBSERVADO O PRINCIPIO DA NOVIDADE, NAO PODERAO COEXISTIR, NA MESMA UNIDADE FEDERATIVA, DOIS NOMES EMPRESARIAIS IDENTICOS OU SEMELHANTES.  1 SE A FIRMA OU DENOMINACAO FOR IDENTICA OU SEMELHANTE A DE OUTRA EMPRESA JA REGISTRADA, DEVERA SER MODIFICADA OU ACRESCIDA DE DESIGNACAO QUE A DISTINGA.  2 SERA ADMITIDO O USO DA EXPRESSAO DE FANTASIA INCOMUM, DESDE QUE EXPRESSAMENTE AUTORIZADA PELOS SOCIOS DA SOCIEDADE ANTERIORMENTE REGISTRADA. ART. 8 FICAM ESTABELECIDOS OS SEGUINTES CRITERIOS PARA A ANALISE DE IDENTIDADE E SEMELHANCA DOS NOMES EMPRESARIAIS, PELOS ORGAOS INTEGRANTES DO SISTEMA NACIONAL DE REGISTRO DE EMPRESAS MERCANTIS - SINREM: I - ENTRE FIRMAS, CONSIDERAM-SE OS NOMES POR INTEIRO, HAVENDO IDENTIDADE SE HOMOGRAFOS E SEMELHANCA SE HOMOFONOS; II - ENTRE DENOMINACOES: A) CONSIDERAM-SE OS NOMES POR INTEIRO, QUANDO COMPOSTOS POR EXPRESSOES COMUNS, DE FANTASIA, DE USO GENERALIZADO OU VULGAR, OCORRENDO IDENTIDADE SE HOMOGRAFOS E SEMELHANCA SE HOMOFONOS; B) QUANDO CONTIVEREM EXPRESSOES DE FANTASIA INCOMUNS, SERAO ELAS ANALISADAS ISOLADAMENTE, OCORRENDO IDENTIDADE SE HOMOGRAFAS E SEMELHANCA SE HOMOFONAS. PORTANTO, NA ANALISE DO NOME EMPRESARIAL LEVA-SE EM CONSIDERACAO O NOME INTEIRO QUANDO EXISTEM EXPRESSOES COMUNS DE FANTASIA. NO CASO A AUTORA TEM COMO DENOMINACAO STARK BANK S.A. E A RE EMPRESA BRASILEIRA DE CARTOES START BANK EIRELI, DE FORMA QUE O NOME EMPRESARIAL NA SUA INTEGRALIDADE NAO E HOMOGRAFO OU HOMOFONO. A AUTORA PRETENDE QUE A RE EFETUE A SUPRESSAO DO START POR SER HOMOFONO A STARK, MAS A PROPRIA LEI DETERMINA QUE A FORMA DE CORRIGIR EVENTUAIS NOMES COLIDENTES E INCLUINDO DESIGNACAO QUE OS DISTINGAM. POR TAL RAZAO E NECESSARIO O COTEJO ENTRE OS NOMES NA SUA INTEGRALIDADE, NAO PODENDO SE AFIRMAR QUE HA COLIDENCIA PORTANTO. OS DEMAIS ARGUMENTOS LEVANTADOS PELA PARTE AUTORA SAO IRRELEVANTES. O FATO DE NAO ESTAR CREDENCIADA JUNTO AO BACEN E SUPOSTAMENTE ADOTAR PRATICAS ABUSIVAS OU PUBLICIDADE ENGANOSA FOGE TOTALMENTE A ANALISE DA COLIDENCIA ENTRE MARCAS E NOME EMPRESARIAL, NAO CONSTITUINDO CAUSA DE PEDIR APTA PARA A ANALISE DE TAIS PEDIDOS. ANTE O EXPOSTO, JULGO IMPROCEDENTES OS PEDIDOS FORMULADOS NA INICIAL DESTA ACAO PROPOSTA POR STARK BANK S.A. CONTRA EMPRESA BRASILEIRA DE CARTOES START BANK EIRELI. NO MAIS, EXTINGO A ACAO COM RESOLUCAO DO MERITO, FUNDAMENTADO NO ART. 487, I, DO CPC. SUCUMBENTE, ARCARA A PARTE AUTORA COM AS DESPESAS E CUSTAS PROCESSUAIS, BEM COMO OS HONORARIOS ADVOCATICIOS DA PARTE RE, QUE FIXO, EM 10% DO VALOR DA CAUSA, ATUALIZADOS PELA TABELA PRATICA DO TRIBUNAL DE JUSTICA DE SAO PAULO, DESDE O AJUIZAMENTO [SUMULA N 14 DO STJ], COM JUROS MORATORIOS DE 1% AO MES, A CONTAR DO TRANSITO EM JULGADO, CONFORME ART. 85, 16, DO CPC. P.R.I. ADVOGADOS(S): JULIANO MELO DUARTE (OAB 193405/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2021-05-04T00:00:00",
                "CaptureDate": "2021-05-10T13:18:58"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0078/2021 TEOR DO ATO: VISTOS. TRATA-SE DE DEMANDA AJUIZADA POR STARK BANK S.A. CONTRA EMPRESA BRASILEIRA DE CARTOES START BANK EIRELI. SUSTENTA A AUTORA TER SIDO CONSTITUIDA EM 2018 COM NOME EMPRESARIAL STARK BANK E FORNECER TECNOLOGIA PARA EMPRESAS REALIZAREM OPERACOES FINANCEIRAS, ATUANDO COMO FACILITADORA JUNTO AOS BANCOS. AFIRMA QUE, DESDE MAIO DESTE ANO, COMECOU A RECEBER INUMERAS RECLAMACOES DE CONSUMIDORES QUE A CONFUNDEM COM A RE, QUE UTILIZA A EXPRESSAO START BANK PARA ATUAR NO MESMO SEGMENTO DE MERCADO [BANCARIO/FINANCEIRO]. REQUER: (1) A CONFIRMACAO DA CONCESSAO DA TUTELA DE URGENCIA PARA QUE SEJA DETERMINADA LIMINARMENTE QUE A RE SE ABSTENHA DE USAR O NOME EMPRESARIAL E SINAIS DISTINTIVOS SEMELHANTES AO DA AUTORA ('STARK BANK') DE FORMA ISOLADA OU EM CONJUNTO COM OUTRAS EXPRESSOES, MARCAS OU VARIACOES EM SUAS ATIVIDADES OU POR QUALQUER OUTRO MOTIVO, ESPECIALMENTE COMO TITULO DE ESTABELECIMENTO, NOME DE DOMINIO NA INTERNET, NOME DE EMPRESA, MARCA OU LOGOMARCA DISTINTA DE PRODUTOS, SERVICOS, COMERCIALIZACAO, MATERIAIS DE DIVULGACAO/PUBLICIDADE/PROPAGANDA, ESTABELECIMENTOS OU EM QUALQUER OUTRO SINAL DISTINTIVO FISICO (COMO FACHADAS, LETREIRO, MATERIAL PUBLICITARIO, NOTAS FISCAIS, TOTENS, UNIFORMES, IMPRESSOS, DENTRE OUTROS) OU DIGITAL (EM SITIO DE INTERNET, ENDERECO DE E-MAIL ETC.)'; BEM COMO (2) A CONDENACAO EM DANOS MORAIS. INTIMADA, A RE APRESENTOU MANIFESTACAO SOBRE O PEDIDO DE TUTELA DE URGENCIA A FLS. 185/193. AFIRMOU SER DEPOSITANTE DO PEDIDO DE REGISTRO DA MARCA START BANK BRASIL PERANTE O INPI E A POSSIBILIDADE DE CONVIVENCIA ENTRE AS MARCAS. A TUTELA DE URGENCIA FOI INDEFERIDA A FLS. 218/220, DECISAO MANTIDA EM SEDE DE AGRAVO DE INSTRUMENTO [FLS. 328/339]. CITADA, A RE APRESENTOU A CONTESTACAO DE FLS. 238/262 NA QUAL REFORCOU OS ARGUMENTOS DA MANIFESTACAO, BEM COMO INFORMOU QUE O DEPOSITO DA MARCA START BANK BRASIL FOI REALIZADO JUNTO AO INPI ATRAVES DA EMPRESA CONSOLIDE ASSESSORIA EMPRESARIAL ONLINE LTDA (FLS. 200), CUJO TITULAR E MERSON NOR JUNIOR, FILHO DE MERSON NOR, DIRETOR PRESIDENTE DA RE, EMPRESA BRASILEIRA DE CARTOES START BANK EIRELI, QUE EXPRESSAMENTE CONCEDEU AOS REUS DECLARACAO DE USO DE MARCA, PERMITINDO A RE LIVREMENTE DELA SE VALER. DEFENDEU A INEXISTENCIA DE COLIDENCIA GRAFICA, SONORA E VISUAL ENTRE AS MARCAS, BEM COMO A INEXISTENCIA DE CONCORRENCIA DESLEAL, REQUERENDO A IMPROCEDENCIA DOS PEDIDOS. JUNTOU OS DOCUMENTOS DE FLS. 263/270. REPLICA A FLS. 274/292. A FLS. 344/347 A AUTORA REQUEREU A DESIGNACAO DE PROVA PERICIAL E ORAL ALEM DISSO, A AUTORA E A RE CONTINUARAM A DISCUTIR SOBRE A QUESTAO DA LEGALIDADE DAS ATIVIDADES DA SEGUNDA E DA TENTATIVA DE ATUAR NA MESMA AREA [FLS. 348/350, 364/365, 364/365, 366/367, 371/372 E 383/384]. EIS A SINTESE DO NECESSARIO. FUNDAMENTO E DECIDO. PASSO AO JULGAMENTO ANTECIPADO DA LIDE, JA QUE INEXISTE A NECESSIDADE DE PRODUCAO DE OUTRAS PROVAS ALEM DAQUELAS CONSTANTES NOS AUTOS, NOS TERMOS DO ART. 355, I, DO CPC. RESSALTO SER CASO DE JULGAMENTO ANTECIPADO DO FEITO, POIS AS PROVAS REQUERIDAS NAO SAO APTAS A COMPROVAR A OCORRENCIA DE VIOLACAO DA MARCA E DO NOME EMPRESARIAL NO CASO, POIS A QUESTAO E APENAS DE DIREITO. OS PEDIDOS SAO IMPROCEDENTES. OS ARTIGOS 123, I, E 129 DA LEI N 9.279/96, SEGUNDO OS QUAIS, RESPECTIVAMENTE, PARA OS EFEITOS DESTA LEI, CONSIDERA-SE: I - MARCA DE PRODUTO OU SERVICO: AQUELA USADA PARA DISTINGUIR PRODUTO OU SERVICO DE OUTRO IDENTICO, SEMELHANTE OU AFIM, DE ORIGEM DIVERSA; E A PROPRIEDADE DA MARCA ADQUIRE-SE PELO REGISTRO VALIDAMENTE EXPEDIDO, CONFORME AS DISPOSICOES DESTA LEI, SENDO ASSEGURADO AO TITULAR SEU USO EXCLUSIVO EM TODO O TERRITORIO NACIONAL, OBSERVADO QUANTO AS MARCAS COLETIVAS E DE CERTIFICACAO O DISPOSTO NOS ARTS. 147 E 148. PELA CONJUGACAO DOS DISPOSITIVOS, MARCA E SINAL DISTINTIVO DE PRODUTO OU SERVICO DESTINADO A DIFERENCIA-LO DE OUTRO IDENTICO OU SEMELHANTE, E ASSEGURA AO SEU TITULAR O USO EXCLUSIVO EM TODO O PAIS. EM RELACAO A MARCA, CONFORME JA ENFRENTADO EM TUTELA DE URGENCIA, VERIFICO, EM CONSULTA AO BANCO DE DADOS DO INPI, QUE A AUTORA TEVE DOIS PEDIDOS DE REGISTRO DE MARCAS NOMINATIVAS DE SERVICOS INDEFERIDOS: STARK BANK [PROCESSO N 917521773] E STARK [PROCESSO N 914799436]. A RE, POR SUA VEZ, APESAR DE NAO POSSUIR QUALQUER DEPOSITO [O REFERIDO PROCESSO N 918959632 PARA REGISTRO DE MARCA MISTA START BANK BRASIL PERTENCE A TERCEIRO], DEMONSTROU POSSUIR AUTORIZACAO DE USO DA MARCA START BANK BRASIL\", CONFORME SE VERIFICA NO TERMO DE AUTORIZACAO DE USO [FLS. 234]. POR FIM, EXISTE MAIS UM ELEMENTO A AFASTAR EVENTUAL COLIDENCIA ENTRE AS EXPRESSOES STARK BANK E START BANK: E QUE O INPI JA CONCEDEU REGISTRO AS MARCAS NOMINATIVAS STARK E START NUMA MESMA CLASSE DE PRODUTO, POSSIBILITANDO A COEXISTENCIA ENTRE AMBAS [VEJA-SE OS PROCESSOS N 908084668 E 818458720]. EVIDENTEMENTE, NESSA HIPOTESE, A AUTARQUIA FEDERAL NAO VISLUMBROU REPRODUCAO OU IMITACAO ENTRE AS MARCAS, RAZAO PELA QUAL AS REGISTROU. LOGO, A QUESTAO SE ENCONTRA ENCERRADA DO PONTO DE VISTA MARCARIO. QUANTO A SUPOSTA COLIDENCIA ENTRE OS NOMES EMPRESARIAIS DAS PARTES, DISPOE O CC/02 E A INDREI 15/13, RESPECTIVAMENTE: ART. 1.163. O NOME DE EMPRESARIO DEVE DISTINGUIR-SE DE QUALQUER OUTRO JA INSCRITO NO MESMO REGISTRO. PARAGRAFO UNICO. SE O EMPRESARIO TIVER NOME IDENTICO AO DE OUTROS JA INSCRITOS, DEVERA ACRESCENTAR DESIGNACAO QUE O DISTINGA. ART. 6 OBSERVADO O PRINCIPIO DA NOVIDADE, NAO PODERAO COEXISTIR, NA MESMA UNIDADE FEDERATIVA, DOIS NOMES EMPRESARIAIS IDENTICOS OU SEMELHANTES.  1 SE A FIRMA OU DENOMINACAO FOR IDENTICA OU SEMELHANTE A DE OUTRA EMPRESA JA REGISTRADA, DEVERA SER MODIFICADA OU ACRESCIDA DE DESIGNACAO QUE A DISTINGA.  2 SERA ADMITIDO O USO DA EXPRESSAO DE FANTASIA INCOMUM, DESDE QUE EXPRESSAMENTE AUTORIZADA PELOS SOCIOS DA SOCIEDADE ANTERIORMENTE REGISTRADA. ART. 8 FICAM ESTABELECIDOS OS SEGUINTES CRITERIOS PARA A ANALISE DE IDENTIDADE E SEMELHANCA DOS NOMES EMPRESARIAIS, PELOS ORGAOS INTEGRANTES DO SISTEMA NACIONAL DE REGISTRO DE EMPRESAS MERCANTIS - SINREM: I - ENTRE FIRMAS, CONSIDERAM-SE OS NOMES POR INTEIRO, HAVENDO IDENTIDADE SE HOMOGRAFOS E SEMELHANCA SE HOMOFONOS; II - ENTRE DENOMINACOES: A) CONSIDERAM-SE OS NOMES POR INTEIRO, QUANDO COMPOSTOS POR EXPRESSOES COMUNS, DE FANTASIA, DE USO GENERALIZADO OU VULGAR, OCORRENDO IDENTIDADE SE HOMOGRAFOS E SEMELHANCA SE HOMOFONOS; B) QUANDO CONTIVEREM EXPRESSOES DE FANTASIA INCOMUNS, SERAO ELAS ANALISADAS ISOLADAMENTE, OCORRENDO IDENTIDADE SE HOMOGRAFAS E SEMELHANCA SE HOMOFONAS. PORTANTO, NA ANALISE DO NOME EMPRESARIAL LEVA-SE EM CONSIDERACAO O NOME INTEIRO QUANDO EXISTEM EXPRESSOES COMUNS DE FANTASIA. NO CASO A AUTORA TEM COMO DENOMINACAO STARK BANK S.A. E A RE EMPRESA BRASILEIRA DE CARTOES START BANK EIRELI, DE FORMA QUE O NOME EMPRESARIAL NA SUA INTEGRALIDADE NAO E HOMOGRAFO OU HOMOFONO. A AUTORA PRETENDE QUE A RE EFETUE A SUPRESSAO DO START POR SER HOMOFONO A STARK, MAS A PROPRIA LEI DETERMINA QUE A FORMA DE CORRIGIR EVENTUAIS NOMES COLIDENTES E INCLUINDO DESIGNACAO QUE OS DISTINGAM. POR TAL RAZAO E NECESSARIO O COTEJO ENTRE OS NOMES NA SUA INTEGRALIDADE, NAO PODENDO SE AFIRMAR QUE HA COLIDENCIA PORTANTO. OS DEMAIS ARGUMENTOS LEVANTADOS PELA PARTE AUTORA SAO IRRELEVANTES. O FATO DE NAO ESTAR CREDENCIADA JUNTO AO BACEN E SUPOSTAMENTE ADOTAR PRATICAS ABUSIVAS OU PUBLICIDADE ENGANOSA FOGE TOTALMENTE A ANALISE DA COLIDENCIA ENTRE MARCAS E NOME EMPRESARIAL, NAO CONSTITUINDO CAUSA DE PEDIR APTA PARA A ANALISE DE TAIS PEDIDOS. ANTE O EXPOSTO, JULGO IMPROCEDENTES OS PEDIDOS FORMULADOS NA INICIAL DESTA ACAO PROPOSTA POR STARK BANK S.A. CONTRA EMPRESA BRASILEIRA DE CARTOES START BANK EIRELI. NO MAIS, EXTINGO A ACAO COM RESOLUCAO DO MERITO, FUNDAMENTADO NO ART. 487, I, DO CPC. SUCUMBENTE, ARCARA A PARTE AUTORA COM AS DESPESAS E CUSTAS PROCESSUAIS, BEM COMO OS HONORARIOS ADVOCATICIOS DA PARTE RE, QUE FIXO, EM 10% DO VALOR DA CAUSA, ATUALIZADOS PELA TABELA PRATICA DO TRIBUNAL DE JUSTICA DE SAO PAULO, DESDE O AJUIZAMENTO [SUMULA N 14 DO STJ], COM JUROS MORATORIOS DE 1% AO MES, A CONTAR DO TRANSITO EM JULGADO, CONFORME ART. 85, 16, DO CPC. P.R.I. ADVOGADOS(S): JULIANO MELO DUARTE (OAB 193405/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2021-05-04T00:00:00",
                "CaptureDate": "2022-12-23T18:22:04"
              },
              {
                "Content": "JULGADA IMPROCEDENTE A ACAO | VISTOS. TRATA-SE DE DEMANDA AJUIZADA POR STARK BANK S.A. CONTRA EMPRESA BRASILEIRA DE CARTOES START BANK EIRELI. SUSTENTA A AUTORA TER SIDO CONSTITUIDA EM 2018 COM NOME EMPRESARIAL STARK BANK E FORNECER TECNOLOGIA PARA EMPRESAS REALIZAREM OPERACOES FINANCEIRAS, ATUANDO COMO FACILITADORA JUNTO AOS BANCOS. AFIRMA QUE, DESDE MAIO DESTE ANO, COMECOU A RECEBER INUMERAS RECLAMACOES DE CONSUMIDORES QUE A CONFUNDEM COM A RE, QUE UTILIZA A EXPRESSAO START BANK PARA ATUAR NO MESMO SEGMENTO DE MERCADO [BANCARIO/FINANCEIRO]. REQUER: (1) A CONFIRMACAO DA CONCESSAO DA TUTELA DE URGENCIA PARA QUE SEJA DETERMINADA LIMINARMENTE QUE A RE SE ABSTENHA DE USAR O NOME EMPRESARIAL E SINAIS DISTINTIVOS SEMELHANTES AO DA AUTORA ('STARK BANK') DE FORMA ISOLADA OU EM CONJUNTO COM OUTRAS EXPRESSOES, MARCAS OU VARIACOES EM SUAS ATIVIDADES OU POR QUALQUER OUTRO MOTIVO, ESPECIALMENTE COMO TITULO DE ESTABELECIMENTO, NOME DE DOMINIO NA INTERNET, NOME DE EMPRESA, MARCA OU LOGOMARCA DISTINTA DE PRODUTOS, SERVICOS, COMERCIALIZACAO, MATERIAIS DE DIVULGACAO/PUBLICIDADE/PROPAGANDA, ESTABELECIMENTOS OU EM QUALQUER OUTRO SINAL DISTINTIVO FISICO (COMO FACHADAS, LETREIRO, MATERIAL PUBLICITARIO, NOTAS FISCAIS, TOTENS, UNIFORMES, IMPRESSOS, DENTRE OUTROS) OU DIGITAL (EM SITIO DE INTERNET, ENDERECO DE E-MAIL ETC.)'; BEM COMO (2) A CONDENACAO EM DANOS MORAIS. INTIMADA, A RE APRESENTOU MANIFESTACAO SOBRE O PEDIDO DE TUTELA DE URGENCIA A FLS. 185/193. AFIRMOU SER DEPOSITANTE DO PEDIDO DE REGISTRO DA MARCA START BANK BRASIL PERANTE O INPI E A POSSIBILIDADE DE CONVIVENCIA ENTRE AS MARCAS. A TUTELA DE URGENCIA FOI INDEFERIDA A FLS. 218/220, DECISAO MANTIDA EM SEDE DE AGRAVO DE INSTRUMENTO [FLS. 328/339]. CITADA, A RE APRESENTOU A CONTESTACAO DE FLS. 238/262 NA QUAL REFORCOU OS ARGUMENTOS DA MANIFESTACAO, BEM COMO INFORMOU QUE O DEPOSITO DA MARCA START BANK BRASIL FOI REALIZADO JUNTO AO INPI ATRAVES DA EMPRESA CONSOLIDE ASSESSORIA EMPRESARIAL ONLINE LTDA (FLS. 200), CUJO TITULAR E MERSON NOR JUNIOR, FILHO DE MERSON NOR, DIRETOR PRESIDENTE DA RE, EMPRESA BRASILEIRA DE CARTOES START BANK EIRELI, QUE EXPRESSAMENTE CONCEDEU AOS REUS DECLARACAO DE USO DE MARCA, PERMITINDO A RE LIVREMENTE DELA SE VALER. DEFENDEU A INEXISTENCIA DE COLIDENCIA GRAFICA, SONORA E VISUAL ENTRE AS MARCAS, BEM COMO A INEXISTENCIA DE CONCORRENCIA DESLEAL, REQUERENDO A IMPROCEDENCIA DOS PEDIDOS. JUNTOU OS DOCUMENTOS DE FLS. 263/270. REPLICA A FLS. 274/292. A FLS. 344/347 A AUTORA REQUEREU A DESIGNACAO DE PROVA PERICIAL E ORAL ALEM DISSO, A AUTORA E A RE CONTINUARAM A DISCUTIR SOBRE A QUESTAO DA LEGALIDADE DAS ATIVIDADES DA SEGUNDA E DA TENTATIVA DE ATUAR NA MESMA AREA [FLS. 348/350, 364/365, 364/365, 366/367, 371/372 E 383/384]. EIS A SINTESE DO NECESSARIO. FUNDAMENTO E DECIDO. PASSO AO JULGAMENTO ANTECIPADO DA LIDE, JA QUE INEXISTE A NECESSIDADE DE PRODUCAO DE OUTRAS PROVAS ALEM DAQUELAS CONSTANTES NOS AUTOS, NOS TERMOS DO ART. 355, I, DO CPC. RESSALTO SER CASO DE JULGAMENTO ANTECIPADO DO FEITO, POIS AS PROVAS REQUERIDAS NAO SAO APTAS A COMPROVAR A OCORRENCIA DE VIOLACAO DA MARCA E DO NOME EMPRESARIAL NO CASO, POIS A QUESTAO E APENAS DE DIREITO. OS PEDIDOS SAO IMPROCEDENTES. OS ARTIGOS 123, I, E 129 DA LEI N 9.279/96, SEGUNDO OS QUAIS, RESPECTIVAMENTE, PARA OS EFEITOS DESTA LEI, CONSIDERA-SE: I - MARCA DE PRODUTO OU SERVICO: AQUELA USADA PARA DISTINGUIR PRODUTO OU SERVICO DE OUTRO IDENTICO, SEMELHANTE OU AFIM, DE ORIGEM DIVERSA; E A PROPRIEDADE DA MARCA ADQUIRE-SE PELO REGISTRO VALIDAMENTE EXPEDIDO, CONFORME AS DISPOSICOES DESTA LEI, SENDO ASSEGURADO AO TITULAR SEU USO EXCLUSIVO EM TODO O TERRITORIO NACIONAL, OBSERVADO QUANTO AS MARCAS COLETIVAS E DE CERTIFICACAO O DISPOSTO NOS ARTS. 147 E 148. PELA CONJUGACAO DOS DISPOSITIVOS, MARCA E SINAL DISTINTIVO DE PRODUTO OU SERVICO DESTINADO A DIFERENCIA-LO DE OUTRO IDENTICO OU SEMELHANTE, E ASSEGURA AO SEU TITULAR O USO EXCLUSIVO EM TODO O PAIS. EM RELACAO A MARCA, CONFORME JA ENFRENTADO EM TUTELA DE URGENCIA, VERIFICO, EM CONSULTA AO BANCO DE DADOS DO INPI, QUE A AUTORA TEVE DOIS PEDIDOS DE REGISTRO DE MARCAS NOMINATIVAS DE SERVICOS INDEFERIDOS: STARK BANK [PROCESSO N 917521773] E STARK [PROCESSO N 914799436]. A RE, POR SUA VEZ, APESAR DE NAO POSSUIR QUALQUER DEPOSITO [O REFERIDO PROCESSO N 918959632 PARA REGISTRO DE MARCA MISTA START BANK BRASIL PERTENCE A TERCEIRO], DEMONSTROU POSSUIR AUTORIZACAO DE USO DA MARCA START BANK BRASIL\", CONFORME SE VERIFICA NO TERMO DE AUTORIZACAO DE USO [FLS. 234]. POR FIM, EXISTE MAIS UM ELEMENTO A AFASTAR EVENTUAL COLIDENCIA ENTRE AS EXPRESSOES STARK BANK E START BANK: E QUE O INPI JA CONCEDEU REGISTRO AS MARCAS NOMINATIVAS STARK E START NUMA MESMA CLASSE DE PRODUTO, POSSIBILITANDO A COEXISTENCIA ENTRE AMBAS [VEJA-SE OS PROCESSOS N 908084668 E 818458720]. EVIDENTEMENTE, NESSA HIPOTESE, A AUTARQUIA FEDERAL NAO VISLUMBROU REPRODUCAO OU IMITACAO ENTRE AS MARCAS, RAZAO PELA QUAL AS REGISTROU. LOGO, A QUESTAO SE ENCONTRA ENCERRADA DO PONTO DE VISTA MARCARIO. QUANTO A SUPOSTA COLIDENCIA ENTRE OS NOMES EMPRESARIAIS DAS PARTES, DISPOE O CC/02 E A INDREI 15/13, RESPECTIVAMENTE: ART. 1.163. O NOME DE EMPRESARIO DEVE DISTINGUIR-SE DE QUALQUER OUTRO JA INSCRITO NO MESMO REGISTRO. PARAGRAFO UNICO. SE O EMPRESARIO TIVER NOME IDENTICO AO DE OUTROS JA INSCRITOS, DEVERA ACRESCENTAR DESIGNACAO QUE O DISTINGA. ART. 6 OBSERVADO O PRINCIPIO DA NOVIDADE, NAO PODERAO COEXISTIR, NA MESMA UNIDADE FEDERATIVA, DOIS NOMES EMPRESARIAIS IDENTICOS OU SEMELHANTES.  1 SE A FIRMA OU DENOMINACAO FOR IDENTICA OU SEMELHANTE A DE OUTRA EMPRESA JA REGISTRADA, DEVERA SER MODIFICADA OU ACRESCIDA DE DESIGNACAO QUE A DISTINGA.  2 SERA ADMITIDO O USO DA EXPRESSAO DE FANTASIA INCOMUM, DESDE QUE EXPRESSAMENTE AUTORIZADA PELOS SOCIOS DA SOCIEDADE ANTERIORMENTE REGISTRADA. ART. 8 FICAM ESTABELECIDOS OS SEGUINTES CRITERIOS PARA A ANALISE DE IDENTIDADE E SEMELHANCA DOS NOMES EMPRESARIAIS, PELOS ORGAOS INTEGRANTES DO SISTEMA NACIONAL DE REGISTRO DE EMPRESAS MERCANTIS - SINREM: I - ENTRE FIRMAS, CONSIDERAM-SE OS NOMES POR INTEIRO, HAVENDO IDENTIDADE SE HOMOGRAFOS E SEMELHANCA SE HOMOFONOS; II - ENTRE DENOMINACOES: A) CONSIDERAM-SE OS NOMES POR INTEIRO, QUANDO COMPOSTOS POR EXPRESSOES COMUNS, DE FANTASIA, DE USO GENERALIZADO OU VULGAR, OCORRENDO IDENTIDADE SE HOMOGRAFOS E SEMELHANCA SE HOMOFONOS; B) QUANDO CONTIVEREM EXPRESSOES DE FANTASIA INCOMUNS, SERAO ELAS ANALISADAS ISOLADAMENTE, OCORRENDO IDENTIDADE SE HOMOGRAFAS E SEMELHANCA SE HOMOFONAS. PORTANTO, NA ANALISE DO NOME EMPRESARIAL LEVA-SE EM CONSIDERACAO O NOME INTEIRO QUANDO EXISTEM EXPRESSOES COMUNS DE FANTASIA. NO CASO A AUTORA TEM COMO DENOMINACAO STARK BANK S.A. E A RE EMPRESA BRASILEIRA DE CARTOES START BANK EIRELI, DE FORMA QUE O NOME EMPRESARIAL NA SUA INTEGRALIDADE NAO E HOMOGRAFO OU HOMOFONO. A AUTORA PRETENDE QUE A RE EFETUE A SUPRESSAO DO START POR SER HOMOFONO A STARK, MAS A PROPRIA LEI DETERMINA QUE A FORMA DE CORRIGIR EVENTUAIS NOMES COLIDENTES E INCLUINDO DESIGNACAO QUE OS DISTINGAM. POR TAL RAZAO E NECESSARIO O COTEJO ENTRE OS NOMES NA SUA INTEGRALIDADE, NAO PODENDO SE AFIRMAR QUE HA COLIDENCIA PORTANTO. OS DEMAIS ARGUMENTOS LEVANTADOS PELA PARTE AUTORA SAO IRRELEVANTES. O FATO DE NAO ESTAR CREDENCIADA JUNTO AO BACEN E SUPOSTAMENTE ADOTAR PRATICAS ABUSIVAS OU PUBLICIDADE ENGANOSA FOGE TOTALMENTE A ANALISE DA COLIDENCIA ENTRE MARCAS E NOME EMPRESARIAL, NAO CONSTITUINDO CAUSA DE PEDIR APTA PARA A ANALISE DE TAIS PEDIDOS. ANTE O EXPOSTO, JULGO IMPROCEDENTES OS PEDIDOS FORMULADOS NA INICIAL DESTA ACAO PROPOSTA POR STARK BANK S.A. CONTRA EMPRESA BRASILEIRA DE CARTOES START BANK EIRELI. NO MAIS, EXTINGO A ACAO COM RESOLUCAO DO MERITO, FUNDAMENTADO NO ART. 487, I, DO CPC. SUCUMBENTE, ARCARA A PARTE AUTORA COM AS DESPESAS E CUSTAS PROCESSUAIS, BEM COMO OS HONORARIOS ADVOCATICIOS DA PARTE RE, QUE FIXO, EM 10% DO VALOR DA CAUSA, ATUALIZADOS PELA TABELA PRATICA DO TRIBUNAL DE JUSTICA DE SAO PAULO, DESDE O AJUIZAMENTO [SUMULA N 14 DO STJ], COM JUROS MORATORIOS DE 1% AO MES, A CONTAR DO TRANSITO EM JULGADO, CONFORME ART. 85, 16, DO CPC. P.R.I.",
                "PublishDate": "2021-05-03T00:00:00",
                "CaptureDate": "2021-05-10T13:18:58"
              },
              {
                "Content": "JULGADA IMPROCEDENTE A ACAO VISTOS. TRATA-SE DE DEMANDA AJUIZADA POR STARK BANK S.A. CONTRA EMPRESA BRASILEIRA DE CARTOES START BANK EIRELI. SUSTENTA A AUTORA TER SIDO CONSTITUIDA EM 2018 COM NOME EMPRESARIAL STARK BANK E FORNECER TECNOLOGIA PARA EMPRESAS REALIZAREM OPERACOES FINANCEIRAS, ATUANDO COMO FACILITADORA JUNTO AOS BANCOS. AFIRMA QUE, DESDE MAIO DESTE ANO, COMECOU A RECEBER INUMERAS RECLAMACOES DE CONSUMIDORES QUE A CONFUNDEM COM A RE, QUE UTILIZA A EXPRESSAO START BANK PARA ATUAR NO MESMO SEGMENTO DE MERCADO [BANCARIO/FINANCEIRO]. REQUER: (1) A CONFIRMACAO DA CONCESSAO DA TUTELA DE URGENCIA PARA QUE SEJA DETERMINADA LIMINARMENTE QUE A RE SE ABSTENHA DE USAR O NOME EMPRESARIAL E SINAIS DISTINTIVOS SEMELHANTES AO DA AUTORA ('STARK BANK') DE FORMA ISOLADA OU EM CONJUNTO COM OUTRAS EXPRESSOES, MARCAS OU VARIACOES EM SUAS ATIVIDADES OU POR QUALQUER OUTRO MOTIVO, ESPECIALMENTE COMO TITULO DE ESTABELECIMENTO, NOME DE DOMINIO NA INTERNET, NOME DE EMPRESA, MARCA OU LOGOMARCA DISTINTA DE PRODUTOS, SERVICOS, COMERCIALIZACAO, MATERIAIS DE DIVULGACAO/PUBLICIDADE/PROPAGANDA, ESTABELECIMENTOS OU EM QUALQUER OUTRO SINAL DISTINTIVO FISICO (COMO FACHADAS, LETREIRO, MATERIAL PUBLICITARIO, NOTAS FISCAIS, TOTENS, UNIFORMES, IMPRESSOS, DENTRE OUTROS) OU DIGITAL (EM SITIO DE INTERNET, ENDERECO DE E-MAIL ETC.)'; BEM COMO (2) A CONDENACAO EM DANOS MORAIS. INTIMADA, A RE APRESENTOU MANIFESTACAO SOBRE O PEDIDO DE TUTELA DE URGENCIA A FLS. 185/193. AFIRMOU SER DEPOSITANTE DO PEDIDO DE REGISTRO DA MARCA START BANK BRASIL PERANTE O INPI E A POSSIBILIDADE DE CONVIVENCIA ENTRE AS MARCAS. A TUTELA DE URGENCIA FOI INDEFERIDA A FLS. 218/220, DECISAO MANTIDA EM SEDE DE AGRAVO DE INSTRUMENTO [FLS. 328/339]. CITADA, A RE APRESENTOU A CONTESTACAO DE FLS. 238/262 NA QUAL REFORCOU OS ARGUMENTOS DA MANIFESTACAO, BEM COMO INFORMOU QUE O DEPOSITO DA MARCA START BANK BRASIL FOI REALIZADO JUNTO AO INPI ATRAVES DA EMPRESA CONSOLIDE ASSESSORIA EMPRESARIAL ONLINE LTDA (FLS. 200), CUJO TITULAR E MERSON NOR JUNIOR, FILHO DE MERSON NOR, DIRETOR PRESIDENTE DA RE, EMPRESA BRASILEIRA DE CARTOES START BANK EIRELI, QUE EXPRESSAMENTE CONCEDEU AOS REUS DECLARACAO DE USO DE MARCA, PERMITINDO A RE LIVREMENTE DELA SE VALER. DEFENDEU A INEXISTENCIA DE COLIDENCIA GRAFICA, SONORA E VISUAL ENTRE AS MARCAS, BEM COMO A INEXISTENCIA DE CONCORRENCIA DESLEAL, REQUERENDO A IMPROCEDENCIA DOS PEDIDOS. JUNTOU OS DOCUMENTOS DE FLS. 263/270. REPLICA A FLS. 274/292. A FLS. 344/347 A AUTORA REQUEREU A DESIGNACAO DE PROVA PERICIAL E ORAL ALEM DISSO, A AUTORA E A RE CONTINUARAM A DISCUTIR SOBRE A QUESTAO DA LEGALIDADE DAS ATIVIDADES DA SEGUNDA E DA TENTATIVA DE ATUAR NA MESMA AREA [FLS. 348/350, 364/365, 364/365, 366/367, 371/372 E 383/384]. EIS A SINTESE DO NECESSARIO. FUNDAMENTO E DECIDO. PASSO AO JULGAMENTO ANTECIPADO DA LIDE, JA QUE INEXISTE A NECESSIDADE DE PRODUCAO DE OUTRAS PROVAS ALEM DAQUELAS CONSTANTES NOS AUTOS, NOS TERMOS DO ART. 355, I, DO CPC. RESSALTO SER CASO DE JULGAMENTO ANTECIPADO DO FEITO, POIS AS PROVAS REQUERIDAS NAO SAO APTAS A COMPROVAR A OCORRENCIA DE VIOLACAO DA MARCA E DO NOME EMPRESARIAL NO CASO, POIS A QUESTAO E APENAS DE DIREITO. OS PEDIDOS SAO IMPROCEDENTES. OS ARTIGOS 123, I, E 129 DA LEI N 9.279/96, SEGUNDO OS QUAIS, RESPECTIVAMENTE, PARA OS EFEITOS DESTA LEI, CONSIDERA-SE: I - MARCA DE PRODUTO OU SERVICO: AQUELA USADA PARA DISTINGUIR PRODUTO OU SERVICO DE OUTRO IDENTICO, SEMELHANTE OU AFIM, DE ORIGEM DIVERSA; E A PROPRIEDADE DA MARCA ADQUIRE-SE PELO REGISTRO VALIDAMENTE EXPEDIDO, CONFORME AS DISPOSICOES DESTA LEI, SENDO ASSEGURADO AO TITULAR SEU USO EXCLUSIVO EM TODO O TERRITORIO NACIONAL, OBSERVADO QUANTO AS MARCAS COLETIVAS E DE CERTIFICACAO O DISPOSTO NOS ARTS. 147 E 148. PELA CONJUGACAO DOS DISPOSITIVOS, MARCA E SINAL DISTINTIVO DE PRODUTO OU SERVICO DESTINADO A DIFERENCIA-LO DE OUTRO IDENTICO OU SEMELHANTE, E ASSEGURA AO SEU TITULAR O USO EXCLUSIVO EM TODO O PAIS. EM RELACAO A MARCA, CONFORME JA ENFRENTADO EM TUTELA DE URGENCIA, VERIFICO, EM CONSULTA AO BANCO DE DADOS DO INPI, QUE A AUTORA TEVE DOIS PEDIDOS DE REGISTRO DE MARCAS NOMINATIVAS DE SERVICOS INDEFERIDOS: STARK BANK [PROCESSO N 917521773] E STARK [PROCESSO N 914799436]. A RE, POR SUA VEZ, APESAR DE NAO POSSUIR QUALQUER DEPOSITO [O REFERIDO PROCESSO N 918959632 PARA REGISTRO DE MARCA MISTA START BANK BRASIL PERTENCE A TERCEIRO], DEMONSTROU POSSUIR AUTORIZACAO DE USO DA MARCA START BANK BRASIL\", CONFORME SE VERIFICA NO TERMO DE AUTORIZACAO DE USO [FLS. 234]. POR FIM, EXISTE MAIS UM ELEMENTO A AFASTAR EVENTUAL COLIDENCIA ENTRE AS EXPRESSOES STARK BANK E START BANK: E QUE O INPI JA CONCEDEU REGISTRO AS MARCAS NOMINATIVAS STARK E START NUMA MESMA CLASSE DE PRODUTO, POSSIBILITANDO A COEXISTENCIA ENTRE AMBAS [VEJA-SE OS PROCESSOS N 908084668 E 818458720]. EVIDENTEMENTE, NESSA HIPOTESE, A AUTARQUIA FEDERAL NAO VISLUMBROU REPRODUCAO OU IMITACAO ENTRE AS MARCAS, RAZAO PELA QUAL AS REGISTROU. LOGO, A QUESTAO SE ENCONTRA ENCERRADA DO PONTO DE VISTA MARCARIO. QUANTO A SUPOSTA COLIDENCIA ENTRE OS NOMES EMPRESARIAIS DAS PARTES, DISPOE O CC/02 E A INDREI 15/13, RESPECTIVAMENTE: ART. 1.163. O NOME DE EMPRESARIO DEVE DISTINGUIR-SE DE QUALQUER OUTRO JA INSCRITO NO MESMO REGISTRO. PARAGRAFO UNICO. SE O EMPRESARIO TIVER NOME IDENTICO AO DE OUTROS JA INSCRITOS, DEVERA ACRESCENTAR DESIGNACAO QUE O DISTINGA. ART. 6 OBSERVADO O PRINCIPIO DA NOVIDADE, NAO PODERAO COEXISTIR, NA MESMA UNIDADE FEDERATIVA, DOIS NOMES EMPRESARIAIS IDENTICOS OU SEMELHANTES.  1 SE A FIRMA OU DENOMINACAO FOR IDENTICA OU SEMELHANTE A DE OUTRA EMPRESA JA REGISTRADA, DEVERA SER MODIFICADA OU ACRESCIDA DE DESIGNACAO QUE A DISTINGA.  2 SERA ADMITIDO O USO DA EXPRESSAO DE FANTASIA INCOMUM, DESDE QUE EXPRESSAMENTE AUTORIZADA PELOS SOCIOS DA SOCIEDADE ANTERIORMENTE REGISTRADA. ART. 8 FICAM ESTABELECIDOS OS SEGUINTES CRITERIOS PARA A ANALISE DE IDENTIDADE E SEMELHANCA DOS NOMES EMPRESARIAIS, PELOS ORGAOS INTEGRANTES DO SISTEMA NACIONAL DE REGISTRO DE EMPRESAS MERCANTIS - SINREM: I - ENTRE FIRMAS, CONSIDERAM-SE OS NOMES POR INTEIRO, HAVENDO IDENTIDADE SE HOMOGRAFOS E SEMELHANCA SE HOMOFONOS; II - ENTRE DENOMINACOES: A) CONSIDERAM-SE OS NOMES POR INTEIRO, QUANDO COMPOSTOS POR EXPRESSOES COMUNS, DE FANTASIA, DE USO GENERALIZADO OU VULGAR, OCORRENDO IDENTIDADE SE HOMOGRAFOS E SEMELHANCA SE HOMOFONOS; B) QUANDO CONTIVEREM EXPRESSOES DE FANTASIA INCOMUNS, SERAO ELAS ANALISADAS ISOLADAMENTE, OCORRENDO IDENTIDADE SE HOMOGRAFAS E SEMELHANCA SE HOMOFONAS. PORTANTO, NA ANALISE DO NOME EMPRESARIAL LEVA-SE EM CONSIDERACAO O NOME INTEIRO QUANDO EXISTEM EXPRESSOES COMUNS DE FANTASIA. NO CASO A AUTORA TEM COMO DENOMINACAO STARK BANK S.A. E A RE EMPRESA BRASILEIRA DE CARTOES START BANK EIRELI, DE FORMA QUE O NOME EMPRESARIAL NA SUA INTEGRALIDADE NAO E HOMOGRAFO OU HOMOFONO. A AUTORA PRETENDE QUE A RE EFETUE A SUPRESSAO DO START POR SER HOMOFONO A STARK, MAS A PROPRIA LEI DETERMINA QUE A FORMA DE CORRIGIR EVENTUAIS NOMES COLIDENTES E INCLUINDO DESIGNACAO QUE OS DISTINGAM. POR TAL RAZAO E NECESSARIO O COTEJO ENTRE OS NOMES NA SUA INTEGRALIDADE, NAO PODENDO SE AFIRMAR QUE HA COLIDENCIA PORTANTO. OS DEMAIS ARGUMENTOS LEVANTADOS PELA PARTE AUTORA SAO IRRELEVANTES. O FATO DE NAO ESTAR CREDENCIADA JUNTO AO BACEN E SUPOSTAMENTE ADOTAR PRATICAS ABUSIVAS OU PUBLICIDADE ENGANOSA FOGE TOTALMENTE A ANALISE DA COLIDENCIA ENTRE MARCAS E NOME EMPRESARIAL, NAO CONSTITUINDO CAUSA DE PEDIR APTA PARA A ANALISE DE TAIS PEDIDOS. ANTE O EXPOSTO, JULGO IMPROCEDENTES OS PEDIDOS FORMULADOS NA INICIAL DESTA ACAO PROPOSTA POR STARK BANK S.A. CONTRA EMPRESA BRASILEIRA DE CARTOES START BANK EIRELI. NO MAIS, EXTINGO A ACAO COM RESOLUCAO DO MERITO, FUNDAMENTADO NO ART. 487, I, DO CPC. SUCUMBENTE, ARCARA A PARTE AUTORA COM AS DESPESAS E CUSTAS PROCESSUAIS, BEM COMO OS HONORARIOS ADVOCATICIOS DA PARTE RE, QUE FIXO, EM 10% DO VALOR DA CAUSA, ATUALIZADOS PELA TABELA PRATICA DO TRIBUNAL DE JUSTICA DE SAO PAULO, DESDE O AJUIZAMENTO [SUMULA N 14 DO STJ], COM JUROS MORATORIOS DE 1% AO MES, A CONTAR DO TRANSITO EM JULGADO, CONFORME ART. 85, 16, DO CPC. P.R.I.",
                "PublishDate": "2021-05-03T00:00:00",
                "CaptureDate": "2022-12-23T18:22:04"
              },
              {
                "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.21.40671636-7 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 29/04/2021 11:01",
                "PublishDate": "2021-04-29T00:00:00",
                "CaptureDate": "2021-05-10T13:18:58"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.21.40671636-7 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 29/04/2021 11:01",
                "PublishDate": "2021-04-29T00:00:00",
                "CaptureDate": "2022-12-23T18:22:04"
              },
              {
                "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.21.40669511-4 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 28/04/2021 19:50",
                "PublishDate": "2021-04-28T00:00:00",
                "CaptureDate": "2021-05-10T13:18:58"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.21.40669511-4 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 28/04/2021 19:50",
                "PublishDate": "2021-04-28T00:00:00",
                "CaptureDate": "2022-12-23T18:22:04"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2021-02-22T00:00:00",
                "CaptureDate": "2021-03-27T02:36:35"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2021-02-19T00:00:00",
                "CaptureDate": "2021-03-27T02:36:35"
              },
              {
                "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.21.40155262-5 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 08/02/2021 18:59",
                "PublishDate": "2021-02-08T00:00:00",
                "CaptureDate": "2021-03-27T02:36:35"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.21.40155262-5 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 08/02/2021 18:59",
                "PublishDate": "2021-02-08T00:00:00",
                "CaptureDate": "2022-12-23T18:22:04"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0293/2020 DATA DA DISPONIBILIZACAO: 07/01/2021 DATA DA PUBLICACAO: 08/01/2021 NUMERO DO DIARIO: 3191 PAGINA: 437/463",
                "PublishDate": "2021-01-07T00:00:00",
                "CaptureDate": "2021-01-07T18:29:12"
              },
              {
                "Content": "PROCESSO 1049225-65.2020.8.26.0100 - PROCEDIMENTO COMUM CIVEL - PROPRIEDADE INTELECTUAL / INDUSTRIAL - STARK BANK S.A. - EMPRESA BRASILEIRA DE CARTOES START BANK EIRELI - VISTOS. FLS. 348/363 E 366/379: MANIFESTE-SE A PARTE REQUERIDA, EM QUINZE DIAS, SOBRE OS NOVOS DOCUMENTOS JUNTADOS, NOS TERMOS DO ART. 437, 1 DO CPC. INT. - ADV: RAFAEL HIDEO NAZIMA (OAB 295443/SP), JULIANO MELO DUARTE (OAB 193405/SP)",
                "PublishDate": "2021-01-07T00:00:00",
                "CaptureDate": "2021-01-07T18:29:12"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0293/2020 DATA DA DISPONIBILIZACAO: 07/01/2021 DATA DA PUBLICACAO: 08/01/2021 NUMERO DO DIARIO: 3191 PAGINA: 437/463",
                "PublishDate": "2021-01-07T00:00:00",
                "CaptureDate": "2021-03-27T02:36:35"
              },
              {
                "Content": "DECISAO VISTOS. FLS. 348/363 E 366/379: MANIFESTE-SE A PARTE REQUERIDA, EM QUINZE DIAS, SOBRE OS NOVOS DOCUMENTOS JUNTADOS, NOS TERMOS DO ART. 437, 1 DO CPC. INT.",
                "PublishDate": "2020-12-18T00:00:00",
                "CaptureDate": "2021-01-07T18:29:12"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0293/2020 TEOR DO ATO: VISTOS. FLS. 348/363 E 366/379: MANIFESTE-SE A PARTE REQUERIDA, EM QUINZE DIAS, SOBRE OS NOVOS DOCUMENTOS JUNTADOS, NOS TERMOS DO ART. 437, 1 DO CPC. INT. ADVOGADOS(S): JULIANO MELO DUARTE (OAB 193405/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-12-18T00:00:00",
                "CaptureDate": "2021-01-07T18:29:12"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0293/2020 TEOR DO ATO: VISTOS. FLS. 348/363 E 366/379: MANIFESTE-SE A PARTE REQUERIDA, EM QUINZE DIAS, SOBRE OS NOVOS DOCUMENTOS JUNTADOS, NOS TERMOS DO ART. 437, 1 DO CPC. INT. ADVOGADOS(S): JULIANO MELO DUARTE (OAB 193405/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-12-18T00:00:00",
                "CaptureDate": "2021-03-27T02:36:35"
              },
              {
                "Content": "DECISAO | VISTOS. FLS. 348/363 E 366/379: MANIFESTE-SE A PARTE REQUERIDA, EM QUINZE DIAS, SOBRE OS NOVOS DOCUMENTOS JUNTADOS, NOS TERMOS DO ART. 437, 1 DO CPC. INT.",
                "PublishDate": "2020-12-18T00:00:00",
                "CaptureDate": "2021-03-27T02:36:35"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.20.41947430-7 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 09/12/2020 18:15",
                "PublishDate": "2020-12-09T00:00:00",
                "CaptureDate": "2021-01-07T18:29:12"
              },
              {
                "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.20.41947430-7 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 09/12/2020 18:15",
                "PublishDate": "2020-12-09T00:00:00",
                "CaptureDate": "2021-03-27T02:36:35"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.20.41705562-5 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 28/10/2020 17:38",
                "PublishDate": "2020-10-28T00:00:00",
                "CaptureDate": "2021-01-07T18:29:12"
              },
              {
                "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.20.41705562-5 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 28/10/2020 17:38",
                "PublishDate": "2020-10-28T00:00:00",
                "CaptureDate": "2021-03-27T02:36:35"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.20.41597551-4 TIPO DA PETICAO: PETICAO INTERMEDIARIA DATA: 09/10/2020 19:38",
                "PublishDate": "2020-10-09T00:00:00",
                "CaptureDate": "2021-01-07T18:29:12"
              },
              {
                "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.20.41597551-4 TIPO DA PETICAO: PETICAO INTERMEDIARIA DATA: 09/10/2020 19:38",
                "PublishDate": "2020-10-09T00:00:00",
                "CaptureDate": "2021-03-27T02:36:35"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.20.41581161-9 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 07/10/2020 20:46",
                "PublishDate": "2020-10-07T00:00:00",
                "CaptureDate": "2021-01-07T18:29:12"
              },
              {
                "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.20.41581161-9 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 07/10/2020 20:46",
                "PublishDate": "2020-10-07T00:00:00",
                "CaptureDate": "2021-03-27T02:36:35"
              },
              {
                "Content": "ESPECIFICACAO DE PROVAS JUNTADA N PROTOCOLO: WJMJ.20.41405159-9 TIPO DA PETICAO: INDICACAO DE PROVAS DATA: 10/09/2020 14:02",
                "PublishDate": "2020-09-10T00:00:00",
                "CaptureDate": "2020-09-23T03:00:46"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2020-09-10T00:00:00",
                "CaptureDate": "2020-09-23T03:00:46"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2020-09-10T00:00:00",
                "CaptureDate": "2020-09-23T03:00:46"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2020-09-10T00:00:00",
                "CaptureDate": "2021-03-27T02:36:35"
              },
              {
                "Content": "ESPECIFICACAO DE PROVAS JUNTADA | N PROTOCOLO: WJMJ.20.41405159-9 TIPO DA PETICAO: INDICACAO DE PROVAS DATA: 10/09/2020 14:02",
                "PublishDate": "2020-09-10T00:00:00",
                "CaptureDate": "2021-03-27T02:36:35"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.20.41399240-3 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 09/09/2020 17:51",
                "PublishDate": "2020-09-09T00:00:00",
                "CaptureDate": "2020-09-23T03:00:46"
              },
              {
                "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.20.41399240-3 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 09/09/2020 17:51",
                "PublishDate": "2020-09-09T00:00:00",
                "CaptureDate": "2021-03-27T02:36:35"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0229/2020 DATA DA DISPONIBILIZACAO: 03/09/2020 DATA DA PUBLICACAO: 04/09/2020 NUMERO DO DIARIO: 3120 PAGINA: 770/781",
                "PublishDate": "2020-09-03T00:00:00",
                "CaptureDate": "2020-09-23T03:00:46"
              },
              {
                "Content": "PROCESSO 1049225-65.2020.8.26.0100 - PROCEDIMENTO COMUM CIVEL - PROPRIEDADE INTELECTUAL / INDUSTRIAL - STARK BANK S.A. - EMPRESA BRASILEIRA DE CARTOES START BANK EIRELI - VISTOS. 1- FLS. 328/339: CIENCIA AS PARTES DO V. ACORDAO, QUE NEGOU PROVIMENTO DO RECURSO DE AGRAVO DE INSTRUMENTO. 2- NO MAIS, CUMPRA-SE A DECISAO DA FL. 325. 3- INTIMEM-SE. - ADV: JULIANO MELO DUARTE (OAB 193405/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-09-03T00:00:00",
                "CaptureDate": "2020-09-23T03:00:45"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0229/2020 DATA DA DISPONIBILIZACAO: 03/09/2020 DATA DA PUBLICACAO: 04/09/2020 NUMERO DO DIARIO: 3120 PAGINA: 770/781",
                "PublishDate": "2020-09-03T00:00:00",
                "CaptureDate": "2021-03-27T02:36:35"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0229/2020 TEOR DO ATO: VISTOS. 1- FLS. 328/339: CIENCIA AS PARTES DO V. ACORDAO, QUE NEGOU PROVIMENTO DO RECURSO DE AGRAVO DE INSTRUMENTO. 2- NO MAIS, CUMPRA-SE A DECISAO DA FL. 325. 3- INTIMEM-SE. ADVOGADOS(S): JULIANO MELO DUARTE (OAB 193405/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-09-02T00:00:00",
                "CaptureDate": "2020-09-23T03:00:46"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0229/2020 TEOR DO ATO: VISTOS. 1- FLS. 328/339: CIENCIA AS PARTES DO V. ACORDAO, QUE NEGOU PROVIMENTO DO RECURSO DE AGRAVO DE INSTRUMENTO. 2- NO MAIS, CUMPRA-SE A DECISAO DA FL. 325. 3- INTIMEM-SE. ADVOGADOS(S): JULIANO MELO DUARTE (OAB 193405/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-09-02T00:00:00",
                "CaptureDate": "2021-03-27T02:36:35"
              },
              {
                "Content": "DECISAO VISTOS. 1- FLS. 328/339: CIENCIA AS PARTES DO V. ACORDAO, QUE NEGOU PROVIMENTO DO RECURSO DE AGRAVO DE INSTRUMENTO. 2- NO MAIS, CUMPRA-SE A DECISAO DA FL. 325. 3- INTIMEM-SE.",
                "PublishDate": "2020-09-01T00:00:00",
                "CaptureDate": "2020-09-23T03:00:46"
              },
              {
                "Content": "DECISAO | VISTOS. 1- FLS. 328/339: CIENCIA AS PARTES DO V. ACORDAO, QUE NEGOU PROVIMENTO DO RECURSO DE AGRAVO DE INSTRUMENTO. 2- NO MAIS, CUMPRA-SE A DECISAO DA FL. 325. 3- INTIMEM-SE.",
                "PublishDate": "2020-09-01T00:00:00",
                "CaptureDate": "2021-03-27T02:36:35"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2020-08-28T00:00:00",
                "CaptureDate": "2020-09-23T03:00:46"
              },
              {
                "Content": "AGRAVO DE INSTRUMENTO - ACORDAO E DEMAIS PECAS JUNTADOS - COM TRANSITO EM JULGADO - AGRAVO DESTRUIDO",
                "PublishDate": "2020-08-28T00:00:00",
                "CaptureDate": "2020-09-23T03:00:46"
              },
              {
                "Content": "AGRAVO DE INSTRUMENTO - ACORDAO E DEMAIS PECAS JUNTADOS - COM TRANSITO EM JULGADO - AGRAVO DESTRUIDO",
                "PublishDate": "2020-08-28T00:00:00",
                "CaptureDate": "2021-03-27T02:36:35"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2020-08-28T00:00:00",
                "CaptureDate": "2021-03-27T02:36:35"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0221/2020 DATA DA DISPONIBILIZACAO: 24/08/2020 DATA DA PUBLICACAO: 25/08/2020 NUMERO DO DIARIO: 3112 PAGINA: 900/916",
                "PublishDate": "2020-08-24T00:00:00",
                "CaptureDate": "2020-09-23T03:00:46"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0221/2020 DATA DA DISPONIBILIZACAO: 24/08/2020 DATA DA PUBLICACAO: 25/08/2020 NUMERO DO DIARIO: 3112 PAGINA: 900/916",
                "PublishDate": "2020-08-24T00:00:00",
                "CaptureDate": "2021-03-27T02:36:35"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0221/2020 TEOR DO ATO: VISTOS. TOMO CIENCIA SOBRE O RECURSO INTERPOSTO PELA AUTORA (FLS. 293/298). CIENCIA A PARTE REQUERIDA DOS DOCUMENTOS DE FLS. 299/324, SENDO-LHE FACULTADA A MANIFESTACAO NOS TERMOS DO ART. 437, 1, DO CPC, NO PRAZO DE 15 DIAS. MANIFESTEM-SE AS PARTES, NO MESMO LAPSO, SOBRE O INTERESSE NA PRODUCAO DE OUTRAS PROVAS, JUSTIFICANDO A PERTINENCIA, DE ACORDO COM OS PONTOS CONTROVERTIDOS. APOS O DECURSO DO PRAZO, TORNEM CONCLUSOS PARA O SANEAMENTO OU A PROLACAO DE SENTENCA. INTIMEM-SE. ADVOGADOS(S): JULIANO MELO DUARTE (OAB 193405/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-08-21T00:00:00",
                "CaptureDate": "2020-09-23T03:00:46"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0221/2020 TEOR DO ATO: VISTOS. TOMO CIENCIA SOBRE O RECURSO INTERPOSTO PELA AUTORA (FLS. 293/298). CIENCIA A PARTE REQUERIDA DOS DOCUMENTOS DE FLS. 299/324, SENDO-LHE FACULTADA A MANIFESTACAO NOS TERMOS DO ART. 437, 1, DO CPC, NO PRAZO DE 15 DIAS. MANIFESTEM-SE AS PARTES, NO MESMO LAPSO, SOBRE O INTERESSE NA PRODUCAO DE OUTRAS PROVAS, JUSTIFICANDO A PERTINENCIA, DE ACORDO COM OS PONTOS CONTROVERTIDOS. APOS O DECURSO DO PRAZO, TORNEM CONCLUSOS PARA O SANEAMENTO OU A PROLACAO DE SENTENCA. INTIMEM-SE. ADVOGADOS(S): JULIANO MELO DUARTE (OAB 193405/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-08-21T00:00:00",
                "CaptureDate": "2021-03-27T02:36:35"
              },
              {
                "Content": "DECISAO VISTOS. TOMO CIENCIA SOBRE O RECURSO INTERPOSTO PELA AUTORA (FLS. 293/298). CIENCIA A PARTE REQUERIDA DOS DOCUMENTOS DE FLS. 299/324, SENDO-LHE FACULTADA A MANIFESTACAO NOS TERMOS DO ART. 437, 1, DO CPC, NO PRAZO DE 15 DIAS. MANIFESTEM-SE AS PARTES, NO MESMO LAPSO, SOBRE O INTERESSE NA PRODUCAO DE OUTRAS PROVAS, JUSTIFICANDO A PERTINENCIA, DE ACORDO COM OS PONTOS CONTROVERTIDOS. APOS O DECURSO DO PRAZO, TORNEM CONCLUSOS PARA O SANEAMENTO OU A PROLACAO DE SENTENCA. INTIMEM-SE.",
                "PublishDate": "2020-08-20T00:00:00",
                "CaptureDate": "2020-09-23T03:00:46"
              },
              {
                "Content": "DECISAO | VISTOS. TOMO CIENCIA SOBRE O RECURSO INTERPOSTO PELA AUTORA (FLS. 293/298). CIENCIA A PARTE REQUERIDA DOS DOCUMENTOS DE FLS. 299/324, SENDO-LHE FACULTADA A MANIFESTACAO NOS TERMOS DO ART. 437, 1, DO CPC, NO PRAZO DE 15 DIAS. MANIFESTEM-SE AS PARTES, NO MESMO LAPSO, SOBRE O INTERESSE NA PRODUCAO DE OUTRAS PROVAS, JUSTIFICANDO A PERTINENCIA, DE ACORDO COM OS PONTOS CONTROVERTIDOS. APOS O DECURSO DO PRAZO, TORNEM CONCLUSOS PARA O SANEAMENTO OU A PROLACAO DE SENTENCA. INTIMEM-SE.",
                "PublishDate": "2020-08-20T00:00:00",
                "CaptureDate": "2021-03-27T02:36:35"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2020-08-19T00:00:00",
                "CaptureDate": "2020-09-23T03:00:46"
              },
              {
                "Content": "REPLICA JUNTADA N PROTOCOLO: WJMJ.20.41258360-7 TIPO DA PETICAO: MANIFESTACAO SOBRE A CONTESTACAO DATA: 18/08/2020 21:54",
                "PublishDate": "2020-08-18T00:00:00",
                "CaptureDate": "2020-09-23T03:00:46"
              },
              {
                "Content": "REPLICA JUNTADA | N PROTOCOLO: WJMJ.20.41258360-7 TIPO DA PETICAO: MANIFESTACAO SOBRE A CONTESTACAO DATA: 18/08/2020 21:54",
                "PublishDate": "2020-08-18T00:00:00",
                "CaptureDate": "2021-03-27T02:36:35"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0189/2020 DATA DA DISPONIBILIZACAO: 27/07/2020 DATA DA PUBLICACAO: 28/07/2020 NUMERO DO DIARIO: 3092 PAGINA: 1024/1038",
                "PublishDate": "2020-07-27T00:00:00",
                "CaptureDate": "2020-09-23T03:00:46"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0189/2020 DATA DA DISPONIBILIZACAO: 27/07/2020 DATA DA PUBLICACAO: 28/07/2020 NUMERO DO DIARIO: 3092 PAGINA: 1024/1038",
                "PublishDate": "2020-07-27T00:00:00",
                "CaptureDate": "2021-03-27T02:36:35"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0189/2020 TEOR DO ATO: A PARTE AUTORA FICA INTIMADA A APRESENTAR REPLICA, NO PRAZO DE 15 (QUINZE) DIAS, NOS TERMOS DOS ARTIGOS 350 E 351, AMBOS DO CODIGO DE PROCESSO CIVIL. ADVOGADOS(S): JULIANO MELO DUARTE (OAB 193405/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-07-24T00:00:00",
                "CaptureDate": "2020-09-23T03:00:46"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0189/2020 TEOR DO ATO: A PARTE AUTORA FICA INTIMADA A APRESENTAR REPLICA, NO PRAZO DE 15 (QUINZE) DIAS, NOS TERMOS DOS ARTIGOS 350 E 351, AMBOS DO CODIGO DE PROCESSO CIVIL. ADVOGADOS(S): JULIANO MELO DUARTE (OAB 193405/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-07-24T00:00:00",
                "CaptureDate": "2021-03-27T02:36:35"
              },
              {
                "Content": "ATO ORDINATORIO - REPLICA DA CONTESTACAO A PARTE AUTORA FICA INTIMADA A APRESENTAR REPLICA, NO PRAZO DE 15 (QUINZE) DIAS, NOS TERMOS DOS ARTIGOS 350 E 351, AMBOS DO CODIGO DE PROCESSO CIVIL.",
                "PublishDate": "2020-07-23T00:00:00",
                "CaptureDate": "2020-09-23T03:00:46"
              },
              {
                "Content": "ATO ORDINATORIO - REPLICA DA CONTESTACAO | A PARTE AUTORA FICA INTIMADA A APRESENTAR REPLICA, NO PRAZO DE 15 (QUINZE) DIAS, NOS TERMOS DOS ARTIGOS 350 E 351, AMBOS DO CODIGO DE PROCESSO CIVIL.",
                "PublishDate": "2020-07-23T00:00:00",
                "CaptureDate": "2021-03-27T02:36:35"
              },
              {
                "Content": "CONTESTACAO JUNTADA N PROTOCOLO: WJMJ.20.41070821-6 TIPO DA PETICAO: CONTESTACAO DATA: 22/07/2020 15:16",
                "PublishDate": "2020-07-22T00:00:00",
                "CaptureDate": "2020-09-23T03:00:46"
              },
              {
                "Content": "CONTESTACAO JUNTADA | N PROTOCOLO: WJMJ.20.41070821-6 TIPO DA PETICAO: CONTESTACAO DATA: 22/07/2020 15:16",
                "PublishDate": "2020-07-22T00:00:00",
                "CaptureDate": "2021-03-27T02:36:35"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0168/2020 DATA DA DISPONIBILIZACAO: 14/07/2020 DATA DA PUBLICACAO: 15/07/2020 NUMERO DO DIARIO: 3083 PAGINA: 942/947",
                "PublishDate": "2020-07-14T00:00:00",
                "CaptureDate": "2020-09-23T03:00:46"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0168/2020 DATA DA DISPONIBILIZACAO: 14/07/2020 DATA DA PUBLICACAO: 15/07/2020 NUMERO DO DIARIO: 3083 PAGINA: 942/947",
                "PublishDate": "2020-07-14T00:00:00",
                "CaptureDate": "2021-03-27T02:36:35"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0168/2020 TEOR DO ATO: VISTOS. FLS. 226/231: CUIDA-SE DE EMBARGOS DE DECLARACAO OPOSTOS PELA PARTE REQUERIDA, NOS QUAIS ALEGA ERRO MATERIAL. CONHECO-OS, POIS TEMPESTIVOS, E OS REJEITO, SOB O FUNDAMENTO DE QUE A DECISAO APRECIOU OS ARGUMENTOS ESSENCIAIS DAS PARTES, NAO PADECENDO DE VICIO CORRIGIVEL POR ESTA VIA. INDEPENDENTEMENTE DE QUAL SEJA A RELACAO DO DEPOSITANTE DA MARCA \"START BANK BRASIL\" COM A REQUERIDA, FATO E QUE AS PERSONALIDADES NAO SE CONFUNDEM. EM VERDADE, CASO DESEJE A MODIFICACAO DO JULGADO, DEVERA INTERPOR O ADEQUADO RECURSO. INT. ADVOGADOS(S): JULIANO MELO DUARTE (OAB 193405/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-07-13T00:00:00",
                "CaptureDate": "2020-09-23T03:00:46"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0168/2020 TEOR DO ATO: VISTOS. FLS. 226/231: CUIDA-SE DE EMBARGOS DE DECLARACAO OPOSTOS PELA PARTE REQUERIDA, NOS QUAIS ALEGA ERRO MATERIAL. CONHECO-OS, POIS TEMPESTIVOS, E OS REJEITO, SOB O FUNDAMENTO DE QUE A DECISAO APRECIOU OS ARGUMENTOS ESSENCIAIS DAS PARTES, NAO PADECENDO DE VICIO CORRIGIVEL POR ESTA VIA. INDEPENDENTEMENTE DE QUAL SEJA A RELACAO DO DEPOSITANTE DA MARCA \"START BANK BRASIL\" COM A REQUERIDA, FATO E QUE AS PERSONALIDADES NAO SE CONFUNDEM. EM VERDADE, CASO DESEJE A MODIFICACAO DO JULGADO, DEVERA INTERPOR O ADEQUADO RECURSO. INT. ADVOGADOS(S): JULIANO MELO DUARTE (OAB 193405/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-07-13T00:00:00",
                "CaptureDate": "2021-03-27T02:36:35"
              },
              {
                "Content": "EMBARGOS DE DECLARACAO JUNTADOS N PROTOCOLO: WJMJ.20.40992877-1 TIPO DA PETICAO: EMBARGOS DE DECLARACAO DATA: 10/07/2020 11:58",
                "PublishDate": "2020-07-10T00:00:00",
                "CaptureDate": "2020-09-23T03:00:46"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2020-07-10T00:00:00",
                "CaptureDate": "2020-09-23T03:00:46"
              },
              {
                "Content": "EMBARGOS DE DECLARACAO NAO-ACOLHIDOS VISTOS. FLS. 226/231: CUIDA-SE DE EMBARGOS DE DECLARACAO OPOSTOS PELA PARTE REQUERIDA, NOS QUAIS ALEGA ERRO MATERIAL. CONHECO-OS, POIS TEMPESTIVOS, E OS REJEITO, SOB O FUNDAMENTO DE QUE A DECISAO APRECIOU OS ARGUMENTOS ESSENCIAIS DAS PARTES, NAO PADECENDO DE VICIO CORRIGIVEL POR ESTA VIA. INDEPENDENTEMENTE DE QUAL SEJA A RELACAO DO DEPOSITANTE DA MARCA \"START BANK BRASIL\" COM A REQUERIDA, FATO E QUE AS PERSONALIDADES NAO SE CONFUNDEM. EM VERDADE, CASO DESEJE A MODIFICACAO DO JULGADO, DEVERA INTERPOR O ADEQUADO RECURSO. INT.",
                "PublishDate": "2020-07-10T00:00:00",
                "CaptureDate": "2020-09-23T03:00:46"
              },
              {
                "Content": "EMBARGOS DE DECLARACAO NAO-ACOLHIDOS | VISTOS. FLS. 226/231: CUIDA-SE DE EMBARGOS DE DECLARACAO OPOSTOS PELA PARTE REQUERIDA, NOS QUAIS ALEGA ERRO MATERIAL. CONHECO-OS, POIS TEMPESTIVOS, E OS REJEITO, SOB O FUNDAMENTO DE QUE A DECISAO APRECIOU OS ARGUMENTOS ESSENCIAIS DAS PARTES, NAO PADECENDO DE VICIO CORRIGIVEL POR ESTA VIA. INDEPENDENTEMENTE DE QUAL SEJA A RELACAO DO DEPOSITANTE DA MARCA \"START BANK BRASIL\" COM A REQUERIDA, FATO E QUE AS PERSONALIDADES NAO SE CONFUNDEM. EM VERDADE, CASO DESEJE A MODIFICACAO DO JULGADO, DEVERA INTERPOR O ADEQUADO RECURSO. INT.",
                "PublishDate": "2020-07-10T00:00:00",
                "CaptureDate": "2021-03-27T02:36:35"
              },
              {
                "Content": "EMBARGOS DE DECLARACAO JUNTADOS | N PROTOCOLO: WJMJ.20.40992877-1 TIPO DA PETICAO: EMBARGOS DE DECLARACAO DATA: 10/07/2020 11:58",
                "PublishDate": "2020-07-10T00:00:00",
                "CaptureDate": "2021-03-27T02:36:35"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0160/2020 DATA DA DISPONIBILIZACAO: 08/07/2020 DATA DA PUBLICACAO: 09/07/2020 NUMERO DO DIARIO: 3079 PAGINA: 895/901",
                "PublishDate": "2020-07-08T00:00:00",
                "CaptureDate": "2020-09-23T03:00:46"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0160/2020 DATA DA DISPONIBILIZACAO: 08/07/2020 DATA DA PUBLICACAO: 09/07/2020 NUMERO DO DIARIO: 3079 PAGINA: 895/901",
                "PublishDate": "2020-07-08T00:00:00",
                "CaptureDate": "2021-03-27T02:36:35"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0161/2020 DATA DA DISPONIBILIZACAO: 07/07/2020 DATA DA PUBLICACAO: 08/07/2020 NUMERO DO DIARIO: 3078 PAGINA: 1150/1159",
                "PublishDate": "2020-07-07T00:00:00",
                "CaptureDate": "2020-09-23T03:00:46"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0161/2020 DATA DA DISPONIBILIZACAO: 07/07/2020 DATA DA PUBLICACAO: 08/07/2020 NUMERO DO DIARIO: 3078 PAGINA: 1150/1159",
                "PublishDate": "2020-07-07T00:00:00",
                "CaptureDate": "2021-03-27T02:36:35"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0161/2020 TEOR DO ATO: VISTOS. CUIDA-SE DE DEMANDA AJUIZADA POR STARK BANK S.A. CONTRA EMPRESA BRASILEIRA DE CARTOES START BANK EIRELI. SUSTENTA A AUTORA TER SIDO CONSTITUIDA EM 2018 COM NOME EMPRESARIAL STARK BAN E FORNECER TECNOLOGIA PARA EMPRESAS ESCALAREM OPERACOES FINANCEIRAS, ATUANDO COMO FACILITADORES JUNTO AOS BANCOS. AFIRMA QUE, DESDE MAIO DESTE ANO, COMECOU A RECEBER INUMERAS RECLAMACOES DE CONSUMIDORES QUE A CONFUNDEM COM A RE, QUE UTILIZA A EXPRESSAO START BANK PARA ATUAR NO MESMO SEGMENTO DE MERCADO [BANCARIO/FINANCEIRO]. REQUER A CONCESSAO DA TUTELA DE URGENCIA PARA QUE \"SEJA DETERMINADA LIMINARMENTE QUE A RE SE ABSTENHA DE USAR O NOME EMPRESARIAL E SINAIS DISTINTIVOS SEMELHANTES AO DA AUTORA ('STARK BANK') DE FORMA ISOLADA OU EM CONJUNTO COM OUTRAS EXPRESSOES, MARCAS OU VARIACOES EM SUAS ATIVIDADES OU POR QUALQUER OUTRO MOTIVO, ESPECIALMENTE COMO TITULO DE ESTABELECIMENTO, NOME DE DOMINIO NA INTERNET, NOME DE EMPRESA, MARCA OU LOGOMARCA DISTINTA DE PRODUTOS, SERVICOS, COMERCIALIZACAO, MATERIAIS DE DIVULGACAO/PUBLICIDADE/PROPAGANDA, ESTABELECIMENTOS OU EM QUALQUER OUTRO SINAL DISTINTIVO FISICO (COMO FACHADAS, LETREIRO, MATERIAL PUBLICITARIO, NOTAS FISCAIS, TOTENS, UNIFORMES, IMPRESSOS, DENTRE OUTROS) OU DIGITAL (EM SITIO DE INTERNET, ENDERECO DE E-MAIL ETC.)'. INTIMADA, A RE APRESENTOU MANIFESTACAO SOBRE O PEDIDO DE TUTELA DE URGENCIA A FLS. 185/193. AFIRMOU SER DEPOSITANTE DO PEDIDO DE REGISTRO DA MARCA START BANK BRASIL PERANTE O INPI E A POSSIBILIDADE DE CONVIVENCIA ENTRE AS MARCAS. DECIDO. NAO VERIFICO O PREENCHIMENTO DE TODOS OS ELEMENTOS DO ART. 300 DO CPC PARA A ANTECIPACAO DOS EFEITOS DA TUTELA, SENAO VEJA-SE. O MENCIONADO DISPOSITIVO ESTABELECE: ART. 300. A TUTELA DE URGENCIA SERA CONCEDIDA QUANDO HOUVER ELEMENTOS QUE EVIDENCIEM A PROBABILIDADE DO DIREITO E O PERIGO DE DANO OU O RISCO AO RESULTADO UTIL DO PROCESSO.  1O PARA A CONCESSAO DA TUTELA DE URGENCIA, O JUIZ PODE, CONFORME O CASO, EXIGIR CAUCAO REAL OU FIDEJUSSORIA IDONEA PARA RESSARCIR OS DANOS QUE A OUTRA PARTE POSSA VIR A SOFRER, PODENDO A CAUCAO SER DISPENSADA SE A PARTE ECONOMICAMENTE HIPOSSUFICIENTE NAO PUDER OFERECE-LA.  2O A TUTELA DE URGENCIA PODE SER CONCEDIDA LIMINARMENTE OU APOS JUSTIFICACAO PREVIA.  3O A TUTELA DE URGENCIA DE NATUREZA ANTECIPADA NAO SERA CONCEDIDA QUANDO HOUVER PERIGO DE IRREVERSIBILIDADE DOS EFEITOS DA DECISAO. ASSIM, ESSENCIALMENTE, CONCEDER-SE-A A TUTELA DE URGENCIA QUANTO HOUVER: (1) PROBABILIDADE DO DIREITO; E (2) RISCO DE DANO DE PERECIMENTO DO PROPRIO DIREITO OU AO RESULTADO UTIL DO PROCESSO; POR OUTRO LADO, NAO PODE EXISTIR PERIGO DE IRREVERSIBILIDADE DA MEDIDA. NO PRESENTE CASO, NAO E POSSIVEL VERIFICAR, NESSE MOMENTO PROCESSUAL, A PROBABILIDADE DO DIREITO. SOB A OTICA DA PROTECAO DOS NOMES EMPRESARIAIS, VALE RECORDAR O DISPOSTO NO CODIGO CIVIL: ART. 1.163. O NOME DE EMPRESARIO DEVE DISTINGUIR-SE DE QUALQUER OUTRO JA INSCRITO NO MESMO REGISTRO. PARAGRAFO UNICO. SE O EMPRESARIO TIVER NOME IDENTICO AO DE OUTROS JA INSCRITOS, DEVERA ACRESCENTAR DESIGNACAO QUE O DISTINGA. ART. 1.166. A INSCRICAO DO EMPRESARIO, OU DOS ATOS CONSTITUTIVOS DAS PESSOAS JURIDICAS, OU AS RESPECTIVAS AVERBACOES, NO REGISTRO PROPRIO, ASSEGURAM O USO EXCLUSIVO DO NOME NOS LIMITES DO RESPECTIVO ESTADO. PARAGRAFO UNICO. O USO PREVISTO NESTE ARTIGO ESTENDER-SE-A A TODO O TERRITORIO NACIONAL, SE REGISTRADO NA FORMA DA LEI ESPECIAL. ORA, AS IMAGENS COLACIONADAS A FLS. 5 INDICAM QUE AMBAS AS PARTES POSSUEM INSCRICOES VALIDADAS PELA JUNTA COMERCIAL: A AUTORA STARK BANK S.A. E A RE EMPRESA BRASILEIRA DE CARTOES START BANK EIRELI, NAO HAVENDO, PER SI, COLIDENCIA ENTRE OS NOMES EMPRESARIAIS. QUANTO A UTILIZACAO DAS EXPRESSOES COMO MARCA, VERIFICO, EM CONSULTA AO BANCO DE DADOS DO INPI, QUE A AUTORA TEVE DOIS PEDIDOS DE REGISTRO DE MARCAS NOMINATIVAS DE SERVICOS INDEFERIDOS: \"STARK BANK\" [PROCESSO N 917521773] E \"STARK\" [PROCESSO N 914799436]. A RE, POR SUA VEZ, NAO POSSUI QUALQUER DEPOSITO [O REFERIDO PROCESSO N 918959632 PARA REGISTRO DE MARCA MISTA \"START BANK BRASIL\" PERTENCE A TERCEIRO]. POR FIM, EXISTE MAIS UM ELEMENTO A AFASTAR, AO MENOS EM COGNICAO SUMARIA, EVENTUAL COLIDENCIA ENTRE AS EXPRESSOES \"STARK BANK\" E \"START BANK\": E QUE O INPI JA CONCEDEU REGISTRO AS MARCAS NOMINATIVAS \"STARK\" E \"START\" NUMA MESMA CLASSE DE PRODUTO, POSSIBILITANDO A COEXISTENCIA ENTRE AMBAS [VEJA-SE OS PROCESSOS N 908084668 E 818458720]. EVIDENTEMENTE, NESSA HIPOTESE, A AUTARQUIA FEDERAL NAO VISLUMBROU REPRODUCAO OU IMITACAO ENTRE AS MARCAS, RAZAO PELA QUAL AS REGISTROU. ANTE O EXPOSTO, INDEFIRO A TUTELA DE URGENCIA. AGUARDE-SE A VINDA DA CONTESTACAO, CUJO PRAZO COMECOU A CORRER DO INGRESSO DA RE NOS AUTOS. INT. ADVOGADOS(S): JULIANO MELO DUARTE (OAB 193405/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-07-06T00:00:00",
                "CaptureDate": "2020-09-23T03:00:46"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0161/2020 TEOR DO ATO: VISTOS. CUIDA-SE DE DEMANDA AJUIZADA POR STARK BANK S.A. CONTRA EMPRESA BRASILEIRA DE CARTOES START BANK EIRELI. SUSTENTA A AUTORA TER SIDO CONSTITUIDA EM 2018 COM NOME EMPRESARIAL STARK BAN E FORNECER TECNOLOGIA PARA EMPRESAS ESCALAREM OPERACOES FINANCEIRAS, ATUANDO COMO FACILITADORES JUNTO AOS BANCOS. AFIRMA QUE, DESDE MAIO DESTE ANO, COMECOU A RECEBER INUMERAS RECLAMACOES DE CONSUMIDORES QUE A CONFUNDEM COM A RE, QUE UTILIZA A EXPRESSAO START BANK PARA ATUAR NO MESMO SEGMENTO DE MERCADO [BANCARIO/FINANCEIRO]. REQUER A CONCESSAO DA TUTELA DE URGENCIA PARA QUE \"SEJA DETERMINADA LIMINARMENTE QUE A RE SE ABSTENHA DE USAR O NOME EMPRESARIAL E SINAIS DISTINTIVOS SEMELHANTES AO DA AUTORA ('STARK BANK') DE FORMA ISOLADA OU EM CONJUNTO COM OUTRAS EXPRESSOES, MARCAS OU VARIACOES EM SUAS ATIVIDADES OU POR QUALQUER OUTRO MOTIVO, ESPECIALMENTE COMO TITULO DE ESTABELECIMENTO, NOME DE DOMINIO NA INTERNET, NOME DE EMPRESA, MARCA OU LOGOMARCA DISTINTA DE PRODUTOS, SERVICOS, COMERCIALIZACAO, MATERIAIS DE DIVULGACAO/PUBLICIDADE/PROPAGANDA, ESTABELECIMENTOS OU EM QUALQUER OUTRO SINAL DISTINTIVO FISICO (COMO FACHADAS, LETREIRO, MATERIAL PUBLICITARIO, NOTAS FISCAIS, TOTENS, UNIFORMES, IMPRESSOS, DENTRE OUTROS) OU DIGITAL (EM SITIO DE INTERNET, ENDERECO DE E-MAIL ETC.)'. INTIMADA, A RE APRESENTOU MANIFESTACAO SOBRE O PEDIDO DE TUTELA DE URGENCIA A FLS. 185/193. AFIRMOU SER DEPOSITANTE DO PEDIDO DE REGISTRO DA MARCA START BANK BRASIL PERANTE O INPI E A POSSIBILIDADE DE CONVIVENCIA ENTRE AS MARCAS. DECIDO. NAO VERIFICO O PREENCHIMENTO DE TODOS OS ELEMENTOS DO ART. 300 DO CPC PARA A ANTECIPACAO DOS EFEITOS DA TUTELA, SENAO VEJA-SE. O MENCIONADO DISPOSITIVO ESTABELECE: ART. 300. A TUTELA DE URGENCIA SERA CONCEDIDA QUANDO HOUVER ELEMENTOS QUE EVIDENCIEM A PROBABILIDADE DO DIREITO E O PERIGO DE DANO OU O RISCO AO RESULTADO UTIL DO PROCESSO.  1O PARA A CONCESSAO DA TUTELA DE URGENCIA, O JUIZ PODE, CONFORME O CASO, EXIGIR CAUCAO REAL OU FIDEJUSSORIA IDONEA PARA RESSARCIR OS DANOS QUE A OUTRA PARTE POSSA VIR A SOFRER, PODENDO A CAUCAO SER DISPENSADA SE A PARTE ECONOMICAMENTE HIPOSSUFICIENTE NAO PUDER OFERECE-LA.  2O A TUTELA DE URGENCIA PODE SER CONCEDIDA LIMINARMENTE OU APOS JUSTIFICACAO PREVIA.  3O A TUTELA DE URGENCIA DE NATUREZA ANTECIPADA NAO SERA CONCEDIDA QUANDO HOUVER PERIGO DE IRREVERSIBILIDADE DOS EFEITOS DA DECISAO. ASSIM, ESSENCIALMENTE, CONCEDER-SE-A A TUTELA DE URGENCIA QUANTO HOUVER: (1) PROBABILIDADE DO DIREITO; E (2) RISCO DE DANO DE PERECIMENTO DO PROPRIO DIREITO OU AO RESULTADO UTIL DO PROCESSO; POR OUTRO LADO, NAO PODE EXISTIR PERIGO DE IRREVERSIBILIDADE DA MEDIDA. NO PRESENTE CASO, NAO E POSSIVEL VERIFICAR, NESSE MOMENTO PROCESSUAL, A PROBABILIDADE DO DIREITO. SOB A OTICA DA PROTECAO DOS NOMES EMPRESARIAIS, VALE RECORDAR O DISPOSTO NO CODIGO CIVIL: ART. 1.163. O NOME DE EMPRESARIO DEVE DISTINGUIR-SE DE QUALQUER OUTRO JA INSCRITO NO MESMO REGISTRO. PARAGRAFO UNICO. SE O EMPRESARIO TIVER NOME IDENTICO AO DE OUTROS JA INSCRITOS, DEVERA ACRESCENTAR DESIGNACAO QUE O DISTINGA. ART. 1.166. A INSCRICAO DO EMPRESARIO, OU DOS ATOS CONSTITUTIVOS DAS PESSOAS JURIDICAS, OU AS RESPECTIVAS AVERBACOES, NO REGISTRO PROPRIO, ASSEGURAM O USO EXCLUSIVO DO NOME NOS LIMITES DO RESPECTIVO ESTADO. PARAGRAFO UNICO. O USO PREVISTO NESTE ARTIGO ESTENDER-SE-A A TODO O TERRITORIO NACIONAL, SE REGISTRADO NA FORMA DA LEI ESPECIAL. ORA, AS IMAGENS COLACIONADAS A FLS. 5 INDICAM QUE AMBAS AS PARTES POSSUEM INSCRICOES VALIDADAS PELA JUNTA COMERCIAL: A AUTORA STARK BANK S.A. E A RE EMPRESA BRASILEIRA DE CARTOES START BANK EIRELI, NAO HAVENDO, PER SI, COLIDENCIA ENTRE OS NOMES EMPRESARIAIS. QUANTO A UTILIZACAO DAS EXPRESSOES COMO MARCA, VERIFICO, EM CONSULTA AO BANCO DE DADOS DO INPI, QUE A AUTORA TEVE DOIS PEDIDOS DE REGISTRO DE MARCAS NOMINATIVAS DE SERVICOS INDEFERIDOS: \"STARK BANK\" [PROCESSO N 917521773] E \"STARK\" [PROCESSO N 914799436]. A RE, POR SUA VEZ, NAO POSSUI QUALQUER DEPOSITO [O REFERIDO PROCESSO N 918959632 PARA REGISTRO DE MARCA MISTA \"START BANK BRASIL\" PERTENCE A TERCEIRO]. POR FIM, EXISTE MAIS UM ELEMENTO A AFASTAR, AO MENOS EM COGNICAO SUMARIA, EVENTUAL COLIDENCIA ENTRE AS EXPRESSOES \"STARK BANK\" E \"START BANK\": E QUE O INPI JA CONCEDEU REGISTRO AS MARCAS NOMINATIVAS \"STARK\" E \"START\" NUMA MESMA CLASSE DE PRODUTO, POSSIBILITANDO A COEXISTENCIA ENTRE AMBAS [VEJA-SE OS PROCESSOS N 908084668 E 818458720]. EVIDENTEMENTE, NESSA HIPOTESE, A AUTARQUIA FEDERAL NAO VISLUMBROU REPRODUCAO OU IMITACAO ENTRE AS MARCAS, RAZAO PELA QUAL AS REGISTROU. ANTE O EXPOSTO, INDEFIRO A TUTELA DE URGENCIA. AGUARDE-SE A VINDA DA CONTESTACAO, CUJO PRAZO COMECOU A CORRER DO INGRESSO DA RE NOS AUTOS. INT. ADVOGADOS(S): JULIANO MELO DUARTE (OAB 193405/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-07-06T00:00:00",
                "CaptureDate": "2021-03-27T02:36:35"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0160/2020 TEOR DO ATO: RECOLHA, A PARTE REQUERIDA, AS CUSTAS REFERENTES A TAXA DE MANDATO, NOS TERMOS DA LEI ESTADUAL N 10.394/1970 ALTERADA PELA LEI N 216/1974, ART. 48 E LEI N 16.665/2018 CORRESPONDENDO A 2% SOBRE O MENOR SALARIO - MINIMO VIGENTE NA CAPITAL DO ESTADO (R$23,67 POR PROCURACAO/SUBSTABELECIMENTO), NO PRAZO DE 15 (QUINZE) DIAS. ADVOGADOS(S): JULIANO MELO DUARTE (OAB 193405/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-07-03T00:00:00",
                "CaptureDate": "2020-09-23T03:00:46"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.20.40945255-6 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 03/07/2020 11:13",
                "PublishDate": "2020-07-03T00:00:00",
                "CaptureDate": "2020-09-23T03:00:46"
              },
              {
                "Content": "CERTIDAO DE CARTORIO EXPEDIDA CERTIDAO - CONFERENCIA GUIA DARE - PORTAL DE CUSTAS - PROV. CG N 01.2020",
                "PublishDate": "2020-07-03T00:00:00",
                "CaptureDate": "2020-09-23T03:00:46"
              },
              {
                "Content": "NAO CONCEDIDA A ANTECIPACAO DE TUTELA VISTOS. CUIDA-SE DE DEMANDA AJUIZADA POR STARK BANK S.A. CONTRA EMPRESA BRASILEIRA DE CARTOES START BANK EIRELI. SUSTENTA A AUTORA TER SIDO CONSTITUIDA EM 2018 COM NOME EMPRESARIAL STARK BAN E FORNECER TECNOLOGIA PARA EMPRESAS ESCALAREM OPERACOES FINANCEIRAS, ATUANDO COMO FACILITADORES JUNTO AOS BANCOS. AFIRMA QUE, DESDE MAIO DESTE ANO, COMECOU A RECEBER INUMERAS RECLAMACOES DE CONSUMIDORES QUE A CONFUNDEM COM A RE, QUE UTILIZA A EXPRESSAO START BANK PARA ATUAR NO MESMO SEGMENTO DE MERCADO [BANCARIO/FINANCEIRO]. REQUER A CONCESSAO DA TUTELA DE URGENCIA PARA QUE \"SEJA DETERMINADA LIMINARMENTE QUE A RE SE ABSTENHA DE USAR O NOME EMPRESARIAL E SINAIS DISTINTIVOS SEMELHANTES AO DA AUTORA ('STARK BANK') DE FORMA ISOLADA OU EM CONJUNTO COM OUTRAS EXPRESSOES, MARCAS OU VARIACOES EM SUAS ATIVIDADES OU POR QUALQUER OUTRO MOTIVO, ESPECIALMENTE COMO TITULO DE ESTABELECIMENTO, NOME DE DOMINIO NA INTERNET, NOME DE EMPRESA, MARCA OU LOGOMARCA DISTINTA DE PRODUTOS, SERVICOS, COMERCIALIZACAO, MATERIAIS DE DIVULGACAO/PUBLICIDADE/PROPAGANDA, ESTABELECIMENTOS OU EM QUALQUER OUTRO SINAL DISTINTIVO FISICO (COMO FACHADAS, LETREIRO, MATERIAL PUBLICITARIO, NOTAS FISCAIS, TOTENS, UNIFORMES, IMPRESSOS, DENTRE OUTROS) OU DIGITAL (EM SITIO DE INTERNET, ENDERECO DE E-MAIL ETC.)'. INTIMADA, A RE APRESENTOU MANIFESTACAO SOBRE O PEDIDO DE TUTELA DE URGENCIA A FLS. 185/193. AFIRMOU SER DEPOSITANTE DO PEDIDO DE REGISTRO DA MARCA START BANK BRASIL PERANTE O INPI E A POSSIBILIDADE DE CONVIVENCIA ENTRE AS MARCAS. DECIDO. NAO VERIFICO O PREENCHIMENTO DE TODOS OS ELEMENTOS DO ART. 300 DO CPC PARA A ANTECIPACAO DOS EFEITOS DA TUTELA, SENAO VEJA-SE. O MENCIONADO DISPOSITIVO ESTABELECE: ART. 300. A TUTELA DE URGENCIA SERA CONCEDIDA QUANDO HOUVER ELEMENTOS QUE EVIDENCIEM A PROBABILIDADE DO DIREITO E O PERIGO DE DANO OU O RISCO AO RESULTADO UTIL DO PROCESSO.  1O PARA A CONCESSAO DA TUTELA DE URGENCIA, O JUIZ PODE, CONFORME O CASO, EXIGIR CAUCAO REAL OU FIDEJUSSORIA IDONEA PARA RESSARCIR OS DANOS QUE A OUTRA PARTE POSSA VIR A SOFRER, PODENDO A CAUCAO SER DISPENSADA SE A PARTE ECONOMICAMENTE HIPOSSUFICIENTE NAO PUDER OFERECE-LA.  2O A TUTELA DE URGENCIA PODE SER CONCEDIDA LIMINARMENTE OU APOS JUSTIFICACAO PREVIA.  3O A TUTELA DE URGENCIA DE NATUREZA ANTECIPADA NAO SERA CONCEDIDA QUANDO HOUVER PERIGO DE IRREVERSIBILIDADE DOS EFEITOS DA DECISAO. ASSIM, ESSENCIALMENTE, CONCEDER-SE-A A TUTELA DE URGENCIA QUANTO HOUVER: (1) PROBABILIDADE DO DIREITO; E (2) RISCO DE DANO DE PERECIMENTO DO PROPRIO DIREITO OU AO RESULTADO UTIL DO PROCESSO; POR OUTRO LADO, NAO PODE EXISTIR PERIGO DE IRREVERSIBILIDADE DA MEDIDA. NO PRESENTE CASO, NAO E POSSIVEL VERIFICAR, NESSE MOMENTO PROCESSUAL, A PROBABILIDADE DO DIREITO. SOB A OTICA DA PROTECAO DOS NOMES EMPRESARIAIS, VALE RECORDAR O DISPOSTO NO CODIGO CIVIL: ART. 1.163. O NOME DE EMPRESARIO DEVE DISTINGUIR-SE DE QUALQUER OUTRO JA INSCRITO NO MESMO REGISTRO. PARAGRAFO UNICO. SE O EMPRESARIO TIVER NOME IDENTICO AO DE OUTROS JA INSCRITOS, DEVERA ACRESCENTAR DESIGNACAO QUE O DISTINGA. ART. 1.166. A INSCRICAO DO EMPRESARIO, OU DOS ATOS CONSTITUTIVOS DAS PESSOAS JURIDICAS, OU AS RESPECTIVAS AVERBACOES, NO REGISTRO PROPRIO, ASSEGURAM O USO EXCLUSIVO DO NOME NOS LIMITES DO RESPECTIVO ESTADO. PARAGRAFO UNICO. O USO PREVISTO NESTE ARTIGO ESTENDER-SE-A A TODO O TERRITORIO NACIONAL, SE REGISTRADO NA FORMA DA LEI ESPECIAL. ORA, AS IMAGENS COLACIONADAS A FLS. 5 INDICAM QUE AMBAS AS PARTES POSSUEM INSCRICOES VALIDADAS PELA JUNTA COMERCIAL: A AUTORA STARK BANK S.A. E A RE EMPRESA BRASILEIRA DE CARTOES START BANK EIRELI, NAO HAVENDO, PER SI, COLIDENCIA ENTRE OS NOMES EMPRESARIAIS. QUANTO A UTILIZACAO DAS EXPRESSOES COMO MARCA, VERIFICO, EM CONSULTA AO BANCO DE DADOS DO INPI, QUE A AUTORA TEVE DOIS PEDIDOS DE REGISTRO DE MARCAS NOMINATIVAS DE SERVICOS INDEFERIDOS: \"STARK BANK\" [PROCESSO N 917521773] E \"STARK\" [PROCESSO N 914799436]. A RE, POR SUA VEZ, NAO POSSUI QUALQUER DEPOSITO [O REFERIDO PROCESSO N 918959632 PARA REGISTRO DE MARCA MISTA \"START BANK BRASIL\" PERTENCE A TERCEIRO]. POR FIM, EXISTE MAIS UM ELEMENTO A AFASTAR, AO MENOS EM COGNICAO SUMARIA, EVENTUAL COLIDENCIA ENTRE AS EXPRESSOES \"STARK BANK\" E \"START BANK\": E QUE O INPI JA CONCEDEU REGISTRO AS MARCAS NOMINATIVAS \"STARK\" E \"START\" NUMA MESMA CLASSE DE PRODUTO, POSSIBILITANDO A COEXISTENCIA ENTRE AMBAS [VEJA-SE OS PROCESSOS N 908084668 E 818458720]. EVIDENTEMENTE, NESSA HIPOTESE, A AUTARQUIA FEDERAL NAO VISLUMBROU REPRODUCAO OU IMITACAO ENTRE AS MARCAS, RAZAO PELA QUAL AS REGISTROU. ANTE O EXPOSTO, INDEFIRO A TUTELA DE URGENCIA. AGUARDE-SE A VINDA DA CONTESTACAO, CUJO PRAZO COMECOU A CORRER DO INGRESSO DA RE NOS AUTOS. INT.",
                "PublishDate": "2020-07-03T00:00:00",
                "CaptureDate": "2020-09-23T03:00:46"
              },
              {
                "Content": "NAO CONCEDIDA A ANTECIPACAO DE TUTELA | VISTOS. CUIDA-SE DE DEMANDA AJUIZADA POR STARK BANK S.A. CONTRA EMPRESA BRASILEIRA DE CARTOES START BANK EIRELI. SUSTENTA A AUTORA TER SIDO CONSTITUIDA EM 2018 COM NOME EMPRESARIAL STARK BAN E FORNECER TECNOLOGIA PARA EMPRESAS ESCALAREM OPERACOES FINANCEIRAS, ATUANDO COMO FACILITADORES JUNTO AOS BANCOS. AFIRMA QUE, DESDE MAIO DESTE ANO, COMECOU A RECEBER INUMERAS RECLAMACOES DE CONSUMIDORES QUE A CONFUNDEM COM A RE, QUE UTILIZA A EXPRESSAO START BANK PARA ATUAR NO MESMO SEGMENTO DE MERCADO [BANCARIO/FINANCEIRO]. REQUER A CONCESSAO DA TUTELA DE URGENCIA PARA QUE \"SEJA DETERMINADA LIMINARMENTE QUE A RE SE ABSTENHA DE USAR O NOME EMPRESARIAL E SINAIS DISTINTIVOS SEMELHANTES AO DA AUTORA ('STARK BANK') DE FORMA ISOLADA OU EM CONJUNTO COM OUTRAS EXPRESSOES, MARCAS OU VARIACOES EM SUAS ATIVIDADES OU POR QUALQUER OUTRO MOTIVO, ESPECIALMENTE COMO TITULO DE ESTABELECIMENTO, NOME DE DOMINIO NA INTERNET, NOME DE EMPRESA, MARCA OU LOGOMARCA DISTINTA DE PRODUTOS, SERVICOS, COMERCIALIZACAO, MATERIAIS DE DIVULGACAO/PUBLICIDADE/PROPAGANDA, ESTABELECIMENTOS OU EM QUALQUER OUTRO SINAL DISTINTIVO FISICO (COMO FACHADAS, LETREIRO, MATERIAL PUBLICITARIO, NOTAS FISCAIS, TOTENS, UNIFORMES, IMPRESSOS, DENTRE OUTROS) OU DIGITAL (EM SITIO DE INTERNET, ENDERECO DE E-MAIL ETC.)'. INTIMADA, A RE APRESENTOU MANIFESTACAO SOBRE O PEDIDO DE TUTELA DE URGENCIA A FLS. 185/193. AFIRMOU SER DEPOSITANTE DO PEDIDO DE REGISTRO DA MARCA START BANK BRASIL PERANTE O INPI E A POSSIBILIDADE DE CONVIVENCIA ENTRE AS MARCAS. DECIDO. NAO VERIFICO O PREENCHIMENTO DE TODOS OS ELEMENTOS DO ART. 300 DO CPC PARA A ANTECIPACAO DOS EFEITOS DA TUTELA, SENAO VEJA-SE. O MENCIONADO DISPOSITIVO ESTABELECE: ART. 300. A TUTELA DE URGENCIA SERA CONCEDIDA QUANDO HOUVER ELEMENTOS QUE EVIDENCIEM A PROBABILIDADE DO DIREITO E O PERIGO DE DANO OU O RISCO AO RESULTADO UTIL DO PROCESSO.  1O PARA A CONCESSAO DA TUTELA DE URGENCIA, O JUIZ PODE, CONFORME O CASO, EXIGIR CAUCAO REAL OU FIDEJUSSORIA IDONEA PARA RESSARCIR OS DANOS QUE A OUTRA PARTE POSSA VIR A SOFRER, PODENDO A CAUCAO SER DISPENSADA SE A PARTE ECONOMICAMENTE HIPOSSUFICIENTE NAO PUDER OFERECE-LA.  2O A TUTELA DE URGENCIA PODE SER CONCEDIDA LIMINARMENTE OU APOS JUSTIFICACAO PREVIA.  3O A TUTELA DE URGENCIA DE NATUREZA ANTECIPADA NAO SERA CONCEDIDA QUANDO HOUVER PERIGO DE IRREVERSIBILIDADE DOS EFEITOS DA DECISAO. ASSIM, ESSENCIALMENTE, CONCEDER-SE-A A TUTELA DE URGENCIA QUANTO HOUVER: (1) PROBABILIDADE DO DIREITO; E (2) RISCO DE DANO DE PERECIMENTO DO PROPRIO DIREITO OU AO RESULTADO UTIL DO PROCESSO; POR OUTRO LADO, NAO PODE EXISTIR PERIGO DE IRREVERSIBILIDADE DA MEDIDA. NO PRESENTE CASO, NAO E POSSIVEL VERIFICAR, NESSE MOMENTO PROCESSUAL, A PROBABILIDADE DO DIREITO. SOB A OTICA DA PROTECAO DOS NOMES EMPRESARIAIS, VALE RECORDAR O DISPOSTO NO CODIGO CIVIL: ART. 1.163. O NOME DE EMPRESARIO DEVE DISTINGUIR-SE DE QUALQUER OUTRO JA INSCRITO NO MESMO REGISTRO. PARAGRAFO UNICO. SE O EMPRESARIO TIVER NOME IDENTICO AO DE OUTROS JA INSCRITOS, DEVERA ACRESCENTAR DESIGNACAO QUE O DISTINGA. ART. 1.166. A INSCRICAO DO EMPRESARIO, OU DOS ATOS CONSTITUTIVOS DAS PESSOAS JURIDICAS, OU AS RESPECTIVAS AVERBACOES, NO REGISTRO PROPRIO, ASSEGURAM O USO EXCLUSIVO DO NOME NOS LIMITES DO RESPECTIVO ESTADO. PARAGRAFO UNICO. O USO PREVISTO NESTE ARTIGO ESTENDER-SE-A A TODO O TERRITORIO NACIONAL, SE REGISTRADO NA FORMA DA LEI ESPECIAL. ORA, AS IMAGENS COLACIONADAS A FLS. 5 INDICAM QUE AMBAS AS PARTES POSSUEM INSCRICOES VALIDADAS PELA JUNTA COMERCIAL: A AUTORA STARK BANK S.A. E A RE EMPRESA BRASILEIRA DE CARTOES START BANK EIRELI, NAO HAVENDO, PER SI, COLIDENCIA ENTRE OS NOMES EMPRESARIAIS. QUANTO A UTILIZACAO DAS EXPRESSOES COMO MARCA, VERIFICO, EM CONSULTA AO BANCO DE DADOS DO INPI, QUE A AUTORA TEVE DOIS PEDIDOS DE REGISTRO DE MARCAS NOMINATIVAS DE SERVICOS INDEFERIDOS: \"STARK BANK\" [PROCESSO N 917521773] E \"STARK\" [PROCESSO N 914799436]. A RE, POR SUA VEZ, NAO POSSUI QUALQUER DEPOSITO [O REFERIDO PROCESSO N 918959632 PARA REGISTRO DE MARCA MISTA \"START BANK BRASIL\" PERTENCE A TERCEIRO]. POR FIM, EXISTE MAIS UM ELEMENTO A AFASTAR, AO MENOS EM COGNICAO SUMARIA, EVENTUAL COLIDENCIA ENTRE AS EXPRESSOES \"STARK BANK\" E \"START BANK\": E QUE O INPI JA CONCEDEU REGISTRO AS MARCAS NOMINATIVAS \"STARK\" E \"START\" NUMA MESMA CLASSE DE PRODUTO, POSSIBILITANDO A COEXISTENCIA ENTRE AMBAS [VEJA-SE OS PROCESSOS N 908084668 E 818458720]. EVIDENTEMENTE, NESSA HIPOTESE, A AUTARQUIA FEDERAL NAO VISLUMBROU REPRODUCAO OU IMITACAO ENTRE AS MARCAS, RAZAO PELA QUAL AS REGISTROU. ANTE O EXPOSTO, INDEFIRO A TUTELA DE URGENCIA. AGUARDE-SE A VINDA DA CONTESTACAO, CUJO PRAZO COMECOU A CORRER DO INGRESSO DA RE NOS AUTOS. INT.",
                "PublishDate": "2020-07-03T00:00:00",
                "CaptureDate": "2021-03-27T02:36:35"
              },
              {
                "Content": "CERTIDAO DE CARTORIO EXPEDIDA | CERTIDAO - CONFERENCIA GUIA DARE - PORTAL DE CUSTAS - PROV. CG N 01.2020",
                "PublishDate": "2020-07-03T00:00:00",
                "CaptureDate": "2021-03-27T02:36:35"
              },
              {
                "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.20.40945255-6 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 03/07/2020 11:13",
                "PublishDate": "2020-07-03T00:00:00",
                "CaptureDate": "2021-03-27T02:36:35"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0160/2020 TEOR DO ATO: RECOLHA, A PARTE REQUERIDA, AS CUSTAS REFERENTES A TAXA DE MANDATO, NOS TERMOS DA LEI ESTADUAL N 10.394/1970 ALTERADA PELA LEI N 216/1974, ART. 48 E LEI N 16.665/2018 CORRESPONDENDO A 2% SOBRE O MENOR SALARIO - MINIMO VIGENTE NA CAPITAL DO ESTADO (R$23,67 POR PROCURACAO/SUBSTABELECIMENTO), NO PRAZO DE 15 (QUINZE) DIAS. ADVOGADOS(S): JULIANO MELO DUARTE (OAB 193405/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-07-03T00:00:00",
                "CaptureDate": "2021-03-27T02:36:35"
              },
              {
                "Content": "CONTESTACAO JUNTADA N PROTOCOLO: WJMJ.20.40934412-5 TIPO DA PETICAO: CONTESTACAO DATA: 02/07/2020 02:12",
                "PublishDate": "2020-07-02T00:00:00",
                "CaptureDate": "2020-09-23T03:00:46"
              },
              {
                "Content": "ATO ORDINATORIO - PUBLICAVEL RECOLHA, A PARTE REQUERIDA, AS CUSTAS REFERENTES A TAXA DE MANDATO, NOS TERMOS DA LEI ESTADUAL N 10.394/1970 ALTERADA PELA LEI N 216/1974, ART. 48 E LEI N 16.665/2018 CORRESPONDENDO A 2% SOBRE O MENOR SALARIO - MINIMO VIGENTE NA CAPITAL DO ESTADO (R$23,67 POR PROCURACAO/SUBSTABELECIMENTO), NO PRAZO DE 15 (QUINZE) DIAS.",
                "PublishDate": "2020-07-02T00:00:00",
                "CaptureDate": "2020-09-23T03:00:46"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2020-07-02T00:00:00",
                "CaptureDate": "2020-09-23T03:00:46"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2020-07-02T00:00:00",
                "CaptureDate": "2021-03-27T02:36:35"
              },
              {
                "Content": "ATO ORDINATORIO - PUBLICAVEL | RECOLHA, A PARTE REQUERIDA, AS CUSTAS REFERENTES A TAXA DE MANDATO, NOS TERMOS DA LEI ESTADUAL N 10.394/1970 ALTERADA PELA LEI N 216/1974, ART. 48 E LEI N 16.665/2018 CORRESPONDENDO A 2% SOBRE O MENOR SALARIO - MINIMO VIGENTE NA CAPITAL DO ESTADO (R$23,67 POR PROCURACAO/SUBSTABELECIMENTO), NO PRAZO DE 15 (QUINZE) DIAS.",
                "PublishDate": "2020-07-02T00:00:00",
                "CaptureDate": "2021-03-27T02:36:35"
              },
              {
                "Content": "CONTESTACAO JUNTADA | N PROTOCOLO: WJMJ.20.40934412-5 TIPO DA PETICAO: CONTESTACAO DATA: 02/07/2020 02:12",
                "PublishDate": "2020-07-02T00:00:00",
                "CaptureDate": "2021-03-27T02:36:35"
              },
              {
                "Content": "ATO ORDINATORIO - INTIMACAO - DJE | RECOLHA, A PARTE REQUERIDA, AS CUSTAS REFERENTES A TAXA DE MANDATO, NOS TERMOS DA LEI ESTADUAL N 10.394/1970 ALTERADA PELA LEI N 216/1974, ART. 48 E LEI N 16.665/2018 CORRESPONDENDO A 2% SOBRE O MENOR SALARIO - MINIMO VIGENTE NA CAPITAL DO ESTADO (R$23,67 POR PROCURACAO/SUBSTABELECIMENTO), NO PRAZO DE 15 (QUINZE) DIAS.",
                "PublishDate": "2020-07-02T00:00:00",
                "CaptureDate": "2022-04-28T02:10:22"
              },
              {
                "Content": "ATO ORDINATORIO - INTIMACAO - DJE RECOLHA, A PARTE REQUERIDA, AS CUSTAS REFERENTES A TAXA DE MANDATO, NOS TERMOS DA LEI ESTADUAL N 10.394/1970 ALTERADA PELA LEI N 216/1974, ART. 48 E LEI N 16.665/2018 CORRESPONDENDO A 2% SOBRE O MENOR SALARIO - MINIMO VIGENTE NA CAPITAL DO ESTADO (R$23,67 POR PROCURACAO/SUBSTABELECIMENTO), NO PRAZO DE 15 (QUINZE) DIAS.",
                "PublishDate": "2020-07-02T00:00:00",
                "CaptureDate": "2022-12-23T18:22:03"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0149/2020 DATA DA DISPONIBILIZACAO: 29/06/2020 DATA DA PUBLICACAO: 30/06/2020 NUMERO DO DIARIO: 3072 PAGINA: 999/1005",
                "PublishDate": "2020-06-29T00:00:00",
                "CaptureDate": "2020-09-23T03:00:46"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0149/2020 DATA DA DISPONIBILIZACAO: 29/06/2020 DATA DA PUBLICACAO: 30/06/2020 NUMERO DO DIARIO: 3072 PAGINA: 999/1005",
                "PublishDate": "2020-06-29T00:00:00",
                "CaptureDate": "2021-03-27T02:36:35"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0149/2020 TEOR DO ATO: FICA A PARTE REQUERENTE INTIMADA PARA COMPROVAR O RECEBIMENTO DA DECISAO-OFICIO ENVIADA A PARTE CONTRARIA (FLS. 139/140), EM 05 DIAS. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-06-26T00:00:00",
                "CaptureDate": "2020-09-23T03:00:46"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0149/2020 TEOR DO ATO: FICA A PARTE REQUERENTE INTIMADA PARA COMPROVAR O RECEBIMENTO DA DECISAO-OFICIO ENVIADA A PARTE CONTRARIA (FLS. 139/140), EM 05 DIAS. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-06-26T00:00:00",
                "CaptureDate": "2021-03-27T02:36:35"
              },
              {
                "Content": "ATO ORDINATORIO - PUBLICAVEL FICA A PARTE REQUERENTE INTIMADA PARA COMPROVAR O RECEBIMENTO DA DECISAO-OFICIO ENVIADA A PARTE CONTRARIA (FLS. 139/140), EM 05 DIAS.",
                "PublishDate": "2020-06-25T00:00:00",
                "CaptureDate": "2020-09-23T03:00:46"
              },
              {
                "Content": "ATO ORDINATORIO - PUBLICAVEL | FICA A PARTE REQUERENTE INTIMADA PARA COMPROVAR O RECEBIMENTO DA DECISAO-OFICIO ENVIADA A PARTE CONTRARIA (FLS. 139/140), EM 05 DIAS.",
                "PublishDate": "2020-06-25T00:00:00",
                "CaptureDate": "2021-03-27T02:36:35"
              },
              {
                "Content": "ATO ORDINATORIO - INTIMACAO - DJE | FICA A PARTE REQUERENTE INTIMADA PARA COMPROVAR O RECEBIMENTO DA DECISAO-OFICIO ENVIADA A PARTE CONTRARIA (FLS. 139/140), EM 05 DIAS.",
                "PublishDate": "2020-06-25T00:00:00",
                "CaptureDate": "2022-04-28T02:10:22"
              },
              {
                "Content": "ATO ORDINATORIO - INTIMACAO - DJE FICA A PARTE REQUERENTE INTIMADA PARA COMPROVAR O RECEBIMENTO DA DECISAO-OFICIO ENVIADA A PARTE CONTRARIA (FLS. 139/140), EM 05 DIAS.",
                "PublishDate": "2020-06-25T00:00:00",
                "CaptureDate": "2022-12-23T18:22:03"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.20.40886228-9 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 24/06/2020 21:12",
                "PublishDate": "2020-06-24T00:00:00",
                "CaptureDate": "2020-09-23T03:00:46"
              },
              {
                "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.20.40886228-9 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 24/06/2020 21:12",
                "PublishDate": "2020-06-24T00:00:00",
                "CaptureDate": "2021-03-27T02:36:35"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0127/2020 DATA DA DISPONIBILIZACAO: 17/06/2020 DATA DA PUBLICACAO: 18/06/2020 NUMERO DO DIARIO: 3064 PAGINA: 872/879",
                "PublishDate": "2020-06-17T00:00:00",
                "CaptureDate": "2020-09-23T03:00:46"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0127/2020 DATA DA DISPONIBILIZACAO: 17/06/2020 DATA DA PUBLICACAO: 18/06/2020 NUMERO DO DIARIO: 3064 PAGINA: 872/879",
                "PublishDate": "2020-06-17T00:00:00",
                "CaptureDate": "2021-03-27T02:36:35"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0127/2020 TEOR DO ATO: VISTOS. CONSIDERANDO-SE A GRAVIDADE DAS ALEGACOES DA PARTE AUTORA, ANTES DA APRECIACAO DA LIMINAR E PRUDENTE A MANIFESTACAO DA PARTE REQUERIDA. ASSIM, FACULTO A PARTE RE APRESENTAR MANIFESTACAO SOBRE O PEDIDO DE TUTELA DE URGENCIA, NO PRAZO DE CINCO DIAS. SERVIRA A PRESENTE DECISAO DE OFICIO, A SER IMPRESSO E ENTREGUE PELA REQUERENTE DIRETAMENTE A PARTE CONTRARIA. CASO ESSA VENHA A SE MANIFESTAR NOS AUTOS SOBRE A LIMINAR, SEU PRAZO PARA CONTESTAR INICIAR-SE-A DA DATA DE INGRESSO ESPONTANEO. DO CONTRARIO, TRANSCORRIDO IN ALBIS O PRAZO PARA MANIFESTACAO, OS AUTOS DEVERAO VIR CONCLUSOS PARA APRECIACAO DA TUTELA ANTECIPADA, QUANDO, ENTAO, DETERMINAR-SE-A A EXPEDICAO DE CARTA DE CITACAO, SEGUINDO A DEMANDA SEU TRAMITE REGULAR. INT. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-06-16T00:00:00",
                "CaptureDate": "2020-09-23T03:00:46"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0127/2020 TEOR DO ATO: VISTOS. CONSIDERANDO-SE A GRAVIDADE DAS ALEGACOES DA PARTE AUTORA, ANTES DA APRECIACAO DA LIMINAR E PRUDENTE A MANIFESTACAO DA PARTE REQUERIDA. ASSIM, FACULTO A PARTE RE APRESENTAR MANIFESTACAO SOBRE O PEDIDO DE TUTELA DE URGENCIA, NO PRAZO DE CINCO DIAS. SERVIRA A PRESENTE DECISAO DE OFICIO, A SER IMPRESSO E ENTREGUE PELA REQUERENTE DIRETAMENTE A PARTE CONTRARIA. CASO ESSA VENHA A SE MANIFESTAR NOS AUTOS SOBRE A LIMINAR, SEU PRAZO PARA CONTESTAR INICIAR-SE-A DA DATA DE INGRESSO ESPONTANEO. DO CONTRARIO, TRANSCORRIDO IN ALBIS O PRAZO PARA MANIFESTACAO, OS AUTOS DEVERAO VIR CONCLUSOS PARA APRECIACAO DA TUTELA ANTECIPADA, QUANDO, ENTAO, DETERMINAR-SE-A A EXPEDICAO DE CARTA DE CITACAO, SEGUINDO A DEMANDA SEU TRAMITE REGULAR. INT. ADVOGADOS(S): RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-06-16T00:00:00",
                "CaptureDate": "2021-03-27T02:36:35"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2020-06-15T00:00:00",
                "CaptureDate": "2020-09-23T03:00:46"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2020-06-15T00:00:00",
                "CaptureDate": "2020-09-23T03:00:46"
              },
              {
                "Content": "CERTIDAO DE CARTORIO EXPEDIDA CERTIDAO - PETICAO INICIAL",
                "PublishDate": "2020-06-15T00:00:00",
                "CaptureDate": "2020-09-23T03:00:46"
              },
              {
                "Content": "DECISAO VISTOS. CONSIDERANDO-SE A GRAVIDADE DAS ALEGACOES DA PARTE AUTORA, ANTES DA APRECIACAO DA LIMINAR E PRUDENTE A MANIFESTACAO DA PARTE REQUERIDA. ASSIM, FACULTO A PARTE RE APRESENTAR MANIFESTACAO SOBRE O PEDIDO DE TUTELA DE URGENCIA, NO PRAZO DE CINCO DIAS. SERVIRA A PRESENTE DECISAO DE OFICIO, A SER IMPRESSO E ENTREGUE PELA REQUERENTE DIRETAMENTE A PARTE CONTRARIA. CASO ESSA VENHA A SE MANIFESTAR NOS AUTOS SOBRE A LIMINAR, SEU PRAZO PARA CONTESTAR INICIAR-SE-A DA DATA DE INGRESSO ESPONTANEO. DO CONTRARIO, TRANSCORRIDO IN ALBIS O PRAZO PARA MANIFESTACAO, OS AUTOS DEVERAO VIR CONCLUSOS PARA APRECIACAO DA TUTELA ANTECIPADA, QUANDO, ENTAO, DETERMINAR-SE-A A EXPEDICAO DE CARTA DE CITACAO, SEGUINDO A DEMANDA SEU TRAMITE REGULAR. INT.",
                "PublishDate": "2020-06-15T00:00:00",
                "CaptureDate": "2020-09-23T03:00:46"
              },
              {
                "Content": "DECISAO | VISTOS. CONSIDERANDO-SE A GRAVIDADE DAS ALEGACOES DA PARTE AUTORA, ANTES DA APRECIACAO DA LIMINAR E PRUDENTE A MANIFESTACAO DA PARTE REQUERIDA. ASSIM, FACULTO A PARTE RE APRESENTAR MANIFESTACAO SOBRE O PEDIDO DE TUTELA DE URGENCIA, NO PRAZO DE CINCO DIAS. SERVIRA A PRESENTE DECISAO DE OFICIO, A SER IMPRESSO E ENTREGUE PELA REQUERENTE DIRETAMENTE A PARTE CONTRARIA. CASO ESSA VENHA A SE MANIFESTAR NOS AUTOS SOBRE A LIMINAR, SEU PRAZO PARA CONTESTAR INICIAR-SE-A DA DATA DE INGRESSO ESPONTANEO. DO CONTRARIO, TRANSCORRIDO IN ALBIS O PRAZO PARA MANIFESTACAO, OS AUTOS DEVERAO VIR CONCLUSOS PARA APRECIACAO DA TUTELA ANTECIPADA, QUANDO, ENTAO, DETERMINAR-SE-A A EXPEDICAO DE CARTA DE CITACAO, SEGUINDO A DEMANDA SEU TRAMITE REGULAR. INT.",
                "PublishDate": "2020-06-15T00:00:00",
                "CaptureDate": "2021-03-27T02:36:35"
              },
              {
                "Content": "CERTIDAO DE CARTORIO EXPEDIDA | CERTIDAO - PETICAO INICIAL",
                "PublishDate": "2020-06-15T00:00:00",
                "CaptureDate": "2021-03-27T02:36:35"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2020-06-15T00:00:00",
                "CaptureDate": "2021-03-27T02:36:35"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2020-06-15T00:00:00",
                "CaptureDate": "2021-03-27T02:36:35"
              }
            ],
            "Petitions": [
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2020-06-24T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "CONTESTACAO",
                "Author": "",
                "CreationDate": "2020-07-02T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2020-07-03T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "EMBARGOS DE DECLARACAO",
                "Author": "",
                "CreationDate": "2020-07-10T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "CONTESTACAO",
                "Author": "",
                "CreationDate": "2020-07-22T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "MANIFESTACAO SOBRE A CONTESTACAO",
                "Author": "",
                "CreationDate": "2020-08-18T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2020-09-09T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "INDICACAO DE PROVAS",
                "Author": "",
                "CreationDate": "2020-09-10T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2020-10-07T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICAO INTERMEDIARIA",
                "Author": "",
                "CreationDate": "2020-10-09T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2020-10-28T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2020-12-09T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2021-02-08T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2021-04-28T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2021-04-29T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "RAZOES DE APELACAO",
                "Author": "",
                "CreationDate": "2021-05-28T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "CONTRARRAZOES DE APELACAO",
                "Author": "",
                "CreationDate": "2021-07-22T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              }
            ],
            "Decisions": [
              {
                "DecisionContent": "JULGO IMPROCEDENTES OS PEDIDOS FORMULADOS NA INICIAL DESTA ACAO PROPOSTA POR STARK BANK S.A.",
                "DecisionDate": "2021-05-06T00:00:00"
              },
              {
                "DecisionContent": "EXTINGO A ACAO COM RESOLUCAO DO MERITO, FUNDAMENTADO NO ART. 487, I, DO CPC.",
                "DecisionDate": "2021-05-06T00:00:00"
              },
              {
                "DecisionContent": "JULGO IMPROCEDENTES OS PEDIDOS FORMULADOS NA INICIAL DESTA ACAO PROPOSTA POR STARK BANK S.A.",
                "DecisionDate": "2021-05-04T00:00:00"
              },
              {
                "DecisionContent": "EXTINGO A ACAO COM RESOLUCAO DO MERITO, FUNDAMENTADO NO ART. 487, I, DO CPC.",
                "DecisionDate": "2021-05-04T00:00:00"
              },
              {
                "DecisionContent": "JULGO IMPROCEDENTES OS PEDIDOS FORMULADOS NA INICIAL DESTA ACAO PROPOSTA POR STARK BANK S.A.",
                "DecisionDate": "2021-05-04T00:00:00"
              },
              {
                "DecisionContent": "EXTINGO A ACAO COM RESOLUCAO DO MERITO, FUNDAMENTADO NO ART. 487, I, DO CPC.",
                "DecisionDate": "2021-05-04T00:00:00"
              },
              {
                "DecisionContent": "JULGO IMPROCEDENTES OS PEDIDOS FORMULADOS NA INICIAL DESTA ACAO PROPOSTA POR STARK BANK S.A.",
                "DecisionDate": "2021-05-03T00:00:00"
              },
              {
                "DecisionContent": "EXTINGO A ACAO COM RESOLUCAO DO MERITO, FUNDAMENTADO NO ART. 487, I, DO CPC.",
                "DecisionDate": "2021-05-03T00:00:00"
              },
              {
                "DecisionContent": "JULGO IMPROCEDENTES OS PEDIDOS FORMULADOS NA INICIAL DESTA ACAO PROPOSTA POR STARK BANK S.A.",
                "DecisionDate": "2021-05-03T00:00:00"
              },
              {
                "DecisionContent": "EXTINGO A ACAO COM RESOLUCAO DO MERITO, FUNDAMENTADO NO ART. 487, I, DO CPC.",
                "DecisionDate": "2021-05-03T00:00:00"
              }
            ]
          },
          {
            "Number": "10117999420198260248",
            "Type": "PROCEDIMENTO COMUM",
            "MainSubject": "INDENIZACAO POR DANO MORAL",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "INDAIATUBA",
            "Judge": "LUCAS PEREIRA MORAES GARCIA",
            "JudgingBody": "2 VARA CIVEL",
            "State": "SP",
            "Status": "EM GRAU DE RECURSO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "INDENIZAÇÃO POR DANO MORAL",
            "InferredCNJSubjectNumber": 14010,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO TRABALHO",
            "InferredBroadCNJSubjectNumber": 864,
            "OtherSubjects": [
              "INDENIZACAO POR DANO MORAL",
              "INDENIZACAO POR DANO MORAL"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 76460.54,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "2020-09-01T00:00:00",
            "PublicationDate": "2022-09-09T00:00:00",
            "NoticeDate": "2020-09-01T00:00:00",
            "LastMovementDate": "2022-01-07T00:00:00",
            "CaptureDate": "2022-12-24T02:31:06",
            "LastUpdate": "2022-12-24T02:31:06",
            "NumberOfParties": 14,
            "NumberOfUpdates": 222,
            "LawSuitAge": 1275,
            "AverageNumberOfUpdatesPerMonth": 4,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "15005633000160",
                "IsPartyActive": true,
                "Name": "MASOTTI INDAIATUBA EMPREENDIMENTOS LTDA",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2022-12-24T02:31:06"
              },
              {
                "Doc": "28235049821",
                "IsPartyActive": true,
                "Name": "CLARISSA ALINE PAIE RODELLA CONTATO",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "209019",
                  "State": "SP",
                  "SpecificType": "ADVOGADO REQUERENTE"
                },
                "LastCaptureDate": "2022-12-24T02:31:06"
              },
              {
                "Doc": "42518816801",
                "IsPartyActive": false,
                "Name": "GABRIELA BONI TEIXEIRA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "412208",
                  "State": "SP",
                  "SpecificType": "ADVOGADO REQUERENTE"
                },
                "LastCaptureDate": "2020-04-05T01:46:42"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2022-12-24T02:31:06"
              },
              {
                "Doc": "00028986000108",
                "IsPartyActive": true,
                "Name": "ELEVADORES ATLAS SCHINDLER LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2022-12-24T02:31:06"
              },
              {
                "Doc": "46189325000165",
                "IsPartyActive": true,
                "Name": "ITAU UNIBANCO S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2022-12-24T02:31:06"
              },
              {
                "Doc": "13510720806",
                "IsPartyActive": true,
                "Name": "PAULO ROBERTO JOAQUIM DOS REIS",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "23134",
                  "State": "SP",
                  "SpecificType": "ADVOGADO REQUERIDO"
                },
                "LastCaptureDate": "2022-12-24T02:31:06"
              },
              {
                "Doc": "15092288884",
                "IsPartyActive": false,
                "Name": "FABIO HENRIQUE PRADO DE TOLEDO",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Doc": "35068411817",
                "IsPartyActive": true,
                "Name": "RAFAEL HIDEO NAZIMA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "295443",
                  "State": "SP",
                  "SpecificType": "ADVOGADO (REQDO)"
                },
                "LastCaptureDate": "2022-12-24T02:31:06"
              },
              {
                "IsPartyActive": false,
                "Name": "CLARISSA ALINE PAIE RODELLA CONTATO",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "SpecificType": "ADVOGADO (REQTE)"
                },
                "LastCaptureDate": "2022-05-20T11:00:57"
              },
              {
                "IsPartyActive": false,
                "Name": "RAFAEL HIDEO NAZIMA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "SpecificType": "ADVOGADO (REQDO)"
                },
                "LastCaptureDate": "2022-05-20T11:00:57"
              },
              {
                "IsPartyActive": false,
                "Name": "PAULO ROBERTO JOAQUIM DOS REIS",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "SpecificType": "ADVOGADO (REQDO)"
                },
                "LastCaptureDate": "2022-05-20T11:00:57"
              },
              {
                "Doc": "27581891860",
                "IsPartyActive": true,
                "Name": "LUCAS PEREIRA MORAES GARCIA",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "OAB": "220929",
                  "State": "SP",
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2022-12-24T02:31:06"
              },
              {
                "Doc": "16580239867",
                "IsPartyActive": true,
                "Name": "ANDRE GUSTAVO SALVADOR KAUFFMAN",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "168804",
                  "State": "SP",
                  "SpecificType": "ADVOGADO (REQDO)"
                },
                "LastCaptureDate": "2022-12-24T02:31:06"
              }
            ],
            "Updates": [
              {
                "Content": "INICIO DA EXECUCAO JUNTADO | 0000192-13.2022.8.26.0114 - CUMPRIMENTO DE SENTENCA",
                "PublishDate": "2022-01-07T00:00:00",
                "CaptureDate": "2022-05-20T11:00:57"
              },
              {
                "Content": "INICIO DA EXECUCAO JUNTADO 0000192-13.2022.8.26.0114 - CUMPRIMENTO DE SENTENCA",
                "PublishDate": "2022-01-07T00:00:00",
                "CaptureDate": "2022-12-24T02:31:07"
              },
              {
                "Content": "PEDIDO DE EXTINCAO JUNTADA | N PROTOCOLO: WCAS.21.70639400-4 TIPO DA PETICAO: PEDIDO DE EXTINCAO DO PROCESSO DATA: 03/12/2021 11:55",
                "PublishDate": "2021-12-04T00:00:00",
                "CaptureDate": "2022-05-20T11:00:57"
              },
              {
                "Content": "PEDIDO DE EXTINCAO JUNTADA N PROTOCOLO: WCAS.21.70639400-4 TIPO DA PETICAO: PEDIDO DE EXTINCAO DO PROCESSO DATA: 03/12/2021 11:55",
                "PublishDate": "2021-12-04T00:00:00",
                "CaptureDate": "2022-12-24T02:31:07"
              },
              {
                "Content": "PETICAO JUNTADA | N PROTOCOLO: WCAS.21.70602899-7 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 14/11/2021 20:37",
                "PublishDate": "2021-11-15T00:00:00",
                "CaptureDate": "2021-11-30T10:37:29"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WCAS.21.70602899-7 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 14/11/2021 20:37",
                "PublishDate": "2021-11-15T00:00:00",
                "CaptureDate": "2022-12-24T02:31:07"
              },
              {
                "Content": "REMETIDOS OS AUTOS PARA O TRIBUNAL DE JUSTICA/COLEGIO RECURSAL - PROCESSO DIGITAL",
                "PublishDate": "2021-06-28T00:00:00",
                "CaptureDate": "2021-07-12T17:16:20"
              },
              {
                "Content": "CERTIDAO DE CARTORIO EXPEDIDA | CERTIDAO - REMESSA DOS AUTOS A 2 INSTANCIA - ART. 102 - NSCGJ",
                "PublishDate": "2021-06-28T00:00:00",
                "CaptureDate": "2021-07-12T17:16:20"
              },
              {
                "Content": "CERTIDAO DE CARTORIO EXPEDIDA CERTIDAO - REMESSA DOS AUTOS A 2 INSTANCIA - ART. 102 - NSCGJ",
                "PublishDate": "2021-06-28T00:00:00",
                "CaptureDate": "2022-12-24T02:31:07"
              },
              {
                "Content": "REMETIDOS OS AUTOS PARA O TRIBUNAL DE JUSTICA/COLEGIO RECURSAL - PROCESSO DIGITAL",
                "PublishDate": "2021-06-28T00:00:00",
                "CaptureDate": "2022-12-24T02:31:07"
              },
              {
                "Content": "CONTRARRAZOES JUNTADA | N PROTOCOLO: WCAS.21.70313816-3 TIPO DA PETICAO: CONTRARRAZOES DE APELACAO DATA: 14/06/2021 23:16",
                "PublishDate": "2021-06-15T00:00:00",
                "CaptureDate": "2021-07-12T17:16:20"
              },
              {
                "Content": "CONTRARRAZOES JUNTADA N PROTOCOLO: WCAS.21.70313816-3 TIPO DA PETICAO: CONTRARRAZOES DE APELACAO DATA: 14/06/2021 23:16",
                "PublishDate": "2021-06-15T00:00:00",
                "CaptureDate": "2022-12-24T02:31:07"
              },
              {
                "Content": "CONTRARRAZOES JUNTADA | N PROTOCOLO: WCAS.21.70302833-3 TIPO DA PETICAO: CONTRARRAZOES DE APELACAO DATA: 08/06/2021 22:03",
                "PublishDate": "2021-06-08T00:00:00",
                "CaptureDate": "2021-07-12T17:16:20"
              },
              {
                "Content": "CONTRARRAZOES JUNTADA N PROTOCOLO: WCAS.21.70302833-3 TIPO DA PETICAO: CONTRARRAZOES DE APELACAO DATA: 08/06/2021 22:03",
                "PublishDate": "2021-06-08T00:00:00",
                "CaptureDate": "2022-12-24T02:31:07"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0476/2021 DATA DA DISPONIBILIZACAO: 25/05/2021 DATA DA PUBLICACAO: 26/05/2021 NUMERO DO DIARIO: 3285 PAGINA: 1702",
                "PublishDate": "2021-05-25T00:00:00",
                "CaptureDate": "2021-06-03T07:35:42"
              },
              {
                "Content": "PROCESSO 1011799-94.2019.8.26.0248 - PROCEDIMENTO COMUM CIVEL - INDENIZACAO POR DANO MORAL - MASOTTI INDAIATUBA EMPREENDIMENTOS LTDA. - STARK BANK S.A. - - ELEVADORES ATLAS SCHINDLER LTDA. - - ITAU UNIBANCO S/A - AUTOS N 2020/001682 (NUMERO DO PROCESSO NA VARA). INTERPOSTO RECURSO DE APELACAO, ABRA-SE VISTA A PARTE CONTRARIA PARA AS CONTRARRAZOES, NO PRAZO LEGAL. APOS, REMETAM-SE OS AUTOS AO EGREGIO TRIBUNAL DE JUSTICA DO ESTADO DE SAO PAULO, SECAO DE DIREITO PRIVADO, COM NOSSAS HOMENAGENS E CAUTELAS DE PRAXE. INTIMEM-SE. CAMPINAS, 21 DE MAIO DE 2021. - ADV: PAULO ROBERTO JOAQUIM DOS REIS (OAB 23134/SP), ANDRE GUSTAVO SALVADOR KAUFFMAN (OAB 168804/SP), CLARISSA ALINE PAIE RODELLA CONTATO (OAB 209019/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2021-05-25T00:00:00",
                "CaptureDate": "2021-06-03T07:35:42"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0476/2021 DATA DA DISPONIBILIZACAO: 25/05/2021 DATA DA PUBLICACAO: 26/05/2021 NUMERO DO DIARIO: 3285 PAGINA: 1702",
                "PublishDate": "2021-05-25T00:00:00",
                "CaptureDate": "2022-12-24T02:31:07"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0476/2021 TEOR DO ATO: AUTOS N 2020/001682 (NUMERO DO PROCESSO NA VARA). INTERPOSTO RECURSO DE APELACAO, ABRA-SE VISTA A PARTE CONTRARIA PARA AS CONTRARRAZOES, NO PRAZO LEGAL. APOS, REMETAM-SE OS AUTOS AO EGREGIO TRIBUNAL DE JUSTICA DO ESTADO DE SAO PAULO, SECAO DE DIREITO PRIVADO, COM NOSSAS HOMENAGENS E CAUTELAS DE PRAXE. INTIMEM-SE. CAMPINAS, 21 DE MAIO DE 2021. ADVOGADOS(S): ANDRE GUSTAVO SALVADOR KAUFFMAN (OAB 168804/SP), CLARISSA ALINE PAIE RODELLA CONTATO (OAB 209019/SP), PAULO ROBERTO JOAQUIM DOS REIS (OAB 23134/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2021-05-24T00:00:00",
                "CaptureDate": "2021-06-03T07:35:42"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0476/2021 TEOR DO ATO: AUTOS N 2020/001682 (NUMERO DO PROCESSO NA VARA). INTERPOSTO RECURSO DE APELACAO, ABRA-SE VISTA A PARTE CONTRARIA PARA AS CONTRARRAZOES, NO PRAZO LEGAL. APOS, REMETAM-SE OS AUTOS AO EGREGIO TRIBUNAL DE JUSTICA DO ESTADO DE SAO PAULO, SECAO DE DIREITO PRIVADO, COM NOSSAS HOMENAGENS E CAUTELAS DE PRAXE. INTIMEM-SE. CAMPINAS, 21 DE MAIO DE 2021. ADVOGADOS(S): ANDRE GUSTAVO SALVADOR KAUFFMAN (OAB 168804/SP), CLARISSA ALINE PAIE RODELLA CONTATO (OAB 209019/SP), PAULO ROBERTO JOAQUIM DOS REIS (OAB 23134/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2021-05-24T00:00:00",
                "CaptureDate": "2022-12-24T02:31:07"
              },
              {
                "Content": "RECEBIDO O RECURSO | AUTOS N 2020/001682 (NUMERO DO PROCESSO NA VARA). INTERPOSTO RECURSO DE APELACAO, ABRA-SE VISTA A PARTE CONTRARIA PARA AS CONTRARRAZOES, NO PRAZO LEGAL. APOS, REMETAM-SE OS AUTOS AO EGREGIO TRIBUNAL DE JUSTICA DO ESTADO DE SAO PAULO, SECAO DE DIREITO PRIVADO, COM NOSSAS HOMENAGENS E CAUTELAS DE PRAXE. INTIMEM-SE. CAMPINAS, 21 DE MAIO DE 2021.",
                "PublishDate": "2021-05-21T00:00:00",
                "CaptureDate": "2021-06-03T07:35:42"
              },
              {
                "Content": "RECEBIDO O RECURSO AUTOS N 2020/001682 (NUMERO DO PROCESSO NA VARA). INTERPOSTO RECURSO DE APELACAO, ABRA-SE VISTA A PARTE CONTRARIA PARA AS CONTRARRAZOES, NO PRAZO LEGAL. APOS, REMETAM-SE OS AUTOS AO EGREGIO TRIBUNAL DE JUSTICA DO ESTADO DE SAO PAULO, SECAO DE DIREITO PRIVADO, COM NOSSAS HOMENAGENS E CAUTELAS DE PRAXE. INTIMEM-SE. CAMPINAS, 21 DE MAIO DE 2021.",
                "PublishDate": "2021-05-21T00:00:00",
                "CaptureDate": "2022-12-24T02:31:07"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2021-05-20T00:00:00",
                "CaptureDate": "2021-06-03T07:35:42"
              },
              {
                "Content": "APELACAO/RAZOES JUNTADA | N PROTOCOLO: WCAS.21.70267054-6 TIPO DA PETICAO: RAZOES DE APELACAO DATA: 19/05/2021 20:21",
                "PublishDate": "2021-05-19T00:00:00",
                "CaptureDate": "2021-06-03T07:35:42"
              },
              {
                "Content": "APELACAO/RAZOES JUNTADA N PROTOCOLO: WCAS.21.70267054-6 TIPO DA PETICAO: RAZOES DE APELACAO DATA: 19/05/2021 20:21",
                "PublishDate": "2021-05-19T00:00:00",
                "CaptureDate": "2022-12-24T02:31:07"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0364/2021 DATA DA DISPONIBILIZACAO: 28/04/2021 DATA DA PUBLICACAO: 29/04/2021 NUMERO DO DIARIO: 3266 PAGINA: 1795",
                "PublishDate": "2021-04-28T00:00:00",
                "CaptureDate": "2021-05-03T23:33:34"
              },
              {
                "Content": "PROCESSO 1011799-94.2019.8.26.0248 - PROCEDIMENTO COMUM CIVEL - INDENIZACAO POR DANO MORAL - MASOTTI INDAIATUBA EMPREENDIMENTOS LTDA. - STARK BANK S.A. - - ELEVADORES ATLAS SCHINDLER LTDA. - - ITAU UNIBANCO S/A - AUTOS N 2020/001682 (NUMERO DO PROCESSO NA VARA). VISTOS. FLS. 535/541 [(...) REQUER A VOSSA EXCELENCIA QUE RECEBA E CONHECA DOS PRESENTES EMBARGOS E, AO FINAL, OS ACOLHA, A FIM DE RECONSIDERAR A R. SENTENCA, DE MODO A FIXAR O VALOR DA CAUSA NOS PARAMETROS APRESENTADOS PELA EMBARGADA, NO IMPORTE DE R$ 142.901,08 (CENTO E QUARENTA E DOIS MIL NOVECENTOS E UM REAIS E OITO CENTAVOS), ALEM DA REFORMA QUANTO A FIXACAO DA VERBA HONORARIA., SUPRIMINDO, ASSIM, AS OMISSOES APONTADAS (...)] CONHECO OS EMBARGOS OPOSTOS, UMA VEZ QUE TEMPESTIVOS (FL. 543). POREM, REJEITO-OS DE PLANO, PORQUE NAO HA NENHUMA OMISSAO A SER SANADA NO CASO. COM EFEITO, A RIGOR, O QUE PRETENDE A PARTE AUTORA E DEBATER O MERITO DA SENTENCA PROFERIDA POR ESTE JUIZO, ALGO QUE, DATA VENIA, NAO E POSSIVEL DE SER FEITO VIA DECLARATORIOS, DIANTE DA RESTRITA NATUREZA INTEGRATIVA DESSE RECURSO. INTIMEM-SE. CAMPINAS, 26 DE ABRIL DE 2021. FABIO HENRIQUE PRADO DE TOLEDO JUIZ(A) DE DIREITO - ADV: ANDRE GUSTAVO SALVADOR KAUFFMAN (OAB 168804/SP), CLARISSA ALINE PAIE RODELLA CONTATO (OAB 209019/SP), PAULO ROBERTO JOAQUIM DOS REIS (OAB 23134/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2021-04-28T00:00:00",
                "CaptureDate": "2021-05-03T23:33:34"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0364/2021 DATA DA DISPONIBILIZACAO: 28/04/2021 DATA DA PUBLICACAO: 29/04/2021 NUMERO DO DIARIO: 3266 PAGINA: 1795",
                "PublishDate": "2021-04-28T00:00:00",
                "CaptureDate": "2022-12-24T02:31:07"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0364/2021 TEOR DO ATO: AUTOS N 2020/001682 (NUMERO DO PROCESSO NA VARA). VISTOS. FLS. 535/541 [\"(...) REQUER A VOSSA EXCELENCIA QUE RECEBA E CONHECA DOS PRESENTES EMBARGOS E, AO FINAL, OS ACOLHA, A FIM DE RECONSIDERAR A R. SENTENCA, DE MODO A FIXAR O VALOR DA CAUSA NOS PARAMETROS APRESENTADOS PELA EMBARGADA, NO IMPORTE DE R$ 142.901,08 (CENTO E QUARENTA E DOIS MIL NOVECENTOS E UM REAIS E OITO CENTAVOS), ALEM DA REFORMA QUANTO A FIXACAO DA VERBA HONORARIA., SUPRIMINDO, ASSIM, AS OMISSOES APONTADAS (...)\"] CONHECO OS EMBARGOS OPOSTOS, UMA VEZ QUE TEMPESTIVOS (FL. 543). POREM, REJEITO-OS DE PLANO, PORQUE NAO HA NENHUMA OMISSAO A SER SANADA NO CASO. COM EFEITO, A RIGOR, O QUE PRETENDE A PARTE AUTORA E DEBATER O MERITO DA SENTENCA PROFERIDA POR ESTE JUIZO, ALGO QUE, DATA VENIA, NAO E POSSIVEL DE SER FEITO VIA DECLARATORIOS, DIANTE DA RESTRITA NATUREZA INTEGRATIVA DESSE RECURSO. INTIMEM-SE. CAMPINAS, 26 DE ABRIL DE 2021. FABIO HENRIQUE PRADO DE TOLEDO JUIZ(A) DE DIREITO ADVOGADOS(S): ANDRE GUSTAVO SALVADOR KAUFFMAN (OAB 168804/SP), CLARISSA ALINE PAIE RODELLA CONTATO (OAB 209019/SP), PAULO ROBERTO JOAQUIM DOS REIS (OAB 23134/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2021-04-27T00:00:00",
                "CaptureDate": "2021-05-03T23:33:34"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0364/2021 TEOR DO ATO: AUTOS N 2020/001682 (NUMERO DO PROCESSO NA VARA). VISTOS. FLS. 535/541 [\"(...) REQUER A VOSSA EXCELENCIA QUE RECEBA E CONHECA DOS PRESENTES EMBARGOS E, AO FINAL, OS ACOLHA, A FIM DE RECONSIDERAR A R. SENTENCA, DE MODO A FIXAR O VALOR DA CAUSA NOS PARAMETROS APRESENTADOS PELA EMBARGADA, NO IMPORTE DE R$ 142.901,08 (CENTO E QUARENTA E DOIS MIL NOVECENTOS E UM REAIS E OITO CENTAVOS), ALEM DA REFORMA QUANTO A FIXACAO DA VERBA HONORARIA., SUPRIMINDO, ASSIM, AS OMISSOES APONTADAS (...)\"] CONHECO OS EMBARGOS OPOSTOS, UMA VEZ QUE TEMPESTIVOS (FL. 543). POREM, REJEITO-OS DE PLANO, PORQUE NAO HA NENHUMA OMISSAO A SER SANADA NO CASO. COM EFEITO, A RIGOR, O QUE PRETENDE A PARTE AUTORA E DEBATER O MERITO DA SENTENCA PROFERIDA POR ESTE JUIZO, ALGO QUE, DATA VENIA, NAO E POSSIVEL DE SER FEITO VIA DECLARATORIOS, DIANTE DA RESTRITA NATUREZA INTEGRATIVA DESSE RECURSO. INTIMEM-SE. CAMPINAS, 26 DE ABRIL DE 2021. FABIO HENRIQUE PRADO DE TOLEDO JUIZ(A) DE DIREITO ADVOGADOS(S): ANDRE GUSTAVO SALVADOR KAUFFMAN (OAB 168804/SP), CLARISSA ALINE PAIE RODELLA CONTATO (OAB 209019/SP), PAULO ROBERTO JOAQUIM DOS REIS (OAB 23134/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2021-04-27T00:00:00",
                "CaptureDate": "2022-12-24T02:31:07"
              },
              {
                "Content": "EMBARGOS DE DECLARACAO NAO-ACOLHIDOS | AUTOS N 2020/001682 (NUMERO DO PROCESSO NA VARA). VISTOS. FLS. 535/541 [\"(...) REQUER A VOSSA EXCELENCIA QUE RECEBA E CONHECA DOS PRESENTES EMBARGOS E, AO FINAL, OS ACOLHA, A FIM DE RECONSIDERAR A R. SENTENCA, DE MODO A FIXAR O VALOR DA CAUSA NOS PARAMETROS APRESENTADOS PELA EMBARGADA, NO IMPORTE DE R$ 142.901,08 (CENTO E QUARENTA E DOIS MIL NOVECENTOS E UM REAIS E OITO CENTAVOS), ALEM DA REFORMA QUANTO A FIXACAO DA VERBA HONORARIA., SUPRIMINDO, ASSIM, AS OMISSOES APONTADAS (...)\"] CONHECO OS EMBARGOS OPOSTOS, UMA VEZ QUE TEMPESTIVOS (FL. 543). POREM, REJEITO-OS DE PLANO, PORQUE NAO HA NENHUMA OMISSAO A SER SANADA NO CASO. COM EFEITO, A RIGOR, O QUE PRETENDE A PARTE AUTORA E DEBATER O MERITO DA SENTENCA PROFERIDA POR ESTE JUIZO, ALGO QUE, DATA VENIA, NAO E POSSIVEL DE SER FEITO VIA DECLARATORIOS, DIANTE DA RESTRITA NATUREZA INTEGRATIVA DESSE RECURSO. INTIMEM-SE. CAMPINAS, 26 DE ABRIL DE 2021. FABIO HENRIQUE PRADO DE TOLEDO JUIZ(A) DE DIREITO",
                "PublishDate": "2021-04-26T00:00:00",
                "CaptureDate": "2021-05-03T23:33:34"
              },
              {
                "Content": "EMBARGOS DE DECLARACAO NAO-ACOLHIDOS AUTOS N 2020/001682 (NUMERO DO PROCESSO NA VARA). VISTOS. FLS. 535/541 [\"(...) REQUER A VOSSA EXCELENCIA QUE RECEBA E CONHECA DOS PRESENTES EMBARGOS E, AO FINAL, OS ACOLHA, A FIM DE RECONSIDERAR A R. SENTENCA, DE MODO A FIXAR O VALOR DA CAUSA NOS PARAMETROS APRESENTADOS PELA EMBARGADA, NO IMPORTE DE R$ 142.901,08 (CENTO E QUARENTA E DOIS MIL NOVECENTOS E UM REAIS E OITO CENTAVOS), ALEM DA REFORMA QUANTO A FIXACAO DA VERBA HONORARIA., SUPRIMINDO, ASSIM, AS OMISSOES APONTADAS (...)\"] CONHECO OS EMBARGOS OPOSTOS, UMA VEZ QUE TEMPESTIVOS (FL. 543). POREM, REJEITO-OS DE PLANO, PORQUE NAO HA NENHUMA OMISSAO A SER SANADA NO CASO. COM EFEITO, A RIGOR, O QUE PRETENDE A PARTE AUTORA E DEBATER O MERITO DA SENTENCA PROFERIDA POR ESTE JUIZO, ALGO QUE, DATA VENIA, NAO E POSSIVEL DE SER FEITO VIA DECLARATORIOS, DIANTE DA RESTRITA NATUREZA INTEGRATIVA DESSE RECURSO. INTIMEM-SE. CAMPINAS, 26 DE ABRIL DE 2021. FABIO HENRIQUE PRADO DE TOLEDO JUIZ(A) DE DIREITO",
                "PublishDate": "2021-04-26T00:00:00",
                "CaptureDate": "2022-12-24T02:31:07"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2021-02-25T00:00:00",
                "CaptureDate": "2021-03-18T00:29:50"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2021-02-25T00:00:00",
                "CaptureDate": "2021-03-18T00:29:50"
              },
              {
                "Content": "CERTIDAO DE CARTORIO EXPEDIDA | CERTIDAO - EMBARGOS DE DECLARACAO TEMPESTIVOS",
                "PublishDate": "2021-02-25T00:00:00",
                "CaptureDate": "2021-03-18T00:29:50"
              },
              {
                "Content": "CERTIDAO DE CARTORIO EXPEDIDA CERTIDAO - EMBARGOS DE DECLARACAO TEMPESTIVOS",
                "PublishDate": "2021-02-25T00:00:00",
                "CaptureDate": "2022-12-24T02:31:07"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2021-02-25T00:00:00",
                "CaptureDate": "2022-12-24T02:31:07"
              },
              {
                "Content": "EMBARGOS DE DECLARACAO JUNTADOS | N PROTOCOLO: WCAS.21.70091988-1 TIPO DA PETICAO: EMBARGOS DE DECLARACAO DATA: 24/02/2021 17:54",
                "PublishDate": "2021-02-24T00:00:00",
                "CaptureDate": "2021-03-18T00:29:50"
              },
              {
                "Content": "EMBARGOS DE DECLARACAO JUNTADOS N PROTOCOLO: WCAS.21.70091988-1 TIPO DA PETICAO: EMBARGOS DE DECLARACAO DATA: 24/02/2021 17:54",
                "PublishDate": "2021-02-24T00:00:00",
                "CaptureDate": "2022-12-24T02:31:07"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0112/2021 DATA DA DISPONIBILIZACAO: 16/02/2021 DATA DA PUBLICACAO: 17/02/2021 NUMERO DO DIARIO: 3218 PAGINA: 1975",
                "PublishDate": "2021-02-16T00:00:00",
                "CaptureDate": "2021-03-18T00:29:50"
              },
              {
                "Content": "PROCESSO 1011799-94.2019.8.26.0248 - PROCEDIMENTO COMUM CIVEL - INDENIZACAO POR DANO MORAL - MASOTTI INDAIATUBA EMPREENDIMENTOS LTDA. - STARK BANK S.A. - - ELEVADORES ATLAS SCHINDLER LTDA. - - ITAU UNIBANCO S/A - ANTE O EXPOSTO, JULGO IMPROCEDENTE OS PEDIDOS INICIAIS E, POR CONSEQUENCIA DISSO, ATO CONTINUO, CONDENO A AUTORA A PAGAR, AO ADVOGADO DE CADA UM DOS REUS, A TITULO DE HONORARIOS ADVOCATICIOS SUCUMBENCIAIS, IMPORTANCIA CORRESPONDENTE A 10% DO VALOR ATUALIZADO DA CAUSA. - ADV: ANDRE GUSTAVO SALVADOR KAUFFMAN (OAB 168804/SP), CLARISSA ALINE PAIE RODELLA CONTATO (OAB 209019/SP), PAULO ROBERTO JOAQUIM DOS REIS (OAB 23134/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2021-02-16T00:00:00",
                "CaptureDate": "2021-03-18T00:29:50"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0112/2021 DATA DA DISPONIBILIZACAO: 16/02/2021 DATA DA PUBLICACAO: 17/02/2021 NUMERO DO DIARIO: 3218 PAGINA: 1975",
                "PublishDate": "2021-02-16T00:00:00",
                "CaptureDate": "2022-12-24T02:31:07"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0112/2021 TEOR DO ATO: ANTE O EXPOSTO, JULGO IMPROCEDENTE OS PEDIDOS INICIAIS E, POR CONSEQUENCIA DISSO, ATO CONTINUO, CONDENO A AUTORA A PAGAR, AO ADVOGADO DE CADA UM DOS REUS, A TITULO DE HONORARIOS ADVOCATICIOS SUCUMBENCIAIS, IMPORTANCIA CORRESPONDENTE A 10% DO VALOR ATUALIZADO DA CAUSA. ADVOGADOS(S): ANDRE GUSTAVO SALVADOR KAUFFMAN (OAB 168804/SP), CLARISSA ALINE PAIE RODELLA CONTATO (OAB 209019/SP), PAULO ROBERTO JOAQUIM DOS REIS (OAB 23134/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2021-02-15T00:00:00",
                "CaptureDate": "2021-03-18T00:29:50"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0112/2021 TEOR DO ATO: ANTE O EXPOSTO, JULGO IMPROCEDENTE OS PEDIDOS INICIAIS E, POR CONSEQUENCIA DISSO, ATO CONTINUO, CONDENO A AUTORA A PAGAR, AO ADVOGADO DE CADA UM DOS REUS, A TITULO DE HONORARIOS ADVOCATICIOS SUCUMBENCIAIS, IMPORTANCIA CORRESPONDENTE A 10% DO VALOR ATUALIZADO DA CAUSA. ADVOGADOS(S): ANDRE GUSTAVO SALVADOR KAUFFMAN (OAB 168804/SP), CLARISSA ALINE PAIE RODELLA CONTATO (OAB 209019/SP), PAULO ROBERTO JOAQUIM DOS REIS (OAB 23134/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2021-02-15T00:00:00",
                "CaptureDate": "2022-12-24T02:31:07"
              },
              {
                "Content": "JULGADA PROCEDENTE A ACAO | ANTE O EXPOSTO, JULGO IMPROCEDENTE OS PEDIDOS INICIAIS E, POR CONSEQUENCIA DISSO, ATO CONTINUO, CONDENO A AUTORA A PAGAR, AO ADVOGADO DE CADA UM DOS REUS, A TITULO DE HONORARIOS ADVOCATICIOS SUCUMBENCIAIS, IMPORTANCIA CORRESPONDENTE A 10% DO VALOR ATUALIZADO DA CAUSA.",
                "PublishDate": "2021-02-12T00:00:00",
                "CaptureDate": "2021-03-18T00:29:50"
              },
              {
                "Content": "JULGADA PROCEDENTE A ACAO ANTE O EXPOSTO, JULGO IMPROCEDENTE OS PEDIDOS INICIAIS E, POR CONSEQUENCIA DISSO, ATO CONTINUO, CONDENO A AUTORA A PAGAR, AO ADVOGADO DE CADA UM DOS REUS, A TITULO DE HONORARIOS ADVOCATICIOS SUCUMBENCIAIS, IMPORTANCIA CORRESPONDENTE A 10% DO VALOR ATUALIZADO DA CAUSA.",
                "PublishDate": "2021-02-12T00:00:00",
                "CaptureDate": "2022-12-24T02:31:07"
              },
              {
                "Content": "PROCESSO :1011799-94.2019.8.26.0248 CLASSE :PROCEDIMENTO COMUM CIVEL REQTE : MASOTTI INDAIATUBA EMPREENDIMENTOS LTDA. ADVOGADO : 209019/SP - CLARISSA ALINE PAIE RODELLA CONTATO REQDO : STARK BANK S.A. ADVOGADO : 295443/SP - RAFAEL HIDEO NAZIMA VARA :2 VARA CIVEL",
                "PublishDate": "2020-09-04T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "RECEBIDOS OS AUTOS DO OUTRO FORO",
                "PublishDate": "2020-09-01T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "REDISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR) CONFORME R DECISAO DE FLS 523",
                "PublishDate": "2020-09-01T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "CERTIDAO DE CARTORIO EXPEDIDA CERTIFICO E DOU FE QUE NOS TERMOS DO PARAGRAFO SEXTO DO ARTIGO 1.093 DA NORMAS DE SERVICOS DA CORREGEDORIA GERAL DE JUSTICA PROCEDI A EFETIVA UTILIZACAO DAS GUIAS DARE(FLS.163 E 165) JUNTO AO PORTAL DE CUSTAS. NADA MAIS",
                "PublishDate": "2020-09-01T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "CONCLUSOS PARA SENTENCA",
                "PublishDate": "2020-09-01T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "CONCLUSOS PARA SENTENCA",
                "PublishDate": "2020-09-01T00:00:00",
                "CaptureDate": "2021-03-18T00:29:50"
              },
              {
                "Content": "CERTIDAO DE CARTORIO EXPEDIDA | CERTIFICO E DOU FE QUE NOS TERMOS DO PARAGRAFO SEXTO DO ARTIGO 1.093 DA NORMAS DE SERVICOS DA CORREGEDORIA GERAL DE JUSTICA PROCEDI A EFETIVA UTILIZACAO DAS GUIAS DARE(FLS.163 E 165) JUNTO AO PORTAL DE CUSTAS. NADA MAIS",
                "PublishDate": "2020-09-01T00:00:00",
                "CaptureDate": "2021-03-18T00:29:50"
              },
              {
                "Content": "REDISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR) | CONFORME R DECISAO DE FLS 523",
                "PublishDate": "2020-09-01T00:00:00",
                "CaptureDate": "2021-03-18T00:29:50"
              },
              {
                "Content": "RECEBIDOS OS AUTOS DO OUTRO FORO",
                "PublishDate": "2020-09-01T00:00:00",
                "CaptureDate": "2021-03-18T00:29:50"
              },
              {
                "Content": "CERTIDAO DE CARTORIO EXPEDIDA CERTIDAO - GENERICA",
                "PublishDate": "2020-08-26T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "REMETIDOS OS AUTOS PARA O CARTORIO DISTRIBUIDOR LOCAL PARA REDISTRIBUICAO",
                "PublishDate": "2020-08-26T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "REMETIDOS OS AUTOS PARA OUTRO FORO/COMARCA DESTE ESTADO (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR) DETERMINACAO JUDICIAL DE FLS. 523/524 FORO DESTINO: FORO DE CAMPINAS",
                "PublishDate": "2020-08-26T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "REMETIDOS OS AUTOS PARA OUTRO FORO/COMARCA DESTE ESTADO (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR) | DETERMINACAO JUDICIAL DE FLS. 523/524 FORO DESTINO: FORO DE CAMPINAS",
                "PublishDate": "2020-08-26T00:00:00",
                "CaptureDate": "2021-03-18T00:29:50"
              },
              {
                "Content": "CERTIDAO DE CARTORIO EXPEDIDA | CERTIDAO - GENERICA",
                "PublishDate": "2020-08-26T00:00:00",
                "CaptureDate": "2021-03-18T00:29:50"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0368/2020 DATA DA DISPONIBILIZACAO: 31/07/2020 DATA DA PUBLICACAO: 03/08/2020 NUMERO DO DIARIO: 3096 PAGINA: 80/89",
                "PublishDate": "2020-07-31T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0368/2020 DATA DA DISPONIBILIZACAO: 31/07/2020 DATA DA PUBLICACAO: 03/08/2020 NUMERO DO DIARIO: 3096 PAGINA: 80/89",
                "PublishDate": "2020-07-31T00:00:00",
                "CaptureDate": "2021-03-18T00:29:50"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0368/2020 TEOR DO ATO: VISTOS. ELEVADORES ATLAS SCHINDLER LTDA. OPOE EXCECAO DE INCOMPETENCIA, EM AUTOS DE ACAO DECLATORIA DE INEXIGIBILIDADE DE DEBITO C.C PEDIDO DE INDENIZACAO POR DANOS MORAIS E REPETICAO DE INDEBITO QUE LHE MOVE MASOTTI INDAIATUBA EMPREENDIMENTOS LTDA., SOB O ARGUMENTO DE QUE HOUVE ELEICAO DO FORO DE CAMPINAS PARA DIRIMIR QUAIS QUER QUESTOES REFERENTE AO CONTRATO FIRMADO PELAS PARTES, COM RENUNCIA A QUALQUER OUTRO POR MAIS PRIVILEGIADO QUE SEJA. POIS BEM, A EXISTENCIA DE CLAUSULA DE ELEICAO DE FORO E INCONTROVERSA, UMA VEZ QUE ESTA EXPRESSA NA CLAUSULA 13 DO CONTRATO DE FORNECIMENTO, MONTAGEM E INSTALACAO DE ELEVADORES ASSINADO PELAS PARTES (FLS. 140/155), E NAO FOI .IMPUGNADA PELA PARTE AUTORA NA OCASIAO DA REPLICA. ALEM DO MAIS, E CEDICO QUE A ELEICAO DE FORO, MODALIDADE DE NEGOCIO JURIDICO DE INDOLE PROCESSUAL, POSSIBILITA AS PARTES, NO AMBITO DE SUA AUTONOMIA DE VONTADE, DERROGAR AS REGRAS TRADICIONAIS DETERMINATIVAS DA COMPETENCIA TERRITORIAL NUM DETERMINADO CASO, APONTANDO OS PROPRIOS INTERESSADOS O FORO DE SUA ESCOLHA, CONFORME DISPOSTO NO ART. 63 DO CODIGO DE PROCESSO CIVIL, QUE REZA: ART. 63 - AS PARTES PODEM MODIFICAR A COMPETENCIA EM RAZAO DO VALOR E DO TERRITORIO, ELEGENDO FORO ONDE SERA PROPOSTA ACAO ORIUNDA DE DIREITOS E OBRIGACOES. PARAGRAFO PRIMEIRO - A ELEICAO DE FORO SO PRODUZ EFEITO QUANDO CONSTAR DE INSTRUMENTO ESCRITO E ALUDIR EXPRESSAMENTE A DETERMINADO NEGOCIO JURIDICO._ NO CASO IN STUDIO O CONTRATO DE CONTRATO DE FORNECIMENTO, MONTAGEM E INSTALACAO DE ELEVADORES ASSINADO PELAS PARTES QUE GEROU ESTA ACAO E QUE A AUTORA PRETENDE A CONDENACAO DAS RES AO PAGAMENTO DE R$ 66.460,54 (SESSENTA E SEIS MIL, QUATROCENTOS E SESSENTA REAIS E CINQUENTA E QUATRO CENTAVOS), REFERENTE AO PAGAMENTO DE BOLETO FRAUDADO, ALEM DE INDENIZACAO POR DANOS MORAIS, INDICOU A COMARCA DE CAMPINAS-SP PARA A TRAMITACAO DE EVENTUAIS LITIGIOS ENVOLVENDO AS PESSOAS JURIDICAS (CLAUSULA 13 FLS. 153). ASSIM, NAO HA POR QUE NAO RESPEITA-LA, POIS O CONTRATO FIRMADO PELAS PARTES NAO TEM NATUREZA DE CONTRATO DE ADESAO E, PORTANTO, VALE O FORO ELEITO CONTRATUALMENTE (NESSE SENTIDO: STJ, AGRG NO ARESP 563.993/GO, REL. MINISTRA MARIA ISABEL GALLOTTI, QUARTA TURMA, J. 17/3/2015). ANTE O EXPOSTO, ACOLHO A PRESENTE EXCECAO DE INCOMPETENCIA NOS TERMOS DO ARTIGO 64, 2 DO CODIGO DE PROCESSO CIVIL, REDISTRIBUINDO-SE O FEITO A UMA DAS VARAS CIVEIS DA COMARCA DE CAMPINAS -SP.. INTIME-SE. ADVOGADOS(S): CLARISSA ALINE PAIE RODELLA CONTATO (OAB 209019/SP), PAULO ROBERTO JOAQUIM DOS REIS (OAB 23134/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-07-30T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0368/2020 TEOR DO ATO: VISTOS. ELEVADORES ATLAS SCHINDLER LTDA. OPOE EXCECAO DE INCOMPETENCIA, EM AUTOS DE ACAO DECLATORIA DE INEXIGIBILIDADE DE DEBITO C.C PEDIDO DE INDENIZACAO POR DANOS MORAIS E REPETICAO DE INDEBITO QUE LHE MOVE MASOTTI INDAIATUBA EMPREENDIMENTOS LTDA., SOB O ARGUMENTO DE QUE HOUVE ELEICAO DO FORO DE CAMPINAS PARA DIRIMIR QUAIS QUER QUESTOES REFERENTE AO CONTRATO FIRMADO PELAS PARTES, COM RENUNCIA A QUALQUER OUTRO POR MAIS PRIVILEGIADO QUE SEJA. POIS BEM, A EXISTENCIA DE CLAUSULA DE ELEICAO DE FORO E INCONTROVERSA, UMA VEZ QUE ESTA EXPRESSA NA CLAUSULA 13 DO CONTRATO DE FORNECIMENTO, MONTAGEM E INSTALACAO DE ELEVADORES ASSINADO PELAS PARTES (FLS. 140/155), E NAO FOI .IMPUGNADA PELA PARTE AUTORA NA OCASIAO DA REPLICA. ALEM DO MAIS, E CEDICO QUE A ELEICAO DE FORO, MODALIDADE DE NEGOCIO JURIDICO DE INDOLE PROCESSUAL, POSSIBILITA AS PARTES, NO AMBITO DE SUA AUTONOMIA DE VONTADE, DERROGAR AS REGRAS TRADICIONAIS DETERMINATIVAS DA COMPETENCIA TERRITORIAL NUM DETERMINADO CASO, APONTANDO OS PROPRIOS INTERESSADOS O FORO DE SUA ESCOLHA, CONFORME DISPOSTO NO ART. 63 DO CODIGO DE PROCESSO CIVIL, QUE REZA: ART. 63 - AS PARTES PODEM MODIFICAR A COMPETENCIA EM RAZAO DO VALOR E DO TERRITORIO, ELEGENDO FORO ONDE SERA PROPOSTA ACAO ORIUNDA DE DIREITOS E OBRIGACOES. PARAGRAFO PRIMEIRO - A ELEICAO DE FORO SO PRODUZ EFEITO QUANDO CONSTAR DE INSTRUMENTO ESCRITO E ALUDIR EXPRESSAMENTE A DETERMINADO NEGOCIO JURIDICO._ NO CASO IN STUDIO O CONTRATO DE CONTRATO DE FORNECIMENTO, MONTAGEM E INSTALACAO DE ELEVADORES ASSINADO PELAS PARTES QUE GEROU ESTA ACAO E QUE A AUTORA PRETENDE A CONDENACAO DAS RES AO PAGAMENTO DE R$ 66.460,54 (SESSENTA E SEIS MIL, QUATROCENTOS E SESSENTA REAIS E CINQUENTA E QUATRO CENTAVOS), REFERENTE AO PAGAMENTO DE BOLETO FRAUDADO, ALEM DE INDENIZACAO POR DANOS MORAIS, INDICOU A COMARCA DE CAMPINAS-SP PARA A TRAMITACAO DE EVENTUAIS LITIGIOS ENVOLVENDO AS PESSOAS JURIDICAS (CLAUSULA 13 FLS. 153). ASSIM, NAO HA POR QUE NAO RESPEITA-LA, POIS O CONTRATO FIRMADO PELAS PARTES NAO TEM NATUREZA DE CONTRATO DE ADESAO E, PORTANTO, VALE O FORO ELEITO CONTRATUALMENTE (NESSE SENTIDO: STJ, AGRG NO ARESP 563.993/GO, REL. MINISTRA MARIA ISABEL GALLOTTI, QUARTA TURMA, J. 17/3/2015). ANTE O EXPOSTO, ACOLHO A PRESENTE EXCECAO DE INCOMPETENCIA NOS TERMOS DO ARTIGO 64, 2 DO CODIGO DE PROCESSO CIVIL, REDISTRIBUINDO-SE O FEITO A UMA DAS VARAS CIVEIS DA COMARCA DE CAMPINAS -SP.. INTIME-SE. ADVOGADOS(S): CLARISSA ALINE PAIE RODELLA CONTATO (OAB 209019/SP), PAULO ROBERTO JOAQUIM DOS REIS (OAB 23134/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-07-30T00:00:00",
                "CaptureDate": "2021-03-18T00:29:50"
              },
              {
                "Content": "ACOLHIDA A EXCECAO DE INCOMPETENCIA VISTOS. ELEVADORES ATLAS SCHINDLER LTDA. OPOE EXCECAO DE INCOMPETENCIA, EM AUTOS DE ACAO DECLATORIA DE INEXIGIBILIDADE DE DEBITO C.C PEDIDO DE INDENIZACAO POR DANOS MORAIS E REPETICAO DE INDEBITO QUE LHE MOVE MASOTTI INDAIATUBA EMPREENDIMENTOS LTDA., SOB O ARGUMENTO DE QUE HOUVE ELEICAO DO FORO DE CAMPINAS PARA DIRIMIR QUAIS QUER QUESTOES REFERENTE AO CONTRATO FIRMADO PELAS PARTES, COM RENUNCIA A QUALQUER OUTRO POR MAIS PRIVILEGIADO QUE SEJA. POIS BEM, A EXISTENCIA DE CLAUSULA DE ELEICAO DE FORO E INCONTROVERSA, UMA VEZ QUE ESTA EXPRESSA NA CLAUSULA 13 DO CONTRATO DE FORNECIMENTO, MONTAGEM E INSTALACAO DE ELEVADORES ASSINADO PELAS PARTES (FLS. 140/155), E NAO FOI .IMPUGNADA PELA PARTE AUTORA NA OCASIAO DA REPLICA. ALEM DO MAIS, E CEDICO QUE A ELEICAO DE FORO, MODALIDADE DE NEGOCIO JURIDICO DE INDOLE PROCESSUAL, POSSIBILITA AS PARTES, NO AMBITO DE SUA AUTONOMIA DE VONTADE, DERROGAR AS REGRAS TRADICIONAIS DETERMINATIVAS DA COMPETENCIA TERRITORIAL NUM DETERMINADO CASO, APONTANDO OS PROPRIOS INTERESSADOS O FORO DE SUA ESCOLHA, CONFORME DISPOSTO NO ART. 63 DO CODIGO DE PROCESSO CIVIL, QUE REZA: ART. 63 - AS PARTES PODEM MODIFICAR A COMPETENCIA EM RAZAO DO VALOR E DO TERRITORIO, ELEGENDO FORO ONDE SERA PROPOSTA ACAO ORIUNDA DE DIREITOS E OBRIGACOES. PARAGRAFO PRIMEIRO - A ELEICAO DE FORO SO PRODUZ EFEITO QUANDO CONSTAR DE INSTRUMENTO ESCRITO E ALUDIR EXPRESSAMENTE A DETERMINADO NEGOCIO JURIDICO._ NO CASO IN STUDIO O CONTRATO DE CONTRATO DE FORNECIMENTO, MONTAGEM E INSTALACAO DE ELEVADORES ASSINADO PELAS PARTES QUE GEROU ESTA ACAO E QUE A AUTORA PRETENDE A CONDENACAO DAS RES AO PAGAMENTO DE R$ 66.460,54 (SESSENTA E SEIS MIL, QUATROCENTOS E SESSENTA REAIS E CINQUENTA E QUATRO CENTAVOS), REFERENTE AO PAGAMENTO DE BOLETO FRAUDADO, ALEM DE INDENIZACAO POR DANOS MORAIS, INDICOU A COMARCA DE CAMPINAS-SP PARA A TRAMITACAO DE EVENTUAIS LITIGIOS ENVOLVENDO AS PESSOAS JURIDICAS (CLAUSULA 13 FLS. 153). ASSIM, NAO HA POR QUE NAO RESPEITA-LA, POIS O CONTRATO FIRMADO PELAS PARTES NAO TEM NATUREZA DE CONTRATO DE ADESAO E, PORTANTO, VALE O FORO ELEITO CONTRATUALMENTE (NESSE SENTIDO: STJ, AGRG NO ARESP 563.993/GO, REL. MINISTRA MARIA ISABEL GALLOTTI, QUARTA TURMA, J. 17/3/2015). ANTE O EXPOSTO, ACOLHO A PRESENTE EXCECAO DE INCOMPETENCIA NOS TERMOS DO ARTIGO 64, 2 DO CODIGO DE PROCESSO CIVIL, REDISTRIBUINDO-SE O FEITO A UMA DAS VARAS CIVEIS DA COMARCA DE CAMPINAS -SP.. INTIME-SE.",
                "PublishDate": "2020-07-28T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "ACOLHIDA A EXCECAO DE INCOMPETENCIA | VISTOS. ELEVADORES ATLAS SCHINDLER LTDA. OPOE EXCECAO DE INCOMPETENCIA, EM AUTOS DE ACAO DECLATORIA DE INEXIGIBILIDADE DE DEBITO C.C PEDIDO DE INDENIZACAO POR DANOS MORAIS E REPETICAO DE INDEBITO QUE LHE MOVE MASOTTI INDAIATUBA EMPREENDIMENTOS LTDA., SOB O ARGUMENTO DE QUE HOUVE ELEICAO DO FORO DE CAMPINAS PARA DIRIMIR QUAIS QUER QUESTOES REFERENTE AO CONTRATO FIRMADO PELAS PARTES, COM RENUNCIA A QUALQUER OUTRO POR MAIS PRIVILEGIADO QUE SEJA. POIS BEM, A EXISTENCIA DE CLAUSULA DE ELEICAO DE FORO E INCONTROVERSA, UMA VEZ QUE ESTA EXPRESSA NA CLAUSULA 13 DO CONTRATO DE FORNECIMENTO, MONTAGEM E INSTALACAO DE ELEVADORES ASSINADO PELAS PARTES (FLS. 140/155), E NAO FOI .IMPUGNADA PELA PARTE AUTORA NA OCASIAO DA REPLICA. ALEM DO MAIS, E CEDICO QUE A ELEICAO DE FORO, MODALIDADE DE NEGOCIO JURIDICO DE INDOLE PROCESSUAL, POSSIBILITA AS PARTES, NO AMBITO DE SUA AUTONOMIA DE VONTADE, DERROGAR AS REGRAS TRADICIONAIS DETERMINATIVAS DA COMPETENCIA TERRITORIAL NUM DETERMINADO CASO, APONTANDO OS PROPRIOS INTERESSADOS O FORO DE SUA ESCOLHA, CONFORME DISPOSTO NO ART. 63 DO CODIGO DE PROCESSO CIVIL, QUE REZA: ART. 63 - AS PARTES PODEM MODIFICAR A COMPETENCIA EM RAZAO DO VALOR E DO TERRITORIO, ELEGENDO FORO ONDE SERA PROPOSTA ACAO ORIUNDA DE DIREITOS E OBRIGACOES. PARAGRAFO PRIMEIRO - A ELEICAO DE FORO SO PRODUZ EFEITO QUANDO CONSTAR DE INSTRUMENTO ESCRITO E ALUDIR EXPRESSAMENTE A DETERMINADO NEGOCIO JURIDICO._ NO CASO IN STUDIO O CONTRATO DE CONTRATO DE FORNECIMENTO, MONTAGEM E INSTALACAO DE ELEVADORES ASSINADO PELAS PARTES QUE GEROU ESTA ACAO E QUE A AUTORA PRETENDE A CONDENACAO DAS RES AO PAGAMENTO DE R$ 66.460,54 (SESSENTA E SEIS MIL, QUATROCENTOS E SESSENTA REAIS E CINQUENTA E QUATRO CENTAVOS), REFERENTE AO PAGAMENTO DE BOLETO FRAUDADO, ALEM DE INDENIZACAO POR DANOS MORAIS, INDICOU A COMARCA DE CAMPINAS-SP PARA A TRAMITACAO DE EVENTUAIS LITIGIOS ENVOLVENDO AS PESSOAS JURIDICAS (CLAUSULA 13 FLS. 153). ASSIM, NAO HA POR QUE NAO RESPEITA-LA, POIS O CONTRATO FIRMADO PELAS PARTES NAO TEM NATUREZA DE CONTRATO DE ADESAO E, PORTANTO, VALE O FORO ELEITO CONTRATUALMENTE (NESSE SENTIDO: STJ, AGRG NO ARESP 563.993/GO, REL. MINISTRA MARIA ISABEL GALLOTTI, QUARTA TURMA, J. 17/3/2015). ANTE O EXPOSTO, ACOLHO A PRESENTE EXCECAO DE INCOMPETENCIA NOS TERMOS DO ARTIGO 64, 2 DO CODIGO DE PROCESSO CIVIL, REDISTRIBUINDO-SE O FEITO A UMA DAS VARAS CIVEIS DA COMARCA DE CAMPINAS -SP.. INTIME-SE.",
                "PublishDate": "2020-07-28T00:00:00",
                "CaptureDate": "2021-03-18T00:29:50"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WIDU.20.70073290-0 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 24/07/2020 15:06",
                "PublishDate": "2020-07-24T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "PETICAO JUNTADA | N PROTOCOLO: WIDU.20.70073290-0 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 24/07/2020 15:06",
                "PublishDate": "2020-07-24T00:00:00",
                "CaptureDate": "2021-03-18T00:29:50"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WIDU.20.70064840-2 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 06/07/2020 09:21",
                "PublishDate": "2020-07-06T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "PETICAO JUNTADA | N PROTOCOLO: WIDU.20.70064840-2 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 06/07/2020 09:21",
                "PublishDate": "2020-07-06T00:00:00",
                "CaptureDate": "2021-03-18T00:29:50"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2020-06-29T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2020-06-29T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2020-06-29T00:00:00",
                "CaptureDate": "2021-03-18T00:29:50"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2020-06-29T00:00:00",
                "CaptureDate": "2021-03-18T00:29:50"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WIDU.20.70061624-1 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 26/06/2020 17:16",
                "PublishDate": "2020-06-26T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "PETICAO JUNTADA | N PROTOCOLO: WIDU.20.70061624-1 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 26/06/2020 17:16",
                "PublishDate": "2020-06-26T00:00:00",
                "CaptureDate": "2021-03-18T00:29:50"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0226/2020 DATA DA DISPONIBILIZACAO: 18/06/2020 DATA DA PUBLICACAO: 19/06/2020 NUMERO DO DIARIO: 3065 PAGINA: 130/136",
                "PublishDate": "2020-06-18T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0226/2020 DATA DA DISPONIBILIZACAO: 18/06/2020 DATA DA PUBLICACAO: 19/06/2020 NUMERO DO DIARIO: 3065 PAGINA: 130/136",
                "PublishDate": "2020-06-18T00:00:00",
                "CaptureDate": "2021-03-18T00:29:50"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0226/2020 TEOR DO ATO: MANIFESTE-SE A PARTE AUTORA SOBRE A PETICAO E DOCUMENTOS DE FLS. 458/494. ADVOGADOS(S): ANDRE GUSTAVO SALVADOR KAUFFMAN (OAB 168804/SP), CLARISSA ALINE PAIE RODELLA CONTATO (OAB 209019/SP), PAULO ROBERTO JOAQUIM DOS REIS (OAB 23134/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-06-17T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0226/2020 TEOR DO ATO: MANIFESTE-SE A PARTE AUTORA SOBRE A PETICAO E DOCUMENTOS DE FLS. 458/494. ADVOGADOS(S): ANDRE GUSTAVO SALVADOR KAUFFMAN (OAB 168804/SP), CLARISSA ALINE PAIE RODELLA CONTATO (OAB 209019/SP), PAULO ROBERTO JOAQUIM DOS REIS (OAB 23134/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-06-17T00:00:00",
                "CaptureDate": "2021-03-18T00:29:50"
              },
              {
                "Content": "ATO ORDINATORIO - PUBLICAVEL MANIFESTE-SE A PARTE AUTORA SOBRE A PETICAO E DOCUMENTOS DE FLS. 458/494.",
                "PublishDate": "2020-06-16T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "ATO ORDINATORIO - PUBLICAVEL | MANIFESTE-SE A PARTE AUTORA SOBRE A PETICAO E DOCUMENTOS DE FLS. 458/494.",
                "PublishDate": "2020-06-16T00:00:00",
                "CaptureDate": "2021-03-18T00:29:50"
              },
              {
                "Content": "ATO ORDINATORIO - INTIMACAO - DJE | MANIFESTE-SE A PARTE AUTORA SOBRE A PETICAO E DOCUMENTOS DE FLS. 458/494.",
                "PublishDate": "2020-06-16T00:00:00",
                "CaptureDate": "2022-05-20T11:00:57"
              },
              {
                "Content": "ATO ORDINATORIO - INTIMACAO - DJE MANIFESTE-SE A PARTE AUTORA SOBRE A PETICAO E DOCUMENTOS DE FLS. 458/494.",
                "PublishDate": "2020-06-16T00:00:00",
                "CaptureDate": "2022-12-24T02:31:07"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WIDU.20.70056215-0 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 15/06/2020 17:56",
                "PublishDate": "2020-06-15T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "PETICAO JUNTADA | N PROTOCOLO: WIDU.20.70056215-0 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 15/06/2020 17:56",
                "PublishDate": "2020-06-15T00:00:00",
                "CaptureDate": "2021-03-18T00:29:50"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WIDU.20.70055498-0 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 12/06/2020 16:00",
                "PublishDate": "2020-06-12T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "PETICAO JUNTADA | N PROTOCOLO: WIDU.20.70055498-0 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 12/06/2020 16:00",
                "PublishDate": "2020-06-12T00:00:00",
                "CaptureDate": "2021-03-18T00:29:50"
              },
              {
                "Content": "ESPECIFICACAO DE PROVAS JUNTADA N PROTOCOLO: WIDU.20.70055334-7 TIPO DA PETICAO: INDICACAO DE PROVAS DATA: 11/06/2020 23:25",
                "PublishDate": "2020-06-11T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WIDU.20.70055335-5 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 11/06/2020 23:28",
                "PublishDate": "2020-06-11T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "PETICAO JUNTADA | N PROTOCOLO: WIDU.20.70055335-5 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 11/06/2020 23:28",
                "PublishDate": "2020-06-11T00:00:00",
                "CaptureDate": "2021-03-18T00:29:50"
              },
              {
                "Content": "ESPECIFICACAO DE PROVAS JUNTADA | N PROTOCOLO: WIDU.20.70055334-7 TIPO DA PETICAO: INDICACAO DE PROVAS DATA: 11/06/2020 23:25",
                "PublishDate": "2020-06-11T00:00:00",
                "CaptureDate": "2021-03-18T00:29:50"
              },
              {
                "Content": "ESPECIFICACAO DE PROVAS JUNTADA N PROTOCOLO: WIDU.20.70054666-9 TIPO DA PETICAO: INDICACAO DE PROVAS DATA: 09/06/2020 21:42",
                "PublishDate": "2020-06-09T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "ESPECIFICACAO DE PROVAS JUNTADA | N PROTOCOLO: WIDU.20.70054666-9 TIPO DA PETICAO: INDICACAO DE PROVAS DATA: 09/06/2020 21:42",
                "PublishDate": "2020-06-09T00:00:00",
                "CaptureDate": "2021-03-18T00:29:50"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0192/2020 DATA DA DISPONIBILIZACAO: 03/06/2020 DATA DA PUBLICACAO: 04/06/2020 NUMERO DO DIARIO: 3054 PAGINA: 99/106",
                "PublishDate": "2020-06-03T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0192/2020 DATA DA DISPONIBILIZACAO: 03/06/2020 DATA DA PUBLICACAO: 04/06/2020 NUMERO DO DIARIO: 3054 PAGINA: 99/106",
                "PublishDate": "2020-06-03T00:00:00",
                "CaptureDate": "2021-03-18T00:29:50"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0192/2020 TEOR DO ATO: VISTOS. FLS. 410: O NOME DO PROCURADOR INDICADO PELO REU BANCO UNIBANCO S/A JA FORA CADASTRADO NO SISTEMA. FLS. 415/417: DEFIRO A JUNTADA DAS TAXAS PELAS RE ELEVADORES ATLAS SCHINDLER LTDA. E IMPORTANTE SUBLINHAR QUE O NOME DA PROCURADORA INDICADA PELA REQUERENTE AS FLS. 438 JA ESTA INSERIDO NO SISTEMA. NO MAIS, ESPECIFIQUEM AS PARTES EVENTUAIS PROVAS QUE PRETENDAM PRODUZIR, JUSTIFICANDO A SUA RELEVANCIA E PERTINENCIA. INT. ADVOGADOS(S): CLARISSA ALINE PAIE RODELLA CONTATO (OAB 209019/SP), PAULO ROBERTO JOAQUIM DOS REIS (OAB 23134/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-06-02T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0192/2020 TEOR DO ATO: VISTOS. FLS. 410: O NOME DO PROCURADOR INDICADO PELO REU BANCO UNIBANCO S/A JA FORA CADASTRADO NO SISTEMA. FLS. 415/417: DEFIRO A JUNTADA DAS TAXAS PELAS RE ELEVADORES ATLAS SCHINDLER LTDA. E IMPORTANTE SUBLINHAR QUE O NOME DA PROCURADORA INDICADA PELA REQUERENTE AS FLS. 438 JA ESTA INSERIDO NO SISTEMA. NO MAIS, ESPECIFIQUEM AS PARTES EVENTUAIS PROVAS QUE PRETENDAM PRODUZIR, JUSTIFICANDO A SUA RELEVANCIA E PERTINENCIA. INT. ADVOGADOS(S): CLARISSA ALINE PAIE RODELLA CONTATO (OAB 209019/SP), PAULO ROBERTO JOAQUIM DOS REIS (OAB 23134/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-06-02T00:00:00",
                "CaptureDate": "2021-03-18T00:29:50"
              },
              {
                "Content": "MERO EXPEDIENTE VISTOS. FLS. 410: O NOME DO PROCURADOR INDICADO PELO REU BANCO UNIBANCO S/A JA FORA CADASTRADO NO SISTEMA. FLS. 415/417: DEFIRO A JUNTADA DAS TAXAS PELAS RE ELEVADORES ATLAS SCHINDLER LTDA. E IMPORTANTE SUBLINHAR QUE O NOME DA PROCURADORA INDICADA PELA REQUERENTE AS FLS. 438 JA ESTA INSERIDO NO SISTEMA. NO MAIS, ESPECIFIQUEM AS PARTES EVENTUAIS PROVAS QUE PRETENDAM PRODUZIR, JUSTIFICANDO A SUA RELEVANCIA E PERTINENCIA. INT.",
                "PublishDate": "2020-06-01T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "MERO EXPEDIENTE | VISTOS. FLS. 410: O NOME DO PROCURADOR INDICADO PELO REU BANCO UNIBANCO S/A JA FORA CADASTRADO NO SISTEMA. FLS. 415/417: DEFIRO A JUNTADA DAS TAXAS PELAS RE ELEVADORES ATLAS SCHINDLER LTDA. E IMPORTANTE SUBLINHAR QUE O NOME DA PROCURADORA INDICADA PELA REQUERENTE AS FLS. 438 JA ESTA INSERIDO NO SISTEMA. NO MAIS, ESPECIFIQUEM AS PARTES EVENTUAIS PROVAS QUE PRETENDAM PRODUZIR, JUSTIFICANDO A SUA RELEVANCIA E PERTINENCIA. INT.",
                "PublishDate": "2020-06-01T00:00:00",
                "CaptureDate": "2021-03-18T00:29:50"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE | VISTOS. FLS. 410: O NOME DO PROCURADOR INDICADO PELO REU BANCO UNIBANCO S/A JA FORA CADASTRADO NO SISTEMA. FLS. 415/417: DEFIRO A JUNTADA DAS TAXAS PELAS RE ELEVADORES ATLAS SCHINDLER LTDA. E IMPORTANTE SUBLINHAR QUE O NOME DA PROCURADORA INDICADA PELA REQUERENTE AS FLS. 438 JA ESTA INSERIDO NO SISTEMA. NO MAIS, ESPECIFIQUEM AS PARTES EVENTUAIS PROVAS QUE PRETENDAM PRODUZIR, JUSTIFICANDO A SUA RELEVANCIA E PERTINENCIA. INT.",
                "PublishDate": "2020-06-01T00:00:00",
                "CaptureDate": "2022-05-20T11:00:57"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE VISTOS. FLS. 410: O NOME DO PROCURADOR INDICADO PELO REU BANCO UNIBANCO S/A JA FORA CADASTRADO NO SISTEMA. FLS. 415/417: DEFIRO A JUNTADA DAS TAXAS PELAS RE ELEVADORES ATLAS SCHINDLER LTDA. E IMPORTANTE SUBLINHAR QUE O NOME DA PROCURADORA INDICADA PELA REQUERENTE AS FLS. 438 JA ESTA INSERIDO NO SISTEMA. NO MAIS, ESPECIFIQUEM AS PARTES EVENTUAIS PROVAS QUE PRETENDAM PRODUZIR, JUSTIFICANDO A SUA RELEVANCIA E PERTINENCIA. INT.",
                "PublishDate": "2020-06-01T00:00:00",
                "CaptureDate": "2022-12-24T02:31:07"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2020-05-31T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2020-05-27T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "REPLICA JUNTADA N PROTOCOLO: WIDU.20.70049209-7 TIPO DA PETICAO: MANIFESTACAO SOBRE A CONTESTACAO DATA: 26/05/2020 21:46",
                "PublishDate": "2020-05-26T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "REPLICA JUNTADA | N PROTOCOLO: WIDU.20.70049209-7 TIPO DA PETICAO: MANIFESTACAO SOBRE A CONTESTACAO DATA: 26/05/2020 21:46",
                "PublishDate": "2020-05-26T00:00:00",
                "CaptureDate": "2021-03-18T00:29:50"
              },
              {
                "Content": "CERTIDAO DE CARTORIO EXPEDIDA CERTIFICO E DOU FE QUE VINCULEI A(S) GUIA(S) DARE DE FLS. 416 AO PRESENTE PROCESSO NO PORTAL DE CUSTAS, RECOLHIMENTOS E DEPOSITOS DO TJSP, NOS TERMOS DO PROVIMENTO CG 01/2020 E COMUNICADO CG 136/2020 DE 21/01/2020.",
                "PublishDate": "2020-05-06T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "CERTIDAO DE CARTORIO EXPEDIDA | CERTIFICO E DOU FE QUE VINCULEI A(S) GUIA(S) DARE DE FLS. 416 AO PRESENTE PROCESSO NO PORTAL DE CUSTAS, RECOLHIMENTOS E DEPOSITOS DO TJSP, NOS TERMOS DO PROVIMENTO CG 01/2020 E COMUNICADO CG 136/2020 DE 21/01/2020.",
                "PublishDate": "2020-05-06T00:00:00",
                "CaptureDate": "2021-03-18T00:29:50"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WIDU.20.70040264-0 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 04/05/2020 23:18",
                "PublishDate": "2020-05-05T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "PETICAO JUNTADA | N PROTOCOLO: WIDU.20.70040264-0 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 04/05/2020 23:18",
                "PublishDate": "2020-05-05T00:00:00",
                "CaptureDate": "2021-03-18T00:29:50"
              },
              {
                "Content": "CERTIDAO DE CARTORIO EXPEDIDA CERTIFICO E DOU FE QUE VINCULEI A(S) GUIA(S) DARE DE FLS. 411 AO PRESENTE PROCESSO NO PORTAL DE CUSTAS, RECOLHIMENTOS E DEPOSITOS DO TJSP, NOS TERMOS DO PROVIMENTO CG 01/2020 E COMUNICADO CG 136/2020 DE 21/01/2020.",
                "PublishDate": "2020-04-22T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "CERTIDAO DE CARTORIO EXPEDIDA | CERTIFICO E DOU FE QUE VINCULEI A(S) GUIA(S) DARE DE FLS. 411 AO PRESENTE PROCESSO NO PORTAL DE CUSTAS, RECOLHIMENTOS E DEPOSITOS DO TJSP, NOS TERMOS DO PROVIMENTO CG 01/2020 E COMUNICADO CG 136/2020 DE 21/01/2020.",
                "PublishDate": "2020-04-22T00:00:00",
                "CaptureDate": "2021-03-18T00:29:50"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0085/2020 DATA DA DISPONIBILIZACAO: 17/04/2020 DATA DA PUBLICACAO: 04/05/2020 NUMERO DO DIARIO: 3027 PAGINA: 88/96",
                "PublishDate": "2020-04-17T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WIDU.20.70036642-3 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 17/04/2020 18:28",
                "PublishDate": "2020-04-17T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "PETICAO JUNTADA | N PROTOCOLO: WIDU.20.70036642-3 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 17/04/2020 18:28",
                "PublishDate": "2020-04-17T00:00:00",
                "CaptureDate": "2021-03-18T00:29:50"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0085/2020 DATA DA DISPONIBILIZACAO: 17/04/2020 DATA DA PUBLICACAO: 04/05/2020 NUMERO DO DIARIO: 3027 PAGINA: 88/96",
                "PublishDate": "2020-04-17T00:00:00",
                "CaptureDate": "2021-03-18T00:29:50"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0085/2020 TEOR DO ATO: MANIFESTE-SE A REQUERENTE QUANTO AS CONTESTACOES E DOCUMENTOS JUNTADOS AS FLS. 185/202, 214/314 E 317/407. ADVOGADOS(S): ANDRE GUSTAVO SALVADOR KAUFFMAN (OAB 168804/SP), CLARISSA ALINE PAIE RODELLA CONTATO (OAB 209019/SP), PAULO ROBERTO JOAQUIM DOS REIS (OAB 23134/SP), GABRIELA BONI TEIXEIRA (OAB 412208/SP)",
                "PublishDate": "2020-04-16T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0085/2020 TEOR DO ATO: MANIFESTE-SE A REQUERENTE QUANTO AS CONTESTACOES E DOCUMENTOS JUNTADOS AS FLS. 185/202, 214/314 E 317/407. ADVOGADOS(S): ANDRE GUSTAVO SALVADOR KAUFFMAN (OAB 168804/SP), CLARISSA ALINE PAIE RODELLA CONTATO (OAB 209019/SP), PAULO ROBERTO JOAQUIM DOS REIS (OAB 23134/SP), GABRIELA BONI TEIXEIRA (OAB 412208/SP)",
                "PublishDate": "2020-04-16T00:00:00",
                "CaptureDate": "2021-03-18T00:29:50"
              },
              {
                "Content": "ATO ORDINATORIO - PUBLICAVEL MANIFESTE-SE A REQUERENTE QUANTO AS CONTESTACOES E DOCUMENTOS JUNTADOS AS FLS. 185/202, 214/314 E 317/407.",
                "PublishDate": "2020-04-15T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "ATO ORDINATORIO - PUBLICAVEL | MANIFESTE-SE A REQUERENTE QUANTO AS CONTESTACOES E DOCUMENTOS JUNTADOS AS FLS. 185/202, 214/314 E 317/407.",
                "PublishDate": "2020-04-15T00:00:00",
                "CaptureDate": "2021-03-18T00:29:50"
              },
              {
                "Content": "ATO ORDINATORIO - INTIMACAO - DJE | MANIFESTE-SE A REQUERENTE QUANTO AS CONTESTACOES E DOCUMENTOS JUNTADOS AS FLS. 185/202, 214/314 E 317/407.",
                "PublishDate": "2020-04-15T00:00:00",
                "CaptureDate": "2022-05-20T11:00:57"
              },
              {
                "Content": "ATO ORDINATORIO - INTIMACAO - DJE MANIFESTE-SE A REQUERENTE QUANTO AS CONTESTACOES E DOCUMENTOS JUNTADOS AS FLS. 185/202, 214/314 E 317/407.",
                "PublishDate": "2020-04-15T00:00:00",
                "CaptureDate": "2022-12-24T02:31:07"
              },
              {
                "Content": "CONTESTACAO JUNTADA N PROTOCOLO: WIDU.20.70035602-9 TIPO DA PETICAO: CONTESTACAO DATA: 14/04/2020 22:53",
                "PublishDate": "2020-04-14T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "CONTESTACAO JUNTADA | N PROTOCOLO: WIDU.20.70035602-9 TIPO DA PETICAO: CONTESTACAO DATA: 14/04/2020 22:53",
                "PublishDate": "2020-04-14T00:00:00",
                "CaptureDate": "2021-03-18T00:29:50"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0060/2020 DATA DA DISPONIBILIZACAO: 03/04/2020 DATA DA PUBLICACAO: 04/05/2020 NUMERO DO DIARIO: 3019 PAGINA: 176/203",
                "PublishDate": "2020-04-03T00:00:00",
                "CaptureDate": "2020-04-05T01:46:42"
              },
              {
                "Content": "PROCESSO 1011799-94.2019.8.26.0248 - PROCEDIMENTO COMUM CIVEL - INDENIZACAO POR DANO MORAL - MASOTTI INDAIATUBA EMPREENDIMENTOS LTDA. - STARK BANK S.A. - - ELEVADORES ATLAS SCHINDLER LTDA. - - ITAU UNIBANCO S/A - PROVIDENCIE A REQUERIDA ATLAS O PAGAMENTO DE TAXA DA OAB NO VALOR DE R$ 23,27, SOB PENA DE COMUNICACAO AO ORGAO ESPECIFICO. - ADV: GABRIELA BONI TEIXEIRA (OAB 412208/SP), CLARISSA ALINE PAIE RODELLA CONTATO (OAB 209019/SP), PAULO ROBERTO JOAQUIM DOS REIS (OAB 23134/SP), ANDRE GUSTAVO SALVADOR KAUFFMAN (OAB 168804/SP)",
                "PublishDate": "2020-04-03T00:00:00",
                "CaptureDate": "2020-04-05T01:46:42"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0060/2020 DATA DA DISPONIBILIZACAO: 03/04/2020 DATA DA PUBLICACAO: 04/05/2020 NUMERO DO DIARIO: 3019 PAGINA: 176/203",
                "PublishDate": "2020-04-03T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0060/2020 TEOR DO ATO: PROVIDENCIE A REQUERIDA ATLAS O PAGAMENTO DE TAXA DA OAB NO VALOR DE R$ 23,27, SOB PENA DE COMUNICACAO AO ORGAO ESPECIFICO. ADVOGADOS(S): ANDRE GUSTAVO SALVADOR KAUFFMAN (OAB 168804/SP), CLARISSA ALINE PAIE RODELLA CONTATO (OAB 209019/SP), PAULO ROBERTO JOAQUIM DOS REIS (OAB 23134/SP), GABRIELA BONI TEIXEIRA (OAB 412208/SP)",
                "PublishDate": "2020-04-01T00:00:00",
                "CaptureDate": "2020-04-05T01:46:42"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0060/2020 TEOR DO ATO: PROVIDENCIE A REQUERIDA ATLAS O PAGAMENTO DE TAXA DA OAB NO VALOR DE R$ 23,27, SOB PENA DE COMUNICACAO AO ORGAO ESPECIFICO. ADVOGADOS(S): ANDRE GUSTAVO SALVADOR KAUFFMAN (OAB 168804/SP), CLARISSA ALINE PAIE RODELLA CONTATO (OAB 209019/SP), PAULO ROBERTO JOAQUIM DOS REIS (OAB 23134/SP), GABRIELA BONI TEIXEIRA (OAB 412208/SP)",
                "PublishDate": "2020-04-01T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "ATO ORDINATORIO - PUBLICAVEL | PROVIDENCIE A REQUERIDA ATLAS O PAGAMENTO DE TAXA DA OAB NO VALOR DE R$ 23,27, SOB PENA DE COMUNICACAO AO ORGAO ESPECIFICO.",
                "PublishDate": "2020-03-31T00:00:00",
                "CaptureDate": "2020-04-05T01:46:42"
              },
              {
                "Content": "ATO ORDINATORIO - PUBLICAVEL PROVIDENCIE A REQUERIDA ATLAS O PAGAMENTO DE TAXA DA OAB NO VALOR DE R$ 23,27, SOB PENA DE COMUNICACAO AO ORGAO ESPECIFICO.",
                "PublishDate": "2020-03-31T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "ATO ORDINATORIO - INTIMACAO - DJE | PROVIDENCIE A REQUERIDA ATLAS O PAGAMENTO DE TAXA DA OAB NO VALOR DE R$ 23,27, SOB PENA DE COMUNICACAO AO ORGAO ESPECIFICO.",
                "PublishDate": "2020-03-31T00:00:00",
                "CaptureDate": "2022-05-20T11:00:57"
              },
              {
                "Content": "ATO ORDINATORIO - INTIMACAO - DJE PROVIDENCIE A REQUERIDA ATLAS O PAGAMENTO DE TAXA DA OAB NO VALOR DE R$ 23,27, SOB PENA DE COMUNICACAO AO ORGAO ESPECIFICO.",
                "PublishDate": "2020-03-31T00:00:00",
                "CaptureDate": "2022-12-24T02:31:07"
              },
              {
                "Content": "PROCURACAO/SUBSTABELECIMENTO JUNTADA |",
                "PublishDate": "2020-03-27T00:00:00",
                "CaptureDate": "2020-04-05T01:46:42"
              },
              {
                "Content": "CONTESTACAO JUNTADA | N PROTOCOLO: WIDU.20.70031890-9 TIPO DA PETICAO: CONTESTACAO DATA: 27/03/2020 15:25",
                "PublishDate": "2020-03-27T00:00:00",
                "CaptureDate": "2020-04-05T01:46:42"
              },
              {
                "Content": "CONTESTACAO JUNTADA N PROTOCOLO: WIDU.20.70031890-9 TIPO DA PETICAO: CONTESTACAO DATA: 27/03/2020 15:25",
                "PublishDate": "2020-03-27T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "PROCURACAO/SUBSTABELECIMENTO JUNTADA",
                "PublishDate": "2020-03-27T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "PROCURACAO/SUBSTABELECIMENTO JUNTADA",
                "PublishDate": "2020-03-27T00:00:00",
                "CaptureDate": "2021-03-18T00:29:50"
              },
              {
                "Content": "SUSPENSAO DO PRAZO | PRAZO REFERENTE AO USUARIO FOI ALTERADO PARA 08/05/2020 DEVIDO A ALTERACAO DA TABELA DE FERIADOS",
                "PublishDate": "2020-03-26T00:00:00",
                "CaptureDate": "2020-04-05T01:46:42"
              },
              {
                "Content": "SUSPENSAO DO PRAZO PRAZO REFERENTE AO USUARIO FOI ALTERADO PARA 08/05/2020 DEVIDO A ALTERACAO DA TABELA DE FERIADOS",
                "PublishDate": "2020-03-26T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "AR POSITIVO JUNTADO | JUNTADA DE AR : AR105252162TJ SITUACAO : CUMPRIDO MODELO : PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC DESTINATARIO : STARK BANK S.A. DILIGENCIA : 02/03/2020",
                "PublishDate": "2020-03-05T00:00:00",
                "CaptureDate": "2020-04-05T01:46:42"
              },
              {
                "Content": "AR POSITIVO JUNTADO JUNTADA DE AR : AR105252162TJ SITUACAO : CUMPRIDO MODELO : PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC DESTINATARIO : STARK BANK S.A. DILIGENCIA : 02/03/2020",
                "PublishDate": "2020-03-05T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0032/2020 DATA DA DISPONIBILIZACAO: 27/02/2020 DATA DA PUBLICACAO: 28/02/2020 NUMERO DO DIARIO: 2993 PAGINA: 120/142",
                "PublishDate": "2020-02-27T00:00:00",
                "CaptureDate": "2020-02-28T00:35:51"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0032/2020 DATA DA DISPONIBILIZACAO: 27/02/2020 DATA DA PUBLICACAO: 28/02/2020 NUMERO DO DIARIO: 2993 PAGINA: 120/142",
                "PublishDate": "2020-02-27T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "CARTA EXPEDIDA | PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                "PublishDate": "2020-02-26T00:00:00",
                "CaptureDate": "2020-02-28T00:35:51"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0032/2020 TEOR DO ATO: EXPEDI CARTA(S) PARA CITACAO DA(S) PARTE(S) STARK BANK S.A., CONFORME FLS. 181. ADVOGADOS(S): CLARISSA ALINE PAIE RODELLA CONTATO (OAB 209019/SP), PAULO ROBERTO JOAQUIM DOS REIS (OAB 23134/SP), GABRIELA BONI TEIXEIRA (OAB 412208/SP)",
                "PublishDate": "2020-02-26T00:00:00",
                "CaptureDate": "2020-02-28T00:35:51"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0032/2020 TEOR DO ATO: EXPEDI CARTA(S) PARA CITACAO DA(S) PARTE(S) STARK BANK S.A., CONFORME FLS. 181. ADVOGADOS(S): CLARISSA ALINE PAIE RODELLA CONTATO (OAB 209019/SP), PAULO ROBERTO JOAQUIM DOS REIS (OAB 23134/SP), GABRIELA BONI TEIXEIRA (OAB 412208/SP)",
                "PublishDate": "2020-02-26T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "CARTA EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                "PublishDate": "2020-02-26T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "ATO ORDINATORIO | EXPEDI CARTA(S) PARA CITACAO DA(S) PARTE(S) STARK BANK S.A., CONFORME FLS. 181.",
                "PublishDate": "2020-02-21T00:00:00",
                "CaptureDate": "2020-02-28T00:35:51"
              },
              {
                "Content": "ATO ORDINATORIO EXPEDI CARTA(S) PARA CITACAO DA(S) PARTE(S) STARK BANK S.A., CONFORME FLS. 181.",
                "PublishDate": "2020-02-21T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "CERTIDAO DE CARTORIO EXPEDIDA | CERTIFICO E DOU FE QUE VINCULEI A(S) GUIA(S) DARE DE FLS. 206 AO PRESENTE PROCESSO NO PORTAL DE CUSTAS, RECOLHIMENTOS E DEPOSITOS DO TJSP, NOS TERMOS DO PROVIMENTO CG 01/2020 E COMUNICADO CG 136/2020 DE 21/01/2020.",
                "PublishDate": "2020-02-20T00:00:00",
                "CaptureDate": "2020-02-28T00:35:51"
              },
              {
                "Content": "CERTIDAO DE CARTORIO EXPEDIDA CERTIFICO E DOU FE QUE VINCULEI A(S) GUIA(S) DARE DE FLS. 206 AO PRESENTE PROCESSO NO PORTAL DE CUSTAS, RECOLHIMENTOS E DEPOSITOS DO TJSP, NOS TERMOS DO PROVIMENTO CG 01/2020 E COMUNICADO CG 136/2020 DE 21/01/2020.",
                "PublishDate": "2020-02-20T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "PETICAO JUNTADA | N PROTOCOLO: WIDU.20.70018074-5 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 19/02/2020 16:24",
                "PublishDate": "2020-02-19T00:00:00",
                "CaptureDate": "2020-02-28T00:35:51"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WIDU.20.70018074-5 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 19/02/2020 16:24",
                "PublishDate": "2020-02-19T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0025/2020 DATA DA DISPONIBILIZACAO: 14/02/2020 DATA DA PUBLICACAO: 17/02/2020 NUMERO DO DIARIO: 2986 PAGINA: 151/173",
                "PublishDate": "2020-02-14T00:00:00",
                "CaptureDate": "2020-02-15T00:44:21"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0025/2020 DATA DA DISPONIBILIZACAO: 14/02/2020 DATA DA PUBLICACAO: 17/02/2020 NUMERO DO DIARIO: 2986 PAGINA: 151/173",
                "PublishDate": "2020-02-14T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0025/2020 TEOR DO ATO: PROVIDENCIE O REQUERIDO ITAU A JUNTADA DE DUAS TAXAS DA OAB NO VALOR DE R$ 47,34, SOB PENA DE COMUNICACAO AO ORGAO ESPECIFICO. ADVOGADOS(S): CLARISSA ALINE PAIE RODELLA CONTATO (OAB 209019/SP), PAULO ROBERTO JOAQUIM DOS REIS (OAB 23134/SP), GABRIELA BONI TEIXEIRA (OAB 412208/SP)",
                "PublishDate": "2020-02-13T00:00:00",
                "CaptureDate": "2020-02-15T00:44:21"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0025/2020 TEOR DO ATO: PROVIDENCIE O REQUERIDO ITAU A JUNTADA DE DUAS TAXAS DA OAB NO VALOR DE R$ 47,34, SOB PENA DE COMUNICACAO AO ORGAO ESPECIFICO. ADVOGADOS(S): CLARISSA ALINE PAIE RODELLA CONTATO (OAB 209019/SP), PAULO ROBERTO JOAQUIM DOS REIS (OAB 23134/SP), GABRIELA BONI TEIXEIRA (OAB 412208/SP)",
                "PublishDate": "2020-02-13T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "ATO ORDINATORIO - PUBLICAVEL | PROVIDENCIE O REQUERIDO ITAU A JUNTADA DE DUAS TAXAS DA OAB NO VALOR DE R$ 47,34, SOB PENA DE COMUNICACAO AO ORGAO ESPECIFICO.",
                "PublishDate": "2020-02-12T00:00:00",
                "CaptureDate": "2020-02-15T00:44:21"
              },
              {
                "Content": "ATO ORDINATORIO - PUBLICAVEL PROVIDENCIE O REQUERIDO ITAU A JUNTADA DE DUAS TAXAS DA OAB NO VALOR DE R$ 47,34, SOB PENA DE COMUNICACAO AO ORGAO ESPECIFICO.",
                "PublishDate": "2020-02-12T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "ATO ORDINATORIO - INTIMACAO - DJE | PROVIDENCIE O REQUERIDO ITAU A JUNTADA DE DUAS TAXAS DA OAB NO VALOR DE R$ 47,34, SOB PENA DE COMUNICACAO AO ORGAO ESPECIFICO.",
                "PublishDate": "2020-02-12T00:00:00",
                "CaptureDate": "2022-05-20T11:00:57"
              },
              {
                "Content": "ATO ORDINATORIO - INTIMACAO - DJE PROVIDENCIE O REQUERIDO ITAU A JUNTADA DE DUAS TAXAS DA OAB NO VALOR DE R$ 47,34, SOB PENA DE COMUNICACAO AO ORGAO ESPECIFICO.",
                "PublishDate": "2020-02-12T00:00:00",
                "CaptureDate": "2022-12-24T02:31:07"
              },
              {
                "Content": "CONTESTACAO JUNTADA | N PROTOCOLO: WIDU.20.70014164-2 TIPO DA PETICAO: CONTESTACAO DATA: 11/02/2020 18:32",
                "PublishDate": "2020-02-11T00:00:00",
                "CaptureDate": "2020-02-15T00:44:21"
              },
              {
                "Content": "CONTESTACAO JUNTADA N PROTOCOLO: WIDU.20.70014164-2 TIPO DA PETICAO: CONTESTACAO DATA: 11/02/2020 18:32",
                "PublishDate": "2020-02-11T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "PETICAO JUNTADA | N PROTOCOLO: WIDU.20.70010754-1 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 05/02/2020 14:38",
                "PublishDate": "2020-02-05T00:00:00",
                "CaptureDate": "2020-02-15T00:44:21"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WIDU.20.70010754-1 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 05/02/2020 14:38",
                "PublishDate": "2020-02-05T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0007/2020 DATA DA DISPONIBILIZACAO: 28/01/2020 DATA DA PUBLICACAO: 29/01/2020 NUMERO DO DIARIO: 2973 PAGINA: 146/186",
                "PublishDate": "2020-01-28T00:00:00",
                "CaptureDate": "2020-01-25T03:13:28"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0007/2020 DATA DA DISPONIBILIZACAO: 28/01/2020 DATA DA PUBLICACAO: 29/01/2020 NUMERO DO DIARIO: 2973 PAGINA: 146/186",
                "PublishDate": "2020-01-28T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0007/2020 TEOR DO ATO: MANIFESTE-SE A PARTE REQUERENTE SOBRE O AR NEGATIVO COM A INFORMACAO \"DESCONHECIDO\" DE FLS. 176, NO PRAZO LEGAL. ADVOGADOS(S): CLARISSA ALINE PAIE RODELLA CONTATO (OAB 209019/SP), GABRIELA BONI TEIXEIRA (OAB 412208/SP)",
                "PublishDate": "2020-01-24T00:00:00",
                "CaptureDate": "2020-01-25T03:13:28"
              },
              {
                "Content": "ATO ORDINATORIO - PUBLICAVEL | MANIFESTE-SE A PARTE REQUERENTE SOBRE O AR NEGATIVO COM A INFORMACAO \"DESCONHECIDO\" DE FLS. 176, NO PRAZO LEGAL.",
                "PublishDate": "2020-01-24T00:00:00",
                "CaptureDate": "2020-01-25T03:13:28"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0002/2020 DATA DA DISPONIBILIZACAO: 24/01/2020 DATA DA PUBLICACAO: 27/01/2020 NUMERO DO DIARIO: 2971 PAGINA: 256/297",
                "PublishDate": "2020-01-24T00:00:00",
                "CaptureDate": "2020-01-25T03:13:28"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0002/2020 DATA DA DISPONIBILIZACAO: 24/01/2020 DATA DA PUBLICACAO: 27/01/2020 NUMERO DO DIARIO: 2971 PAGINA: 256/297",
                "PublishDate": "2020-01-24T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "ATO ORDINATORIO - PUBLICAVEL MANIFESTE-SE A PARTE REQUERENTE SOBRE O AR NEGATIVO COM A INFORMACAO \"DESCONHECIDO\" DE FLS. 176, NO PRAZO LEGAL.",
                "PublishDate": "2020-01-24T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0007/2020 TEOR DO ATO: MANIFESTE-SE A PARTE REQUERENTE SOBRE O AR NEGATIVO COM A INFORMACAO \"DESCONHECIDO\" DE FLS. 176, NO PRAZO LEGAL. ADVOGADOS(S): CLARISSA ALINE PAIE RODELLA CONTATO (OAB 209019/SP), GABRIELA BONI TEIXEIRA (OAB 412208/SP)",
                "PublishDate": "2020-01-24T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "ATO ORDINATORIO - INTIMACAO - DJE | MANIFESTE-SE A PARTE REQUERENTE SOBRE O AR NEGATIVO COM A INFORMACAO \"DESCONHECIDO\" DE FLS. 176, NO PRAZO LEGAL.",
                "PublishDate": "2020-01-24T00:00:00",
                "CaptureDate": "2022-05-20T11:00:57"
              },
              {
                "Content": "ATO ORDINATORIO - INTIMACAO - DJE MANIFESTE-SE A PARTE REQUERENTE SOBRE O AR NEGATIVO COM A INFORMACAO \"DESCONHECIDO\" DE FLS. 176, NO PRAZO LEGAL.",
                "PublishDate": "2020-01-24T00:00:00",
                "CaptureDate": "2022-12-24T02:31:07"
              },
              {
                "Content": "AR POSITIVO JUNTADO | JUNTADA DE AR : AR105227579TJ SITUACAO : CUMPRIDO MODELO : PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC DESTINATARIO : ITAU UNIBANCO S/A DILIGENCIA : 16/01/2020",
                "PublishDate": "2020-01-21T00:00:00",
                "CaptureDate": "2020-01-25T03:13:28"
              },
              {
                "Content": "AR NEGATIVO JUNTADO - DESCONHECIDO | JUNTADA DE AR : AR105227551TJ SITUACAO : DESCONHECIDO MODELO : PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC DESTINATARIO : STARK BANK S.A.",
                "PublishDate": "2020-01-21T00:00:00",
                "CaptureDate": "2020-01-25T03:13:28"
              },
              {
                "Content": "AR NEGATIVO JUNTADO - DESCONHECIDO JUNTADA DE AR : AR105227551TJ SITUACAO : DESCONHECIDO MODELO : PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC DESTINATARIO : STARK BANK S.A.",
                "PublishDate": "2020-01-21T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "AR POSITIVO JUNTADO JUNTADA DE AR : AR105227579TJ SITUACAO : CUMPRIDO MODELO : PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC DESTINATARIO : ITAU UNIBANCO S/A DILIGENCIA : 16/01/2020",
                "PublishDate": "2020-01-21T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "AR POSITIVO JUNTADO | JUNTADA DE AR : AR105227565TJ SITUACAO : CUMPRIDO MODELO : PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC DESTINATARIO : ELEVADORES ATLAS SCHINDLER LTDA. DILIGENCIA : 16/01/2020",
                "PublishDate": "2020-01-18T00:00:00",
                "CaptureDate": "2020-01-25T03:13:28"
              },
              {
                "Content": "AR POSITIVO JUNTADO JUNTADA DE AR : AR105227565TJ SITUACAO : CUMPRIDO MODELO : PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC DESTINATARIO : ELEVADORES ATLAS SCHINDLER LTDA. DILIGENCIA : 16/01/2020",
                "PublishDate": "2020-01-18T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0002/2020 TEOR DO ATO: VISTOS. DIANTE DAS ESPECIFICIDADES DA CAUSA E DE MODO A ADEQUAR O RITO PROCESSUAL AS NECESSIDADES DO CONFLITO, DEIXO PARA MOMENTO OPORTUNO A ANALISE DA CONVENIENCIA DA AUDIENCIA DE CONCILIACAO.(CPC, ART.139, VI E ENUNCIADO N.35 DA ENFAM). CITE-SE A PARTE RE PARA CONTESTAR O FEITO NO PRAZO DE 15 (QUINZE) DIAS UTEIS. A AUSENCIA DE CONTESTACAO IMPLICARA REVELIA E PRESUNCAO DE VERACIDADE DA MATERIA FATICA APRESENTADA NA PETICAO INICIAL (ARTIGO 344, DO CPC). A PRESENTE CITACAO E ACOMPANHADA DE SENHA PARA ACESSO AO PROCESSO DIGITAL, QUE CONTEM A INTEGRA DA PETICAO INICIAL E DOS DOCUMENTOS. TRATANDO-SE DE PROCESSO ELETRONICO, EM PRESTIGIO AS REGRAS FUNDAMENTAIS DOS ARTIGOS 4 E 6 DO CPC, FICA VEDADO O EXERCICIO DA FACULDADE PREVISTA NO ARTIGO 340 DO CPC. INTIME-SE. ( CERTIFICO E DOU FE QUE, EM FACE DO RECOLHIMENTO DE FLS. 167/169, EXPEDI CARTAS AR DE CITACAO MODELO DIGITAL DOS REQUERIDOS, COMO DETERMINADO AS FLS. 170.) ADVOGADOS(S): CLARISSA ALINE PAIE RODELLA CONTATO (OAB 209019/SP), GABRIELA BONI TEIXEIRA (OAB 412208/SP)",
                "PublishDate": "2020-01-13T00:00:00",
                "CaptureDate": "2020-01-25T03:13:28"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0002/2020 TEOR DO ATO: VISTOS. DIANTE DAS ESPECIFICIDADES DA CAUSA E DE MODO A ADEQUAR O RITO PROCESSUAL AS NECESSIDADES DO CONFLITO, DEIXO PARA MOMENTO OPORTUNO A ANALISE DA CONVENIENCIA DA AUDIENCIA DE CONCILIACAO.(CPC, ART.139, VI E ENUNCIADO N.35 DA ENFAM). CITE-SE A PARTE RE PARA CONTESTAR O FEITO NO PRAZO DE 15 (QUINZE) DIAS UTEIS. A AUSENCIA DE CONTESTACAO IMPLICARA REVELIA E PRESUNCAO DE VERACIDADE DA MATERIA FATICA APRESENTADA NA PETICAO INICIAL (ARTIGO 344, DO CPC). A PRESENTE CITACAO E ACOMPANHADA DE SENHA PARA ACESSO AO PROCESSO DIGITAL, QUE CONTEM A INTEGRA DA PETICAO INICIAL E DOS DOCUMENTOS. TRATANDO-SE DE PROCESSO ELETRONICO, EM PRESTIGIO AS REGRAS FUNDAMENTAIS DOS ARTIGOS 4 E 6 DO CPC, FICA VEDADO O EXERCICIO DA FACULDADE PREVISTA NO ARTIGO 340 DO CPC. INTIME-SE. ( CERTIFICO E DOU FE QUE, EM FACE DO RECOLHIMENTO DE FLS. 167/169, EXPEDI CARTAS AR DE CITACAO MODELO DIGITAL DOS REQUERIDOS, COMO DETERMINADO AS FLS. 170.) ADVOGADOS(S): CLARISSA ALINE PAIE RODELLA CONTATO (OAB 209019/SP), GABRIELA BONI TEIXEIRA (OAB 412208/SP)",
                "PublishDate": "2020-01-13T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "CARTA EXPEDIDA | PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                "PublishDate": "2020-01-10T00:00:00",
                "CaptureDate": "2020-01-25T03:13:28"
              },
              {
                "Content": "CARTA EXPEDIDA | PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                "PublishDate": "2020-01-10T00:00:00",
                "CaptureDate": "2020-01-25T03:13:28"
              },
              {
                "Content": "CARTA EXPEDIDA | PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                "PublishDate": "2020-01-10T00:00:00",
                "CaptureDate": "2020-01-25T03:13:28"
              },
              {
                "Content": "CERTIDAO DE CARTORIO EXPEDIDA | CERTIFICO E DOU FE QUE, EM FACE DO RECOLHIMENTO DE FLS. 167/169, EXPEDI CARTAS AR DE CITACAO MODELO DIGITAL DOS REQUERIDOS, COMO DETERMINADO AS FLS. 170.",
                "PublishDate": "2020-01-10T00:00:00",
                "CaptureDate": "2020-01-25T03:13:28"
              },
              {
                "Content": "CERTIDAO DE CARTORIO EXPEDIDA CERTIFICO E DOU FE QUE, EM FACE DO RECOLHIMENTO DE FLS. 167/169, EXPEDI CARTAS AR DE CITACAO MODELO DIGITAL DOS REQUERIDOS, COMO DETERMINADO AS FLS. 170.",
                "PublishDate": "2020-01-10T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "CARTA EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                "PublishDate": "2020-01-10T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "CARTA EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                "PublishDate": "2020-01-10T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "CARTA EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                "PublishDate": "2020-01-10T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "RECEBIDA A PETICAO INICIAL | VISTOS. DIANTE DAS ESPECIFICIDADES DA CAUSA E DE MODO A ADEQUAR O RITO PROCESSUAL AS NECESSIDADES DO CONFLITO, DEIXO PARA MOMENTO OPORTUNO A ANALISE DA CONVENIENCIA DA AUDIENCIA DE CONCILIACAO.(CPC, ART.139, VI E ENUNCIADO N.35 DA ENFAM). CITE-SE A PARTE RE PARA CONTESTAR O FEITO NO PRAZO DE 15 (QUINZE) DIAS UTEIS. A AUSENCIA DE CONTESTACAO IMPLICARA REVELIA E PRESUNCAO DE VERACIDADE DA MATERIA FATICA APRESENTADA NA PETICAO INICIAL (ARTIGO 344, DO CPC). A PRESENTE CITACAO E ACOMPANHADA DE SENHA PARA ACESSO AO PROCESSO DIGITAL, QUE CONTEM A INTEGRA DA PETICAO INICIAL E DOS DOCUMENTOS. TRATANDO-SE DE PROCESSO ELETRONICO, EM PRESTIGIO AS REGRAS FUNDAMENTAIS DOS ARTIGOS 4 E 6 DO CPC, FICA VEDADO O EXERCICIO DA FACULDADE PREVISTA NO ARTIGO 340 DO CPC. INTIME-SE. ( CERTIFICO E DOU FE QUE, EM FACE DO RECOLHIMENTO DE FLS. 167/169, EXPEDI CARTAS AR DE CITACAO MODELO DIGITAL DOS REQUERIDOS, COMO DETERMINADO AS FLS. 170.)",
                "PublishDate": "2020-01-09T00:00:00",
                "CaptureDate": "2020-01-25T03:13:28"
              },
              {
                "Content": "RECEBIDA A PETICAO INICIAL VISTOS. DIANTE DAS ESPECIFICIDADES DA CAUSA E DE MODO A ADEQUAR O RITO PROCESSUAL AS NECESSIDADES DO CONFLITO, DEIXO PARA MOMENTO OPORTUNO A ANALISE DA CONVENIENCIA DA AUDIENCIA DE CONCILIACAO.(CPC, ART.139, VI E ENUNCIADO N.35 DA ENFAM). CITE-SE A PARTE RE PARA CONTESTAR O FEITO NO PRAZO DE 15 (QUINZE) DIAS UTEIS. A AUSENCIA DE CONTESTACAO IMPLICARA REVELIA E PRESUNCAO DE VERACIDADE DA MATERIA FATICA APRESENTADA NA PETICAO INICIAL (ARTIGO 344, DO CPC). A PRESENTE CITACAO E ACOMPANHADA DE SENHA PARA ACESSO AO PROCESSO DIGITAL, QUE CONTEM A INTEGRA DA PETICAO INICIAL E DOS DOCUMENTOS. TRATANDO-SE DE PROCESSO ELETRONICO, EM PRESTIGIO AS REGRAS FUNDAMENTAIS DOS ARTIGOS 4 E 6 DO CPC, FICA VEDADO O EXERCICIO DA FACULDADE PREVISTA NO ARTIGO 340 DO CPC. INTIME-SE. ( CERTIFICO E DOU FE QUE, EM FACE DO RECOLHIMENTO DE FLS. 167/169, EXPEDI CARTAS AR DE CITACAO MODELO DIGITAL DOS REQUERIDOS, COMO DETERMINADO AS FLS. 170.)",
                "PublishDate": "2020-01-09T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO |",
                "PublishDate": "2019-12-16T00:00:00",
                "CaptureDate": "2020-01-25T03:13:28"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2019-12-16T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "GUIA JUNTADA |",
                "PublishDate": "2019-12-13T00:00:00",
                "CaptureDate": "2020-01-25T03:13:28"
              },
              {
                "Content": "CUSTAS DE MANDATO JUNTADAS |",
                "PublishDate": "2019-12-13T00:00:00",
                "CaptureDate": "2020-01-25T03:13:28"
              },
              {
                "Content": "CUSTAS INICIAIS JUNTADAS |",
                "PublishDate": "2019-12-13T00:00:00",
                "CaptureDate": "2020-01-25T03:13:28"
              },
              {
                "Content": "CUSTAS INICIAIS JUNTADAS |",
                "PublishDate": "2019-12-13T00:00:00",
                "CaptureDate": "2020-01-25T03:13:28"
              },
              {
                "Content": "CUSTAS DE MANDATO JUNTADAS |",
                "PublishDate": "2019-12-13T00:00:00",
                "CaptureDate": "2020-01-25T03:13:28"
              },
              {
                "Content": "PETICAO JUNTADA | N PROTOCOLO: WIDU.19.70151140-9 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 13/12/2019 11:35",
                "PublishDate": "2019-12-13T00:00:00",
                "CaptureDate": "2020-01-25T03:13:28"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WIDU.19.70151140-9 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 13/12/2019 11:35",
                "PublishDate": "2019-12-13T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "CUSTAS DE MANDATO JUNTADAS",
                "PublishDate": "2019-12-13T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "CUSTAS INICIAIS JUNTADAS",
                "PublishDate": "2019-12-13T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "CUSTAS INICIAIS JUNTADAS",
                "PublishDate": "2019-12-13T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "CUSTAS DE MANDATO JUNTADAS",
                "PublishDate": "2019-12-13T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "GUIA JUNTADA",
                "PublishDate": "2019-12-13T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "GUIA JUNTADA",
                "PublishDate": "2019-12-13T00:00:00",
                "CaptureDate": "2021-03-18T00:29:50"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0446/2019 DATA DA DISPONIBILIZACAO: 05/12/2019 DATA DA PUBLICACAO: 06/12/2019 NUMERO DO DIARIO: 2947 PAGINA: 468/493",
                "PublishDate": "2019-12-05T00:00:00",
                "CaptureDate": "2019-12-06T02:34:55"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0446/2019 DATA DA DISPONIBILIZACAO: 05/12/2019 DATA DA PUBLICACAO: 06/12/2019 NUMERO DO DIARIO: 2947 PAGINA: 468/493",
                "PublishDate": "2019-12-05T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0446/2019 TEOR DO ATO: VISTOS. INTIME-SE A EMPRESA REQUERENTE PARA REGULARIZAR A INICIAL, NO PRAZO DE 15 (QUINZE) DIAS, COMPROVANDO O RECOLHIMENTO DAS TAXAS (TAXA JUDICIARIA INICIAL, TAXA DA OAB E CUSTAS POSTAIS - PARA CITACAO POSTAL, VIA AR/MP), SOB AS PENAS DA LEI. APOS, TORNEM CONCLUSOS. INT. ADVOGADOS(S): CLARISSA ALINE PAIE RODELLA CONTATO (OAB 209019/SP), GABRIELA BONI TEIXEIRA (OAB 412208/SP)",
                "PublishDate": "2019-12-04T00:00:00",
                "CaptureDate": "2019-12-04T04:39:53"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0446/2019 TEOR DO ATO: VISTOS. INTIME-SE A EMPRESA REQUERENTE PARA REGULARIZAR A INICIAL, NO PRAZO DE 15 (QUINZE) DIAS, COMPROVANDO O RECOLHIMENTO DAS TAXAS (TAXA JUDICIARIA INICIAL, TAXA DA OAB E CUSTAS POSTAIS - PARA CITACAO POSTAL, VIA AR/MP), SOB AS PENAS DA LEI. APOS, TORNEM CONCLUSOS. INT. ADVOGADOS(S): CLARISSA ALINE PAIE RODELLA CONTATO (OAB 209019/SP), GABRIELA BONI TEIXEIRA (OAB 412208/SP)",
                "PublishDate": "2019-12-04T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "MERO EXPEDIENTE | VISTOS. INTIME-SE A EMPRESA REQUERENTE PARA REGULARIZAR A INICIAL, NO PRAZO DE 15 (QUINZE) DIAS, COMPROVANDO O RECOLHIMENTO DAS TAXAS (TAXA JUDICIARIA INICIAL, TAXA DA OAB E CUSTAS POSTAIS - PARA CITACAO POSTAL, VIA AR/MP), SOB AS PENAS DA LEI. APOS, TORNEM CONCLUSOS. INT.",
                "PublishDate": "2019-12-02T00:00:00",
                "CaptureDate": "2019-12-04T04:39:53"
              },
              {
                "Content": "MERO EXPEDIENTE VISTOS. INTIME-SE A EMPRESA REQUERENTE PARA REGULARIZAR A INICIAL, NO PRAZO DE 15 (QUINZE) DIAS, COMPROVANDO O RECOLHIMENTO DAS TAXAS (TAXA JUDICIARIA INICIAL, TAXA DA OAB E CUSTAS POSTAIS - PARA CITACAO POSTAL, VIA AR/MP), SOB AS PENAS DA LEI. APOS, TORNEM CONCLUSOS. INT.",
                "PublishDate": "2019-12-02T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE | VISTOS. INTIME-SE A EMPRESA REQUERENTE PARA REGULARIZAR A INICIAL, NO PRAZO DE 15 (QUINZE) DIAS, COMPROVANDO O RECOLHIMENTO DAS TAXAS (TAXA JUDICIARIA INICIAL, TAXA DA OAB E CUSTAS POSTAIS - PARA CITACAO POSTAL, VIA AR/MP), SOB AS PENAS DA LEI. APOS, TORNEM CONCLUSOS. INT.",
                "PublishDate": "2019-12-02T00:00:00",
                "CaptureDate": "2022-05-20T11:00:57"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE VISTOS. INTIME-SE A EMPRESA REQUERENTE PARA REGULARIZAR A INICIAL, NO PRAZO DE 15 (QUINZE) DIAS, COMPROVANDO O RECOLHIMENTO DAS TAXAS (TAXA JUDICIARIA INICIAL, TAXA DA OAB E CUSTAS POSTAIS - PARA CITACAO POSTAL, VIA AR/MP), SOB AS PENAS DA LEI. APOS, TORNEM CONCLUSOS. INT.",
                "PublishDate": "2019-12-02T00:00:00",
                "CaptureDate": "2022-12-24T02:31:07"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO |",
                "PublishDate": "2019-11-29T00:00:00",
                "CaptureDate": "2019-12-04T04:39:53"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR) |",
                "PublishDate": "2019-11-29T00:00:00",
                "CaptureDate": "2019-12-04T04:39:53"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2019-11-29T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2019-11-29T00:00:00",
                "CaptureDate": "2020-09-22T23:49:45"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2019-11-29T00:00:00",
                "CaptureDate": "2021-03-18T00:29:50"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2019-11-29T00:00:00",
                "CaptureDate": "2021-03-18T00:29:50"
              }
            ],
            "Petitions": [
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2019-12-13T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2020-02-05T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "CONTESTACAO",
                "Author": "",
                "CreationDate": "2020-02-11T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2020-02-19T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "CONTESTACAO",
                "Author": "",
                "CreationDate": "2020-03-27T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "CONTESTACAO",
                "Author": "",
                "CreationDate": "2020-04-14T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2020-04-17T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2020-05-04T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "MANIFESTACAO SOBRE A CONTESTACAO",
                "Author": "",
                "CreationDate": "2020-05-26T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "INDICACAO DE PROVAS",
                "Author": "",
                "CreationDate": "2020-06-09T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "INDICACAO DE PROVAS",
                "Author": "",
                "CreationDate": "2020-06-11T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2020-06-11T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2020-06-12T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2020-06-15T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2020-06-26T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2020-07-06T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2020-07-24T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "EMBARGOS DE DECLARACAO",
                "Author": "",
                "CreationDate": "2021-02-24T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "RAZOES DE APELACAO",
                "Author": "",
                "CreationDate": "2021-05-19T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "CONTRARRAZOES DE APELACAO",
                "Author": "",
                "CreationDate": "2021-06-08T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "CONTRARRAZOES DE APELACAO",
                "Author": "",
                "CreationDate": "2021-06-14T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2021-11-14T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PEDIDO DE EXTINCAO DO PROCESSO",
                "Author": "",
                "CreationDate": "2021-12-03T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              }
            ],
            "Decisions": [
              {
                "DecisionContent": "JULGO IMPROCEDENTE OS PEDIDOS INICIAIS E, POR CONSEQUENCIA DISSO, ATO CONTINUO, CONDENO A AUTORA A PAGAR, AO ADVOGADO DE CADA UM DOS REUS, A TITULO DE HONORARIOS ADVOCATICIOS SUCUMBENCIAIS, IMPORTANCIA CORRESPONDENTE A 10% DO VALOR ATUALIZADO DA CAUSA.",
                "DecisionDate": "2021-02-16T00:00:00"
              },
              {
                "DecisionContent": "JULGO IMPROCEDENTE OS PEDIDOS INICIAIS E, POR CONSEQUENCIA DISSO, ATO CONTINUO, CONDENO A AUTORA A PAGAR, AO ADVOGADO DE CADA UM DOS REUS, A TITULO DE HONORARIOS ADVOCATICIOS SUCUMBENCIAIS, IMPORTANCIA CORRESPONDENTE A 10% DO VALOR ATUALIZADO DA CAUSA.",
                "DecisionDate": "2021-02-15T00:00:00"
              },
              {
                "DecisionContent": "JULGO IMPROCEDENTE OS PEDIDOS INICIAIS E, POR CONSEQUENCIA DISSO, ATO CONTINUO, CONDENO A AUTORA A PAGAR, AO ADVOGADO DE CADA UM DOS REUS, A TITULO DE HONORARIOS ADVOCATICIOS SUCUMBENCIAIS, IMPORTANCIA CORRESPONDENTE A 10% DO VALOR ATUALIZADO DA CAUSA.",
                "DecisionDate": "2021-02-15T00:00:00"
              },
              {
                "DecisionContent": "JULGO IMPROCEDENTE OS PEDIDOS INICIAIS E, POR CONSEQUENCIA DISSO, ATO CONTINUO, CONDENO A AUTORA A PAGAR, AO ADVOGADO DE CADA UM DOS REUS, A TITULO DE HONORARIOS ADVOCATICIOS SUCUMBENCIAIS, IMPORTANCIA CORRESPONDENTE A 10% DO VALOR ATUALIZADO DA CAUSA.",
                "DecisionDate": "2021-02-12T00:00:00"
              },
              {
                "DecisionContent": "JULGO IMPROCEDENTE OS PEDIDOS INICIAIS E, POR CONSEQUENCIA DISSO, ATO CONTINUO, CONDENO A AUTORA A PAGAR, AO ADVOGADO DE CADA UM DOS REUS, A TITULO DE HONORARIOS ADVOCATICIOS SUCUMBENCIAIS, IMPORTANCIA CORRESPONDENTE A 10% DO VALOR ATUALIZADO DA CAUSA.",
                "DecisionDate": "2021-02-12T00:00:00"
              },
              {
                "DecisionContent": "ACOLHO A PRESENTE EXCECAO DE INCOMPETENCIA NOS TERMOS DO ARTIGO 64, 2 DO CODIGO DE PROCESSO CIVIL, REDISTRIBUINDO-SE O FEITO A UMA DAS VARAS CIVEIS DA COMARCA DE CAMPINAS -SP..",
                "DecisionDate": "2020-07-30T00:00:00"
              },
              {
                "DecisionContent": "ACOLHO A PRESENTE EXCECAO DE INCOMPETENCIA NOS TERMOS DO ARTIGO 64, 2 DO CODIGO DE PROCESSO CIVIL, REDISTRIBUINDO-SE O FEITO A UMA DAS VARAS CIVEIS DA COMARCA DE CAMPINAS -SP..",
                "DecisionDate": "2020-07-30T00:00:00"
              },
              {
                "DecisionContent": "ACOLHO A PRESENTE EXCECAO DE INCOMPETENCIA NOS TERMOS DO ARTIGO 64, 2 DO CODIGO DE PROCESSO CIVIL, REDISTRIBUINDO-SE O FEITO A UMA DAS VARAS CIVEIS DA COMARCA DE CAMPINAS -SP..",
                "DecisionDate": "2020-07-28T00:00:00"
              },
              {
                "DecisionContent": "ACOLHO A PRESENTE EXCECAO DE INCOMPETENCIA NOS TERMOS DO ARTIGO 64, 2 DO CODIGO DE PROCESSO CIVIL, REDISTRIBUINDO-SE O FEITO A UMA DAS VARAS CIVEIS DA COMARCA DE CAMPINAS -SP..",
                "DecisionDate": "2020-07-28T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO A JUNTADA DAS TAXAS PELAS RE ELEVADORES ATLAS SCHINDLER LTDA.",
                "DecisionDate": "2020-06-02T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO A JUNTADA DAS TAXAS PELAS RE ELEVADORES ATLAS SCHINDLER LTDA.",
                "DecisionDate": "2020-06-02T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO A JUNTADA DAS TAXAS PELAS RE ELEVADORES ATLAS SCHINDLER LTDA.",
                "DecisionDate": "2020-06-01T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO A JUNTADA DAS TAXAS PELAS RE ELEVADORES ATLAS SCHINDLER LTDA.",
                "DecisionDate": "2020-06-01T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO A JUNTADA DAS TAXAS PELAS RE ELEVADORES ATLAS SCHINDLER LTDA.",
                "DecisionDate": "2020-06-01T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO A JUNTADA DAS TAXAS PELAS RE ELEVADORES ATLAS SCHINDLER LTDA.",
                "DecisionDate": "2020-06-01T00:00:00"
              }
            ]
          },
          {
            "Number": "00058676720208260100",
            "Type": "CUMPRIMENTO PROVISORIO DE DECISAO",
            "MainSubject": "PROTESTO INDEVIDO DE TITULO",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "SAO PAULO",
            "JudgingBody": "8 VARA CIVEL - FORO CENTRAL CIVEL",
            "State": "SP",
            "Status": "INDEFINIDO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "PROTESTO INDEVIDO DE TÍTULO",
            "InferredCNJSubjectNumber": 7781,
            "InferredCNJProcedureTypeName": "CUMPRIMENTO PROVISÓRIO DE DECISÃO",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "PROTESTO INDEVIDO DE TITULO"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": -1,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2020-03-16T00:00:00",
            "NoticeDate": "2020-01-30T00:00:00",
            "LastMovementDate": "2020-03-16T00:00:00",
            "CaptureDate": "2020-03-17T04:49:53",
            "LastUpdate": "2020-03-17T04:49:53",
            "NumberOfParties": 4,
            "NumberOfUpdates": 18,
            "LawSuitAge": 1490,
            "AverageNumberOfUpdatesPerMonth": 0,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "IsPartyActive": true,
                "Name": "ADVISOR BOOKEEPING SERVICES LTDA",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2020-03-17T04:49:53"
              },
              {
                "Doc": "30915522845",
                "IsPartyActive": true,
                "Name": "CAROLINE NITTO FERNANDES",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "SpecificType": "ADVOGADO REQUERENTE"
                },
                "LastCaptureDate": "2020-03-17T04:49:53"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2020-03-17T04:49:53"
              },
              {
                "Doc": "35068411817",
                "IsPartyActive": true,
                "Name": "RAFAEL HIDEO NAZIMA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "SpecificType": "ADVOGADO REQUERIDO"
                },
                "LastCaptureDate": "2020-03-17T04:49:53"
              }
            ],
            "Updates": [
              {
                "Content": "ATO ORDINATORIO - NAO PUBLICAVEL | NA PRESENTE DATA ENCAMINHEI OS AUTOS A DATILOGRAFIA PARA EXPEDICAO DE GUIA DE LEVANTAMENTO/MANDADO DE LEVANTAMENTO ELETRONICO. DEVERA O INTERESSADO AGUARDAR NOVA PUBLICACAO COM INTIMACAO PARA RETIRADA DA GUIA (MLJ)/CIENCIA DA EXPEDICAO (MLE).",
                "PublishDate": "2020-03-16T00:00:00",
                "CaptureDate": "2020-03-17T04:49:53"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0075/2020 DATA DA DISPONIBILIZACAO: 16/03/2020 DATA DA PUBLICACAO: 17/03/2020 NUMERO DO DIARIO: 3005 PAGINA: 148/170",
                "PublishDate": "2020-03-16T00:00:00",
                "CaptureDate": "2020-03-17T04:49:53"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0075/2020 TEOR DO ATO: VISTOS. 1 - FLS. 14: DIANTE DA SATISFACAO DA OBRIGACAO, JULGO EXTINTA A EXECUCAO, COM FUNDAMENTO NO ARTIGO 924, INCISO II, DO CODIGO DE PROCESSO CIVIL. 2 - DEFIRO A EXPEDICAO DO MANDADO DE LEVANTAMENTO, EM FAVOR DO EXEQUENTE, DO COMPROVANTE DE DEPOSITO DE FLS. 07/08, NO VALOR DE R$1.156,07, O QUE SE DARA POR MEIO DO \"MODULO DE LEVANTAMENTO ELETRONICO DO PORTAL DE CUSTAS RECOLHIMENTOS E DEPOSITOS DO TJSP\", NOS TERMOS DOS COMUNICADOS CONJUNTOS N 474/2017 E 1731/2018, DA PRESIDENCIA DO TRIBUNAL DE JUSTICA E DA CORREGEDORIA GERAL DE JUSTICA. PROVIDENCIE-SE O NECESSARIO, OBSERVANDO-SE O FORMULARIO JUNTADO AS FLS. 15. 3 - PROVIDENCIE A PARTE EXECUTADA O RECOLHIMENTO DAS CUSTAS FINAIS, EM GUIA PROPRIA, NO PRAZO DE 15 DIAS. DECORRIDO O PRAZO ASSINALADO, SEM O CUMPRIMENTO, EXPECA-SE CERTIDAO PARA INSCRICAO EM DIVIDA ATIVA, NOS TERMOS DO ART. 1.098 DAS NSCGJ. 4 - OPORTUNAMENTE, PROCEDAM-SE AS ANOTACOES E COMUNICACOES NECESSARIAS, ARQUIVANDO-SE OS AUTOS P.R.I.C. ADVOGADOS(S): CAROLINE NITTO FERNANDES (OAB 276522/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-03-12T00:00:00",
                "CaptureDate": "2020-03-17T04:49:53"
              },
              {
                "Content": "EXTINTA A EXECUCAO/CUMPRIMENTO DA SENTENCA PELA SATISFACAO DA OBRIGACAO | VISTOS. 1 - FLS. 14: DIANTE DA SATISFACAO DA OBRIGACAO, JULGO EXTINTA A EXECUCAO, COM FUNDAMENTO NO ARTIGO 924, INCISO II, DO CODIGO DE PROCESSO CIVIL. 2 - DEFIRO A EXPEDICAO DO MANDADO DE LEVANTAMENTO, EM FAVOR DO EXEQUENTE, DO COMPROVANTE DE DEPOSITO DE FLS. 07/08, NO VALOR DE R$1.156,07, O QUE SE DARA POR MEIO DO \"MODULO DE LEVANTAMENTO ELETRONICO DO PORTAL DE CUSTAS RECOLHIMENTOS E DEPOSITOS DO TJSP\", NOS TERMOS DOS COMUNICADOS CONJUNTOS N 474/2017 E 1731/2018, DA PRESIDENCIA DO TRIBUNAL DE JUSTICA E DA CORREGEDORIA GERAL DE JUSTICA. PROVIDENCIE-SE O NECESSARIO, OBSERVANDO-SE O FORMULARIO JUNTADO AS FLS. 15. 3 - PROVIDENCIE A PARTE EXECUTADA O RECOLHIMENTO DAS CUSTAS FINAIS, EM GUIA PROPRIA, NO PRAZO DE 15 DIAS. DECORRIDO O PRAZO ASSINALADO, SEM O CUMPRIMENTO, EXPECA-SE CERTIDAO PARA INSCRICAO EM DIVIDA ATIVA, NOS TERMOS DO ART. 1.098 DAS NSCGJ. 4 - OPORTUNAMENTE, PROCEDAM-SE AS ANOTACOES E COMUNICACOES NECESSARIAS, ARQUIVANDO-SE OS AUTOS P.R.I.C.",
                "PublishDate": "2020-03-12T00:00:00",
                "CaptureDate": "2020-03-17T04:49:53"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO |",
                "PublishDate": "2020-03-12T00:00:00",
                "CaptureDate": "2020-03-17T04:49:53"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO |",
                "PublishDate": "2020-03-12T00:00:00",
                "CaptureDate": "2020-03-17T04:49:53"
              },
              {
                "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.20.40354447-5 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 11/03/2020 17:36",
                "PublishDate": "2020-03-11T00:00:00",
                "CaptureDate": "2020-03-17T04:49:53"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0068/2020 DATA DA DISPONIBILIZACAO: 10/03/2020 DATA DA PUBLICACAO: 11/03/2020 NUMERO DO DIARIO: 3001 PAGINA: 118/142",
                "PublishDate": "2020-03-10T00:00:00",
                "CaptureDate": "2020-03-11T04:00:34"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0068/2020 TEOR DO ATO: FLS. 07: CIENCIA SOBRE O COMPROVANTE DE PAGAMENTO. ADVOGADOS(S): CAROLINE NITTO FERNANDES (OAB 276522/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-03-06T00:00:00",
                "CaptureDate": "2020-03-11T04:00:34"
              },
              {
                "Content": "ATO ORDINATORIO | FLS. 07: CIENCIA SOBRE O COMPROVANTE DE PAGAMENTO.",
                "PublishDate": "2020-03-05T00:00:00",
                "CaptureDate": "2020-03-11T04:00:34"
              },
              {
                "Content": "PEDIDO DE EXTINCAO - OBRIGACAO SATISFEITA (ART. 924, II, DO CPC) | N PROTOCOLO: WJMJ.20.40302549-4 TIPO DA PETICAO: PEDIDO DE EXTINCAO (ART. 924, II, DO CPC) DATA: 03/03/2020 19:38",
                "PublishDate": "2020-03-03T00:00:00",
                "CaptureDate": "2020-03-11T04:00:34"
              },
              {
                "Content": "SUSPENSAO DO PRAZO | PRAZO REFERENTE AO USUARIO FOI ALTERADO PARA 04/03/2020 DEVIDO A ALTERACAO DA TABELA DE FERIADOS",
                "PublishDate": "2020-02-23T00:00:00",
                "CaptureDate": "2020-03-11T04:00:34"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0033/2020 DATA DA DISPONIBILIZACAO: 06/02/2020 DATA DA PUBLICACAO: 07/02/2020 NUMERO DO DIARIO: 2980 PAGINA: 123/139",
                "PublishDate": "2020-02-06T00:00:00",
                "CaptureDate": "2020-03-11T04:00:34"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0033/2020 TEOR DO ATO: VISTOS. NA FORMA DO ARTIGO 513 2, INTIME-SE O EXECUTADO, NA PESSOA DE SEU ADVOGADO (DJE) OU, NAO O TENDO, PESSOALMENTE, PARA QUE, NO PRAZO DE 15 (QUINZE) DIAS, PAGUE O VALOR INDICADO NO DEMONSTRATIVO DISCRIMINADO E ATUALIZADO DO CREDITO, ACRESCIDO DE CUSTAS, SE HOUVER. FICA A PARTE EXECUTADA ADVERTIDA DE QUE, TRANSCORRIDO O PRAZO PREVISTO NO ART.523 SEM O PAGAMENTO VOLUNTARIO, INICIA-SE O PRAZO DE 15 (QUINZE) DIAS PARA QUE, INDEPENDENTEMENTE DE PENHORA OU NOVA INTIMACAO, APRESENTE, NOS PROPRIOS AUTOS, SUA IMPUGNACAO. NAO OCORRENDO PAGAMENTO VOLUNTARIO NO PRAZO DO ARTIGO 523 DO CPC, O DEBITO SERA ACRESCIDO DE MULTA DE DEZ POR CENTO E, TAMBEM, DE HONORARIOS DE ADVOGADO DE DEZ POR CENTO. DECORRIDO O PRAZO SEM QUE HAJA O PAGAMENTO VOLUNTARIO, CERTIFIQUE NOS AUTOS A SERVENTIA E, APOS, EXPECA-SE MANDADO DE PENHORA E AVALIACAO, CONFORME ART. 523, 3 DO CPC. ADEMAIS, NAO EFETUADO O PAGAMENTO VOLUNTARIO NO PRAZO DE 15 (QUINZE) DIAS, INDEPENDENTEMENTE DE NOVA INTIMACAO DO CREDOR, PODERA A PARTE EXEQUENTE EFETUAR PEDIDO DE PESQUISAS JUNTO AOS SISTEMAS INFORMATIZADOS A DISPOSICAO DO JUIZO, DEVENDO COMPROVAR O PREVIO RECOLHIMENTO DAS TAXAS PREVISTAS NO ART.2, INC.XI, DA LEI ESTADUAL 14.838/12, CALCULADAS POR CADA DILIGENCIA A SER EFETUADA. POR FIM, CERTIFICADO O TRANSITO EM JULGADO DA DECISAO E TRANSCORRIDO O PRAZO DO ART. 523, MEDIANTE O RECOLHIMENTO DAS RESPECTIVAS TAXAS, A PARTE EXEQUENTE PODERA REQUERER DIRETAMENTE A SERVENTIA A EXPEDICAO DE CERTIDAO, NOS TERMOS DO ART.517 DO CPC, QUE SERVIRA TAMBEM AOS FINS PREVISTOS NO ART. 782, 3, TODOS DO CODIGO DE PROCESSO CIVIL. INTIME-SE. ADVOGADOS(S): CAROLINE NITTO FERNANDES (OAB 276522/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-02-04T00:00:00",
                "CaptureDate": "2020-03-11T04:00:34"
              },
              {
                "Content": "DECISAO | VISTOS. NA FORMA DO ARTIGO 513 2, INTIME-SE O EXECUTADO, NA PESSOA DE SEU ADVOGADO (DJE) OU, NAO O TENDO, PESSOALMENTE, PARA QUE, NO PRAZO DE 15 (QUINZE) DIAS, PAGUE O VALOR INDICADO NO DEMONSTRATIVO DISCRIMINADO E ATUALIZADO DO CREDITO, ACRESCIDO DE CUSTAS, SE HOUVER. FICA A PARTE EXECUTADA ADVERTIDA DE QUE, TRANSCORRIDO O PRAZO PREVISTO NO ART.523 SEM O PAGAMENTO VOLUNTARIO, INICIA-SE O PRAZO DE 15 (QUINZE) DIAS PARA QUE, INDEPENDENTEMENTE DE PENHORA OU NOVA INTIMACAO, APRESENTE, NOS PROPRIOS AUTOS, SUA IMPUGNACAO. NAO OCORRENDO PAGAMENTO VOLUNTARIO NO PRAZO DO ARTIGO 523 DO CPC, O DEBITO SERA ACRESCIDO DE MULTA DE DEZ POR CENTO E, TAMBEM, DE HONORARIOS DE ADVOGADO DE DEZ POR CENTO. DECORRIDO O PRAZO SEM QUE HAJA O PAGAMENTO VOLUNTARIO, CERTIFIQUE NOS AUTOS A SERVENTIA E, APOS, EXPECA-SE MANDADO DE PENHORA E AVALIACAO, CONFORME ART. 523, 3 DO CPC. ADEMAIS, NAO EFETUADO O PAGAMENTO VOLUNTARIO NO PRAZO DE 15 (QUINZE) DIAS, INDEPENDENTEMENTE DE NOVA INTIMACAO DO CREDOR, PODERA A PARTE EXEQUENTE EFETUAR PEDIDO DE PESQUISAS JUNTO AOS SISTEMAS INFORMATIZADOS A DISPOSICAO DO JUIZO, DEVENDO COMPROVAR O PREVIO RECOLHIMENTO DAS TAXAS PREVISTAS NO ART.2, INC.XI, DA LEI ESTADUAL 14.838/12, CALCULADAS POR CADA DILIGENCIA A SER EFETUADA. POR FIM, CERTIFICADO O TRANSITO EM JULGADO DA DECISAO E TRANSCORRIDO O PRAZO DO ART. 523, MEDIANTE O RECOLHIMENTO DAS RESPECTIVAS TAXAS, A PARTE EXEQUENTE PODERA REQUERER DIRETAMENTE A SERVENTIA A EXPEDICAO DE CERTIDAO, NOS TERMOS DO ART.517 DO CPC, QUE SERVIRA TAMBEM AOS FINS PREVISTOS NO ART. 782, 3, TODOS DO CODIGO DE PROCESSO CIVIL. INTIME-SE.",
                "PublishDate": "2020-02-04T00:00:00",
                "CaptureDate": "2020-03-11T04:00:34"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO |",
                "PublishDate": "2020-02-04T00:00:00",
                "CaptureDate": "2020-03-11T04:00:34"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO |",
                "PublishDate": "2020-02-04T00:00:00",
                "CaptureDate": "2020-03-11T04:00:34"
              },
              {
                "Content": "INCIDENTE PROCESSUAL INSTAURADO | PROCESSO PRINCIPAL: 1117936-93.2018.8.26.0100",
                "PublishDate": "2020-01-30T00:00:00",
                "CaptureDate": "2020-03-11T04:00:34"
              }
            ],
            "Petitions": [
              {
                "Type": "PEDIDO DE EXTINCAO (ART. 924, II, DO CPC)",
                "Author": "",
                "CreationDate": "2020-03-03T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2020-03-11T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              }
            ],
            "Decisions": [
              {
                "DecisionContent": "JULGO EXTINTA A EXECUCAO, COM FUNDAMENTO NO ARTIGO 924, INCISO II, DO CODIGO DE PROCESSO CIVIL.",
                "DecisionDate": "2020-03-12T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO A EXPEDICAO DO MANDADO DE LEVANTAMENTO, EM FAVOR DO EXEQUENTE, DO COMPROVANTE DE DEPOSITO DE FLS. 07/08, NO VALOR DE R$1.156,07, O QUE SE DARA POR MEIO DO \"MODULO DE LEVANTAMENTO ELETRONICO DO PORTAL DE CUSTAS RECOLHIMENTOS E DEPOSITOS DO TJSP\", NOS TERMOS DOS COMUNICADOS CONJUNTOS N 474/2017 E 1731/2018, DA PRESIDENCIA DO TRIBUNAL DE JUSTICA E DA CORREGEDORIA GERAL DE JUSTICA.",
                "DecisionDate": "2020-03-12T00:00:00"
              },
              {
                "DecisionContent": "JULGO EXTINTA A EXECUCAO, COM FUNDAMENTO NO ARTIGO 924, INCISO II, DO CODIGO DE PROCESSO CIVIL.",
                "DecisionDate": "2020-03-12T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO A EXPEDICAO DO MANDADO DE LEVANTAMENTO, EM FAVOR DO EXEQUENTE, DO COMPROVANTE DE DEPOSITO DE FLS. 07/08, NO VALOR DE R$1.156,07, O QUE SE DARA POR MEIO DO \"MODULO DE LEVANTAMENTO ELETRONICO DO PORTAL DE CUSTAS RECOLHIMENTOS E DEPOSITOS DO TJSP\", NOS TERMOS DOS COMUNICADOS CONJUNTOS N 474/2017 E 1731/2018, DA PRESIDENCIA DO TRIBUNAL DE JUSTICA E DA CORREGEDORIA GERAL DE JUSTICA.",
                "DecisionDate": "2020-03-12T00:00:00"
              }
            ]
          },
          {
            "Number": "00202699020205040303",
            "Type": "RITO ORDINARIO",
            "MainSubject": "RECONHECIMENTO DE RELACAO DE EMPREGO",
            "CourtName": "TRT4",
            "CourtLevel": "1",
            "CourtType": "TRABALHISTA",
            "CourtDistrict": "NOVO HAMBURGO",
            "JudgingBody": "3 VARA DO TRABALHO DE NOVO HAMBURGO",
            "State": "RS",
            "Status": "TRANSITADO EM JULGADO",
            "LawsuitHostService": "PJE",
            "InferredCNJSubjectName": "RECONHECIMENTO DE RELAÇÃO DE EMPREGO",
            "InferredCNJSubjectNumber": 13722,
            "InferredBroadCNJSubjectName": "DIREITO DO TRABALHO",
            "InferredBroadCNJSubjectNumber": 864,
            "OtherSubjects": [
              "RECONHECIMENTO DE RELACAO DE EMPREGO",
              "AVISO PREVIO"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 108866.73,
            "ResJudicataDate": "2022-09-27T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2022-10-14T00:00:00",
            "NoticeDate": "2020-05-19T11:45:55",
            "LastMovementDate": "2022-11-05T00:05:57",
            "CaptureDate": "2022-11-17T10:54:25",
            "LastUpdate": "2022-11-17T10:54:25",
            "NumberOfParties": 16,
            "NumberOfUpdates": 1142,
            "LawSuitAge": 1380,
            "AverageNumberOfUpdatesPerMonth": 24,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "01095701037",
                "IsPartyActive": false,
                "Name": "RALPH EMERSON GOMEZ",
                "Polarity": "ACTIVE",
                "Type": "AUTHOR",
                "PartyDetails": {
                  "SpecificType": "AUTOR"
                },
                "LastCaptureDate": "2020-08-20T22:59:52"
              },
              {
                "Doc": "10685786000181",
                "IsPartyActive": false,
                "Name": "FRI SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO",
                "Polarity": "PASSIVE",
                "Type": "DEFENDANT",
                "PartyDetails": {
                  "SpecificType": "REU"
                },
                "LastCaptureDate": "2020-08-20T22:59:52"
              },
              {
                "IsPartyActive": false,
                "Name": "E A R F E I E M",
                "Polarity": "PASSIVE",
                "Type": "DEFENDANT",
                "PartyDetails": {
                  "SpecificType": "REU"
                },
                "LastCaptureDate": "2020-08-20T22:59:52"
              },
              {
                "IsPartyActive": false,
                "Name": "A F M",
                "Polarity": "PASSIVE",
                "Type": "DEFENDANT",
                "PartyDetails": {
                  "SpecificType": "REU"
                },
                "LastCaptureDate": "2020-08-20T22:59:52"
              },
              {
                "IsPartyActive": false,
                "Name": "S B S A",
                "Polarity": "PASSIVE",
                "Type": "DEFENDANT",
                "PartyDetails": {
                  "SpecificType": "REU"
                },
                "LastCaptureDate": "2020-08-20T22:59:52"
              },
              {
                "Doc": "00085411086",
                "IsPartyActive": true,
                "Name": "VINICIUS LEIPNITZ DA SILVA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "SpecificType": "ADVOGADO"
                },
                "LastCaptureDate": "2022-11-17T10:54:25"
              },
              {
                "IsPartyActive": false,
                "Name": "E A ROCHA FORTS ESCRITORIO IMOBILIARIO EIRELI ME",
                "Polarity": "PASSIVE",
                "Type": "DEFENDANT",
                "PartyDetails": {
                  "SpecificType": "REU"
                },
                "LastCaptureDate": "2020-08-20T22:59:52"
              },
              {
                "Doc": "25321930000178",
                "IsPartyActive": false,
                "Name": "ARENA FOMENTO MERCANTIL LTDA",
                "Polarity": "PASSIVE",
                "Type": "DEFENDANT",
                "PartyDetails": {
                  "SpecificType": "REU"
                },
                "LastCaptureDate": "2020-08-20T22:59:52"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": false,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "DEFENDANT",
                "PartyDetails": {
                  "SpecificType": "REU"
                },
                "LastCaptureDate": "2020-08-20T22:59:52"
              },
              {
                "Doc": "13486308840",
                "IsPartyActive": false,
                "Name": "LUIZ ALEXANDRE SANDA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "SpecificType": "ADVOGADO"
                },
                "LastCaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Doc": "01095701037",
                "IsPartyActive": true,
                "Name": "RALPH EMERSON GOMEZ",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "RECLAMANTE"
                },
                "LastCaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Doc": "10685786000181",
                "IsPartyActive": true,
                "Name": "FRI SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "RECLAMADO"
                },
                "LastCaptureDate": "2022-11-17T10:54:25"
              },
              {
                "IsPartyActive": true,
                "Name": "E A ROCHA FORTS ESCRITORIO IMOBILIARIO EIRELI ME",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "RECLAMADO"
                },
                "LastCaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Doc": "25321930000178",
                "IsPartyActive": true,
                "Name": "ARENA FOMENTO MERCANTIL LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "RECLAMADO"
                },
                "LastCaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": false,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "RECLAMADO"
                },
                "LastCaptureDate": "2021-12-12T03:21:11"
              },
              {
                "IsPartyActive": true,
                "Name": "P E B",
                "Polarity": "NEUTRAL",
                "Type": "OTHER",
                "PartyDetails": {
                  "SpecificType": "TERCEIRO INTERESSADO"
                },
                "LastCaptureDate": "2022-11-17T10:54:25"
              }
            ],
            "Updates": [
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 04/11/2022",
                "PublishDate": "2022-11-05T00:05:57",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "EXPEDIDO(A) NOTIFICACAO A(O) PEDRO EDMUNDO BOLL",
                "PublishDate": "2022-10-26T12:43:40",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2022-10-26T11:25:40",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (3) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS AO EXMO. MAGISTRADO. NOVO HAMBURGO, 25 DE OUTUBRO DE 2022. ANDRESSA TRIERWEILER VISTOS OS AUTOS. NOMEIO O CONTADOR PEDRO EDMUNDO BOLL PARA ELABORACAO DOS CALCULOS DE LIQUIDACAO, COM PRAZO DE 20 DIAS PARA A ENTREGA DO LAUDO, DEVENDO OBSERVAR OS CRITERIOS JA FIXADOS PELO JUIZO. NOVO HAMBURGO/RS, 26 DE OUTUBRO DE 2022. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2022-10-26T11:25:40",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2022-10-25T16:36:10",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 17/10/2022",
                "PublishDate": "2022-10-15T01:29:20",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2022-10-15T01:29:20",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2022-10-14T12:33:24",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "EXPEDIDO(A) ALVARA A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2022-10-14T08:46:07",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "PROCESSO N ATORD-0020269-90.2020.5.04.0303 RECLAMANTE RALPH EMERSON GOMEZ ADVOGADO VINICIUS LEIPNITZ DA SILVA(OAB: 101515/RS) RECLAMADO ARENA FOMENTO MERCANTIL LTDA RECLAMADO E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME RECLAMADO FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. INTIMADO(S)/CITADO(S): - RALPH EMERSON GOMEZ PODER JUDICIARIO JUSTICA DO NOTIFICACAO DESTINATARIO: RALPH EMERSON GOMEZ PELA PRESENTE, FICA O DESTINATARIO NOTIFICADO PARA APRESENTAR CALCULOS DE LIQUIDACAO NO PRAZO DE 10 DIAS, NOS TERMOS DO DESPACHO ID 2846B17. FICA NOTIFICADO, AINDA, PARA DEPOSITAR A SUA CTPS EM SECRETARIA E CIENTE DA EXPEDICAO DE ALVARA PARA ENCAMINHAMENTO DO SEGURO- DESEMPREGO, CONFORME ID D274949. NOVO HAMBURGO/RS, 14 DE OUTUBRO DE 2022. ANA LUCIA SCHNEIDER ASSESSOR",
                "PublishDate": "2022-10-14T00:00:00",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2022-10-04T17:11:22",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (3) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 04 DE OUTUBRO DE 2022. ANA STELA PACHIEGA VISTOS OS AUTOS. EXPECA-SE O ALVARA PARA ENCAMINHAMENTO DO SEGURO-DESEMPREGO. O AUTOR DEVERA DEPOSITAR A SUA CTPS EM SECRETARIA. INTIME-SE O AUTOR PARA QUE APRESENTE OS CALCULOS DE LIQUIDACAO, NO PRAZO DE DEZ DIAS, OBSERVANDO OS CRITERIOS ABAIXO, SE DE FORMA DIVERSA NAO TIVEREM SIDO FIXADOS NA SENTENCA. PARA APRESENTACAO DOS CALCULOS DE LIQUIDACAO ELABORADOS VIA PJE CALC, DETERMINA-SE O ENVIO DO ARQUIVO .PJC ATRAVES DO SISTEMA PJE, PARA FUTURA ATUALIZACAO E CITACAO PARA PAGAMENTO. PARA QUE TAL FUNCIONALIDADE FIQUE HABILITADA E NECESSARIO INCLUIR ANEXO EM PDF COM O RESUMO DO CALCULO E SELECIONAR O TIPO DE DOCUMENTO PLANILHA DE CALCULO OU PLANILHA DE ATUALIZACAO DE CALCULO. COM ISSO, O SISTEMA HABILITA OS CAMPOS CREDOR, DEVEDOR E ESCOLHER ARQUIVO. NESSA OPCAO \"ESCOLHER ARQUIVO\" DEVE SER ANEXADO O ARQUIVO \".PJC\". 1. ATUALIZACAO MONETARIA E JUROS: NA FORMA DA TESE VINCULANTE FIXADA PELO STF NA ADC 58 (INCIDENCIA DO IPCA-E MAIS JUROS PELA TR ACUMULADA NA FASE PRE- JUDICIAL E, A PARTIR DO AJUIZAMENTO DA ACAO A INCIDENCIA DA TAXA SELIC (ART. 406 DO CODIGO CIVIL), QUE JA INCLUI JUROS DE MORA. 2. A ATUALIZACAO DO FGTS DEVE SEGUIR OS MESMOS CRITERIOS DOS CREDITOS TRABALHISTAS. ASSINADO ELETRONICAMENTE POR: THIAGO BOLDT DE SOUZA - JUNTADO EM: 04/10/2022 17:11:22 - 2846B17 3. SAO CABIVEIS OS DESCONTOS FISCAIS E PREVIDENCIARIOS QUANDO NAO VEDADOS EXPRESSAMENTE NA DECISAO TRANSITADA EM JULGADO (SUMULA 25 DO E. TRT DA 4 REGIAO) E APLICADO O DISPOSTO NO ART. 12-A DA LEI 7.713/88, INCLUIDO PELA LEI 12.350/10. 4. OS DESCONTOS PREVIDENCIARIOS DO EMPREGADO DEVEM SER PROCEDIDOS MES A MES, INCIDINDO SOBRE O VALOR HISTORICO SUJEITO A CONTRIBUICAO, RESPEITADO O TETO- LIMITE, SEGUNDO TABELA PROPRIA PUBLICADA PELO INSS, E AS ALIQUOTAS PREVISTAS EM LEI, CONSIDERANDO INCLUSIVE O VALOR DA REMUNERACAO MENSAL SATISFEITA A EPOCA E A CONTRIBUICAO PREVIDENCIARIA RELATIVA AO EMPREGADO JA PROCEDIDA NA VIGENCIA DO PACTO. A CONTRIBUICAO PREVIDENCIARIA DO EMPREGADOR COMPREENDE O PERCENTUAL DE 20% ACRESCIDA DA PARCELA SAT. DEVERAO SER OBSERVADOS OS CRITERIOS DA SUMULA N 368 DO TST. 5. A BASE DE CALCULO DAS HORAS EXTRAS DEVE SER COMPOSTA DAS MESMAS VERBAS CONSIDERADAS AO LONGO DO CONTRATO SE OUTRO CRITERIO NAO TIVER SIDO FIXADO NA DECISAO EXEQUENDA. 6. A COMPENSACAO DE PARCELAS PAGAS SOMENTE PODE SER PROCEDIDA QUANDO EXPRESSAMENTE AUTORIZADA E EM RELACAO AO MESMO MES DE APURACAO. EVENTUAIS PAGAMENTOS A MAIOR NAO PODERAO SER COMPENSADOS EM MESES POSTERIORES, SALVO SE HOUVER EXPRESSA AUTORIZACAO NESSE SENTIDO NA DECISAO EXEQUENDA. 7. DA FORMA DOS CALCULOS: NO CALCULO DE CADA PARCELA DEVERA SER INFORMADO O CRITERIO UTILIZADO. DEVERA SER APRESENTADO, AINDA, ALEM DAS PLANILHAS DISCRIMINANDO OS VALORES CALCULADOS, RESUMO ONDE CONSTEM, EM SEPARADO, OS TOTAIS DE PRINCIPAL (01), JUROS TRIBUTAVEIS (02) PARA FINS DE CALCULO AUTOMATICO DO IMPOSTO DE RENDA; DE PRINCIPAL (101) E DE JUROS NAO TRIBUTAVEIS (102), DE FGTS (111) E DE VALORES HISTORICOS DE INSS DE CADA PARTE (EMPREGADO E EMPREGADOR). 8. DEVERAO SER OBSERVADAS AS DISPOSICOES DA RECOMENDACAO N 01/2015 DA CORREGEDORIA REGIONAL DO E. TRT. NOVO HAMBURGO/RS, 04 DE OUTUBRO DE 2022. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2022-10-04T17:11:22",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2022-10-04T14:57:26",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "INICIADA A LIQUIDACAO",
                "PublishDate": "2022-10-04T14:57:06",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "TRANSITADO EM JULGADO EM 27/09/2022",
                "PublishDate": "2022-10-04T14:57:04",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DECORRIDO O PRAZO DE E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME EM 27/09/2022",
                "PublishDate": "2022-09-28T00:01:11",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DECORRIDO O PRAZO DE FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. EM 27/09/2022",
                "PublishDate": "2022-09-28T00:01:11",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DECORRIDO O PRAZO DE ARENA FOMENTO MERCANTIL LTDA EM 29/08/2022",
                "PublishDate": "2022-08-30T00:06:27",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "PUBLICADO(A) O(A) EDITAL EM 15/08/2022",
                "PublishDate": "2022-08-13T01:29:16",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) EDITAL NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2022-08-13T01:29:16",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "PUBLICADO(A) O(A) EDITAL EM 15/08/2022",
                "PublishDate": "2022-08-13T01:29:16",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) EDITAL NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2022-08-13T01:29:16",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "EXPEDIDO(A) EDITAL A(O) E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME",
                "PublishDate": "2022-08-12T15:05:36",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) ARENA FOMENTO MERCANTIL LTDA",
                "PublishDate": "2022-08-12T15:05:36",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "EXPEDIDO(A) EDITAL A(O) FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA.",
                "PublishDate": "2022-08-12T15:05:36",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 09/08/2022",
                "PublishDate": "2022-08-10T00:06:04",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 28/07/2022",
                "PublishDate": "2022-07-28T01:27:05",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2022-07-28T01:27:05",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2022-07-27T15:26:57",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "JULGADO(S) PROCEDENTE(S) EM PARTE O(S) PEDIDO(S) (ACAO TRABALHISTA - RITO ORDINARIO (985) / ) DE RALPH EMERSON GOMEZ",
                "PublishDate": "2022-07-27T15:25:57",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "ARBITRADAS E NAO DISPENSADAS AS CUSTAS PROCESSUAIS NO VALOR DE R$ 400,00",
                "PublishDate": "2022-07-27T15:25:57",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "SENTENCA PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (3) VISTOS, ETC. RALPH EMERSON GOMEZ AJUIZA ACAO TRABALHISTA EM FACE DE FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA, E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI  ME, ARENA FOMENTO MERCANTIL LTDA E STARK BANK S.A., EM 19.05.2020, AFIRMANDO QUE TRABALHA PARA AS RECLAMADAS DESDE 01.07.2019. APOS EXPOSICAO FATICA, REQUER O DEFERIMENTO DE TUTELA DE URGENCIA DETERMINANDO O BLOQUEIO NAS CONTAS DA RE DE QUANTIA EQUIVALENTE AO VALOR DA CAUSA, BEM COMO A EXPEDICAO DE ALVARA PARA O ENCAMINHAMENTO DO SEGURO-DESEMPREGO. NO MERITO, POSTULA O RECONHECIMENTO DO VINCULO DE EMPREGO E DA RESCISAO INDIRETA DO CONTRATO DE TRABALHO, COM A CONDENACAO DAS RES AO PAGAMENTO DE SALDO DE SALARIO, SALARIOS EM ATRASO, DECIMOS TERCEIROS SALARIOS, FERIAS, FGTS ACRESCIDO DO ADICIONAL COMPENSATORIO DE 40% E MULTAS DOS ARTIGOS 467 E 477 DA CLT. POR FIM, REQUER O BENEFICIO DA ASSISTENCIA JUDICIARIA GRATUITA E A CONDENACAO DAS RECLAMADAS AO PAGAMENTO DE HONORARIOS ADVOCATICIOS. ATRIBUI A CAUSA O VALOR DE R$ 108.886,73. JUNTA DOCUMENTOS. E INDEFERIDA A TUTELA DE URGENCIA POSTULADA, CONFORME DECISAO DA FL. 88. A QUARTA RECLAMADA (STARK BANK) APRESENTA DEFESA REFUTANDO AS PRETENSOES DA INICIAL. A TERCEIRA RECLAMADA (ARENA) E DECLARADA REVEL, EM RAZAO DO NAO OFERECIMENTO DA DEFESA NO PRAZO CONSIGNADO, SENDO DETERMINADA A EXTINCAO DO FEITO EM RELACAO A QUARTA RE (STARK BANK), CONSOANTE DECISAO DA FL. 289. DETERMINA-SE A CITACAO DA PRIMEIRA E SEGUNDA RECLAMADAS POR EDITAL. ASSINADO ELETRONICAMENTE POR: THIAGO BOLDT DE SOUZA - JUNTADO EM: 27/07/2022 15:25:56 - 22A15C3 A PRIMEIRA E SEGUNDA RECLAMADAS SAO DECLARADAS REVEIS, EM RAZAO DO NAO OFERECIMENTO DA DEFESA NO PRAZO CONSIGNADO EM EDITAL. O AUTOR MANIFESTA-SE OS AUTOS SAO CONCLUSOS PARA PROLACAO DA SENTENCA. E O RELATORIO. ISTO POSTO: 1. CONFISSAO DAS RECLAMADAS CONSIDERANDO QUE A PRIMEIRA, SEGUNDA E TERCEIRA RECLAMADAS, REGULARMENTE INTIMADAS DO AJUIZAMENTO DA PRESENTE DEMANDA, CONFORME COMPROVANTE POSTAL DAS FLS. 234 E EDITAIS DAS FLS. 304-307, NAO APRESENTARAM DEFESA NO PRAZO CONSIGNADO, JA TENDO SIDO, INCLUSIVE, DECLARADAS REVEIS, CONSOANTE DECISOES DAS FLS. 289 E 308, APLICO-LHES A PENALIDADE DE CONFISSAO QUANTO A MATERIA DE FATO, NA FORMA DO ART. 844 DA CLT. 2. DA RELACAO HAVIDA ENTRE AS PARTES AFIRMA O RECLAMANTE QUE FOI CONTRATADO PELA PRIMEIRA RECLAMADA EM 01.07.2019, PARA EXERCER A FUNCAO DE CONSULTOR DE VENDAS, SENDO REMUNERADO A TITULO DE COMISSOES NA RAZAO DE 4% SOBRE O VALOR DO CONTRATO DIRETO E 2% NOS MESES SEGUINTES. ALEGA QUE A PARTIR DE 06.09.2019 PASSOU A ATUAR COMO SUPERVISOR, PERCEBENDO 6% SOBRE O VALOR DOS CONTRATOS NO MOMENTO DA CONTRATACAO E 1% NOS MESES SEGUINTES, ALEM DE 1% SOBRE O FATURAMENTO DA EQUIPE (CINCO CONSULTORES SUBORDINADOS). ADUZ QUE EXERCIA SUAS ATRIBUICOES VISITANDO CLIENTES E NO ESCRITORIO DAS RES, ONDE COMPARECIA DE TRES A QUATRO DIAS POR SEMANA, DESTACANDO QUE NAO RECEBE COMISSOES DESDE DEZEMBRO/2019, BEM LOCAL FOI FECHADO EM 21.02.2020, DE MODO QUE DESDE ENTAO NAO RECEBE MAIS INFORMACOES DOS REPRESENTANTES DA EMPRESA, QUE NAO ATENDEM AS LIGACOES OU RESPONDEM AS MENSAGENS DE WHATSAPP. POSTULA O RECONHECIMENTO DA RELACAO DE EMPREGO NO PERIODO, COM CONSEQUENTE ANOTACAO DA CTPS, BEM COMO DA RESCISAO INDIRETA DO CONTRATO DE TRABALHO E PAGAMENTO DAS PARCELAS SALARIAIS E RESCISORIAS CORRESPONDENTES. ANALISO. ASSINADO ELETRONICAMENTE POR: THIAGO BOLDT DE SOUZA - JUNTADO EM: 27/07/2022 15:25:56 - 22A15C3 EM RAZAO DAS PENALIDADES DE REVELIA E CONFISSAO APLICADAS AS RES, TENHO, TAL COMO AFIRMADO NA INICIAL, QUE O AUTOR FOI CONTRATADO PELO PELA PRIMEIRA RECLAMADA, PARA EXERCER A FUNCAO DE CONSULTOR DE VENDAS, BEM COMO QUE NA RELACAO HAVIDA ENTRE AS PARTES ESTAVAM PRESENTES OS REQUISITOS CARACTERIZADORES DA RELACAO DE EMPREGO, QUAIS SEJAM, PESSOALIDADE, ONEROSIDADE, NAO EVENTUALIDADE E SUBORDINACAO. RECONHECO, PORTANTO, O VINCULO EMPREGATICIO ENTRE O AUTOR E A PRIMEIRA RECLAMADA, NO PERIODO COMPREENDIDO ENTRE 01.07.2019 A 21.02.2020 E O EXERCICIO DA FUNCAO DE CONSULTOR DE VENDAS. O MARCO FINAL FIXADO LEVA EM CONSIDERACAO A DATA EM QUE O AUTOR REFERE QUE AS RES ENCERRARAM AS ATIVIDADES NO ESCRITORIO LOCAL E NAO ATENDERAM MAIS SUAS LIGACOES E MENSAGENS, NAO HAVENDO QUALQUER INDICATIVO QUE O AUTOR TENHA PERMANECIDO PRESTADO SERVICOS APOS TAL DATA. PELO CONTRARIO, OS EXTRATOS REVELAM O AUMENTO DE CREDITOS REALIZADOS PELA UBER BRASIL, SENDO PRESUMIVEL, DESTE MODO, QUE O AUTOR PASSOU A DESEMPENHAR TAL ATIVIDADE COM MAIOR INTENSIDADE. QUANTO A REMUNERACAO, MUITO EMBORA O AUTOR SUSTENTE QUE FAZIA JUS A UMA MEDIA DE COMISSOES QUE ALCANCAVAM O MONTANTE MENSAL DE R$ 7.626,00, ANALISANDO O EXTRATO DA SUA CONTA BANCARIA DAS FLS. 59-77, OBSERVO QUE EXISTEM 12 (DOZE) LANCAMENTOS A CREDITO PROVENIENTES DE FORTS C E T EM FINANCAS EIREL E FORTS BANK STARK BANK, TOTALIZANDO O MONTANTE DE R$ 31.787,40, O QUE IMPLICA EM UMA MEDIA MENSAL DE, APROXIMADAMENTE, R$ 4.150,00, CONSIDERANDO A DURACAO DO CONTRATO DE TRABALHO (7 MESES E 21 DIAS). POR FORCA DA PREVISAO CONTIDA NO ART. 29 DA CLT, DEVE A PRIMEIRA RECLAMADA, EM ATE DEZ DIAS DO TRANSITO EM JULGADO DA PRESENTE DECISAO, ANOTAR O CONTRATO DE TRABALHO NA CTPS DO AUTOR, COM ADMISSAO EM 01.07.2019 E DATA DE SAIDA EM 21.02.2020, A REMUNERACAO DE R$ 4.150,00 POR MES E O EXERCICIO DA FUNCAO DE CONSULTOR DE VENDAS. CASO NAO REALIZADA A ANOTACAO PELA RECLAMADA, DEVE A SECRETARIA DA VARA REALIZAR OS RESPECTIVOS REGISTROS. FICA AUTORIZADO O ENCAMINHAMENTO DO BENEFICIO DO SEGURO- DESEMPREGO (CONDICIONADO O RECEBIMENTO AO PREENCHIMENTO DOS DEMAIS REQUISITOS LEGAIS), DEVENDO, PARA TANTO, SER EXPEDIDO O RESPECTIVO ALVARA. 3. RESCISAO INDIRETA - PARCELAS RELATIVAS A EXTINCAO E AO CONTRATO DE TRABALHO CONSIDERANDO QUE NAO HA PROVA DE QUE O AUTOR PEDIU DEMISSAO, E TENDO EM CONTA QUE A PRIMEIRA RE SEQUER FOI LOCALIZADA NOS ENDERECOS INDICADOS ASSINADO ELETRONICAMENTE POR: THIAGO BOLDT DE SOUZA - JUNTADO EM: 27/07/2022 15:25:56 - 22A15C3 COMO SENDO DA SUA SEDE OU ESCRITORIO, RECONHECO A VERACIDADE DOS FATOS NARRADOS NA INICIAL, BEM COMO QUE ENTENDO QUE SE REVELAM SUFICIENTEMENTE ROBUSTOS A PONTO DE AUTORIZAREM A EXTINCAO DO CONTRATO DE TRABALHO POR CULPA DO EMPREGADOR, VEZ QUE A CONDUTA DA RECLAMADA SE ENQUADRA, NO MINIMO, NA DISPOSICAO CONTIDA NO INCISO D DO ART. 483 DA CLT, NA MEDIDA EM QUE A EMPRESA CESSOU SUAS ATIVIDADES SEM AO MENOS PROMOVER A FORMALIZACAO E RESCISAO NORMAL DO CONTRATO DE TRABALHO DO RECLAMANTE. DESTE MODO, RECONHECO RESCISAO INDIRETA DO CONTRATO DE TRABALHO DO AUTOR, COM FUNDAMENTO NA ALINEA D DO ART. 483 DA CLT, COM MARCO FINAL DA PRESTACAO DE SERVICOS EM 21.02.2020, TAL COMO ARBITRADO NO TOPICO ANTERIOR. ASSIM, SAO DEVIDAS AS VERBAS RESCISORIAS PROPRIAS DESTA MODALIDADE DE EXTINCAO CONTRATUAL, OBSERVADAS AS LIMITACOES DO PEDIDO, BEM COMO O PERIODO CONTRATUAL ORA RECONHECIDO. E CREDOR O RECLAMANTE, PORTANTO, DE FERIAS PROPORCIONAIS (9/12) E DECIMOS TERCEIROS SALARIOS PROPORCIONAIS DOS ANOS DE 2019 (6/12) E 2020 (2/12). REGISTRO, POR PERTINENTE, QUE DEIXO DE CONSIDERAR A PROJECAO DO AVISO PREVIO INDENIZADO NA MEDIDA EM QUE O AUTOR SEQUER POSTULA AQUELA PARCELA, VEICULANDO OS PEDIDOS DE FERIAS E DECIMOS TERCEIROS SALARIOS PROPORCIONAIS LEVANDO EM CONTA SOMENTE O ALEGADO PERIODO DE PRESTACAO DE SERVICOS. E DEVIDO O FGTS DO CONTRATO, ACRESCIDO DO ADICIONAL COMPENSATORIO DE 40%. EM RELACAO AO SALDO DE SALARIO E OS SALARIOS EM ATRASO, MUITO EMBORA O AUTOR ALEGUE QUE RECEBEU SUA ULTIMA REMUNERACAO EM DEZEMBRO, REFERENTE A NOVEMBRO/2019, OBSERVO QUE O EXTRATO DA SUA CONTA BANCARIA CONSIGNA QUE PELO MENOS 2 (DOIS) DOS 12 (DOZE) LANCAMENTOS FORAM REALIZADOS NO ANO DE 2020, NO FINAL DE JANEIRO E INICIO DE MARCO, COM CESSACAO DA PRESTACAO DE SERVICOS EM FEVEREIRO DAQUELE ANO, PELO QUE RECONHECO QUE OS SALARIOS DOS MESES DE DEZEMBRO/2019, JANEIRO E FEVEREIRO/2020 FORAM REGULARMENTE ALCANCADOS, RAZAO PORQUE INDEFIRO A PARCELA CORRESPONDENTE. 4. MULTAS DOS ARTIGOS 467 E 477 DA CLT TENDO EM CONTA QUE A PRIMEIRA RE NAO CONTROVERTE O INADIMPLEMENTO DAS VERBAS RESCISORIAS, E DEVIDA A SANCAO PREVISTA NO ART. 467 DA CLT. COM RELACAO A MULTA DO ART. 477,  8, DA CLT, IGUALMENTE, ENTENDO DEVIDA A PARCELA, VEZ QUE NENHUMA VERBA RESCISORIA FOI ALCANCADA DENTRO DO PRAZO PREVISTO NO 6 DO ART. 477 DA CLT. ASSINADO ELETRONICAMENTE POR: THIAGO BOLDT DE SOUZA - JUNTADO EM: 27/07/2022 15:25:56 - 22A15C3 E CREDOR O RECLAMANTE, PORTANTO, DAS MULTAS PREVISTAS NOS ARTIGOS 467 E 477, 8, DA CLT. 5. RESPONSABILIDADE DAS RECLAMADAS ANTE AS PENALIDADES DE REVELIA E CONFISSAO APLICADAS, E CONSIDERANDO QUE PELO MENOS A PRIMEIRA E SEGUNDA RES CONTAM COM SOCIO COMUM (VIDE FLS. 83-84), RECONHECO QUE AS TRES RECLAMADAS INTEGRAM O MESMO GRUPO ECONOMICO, DEVENDO RESPONDER SOLIDARIAMENTE PELOS CREDITOS DEFERIDOS NA PRESENTE DEMANDA, COM FUNDAMENTO NO 2 DO ART. 2 DA CLT. 6. ASSISTENCIA JUDICIARIA GRATUITA E HONORARIOS CONCEDO AO RECLAMANTE, COM FULCRO NO ART. 790, 3, DA CLT, O BENEFICIO DA ASSISTENCIA JUDICIARIA GRATUITA. EM RELACAO AOS HONORARIOS, EM ATENCAO DO DISPOSTO NO ARTIGO 791-A DA CLT, DE ACORDO COM A ALTERACAO PROCESSUAL PROMOVIDA PELA LEI N 13.467 /2017, VIGENTE AO TEMPO DO AJUIZAMENTO DA PRESENTE DEMANDA, CONDENO AS RECLAMADAS, OBSERVADA A SOLIDARIEDADE ORA RECONHECIDA, A PAGAR HONORARIOS ADVOCATICIOS SUCUMBENCIAIS EM FAVOR DO ADVOGADO DA PARTE AUTORA DE 15% SOBRE O VALOR DA CONDENACAO, A SER APURADO EM LIQUIDACAO DE SENTENCA, OBSERVANDO-SE O ENTENDIMENTO CONSAGRADO NA SUMULA N 37 DO TRIBUNAL REGIONAL DO TRABALHO 4 REGIAO. 7. JUROS E CORRECAO MONETARIA JUROS E CORRECAO MONETARIA NA FORMA DA LEI, OBSERVADOS OS CRITERIOS VIGENTES A EPOCA DA LIQUIDACAO DO TITULO EXECUTIVO JUDICIAL, MOMENTO OPORTUNO PARA RESPECTIVA DEFINICAO. 1. 8. RECOLHIMENTOS PREVIDENCIARIOS E FISCAIS ASSINADO ELETRONICAMENTE POR: THIAGO BOLDT DE SOUZA - JUNTADO EM: 27/07/2022 15:25:56 - 22A15C3 POR FORCA DA PREVISAO CONTIDA NOS ARTIGOS 46 DA LEI 8.541/92 E ART. 28 DA LEI 8.212/91, DETERMINO QUE A PARTE RECLAMADA PROCEDA A RETENCAO DOS DESCONTOS FISCAIS E PREVIDENCIARIOS, OBSERVADAS, QUANTO A ESTES, AS COTAS RECLAMANTE /RECLAMADA. COM RELACAO AO IMPOSTO DE RENDA, ESTE DEVERA INCIDIR SOBRE O VALOR TRIBUTAVEL ATUALIZADO, EXCLUIDOS OS JUROS DE MORA, DEVENDO SER OBSERVADO PARA O CALCULO O REGIME DE COMPETENCIA (TRIBUTACAO MES A MES, OBSERVADAS AS ALIQUOTAS, LIMITES E ISENCOES VIGENTES NAS EPOCAS PROPRIAS DA INCIDENCIA TRIBUTARIA). A RESPONSABILIDADE PELOS TRIBUTOS ACIMA REFERIDOS DECORRE DE EXPRESSA PREVISAO LEGAL, SENDO INDEVIDA QUALQUER INDENIZACAO COMPENSATORIA. NESSE SENTIDO, INCLUSIVE, E O ENTENDIMENTO CONSAGRADO NA ORIENTACAO JURISPRUDENCIAL 363 DA SBDI-1 DO TRIBUNAL SUPERIOR DO TRABALHO. DISPOSITIVO ANTE O EXPOSTO, NOS TERMOS DA FUNDAMENTACAO, JULGO PROCEDENTE EM PARTE A ACAO MOVIDA POR RALPH EMERSON GOMEZ EM FACE DE FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA, E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI  ME E ARENA FOMENTO MERCANTIL LTDA. RECONHECO A EXISTENCIA DE VINCULO EMPREGATICIO ENTRE O RECLAMANTE E A PRIMEIRA RECLAMADA DE 01.07.2019 ATE 21.02.2020 E CONDENO AS RECLAMADAS, SOLIDARIAMENTE, A PAGAREM AO RECLAMANTE AS SEGUINTES VERBAS: A) FERIAS PROPORCIONAIS (9/12); B) DECIMOS TERCEIROS SALARIOS PROPORCIONAIS DOS ANOS DE 2019 (6 /12) E 2020 (2/12); C) FGTS DO CONTRATO, ACRESCIDO DO ADICIONAL COMPENSATORIO DE 40%; D) MULTA DO ART. 467 DA CLT; ASSINADO ELETRONICAMENTE POR: THIAGO BOLDT DE SOUZA - JUNTADO EM: 27/07/2022 15:25:56 - 22A15C3 E) MULTA DO ART. 477,  8, DA CLT. OS VALORES SERAO APURADOS EM LIQUIDACAO DE SENTENCA, ACRESCIDOS DE JUROS E CORRECAO MONETARIA, OBSERVADA A LIMITACAO EM RELACAO A QUANTIA POSTULADA NA PETICAO INICIAL. AS RECLAMADAS PAGARAO CUSTAS DE R$ 400,00, COMPLEMENTAVEIS AO FINAL, CALCULADAS SOBRE O VALOR BRUTO DA CONDENACAO, QUE ORA ARBITRO EM R$ 20.000,00. EM ATENCAO AO DISPOSTO NO 3 DO ART. 832 DA CLT, ACRESCIDO PELA LEI N 10.035, DE 25.10.2000, DECLARO QUE A CONDENACAO DA ALINEA B DO PRESENTE DISPOSITIVO POSSUI NATUREZA SALARIAL. CONDENO AS RECLAMADAS, NA FORMA DO DISPOSTO NO ART. 791-A DA CLT E OBSERVADA A SOLIDARIEDADE ORA DEFINIDA, A PAGAR HONORARIOS ADVOCATICIOS SUCUMBENCIAIS EM FAVOR DO ADVOGADO DA PARTE AUTORA DE 15% SOBRE O VALOR DA CONDENACAO, A SER APURADO EM LIQUIDACAO DE SENTENCA, OBSERVANDO-SE O ENTENDIMENTO CONSAGRADO NA SUMULA N 37 DO TRIBUNAL REGIONAL DO TRABALHO 4 REGIAO. POR FORCA DA PREVISAO CONTIDA NO ART. 29 DA CLT, DEVE A PRIMEIRA RECLAMADA, EM ATE DEZ DIAS DO TRANSITO EM JULGADO DA PRESENTE DECISAO, ANOTAR O CONTRATO DE TRABALHO NA CTPS DO AUTOR, COM ADMISSAO EM 01.07.2019 E DATA DE SAIDA EM 21.02.2020, A REMUNERACAO DE R$ 4.150,00 POR MES E O EXERCICIO DA FUNCAO DE CONSULTOR DE VENDAS. CASO NAO REALIZADA A ANOTACAO PELA RECLAMADA, DEVE A SECRETARIA DA VARA REALIZAR OS RESPECTIVOS REGISTROS. INTIMEM-SE AS PARTES. DISPENSADA A INTIMACAO DA UNIAO, NA FORMA DO PROVIMENTO CONJUNTO 12/2013 DO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO. APOS O TRANSITO EM JULGADO, EXPECA-SE O ALVARA PARA O ENCAMINHAMENTO DO SEGURO-DESEMPREGO E CUMPRA-SE. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO ASSINADO ELETRONICAMENTE POR: THIAGO BOLDT DE SOUZA - JUNTADO EM: 27/07/2022 15:25:56 - 22A15C3 NOVO HAMBURGO/RS, 27 DE JULHO DE 2022. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2022-07-27T15:25:57",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA JULGAMENTO PROFERIR SENTENCA A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2022-05-11T11:51:13",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA JULGAMENTO PROFERIR SENTENCA A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2022-05-11T11:51:13",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "JUNTADA A PETICAO DE RAZOES FINAIS (RAZOES FINAIS)",
                "PublishDate": "2022-05-10T16:28:46",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "JUNTADA A PETICAO DE RAZOES FINAIS (RAZOES FINAIS)",
                "PublishDate": "2022-05-10T16:28:46",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "JUNTADA A PETICAO DE RAZOES FINAIS (RAZOES FINAIS)",
                "PublishDate": "2022-05-10T16:28:00",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "JUNTADA A PETICAO DE RAZOES FINAIS (RAZOES FINAIS)",
                "PublishDate": "2022-05-10T16:28:00",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "JUNTADA A PETICAO DE RAZOES FINAIS (RAZOES FINAIS)",
                "PublishDate": "2022-05-10T16:26:48",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "JUNTADA A PETICAO DE RAZOES FINAIS (RAZOES FINAIS)",
                "PublishDate": "2022-05-10T16:26:48",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 04/05/2022",
                "PublishDate": "2022-05-04T01:28:31",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2022-05-04T01:28:31",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 04/05/2022",
                "PublishDate": "2022-05-04T01:28:31",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2022-05-04T01:28:31",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2022-05-03T15:37:31",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2022-05-03T15:37:31",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2022-05-03T15:36:31",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (3) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS AO EXMO. MAGISTRADO. NOVO HAMBURGO, 03 DE MAIO DE 2022. ANDRESSA TRIERWEILER VISTOS OS AUTOS. INDEFIRO A PROVA ORAL REQUERIDA PELO AUTOR, PORQUE DESNECESSARIA AO DESLINDE DO FEITO. CONCEDO AO RECLAMANTE PRAZO DE CINCO DIAS PARA APRESENTACAO DE MEMORIAIS. APOS, VENHAM OS AUTOS CONCLUSOS PARA JULGAMENTO. NOVO HAMBURGO/RS, 03 DE MAIO DE 2022. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2022-05-03T15:36:31",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2022-05-03T15:36:31",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (3) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS AO EXMO. MAGISTRADO. NOVO HAMBURGO, 03 DE MAIO DE 2022. ANDRESSA TRIERWEILER VISTOS OS AUTOS. INDEFIRO A PROVA ORAL REQUERIDA PELO AUTOR, PORQUE DESNECESSARIA AO DESLINDE DO FEITO. CONCEDO AO RECLAMANTE PRAZO DE CINCO DIAS PARA APRESENTACAO DE MEMORIAIS. APOS, VENHAM OS AUTOS CONCLUSOS PARA JULGAMENTO. NOVO HAMBURGO/RS, 03 DE MAIO DE 2022. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2022-05-03T15:36:31",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "PROCESSO N ATORD-0020269-90.2020.5.04.0303 RECLAMANTE RALPH EMERSON GOMEZ ADVOGADO VINICIUS LEIPNITZ DA SILVA(OAB: 101515/RS) RECLAMADO ARENA FOMENTO MERCANTIL LTDA RECLAMADO E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME RECLAMADO FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. INTIMADO(S)/CITADO(S): - RALPH EMERSON GOMEZ PODER JUDICIARIO JUSTICA DO INTIMACAO FICA V. SA. INTIMADO PARA TOMAR CIENCIA DO DESPACHO ID 561AB7D PROFERIDO NOS AUTOS. TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS AO EXMO. MAGISTRADO. NOVO HAMBURGO, 03 DE MAIO DE 2022. ANDRESSA TRIERWEILER VISTOS OS AUTOS. INDEFIRO A PROVA ORAL REQUERIDA PELO AUTOR, PORQUE DESNECESSARIA AO DESLINDE DO FEITO. CONCEDO AO RECLAMANTE PRAZO DE CINCO DIAS PARA APRESENTACAO DE MEMORIAIS. APOS, VENHAM OS AUTOS CONCLUSOS PARA JULGAMENTO. NOVO HAMBURGO/RS, 03 DE MAIO DE 2022. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2022-05-03T00:00:00",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 28/04/2022",
                "PublishDate": "2022-04-29T00:09:46",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 28/04/2022",
                "PublishDate": "2022-04-29T00:09:46",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2022-04-28T16:12:26",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2022-04-28T16:12:26",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (PETICAO - PROVAS)",
                "PublishDate": "2022-04-28T09:50:28",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (PETICAO - PROVAS)",
                "PublishDate": "2022-04-28T09:50:28",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 20/04/2022",
                "PublishDate": "2022-04-20T01:37:19",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2022-04-20T01:37:19",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 20/04/2022",
                "PublishDate": "2022-04-20T01:37:19",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2022-04-20T01:37:19",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 20/04/2022",
                "PublishDate": "2022-04-20T01:37:19",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2022-04-20T01:37:19",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2022-04-19T10:41:29",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2022-04-19T10:41:29",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2022-04-19T10:41:29",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2022-04-19T10:40:28",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (3) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 31 DE MARCO DE 2022. RODRIGO PFUTZ VISTOS OS AUTOS. DECRETO A REVELIA DAS RECLAMADAS FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME., UMA VEZ QUE DEIXARAM DE CONTESTAR A ACAO, NO PRAZO DOS EDITAIS DOS ID'S 54186CF E B3F4580. INTIME-SE O AUTOR PARA INFORMAR SE POSSUI OUTRAS A PRODUZIR, NO PRAZO DE 05 DIAS (ESPECIFICANDO-AS, EM CASO POSITIVO), PODENDO, SE A RESPOSTA FOR NEGATIVA, ADUZIR RAZOES FINAIS, VINDO ENTAO OS AUTOS CONCLUSOS PARA JULGAMENTO. DECORRIDO O PRAZO SEM MANIFESTACAO, PRESUMIR-SE-A QUE AS RAZOES FINAIS SERAO REMISSIVAS, DEVENDO OS AUTOS VIR CONCLUSOS PARA JULGAMENTO. NOVO HAMBURGO/RS, 19 DE ABRIL DE 2022. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2022-04-19T10:40:28",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2022-04-19T10:40:28",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (3) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 31 DE MARCO DE 2022. RODRIGO PFUTZ VISTOS OS AUTOS. DECRETO A REVELIA DAS RECLAMADAS FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME., UMA VEZ QUE DEIXARAM DE CONTESTAR A ACAO, NO PRAZO DOS EDITAIS DOS ID'S 54186CF E B3F4580. INTIME-SE O AUTOR PARA INFORMAR SE POSSUI OUTRAS A PRODUZIR, NO PRAZO DE 05 DIAS (ESPECIFICANDO-AS, EM CASO POSITIVO), PODENDO, SE A RESPOSTA FOR NEGATIVA, ADUZIR RAZOES FINAIS, VINDO ENTAO OS AUTOS CONCLUSOS PARA JULGAMENTO. DECORRIDO O PRAZO SEM MANIFESTACAO, PRESUMIR-SE-A QUE AS RAZOES FINAIS SERAO REMISSIVAS, DEVENDO OS AUTOS VIR CONCLUSOS PARA JULGAMENTO. NOVO HAMBURGO/RS, 19 DE ABRIL DE 2022. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2022-04-19T10:40:28",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2022-04-19T10:40:28",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (3) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 31 DE MARCO DE 2022. RODRIGO PFUTZ VISTOS OS AUTOS. DECRETO A REVELIA DAS RECLAMADAS FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME., UMA VEZ QUE DEIXARAM DE CONTESTAR A ACAO, NO PRAZO DOS EDITAIS DOS ID'S 54186CF E B3F4580. INTIME-SE O AUTOR PARA INFORMAR SE POSSUI OUTRAS A PRODUZIR, NO PRAZO DE 05 DIAS (ESPECIFICANDO-AS, EM CASO POSITIVO), PODENDO, SE A RESPOSTA FOR NEGATIVA, ADUZIR RAZOES FINAIS, VINDO ENTAO OS AUTOS CONCLUSOS PARA JULGAMENTO. DECORRIDO O PRAZO SEM MANIFESTACAO, PRESUMIR-SE-A QUE AS RAZOES FINAIS SERAO REMISSIVAS, DEVENDO OS AUTOS VIR CONCLUSOS PARA JULGAMENTO. NOVO HAMBURGO/RS, 19 DE ABRIL DE 2022. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2022-04-19T10:40:28",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "PROCESSO N ATORD-0020269-90.2020.5.04.0303 RECLAMANTE RALPH EMERSON GOMEZ ADVOGADO VINICIUS LEIPNITZ DA SILVA(OAB: 101515/RS) RECLAMADO ARENA FOMENTO MERCANTIL LTDA RECLAMADO E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME RECLAMADO FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. INTIMADO(S)/CITADO(S): - RALPH EMERSON GOMEZ PODER JUDICIARIO JUSTICA DO INTIMACAO FICA V. SA. INTIMADO PARA TOMAR CIENCIA DO DESPACHO ID 49CA86C PROFERIDO NOS AUTOS. TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 31 DE MARCO DE 2022. RODRIGO PFUTZ VISTOS OS AUTOS. DECRETO A REVELIA DAS RECLAMADAS FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME., UMA VEZ QUE DEIXARAM DE CONTESTAR A ACAO, NO PRAZO DOS EDITAIS DOS ID'S 54186CF E B3F4580. INTIME-SE O AUTOR PARA INFORMAR SE POSSUI OUTRAS A PRODUZIR, NO PRAZO DE 05 DIAS (ESPECIFICANDO-AS, EM CASO POSITIVO), PODENDO, SE A RESPOSTA FOR NEGATIVA, ADUZIR RAZOES FINAIS, VINDO ENTAO OS AUTOS CONCLUSOS PARA JULGAMENTO. DECORRIDO O PRAZO SEM MANIFESTACAO, PRESUMIR-SE-A QUE AS RAZOES FINAIS SERAO REMISSIVAS, DEVENDO OS AUTOS VIR CONCLUSOS PARA JULGAMENTO. NOVO HAMBURGO/RS, 19 DE ABRIL DE 2022. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2022-04-19T00:00:00",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2022-03-21T14:25:10",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2022-03-21T14:25:10",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2022-03-21T14:25:10",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DECORRIDO O PRAZO DE E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME EM 11/03/2022",
                "PublishDate": "2022-03-12T00:01:11",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "DECORRIDO O PRAZO DE FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. EM 11/03/2022",
                "PublishDate": "2022-03-12T00:01:11",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "DECORRIDO O PRAZO DE E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME EM 11/03/2022",
                "PublishDate": "2022-03-12T00:01:11",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DECORRIDO O PRAZO DE FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. EM 11/03/2022",
                "PublishDate": "2022-03-12T00:01:11",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DECORRIDO O PRAZO DE E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME EM 11/03/2022",
                "PublishDate": "2022-03-12T00:01:11",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DECORRIDO O PRAZO DE FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. EM 11/03/2022",
                "PublishDate": "2022-03-12T00:01:11",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DECORRIDO O PRAZO DE STARK BANK S.A. EM 28/01/2022",
                "PublishDate": "2022-01-29T01:00:13",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 28/01/2022",
                "PublishDate": "2022-01-29T01:00:13",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "DECORRIDO O PRAZO DE STARK BANK S.A. EM 28/01/2022",
                "PublishDate": "2022-01-29T01:00:13",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 28/01/2022",
                "PublishDate": "2022-01-29T01:00:13",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DECORRIDO O PRAZO DE STARK BANK S.A. EM 28/01/2022",
                "PublishDate": "2022-01-29T01:00:13",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 28/01/2022",
                "PublishDate": "2022-01-29T01:00:13",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "PUBLICADO(A) O(A) EDITAL EM 16/12/2021",
                "PublishDate": "2021-12-16T01:36:11",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) EDITAL NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-12-16T01:36:11",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "PUBLICADO(A) O(A) EDITAL EM 16/12/2021",
                "PublishDate": "2021-12-16T01:36:11",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) EDITAL NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-12-16T01:36:11",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "PUBLICADO(A) O(A) EDITAL EM 16/12/2021",
                "PublishDate": "2021-12-16T01:36:11",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) EDITAL NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-12-16T01:36:11",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "PUBLICADO(A) O(A) EDITAL EM 16/12/2021",
                "PublishDate": "2021-12-16T01:36:11",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) EDITAL NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-12-16T01:36:11",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "PUBLICADO(A) O(A) EDITAL EM 16/12/2021",
                "PublishDate": "2021-12-16T01:36:11",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) EDITAL NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-12-16T01:36:11",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "PUBLICADO(A) O(A) EDITAL EM 16/12/2021",
                "PublishDate": "2021-12-16T01:36:11",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) EDITAL NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-12-16T01:36:11",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "PUBLICADO(A) O(A) EDITAL EM 16/12/2021",
                "PublishDate": "2021-12-16T01:36:11",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) EDITAL NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-12-16T01:36:11",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "PUBLICADO(A) O(A) EDITAL EM 16/12/2021",
                "PublishDate": "2021-12-16T01:36:11",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) EDITAL NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-12-16T01:36:11",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "EXPEDIDO(A) EDITAL A(O) E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME",
                "PublishDate": "2021-12-15T10:56:47",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "EXPEDIDO(A) EDITAL A(O) FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA.",
                "PublishDate": "2021-12-15T10:56:47",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "EXPEDIDO(A) EDITAL A(O) E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME",
                "PublishDate": "2021-12-15T10:56:47",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "EXPEDIDO(A) EDITAL A(O) FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA.",
                "PublishDate": "2021-12-15T10:56:47",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "EXPEDIDO(A) EDITAL A(O) E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME",
                "PublishDate": "2021-12-15T10:56:47",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "EXPEDIDO(A) EDITAL A(O) FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA.",
                "PublishDate": "2021-12-15T10:56:47",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "EXPEDIDO(A) EDITAL A(O) E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME",
                "PublishDate": "2021-12-15T10:56:47",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "EXPEDIDO(A) EDITAL A(O) FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA.",
                "PublishDate": "2021-12-15T10:56:47",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2021-12-14T14:35:25",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (3) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS AO EXMO. MAGISTRADO. NOVO HAMBURGO, 14 DE DEZEMBRO DE 2021. ANDRESSA TRIERWEILER VISTOS OS AUTOS. CITEM-SE AS DUAS PRIMEIRAS RECLAMADAS POR EDITAL. NOVO HAMBURGO/RS, 14 DE DEZEMBRO DE 2021. ANDRE VASCONCELLOS VIEIRA JUIZ DO TRABALHO TITULAR",
                "PublishDate": "2021-12-14T14:35:25",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2021-12-14T14:35:25",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (3) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS AO EXMO. MAGISTRADO. NOVO HAMBURGO, 14 DE DEZEMBRO DE 2021. ANDRESSA TRIERWEILER VISTOS OS AUTOS. CITEM-SE AS DUAS PRIMEIRAS RECLAMADAS POR EDITAL. NOVO HAMBURGO/RS, 14 DE DEZEMBRO DE 2021. ANDRE VASCONCELLOS VIEIRA JUIZ DO TRABALHO TITULAR",
                "PublishDate": "2021-12-14T14:35:25",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2021-12-14T14:35:25",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (3) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS AO EXMO. MAGISTRADO. NOVO HAMBURGO, 14 DE DEZEMBRO DE 2021. ANDRESSA TRIERWEILER VISTOS OS AUTOS. CITEM-SE AS DUAS PRIMEIRAS RECLAMADAS POR EDITAL. NOVO HAMBURGO/RS, 14 DE DEZEMBRO DE 2021. ANDRE VASCONCELLOS VIEIRA JUIZ DO TRABALHO TITULAR",
                "PublishDate": "2021-12-14T14:35:25",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2021-12-14T14:35:25",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (3) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS AO EXMO. MAGISTRADO. NOVO HAMBURGO, 14 DE DEZEMBRO DE 2021. ANDRESSA TRIERWEILER VISTOS OS AUTOS. CITEM-SE AS DUAS PRIMEIRAS RECLAMADAS POR EDITAL. NOVO HAMBURGO/RS, 14 DE DEZEMBRO DE 2021. ANDRE VASCONCELLOS VIEIRA JUIZ DO TRABALHO TITULAR",
                "PublishDate": "2021-12-14T14:35:25",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A ANDRE VASCONCELLOS VIEIRA",
                "PublishDate": "2021-12-14T14:26:05",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A ANDRE VASCONCELLOS VIEIRA",
                "PublishDate": "2021-12-14T14:26:05",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A ANDRE VASCONCELLOS VIEIRA",
                "PublishDate": "2021-12-14T14:26:05",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A ANDRE VASCONCELLOS VIEIRA",
                "PublishDate": "2021-12-14T14:26:05",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (PETICAO CITACAO POR EDITAL)",
                "PublishDate": "2021-12-14T13:51:30",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (PETICAO CITACAO POR EDITAL)",
                "PublishDate": "2021-12-14T13:51:30",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (PETICAO CITACAO POR EDITAL)",
                "PublishDate": "2021-12-14T13:51:30",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (PETICAO CITACAO POR EDITAL)",
                "PublishDate": "2021-12-14T13:51:30",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 03/12/2021",
                "PublishDate": "2021-12-03T01:31:20",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-12-03T01:31:20",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 03/12/2021",
                "PublishDate": "2021-12-03T01:31:20",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-12-03T01:31:20",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 03/12/2021",
                "PublishDate": "2021-12-03T01:31:20",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-12-03T01:31:20",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 03/12/2021",
                "PublishDate": "2021-12-03T01:31:20",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-12-03T01:31:20",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 03/12/2021",
                "PublishDate": "2021-12-03T01:31:20",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-12-03T01:31:20",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 03/12/2021",
                "PublishDate": "2021-12-03T01:31:20",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-12-03T01:31:20",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 03/12/2021",
                "PublishDate": "2021-12-03T01:31:20",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-12-03T01:31:20",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 03/12/2021",
                "PublishDate": "2021-12-03T01:31:20",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-12-03T01:31:20",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 03/12/2021",
                "PublishDate": "2021-12-03T01:31:20",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-12-03T01:31:20",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 03/12/2021",
                "PublishDate": "2021-12-03T01:31:20",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-12-03T01:31:20",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2021-12-02T15:01:36",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) STARK BANK S.A.",
                "PublishDate": "2021-12-02T15:01:36",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2021-12-02T15:01:36",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) STARK BANK S.A.",
                "PublishDate": "2021-12-02T15:01:36",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2021-12-02T15:01:36",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) STARK BANK S.A.",
                "PublishDate": "2021-12-02T15:01:36",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) STARK BANK S.A.",
                "PublishDate": "2021-12-02T15:01:36",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2021-12-02T15:01:36",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2021-12-02T15:01:36",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) STARK BANK S.A.",
                "PublishDate": "2021-12-02T15:01:36",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2021-12-02T15:00:36",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS AO EXMO. MAGISTRADO. NOVO HAMBURGO, 02 DE DEZEMBRO DE 2021. ANDRESSA TRIERWEILER VISTOS OS AUTOS. A RECLAMADA ARENA FOMENTO MERCANTIL LTDA. FOI CITADA EM 12/06 /2020 (DOCUMENTO ID ID. C1BB3F6 - PAG. 1, FOLHA 188 DO PDF). ASSIM, NAO TENDO APRESENTADO DEFESA, DECRETO A SUA REVELIA. ADEMAIS, CONSIDERANDO A CONCORDANCIA DO AUTOR COM A PRELIMINAR DE ILEGITIMIDADE PASSIVA ARGUIDA PELA RECLAMADA STAR BANK SA (PETICAO ID F8D53F6 - PAG. 1), EXTINGO O FEITO SEM RESOLUCAO DE MERITO QUANTO A ESTA RECLAMADA, NOS TERMOS DO ART. 485, INC. VI, DO CPC. CONSIDERANDO, AINDA, QUE AS DUAS PRIMEIRAS RECLAMADAS NOVAMENTE NAO FORAM CITADAS NOS ENDERECOS FORNECIDOS PELO AUTOR, O QUE E INDICADO PELOS ARS QUE CONSTAM NOS IDS D0D2C1F E 098C96D, DEVERA O RECLAMANTE INFORMAR MEIOS QUE VIABILIZEM A SUA CITACAO, OU REQUERER O QUE ENTENDER DE DIREITO, NO PRAZO DE 15 DIAS, SOB PENA DE EXTINCAO DO PROCESSO SEM RESOLUCAO DE MERITO QUANTO A ESSAS RECLAMADAS. INTIMEM-SE E, APOS, EXCLUA-SE A RECLAMADA STAR BANK SA DO POLO PASSIVO. NOVO HAMBURGO/RS, 02 DE DEZEMBRO DE 2021. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2021-12-02T15:00:36",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2021-12-02T15:00:36",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS AO EXMO. MAGISTRADO. NOVO HAMBURGO, 02 DE DEZEMBRO DE 2021. ANDRESSA TRIERWEILER VISTOS OS AUTOS. A RECLAMADA ARENA FOMENTO MERCANTIL LTDA. FOI CITADA EM 12/06 /2020 (DOCUMENTO ID ID. C1BB3F6 - PAG. 1, FOLHA 188 DO PDF). ASSIM, NAO TENDO APRESENTADO DEFESA, DECRETO A SUA REVELIA. ADEMAIS, CONSIDERANDO A CONCORDANCIA DO AUTOR COM A PRELIMINAR DE ILEGITIMIDADE PASSIVA ARGUIDA PELA RECLAMADA STAR BANK SA (PETICAO ID F8D53F6 - PAG. 1), EXTINGO O FEITO SEM RESOLUCAO DE MERITO QUANTO A ESTA RECLAMADA, NOS TERMOS DO ART. 485, INC. VI, DO CPC. CONSIDERANDO, AINDA, QUE AS DUAS PRIMEIRAS RECLAMADAS NOVAMENTE NAO FORAM CITADAS NOS ENDERECOS FORNECIDOS PELO AUTOR, O QUE E INDICADO PELOS ARS QUE CONSTAM NOS IDS D0D2C1F E 098C96D, DEVERA O RECLAMANTE INFORMAR MEIOS QUE VIABILIZEM A SUA CITACAO, OU REQUERER O QUE ENTENDER DE DIREITO, NO PRAZO DE 15 DIAS, SOB PENA DE EXTINCAO DO PROCESSO SEM RESOLUCAO DE MERITO QUANTO A ESSAS RECLAMADAS. INTIMEM-SE E, APOS, EXCLUA-SE A RECLAMADA STAR BANK SA DO POLO PASSIVO. NOVO HAMBURGO/RS, 02 DE DEZEMBRO DE 2021. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2021-12-02T15:00:36",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2021-12-02T15:00:36",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS AO EXMO. MAGISTRADO. NOVO HAMBURGO, 02 DE DEZEMBRO DE 2021. ANDRESSA TRIERWEILER VISTOS OS AUTOS. A RECLAMADA ARENA FOMENTO MERCANTIL LTDA. FOI CITADA EM 12/06 /2020 (DOCUMENTO ID ID. C1BB3F6 - PAG. 1, FOLHA 188 DO PDF). ASSIM, NAO TENDO APRESENTADO DEFESA, DECRETO A SUA REVELIA. ADEMAIS, CONSIDERANDO A CONCORDANCIA DO AUTOR COM A PRELIMINAR DE ILEGITIMIDADE PASSIVA ARGUIDA PELA RECLAMADA STAR BANK SA (PETICAO ID F8D53F6 - PAG. 1), EXTINGO O FEITO SEM RESOLUCAO DE MERITO QUANTO A ESTA RECLAMADA, NOS TERMOS DO ART. 485, INC. VI, DO CPC. CONSIDERANDO, AINDA, QUE AS DUAS PRIMEIRAS RECLAMADAS NOVAMENTE NAO FORAM CITADAS NOS ENDERECOS FORNECIDOS PELO AUTOR, O QUE E INDICADO PELOS ARS QUE CONSTAM NOS IDS D0D2C1F E 098C96D, DEVERA O RECLAMANTE INFORMAR MEIOS QUE VIABILIZEM A SUA CITACAO, OU REQUERER O QUE ENTENDER DE DIREITO, NO PRAZO DE 15 DIAS, SOB PENA DE EXTINCAO DO PROCESSO SEM RESOLUCAO DE MERITO QUANTO A ESSAS RECLAMADAS. INTIMEM-SE E, APOS, EXCLUA-SE A RECLAMADA STAR BANK SA DO POLO PASSIVO. NOVO HAMBURGO/RS, 02 DE DEZEMBRO DE 2021. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2021-12-02T15:00:36",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2021-12-02T15:00:36",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS AO EXMO. MAGISTRADO. NOVO HAMBURGO, 02 DE DEZEMBRO DE 2021. ANDRESSA TRIERWEILER VISTOS OS AUTOS. A RECLAMADA ARENA FOMENTO MERCANTIL LTDA. FOI CITADA EM 12/06 /2020 (DOCUMENTO ID ID. C1BB3F6 - PAG. 1, FOLHA 188 DO PDF). ASSIM, NAO TENDO APRESENTADO DEFESA, DECRETO A SUA REVELIA. ADEMAIS, CONSIDERANDO A CONCORDANCIA DO AUTOR COM A PRELIMINAR DE ILEGITIMIDADE PASSIVA ARGUIDA PELA RECLAMADA STAR BANK SA (PETICAO ID F8D53F6 - PAG. 1), EXTINGO O FEITO SEM RESOLUCAO DE MERITO QUANTO A ESTA RECLAMADA, NOS TERMOS DO ART. 485, INC. VI, DO CPC. CONSIDERANDO, AINDA, QUE AS DUAS PRIMEIRAS RECLAMADAS NOVAMENTE NAO FORAM CITADAS NOS ENDERECOS FORNECIDOS PELO AUTOR, O QUE E INDICADO PELOS ARS QUE CONSTAM NOS IDS D0D2C1F E 098C96D, DEVERA O RECLAMANTE INFORMAR MEIOS QUE VIABILIZEM A SUA CITACAO, OU REQUERER O QUE ENTENDER DE DIREITO, NO PRAZO DE 15 DIAS, SOB PENA DE EXTINCAO DO PROCESSO SEM RESOLUCAO DE MERITO QUANTO A ESSAS RECLAMADAS. INTIMEM-SE E, APOS, EXCLUA-SE A RECLAMADA STAR BANK SA DO POLO PASSIVO. NOVO HAMBURGO/RS, 02 DE DEZEMBRO DE 2021. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2021-12-02T15:00:36",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2021-12-02T15:00:36",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS AO EXMO. MAGISTRADO. NOVO HAMBURGO, 02 DE DEZEMBRO DE 2021. ANDRESSA TRIERWEILER VISTOS OS AUTOS. A RECLAMADA ARENA FOMENTO MERCANTIL LTDA. FOI CITADA EM 12/06 /2020 (DOCUMENTO ID ID. C1BB3F6 - PAG. 1, FOLHA 188 DO PDF). ASSIM, NAO TENDO APRESENTADO DEFESA, DECRETO A SUA REVELIA. ADEMAIS, CONSIDERANDO A CONCORDANCIA DO AUTOR COM A PRELIMINAR DE ILEGITIMIDADE PASSIVA ARGUIDA PELA RECLAMADA STAR BANK SA (PETICAO ID F8D53F6 - PAG. 1), EXTINGO O FEITO SEM RESOLUCAO DE MERITO QUANTO A ESTA RECLAMADA, NOS TERMOS DO ART. 485, INC. VI, DO CPC. CONSIDERANDO, AINDA, QUE AS DUAS PRIMEIRAS RECLAMADAS NOVAMENTE NAO FORAM CITADAS NOS ENDERECOS FORNECIDOS PELO AUTOR, O QUE E INDICADO PELOS ARS QUE CONSTAM NOS IDS D0D2C1F E 098C96D, DEVERA O RECLAMANTE INFORMAR MEIOS QUE VIABILIZEM A SUA CITACAO, OU REQUERER O QUE ENTENDER DE DIREITO, NO PRAZO DE 15 DIAS, SOB PENA DE EXTINCAO DO PROCESSO SEM RESOLUCAO DE MERITO QUANTO A ESSAS RECLAMADAS. INTIMEM-SE E, APOS, EXCLUA-SE A RECLAMADA STAR BANK SA DO POLO PASSIVO. NOVO HAMBURGO/RS, 02 DE DEZEMBRO DE 2021. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2021-12-02T15:00:36",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2021-12-01T10:04:52",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2021-12-01T10:04:52",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2021-12-01T10:04:52",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2021-12-01T10:04:52",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2021-12-01T10:04:52",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DECORRIDO O PRAZO DE E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME EM 25/11/2021",
                "PublishDate": "2021-11-26T00:01:48",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "DECORRIDO O PRAZO DE FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. EM 25/11/2021",
                "PublishDate": "2021-11-26T00:01:48",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "DECORRIDO O PRAZO DE E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME EM 25/11/2021",
                "PublishDate": "2021-11-26T00:01:48",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "DECORRIDO O PRAZO DE FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. EM 25/11/2021",
                "PublishDate": "2021-11-26T00:01:48",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "DECORRIDO O PRAZO DE E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME EM 25/11/2021",
                "PublishDate": "2021-11-26T00:01:48",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "DECORRIDO O PRAZO DE FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. EM 25/11/2021",
                "PublishDate": "2021-11-26T00:01:48",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "DECORRIDO O PRAZO DE E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME EM 25/11/2021",
                "PublishDate": "2021-11-26T00:01:48",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DECORRIDO O PRAZO DE FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. EM 25/11/2021",
                "PublishDate": "2021-11-26T00:01:48",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DECORRIDO O PRAZO DE E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME EM 25/11/2021",
                "PublishDate": "2021-11-26T00:01:48",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DECORRIDO O PRAZO DE FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. EM 25/11/2021",
                "PublishDate": "2021-11-26T00:01:48",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DECORRIDO O PRAZO DE STARK BANK S.A. EM 05/11/2021",
                "PublishDate": "2021-11-06T00:39:33",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "DECORRIDO O PRAZO DE STARK BANK S.A. EM 05/11/2021",
                "PublishDate": "2021-11-06T00:39:33",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "DECORRIDO O PRAZO DE STARK BANK S.A. EM 05/11/2021",
                "PublishDate": "2021-11-06T00:39:33",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "DECORRIDO O PRAZO DE STARK BANK S.A. EM 05/11/2021",
                "PublishDate": "2021-11-06T00:39:33",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DECORRIDO O PRAZO DE STARK BANK S.A. EM 05/11/2021",
                "PublishDate": "2021-11-06T00:39:33",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 04/11/2021",
                "PublishDate": "2021-11-05T00:03:14",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 04/11/2021",
                "PublishDate": "2021-11-05T00:03:14",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 04/11/2021",
                "PublishDate": "2021-11-05T00:03:14",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 04/11/2021",
                "PublishDate": "2021-11-05T00:03:14",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 04/11/2021",
                "PublishDate": "2021-11-05T00:03:14",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME",
                "PublishDate": "2021-10-26T13:42:23",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA.",
                "PublishDate": "2021-10-26T13:42:23",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME",
                "PublishDate": "2021-10-26T13:42:23",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA.",
                "PublishDate": "2021-10-26T13:42:23",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME",
                "PublishDate": "2021-10-26T13:42:23",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA.",
                "PublishDate": "2021-10-26T13:42:23",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME",
                "PublishDate": "2021-10-26T13:42:23",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA.",
                "PublishDate": "2021-10-26T13:42:23",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME",
                "PublishDate": "2021-10-26T13:42:23",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA.",
                "PublishDate": "2021-10-26T13:42:23",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2021-10-26T12:23:45",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 25 DE OUTUBRO DE 2021. ANA STELA PACHIEGA VISTOS OS AUTOS. CITEM-SE A PRIMEIRA E A SEGUNDA RECLAMADA NOS ENDERECOS INFORMADOS NO ID A0141A4. NOVO HAMBURGO/RS, 26 DE OUTUBRO DE 2021. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2021-10-26T12:23:45",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2021-10-26T12:23:45",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 25 DE OUTUBRO DE 2021. ANA STELA PACHIEGA VISTOS OS AUTOS. CITEM-SE A PRIMEIRA E A SEGUNDA RECLAMADA NOS ENDERECOS INFORMADOS NO ID A0141A4. NOVO HAMBURGO/RS, 26 DE OUTUBRO DE 2021. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2021-10-26T12:23:45",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2021-10-26T12:23:45",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 25 DE OUTUBRO DE 2021. ANA STELA PACHIEGA VISTOS OS AUTOS. CITEM-SE A PRIMEIRA E A SEGUNDA RECLAMADA NOS ENDERECOS INFORMADOS NO ID A0141A4. NOVO HAMBURGO/RS, 26 DE OUTUBRO DE 2021. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2021-10-26T12:23:45",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2021-10-26T12:23:45",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 25 DE OUTUBRO DE 2021. ANA STELA PACHIEGA VISTOS OS AUTOS. CITEM-SE A PRIMEIRA E A SEGUNDA RECLAMADA NOS ENDERECOS INFORMADOS NO ID A0141A4. NOVO HAMBURGO/RS, 26 DE OUTUBRO DE 2021. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2021-10-26T12:23:45",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2021-10-26T12:23:45",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 25 DE OUTUBRO DE 2021. ANA STELA PACHIEGA VISTOS OS AUTOS. CITEM-SE A PRIMEIRA E A SEGUNDA RECLAMADA NOS ENDERECOS INFORMADOS NO ID A0141A4. NOVO HAMBURGO/RS, 26 DE OUTUBRO DE 2021. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2021-10-26T12:23:45",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2021-10-25T14:29:06",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2021-10-25T14:29:06",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2021-10-25T14:29:06",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2021-10-25T14:29:06",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2021-10-25T14:29:06",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (COMPLEMENTACAO)",
                "PublishDate": "2021-10-21T15:09:16",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (COMPLEMENTACAO)",
                "PublishDate": "2021-10-21T15:09:16",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (COMPLEMENTACAO)",
                "PublishDate": "2021-10-21T15:09:16",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (COMPLEMENTACAO)",
                "PublishDate": "2021-10-21T15:09:16",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (COMPLEMENTACAO)",
                "PublishDate": "2021-10-21T15:09:16",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (MANIFESTACAO - NOVOS ENDERECOS)",
                "PublishDate": "2021-10-21T15:02:06",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (MANIFESTACAO - NOVOS ENDERECOS)",
                "PublishDate": "2021-10-21T15:02:06",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (MANIFESTACAO - NOVOS ENDERECOS)",
                "PublishDate": "2021-10-21T15:02:06",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (MANIFESTACAO - NOVOS ENDERECOS)",
                "PublishDate": "2021-10-21T15:02:06",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (MANIFESTACAO - NOVOS ENDERECOS)",
                "PublishDate": "2021-10-21T15:02:06",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 08/10/2021",
                "PublishDate": "2021-10-08T01:32:24",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-10-08T01:32:24",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 08/10/2021",
                "PublishDate": "2021-10-08T01:32:24",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-10-08T01:32:24",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 08/10/2021",
                "PublishDate": "2021-10-08T01:32:24",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-10-08T01:32:24",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 08/10/2021",
                "PublishDate": "2021-10-08T01:32:24",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-10-08T01:32:24",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 08/10/2021",
                "PublishDate": "2021-10-08T01:32:24",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-10-08T01:32:24",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 08/10/2021",
                "PublishDate": "2021-10-08T01:32:24",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-10-08T01:32:24",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2021-10-07T11:35:21",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2021-10-07T11:35:21",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2021-10-07T11:35:21",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2021-10-07T11:35:21",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2021-10-07T11:35:21",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2021-10-07T11:35:21",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2021-10-07T11:34:21",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 05 DE OUTUBRO DE 2021. RODRIGO PFUTZ VISTOS OS AUTOS. CIENCIA AO AUTOR, DA MANIFESTACAO E DOCUMENTOS JUNTADOS PELA QUARTA RECLAMADA NO ID. D4FCD29, DEVENDO, NO PRAZO DE 15 DIAS, INFORMAR MEIOS DE LOCALIZACAO DA PRIMEIRA E SEGUNDA RECLAMADAS, SOB PENA DE EXTINCAO DO PROCESSO SEM RESOLUCAO DE MERITO. NOVO HAMBURGO/RS, 07 DE OUTUBRO DE 2021. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2021-10-07T11:34:21",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2021-10-07T11:34:21",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 05 DE OUTUBRO DE 2021. RODRIGO PFUTZ VISTOS OS AUTOS. CIENCIA AO AUTOR, DA MANIFESTACAO E DOCUMENTOS JUNTADOS PELA QUARTA RECLAMADA NO ID. D4FCD29, DEVENDO, NO PRAZO DE 15 DIAS, INFORMAR MEIOS DE LOCALIZACAO DA PRIMEIRA E SEGUNDA RECLAMADAS, SOB PENA DE EXTINCAO DO PROCESSO SEM RESOLUCAO DE MERITO. NOVO HAMBURGO/RS, 07 DE OUTUBRO DE 2021. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2021-10-07T11:34:21",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2021-10-07T11:34:21",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 05 DE OUTUBRO DE 2021. RODRIGO PFUTZ VISTOS OS AUTOS. CIENCIA AO AUTOR, DA MANIFESTACAO E DOCUMENTOS JUNTADOS PELA QUARTA RECLAMADA NO ID. D4FCD29, DEVENDO, NO PRAZO DE 15 DIAS, INFORMAR MEIOS DE LOCALIZACAO DA PRIMEIRA E SEGUNDA RECLAMADAS, SOB PENA DE EXTINCAO DO PROCESSO SEM RESOLUCAO DE MERITO. NOVO HAMBURGO/RS, 07 DE OUTUBRO DE 2021. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2021-10-07T11:34:21",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2021-10-07T11:34:21",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 05 DE OUTUBRO DE 2021. RODRIGO PFUTZ VISTOS OS AUTOS. CIENCIA AO AUTOR, DA MANIFESTACAO E DOCUMENTOS JUNTADOS PELA QUARTA RECLAMADA NO ID. D4FCD29, DEVENDO, NO PRAZO DE 15 DIAS, INFORMAR MEIOS DE LOCALIZACAO DA PRIMEIRA E SEGUNDA RECLAMADAS, SOB PENA DE EXTINCAO DO PROCESSO SEM RESOLUCAO DE MERITO. NOVO HAMBURGO/RS, 07 DE OUTUBRO DE 2021. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2021-10-07T11:34:21",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2021-10-07T11:34:21",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 05 DE OUTUBRO DE 2021. RODRIGO PFUTZ VISTOS OS AUTOS. CIENCIA AO AUTOR, DA MANIFESTACAO E DOCUMENTOS JUNTADOS PELA QUARTA RECLAMADA NO ID. D4FCD29, DEVENDO, NO PRAZO DE 15 DIAS, INFORMAR MEIOS DE LOCALIZACAO DA PRIMEIRA E SEGUNDA RECLAMADAS, SOB PENA DE EXTINCAO DO PROCESSO SEM RESOLUCAO DE MERITO. NOVO HAMBURGO/RS, 07 DE OUTUBRO DE 2021. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2021-10-07T11:34:21",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2021-10-07T11:34:21",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 05 DE OUTUBRO DE 2021. RODRIGO PFUTZ VISTOS OS AUTOS. CIENCIA AO AUTOR, DA MANIFESTACAO E DOCUMENTOS JUNTADOS PELA QUARTA RECLAMADA NO ID. D4FCD29, DEVENDO, NO PRAZO DE 15 DIAS, INFORMAR MEIOS DE LOCALIZACAO DA PRIMEIRA E SEGUNDA RECLAMADAS, SOB PENA DE EXTINCAO DO PROCESSO SEM RESOLUCAO DE MERITO. NOVO HAMBURGO/RS, 07 DE OUTUBRO DE 2021. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2021-10-07T11:34:21",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2021-10-04T10:38:02",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2021-10-04T10:38:02",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2021-10-04T10:38:02",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2021-10-04T10:38:02",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2021-10-04T10:38:02",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2021-10-04T10:38:02",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DECORRIDO O PRAZO DE STARK BANK S.A. EM 29/09/2021",
                "PublishDate": "2021-09-30T00:02:44",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "DECORRIDO O PRAZO DE STARK BANK S.A. EM 29/09/2021",
                "PublishDate": "2021-09-30T00:02:44",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "DECORRIDO O PRAZO DE STARK BANK S.A. EM 29/09/2021",
                "PublishDate": "2021-09-30T00:02:44",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "DECORRIDO O PRAZO DE STARK BANK S.A. EM 29/09/2021",
                "PublishDate": "2021-09-30T00:02:44",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "DECORRIDO O PRAZO DE STARK BANK S.A. EM 29/09/2021",
                "PublishDate": "2021-09-30T00:02:44",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DECORRIDO O PRAZO DE STARK BANK S.A. EM 29/09/2021",
                "PublishDate": "2021-09-30T00:02:44",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (EXTINCAO_APRESENTACAO ENDERECO)",
                "PublishDate": "2021-09-23T15:26:01",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (EXTINCAO_APRESENTACAO ENDERECO)",
                "PublishDate": "2021-09-23T15:26:01",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (EXTINCAO_APRESENTACAO ENDERECO)",
                "PublishDate": "2021-09-23T15:26:01",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (EXTINCAO_APRESENTACAO ENDERECO)",
                "PublishDate": "2021-09-23T15:26:01",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (EXTINCAO_APRESENTACAO ENDERECO)",
                "PublishDate": "2021-09-23T15:26:01",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (EXTINCAO_APRESENTACAO ENDERECO)",
                "PublishDate": "2021-09-23T15:26:01",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 14/09/2021",
                "PublishDate": "2021-09-14T01:36:57",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-09-14T01:36:57",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 14/09/2021",
                "PublishDate": "2021-09-14T01:36:57",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-09-14T01:36:57",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 14/09/2021",
                "PublishDate": "2021-09-14T01:36:57",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-09-14T01:36:57",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 14/09/2021",
                "PublishDate": "2021-09-14T01:36:57",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-09-14T01:36:57",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 14/09/2021",
                "PublishDate": "2021-09-14T01:36:57",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-09-14T01:36:57",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 14/09/2021",
                "PublishDate": "2021-09-14T01:36:57",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-09-14T01:36:57",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 14/09/2021",
                "PublishDate": "2021-09-14T01:36:57",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-09-14T01:36:57",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) STARK BANK S.A.",
                "PublishDate": "2021-09-13T12:05:40",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) STARK BANK S.A.",
                "PublishDate": "2021-09-13T12:05:40",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) STARK BANK S.A.",
                "PublishDate": "2021-09-13T12:05:40",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) STARK BANK S.A.",
                "PublishDate": "2021-09-13T12:05:40",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) STARK BANK S.A.",
                "PublishDate": "2021-09-13T12:05:40",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) STARK BANK S.A.",
                "PublishDate": "2021-09-13T12:05:40",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) STARK BANK S.A.",
                "PublishDate": "2021-09-13T12:05:40",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "EXPEDIDO(A) OFICIO A(O) STARK BANK S.A.",
                "PublishDate": "2021-09-13T12:03:10",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "EXPEDIDO(A) OFICIO A(O) STARK BANK S.A.",
                "PublishDate": "2021-09-13T12:03:10",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "EXPEDIDO(A) OFICIO A(O) STARK BANK S.A.",
                "PublishDate": "2021-09-13T12:03:10",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "EXPEDIDO(A) OFICIO A(O) STARK BANK S.A.",
                "PublishDate": "2021-09-13T12:03:10",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "EXPEDIDO(A) OFICIO A(O) STARK BANK S.A.",
                "PublishDate": "2021-09-13T12:03:10",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "EXPEDIDO(A) OFICIO A(O) STARK BANK S.A.",
                "PublishDate": "2021-09-13T12:03:10",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "EXPEDIDO(A) OFICIO A(O) STARK BANK S.A.",
                "PublishDate": "2021-09-13T12:03:10",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2021-09-06T13:18:08",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 03 DE SETEMBRO DE 2021. ANA STELA PACHIEGA VISTOS OS AUTOS. OFICIE-SE A RECLAMADA STARK BANK S.A. PARA QUE INFORME O ENDERECO OU NUMERO DE TELEFONE CONSTANTE EM SEUS REGISTROS DAS EMPRESAS FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA (CNPJ NAO INFORMADO) E E. A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME (CNPJ: 21.160.553/0001-81), NO PRAZO DE 10 DIAS. NOVO HAMBURGO/RS, 06 DE SETEMBRO DE 2021. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2021-09-06T13:18:08",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2021-09-06T13:18:08",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 03 DE SETEMBRO DE 2021. ANA STELA PACHIEGA VISTOS OS AUTOS. OFICIE-SE A RECLAMADA STARK BANK S.A. PARA QUE INFORME O ENDERECO OU NUMERO DE TELEFONE CONSTANTE EM SEUS REGISTROS DAS EMPRESAS FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA (CNPJ NAO INFORMADO) E E. A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME (CNPJ: 21.160.553/0001-81), NO PRAZO DE 10 DIAS. NOVO HAMBURGO/RS, 06 DE SETEMBRO DE 2021. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2021-09-06T13:18:08",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2021-09-06T13:18:08",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 03 DE SETEMBRO DE 2021. ANA STELA PACHIEGA VISTOS OS AUTOS. OFICIE-SE A RECLAMADA STARK BANK S.A. PARA QUE INFORME O ENDERECO OU NUMERO DE TELEFONE CONSTANTE EM SEUS REGISTROS DAS EMPRESAS FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA (CNPJ NAO INFORMADO) E E. A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME (CNPJ: 21.160.553/0001-81), NO PRAZO DE 10 DIAS. NOVO HAMBURGO/RS, 06 DE SETEMBRO DE 2021. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2021-09-06T13:18:08",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2021-09-06T13:18:08",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 03 DE SETEMBRO DE 2021. ANA STELA PACHIEGA VISTOS OS AUTOS. OFICIE-SE A RECLAMADA STARK BANK S.A. PARA QUE INFORME O ENDERECO OU NUMERO DE TELEFONE CONSTANTE EM SEUS REGISTROS DAS EMPRESAS FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA (CNPJ NAO INFORMADO) E E. A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME (CNPJ: 21.160.553/0001-81), NO PRAZO DE 10 DIAS. NOVO HAMBURGO/RS, 06 DE SETEMBRO DE 2021. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2021-09-06T13:18:08",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2021-09-06T13:18:08",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 03 DE SETEMBRO DE 2021. ANA STELA PACHIEGA VISTOS OS AUTOS. OFICIE-SE A RECLAMADA STARK BANK S.A. PARA QUE INFORME O ENDERECO OU NUMERO DE TELEFONE CONSTANTE EM SEUS REGISTROS DAS EMPRESAS FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA (CNPJ NAO INFORMADO) E E. A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME (CNPJ: 21.160.553/0001-81), NO PRAZO DE 10 DIAS. NOVO HAMBURGO/RS, 06 DE SETEMBRO DE 2021. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2021-09-06T13:18:08",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2021-09-06T13:18:08",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 03 DE SETEMBRO DE 2021. ANA STELA PACHIEGA VISTOS OS AUTOS. OFICIE-SE A RECLAMADA STARK BANK S.A. PARA QUE INFORME O ENDERECO OU NUMERO DE TELEFONE CONSTANTE EM SEUS REGISTROS DAS EMPRESAS FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA (CNPJ NAO INFORMADO) E E. A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME (CNPJ: 21.160.553/0001-81), NO PRAZO DE 10 DIAS. NOVO HAMBURGO/RS, 06 DE SETEMBRO DE 2021. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2021-09-06T13:18:08",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2021-09-06T13:18:08",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 03 DE SETEMBRO DE 2021. ANA STELA PACHIEGA VISTOS OS AUTOS. OFICIE-SE A RECLAMADA STARK BANK S.A. PARA QUE INFORME O ENDERECO OU NUMERO DE TELEFONE CONSTANTE EM SEUS REGISTROS DAS EMPRESAS FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA (CNPJ NAO INFORMADO) E E. A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME (CNPJ: 21.160.553/0001-81), NO PRAZO DE 10 DIAS. NOVO HAMBURGO/RS, 06 DE SETEMBRO DE 2021. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2021-09-06T13:18:08",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2021-09-03T10:36:05",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2021-09-03T10:36:05",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2021-09-03T10:36:05",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2021-09-03T10:36:05",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2021-09-03T10:36:05",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2021-09-03T10:36:05",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2021-09-03T10:36:05",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 31/08/2021",
                "PublishDate": "2021-09-01T00:01:48",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 31/08/2021",
                "PublishDate": "2021-09-01T00:01:48",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 31/08/2021",
                "PublishDate": "2021-09-01T00:01:48",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 31/08/2021",
                "PublishDate": "2021-09-01T00:01:48",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 31/08/2021",
                "PublishDate": "2021-09-01T00:01:48",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 31/08/2021",
                "PublishDate": "2021-09-01T00:01:48",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 31/08/2021",
                "PublishDate": "2021-09-01T00:01:48",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (REPLICA)",
                "PublishDate": "2021-08-31T16:46:07",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (REPLICA)",
                "PublishDate": "2021-08-31T16:46:07",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (REPLICA)",
                "PublishDate": "2021-08-31T16:46:07",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (REPLICA)",
                "PublishDate": "2021-08-31T16:46:07",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (REPLICA)",
                "PublishDate": "2021-08-31T16:46:07",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (REPLICA)",
                "PublishDate": "2021-08-31T16:46:07",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (REPLICA)",
                "PublishDate": "2021-08-31T16:46:07",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 09/08/2021",
                "PublishDate": "2021-08-07T01:33:09",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-08-07T01:33:09",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 09/08/2021",
                "PublishDate": "2021-08-07T01:33:09",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-08-07T01:33:09",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 09/08/2021",
                "PublishDate": "2021-08-07T01:33:09",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-08-07T01:33:09",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 09/08/2021",
                "PublishDate": "2021-08-07T01:33:09",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-08-07T01:33:09",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 09/08/2021",
                "PublishDate": "2021-08-07T01:33:09",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-08-07T01:33:09",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 09/08/2021",
                "PublishDate": "2021-08-07T01:33:09",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-08-07T01:33:09",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 09/08/2021",
                "PublishDate": "2021-08-07T01:33:09",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-08-07T01:33:09",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 09/08/2021",
                "PublishDate": "2021-08-07T01:33:09",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-08-07T01:33:09",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2021-08-06T13:15:03",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2021-08-06T13:15:03",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2021-08-06T13:15:03",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2021-08-06T13:15:03",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2021-08-06T13:15:03",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2021-08-06T13:15:03",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2021-08-06T13:15:03",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2021-08-06T13:15:03",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 04/08/2021",
                "PublishDate": "2021-08-05T00:01:34",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 04/08/2021",
                "PublishDate": "2021-08-05T00:01:34",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 04/08/2021",
                "PublishDate": "2021-08-05T00:01:34",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 04/08/2021",
                "PublishDate": "2021-08-05T00:01:34",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 04/08/2021",
                "PublishDate": "2021-08-05T00:01:34",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 04/08/2021",
                "PublishDate": "2021-08-05T00:01:34",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 04/08/2021",
                "PublishDate": "2021-08-05T00:01:34",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 04/08/2021",
                "PublishDate": "2021-08-05T00:01:34",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 14/07/2021",
                "PublishDate": "2021-07-14T01:38:29",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-07-14T01:38:29",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 14/07/2021",
                "PublishDate": "2021-07-14T01:38:29",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-07-14T01:38:29",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 14/07/2021",
                "PublishDate": "2021-07-14T01:38:29",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-07-14T01:38:29",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 14/07/2021",
                "PublishDate": "2021-07-14T01:38:29",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-07-14T01:38:29",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 14/07/2021",
                "PublishDate": "2021-07-14T01:38:29",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-07-14T01:38:29",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 14/07/2021",
                "PublishDate": "2021-07-14T01:38:29",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-07-14T01:38:29",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 14/07/2021",
                "PublishDate": "2021-07-14T01:38:29",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-07-14T01:38:29",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 14/07/2021",
                "PublishDate": "2021-07-14T01:38:29",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-07-14T01:38:29",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 14/07/2021",
                "PublishDate": "2021-07-14T01:38:29",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-07-14T01:38:29",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2021-07-13T09:15:18",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2021-07-13T09:15:18",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2021-07-13T09:15:18",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2021-07-13T09:15:18",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2021-07-13T09:15:18",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2021-07-13T09:15:18",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2021-07-13T09:15:18",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2021-07-13T09:15:18",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2021-07-13T09:15:18",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2021-07-13T09:14:18",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 09 DE JULHO DE 2021. ANA STELA PACHIEGA VISTOS OS AUTOS. DE-SE CIENCIA AO AUTOR DAS CERTIDOES DOS ID'S F4CF725 E 7B23A5F DEVENDO, NO PRAZO DE 15 DIAS, INFORMAR MEIOS DE LOCALIZACAO DA PRIMEIRA E SEGUNDA RECLAMADAS, SOB PENA DE EXTINCAO DO PROCESSO SEM RESOLUCAO DE MERITO. NOVO HAMBURGO/RS, 13 DE JULHO DE 2021. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2021-07-13T09:14:18",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2021-07-13T09:14:18",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 09 DE JULHO DE 2021. ANA STELA PACHIEGA VISTOS OS AUTOS. DE-SE CIENCIA AO AUTOR DAS CERTIDOES DOS ID'S F4CF725 E 7B23A5F DEVENDO, NO PRAZO DE 15 DIAS, INFORMAR MEIOS DE LOCALIZACAO DA PRIMEIRA E SEGUNDA RECLAMADAS, SOB PENA DE EXTINCAO DO PROCESSO SEM RESOLUCAO DE MERITO. NOVO HAMBURGO/RS, 13 DE JULHO DE 2021. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2021-07-13T09:14:18",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2021-07-13T09:14:18",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 09 DE JULHO DE 2021. ANA STELA PACHIEGA VISTOS OS AUTOS. DE-SE CIENCIA AO AUTOR DAS CERTIDOES DOS ID'S F4CF725 E 7B23A5F DEVENDO, NO PRAZO DE 15 DIAS, INFORMAR MEIOS DE LOCALIZACAO DA PRIMEIRA E SEGUNDA RECLAMADAS, SOB PENA DE EXTINCAO DO PROCESSO SEM RESOLUCAO DE MERITO. NOVO HAMBURGO/RS, 13 DE JULHO DE 2021. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2021-07-13T09:14:18",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2021-07-13T09:14:18",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 09 DE JULHO DE 2021. ANA STELA PACHIEGA VISTOS OS AUTOS. DE-SE CIENCIA AO AUTOR DAS CERTIDOES DOS ID'S F4CF725 E 7B23A5F DEVENDO, NO PRAZO DE 15 DIAS, INFORMAR MEIOS DE LOCALIZACAO DA PRIMEIRA E SEGUNDA RECLAMADAS, SOB PENA DE EXTINCAO DO PROCESSO SEM RESOLUCAO DE MERITO. NOVO HAMBURGO/RS, 13 DE JULHO DE 2021. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2021-07-13T09:14:18",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2021-07-13T09:14:18",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 09 DE JULHO DE 2021. ANA STELA PACHIEGA VISTOS OS AUTOS. DE-SE CIENCIA AO AUTOR DAS CERTIDOES DOS ID'S F4CF725 E 7B23A5F DEVENDO, NO PRAZO DE 15 DIAS, INFORMAR MEIOS DE LOCALIZACAO DA PRIMEIRA E SEGUNDA RECLAMADAS, SOB PENA DE EXTINCAO DO PROCESSO SEM RESOLUCAO DE MERITO. NOVO HAMBURGO/RS, 13 DE JULHO DE 2021. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2021-07-13T09:14:18",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2021-07-13T09:14:18",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 09 DE JULHO DE 2021. ANA STELA PACHIEGA VISTOS OS AUTOS. DE-SE CIENCIA AO AUTOR DAS CERTIDOES DOS ID'S F4CF725 E 7B23A5F DEVENDO, NO PRAZO DE 15 DIAS, INFORMAR MEIOS DE LOCALIZACAO DA PRIMEIRA E SEGUNDA RECLAMADAS, SOB PENA DE EXTINCAO DO PROCESSO SEM RESOLUCAO DE MERITO. NOVO HAMBURGO/RS, 13 DE JULHO DE 2021. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2021-07-13T09:14:18",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2021-07-13T09:14:18",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 09 DE JULHO DE 2021. ANA STELA PACHIEGA VISTOS OS AUTOS. DE-SE CIENCIA AO AUTOR DAS CERTIDOES DOS ID'S F4CF725 E 7B23A5F DEVENDO, NO PRAZO DE 15 DIAS, INFORMAR MEIOS DE LOCALIZACAO DA PRIMEIRA E SEGUNDA RECLAMADAS, SOB PENA DE EXTINCAO DO PROCESSO SEM RESOLUCAO DE MERITO. NOVO HAMBURGO/RS, 13 DE JULHO DE 2021. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2021-07-13T09:14:18",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2021-07-13T09:14:18",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 09 DE JULHO DE 2021. ANA STELA PACHIEGA VISTOS OS AUTOS. DE-SE CIENCIA AO AUTOR DAS CERTIDOES DOS ID'S F4CF725 E 7B23A5F DEVENDO, NO PRAZO DE 15 DIAS, INFORMAR MEIOS DE LOCALIZACAO DA PRIMEIRA E SEGUNDA RECLAMADAS, SOB PENA DE EXTINCAO DO PROCESSO SEM RESOLUCAO DE MERITO. NOVO HAMBURGO/RS, 13 DE JULHO DE 2021. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2021-07-13T09:14:18",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2021-07-13T09:14:18",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 09 DE JULHO DE 2021. ANA STELA PACHIEGA VISTOS OS AUTOS. DE-SE CIENCIA AO AUTOR DAS CERTIDOES DOS ID'S F4CF725 E 7B23A5F DEVENDO, NO PRAZO DE 15 DIAS, INFORMAR MEIOS DE LOCALIZACAO DA PRIMEIRA E SEGUNDA RECLAMADAS, SOB PENA DE EXTINCAO DO PROCESSO SEM RESOLUCAO DE MERITO. NOVO HAMBURGO/RS, 13 DE JULHO DE 2021. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2021-07-13T09:14:18",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2021-07-09T13:58:25",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2021-07-09T13:58:25",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2021-07-09T13:58:25",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2021-07-09T13:58:25",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2021-07-09T13:58:25",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2021-07-09T13:58:25",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2021-07-09T13:58:25",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2021-07-09T13:58:25",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2021-07-09T13:58:25",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DEVOLVIDO O MANDADO PELO OFICIAL DE JUSTICA (CUMPRIDO COM FINALIDADE NAO ATINGIDA)",
                "PublishDate": "2021-07-08T17:07:14",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "DEVOLVIDO O MANDADO PELO OFICIAL DE JUSTICA (CUMPRIDO COM FINALIDADE NAO ATINGIDA)",
                "PublishDate": "2021-07-08T17:07:14",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "DEVOLVIDO O MANDADO PELO OFICIAL DE JUSTICA (CUMPRIDO COM FINALIDADE NAO ATINGIDA)",
                "PublishDate": "2021-07-08T17:07:14",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "DEVOLVIDO O MANDADO PELO OFICIAL DE JUSTICA (CUMPRIDO COM FINALIDADE NAO ATINGIDA)",
                "PublishDate": "2021-07-08T17:07:14",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "DEVOLVIDO O MANDADO PELO OFICIAL DE JUSTICA (CUMPRIDO COM FINALIDADE NAO ATINGIDA)",
                "PublishDate": "2021-07-08T17:07:14",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "DEVOLVIDO O MANDADO PELO OFICIAL DE JUSTICA (CUMPRIDO COM FINALIDADE NAO ATINGIDA)",
                "PublishDate": "2021-07-08T17:07:14",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "DEVOLVIDO O MANDADO PELO OFICIAL DE JUSTICA (CUMPRIDO COM FINALIDADE NAO ATINGIDA)",
                "PublishDate": "2021-07-08T17:07:14",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "DEVOLVIDO O MANDADO PELO OFICIAL DE JUSTICA (CUMPRIDO COM FINALIDADE NAO ATINGIDA)",
                "PublishDate": "2021-07-08T17:07:14",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DEVOLVIDO O MANDADO PELO OFICIAL DE JUSTICA (CUMPRIDO COM FINALIDADE NAO ATINGIDA)",
                "PublishDate": "2021-07-08T17:07:14",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DEVOLVIDO O MANDADO PELO OFICIAL DE JUSTICA (CUMPRIDO COM FINALIDADE NAO ATINGIDA)",
                "PublishDate": "2021-07-08T16:59:36",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "DEVOLVIDO O MANDADO PELO OFICIAL DE JUSTICA (CUMPRIDO COM FINALIDADE NAO ATINGIDA)",
                "PublishDate": "2021-07-08T16:59:36",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "DEVOLVIDO O MANDADO PELO OFICIAL DE JUSTICA (CUMPRIDO COM FINALIDADE NAO ATINGIDA)",
                "PublishDate": "2021-07-08T16:59:36",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "DEVOLVIDO O MANDADO PELO OFICIAL DE JUSTICA (CUMPRIDO COM FINALIDADE NAO ATINGIDA)",
                "PublishDate": "2021-07-08T16:59:36",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "DEVOLVIDO O MANDADO PELO OFICIAL DE JUSTICA (CUMPRIDO COM FINALIDADE NAO ATINGIDA)",
                "PublishDate": "2021-07-08T16:59:36",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "DEVOLVIDO O MANDADO PELO OFICIAL DE JUSTICA (CUMPRIDO COM FINALIDADE NAO ATINGIDA)",
                "PublishDate": "2021-07-08T16:59:36",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "DEVOLVIDO O MANDADO PELO OFICIAL DE JUSTICA (CUMPRIDO COM FINALIDADE NAO ATINGIDA)",
                "PublishDate": "2021-07-08T16:59:36",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "DEVOLVIDO O MANDADO PELO OFICIAL DE JUSTICA (CUMPRIDO COM FINALIDADE NAO ATINGIDA)",
                "PublishDate": "2021-07-08T16:59:36",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DEVOLVIDO O MANDADO PELO OFICIAL DE JUSTICA (CUMPRIDO COM FINALIDADE NAO ATINGIDA)",
                "PublishDate": "2021-07-08T16:59:36",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "RECEBIDO O MANDADO PELO OFICIAL DE JUSTICA PARA CUMPRIMENTO",
                "PublishDate": "2021-03-30T17:22:16",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "RECEBIDO O MANDADO PELO OFICIAL DE JUSTICA PARA CUMPRIMENTO",
                "PublishDate": "2021-03-30T17:22:16",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "RECEBIDO O MANDADO PELO OFICIAL DE JUSTICA PARA CUMPRIMENTO",
                "PublishDate": "2021-03-30T17:22:16",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "RECEBIDO O MANDADO PELO OFICIAL DE JUSTICA PARA CUMPRIMENTO",
                "PublishDate": "2021-03-30T17:22:16",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "RECEBIDO O MANDADO PELO OFICIAL DE JUSTICA PARA CUMPRIMENTO",
                "PublishDate": "2021-03-30T17:22:16",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "RECEBIDO O MANDADO PELO OFICIAL DE JUSTICA PARA CUMPRIMENTO",
                "PublishDate": "2021-03-30T17:22:16",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "RECEBIDO O MANDADO PELO OFICIAL DE JUSTICA PARA CUMPRIMENTO",
                "PublishDate": "2021-03-30T17:22:16",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "RECEBIDO O MANDADO PELO OFICIAL DE JUSTICA PARA CUMPRIMENTO",
                "PublishDate": "2021-03-30T17:22:16",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "RECEBIDO O MANDADO PELO OFICIAL DE JUSTICA PARA CUMPRIMENTO",
                "PublishDate": "2021-03-30T17:22:16",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "RECEBIDO O MANDADO PELO OFICIAL DE JUSTICA PARA CUMPRIMENTO",
                "PublishDate": "2021-03-30T17:22:16",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "RECEBIDO O MANDADO PELO OFICIAL DE JUSTICA PARA CUMPRIMENTO",
                "PublishDate": "2021-03-30T17:22:16",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "RECEBIDO O MANDADO PELO OFICIAL DE JUSTICA PARA CUMPRIMENTO",
                "PublishDate": "2021-03-30T17:22:16",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "RECEBIDO O MANDADO PELO OFICIAL DE JUSTICA PARA CUMPRIMENTO",
                "PublishDate": "2021-03-30T17:22:16",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "RECEBIDO O MANDADO PELO OFICIAL DE JUSTICA PARA CUMPRIMENTO",
                "PublishDate": "2021-03-30T17:22:16",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "RECEBIDO O MANDADO PELO OFICIAL DE JUSTICA PARA CUMPRIMENTO",
                "PublishDate": "2021-03-30T17:22:16",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "RECEBIDO O MANDADO PELO OFICIAL DE JUSTICA PARA CUMPRIMENTO",
                "PublishDate": "2021-03-30T17:22:16",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "RECEBIDO O MANDADO PELO OFICIAL DE JUSTICA PARA CUMPRIMENTO",
                "PublishDate": "2021-03-30T17:22:16",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "RECEBIDO O MANDADO PELO OFICIAL DE JUSTICA PARA CUMPRIMENTO",
                "PublishDate": "2021-03-30T17:22:16",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "EXPEDIDO(A) MANDADO A(O) E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME",
                "PublishDate": "2021-03-30T10:55:57",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "EXPEDIDO(A) MANDADO A(O) FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA.",
                "PublishDate": "2021-03-30T10:55:57",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "EXPEDIDO(A) MANDADO A(O) E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME",
                "PublishDate": "2021-03-30T10:55:57",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "EXPEDIDO(A) MANDADO A(O) FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA.",
                "PublishDate": "2021-03-30T10:55:57",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "EXPEDIDO(A) MANDADO A(O) E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME",
                "PublishDate": "2021-03-30T10:55:57",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "EXPEDIDO(A) MANDADO A(O) FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA.",
                "PublishDate": "2021-03-30T10:55:57",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "EXPEDIDO(A) MANDADO A(O) E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME",
                "PublishDate": "2021-03-30T10:55:57",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "EXPEDIDO(A) MANDADO A(O) FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA.",
                "PublishDate": "2021-03-30T10:55:57",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "EXPEDIDO(A) MANDADO A(O) E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME",
                "PublishDate": "2021-03-30T10:55:57",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "EXPEDIDO(A) MANDADO A(O) FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA.",
                "PublishDate": "2021-03-30T10:55:57",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "EXPEDIDO(A) MANDADO A(O) E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME",
                "PublishDate": "2021-03-30T10:55:57",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "EXPEDIDO(A) MANDADO A(O) FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA.",
                "PublishDate": "2021-03-30T10:55:57",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "EXPEDIDO(A) MANDADO A(O) E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME",
                "PublishDate": "2021-03-30T10:55:57",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "EXPEDIDO(A) MANDADO A(O) FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA.",
                "PublishDate": "2021-03-30T10:55:57",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "EXPEDIDO(A) MANDADO A(O) E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME",
                "PublishDate": "2021-03-30T10:55:57",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "EXPEDIDO(A) MANDADO A(O) FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA.",
                "PublishDate": "2021-03-30T10:55:57",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "EXPEDIDO(A) MANDADO A(O) E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME",
                "PublishDate": "2021-03-30T10:55:57",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "EXPEDIDO(A) MANDADO A(O) FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA.",
                "PublishDate": "2021-03-30T10:55:57",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2021-03-29T18:14:21",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) PROCESSO N: 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 26 DE MARCO DE 2021. ANA LUCIA SCHNEIDER VISTOS OS AUTOS. CITEM-SE AS RECLAMADAS FRI SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA. E DE E. A. ROCHA FORTS POR OFICIAL DE JUSTICA, OBSERVANDO-SE OS DADOS INFORMADOS PELO AUTOR NO ID 45B00B2. CONSIDERANDO A POSSIBILIDADE DE CUMPRIMENTO REMOTO DOS MANDADOS, ESTES DEVERAO SER CUMPRIDOS POR OFICIAIS DE JUSTICA DESTE FORO. NOVO HAMBURGO/RS, 29 DE MARCO DE 2021. ASSINADO ELETRONICAMENTE POR: THIAGO BOLDT DE SOUZA - JUNTADO EM: 29/03/2021 18:14:20 - 2CA4F0A THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2021-03-29T18:14:21",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2021-03-29T18:14:21",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) PROCESSO N: 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 26 DE MARCO DE 2021. ANA LUCIA SCHNEIDER VISTOS OS AUTOS. CITEM-SE AS RECLAMADAS FRI SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA. E DE E. A. ROCHA FORTS POR OFICIAL DE JUSTICA, OBSERVANDO-SE OS DADOS INFORMADOS PELO AUTOR NO ID 45B00B2. CONSIDERANDO A POSSIBILIDADE DE CUMPRIMENTO REMOTO DOS MANDADOS, ESTES DEVERAO SER CUMPRIDOS POR OFICIAIS DE JUSTICA DESTE FORO. NOVO HAMBURGO/RS, 29 DE MARCO DE 2021. ASSINADO ELETRONICAMENTE POR: THIAGO BOLDT DE SOUZA - JUNTADO EM: 29/03/2021 18:14:20 - 2CA4F0A THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2021-03-29T18:14:21",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2021-03-29T18:14:21",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) PROCESSO N: 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 26 DE MARCO DE 2021. ANA LUCIA SCHNEIDER VISTOS OS AUTOS. CITEM-SE AS RECLAMADAS FRI SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA. E DE E. A. ROCHA FORTS POR OFICIAL DE JUSTICA, OBSERVANDO-SE OS DADOS INFORMADOS PELO AUTOR NO ID 45B00B2. CONSIDERANDO A POSSIBILIDADE DE CUMPRIMENTO REMOTO DOS MANDADOS, ESTES DEVERAO SER CUMPRIDOS POR OFICIAIS DE JUSTICA DESTE FORO. NOVO HAMBURGO/RS, 29 DE MARCO DE 2021. ASSINADO ELETRONICAMENTE POR: THIAGO BOLDT DE SOUZA - JUNTADO EM: 29/03/2021 18:14:20 - 2CA4F0A THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2021-03-29T18:14:21",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2021-03-29T18:14:21",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) PROCESSO N: 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 26 DE MARCO DE 2021. ANA LUCIA SCHNEIDER VISTOS OS AUTOS. CITEM-SE AS RECLAMADAS FRI SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA. E DE E. A. ROCHA FORTS POR OFICIAL DE JUSTICA, OBSERVANDO-SE OS DADOS INFORMADOS PELO AUTOR NO ID 45B00B2. CONSIDERANDO A POSSIBILIDADE DE CUMPRIMENTO REMOTO DOS MANDADOS, ESTES DEVERAO SER CUMPRIDOS POR OFICIAIS DE JUSTICA DESTE FORO. NOVO HAMBURGO/RS, 29 DE MARCO DE 2021. ASSINADO ELETRONICAMENTE POR: THIAGO BOLDT DE SOUZA - JUNTADO EM: 29/03/2021 18:14:20 - 2CA4F0A THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2021-03-29T18:14:21",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2021-03-29T18:14:21",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) PROCESSO N: 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 26 DE MARCO DE 2021. ANA LUCIA SCHNEIDER VISTOS OS AUTOS. CITEM-SE AS RECLAMADAS FRI SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA. E DE E. A. ROCHA FORTS POR OFICIAL DE JUSTICA, OBSERVANDO-SE OS DADOS INFORMADOS PELO AUTOR NO ID 45B00B2. CONSIDERANDO A POSSIBILIDADE DE CUMPRIMENTO REMOTO DOS MANDADOS, ESTES DEVERAO SER CUMPRIDOS POR OFICIAIS DE JUSTICA DESTE FORO. NOVO HAMBURGO/RS, 29 DE MARCO DE 2021. ASSINADO ELETRONICAMENTE POR: THIAGO BOLDT DE SOUZA - JUNTADO EM: 29/03/2021 18:14:20 - 2CA4F0A THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2021-03-29T18:14:21",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2021-03-29T18:14:21",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) PROCESSO N: 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 26 DE MARCO DE 2021. ANA LUCIA SCHNEIDER VISTOS OS AUTOS. CITEM-SE AS RECLAMADAS FRI SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA. E DE E. A. ROCHA FORTS POR OFICIAL DE JUSTICA, OBSERVANDO-SE OS DADOS INFORMADOS PELO AUTOR NO ID 45B00B2. CONSIDERANDO A POSSIBILIDADE DE CUMPRIMENTO REMOTO DOS MANDADOS, ESTES DEVERAO SER CUMPRIDOS POR OFICIAIS DE JUSTICA DESTE FORO. NOVO HAMBURGO/RS, 29 DE MARCO DE 2021. ASSINADO ELETRONICAMENTE POR: THIAGO BOLDT DE SOUZA - JUNTADO EM: 29/03/2021 18:14:20 - 2CA4F0A THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2021-03-29T18:14:21",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2021-03-29T18:14:21",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) PROCESSO N: 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 26 DE MARCO DE 2021. ANA LUCIA SCHNEIDER VISTOS OS AUTOS. CITEM-SE AS RECLAMADAS FRI SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA. E DE E. A. ROCHA FORTS POR OFICIAL DE JUSTICA, OBSERVANDO-SE OS DADOS INFORMADOS PELO AUTOR NO ID 45B00B2. CONSIDERANDO A POSSIBILIDADE DE CUMPRIMENTO REMOTO DOS MANDADOS, ESTES DEVERAO SER CUMPRIDOS POR OFICIAIS DE JUSTICA DESTE FORO. NOVO HAMBURGO/RS, 29 DE MARCO DE 2021. ASSINADO ELETRONICAMENTE POR: THIAGO BOLDT DE SOUZA - JUNTADO EM: 29/03/2021 18:14:20 - 2CA4F0A THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2021-03-29T18:14:21",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2021-03-29T18:14:21",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) PROCESSO N: 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 26 DE MARCO DE 2021. ANA LUCIA SCHNEIDER VISTOS OS AUTOS. CITEM-SE AS RECLAMADAS FRI SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA. E DE E. A. ROCHA FORTS POR OFICIAL DE JUSTICA, OBSERVANDO-SE OS DADOS INFORMADOS PELO AUTOR NO ID 45B00B2. CONSIDERANDO A POSSIBILIDADE DE CUMPRIMENTO REMOTO DOS MANDADOS, ESTES DEVERAO SER CUMPRIDOS POR OFICIAIS DE JUSTICA DESTE FORO. NOVO HAMBURGO/RS, 29 DE MARCO DE 2021. ASSINADO ELETRONICAMENTE POR: THIAGO BOLDT DE SOUZA - JUNTADO EM: 29/03/2021 18:14:20 - 2CA4F0A THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2021-03-29T18:14:21",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2021-03-29T18:14:21",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) PROCESSO N: 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 26 DE MARCO DE 2021. ANA LUCIA SCHNEIDER VISTOS OS AUTOS. CITEM-SE AS RECLAMADAS FRI SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA. E DE E. A. ROCHA FORTS POR OFICIAL DE JUSTICA, OBSERVANDO-SE OS DADOS INFORMADOS PELO AUTOR NO ID 45B00B2. CONSIDERANDO A POSSIBILIDADE DE CUMPRIMENTO REMOTO DOS MANDADOS, ESTES DEVERAO SER CUMPRIDOS POR OFICIAIS DE JUSTICA DESTE FORO. NOVO HAMBURGO/RS, 29 DE MARCO DE 2021. ASSINADO ELETRONICAMENTE POR: THIAGO BOLDT DE SOUZA - JUNTADO EM: 29/03/2021 18:14:20 - 2CA4F0A THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2021-03-29T18:14:21",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2021-03-26T11:15:32",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2021-03-26T11:15:32",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2021-03-26T11:15:32",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2021-03-26T11:15:32",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2021-03-26T11:15:32",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2021-03-26T11:15:32",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2021-03-26T11:15:32",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2021-03-26T11:15:32",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2021-03-26T11:15:32",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (MANIFESTACAO - CITACAO)",
                "PublishDate": "2021-03-25T15:56:23",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (MANIFESTACAO - CITACAO)",
                "PublishDate": "2021-03-25T15:56:23",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (MANIFESTACAO - CITACAO)",
                "PublishDate": "2021-03-25T15:56:23",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (MANIFESTACAO - CITACAO)",
                "PublishDate": "2021-03-25T15:56:23",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (MANIFESTACAO - CITACAO)",
                "PublishDate": "2021-03-25T15:56:23",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (MANIFESTACAO - CITACAO)",
                "PublishDate": "2021-03-25T15:56:23",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (MANIFESTACAO - CITACAO)",
                "PublishDate": "2021-03-25T15:56:23",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (MANIFESTACAO - CITACAO)",
                "PublishDate": "2021-03-25T15:56:23",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (MANIFESTACAO - CITACAO)",
                "PublishDate": "2021-03-25T15:56:23",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DECORRIDO O PRAZO DE STARK BANK S.A. EM 18/03/2021",
                "PublishDate": "2021-03-19T00:09:02",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 18/03/2021",
                "PublishDate": "2021-03-19T00:09:02",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "DECORRIDO O PRAZO DE STARK BANK S.A. EM 18/03/2021",
                "PublishDate": "2021-03-19T00:09:02",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 18/03/2021",
                "PublishDate": "2021-03-19T00:09:02",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "DECORRIDO O PRAZO DE STARK BANK S.A. EM 18/03/2021",
                "PublishDate": "2021-03-19T00:09:02",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 18/03/2021",
                "PublishDate": "2021-03-19T00:09:02",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "DECORRIDO O PRAZO DE STARK BANK S.A. EM 18/03/2021",
                "PublishDate": "2021-03-19T00:09:02",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 18/03/2021",
                "PublishDate": "2021-03-19T00:09:02",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "DECORRIDO O PRAZO DE STARK BANK S.A. EM 18/03/2021",
                "PublishDate": "2021-03-19T00:09:02",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 18/03/2021",
                "PublishDate": "2021-03-19T00:09:02",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "DECORRIDO O PRAZO DE STARK BANK S.A. EM 18/03/2021",
                "PublishDate": "2021-03-19T00:09:02",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 18/03/2021",
                "PublishDate": "2021-03-19T00:09:02",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "DECORRIDO O PRAZO DE STARK BANK S.A. EM 18/03/2021",
                "PublishDate": "2021-03-19T00:09:02",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 18/03/2021",
                "PublishDate": "2021-03-19T00:09:02",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "DECORRIDO O PRAZO DE STARK BANK S.A. EM 18/03/2021",
                "PublishDate": "2021-03-19T00:09:02",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 18/03/2021",
                "PublishDate": "2021-03-19T00:09:02",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DECORRIDO O PRAZO DE STARK BANK S.A. EM 18/03/2021",
                "PublishDate": "2021-03-19T00:09:02",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 18/03/2021",
                "PublishDate": "2021-03-19T00:09:02",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 11/03/2021",
                "PublishDate": "2021-03-11T01:26:11",
                "CaptureDate": "2021-03-11T13:06:38"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-03-11T01:26:11",
                "CaptureDate": "2021-03-11T13:06:38"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 11/03/2021",
                "PublishDate": "2021-03-11T01:26:11",
                "CaptureDate": "2021-03-11T13:06:38"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-03-11T01:26:11",
                "CaptureDate": "2021-03-11T13:06:38"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 11/03/2021",
                "PublishDate": "2021-03-11T01:26:11",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-03-11T01:26:11",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 11/03/2021",
                "PublishDate": "2021-03-11T01:26:11",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-03-11T01:26:11",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 11/03/2021",
                "PublishDate": "2021-03-11T01:26:11",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-03-11T01:26:11",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 11/03/2021",
                "PublishDate": "2021-03-11T01:26:11",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-03-11T01:26:11",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 11/03/2021",
                "PublishDate": "2021-03-11T01:26:11",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-03-11T01:26:11",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 11/03/2021",
                "PublishDate": "2021-03-11T01:26:11",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-03-11T01:26:11",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 11/03/2021",
                "PublishDate": "2021-03-11T01:26:11",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-03-11T01:26:11",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 11/03/2021",
                "PublishDate": "2021-03-11T01:26:11",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-03-11T01:26:11",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 11/03/2021",
                "PublishDate": "2021-03-11T01:26:11",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-03-11T01:26:11",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 11/03/2021",
                "PublishDate": "2021-03-11T01:26:11",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-03-11T01:26:11",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 11/03/2021",
                "PublishDate": "2021-03-11T01:26:11",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-03-11T01:26:11",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 11/03/2021",
                "PublishDate": "2021-03-11T01:26:11",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-03-11T01:26:11",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 11/03/2021",
                "PublishDate": "2021-03-11T01:26:11",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-03-11T01:26:11",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 11/03/2021",
                "PublishDate": "2021-03-11T01:26:11",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-03-11T01:26:11",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 11/03/2021",
                "PublishDate": "2021-03-11T01:26:11",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-03-11T01:26:11",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 11/03/2021",
                "PublishDate": "2021-03-11T01:26:11",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-03-11T01:26:11",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 11/03/2021",
                "PublishDate": "2021-03-11T01:26:11",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-03-11T01:26:11",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "PUBLICADO(A) O(A) INTIMACAO EM 11/03/2021",
                "PublishDate": "2021-03-11T01:26:11",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) INTIMACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2021-03-11T01:26:11",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2021-03-10T11:43:58",
                "CaptureDate": "2021-03-11T13:06:38"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) STARK BANK S.A.",
                "PublishDate": "2021-03-10T11:43:58",
                "CaptureDate": "2021-03-11T13:06:38"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) STARK BANK S.A.",
                "PublishDate": "2021-03-10T11:43:58",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2021-03-10T11:43:58",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) STARK BANK S.A.",
                "PublishDate": "2021-03-10T11:43:58",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2021-03-10T11:43:58",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) STARK BANK S.A.",
                "PublishDate": "2021-03-10T11:43:58",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2021-03-10T11:43:58",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2021-03-10T11:43:58",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) STARK BANK S.A.",
                "PublishDate": "2021-03-10T11:43:58",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) STARK BANK S.A.",
                "PublishDate": "2021-03-10T11:43:58",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2021-03-10T11:43:58",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2021-03-10T11:43:58",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) STARK BANK S.A.",
                "PublishDate": "2021-03-10T11:43:58",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2021-03-10T11:43:58",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) STARK BANK S.A.",
                "PublishDate": "2021-03-10T11:43:58",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2021-03-10T11:43:58",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) STARK BANK S.A.",
                "PublishDate": "2021-03-10T11:43:58",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2021-03-10T11:43:58",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) STARK BANK S.A.",
                "PublishDate": "2021-03-10T11:43:58",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 09 DE MARCO DE 2021. ANA STELA PACHIEGA VISTOS OS AUTOS. INFORME A PARTE AUTORA O ENDERECO OU OUTRO MEIO DE CONTATO(E-MAIL OU CELULAR) DAS RECLAMADAS FRI- SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA. E DE E.A. ROCHA - FORTS, NO PRAZO DE 15 DIAS. NOVO HAMBURGO/RS, 10 DE MARCO DE 2021. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2021-03-10T11:42:58",
                "CaptureDate": "2021-03-11T13:06:38"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2021-03-10T11:42:58",
                "CaptureDate": "2021-03-11T13:06:38"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2021-03-10T11:42:58",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 09 DE MARCO DE 2021. ANA STELA PACHIEGA VISTOS OS AUTOS. INFORME A PARTE AUTORA O ENDERECO OU OUTRO MEIO DE CONTATO(E-MAIL OU CELULAR) DAS RECLAMADAS FRI- SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA. E DE E.A. ROCHA - FORTS, NO PRAZO DE 15 DIAS. NOVO HAMBURGO/RS, 10 DE MARCO DE 2021. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2021-03-10T11:42:58",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2021-03-10T11:42:58",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 09 DE MARCO DE 2021. ANA STELA PACHIEGA VISTOS OS AUTOS. INFORME A PARTE AUTORA O ENDERECO OU OUTRO MEIO DE CONTATO(E-MAIL OU CELULAR) DAS RECLAMADAS FRI- SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA. E DE E.A. ROCHA - FORTS, NO PRAZO DE 15 DIAS. NOVO HAMBURGO/RS, 10 DE MARCO DE 2021. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2021-03-10T11:42:58",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2021-03-10T11:42:58",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 09 DE MARCO DE 2021. ANA STELA PACHIEGA VISTOS OS AUTOS. INFORME A PARTE AUTORA O ENDERECO OU OUTRO MEIO DE CONTATO(E-MAIL OU CELULAR) DAS RECLAMADAS FRI- SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA. E DE E.A. ROCHA - FORTS, NO PRAZO DE 15 DIAS. NOVO HAMBURGO/RS, 10 DE MARCO DE 2021. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2021-03-10T11:42:58",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2021-03-10T11:42:58",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 09 DE MARCO DE 2021. ANA STELA PACHIEGA VISTOS OS AUTOS. INFORME A PARTE AUTORA O ENDERECO OU OUTRO MEIO DE CONTATO(E-MAIL OU CELULAR) DAS RECLAMADAS FRI- SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA. E DE E.A. ROCHA - FORTS, NO PRAZO DE 15 DIAS. NOVO HAMBURGO/RS, 10 DE MARCO DE 2021. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2021-03-10T11:42:58",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2021-03-10T11:42:58",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 09 DE MARCO DE 2021. ANA STELA PACHIEGA VISTOS OS AUTOS. INFORME A PARTE AUTORA O ENDERECO OU OUTRO MEIO DE CONTATO(E-MAIL OU CELULAR) DAS RECLAMADAS FRI- SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA. E DE E.A. ROCHA - FORTS, NO PRAZO DE 15 DIAS. NOVO HAMBURGO/RS, 10 DE MARCO DE 2021. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2021-03-10T11:42:58",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2021-03-10T11:42:58",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 09 DE MARCO DE 2021. ANA STELA PACHIEGA VISTOS OS AUTOS. INFORME A PARTE AUTORA O ENDERECO OU OUTRO MEIO DE CONTATO(E-MAIL OU CELULAR) DAS RECLAMADAS FRI- SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA. E DE E.A. ROCHA - FORTS, NO PRAZO DE 15 DIAS. NOVO HAMBURGO/RS, 10 DE MARCO DE 2021. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2021-03-10T11:42:58",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2021-03-10T11:42:58",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 09 DE MARCO DE 2021. ANA STELA PACHIEGA VISTOS OS AUTOS. INFORME A PARTE AUTORA O ENDERECO OU OUTRO MEIO DE CONTATO(E-MAIL OU CELULAR) DAS RECLAMADAS FRI- SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA. E DE E.A. ROCHA - FORTS, NO PRAZO DE 15 DIAS. NOVO HAMBURGO/RS, 10 DE MARCO DE 2021. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2021-03-10T11:42:58",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2021-03-10T11:42:58",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 09 DE MARCO DE 2021. ANA STELA PACHIEGA VISTOS OS AUTOS. INFORME A PARTE AUTORA O ENDERECO OU OUTRO MEIO DE CONTATO(E-MAIL OU CELULAR) DAS RECLAMADAS FRI- SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA. E DE E.A. ROCHA - FORTS, NO PRAZO DE 15 DIAS. NOVO HAMBURGO/RS, 10 DE MARCO DE 2021. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2021-03-10T11:42:58",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2021-03-10T11:42:58",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 RECLAMANTE: RALPH EMERSON GOMEZ RECLAMADO: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. E OUTROS (4) TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 09 DE MARCO DE 2021. ANA STELA PACHIEGA VISTOS OS AUTOS. INFORME A PARTE AUTORA O ENDERECO OU OUTRO MEIO DE CONTATO(E-MAIL OU CELULAR) DAS RECLAMADAS FRI- SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA. E DE E.A. ROCHA - FORTS, NO PRAZO DE 15 DIAS. NOVO HAMBURGO/RS, 10 DE MARCO DE 2021. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2021-03-10T11:42:58",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2021-03-09T14:15:48",
                "CaptureDate": "2021-03-11T13:06:38"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2021-03-09T14:15:48",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2021-03-09T14:15:48",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2021-03-09T14:15:48",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2021-03-09T14:15:48",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2021-03-09T14:15:48",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2021-03-09T14:15:48",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2021-03-09T14:15:48",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2021-03-09T14:15:48",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2021-03-09T14:15:48",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DECORRIDO O PRAZO DE E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME EM 29/09/2020",
                "PublishDate": "2021-03-07T00:10:51",
                "CaptureDate": "2021-03-11T13:06:38"
              },
              {
                "Content": "DECORRIDO O PRAZO DE E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME EM 29/09/2020",
                "PublishDate": "2021-03-07T00:10:51",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "DECORRIDO O PRAZO DE E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME EM 29/09/2020",
                "PublishDate": "2021-03-07T00:10:51",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "DECORRIDO O PRAZO DE E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME EM 29/09/2020",
                "PublishDate": "2021-03-07T00:10:51",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "DECORRIDO O PRAZO DE E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME EM 29/09/2020",
                "PublishDate": "2021-03-07T00:10:51",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "DECORRIDO O PRAZO DE E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME EM 29/09/2020",
                "PublishDate": "2021-03-07T00:10:51",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "DECORRIDO O PRAZO DE E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME EM 29/09/2020",
                "PublishDate": "2021-03-07T00:10:51",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "DECORRIDO O PRAZO DE E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME EM 29/09/2020",
                "PublishDate": "2021-03-07T00:10:51",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "DECORRIDO O PRAZO DE E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME EM 29/09/2020",
                "PublishDate": "2021-03-07T00:10:51",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DECORRIDO O PRAZO DE E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME EM 29/09/2020",
                "PublishDate": "2021-03-07T00:10:51",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DECORRIDO O PRAZO DE ARENA FOMENTO MERCANTIL LTDA EM 21/10/2020",
                "PublishDate": "2020-10-22T00:01:13",
                "CaptureDate": "2021-03-11T13:06:38"
              },
              {
                "Content": "DECORRIDO O PRAZO DE E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME EM 21/10/2020",
                "PublishDate": "2020-10-22T00:01:13",
                "CaptureDate": "2021-03-11T13:06:38"
              },
              {
                "Content": "DECORRIDO O PRAZO DE ARENA FOMENTO MERCANTIL LTDA EM 21/10/2020",
                "PublishDate": "2020-10-22T00:01:13",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "DECORRIDO O PRAZO DE E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME EM 21/10/2020",
                "PublishDate": "2020-10-22T00:01:13",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "DECORRIDO O PRAZO DE ARENA FOMENTO MERCANTIL LTDA EM 21/10/2020",
                "PublishDate": "2020-10-22T00:01:13",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "DECORRIDO O PRAZO DE E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME EM 21/10/2020",
                "PublishDate": "2020-10-22T00:01:13",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "DECORRIDO O PRAZO DE ARENA FOMENTO MERCANTIL LTDA EM 21/10/2020",
                "PublishDate": "2020-10-22T00:01:13",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "DECORRIDO O PRAZO DE E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME EM 21/10/2020",
                "PublishDate": "2020-10-22T00:01:13",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "DECORRIDO O PRAZO DE ARENA FOMENTO MERCANTIL LTDA EM 21/10/2020",
                "PublishDate": "2020-10-22T00:01:13",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "DECORRIDO O PRAZO DE E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME EM 21/10/2020",
                "PublishDate": "2020-10-22T00:01:13",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "DECORRIDO O PRAZO DE ARENA FOMENTO MERCANTIL LTDA EM 21/10/2020",
                "PublishDate": "2020-10-22T00:01:13",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "DECORRIDO O PRAZO DE E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME EM 21/10/2020",
                "PublishDate": "2020-10-22T00:01:13",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "DECORRIDO O PRAZO DE ARENA FOMENTO MERCANTIL LTDA EM 21/10/2020",
                "PublishDate": "2020-10-22T00:01:13",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "DECORRIDO O PRAZO DE E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME EM 21/10/2020",
                "PublishDate": "2020-10-22T00:01:13",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "DECORRIDO O PRAZO DE ARENA FOMENTO MERCANTIL LTDA EM 21/10/2020",
                "PublishDate": "2020-10-22T00:01:13",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "DECORRIDO O PRAZO DE E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME EM 21/10/2020",
                "PublishDate": "2020-10-22T00:01:13",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "DECORRIDO O PRAZO DE ARENA FOMENTO MERCANTIL LTDA EM 21/10/2020",
                "PublishDate": "2020-10-22T00:01:13",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DECORRIDO O PRAZO DE E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME EM 21/10/2020",
                "PublishDate": "2020-10-22T00:01:13",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DECORRIDO O PRAZO DE ARENA FOMENTO MERCANTIL LTDA EM 21/10/2020",
                "PublishDate": "2020-10-22T00:01:13",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DECORRIDO O PRAZO DE E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME EM 21/10/2020",
                "PublishDate": "2020-10-22T00:01:13",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 11/09/2020",
                "PublishDate": "2020-09-12T00:01:49",
                "CaptureDate": "2021-03-11T13:06:38"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 11/09/2020",
                "PublishDate": "2020-09-12T00:01:49",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 11/09/2020",
                "PublishDate": "2020-09-12T00:01:49",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 11/09/2020",
                "PublishDate": "2020-09-12T00:01:49",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 11/09/2020",
                "PublishDate": "2020-09-12T00:01:49",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 11/09/2020",
                "PublishDate": "2020-09-12T00:01:49",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 11/09/2020",
                "PublishDate": "2020-09-12T00:01:49",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 11/09/2020",
                "PublishDate": "2020-09-12T00:01:49",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 11/09/2020",
                "PublishDate": "2020-09-12T00:01:49",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 11/09/2020",
                "PublishDate": "2020-09-12T00:01:49",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) ARENA FOMENTO MERCANTIL LTDA",
                "PublishDate": "2020-09-04T11:07:20",
                "CaptureDate": "2021-03-11T13:06:38"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) ARENA FOMENTO MERCANTIL LTDA",
                "PublishDate": "2020-09-04T11:07:20",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) ARENA FOMENTO MERCANTIL LTDA",
                "PublishDate": "2020-09-04T11:07:20",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) ARENA FOMENTO MERCANTIL LTDA",
                "PublishDate": "2020-09-04T11:07:20",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) ARENA FOMENTO MERCANTIL LTDA",
                "PublishDate": "2020-09-04T11:07:20",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) ARENA FOMENTO MERCANTIL LTDA",
                "PublishDate": "2020-09-04T11:07:20",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) ARENA FOMENTO MERCANTIL LTDA",
                "PublishDate": "2020-09-04T11:07:20",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) ARENA FOMENTO MERCANTIL LTDA",
                "PublishDate": "2020-09-04T11:07:20",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) ARENA FOMENTO MERCANTIL LTDA",
                "PublishDate": "2020-09-04T11:07:20",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) ARENA FOMENTO MERCANTIL LTDA",
                "PublishDate": "2020-09-04T11:07:20",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME",
                "PublishDate": "2020-09-04T11:07:19",
                "CaptureDate": "2021-03-11T13:06:38"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME",
                "PublishDate": "2020-09-04T11:07:19",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME",
                "PublishDate": "2020-09-04T11:07:19",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME",
                "PublishDate": "2020-09-04T11:07:19",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME",
                "PublishDate": "2020-09-04T11:07:19",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME",
                "PublishDate": "2020-09-04T11:07:19",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME",
                "PublishDate": "2020-09-04T11:07:19",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME",
                "PublishDate": "2020-09-04T11:07:19",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME",
                "PublishDate": "2020-09-04T11:07:19",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME",
                "PublishDate": "2020-09-04T11:07:19",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (MANIFESTACAO - ENDERECO)",
                "PublishDate": "2020-09-03T18:46:28",
                "CaptureDate": "2021-03-11T13:06:38"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (MANIFESTACAO - ENDERECO)",
                "PublishDate": "2020-09-03T18:46:28",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (MANIFESTACAO - ENDERECO)",
                "PublishDate": "2020-09-03T18:46:28",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (MANIFESTACAO - ENDERECO)",
                "PublishDate": "2020-09-03T18:46:28",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (MANIFESTACAO - ENDERECO)",
                "PublishDate": "2020-09-03T18:46:28",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (MANIFESTACAO - ENDERECO)",
                "PublishDate": "2020-09-03T18:46:28",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (MANIFESTACAO - ENDERECO)",
                "PublishDate": "2020-09-03T18:46:28",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (MANIFESTACAO - ENDERECO)",
                "PublishDate": "2020-09-03T18:46:28",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (MANIFESTACAO - ENDERECO)",
                "PublishDate": "2020-09-03T18:46:28",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (MANIFESTACAO - ENDERECO)",
                "PublishDate": "2020-09-03T18:46:28",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "PUBLICADO(A) O(A) NOTIFICACAO EM 20/08/2020",
                "PublishDate": "2020-08-20T00:29:49",
                "CaptureDate": "2020-08-20T22:59:52"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) NOTIFICACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2020-08-20T00:29:49",
                "CaptureDate": "2020-08-20T22:59:52"
              },
              {
                "Content": "PUBLICADO(A) O(A) NOTIFICACAO EM 20/08/2020",
                "PublishDate": "2020-08-20T00:29:49",
                "CaptureDate": "2021-03-11T13:06:38"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) NOTIFICACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2020-08-20T00:29:49",
                "CaptureDate": "2021-03-11T13:06:38"
              },
              {
                "Content": "PUBLICADO(A) O(A) NOTIFICACAO EM 20/08/2020",
                "PublishDate": "2020-08-20T00:29:49",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) NOTIFICACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2020-08-20T00:29:49",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "PUBLICADO(A) O(A) NOTIFICACAO EM 20/08/2020",
                "PublishDate": "2020-08-20T00:29:49",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) NOTIFICACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2020-08-20T00:29:49",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "PUBLICADO(A) O(A) NOTIFICACAO EM 20/08/2020",
                "PublishDate": "2020-08-20T00:29:49",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) NOTIFICACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2020-08-20T00:29:49",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "PUBLICADO(A) O(A) NOTIFICACAO EM 20/08/2020",
                "PublishDate": "2020-08-20T00:29:49",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) NOTIFICACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2020-08-20T00:29:49",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "PUBLICADO(A) O(A) NOTIFICACAO EM 20/08/2020",
                "PublishDate": "2020-08-20T00:29:49",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) NOTIFICACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2020-08-20T00:29:49",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "PUBLICADO(A) O(A) NOTIFICACAO EM 20/08/2020",
                "PublishDate": "2020-08-20T00:29:49",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) NOTIFICACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2020-08-20T00:29:49",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "PUBLICADO(A) O(A) NOTIFICACAO EM 20/08/2020",
                "PublishDate": "2020-08-20T00:29:49",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) NOTIFICACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2020-08-20T00:29:49",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "PUBLICADO(A) O(A) NOTIFICACAO EM 20/08/2020",
                "PublishDate": "2020-08-20T00:29:49",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) NOTIFICACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2020-08-20T00:29:49",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "PUBLICADO(A) O(A) NOTIFICACAO EM 20/08/2020",
                "PublishDate": "2020-08-20T00:29:49",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) NOTIFICACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2020-08-20T00:29:49",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2020-08-18T15:01:20",
                "CaptureDate": "2020-08-20T22:59:52"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2020-08-18T15:01:20",
                "CaptureDate": "2021-03-11T13:06:38"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2020-08-18T15:01:20",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2020-08-18T15:01:20",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2020-08-18T15:01:20",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2020-08-18T15:01:20",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2020-08-18T15:01:20",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2020-08-18T15:01:20",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2020-08-18T15:01:20",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2020-08-18T15:01:20",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2020-08-18T15:01:20",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 AUTOR: RALPH EMERSON GOMEZ REU: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA., E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME, ARENA FOMENTO MERCANTIL LTDA, STARK BANK S.A. TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 18 DE AGOSTO DE 2020. ANA STELA PACHIEGA VISTOS OS AUTOS. A PARTE AUTORA DEVERA INDICAR OS ATUAIS ENDERECOS DAS RECLAMADAS E.A. ROCHA E ARENA FOMENTO MERCANTIL, NO PRAZO DE 15 DIAS, PARA FINS DE CITACAO INICIAL. AGUARDE-SE A COMPROVACAO DA CITACAO DA PRIMEIRA RECLAMADA FRI (ID 12F55A1). NOVO HAMBURGO/RS, 18 DE AGOSTO DE 2020. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2020-08-18T15:00:20",
                "CaptureDate": "2020-08-20T22:59:52"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2020-08-18T15:00:20",
                "CaptureDate": "2020-08-20T22:59:52"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 AUTOR: RALPH EMERSON GOMEZ REU: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA., E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME, ARENA FOMENTO MERCANTIL LTDA, STARK BANK S.A. TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 18 DE AGOSTO DE 2020. ANA STELA PACHIEGA VISTOS OS AUTOS. A PARTE AUTORA DEVERA INDICAR OS ATUAIS ENDERECOS DAS RECLAMADAS E.A. ROCHA E ARENA FOMENTO MERCANTIL, NO PRAZO DE 15 DIAS, PARA FINS DE CITACAO INICIAL. AGUARDE-SE A COMPROVACAO DA CITACAO DA PRIMEIRA RECLAMADA FRI (ID 12F55A1). NOVO HAMBURGO/RS, 18 DE AGOSTO DE 2020. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2020-08-18T15:00:20",
                "CaptureDate": "2021-03-11T13:06:38"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2020-08-18T15:00:20",
                "CaptureDate": "2021-03-11T13:06:38"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2020-08-18T15:00:20",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 AUTOR: RALPH EMERSON GOMEZ REU: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA., E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME, ARENA FOMENTO MERCANTIL LTDA, STARK BANK S.A. TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 18 DE AGOSTO DE 2020. ANA STELA PACHIEGA VISTOS OS AUTOS. A PARTE AUTORA DEVERA INDICAR OS ATUAIS ENDERECOS DAS RECLAMADAS E.A. ROCHA E ARENA FOMENTO MERCANTIL, NO PRAZO DE 15 DIAS, PARA FINS DE CITACAO INICIAL. AGUARDE-SE A COMPROVACAO DA CITACAO DA PRIMEIRA RECLAMADA FRI (ID 12F55A1). NOVO HAMBURGO/RS, 18 DE AGOSTO DE 2020. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2020-08-18T15:00:20",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2020-08-18T15:00:20",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 AUTOR: RALPH EMERSON GOMEZ REU: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA., E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME, ARENA FOMENTO MERCANTIL LTDA, STARK BANK S.A. TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 18 DE AGOSTO DE 2020. ANA STELA PACHIEGA VISTOS OS AUTOS. A PARTE AUTORA DEVERA INDICAR OS ATUAIS ENDERECOS DAS RECLAMADAS E.A. ROCHA E ARENA FOMENTO MERCANTIL, NO PRAZO DE 15 DIAS, PARA FINS DE CITACAO INICIAL. AGUARDE-SE A COMPROVACAO DA CITACAO DA PRIMEIRA RECLAMADA FRI (ID 12F55A1). NOVO HAMBURGO/RS, 18 DE AGOSTO DE 2020. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2020-08-18T15:00:20",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2020-08-18T15:00:20",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 AUTOR: RALPH EMERSON GOMEZ REU: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA., E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME, ARENA FOMENTO MERCANTIL LTDA, STARK BANK S.A. TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 18 DE AGOSTO DE 2020. ANA STELA PACHIEGA VISTOS OS AUTOS. A PARTE AUTORA DEVERA INDICAR OS ATUAIS ENDERECOS DAS RECLAMADAS E.A. ROCHA E ARENA FOMENTO MERCANTIL, NO PRAZO DE 15 DIAS, PARA FINS DE CITACAO INICIAL. AGUARDE-SE A COMPROVACAO DA CITACAO DA PRIMEIRA RECLAMADA FRI (ID 12F55A1). NOVO HAMBURGO/RS, 18 DE AGOSTO DE 2020. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2020-08-18T15:00:20",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2020-08-18T15:00:20",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 AUTOR: RALPH EMERSON GOMEZ REU: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA., E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME, ARENA FOMENTO MERCANTIL LTDA, STARK BANK S.A. TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 18 DE AGOSTO DE 2020. ANA STELA PACHIEGA VISTOS OS AUTOS. A PARTE AUTORA DEVERA INDICAR OS ATUAIS ENDERECOS DAS RECLAMADAS E.A. ROCHA E ARENA FOMENTO MERCANTIL, NO PRAZO DE 15 DIAS, PARA FINS DE CITACAO INICIAL. AGUARDE-SE A COMPROVACAO DA CITACAO DA PRIMEIRA RECLAMADA FRI (ID 12F55A1). NOVO HAMBURGO/RS, 18 DE AGOSTO DE 2020. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2020-08-18T15:00:20",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2020-08-18T15:00:20",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 AUTOR: RALPH EMERSON GOMEZ REU: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA., E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME, ARENA FOMENTO MERCANTIL LTDA, STARK BANK S.A. TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 18 DE AGOSTO DE 2020. ANA STELA PACHIEGA VISTOS OS AUTOS. A PARTE AUTORA DEVERA INDICAR OS ATUAIS ENDERECOS DAS RECLAMADAS E.A. ROCHA E ARENA FOMENTO MERCANTIL, NO PRAZO DE 15 DIAS, PARA FINS DE CITACAO INICIAL. AGUARDE-SE A COMPROVACAO DA CITACAO DA PRIMEIRA RECLAMADA FRI (ID 12F55A1). NOVO HAMBURGO/RS, 18 DE AGOSTO DE 2020. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2020-08-18T15:00:20",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2020-08-18T15:00:20",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 AUTOR: RALPH EMERSON GOMEZ REU: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA., E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME, ARENA FOMENTO MERCANTIL LTDA, STARK BANK S.A. TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 18 DE AGOSTO DE 2020. ANA STELA PACHIEGA VISTOS OS AUTOS. A PARTE AUTORA DEVERA INDICAR OS ATUAIS ENDERECOS DAS RECLAMADAS E.A. ROCHA E ARENA FOMENTO MERCANTIL, NO PRAZO DE 15 DIAS, PARA FINS DE CITACAO INICIAL. AGUARDE-SE A COMPROVACAO DA CITACAO DA PRIMEIRA RECLAMADA FRI (ID 12F55A1). NOVO HAMBURGO/RS, 18 DE AGOSTO DE 2020. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2020-08-18T15:00:20",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2020-08-18T15:00:20",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 AUTOR: RALPH EMERSON GOMEZ REU: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA., E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME, ARENA FOMENTO MERCANTIL LTDA, STARK BANK S.A. TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 18 DE AGOSTO DE 2020. ANA STELA PACHIEGA VISTOS OS AUTOS. A PARTE AUTORA DEVERA INDICAR OS ATUAIS ENDERECOS DAS RECLAMADAS E.A. ROCHA E ARENA FOMENTO MERCANTIL, NO PRAZO DE 15 DIAS, PARA FINS DE CITACAO INICIAL. AGUARDE-SE A COMPROVACAO DA CITACAO DA PRIMEIRA RECLAMADA FRI (ID 12F55A1). NOVO HAMBURGO/RS, 18 DE AGOSTO DE 2020. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2020-08-18T15:00:20",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2020-08-18T15:00:20",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 AUTOR: RALPH EMERSON GOMEZ REU: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA., E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME, ARENA FOMENTO MERCANTIL LTDA, STARK BANK S.A. TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 18 DE AGOSTO DE 2020. ANA STELA PACHIEGA VISTOS OS AUTOS. A PARTE AUTORA DEVERA INDICAR OS ATUAIS ENDERECOS DAS RECLAMADAS E.A. ROCHA E ARENA FOMENTO MERCANTIL, NO PRAZO DE 15 DIAS, PARA FINS DE CITACAO INICIAL. AGUARDE-SE A COMPROVACAO DA CITACAO DA PRIMEIRA RECLAMADA FRI (ID 12F55A1). NOVO HAMBURGO/RS, 18 DE AGOSTO DE 2020. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2020-08-18T15:00:20",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2020-08-18T15:00:20",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 AUTOR: RALPH EMERSON GOMEZ REU: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA., E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME, ARENA FOMENTO MERCANTIL LTDA, STARK BANK S.A. TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 18 DE AGOSTO DE 2020. ANA STELA PACHIEGA VISTOS OS AUTOS. A PARTE AUTORA DEVERA INDICAR OS ATUAIS ENDERECOS DAS RECLAMADAS E.A. ROCHA E ARENA FOMENTO MERCANTIL, NO PRAZO DE 15 DIAS, PARA FINS DE CITACAO INICIAL. AGUARDE-SE A COMPROVACAO DA CITACAO DA PRIMEIRA RECLAMADA FRI (ID 12F55A1). NOVO HAMBURGO/RS, 18 DE AGOSTO DE 2020. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2020-08-18T15:00:20",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2020-08-18T10:54:38",
                "CaptureDate": "2020-08-20T22:59:52"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2020-08-18T10:54:38",
                "CaptureDate": "2021-03-11T13:06:38"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2020-08-18T10:54:38",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2020-08-18T10:54:38",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2020-08-18T10:54:38",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2020-08-18T10:54:38",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2020-08-18T10:54:38",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2020-08-18T10:54:38",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2020-08-18T10:54:38",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2020-08-18T10:54:38",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2020-08-18T10:54:38",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DECORRIDO O PRAZO DE FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. EM 10/08/2020",
                "PublishDate": "2020-08-11T00:01:40",
                "CaptureDate": "2020-08-20T22:59:52"
              },
              {
                "Content": "DECORRIDO O PRAZO DE FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. EM 10/08/2020",
                "PublishDate": "2020-08-11T00:01:40",
                "CaptureDate": "2021-03-11T13:06:38"
              },
              {
                "Content": "DECORRIDO O PRAZO DE FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. EM 10/08/2020",
                "PublishDate": "2020-08-11T00:01:40",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "DECORRIDO O PRAZO DE FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. EM 10/08/2020",
                "PublishDate": "2020-08-11T00:01:40",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "DECORRIDO O PRAZO DE FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. EM 10/08/2020",
                "PublishDate": "2020-08-11T00:01:40",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "DECORRIDO O PRAZO DE FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. EM 10/08/2020",
                "PublishDate": "2020-08-11T00:01:40",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "DECORRIDO O PRAZO DE FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. EM 10/08/2020",
                "PublishDate": "2020-08-11T00:01:40",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "DECORRIDO O PRAZO DE FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. EM 10/08/2020",
                "PublishDate": "2020-08-11T00:01:40",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "DECORRIDO O PRAZO DE FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. EM 10/08/2020",
                "PublishDate": "2020-08-11T00:01:40",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "DECORRIDO O PRAZO DE FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. EM 10/08/2020",
                "PublishDate": "2020-08-11T00:01:40",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DECORRIDO O PRAZO DE FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. EM 10/08/2020",
                "PublishDate": "2020-08-11T00:01:40",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 04/08/2020",
                "PublishDate": "2020-08-05T00:02:31",
                "CaptureDate": "2020-08-20T22:59:52"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 04/08/2020",
                "PublishDate": "2020-08-05T00:02:31",
                "CaptureDate": "2021-03-11T13:06:38"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 04/08/2020",
                "PublishDate": "2020-08-05T00:02:31",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 04/08/2020",
                "PublishDate": "2020-08-05T00:02:31",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 04/08/2020",
                "PublishDate": "2020-08-05T00:02:31",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 04/08/2020",
                "PublishDate": "2020-08-05T00:02:31",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 04/08/2020",
                "PublishDate": "2020-08-05T00:02:31",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 04/08/2020",
                "PublishDate": "2020-08-05T00:02:31",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 04/08/2020",
                "PublishDate": "2020-08-05T00:02:31",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 04/08/2020",
                "PublishDate": "2020-08-05T00:02:31",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 04/08/2020",
                "PublishDate": "2020-08-05T00:02:31",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "EXPEDIDO(A) CARTA PRECATORIA NOTIFICATORIA A(O) E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME",
                "PublishDate": "2020-07-16T10:52:26",
                "CaptureDate": "2020-08-20T22:59:52"
              },
              {
                "Content": "EXPEDIDO(A) CARTA PRECATORIA NOTIFICATORIA A(O) E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME",
                "PublishDate": "2020-07-16T10:52:26",
                "CaptureDate": "2021-03-11T13:06:38"
              },
              {
                "Content": "EXPEDIDO(A) CARTA PRECATORIA NOTIFICATORIA A(O) E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME",
                "PublishDate": "2020-07-16T10:52:26",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "EXPEDIDO(A) CARTA PRECATORIA NOTIFICATORIA A(O) E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME",
                "PublishDate": "2020-07-16T10:52:26",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "EXPEDIDO(A) CARTA PRECATORIA NOTIFICATORIA A(O) E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME",
                "PublishDate": "2020-07-16T10:52:26",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "EXPEDIDO(A) CARTA PRECATORIA NOTIFICATORIA A(O) E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME",
                "PublishDate": "2020-07-16T10:52:26",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "EXPEDIDO(A) CARTA PRECATORIA NOTIFICATORIA A(O) E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME",
                "PublishDate": "2020-07-16T10:52:26",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "EXPEDIDO(A) CARTA PRECATORIA NOTIFICATORIA A(O) E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME",
                "PublishDate": "2020-07-16T10:52:26",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "EXPEDIDO(A) CARTA PRECATORIA NOTIFICATORIA A(O) E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME",
                "PublishDate": "2020-07-16T10:52:26",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "EXPEDIDO(A) CARTA PRECATORIA NOTIFICATORIA A(O) E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME",
                "PublishDate": "2020-07-16T10:52:26",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "EXPEDIDO(A) CARTA PRECATORIA NOTIFICATORIA A(O) E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME",
                "PublishDate": "2020-07-16T10:52:26",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA.",
                "PublishDate": "2020-07-15T12:48:33",
                "CaptureDate": "2020-08-20T22:59:52"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA.",
                "PublishDate": "2020-07-15T12:48:33",
                "CaptureDate": "2021-03-11T13:06:38"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA.",
                "PublishDate": "2020-07-15T12:48:33",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA.",
                "PublishDate": "2020-07-15T12:48:33",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA.",
                "PublishDate": "2020-07-15T12:48:33",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA.",
                "PublishDate": "2020-07-15T12:48:33",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA.",
                "PublishDate": "2020-07-15T12:48:33",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA.",
                "PublishDate": "2020-07-15T12:48:33",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA.",
                "PublishDate": "2020-07-15T12:48:33",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA.",
                "PublishDate": "2020-07-15T12:48:33",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA.",
                "PublishDate": "2020-07-15T12:48:33",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (MANIFESTACAO)",
                "PublishDate": "2020-07-15T06:43:01",
                "CaptureDate": "2020-08-20T22:59:52"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (MANIFESTACAO)",
                "PublishDate": "2020-07-15T06:43:01",
                "CaptureDate": "2021-03-11T13:06:38"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (MANIFESTACAO)",
                "PublishDate": "2020-07-15T06:43:01",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (MANIFESTACAO)",
                "PublishDate": "2020-07-15T06:43:01",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (MANIFESTACAO)",
                "PublishDate": "2020-07-15T06:43:01",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (MANIFESTACAO)",
                "PublishDate": "2020-07-15T06:43:01",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (MANIFESTACAO)",
                "PublishDate": "2020-07-15T06:43:01",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (MANIFESTACAO)",
                "PublishDate": "2020-07-15T06:43:01",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (MANIFESTACAO)",
                "PublishDate": "2020-07-15T06:43:01",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (MANIFESTACAO)",
                "PublishDate": "2020-07-15T06:43:01",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (MANIFESTACAO)",
                "PublishDate": "2020-07-15T06:43:01",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 14/07/2020",
                "PublishDate": "2020-07-15T00:02:32",
                "CaptureDate": "2020-08-20T22:59:52"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 14/07/2020",
                "PublishDate": "2020-07-15T00:02:32",
                "CaptureDate": "2021-03-11T13:06:38"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 14/07/2020",
                "PublishDate": "2020-07-15T00:02:32",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 14/07/2020",
                "PublishDate": "2020-07-15T00:02:32",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 14/07/2020",
                "PublishDate": "2020-07-15T00:02:32",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 14/07/2020",
                "PublishDate": "2020-07-15T00:02:32",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 14/07/2020",
                "PublishDate": "2020-07-15T00:02:32",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 14/07/2020",
                "PublishDate": "2020-07-15T00:02:32",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 14/07/2020",
                "PublishDate": "2020-07-15T00:02:32",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 14/07/2020",
                "PublishDate": "2020-07-15T00:02:32",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DECORRIDO O PRAZO DE RALPH EMERSON GOMEZ EM 14/07/2020",
                "PublishDate": "2020-07-15T00:02:32",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "PUBLICADO(A) O(A) NOTIFICACAO EM 14/07/2020",
                "PublishDate": "2020-07-14T00:26:32",
                "CaptureDate": "2020-08-20T22:59:52"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) NOTIFICACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2020-07-14T00:26:32",
                "CaptureDate": "2020-08-20T22:59:52"
              },
              {
                "Content": "PUBLICADO(A) O(A) NOTIFICACAO EM 14/07/2020",
                "PublishDate": "2020-07-14T00:26:32",
                "CaptureDate": "2021-03-11T13:06:38"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) NOTIFICACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2020-07-14T00:26:32",
                "CaptureDate": "2021-03-11T13:06:38"
              },
              {
                "Content": "PUBLICADO(A) O(A) NOTIFICACAO EM 14/07/2020",
                "PublishDate": "2020-07-14T00:26:32",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) NOTIFICACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2020-07-14T00:26:32",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "PUBLICADO(A) O(A) NOTIFICACAO EM 14/07/2020",
                "PublishDate": "2020-07-14T00:26:32",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) NOTIFICACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2020-07-14T00:26:32",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "PUBLICADO(A) O(A) NOTIFICACAO EM 14/07/2020",
                "PublishDate": "2020-07-14T00:26:32",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) NOTIFICACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2020-07-14T00:26:32",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "PUBLICADO(A) O(A) NOTIFICACAO EM 14/07/2020",
                "PublishDate": "2020-07-14T00:26:32",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) NOTIFICACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2020-07-14T00:26:32",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "PUBLICADO(A) O(A) NOTIFICACAO EM 14/07/2020",
                "PublishDate": "2020-07-14T00:26:32",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) NOTIFICACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2020-07-14T00:26:32",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "PUBLICADO(A) O(A) NOTIFICACAO EM 14/07/2020",
                "PublishDate": "2020-07-14T00:26:32",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) NOTIFICACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2020-07-14T00:26:32",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "PUBLICADO(A) O(A) NOTIFICACAO EM 14/07/2020",
                "PublishDate": "2020-07-14T00:26:32",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) NOTIFICACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2020-07-14T00:26:32",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "PUBLICADO(A) O(A) NOTIFICACAO EM 14/07/2020",
                "PublishDate": "2020-07-14T00:26:32",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) NOTIFICACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2020-07-14T00:26:32",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "PUBLICADO(A) O(A) NOTIFICACAO EM 14/07/2020",
                "PublishDate": "2020-07-14T00:26:32",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) NOTIFICACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2020-07-14T00:26:32",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2020-07-13T10:45:53",
                "CaptureDate": "2020-08-20T22:59:52"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2020-07-13T10:45:53",
                "CaptureDate": "2021-03-11T13:06:38"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2020-07-13T10:45:53",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2020-07-13T10:45:53",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2020-07-13T10:45:53",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2020-07-13T10:45:53",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2020-07-13T10:45:53",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2020-07-13T10:45:53",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2020-07-13T10:45:53",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2020-07-13T10:45:53",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2020-07-13T10:45:53",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 AUTOR: RALPH EMERSON GOMEZ REU: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA., E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME, ARENA FOMENTO MERCANTIL LTDA, STARK BANK S.A. TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 13 DE JULHO DE 2020. ANA STELA PACHIEGA VISTOS OS AUTOS. INTIME-SE A PARTE AUTORA PARA QUE INFORME O ENDERECO DA PRIMEIRA RECLAMADA NO PRAZO DE 15 DIAS, SOB PENA DE EXTINCAO DA ACAO SEM RESOLUCAO DO MERITO COM RELACAO A ESTA RECLAMADA. CUMPRA-SE O DESPACHO DO ID 4816BF4, PARTE FINAL. NOVO HAMBURGO/RS, 13 DE JULHO DE 2020. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2020-07-13T10:44:53",
                "CaptureDate": "2020-08-20T22:59:52"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2020-07-13T10:44:53",
                "CaptureDate": "2020-08-20T22:59:52"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 AUTOR: RALPH EMERSON GOMEZ REU: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA., E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME, ARENA FOMENTO MERCANTIL LTDA, STARK BANK S.A. TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 13 DE JULHO DE 2020. ANA STELA PACHIEGA VISTOS OS AUTOS. INTIME-SE A PARTE AUTORA PARA QUE INFORME O ENDERECO DA PRIMEIRA RECLAMADA NO PRAZO DE 15 DIAS, SOB PENA DE EXTINCAO DA ACAO SEM RESOLUCAO DO MERITO COM RELACAO A ESTA RECLAMADA. CUMPRA-SE O DESPACHO DO ID 4816BF4, PARTE FINAL. NOVO HAMBURGO/RS, 13 DE JULHO DE 2020. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2020-07-13T10:44:53",
                "CaptureDate": "2021-03-11T13:06:38"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2020-07-13T10:44:53",
                "CaptureDate": "2021-03-11T13:06:38"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2020-07-13T10:44:53",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 AUTOR: RALPH EMERSON GOMEZ REU: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA., E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME, ARENA FOMENTO MERCANTIL LTDA, STARK BANK S.A. TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 13 DE JULHO DE 2020. ANA STELA PACHIEGA VISTOS OS AUTOS. INTIME-SE A PARTE AUTORA PARA QUE INFORME O ENDERECO DA PRIMEIRA RECLAMADA NO PRAZO DE 15 DIAS, SOB PENA DE EXTINCAO DA ACAO SEM RESOLUCAO DO MERITO COM RELACAO A ESTA RECLAMADA. CUMPRA-SE O DESPACHO DO ID 4816BF4, PARTE FINAL. NOVO HAMBURGO/RS, 13 DE JULHO DE 2020. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2020-07-13T10:44:53",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2020-07-13T10:44:53",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 AUTOR: RALPH EMERSON GOMEZ REU: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA., E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME, ARENA FOMENTO MERCANTIL LTDA, STARK BANK S.A. TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 13 DE JULHO DE 2020. ANA STELA PACHIEGA VISTOS OS AUTOS. INTIME-SE A PARTE AUTORA PARA QUE INFORME O ENDERECO DA PRIMEIRA RECLAMADA NO PRAZO DE 15 DIAS, SOB PENA DE EXTINCAO DA ACAO SEM RESOLUCAO DO MERITO COM RELACAO A ESTA RECLAMADA. CUMPRA-SE O DESPACHO DO ID 4816BF4, PARTE FINAL. NOVO HAMBURGO/RS, 13 DE JULHO DE 2020. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2020-07-13T10:44:53",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2020-07-13T10:44:53",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 AUTOR: RALPH EMERSON GOMEZ REU: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA., E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME, ARENA FOMENTO MERCANTIL LTDA, STARK BANK S.A. TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 13 DE JULHO DE 2020. ANA STELA PACHIEGA VISTOS OS AUTOS. INTIME-SE A PARTE AUTORA PARA QUE INFORME O ENDERECO DA PRIMEIRA RECLAMADA NO PRAZO DE 15 DIAS, SOB PENA DE EXTINCAO DA ACAO SEM RESOLUCAO DO MERITO COM RELACAO A ESTA RECLAMADA. CUMPRA-SE O DESPACHO DO ID 4816BF4, PARTE FINAL. NOVO HAMBURGO/RS, 13 DE JULHO DE 2020. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2020-07-13T10:44:53",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2020-07-13T10:44:53",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 AUTOR: RALPH EMERSON GOMEZ REU: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA., E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME, ARENA FOMENTO MERCANTIL LTDA, STARK BANK S.A. TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 13 DE JULHO DE 2020. ANA STELA PACHIEGA VISTOS OS AUTOS. INTIME-SE A PARTE AUTORA PARA QUE INFORME O ENDERECO DA PRIMEIRA RECLAMADA NO PRAZO DE 15 DIAS, SOB PENA DE EXTINCAO DA ACAO SEM RESOLUCAO DO MERITO COM RELACAO A ESTA RECLAMADA. CUMPRA-SE O DESPACHO DO ID 4816BF4, PARTE FINAL. NOVO HAMBURGO/RS, 13 DE JULHO DE 2020. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2020-07-13T10:44:53",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2020-07-13T10:44:53",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 AUTOR: RALPH EMERSON GOMEZ REU: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA., E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME, ARENA FOMENTO MERCANTIL LTDA, STARK BANK S.A. TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 13 DE JULHO DE 2020. ANA STELA PACHIEGA VISTOS OS AUTOS. INTIME-SE A PARTE AUTORA PARA QUE INFORME O ENDERECO DA PRIMEIRA RECLAMADA NO PRAZO DE 15 DIAS, SOB PENA DE EXTINCAO DA ACAO SEM RESOLUCAO DO MERITO COM RELACAO A ESTA RECLAMADA. CUMPRA-SE O DESPACHO DO ID 4816BF4, PARTE FINAL. NOVO HAMBURGO/RS, 13 DE JULHO DE 2020. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2020-07-13T10:44:53",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2020-07-13T10:44:53",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 AUTOR: RALPH EMERSON GOMEZ REU: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA., E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME, ARENA FOMENTO MERCANTIL LTDA, STARK BANK S.A. TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 13 DE JULHO DE 2020. ANA STELA PACHIEGA VISTOS OS AUTOS. INTIME-SE A PARTE AUTORA PARA QUE INFORME O ENDERECO DA PRIMEIRA RECLAMADA NO PRAZO DE 15 DIAS, SOB PENA DE EXTINCAO DA ACAO SEM RESOLUCAO DO MERITO COM RELACAO A ESTA RECLAMADA. CUMPRA-SE O DESPACHO DO ID 4816BF4, PARTE FINAL. NOVO HAMBURGO/RS, 13 DE JULHO DE 2020. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2020-07-13T10:44:53",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2020-07-13T10:44:53",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 AUTOR: RALPH EMERSON GOMEZ REU: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA., E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME, ARENA FOMENTO MERCANTIL LTDA, STARK BANK S.A. TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 13 DE JULHO DE 2020. ANA STELA PACHIEGA VISTOS OS AUTOS. INTIME-SE A PARTE AUTORA PARA QUE INFORME O ENDERECO DA PRIMEIRA RECLAMADA NO PRAZO DE 15 DIAS, SOB PENA DE EXTINCAO DA ACAO SEM RESOLUCAO DO MERITO COM RELACAO A ESTA RECLAMADA. CUMPRA-SE O DESPACHO DO ID 4816BF4, PARTE FINAL. NOVO HAMBURGO/RS, 13 DE JULHO DE 2020. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2020-07-13T10:44:53",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2020-07-13T10:44:53",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 AUTOR: RALPH EMERSON GOMEZ REU: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA., E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME, ARENA FOMENTO MERCANTIL LTDA, STARK BANK S.A. TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 13 DE JULHO DE 2020. ANA STELA PACHIEGA VISTOS OS AUTOS. INTIME-SE A PARTE AUTORA PARA QUE INFORME O ENDERECO DA PRIMEIRA RECLAMADA NO PRAZO DE 15 DIAS, SOB PENA DE EXTINCAO DA ACAO SEM RESOLUCAO DO MERITO COM RELACAO A ESTA RECLAMADA. CUMPRA-SE O DESPACHO DO ID 4816BF4, PARTE FINAL. NOVO HAMBURGO/RS, 13 DE JULHO DE 2020. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2020-07-13T10:44:53",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2020-07-13T10:44:53",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 AUTOR: RALPH EMERSON GOMEZ REU: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA., E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME, ARENA FOMENTO MERCANTIL LTDA, STARK BANK S.A. TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS. NOVO HAMBURGO, 13 DE JULHO DE 2020. ANA STELA PACHIEGA VISTOS OS AUTOS. INTIME-SE A PARTE AUTORA PARA QUE INFORME O ENDERECO DA PRIMEIRA RECLAMADA NO PRAZO DE 15 DIAS, SOB PENA DE EXTINCAO DA ACAO SEM RESOLUCAO DO MERITO COM RELACAO A ESTA RECLAMADA. CUMPRA-SE O DESPACHO DO ID 4816BF4, PARTE FINAL. NOVO HAMBURGO/RS, 13 DE JULHO DE 2020. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2020-07-13T10:44:53",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2020-07-13T09:26:14",
                "CaptureDate": "2020-08-20T22:59:52"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2020-07-13T09:26:14",
                "CaptureDate": "2021-03-11T13:06:38"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2020-07-13T09:26:14",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2020-07-13T09:26:14",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2020-07-13T09:26:14",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2020-07-13T09:26:14",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2020-07-13T09:26:14",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2020-07-13T09:26:14",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2020-07-13T09:26:14",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2020-07-13T09:26:14",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2020-07-13T09:26:14",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "JUNTADA A PETICAO DE CONTESTACAO (CONTESTACAO)",
                "PublishDate": "2020-07-04T18:09:50",
                "CaptureDate": "2020-08-20T22:59:52"
              },
              {
                "Content": "JUNTADA A PETICAO DE CONTESTACAO (CONTESTACAO)",
                "PublishDate": "2020-07-04T18:09:50",
                "CaptureDate": "2021-03-11T13:06:38"
              },
              {
                "Content": "JUNTADA A PETICAO DE CONTESTACAO (CONTESTACAO)",
                "PublishDate": "2020-07-04T18:09:50",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "JUNTADA A PETICAO DE CONTESTACAO (CONTESTACAO)",
                "PublishDate": "2020-07-04T18:09:50",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "JUNTADA A PETICAO DE CONTESTACAO (CONTESTACAO)",
                "PublishDate": "2020-07-04T18:09:50",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "JUNTADA A PETICAO DE CONTESTACAO (CONTESTACAO)",
                "PublishDate": "2020-07-04T18:09:50",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "JUNTADA A PETICAO DE CONTESTACAO (CONTESTACAO)",
                "PublishDate": "2020-07-04T18:09:50",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "JUNTADA A PETICAO DE CONTESTACAO (CONTESTACAO)",
                "PublishDate": "2020-07-04T18:09:50",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "JUNTADA A PETICAO DE CONTESTACAO (CONTESTACAO)",
                "PublishDate": "2020-07-04T18:09:50",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "JUNTADA A PETICAO DE CONTESTACAO (CONTESTACAO)",
                "PublishDate": "2020-07-04T18:09:50",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "JUNTADA A PETICAO DE CONTESTACAO (CONTESTACAO)",
                "PublishDate": "2020-07-04T18:09:50",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "PUBLICADO(A) O(A) NOTIFICACAO EM 29/06/2020",
                "PublishDate": "2020-06-27T00:09:28",
                "CaptureDate": "2020-07-01T10:59:30"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) NOTIFICACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2020-06-27T00:09:28",
                "CaptureDate": "2020-07-01T10:59:30"
              },
              {
                "Content": "PUBLICADO(A) O(A) NOTIFICACAO EM 29/06/2020",
                "PublishDate": "2020-06-27T00:09:28",
                "CaptureDate": "2020-08-20T22:59:52"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) NOTIFICACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2020-06-27T00:09:28",
                "CaptureDate": "2020-08-20T22:59:52"
              },
              {
                "Content": "PUBLICADO(A) O(A) NOTIFICACAO EM 29/06/2020",
                "PublishDate": "2020-06-27T00:09:28",
                "CaptureDate": "2021-03-11T13:06:38"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) NOTIFICACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2020-06-27T00:09:28",
                "CaptureDate": "2021-03-11T13:06:38"
              },
              {
                "Content": "PUBLICADO(A) O(A) NOTIFICACAO EM 29/06/2020",
                "PublishDate": "2020-06-27T00:09:28",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) NOTIFICACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2020-06-27T00:09:28",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "PUBLICADO(A) O(A) NOTIFICACAO EM 29/06/2020",
                "PublishDate": "2020-06-27T00:09:28",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) NOTIFICACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2020-06-27T00:09:28",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "PUBLICADO(A) O(A) NOTIFICACAO EM 29/06/2020",
                "PublishDate": "2020-06-27T00:09:28",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) NOTIFICACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2020-06-27T00:09:28",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "PUBLICADO(A) O(A) NOTIFICACAO EM 29/06/2020",
                "PublishDate": "2020-06-27T00:09:28",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) NOTIFICACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2020-06-27T00:09:28",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "PUBLICADO(A) O(A) NOTIFICACAO EM 29/06/2020",
                "PublishDate": "2020-06-27T00:09:28",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) NOTIFICACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2020-06-27T00:09:28",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "PUBLICADO(A) O(A) NOTIFICACAO EM 29/06/2020",
                "PublishDate": "2020-06-27T00:09:28",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) NOTIFICACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2020-06-27T00:09:28",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "PUBLICADO(A) O(A) NOTIFICACAO EM 29/06/2020",
                "PublishDate": "2020-06-27T00:09:28",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) NOTIFICACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2020-06-27T00:09:28",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "PUBLICADO(A) O(A) NOTIFICACAO EM 29/06/2020",
                "PublishDate": "2020-06-27T00:09:28",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) NOTIFICACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2020-06-27T00:09:28",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "PUBLICADO(A) O(A) NOTIFICACAO EM 29/06/2020",
                "PublishDate": "2020-06-27T00:09:28",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DISPONIBILIZADO (A) O(A) NOTIFICACAO NO DIARIO DA JUSTICA ELETRONICO",
                "PublishDate": "2020-06-27T00:09:28",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2020-06-26T11:01:34",
                "CaptureDate": "2020-07-01T10:59:30"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2020-06-26T11:01:34",
                "CaptureDate": "2020-08-20T22:59:52"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2020-06-26T11:01:34",
                "CaptureDate": "2021-03-11T13:06:38"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2020-06-26T11:01:34",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2020-06-26T11:01:34",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2020-06-26T11:01:34",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2020-06-26T11:01:34",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2020-06-26T11:01:34",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2020-06-26T11:01:34",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2020-06-26T11:01:34",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2020-06-26T11:01:34",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) RALPH EMERSON GOMEZ",
                "PublishDate": "2020-06-26T11:01:34",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 AUTOR: RALPH EMERSON GOMEZ REU: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA., E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME, ARENA FOMENTO MERCANTIL LTDA, STARK BANK S.A. TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS AO EXMO. MAGISTRADO. NOVO HAMBURGO, 25 DE JUNHO DE 2020. ANDRESSA TRIERWEILER VISTOS OS AUTOS. NAO HA FALAR EM REVELIA, PORQUE NAO HOUVE O RETORNO DOS COMPROVANTES DE RECEBIMENTO DAS CARTAS DE CITACAO. AGUARDE-SE POR DEZ DIAS. NO SILENCIO, RENOVEM-SE AS CITACOES POR CARTA PRECATORIA. NOVO HAMBURGO/RS, 26 DE JUNHO DE 2020. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2020-06-26T11:00:34",
                "CaptureDate": "2020-07-01T10:59:30"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2020-06-26T11:00:34",
                "CaptureDate": "2020-07-01T10:59:30"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 AUTOR: RALPH EMERSON GOMEZ REU: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA., E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME, ARENA FOMENTO MERCANTIL LTDA, STARK BANK S.A. TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS AO EXMO. MAGISTRADO. NOVO HAMBURGO, 25 DE JUNHO DE 2020. ANDRESSA TRIERWEILER VISTOS OS AUTOS. NAO HA FALAR EM REVELIA, PORQUE NAO HOUVE O RETORNO DOS COMPROVANTES DE RECEBIMENTO DAS CARTAS DE CITACAO. AGUARDE-SE POR DEZ DIAS. NO SILENCIO, RENOVEM-SE AS CITACOES POR CARTA PRECATORIA. NOVO HAMBURGO/RS, 26 DE JUNHO DE 2020. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2020-06-26T11:00:34",
                "CaptureDate": "2020-08-20T22:59:52"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2020-06-26T11:00:34",
                "CaptureDate": "2020-08-20T22:59:52"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 AUTOR: RALPH EMERSON GOMEZ REU: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA., E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME, ARENA FOMENTO MERCANTIL LTDA, STARK BANK S.A. TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS AO EXMO. MAGISTRADO. NOVO HAMBURGO, 25 DE JUNHO DE 2020. ANDRESSA TRIERWEILER VISTOS OS AUTOS. NAO HA FALAR EM REVELIA, PORQUE NAO HOUVE O RETORNO DOS COMPROVANTES DE RECEBIMENTO DAS CARTAS DE CITACAO. AGUARDE-SE POR DEZ DIAS. NO SILENCIO, RENOVEM-SE AS CITACOES POR CARTA PRECATORIA. NOVO HAMBURGO/RS, 26 DE JUNHO DE 2020. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2020-06-26T11:00:34",
                "CaptureDate": "2021-03-11T13:06:38"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2020-06-26T11:00:34",
                "CaptureDate": "2021-03-11T13:06:38"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2020-06-26T11:00:34",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 AUTOR: RALPH EMERSON GOMEZ REU: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA., E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME, ARENA FOMENTO MERCANTIL LTDA, STARK BANK S.A. TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS AO EXMO. MAGISTRADO. NOVO HAMBURGO, 25 DE JUNHO DE 2020. ANDRESSA TRIERWEILER VISTOS OS AUTOS. NAO HA FALAR EM REVELIA, PORQUE NAO HOUVE O RETORNO DOS COMPROVANTES DE RECEBIMENTO DAS CARTAS DE CITACAO. AGUARDE-SE POR DEZ DIAS. NO SILENCIO, RENOVEM-SE AS CITACOES POR CARTA PRECATORIA. NOVO HAMBURGO/RS, 26 DE JUNHO DE 2020. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2020-06-26T11:00:34",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2020-06-26T11:00:34",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 AUTOR: RALPH EMERSON GOMEZ REU: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA., E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME, ARENA FOMENTO MERCANTIL LTDA, STARK BANK S.A. TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS AO EXMO. MAGISTRADO. NOVO HAMBURGO, 25 DE JUNHO DE 2020. ANDRESSA TRIERWEILER VISTOS OS AUTOS. NAO HA FALAR EM REVELIA, PORQUE NAO HOUVE O RETORNO DOS COMPROVANTES DE RECEBIMENTO DAS CARTAS DE CITACAO. AGUARDE-SE POR DEZ DIAS. NO SILENCIO, RENOVEM-SE AS CITACOES POR CARTA PRECATORIA. NOVO HAMBURGO/RS, 26 DE JUNHO DE 2020. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2020-06-26T11:00:34",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2020-06-26T11:00:34",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 AUTOR: RALPH EMERSON GOMEZ REU: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA., E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME, ARENA FOMENTO MERCANTIL LTDA, STARK BANK S.A. TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS AO EXMO. MAGISTRADO. NOVO HAMBURGO, 25 DE JUNHO DE 2020. ANDRESSA TRIERWEILER VISTOS OS AUTOS. NAO HA FALAR EM REVELIA, PORQUE NAO HOUVE O RETORNO DOS COMPROVANTES DE RECEBIMENTO DAS CARTAS DE CITACAO. AGUARDE-SE POR DEZ DIAS. NO SILENCIO, RENOVEM-SE AS CITACOES POR CARTA PRECATORIA. NOVO HAMBURGO/RS, 26 DE JUNHO DE 2020. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2020-06-26T11:00:34",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2020-06-26T11:00:34",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 AUTOR: RALPH EMERSON GOMEZ REU: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA., E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME, ARENA FOMENTO MERCANTIL LTDA, STARK BANK S.A. TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS AO EXMO. MAGISTRADO. NOVO HAMBURGO, 25 DE JUNHO DE 2020. ANDRESSA TRIERWEILER VISTOS OS AUTOS. NAO HA FALAR EM REVELIA, PORQUE NAO HOUVE O RETORNO DOS COMPROVANTES DE RECEBIMENTO DAS CARTAS DE CITACAO. AGUARDE-SE POR DEZ DIAS. NO SILENCIO, RENOVEM-SE AS CITACOES POR CARTA PRECATORIA. NOVO HAMBURGO/RS, 26 DE JUNHO DE 2020. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2020-06-26T11:00:34",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2020-06-26T11:00:34",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 AUTOR: RALPH EMERSON GOMEZ REU: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA., E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME, ARENA FOMENTO MERCANTIL LTDA, STARK BANK S.A. TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS AO EXMO. MAGISTRADO. NOVO HAMBURGO, 25 DE JUNHO DE 2020. ANDRESSA TRIERWEILER VISTOS OS AUTOS. NAO HA FALAR EM REVELIA, PORQUE NAO HOUVE O RETORNO DOS COMPROVANTES DE RECEBIMENTO DAS CARTAS DE CITACAO. AGUARDE-SE POR DEZ DIAS. NO SILENCIO, RENOVEM-SE AS CITACOES POR CARTA PRECATORIA. NOVO HAMBURGO/RS, 26 DE JUNHO DE 2020. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2020-06-26T11:00:34",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2020-06-26T11:00:34",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 AUTOR: RALPH EMERSON GOMEZ REU: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA., E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME, ARENA FOMENTO MERCANTIL LTDA, STARK BANK S.A. TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS AO EXMO. MAGISTRADO. NOVO HAMBURGO, 25 DE JUNHO DE 2020. ANDRESSA TRIERWEILER VISTOS OS AUTOS. NAO HA FALAR EM REVELIA, PORQUE NAO HOUVE O RETORNO DOS COMPROVANTES DE RECEBIMENTO DAS CARTAS DE CITACAO. AGUARDE-SE POR DEZ DIAS. NO SILENCIO, RENOVEM-SE AS CITACOES POR CARTA PRECATORIA. NOVO HAMBURGO/RS, 26 DE JUNHO DE 2020. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2020-06-26T11:00:34",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2020-06-26T11:00:34",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 AUTOR: RALPH EMERSON GOMEZ REU: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA., E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME, ARENA FOMENTO MERCANTIL LTDA, STARK BANK S.A. TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS AO EXMO. MAGISTRADO. NOVO HAMBURGO, 25 DE JUNHO DE 2020. ANDRESSA TRIERWEILER VISTOS OS AUTOS. NAO HA FALAR EM REVELIA, PORQUE NAO HOUVE O RETORNO DOS COMPROVANTES DE RECEBIMENTO DAS CARTAS DE CITACAO. AGUARDE-SE POR DEZ DIAS. NO SILENCIO, RENOVEM-SE AS CITACOES POR CARTA PRECATORIA. NOVO HAMBURGO/RS, 26 DE JUNHO DE 2020. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2020-06-26T11:00:34",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2020-06-26T11:00:34",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 AUTOR: RALPH EMERSON GOMEZ REU: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA., E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME, ARENA FOMENTO MERCANTIL LTDA, STARK BANK S.A. TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS AO EXMO. MAGISTRADO. NOVO HAMBURGO, 25 DE JUNHO DE 2020. ANDRESSA TRIERWEILER VISTOS OS AUTOS. NAO HA FALAR EM REVELIA, PORQUE NAO HOUVE O RETORNO DOS COMPROVANTES DE RECEBIMENTO DAS CARTAS DE CITACAO. AGUARDE-SE POR DEZ DIAS. NO SILENCIO, RENOVEM-SE AS CITACOES POR CARTA PRECATORIA. NOVO HAMBURGO/RS, 26 DE JUNHO DE 2020. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2020-06-26T11:00:34",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE",
                "PublishDate": "2020-06-26T11:00:34",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DESPACHO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 AUTOR: RALPH EMERSON GOMEZ REU: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA., E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME, ARENA FOMENTO MERCANTIL LTDA, STARK BANK S.A. TERMO DE CONCLUSAO NESTA DATA, FACO OS AUTOS CONCLUSOS AO EXMO. MAGISTRADO. NOVO HAMBURGO, 25 DE JUNHO DE 2020. ANDRESSA TRIERWEILER VISTOS OS AUTOS. NAO HA FALAR EM REVELIA, PORQUE NAO HOUVE O RETORNO DOS COMPROVANTES DE RECEBIMENTO DAS CARTAS DE CITACAO. AGUARDE-SE POR DEZ DIAS. NO SILENCIO, RENOVEM-SE AS CITACOES POR CARTA PRECATORIA. NOVO HAMBURGO/RS, 26 DE JUNHO DE 2020. THIAGO BOLDT DE SOUZA JUIZ DO TRABALHO SUBSTITUTO",
                "PublishDate": "2020-06-26T11:00:34",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "JUNTADA A PETICAO DE SOLICITACAO DE HABILITACAO (HABILITACAO)",
                "PublishDate": "2020-06-25T16:22:43",
                "CaptureDate": "2020-07-01T10:59:30"
              },
              {
                "Content": "JUNTADA A PETICAO DE SOLICITACAO DE HABILITACAO (HABILITACAO)",
                "PublishDate": "2020-06-25T16:22:43",
                "CaptureDate": "2020-08-20T22:59:52"
              },
              {
                "Content": "JUNTADA A PETICAO DE SOLICITACAO DE HABILITACAO (HABILITACAO)",
                "PublishDate": "2020-06-25T16:22:43",
                "CaptureDate": "2021-03-11T13:06:38"
              },
              {
                "Content": "JUNTADA A PETICAO DE SOLICITACAO DE HABILITACAO (HABILITACAO)",
                "PublishDate": "2020-06-25T16:22:43",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "JUNTADA A PETICAO DE SOLICITACAO DE HABILITACAO (HABILITACAO)",
                "PublishDate": "2020-06-25T16:22:43",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "JUNTADA A PETICAO DE SOLICITACAO DE HABILITACAO (HABILITACAO)",
                "PublishDate": "2020-06-25T16:22:43",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "JUNTADA A PETICAO DE SOLICITACAO DE HABILITACAO (HABILITACAO)",
                "PublishDate": "2020-06-25T16:22:43",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "JUNTADA A PETICAO DE SOLICITACAO DE HABILITACAO (HABILITACAO)",
                "PublishDate": "2020-06-25T16:22:43",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "JUNTADA A PETICAO DE SOLICITACAO DE HABILITACAO (HABILITACAO)",
                "PublishDate": "2020-06-25T16:22:43",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "JUNTADA A PETICAO DE SOLICITACAO DE HABILITACAO (HABILITACAO)",
                "PublishDate": "2020-06-25T16:22:43",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "JUNTADA A PETICAO DE SOLICITACAO DE HABILITACAO (HABILITACAO)",
                "PublishDate": "2020-06-25T16:22:43",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "JUNTADA A PETICAO DE SOLICITACAO DE HABILITACAO (HABILITACAO)",
                "PublishDate": "2020-06-25T16:22:43",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2020-06-25T13:59:03",
                "CaptureDate": "2020-07-01T10:59:30"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2020-06-25T13:59:03",
                "CaptureDate": "2020-08-20T22:59:52"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2020-06-25T13:59:03",
                "CaptureDate": "2021-03-11T13:06:38"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2020-06-25T13:59:03",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2020-06-25T13:59:03",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2020-06-25T13:59:03",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2020-06-25T13:59:03",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2020-06-25T13:59:03",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2020-06-25T13:59:03",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2020-06-25T13:59:03",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2020-06-25T13:59:03",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DESPACHO (GENERICA) A THIAGO BOLDT DE SOUZA",
                "PublishDate": "2020-06-25T13:59:03",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (PEDIDO DE REVELIA E LIMINAR)",
                "PublishDate": "2020-06-25T11:15:16",
                "CaptureDate": "2020-07-01T10:59:30"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (PEDIDO DE REVELIA E LIMINAR)",
                "PublishDate": "2020-06-25T11:15:16",
                "CaptureDate": "2020-08-20T22:59:52"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (PEDIDO DE REVELIA E LIMINAR)",
                "PublishDate": "2020-06-25T11:15:16",
                "CaptureDate": "2021-03-11T13:06:38"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (PEDIDO DE REVELIA E LIMINAR)",
                "PublishDate": "2020-06-25T11:15:16",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (PEDIDO DE REVELIA E LIMINAR)",
                "PublishDate": "2020-06-25T11:15:16",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (PEDIDO DE REVELIA E LIMINAR)",
                "PublishDate": "2020-06-25T11:15:16",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (PEDIDO DE REVELIA E LIMINAR)",
                "PublishDate": "2020-06-25T11:15:16",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (PEDIDO DE REVELIA E LIMINAR)",
                "PublishDate": "2020-06-25T11:15:16",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (PEDIDO DE REVELIA E LIMINAR)",
                "PublishDate": "2020-06-25T11:15:16",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (PEDIDO DE REVELIA E LIMINAR)",
                "PublishDate": "2020-06-25T11:15:16",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (PEDIDO DE REVELIA E LIMINAR)",
                "PublishDate": "2020-06-25T11:15:16",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "JUNTADA A PETICAO DE MANIFESTACAO (PEDIDO DE REVELIA E LIMINAR)",
                "PublishDate": "2020-06-25T11:15:16",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DECORRIDO O PRAZO DE STARK BANK S.A. EM 16/06/2020",
                "PublishDate": "2020-06-17T00:22:58",
                "CaptureDate": "2020-07-01T10:59:30"
              },
              {
                "Content": "DECORRIDO O PRAZO DE ARENA FOMENTO MERCANTIL LTDA EM 16/06/2020",
                "PublishDate": "2020-06-17T00:22:58",
                "CaptureDate": "2020-07-01T10:59:30"
              },
              {
                "Content": "DECORRIDO O PRAZO DE E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME EM 16/06/2020",
                "PublishDate": "2020-06-17T00:22:58",
                "CaptureDate": "2020-07-01T10:59:30"
              },
              {
                "Content": "DECORRIDO O PRAZO DE FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. EM 16/06/2020",
                "PublishDate": "2020-06-17T00:22:58",
                "CaptureDate": "2020-07-01T10:59:30"
              },
              {
                "Content": "DECORRIDO O PRAZO DE STARK BANK S.A. EM 16/06/2020",
                "PublishDate": "2020-06-17T00:22:58",
                "CaptureDate": "2020-08-20T22:59:52"
              },
              {
                "Content": "DECORRIDO O PRAZO DE ARENA FOMENTO MERCANTIL LTDA EM 16/06/2020",
                "PublishDate": "2020-06-17T00:22:58",
                "CaptureDate": "2020-08-20T22:59:52"
              },
              {
                "Content": "DECORRIDO O PRAZO DE E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME EM 16/06/2020",
                "PublishDate": "2020-06-17T00:22:58",
                "CaptureDate": "2020-08-20T22:59:52"
              },
              {
                "Content": "DECORRIDO O PRAZO DE FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. EM 16/06/2020",
                "PublishDate": "2020-06-17T00:22:58",
                "CaptureDate": "2020-08-20T22:59:52"
              },
              {
                "Content": "DECORRIDO O PRAZO DE STARK BANK S.A. EM 16/06/2020",
                "PublishDate": "2020-06-17T00:22:58",
                "CaptureDate": "2021-03-11T13:06:38"
              },
              {
                "Content": "DECORRIDO O PRAZO DE ARENA FOMENTO MERCANTIL LTDA EM 16/06/2020",
                "PublishDate": "2020-06-17T00:22:58",
                "CaptureDate": "2021-03-11T13:06:38"
              },
              {
                "Content": "DECORRIDO O PRAZO DE E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME EM 16/06/2020",
                "PublishDate": "2020-06-17T00:22:58",
                "CaptureDate": "2021-03-11T13:06:38"
              },
              {
                "Content": "DECORRIDO O PRAZO DE FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. EM 16/06/2020",
                "PublishDate": "2020-06-17T00:22:58",
                "CaptureDate": "2021-03-11T13:06:38"
              },
              {
                "Content": "DECORRIDO O PRAZO DE STARK BANK S.A. EM 16/06/2020",
                "PublishDate": "2020-06-17T00:22:58",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "DECORRIDO O PRAZO DE ARENA FOMENTO MERCANTIL LTDA EM 16/06/2020",
                "PublishDate": "2020-06-17T00:22:58",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "DECORRIDO O PRAZO DE E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME EM 16/06/2020",
                "PublishDate": "2020-06-17T00:22:58",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "DECORRIDO O PRAZO DE FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. EM 16/06/2020",
                "PublishDate": "2020-06-17T00:22:58",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "DECORRIDO O PRAZO DE STARK BANK S.A. EM 16/06/2020",
                "PublishDate": "2020-06-17T00:22:58",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "DECORRIDO O PRAZO DE ARENA FOMENTO MERCANTIL LTDA EM 16/06/2020",
                "PublishDate": "2020-06-17T00:22:58",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "DECORRIDO O PRAZO DE E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME EM 16/06/2020",
                "PublishDate": "2020-06-17T00:22:58",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "DECORRIDO O PRAZO DE FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. EM 16/06/2020",
                "PublishDate": "2020-06-17T00:22:58",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "DECORRIDO O PRAZO DE STARK BANK S.A. EM 16/06/2020",
                "PublishDate": "2020-06-17T00:22:58",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "DECORRIDO O PRAZO DE ARENA FOMENTO MERCANTIL LTDA EM 16/06/2020",
                "PublishDate": "2020-06-17T00:22:58",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "DECORRIDO O PRAZO DE E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME EM 16/06/2020",
                "PublishDate": "2020-06-17T00:22:58",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "DECORRIDO O PRAZO DE FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. EM 16/06/2020",
                "PublishDate": "2020-06-17T00:22:58",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "DECORRIDO O PRAZO DE STARK BANK S.A. EM 16/06/2020",
                "PublishDate": "2020-06-17T00:22:58",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "DECORRIDO O PRAZO DE ARENA FOMENTO MERCANTIL LTDA EM 16/06/2020",
                "PublishDate": "2020-06-17T00:22:58",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "DECORRIDO O PRAZO DE E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME EM 16/06/2020",
                "PublishDate": "2020-06-17T00:22:58",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "DECORRIDO O PRAZO DE FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. EM 16/06/2020",
                "PublishDate": "2020-06-17T00:22:58",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "DECORRIDO O PRAZO DE STARK BANK S.A. EM 16/06/2020",
                "PublishDate": "2020-06-17T00:22:58",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "DECORRIDO O PRAZO DE ARENA FOMENTO MERCANTIL LTDA EM 16/06/2020",
                "PublishDate": "2020-06-17T00:22:58",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "DECORRIDO O PRAZO DE E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME EM 16/06/2020",
                "PublishDate": "2020-06-17T00:22:58",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "DECORRIDO O PRAZO DE FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. EM 16/06/2020",
                "PublishDate": "2020-06-17T00:22:58",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "DECORRIDO O PRAZO DE STARK BANK S.A. EM 16/06/2020",
                "PublishDate": "2020-06-17T00:22:58",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "DECORRIDO O PRAZO DE ARENA FOMENTO MERCANTIL LTDA EM 16/06/2020",
                "PublishDate": "2020-06-17T00:22:58",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "DECORRIDO O PRAZO DE E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME EM 16/06/2020",
                "PublishDate": "2020-06-17T00:22:58",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "DECORRIDO O PRAZO DE FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. EM 16/06/2020",
                "PublishDate": "2020-06-17T00:22:58",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "DECORRIDO O PRAZO DE STARK BANK S.A. EM 16/06/2020",
                "PublishDate": "2020-06-17T00:22:58",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "DECORRIDO O PRAZO DE ARENA FOMENTO MERCANTIL LTDA EM 16/06/2020",
                "PublishDate": "2020-06-17T00:22:58",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "DECORRIDO O PRAZO DE E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME EM 16/06/2020",
                "PublishDate": "2020-06-17T00:22:58",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "DECORRIDO O PRAZO DE FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. EM 16/06/2020",
                "PublishDate": "2020-06-17T00:22:58",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "DECORRIDO O PRAZO DE STARK BANK S.A. EM 16/06/2020",
                "PublishDate": "2020-06-17T00:22:58",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DECORRIDO O PRAZO DE ARENA FOMENTO MERCANTIL LTDA EM 16/06/2020",
                "PublishDate": "2020-06-17T00:22:58",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DECORRIDO O PRAZO DE E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME EM 16/06/2020",
                "PublishDate": "2020-06-17T00:22:58",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DECORRIDO O PRAZO DE FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. EM 16/06/2020",
                "PublishDate": "2020-06-17T00:22:58",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DECORRIDO O PRAZO DE STARK BANK S.A. EM 16/06/2020",
                "PublishDate": "2020-06-17T00:22:58",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DECORRIDO O PRAZO DE ARENA FOMENTO MERCANTIL LTDA EM 16/06/2020",
                "PublishDate": "2020-06-17T00:22:58",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DECORRIDO O PRAZO DE E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME EM 16/06/2020",
                "PublishDate": "2020-06-17T00:22:58",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DECORRIDO O PRAZO DE FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA. EM 16/06/2020",
                "PublishDate": "2020-06-17T00:22:58",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) STARK BANK S.A.",
                "PublishDate": "2020-05-20T18:47:31",
                "CaptureDate": "2020-07-01T10:59:30"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) ARENA FOMENTO MERCANTIL LTDA",
                "PublishDate": "2020-05-20T18:47:31",
                "CaptureDate": "2020-07-01T10:59:30"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) STARK BANK S.A.",
                "PublishDate": "2020-05-20T18:47:31",
                "CaptureDate": "2020-08-20T22:59:52"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) ARENA FOMENTO MERCANTIL LTDA",
                "PublishDate": "2020-05-20T18:47:31",
                "CaptureDate": "2020-08-20T22:59:52"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) STARK BANK S.A.",
                "PublishDate": "2020-05-20T18:47:31",
                "CaptureDate": "2021-03-11T13:06:38"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) ARENA FOMENTO MERCANTIL LTDA",
                "PublishDate": "2020-05-20T18:47:31",
                "CaptureDate": "2021-03-11T13:06:38"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) STARK BANK S.A.",
                "PublishDate": "2020-05-20T18:47:31",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) ARENA FOMENTO MERCANTIL LTDA",
                "PublishDate": "2020-05-20T18:47:31",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) STARK BANK S.A.",
                "PublishDate": "2020-05-20T18:47:31",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) ARENA FOMENTO MERCANTIL LTDA",
                "PublishDate": "2020-05-20T18:47:31",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) STARK BANK S.A.",
                "PublishDate": "2020-05-20T18:47:31",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) ARENA FOMENTO MERCANTIL LTDA",
                "PublishDate": "2020-05-20T18:47:31",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) STARK BANK S.A.",
                "PublishDate": "2020-05-20T18:47:31",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) ARENA FOMENTO MERCANTIL LTDA",
                "PublishDate": "2020-05-20T18:47:31",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) STARK BANK S.A.",
                "PublishDate": "2020-05-20T18:47:31",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) ARENA FOMENTO MERCANTIL LTDA",
                "PublishDate": "2020-05-20T18:47:31",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) STARK BANK S.A.",
                "PublishDate": "2020-05-20T18:47:31",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) ARENA FOMENTO MERCANTIL LTDA",
                "PublishDate": "2020-05-20T18:47:31",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) STARK BANK S.A.",
                "PublishDate": "2020-05-20T18:47:31",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) ARENA FOMENTO MERCANTIL LTDA",
                "PublishDate": "2020-05-20T18:47:31",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) STARK BANK S.A.",
                "PublishDate": "2020-05-20T18:47:31",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) ARENA FOMENTO MERCANTIL LTDA",
                "PublishDate": "2020-05-20T18:47:31",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) STARK BANK S.A.",
                "PublishDate": "2020-05-20T18:47:31",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) ARENA FOMENTO MERCANTIL LTDA",
                "PublishDate": "2020-05-20T18:47:31",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME",
                "PublishDate": "2020-05-20T18:47:30",
                "CaptureDate": "2020-07-01T10:59:30"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME",
                "PublishDate": "2020-05-20T18:47:30",
                "CaptureDate": "2020-08-20T22:59:52"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME",
                "PublishDate": "2020-05-20T18:47:30",
                "CaptureDate": "2021-03-11T13:06:38"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME",
                "PublishDate": "2020-05-20T18:47:30",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME",
                "PublishDate": "2020-05-20T18:47:30",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME",
                "PublishDate": "2020-05-20T18:47:30",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME",
                "PublishDate": "2020-05-20T18:47:30",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME",
                "PublishDate": "2020-05-20T18:47:30",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME",
                "PublishDate": "2020-05-20T18:47:30",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME",
                "PublishDate": "2020-05-20T18:47:30",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME",
                "PublishDate": "2020-05-20T18:47:30",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME",
                "PublishDate": "2020-05-20T18:47:30",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA.",
                "PublishDate": "2020-05-20T18:47:29",
                "CaptureDate": "2020-07-01T10:59:30"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA.",
                "PublishDate": "2020-05-20T18:47:29",
                "CaptureDate": "2020-08-20T22:59:52"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA.",
                "PublishDate": "2020-05-20T18:47:29",
                "CaptureDate": "2021-03-11T13:06:38"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA.",
                "PublishDate": "2020-05-20T18:47:29",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA.",
                "PublishDate": "2020-05-20T18:47:29",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA.",
                "PublishDate": "2020-05-20T18:47:29",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA.",
                "PublishDate": "2020-05-20T18:47:29",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA.",
                "PublishDate": "2020-05-20T18:47:29",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA.",
                "PublishDate": "2020-05-20T18:47:29",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA.",
                "PublishDate": "2020-05-20T18:47:29",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA.",
                "PublishDate": "2020-05-20T18:47:29",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "EXPEDIDO(A) INTIMACAO A(O) FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA.",
                "PublishDate": "2020-05-20T18:47:29",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DECISAO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 AUTOR: RALPH EMERSON GOMEZ REU: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA., E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME, ARENA FOMENTO MERCANTIL LTDA, STARK BANK S.A. TERMO DE CONCLUSAO FACO OS AUTOS CONCLUSOS. CAROLINA LERNER VISTOS OS AUTOS. REQUER A PARTE AUTORA, EM TUTELA DE URGENCIA, QUE SEJA DETERMINADO O BLOQUEIO DE VALORES DAS RECLAMADAS, SUGERINDO QUE AS MESMAS POSSAM ESTAR EM VIAS DE INSOLVENCIA, BEM COMO QUE SEJA EXPEDIDO ALVARA PARA ENCAMINHAR O SEGURO-DESEMPREGO. POSTULA, AINDA, O RECONHECIMENTO DE VINCULO DE EMPREGO A PARTIR DE 1 DE JULHO DE 2019, REQUERENDO QUE SEJA DETERMINADA RESCISAO INDIRETA DO CONTRATO DE TRABALHO POR JUSTA CAUSA DAS RECLAMADAS. QUANTO AO PEDIDO DE BLOQUEIO DE VALORES PELO SISTEMA BACEN, CONSIDERANDO QUE NENHUM ELEMENTO DE CONVICCAO E APRESENTADO PELO RECLAMANTE PARA AMPARAR O RESPECTIVO PLEITO, INDEFIRO. QUANTO AO PEDIDO DE LIBERACAO DO ALVARA PARA ENCAMINHAMENTO DO SEGURO-DESEMPREGO, E IMPRESCINDIVEL A VERIFICACAO ACERCA DA EXISTENCIA DE VINCULO DE EMPREGO ENTRE AS PARTES, BEM COMO A MODALIDADE DE RESCISAO CONTRATUAL, O QUE SE MOSTRA IMPOSSIVEL EM NIVEL DE COGNICAO SUMARIA, PELO QUE INDEFIRO. CITEM-SE AS RECLAMADAS PARA APRESENTACAO DE DEFESAS, NO PRAZO DE 15 DIAS, NOS TERMOS DO ART. 335DO CPC E DO ART. 6 ATO N 11 DA CORREGEDORIA GERAL DA JUSTICA DO TRABALHO. NA MESMA OPORTUNIDADE, AS RECLAMADAS PODERAO APRESENTAR PROPOSTA(S) CONCILIATORIA(S). NO SILENCIO, VOLTEM CONCLUSOS. APRESENTADA AS DEFESAS, INTIME-SE A PARTE AUTORA, COM PRAZO DE QUINZE DIAS PARA MANIFESTACAO. NOVO HAMBURGO/RS, 20 DE MAIO DE 2020. ASSINADO ELETRONICAMENTE POR: ANDRE VASCONCELLOS VIEIRA - JUNTADO EM: 20/05/2020 15:01:46 - 0C0B6D9 ANDRE VASCONCELLOS VIEIRA JUIZ DO TRABALHO TITULAR",
                "PublishDate": "2020-05-20T15:01:46",
                "CaptureDate": "2020-07-01T10:59:30"
              },
              {
                "Content": "APRECIADA A TUTELA PROVISORIA",
                "PublishDate": "2020-05-20T15:01:46",
                "CaptureDate": "2020-07-01T10:59:30"
              },
              {
                "Content": "DECISAO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 AUTOR: RALPH EMERSON GOMEZ REU: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA., E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME, ARENA FOMENTO MERCANTIL LTDA, STARK BANK S.A. TERMO DE CONCLUSAO FACO OS AUTOS CONCLUSOS. CAROLINA LERNER VISTOS OS AUTOS. REQUER A PARTE AUTORA, EM TUTELA DE URGENCIA, QUE SEJA DETERMINADO O BLOQUEIO DE VALORES DAS RECLAMADAS, SUGERINDO QUE AS MESMAS POSSAM ESTAR EM VIAS DE INSOLVENCIA, BEM COMO QUE SEJA EXPEDIDO ALVARA PARA ENCAMINHAR O SEGURO-DESEMPREGO. POSTULA, AINDA, O RECONHECIMENTO DE VINCULO DE EMPREGO A PARTIR DE 1 DE JULHO DE 2019, REQUERENDO QUE SEJA DETERMINADA RESCISAO INDIRETA DO CONTRATO DE TRABALHO POR JUSTA CAUSA DAS RECLAMADAS. QUANTO AO PEDIDO DE BLOQUEIO DE VALORES PELO SISTEMA BACEN, CONSIDERANDO QUE NENHUM ELEMENTO DE CONVICCAO E APRESENTADO PELO RECLAMANTE PARA AMPARAR O RESPECTIVO PLEITO, INDEFIRO. QUANTO AO PEDIDO DE LIBERACAO DO ALVARA PARA ENCAMINHAMENTO DO SEGURO-DESEMPREGO, E IMPRESCINDIVEL A VERIFICACAO ACERCA DA EXISTENCIA DE VINCULO DE EMPREGO ENTRE AS PARTES, BEM COMO A MODALIDADE DE RESCISAO CONTRATUAL, O QUE SE MOSTRA IMPOSSIVEL EM NIVEL DE COGNICAO SUMARIA, PELO QUE INDEFIRO. CITEM-SE AS RECLAMADAS PARA APRESENTACAO DE DEFESAS, NO PRAZO DE 15 DIAS, NOS TERMOS DO ART. 335DO CPC E DO ART. 6 ATO N 11 DA CORREGEDORIA GERAL DA JUSTICA DO TRABALHO. NA MESMA OPORTUNIDADE, AS RECLAMADAS PODERAO APRESENTAR PROPOSTA(S) CONCILIATORIA(S). NO SILENCIO, VOLTEM CONCLUSOS. APRESENTADA AS DEFESAS, INTIME-SE A PARTE AUTORA, COM PRAZO DE QUINZE DIAS PARA MANIFESTACAO. NOVO HAMBURGO/RS, 20 DE MAIO DE 2020. ASSINADO ELETRONICAMENTE POR: ANDRE VASCONCELLOS VIEIRA - JUNTADO EM: 20/05/2020 15:01:46 - 0C0B6D9 ANDRE VASCONCELLOS VIEIRA JUIZ DO TRABALHO TITULAR",
                "PublishDate": "2020-05-20T15:01:46",
                "CaptureDate": "2020-08-20T22:59:52"
              },
              {
                "Content": "APRECIADA A TUTELA PROVISORIA",
                "PublishDate": "2020-05-20T15:01:46",
                "CaptureDate": "2020-08-20T22:59:52"
              },
              {
                "Content": "DECISAO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 AUTOR: RALPH EMERSON GOMEZ REU: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA., E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME, ARENA FOMENTO MERCANTIL LTDA, STARK BANK S.A. TERMO DE CONCLUSAO FACO OS AUTOS CONCLUSOS. CAROLINA LERNER VISTOS OS AUTOS. REQUER A PARTE AUTORA, EM TUTELA DE URGENCIA, QUE SEJA DETERMINADO O BLOQUEIO DE VALORES DAS RECLAMADAS, SUGERINDO QUE AS MESMAS POSSAM ESTAR EM VIAS DE INSOLVENCIA, BEM COMO QUE SEJA EXPEDIDO ALVARA PARA ENCAMINHAR O SEGURO-DESEMPREGO. POSTULA, AINDA, O RECONHECIMENTO DE VINCULO DE EMPREGO A PARTIR DE 1 DE JULHO DE 2019, REQUERENDO QUE SEJA DETERMINADA RESCISAO INDIRETA DO CONTRATO DE TRABALHO POR JUSTA CAUSA DAS RECLAMADAS. QUANTO AO PEDIDO DE BLOQUEIO DE VALORES PELO SISTEMA BACEN, CONSIDERANDO QUE NENHUM ELEMENTO DE CONVICCAO E APRESENTADO PELO RECLAMANTE PARA AMPARAR O RESPECTIVO PLEITO, INDEFIRO. QUANTO AO PEDIDO DE LIBERACAO DO ALVARA PARA ENCAMINHAMENTO DO SEGURO-DESEMPREGO, E IMPRESCINDIVEL A VERIFICACAO ACERCA DA EXISTENCIA DE VINCULO DE EMPREGO ENTRE AS PARTES, BEM COMO A MODALIDADE DE RESCISAO CONTRATUAL, O QUE SE MOSTRA IMPOSSIVEL EM NIVEL DE COGNICAO SUMARIA, PELO QUE INDEFIRO. CITEM-SE AS RECLAMADAS PARA APRESENTACAO DE DEFESAS, NO PRAZO DE 15 DIAS, NOS TERMOS DO ART. 335DO CPC E DO ART. 6 ATO N 11 DA CORREGEDORIA GERAL DA JUSTICA DO TRABALHO. NA MESMA OPORTUNIDADE, AS RECLAMADAS PODERAO APRESENTAR PROPOSTA(S) CONCILIATORIA(S). NO SILENCIO, VOLTEM CONCLUSOS. APRESENTADA AS DEFESAS, INTIME-SE A PARTE AUTORA, COM PRAZO DE QUINZE DIAS PARA MANIFESTACAO. NOVO HAMBURGO/RS, 20 DE MAIO DE 2020. ASSINADO ELETRONICAMENTE POR: ANDRE VASCONCELLOS VIEIRA - JUNTADO EM: 20/05/2020 15:01:46 - 0C0B6D9 ANDRE VASCONCELLOS VIEIRA JUIZ DO TRABALHO TITULAR",
                "PublishDate": "2020-05-20T15:01:46",
                "CaptureDate": "2021-03-11T13:06:38"
              },
              {
                "Content": "APRECIADA A TUTELA PROVISORIA",
                "PublishDate": "2020-05-20T15:01:46",
                "CaptureDate": "2021-03-11T13:06:38"
              },
              {
                "Content": "APRECIADA A TUTELA PROVISORIA",
                "PublishDate": "2020-05-20T15:01:46",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "DECISAO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 AUTOR: RALPH EMERSON GOMEZ REU: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA., E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME, ARENA FOMENTO MERCANTIL LTDA, STARK BANK S.A. TERMO DE CONCLUSAO FACO OS AUTOS CONCLUSOS. CAROLINA LERNER VISTOS OS AUTOS. REQUER A PARTE AUTORA, EM TUTELA DE URGENCIA, QUE SEJA DETERMINADO O BLOQUEIO DE VALORES DAS RECLAMADAS, SUGERINDO QUE AS MESMAS POSSAM ESTAR EM VIAS DE INSOLVENCIA, BEM COMO QUE SEJA EXPEDIDO ALVARA PARA ENCAMINHAR O SEGURO-DESEMPREGO. POSTULA, AINDA, O RECONHECIMENTO DE VINCULO DE EMPREGO A PARTIR DE 1 DE JULHO DE 2019, REQUERENDO QUE SEJA DETERMINADA RESCISAO INDIRETA DO CONTRATO DE TRABALHO POR JUSTA CAUSA DAS RECLAMADAS. QUANTO AO PEDIDO DE BLOQUEIO DE VALORES PELO SISTEMA BACEN, CONSIDERANDO QUE NENHUM ELEMENTO DE CONVICCAO E APRESENTADO PELO RECLAMANTE PARA AMPARAR O RESPECTIVO PLEITO, INDEFIRO. QUANTO AO PEDIDO DE LIBERACAO DO ALVARA PARA ENCAMINHAMENTO DO SEGURO-DESEMPREGO, E IMPRESCINDIVEL A VERIFICACAO ACERCA DA EXISTENCIA DE VINCULO DE EMPREGO ENTRE AS PARTES, BEM COMO A MODALIDADE DE RESCISAO CONTRATUAL, O QUE SE MOSTRA IMPOSSIVEL EM NIVEL DE COGNICAO SUMARIA, PELO QUE INDEFIRO. CITEM-SE AS RECLAMADAS PARA APRESENTACAO DE DEFESAS, NO PRAZO DE 15 DIAS, NOS TERMOS DO ART. 335DO CPC E DO ART. 6 ATO N 11 DA CORREGEDORIA GERAL DA JUSTICA DO TRABALHO. NA MESMA OPORTUNIDADE, AS RECLAMADAS PODERAO APRESENTAR PROPOSTA(S) CONCILIATORIA(S). NO SILENCIO, VOLTEM CONCLUSOS. APRESENTADA AS DEFESAS, INTIME-SE A PARTE AUTORA, COM PRAZO DE QUINZE DIAS PARA MANIFESTACAO. NOVO HAMBURGO/RS, 20 DE MAIO DE 2020. ASSINADO ELETRONICAMENTE POR: ANDRE VASCONCELLOS VIEIRA - JUNTADO EM: 20/05/2020 15:01:46 - 0C0B6D9 ANDRE VASCONCELLOS VIEIRA JUIZ DO TRABALHO TITULAR",
                "PublishDate": "2020-05-20T15:01:46",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "APRECIADA A TUTELA PROVISORIA",
                "PublishDate": "2020-05-20T15:01:46",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "DECISAO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 AUTOR: RALPH EMERSON GOMEZ REU: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA., E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME, ARENA FOMENTO MERCANTIL LTDA, STARK BANK S.A. TERMO DE CONCLUSAO FACO OS AUTOS CONCLUSOS. CAROLINA LERNER VISTOS OS AUTOS. REQUER A PARTE AUTORA, EM TUTELA DE URGENCIA, QUE SEJA DETERMINADO O BLOQUEIO DE VALORES DAS RECLAMADAS, SUGERINDO QUE AS MESMAS POSSAM ESTAR EM VIAS DE INSOLVENCIA, BEM COMO QUE SEJA EXPEDIDO ALVARA PARA ENCAMINHAR O SEGURO-DESEMPREGO. POSTULA, AINDA, O RECONHECIMENTO DE VINCULO DE EMPREGO A PARTIR DE 1 DE JULHO DE 2019, REQUERENDO QUE SEJA DETERMINADA RESCISAO INDIRETA DO CONTRATO DE TRABALHO POR JUSTA CAUSA DAS RECLAMADAS. QUANTO AO PEDIDO DE BLOQUEIO DE VALORES PELO SISTEMA BACEN, CONSIDERANDO QUE NENHUM ELEMENTO DE CONVICCAO E APRESENTADO PELO RECLAMANTE PARA AMPARAR O RESPECTIVO PLEITO, INDEFIRO. QUANTO AO PEDIDO DE LIBERACAO DO ALVARA PARA ENCAMINHAMENTO DO SEGURO-DESEMPREGO, E IMPRESCINDIVEL A VERIFICACAO ACERCA DA EXISTENCIA DE VINCULO DE EMPREGO ENTRE AS PARTES, BEM COMO A MODALIDADE DE RESCISAO CONTRATUAL, O QUE SE MOSTRA IMPOSSIVEL EM NIVEL DE COGNICAO SUMARIA, PELO QUE INDEFIRO. CITEM-SE AS RECLAMADAS PARA APRESENTACAO DE DEFESAS, NO PRAZO DE 15 DIAS, NOS TERMOS DO ART. 335DO CPC E DO ART. 6 ATO N 11 DA CORREGEDORIA GERAL DA JUSTICA DO TRABALHO. NA MESMA OPORTUNIDADE, AS RECLAMADAS PODERAO APRESENTAR PROPOSTA(S) CONCILIATORIA(S). NO SILENCIO, VOLTEM CONCLUSOS. APRESENTADA AS DEFESAS, INTIME-SE A PARTE AUTORA, COM PRAZO DE QUINZE DIAS PARA MANIFESTACAO. NOVO HAMBURGO/RS, 20 DE MAIO DE 2020. ASSINADO ELETRONICAMENTE POR: ANDRE VASCONCELLOS VIEIRA - JUNTADO EM: 20/05/2020 15:01:46 - 0C0B6D9 ANDRE VASCONCELLOS VIEIRA JUIZ DO TRABALHO TITULAR",
                "PublishDate": "2020-05-20T15:01:46",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "APRECIADA A TUTELA PROVISORIA",
                "PublishDate": "2020-05-20T15:01:46",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "DECISAO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 AUTOR: RALPH EMERSON GOMEZ REU: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA., E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME, ARENA FOMENTO MERCANTIL LTDA, STARK BANK S.A. TERMO DE CONCLUSAO FACO OS AUTOS CONCLUSOS. CAROLINA LERNER VISTOS OS AUTOS. REQUER A PARTE AUTORA, EM TUTELA DE URGENCIA, QUE SEJA DETERMINADO O BLOQUEIO DE VALORES DAS RECLAMADAS, SUGERINDO QUE AS MESMAS POSSAM ESTAR EM VIAS DE INSOLVENCIA, BEM COMO QUE SEJA EXPEDIDO ALVARA PARA ENCAMINHAR O SEGURO-DESEMPREGO. POSTULA, AINDA, O RECONHECIMENTO DE VINCULO DE EMPREGO A PARTIR DE 1 DE JULHO DE 2019, REQUERENDO QUE SEJA DETERMINADA RESCISAO INDIRETA DO CONTRATO DE TRABALHO POR JUSTA CAUSA DAS RECLAMADAS. QUANTO AO PEDIDO DE BLOQUEIO DE VALORES PELO SISTEMA BACEN, CONSIDERANDO QUE NENHUM ELEMENTO DE CONVICCAO E APRESENTADO PELO RECLAMANTE PARA AMPARAR O RESPECTIVO PLEITO, INDEFIRO. QUANTO AO PEDIDO DE LIBERACAO DO ALVARA PARA ENCAMINHAMENTO DO SEGURO-DESEMPREGO, E IMPRESCINDIVEL A VERIFICACAO ACERCA DA EXISTENCIA DE VINCULO DE EMPREGO ENTRE AS PARTES, BEM COMO A MODALIDADE DE RESCISAO CONTRATUAL, O QUE SE MOSTRA IMPOSSIVEL EM NIVEL DE COGNICAO SUMARIA, PELO QUE INDEFIRO. CITEM-SE AS RECLAMADAS PARA APRESENTACAO DE DEFESAS, NO PRAZO DE 15 DIAS, NOS TERMOS DO ART. 335DO CPC E DO ART. 6 ATO N 11 DA CORREGEDORIA GERAL DA JUSTICA DO TRABALHO. NA MESMA OPORTUNIDADE, AS RECLAMADAS PODERAO APRESENTAR PROPOSTA(S) CONCILIATORIA(S). NO SILENCIO, VOLTEM CONCLUSOS. APRESENTADA AS DEFESAS, INTIME-SE A PARTE AUTORA, COM PRAZO DE QUINZE DIAS PARA MANIFESTACAO. NOVO HAMBURGO/RS, 20 DE MAIO DE 2020. ASSINADO ELETRONICAMENTE POR: ANDRE VASCONCELLOS VIEIRA - JUNTADO EM: 20/05/2020 15:01:46 - 0C0B6D9 ANDRE VASCONCELLOS VIEIRA JUIZ DO TRABALHO TITULAR",
                "PublishDate": "2020-05-20T15:01:46",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "APRECIADA A TUTELA PROVISORIA",
                "PublishDate": "2020-05-20T15:01:46",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "DECISAO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 AUTOR: RALPH EMERSON GOMEZ REU: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA., E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME, ARENA FOMENTO MERCANTIL LTDA, STARK BANK S.A. TERMO DE CONCLUSAO FACO OS AUTOS CONCLUSOS. CAROLINA LERNER VISTOS OS AUTOS. REQUER A PARTE AUTORA, EM TUTELA DE URGENCIA, QUE SEJA DETERMINADO O BLOQUEIO DE VALORES DAS RECLAMADAS, SUGERINDO QUE AS MESMAS POSSAM ESTAR EM VIAS DE INSOLVENCIA, BEM COMO QUE SEJA EXPEDIDO ALVARA PARA ENCAMINHAR O SEGURO-DESEMPREGO. POSTULA, AINDA, O RECONHECIMENTO DE VINCULO DE EMPREGO A PARTIR DE 1 DE JULHO DE 2019, REQUERENDO QUE SEJA DETERMINADA RESCISAO INDIRETA DO CONTRATO DE TRABALHO POR JUSTA CAUSA DAS RECLAMADAS. QUANTO AO PEDIDO DE BLOQUEIO DE VALORES PELO SISTEMA BACEN, CONSIDERANDO QUE NENHUM ELEMENTO DE CONVICCAO E APRESENTADO PELO RECLAMANTE PARA AMPARAR O RESPECTIVO PLEITO, INDEFIRO. QUANTO AO PEDIDO DE LIBERACAO DO ALVARA PARA ENCAMINHAMENTO DO SEGURO-DESEMPREGO, E IMPRESCINDIVEL A VERIFICACAO ACERCA DA EXISTENCIA DE VINCULO DE EMPREGO ENTRE AS PARTES, BEM COMO A MODALIDADE DE RESCISAO CONTRATUAL, O QUE SE MOSTRA IMPOSSIVEL EM NIVEL DE COGNICAO SUMARIA, PELO QUE INDEFIRO. CITEM-SE AS RECLAMADAS PARA APRESENTACAO DE DEFESAS, NO PRAZO DE 15 DIAS, NOS TERMOS DO ART. 335DO CPC E DO ART. 6 ATO N 11 DA CORREGEDORIA GERAL DA JUSTICA DO TRABALHO. NA MESMA OPORTUNIDADE, AS RECLAMADAS PODERAO APRESENTAR PROPOSTA(S) CONCILIATORIA(S). NO SILENCIO, VOLTEM CONCLUSOS. APRESENTADA AS DEFESAS, INTIME-SE A PARTE AUTORA, COM PRAZO DE QUINZE DIAS PARA MANIFESTACAO. NOVO HAMBURGO/RS, 20 DE MAIO DE 2020. ASSINADO ELETRONICAMENTE POR: ANDRE VASCONCELLOS VIEIRA - JUNTADO EM: 20/05/2020 15:01:46 - 0C0B6D9 ANDRE VASCONCELLOS VIEIRA JUIZ DO TRABALHO TITULAR",
                "PublishDate": "2020-05-20T15:01:46",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "APRECIADA A TUTELA PROVISORIA",
                "PublishDate": "2020-05-20T15:01:46",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "DECISAO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 AUTOR: RALPH EMERSON GOMEZ REU: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA., E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME, ARENA FOMENTO MERCANTIL LTDA, STARK BANK S.A. TERMO DE CONCLUSAO FACO OS AUTOS CONCLUSOS. CAROLINA LERNER VISTOS OS AUTOS. REQUER A PARTE AUTORA, EM TUTELA DE URGENCIA, QUE SEJA DETERMINADO O BLOQUEIO DE VALORES DAS RECLAMADAS, SUGERINDO QUE AS MESMAS POSSAM ESTAR EM VIAS DE INSOLVENCIA, BEM COMO QUE SEJA EXPEDIDO ALVARA PARA ENCAMINHAR O SEGURO-DESEMPREGO. POSTULA, AINDA, O RECONHECIMENTO DE VINCULO DE EMPREGO A PARTIR DE 1 DE JULHO DE 2019, REQUERENDO QUE SEJA DETERMINADA RESCISAO INDIRETA DO CONTRATO DE TRABALHO POR JUSTA CAUSA DAS RECLAMADAS. QUANTO AO PEDIDO DE BLOQUEIO DE VALORES PELO SISTEMA BACEN, CONSIDERANDO QUE NENHUM ELEMENTO DE CONVICCAO E APRESENTADO PELO RECLAMANTE PARA AMPARAR O RESPECTIVO PLEITO, INDEFIRO. QUANTO AO PEDIDO DE LIBERACAO DO ALVARA PARA ENCAMINHAMENTO DO SEGURO-DESEMPREGO, E IMPRESCINDIVEL A VERIFICACAO ACERCA DA EXISTENCIA DE VINCULO DE EMPREGO ENTRE AS PARTES, BEM COMO A MODALIDADE DE RESCISAO CONTRATUAL, O QUE SE MOSTRA IMPOSSIVEL EM NIVEL DE COGNICAO SUMARIA, PELO QUE INDEFIRO. CITEM-SE AS RECLAMADAS PARA APRESENTACAO DE DEFESAS, NO PRAZO DE 15 DIAS, NOS TERMOS DO ART. 335DO CPC E DO ART. 6 ATO N 11 DA CORREGEDORIA GERAL DA JUSTICA DO TRABALHO. NA MESMA OPORTUNIDADE, AS RECLAMADAS PODERAO APRESENTAR PROPOSTA(S) CONCILIATORIA(S). NO SILENCIO, VOLTEM CONCLUSOS. APRESENTADA AS DEFESAS, INTIME-SE A PARTE AUTORA, COM PRAZO DE QUINZE DIAS PARA MANIFESTACAO. NOVO HAMBURGO/RS, 20 DE MAIO DE 2020. ASSINADO ELETRONICAMENTE POR: ANDRE VASCONCELLOS VIEIRA - JUNTADO EM: 20/05/2020 15:01:46 - 0C0B6D9 ANDRE VASCONCELLOS VIEIRA JUIZ DO TRABALHO TITULAR",
                "PublishDate": "2020-05-20T15:01:46",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "APRECIADA A TUTELA PROVISORIA",
                "PublishDate": "2020-05-20T15:01:46",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "DECISAO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 AUTOR: RALPH EMERSON GOMEZ REU: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA., E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME, ARENA FOMENTO MERCANTIL LTDA, STARK BANK S.A. TERMO DE CONCLUSAO FACO OS AUTOS CONCLUSOS. CAROLINA LERNER VISTOS OS AUTOS. REQUER A PARTE AUTORA, EM TUTELA DE URGENCIA, QUE SEJA DETERMINADO O BLOQUEIO DE VALORES DAS RECLAMADAS, SUGERINDO QUE AS MESMAS POSSAM ESTAR EM VIAS DE INSOLVENCIA, BEM COMO QUE SEJA EXPEDIDO ALVARA PARA ENCAMINHAR O SEGURO-DESEMPREGO. POSTULA, AINDA, O RECONHECIMENTO DE VINCULO DE EMPREGO A PARTIR DE 1 DE JULHO DE 2019, REQUERENDO QUE SEJA DETERMINADA RESCISAO INDIRETA DO CONTRATO DE TRABALHO POR JUSTA CAUSA DAS RECLAMADAS. QUANTO AO PEDIDO DE BLOQUEIO DE VALORES PELO SISTEMA BACEN, CONSIDERANDO QUE NENHUM ELEMENTO DE CONVICCAO E APRESENTADO PELO RECLAMANTE PARA AMPARAR O RESPECTIVO PLEITO, INDEFIRO. QUANTO AO PEDIDO DE LIBERACAO DO ALVARA PARA ENCAMINHAMENTO DO SEGURO-DESEMPREGO, E IMPRESCINDIVEL A VERIFICACAO ACERCA DA EXISTENCIA DE VINCULO DE EMPREGO ENTRE AS PARTES, BEM COMO A MODALIDADE DE RESCISAO CONTRATUAL, O QUE SE MOSTRA IMPOSSIVEL EM NIVEL DE COGNICAO SUMARIA, PELO QUE INDEFIRO. CITEM-SE AS RECLAMADAS PARA APRESENTACAO DE DEFESAS, NO PRAZO DE 15 DIAS, NOS TERMOS DO ART. 335DO CPC E DO ART. 6 ATO N 11 DA CORREGEDORIA GERAL DA JUSTICA DO TRABALHO. NA MESMA OPORTUNIDADE, AS RECLAMADAS PODERAO APRESENTAR PROPOSTA(S) CONCILIATORIA(S). NO SILENCIO, VOLTEM CONCLUSOS. APRESENTADA AS DEFESAS, INTIME-SE A PARTE AUTORA, COM PRAZO DE QUINZE DIAS PARA MANIFESTACAO. NOVO HAMBURGO/RS, 20 DE MAIO DE 2020. ASSINADO ELETRONICAMENTE POR: ANDRE VASCONCELLOS VIEIRA - JUNTADO EM: 20/05/2020 15:01:46 - 0C0B6D9 ANDRE VASCONCELLOS VIEIRA JUIZ DO TRABALHO TITULAR",
                "PublishDate": "2020-05-20T15:01:46",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "APRECIADA A TUTELA PROVISORIA",
                "PublishDate": "2020-05-20T15:01:46",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "DECISAO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 AUTOR: RALPH EMERSON GOMEZ REU: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA., E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME, ARENA FOMENTO MERCANTIL LTDA, STARK BANK S.A. TERMO DE CONCLUSAO FACO OS AUTOS CONCLUSOS. CAROLINA LERNER VISTOS OS AUTOS. REQUER A PARTE AUTORA, EM TUTELA DE URGENCIA, QUE SEJA DETERMINADO O BLOQUEIO DE VALORES DAS RECLAMADAS, SUGERINDO QUE AS MESMAS POSSAM ESTAR EM VIAS DE INSOLVENCIA, BEM COMO QUE SEJA EXPEDIDO ALVARA PARA ENCAMINHAR O SEGURO-DESEMPREGO. POSTULA, AINDA, O RECONHECIMENTO DE VINCULO DE EMPREGO A PARTIR DE 1 DE JULHO DE 2019, REQUERENDO QUE SEJA DETERMINADA RESCISAO INDIRETA DO CONTRATO DE TRABALHO POR JUSTA CAUSA DAS RECLAMADAS. QUANTO AO PEDIDO DE BLOQUEIO DE VALORES PELO SISTEMA BACEN, CONSIDERANDO QUE NENHUM ELEMENTO DE CONVICCAO E APRESENTADO PELO RECLAMANTE PARA AMPARAR O RESPECTIVO PLEITO, INDEFIRO. QUANTO AO PEDIDO DE LIBERACAO DO ALVARA PARA ENCAMINHAMENTO DO SEGURO-DESEMPREGO, E IMPRESCINDIVEL A VERIFICACAO ACERCA DA EXISTENCIA DE VINCULO DE EMPREGO ENTRE AS PARTES, BEM COMO A MODALIDADE DE RESCISAO CONTRATUAL, O QUE SE MOSTRA IMPOSSIVEL EM NIVEL DE COGNICAO SUMARIA, PELO QUE INDEFIRO. CITEM-SE AS RECLAMADAS PARA APRESENTACAO DE DEFESAS, NO PRAZO DE 15 DIAS, NOS TERMOS DO ART. 335DO CPC E DO ART. 6 ATO N 11 DA CORREGEDORIA GERAL DA JUSTICA DO TRABALHO. NA MESMA OPORTUNIDADE, AS RECLAMADAS PODERAO APRESENTAR PROPOSTA(S) CONCILIATORIA(S). NO SILENCIO, VOLTEM CONCLUSOS. APRESENTADA AS DEFESAS, INTIME-SE A PARTE AUTORA, COM PRAZO DE QUINZE DIAS PARA MANIFESTACAO. NOVO HAMBURGO/RS, 20 DE MAIO DE 2020. ASSINADO ELETRONICAMENTE POR: ANDRE VASCONCELLOS VIEIRA - JUNTADO EM: 20/05/2020 15:01:46 - 0C0B6D9 ANDRE VASCONCELLOS VIEIRA JUIZ DO TRABALHO TITULAR",
                "PublishDate": "2020-05-20T15:01:46",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "APRECIADA A TUTELA PROVISORIA",
                "PublishDate": "2020-05-20T15:01:46",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DECISAO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 AUTOR: RALPH EMERSON GOMEZ REU: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA., E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME, ARENA FOMENTO MERCANTIL LTDA, STARK BANK S.A. TERMO DE CONCLUSAO FACO OS AUTOS CONCLUSOS. CAROLINA LERNER VISTOS OS AUTOS. REQUER A PARTE AUTORA, EM TUTELA DE URGENCIA, QUE SEJA DETERMINADO O BLOQUEIO DE VALORES DAS RECLAMADAS, SUGERINDO QUE AS MESMAS POSSAM ESTAR EM VIAS DE INSOLVENCIA, BEM COMO QUE SEJA EXPEDIDO ALVARA PARA ENCAMINHAR O SEGURO-DESEMPREGO. POSTULA, AINDA, O RECONHECIMENTO DE VINCULO DE EMPREGO A PARTIR DE 1 DE JULHO DE 2019, REQUERENDO QUE SEJA DETERMINADA RESCISAO INDIRETA DO CONTRATO DE TRABALHO POR JUSTA CAUSA DAS RECLAMADAS. QUANTO AO PEDIDO DE BLOQUEIO DE VALORES PELO SISTEMA BACEN, CONSIDERANDO QUE NENHUM ELEMENTO DE CONVICCAO E APRESENTADO PELO RECLAMANTE PARA AMPARAR O RESPECTIVO PLEITO, INDEFIRO. QUANTO AO PEDIDO DE LIBERACAO DO ALVARA PARA ENCAMINHAMENTO DO SEGURO-DESEMPREGO, E IMPRESCINDIVEL A VERIFICACAO ACERCA DA EXISTENCIA DE VINCULO DE EMPREGO ENTRE AS PARTES, BEM COMO A MODALIDADE DE RESCISAO CONTRATUAL, O QUE SE MOSTRA IMPOSSIVEL EM NIVEL DE COGNICAO SUMARIA, PELO QUE INDEFIRO. CITEM-SE AS RECLAMADAS PARA APRESENTACAO DE DEFESAS, NO PRAZO DE 15 DIAS, NOS TERMOS DO ART. 335DO CPC E DO ART. 6 ATO N 11 DA CORREGEDORIA GERAL DA JUSTICA DO TRABALHO. NA MESMA OPORTUNIDADE, AS RECLAMADAS PODERAO APRESENTAR PROPOSTA(S) CONCILIATORIA(S). NO SILENCIO, VOLTEM CONCLUSOS. APRESENTADA AS DEFESAS, INTIME-SE A PARTE AUTORA, COM PRAZO DE QUINZE DIAS PARA MANIFESTACAO. NOVO HAMBURGO/RS, 20 DE MAIO DE 2020. ASSINADO ELETRONICAMENTE POR: ANDRE VASCONCELLOS VIEIRA - JUNTADO EM: 20/05/2020 15:01:46 - 0C0B6D9 ANDRE VASCONCELLOS VIEIRA JUIZ DO TRABALHO TITULAR",
                "PublishDate": "2020-05-20T15:01:46",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "APRECIADA A TUTELA PROVISORIA",
                "PublishDate": "2020-05-20T15:01:46",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DECISAO PODER JUDICIARIO JUSTICA DO TRABALHO TRIBUNAL REGIONAL DO TRABALHO DA 4 REGIAO 3 VARA DO TRABALHO DE NOVO HAMBURGO ATORD 0020269-90.2020.5.04.0303 AUTOR: RALPH EMERSON GOMEZ REU: FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA., E.A. ROCHA - FORTS ESCRITORIO IMOBILIARIO EIRELI - ME, ARENA FOMENTO MERCANTIL LTDA, STARK BANK S.A. TERMO DE CONCLUSAO FACO OS AUTOS CONCLUSOS. CAROLINA LERNER VISTOS OS AUTOS. REQUER A PARTE AUTORA, EM TUTELA DE URGENCIA, QUE SEJA DETERMINADO O BLOQUEIO DE VALORES DAS RECLAMADAS, SUGERINDO QUE AS MESMAS POSSAM ESTAR EM VIAS DE INSOLVENCIA, BEM COMO QUE SEJA EXPEDIDO ALVARA PARA ENCAMINHAR O SEGURO-DESEMPREGO. POSTULA, AINDA, O RECONHECIMENTO DE VINCULO DE EMPREGO A PARTIR DE 1 DE JULHO DE 2019, REQUERENDO QUE SEJA DETERMINADA RESCISAO INDIRETA DO CONTRATO DE TRABALHO POR JUSTA CAUSA DAS RECLAMADAS. QUANTO AO PEDIDO DE BLOQUEIO DE VALORES PELO SISTEMA BACEN, CONSIDERANDO QUE NENHUM ELEMENTO DE CONVICCAO E APRESENTADO PELO RECLAMANTE PARA AMPARAR O RESPECTIVO PLEITO, INDEFIRO. QUANTO AO PEDIDO DE LIBERACAO DO ALVARA PARA ENCAMINHAMENTO DO SEGURO-DESEMPREGO, E IMPRESCINDIVEL A VERIFICACAO ACERCA DA EXISTENCIA DE VINCULO DE EMPREGO ENTRE AS PARTES, BEM COMO A MODALIDADE DE RESCISAO CONTRATUAL, O QUE SE MOSTRA IMPOSSIVEL EM NIVEL DE COGNICAO SUMARIA, PELO QUE INDEFIRO. CITEM-SE AS RECLAMADAS PARA APRESENTACAO DE DEFESAS, NO PRAZO DE 15 DIAS, NOS TERMOS DO ART. 335DO CPC E DO ART. 6 ATO N 11 DA CORREGEDORIA GERAL DA JUSTICA DO TRABALHO. NA MESMA OPORTUNIDADE, AS RECLAMADAS PODERAO APRESENTAR PROPOSTA(S) CONCILIATORIA(S). NO SILENCIO, VOLTEM CONCLUSOS. APRESENTADA AS DEFESAS, INTIME-SE A PARTE AUTORA, COM PRAZO DE QUINZE DIAS PARA MANIFESTACAO. NOVO HAMBURGO/RS, 20 DE MAIO DE 2020. ASSINADO ELETRONICAMENTE POR: ANDRE VASCONCELLOS VIEIRA - JUNTADO EM: 20/05/2020 15:01:46 - 0C0B6D9 ANDRE VASCONCELLOS VIEIRA JUIZ DO TRABALHO TITULAR",
                "PublishDate": "2020-05-20T15:01:46",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DECISAO DE PEDIDO DE TUTELA A ANDRE VASCONCELLOS VIEIRA",
                "PublishDate": "2020-05-20T11:04:15",
                "CaptureDate": "2020-07-01T10:59:30"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DECISAO DE PEDIDO DE TUTELA A ANDRE VASCONCELLOS VIEIRA",
                "PublishDate": "2020-05-20T11:04:15",
                "CaptureDate": "2020-08-20T22:59:52"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DECISAO DE PEDIDO DE TUTELA A ANDRE VASCONCELLOS VIEIRA",
                "PublishDate": "2020-05-20T11:04:15",
                "CaptureDate": "2021-03-11T13:06:38"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DECISAO DE PEDIDO DE TUTELA A ANDRE VASCONCELLOS VIEIRA",
                "PublishDate": "2020-05-20T11:04:15",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DECISAO DE PEDIDO DE TUTELA A ANDRE VASCONCELLOS VIEIRA",
                "PublishDate": "2020-05-20T11:04:15",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DECISAO DE PEDIDO DE TUTELA A ANDRE VASCONCELLOS VIEIRA",
                "PublishDate": "2020-05-20T11:04:15",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DECISAO DE PEDIDO DE TUTELA A ANDRE VASCONCELLOS VIEIRA",
                "PublishDate": "2020-05-20T11:04:15",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DECISAO DE PEDIDO DE TUTELA A ANDRE VASCONCELLOS VIEIRA",
                "PublishDate": "2020-05-20T11:04:15",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DECISAO DE PEDIDO DE TUTELA A ANDRE VASCONCELLOS VIEIRA",
                "PublishDate": "2020-05-20T11:04:15",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DECISAO DE PEDIDO DE TUTELA A ANDRE VASCONCELLOS VIEIRA",
                "PublishDate": "2020-05-20T11:04:15",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DECISAO DE PEDIDO DE TUTELA A ANDRE VASCONCELLOS VIEIRA",
                "PublishDate": "2020-05-20T11:04:15",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "CONCLUSOS OS AUTOS PARA DECISAO DE PEDIDO DE TUTELA A ANDRE VASCONCELLOS VIEIRA",
                "PublishDate": "2020-05-20T11:04:15",
                "CaptureDate": "2022-11-17T10:54:25"
              },
              {
                "Content": "DISTRIBUIDO POR SORTEIO",
                "PublishDate": "2020-05-19T11:45:55",
                "CaptureDate": "2020-07-01T10:59:30"
              },
              {
                "Content": "DISTRIBUIDO POR SORTEIO",
                "PublishDate": "2020-05-19T11:45:55",
                "CaptureDate": "2020-08-20T22:59:52"
              },
              {
                "Content": "DISTRIBUIDO POR SORTEIO",
                "PublishDate": "2020-05-19T11:45:55",
                "CaptureDate": "2021-03-11T13:06:38"
              },
              {
                "Content": "DISTRIBUIDO POR SORTEIO",
                "PublishDate": "2020-05-19T11:45:55",
                "CaptureDate": "2021-07-14T18:50:14"
              },
              {
                "Content": "DISTRIBUIDO POR SORTEIO",
                "PublishDate": "2020-05-19T11:45:55",
                "CaptureDate": "2021-08-08T06:22:21"
              },
              {
                "Content": "DISTRIBUIDO POR SORTEIO",
                "PublishDate": "2020-05-19T11:45:55",
                "CaptureDate": "2021-09-14T13:27:08"
              },
              {
                "Content": "DISTRIBUIDO POR SORTEIO",
                "PublishDate": "2020-05-19T11:45:55",
                "CaptureDate": "2021-10-11T01:15:54"
              },
              {
                "Content": "DISTRIBUIDO POR SORTEIO",
                "PublishDate": "2020-05-19T11:45:55",
                "CaptureDate": "2021-12-12T03:21:11"
              },
              {
                "Content": "DISTRIBUIDO POR SORTEIO",
                "PublishDate": "2020-05-19T11:45:55",
                "CaptureDate": "2022-01-25T17:34:09"
              },
              {
                "Content": "DISTRIBUIDO POR SORTEIO",
                "PublishDate": "2020-05-19T11:45:55",
                "CaptureDate": "2022-04-21T23:36:57"
              },
              {
                "Content": "DISTRIBUIDO POR SORTEIO",
                "PublishDate": "2020-05-19T11:45:55",
                "CaptureDate": "2022-05-15T08:54:31"
              },
              {
                "Content": "DISTRIBUIDO POR SORTEIO",
                "PublishDate": "2020-05-19T11:45:55",
                "CaptureDate": "2022-11-17T10:54:25"
              }
            ],
            "Petitions": [],
            "Decisions": [
              {
                "DecisionContent": "CONDENO AS RECLAMADAS, OBSERVADA A SOLIDARIEDADE ORA RECONHECIDA, A PAGAR HONORARIOS ADVOCATICIOS SUCUMBENCIAIS EM FAVOR DO ADVOGADO DA PARTE AUTORA DE 15% SOBRE O VALOR DA CONDENACAO, A SER APURADO EM LIQUIDACAO DE SENTENCA, OBSERVANDO-SE O ENTENDIMENTO CONSAGRADO NA SUMULA N 37 DO TRIBUNAL REGIONAL DO TRABALHO 4 REGIAO.",
                "DecisionDate": "2022-07-27T15:25:57"
              },
              {
                "DecisionContent": "JULGO PROCEDENTE EM PARTE A ACAO MOVIDA POR RALPH EMERSON GOMEZ EM FACE DE FRI- SERVICOS DE CONSULTORIA E INVESTIMENTOS FINANCEIRO LTDA, E.A.",
                "DecisionDate": "2022-07-27T15:25:57"
              },
              {
                "DecisionContent": "CONDENO AS RECLAMADAS, SOLIDARIAMENTE, A PAGAREM AO RECLAMANTE AS SEGUINTES VERBAS: A) FERIAS PROPORCIONAIS (9/12); B) DECIMOS TERCEIROS SALARIOS PROPORCIONAIS DOS ANOS DE 2019 (6 /12) E 2020 (2/12); C) FGTS DO CONTRATO, ACRESCIDO DO ADICIONAL COMPENSATORIO DE 40%; D) MULTA DO ART. 467 DA CLT; ASSINADO ELETRONICAMENTE POR: THIAGO BOLDT DE SOUZA - JUNTADO EM: 27/07/2022 15:25:56 - 22A15C3 E) MULTA DO ART. 477,  8, DA CLT.",
                "DecisionDate": "2022-07-27T15:25:57"
              },
              {
                "DecisionContent": "DECLARO QUE A CONDENACAO DA ALINEA B DO PRESENTE DISPOSITIVO POSSUI NATUREZA SALARIAL.",
                "DecisionDate": "2022-07-27T15:25:57"
              },
              {
                "DecisionContent": "CONDENO AS RECLAMADAS, NA FORMA DO DISPOSTO NO ART. 791-A DA CLT E OBSERVADA A SOLIDARIEDADE ORA DEFINIDA, A PAGAR HONORARIOS ADVOCATICIOS SUCUMBENCIAIS EM FAVOR DO ADVOGADO DA PARTE AUTORA DE 15% SOBRE O VALOR DA CONDENACAO, A SER APURADO EM LIQUIDACAO DE SENTENCA, OBSERVANDO-SE O ENTENDIMENTO CONSAGRADO NA SUMULA N 37 DO TRIBUNAL REGIONAL DO TRABALHO 4 REGIAO.",
                "DecisionDate": "2022-07-27T15:25:57"
              },
              {
                "DecisionContent": "EXTINGO O FEITO SEM RESOLUCAO DE MERITO QUANTO A ESTA RECLAMADA, NOS TERMOS DO ART. 485, INC.",
                "DecisionDate": "2021-12-02T15:00:36"
              },
              {
                "DecisionContent": "EXTINGO O FEITO SEM RESOLUCAO DE MERITO QUANTO A ESTA RECLAMADA, NOS TERMOS DO ART. 485, INC.",
                "DecisionDate": "2021-12-02T15:00:36"
              },
              {
                "DecisionContent": "EXTINGO O FEITO SEM RESOLUCAO DE MERITO QUANTO A ESTA RECLAMADA, NOS TERMOS DO ART. 485, INC.",
                "DecisionDate": "2021-12-02T15:00:36"
              },
              {
                "DecisionContent": "EXTINGO O FEITO SEM RESOLUCAO DE MERITO QUANTO A ESTA RECLAMADA, NOS TERMOS DO ART. 485, INC.",
                "DecisionDate": "2021-12-02T15:00:36"
              },
              {
                "DecisionContent": "EXTINGO O FEITO SEM RESOLUCAO DE MERITO QUANTO A ESTA RECLAMADA, NOS TERMOS DO ART. 485, INC.",
                "DecisionDate": "2021-12-02T15:00:36"
              }
            ]
          },
          {
            "Number": "10384412920208260100",
            "Type": "PROCEDIMENTO COMUM",
            "MainSubject": "PRATICAS ABUSIVAS",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "SAO PAULO",
            "Judge": "RODRIGO RAMOS",
            "JudgingBody": "1 VARA CIVEL",
            "State": "SP",
            "Status": "INDEFINIDO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "PRÁTICAS ABUSIVAS",
            "InferredCNJSubjectNumber": 11811,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "PRATICAS ABUSIVAS",
              "RESCISAO DO CONTRATO E DEVOLUCAO DO DINHEIRO"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 64000,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2022-05-13T00:00:00",
            "NoticeDate": "2020-05-11T00:00:00",
            "LastMovementDate": "2022-09-22T00:00:00",
            "CaptureDate": "2022-12-07T16:10:33",
            "LastUpdate": "2022-12-07T16:10:33",
            "NumberOfParties": 8,
            "NumberOfUpdates": 247,
            "LawSuitAge": 1388,
            "AverageNumberOfUpdatesPerMonth": 5,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "12555110879",
                "IsPartyActive": false,
                "Name": "DENISE CAVALCANTE FORTES MARTINS",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2020-10-19T04:09:16"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2022-12-07T16:10:33"
              },
              {
                "Doc": "21160553000181",
                "IsPartyActive": true,
                "Name": "FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2022-12-07T16:10:33"
              },
              {
                "IsPartyActive": true,
                "Name": "FRI SERVICOS DE CONSULTORIA E INVESTIMENTOS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2022-12-07T16:10:33"
              },
              {
                "Doc": "30954137850",
                "IsPartyActive": true,
                "Name": "RODRIGO FELIPE CUSCIANO",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "271322",
                  "State": "SP",
                  "SpecificType": "ADVOGADO (REQTE)"
                },
                "LastCaptureDate": "2022-12-07T16:10:33"
              },
              {
                "Doc": "35068411817",
                "IsPartyActive": true,
                "Name": "RAFAEL HIDEO NAZIMA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "295443",
                  "State": "SP",
                  "SpecificType": "ADVOGADO (REQDO)"
                },
                "LastCaptureDate": "2022-12-07T16:10:33"
              },
              {
                "IsPartyActive": true,
                "Name": "RODRIGO RAMOS",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2022-12-07T16:10:33"
              },
              {
                "Doc": "34468791888",
                "IsPartyActive": true,
                "Name": "PAULO ROBERTO ATHIE PICCELLI",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2022-12-07T16:10:33"
              }
            ],
            "Updates": [
              {
                "Content": "ATO ORDINATORIO - INTIMACAO - PORTAL EDITAL",
                "PublishDate": "2022-09-22T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "CONTESTACAO JUNTADA N PROTOCOLO: WJMJ.22.41035629-0 TIPO DA PETICAO: CONTESTACAO DATA: 21/06/2022 23:48",
                "PublishDate": "2022-06-21T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "EDITAL JUNTADO",
                "PublishDate": "2022-06-20T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0300/2022 TEOR DO ATO: VISTOS. FLS. 263/265 E 266/267. 1. AS TENTATIVAS DE LOCALIZACAO DA PARTE REQUERIDA FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA, NOS ENDERECOS DECLINADOS NA INICIAL, BEM COMO NOS OBTIDOS PELOS SISTEMAS INFORMATIZADOS A DISPOSICAO DO JUIZO, RESTARAM INFRUTIFERAS. ASSIM, NOS TERMOS DO ART. 256, INCISO II, DO CODIGO DE PROCESSO CIVIL, DEFIRO A CITACAO POR EDITAL DO(A) REQUERIDO(A) FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA. CABERA A PARTE REQUERENTE, NO PRAZO DE QUINZE DIAS, PROVIDENCIAR A ELABORACAO DA MINUTA DO EDITAL COM PRAZO DE VINTE DIAS, ENCAMINHANDO-A POR VIA ELETRONICA DIRETAMENTE AO OFICIO PELO QUAL TRAMITA O PROCESSO (UPJ1A5CV@TJSP.JUS.BR). DECORRIDO O PRAZO PREVISTO NO EDITAL SEM NOTICIA DO(A) REQUERIDO(A), OFICIE-SE A DEFENSORIA PUBLICA SOLICITANDO A INDICACAO DE PROFISSIONAL PARA ATUAR COMO CURADOR ESPECIAL EM FAVOR DO(S) REU(S) CITADO(S) POR EDITAL/HORA CERTA, O QUAL FICA DESDE JA NOMEADO. COM A INDICACAO, INTIME-SE O CURADOR, A PRINCIPIO PELO DJE E, SE NECESSARIO, POR CARTA, DE SUA NOMEACAO PARA QUE APRESENTE RESPOSTA SOB A FORMA LEGALMENTE PREVISTA, A QUAL SE ADMITE POR NEGATIVA GERAL. NAO LOCALIZADO O PROFISSIONAL INDICADO OU RECUSANDO ELE O ENCARGO, SOLICITE-SE NOVA INDICACAO, PROCEDENDO-SE COMO ACIMA DETERMINADO. COPIA DA PRESENTE DECISAO, ASSINADA DIGITALMENTE, SERVIRA COMO OFICIO A SER ENCAMINHADA PELA SERVENTIA, QUE DEVERA CERTIFICAR O CUMPRIMENTO DO EXPEDIENTE. 2. INDEFIRO O PEDIDO DE LEVANTAMENTO DO VALOR BLOQUEADO, UMA VEZ QUE O PROCESSO ESTA EM FASE DE CONHECIMENTO, SEM DEFINICAO SOBRE O RESULTADO DE MERITO. NO MAIS, O PEDIDO BLOQUEIO FOI DEFERIDO A TITULO DE ARRESTO, MEDIDA CAUTELAR PARA ASSEGURAR O RESULTADO UTIL DO PROCESSO E NAO COMO ANTECIPACAO DA TUTELA REQUERIDA. NO MAIS, EM SE TRATANDO DE CAUTELAR E NAO DE TUTELA ANTECIPADA, NAO HA O QUE SE FALAR EM ESTABILIZACAO. POR FIM, A DECISAO TAMBEM FOI IMPUGNADA POR MEIO DE RECURSO, O QUE TAMBEM AFASTA A ESTABILIZACAO. INTIME-SE. ADVOGADOS(S): RODRIGO FELIPE CUSCIANO (OAB 271322/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2022-05-12T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0300/2022 DATA DA PUBLICACAO: 16/05/2022 NUMERO DO DIARIO: 3505",
                "PublishDate": "2022-05-12T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "PROFERIDAS OUTRAS DECISOES NAO ESPECIFICADAS VISTOS. FLS. 263/265 E 266/267. 1. AS TENTATIVAS DE LOCALIZACAO DA PARTE REQUERIDA FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA, NOS ENDERECOS DECLINADOS NA INICIAL, BEM COMO NOS OBTIDOS PELOS SISTEMAS INFORMATIZADOS A DISPOSICAO DO JUIZO, RESTARAM INFRUTIFERAS. ASSIM, NOS TERMOS DO ART. 256, INCISO II, DO CODIGO DE PROCESSO CIVIL, DEFIRO A CITACAO POR EDITAL DO(A) REQUERIDO(A) FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA. CABERA A PARTE REQUERENTE, NO PRAZO DE QUINZE DIAS, PROVIDENCIAR A ELABORACAO DA MINUTA DO EDITAL COM PRAZO DE VINTE DIAS, ENCAMINHANDO-A POR VIA ELETRONICA DIRETAMENTE AO OFICIO PELO QUAL TRAMITA O PROCESSO (UPJ1A5CV@TJSP.JUS.BR). DECORRIDO O PRAZO PREVISTO NO EDITAL SEM NOTICIA DO(A) REQUERIDO(A), OFICIE-SE A DEFENSORIA PUBLICA SOLICITANDO A INDICACAO DE PROFISSIONAL PARA ATUAR COMO CURADOR ESPECIAL EM FAVOR DO(S) REU(S) CITADO(S) POR EDITAL/HORA CERTA, O QUAL FICA DESDE JA NOMEADO. COM A INDICACAO, INTIME-SE O CURADOR, A PRINCIPIO PELO DJE E, SE NECESSARIO, POR CARTA, DE SUA NOMEACAO PARA QUE APRESENTE RESPOSTA SOB A FORMA LEGALMENTE PREVISTA, A QUAL SE ADMITE POR NEGATIVA GERAL. NAO LOCALIZADO O PROFISSIONAL INDICADO OU RECUSANDO ELE O ENCARGO, SOLICITE-SE NOVA INDICACAO, PROCEDENDO-SE COMO ACIMA DETERMINADO. COPIA DA PRESENTE DECISAO, ASSINADA DIGITALMENTE, SERVIRA COMO OFICIO A SER ENCAMINHADA PELA SERVENTIA, QUE DEVERA CERTIFICAR O CUMPRIMENTO DO EXPEDIENTE. 2. INDEFIRO O PEDIDO DE LEVANTAMENTO DO VALOR BLOQUEADO, UMA VEZ QUE O PROCESSO ESTA EM FASE DE CONHECIMENTO, SEM DEFINICAO SOBRE O RESULTADO DE MERITO. NO MAIS, O PEDIDO BLOQUEIO FOI DEFERIDO A TITULO DE ARRESTO, MEDIDA CAUTELAR PARA ASSEGURAR O RESULTADO UTIL DO PROCESSO E NAO COMO ANTECIPACAO DA TUTELA REQUERIDA. NO MAIS, EM SE TRATANDO DE CAUTELAR E NAO DE TUTELA ANTECIPADA, NAO HA O QUE SE FALAR EM ESTABILIZACAO. POR FIM, A DECISAO TAMBEM FOI IMPUGNADA POR MEIO DE RECURSO, O QUE TAMBEM AFASTA A ESTABILIZACAO. INTIME-SE.",
                "PublishDate": "2022-05-11T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2022-04-18T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2022-03-08T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.22.40324831-2 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 04/03/2022 23:31",
                "PublishDate": "2022-03-05T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.22.40224680-4 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 16/02/2022 16:07",
                "PublishDate": "2022-02-16T00:00:00",
                "CaptureDate": "2022-02-22T19:10:43"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.22.40224680-4 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 16/02/2022 16:07",
                "PublishDate": "2022-02-16T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO: 0023/2022 DATA DA PUBLICACAO: 19/01/2022 NUMERO DO DIARIO: 3429",
                "PublishDate": "2022-01-17T00:00:00",
                "CaptureDate": "2022-02-22T19:10:43"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0023/2022 TEOR DO ATO: VISTOS. A CITACAO POR EDITAL SOMENTE E POSSIVEL APOS O ESGOTAMENTO DE TODAS AS TENTATIVAS DE LOCALIZAR O CITANDO. PARA O ESGOTAMENTO DAS TENTATIVAS, E NECESSARIO QUE: I) JA TENHAM SIDO ACESSADOS OS SISTEMAS SISBAJUD, INFOJUD, RENAJUD, SIEL (CASO O REU SEJA PESSOA FISICA), COMGASJUD E SERASAJUD; II) TENHA SIDO JUNTADO EXTRATO COMPLETO E ATUALIZADO DA JUNTA COMERCIAL, CASO O REU SEJA PESSOA JURIDICA; E III) TODOS OS ENDERECOS OBTIDOS NAS PESQUISAS JA TENHAM SIDO DILIGENCIADOS A CONTENTO. SENDO ASSIM, NO PRAZO DE 30 DIAS O AUTOR DEMONSTRARA QUE ESSES TRES REQUISITOS FORAM SUPRIDOS, DEVENDO INFORMAR EM QUAL PAGINA CONSTA NOS AUTOS CADA ENDERECO OBTIDO E INDICAR EM QUAL PAGINA ESSE ENDERECO JA FOI DILIGENCIADO, BEM COMO QUAL FOI O RESULTADO DA DILIGENCIA (VG., AUSENTE, MUDOU-SE, FALECIDO ETC.). COM A MANIFESTACAO, TORNEM CONCLUSOS PARA EXAME. INTIME-SE. ADVOGADOS(S): RODRIGO FELIPE CUSCIANO (OAB 271322/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2022-01-17T00:00:00",
                "CaptureDate": "2022-02-22T19:10:43"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0023/2022 TEOR DO ATO: VISTOS. A CITACAO POR EDITAL SOMENTE E POSSIVEL APOS O ESGOTAMENTO DE TODAS AS TENTATIVAS DE LOCALIZAR O CITANDO. PARA O ESGOTAMENTO DAS TENTATIVAS, E NECESSARIO QUE: I) JA TENHAM SIDO ACESSADOS OS SISTEMAS SISBAJUD, INFOJUD, RENAJUD, SIEL (CASO O REU SEJA PESSOA FISICA), COMGASJUD E SERASAJUD; II) TENHA SIDO JUNTADO EXTRATO COMPLETO E ATUALIZADO DA JUNTA COMERCIAL, CASO O REU SEJA PESSOA JURIDICA; E III) TODOS OS ENDERECOS OBTIDOS NAS PESQUISAS JA TENHAM SIDO DILIGENCIADOS A CONTENTO. SENDO ASSIM, NO PRAZO DE 30 DIAS O AUTOR DEMONSTRARA QUE ESSES TRES REQUISITOS FORAM SUPRIDOS, DEVENDO INFORMAR EM QUAL PAGINA CONSTA NOS AUTOS CADA ENDERECO OBTIDO E INDICAR EM QUAL PAGINA ESSE ENDERECO JA FOI DILIGENCIADO, BEM COMO QUAL FOI O RESULTADO DA DILIGENCIA (VG., AUSENTE, MUDOU-SE, FALECIDO ETC.). COM A MANIFESTACAO, TORNEM CONCLUSOS PARA EXAME. INTIME-SE. ADVOGADOS(S): RODRIGO FELIPE CUSCIANO (OAB 271322/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2022-01-17T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0023/2022 DATA DA PUBLICACAO: 19/01/2022 NUMERO DO DIARIO: 3429",
                "PublishDate": "2022-01-17T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "DECISAO | VISTOS. A CITACAO POR EDITAL SOMENTE E POSSIVEL APOS O ESGOTAMENTO DE TODAS AS TENTATIVAS DE LOCALIZAR O CITANDO. PARA O ESGOTAMENTO DAS TENTATIVAS, E NECESSARIO QUE: I) JA TENHAM SIDO ACESSADOS OS SISTEMAS SISBAJUD, INFOJUD, RENAJUD, SIEL (CASO O REU SEJA PESSOA FISICA), COMGASJUD E SERASAJUD; II) TENHA SIDO JUNTADO EXTRATO COMPLETO E ATUALIZADO DA JUNTA COMERCIAL, CASO O REU SEJA PESSOA JURIDICA; E III) TODOS OS ENDERECOS OBTIDOS NAS PESQUISAS JA TENHAM SIDO DILIGENCIADOS A CONTENTO. SENDO ASSIM, NO PRAZO DE 30 DIAS O AUTOR DEMONSTRARA QUE ESSES TRES REQUISITOS FORAM SUPRIDOS, DEVENDO INFORMAR EM QUAL PAGINA CONSTA NOS AUTOS CADA ENDERECO OBTIDO E INDICAR EM QUAL PAGINA ESSE ENDERECO JA FOI DILIGENCIADO, BEM COMO QUAL FOI O RESULTADO DA DILIGENCIA (VG., AUSENTE, MUDOU-SE, FALECIDO ETC.). COM A MANIFESTACAO, TORNEM CONCLUSOS PARA EXAME. INTIME-SE.",
                "PublishDate": "2022-01-14T00:00:00",
                "CaptureDate": "2022-02-22T19:10:43"
              },
              {
                "Content": "DECISAO VISTOS. A CITACAO POR EDITAL SOMENTE E POSSIVEL APOS O ESGOTAMENTO DE TODAS AS TENTATIVAS DE LOCALIZAR O CITANDO. PARA O ESGOTAMENTO DAS TENTATIVAS, E NECESSARIO QUE: I) JA TENHAM SIDO ACESSADOS OS SISTEMAS SISBAJUD, INFOJUD, RENAJUD, SIEL (CASO O REU SEJA PESSOA FISICA), COMGASJUD E SERASAJUD; II) TENHA SIDO JUNTADO EXTRATO COMPLETO E ATUALIZADO DA JUNTA COMERCIAL, CASO O REU SEJA PESSOA JURIDICA; E III) TODOS OS ENDERECOS OBTIDOS NAS PESQUISAS JA TENHAM SIDO DILIGENCIADOS A CONTENTO. SENDO ASSIM, NO PRAZO DE 30 DIAS O AUTOR DEMONSTRARA QUE ESSES TRES REQUISITOS FORAM SUPRIDOS, DEVENDO INFORMAR EM QUAL PAGINA CONSTA NOS AUTOS CADA ENDERECO OBTIDO E INDICAR EM QUAL PAGINA ESSE ENDERECO JA FOI DILIGENCIADO, BEM COMO QUAL FOI O RESULTADO DA DILIGENCIA (VG., AUSENTE, MUDOU-SE, FALECIDO ETC.). COM A MANIFESTACAO, TORNEM CONCLUSOS PARA EXAME. INTIME-SE.",
                "PublishDate": "2022-01-14T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2021-12-14T00:00:00",
                "CaptureDate": "2022-02-22T19:10:43"
              },
              {
                "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.21.41946054-4 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 26/11/2021 18:00",
                "PublishDate": "2021-11-26T00:00:00",
                "CaptureDate": "2021-11-30T21:39:33"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.21.41946054-4 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 26/11/2021 18:00",
                "PublishDate": "2021-11-26T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO: 0466/2021 DATA DA DISPONIBILIZACAO: 19/11/2021 DATA DA PUBLICACAO: 22/11/2021 NUMERO DO DIARIO: 3402 PAGINA: 12/21",
                "PublishDate": "2021-11-19T00:00:00",
                "CaptureDate": "2021-11-30T21:39:33"
              },
              {
                "Content": "PROCESSO 1038441-29.2020.8.26.0100 - PROCEDIMENTO COMUM CIVEL - PRATICAS ABUSIVAS - PAULO ROBERTO ATHIE PICCELLI - STARK BANK S.A. - - FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA. - - FRI SERVICOS DE CONSULTORIA E INVESTIMENTOS LTDA - MANIFESTE-SE O AUTOR QUANTO AO(S) SEED(S) NEGATIVO(S) JUNTADO(S) AOS AUTOS. - ADV: RAFAEL HIDEO NAZIMA (OAB 295443/SP), RODRIGO FELIPE CUSCIANO (OAB 271322/SP)",
                "PublishDate": "2021-11-19T00:00:00",
                "CaptureDate": "2021-11-30T21:39:33"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0466/2021 DATA DA DISPONIBILIZACAO: 19/11/2021 DATA DA PUBLICACAO: 22/11/2021 NUMERO DO DIARIO: 3402 PAGINA: 12/21",
                "PublishDate": "2021-11-19T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0466/2021 TEOR DO ATO: MANIFESTE-SE O AUTOR QUANTO AO(S) SEED(S) NEGATIVO(S) JUNTADO(S) AOS AUTOS. ADVOGADOS(S): RODRIGO FELIPE CUSCIANO (OAB 271322/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2021-11-17T00:00:00",
                "CaptureDate": "2021-11-30T21:39:33"
              },
              {
                "Content": "ATO ORDINATORIO - PUBLICAVEL | MANIFESTE-SE O AUTOR QUANTO AO(S) SEED(S) NEGATIVO(S) JUNTADO(S) AOS AUTOS.",
                "PublishDate": "2021-11-17T00:00:00",
                "CaptureDate": "2021-11-30T21:39:33"
              },
              {
                "Content": "AR NEGATIVO JUNTADO - MUDOU-SE | JUNTADA DE AR : AR367533384TJ SITUACAO : MUDOU-SE MODELO : PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC DESTINATARIO : FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA.",
                "PublishDate": "2021-11-17T00:00:00",
                "CaptureDate": "2021-11-30T21:39:33"
              },
              {
                "Content": "AR NEGATIVO JUNTADO - MUDOU-SE JUNTADA DE AR : AR367533384TJ SITUACAO : MUDOU-SE MODELO : PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC DESTINATARIO : FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA.",
                "PublishDate": "2021-11-17T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "ATO ORDINATORIO - INTIMACAO - DJE MANIFESTE-SE O AUTOR QUANTO AO(S) SEED(S) NEGATIVO(S) JUNTADO(S) AOS AUTOS.",
                "PublishDate": "2021-11-17T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0466/2021 TEOR DO ATO: MANIFESTE-SE O AUTOR QUANTO AO(S) SEED(S) NEGATIVO(S) JUNTADO(S) AOS AUTOS. ADVOGADOS(S): RODRIGO FELIPE CUSCIANO (OAB 271322/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2021-11-17T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "CARTA EXPEDIDA | PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                "PublishDate": "2021-11-03T00:00:00",
                "CaptureDate": "2021-11-30T21:39:33"
              },
              {
                "Content": "CARTA EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                "PublishDate": "2021-11-03T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "ATO ORDINATORIO - NAO PUBLICAVEL | CARTA",
                "PublishDate": "2021-10-27T00:00:00",
                "CaptureDate": "2021-11-30T21:39:33"
              },
              {
                "Content": "ATO ORDINATORIO - INTIMACAO - PORTAL CARTA",
                "PublishDate": "2021-10-27T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.21.41751247-4 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 22/10/2021 16:31",
                "PublishDate": "2021-10-22T00:00:00",
                "CaptureDate": "2021-11-30T21:39:33"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.21.41751247-4 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 22/10/2021 16:31",
                "PublishDate": "2021-10-22T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0431/2021 DATA DA DISPONIBILIZACAO: 15/10/2021 DATA DA PUBLICACAO: 18/10/2021 NUMERO DO DIARIO: 3381 PAGINA: 1/21",
                "PublishDate": "2021-10-15T00:00:00",
                "CaptureDate": "2021-10-18T12:11:59"
              },
              {
                "Content": "PROCESSO 1038441-29.2020.8.26.0100 - PROCEDIMENTO COMUM CIVEL - PRATICAS ABUSIVAS - PAULO ROBERTO ATHIE PICCELLI - STARK BANK S.A. - - FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA. - - FRI SERVICOS DE CONSULTORIA E INVESTIMENTOS LTDA - VISTOS. FLS. 245/247: INDEFIRO, POR ORA, O EDITAL, POSTO QUE O ENDERECO FALTANTE NAO FOI DILIGENCIADO POR ESTE JUIZO, TAMPOUCO HOUVE COMPROVACAO DE SUA DILIGENCIA NOS PROCESSOS INDICADOS. ASSIM, PROVIDENCIE-SE AS CUSTAS NECESSARIAS PARA A CITACAO POSTAL FALTANTE, NO PRAZO DE CINCO DIAS. INTIME-SE. - ADV: RODRIGO FELIPE CUSCIANO (OAB 271322/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2021-10-15T00:00:00",
                "CaptureDate": "2021-10-18T12:11:59"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0431/2021 DATA DA DISPONIBILIZACAO: 15/10/2021 DATA DA PUBLICACAO: 18/10/2021 NUMERO DO DIARIO: 3381 PAGINA: 1/21",
                "PublishDate": "2021-10-15T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0431/2021 TEOR DO ATO: VISTOS. FLS. 245/247: INDEFIRO, POR ORA, O EDITAL, POSTO QUE O ENDERECO FALTANTE NAO FOI DILIGENCIADO POR ESTE JUIZO, TAMPOUCO HOUVE COMPROVACAO DE SUA DILIGENCIA NOS PROCESSOS INDICADOS. ASSIM, PROVIDENCIE-SE AS CUSTAS NECESSARIAS PARA A CITACAO POSTAL FALTANTE, NO PRAZO DE CINCO DIAS. INTIME-SE. ADVOGADOS(S): RODRIGO FELIPE CUSCIANO (OAB 271322/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2021-10-14T00:00:00",
                "CaptureDate": "2021-10-18T12:11:59"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0431/2021 TEOR DO ATO: VISTOS. FLS. 245/247: INDEFIRO, POR ORA, O EDITAL, POSTO QUE O ENDERECO FALTANTE NAO FOI DILIGENCIADO POR ESTE JUIZO, TAMPOUCO HOUVE COMPROVACAO DE SUA DILIGENCIA NOS PROCESSOS INDICADOS. ASSIM, PROVIDENCIE-SE AS CUSTAS NECESSARIAS PARA A CITACAO POSTAL FALTANTE, NO PRAZO DE CINCO DIAS. INTIME-SE. ADVOGADOS(S): RODRIGO FELIPE CUSCIANO (OAB 271322/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2021-10-14T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "DECISAO | VISTOS. FLS. 245/247: INDEFIRO, POR ORA, O EDITAL, POSTO QUE O ENDERECO FALTANTE NAO FOI DILIGENCIADO POR ESTE JUIZO, TAMPOUCO HOUVE COMPROVACAO DE SUA DILIGENCIA NOS PROCESSOS INDICADOS. ASSIM, PROVIDENCIE-SE AS CUSTAS NECESSARIAS PARA A CITACAO POSTAL FALTANTE, NO PRAZO DE CINCO DIAS. INTIME-SE.",
                "PublishDate": "2021-10-13T00:00:00",
                "CaptureDate": "2021-10-18T12:11:59"
              },
              {
                "Content": "DECISAO VISTOS. FLS. 245/247: INDEFIRO, POR ORA, O EDITAL, POSTO QUE O ENDERECO FALTANTE NAO FOI DILIGENCIADO POR ESTE JUIZO, TAMPOUCO HOUVE COMPROVACAO DE SUA DILIGENCIA NOS PROCESSOS INDICADOS. ASSIM, PROVIDENCIE-SE AS CUSTAS NECESSARIAS PARA A CITACAO POSTAL FALTANTE, NO PRAZO DE CINCO DIAS. INTIME-SE.",
                "PublishDate": "2021-10-13T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2021-09-15T00:00:00",
                "CaptureDate": "2021-09-25T05:11:08"
              },
              {
                "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.21.41506653-1 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 13/09/2021 16:05",
                "PublishDate": "2021-09-13T00:00:00",
                "CaptureDate": "2021-09-25T05:11:08"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.21.41506653-1 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 13/09/2021 16:05",
                "PublishDate": "2021-09-13T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0387/2021 DATA DA DISPONIBILIZACAO: 03/09/2021 DATA DA PUBLICACAO: 08/09/2021 NUMERO DO DIARIO: 3355 PAGINA: 280/286",
                "PublishDate": "2021-09-03T00:00:00",
                "CaptureDate": "2021-09-25T05:11:08"
              },
              {
                "Content": "PROCESSO 1038441-29.2020.8.26.0100 - PROCEDIMENTO COMUM CIVEL - PRATICAS ABUSIVAS - PAULO ROBERTO ATHIE PICCELLI - STARK BANK S.A. - - FRI SERVICOS DE CONSULTORIA E INVESTIMENTOS LTDA E OUTRO - CONFORME DETERMINADO AS FLS 239, CIENCIA A PARTE INTERESSADA DAS PESQUISAS REALIZADAS VIA SERASAJUD E COMGASJUD FLS 241/242. - ADV: RODRIGO FELIPE CUSCIANO (OAB 271322/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2021-09-03T00:00:00",
                "CaptureDate": "2021-09-25T05:11:08"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0387/2021 DATA DA DISPONIBILIZACAO: 03/09/2021 DATA DA PUBLICACAO: 08/09/2021 NUMERO DO DIARIO: 3355 PAGINA: 280/286",
                "PublishDate": "2021-09-03T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0387/2021 TEOR DO ATO: CONFORME DETERMINADO AS FLS 239, CIENCIA A PARTE INTERESSADA DAS PESQUISAS REALIZADAS VIA SERASAJUD E COMGASJUD FLS 241/242. ADVOGADOS(S): RODRIGO FELIPE CUSCIANO (OAB 271322/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2021-09-02T00:00:00",
                "CaptureDate": "2021-09-25T05:11:08"
              },
              {
                "Content": "ATO ORDINATORIO - PUBLICAVEL | CONFORME DETERMINADO AS FLS 239, CIENCIA A PARTE INTERESSADA DAS PESQUISAS REALIZADAS VIA SERASAJUD E COMGASJUD FLS 241/242.",
                "PublishDate": "2021-09-02T00:00:00",
                "CaptureDate": "2021-09-25T05:11:08"
              },
              {
                "Content": "RESPOSTA DE VERIFICACAO DE ENDERECO JUNTADO",
                "PublishDate": "2021-09-02T00:00:00",
                "CaptureDate": "2021-09-25T05:11:08"
              },
              {
                "Content": "RESPOSTA DE VERIFICACAO DE ENDERECO JUNTADO",
                "PublishDate": "2021-09-02T00:00:00",
                "CaptureDate": "2021-09-25T05:11:08"
              },
              {
                "Content": "RESPOSTA DE VERIFICACAO DE ENDERECO JUNTADO",
                "PublishDate": "2021-09-02T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "RESPOSTA DE VERIFICACAO DE ENDERECO JUNTADO",
                "PublishDate": "2021-09-02T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "ATO ORDINATORIO - INTIMACAO - DJE CONFORME DETERMINADO AS FLS 239, CIENCIA A PARTE INTERESSADA DAS PESQUISAS REALIZADAS VIA SERASAJUD E COMGASJUD FLS 241/242.",
                "PublishDate": "2021-09-02T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0387/2021 TEOR DO ATO: CONFORME DETERMINADO AS FLS 239, CIENCIA A PARTE INTERESSADA DAS PESQUISAS REALIZADAS VIA SERASAJUD E COMGASJUD FLS 241/242. ADVOGADOS(S): RODRIGO FELIPE CUSCIANO (OAB 271322/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2021-09-02T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0363/2021 DATA DA DISPONIBILIZACAO: 20/08/2021 DATA DA PUBLICACAO: 23/08/2021 NUMERO DO DIARIO: 3345 PAGINA: 128/139",
                "PublishDate": "2021-08-20T00:00:00",
                "CaptureDate": "2021-09-01T07:15:55"
              },
              {
                "Content": "PROCESSO 1038441-29.2020.8.26.0100 - PROCEDIMENTO COMUM CIVEL - PRATICAS ABUSIVAS - PAULO ROBERTO ATHIE PICCELLI - STARK BANK S.A. - - FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA. - - FRI SERVICOS DE CONSULTORIA E INVESTIMENTOS LTDA - VISTOS. DEFIRO O PEDIDO DE PESQUISAS DE ENDERECOS POR MEIO DOS SISTEMAS SERASAJUD E COMGASJUD EM NOME DA PARTE (CPF/CNPJ ACIMA INDICADO). APOS A JUNTADA DOS RESULTADOS DAS PESQUISAS, INTIME-SE A PARTE REQUERENTE PARA DAR-LHE CIENCIA, BEM COMO PARA MANIFESTAR-SE EM TERMOS DE PROSSEGUIMENTO NO PRAZO CINCO DIAS. CASO SEJAM LOCALIZADOS ENDERECOS NAO DILIGENCIADOS, MEDIANTE O RECOLHIMENTO DAS CUSTAS ATINENTES, FICA DESDE JA DEFERIDA A TENTATIVA DE CITACAO NOS ENDERECOS OBTIDOS. TRANSCORRIDO O PRAZO ACIMA FIXADO E NADA VINDO, AGUARDE-SE POR TRINTA DIAS E, NO SILENCIO, INTIME-SE O AUTOR POR CARTA PARA QUE, NO PRAZO DE CINCO DIAS, PROMOVA OS ATOS E DILIGENCIAS QUE LHE COMPETEM E CUJA AUSENCIA ESTA A IMPEDIR O ANDAMENTO DO FEITO, SOB PENA DE EXTINCAO, NOS TERMOS DO ART. 485, INCISO III E  1, DO CODIGO DE PROCESSO CIVIL. INTIME-SE. - ADV: RAFAEL HIDEO NAZIMA (OAB 295443/SP), RODRIGO FELIPE CUSCIANO (OAB 271322/SP)",
                "PublishDate": "2021-08-20T00:00:00",
                "CaptureDate": "2021-09-01T07:15:55"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0363/2021 DATA DA DISPONIBILIZACAO: 20/08/2021 DATA DA PUBLICACAO: 23/08/2021 NUMERO DO DIARIO: 3345 PAGINA: 128/139",
                "PublishDate": "2021-08-20T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0363/2021 TEOR DO ATO: VISTOS. DEFIRO O PEDIDO DE PESQUISAS DE ENDERECOS POR MEIO DOS SISTEMAS SERASAJUD E COMGASJUD EM NOME DA PARTE (CPF/CNPJ ACIMA INDICADO). APOS A JUNTADA DOS RESULTADOS DAS PESQUISAS, INTIME-SE A PARTE REQUERENTE PARA DAR-LHE CIENCIA, BEM COMO PARA MANIFESTAR-SE EM TERMOS DE PROSSEGUIMENTO NO PRAZO CINCO DIAS. CASO SEJAM LOCALIZADOS ENDERECOS NAO DILIGENCIADOS, MEDIANTE O RECOLHIMENTO DAS CUSTAS ATINENTES, FICA DESDE JA DEFERIDA A TENTATIVA DE CITACAO NOS ENDERECOS OBTIDOS. TRANSCORRIDO O PRAZO ACIMA FIXADO E NADA VINDO, AGUARDE-SE POR TRINTA DIAS E, NO SILENCIO, INTIME-SE O AUTOR POR CARTA PARA QUE, NO PRAZO DE CINCO DIAS, PROMOVA OS ATOS E DILIGENCIAS QUE LHE COMPETEM E CUJA AUSENCIA ESTA A IMPEDIR O ANDAMENTO DO FEITO, SOB PENA DE EXTINCAO, NOS TERMOS DO ART. 485, INCISO III E  1, DO CODIGO DE PROCESSO CIVIL. INTIME-SE. ADVOGADOS(S): RODRIGO FELIPE CUSCIANO (OAB 271322/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2021-08-19T00:00:00",
                "CaptureDate": "2021-09-01T07:15:55"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0363/2021 TEOR DO ATO: VISTOS. DEFIRO O PEDIDO DE PESQUISAS DE ENDERECOS POR MEIO DOS SISTEMAS SERASAJUD E COMGASJUD EM NOME DA PARTE (CPF/CNPJ ACIMA INDICADO). APOS A JUNTADA DOS RESULTADOS DAS PESQUISAS, INTIME-SE A PARTE REQUERENTE PARA DAR-LHE CIENCIA, BEM COMO PARA MANIFESTAR-SE EM TERMOS DE PROSSEGUIMENTO NO PRAZO CINCO DIAS. CASO SEJAM LOCALIZADOS ENDERECOS NAO DILIGENCIADOS, MEDIANTE O RECOLHIMENTO DAS CUSTAS ATINENTES, FICA DESDE JA DEFERIDA A TENTATIVA DE CITACAO NOS ENDERECOS OBTIDOS. TRANSCORRIDO O PRAZO ACIMA FIXADO E NADA VINDO, AGUARDE-SE POR TRINTA DIAS E, NO SILENCIO, INTIME-SE O AUTOR POR CARTA PARA QUE, NO PRAZO DE CINCO DIAS, PROMOVA OS ATOS E DILIGENCIAS QUE LHE COMPETEM E CUJA AUSENCIA ESTA A IMPEDIR O ANDAMENTO DO FEITO, SOB PENA DE EXTINCAO, NOS TERMOS DO ART. 485, INCISO III E  1, DO CODIGO DE PROCESSO CIVIL. INTIME-SE. ADVOGADOS(S): RODRIGO FELIPE CUSCIANO (OAB 271322/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2021-08-19T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "DECISAO | VISTOS. DEFIRO O PEDIDO DE PESQUISAS DE ENDERECOS POR MEIO DOS SISTEMAS SERASAJUD E COMGASJUD EM NOME DA PARTE (CPF/CNPJ ACIMA INDICADO). APOS A JUNTADA DOS RESULTADOS DAS PESQUISAS, INTIME-SE A PARTE REQUERENTE PARA DAR-LHE CIENCIA, BEM COMO PARA MANIFESTAR-SE EM TERMOS DE PROSSEGUIMENTO NO PRAZO CINCO DIAS. CASO SEJAM LOCALIZADOS ENDERECOS NAO DILIGENCIADOS, MEDIANTE O RECOLHIMENTO DAS CUSTAS ATINENTES, FICA DESDE JA DEFERIDA A TENTATIVA DE CITACAO NOS ENDERECOS OBTIDOS. TRANSCORRIDO O PRAZO ACIMA FIXADO E NADA VINDO, AGUARDE-SE POR TRINTA DIAS E, NO SILENCIO, INTIME-SE O AUTOR POR CARTA PARA QUE, NO PRAZO DE CINCO DIAS, PROMOVA OS ATOS E DILIGENCIAS QUE LHE COMPETEM E CUJA AUSENCIA ESTA A IMPEDIR O ANDAMENTO DO FEITO, SOB PENA DE EXTINCAO, NOS TERMOS DO ART. 485, INCISO III E  1, DO CODIGO DE PROCESSO CIVIL. INTIME-SE.",
                "PublishDate": "2021-08-18T00:00:00",
                "CaptureDate": "2021-09-01T07:15:55"
              },
              {
                "Content": "DECISAO VISTOS. DEFIRO O PEDIDO DE PESQUISAS DE ENDERECOS POR MEIO DOS SISTEMAS SERASAJUD E COMGASJUD EM NOME DA PARTE (CPF/CNPJ ACIMA INDICADO). APOS A JUNTADA DOS RESULTADOS DAS PESQUISAS, INTIME-SE A PARTE REQUERENTE PARA DAR-LHE CIENCIA, BEM COMO PARA MANIFESTAR-SE EM TERMOS DE PROSSEGUIMENTO NO PRAZO CINCO DIAS. CASO SEJAM LOCALIZADOS ENDERECOS NAO DILIGENCIADOS, MEDIANTE O RECOLHIMENTO DAS CUSTAS ATINENTES, FICA DESDE JA DEFERIDA A TENTATIVA DE CITACAO NOS ENDERECOS OBTIDOS. TRANSCORRIDO O PRAZO ACIMA FIXADO E NADA VINDO, AGUARDE-SE POR TRINTA DIAS E, NO SILENCIO, INTIME-SE O AUTOR POR CARTA PARA QUE, NO PRAZO DE CINCO DIAS, PROMOVA OS ATOS E DILIGENCIAS QUE LHE COMPETEM E CUJA AUSENCIA ESTA A IMPEDIR O ANDAMENTO DO FEITO, SOB PENA DE EXTINCAO, NOS TERMOS DO ART. 485, INCISO III E  1, DO CODIGO DE PROCESSO CIVIL. INTIME-SE.",
                "PublishDate": "2021-08-18T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2021-08-17T00:00:00",
                "CaptureDate": "2021-09-01T07:15:55"
              },
              {
                "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.21.41344766-0 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 16/08/2021 22:49",
                "PublishDate": "2021-08-17T00:00:00",
                "CaptureDate": "2021-09-01T07:15:55"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.21.41344766-0 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 16/08/2021 22:49",
                "PublishDate": "2021-08-17T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2021-08-17T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0347/2021 DATA DA DISPONIBILIZACAO: 10/08/2021 DATA DA PUBLICACAO: 11/08/2021 NUMERO DO DIARIO: 3337 PAGINA: 11/21",
                "PublishDate": "2021-08-10T00:00:00",
                "CaptureDate": "2021-08-15T06:23:20"
              },
              {
                "Content": "PROCESSO 1038441-29.2020.8.26.0100 - PROCEDIMENTO COMUM CIVEL - PRATICAS ABUSIVAS - PAULO ROBERTO ATHIE PICCELLI - STARK BANK S.A. - - FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA. - - FRI SERVICOS DE CONSULTORIA E INVESTIMENTOS LTDA - VISTOS. MANIFESTE-SE O REQUERENTE, NO PRAZO DE CINCO DIAS, QUANTO AS PESQUISAS DE ENDERECOS FALTANTES, TENDO EM VISTA O CERTIFICADO PELA SERVENTIA AS FLS. 232. ANOTO QUE ESTE JUIZO MANTEM CONVENIO COM OS SEGUINTES ORGAOS NAO DILIGENCIADOS: SERASAJUD E COMGASJUD. INTIME-SE. - ADV: RAFAEL HIDEO NAZIMA (OAB 295443/SP), RODRIGO FELIPE CUSCIANO (OAB 271322/SP)",
                "PublishDate": "2021-08-10T00:00:00",
                "CaptureDate": "2021-08-15T06:23:20"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0347/2021 DATA DA DISPONIBILIZACAO: 10/08/2021 DATA DA PUBLICACAO: 11/08/2021 NUMERO DO DIARIO: 3337 PAGINA: 11/21",
                "PublishDate": "2021-08-10T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0347/2021 TEOR DO ATO: VISTOS. MANIFESTE-SE O REQUERENTE, NO PRAZO DE CINCO DIAS, QUANTO AS PESQUISAS DE ENDERECOS FALTANTES, TENDO EM VISTA O CERTIFICADO PELA SERVENTIA AS FLS. 232. ANOTO QUE ESTE JUIZO MANTEM CONVENIO COM OS SEGUINTES ORGAOS NAO DILIGENCIADOS: SERASAJUD E COMGASJUD. INTIME-SE. ADVOGADOS(S): RODRIGO FELIPE CUSCIANO (OAB 271322/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2021-08-08T00:00:00",
                "CaptureDate": "2021-08-15T06:23:20"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0347/2021 TEOR DO ATO: VISTOS. MANIFESTE-SE O REQUERENTE, NO PRAZO DE CINCO DIAS, QUANTO AS PESQUISAS DE ENDERECOS FALTANTES, TENDO EM VISTA O CERTIFICADO PELA SERVENTIA AS FLS. 232. ANOTO QUE ESTE JUIZO MANTEM CONVENIO COM OS SEGUINTES ORGAOS NAO DILIGENCIADOS: SERASAJUD E COMGASJUD. INTIME-SE. ADVOGADOS(S): RODRIGO FELIPE CUSCIANO (OAB 271322/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2021-08-08T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "DECISAO | VISTOS. MANIFESTE-SE O REQUERENTE, NO PRAZO DE CINCO DIAS, QUANTO AS PESQUISAS DE ENDERECOS FALTANTES, TENDO EM VISTA O CERTIFICADO PELA SERVENTIA AS FLS. 232. ANOTO QUE ESTE JUIZO MANTEM CONVENIO COM OS SEGUINTES ORGAOS NAO DILIGENCIADOS: SERASAJUD E COMGASJUD. INTIME-SE.",
                "PublishDate": "2021-08-06T00:00:00",
                "CaptureDate": "2021-08-15T06:23:20"
              },
              {
                "Content": "DECISAO VISTOS. MANIFESTE-SE O REQUERENTE, NO PRAZO DE CINCO DIAS, QUANTO AS PESQUISAS DE ENDERECOS FALTANTES, TENDO EM VISTA O CERTIFICADO PELA SERVENTIA AS FLS. 232. ANOTO QUE ESTE JUIZO MANTEM CONVENIO COM OS SEGUINTES ORGAOS NAO DILIGENCIADOS: SERASAJUD E COMGASJUD. INTIME-SE.",
                "PublishDate": "2021-08-06T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2021-07-16T00:00:00",
                "CaptureDate": "2021-08-15T06:23:20"
              },
              {
                "Content": "CERTIDAO DE CARTORIO EXPEDIDA | CERTIDAO - GENERICA",
                "PublishDate": "2021-07-16T00:00:00",
                "CaptureDate": "2021-08-15T06:23:20"
              },
              {
                "Content": "CERTIDAO DE CARTORIO EXPEDIDA CERTIDAO - GENERICA",
                "PublishDate": "2021-07-16T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2021-07-16T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "ATO ORDINATORIO - NAO PUBLICAVEL | ATO ORDINATORIO - GENERICO - COM ATOS E NAO PUBLICAVEL",
                "PublishDate": "2021-06-29T00:00:00",
                "CaptureDate": "2021-07-01T03:01:12"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0286/2021 DATA DA DISPONIBILIZACAO: 29/06/2021 DATA DA PUBLICACAO: 30/06/2021 NUMERO DO DIARIO: 3308 PAGINA: 11/20",
                "PublishDate": "2021-06-29T00:00:00",
                "CaptureDate": "2021-07-01T03:01:12"
              },
              {
                "Content": "PROCESSO 1038441-29.2020.8.26.0100 - PROCEDIMENTO COMUM CIVEL - PRATICAS ABUSIVAS - PAULO ROBERTO ATHIE PICCELLI - STARK BANK S.A. - - FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA. - - FRI SERVICOS DE CONSULTORIA E INVESTIMENTOS LTDA - VISTOS. CERTIFIQUE A SERVENTIA SE TODOS OS ORGAOS CONVENIADOS A ESTE JUIZO PARA PESQUISAS DE ENDERECOS FORAM CONSULTADOS E SE TODOS OS ENDERECOS ENCONTRADOS FORAM DILIGENCIADOS. INTIME-SE. - ADV: RODRIGO FELIPE CUSCIANO (OAB 271322/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2021-06-29T00:00:00",
                "CaptureDate": "2021-07-01T03:01:12"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0286/2021 DATA DA DISPONIBILIZACAO: 29/06/2021 DATA DA PUBLICACAO: 30/06/2021 NUMERO DO DIARIO: 3308 PAGINA: 11/20",
                "PublishDate": "2021-06-29T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "ATO ORDINATORIO - INTIMACAO - PORTAL ATO ORDINATORIO - GENERICO - COM ATOS E NAO PUBLICAVEL",
                "PublishDate": "2021-06-29T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0286/2021 TEOR DO ATO: VISTOS. CERTIFIQUE A SERVENTIA SE TODOS OS ORGAOS CONVENIADOS A ESTE JUIZO PARA PESQUISAS DE ENDERECOS FORAM CONSULTADOS E SE TODOS OS ENDERECOS ENCONTRADOS FORAM DILIGENCIADOS. INTIME-SE. ADVOGADOS(S): RODRIGO FELIPE CUSCIANO (OAB 271322/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2021-06-28T00:00:00",
                "CaptureDate": "2021-07-01T03:01:12"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0286/2021 TEOR DO ATO: VISTOS. CERTIFIQUE A SERVENTIA SE TODOS OS ORGAOS CONVENIADOS A ESTE JUIZO PARA PESQUISAS DE ENDERECOS FORAM CONSULTADOS E SE TODOS OS ENDERECOS ENCONTRADOS FORAM DILIGENCIADOS. INTIME-SE. ADVOGADOS(S): RODRIGO FELIPE CUSCIANO (OAB 271322/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2021-06-28T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "DECISAO | VISTOS. CERTIFIQUE A SERVENTIA SE TODOS OS ORGAOS CONVENIADOS A ESTE JUIZO PARA PESQUISAS DE ENDERECOS FORAM CONSULTADOS E SE TODOS OS ENDERECOS ENCONTRADOS FORAM DILIGENCIADOS. INTIME-SE.",
                "PublishDate": "2021-06-25T00:00:00",
                "CaptureDate": "2021-07-01T03:01:12"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2021-06-25T00:00:00",
                "CaptureDate": "2021-07-01T03:01:12"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2021-06-25T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "DECISAO VISTOS. CERTIFIQUE A SERVENTIA SE TODOS OS ORGAOS CONVENIADOS A ESTE JUIZO PARA PESQUISAS DE ENDERECOS FORAM CONSULTADOS E SE TODOS OS ENDERECOS ENCONTRADOS FORAM DILIGENCIADOS. INTIME-SE.",
                "PublishDate": "2021-06-25T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.21.41026443-2 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 24/06/2021 19:25",
                "PublishDate": "2021-06-24T00:00:00",
                "CaptureDate": "2021-07-01T03:01:12"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.21.41026443-2 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 24/06/2021 19:25",
                "PublishDate": "2021-06-24T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0255/2021 DATA DA DISPONIBILIZACAO: 15/06/2021 DATA DA PUBLICACAO: 16/06/2021 NUMERO DO DIARIO: 3298 PAGINA: 2/11",
                "PublishDate": "2021-06-15T00:00:00",
                "CaptureDate": "2021-07-01T03:01:12"
              },
              {
                "Content": "PROCESSO 1038441-29.2020.8.26.0100 - PROCEDIMENTO COMUM CIVEL - PRATICAS ABUSIVAS - PAULO ROBERTO ATHIE PICCELLI - STARK BANK S.A. - - FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA. - - FRI SERVICOS DE CONSULTORIA E INVESTIMENTOS LTDA - CONFORME DETERMINADO AS FLS 216, CIENCIA A PARTE INTERESSADA DAS PESQUISAS REALIZADAS VIA SISBAJUD E RENAJUD FLS 218/220. - ADV: RAFAEL HIDEO NAZIMA (OAB 295443/SP), RODRIGO FELIPE CUSCIANO (OAB 271322/SP)",
                "PublishDate": "2021-06-15T00:00:00",
                "CaptureDate": "2021-07-04T04:39:48"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0255/2021 DATA DA DISPONIBILIZACAO: 15/06/2021 DATA DA PUBLICACAO: 16/06/2021 NUMERO DO DIARIO: 3298 PAGINA: 2/11",
                "PublishDate": "2021-06-15T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0255/2021 TEOR DO ATO: CONFORME DETERMINADO AS FLS 216, CIENCIA A PARTE INTERESSADA DAS PESQUISAS REALIZADAS VIA SISBAJUD E RENAJUD FLS 218/220. ADVOGADOS(S): RODRIGO FELIPE CUSCIANO (OAB 271322/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2021-06-14T00:00:00",
                "CaptureDate": "2021-07-01T03:01:12"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0255/2021 TEOR DO ATO: CONFORME DETERMINADO AS FLS 216, CIENCIA A PARTE INTERESSADA DAS PESQUISAS REALIZADAS VIA SISBAJUD E RENAJUD FLS 218/220. ADVOGADOS(S): RODRIGO FELIPE CUSCIANO (OAB 271322/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2021-06-14T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "ATO ORDINATORIO - PUBLICAVEL | CONFORME DETERMINADO AS FLS 216, CIENCIA A PARTE INTERESSADA DAS PESQUISAS REALIZADAS VIA SISBAJUD E RENAJUD FLS 218/220.",
                "PublishDate": "2021-06-11T00:00:00",
                "CaptureDate": "2021-07-01T03:01:12"
              },
              {
                "Content": "RESPOSTA DE VERIFICACAO DE ENDERECO JUNTADO",
                "PublishDate": "2021-06-11T00:00:00",
                "CaptureDate": "2021-07-01T03:01:12"
              },
              {
                "Content": "RESPOSTA DE VERIFICACAO DE ENDERECO JUNTADO",
                "PublishDate": "2021-06-11T00:00:00",
                "CaptureDate": "2021-07-01T03:01:12"
              },
              {
                "Content": "RESPOSTA DE VERIFICACAO DE ENDERECO JUNTADO",
                "PublishDate": "2021-06-11T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "ATO ORDINATORIO - INTIMACAO - DJE CONFORME DETERMINADO AS FLS 216, CIENCIA A PARTE INTERESSADA DAS PESQUISAS REALIZADAS VIA SISBAJUD E RENAJUD FLS 218/220.",
                "PublishDate": "2021-06-11T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0234/2021 DATA DA DISPONIBILIZACAO: 28/05/2021 DATA DA PUBLICACAO: 31/05/2021 NUMERO DO DIARIO: 3288 PAGINA: 9/15",
                "PublishDate": "2021-05-28T00:00:00",
                "CaptureDate": "2021-06-01T13:04:39"
              },
              {
                "Content": "PROCESSO 1038441-29.2020.8.26.0100 - PROCEDIMENTO COMUM CIVEL - PRATICAS ABUSIVAS - PAULO ROBERTO ATHIE PICCELLI - STARK BANK S.A. - - FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA. - - FRI SERVICOS DE CONSULTORIA E INVESTIMENTOS LTDA - VISTOS. FLS 212- DEFIRO O PEDIDO DE PESQUISAS DE ENDERECOS POR MEIO DOS SISTEMAS SISBAJUD, E RENAJUD EM NOME DA PARTE FORTS CONSULTORIA TECNOLOGIA (CNPJ 21.160.553/0001-81). APOS A JUNTADA DOS RESULTADOS DAS PESQUISAS, INTIME-SE A PARTE REQUERENTE PARA DAR-LHE CIENCIA, BEM COMO PARA MANIFESTAR-SE EM TERMOS DE PROSSEGUIMENTO NO PRAZO CINCO DIAS. CASO SEJAM LOCALIZADOS ENDERECOS NAO DILIGENCIADOS, MEDIANTE O RECOLHIMENTO DAS CUSTAS ATINENTES, FICA DESDE JA DEFERIDA A TENTATIVA DE CITACAO NOS ENDERECOS OBTIDOS. TRANSCORRIDO O PRAZO ACIMA FIXADO E NADA VINDO, AGUARDE-SE POR TRINTA DIAS E, NO SILENCIO, INTIME-SE O AUTOR POR CARTA PARA QUE, NO PRAZO DE CINCO DIAS, PROMOVA OS ATOS E DILIGENCIAS QUE LHE COMPETEM E CUJA AUSENCIA ESTA A IMPEDIR O ANDAMENTO DO FEITO, SOB PENA DE EXTINCAO, NOS TERMOS DO ART. 485, INCISO III E  1, DO CODIGO DE PROCESSO CIVIL. INTIME-SE. - ADV: RODRIGO FELIPE CUSCIANO (OAB 271322/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2021-05-28T00:00:00",
                "CaptureDate": "2021-06-01T13:04:39"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0234/2021 DATA DA DISPONIBILIZACAO: 28/05/2021 DATA DA PUBLICACAO: 31/05/2021 NUMERO DO DIARIO: 3288 PAGINA: 9/15",
                "PublishDate": "2021-05-28T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0234/2021 TEOR DO ATO: VISTOS. FLS 212- DEFIRO O PEDIDO DE PESQUISAS DE ENDERECOS POR MEIO DOS SISTEMAS SISBAJUD, E RENAJUD EM NOME DA PARTE FORTS CONSULTORIA TECNOLOGIA (CNPJ 21.160.553/0001-81). APOS A JUNTADA DOS RESULTADOS DAS PESQUISAS, INTIME-SE A PARTE REQUERENTE PARA DAR-LHE CIENCIA, BEM COMO PARA MANIFESTAR-SE EM TERMOS DE PROSSEGUIMENTO NO PRAZO CINCO DIAS. CASO SEJAM LOCALIZADOS ENDERECOS NAO DILIGENCIADOS, MEDIANTE O RECOLHIMENTO DAS CUSTAS ATINENTES, FICA DESDE JA DEFERIDA A TENTATIVA DE CITACAO NOS ENDERECOS OBTIDOS. TRANSCORRIDO O PRAZO ACIMA FIXADO E NADA VINDO, AGUARDE-SE POR TRINTA DIAS E, NO SILENCIO, INTIME-SE O AUTOR POR CARTA PARA QUE, NO PRAZO DE CINCO DIAS, PROMOVA OS ATOS E DILIGENCIAS QUE LHE COMPETEM E CUJA AUSENCIA ESTA A IMPEDIR O ANDAMENTO DO FEITO, SOB PENA DE EXTINCAO, NOS TERMOS DO ART. 485, INCISO III E  1, DO CODIGO DE PROCESSO CIVIL. INTIME-SE. ADVOGADOS(S): RODRIGO FELIPE CUSCIANO (OAB 271322/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2021-05-26T00:00:00",
                "CaptureDate": "2021-06-01T13:04:39"
              },
              {
                "Content": "DECISAO | VISTOS. FLS 212- DEFIRO O PEDIDO DE PESQUISAS DE ENDERECOS POR MEIO DOS SISTEMAS SISBAJUD, E RENAJUD EM NOME DA PARTE FORTS CONSULTORIA TECNOLOGIA (CNPJ 21.160.553/0001-81). APOS A JUNTADA DOS RESULTADOS DAS PESQUISAS, INTIME-SE A PARTE REQUERENTE PARA DAR-LHE CIENCIA, BEM COMO PARA MANIFESTAR-SE EM TERMOS DE PROSSEGUIMENTO NO PRAZO CINCO DIAS. CASO SEJAM LOCALIZADOS ENDERECOS NAO DILIGENCIADOS, MEDIANTE O RECOLHIMENTO DAS CUSTAS ATINENTES, FICA DESDE JA DEFERIDA A TENTATIVA DE CITACAO NOS ENDERECOS OBTIDOS. TRANSCORRIDO O PRAZO ACIMA FIXADO E NADA VINDO, AGUARDE-SE POR TRINTA DIAS E, NO SILENCIO, INTIME-SE O AUTOR POR CARTA PARA QUE, NO PRAZO DE CINCO DIAS, PROMOVA OS ATOS E DILIGENCIAS QUE LHE COMPETEM E CUJA AUSENCIA ESTA A IMPEDIR O ANDAMENTO DO FEITO, SOB PENA DE EXTINCAO, NOS TERMOS DO ART. 485, INCISO III E  1, DO CODIGO DE PROCESSO CIVIL. INTIME-SE.",
                "PublishDate": "2021-05-26T00:00:00",
                "CaptureDate": "2021-06-01T13:04:39"
              },
              {
                "Content": "DECISAO VISTOS. FLS 212- DEFIRO O PEDIDO DE PESQUISAS DE ENDERECOS POR MEIO DOS SISTEMAS SISBAJUD, E RENAJUD EM NOME DA PARTE FORTS CONSULTORIA TECNOLOGIA (CNPJ 21.160.553/0001-81). APOS A JUNTADA DOS RESULTADOS DAS PESQUISAS, INTIME-SE A PARTE REQUERENTE PARA DAR-LHE CIENCIA, BEM COMO PARA MANIFESTAR-SE EM TERMOS DE PROSSEGUIMENTO NO PRAZO CINCO DIAS. CASO SEJAM LOCALIZADOS ENDERECOS NAO DILIGENCIADOS, MEDIANTE O RECOLHIMENTO DAS CUSTAS ATINENTES, FICA DESDE JA DEFERIDA A TENTATIVA DE CITACAO NOS ENDERECOS OBTIDOS. TRANSCORRIDO O PRAZO ACIMA FIXADO E NADA VINDO, AGUARDE-SE POR TRINTA DIAS E, NO SILENCIO, INTIME-SE O AUTOR POR CARTA PARA QUE, NO PRAZO DE CINCO DIAS, PROMOVA OS ATOS E DILIGENCIAS QUE LHE COMPETEM E CUJA AUSENCIA ESTA A IMPEDIR O ANDAMENTO DO FEITO, SOB PENA DE EXTINCAO, NOS TERMOS DO ART. 485, INCISO III E  1, DO CODIGO DE PROCESSO CIVIL. INTIME-SE.",
                "PublishDate": "2021-05-26T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0234/2021 TEOR DO ATO: VISTOS. FLS 212- DEFIRO O PEDIDO DE PESQUISAS DE ENDERECOS POR MEIO DOS SISTEMAS SISBAJUD, E RENAJUD EM NOME DA PARTE FORTS CONSULTORIA TECNOLOGIA (CNPJ 21.160.553/0001-81). APOS A JUNTADA DOS RESULTADOS DAS PESQUISAS, INTIME-SE A PARTE REQUERENTE PARA DAR-LHE CIENCIA, BEM COMO PARA MANIFESTAR-SE EM TERMOS DE PROSSEGUIMENTO NO PRAZO CINCO DIAS. CASO SEJAM LOCALIZADOS ENDERECOS NAO DILIGENCIADOS, MEDIANTE O RECOLHIMENTO DAS CUSTAS ATINENTES, FICA DESDE JA DEFERIDA A TENTATIVA DE CITACAO NOS ENDERECOS OBTIDOS. TRANSCORRIDO O PRAZO ACIMA FIXADO E NADA VINDO, AGUARDE-SE POR TRINTA DIAS E, NO SILENCIO, INTIME-SE O AUTOR POR CARTA PARA QUE, NO PRAZO DE CINCO DIAS, PROMOVA OS ATOS E DILIGENCIAS QUE LHE COMPETEM E CUJA AUSENCIA ESTA A IMPEDIR O ANDAMENTO DO FEITO, SOB PENA DE EXTINCAO, NOS TERMOS DO ART. 485, INCISO III E  1, DO CODIGO DE PROCESSO CIVIL. INTIME-SE. ADVOGADOS(S): RODRIGO FELIPE CUSCIANO (OAB 271322/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2021-05-26T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2021-05-19T00:00:00",
                "CaptureDate": "2021-06-01T13:04:39"
              },
              {
                "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.21.40794000-7 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 18/05/2021 15:31",
                "PublishDate": "2021-05-18T00:00:00",
                "CaptureDate": "2021-06-01T13:04:39"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.21.40794000-7 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 18/05/2021 15:31",
                "PublishDate": "2021-05-18T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0215/2021 DATA DA DISPONIBILIZACAO: 17/05/2021 DATA DA PUBLICACAO: 18/05/2021 NUMERO DO DIARIO: 3279 PAGINA: 1/9",
                "PublishDate": "2021-05-17T00:00:00",
                "CaptureDate": "2021-06-01T13:04:39"
              },
              {
                "Content": "PROCESSO 1038441-29.2020.8.26.0100 - PROCEDIMENTO COMUM CIVEL - PRATICAS ABUSIVAS - PAULO ROBERTO ATHIE PICCELLI - STARK BANK S.A. - - FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA. E OUTRO - CONFORME DETERMINADO AS FLS 204, CIENCIA A PARTE INTERESSADA DA PESQUISA REALIZADA VIA INFOJUD FLS 209. - ADV: RODRIGO FELIPE CUSCIANO (OAB 271322/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2021-05-17T00:00:00",
                "CaptureDate": "2021-06-04T21:17:31"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0215/2021 DATA DA DISPONIBILIZACAO: 17/05/2021 DATA DA PUBLICACAO: 18/05/2021 NUMERO DO DIARIO: 3279 PAGINA: 1/9",
                "PublishDate": "2021-05-17T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0215/2021 TEOR DO ATO: CONFORME DETERMINADO AS FLS 204, CIENCIA A PARTE INTERESSADA DA PESQUISA REALIZADA VIA INFOJUD FLS 209. ADVOGADOS(S): RODRIGO FELIPE CUSCIANO (OAB 271322/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2021-05-14T00:00:00",
                "CaptureDate": "2021-06-01T13:04:39"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0215/2021 TEOR DO ATO: CONFORME DETERMINADO AS FLS 204, CIENCIA A PARTE INTERESSADA DA PESQUISA REALIZADA VIA INFOJUD FLS 209. ADVOGADOS(S): RODRIGO FELIPE CUSCIANO (OAB 271322/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2021-05-14T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "ATO ORDINATORIO - PUBLICAVEL | CONFORME DETERMINADO AS FLS 204, CIENCIA A PARTE INTERESSADA DA PESQUISA REALIZADA VIA INFOJUD FLS 209.",
                "PublishDate": "2021-05-13T00:00:00",
                "CaptureDate": "2021-06-01T13:04:39"
              },
              {
                "Content": "RESPOSTA DE VERIFICAC??O DE ENDERECO JUNTADO",
                "PublishDate": "2021-05-13T00:00:00",
                "CaptureDate": "2021-06-01T13:04:39"
              },
              {
                "Content": "RESPOSTA DE VERIFICACAO DE ENDERECO JUNTADO",
                "PublishDate": "2021-05-13T00:00:00",
                "CaptureDate": "2021-06-04T21:17:31"
              },
              {
                "Content": "RESPOSTA DE VERIFICACAO DE ENDERECO JUNTADO",
                "PublishDate": "2021-05-13T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "ATO ORDINATORIO - INTIMACAO - DJE CONFORME DETERMINADO AS FLS 204, CIENCIA A PARTE INTERESSADA DA PESQUISA REALIZADA VIA INFOJUD FLS 209.",
                "PublishDate": "2021-05-13T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.21.40694073-9 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 03/05/2021 16:24",
                "PublishDate": "2021-05-03T00:00:00",
                "CaptureDate": "2021-06-01T13:04:39"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.21.40694073-9 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 03/05/2021 16:24",
                "PublishDate": "2021-05-03T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "ATO ORDINATORIO - NAO PUBLICAVEL | INTIME-SE O AUTOR POR CARTA PARA QUE PROMOVA OS ATOS E DILIGENCIAS QUE LHE COMPETEM E CUJA AUSENCIA ESTA A IMPEDIR O ANDAMENTO DO FEITO NO PRAZO DE 5 DIAS, SOB PENA DE EXTINCAO (ART. 485, INC. III E 1 DO CPC).",
                "PublishDate": "2021-04-29T00:00:00",
                "CaptureDate": "2021-06-01T13:04:39"
              },
              {
                "Content": "CERTIDAO DE CARTORIO EXPEDIDA | MANIFESTACAO DO AUTOR",
                "PublishDate": "2021-04-29T00:00:00",
                "CaptureDate": "2021-06-01T13:04:39"
              },
              {
                "Content": "CERTIDAO DE CARTORIO EXPEDIDA MANIFESTACAO DO AUTOR",
                "PublishDate": "2021-04-29T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "ATO ORDINATORIO - INTIMACAO - PORTAL INTIME-SE O AUTOR POR CARTA PARA QUE PROMOVA OS ATOS E DILIGENCIAS QUE LHE COMPETEM E CUJA AUSENCIA ESTA A IMPEDIR O ANDAMENTO DO FEITO NO PRAZO DE 5 DIAS, SOB PENA DE EXTINCAO (ART. 485, INC. III E 1 DO CPC).",
                "PublishDate": "2021-04-29T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "SUSPENSAO DO PRAZO | PRAZO REFERENTE AO USUARIO FOI ALTERADO PARA 28/04/2021 DEVIDO A ALTERACAO DA TABELA DE FERIADOS",
                "PublishDate": "2021-04-14T00:00:00",
                "CaptureDate": "2021-06-01T13:04:39"
              },
              {
                "Content": "SUSPENSAO DO PRAZO PRAZO REFERENTE AO USUARIO FOI ALTERADO PARA 28/04/2021 DEVIDO A ALTERACAO DA TABELA DE FERIADOS",
                "PublishDate": "2021-04-14T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "SUSPENSAO DO PRAZO | PRAZO REFERENTE AO USUARIO FOI ALTERADO PARA 16/04/2021 DEVIDO A ALTERACAO DA TABELA DE FERIADOS",
                "PublishDate": "2021-02-08T00:00:00",
                "CaptureDate": "2021-03-07T08:43:45"
              },
              {
                "Content": "SUSPENSAO DO PRAZO PRAZO REFERENTE AO USUARIO FOI ALTERADO PARA 16/04/2021 DEVIDO A ALTERACAO DA TABELA DE FERIADOS",
                "PublishDate": "2021-02-08T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "SUSPENSAO DO PRAZO | PRAZO REFERENTE AO USUARIO FOI ALTERADO PARA 07/01/2021 DEVIDO A ALTERACAO DA TABELA DE FERIADOS",
                "PublishDate": "2020-12-29T00:00:00",
                "CaptureDate": "2021-03-07T08:43:45"
              },
              {
                "Content": "SUSPENSAO DO PRAZO PRAZO REFERENTE AO USUARIO FOI ALTERADO PARA 07/01/2021 DEVIDO A ALTERACAO DA TABELA DE FERIADOS",
                "PublishDate": "2020-12-29T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0493/2020 DATA DA DISPONIBILIZACAO: 10/12/2020 DATA DA PUBLICACAO: 11/12/2020 NUMERO DO DIARIO: 3184 PAGINA: 665/677",
                "PublishDate": "2020-12-10T00:00:00",
                "CaptureDate": "2021-03-07T08:43:45"
              },
              {
                "Content": "PROCESSO 1038441-29.2020.8.26.0100 - PROCEDIMENTO COMUM CIVEL - PRATICAS ABUSIVAS - PAULO ROBERTO ATHIE PICCELLI - STARK BANK S.A. E OUTROS - VISTOS. COMPROVACAO O ADEQUADO RECOLHIMENTO, DEFIRO AS PESQUISAS DE ENDERECOS POR MEIO DOS SISTEMAS INFOJUD, EM NOME DA EXECUTADA FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA CNPJ: 21.160.553/0001-81 EM SEGUIDA A REALIZACAO DAS PESQUISAS, INTIME-SE A PARTE REQUERENTE PARA DAR-LHE CIENCIA ACERCA DOS RESULTADOS OBTIDOS, BEM COMO PARA MANIFESTAR-SE EM TERMOS DE PROSSEGUIMENTO NO PRAZO CINCO DIAS. CASO SEJAM LOCALIZADOS ENDERECOS NAO DILIGENCIADOS, MEDIANTE O RECOLHIMENTO DAS CUSTAS ATINENTES, FICA DESDE JA DEFERIDA A TENTATIVA DE CITACAO NOS ENDERECOS OBTIDOS. TRANSCORRIDO O PRAZO ACIMA FIXADO E NADA VINDO, AGUARDE-SE POR TRINTA DIAS E, NO SILENCIO, INTIME-SE O AUTOR POR CARTA PARA QUE, NO PRAZO DE CINCO DIAS, PROMOVA OS ATOS E DILIGENCIAS QUE LHE COMPETEM E CUJA AUSENCIA ESTA A IMPEDIR O ANDAMENTO DO FEITO, SOB PENA DE EXTINCAO, NOS TERMOS DO ART. 485, INCISO III E  1, DO CODIGO DE PROCESSO CIVIL. INTIME-SE. - ADV: RODRIGO FELIPE CUSCIANO (OAB 271322/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-12-10T00:00:00",
                "CaptureDate": "2021-03-07T08:43:45"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0493/2020 DATA DA DISPONIBILIZACAO: 10/12/2020 DATA DA PUBLICACAO: 11/12/2020 NUMERO DO DIARIO: 3184 PAGINA: 665/677",
                "PublishDate": "2020-12-10T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0493/2020 TEOR DO ATO: VISTOS. COMPROVACAO O ADEQUADO RECOLHIMENTO, DEFIRO AS PESQUISAS DE ENDERECOS POR MEIO DOS SISTEMAS INFOJUD, EM NOME DA EXECUTADA FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA CNPJ: 21.160.553/0001-81 EM SEGUIDA A REALIZACAO DAS PESQUISAS, INTIME-SE A PARTE REQUERENTE PARA DAR-LHE CIENCIA ACERCA DOS RESULTADOS OBTIDOS, BEM COMO PARA MANIFESTAR-SE EM TERMOS DE PROSSEGUIMENTO NO PRAZO CINCO DIAS. CASO SEJAM LOCALIZADOS ENDERECOS NAO DILIGENCIADOS, MEDIANTE O RECOLHIMENTO DAS CUSTAS ATINENTES, FICA DESDE JA DEFERIDA A TENTATIVA DE CITACAO NOS ENDERECOS OBTIDOS. TRANSCORRIDO O PRAZO ACIMA FIXADO E NADA VINDO, AGUARDE-SE POR TRINTA DIAS E, NO SILENCIO, INTIME-SE O AUTOR POR CARTA PARA QUE, NO PRAZO DE CINCO DIAS, PROMOVA OS ATOS E DILIGENCIAS QUE LHE COMPETEM E CUJA AUSENCIA ESTA A IMPEDIR O ANDAMENTO DO FEITO, SOB PENA DE EXTINCAO, NOS TERMOS DO ART. 485, INCISO III E  1, DO CODIGO DE PROCESSO CIVIL. INTIME-SE. ADVOGADOS(S): RODRIGO FELIPE CUSCIANO (OAB 271322/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-12-09T00:00:00",
                "CaptureDate": "2021-03-07T08:43:45"
              },
              {
                "Content": "DECISAO | VISTOS. COMPROVACAO O ADEQUADO RECOLHIMENTO, DEFIRO AS PESQUISAS DE ENDERECOS POR MEIO DOS SISTEMAS INFOJUD, EM NOME DA EXECUTADA FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA CNPJ: 21.160.553/0001-81 EM SEGUIDA A REALIZACAO DAS PESQUISAS, INTIME-SE A PARTE REQUERENTE PARA DAR-LHE CIENCIA ACERCA DOS RESULTADOS OBTIDOS, BEM COMO PARA MANIFESTAR-SE EM TERMOS DE PROSSEGUIMENTO NO PRAZO CINCO DIAS. CASO SEJAM LOCALIZADOS ENDERECOS NAO DILIGENCIADOS, MEDIANTE O RECOLHIMENTO DAS CUSTAS ATINENTES, FICA DESDE JA DEFERIDA A TENTATIVA DE CITACAO NOS ENDERECOS OBTIDOS. TRANSCORRIDO O PRAZO ACIMA FIXADO E NADA VINDO, AGUARDE-SE POR TRINTA DIAS E, NO SILENCIO, INTIME-SE O AUTOR POR CARTA PARA QUE, NO PRAZO DE CINCO DIAS, PROMOVA OS ATOS E DILIGENCIAS QUE LHE COMPETEM E CUJA AUSENCIA ESTA A IMPEDIR O ANDAMENTO DO FEITO, SOB PENA DE EXTINCAO, NOS TERMOS DO ART. 485, INCISO III E  1, DO CODIGO DE PROCESSO CIVIL. INTIME-SE.",
                "PublishDate": "2020-12-09T00:00:00",
                "CaptureDate": "2021-03-07T08:43:45"
              },
              {
                "Content": "DECISAO VISTOS. COMPROVACAO O ADEQUADO RECOLHIMENTO, DEFIRO AS PESQUISAS DE ENDERECOS POR MEIO DOS SISTEMAS INFOJUD, EM NOME DA EXECUTADA FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA CNPJ: 21.160.553/0001-81 EM SEGUIDA A REALIZACAO DAS PESQUISAS, INTIME-SE A PARTE REQUERENTE PARA DAR-LHE CIENCIA ACERCA DOS RESULTADOS OBTIDOS, BEM COMO PARA MANIFESTAR-SE EM TERMOS DE PROSSEGUIMENTO NO PRAZO CINCO DIAS. CASO SEJAM LOCALIZADOS ENDERECOS NAO DILIGENCIADOS, MEDIANTE O RECOLHIMENTO DAS CUSTAS ATINENTES, FICA DESDE JA DEFERIDA A TENTATIVA DE CITACAO NOS ENDERECOS OBTIDOS. TRANSCORRIDO O PRAZO ACIMA FIXADO E NADA VINDO, AGUARDE-SE POR TRINTA DIAS E, NO SILENCIO, INTIME-SE O AUTOR POR CARTA PARA QUE, NO PRAZO DE CINCO DIAS, PROMOVA OS ATOS E DILIGENCIAS QUE LHE COMPETEM E CUJA AUSENCIA ESTA A IMPEDIR O ANDAMENTO DO FEITO, SOB PENA DE EXTINCAO, NOS TERMOS DO ART. 485, INCISO III E  1, DO CODIGO DE PROCESSO CIVIL. INTIME-SE.",
                "PublishDate": "2020-12-09T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0493/2020 TEOR DO ATO: VISTOS. COMPROVACAO O ADEQUADO RECOLHIMENTO, DEFIRO AS PESQUISAS DE ENDERECOS POR MEIO DOS SISTEMAS INFOJUD, EM NOME DA EXECUTADA FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA CNPJ: 21.160.553/0001-81 EM SEGUIDA A REALIZACAO DAS PESQUISAS, INTIME-SE A PARTE REQUERENTE PARA DAR-LHE CIENCIA ACERCA DOS RESULTADOS OBTIDOS, BEM COMO PARA MANIFESTAR-SE EM TERMOS DE PROSSEGUIMENTO NO PRAZO CINCO DIAS. CASO SEJAM LOCALIZADOS ENDERECOS NAO DILIGENCIADOS, MEDIANTE O RECOLHIMENTO DAS CUSTAS ATINENTES, FICA DESDE JA DEFERIDA A TENTATIVA DE CITACAO NOS ENDERECOS OBTIDOS. TRANSCORRIDO O PRAZO ACIMA FIXADO E NADA VINDO, AGUARDE-SE POR TRINTA DIAS E, NO SILENCIO, INTIME-SE O AUTOR POR CARTA PARA QUE, NO PRAZO DE CINCO DIAS, PROMOVA OS ATOS E DILIGENCIAS QUE LHE COMPETEM E CUJA AUSENCIA ESTA A IMPEDIR O ANDAMENTO DO FEITO, SOB PENA DE EXTINCAO, NOS TERMOS DO ART. 485, INCISO III E  1, DO CODIGO DE PROCESSO CIVIL. INTIME-SE. ADVOGADOS(S): RODRIGO FELIPE CUSCIANO (OAB 271322/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-12-09T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2020-12-03T00:00:00",
                "CaptureDate": "2021-03-07T08:43:45"
              },
              {
                "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.20.41923007-6 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 03/12/2020 17:18",
                "PublishDate": "2020-12-03T00:00:00",
                "CaptureDate": "2021-03-07T08:43:45"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0484/2020 DATA DA DISPONIBILIZACAO: 03/12/2020 DATA DA PUBLICACAO: 04/12/2020 NUMERO DO DIARIO: 3181 PAGINA: 11/21",
                "PublishDate": "2020-12-03T00:00:00",
                "CaptureDate": "2021-03-07T08:43:45"
              },
              {
                "Content": "PROCESSO 1038441-29.2020.8.26.0100 - PROCEDIMENTO COMUM CIVEL - PRATICAS ABUSIVAS - PAULO ROBERTO ATHIE PICCELLI - STARK BANK S.A. - - FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA. - - FRI SERVICOS DE CONSULTORIA E INVESTIMENTOS LTDA - VISTOS. INDEFIRO O PEDIDO DE PESQUISA DE ENDERECOS POR MEIO DO SISTEMA INFOSEG, VEZ QUE O JUIZO NAO SE ENCONTRA HABILITADO PERANTE O REFERIDO SISTEMA. NAO OBSTANTE, POR INTELIGENCIA AO DISPOSTO NO ART. 319,  1, DO CODIGO DE PROCESSO CIVIL, ANOTO QUE O JUIZO ENCONTRA-SE HABILITADO PARA PESQUISAS DE ENDERECOS JUNTO AOS SISTEMAS SISBAJUD, INFOJUD, RENAJUD, SERASAJUD, COMGASJUD E, PARA PESSOAS FISICAS E INDEPENDENTEMENTE DO RECOLHIMENTO DE CUSTAS, SIEL. ASSIM SENDO, FICA O REQUERENTE INTIMADO PARA REFORMULAR O PEDIDO DE PESQUISA DE ENDERECOS, A SER REALIZADO POR MEIO DE QUAISQUER DOS SISTEMAS SUPRACITADOS, NO PRAZO DE DEZ DIAS. INTIME-SE. - ADV: RAFAEL HIDEO NAZIMA (OAB 295443/SP), RODRIGO FELIPE CUSCIANO (OAB 271322/SP)",
                "PublishDate": "2020-12-03T00:00:00",
                "CaptureDate": "2021-03-12T08:31:43"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0484/2020 DATA DA DISPONIBILIZACAO: 03/12/2020 DATA DA PUBLICACAO: 04/12/2020 NUMERO DO DIARIO: 3181 PAGINA: 11/21",
                "PublishDate": "2020-12-03T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.20.41923007-6 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 03/12/2020 17:18",
                "PublishDate": "2020-12-03T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2020-12-03T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0484/2020 TEOR DO ATO: VISTOS. INDEFIRO O PEDIDO DE PESQUISA DE ENDERECOS POR MEIO DO SISTEMA INFOSEG, VEZ QUE O JUIZO NAO SE ENCONTRA HABILITADO PERANTE O REFERIDO SISTEMA. NAO OBSTANTE, POR INTELIGENCIA AO DISPOSTO NO ART. 319,  1, DO CODIGO DE PROCESSO CIVIL, ANOTO QUE O JUIZO ENCONTRA-SE HABILITADO PARA PESQUISAS DE ENDERECOS JUNTO AOS SISTEMAS SISBAJUD, INFOJUD, RENAJUD, SERASAJUD, COMGASJUD E, PARA PESSOAS FISICAS E INDEPENDENTEMENTE DO RECOLHIMENTO DE CUSTAS, SIEL. ASSIM SENDO, FICA O REQUERENTE INTIMADO PARA REFORMULAR O PEDIDO DE PESQUISA DE ENDERECOS, A SER REALIZADO POR MEIO DE QUAISQUER DOS SISTEMAS SUPRACITADOS, NO PRAZO DE DEZ DIAS. INTIME-SE. ADVOGADOS(S): RODRIGO FELIPE CUSCIANO (OAB 271322/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-12-02T00:00:00",
                "CaptureDate": "2021-03-07T08:43:45"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0484/2020 TEOR DO ATO: VISTOS. INDEFIRO O PEDIDO DE PESQUISA DE ENDERECOS POR MEIO DO SISTEMA INFOSEG, VEZ QUE O JUIZO NAO SE ENCONTRA HABILITADO PERANTE O REFERIDO SISTEMA. NAO OBSTANTE, POR INTELIGENCIA AO DISPOSTO NO ART. 319,  1, DO CODIGO DE PROCESSO CIVIL, ANOTO QUE O JUIZO ENCONTRA-SE HABILITADO PARA PESQUISAS DE ENDERECOS JUNTO AOS SISTEMAS SISBAJUD, INFOJUD, RENAJUD, SERASAJUD, COMGASJUD E, PARA PESSOAS FISICAS E INDEPENDENTEMENTE DO RECOLHIMENTO DE CUSTAS, SIEL. ASSIM SENDO, FICA O REQUERENTE INTIMADO PARA REFORMULAR O PEDIDO DE PESQUISA DE ENDERECOS, A SER REALIZADO POR MEIO DE QUAISQUER DOS SISTEMAS SUPRACITADOS, NO PRAZO DE DEZ DIAS. INTIME-SE. ADVOGADOS(S): RODRIGO FELIPE CUSCIANO (OAB 271322/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-12-02T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "DECISAO | VISTOS. INDEFIRO O PEDIDO DE PESQUISA DE ENDERECOS POR MEIO DO SISTEMA INFOSEG, VEZ QUE O JUIZO NAO SE ENCONTRA HABILITADO PERANTE O REFERIDO SISTEMA. NAO OBSTANTE, POR INTELIGENCIA AO DISPOSTO NO ART. 319,  1, DO CODIGO DE PROCESSO CIVIL, ANOTO QUE O JUIZO ENCONTRA-SE HABILITADO PARA PESQUISAS DE ENDERECOS JUNTO AOS SISTEMAS SISBAJUD, INFOJUD, RENAJUD, SERASAJUD, COMGASJUD E, PARA PESSOAS FISICAS E INDEPENDENTEMENTE DO RECOLHIMENTO DE CUSTAS, SIEL. ASSIM SENDO, FICA O REQUERENTE INTIMADO PARA REFORMULAR O PEDIDO DE PESQUISA DE ENDERECOS, A SER REALIZADO POR MEIO DE QUAISQUER DOS SISTEMAS SUPRACITADOS, NO PRAZO DE DEZ DIAS. INTIME-SE.",
                "PublishDate": "2020-12-01T00:00:00",
                "CaptureDate": "2021-03-07T08:43:45"
              },
              {
                "Content": "DECISAO VISTOS. INDEFIRO O PEDIDO DE PESQUISA DE ENDERECOS POR MEIO DO SISTEMA INFOSEG, VEZ QUE O JUIZO NAO SE ENCONTRA HABILITADO PERANTE O REFERIDO SISTEMA. NAO OBSTANTE, POR INTELIGENCIA AO DISPOSTO NO ART. 319,  1, DO CODIGO DE PROCESSO CIVIL, ANOTO QUE O JUIZO ENCONTRA-SE HABILITADO PARA PESQUISAS DE ENDERECOS JUNTO AOS SISTEMAS SISBAJUD, INFOJUD, RENAJUD, SERASAJUD, COMGASJUD E, PARA PESSOAS FISICAS E INDEPENDENTEMENTE DO RECOLHIMENTO DE CUSTAS, SIEL. ASSIM SENDO, FICA O REQUERENTE INTIMADO PARA REFORMULAR O PEDIDO DE PESQUISA DE ENDERECOS, A SER REALIZADO POR MEIO DE QUAISQUER DOS SISTEMAS SUPRACITADOS, NO PRAZO DE DEZ DIAS. INTIME-SE.",
                "PublishDate": "2020-12-01T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2020-10-30T00:00:00",
                "CaptureDate": "2021-03-07T08:43:45"
              },
              {
                "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.20.41703219-6 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 28/10/2020 15:09",
                "PublishDate": "2020-10-28T00:00:00",
                "CaptureDate": "2021-03-07T08:43:45"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.20.41703219-6 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 28/10/2020 15:09",
                "PublishDate": "2020-10-28T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.20.41689547-6 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 26/10/2020 22:06",
                "PublishDate": "2020-10-26T00:00:00",
                "CaptureDate": "2021-03-07T08:43:45"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.20.41689547-6 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 26/10/2020 22:06",
                "PublishDate": "2020-10-26T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0404/2020 DATA DA DISPONIBILIZACAO: 16/10/2020 DATA DA PUBLICACAO: 19/10/2020 NUMERO DO DIARIO: 3149 PAGINA: 9/16",
                "PublishDate": "2020-10-16T00:00:00",
                "CaptureDate": "2020-10-19T04:09:17"
              },
              {
                "Content": "PROCESSO 1038441-29.2020.8.26.0100 - PROCEDIMENTO COMUM CIVEL - PRATICAS ABUSIVAS - PAULO ROBERTO ATHIE PICCELLI - STARK BANK S.A. - - FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA. - - FRI SERVICOS DE CONSULTORIA E INVESTIMENTOS LTDA - MANIFESTE-SE O AUTOR QUANTO AO(S) SEED(S) NEGATIVO(S) JUNTADO(S) AOS AUTOS. - ADV: RAFAEL HIDEO NAZIMA (OAB 295443/SP), RODRIGO FELIPE CUSCIANO (OAB 271322/SP)",
                "PublishDate": "2020-10-16T00:00:00",
                "CaptureDate": "2020-10-19T04:09:16"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0404/2020 DATA DA DISPONIBILIZACAO: 16/10/2020 DATA DA PUBLICACAO: 19/10/2020 NUMERO DO DIARIO: 3149 PAGINA: 9/16",
                "PublishDate": "2020-10-16T00:00:00",
                "CaptureDate": "2021-03-07T08:43:45"
              },
              {
                "Content": "ATO ORDINATORIO - PUBLICAVEL MANIFESTE-SE O AUTOR QUANTO AO(S) SEED(S) NEGATIVO(S) JUNTADO(S) AOS AUTOS.",
                "PublishDate": "2020-10-15T00:00:00",
                "CaptureDate": "2020-10-19T04:09:17"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0404/2020 TEOR DO ATO: MANIFESTE-SE O AUTOR QUANTO AO(S) SEED(S) NEGATIVO(S) JUNTADO(S) AOS AUTOS. ADVOGADOS(S): RODRIGO FELIPE CUSCIANO (OAB 271322/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-10-15T00:00:00",
                "CaptureDate": "2020-10-19T04:09:17"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0404/2020 TEOR DO ATO: MANIFESTE-SE O AUTOR QUANTO AO(S) SEED(S) NEGATIVO(S) JUNTADO(S) AOS AUTOS. ADVOGADOS(S): RODRIGO FELIPE CUSCIANO (OAB 271322/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-10-15T00:00:00",
                "CaptureDate": "2021-03-07T08:43:45"
              },
              {
                "Content": "ATO ORDINATORIO - PUBLICAVEL | MANIFESTE-SE O AUTOR QUANTO AO(S) SEED(S) NEGATIVO(S) JUNTADO(S) AOS AUTOS.",
                "PublishDate": "2020-10-15T00:00:00",
                "CaptureDate": "2021-03-07T08:43:45"
              },
              {
                "Content": "ATO ORDINATORIO - INTIMACAO - DJE MANIFESTE-SE O AUTOR QUANTO AO(S) SEED(S) NEGATIVO(S) JUNTADO(S) AOS AUTOS.",
                "PublishDate": "2020-10-15T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "AR NEGATIVO JUNTADO - MUDOU-SE JUNTADA DE AR : AR214090491TJ SITUACAO : MUDOU-SE MODELO : PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC DESTINATARIO : FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA.",
                "PublishDate": "2020-10-14T00:00:00",
                "CaptureDate": "2020-10-19T04:09:17"
              },
              {
                "Content": "AR NEGATIVO JUNTADO - MUDOU-SE | JUNTADA DE AR : AR214090491TJ SITUACAO : MUDOU-SE MODELO : PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC DESTINATARIO : FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA.",
                "PublishDate": "2020-10-14T00:00:00",
                "CaptureDate": "2021-03-07T08:43:45"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.20.41335077-0 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 31/08/2020 00:38",
                "PublishDate": "2020-08-31T00:00:00",
                "CaptureDate": "2020-09-26T11:09:29"
              },
              {
                "Content": "CARTA EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                "PublishDate": "2020-08-31T00:00:00",
                "CaptureDate": "2020-09-26T11:09:29"
              },
              {
                "Content": "CARTA EXPEDIDA | PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                "PublishDate": "2020-08-31T00:00:00",
                "CaptureDate": "2021-03-07T08:43:45"
              },
              {
                "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.20.41335077-0 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 31/08/2020 00:38",
                "PublishDate": "2020-08-31T00:00:00",
                "CaptureDate": "2021-03-07T08:43:45"
              },
              {
                "Content": "ATO ORDINATORIO - NAO PUBLICAVEL CARTA",
                "PublishDate": "2020-08-27T00:00:00",
                "CaptureDate": "2020-09-26T11:09:29"
              },
              {
                "Content": "ATO ORDINATORIO - NAO PUBLICAVEL | CARTA",
                "PublishDate": "2020-08-27T00:00:00",
                "CaptureDate": "2021-03-07T08:43:45"
              },
              {
                "Content": "ATO ORDINATORIO - INTIMACAO - PORTAL CARTA",
                "PublishDate": "2020-08-27T00:00:00",
                "CaptureDate": "2022-12-07T16:10:34"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.20.41305605-8 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 25/08/2020 20:04",
                "PublishDate": "2020-08-25T00:00:00",
                "CaptureDate": "2020-09-26T11:09:29"
              },
              {
                "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.20.41305605-8 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 25/08/2020 20:04",
                "PublishDate": "2020-08-25T00:00:00",
                "CaptureDate": "2021-03-07T08:43:45"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0327/2020 DATA DA DISPONIBILIZACAO: 24/08/2020 DATA DA PUBLICACAO: 25/08/2020 NUMERO DO DIARIO: 3112 PAGINA: 1/12",
                "PublishDate": "2020-08-24T00:00:00",
                "CaptureDate": "2020-09-26T11:09:29"
              },
              {
                "Content": "PROCESSO 1038441-29.2020.8.26.0100 - PROCEDIMENTO COMUM CIVEL - PRATICAS ABUSIVAS - PAULO ROBERTO ATHIE PICCELLI - STARK BANK S.A. - - FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA. - - FRI SERVICOS DE CONSULTORIA E INVESTIMENTOS LTDA - VISTOS. VERIFICO QUE O VALOR BLOQUEADO OCORREU EM NOME DE STARK BANK S.A., QUE POSSUI ADVOGADO NOS AUTOS E JA FOI INTIMADO DA CONSTRICAO. COM RELACAO A CORRE FRI SERVICOS DE CONSULTORIA E INVESTIMENTOS LTDA, VERIFICO QUE AS FLS. 145 RETORNOU AR POSITIVO E QUE DECORREU PRAZO SEM MANIFESTACAO DESTA CORRE NOS AUTOS. QUANTO AO AR QUE RETORNOU NEGATIVO EM NOME DO REQUERIDO FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA., EXPECA A SERVENTIA NOVA CARTA DE CITACAO NO ENDERECO DE FLS. 164. INTIME-SE. - ADV: RODRIGO FELIPE CUSCIANO (OAB 271322/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-08-24T00:00:00",
                "CaptureDate": "2020-09-26T11:09:29"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0327/2020 DATA DA DISPONIBILIZACAO: 24/08/2020 DATA DA PUBLICACAO: 25/08/2020 NUMERO DO DIARIO: 3112 PAGINA: 1/12",
                "PublishDate": "2020-08-24T00:00:00",
                "CaptureDate": "2021-03-07T08:43:45"
              },
              {
                "Content": "DECISAO VISTOS. VERIFICO QUE O VALOR BLOQUEADO OCORREU EM NOME DE STARK BANK S.A., QUE POSSUI ADVOGADO NOS AUTOS E JA FOI INTIMADO DA CONSTRICAO. COM RELACAO A CORRE FRI SERVICOS DE CONSULTORIA E INVESTIMENTOS LTDA, VERIFICO QUE AS FLS. 145 RETORNOU AR POSITIVO E QUE DECORREU PRAZO SEM MANIFESTACAO DESTA CORRE NOS AUTOS. QUANTO AO AR QUE RETORNOU NEGATIVO EM NOME DO REQUERIDO FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA., EXPECA A SERVENTIA NOVA CARTA DE CITACAO NO ENDERECO DE FLS. 164. INTIME-SE.",
                "PublishDate": "2020-08-20T00:00:00",
                "CaptureDate": "2020-09-26T11:09:29"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0327/2020 TEOR DO ATO: VISTOS. VERIFICO QUE O VALOR BLOQUEADO OCORREU EM NOME DE STARK BANK S.A., QUE POSSUI ADVOGADO NOS AUTOS E JA FOI INTIMADO DA CONSTRICAO. COM RELACAO A CORRE FRI SERVICOS DE CONSULTORIA E INVESTIMENTOS LTDA, VERIFICO QUE AS FLS. 145 RETORNOU AR POSITIVO E QUE DECORREU PRAZO SEM MANIFESTACAO DESTA CORRE NOS AUTOS. QUANTO AO AR QUE RETORNOU NEGATIVO EM NOME DO REQUERIDO FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA., EXPECA A SERVENTIA NOVA CARTA DE CITACAO NO ENDERECO DE FLS. 164. INTIME-SE. ADVOGADOS(S): RODRIGO FELIPE CUSCIANO (OAB 271322/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-08-20T00:00:00",
                "CaptureDate": "2020-09-26T11:09:29"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0327/2020 TEOR DO ATO: VISTOS. VERIFICO QUE O VALOR BLOQUEADO OCORREU EM NOME DE STARK BANK S.A., QUE POSSUI ADVOGADO NOS AUTOS E JA FOI INTIMADO DA CONSTRICAO. COM RELACAO A CORRE FRI SERVICOS DE CONSULTORIA E INVESTIMENTOS LTDA, VERIFICO QUE AS FLS. 145 RETORNOU AR POSITIVO E QUE DECORREU PRAZO SEM MANIFESTACAO DESTA CORRE NOS AUTOS. QUANTO AO AR QUE RETORNOU NEGATIVO EM NOME DO REQUERIDO FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA., EXPECA A SERVENTIA NOVA CARTA DE CITACAO NO ENDERECO DE FLS. 164. INTIME-SE. ADVOGADOS(S): RODRIGO FELIPE CUSCIANO (OAB 271322/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-08-20T00:00:00",
                "CaptureDate": "2021-03-07T08:43:45"
              },
              {
                "Content": "DECISAO | VISTOS. VERIFICO QUE O VALOR BLOQUEADO OCORREU EM NOME DE STARK BANK S.A., QUE POSSUI ADVOGADO NOS AUTOS E JA FOI INTIMADO DA CONSTRICAO. COM RELACAO A CORRE FRI SERVICOS DE CONSULTORIA E INVESTIMENTOS LTDA, VERIFICO QUE AS FLS. 145 RETORNOU AR POSITIVO E QUE DECORREU PRAZO SEM MANIFESTACAO DESTA CORRE NOS AUTOS. QUANTO AO AR QUE RETORNOU NEGATIVO EM NOME DO REQUERIDO FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA., EXPECA A SERVENTIA NOVA CARTA DE CITACAO NO ENDERECO DE FLS. 164. INTIME-SE.",
                "PublishDate": "2020-08-20T00:00:00",
                "CaptureDate": "2021-03-07T08:43:45"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2020-08-05T00:00:00",
                "CaptureDate": "2020-09-26T11:09:29"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.20.41130836-0 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 30/07/2020 17:22",
                "PublishDate": "2020-07-30T00:00:00",
                "CaptureDate": "2020-09-26T11:09:29"
              },
              {
                "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.20.41130836-0 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 30/07/2020 17:22",
                "PublishDate": "2020-07-30T00:00:00",
                "CaptureDate": "2021-03-07T08:43:45"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.20.41084733-0 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 24/07/2020 00:23",
                "PublishDate": "2020-07-24T00:00:00",
                "CaptureDate": "2020-09-26T11:09:29"
              },
              {
                "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.20.41084733-0 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 24/07/2020 00:23",
                "PublishDate": "2020-07-24T00:00:00",
                "CaptureDate": "2021-03-07T08:43:45"
              },
              {
                "Content": "AR POSITIVO JUNTADO JUNTADA DE AR : AR158961954TJ SITUACAO : CUMPRIDO MODELO : PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC DESTINATARIO : FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA. DILIGENCIA : 26/05/2020",
                "PublishDate": "2020-07-20T00:00:00",
                "CaptureDate": "2020-09-26T11:09:29"
              },
              {
                "Content": "AR POSITIVO JUNTADO | JUNTADA DE AR : AR158961954TJ SITUACAO : CUMPRIDO MODELO : PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC DESTINATARIO : FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA. DILIGENCIA : 26/05/2020",
                "PublishDate": "2020-07-20T00:00:00",
                "CaptureDate": "2021-03-07T08:43:45"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.20.40991115-1 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 10/07/2020 00:01",
                "PublishDate": "2020-07-10T00:00:00",
                "CaptureDate": "2020-09-26T11:09:29"
              },
              {
                "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.20.40991115-1 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 10/07/2020 00:01",
                "PublishDate": "2020-07-10T00:00:00",
                "CaptureDate": "2021-03-07T08:43:45"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0249/2020 DATA DA DISPONIBILIZACAO: 03/07/2020 DATA DA PUBLICACAO: 06/07/2020 NUMERO DO DIARIO: 3076 PAGINA: 361",
                "PublishDate": "2020-07-03T00:00:00",
                "CaptureDate": "2020-09-26T11:09:29"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0249/2020 DATA DA DISPONIBILIZACAO: 03/07/2020 DATA DA PUBLICACAO: 06/07/2020 NUMERO DO DIARIO: 3076 PAGINA: 361",
                "PublishDate": "2020-07-03T00:00:00",
                "CaptureDate": "2020-09-26T11:09:29"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0249/2020 DATA DA DISPONIBILIZACAO: 03/07/2020 DATA DA PUBLICACAO: 06/07/2020 NUMERO DO DIARIO: 3076 PAGINA: 361",
                "PublishDate": "2020-07-03T00:00:00",
                "CaptureDate": "2021-03-07T08:43:45"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0249/2020 DATA DA DISPONIBILIZACAO: 03/07/2020 DATA DA PUBLICACAO: 06/07/2020 NUMERO DO DIARIO: 3076 PAGINA: 361",
                "PublishDate": "2020-07-03T00:00:00",
                "CaptureDate": "2021-03-07T08:43:45"
              },
              {
                "Content": "PETICAO JUNTADA",
                "PublishDate": "2020-07-01T00:00:00",
                "CaptureDate": "2020-09-26T11:09:29"
              },
              {
                "Content": "DECISAO VISTOS. FLS. 154: SEM RAZAO O EXECUTADO. CONFORME MINUTA DE BLOQUEIO (FLS. 108) E DECISAO DE FLS. 116, O VALOR EXCEDENTE JA FOI DESBLOQUEADO. ASSIM, AGUARDE-SE O JULGAMENTO DO AGRAVO E RETORNO DO A.R. TORNEM PARA VERIFICACAO EM TRINTA DIAS. INTIME-SE.",
                "PublishDate": "2020-07-01T00:00:00",
                "CaptureDate": "2020-09-26T11:09:29"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0249/2020 TEOR DO ATO: VISTOS. BLOQUEADOS ATIVOS FINANCEIROS SUFICIENTES PARA A SATISFACAO DO DEBITO (STARK BANK S/A-R$ 64.000,00) FLS 106/109, REQUISITEI SUA TRANSFERENCIA PARA CONTA JUDICIAL, CONVERTENDO O BLOQUEIO EM ARRESTO, E O DESBLOQUEIO DO VALOR EXCEDENTE. CONSIDERANDO QUE A PARTE EXECUTADA AINDA NAO FOI CITADA E INTIMADA DA REALIZACAO DO BLOQUEIO VIA BACENJUD, DIGA O EXEQUENTE COM RELACAO A CITACAO E INTIMACAO. INTIME-SE. ADVOGADOS(S): RODRIGO FELIPE CUSCIANO (OAB 271322/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-07-01T00:00:00",
                "CaptureDate": "2020-09-26T11:09:29"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0249/2020 TEOR DO ATO: VISTOS. FLS. 154: SEM RAZAO O EXECUTADO. CONFORME MINUTA DE BLOQUEIO (FLS. 108) E DECISAO DE FLS. 116, O VALOR EXCEDENTE JA FOI DESBLOQUEADO. ASSIM, AGUARDE-SE O JULGAMENTO DO AGRAVO E RETORNO DO A.R. TORNEM PARA VERIFICACAO EM TRINTA DIAS. INTIME-SE. ADVOGADOS(S): RODRIGO FELIPE CUSCIANO (OAB 271322/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-07-01T00:00:00",
                "CaptureDate": "2020-09-26T11:09:29"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0249/2020 TEOR DO ATO: VISTOS. FLS. 154: SEM RAZAO O EXECUTADO. CONFORME MINUTA DE BLOQUEIO (FLS. 108) E DECISAO DE FLS. 116, O VALOR EXCEDENTE JA FOI DESBLOQUEADO. ASSIM, AGUARDE-SE O JULGAMENTO DO AGRAVO E RETORNO DO A.R. TORNEM PARA VERIFICACAO EM TRINTA DIAS. INTIME-SE. ADVOGADOS(S): RODRIGO FELIPE CUSCIANO (OAB 271322/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-07-01T00:00:00",
                "CaptureDate": "2021-03-07T08:43:45"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0249/2020 TEOR DO ATO: VISTOS. BLOQUEADOS ATIVOS FINANCEIROS SUFICIENTES PARA A SATISFACAO DO DEBITO (STARK BANK S/A-R$ 64.000,00) FLS 106/109, REQUISITEI SUA TRANSFERENCIA PARA CONTA JUDICIAL, CONVERTENDO O BLOQUEIO EM ARRESTO, E O DESBLOQUEIO DO VALOR EXCEDENTE. CONSIDERANDO QUE A PARTE EXECUTADA AINDA NAO FOI CITADA E INTIMADA DA REALIZACAO DO BLOQUEIO VIA BACENJUD, DIGA O EXEQUENTE COM RELACAO A CITACAO E INTIMACAO. INTIME-SE. ADVOGADOS(S): RODRIGO FELIPE CUSCIANO (OAB 271322/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-07-01T00:00:00",
                "CaptureDate": "2021-03-07T08:43:45"
              },
              {
                "Content": "DECISAO | VISTOS. FLS. 154: SEM RAZAO O EXECUTADO. CONFORME MINUTA DE BLOQUEIO (FLS. 108) E DECISAO DE FLS. 116, O VALOR EXCEDENTE JA FOI DESBLOQUEADO. ASSIM, AGUARDE-SE O JULGAMENTO DO AGRAVO E RETORNO DO A.R. TORNEM PARA VERIFICACAO EM TRINTA DIAS. INTIME-SE.",
                "PublishDate": "2020-07-01T00:00:00",
                "CaptureDate": "2021-03-07T08:43:45"
              },
              {
                "Content": "PETICAO JUNTADA",
                "PublishDate": "2020-07-01T00:00:00",
                "CaptureDate": "2021-03-07T08:43:45"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2020-06-28T00:00:00",
                "CaptureDate": "2020-09-26T11:09:29"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.20.40900072-8 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 26/06/2020 15:13",
                "PublishDate": "2020-06-26T00:00:00",
                "CaptureDate": "2020-09-26T11:09:29"
              },
              {
                "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.20.40900072-8 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 26/06/2020 15:13",
                "PublishDate": "2020-06-26T00:00:00",
                "CaptureDate": "2021-03-07T08:43:45"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0222/2020 DATA DA DISPONIBILIZACAO: 19/06/2020 DATA DA PUBLICACAO: 22/06/2020 NUMERO DO DIARIO: 3066 PAGINA: 18",
                "PublishDate": "2020-06-22T00:00:00",
                "CaptureDate": "2020-09-26T11:09:29"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0222/2020 DATA DA DISPONIBILIZACAO: 19/06/2020 DATA DA PUBLICACAO: 22/06/2020 NUMERO DO DIARIO: 3066 PAGINA: 18",
                "PublishDate": "2020-06-22T00:00:00",
                "CaptureDate": "2021-03-07T08:43:45"
              },
              {
                "Content": "DECISAO VISTOS. ANOTE-SE A ATRIBUICAO DE PARCIAL EFEITO SUSPENSIVO AO RECURSO DE AGRAVO DE INSTRUMENTO, PARA OBSTAR O DESBLOQUEIO E LEVANTAMENTO DO VALOR CONSTRITO VIA SISTEMA BACENJUD (FLS. 106/109). AGUARDE-SE O JULGAMENTO DO RECURSO, OCASIAO EM QUE AS PARTES DEVERAO COMUNICAR O JUIZO. FICA O REQUERIDO STARK BANK S.A. INTIMADO, NA PESSOA DE SEU ADVOGADO, ACERCA DA CONSTRICAO EFETIVADA VIA SISTEMA BACENJUD PELA PUBLICACAO DESTA DECISAO NO DJE. NO MAIS, AGUARDE-SE O RETORNO DO AVISO DE RECEBIMENTO RELATIVO A CARTA DE CITACAO EXPEDIDA EM NOME DO REQUERIDO FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA. INTIMEM-SE.",
                "PublishDate": "2020-06-17T00:00:00",
                "CaptureDate": "2020-09-26T11:09:29"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0222/2020 TEOR DO ATO: VISTOS. ANOTE-SE A ATRIBUICAO DE PARCIAL EFEITO SUSPENSIVO AO RECURSO DE AGRAVO DE INSTRUMENTO, PARA OBSTAR O DESBLOQUEIO E LEVANTAMENTO DO VALOR CONSTRITO VIA SISTEMA BACENJUD (FLS. 106/109). AGUARDE-SE O JULGAMENTO DO RECURSO, OCASIAO EM QUE AS PARTES DEVERAO COMUNICAR O JUIZO. FICA O REQUERIDO STARK BANK S.A. INTIMADO, NA PESSOA DE SEU ADVOGADO, ACERCA DA CONSTRICAO EFETIVADA VIA SISTEMA BACENJUD PELA PUBLICACAO DESTA DECISAO NO DJE. NO MAIS, AGUARDE-SE O RETORNO DO AVISO DE RECEBIMENTO RELATIVO A CARTA DE CITACAO EXPEDIDA EM NOME DO REQUERIDO FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA. INTIMEM-SE. ADVOGADOS(S): RODRIGO FELIPE CUSCIANO (OAB 271322/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-06-17T00:00:00",
                "CaptureDate": "2020-09-26T11:09:29"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0222/2020 TEOR DO ATO: VISTOS. ANOTE-SE A ATRIBUICAO DE PARCIAL EFEITO SUSPENSIVO AO RECURSO DE AGRAVO DE INSTRUMENTO, PARA OBSTAR O DESBLOQUEIO E LEVANTAMENTO DO VALOR CONSTRITO VIA SISTEMA BACENJUD (FLS. 106/109). AGUARDE-SE O JULGAMENTO DO RECURSO, OCASIAO EM QUE AS PARTES DEVERAO COMUNICAR O JUIZO. FICA O REQUERIDO STARK BANK S.A. INTIMADO, NA PESSOA DE SEU ADVOGADO, ACERCA DA CONSTRICAO EFETIVADA VIA SISTEMA BACENJUD PELA PUBLICACAO DESTA DECISAO NO DJE. NO MAIS, AGUARDE-SE O RETORNO DO AVISO DE RECEBIMENTO RELATIVO A CARTA DE CITACAO EXPEDIDA EM NOME DO REQUERIDO FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA. INTIMEM-SE. ADVOGADOS(S): RODRIGO FELIPE CUSCIANO (OAB 271322/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-06-17T00:00:00",
                "CaptureDate": "2021-03-07T08:43:45"
              },
              {
                "Content": "DECISAO | VISTOS. ANOTE-SE A ATRIBUICAO DE PARCIAL EFEITO SUSPENSIVO AO RECURSO DE AGRAVO DE INSTRUMENTO, PARA OBSTAR O DESBLOQUEIO E LEVANTAMENTO DO VALOR CONSTRITO VIA SISTEMA BACENJUD (FLS. 106/109). AGUARDE-SE O JULGAMENTO DO RECURSO, OCASIAO EM QUE AS PARTES DEVERAO COMUNICAR O JUIZO. FICA O REQUERIDO STARK BANK S.A. INTIMADO, NA PESSOA DE SEU ADVOGADO, ACERCA DA CONSTRICAO EFETIVADA VIA SISTEMA BACENJUD PELA PUBLICACAO DESTA DECISAO NO DJE. NO MAIS, AGUARDE-SE O RETORNO DO AVISO DE RECEBIMENTO RELATIVO A CARTA DE CITACAO EXPEDIDA EM NOME DO REQUERIDO FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA. INTIMEM-SE.",
                "PublishDate": "2020-06-17T00:00:00",
                "CaptureDate": "2021-03-07T08:43:45"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.20.40729434-1 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 01/06/2020 17:48",
                "PublishDate": "2020-06-05T00:00:00",
                "CaptureDate": "2020-09-26T11:09:29"
              },
              {
                "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.20.40729434-1 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 01/06/2020 17:48",
                "PublishDate": "2020-06-05T00:00:00",
                "CaptureDate": "2021-03-07T08:43:45"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2020-06-03T00:00:00",
                "CaptureDate": "2020-09-26T11:09:29"
              },
              {
                "Content": "PEDIDO DE INFORMACOES JUNTADO",
                "PublishDate": "2020-06-03T00:00:00",
                "CaptureDate": "2020-09-26T11:09:29"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2020-06-03T00:00:00",
                "CaptureDate": "2020-09-26T11:09:29"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2020-06-03T00:00:00",
                "CaptureDate": "2021-03-07T08:43:45"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2020-06-03T00:00:00",
                "CaptureDate": "2021-03-07T08:43:45"
              },
              {
                "Content": "AR POSITIVO JUNTADO JUNTADA DE AR : AR158959363TJ SITUACAO : CUMPRIDO MODELO : PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC DESTINATARIO : FRI SERVICOS DE CONSULTORIA E INVESTIMENTOS LTDA DILIGENCIA : 28/05/2020",
                "PublishDate": "2020-06-02T00:00:00",
                "CaptureDate": "2020-09-26T11:09:29"
              },
              {
                "Content": "AR POSITIVO JUNTADO | JUNTADA DE AR : AR158959363TJ SITUACAO : CUMPRIDO MODELO : PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC DESTINATARIO : FRI SERVICOS DE CONSULTORIA E INVESTIMENTOS LTDA DILIGENCIA : 28/05/2020",
                "PublishDate": "2020-06-02T00:00:00",
                "CaptureDate": "2021-03-07T08:43:45"
              },
              {
                "Content": "PEDIDO DE HABILITACAO JUNTADO N PROTOCOLO: WJMJ.20.40725186-3 TIPO DA PETICAO: PEDIDO DE HABILITACAO DATA: 01/06/2020 12:22",
                "PublishDate": "2020-06-01T00:00:00",
                "CaptureDate": "2020-09-26T11:09:29"
              },
              {
                "Content": "PEDIDO DE HABILITACAO JUNTADO | N PROTOCOLO: WJMJ.20.40725186-3 TIPO DA PETICAO: PEDIDO DE HABILITACAO DATA: 01/06/2020 12:22",
                "PublishDate": "2020-06-01T00:00:00",
                "CaptureDate": "2021-03-07T08:43:45"
              },
              {
                "Content": "AR POSITIVO JUNTADO JUNTADA DE AR : AR158959350TJ SITUACAO : CUMPRIDO MODELO : PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC DESTINATARIO : STARK BANK S.A. DILIGENCIA : 27/05/2020",
                "PublishDate": "2020-05-30T00:00:00",
                "CaptureDate": "2020-09-26T11:09:29"
              },
              {
                "Content": "AR POSITIVO JUNTADO | JUNTADA DE AR : AR158959350TJ SITUACAO : CUMPRIDO MODELO : PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC DESTINATARIO : STARK BANK S.A. DILIGENCIA : 27/05/2020",
                "PublishDate": "2020-05-30T00:00:00",
                "CaptureDate": "2021-03-07T08:43:45"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0178/2020 DATA DA DISPONIBILIZACAO: 21/05/2020 DATA DA PUBLICACAO: 26/05/2020 NUMERO DO DIARIO: 3047 PAGINA: 18",
                "PublishDate": "2020-05-26T00:00:00",
                "CaptureDate": "2020-09-26T11:09:29"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO :0178/2020 DATA DA DISPONIBILIZACAO: 21/05/2020 DATA DA PUBLICACAO: 26/05/2020 NUMERO DO DIARIO: 3047 PAGINA: 18",
                "PublishDate": "2020-05-26T00:00:00",
                "CaptureDate": "2021-03-07T08:43:45"
              },
              {
                "Content": "DECISAO VISTOS. BLOQUEADOS ATIVOS FINANCEIROS SUFICIENTES PARA A SATISFACAO DO DEBITO (STARK BANK S/A-R$ 64.000,00) FLS 106/109, REQUISITEI SUA TRANSFERENCIA PARA CONTA JUDICIAL, CONVERTENDO O BLOQUEIO EM ARRESTO, E O DESBLOQUEIO DO VALOR EXCEDENTE. CONSIDERANDO QUE A PARTE EXECUTADA AINDA NAO FOI CITADA E INTIMADA DA REALIZACAO DO BLOQUEIO VIA BACENJUD, DIGA O EXEQUENTE COM RELACAO A CITACAO E INTIMACAO. INTIME-SE.",
                "PublishDate": "2020-05-19T00:00:00",
                "CaptureDate": "2020-09-26T11:09:29"
              },
              {
                "Content": "CARTA EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                "PublishDate": "2020-05-19T00:00:00",
                "CaptureDate": "2020-09-26T11:09:29"
              },
              {
                "Content": "CARTA EXPEDIDA | PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                "PublishDate": "2020-05-19T00:00:00",
                "CaptureDate": "2021-03-07T08:43:45"
              },
              {
                "Content": "DECISAO | VISTOS. BLOQUEADOS ATIVOS FINANCEIROS SUFICIENTES PARA A SATISFACAO DO DEBITO (STARK BANK S/A-R$ 64.000,00) FLS 106/109, REQUISITEI SUA TRANSFERENCIA PARA CONTA JUDICIAL, CONVERTENDO O BLOQUEIO EM ARRESTO, E O DESBLOQUEIO DO VALOR EXCEDENTE. CONSIDERANDO QUE A PARTE EXECUTADA AINDA NAO FOI CITADA E INTIMADA DA REALIZACAO DO BLOQUEIO VIA BACENJUD, DIGA O EXEQUENTE COM RELACAO A CITACAO E INTIMACAO. INTIME-SE.",
                "PublishDate": "2020-05-19T00:00:00",
                "CaptureDate": "2021-03-07T08:43:45"
              },
              {
                "Content": "RECEBIDA A PETICAO INICIAL - CITACAO POR CARTA AR VISTOS. CUIDA-SE DE ACAO ANULATORIA CUMULADA COM RESTITUICAO DE VALORES E PEDIDO DE TUTELA DE URGENCIA AJUIZADA POR PAULO ROBERTO ATHIE PICCELLI EM FACE DE FRI SERVICOS DE CONSULTORIA E INVESTIMENTOS LTDA E OUTROS, SUSTENTANDO, EM SINTESE, TER CELEBRADO CONTRATO DE INVESTIMENTOS FINANCEIROS (MUTUO) COM AS RES FRI E FORTS BANK EM MEADOS DE NOVEMBRO DE 2019, RESPONSABILIZANDO ELAS PELO PAGAMENTO DE JUROS DE 10% AO MES NO FINAL DO PERIODO DE TRES MESES. ADUZ QUE INVESTIU OITENTA MIL REAIS MEDIANTE PAGAMENTO DE DOIS BOLETOS EM FAVOR DA RE STARK BANK. APOS A QUEBRA DE CONFIANCA, POR CONTA DA FALTA DE PAGAMENTO DOS RENDIMENTOS, SOLICITOU O RESGATE DE R$ 50.000,00 EM 29/11/2019, POREM, NAO OBTEVE SUCESSO. ALMEJA, ASSIM, A CONCESSAO DE TUTELA DE URGENCIA A PARA BLOQUEIO DE BENS (DINHEIRO, VEICULOS, IMOVEIS) EM NOME DAS REQUERIDAS, PARA SATISFACAO DO CREDITO DE R$ 64.000,00. E A SINTESE DO NECESSARIO. DECIDO. DA ANALISE DOS FATOS E FUNDAMENTOS DO PEDIDO, SEMPRE CONSIDERANDO OS LIMITES DE COGNICAO DESTA FASE DO PROCESSO, ENTENDO PRESENTES OS REQUISITOS QUE AUTORIZAM PARCIAL CONCESSAO DA TUTELA PRETENDIDA. PARA A CONCESSAO DA TUTELA DE URGENCIA DEVEM ESTAR PRESENTES OS REQUISITOS DO ARTIGO 300 DO CODIGO DE PROCESSO CIVIL, DENTRE ELES A EXISTENCIA DE ELEMENTOS QUE EVIDENCIEM A PROBABILIDADE DO DIREITO, ALEM DO PERIGO DE DANO OU O RISCO AO RESULTADO UTIL DO PROCESSO. NO PRESENTE CASO, EM JUIZO DE COGNICAO SUMARIA, VERIFICA-SE QUE, MUITO EMBORA O CONTRATO DE MUTUO (FLS. 69/71) NAO ESTEJA ASSINADO PELAS PARTES, E CERTO QUE HOUVE EMISSAO DOS BOLETOS (FLS. 63/64) PELA FORTS CONSULTORIA PARA PAGAMENTO DE VALORES DESTINADOS A CORRE STARK BANK (FLS. 65/66), EVIDENCIANDO, ASSIM, A EXISTENCIA DA RELACAO JURIDICA ENTRE AS PARTES. OUTROSSIM, OS DOCUMENTOS DE FLS. 73/76 COMPROVAM A SOLICITACAO DE DEVOLUCAO DOS VALORES INVESTIDOS, E A RESISTENCIA DAS RES EM ATENDER A SOLICITACAO DO AUTOR, O QUE EVIDENCIA A PROBABILIDADE DO DIREITO E O RISCO DE DANO IRREPARAVEL, POIS OS REUS ESTAO RETENDO VALORES, IMPOSSIBILITANDO O AUTOR DE GERIR SEU PATRIMONIO. ASSIM, PELO PODER GERAL DE CAUTELA, DEFIRO DESDE JA O PEDIDO LIMINAR PARA DETERMINAR O ARRESTO DE ATIVOS FINANCEIROS PENTENCENTES AOS REQUERIDOS POR MEIO DO SISTEMA BACENJUD NO VALOR DE R$ 64.000,00, DEVENDO O REQUERENTE COMPLEMENTAR AS CUSTAS PERTINENTES (RECOLHER MAIS UMA TAXA). NO MAIS, INDEFIRO, POR ORA, OS PEDIDOS DE PESQUISA DE BENS VIA SISTEMAS INFOJUD, RENAJUD E ARISP, POIS ALEM DE PREMATUROS, TRATA-SE DE ACAO DE CONHECIMENTO EM QUE OS REQUERIDOS SEQUER FORAM CITADOS, RESGUARDADA A POSSIBILIDADE DE ANALISE E DEFERIMENTO DE NOVO PEDIDO EM MOMENTO ULTERIOR. ESCLARECO QUE AS PESQUISAS DE BENS CONSTITUEM MEDIDAS EXCEPCIONAIS E IMPLICARIAM EM QUEBRA DE SIGILO FISCAL DOS DEVEDORES, MEDIDA INVIAVEL ANTES DA FORMACAO DA RELACAO JURIDICO-PROCESSUAL. SEM PREJUIZO, CITE-SE E INTIME-SE A PARTE RE PARA CONTESTAR O FEITO NO PRAZO DE 15 (QUINZE) DIAS UTEIS. A AUSENCIA DE CONTESTACAO IMPLICARA REVELIA E PRESUNCAO DE VERACIDADE DA MATERIA FATICA APRESENTADA NA PETICAO INICIAL. TRATANDO-SE DE PROCESSO ELETRONICO, EM PRESTIGIO AS REGRAS FUNDAMENTAIS DOS ARTIGOS 4 E 6 DO CPC FICA VEDADO O EXERCICIO DA FACULDADE PREVISTA NO ARTIGO 340 DO CPC. INTIMEM-SE.",
                "PublishDate": "2020-05-18T00:00:00",
                "CaptureDate": "2020-09-26T11:09:29"
              },
              {
                "Content": "BLOQUEIO/PENHORA ON LINE - POSITIVO JUNTADO",
                "PublishDate": "2020-05-18T00:00:00",
                "CaptureDate": "2020-09-26T11:09:29"
              },
              {
                "Content": "CARTA EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                "PublishDate": "2020-05-18T00:00:00",
                "CaptureDate": "2020-09-26T11:09:29"
              },
              {
                "Content": "CARTA EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                "PublishDate": "2020-05-18T00:00:00",
                "CaptureDate": "2020-09-26T11:09:29"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.20.40649982-9 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 18/05/2020 17:39",
                "PublishDate": "2020-05-18T00:00:00",
                "CaptureDate": "2020-09-26T11:09:29"
              },
              {
                "Content": "RECEBIDA A PETICAO INICIAL - CITACAO POR CARTA AR VISTOS. CUIDA-SE DE ACAO ANULATORIA CUMULADA COM RESTITUICAO DE VALORES E PEDIDO DE TUTELA DE URGENCIA AJUIZADA POR PAULO ROBERTO ATHIE PICCELLI EM FACE DE FRI SERVICOS DE CONSULTORIA E INVESTIMENTOS LTDA E OUTROS, SUSTENTANDO, EM SINTESE, TER CELEBRADO CONTRATO DE INVESTIMENTOS FINANCEIROS (MUTUO) COM AS RES FRI E FORTS BANK EM MEADOS DE NOVEMBRO DE 2019, RESPONSABILIZANDO ELAS PELO PAGAMENTO DE JUROS DE 10% AO MES NO FINAL DO PERIODO DE TRES MESES. ADUZ QUE INVESTIU OITENTA MIL REAIS MEDIANTE PAGAMENTO DE DOIS BOLETOS EM FAVOR DA RE STARK BANK. APOS A QUEBRA DE CONFIANCA, POR CONTA DA FALTA DE PAGAMENTO DOS RENDIMENTOS, SOLICITOU O RESGATE DE R$ 50.000,00 EM 29/11/2019, POREM, NAO OBTEVE SUCESSO. ALMEJA, ASSIM, A CONCESSAO DE TUTELA DE URGENCIA A PARA BLOQUEIO DE BENS (DINHEIRO, VEICULOS, IMOVEIS) EM NOME DAS REQUERIDAS, PARA SATISFACAO DO CREDITO DE R$ 64.000,00. E A SINTESE DO NECESSARIO. DECIDO. DA ANALISE DOS FATOS E FUNDAMENTOS DO PEDIDO, SEMPRE CONSIDERANDO OS LIMITES DE COGNICAO DESTA FASE DO PROCESSO, ENTENDO PRESENTES OS REQUISITOS QUE AUTORIZAM PARCIAL CONCESSAO DA TUTELA PRETENDIDA. PARA A CONCESSAO DA TUTELA DE URGENCIA DEVEM ESTAR PRESENTES OS REQUISITOS DO ARTIGO 300 DO CODIGO DE PROCESSO CIVIL, DENTRE ELES A EXISTENCIA DE ELEMENTOS QUE EVIDENCIEM A PROBABILIDADE DO DIREITO, ALEM DO PERIGO DE DANO OU O RISCO AO RESULTADO UTIL DO PROCESSO. NO PRESENTE CASO, EM JUIZO DE COGNICAO SUMARIA, VERIFICA-SE QUE, MUITO EMBORA O CONTRATO DE MUTUO (FLS. 69/71) NAO ESTEJA ASSINADO PELAS PARTES, E CERTO QUE HOUVE EMISSAO DOS BOLETOS (FLS. 63/64) PELA FORTS CONSULTORIA PARA PAGAMENTO DE VALORES DESTINADOS A CORRE STARK BANK (FLS. 65/66), EVIDENCIANDO, ASSIM, A EXISTENCIA DA RELACAO JURIDICA ENTRE AS PARTES. OUTROSSIM, OS DOCUMENTOS DE FLS. 73/76 COMPROVAM A SOLICITACAO DE DEVOLUCAO DOS VALORES INVESTIDOS, E A RESISTENCIA DAS RES EM ATENDER A SOLICITACAO DO AUTOR, O QUE EVIDENCIA A PROBABILIDADE DO DIREITO E O RISCO DE DANO IRREPARAVEL, POIS OS REUS ESTAO RETENDO VALORES, IMPOSSIBILITANDO O AUTOR DE GERIR SEU PATRIMONIO. ASSIM, PELO PODER GERAL DE CAUTELA, DEFIRO DESDE JA O PEDIDO LIMINAR PARA DETERMINAR O ARRESTO DE ATIVOS FINANCEIROS PENTENCENTES AOS REQUERIDOS POR MEIO DO SISTEMA BACENJUD NO VALOR DE R$ 64.000,00, DEVENDO O REQUERENTE COMPLEMENTAR AS CUSTAS PERTINENTES (RECOLHER MAIS UMA TAXA). NO MAIS, INDEFIRO, POR ORA, OS PEDIDOS DE PESQUISA DE BENS VIA SISTEMAS INFOJUD, RENAJUD E ARISP, POIS ALEM DE PREMATUROS, TRATA-SE DE ACAO DE CONHECIMENTO EM QUE OS REQUERIDOS SEQUER FORAM CITADOS, RESGUARDADA A POSSIBILIDADE DE ANALISE E DEFERIMENTO DE NOVO PEDIDO EM MOMENTO ULTERIOR. ESCLARECO QUE AS PESQUISAS DE BENS CONSTITUEM MEDIDAS EXCEPCIONAIS E IMPLICARIAM EM QUEBRA DE SIGILO FISCAL DOS DEVEDORES, MEDIDA INVIAVEL ANTES DA FORMACAO DA RELACAO JURIDICO-PROCESSUAL. SEM PREJUIZO, CITE-SE E INTIME-SE A PARTE RE PARA CONTESTAR O FEITO NO PRAZO DE 15 (QUINZE) DIAS UTEIS. A AUSENCIA DE CONTESTACAO IMPLICARA REVELIA E PRESUNCAO DE VERACIDADE DA MATERIA FATICA APRESENTADA NA PETICAO INICIAL. TRATANDO-SE DE PROCESSO ELETRONICO, EM PRESTIGIO AS REGRAS FUNDAMENTAIS DOS ARTIGOS 4 E 6 DO CPC FICA VEDADO O EXERCICIO DA FACULDADE PREVISTA NO ARTIGO 340 DO CPC. INTIMEM-SE.",
                "PublishDate": "2020-05-18T00:00:00",
                "CaptureDate": "2020-09-26T11:09:29"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0178/2020 TEOR DO ATO: VISTOS. CUIDA-SE DE ACAO ANULATORIA CUMULADA COM RESTITUICAO DE VALORES E PEDIDO DE TUTELA DE URGENCIA AJUIZADA POR PAULO ROBERTO ATHIE PICCELLI EM FACE DE FRI SERVICOS DE CONSULTORIA E INVESTIMENTOS LTDA E OUTROS, SUSTENTANDO, EM SINTESE, TER CELEBRADO CONTRATO DE INVESTIMENTOS FINANCEIROS (MUTUO) COM AS RES FRI E FORTS BANK EM MEADOS DE NOVEMBRO DE 2019, RESPONSABILIZANDO ELAS PELO PAGAMENTO DE JUROS DE 10% AO MES NO FINAL DO PERIODO DE TRES MESES. ADUZ QUE INVESTIU OITENTA MIL REAIS MEDIANTE PAGAMENTO DE DOIS BOLETOS EM FAVOR DA RE STARK BANK. APOS A QUEBRA DE CONFIANCA, POR CONTA DA FALTA DE PAGAMENTO DOS RENDIMENTOS, SOLICITOU O RESGATE DE R$ 50.000,00 EM 29/11/2019, POREM, NAO OBTEVE SUCESSO. ALMEJA, ASSIM, A CONCESSAO DE TUTELA DE URGENCIA A PARA BLOQUEIO DE BENS (DINHEIRO, VEICULOS, IMOVEIS) EM NOME DAS REQUERIDAS, PARA SATISFACAO DO CREDITO DE R$ 64.000,00. E A SINTESE DO NECESSARIO. DECIDO. DA ANALISE DOS FATOS E FUNDAMENTOS DO PEDIDO, SEMPRE CONSIDERANDO OS LIMITES DE COGNICAO DESTA FASE DO PROCESSO, ENTENDO PRESENTES OS REQUISITOS QUE AUTORIZAM PARCIAL CONCESSAO DA TUTELA PRETENDIDA. PARA A CONCESSAO DA TUTELA DE URGENCIA DEVEM ESTAR PRESENTES OS REQUISITOS DO ARTIGO 300 DO CODIGO DE PROCESSO CIVIL, DENTRE ELES A EXISTENCIA DE ELEMENTOS QUE EVIDENCIEM A PROBABILIDADE DO DIREITO, ALEM DO PERIGO DE DANO OU O RISCO AO RESULTADO UTIL DO PROCESSO. NO PRESENTE CASO, EM JUIZO DE COGNICAO SUMARIA, VERIFICA-SE QUE, MUITO EMBORA O CONTRATO DE MUTUO (FLS. 69/71) NAO ESTEJA ASSINADO PELAS PARTES, E CERTO QUE HOUVE EMISSAO DOS BOLETOS (FLS. 63/64) PELA FORTS CONSULTORIA PARA PAGAMENTO DE VALORES DESTINADOS A CORRE STARK BANK (FLS. 65/66), EVIDENCIANDO, ASSIM, A EXISTENCIA DA RELACAO JURIDICA ENTRE AS PARTES. OUTROSSIM, OS DOCUMENTOS DE FLS. 73/76 COMPROVAM A SOLICITACAO DE DEVOLUCAO DOS VALORES INVESTIDOS, E A RESISTENCIA DAS RES EM ATENDER A SOLICITACAO DO AUTOR, O QUE EVIDENCIA A PROBABILIDADE DO DIREITO E O RISCO DE DANO IRREPARAVEL, POIS OS REUS ESTAO RETENDO VALORES, IMPOSSIBILITANDO O AUTOR DE GERIR SEU PATRIMONIO. ASSIM, PELO PODER GERAL DE CAUTELA, DEFIRO DESDE JA O PEDIDO LIMINAR PARA DETERMINAR O ARRESTO DE ATIVOS FINANCEIROS PENTENCENTES AOS REQUERIDOS POR MEIO DO SISTEMA BACENJUD NO VALOR DE R$ 64.000,00, DEVENDO O REQUERENTE COMPLEMENTAR AS CUSTAS PERTINENTES (RECOLHER MAIS UMA TAXA). NO MAIS, INDEFIRO, POR ORA, OS PEDIDOS DE PESQUISA DE BENS VIA SISTEMAS INFOJUD, RENAJUD E ARISP, POIS ALEM DE PREMATUROS, TRATA-SE DE ACAO DE CONHECIMENTO EM QUE OS REQUERIDOS SEQUER FORAM CITADOS, RESGUARDADA A POSSIBILIDADE DE ANALISE E DEFERIMENTO DE NOVO PEDIDO EM MOMENTO ULTERIOR. ESCLARECO QUE AS PESQUISAS DE BENS CONSTITUEM MEDIDAS EXCEPCIONAIS E IMPLICARIAM EM QUEBRA DE SIGILO FISCAL DOS DEVEDORES, MEDIDA INVIAVEL ANTES DA FORMACAO DA RELACAO JURIDICO-PROCESSUAL. SEM PREJUIZO, CITE-SE E INTIME-SE A PARTE RE PARA CONTESTAR O FEITO NO PRAZO DE 15 (QUINZE) DIAS UTEIS. A AUSENCIA DE CONTESTACAO IMPLICARA REVELIA E PRESUNCAO DE VERACIDADE DA MATERIA FATICA APRESENTADA NA PETICAO INICIAL. TRATANDO-SE DE PROCESSO ELETRONICO, EM PRESTIGIO AS REGRAS FUNDAMENTAIS DOS ARTIGOS 4 E 6 DO CPC FICA VEDADO O EXERCICIO DA FACULDADE PREVISTA NO ARTIGO 340 DO CPC. INTIMEM-SE. ADVOGADOS(S): RODRIGO FELIPE CUSCIANO (OAB 271322/SP)",
                "PublishDate": "2020-05-18T00:00:00",
                "CaptureDate": "2020-09-26T11:09:29"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0178/2020 TEOR DO ATO: VISTOS. CUIDA-SE DE ACAO ANULATORIA CUMULADA COM RESTITUICAO DE VALORES E PEDIDO DE TUTELA DE URGENCIA AJUIZADA POR PAULO ROBERTO ATHIE PICCELLI EM FACE DE FRI SERVICOS DE CONSULTORIA E INVESTIMENTOS LTDA E OUTROS, SUSTENTANDO, EM SINTESE, TER CELEBRADO CONTRATO DE INVESTIMENTOS FINANCEIROS (MUTUO) COM AS RES FRI E FORTS BANK EM MEADOS DE NOVEMBRO DE 2019, RESPONSABILIZANDO ELAS PELO PAGAMENTO DE JUROS DE 10% AO MES NO FINAL DO PERIODO DE TRES MESES. ADUZ QUE INVESTIU OITENTA MIL REAIS MEDIANTE PAGAMENTO DE DOIS BOLETOS EM FAVOR DA RE STARK BANK. APOS A QUEBRA DE CONFIANCA, POR CONTA DA FALTA DE PAGAMENTO DOS RENDIMENTOS, SOLICITOU O RESGATE DE R$ 50.000,00 EM 29/11/2019, POREM, NAO OBTEVE SUCESSO. ALMEJA, ASSIM, A CONCESSAO DE TUTELA DE URGENCIA A PARA BLOQUEIO DE BENS (DINHEIRO, VEICULOS, IMOVEIS) EM NOME DAS REQUERIDAS, PARA SATISFACAO DO CREDITO DE R$ 64.000,00. E A SINTESE DO NECESSARIO. DECIDO. DA ANALISE DOS FATOS E FUNDAMENTOS DO PEDIDO, SEMPRE CONSIDERANDO OS LIMITES DE COGNICAO DESTA FASE DO PROCESSO, ENTENDO PRESENTES OS REQUISITOS QUE AUTORIZAM PARCIAL CONCESSAO DA TUTELA PRETENDIDA. PARA A CONCESSAO DA TUTELA DE URGENCIA DEVEM ESTAR PRESENTES OS REQUISITOS DO ARTIGO 300 DO CODIGO DE PROCESSO CIVIL, DENTRE ELES A EXISTENCIA DE ELEMENTOS QUE EVIDENCIEM A PROBABILIDADE DO DIREITO, ALEM DO PERIGO DE DANO OU O RISCO AO RESULTADO UTIL DO PROCESSO. NO PRESENTE CASO, EM JUIZO DE COGNICAO SUMARIA, VERIFICA-SE QUE, MUITO EMBORA O CONTRATO DE MUTUO (FLS. 69/71) NAO ESTEJA ASSINADO PELAS PARTES, E CERTO QUE HOUVE EMISSAO DOS BOLETOS (FLS. 63/64) PELA FORTS CONSULTORIA PARA PAGAMENTO DE VALORES DESTINADOS A CORRE STARK BANK (FLS. 65/66), EVIDENCIANDO, ASSIM, A EXISTENCIA DA RELACAO JURIDICA ENTRE AS PARTES. OUTROSSIM, OS DOCUMENTOS DE FLS. 73/76 COMPROVAM A SOLICITACAO DE DEVOLUCAO DOS VALORES INVESTIDOS, E A RESISTENCIA DAS RES EM ATENDER A SOLICITACAO DO AUTOR, O QUE EVIDENCIA A PROBABILIDADE DO DIREITO E O RISCO DE DANO IRREPARAVEL, POIS OS REUS ESTAO RETENDO VALORES, IMPOSSIBILITANDO O AUTOR DE GERIR SEU PATRIMONIO. ASSIM, PELO PODER GERAL DE CAUTELA, DEFIRO DESDE JA O PEDIDO LIMINAR PARA DETERMINAR O ARRESTO DE ATIVOS FINANCEIROS PENTENCENTES AOS REQUERIDOS POR MEIO DO SISTEMA BACENJUD NO VALOR DE R$ 64.000,00, DEVENDO O REQUERENTE COMPLEMENTAR AS CUSTAS PERTINENTES (RECOLHER MAIS UMA TAXA). NO MAIS, INDEFIRO, POR ORA, OS PEDIDOS DE PESQUISA DE BENS VIA SISTEMAS INFOJUD, RENAJUD E ARISP, POIS ALEM DE PREMATUROS, TRATA-SE DE ACAO DE CONHECIMENTO EM QUE OS REQUERIDOS SEQUER FORAM CITADOS, RESGUARDADA A POSSIBILIDADE DE ANALISE E DEFERIMENTO DE NOVO PEDIDO EM MOMENTO ULTERIOR. ESCLARECO QUE AS PESQUISAS DE BENS CONSTITUEM MEDIDAS EXCEPCIONAIS E IMPLICARIAM EM QUEBRA DE SIGILO FISCAL DOS DEVEDORES, MEDIDA INVIAVEL ANTES DA FORMACAO DA RELACAO JURIDICO-PROCESSUAL. SEM PREJUIZO, CITE-SE E INTIME-SE A PARTE RE PARA CONTESTAR O FEITO NO PRAZO DE 15 (QUINZE) DIAS UTEIS. A AUSENCIA DE CONTESTACAO IMPLICARA REVELIA E PRESUNCAO DE VERACIDADE DA MATERIA FATICA APRESENTADA NA PETICAO INICIAL. TRATANDO-SE DE PROCESSO ELETRONICO, EM PRESTIGIO AS REGRAS FUNDAMENTAIS DOS ARTIGOS 4 E 6 DO CPC FICA VEDADO O EXERCICIO DA FACULDADE PREVISTA NO ARTIGO 340 DO CPC. INTIMEM-SE. ADVOGADOS(S): RODRIGO FELIPE CUSCIANO (OAB 271322/SP)",
                "PublishDate": "2020-05-18T00:00:00",
                "CaptureDate": "2021-03-07T08:43:45"
              },
              {
                "Content": "RECEBIDA A PETICAO INICIAL - CITACAO POR CARTA AR | VISTOS. CUIDA-SE DE ACAO ANULATORIA CUMULADA COM RESTITUICAO DE VALORES E PEDIDO DE TUTELA DE URGENCIA AJUIZADA POR PAULO ROBERTO ATHIE PICCELLI EM FACE DE FRI SERVICOS DE CONSULTORIA E INVESTIMENTOS LTDA E OUTROS, SUSTENTANDO, EM SINTESE, TER CELEBRADO CONTRATO DE INVESTIMENTOS FINANCEIROS (MUTUO) COM AS RES FRI E FORTS BANK EM MEADOS DE NOVEMBRO DE 2019, RESPONSABILIZANDO ELAS PELO PAGAMENTO DE JUROS DE 10% AO MES NO FINAL DO PERIODO DE TRES MESES. ADUZ QUE INVESTIU OITENTA MIL REAIS MEDIANTE PAGAMENTO DE DOIS BOLETOS EM FAVOR DA RE STARK BANK. APOS A QUEBRA DE CONFIANCA, POR CONTA DA FALTA DE PAGAMENTO DOS RENDIMENTOS, SOLICITOU O RESGATE DE R$ 50.000,00 EM 29/11/2019, POREM, NAO OBTEVE SUCESSO. ALMEJA, ASSIM, A CONCESSAO DE TUTELA DE URGENCIA A PARA BLOQUEIO DE BENS (DINHEIRO, VEICULOS, IMOVEIS) EM NOME DAS REQUERIDAS, PARA SATISFACAO DO CREDITO DE R$ 64.000,00. E A SINTESE DO NECESSARIO. DECIDO. DA ANALISE DOS FATOS E FUNDAMENTOS DO PEDIDO, SEMPRE CONSIDERANDO OS LIMITES DE COGNICAO DESTA FASE DO PROCESSO, ENTENDO PRESENTES OS REQUISITOS QUE AUTORIZAM PARCIAL CONCESSAO DA TUTELA PRETENDIDA. PARA A CONCESSAO DA TUTELA DE URGENCIA DEVEM ESTAR PRESENTES OS REQUISITOS DO ARTIGO 300 DO CODIGO DE PROCESSO CIVIL, DENTRE ELES A EXISTENCIA DE ELEMENTOS QUE EVIDENCIEM A PROBABILIDADE DO DIREITO, ALEM DO PERIGO DE DANO OU O RISCO AO RESULTADO UTIL DO PROCESSO. NO PRESENTE CASO, EM JUIZO DE COGNICAO SUMARIA, VERIFICA-SE QUE, MUITO EMBORA O CONTRATO DE MUTUO (FLS. 69/71) NAO ESTEJA ASSINADO PELAS PARTES, E CERTO QUE HOUVE EMISSAO DOS BOLETOS (FLS. 63/64) PELA FORTS CONSULTORIA PARA PAGAMENTO DE VALORES DESTINADOS A CORRE STARK BANK (FLS. 65/66), EVIDENCIANDO, ASSIM, A EXISTENCIA DA RELACAO JURIDICA ENTRE AS PARTES. OUTROSSIM, OS DOCUMENTOS DE FLS. 73/76 COMPROVAM A SOLICITACAO DE DEVOLUCAO DOS VALORES INVESTIDOS, E A RESISTENCIA DAS RES EM ATENDER A SOLICITACAO DO AUTOR, O QUE EVIDENCIA A PROBABILIDADE DO DIREITO E O RISCO DE DANO IRREPARAVEL, POIS OS REUS ESTAO RETENDO VALORES, IMPOSSIBILITANDO O AUTOR DE GERIR SEU PATRIMONIO. ASSIM, PELO PODER GERAL DE CAUTELA, DEFIRO DESDE JA O PEDIDO LIMINAR PARA DETERMINAR O ARRESTO DE ATIVOS FINANCEIROS PENTENCENTES AOS REQUERIDOS POR MEIO DO SISTEMA BACENJUD NO VALOR DE R$ 64.000,00, DEVENDO O REQUERENTE COMPLEMENTAR AS CUSTAS PERTINENTES (RECOLHER MAIS UMA TAXA). NO MAIS, INDEFIRO, POR ORA, OS PEDIDOS DE PESQUISA DE BENS VIA SISTEMAS INFOJUD, RENAJUD E ARISP, POIS ALEM DE PREMATUROS, TRATA-SE DE ACAO DE CONHECIMENTO EM QUE OS REQUERIDOS SEQUER FORAM CITADOS, RESGUARDADA A POSSIBILIDADE DE ANALISE E DEFERIMENTO DE NOVO PEDIDO EM MOMENTO ULTERIOR. ESCLARECO QUE AS PESQUISAS DE BENS CONSTITUEM MEDIDAS EXCEPCIONAIS E IMPLICARIAM EM QUEBRA DE SIGILO FISCAL DOS DEVEDORES, MEDIDA INVIAVEL ANTES DA FORMACAO DA RELACAO JURIDICO-PROCESSUAL. SEM PREJUIZO, CITE-SE E INTIME-SE A PARTE RE PARA CONTESTAR O FEITO NO PRAZO DE 15 (QUINZE) DIAS UTEIS. A AUSENCIA DE CONTESTACAO IMPLICARA REVELIA E PRESUNCAO DE VERACIDADE DA MATERIA FATICA APRESENTADA NA PETICAO INICIAL. TRATANDO-SE DE PROCESSO ELETRONICO, EM PRESTIGIO AS REGRAS FUNDAMENTAIS DOS ARTIGOS 4 E 6 DO CPC FICA VEDADO O EXERCICIO DA FACULDADE PREVISTA NO ARTIGO 340 DO CPC. INTIMEM-SE.",
                "PublishDate": "2020-05-18T00:00:00",
                "CaptureDate": "2021-03-07T08:43:45"
              },
              {
                "Content": "PETICAO JUNTADA | N PROTOCOLO: WJMJ.20.40649982-9 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 18/05/2020 17:39",
                "PublishDate": "2020-05-18T00:00:00",
                "CaptureDate": "2021-03-07T08:43:45"
              },
              {
                "Content": "CARTA EXPEDIDA | PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                "PublishDate": "2020-05-18T00:00:00",
                "CaptureDate": "2021-03-07T08:43:45"
              },
              {
                "Content": "CARTA EXPEDIDA | PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                "PublishDate": "2020-05-18T00:00:00",
                "CaptureDate": "2021-03-07T08:43:45"
              },
              {
                "Content": "BLOQUEIO/PENHORA ON LINE - POSITIVO JUNTADO",
                "PublishDate": "2020-05-18T00:00:00",
                "CaptureDate": "2021-03-07T08:43:45"
              },
              {
                "Content": "RECEBIDA A PETICAO INICIAL - CITACAO POR CARTA AR | VISTOS. CUIDA-SE DE ACAO ANULATORIA CUMULADA COM RESTITUICAO DE VALORES E PEDIDO DE TUTELA DE URGENCIA AJUIZADA POR PAULO ROBERTO ATHIE PICCELLI EM FACE DE FRI SERVICOS DE CONSULTORIA E INVESTIMENTOS LTDA E OUTROS, SUSTENTANDO, EM SINTESE, TER CELEBRADO CONTRATO DE INVESTIMENTOS FINANCEIROS (MUTUO) COM AS RES FRI E FORTS BANK EM MEADOS DE NOVEMBRO DE 2019, RESPONSABILIZANDO ELAS PELO PAGAMENTO DE JUROS DE 10% AO MES NO FINAL DO PERIODO DE TRES MESES. ADUZ QUE INVESTIU OITENTA MIL REAIS MEDIANTE PAGAMENTO DE DOIS BOLETOS EM FAVOR DA RE STARK BANK. APOS A QUEBRA DE CONFIANCA, POR CONTA DA FALTA DE PAGAMENTO DOS RENDIMENTOS, SOLICITOU O RESGATE DE R$ 50.000,00 EM 29/11/2019, POREM, NAO OBTEVE SUCESSO. ALMEJA, ASSIM, A CONCESSAO DE TUTELA DE URGENCIA A PARA BLOQUEIO DE BENS (DINHEIRO, VEICULOS, IMOVEIS) EM NOME DAS REQUERIDAS, PARA SATISFACAO DO CREDITO DE R$ 64.000,00. E A SINTESE DO NECESSARIO. DECIDO. DA ANALISE DOS FATOS E FUNDAMENTOS DO PEDIDO, SEMPRE CONSIDERANDO OS LIMITES DE COGNICAO DESTA FASE DO PROCESSO, ENTENDO PRESENTES OS REQUISITOS QUE AUTORIZAM PARCIAL CONCESSAO DA TUTELA PRETENDIDA. PARA A CONCESSAO DA TUTELA DE URGENCIA DEVEM ESTAR PRESENTES OS REQUISITOS DO ARTIGO 300 DO CODIGO DE PROCESSO CIVIL, DENTRE ELES A EXISTENCIA DE ELEMENTOS QUE EVIDENCIEM A PROBABILIDADE DO DIREITO, ALEM DO PERIGO DE DANO OU O RISCO AO RESULTADO UTIL DO PROCESSO. NO PRESENTE CASO, EM JUIZO DE COGNICAO SUMARIA, VERIFICA-SE QUE, MUITO EMBORA O CONTRATO DE MUTUO (FLS. 69/71) NAO ESTEJA ASSINADO PELAS PARTES, E CERTO QUE HOUVE EMISSAO DOS BOLETOS (FLS. 63/64) PELA FORTS CONSULTORIA PARA PAGAMENTO DE VALORES DESTINADOS A CORRE STARK BANK (FLS. 65/66), EVIDENCIANDO, ASSIM, A EXISTENCIA DA RELACAO JURIDICA ENTRE AS PARTES. OUTROSSIM, OS DOCUMENTOS DE FLS. 73/76 COMPROVAM A SOLICITACAO DE DEVOLUCAO DOS VALORES INVESTIDOS, E A RESISTENCIA DAS RES EM ATENDER A SOLICITACAO DO AUTOR, O QUE EVIDENCIA A PROBABILIDADE DO DIREITO E O RISCO DE DANO IRREPARAVEL, POIS OS REUS ESTAO RETENDO VALORES, IMPOSSIBILITANDO O AUTOR DE GERIR SEU PATRIMONIO. ASSIM, PELO PODER GERAL DE CAUTELA, DEFIRO DESDE JA O PEDIDO LIMINAR PARA DETERMINAR O ARRESTO DE ATIVOS FINANCEIROS PENTENCENTES AOS REQUERIDOS POR MEIO DO SISTEMA BACENJUD NO VALOR DE R$ 64.000,00, DEVENDO O REQUERENTE COMPLEMENTAR AS CUSTAS PERTINENTES (RECOLHER MAIS UMA TAXA). NO MAIS, INDEFIRO, POR ORA, OS PEDIDOS DE PESQUISA DE BENS VIA SISTEMAS INFOJUD, RENAJUD E ARISP, POIS ALEM DE PREMATUROS, TRATA-SE DE ACAO DE CONHECIMENTO EM QUE OS REQUERIDOS SEQUER FORAM CITADOS, RESGUARDADA A POSSIBILIDADE DE ANALISE E DEFERIMENTO DE NOVO PEDIDO EM MOMENTO ULTERIOR. ESCLARECO QUE AS PESQUISAS DE BENS CONSTITUEM MEDIDAS EXCEPCIONAIS E IMPLICARIAM EM QUEBRA DE SIGILO FISCAL DOS DEVEDORES, MEDIDA INVIAVEL ANTES DA FORMACAO DA RELACAO JURIDICO-PROCESSUAL. SEM PREJUIZO, CITE-SE E INTIME-SE A PARTE RE PARA CONTESTAR O FEITO NO PRAZO DE 15 (QUINZE) DIAS UTEIS. A AUSENCIA DE CONTESTACAO IMPLICARA REVELIA E PRESUNCAO DE VERACIDADE DA MATERIA FATICA APRESENTADA NA PETICAO INICIAL. TRATANDO-SE DE PROCESSO ELETRONICO, EM PRESTIGIO AS REGRAS FUNDAMENTAIS DOS ARTIGOS 4 E 6 DO CPC FICA VEDADO O EXERCICIO DA FACULDADE PREVISTA NO ARTIGO 340 DO CPC. INTIMEM-SE.",
                "PublishDate": "2020-05-18T00:00:00",
                "CaptureDate": "2021-03-07T08:43:45"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2020-05-12T00:00:00",
                "CaptureDate": "2020-09-26T11:09:29"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2020-05-11T00:00:00",
                "CaptureDate": "2020-09-26T11:09:29"
              }
            ],
            "Petitions": [
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2020-05-18T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PEDIDO DE HABILITACAO",
                "Author": "",
                "CreationDate": "2020-06-01T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2020-06-01T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2020-06-26T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2020-07-10T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2020-07-24T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2020-07-30T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2020-08-25T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2020-08-31T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2020-10-26T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2020-10-28T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2020-12-03T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2021-05-03T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2021-05-18T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2021-06-24T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2021-08-16T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2021-09-13T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2021-10-22T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2021-11-26T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2022-02-16T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2022-03-04T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "CONTESTACAO",
                "Author": "",
                "CreationDate": "2022-06-21T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              }
            ],
            "Decisions": [
              {
                "DecisionContent": "DEFIRO A CITACAO POR EDITAL DO(A) REQUERIDO(A) FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA.",
                "DecisionDate": "2022-05-12T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO A CITACAO POR EDITAL DO(A) REQUERIDO(A) FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA.",
                "DecisionDate": "2022-05-11T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO O PEDIDO DE PESQUISAS DE ENDERECOS POR MEIO DOS SISTEMAS SERASAJUD E COMGASJUD EM NOME DA PARTE (CPF/CNPJ ACIMA INDICADO).",
                "DecisionDate": "2021-08-20T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO O PEDIDO DE PESQUISAS DE ENDERECOS POR MEIO DOS SISTEMAS SERASAJUD E COMGASJUD EM NOME DA PARTE (CPF/CNPJ ACIMA INDICADO).",
                "DecisionDate": "2021-08-19T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO O PEDIDO DE PESQUISAS DE ENDERECOS POR MEIO DOS SISTEMAS SERASAJUD E COMGASJUD EM NOME DA PARTE (CPF/CNPJ ACIMA INDICADO).",
                "DecisionDate": "2021-08-19T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO O PEDIDO DE PESQUISAS DE ENDERECOS POR MEIO DOS SISTEMAS SERASAJUD E COMGASJUD EM NOME DA PARTE (CPF/CNPJ ACIMA INDICADO).",
                "DecisionDate": "2021-08-18T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO O PEDIDO DE PESQUISAS DE ENDERECOS POR MEIO DOS SISTEMAS SERASAJUD E COMGASJUD EM NOME DA PARTE (CPF/CNPJ ACIMA INDICADO).",
                "DecisionDate": "2021-08-18T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO O PEDIDO DE PESQUISAS DE ENDERECOS POR MEIO DOS SISTEMAS SISBAJUD, E RENAJUD EM NOME DA PARTE FORTS CONSULTORIA TECNOLOGIA (CNPJ 21.160.553/0001-81).",
                "DecisionDate": "2021-05-28T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO O PEDIDO DE PESQUISAS DE ENDERECOS POR MEIO DOS SISTEMAS SISBAJUD, E RENAJUD EM NOME DA PARTE FORTS CONSULTORIA TECNOLOGIA (CNPJ 21.160.553/0001-81).",
                "DecisionDate": "2021-05-26T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO O PEDIDO DE PESQUISAS DE ENDERECOS POR MEIO DOS SISTEMAS SISBAJUD, E RENAJUD EM NOME DA PARTE FORTS CONSULTORIA TECNOLOGIA (CNPJ 21.160.553/0001-81).",
                "DecisionDate": "2021-05-26T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO O PEDIDO DE PESQUISAS DE ENDERECOS POR MEIO DOS SISTEMAS SISBAJUD, E RENAJUD EM NOME DA PARTE FORTS CONSULTORIA TECNOLOGIA (CNPJ 21.160.553/0001-81).",
                "DecisionDate": "2021-05-26T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO O PEDIDO DE PESQUISAS DE ENDERECOS POR MEIO DOS SISTEMAS SISBAJUD, E RENAJUD EM NOME DA PARTE FORTS CONSULTORIA TECNOLOGIA (CNPJ 21.160.553/0001-81).",
                "DecisionDate": "2021-05-26T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO AS PESQUISAS DE ENDERECOS POR MEIO DOS SISTEMAS INFOJUD, EM NOME DA EXECUTADA FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA CNPJ: 21.160.553/0001-81 EM SEGUIDA A REALIZACAO DAS PESQUISAS, INTIME-SE A PARTE REQUERENTE PARA DAR-LHE CIENCIA ACERCA DOS RESULTADOS OBTIDOS, BEM COMO PARA MANIFESTAR-SE EM TERMOS DE PROSSEGUIMENTO NO PRAZO CINCO DIAS.",
                "DecisionDate": "2020-12-10T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO AS PESQUISAS DE ENDERECOS POR MEIO DOS SISTEMAS INFOJUD, EM NOME DA EXECUTADA FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA CNPJ: 21.160.553/0001-81 EM SEGUIDA A REALIZACAO DAS PESQUISAS, INTIME-SE A PARTE REQUERENTE PARA DAR-LHE CIENCIA ACERCA DOS RESULTADOS OBTIDOS, BEM COMO PARA MANIFESTAR-SE EM TERMOS DE PROSSEGUIMENTO NO PRAZO CINCO DIAS.",
                "DecisionDate": "2020-12-09T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO AS PESQUISAS DE ENDERECOS POR MEIO DOS SISTEMAS INFOJUD, EM NOME DA EXECUTADA FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA CNPJ: 21.160.553/0001-81 EM SEGUIDA A REALIZACAO DAS PESQUISAS, INTIME-SE A PARTE REQUERENTE PARA DAR-LHE CIENCIA ACERCA DOS RESULTADOS OBTIDOS, BEM COMO PARA MANIFESTAR-SE EM TERMOS DE PROSSEGUIMENTO NO PRAZO CINCO DIAS.",
                "DecisionDate": "2020-12-09T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO AS PESQUISAS DE ENDERECOS POR MEIO DOS SISTEMAS INFOJUD, EM NOME DA EXECUTADA FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA CNPJ: 21.160.553/0001-81 EM SEGUIDA A REALIZACAO DAS PESQUISAS, INTIME-SE A PARTE REQUERENTE PARA DAR-LHE CIENCIA ACERCA DOS RESULTADOS OBTIDOS, BEM COMO PARA MANIFESTAR-SE EM TERMOS DE PROSSEGUIMENTO NO PRAZO CINCO DIAS.",
                "DecisionDate": "2020-12-09T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO AS PESQUISAS DE ENDERECOS POR MEIO DOS SISTEMAS INFOJUD, EM NOME DA EXECUTADA FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA CNPJ: 21.160.553/0001-81 EM SEGUIDA A REALIZACAO DAS PESQUISAS, INTIME-SE A PARTE REQUERENTE PARA DAR-LHE CIENCIA ACERCA DOS RESULTADOS OBTIDOS, BEM COMO PARA MANIFESTAR-SE EM TERMOS DE PROSSEGUIMENTO NO PRAZO CINCO DIAS.",
                "DecisionDate": "2020-12-09T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO DESDE JA O PEDIDO LIMINAR PARA DETERMINAR O ARRESTO DE ATIVOS FINANCEIROS PENTENCENTES AOS REQUERIDOS POR MEIO DO SISTEMA BACENJUD NO VALOR DE R$ 64.000,00, DEVENDO O REQUERENTE COMPLEMENTAR AS CUSTAS PERTINENTES (RECOLHER MAIS UMA TAXA).",
                "DecisionDate": "2020-05-18T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO DESDE JA O PEDIDO LIMINAR PARA DETERMINAR O ARRESTO DE ATIVOS FINANCEIROS PENTENCENTES AOS REQUERIDOS POR MEIO DO SISTEMA BACENJUD NO VALOR DE R$ 64.000,00, DEVENDO O REQUERENTE COMPLEMENTAR AS CUSTAS PERTINENTES (RECOLHER MAIS UMA TAXA).",
                "DecisionDate": "2020-05-18T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO DESDE JA O PEDIDO LIMINAR PARA DETERMINAR O ARRESTO DE ATIVOS FINANCEIROS PENTENCENTES AOS REQUERIDOS POR MEIO DO SISTEMA BACENJUD NO VALOR DE R$ 64.000,00, DEVENDO O REQUERENTE COMPLEMENTAR AS CUSTAS PERTINENTES (RECOLHER MAIS UMA TAXA).",
                "DecisionDate": "2020-05-18T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO DESDE JA O PEDIDO LIMINAR PARA DETERMINAR O ARRESTO DE ATIVOS FINANCEIROS PENTENCENTES AOS REQUERIDOS POR MEIO DO SISTEMA BACENJUD NO VALOR DE R$ 64.000,00, DEVENDO O REQUERENTE COMPLEMENTAR AS CUSTAS PERTINENTES (RECOLHER MAIS UMA TAXA).",
                "DecisionDate": "2020-05-18T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO DESDE JA O PEDIDO LIMINAR PARA DETERMINAR O ARRESTO DE ATIVOS FINANCEIROS PENTENCENTES AOS REQUERIDOS POR MEIO DO SISTEMA BACENJUD NO VALOR DE R$ 64.000,00, DEVENDO O REQUERENTE COMPLEMENTAR AS CUSTAS PERTINENTES (RECOLHER MAIS UMA TAXA).",
                "DecisionDate": "2020-05-18T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO DESDE JA O PEDIDO LIMINAR PARA DETERMINAR O ARRESTO DE ATIVOS FINANCEIROS PENTENCENTES AOS REQUERIDOS POR MEIO DO SISTEMA BACENJUD NO VALOR DE R$ 64.000,00, DEVENDO O REQUERENTE COMPLEMENTAR AS CUSTAS PERTINENTES (RECOLHER MAIS UMA TAXA).",
                "DecisionDate": "2020-05-18T00:00:00"
              }
            ]
          },
          {
            "Number": "10417367420208260100",
            "Type": "PROCEDIMENTO COMUM",
            "MainSubject": "PRATICAS ABUSIVAS",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "SAO PAULO",
            "Judge": "TAMARA HOCHGREB MATOS",
            "JudgingBody": "24 VARA CIVEL - FORO CENTRAL CIVEL",
            "State": "SP",
            "Status": "INDEFINIDO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "PRÁTICAS ABUSIVAS",
            "InferredCNJSubjectNumber": 11811,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "PRATICAS ABUSIVAS",
              "RESCISAO DO CONTRATO E DEVOLUCAO DO DINHEIRO"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 55438.98,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2020-10-20T00:00:00",
            "NoticeDate": "2020-05-21T00:00:00",
            "LastMovementDate": "2020-10-20T00:00:00",
            "CaptureDate": "2020-10-21T05:43:56",
            "LastUpdate": "2020-10-21T05:43:56",
            "NumberOfParties": 10,
            "NumberOfUpdates": 95,
            "LawSuitAge": 1378,
            "AverageNumberOfUpdatesPerMonth": 2,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "29883314809",
                "IsPartyActive": true,
                "Name": "TAMARA HOCHGREB MATOS",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2020-10-21T05:43:56"
              },
              {
                "Doc": "21297042808",
                "IsPartyActive": true,
                "Name": "HYE MIN CHOI",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2020-10-21T05:43:56"
              },
              {
                "Doc": "07625343898",
                "IsPartyActive": true,
                "Name": "ROBERTO SUCHAN KIM",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2020-10-21T05:43:56"
              },
              {
                "IsPartyActive": true,
                "Name": "SUNG EUN LEE",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2020-10-21T05:43:56"
              },
              {
                "Doc": "12930677848",
                "IsPartyActive": true,
                "Name": "JOAO CARLOS PUJOL FOGACA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "148874",
                  "State": "SP",
                  "SpecificType": "ADVOGADO"
                },
                "LastCaptureDate": "2020-10-21T05:43:56"
              },
              {
                "Doc": "35068411817",
                "IsPartyActive": true,
                "Name": "RAFAEL HIDEO NAZIMA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "295443",
                  "State": "SP",
                  "SpecificType": "ADVOGADO"
                },
                "LastCaptureDate": "2020-10-21T05:43:56"
              },
              {
                "Doc": "56059442072",
                "IsPartyActive": true,
                "Name": "JOAO BAPTISTA DE MELLO NETO",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "39915",
                  "State": "RS",
                  "SpecificType": "ADVOGADO"
                },
                "LastCaptureDate": "2020-10-21T05:43:56"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2020-10-21T05:43:56"
              },
              {
                "Doc": "21160553000181",
                "IsPartyActive": true,
                "Name": "FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2020-10-21T05:43:56"
              },
              {
                "IsPartyActive": true,
                "Name": "FRI SERVICOS DE CONSULTORIA E INVESTIMENTOS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2020-10-21T05:43:56"
              }
            ],
            "Updates": [
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0396/2020 DATA DA DISPONIBILIZACAO: 20/10/2020 DATA DA PUBLICACAO: 21/10/2020 NUMERO DO DIARIO: 3151 PAGINA: 450/458",
                "PublishDate": "2020-10-20T00:00:00",
                "CaptureDate": "2020-10-21T05:43:56"
              },
              {
                "Content": "PROCESSO 1041736-74.2020.8.26.0100 - PROCEDIMENTO COMUM CIVEL - PRATICAS ABUSIVAS - HYE MIN CHOI - - ROBERTO SUCHAN KIM - - SUNG EUN LEE - STARK BANK S.A. - - FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA. - - FRI SERVICOS DE CONSULTORIA E INVESTIMENTOS LTDA - ANTE O EXPOSTO, NOS TERMOS DO ART. 487, I, DO CPC, JULGO PROCEDENTES OS PEDIDOS DA ACAO PARA DECLARAR A RESCISAO DOS CONTRATOS CELEBRADOS ENTRE AS PARTES E CONDENAR AS RES FRI SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA E FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA., SOLIDARIAMENTE, A RESTITUIR AOS AUTORES OS VALORES DE R$34.267,77, R$5.000,00 E R$16.171,21, COM CORRECAO MONETARIA PELA TABELA PRATICA DO TJSP DA DATA DA TRANSFERENCIAS DOS RESPECTIVOS CREDITOS AOS AUTORES (JANEIRO DE 2020), ALEM DE JUROS DE 1% AO MES A PARTIR DA CITACAO. PELA SUCUMBENCIA, AS CORRES FRI SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA E FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA ARCARAO COM PAGAMENTO DAS CUSTAS E DESPESAS PROCESSUAIS, ALEM DE HONORARIOS ADVOCATICIOS, ORA ARBITRADOS EM 10% SOBRE O VALOR DA CONDENACAO. INT. - ADV: JOAO BAPTISTA DE MELLO NETO (OAB 39915/RS), RAFAEL HIDEO NAZIMA (OAB 295443/SP), JOAO CARLOS PUJOL FOGACA (OAB 148874/SP)",
                "PublishDate": "2020-10-20T00:00:00",
                "CaptureDate": "2020-10-21T05:43:56"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0396/2020 TEOR DO ATO: ANTE O EXPOSTO, NOS TERMOS DO ART. 487, I, DO CPC, JULGO PROCEDENTES OS PEDIDOS DA ACAO PARA DECLARAR A RESCISAO DOS CONTRATOS CELEBRADOS ENTRE AS PARTES E CONDENAR AS RES FRI SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA E FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA., SOLIDARIAMENTE, A RESTITUIR AOS AUTORES OS VALORES DE R$34.267,77, R$5.000,00 E R$16.171,21, COM CORRECAO MONETARIA PELA TABELA PRATICA DO TJSP DA DATA DA TRANSFERENCIAS DOS RESPECTIVOS CREDITOS AOS AUTORES (JANEIRO DE 2020), ALEM DE JUROS DE 1% AO MES A PARTIR DA CITACAO. PELA SUCUMBENCIA, AS CORRES FRI SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA E FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA ARCARAO COM PAGAMENTO DAS CUSTAS E DESPESAS PROCESSUAIS, ALEM DE HONORARIOS ADVOCATICIOS, ORA ARBITRADOS EM 10% SOBRE O VALOR DA CONDENACAO. INT. ADVOGADOS(S): JOAO CARLOS PUJOL FOGACA (OAB 148874/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP), JOAO BAPTISTA DE MELLO NETO (OAB 39915/RS)",
                "PublishDate": "2020-10-16T00:00:00",
                "CaptureDate": "2020-10-21T05:43:56"
              },
              {
                "Content": "JULGADA PROCEDENTE EM PARTE A ACAO ANTE O EXPOSTO, NOS TERMOS DO ART. 487, I, DO CPC, JULGO PROCEDENTES OS PEDIDOS DA ACAO PARA DECLARAR A RESCISAO DOS CONTRATOS CELEBRADOS ENTRE AS PARTES E CONDENAR AS RES FRI SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA E FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA., SOLIDARIAMENTE, A RESTITUIR AOS AUTORES OS VALORES DE R$34.267,77, R$5.000,00 E R$16.171,21, COM CORRECAO MONETARIA PELA TABELA PRATICA DO TJSP DA DATA DA TRANSFERENCIAS DOS RESPECTIVOS CREDITOS AOS AUTORES (JANEIRO DE 2020), ALEM DE JUROS DE 1% AO MES A PARTIR DA CITACAO. PELA SUCUMBENCIA, AS CORRES FRI SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA E FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA ARCARAO COM PAGAMENTO DAS CUSTAS E DESPESAS PROCESSUAIS, ALEM DE HONORARIOS ADVOCATICIOS, ORA ARBITRADOS EM 10% SOBRE O VALOR DA CONDENACAO. INT.",
                "PublishDate": "2020-10-15T00:00:00",
                "CaptureDate": "2020-10-21T05:43:56"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.20.41569874-0 TIPO DA PETICAO: PETICAO DE JUNTADA DOS DOCUMENTOS SOLICITADOS DATA: 06/10/2020 16:45",
                "PublishDate": "2020-10-07T00:00:00",
                "CaptureDate": "2020-10-15T11:13:02"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0380/2020 DATA DA DISPONIBILIZACAO: 07/10/2020 DATA DA PUBLICACAO: 08/10/2020 NUMERO DO DIARIO: 3143 PAGINA: 617/626",
                "PublishDate": "2020-10-07T00:00:00",
                "CaptureDate": "2020-10-15T11:13:02"
              },
              {
                "Content": "CONCLUSOS PARA SENTENCA",
                "PublishDate": "2020-10-07T00:00:00",
                "CaptureDate": "2020-10-15T11:13:02"
              },
              {
                "Content": "PROCESSO 1041736-74.2020.8.26.0100 - PROCEDIMENTO COMUM CIVEL - PRATICAS ABUSIVAS - HYE MIN CHOI - - ROBERTO SUCHAN KIM - - SUNG EUN LEE - STARK BANK S.A. - - FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA. - - FRI SERVICOS DE CONSULTORIA E INVESTIMENTOS LTDA - VISTOS. FLS 262/267: REGULARIZEM OS CORREUS FRI SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA E FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA SUA REPRESENTACAO PROCESSUAL, RECOLHENDO AS CUSTAS JUDICIAIS DE PROCURACAO. APOS, NADA MAIS SENDO REQUERIDO, TORNEM CONCLUSOS PARA SENTENCA OU OUTRAS DELIBERACOES. INTIME-SE. - ADV: JOAO BAPTISTA DE MELLO NETO (OAB 39915/RS), RAFAEL HIDEO NAZIMA (OAB 295443/SP), JOAO CARLOS PUJOL FOGACA (OAB 148874/SP)",
                "PublishDate": "2020-10-07T00:00:00",
                "CaptureDate": "2020-10-15T11:13:02"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0380/2020 TEOR DO ATO: VISTOS. FLS 262/267: REGULARIZEM OS CORREUS FRI SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA E FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA SUA REPRESENTACAO PROCESSUAL, RECOLHENDO AS CUSTAS JUDICIAIS DE PROCURACAO. APOS, NADA MAIS SENDO REQUERIDO, TORNEM CONCLUSOS PARA SENTENCA OU OUTRAS DELIBERACOES. INTIME-SE. ADVOGADOS(S): JOAO CARLOS PUJOL FOGACA (OAB 148874/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP), JOAO BAPTISTA DE MELLO NETO (OAB 39915/RS)",
                "PublishDate": "2020-10-05T00:00:00",
                "CaptureDate": "2020-10-15T11:13:02"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.20.41549158-4 TIPO DA PETICAO: PETICAO INTERMEDIARIA DATA: 02/10/2020 14:41",
                "PublishDate": "2020-10-02T00:00:00",
                "CaptureDate": "2020-10-15T11:13:02"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2020-10-02T00:00:00",
                "CaptureDate": "2020-10-15T11:13:02"
              },
              {
                "Content": "DECISAO VISTOS. FLS 262/267: REGULARIZEM OS CORREUS FRI SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA E FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA SUA REPRESENTACAO PROCESSUAL, RECOLHENDO AS CUSTAS JUDICIAIS DE PROCURACAO. APOS, NADA MAIS SENDO REQUERIDO, TORNEM CONCLUSOS PARA SENTENCA OU OUTRAS DELIBERACOES. INTIME-SE.",
                "PublishDate": "2020-10-02T00:00:00",
                "CaptureDate": "2020-10-15T11:13:02"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.20.41543532-3 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 01/10/2020 17:47",
                "PublishDate": "2020-10-01T00:00:00",
                "CaptureDate": "2020-10-15T11:13:02"
              },
              {
                "Content": "CONCLUSOS PARA SENTENCA",
                "PublishDate": "2020-10-01T00:00:00",
                "CaptureDate": "2020-10-15T11:13:02"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0345/2020 DATA DA DISPONIBILIZACAO: 15/09/2020 DATA DA PUBLICACAO: 16/09/2020 NUMERO DO DIARIO: 3127 PAGINA: 469/475",
                "PublishDate": "2020-09-15T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0342/2020 DATA DA DISPONIBILIZACAO: 14/09/2020 DATA DA PUBLICACAO: 15/09/2020 NUMERO DO DIARIO: 3126 PAGINA: 549/557",
                "PublishDate": "2020-09-14T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2020-09-11T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "DECISAO VISTOS. FLS 617: CIENCIA AOS REQUERIDOS DOS DOCUMENTOS JUNTADOS. APOS, NADA MAIS SENDO REQUERIDO, TORNEM CONCLUSOS PARA SENTENCA OU OUTRAS DELIBERACOES. INTIME-SE.",
                "PublishDate": "2020-09-11T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0345/2020 TEOR DO ATO: VISTOS. FLS 617: CIENCIA AOS REQUERIDOS DOS DOCUMENTOS JUNTADOS. APOS, NADA MAIS SENDO REQUERIDO, TORNEM CONCLUSOS PARA SENTENCA OU OUTRAS DELIBERACOES. INTIME-SE. ADVOGADOS(S): JOAO CARLOS PUJOL FOGACA (OAB 148874/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP), JOAO BAPTISTA DE MELLO NETO (OAB 39915/RS)",
                "PublishDate": "2020-09-11T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0342/2020 TEOR DO ATO: VISTOS. EM CINCO DIAS TRAGAM OS AUTORES COPIA LEGIVEL DO DOCUMENTO DE FL.28. APOS, ABRA-SE VISTA AOS REUS E TORNEM CONCLUSOS PARA SENTENCA. INTIME-SE. ADVOGADOS(S): JOAO CARLOS PUJOL FOGACA (OAB 148874/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP), JOAO BAPTISTA DE MELLO NETO (OAB 39915/RS)",
                "PublishDate": "2020-09-10T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.20.41406702-9 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 10/09/2020 15:55",
                "PublishDate": "2020-09-10T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "DECISAO VISTOS. EM CINCO DIAS TRAGAM OS AUTORES COPIA LEGIVEL DO DOCUMENTO DE FL.28. APOS, ABRA-SE VISTA AOS REUS E TORNEM CONCLUSOS PARA SENTENCA. INTIME-SE.",
                "PublishDate": "2020-09-09T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "CERTIDAO DE CARTORIO EXPEDIDA CERTIDAO - GENERICA",
                "PublishDate": "2020-09-03T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2020-09-03T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "CONCLUSOS PARA SENTENCA",
                "PublishDate": "2020-09-03T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0289/2020 DATA DA DISPONIBILIZACAO: 11/08/2020 DATA DA PUBLICACAO: 12/08/2020 NUMERO DO DIARIO: 3103 PAGINA: 659/666",
                "PublishDate": "2020-08-11T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "PROCESSO 1041736-74.2020.8.26.0100 - PROCEDIMENTO COMUM CIVEL - PRATICAS ABUSIVAS - HYE MIN CHOI - - ROBERTO SUCHAN KIM - - SUNG EUN LEE - STARK BANK S.A. - - FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA. - - FRI SERVICOS DE CONSULTORIA E INVESTIMENTOS LTDA - VISTOS. FLS 575/582: CIENCIA AOS REQUERIDOS DOS DOCUMENTOS JUNTADOS. APOS, NADA MAIS SENDO REQUERIDO, TORNEM CONCLUSOS PARA SENTENCA OU OUTRAS DELIBERACOES. INTIME-SE. - ADV: JOAO CARLOS PUJOL FOGACA (OAB 148874/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP), JOAO BAPTISTA DE MELLO NETO (OAB 39915/RS)",
                "PublishDate": "2020-08-11T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0287/2020 DATA DA DISPONIBILIZACAO: 10/08/2020 DATA DA PUBLICACAO: 11/08/2020 NUMERO DO DIARIO: 3102 PAGINA: 305/314",
                "PublishDate": "2020-08-10T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "PROCESSO 1041736-74.2020.8.26.0100 - PROCEDIMENTO COMUM CIVEL - PRATICAS ABUSIVAS - HYE MIN CHOI - - ROBERTO SUCHAN KIM - - SUNG EUN LEE - STARK BANK S.A. - - FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA. - - FRI SERVICOS DE CONSULTORIA E INVESTIMENTOS LTDA - VISTOS. 1) FLS. 517/518, 523/524 E 529/531: 1.1) NADA A DECIDIR, POIS NAO HOUVE RESTRICAO AOS VEICULOS MENCIONADOS POR ESTE JUIZO. 1.2) A FIM DE ASSEGURAR O RESULTADO UTIL DO PROCESSO, ALEM DO BLOQUEIO DA TRANSFERENCIA JA EFETUADA, DEFIRO O ARRESTO DOS VEICULOS HYUNDAI HB20 - PLACA FVQ-5773 E HYUNDAI HB20 - PLACA ELE 2836, A FIM DE ASSEGURAR A PREFERENCIA DOS AUTORES, EM CASO DE EVENTUAL CONCURSO DE CREDORES, SERVINDO ESTA DECISAO COMO TERMO. ANOTE-SE NO SISTEMA RENAJUD COMO PENHORA, DIANTE DA FALTA DE OPCAO DE ARRESTO (VALOR DA CAUSA: R$ 55.438,98 EM 21.05.2020). 2) FLS. 532/546: 2.1) RECOLHAM AS RES A TAXA DE PROCURACAO. 2.2) MANIFESTEM-SE OS AUTORES EM REPLICA. INTIME-SE. - ADV: RAFAEL HIDEO NAZIMA (OAB 295443/ SP), JOAO BAPTISTA DE MELLO NETO (OAB 39915/RS), JOAO CARLOS PUJOL FOGACA (OAB 148874/SP)",
                "PublishDate": "2020-08-10T00:00:00",
                "CaptureDate": "2020-09-27T21:11:31"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0289/2020 TEOR DO ATO: VISTOS. FLS 575/582: CIENCIA AOS REQUERIDOS DOS DOCUMENTOS JUNTADOS. APOS, NADA MAIS SENDO REQUERIDO, TORNEM CONCLUSOS PARA SENTENCA OU OUTRAS DELIBERACOES. INTIME-SE. ADVOGADOS(S): JOAO CARLOS PUJOL FOGACA (OAB 148874/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP), JOAO BAPTISTA DE MELLO NETO (OAB 39915/RS)",
                "PublishDate": "2020-08-07T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "DOCUMENTO JUNTADO",
                "PublishDate": "2020-08-06T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "DOCUMENTO JUNTADO",
                "PublishDate": "2020-08-06T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0287/2020 TEOR DO ATO: VISTOS. 1) FLS. 517/518, 523/524 E 529/531: 1.1) NADA A DECIDIR, POIS NAO HOUVE RESTRICAO AOS VEICULOS MENCIONADOS POR ESTE JUIZO. 1.2) A FIM DE ASSEGURAR O RESULTADO UTIL DO PROCESSO, ALEM DO BLOQUEIO DA TRANSFERENCIA JA EFETUADA, DEFIRO O ARRESTO DOS VEICULOS HYUNDAI HB20 - PLACA FVQ-5773 E HYUNDAI HB20 - PLACA ELE 2836, A FIM DE ASSEGURAR A PREFERENCIA DOS AUTORES, EM CASO DE EVENTUAL CONCURSO DE CREDORES, SERVINDO ESTA DECISAO COMO TERMO. ANOTE-SE NO SISTEMA RENAJUD COMO PENHORA, DIANTE DA FALTA DE OPCAO DE ARRESTO (VALOR DA CAUSA: R$ 55.438,98 EM 21.05.2020). 2) FLS. 532/546: 2.1) RECOLHAM AS RES A TAXA DE PROCURACAO. 2.2) MANIFESTEM-SE OS AUTORES EM REPLICA. INTIME-SE. ADVOGADOS(S): JOAO CARLOS PUJOL FOGACA (OAB 148874/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP), JOAO BAPTISTA DE MELLO NETO (OAB 39915/RS)",
                "PublishDate": "2020-08-06T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "REPLICA JUNTADA N PROTOCOLO: WJMJ.20.41175156-5 TIPO DA PETICAO: MANIFESTACAO SOBRE A CONTESTACAO DATA: 06/08/2020 12:31",
                "PublishDate": "2020-08-06T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2020-08-06T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "DECISAO VISTOS. FLS 575/582: CIENCIA AOS REQUERIDOS DOS DOCUMENTOS JUNTADOS. APOS, NADA MAIS SENDO REQUERIDO, TORNEM CONCLUSOS PARA SENTENCA OU OUTRAS DELIBERACOES. INTIME-SE.",
                "PublishDate": "2020-08-06T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2020-08-05T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "DECISAO VISTOS. 1) FLS. 517/518, 523/524 E 529/531: 1.1) NADA A DECIDIR, POIS NAO HOUVE RESTRICAO AOS VEICULOS MENCIONADOS POR ESTE JUIZO. 1.2) A FIM DE ASSEGURAR O RESULTADO UTIL DO PROCESSO, ALEM DO BLOQUEIO DA TRANSFERENCIA JA EFETUADA, DEFIRO O ARRESTO DOS VEICULOS HYUNDAI HB20 - PLACA FVQ-5773 E HYUNDAI HB20 - PLACA ELE 2836, A FIM DE ASSEGURAR A PREFERENCIA DOS AUTORES, EM CASO DE EVENTUAL CONCURSO DE CREDORES, SERVINDO ESTA DECISAO COMO TERMO. ANOTE-SE NO SISTEMA RENAJUD COMO PENHORA, DIANTE DA FALTA DE OPCAO DE ARRESTO (VALOR DA CAUSA: R$ 55.438,98 EM 21.05.2020). 2) FLS. 532/546: 2.1) RECOLHAM AS RES A TAXA DE PROCURACAO. 2.2) MANIFESTEM-SE OS AUTORES EM REPLICA. INTIME-SE.",
                "PublishDate": "2020-08-05T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "INICIO DA EXECUCAO JUNTADO 0034880-14.2020.8.26.0100 - CUMPRIMENTO DE SENTENCA",
                "PublishDate": "2020-08-04T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "CONTESTACAO JUNTADA N PROTOCOLO: WJMJ.20.41054407-8 TIPO DA PETICAO: CONTESTACAO DATA: 20/07/2020 18:05",
                "PublishDate": "2020-07-20T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "AR POSITIVO JUNTADO JUNTADA DE AR : AR159115791TJ SITUACAO : CUMPRIDO MODELO : PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC DESTINATARIO : FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA. DILIGENCIA : 19/06/2020",
                "PublishDate": "2020-07-20T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.20.41030490-5 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 16/07/2020 11:27",
                "PublishDate": "2020-07-16T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.20.41003352-9 TIPO DA PETICAO: PETICAO INTERMEDIARIA DATA: 13/07/2020 14:33",
                "PublishDate": "2020-07-13T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.20.41003483-5 TIPO DA PETICAO: PETICAO INTERMEDIARIA DATA: 13/07/2020 14:41",
                "PublishDate": "2020-07-13T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2020-07-13T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0230/2020 DATA DA DISPONIBILIZACAO: 07/07/2020 DATA DA PUBLICACAO: 08/07/2020 NUMERO DO DIARIO: 3078 PAGINA: 524/531",
                "PublishDate": "2020-07-07T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0230/2020 DATA DA DISPONIBILIZACAO: 07/07/2020 DATA DA PUBLICACAO: 08/07/2020 NUMERO DO DIARIO: 3078 PAGINA: 524/531",
                "PublishDate": "2020-07-07T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0230/2020 TEOR DO ATO: VISTOS. FLS. 505: PUBLIQUE-SE A DECISAO DE FLS. 486. INTIME-SE. ADVOGADOS(S): JOAO CARLOS PUJOL FOGACA (OAB 148874/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-07-03T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0230/2020 TEOR DO ATO: VISTOS. I) HOMOLOGO A DESISTENCIA EM FACE DO CORREU STARK BANK S/A. ANOTE-SE. CONDENO OS REQUERENTES AO PAGAMENTO DE HONORARIOS ADVOCATICIOS ARBITRADOS EM R$ 2.000,00, POIS O PEDIDO DE DESISTENCIA FOI FORMULADO APOS OS ARGUMENTOS APRESENTADOS A FLS. 162/164. A COBRANCA DOS HONORARIOS ADVOCATICIOS DEVERA SER OBJETO DE INCIDENTE PROPRIO. II) CUMPRA A SERVENTIA O ITEM 1 DA DECISAO DE FLS. 158/159, ARRESTANDO R$ 55.438,98 DOS REQUERIDOS FRI SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA - CNPJ N 10.685.786/0001-81 E FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA - CNPJ N 21.160.553/0001-81 VIA BACENJUD E REALIZANDO A PESQUISA DE BENS VIA RENAJUD. III) EXPECA-SE CARTA DE CITACAO DO CORREU FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA PARA A APRESENTACAO DE CONTESTACAO NO PRAZO DE 15 DIAS UTEIS, CONTADOS DA JUNTADA DA CARTA DE CITACAO POSITIVA AOS AUTOS (ART. 231, I E 1 C/C ART. 335, III DO CPC), SOB PENA DE APLICACAO DOS EFEITOS DA REVELIA, NA FORMA DO ART. 344 E 346 DO CPC, PRESUMINDO-SE VERDADEIROS OS FATOS ALEGADOS NA INICIAL. INTIME-SE. ADVOGADOS(S): JOAO CARLOS PUJOL FOGACA (OAB 148874/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-07-03T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2020-07-02T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "DECISAO VISTOS. FLS. 505: PUBLIQUE-SE A DECISAO DE FLS. 486. INTIME-SE.",
                "PublishDate": "2020-07-02T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "AGRAVO DE INSTRUMENTO - ACORDAO E DEMAIS PECAS JUNTADOS - COM TRANSITO EM JULGADO - AGRAVO DESTRUIDO",
                "PublishDate": "2020-06-30T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2020-06-30T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0205/2020 DATA DA DISPONIBILIZACAO: 23/06/2020 DATA DA PUBLICACAO: 24/06/2020 NUMERO DO DIARIO: 3068 PAGINA: 382/387",
                "PublishDate": "2020-06-23T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.20.40867783-0 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 22/06/2020 22:40",
                "PublishDate": "2020-06-22T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0205/2020 TEOR DO ATO: VISTOS. FLS. 497/498: DEFIRO O BLOQUEIO APENAS DA TRANSFERENCIA DOS VEICULOS HYUNDAI HB20 - PLACA FVQ-5773 E HYUNDAI HB20 - PLACA ELE 2836 VIA RENAJUD, SUFICIENTE PARA ASSEGURAR O RESULTADO UTIL DO PROCESSO. INDEFIRO A TRANSMISSAO DA POSSE DOS VEICULOS AO CO-AUTOR, POIS O PROCESSO AINDA ESTA EM FASE DE CONHECIMENTO. AGUARDE-SE A CITACAO. INTIME-SE. ADVOGADOS(S): JOAO CARLOS PUJOL FOGACA (OAB 148874/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-06-19T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "DOCUMENTO JUNTADO",
                "PublishDate": "2020-06-19T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "DOCUMENTO JUNTADO",
                "PublishDate": "2020-06-19T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2020-06-18T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2020-06-18T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "DECISAO VISTOS. FLS. 497/498: DEFIRO O BLOQUEIO APENAS DA TRANSFERENCIA DOS VEICULOS HYUNDAI HB20 - PLACA FVQ-5773 E HYUNDAI HB20 - PLACA ELE 2836 VIA RENAJUD, SUFICIENTE PARA ASSEGURAR O RESULTADO UTIL DO PROCESSO. INDEFIRO A TRANSMISSAO DA POSSE DOS VEICULOS AO CO-AUTOR, POIS O PROCESSO AINDA ESTA EM FASE DE CONHECIMENTO. AGUARDE-SE A CITACAO. INTIME-SE.",
                "PublishDate": "2020-06-18T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.20.40833825-3 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 17/06/2020 16:06",
                "PublishDate": "2020-06-17T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0193/2020 DATA DA DISPONIBILIZACAO: 16/06/2020 DATA DA PUBLICACAO: 17/06/2020 NUMERO DO DIARIO: 3063 PAGINA: 351/360",
                "PublishDate": "2020-06-16T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0193/2020 TEOR DO ATO: CIENCIA AO(A)(S) REQUERENTE(S) DO(S) RESULTADO(S) DA(S) PESQUISA(S). ADVOGADOS(S): JOAO CARLOS PUJOL FOGACA (OAB 148874/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-06-12T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "DOCUMENTO JUNTADO",
                "PublishDate": "2020-06-11T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "DOCUMENTO JUNTADO",
                "PublishDate": "2020-06-11T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "CARTA EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                "PublishDate": "2020-06-11T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "BACEN JUD POSITIVO JUNTADO",
                "PublishDate": "2020-06-11T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "ATO ORDINATORIO - PUBLICAVEL CIENCIA AO(A)(S) REQUERENTE(S) DO(S) RESULTADO(S) DA(S) PESQUISA(S).",
                "PublishDate": "2020-06-11T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2020-06-08T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.20.40768833-1 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 08/06/2020 12:38",
                "PublishDate": "2020-06-08T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2020-06-08T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "BLOQUEIO/PENHORA ON LINE VISTOS. I) HOMOLOGO A DESISTENCIA EM FACE DO CORREU STARK BANK S/A. ANOTE-SE. CONDENO OS REQUERENTES AO PAGAMENTO DE HONORARIOS ADVOCATICIOS ARBITRADOS EM R$ 2.000,00, POIS O PEDIDO DE DESISTENCIA FOI FORMULADO APOS OS ARGUMENTOS APRESENTADOS A FLS. 162/164. A COBRANCA DOS HONORARIOS ADVOCATICIOS DEVERA SER OBJETO DE INCIDENTE PROPRIO. II) CUMPRA A SERVENTIA O ITEM 1 DA DECISAO DE FLS. 158/159, ARRESTANDO R$ 55.438,98 DOS REQUERIDOS FRI SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA - CNPJ N 10.685.786/0001-81 E FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA - CNPJ N 21.160.553/0001-81 VIA BACENJUD E REALIZANDO A PESQUISA DE BENS VIA RENAJUD. III) EXPECA-SE CARTA DE CITACAO DO CORREU FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA PARA A APRESENTACAO DE CONTESTACAO NO PRAZO DE 15 DIAS UTEIS, CONTADOS DA JUNTADA DA CARTA DE CITACAO POSITIVA AOS AUTOS (ART. 231, I E 1 C/C ART. 335, III DO CPC), SOB PENA DE APLICACAO DOS EFEITOS DA REVELIA, NA FORMA DO ART. 344 E 346 DO CPC, PRESUMINDO-SE VERDADEIROS OS FATOS ALEGADOS NA INICIAL. INTIME-SE.",
                "PublishDate": "2020-06-08T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.20.40766063-1 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 07/06/2020 01:02",
                "PublishDate": "2020-06-07T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "AR POSITIVO JUNTADO JUNTADA DE AR : AR158980975TJ SITUACAO : CUMPRIDO MODELO : PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC DESTINATARIO : FRI SERVICOS DE CONSULTORIA E INVESTIMENTOS LTDA DILIGENCIA : 28/05/2020",
                "PublishDate": "2020-06-02T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0166/2020 DATA DA DISPONIBILIZACAO: 02/06/2020 DATA DA PUBLICACAO: 03/06/2020 NUMERO DO DIARIO: 3053 PAGINA: 571/579",
                "PublishDate": "2020-06-02T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0166/2020 DATA DA DISPONIBILIZACAO: 02/06/2020 DATA DA PUBLICACAO: 03/06/2020 NUMERO DO DIARIO: 3053 PAGINA: 571/579",
                "PublishDate": "2020-06-02T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO :0166/2020 DATA DA DISPONIBILIZACAO: 02/06/2020 DATA DA PUBLICACAO: 03/06/2020 NUMERO DO DIARIO: 3053 PAGINA: 571/579",
                "PublishDate": "2020-06-02T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "AR POSITIVO JUNTADO JUNTADA DE AR : AR158980967TJ SITUACAO : CUMPRIDO MODELO : PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC DESTINATARIO : STARK BANK S.A. DILIGENCIA : 27/05/2020",
                "PublishDate": "2020-05-30T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0166/2020 TEOR DO ATO: VISTOS. FLS 162/164: 1. DIANTE DO INGRESSO VOLUNTARIO, CONSIDERO O CORREU STARK BANK SA CITADO. 2. MANTENHO A DECISAO DE FLS. 158/159 POR SEUS PROPRIOS E JURIDICOS FUNDAMENTOS. INTIME-SE. ADVOGADOS(S): JOAO CARLOS PUJOL FOGACA (OAB 148874/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-05-29T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0166/2020 TEOR DO ATO: VISTOS. FLS 190: MANIFESTE-SE O CORREU STARK BANK SOBRE O PEDIDO DE DESISTENCIA. INTIME-SE. ADVOGADOS(S): JOAO CARLOS PUJOL FOGACA (OAB 148874/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-05-29T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0166/2020 TEOR DO ATO: VISTOS. 1. DISPOE O ART. 300 DO CPC QUE \"A TUTELA DE URGENCIA SERA CONCEDIDA QUANDO HOUVER ELEMENTOS QUE EVIDENCIEM A PROBABILIDADE DO DIREITO E O PERIGO DE DANO OU O RISCO AO RESULTADO UTIL DO PROCESSO\". EM SEDE DE COGNICAO SUMARIA DOS FATOS, VERIFICO QUE HA PROBABILIDADE DO DIREITO ALEGADO, NA MEDIDA EM QUE OS DOCUMENTOS DE FLS. 21/29 COMPROVAM OS INVESTIMENTOS EFETUADOS PELOS AUTORES, NOS VALORES DE R$ 34.267,77, R$ 5.000,00 E R$ 16.171,21, TENDO OS AUTORES, EM PRINCIPIO, O DIREITO AO RESGATE DAS QUANTIAS APLICADAS. DA MESMA FORMA, HA EVIDENTE PERIGO DE DANO, UMA VEZ QUE OS DOCUMENTOS DE FLS. 30/31 E 32/33 DEMONSTRAM QUE OS REUS VEM SE ESQUIVANDO DE SUAS OBRIGACOES, E NAO HA PATRIMONIO QUE GARANTA A RESTITUICAO DO VALOR INVESTIDO. NESSE PASSO, DEFIRO O PEDIDO DE TUTELA DE URGENCIA PARA DETERMINAR O ARRESTO DE R$55.438,98 DOS REQUERIDOS FRI SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA - CNPJ N 10.685.786/0001-81, FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA - CNPJ N 21.160.553/0001-81 E STARK BANK SA - CNPJ N 20.018.183/0001-80 VIA BACENJUD E A PESQUISA DE BENS VIA RENAJUD. PARA REALIZACAO DA PESQUISA DE BENS ATRAVES DO CONVENIO INFOJUD, RECOLHAM OS AUTORES AS CUSTAS JUDICIAIS PERTINENTES, NO VALOR DE $ 16,00 PARA CADA PESQUISA. 2. EXPECA-SE CARTA DE CITACAO PARA A APRESENTACAO DE CONTESTACAO NO PRAZO DE 15 DIAS UTEIS, CONTADOS DA JUNTADA DA(S) CARTA(S) DE CITACAO POSITIVA(S) AOS AUTOS (ART. 231, I E 1 C/C ART. 335, III DO CPC), SOB PENA DE APLICACAO DOS EFEITOS DA REVELIA, NA FORMA DO ART. 344 E 346 DO NCPC, PRESUMINDO-SE VERDADEIROS OS FATOS ALEGADOS NA INICIAL, DEVENDO O MESMO OBSERVAR O DISPOSTO NOS ART. 336, 341, 342, 434 E 437 TODOS DO CPC. DESDE JA FICA(M) ALERTADO(S) O(S) REU(S), QUE, NA FORMA DO ART. 90, 4 DO CPC, \"SE HOUVER RECONHECIMENTO DA PROCEDENCIA DO PEDIDO E, SIMULTANEAMENTE, CUMPRIMENTO INTEGRAL DA PRESTACAO RECONHECIDA, OS HONORARIOS SERAO REDUZIDOS PELA METADE\". DEVERAO AS PARTES, AINDA, NO REFERIDO PRAZO DE 15 DIAS, NA FORMA DO ART. 77, V DO CPC, DECLINAR O ENDERECO ELETRONICO (E-MAIL) PARA RECEBIMENTO DE INTIMACAO, EM ANALOGIA AOS ARTS. 193, 246, 1, 270 E 287 CPC, SOB PENA DE MULTA POR LITIGANCIA DE MA-FE. A CARTA DE CITACAO DEVERA SER ACOMPANHADA DE SENHA PARA ACESSO AO PROCESSO DIGITAL, QUE CONTEM A INTEGRA DA PETICAO INICIAL E DOS DOCUMENTOS. TRATANDO-SE DE PROCESSO ELETRONICO, EM PRESTIGIO AS REGRAS FUNDAMENTAIS DOS ARTIGOS 4 E 6 DO CPC, FICA VEDADO O EXERCICIO DA FACULDADE PREVISTA NO ARTIGO 340 DO CPC. INTIME-SE. ADVOGADOS(S): JOAO CARLOS PUJOL FOGACA (OAB 148874/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2020-05-29T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.20.40705743-9 TIPO DA PETICAO: PEDIDO DE DESISTENCIA ART. 485, VIII, DO CPC DATA: 28/05/2020 10:25",
                "PublishDate": "2020-05-28T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2020-05-28T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "DECISAO VISTOS. FLS 190: MANIFESTE-SE O CORREU STARK BANK SOBRE O PEDIDO DE DESISTENCIA. INTIME-SE.",
                "PublishDate": "2020-05-28T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "PEDIDO DE LIMINAR/TUTELA ANTECIPADA JUNTADO N PROTOCOLO: WJMJ.20.40686670-8 TIPO DA PETICAO: PEDIDO DE LIMINAR/ANTECIPACAO DE TUTELA DATA: 26/05/2020 05:31",
                "PublishDate": "2020-05-26T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2020-05-26T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "DECISAO VISTOS. FLS 162/164: 1. DIANTE DO INGRESSO VOLUNTARIO, CONSIDERO O CORREU STARK BANK SA CITADO. 2. MANTENHO A DECISAO DE FLS. 158/159 POR SEUS PROPRIOS E JURIDICOS FUNDAMENTOS. INTIME-SE.",
                "PublishDate": "2020-05-26T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2020-05-22T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "DOCUMENTO JUNTADO",
                "PublishDate": "2020-05-22T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "DOCUMENTO JUNTADO",
                "PublishDate": "2020-05-22T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "RECEBIDA A PETICAO INICIAL - CITACAO POR CARTA AR VISTOS. 1. DISPOE O ART. 300 DO CPC QUE \"A TUTELA DE URGENCIA SERA CONCEDIDA QUANDO HOUVER ELEMENTOS QUE EVIDENCIEM A PROBABILIDADE DO DIREITO E O PERIGO DE DANO OU O RISCO AO RESULTADO UTIL DO PROCESSO\". EM SEDE DE COGNICAO SUMARIA DOS FATOS, VERIFICO QUE HA PROBABILIDADE DO DIREITO ALEGADO, NA MEDIDA EM QUE OS DOCUMENTOS DE FLS. 21/29 COMPROVAM OS INVESTIMENTOS EFETUADOS PELOS AUTORES, NOS VALORES DE R$ 34.267,77, R$ 5.000,00 E R$ 16.171,21, TENDO OS AUTORES, EM PRINCIPIO, O DIREITO AO RESGATE DAS QUANTIAS APLICADAS. DA MESMA FORMA, HA EVIDENTE PERIGO DE DANO, UMA VEZ QUE OS DOCUMENTOS DE FLS. 30/31 E 32/33 DEMONSTRAM QUE OS REUS VEM SE ESQUIVANDO DE SUAS OBRIGACOES, E NAO HA PATRIMONIO QUE GARANTA A RESTITUICAO DO VALOR INVESTIDO. NESSE PASSO, DEFIRO O PEDIDO DE TUTELA DE URGENCIA PARA DETERMINAR O ARRESTO DE R$55.438,98 DOS REQUERIDOS FRI SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA - CNPJ N 10.685.786/0001-81, FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA - CNPJ N 21.160.553/0001-81 E STARK BANK SA - CNPJ N 20.018.183/0001-80 VIA BACENJUD E A PESQUISA DE BENS VIA RENAJUD. PARA REALIZACAO DA PESQUISA DE BENS ATRAVES DO CONVENIO INFOJUD, RECOLHAM OS AUTORES AS CUSTAS JUDICIAIS PERTINENTES, NO VALOR DE $ 16,00 PARA CADA PESQUISA. 2. EXPECA-SE CARTA DE CITACAO PARA A APRESENTACAO DE CONTESTACAO NO PRAZO DE 15 DIAS UTEIS, CONTADOS DA JUNTADA DA(S) CARTA(S) DE CITACAO POSITIVA(S) AOS AUTOS (ART. 231, I E 1 C/C ART. 335, III DO CPC), SOB PENA DE APLICACAO DOS EFEITOS DA REVELIA, NA FORMA DO ART. 344 E 346 DO NCPC, PRESUMINDO-SE VERDADEIROS OS FATOS ALEGADOS NA INICIAL, DEVENDO O MESMO OBSERVAR O DISPOSTO NOS ART. 336, 341, 342, 434 E 437 TODOS DO CPC. DESDE JA FICA(M) ALERTADO(S) O(S) REU(S), QUE, NA FORMA DO ART. 90, 4 DO CPC, \"SE HOUVER RECONHECIMENTO DA PROCEDENCIA DO PEDIDO E, SIMULTANEAMENTE, CUMPRIMENTO INTEGRAL DA PRESTACAO RECONHECIDA, OS HONORARIOS SERAO REDUZIDOS PELA METADE\". DEVERAO AS PARTES, AINDA, NO REFERIDO PRAZO DE 15 DIAS, NA FORMA DO ART. 77, V DO CPC, DECLINAR O ENDERECO ELETRONICO (E-MAIL) PARA RECEBIMENTO DE INTIMACAO, EM ANALOGIA AOS ARTS. 193, 246, 1, 270 E 287 CPC, SOB PENA DE MULTA POR LITIGANCIA DE MA-FE. A CARTA DE CITACAO DEVERA SER ACOMPANHADA DE SENHA PARA ACESSO AO PROCESSO DIGITAL, QUE CONTEM A INTEGRA DA PETICAO INICIAL E DOS DOCUMENTOS. TRATANDO-SE DE PROCESSO ELETRONICO, EM PRESTIGIO AS REGRAS FUNDAMENTAIS DOS ARTIGOS 4 E 6 DO CPC, FICA VEDADO O EXERCICIO DA FACULDADE PREVISTA NO ARTIGO 340 DO CPC. INTIME-SE.",
                "PublishDate": "2020-05-22T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "CARTA EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                "PublishDate": "2020-05-22T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "CARTA EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                "PublishDate": "2020-05-22T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2020-05-21T00:00:00",
                "CaptureDate": "2020-09-27T17:22:36"
              }
            ],
            "Petitions": [
              {
                "Type": "PEDIDO DE LIMINAR/ANTECIPACAO DE TUTELA",
                "Author": "",
                "CreationDate": "2020-05-26T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PEDIDO DE DESISTENCIA ART. 485, VIII, DO CPC",
                "Author": "",
                "CreationDate": "2020-05-28T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2020-06-07T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2020-06-08T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2020-06-17T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2020-06-22T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICAO INTERMEDIARIA",
                "Author": "",
                "CreationDate": "2020-07-13T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICAO INTERMEDIARIA",
                "Author": "",
                "CreationDate": "2020-07-13T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2020-07-16T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "CONTESTACAO",
                "Author": "",
                "CreationDate": "2020-07-20T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "MANIFESTACAO SOBRE A CONTESTACAO",
                "Author": "",
                "CreationDate": "2020-08-06T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2020-09-10T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2020-10-01T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICAO INTERMEDIARIA",
                "Author": "",
                "CreationDate": "2020-10-02T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICAO DE JUNTADA DOS DOCUMENTOS SOLICITADOS",
                "Author": "",
                "CreationDate": "2020-10-06T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              }
            ],
            "Decisions": [
              {
                "DecisionContent": "JULGO PROCEDENTES OS PEDIDOS DA ACAO PARA DECLARAR A RESCISAO DOS CONTRATOS CELEBRADOS ENTRE AS PARTES E CONDENAR AS RES FRI SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA E FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA., SOLIDARIAMENTE, A RESTITUIR AOS AUTORES OS VALORES DE R$34.267,77, R$5.000,00 E R$16.171,21, COM CORRECAO MONETARIA PELA TABELA PRATICA DO TJSP DA DATA DA TRANSFERENCIAS DOS RESPECTIVOS CREDITOS AOS AUTORES (JANEIRO DE 2020), ALEM DE JUROS DE 1% AO MES A PARTIR DA CITACAO.",
                "DecisionDate": "2020-10-20T00:00:00"
              },
              {
                "DecisionContent": "JULGO PROCEDENTES OS PEDIDOS DA ACAO PARA DECLARAR A RESCISAO DOS CONTRATOS CELEBRADOS ENTRE AS PARTES E CONDENAR AS RES FRI SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA E FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA., SOLIDARIAMENTE, A RESTITUIR AOS AUTORES OS VALORES DE R$34.267,77, R$5.000,00 E R$16.171,21, COM CORRECAO MONETARIA PELA TABELA PRATICA DO TJSP DA DATA DA TRANSFERENCIAS DOS RESPECTIVOS CREDITOS AOS AUTORES (JANEIRO DE 2020), ALEM DE JUROS DE 1% AO MES A PARTIR DA CITACAO.",
                "DecisionDate": "2020-10-16T00:00:00"
              },
              {
                "DecisionContent": "JULGO PROCEDENTES OS PEDIDOS DA ACAO PARA DECLARAR A RESCISAO DOS CONTRATOS CELEBRADOS ENTRE AS PARTES E CONDENAR AS RES FRI SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA E FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA., SOLIDARIAMENTE, A RESTITUIR AOS AUTORES OS VALORES DE R$34.267,77, R$5.000,00 E R$16.171,21, COM CORRECAO MONETARIA PELA TABELA PRATICA DO TJSP DA DATA DA TRANSFERENCIAS DOS RESPECTIVOS CREDITOS AOS AUTORES (JANEIRO DE 2020), ALEM DE JUROS DE 1% AO MES A PARTIR DA CITACAO.",
                "DecisionDate": "2020-10-15T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO O ARRESTO DOS VEICULOS HYUNDAI HB20 - PLACA FVQ-5773 E HYUNDAI HB20 - PLACA ELE 2836, A FIM DE ASSEGURAR A PREFERENCIA DOS AUTORES, EM CASO DE EVENTUAL CONCURSO DE CREDORES, SERVINDO ESTA DECISAO COMO TERMO.",
                "DecisionDate": "2020-08-10T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO O ARRESTO DOS VEICULOS HYUNDAI HB20 - PLACA FVQ-5773 E HYUNDAI HB20 - PLACA ELE 2836, A FIM DE ASSEGURAR A PREFERENCIA DOS AUTORES, EM CASO DE EVENTUAL CONCURSO DE CREDORES, SERVINDO ESTA DECISAO COMO TERMO.",
                "DecisionDate": "2020-08-06T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO O ARRESTO DOS VEICULOS HYUNDAI HB20 - PLACA FVQ-5773 E HYUNDAI HB20 - PLACA ELE 2836, A FIM DE ASSEGURAR A PREFERENCIA DOS AUTORES, EM CASO DE EVENTUAL CONCURSO DE CREDORES, SERVINDO ESTA DECISAO COMO TERMO.",
                "DecisionDate": "2020-08-05T00:00:00"
              },
              {
                "DecisionContent": "HOMOLOGO A DESISTENCIA EM FACE DO CORREU STARK BANK S/A.",
                "DecisionDate": "2020-07-03T00:00:00"
              },
              {
                "DecisionContent": "CONDENO OS REQUERENTES AO PAGAMENTO DE HONORARIOS ADVOCATICIOS ARBITRADOS EM R$ 2.000,00, POIS O PEDIDO DE DESISTENCIA FOI FORMULADO APOS OS ARGUMENTOS APRESENTADOS A FLS. 162/164.",
                "DecisionDate": "2020-07-03T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO O BLOQUEIO APENAS DA TRANSFERENCIA DOS VEICULOS HYUNDAI HB20 - PLACA FVQ-5773 E HYUNDAI HB20 - PLACA ELE 2836 VIA RENAJUD, SUFICIENTE PARA ASSEGURAR O RESULTADO UTIL DO PROCESSO.",
                "DecisionDate": "2020-06-19T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO O BLOQUEIO APENAS DA TRANSFERENCIA DOS VEICULOS HYUNDAI HB20 - PLACA FVQ-5773 E HYUNDAI HB20 - PLACA ELE 2836 VIA RENAJUD, SUFICIENTE PARA ASSEGURAR O RESULTADO UTIL DO PROCESSO.",
                "DecisionDate": "2020-06-18T00:00:00"
              },
              {
                "DecisionContent": "HOMOLOGO A DESISTENCIA EM FACE DO CORREU STARK BANK S/A.",
                "DecisionDate": "2020-06-08T00:00:00"
              },
              {
                "DecisionContent": "CONDENO OS REQUERENTES AO PAGAMENTO DE HONORARIOS ADVOCATICIOS ARBITRADOS EM R$ 2.000,00, POIS O PEDIDO DE DESISTENCIA FOI FORMULADO APOS OS ARGUMENTOS APRESENTADOS A FLS. 162/164.",
                "DecisionDate": "2020-06-08T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO O PEDIDO DE TUTELA DE URGENCIA PARA DETERMINAR O ARRESTO DE R$55.438,98 DOS REQUERIDOS FRI SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA - CNPJ N 10.685.786/0001-81, FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA - CNPJ N 21.160.553/0001-81 E STARK BANK SA - CNPJ N 20.018.183/0001-80 VIA BACENJUD E A PESQUISA DE BENS VIA RENAJUD.",
                "DecisionDate": "2020-05-29T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO O PEDIDO DE TUTELA DE URGENCIA PARA DETERMINAR O ARRESTO DE R$55.438,98 DOS REQUERIDOS FRI SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA - CNPJ N 10.685.786/0001-81, FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA - CNPJ N 21.160.553/0001-81 E STARK BANK SA - CNPJ N 20.018.183/0001-80 VIA BACENJUD E A PESQUISA DE BENS VIA RENAJUD.",
                "DecisionDate": "2020-05-22T00:00:00"
              }
            ]
          },
          {
            "Number": "00001921320228260114",
            "Type": "CUMPRIMENTO PROVISORIO DE SENTENCA",
            "MainSubject": "INDENIZACAO POR DANO MORAL",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "CAMPINAS",
            "JudgingBody": "2 VARA CIVEL",
            "State": "SP",
            "Status": "INDEFINIDO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "INDENIZAÇÃO POR DANO MORAL",
            "InferredCNJSubjectNumber": 14010,
            "InferredCNJProcedureTypeName": "CUMPRIMENTO PROVISÓRIO DE SENTENÇA",
            "InferredBroadCNJSubjectName": "DIREITO DO TRABALHO",
            "InferredBroadCNJSubjectNumber": 864,
            "OtherSubjects": [
              "INDENIZACAO POR DANO MORAL"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": -1,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2022-07-18T00:00:00",
            "NoticeDate": "2021-12-22T00:00:00",
            "LastMovementDate": "2022-07-18T00:00:00",
            "CaptureDate": "2022-12-04T17:00:36",
            "LastUpdate": "2022-12-04T17:00:36",
            "NumberOfParties": 8,
            "NumberOfUpdates": 46,
            "LawSuitAge": 798,
            "AverageNumberOfUpdatesPerMonth": 1,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "15005633000160",
                "IsPartyActive": true,
                "Name": "MASOTTI INDAIATUBA EMPREENDIMENTOS LTDA",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "EXEQTE"
                },
                "LastCaptureDate": "2022-12-04T17:00:36"
              },
              {
                "Doc": "28235049821",
                "IsPartyActive": true,
                "Name": "CLARISSA ALINE PAIE RODELLA CONTATO",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "209019",
                  "State": "SP",
                  "SpecificType": "ADVOGADA (EXEQTE)"
                },
                "LastCaptureDate": "2022-12-04T17:00:36"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "EXECTDO"
                },
                "LastCaptureDate": "2022-12-04T17:00:36"
              },
              {
                "Doc": "00028986000108",
                "IsPartyActive": true,
                "Name": "ELEVADORES ATLAS SCHINDLER LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "EXECTDO"
                },
                "LastCaptureDate": "2022-12-04T17:00:36"
              },
              {
                "Doc": "46189325000165",
                "IsPartyActive": true,
                "Name": "ITAU UNIBANCO S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "EXECTDO"
                },
                "LastCaptureDate": "2022-12-04T17:00:36"
              },
              {
                "Doc": "35068411817",
                "IsPartyActive": true,
                "Name": "RAFAEL HIDEO NAZIMA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "295443",
                  "State": "SP",
                  "SpecificType": "ADVOGADO (EXECTDO)"
                },
                "LastCaptureDate": "2022-12-04T17:00:36"
              },
              {
                "Doc": "16580239867",
                "IsPartyActive": true,
                "Name": "ANDRE GUSTAVO SALVADOR KAUFFMAN",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "168804",
                  "State": "SP",
                  "SpecificType": "ADVOGADO (EXECTDO)"
                },
                "LastCaptureDate": "2022-12-04T17:00:36"
              },
              {
                "Doc": "13510720806",
                "IsPartyActive": true,
                "Name": "PAULO ROBERTO JOAQUIM DOS REIS",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "23134",
                  "State": "SP",
                  "SpecificType": "ADVOGADO (EXECTDO)"
                },
                "LastCaptureDate": "2022-12-04T17:00:36"
              }
            ],
            "Updates": [
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0566/2022 DATA DA PUBLICACAO: 19/07/2022 NUMERO DO DIARIO: 3549",
                "PublishDate": "2022-07-18T00:00:00",
                "CaptureDate": "2022-12-04T17:00:36"
              },
              {
                "Content": "PROCESSO 0000192-13.2022.8.26.0114 (PROCESSO PRINCIPAL 1011799-94.2019.8.26.0248) - CUMPRIMENTO PROVISORIO DE SENTENCA - INDENIZACAO POR DANO MORAL - MASOTTI INDAIATUBA EMPREENDIMENTOS LTDA. - STARK BANK S.A. - - ELEVADORES ATLAS SCHINDLER LTDA. - - ITAU UNIBANCO S/A - AUTOS N 2020/001682 (NUMERO DO PROCESSO NA VARA). VISTOS. TRATA-SE DE IMPUGNACAO A EXECUCAO (CUMPRIMENTO) DE SENTENCA CONDENATORIA APRESENTADA POR STARK BANK S.A. E OUTROS EM FACE DE MASOTTI INDAIATUBA EMPREENDIMENTOS LTDA., COM FUNDAMENTO NO ARTIGO 525 CODIGO DE PROCESSO CIVIL. ALEGA EXCESSO DE EXECUCAO. HOUVE MANIFESTACAO DA PARTE IMPUGNADA (FLS. 136/141). E O RELATORIO. DECIDO. A PRESENTE IMPUGNACAO DEVE SER JULGADA IMPROCEDENTE, POSTO QUE SENDO A CONDENACAO SOLIDARIA, PODERIA O EXEQUENTE COBRAR TODO OU PARTE DOS VALORES DE QUALQUER DEVEDOR SOLIDARIO, A SUA ESCOLHA. AS PARTES EFETUARAM O DEPOSITO PARCIAL DE SUA QUOTA PARTE, NAO HAVENDO EXCESSO DE EXECUCAO, MAS A ADEQUACAO DO PROCEDIMENTO COM CADA PARTE EFETUANDO O PAGAMENTO DE SUA QUOTA PARTE. ANTE O EXPOSTO, CONHECO DA PRESENTE IMPUGNACAO E, EM SEU MERITO, INDEFIRO-A, MOTIVO PELO QUAL DETERMINO QUE A EXECUCAO TENHA SEU REGULAR PROSSEGUIMENTO. COMO HA O DEPOSITO INTEGRAL PELAS EXECUTADAS (FLS. 88/90 OU 672/674 DOS AUTOS PRINCIPAIS R$ 34.684,77, FLS. 100/102 R$ 35.479,70 E FLS. 128/129 R$ 37.23,29), SUSPENDO O PRESENTE CUMPRIMENTO PROVISORIA DE SENTENCA ATE O TRANSITO EM JULGADO DO PROCESSO, APOS O QUE SERA APRECIADO PEDIDO DE LEVANTAMENTO DE VALORES. AGUARDE-SE, TAMBEM, O JULGAMENTO DO AGRAVO. INTIMEM-SE. CAMPINAS, 14 DE JULHO DE 2022. LUCAS PEREIRA MORAES GARCIA JUIZ(A) DE DIREITO - ADV: RAFAEL HIDEO NAZIMA (OAB 295443/SP), ANDRE GUSTAVO SALVADOR KAUFFMAN (OAB 168804/SP), PAULO ROBERTO JOAQUIM DOS REIS (OAB 23134/SP), CLARISSA ALINE PAIE RODELLA CONTATO (OAB 209019/SP)",
                "PublishDate": "2022-07-18T00:00:00",
                "CaptureDate": "2022-12-04T17:00:36"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0566/2022 TEOR DO ATO: AUTOS N 2020/001682 (NUMERO DO PROCESSO NA VARA). VISTOS. TRATA-SE DE IMPUGNACAO A EXECUCAO (CUMPRIMENTO) DE SENTENCA CONDENATORIA APRESENTADA POR STARK BANK S.A. E OUTROS EM FACE DE MASOTTI INDAIATUBA EMPREENDIMENTOS LTDA., COM FUNDAMENTO NO ARTIGO 525 CODIGO DE PROCESSO CIVIL. ALEGA EXCESSO DE EXECUCAO. HOUVE MANIFESTACAO DA PARTE IMPUGNADA (FLS. 136/141). E O RELATORIO. DECIDO. A PRESENTE IMPUGNACAO DEVE SER JULGADA IMPROCEDENTE, POSTO QUE SENDO A CONDENACAO SOLIDARIA, PODERIA O EXEQUENTE COBRAR TODO OU PARTE DOS VALORES DE QUALQUER DEVEDOR SOLIDARIO, A SUA ESCOLHA. AS PARTES EFETUARAM O DEPOSITO PARCIAL DE SUA QUOTA PARTE, NAO HAVENDO EXCESSO DE EXECUCAO, MAS A ADEQUACAO DO PROCEDIMENTO COM CADA PARTE EFETUANDO O PAGAMENTO DE SUA QUOTA PARTE. ANTE O EXPOSTO, CONHECO DA PRESENTE IMPUGNACAO E, EM SEU MERITO, INDEFIRO-A, MOTIVO PELO QUAL DETERMINO QUE A EXECUCAO TENHA SEU REGULAR PROSSEGUIMENTO. COMO HA O DEPOSITO INTEGRAL PELAS EXECUTADAS (FLS. 88/90 OU 672/674 DOS AUTOS PRINCIPAIS R$ 34.684,77, FLS. 100/102 R$ 35.479,70 E FLS. 128/129 R$ 37.23,29), SUSPENDO O PRESENTE CUMPRIMENTO PROVISORIA DE SENTENCA ATE O TRANSITO EM JULGADO DO PROCESSO, APOS O QUE SERA APRECIADO PEDIDO DE LEVANTAMENTO DE VALORES. AGUARDE-SE, TAMBEM, O JULGAMENTO DO AGRAVO. INTIMEM-SE. CAMPINAS, 14 DE JULHO DE 2022. LUCAS PEREIRA MORAES GARCIA JUIZ(A) DE DIREITO ADVOGADOS(S): ANDRE GUSTAVO SALVADOR KAUFFMAN (OAB 168804/SP), CLARISSA ALINE PAIE RODELLA CONTATO (OAB 209019/SP), PAULO ROBERTO JOAQUIM DOS REIS (OAB 23134/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2022-07-15T00:00:00",
                "CaptureDate": "2022-12-04T17:00:36"
              },
              {
                "Content": "DECISAO OU DESPACHO CONCESSAO DE EFEITO SUSPENSIVO IMPUGNACAO AO CUMPRIMENTO DE SENTENCA AUTOS N 2020/001682 (NUMERO DO PROCESSO NA VARA). VISTOS. TRATA-SE DE IMPUGNACAO A EXECUCAO (CUMPRIMENTO) DE SENTENCA CONDENATORIA APRESENTADA POR STARK BANK S.A. E OUTROS EM FACE DE MASOTTI INDAIATUBA EMPREENDIMENTOS LTDA., COM FUNDAMENTO NO ARTIGO 525 CODIGO DE PROCESSO CIVIL. ALEGA EXCESSO DE EXECUCAO. HOUVE MANIFESTACAO DA PARTE IMPUGNADA (FLS. 136/141). E O RELATORIO. DECIDO. A PRESENTE IMPUGNACAO DEVE SER JULGADA IMPROCEDENTE, POSTO QUE SENDO A CONDENACAO SOLIDARIA, PODERIA O EXEQUENTE COBRAR TODO OU PARTE DOS VALORES DE QUALQUER DEVEDOR SOLIDARIO, A SUA ESCOLHA. AS PARTES EFETUARAM O DEPOSITO PARCIAL DE SUA QUOTA PARTE, NAO HAVENDO EXCESSO DE EXECUCAO, MAS A ADEQUACAO DO PROCEDIMENTO COM CADA PARTE EFETUANDO O PAGAMENTO DE SUA QUOTA PARTE. ANTE O EXPOSTO, CONHECO DA PRESENTE IMPUGNACAO E, EM SEU MERITO, INDEFIRO-A, MOTIVO PELO QUAL DETERMINO QUE A EXECUCAO TENHA SEU REGULAR PROSSEGUIMENTO. COMO HA O DEPOSITO INTEGRAL PELAS EXECUTADAS (FLS. 88/90 OU 672/674 DOS AUTOS PRINCIPAIS R$ 34.684,77, FLS. 100/102 R$ 35.479,70 E FLS. 128/129 R$ 37.23,29), SUSPENDO O PRESENTE CUMPRIMENTO PROVISORIA DE SENTENCA ATE O TRANSITO EM JULGADO DO PROCESSO, APOS O QUE SERA APRECIADO PEDIDO DE LEVANTAMENTO DE VALORES. AGUARDE-SE, TAMBEM, O JULGAMENTO DO AGRAVO. INTIMEM-SE. CAMPINAS, 14 DE JULHO DE 2022. LUCAS PEREIRA MORAES GARCIA JUIZ(A) DE DIREITO",
                "PublishDate": "2022-07-14T00:00:00",
                "CaptureDate": "2022-12-04T17:00:36"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2022-07-13T00:00:00",
                "CaptureDate": "2022-12-04T17:00:36"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2022-07-13T00:00:00",
                "CaptureDate": "2022-12-04T17:00:36"
              },
              {
                "Content": "MANIFESTACAO SOBRE A IMPUGNACAO JUNTADA N PROTOCOLO: WCAS.22.70320697-6 TIPO DA PETICAO: MANIFESTACAO SOBRE A IMPUGNACAO DATA: 04/07/2022 14:48",
                "PublishDate": "2022-07-04T00:00:00",
                "CaptureDate": "2022-12-04T17:00:36"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0474/2022 DATA DA PUBLICACAO: 20/06/2022 NUMERO DO DIARIO: 3528",
                "PublishDate": "2022-06-15T00:00:00",
                "CaptureDate": "2022-12-04T17:00:36"
              },
              {
                "Content": "ATO ORDINATORIO - INTIMACAO - DJE MANIFESTE-SE A EXEQUENTE SOBRE A IMPUGNACAO APRESENTADA, EM 15 DIAS.",
                "PublishDate": "2022-06-14T00:00:00",
                "CaptureDate": "2022-12-04T17:00:36"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0474/2022 TEOR DO ATO: MANIFESTE-SE A EXEQUENTE SOBRE A IMPUGNACAO APRESENTADA, EM 15 DIAS. ADVOGADOS(S): ANDRE GUSTAVO SALVADOR KAUFFMAN (OAB 168804/SP), CLARISSA ALINE PAIE RODELLA CONTATO (OAB 209019/SP), PAULO ROBERTO JOAQUIM DOS REIS (OAB 23134/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2022-06-14T00:00:00",
                "CaptureDate": "2022-12-04T17:00:36"
              },
              {
                "Content": "IMPUGNACAO AO CUMPRIMENTO DE SENTENCA JUNTADA N PROTOCOLO: WCAS.22.70278018-0 TIPO DA PETICAO: IMPUGNACAO AO CUMPRIMENTO DA SENTENCA DATA: 09/06/2022 13:37",
                "PublishDate": "2022-06-09T00:00:00",
                "CaptureDate": "2022-12-04T17:00:36"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0439/2022 DATA DA PUBLICACAO: 07/06/2022 NUMERO DO DIARIO: 3521",
                "PublishDate": "2022-06-06T00:00:00",
                "CaptureDate": "2022-12-04T17:00:36"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0439/2022 TEOR DO ATO: 1. MANTENHO A DECISAO AGRAVADA POR SEUS PROPRIOS FUNDAMENTOS JURIDICOS. 2. NO MAIS, CUMPRA-SE A DECISAO DE FLS. 107, AGUARDANDO-SE O PRAZO EM CURSO. ADVOGADOS(S): ANDRE GUSTAVO SALVADOR KAUFFMAN (OAB 168804/SP), CLARISSA ALINE PAIE RODELLA CONTATO (OAB 209019/SP), PAULO ROBERTO JOAQUIM DOS REIS (OAB 23134/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2022-06-03T00:00:00",
                "CaptureDate": "2022-12-04T17:00:36"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE 1. MANTENHO A DECISAO AGRAVADA POR SEUS PROPRIOS FUNDAMENTOS JURIDICOS. 2. NO MAIS, CUMPRA-SE A DECISAO DE FLS. 107, AGUARDANDO-SE O PRAZO EM CURSO.",
                "PublishDate": "2022-06-02T00:00:00",
                "CaptureDate": "2022-12-04T17:00:36"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2022-06-01T00:00:00",
                "CaptureDate": "2022-12-04T17:00:36"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2022-06-01T00:00:00",
                "CaptureDate": "2022-12-04T17:00:36"
              },
              {
                "Content": "OFICIO JUNTADO",
                "PublishDate": "2022-05-31T00:00:00",
                "CaptureDate": "2022-12-04T17:00:36"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WCAS.22.70253561-5 TIPO DA PETICAO: PETICAO JUNTANDO COPIA DO AGRAVO (ART. 1.018, DO CPC) DATA: 27/05/2022 20:21",
                "PublishDate": "2022-05-27T00:00:00",
                "CaptureDate": "2022-12-04T17:00:36"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0399/2022 DATA DA PUBLICACAO: 25/05/2022 NUMERO DO DIARIO: 3511",
                "PublishDate": "2022-05-23T00:00:00",
                "CaptureDate": "2022-12-04T17:00:36"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0399/2022 TEOR DO ATO: AUTOS N 2020/001682 (NUMERO DO PROCESSO NA VARA). NOS TERMOS DO ART. 523 DO CODIGO DE PROCESSO CIVIL, CONCEDO AO DEVEDOR O PRAZO DE 15 (QUINZE) DIAS PARA QUE EFETUE, NESTES AUTOS DE CUMPRIMENTO PROVISORIO DE SENTENCA, O PAGAMENTO DA QUANTIA DE R$ 70.959,40. (FLS. 05), QUE DEVERA SER CORRIGIDA MONETARIAMENTE E ACRESCIDA DE JUROS DE MORA DE 1% AO MES, DESDE DEZEMBRO/2021 (DATA DO CALCULO APRESENTADO), ATE O EFETIVO PAGAMENTO. FICA A PARTE EXECUTADA ADVERTIDA DE QUE, CASO NAO EFETUE O PAGAMENTO, O DEBITO SERA ACRESCIDO DE MULTA DE 10% (DEZ POR CENTO) E, TAMBEM, DE HONORARIOS ADVOCATICIOS DE 10% (DEZ POR CENTO). INTIMEM-SE. CAMPINAS, 17 DE MAIO DE 2022. LUCAS PEREIRA MORAES GARCIA JUIZ(A) DE DIREITO ADVOGADOS(S): CLARISSA ALINE PAIE RODELLA CONTATO (OAB 209019/SP), PAULO ROBERTO JOAQUIM DOS REIS (OAB 23134/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP), ANDRE GUSTAVO SALVADOR KAUFFMAN (OAB 168804/SP)",
                "PublishDate": "2022-05-20T00:00:00",
                "CaptureDate": "2022-12-04T17:00:36"
              },
              {
                "Content": "PROFERIDAS OUTRAS DECISOES NAO ESPECIFICADAS AUTOS N 2020/001682 (NUMERO DO PROCESSO NA VARA). NOS TERMOS DO ART. 523 DO CODIGO DE PROCESSO CIVIL, CONCEDO AO DEVEDOR O PRAZO DE 15 (QUINZE) DIAS PARA QUE EFETUE, NESTES AUTOS DE CUMPRIMENTO PROVISORIO DE SENTENCA, O PAGAMENTO DA QUANTIA DE R$ 70.959,40. (FLS. 05), QUE DEVERA SER CORRIGIDA MONETARIAMENTE E ACRESCIDA DE JUROS DE MORA DE 1% AO MES, DESDE DEZEMBRO/2021 (DATA DO CALCULO APRESENTADO), ATE O EFETIVO PAGAMENTO. FICA A PARTE EXECUTADA ADVERTIDA DE QUE, CASO NAO EFETUE O PAGAMENTO, O DEBITO SERA ACRESCIDO DE MULTA DE 10% (DEZ POR CENTO) E, TAMBEM, DE HONORARIOS ADVOCATICIOS DE 10% (DEZ POR CENTO). INTIMEM-SE. CAMPINAS, 17 DE MAIO DE 2022. LUCAS PEREIRA MORAES GARCIA JUIZ(A) DE DIREITO",
                "PublishDate": "2022-05-19T00:00:00",
                "CaptureDate": "2022-12-04T17:00:36"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2022-05-17T00:00:00",
                "CaptureDate": "2022-12-04T17:00:36"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WCAS.22.70223915-3 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 13/05/2022 02:19",
                "PublishDate": "2022-05-13T00:00:00",
                "CaptureDate": "2022-12-04T17:00:36"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0355/2022 DATA DA PUBLICACAO: 11/05/2022 NUMERO DO DIARIO: 3502",
                "PublishDate": "2022-05-10T00:00:00",
                "CaptureDate": "2022-12-04T17:00:36"
              },
              {
                "Content": "REMETIDOS OS AUTOS PARA O CARTORIO DISTRIBUIDOR LOCAL PARA ANOTACAO/CORRECAO DE CLASSE",
                "PublishDate": "2022-05-10T00:00:00",
                "CaptureDate": "2022-12-04T17:00:36"
              },
              {
                "Content": "CLASSE RETIFICADA CORRIGIDA A CLASSE DE CUMPRIMENTO DE SENTENCA PARA CUMPRIMENTO PROVISORIO DE SENTENCA.",
                "PublishDate": "2022-05-10T00:00:00",
                "CaptureDate": "2022-12-04T17:00:36"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0355/2022 TEOR DO ATO: 1. FLS. 09/11: TRATA-SE DE EMBARGOS DE DECLARACAO OPOSTOS PARA ALEGAR OBSCURIDADE, OMISSAO OU CONTRADICAO DA DECISAO PROLATADA. RECEBO OS EMBARGOS, VEZ QUE TEMPESTIVOS. NO MERITO, NEGO-LHES PROVIMENTO, POIS NAO HA VICIO A SER SANADO NA DECISAO EMBARGADA. EVENTUAL INCONFORMISMO HA DE SER MANEJADO EM VIA ADEQUADA. POR TODO O EXPOSTO, REJEITO OS EMBARGOS DE DECLARACAO OPOSTOS, MANTENDO NA INTEGRA A DECISAO TAL QUAL LANCADA. 2. ANOTE-SE TRATAR DE CUMPRIMENTO PROVISORIO DE SENTENCA. ALTERE A Z. SERVENTIA A CLASSE-ASSUNTO. ADVOGADOS(S): ANDRE GUSTAVO SALVADOR KAUFFMAN (OAB 168804/SP), CLARISSA ALINE PAIE RODELLA CONTATO (OAB 209019/SP), PAULO ROBERTO JOAQUIM DOS REIS (OAB 23134/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2022-05-09T00:00:00",
                "CaptureDate": "2022-12-04T17:00:36"
              },
              {
                "Content": "EMBARGOS DE DECLARACAO NAO-ACOLHIDOS 1. FLS. 09/11: TRATA-SE DE EMBARGOS DE DECLARACAO OPOSTOS PARA ALEGAR OBSCURIDADE, OMISSAO OU CONTRADICAO DA DECISAO PROLATADA. RECEBO OS EMBARGOS, VEZ QUE TEMPESTIVOS. NO MERITO, NEGO-LHES PROVIMENTO, POIS NAO HA VICIO A SER SANADO NA DECISAO EMBARGADA. EVENTUAL INCONFORMISMO HA DE SER MANEJADO EM VIA ADEQUADA. POR TODO O EXPOSTO, REJEITO OS EMBARGOS DE DECLARACAO OPOSTOS, MANTENDO NA INTEGRA A DECISAO TAL QUAL LANCADA. 2. ANOTE-SE TRATAR DE CUMPRIMENTO PROVISORIO DE SENTENCA. ALTERE A Z. SERVENTIA A CLASSE-ASSUNTO.",
                "PublishDate": "2022-05-06T00:00:00",
                "CaptureDate": "2022-12-04T17:00:36"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WCAS.22.70066911-8 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 15/02/2022 18:11",
                "PublishDate": "2022-02-16T00:00:00",
                "CaptureDate": "2022-12-04T17:00:36"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2022-02-03T00:00:00",
                "CaptureDate": "2022-02-09T00:40:51"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2022-02-03T00:00:00",
                "CaptureDate": "2022-02-09T00:40:51"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WCAS.22.70038326-5 TIPO DA PETICAO: PETICAO INTERMEDIARIA DATA: 01/02/2022 16:24",
                "PublishDate": "2022-02-01T00:00:00",
                "CaptureDate": "2022-02-09T00:40:51"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0052/2022 DATA DA PUBLICACAO: 28/01/2022 NUMERO DO DIARIO: 3435",
                "PublishDate": "2022-01-27T00:00:00",
                "CaptureDate": "2022-02-09T00:40:51"
              },
              {
                "Content": "PROCESSO 0000192-13.2022.8.26.0114 (PROCESSO PRINCIPAL 1011799-94.2019.8.26.0248) - CUMPRIMENTO DE SENTENCA - INDENIZACAO POR DANO MORAL - MASOTTI INDAIATUBA EMPREENDIMENTOS LTDA. - STARK BANK S.A. - - ELEVADORES ATLAS SCHINDLER LTDA. - - ITAU UNIBANCO S/A - VISTOS. CONCEDO A PARTE EMBARGADA O PRAZO DE 5 (CINCO) DIAS PARA, QUERENDO, MANIFESTAR-SE ACERCA DOS EMBARGOS DE DECLARACAO APRESENTADOS, FACO-O COM FUNDAMENTO NO ARTIGO 1.023  2 DO CPC. - ADV: RAFAEL HIDEO NAZIMA (OAB 295443/SP), CLARISSA ALINE PAIE RODELLA CONTATO (OAB 209019/SP), ANDRE GUSTAVO SALVADOR KAUFFMAN (OAB 168804/SP), PAULO ROBERTO JOAQUIM DOS REIS (OAB 23134/SP)",
                "PublishDate": "2022-01-27T00:00:00",
                "CaptureDate": "2022-02-09T00:40:51"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0052/2022 TEOR DO ATO: VISTOS. CONCEDO A PARTE EMBARGADA O PRAZO DE 5 (CINCO) DIAS PARA, QUERENDO, MANIFESTAR-SE ACERCA DOS EMBARGOS DE DECLARACAO APRESENTADOS, FACO-O COM FUNDAMENTO NO ARTIGO 1.023  2 DO CPC. ADVOGADOS(S): ANDRE GUSTAVO SALVADOR KAUFFMAN (OAB 168804/SP), CLARISSA ALINE PAIE RODELLA CONTATO (OAB 209019/SP), PAULO ROBERTO JOAQUIM DOS REIS (OAB 23134/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2022-01-26T00:00:00",
                "CaptureDate": "2022-02-09T00:40:51"
              },
              {
                "Content": "EMBARGOS DE DECLARACAO JUNTADOS N PROTOCOLO: WCAS.22.70022568-6 TIPO DA PETICAO: EMBARGOS DE DECLARACAO DATA: 24/01/2022 23:10",
                "PublishDate": "2022-01-25T00:00:00",
                "CaptureDate": "2022-02-09T00:40:51"
              },
              {
                "Content": "CERTIDAO DE CARTORIO EXPEDIDA EMBARGOS DE DECLARACAO TEMPESTIVOS",
                "PublishDate": "2022-01-25T00:00:00",
                "CaptureDate": "2022-02-09T00:40:51"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2022-01-25T00:00:00",
                "CaptureDate": "2022-02-09T00:40:51"
              },
              {
                "Content": "MERO EXPEDIENTE VISTOS. CONCEDO A PARTE EMBARGADA O PRAZO DE 5 (CINCO) DIAS PARA, QUERENDO, MANIFESTAR-SE ACERCA DOS EMBARGOS DE DECLARACAO APRESENTADOS, FACO-O COM FUNDAMENTO NO ARTIGO 1.023  2 DO CPC.",
                "PublishDate": "2022-01-25T00:00:00",
                "CaptureDate": "2022-02-09T00:40:51"
              },
              {
                "Content": "PEDIDO DE EXTINCAO JUNTADA N PROTOCOLO: WCAS.22.70024727-2 TIPO DA PETICAO: PEDIDO DE EXTINCAO DO PROCESSO DATA: 25/01/2022 18:16",
                "PublishDate": "2022-01-25T00:00:00",
                "CaptureDate": "2022-02-09T00:40:51"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE VISTOS. CONCEDO A PARTE EMBARGADA O PRAZO DE 5 (CINCO) DIAS PARA, QUERENDO, MANIFESTAR-SE ACERCA DOS EMBARGOS DE DECLARACAO APRESENTADOS, FACO-O COM FUNDAMENTO NO ARTIGO 1.023  2 DO CPC.",
                "PublishDate": "2022-01-25T00:00:00",
                "CaptureDate": "2022-12-04T17:00:36"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0011/2022 DATA DA PUBLICACAO: 21/01/2022 NUMERO DO DIARIO: 3426",
                "PublishDate": "2022-01-13T00:00:00",
                "CaptureDate": "2022-02-09T00:40:51"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0011/2022 TEOR DO ATO: AUTOS N 2020/001682 (NUMERO DO PROCESSO NA VARA). NOS TERMOS DO ART. 523 DO CODIGO DE PROCESSO CIVIL, CONCEDO AO DEVEDOR O PRAZO DE 15 (QUINZE) DIAS PARA QUE EFETUE, NESTES AUTOS DE CUMPRIMENTO DE SENTENCA, O PAGAMENTO DA QUANTIA DE R$ 70.959,40 (FLS.05), QUE DEVERA SER CORRIGIDA MONETARIAMENTE E ACRESCIDA DE JUROS DE MORA DE 1% AO MES, DESDE DEZEMBRO/2021 (DATA DO CALCULO APRESENTADO), ATE O EFETIVO PAGAMENTO. FICA A PARTE EXECUTADA ADVERTIDA DE QUE, CASO NAO EFETUE O PAGAMENTO, O DEBITO SERA ACRESCIDO DE MULTA DE 10% (DEZ POR CENTO) E, TAMBEM, DE HONORARIOS ADVOCATICIOS DE 10% (DEZ POR CENTO). A INTIMACAO DA PARTE PARA QUE EFETUE O PAGAMENTO SERA FEITA NOS SEGUINTES TEMOS: (1) NA PESSOA DO ADVOGADO, COM A PUBLICACAO DESTA DECISAO NA IMPRENSA OFICIAL (ART. 272 DO CODIGO DE PROCESSO CIVIL), ACASO TENHA PROCURADOR CONSTITUIDO NOS AUTOS; (2) POR CARTA COM AVISO DE RECEBIMENTO, QUANDO REPRESENTADO PELA DEFENSORIA PUBLICA OU QUANDO NAO TIVER PROCURADOR CONSTITUIDO NOS AUTOS, FICANDO RESSALTADO QUE SE APLICA AQUI O DISPOSTO NO PARAGRAFO UNICO DO ARTIGO 274 DO CPC, OU SEJA, SE O EXECUTADO FOI CITADO PESSOALMENTE NO ENDERECO CONSTANTE DOS AUTOS OU INFORMOU ANTERIORMENTE ESSE ENDERECO, PRESUMIR-SE-AO VALIDAS AS INTIMACOES DIRIGIDAS A ESSE ENDERECO, AINDA QUE NAO RECEBIDAS PESSOALMENTE; (3) POR EDITAL, QUANDO, CITADO DESSA FORMA NA FASE DE CONHECIMENTO E NELA TIVER SIDO REVEL. INTIMEM-SE. CAMPINAS, 11 DE JANEIRO DE 2022. GABRIEL BALDI DE CARVALHO JUIZ(A) DE DIREITO ADVOGADOS(S): ANDRE GUSTAVO SALVADOR KAUFFMAN (OAB 168804/SP), CLARISSA ALINE PAIE RODELLA CONTATO (OAB 209019/SP), PAULO ROBERTO JOAQUIM DOS REIS (OAB 23134/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP)",
                "PublishDate": "2022-01-12T00:00:00",
                "CaptureDate": "2022-02-09T00:40:51"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2022-01-11T00:00:00",
                "CaptureDate": "2022-02-09T00:40:51"
              },
              {
                "Content": "DECISAO AUTOS N 2020/001682 (NUMERO DO PROCESSO NA VARA). NOS TERMOS DO ART. 523 DO CODIGO DE PROCESSO CIVIL, CONCEDO AO DEVEDOR O PRAZO DE 15 (QUINZE) DIAS PARA QUE EFETUE, NESTES AUTOS DE CUMPRIMENTO DE SENTENCA, O PAGAMENTO DA QUANTIA DE R$ 70.959,40 (FLS.05), QUE DEVERA SER CORRIGIDA MONETARIAMENTE E ACRESCIDA DE JUROS DE MORA DE 1% AO MES, DESDE DEZEMBRO/2021 (DATA DO CALCULO APRESENTADO), ATE O EFETIVO PAGAMENTO. FICA A PARTE EXECUTADA ADVERTIDA DE QUE, CASO NAO EFETUE O PAGAMENTO, O DEBITO SERA ACRESCIDO DE MULTA DE 10% (DEZ POR CENTO) E, TAMBEM, DE HONORARIOS ADVOCATICIOS DE 10% (DEZ POR CENTO). A INTIMACAO DA PARTE PARA QUE EFETUE O PAGAMENTO SERA FEITA NOS SEGUINTES TEMOS: (1) NA PESSOA DO ADVOGADO, COM A PUBLICACAO DESTA DECISAO NA IMPRENSA OFICIAL (ART. 272 DO CODIGO DE PROCESSO CIVIL), ACASO TENHA PROCURADOR CONSTITUIDO NOS AUTOS; (2) POR CARTA COM AVISO DE RECEBIMENTO, QUANDO REPRESENTADO PELA DEFENSORIA PUBLICA OU QUANDO NAO TIVER PROCURADOR CONSTITUIDO NOS AUTOS, FICANDO RESSALTADO QUE SE APLICA AQUI O DISPOSTO NO PARAGRAFO UNICO DO ARTIGO 274 DO CPC, OU SEJA, SE O EXECUTADO FOI CITADO PESSOALMENTE NO ENDERECO CONSTANTE DOS AUTOS OU INFORMOU ANTERIORMENTE ESSE ENDERECO, PRESUMIR-SE-AO VALIDAS AS INTIMACOES DIRIGIDAS A ESSE ENDERECO, AINDA QUE NAO RECEBIDAS PESSOALMENTE; (3) POR EDITAL, QUANDO, CITADO DESSA FORMA NA FASE DE CONHECIMENTO E NELA TIVER SIDO REVEL. INTIMEM-SE. CAMPINAS, 11 DE JANEIRO DE 2022. GABRIEL BALDI DE CARVALHO JUIZ(A) DE DIREITO",
                "PublishDate": "2022-01-11T00:00:00",
                "CaptureDate": "2022-02-09T00:40:51"
              },
              {
                "Content": "INICIO DA EXECUCAO JUNTADO PROCESSO PRINCIPAL: 1011799-94.2019.8.26.0248",
                "PublishDate": "2022-01-07T00:00:00",
                "CaptureDate": "2022-02-09T00:40:51"
              }
            ],
            "Petitions": [
              {
                "Type": "EMBARGOS DE DECLARACAO",
                "Author": "",
                "CreationDate": "2022-01-24T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PEDIDO DE EXTINCAO DO PROCESSO",
                "Author": "",
                "CreationDate": "2022-01-25T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICAO INTERMEDIARIA",
                "Author": "",
                "CreationDate": "2022-02-01T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2022-02-15T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2022-05-13T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICAO JUNTANDO COPIA DO AGRAVO (ART. 1.018, DO CPC)",
                "Author": "",
                "CreationDate": "2022-05-27T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "IMPUGNACAO AO CUMPRIMENTO DA SENTENCA",
                "Author": "",
                "CreationDate": "2022-06-09T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "MANIFESTACAO SOBRE A IMPUGNACAO",
                "Author": "",
                "CreationDate": "2022-07-04T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              }
            ],
            "Decisions": []
          },
          {
            "Number": "10019167120228260005",
            "Type": "PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL",
            "MainSubject": "INDENIZACAO POR DANO MATERIAL",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "ESPECIAL CIVEL",
            "CourtDistrict": "SAO PAULO",
            "Judge": "ENIO JOSE HAUFFE",
            "JudgingBody": "1 VARA DO JUIZADO ESPECIAL CIVEL",
            "State": "SP",
            "Status": "ARQUIVADO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "INDENIZAÇÃO POR DANO MATERIAL",
            "InferredCNJSubjectNumber": 14009,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO DO JUIZADO ESPECIAL CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO TRABALHO",
            "InferredBroadCNJSubjectNumber": 864,
            "OtherSubjects": [
              "INDENIZACAO POR DANO MATERIAL"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 5087.16,
            "ResJudicataDate": "2022-06-28T00:00:00",
            "CloseDate": "2022-06-28T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2022-05-12T00:00:00",
            "NoticeDate": "2022-02-04T00:00:00",
            "LastMovementDate": "2022-06-28T00:00:00",
            "CaptureDate": "2022-12-26T09:23:48",
            "LastUpdate": "2022-12-26T09:23:48",
            "NumberOfParties": 8,
            "NumberOfUpdates": 63,
            "LawSuitAge": 144,
            "AverageNumberOfUpdatesPerMonth": 2,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "31355190827",
                "IsPartyActive": true,
                "Name": "JEFFERSON BETANIN PORANGABA",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2022-12-26T09:23:48"
              },
              {
                "IsPartyActive": false,
                "Name": "GUILHERME BADRA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "SpecificType": "ADVOGADO (REQTE)"
                },
                "LastCaptureDate": "2022-05-27T07:09:18"
              },
              {
                "Doc": "30297195000144",
                "IsPartyActive": true,
                "Name": "FACILY SOLUCOES E TECNOLOGIA LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2022-12-26T09:23:48"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2022-12-26T09:23:48"
              },
              {
                "Doc": "35068411817",
                "IsPartyActive": true,
                "Name": "RAFAEL HIDEO NAZIMA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "295443",
                  "State": "SP",
                  "SpecificType": "ADVOGADO (REQDO)"
                },
                "LastCaptureDate": "2022-12-26T09:23:48"
              },
              {
                "Doc": "26410005806",
                "IsPartyActive": true,
                "Name": "ENIO JOSE HAUFFE",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "OAB": "173860",
                  "State": "SP",
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2022-12-26T09:23:48"
              },
              {
                "Doc": "33071196806",
                "IsPartyActive": true,
                "Name": "GUILHERME BADRA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "339677",
                  "State": "SP",
                  "SpecificType": "ADVOGADO (REQTE)"
                },
                "LastCaptureDate": "2022-12-26T09:23:48"
              },
              {
                "IsPartyActive": true,
                "Name": "HAROLDO NUNES",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "229548",
                  "State": "SP",
                  "SpecificType": "ADVOGADO (REQDO)"
                },
                "LastCaptureDate": "2022-12-26T09:23:48"
              }
            ],
            "Updates": [
              {
                "Content": "TRANSITO EM JULGADO AS PARTES - PROC. EM ANDAMENTO CERTIDAO - TRANSITO EM JULGADO - MOVIMENTACAO INCLUSA",
                "PublishDate": "2022-06-28T00:00:00",
                "CaptureDate": "2022-12-26T09:23:49"
              },
              {
                "Content": "ARQUIVADO DEFINITIVAMENTE",
                "PublishDate": "2022-06-28T00:00:00",
                "CaptureDate": "2022-12-26T09:23:49"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO: 0285/2022 DATA DA PUBLICACAO: 13/05/2022 NUMERO DO DIARIO: 3504",
                "PublishDate": "2022-05-12T00:00:00",
                "CaptureDate": "2022-05-27T07:09:18"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0285/2022 DATA DA PUBLICACAO: 13/05/2022 NUMERO DO DIARIO: 3504",
                "PublishDate": "2022-05-12T00:00:00",
                "CaptureDate": "2022-12-26T09:23:49"
              },
              {
                "Content": "PROCESSO 1001916-71.2022.8.26.0005 - PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL - INDENIZACAO POR DANO MATERIAL - JEFFERSON BETANIN PORANGABA - FACILY SOLUCOES E TECNOLOGIA LTDA - - STARK BANK S.A. - ANTE O EXPOSTO, COM FUNDAMENTO NO ART. 487, III, A DO CPC, HOMOLOGO O RECONHECIMENTO DA PROCEDENCIA DO PEDIDO DE RESTITUICAO DO VALOR DAS COMPRAS POR PARTE DA CORRE FACI.LY SOLUCOES E TECNOLOGIA LTDA. POR OUTRO LADO, COM FUNDAMENTO NO DISPOSTO NO ART. 487, I DO CODIGO DE PROCESSO CIVIL, JULGO IMPROCEDENTES: A) OS PEDIDOS EM FACE DE STARK BANK S/A; E B) O PEDIDO DE INDENIZACAO POR DANOS MORAIS. SEM ONUS DE SUCUMBENCIA NESTA PRIMEIRA FASE PROCEDIMENTAL. P.R.I. SAO PAULO, 10 DE MAIO DE 2022. - ADV: HAROLDO NUNES (OAB 229548/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP), GUILHERME BADRA (OAB 339677/SP)",
                "PublishDate": "2022-05-12T00:00:00",
                "CaptureDate": "2022-12-26T09:23:48"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0285/2022 TEOR DO ATO: ANTE O EXPOSTO, COM FUNDAMENTO NO ART. 487, III, A DO CPC, HOMOLOGO O RECONHECIMENTO DA PROCEDENCIA DO PEDIDO DE RESTITUICAO DO VALOR DAS COMPRAS POR PARTE DA CORRE FACI.LY SOLUCOES E TECNOLOGIA LTDA. POR OUTRO LADO, COM FUNDAMENTO NO DISPOSTO NO ART. 487, I DO CODIGO DE PROCESSO CIVIL, JULGO IMPROCEDENTES: A) OS PEDIDOS EM FACE DE STARK BANK S/A; E B) O PEDIDO DE INDENIZACAO POR DANOS MORAIS. SEM ONUS DE SUCUMBENCIA NESTA PRIMEIRA FASE PROCEDIMENTAL. P.R.I. SAO PAULO, 10 DE MAIO DE 2022. ADVOGADOS(S): HAROLDO NUNES (OAB 229548/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP), GUILHERME BADRA (OAB 339677/SP)",
                "PublishDate": "2022-05-11T00:00:00",
                "CaptureDate": "2022-05-27T07:09:18"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0285/2022 TEOR DO ATO: ANTE O EXPOSTO, COM FUNDAMENTO NO ART. 487, III, A DO CPC, HOMOLOGO O RECONHECIMENTO DA PROCEDENCIA DO PEDIDO DE RESTITUICAO DO VALOR DAS COMPRAS POR PARTE DA CORRE FACI.LY SOLUCOES E TECNOLOGIA LTDA. POR OUTRO LADO, COM FUNDAMENTO NO DISPOSTO NO ART. 487, I DO CODIGO DE PROCESSO CIVIL, JULGO IMPROCEDENTES: A) OS PEDIDOS EM FACE DE STARK BANK S/A; E B) O PEDIDO DE INDENIZACAO POR DANOS MORAIS. SEM ONUS DE SUCUMBENCIA NESTA PRIMEIRA FASE PROCEDIMENTAL. P.R.I. SAO PAULO, 10 DE MAIO DE 2022. ADVOGADOS(S): HAROLDO NUNES (OAB 229548/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP), GUILHERME BADRA (OAB 339677/SP)",
                "PublishDate": "2022-05-11T00:00:00",
                "CaptureDate": "2022-12-26T09:23:49"
              },
              {
                "Content": "JULGADA PROCEDENTE EM PARTE A ACAO | ANTE O EXPOSTO, COM FUNDAMENTO NO ART. 487, III, A DO CPC, HOMOLOGO O RECONHECIMENTO DA PROCEDENCIA DO PEDIDO DE RESTITUICAO DO VALOR DAS COMPRAS POR PARTE DA CORRE FACI.LY SOLUCOES E TECNOLOGIA LTDA. POR OUTRO LADO, COM FUNDAMENTO NO DISPOSTO NO ART. 487, I DO CODIGO DE PROCESSO CIVIL, JULGO IMPROCEDENTES: A) OS PEDIDOS EM FACE DE STARK BANK S/A; E B) O PEDIDO DE INDENIZACAO POR DANOS MORAIS. SEM ONUS DE SUCUMBENCIA NESTA PRIMEIRA FASE PROCEDIMENTAL. P.R.I. SAO PAULO, 10 DE MAIO DE 2022.",
                "PublishDate": "2022-05-10T00:00:00",
                "CaptureDate": "2022-05-27T07:09:18"
              },
              {
                "Content": "JULGADA PROCEDENTE EM PARTE A ACAO ANTE O EXPOSTO, COM FUNDAMENTO NO ART. 487, III, A DO CPC, HOMOLOGO O RECONHECIMENTO DA PROCEDENCIA DO PEDIDO DE RESTITUICAO DO VALOR DAS COMPRAS POR PARTE DA CORRE FACI.LY SOLUCOES E TECNOLOGIA LTDA. POR OUTRO LADO, COM FUNDAMENTO NO DISPOSTO NO ART. 487, I DO CODIGO DE PROCESSO CIVIL, JULGO IMPROCEDENTES: A) OS PEDIDOS EM FACE DE STARK BANK S/A; E B) O PEDIDO DE INDENIZACAO POR DANOS MORAIS. SEM ONUS DE SUCUMBENCIA NESTA PRIMEIRA FASE PROCEDIMENTAL. P.R.I. SAO PAULO, 10 DE MAIO DE 2022.",
                "PublishDate": "2022-05-10T00:00:00",
                "CaptureDate": "2022-12-26T09:23:49"
              },
              {
                "Content": "CONCLUSOS PARA SENTENCA",
                "PublishDate": "2022-05-04T00:00:00",
                "CaptureDate": "2022-05-27T07:09:18"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2022-05-03T00:00:00",
                "CaptureDate": "2022-05-27T07:09:18"
              },
              {
                "Content": "REPLICA JUNTADA | N PROTOCOLO: WSMP.22.70095569-2 TIPO DA PETICAO: MANIFESTACAO SOBRE A CONTESTACAO DATA: 03/05/2022 12:41",
                "PublishDate": "2022-05-03T00:00:00",
                "CaptureDate": "2022-05-27T07:09:18"
              },
              {
                "Content": "REPLICA JUNTADA | N PROTOCOLO: WSMP.22.70095567-6 TIPO DA PETICAO: MANIFESTACAO SOBRE A CONTESTACAO DATA: 03/05/2022 12:41",
                "PublishDate": "2022-05-03T00:00:00",
                "CaptureDate": "2022-05-27T07:09:18"
              },
              {
                "Content": "REPLICA JUNTADA N PROTOCOLO: WSMP.22.70095567-6 TIPO DA PETICAO: MANIFESTACAO SOBRE A CONTESTACAO DATA: 03/05/2022 12:41",
                "PublishDate": "2022-05-03T00:00:00",
                "CaptureDate": "2022-12-26T09:23:49"
              },
              {
                "Content": "REPLICA JUNTADA N PROTOCOLO: WSMP.22.70095569-2 TIPO DA PETICAO: MANIFESTACAO SOBRE A CONTESTACAO DATA: 03/05/2022 12:41",
                "PublishDate": "2022-05-03T00:00:00",
                "CaptureDate": "2022-12-26T09:23:49"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2022-05-03T00:00:00",
                "CaptureDate": "2022-12-26T09:23:49"
              },
              {
                "Content": "PETICAO JUNTADA | N PROTOCOLO: WSMP.22.70091107-5 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 28/04/2022 08:57",
                "PublishDate": "2022-04-28T00:00:00",
                "CaptureDate": "2022-05-27T07:09:18"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WSMP.22.70091107-5 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 28/04/2022 08:57",
                "PublishDate": "2022-04-28T00:00:00",
                "CaptureDate": "2022-12-26T09:23:49"
              },
              {
                "Content": "PETICAO JUNTADA | N PROTOCOLO: WSMP.22.70089645-9 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 26/04/2022 21:08",
                "PublishDate": "2022-04-27T00:00:00",
                "CaptureDate": "2022-05-27T07:09:18"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WSMP.22.70089645-9 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 26/04/2022 21:08",
                "PublishDate": "2022-04-27T00:00:00",
                "CaptureDate": "2022-12-26T09:23:49"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO: 0192/2022 DATA DA PUBLICACAO: 06/04/2022 NUMERO DO DIARIO: 3481",
                "PublishDate": "2022-04-05T00:00:00",
                "CaptureDate": "2022-05-27T07:09:18"
              },
              {
                "Content": "PROCESSO 1001916-71.2022.8.26.0005 - PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL - INDENIZACAO POR DANO MATERIAL - JEFFERSON BETANIN PORANGABA - FACILY SOLUCOES E TECNOLOGIA LTDA - - STARK BANK S.A. - 1) INTIME-SE A PARTE AUTORA PARA QUE SE MANIFESTE EM 15 (QUINZE) DIAS SOBRE AS CONTESTACOES APRESENTADAS. 2) NO MESMO PRAZO DE 15 (QUINZE) DIAS, DEVERAO AS PARTES TRAZEREM AOS AUTOS TODAS AS PROVAS DOCUMENTAIS QUE TENHAM INTERESSE EM PRODUZIR (O QUE INCLUI EVENTUAIS MIDIAS COM AUDIOS OU VIDEOS RELACIONADOS AOS FATOS CONTROVERTIDOS), BEM COMO, SE ASSIM DESEJAREM, APRESENTEM ROL DE TESTEMUNHAS, INDICANDO, PRECISAMENTE: (I) O NOME DA TESTEMUNHA; (II) EVENTUAL PARENTESCO COM AS PARTES OU AMIZADE INTIMA; (III) SE PRESENCIOU OS FATOS; (IV) O MOTIVO PELO QUAL ENTENDE QUE A PROVA TESTEMUNHAL E RELEVANTE; (V) SEU ENDERECO DE E-MAIL E SE POSSUI ACESSO A INTERNET E AO APLICATIVO MICROSOFTTEAMS, DE COMPUTADOR PROPRIO (NAO PODENDO SE UTILIZAR DE COMPUTADOR EM LOCAL DE RESIDENCIA DAS PARTES OU ESCRITORIO DO ADVOGADO), COM VIDEO E AUDIO, SENDO CERTO QUE E DE INTEIRA RESPONSABILIDADE DAS PARTES PROVIDENCIAR O NECESSARIO PARA QUE O DEPOIMENTO TESTEMUNHAL SEJA PRODUZIDO, SOB PENA DE SE CONCLUIR PELA PROVA NO SENTIDO CONTRARIO DAQUELA QUE SE PRETENDIA PRODUZIR, ALEM DE EVENTUAL LITIGANCIA DE MA-FE TENDO EM VISTA A SITUACAO DE PANDEMIA DE SARSCOV-2, QUE TRAZ ENORMES PREJUIZOS E RISCOS NA REALIZACAO DE ATOS QUE SE MOSTREM DESNECESSARIOS. AINDA, NA MESMA OPORTUNIDADE, CONSIDERANDO O TEOR DA CONTESTACAO, CONSULTO SE HA POSSIBILIDADE DE ACORDO, CABENDO AS PARTES, SE O CASO, APRESENTAREM AS SUAS PROPOSTAS. A MANIFESTACAO DA PARTE, CASO NAO POSSUA ADVOGADO CONSTITUIDO, DEVERA SER ENCAMINHADA PARA O E-MAIL SAOMIGUELJEC@TJSP. JUS.BR. TUDO ISSO SEM PREJUIZO DA ANALISE DAS QUESTOES PENDENTES, E DO JULGAMENTO DO MERITO NO ESTADO, CASO SE ENTENDA DESNECESSARIA A PRODUCAO DE OUTRAS PROVAS. OPORTUNAMENTE, TORNEM CONCLUSOS. - ADV: RAFAEL HIDEO NAZIMA (OAB 295443/ SP), HAROLDO NUNES (OAB 229548/SP), GUILHERME BADRA (OAB 339677/SP)",
                "PublishDate": "2022-04-05T00:00:00",
                "CaptureDate": "2022-05-27T07:09:18"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0192/2022 DATA DA PUBLICACAO: 06/04/2022 NUMERO DO DIARIO: 3481",
                "PublishDate": "2022-04-05T00:00:00",
                "CaptureDate": "2022-12-26T09:23:49"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0192/2022 TEOR DO ATO: 1) INTIME-SE A PARTE AUTORA PARA QUE SE MANIFESTE EM 15 (QUINZE) DIAS SOBRE AS CONTESTACOES APRESENTADAS. 2) NO MESMO PRAZO DE 15 (QUINZE) DIAS, DEVERAO AS PARTES TRAZEREM AOS AUTOS TODAS AS PROVAS DOCUMENTAIS QUE TENHAM INTERESSE EM PRODUZIR (O QUE INCLUI EVENTUAIS MIDIAS COM AUDIOS OU VIDEOS RELACIONADOS AOS FATOS CONTROVERTIDOS), BEM COMO, SE ASSIM DESEJAREM, APRESENTEM ROL DE TESTEMUNHAS, INDICANDO, PRECISAMENTE: (I) O NOME DA TESTEMUNHA; (II) EVENTUAL PARENTESCO COM AS PARTES OU AMIZADE INTIMA; (III) SE PRESENCIOU OS FATOS; (IV) O MOTIVO PELO QUAL ENTENDE QUE A PROVA TESTEMUNHAL E RELEVANTE; (V) SEU ENDERECO DE E-MAIL E SE POSSUI ACESSO A INTERNET E AO APLICATIVO MICROSOFTTEAMS, DE COMPUTADOR PROPRIO (NAO PODENDO SE UTILIZAR DE COMPUTADOR EM LOCAL DE RESIDENCIA DAS PARTES OU ESCRITORIO DO ADVOGADO), COM VIDEO E AUDIO, SENDO CERTO QUE E DE INTEIRA RESPONSABILIDADE DAS PARTES PROVIDENCIAR O NECESSARIO PARA QUE O DEPOIMENTO TESTEMUNHAL SEJA PRODUZIDO, SOB PENA DE SE CONCLUIR PELA PROVA NO SENTIDO CONTRARIO DAQUELA QUE SE PRETENDIA PRODUZIR, ALEM DE EVENTUAL LITIGANCIA DE MA-FE TENDO EM VISTA A SITUACAO DE PANDEMIA DE SARSCOV-2, QUE TRAZ ENORMES PREJUIZOS E RISCOS NA REALIZACAO DE ATOS QUE SE MOSTREM DESNECESSARIOS. AINDA, NA MESMA OPORTUNIDADE, CONSIDERANDO O TEOR DA CONTESTACAO, CONSULTO SE HA POSSIBILIDADE DE ACORDO, CABENDO AS PARTES, SE O CASO, APRESENTAREM AS SUAS PROPOSTAS. A MANIFESTACAO DA PARTE, CASO NAO POSSUA ADVOGADO CONSTITUIDO, DEVERA SER ENCAMINHADA PARA O E-MAIL \"SAOMIGUELJEC@TJSP.JUS.BR. TUDO ISSO SEM PREJUIZO DA ANALISE DAS QUESTOES PENDENTES, E DO JULGAMENTO DO MERITO NO ESTADO, CASO SE ENTENDA DESNECESSARIA A PRODUCAO DE OUTRAS PROVAS. OPORTUNAMENTE, TORNEM CONCLUSOS. ADVOGADOS(S): HAROLDO NUNES (OAB 229548/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP), GUILHERME BADRA (OAB 339677/SP)",
                "PublishDate": "2022-04-04T00:00:00",
                "CaptureDate": "2022-05-27T07:09:18"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0192/2022 TEOR DO ATO: 1) INTIME-SE A PARTE AUTORA PARA QUE SE MANIFESTE EM 15 (QUINZE) DIAS SOBRE AS CONTESTACOES APRESENTADAS. 2) NO MESMO PRAZO DE 15 (QUINZE) DIAS, DEVERAO AS PARTES TRAZEREM AOS AUTOS TODAS AS PROVAS DOCUMENTAIS QUE TENHAM INTERESSE EM PRODUZIR (O QUE INCLUI EVENTUAIS MIDIAS COM AUDIOS OU VIDEOS RELACIONADOS AOS FATOS CONTROVERTIDOS), BEM COMO, SE ASSIM DESEJAREM, APRESENTEM ROL DE TESTEMUNHAS, INDICANDO, PRECISAMENTE: (I) O NOME DA TESTEMUNHA; (II) EVENTUAL PARENTESCO COM AS PARTES OU AMIZADE INTIMA; (III) SE PRESENCIOU OS FATOS; (IV) O MOTIVO PELO QUAL ENTENDE QUE A PROVA TESTEMUNHAL E RELEVANTE; (V) SEU ENDERECO DE E-MAIL E SE POSSUI ACESSO A INTERNET E AO APLICATIVO MICROSOFTTEAMS, DE COMPUTADOR PROPRIO (NAO PODENDO SE UTILIZAR DE COMPUTADOR EM LOCAL DE RESIDENCIA DAS PARTES OU ESCRITORIO DO ADVOGADO), COM VIDEO E AUDIO, SENDO CERTO QUE E DE INTEIRA RESPONSABILIDADE DAS PARTES PROVIDENCIAR O NECESSARIO PARA QUE O DEPOIMENTO TESTEMUNHAL SEJA PRODUZIDO, SOB PENA DE SE CONCLUIR PELA PROVA NO SENTIDO CONTRARIO DAQUELA QUE SE PRETENDIA PRODUZIR, ALEM DE EVENTUAL LITIGANCIA DE MA-FE TENDO EM VISTA A SITUACAO DE PANDEMIA DE SARSCOV-2, QUE TRAZ ENORMES PREJUIZOS E RISCOS NA REALIZACAO DE ATOS QUE SE MOSTREM DESNECESSARIOS. AINDA, NA MESMA OPORTUNIDADE, CONSIDERANDO O TEOR DA CONTESTACAO, CONSULTO SE HA POSSIBILIDADE DE ACORDO, CABENDO AS PARTES, SE O CASO, APRESENTAREM AS SUAS PROPOSTAS. A MANIFESTACAO DA PARTE, CASO NAO POSSUA ADVOGADO CONSTITUIDO, DEVERA SER ENCAMINHADA PARA O E-MAIL \"SAOMIGUELJEC@TJSP.JUS.BR. TUDO ISSO SEM PREJUIZO DA ANALISE DAS QUESTOES PENDENTES, E DO JULGAMENTO DO MERITO NO ESTADO, CASO SE ENTENDA DESNECESSARIA A PRODUCAO DE OUTRAS PROVAS. OPORTUNAMENTE, TORNEM CONCLUSOS. ADVOGADOS(S): HAROLDO NUNES (OAB 229548/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP), GUILHERME BADRA (OAB 339677/SP)",
                "PublishDate": "2022-04-04T00:00:00",
                "CaptureDate": "2022-12-26T09:23:49"
              },
              {
                "Content": "DECISAO | 1) INTIME-SE A PARTE AUTORA PARA QUE SE MANIFESTE EM 15 (QUINZE) DIAS SOBRE AS CONTESTACOES APRESENTADAS. 2) NO MESMO PRAZO DE 15 (QUINZE) DIAS, DEVERAO AS PARTES TRAZEREM AOS AUTOS TODAS AS PROVAS DOCUMENTAIS QUE TENHAM INTERESSE EM PRODUZIR (O QUE INCLUI EVENTUAIS MIDIAS COM AUDIOS OU VIDEOS RELACIONADOS AOS FATOS CONTROVERTIDOS), BEM COMO, SE ASSIM DESEJAREM, APRESENTEM ROL DE TESTEMUNHAS, INDICANDO, PRECISAMENTE: (I) O NOME DA TESTEMUNHA; (II) EVENTUAL PARENTESCO COM AS PARTES OU AMIZADE INTIMA; (III) SE PRESENCIOU OS FATOS; (IV) O MOTIVO PELO QUAL ENTENDE QUE A PROVA TESTEMUNHAL E RELEVANTE; (V) SEU ENDERECO DE E-MAIL E SE POSSUI ACESSO A INTERNET E AO APLICATIVO MICROSOFTTEAMS, DE COMPUTADOR PROPRIO (NAO PODENDO SE UTILIZAR DE COMPUTADOR EM LOCAL DE RESIDENCIA DAS PARTES OU ESCRITORIO DO ADVOGADO), COM VIDEO E AUDIO, SENDO CERTO QUE E DE INTEIRA RESPONSABILIDADE DAS PARTES PROVIDENCIAR O NECESSARIO PARA QUE O DEPOIMENTO TESTEMUNHAL SEJA PRODUZIDO, SOB PENA DE SE CONCLUIR PELA PROVA NO SENTIDO CONTRARIO DAQUELA QUE SE PRETENDIA PRODUZIR, ALEM DE EVENTUAL LITIGANCIA DE MA-FE TENDO EM VISTA A SITUACAO DE PANDEMIA DE SARSCOV-2, QUE TRAZ ENORMES PREJUIZOS E RISCOS NA REALIZACAO DE ATOS QUE SE MOSTREM DESNECESSARIOS. AINDA, NA MESMA OPORTUNIDADE, CONSIDERANDO O TEOR DA CONTESTACAO, CONSULTO SE HA POSSIBILIDADE DE ACORDO, CABENDO AS PARTES, SE O CASO, APRESENTAREM AS SUAS PROPOSTAS. A MANIFESTACAO DA PARTE, CASO NAO POSSUA ADVOGADO CONSTITUIDO, DEVERA SER ENCAMINHADA PARA O E-MAIL \"SAOMIGUELJEC@TJSP.JUS.BR. TUDO ISSO SEM PREJUIZO DA ANALISE DAS QUESTOES PENDENTES, E DO JULGAMENTO DO MERITO NO ESTADO, CASO SE ENTENDA DESNECESSARIA A PRODUCAO DE OUTRAS PROVAS. OPORTUNAMENTE, TORNEM CONCLUSOS.",
                "PublishDate": "2022-04-01T00:00:00",
                "CaptureDate": "2022-05-27T07:09:18"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2022-04-01T00:00:00",
                "CaptureDate": "2022-05-27T07:09:18"
              },
              {
                "Content": "CONTESTACAO JUNTADA | N PROTOCOLO: WSMP.22.70069228-4 TIPO DA PETICAO: CONTESTACAO DATA: 31/03/2022 17:44",
                "PublishDate": "2022-04-01T00:00:00",
                "CaptureDate": "2022-05-27T07:09:18"
              },
              {
                "Content": "CONTESTACAO JUNTADA N PROTOCOLO: WSMP.22.70069228-4 TIPO DA PETICAO: CONTESTACAO DATA: 31/03/2022 17:44",
                "PublishDate": "2022-04-01T00:00:00",
                "CaptureDate": "2022-12-26T09:23:49"
              },
              {
                "Content": "DECISAO 1) INTIME-SE A PARTE AUTORA PARA QUE SE MANIFESTE EM 15 (QUINZE) DIAS SOBRE AS CONTESTACOES APRESENTADAS. 2) NO MESMO PRAZO DE 15 (QUINZE) DIAS, DEVERAO AS PARTES TRAZEREM AOS AUTOS TODAS AS PROVAS DOCUMENTAIS QUE TENHAM INTERESSE EM PRODUZIR (O QUE INCLUI EVENTUAIS MIDIAS COM AUDIOS OU VIDEOS RELACIONADOS AOS FATOS CONTROVERTIDOS), BEM COMO, SE ASSIM DESEJAREM, APRESENTEM ROL DE TESTEMUNHAS, INDICANDO, PRECISAMENTE: (I) O NOME DA TESTEMUNHA; (II) EVENTUAL PARENTESCO COM AS PARTES OU AMIZADE INTIMA; (III) SE PRESENCIOU OS FATOS; (IV) O MOTIVO PELO QUAL ENTENDE QUE A PROVA TESTEMUNHAL E RELEVANTE; (V) SEU ENDERECO DE E-MAIL E SE POSSUI ACESSO A INTERNET E AO APLICATIVO MICROSOFTTEAMS, DE COMPUTADOR PROPRIO (NAO PODENDO SE UTILIZAR DE COMPUTADOR EM LOCAL DE RESIDENCIA DAS PARTES OU ESCRITORIO DO ADVOGADO), COM VIDEO E AUDIO, SENDO CERTO QUE E DE INTEIRA RESPONSABILIDADE DAS PARTES PROVIDENCIAR O NECESSARIO PARA QUE O DEPOIMENTO TESTEMUNHAL SEJA PRODUZIDO, SOB PENA DE SE CONCLUIR PELA PROVA NO SENTIDO CONTRARIO DAQUELA QUE SE PRETENDIA PRODUZIR, ALEM DE EVENTUAL LITIGANCIA DE MA-FE TENDO EM VISTA A SITUACAO DE PANDEMIA DE SARSCOV-2, QUE TRAZ ENORMES PREJUIZOS E RISCOS NA REALIZACAO DE ATOS QUE SE MOSTREM DESNECESSARIOS. AINDA, NA MESMA OPORTUNIDADE, CONSIDERANDO O TEOR DA CONTESTACAO, CONSULTO SE HA POSSIBILIDADE DE ACORDO, CABENDO AS PARTES, SE O CASO, APRESENTAREM AS SUAS PROPOSTAS. A MANIFESTACAO DA PARTE, CASO NAO POSSUA ADVOGADO CONSTITUIDO, DEVERA SER ENCAMINHADA PARA O E-MAIL \"SAOMIGUELJEC@TJSP.JUS.BR. TUDO ISSO SEM PREJUIZO DA ANALISE DAS QUESTOES PENDENTES, E DO JULGAMENTO DO MERITO NO ESTADO, CASO SE ENTENDA DESNECESSARIA A PRODUCAO DE OUTRAS PROVAS. OPORTUNAMENTE, TORNEM CONCLUSOS.",
                "PublishDate": "2022-04-01T00:00:00",
                "CaptureDate": "2022-12-26T09:23:49"
              },
              {
                "Content": "ESPECIFICACAO DE PROVAS JUNTADA | N PROTOCOLO: WSMP.22.70055982-7 TIPO DA PETICAO: INDICACAO DE PROVAS DATA: 17/03/2022 15:57",
                "PublishDate": "2022-03-17T00:00:00",
                "CaptureDate": "2022-05-27T07:09:18"
              },
              {
                "Content": "AR POSITIVO JUNTADO | JUNTADA DE AR : AR383042738TJ SITUACAO : CUMPRIDO MODELO : PROCESSO DIGITAL - CARTA - CITACAO E INTIMACAO - APRESENTAR ACORDO-DEFESA - SEM AUDIENCIA - JUIZADO DESTINATARIO : STARK BANK S.A. DILIGENCIA : 14/03/2022",
                "PublishDate": "2022-03-17T00:00:00",
                "CaptureDate": "2022-05-27T07:09:18"
              },
              {
                "Content": "AR POSITIVO JUNTADO JUNTADA DE AR : AR383042738TJ SITUACAO : CUMPRIDO MODELO : PROCESSO DIGITAL - CARTA - CITACAO E INTIMACAO - APRESENTAR ACORDO-DEFESA - SEM AUDIENCIA - JUIZADO DESTINATARIO : STARK BANK S.A. DILIGENCIA : 14/03/2022",
                "PublishDate": "2022-03-17T00:00:00",
                "CaptureDate": "2022-12-26T09:23:49"
              },
              {
                "Content": "ESPECIFICACAO DE PROVAS JUNTADA N PROTOCOLO: WSMP.22.70055982-7 TIPO DA PETICAO: INDICACAO DE PROVAS DATA: 17/03/2022 15:57",
                "PublishDate": "2022-03-17T00:00:00",
                "CaptureDate": "2022-12-26T09:23:49"
              },
              {
                "Content": "CARTA DE INTIMACAO EXPEDIDA | PROCESSO DIGITAL - CARTA - CITACAO E INTIMACAO - APRESENTAR ACORDO-DEFESA - SEM AUDIENCIA - JUIZADO",
                "PublishDate": "2022-03-08T00:00:00",
                "CaptureDate": "2022-03-15T13:52:18"
              },
              {
                "Content": "CARTA DE INTIMACAO EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO E INTIMACAO - APRESENTAR ACORDO-DEFESA - SEM AUDIENCIA - JUIZADO",
                "PublishDate": "2022-03-08T00:00:00",
                "CaptureDate": "2022-12-26T09:23:49"
              },
              {
                "Content": "PETICAO JUNTADA | N PROTOCOLO: WSMP.22.70044959-2 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 05/03/2022 14:14",
                "PublishDate": "2022-03-05T00:00:00",
                "CaptureDate": "2022-03-15T13:52:18"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WSMP.22.70044959-2 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 05/03/2022 14:14",
                "PublishDate": "2022-03-05T00:00:00",
                "CaptureDate": "2022-12-26T09:23:49"
              },
              {
                "Content": "CONTESTACAO JUNTADA | N PROTOCOLO: WSMP.22.70044795-6 TIPO DA PETICAO: CONTESTACAO DATA: 04/03/2022 19:56",
                "PublishDate": "2022-03-04T00:00:00",
                "CaptureDate": "2022-03-15T13:52:18"
              },
              {
                "Content": "CONTESTACAO JUNTADA N PROTOCOLO: WSMP.22.70044795-6 TIPO DA PETICAO: CONTESTACAO DATA: 04/03/2022 19:56",
                "PublishDate": "2022-03-04T00:00:00",
                "CaptureDate": "2022-12-26T09:23:49"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO: 0095/2022 DATA DA PUBLICACAO: 23/02/2022 NUMERO DO DIARIO: 3453",
                "PublishDate": "2022-02-22T00:00:00",
                "CaptureDate": "2022-03-15T13:52:18"
              },
              {
                "Content": "PROCESSO 1001916-71.2022.8.26.0005 - PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL - INDENIZACAO POR DANO MATERIAL - JEFFERSON BETANIN PORANGABA - ) FORNECA A PARTE AUTORA NOVO ENDERECO DA PARTE RE, ANTE A DEVOLUCAO DO SEED DE PAGINA 35 ,COM OBSERVACAO MUDOU-SE, NO PRAZO DE DEZ ( 10 ) DIAS SOB PENA DE EXTINCAO DO PROCESSO. - ADV: GUILHERME BADRA (OAB 339677/SP)",
                "PublishDate": "2022-02-22T00:00:00",
                "CaptureDate": "2022-03-15T13:52:18"
              },
              {
                "Content": "PROCESSO 1001916-71.2022.8.26.0005 - PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL - INDENIZACAO POR DANO MATERIAL - JEFFERSON BETANIN PORANGABA - ) FORNECA A PARTE AUTORA NOVO ENDERECO DA PARTE RE, ANTE A DEVOLUCAO DO SEED DE PAGINA 35 ,COM OBSERVACAO MUDOU-SE, NO PRAZO DE DEZ ( 10 ) DIAS SOB PENA DE EXTINCAO DO PROCESSO. - ADV: GUILHERME BADRA (OAB 339677/SP)",
                "PublishDate": "2022-02-22T00:00:00",
                "CaptureDate": "2022-03-15T13:52:18"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0095/2022 DATA DA PUBLICACAO: 23/02/2022 NUMERO DO DIARIO: 3453",
                "PublishDate": "2022-02-22T00:00:00",
                "CaptureDate": "2022-12-26T09:23:49"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0095/2022 TEOR DO ATO: ) FORNECA A PARTE AUTORA NOVO ENDERECO DA PARTE RE, ANTE A DEVOLUCAO DO SEED DE PAGINA 35 ,COM OBSERVACAO \"MUDOU-SE\", NO PRAZO DE DEZ ( 10 ) DIAS SOB PENA DE EXTINCAO DO PROCESSO. ADVOGADOS(S): GUILHERME BADRA (OAB 339677/SP)",
                "PublishDate": "2022-02-21T00:00:00",
                "CaptureDate": "2022-03-15T13:52:18"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0095/2022 TEOR DO ATO: ) FORNECA A PARTE AUTORA NOVO ENDERECO DA PARTE RE, ANTE A DEVOLUCAO DO SEED DE PAGINA 35 ,COM OBSERVACAO \"MUDOU-SE\", NO PRAZO DE DEZ ( 10 ) DIAS SOB PENA DE EXTINCAO DO PROCESSO. ADVOGADOS(S): GUILHERME BADRA (OAB 339677/SP)",
                "PublishDate": "2022-02-21T00:00:00",
                "CaptureDate": "2022-12-26T09:23:49"
              },
              {
                "Content": "ATO ORDINATORIO | ) FORNECA A PARTE AUTORA NOVO ENDERECO DA PARTE RE, ANTE A DEVOLUCAO DO SEED DE PAGINA 35 ,COM OBSERVACAO \"MUDOU-SE\", NO PRAZO DE DEZ ( 10 ) DIAS SOB PENA DE EXTINCAO DO PROCESSO.",
                "PublishDate": "2022-02-18T00:00:00",
                "CaptureDate": "2022-03-15T13:52:18"
              },
              {
                "Content": "AR NEGATIVO JUNTADO - MUDOU-SE | JUNTADA DE AR : AA342586806TJ SITUACAO : MUDOU-SE MODELO : PROCESSO DIGITAL - CARTA - CITACAO E INTIMACAO - APRESENTAR ACORDO-DEFESA - SEM AUDIENCIA - JUIZADO DESTINATARIO : STARK BANK S.A.",
                "PublishDate": "2022-02-18T00:00:00",
                "CaptureDate": "2022-03-15T13:52:18"
              },
              {
                "Content": "AR NEGATIVO JUNTADO - MUDOU-SE JUNTADA DE AR : AA342586806TJ SITUACAO : MUDOU-SE MODELO : PROCESSO DIGITAL - CARTA - CITACAO E INTIMACAO - APRESENTAR ACORDO-DEFESA - SEM AUDIENCIA - JUIZADO DESTINATARIO : STARK BANK S.A.",
                "PublishDate": "2022-02-18T00:00:00",
                "CaptureDate": "2022-12-26T09:23:49"
              },
              {
                "Content": "ATO ORDINATORIO ) FORNECA A PARTE AUTORA NOVO ENDERECO DA PARTE RE, ANTE A DEVOLUCAO DO SEED DE PAGINA 35 ,COM OBSERVACAO \"MUDOU-SE\", NO PRAZO DE DEZ ( 10 ) DIAS SOB PENA DE EXTINCAO DO PROCESSO.",
                "PublishDate": "2022-02-18T00:00:00",
                "CaptureDate": "2022-12-26T09:23:49"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA | RELACAO: 0066/2022 DATA DA PUBLICACAO: 10/02/2022 NUMERO DO DIARIO: 3444",
                "PublishDate": "2022-02-09T00:00:00",
                "CaptureDate": "2022-03-15T13:52:18"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0066/2022 DATA DA PUBLICACAO: 10/02/2022 NUMERO DO DIARIO: 3444",
                "PublishDate": "2022-02-09T00:00:00",
                "CaptureDate": "2022-12-26T09:23:49"
              },
              {
                "Content": "CARTA DE INTIMACAO EXPEDIDA | PROCESSO DIGITAL - CARTA - CITACAO E INTIMACAO - APRESENTAR ACORDO-DEFESA - SEM AUDIENCIA - JUIZADO",
                "PublishDate": "2022-02-08T00:00:00",
                "CaptureDate": "2022-03-15T13:52:18"
              },
              {
                "Content": "CARTA DE INTIMACAO EXPEDIDA | PROCESSO DIGITAL - CARTA - CITACAO E INTIMACAO - APRESENTAR ACORDO-DEFESA - SEM AUDIENCIA - JUIZADO",
                "PublishDate": "2022-02-08T00:00:00",
                "CaptureDate": "2022-03-15T13:52:18"
              },
              {
                "Content": "REMETIDO AO DJE | RELACAO: 0066/2022 TEOR DO ATO: VISTOS. NADA NOS AUTOS SUGERE POSSIBILIDADE DE FRUSTRACAO DE EVENTUAL EXECUCAO FUTURA, CASO PROCEDENTE O PEDIDO. AUSENTES OS REQUISITOS LEGAIS, INDEFIRO O PEDIDO DE TUTELA PROVISORIA. INEGAVEL QUE, NO AMBITO DOS PROCEDIMENTOS REGULAMENTADOS POR MEIO DA LEI N 9.099/1995,A CONTESTACAO PODE SER APRESENTADA EM AUDIENCIA DE INSTRUCAO E JULGAMENTO, SENDO NECESSARIAPREVIA REALIZACAO DE AUDIENCIA DE CONCILIACAO. NO ENTANTO,PARA ALEM DA EXISTENCIA, VALIDADE E EFETIVIDADE, AS REGRAS LEGAIS DEVEM SER VOLTADAS A EFETIVIDADE, SENDO QUE, ANTES DE JUIZ, O JULGADOR E CIDADAO E, EXATAMENTE POR ISSO, SE COLOCA NA POSICAO DE SENTIR A VIDA SOCIAL, COMO PARTE E MEMBRO EFETIVO DESSE CORPO DE PESSOAS, EM LICAO TAO DIFUNDIDA PORCALAMANDREI. NAO POR ACASO, HOJE E PACIFICA A NECESSIDADE DE SE ADOTAR ENTENDIMENTOS QUE SEJAM RAZOAVEIS E PASSEM PELAS DIRETRIZES DECORRENTES DA APLICACAO, AO CASO, DA REGRA DA PROPORCIONALIDADE. NESSE SENTIDO, DEVE-SE CONSIDERAR A PANDEMIA DE COVID-19 E, CALCANDO-SE NA PRUDENCIA (ARTIGO 24 DO CODIGO DE ETICA DA MAGISTRATURA), VERIFICA-SE, NO CASO, A NECESSIDADE DE SE TEMPERAR O REGRAMENTO ESPECIFICO QUE DECORRE DO MICROSSISTEMA PROCESSUAL INSTITUIDO PELA LEI N 9.099/1995, A SE EVITAR O COMPARECIMENTO DAS PARTES EM JUIZO QUANDO TAL FOI DESNECESSARIO. A NECESSIDADE DA MEDIDA E PASSIVEL DE SER VERIFICADA PELA DIRETRIZ EXPEDIDA PELA ORGANIZACAO MUNDIAL DA SAUDE PARA QUE SE EVITE AGLOMERACOES DE PESSOAS EM AMBIENTES FECHADOS QUANDO POSSIVEL, EVITANDO-SE, ASSIM, A DISSEMINACAO DO VIRUS CUJA MUTACAO NAO FOI COMPLETAMENTE ENTENDIDA PELA COMUNIDADE CIENTIFICA (A SE VERIFICAR, POIS, A FALTA DE COMPREENSAO SUFICIENTE SOBRE A NATUREZA DO VIRUS E SUA POSSIBILIDADE DE TRANSFORMACAO). MAIS AINDA, COMPREENDE-SE QUE A MEDIDA E NECESSARIA PARA SE APOIAR OS ESFORCOS PELA MITIGACAO DO ALCANCE DE MAIS UMA DOENCA A AMEACAR OS SERES HUMANOS, COM ESPECIAIS EFEITOS SOBRE A POPULACAO MAIS IDOSA. REFERIDA MEDIDA ESTA EM CONSONANCIA COM O PLANO DE CONTINGENCIA NACIONAL PARA INFECCAO HUMANA PELO NOVOCORONAVIRUSCOVID-19 E COM O ESTADO DE EMERGENCIA INTERNACIONAL RECONHECIDO PELO ESTADO BRASILEIRO POR MEIO DO ARTIGO 8 DA LEI N 13.979/2020. MAIS IMPORTANTE, E MEDIDA DE RIGOR, POIS DETERMINADA PELOEGREGIOCONSELHO SUPERIOR DA MAGISTRATURAPOR MEIO DO SEU PROVIMENTO DE NUMERO2.549 DE 2020, BEM COMO PELA COLENDA CORREGEDORIA GERAL DE JUSTICA, POR MEIO DO SEU PROVIMENTO DE NUMERO 09, TAMBEM DE 2020. EM RELACAO A ADEQUACAO, SALIENTE-SE QUEINEXISTE OUTRO MEIO, QUE NAOA EVITACAO DE AUDIENCIAS,QUE POSSA IMPEDIR A TUTELA DAVIDAHUMANA COMA MESMA INTENSIDADE POR OUTRO ATO QUE LIMITE OS PRINCIPIOS QUE DAO AZO A REGULAMENTACAO ESPECIFICA DOS PROCEDIMENTOS PERANTE O JUIZADO ESPECIAL CIVEL (E QUE, EM ULTIMA ANALISE, CINGEM-SE A BUSCA PELA TUTELA JURISDICIONAL EFETIVA), POIS AS TECNOLOGIAS DISPONIVEIS, ATUALMENTE, NAO PERMITEM ENTENDER QUE A REALIZACAO DO ATO JURIDICO POR MEIO AUDIOVISUAL TERIA A EFICACIA NECESSARIA, MORMENTE QUANDO SE VERIFICA QUE O ACESSO A INTERNET, NO BRASIL, AINDA E DEFEITUOSO. OUTROSSIM,A PRESERVACAO DA VIDA PREVALECE SOBRE OS PRINCIPIOS VINCULADOS A TUTELA JURISDICIONAL EFETIVA E, MAIS IMPORTANTE, SEM A SUPRESSAO DA AUDIENCIA NO PRESENTE CASO, A TUTELA JURISDICIONAL ESTARIA IMPEDIDA DE SER PRESTADA. E NESSE SENTIDO QUE,(I)COM FULCRO NO DIREITO FUNDAMENTAL PREVISTO NO ARTIGO 5, INCISO XXXV, DA CONSTITUICAO FEDERAL,E CONSEQUENTE CONCLUSAO DE QUEO PROCESSO NAO PODE SER VISTO COMO UM FIM EM SI MESMO, MAS, AO REVES, DEVE-SE ADAPTAR AS PECULIARIDADESDO DIREITO MATERIAL QUE CLAMA POR TUTELA;(II)E, TAO IMPORTANTE QUANTO, AUTORIZADO PELO LEGISLADOR, ESPECIFICAMENTE EM RELACAO AO PROCEDIMENTO ORA ANALISADO, EM RAZAO DA PREVISAO QUEIMPOE SUA REGENCIA PELOSPRINCIPIOSDA INFORMALIDADE, SIMPLICIDADE, ECONOMIA PROCESSUAL ECELERIDADE (ARTIGO 2 DA LEI N 9.099 DE 1995),(III)HAVENDO IMPOSICAO NESSE SENTIDO QUANDO SE COTEJA O ESTADO DE PANDEMIA ATUALCOMODEVER DE COOPERACAO ENTRE OS ATORES PROCESSUAISPARA A OBTENCAO DE DECISAO EM TEMPO RAZOAVEL,TUDO COM FULCRO NA BOA-FE OBJETIVA (ARTIGOS5 E 6 DO CODIGO DE PROCESSO CIVIL)E NA BUSCA POR SE ATINGIR O ESCOPO SOCIAL DA JURISDICAO (PACIFICACAO SOCIAL),DETERMINO A CITACAO DA PARTE REPARA QUE APRESENTECONTESTACAONO PRAZO DE 15 DIAS,A QUAL DEVE SERACOMPANHADA DE TODAS AS PROVAS DOCUMENTAIS (O QUE INCLUI EVENTUAIS MIDIAS COM AUDIOS OU VIDEOS RELACIONADOS AOS FATOS CONTROVERTIDOS) QUE ENTENDER NECESSARIAS AO JULGAMENTO DA LIDE, DEVENDO, A PECA DEFENSIVA, SER ACOMPANHADA POR EVENTUAL PROPOSTA DE ACORDO QUE SE JULGUE ADEQUADA AO CASO (A QUAL NAO SERVIRA, DE NENHUMA FORMA, COMO MEIO DE SE CONDICIONAR O JULGAMENTO DA LIDE EM CASO DE NAO ACEITACAO DA PROPOSTA DE ACORDO PELO AUTOR). INTIMEM-SE. CITE-SE. CUMPRAM-SE. SAO PAULO, 07 DE FEVEREIRO DE 2022. ADVOGADOS(S): GUILHERME BADRA (OAB 339677/SP)",
                "PublishDate": "2022-02-08T00:00:00",
                "CaptureDate": "2022-03-15T13:52:18"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0066/2022 TEOR DO ATO: VISTOS. NADA NOS AUTOS SUGERE POSSIBILIDADE DE FRUSTRACAO DE EVENTUAL EXECUCAO FUTURA, CASO PROCEDENTE O PEDIDO. AUSENTES OS REQUISITOS LEGAIS, INDEFIRO O PEDIDO DE TUTELA PROVISORIA. INEGAVEL QUE, NO AMBITO DOS PROCEDIMENTOS REGULAMENTADOS POR MEIO DA LEI N 9.099/1995,A CONTESTACAO PODE SER APRESENTADA EM AUDIENCIA DE INSTRUCAO E JULGAMENTO, SENDO NECESSARIAPREVIA REALIZACAO DE AUDIENCIA DE CONCILIACAO. NO ENTANTO,PARA ALEM DA EXISTENCIA, VALIDADE E EFETIVIDADE, AS REGRAS LEGAIS DEVEM SER VOLTADAS A EFETIVIDADE, SENDO QUE, ANTES DE JUIZ, O JULGADOR E CIDADAO E, EXATAMENTE POR ISSO, SE COLOCA NA POSICAO DE SENTIR A VIDA SOCIAL, COMO PARTE E MEMBRO EFETIVO DESSE CORPO DE PESSOAS, EM LICAO TAO DIFUNDIDA PORCALAMANDREI. NAO POR ACASO, HOJE E PACIFICA A NECESSIDADE DE SE ADOTAR ENTENDIMENTOS QUE SEJAM RAZOAVEIS E PASSEM PELAS DIRETRIZES DECORRENTES DA APLICACAO, AO CASO, DA REGRA DA PROPORCIONALIDADE. NESSE SENTIDO, DEVE-SE CONSIDERAR A PANDEMIA DE COVID-19 E, CALCANDO-SE NA PRUDENCIA (ARTIGO 24 DO CODIGO DE ETICA DA MAGISTRATURA), VERIFICA-SE, NO CASO, A NECESSIDADE DE SE TEMPERAR O REGRAMENTO ESPECIFICO QUE DECORRE DO MICROSSISTEMA PROCESSUAL INSTITUIDO PELA LEI N 9.099/1995, A SE EVITAR O COMPARECIMENTO DAS PARTES EM JUIZO QUANDO TAL FOI DESNECESSARIO. A NECESSIDADE DA MEDIDA E PASSIVEL DE SER VERIFICADA PELA DIRETRIZ EXPEDIDA PELA ORGANIZACAO MUNDIAL DA SAUDE PARA QUE SE EVITE AGLOMERACOES DE PESSOAS EM AMBIENTES FECHADOS QUANDO POSSIVEL, EVITANDO-SE, ASSIM, A DISSEMINACAO DO VIRUS CUJA MUTACAO NAO FOI COMPLETAMENTE ENTENDIDA PELA COMUNIDADE CIENTIFICA (A SE VERIFICAR, POIS, A FALTA DE COMPREENSAO SUFICIENTE SOBRE A NATUREZA DO VIRUS E SUA POSSIBILIDADE DE TRANSFORMACAO). MAIS AINDA, COMPREENDE-SE QUE A MEDIDA E NECESSARIA PARA SE APOIAR OS ESFORCOS PELA MITIGACAO DO ALCANCE DE MAIS UMA DOENCA A AMEACAR OS SERES HUMANOS, COM ESPECIAIS EFEITOS SOBRE A POPULACAO MAIS IDOSA. REFERIDA MEDIDA ESTA EM CONSONANCIA COM O PLANO DE CONTINGENCIA NACIONAL PARA INFECCAO HUMANA PELO NOVOCORONAVIRUSCOVID-19 E COM O ESTADO DE EMERGENCIA INTERNACIONAL RECONHECIDO PELO ESTADO BRASILEIRO POR MEIO DO ARTIGO 8 DA LEI N 13.979/2020. MAIS IMPORTANTE, E MEDIDA DE RIGOR, POIS DETERMINADA PELOEGREGIOCONSELHO SUPERIOR DA MAGISTRATURAPOR MEIO DO SEU PROVIMENTO DE NUMERO2.549 DE 2020, BEM COMO PELA COLENDA CORREGEDORIA GERAL DE JUSTICA, POR MEIO DO SEU PROVIMENTO DE NUMERO 09, TAMBEM DE 2020. EM RELACAO A ADEQUACAO, SALIENTE-SE QUEINEXISTE OUTRO MEIO, QUE NAOA EVITACAO DE AUDIENCIAS,QUE POSSA IMPEDIR A TUTELA DAVIDAHUMANA COMA MESMA INTENSIDADE POR OUTRO ATO QUE LIMITE OS PRINCIPIOS QUE DAO AZO A REGULAMENTACAO ESPECIFICA DOS PROCEDIMENTOS PERANTE O JUIZADO ESPECIAL CIVEL (E QUE, EM ULTIMA ANALISE, CINGEM-SE A BUSCA PELA TUTELA JURISDICIONAL EFETIVA), POIS AS TECNOLOGIAS DISPONIVEIS, ATUALMENTE, NAO PERMITEM ENTENDER QUE A REALIZACAO DO ATO JURIDICO POR MEIO AUDIOVISUAL TERIA A EFICACIA NECESSARIA, MORMENTE QUANDO SE VERIFICA QUE O ACESSO A INTERNET, NO BRASIL, AINDA E DEFEITUOSO. OUTROSSIM,A PRESERVACAO DA VIDA PREVALECE SOBRE OS PRINCIPIOS VINCULADOS A TUTELA JURISDICIONAL EFETIVA E, MAIS IMPORTANTE, SEM A SUPRESSAO DA AUDIENCIA NO PRESENTE CASO, A TUTELA JURISDICIONAL ESTARIA IMPEDIDA DE SER PRESTADA. E NESSE SENTIDO QUE,(I)COM FULCRO NO DIREITO FUNDAMENTAL PREVISTO NO ARTIGO 5, INCISO XXXV, DA CONSTITUICAO FEDERAL,E CONSEQUENTE CONCLUSAO DE QUEO PROCESSO NAO PODE SER VISTO COMO UM FIM EM SI MESMO, MAS, AO REVES, DEVE-SE ADAPTAR AS PECULIARIDADESDO DIREITO MATERIAL QUE CLAMA POR TUTELA;(II)E, TAO IMPORTANTE QUANTO, AUTORIZADO PELO LEGISLADOR, ESPECIFICAMENTE EM RELACAO AO PROCEDIMENTO ORA ANALISADO, EM RAZAO DA PREVISAO QUEIMPOE SUA REGENCIA PELOSPRINCIPIOSDA INFORMALIDADE, SIMPLICIDADE, ECONOMIA PROCESSUAL ECELERIDADE (ARTIGO 2 DA LEI N 9.099 DE 1995),(III)HAVENDO IMPOSICAO NESSE SENTIDO QUANDO SE COTEJA O ESTADO DE PANDEMIA ATUALCOMODEVER DE COOPERACAO ENTRE OS ATORES PROCESSUAISPARA A OBTENCAO DE DECISAO EM TEMPO RAZOAVEL,TUDO COM FULCRO NA BOA-FE OBJETIVA (ARTIGOS5 E 6 DO CODIGO DE PROCESSO CIVIL)E NA BUSCA POR SE ATINGIR O ESCOPO SOCIAL DA JURISDICAO (PACIFICACAO SOCIAL),DETERMINO A CITACAO DA PARTE REPARA QUE APRESENTECONTESTACAONO PRAZO DE 15 DIAS,A QUAL DEVE SERACOMPANHADA DE TODAS AS PROVAS DOCUMENTAIS (O QUE INCLUI EVENTUAIS MIDIAS COM AUDIOS OU VIDEOS RELACIONADOS AOS FATOS CONTROVERTIDOS) QUE ENTENDER NECESSARIAS AO JULGAMENTO DA LIDE, DEVENDO, A PECA DEFENSIVA, SER ACOMPANHADA POR EVENTUAL PROPOSTA DE ACORDO QUE SE JULGUE ADEQUADA AO CASO (A QUAL NAO SERVIRA, DE NENHUMA FORMA, COMO MEIO DE SE CONDICIONAR O JULGAMENTO DA LIDE EM CASO DE NAO ACEITACAO DA PROPOSTA DE ACORDO PELO AUTOR). INTIMEM-SE. CITE-SE. CUMPRAM-SE. SAO PAULO, 07 DE FEVEREIRO DE 2022. ADVOGADOS(S): GUILHERME BADRA (OAB 339677/SP)",
                "PublishDate": "2022-02-08T00:00:00",
                "CaptureDate": "2022-12-26T09:23:49"
              },
              {
                "Content": "CARTA DE INTIMACAO EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO E INTIMACAO - APRESENTAR ACORDO-DEFESA - SEM AUDIENCIA - JUIZADO",
                "PublishDate": "2022-02-08T00:00:00",
                "CaptureDate": "2022-12-26T09:23:49"
              },
              {
                "Content": "CARTA DE INTIMACAO EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO E INTIMACAO - APRESENTAR ACORDO-DEFESA - SEM AUDIENCIA - JUIZADO",
                "PublishDate": "2022-02-08T00:00:00",
                "CaptureDate": "2022-12-26T09:23:49"
              },
              {
                "Content": "DECISAO | VISTOS. NADA NOS AUTOS SUGERE POSSIBILIDADE DE FRUSTRACAO DE EVENTUAL EXECUCAO FUTURA, CASO PROCEDENTE O PEDIDO. AUSENTES OS REQUISITOS LEGAIS, INDEFIRO O PEDIDO DE TUTELA PROVISORIA. INEGAVEL QUE, NO AMBITO DOS PROCEDIMENTOS REGULAMENTADOS POR MEIO DA LEI N 9.099/1995,A CONTESTACAO PODE SER APRESENTADA EM AUDIENCIA DE INSTRUCAO E JULGAMENTO, SENDO NECESSARIAPREVIA REALIZACAO DE AUDIENCIA DE CONCILIACAO. NO ENTANTO,PARA ALEM DA EXISTENCIA, VALIDADE E EFETIVIDADE, AS REGRAS LEGAIS DEVEM SER VOLTADAS A EFETIVIDADE, SENDO QUE, ANTES DE JUIZ, O JULGADOR E CIDADAO E, EXATAMENTE POR ISSO, SE COLOCA NA POSICAO DE SENTIR A VIDA SOCIAL, COMO PARTE E MEMBRO EFETIVO DESSE CORPO DE PESSOAS, EM LICAO TAO DIFUNDIDA PORCALAMANDREI. NAO POR ACASO, HOJE E PACIFICA A NECESSIDADE DE SE ADOTAR ENTENDIMENTOS QUE SEJAM RAZOAVEIS E PASSEM PELAS DIRETRIZES DECORRENTES DA APLICACAO, AO CASO, DA REGRA DA PROPORCIONALIDADE. NESSE SENTIDO, DEVE-SE CONSIDERAR A PANDEMIA DE COVID-19 E, CALCANDO-SE NA PRUDENCIA (ARTIGO 24 DO CODIGO DE ETICA DA MAGISTRATURA), VERIFICA-SE, NO CASO, A NECESSIDADE DE SE TEMPERAR O REGRAMENTO ESPECIFICO QUE DECORRE DO MICROSSISTEMA PROCESSUAL INSTITUIDO PELA LEI N 9.099/1995, A SE EVITAR O COMPARECIMENTO DAS PARTES EM JUIZO QUANDO TAL FOI DESNECESSARIO. A NECESSIDADE DA MEDIDA E PASSIVEL DE SER VERIFICADA PELA DIRETRIZ EXPEDIDA PELA ORGANIZACAO MUNDIAL DA SAUDE PARA QUE SE EVITE AGLOMERACOES DE PESSOAS EM AMBIENTES FECHADOS QUANDO POSSIVEL, EVITANDO-SE, ASSIM, A DISSEMINACAO DO VIRUS CUJA MUTACAO NAO FOI COMPLETAMENTE ENTENDIDA PELA COMUNIDADE CIENTIFICA (A SE VERIFICAR, POIS, A FALTA DE COMPREENSAO SUFICIENTE SOBRE A NATUREZA DO VIRUS E SUA POSSIBILIDADE DE TRANSFORMACAO). MAIS AINDA, COMPREENDE-SE QUE A MEDIDA E NECESSARIA PARA SE APOIAR OS ESFORCOS PELA MITIGACAO DO ALCANCE DE MAIS UMA DOENCA A AMEACAR OS SERES HUMANOS, COM ESPECIAIS EFEITOS SOBRE A POPULACAO MAIS IDOSA. REFERIDA MEDIDA ESTA EM CONSONANCIA COM O PLANO DE CONTINGENCIA NACIONAL PARA INFECCAO HUMANA PELO NOVOCORONAVIRUSCOVID-19 E COM O ESTADO DE EMERGENCIA INTERNACIONAL RECONHECIDO PELO ESTADO BRASILEIRO POR MEIO DO ARTIGO 8 DA LEI N 13.979/2020. MAIS IMPORTANTE, E MEDIDA DE RIGOR, POIS DETERMINADA PELOEGREGIOCONSELHO SUPERIOR DA MAGISTRATURAPOR MEIO DO SEU PROVIMENTO DE NUMERO2.549 DE 2020, BEM COMO PELA COLENDA CORREGEDORIA GERAL DE JUSTICA, POR MEIO DO SEU PROVIMENTO DE NUMERO 09, TAMBEM DE 2020. EM RELACAO A ADEQUACAO, SALIENTE-SE QUEINEXISTE OUTRO MEIO, QUE NAOA EVITACAO DE AUDIENCIAS,QUE POSSA IMPEDIR A TUTELA DAVIDAHUMANA COMA MESMA INTENSIDADE POR OUTRO ATO QUE LIMITE OS PRINCIPIOS QUE DAO AZO A REGULAMENTACAO ESPECIFICA DOS PROCEDIMENTOS PERANTE O JUIZADO ESPECIAL CIVEL (E QUE, EM ULTIMA ANALISE, CINGEM-SE A BUSCA PELA TUTELA JURISDICIONAL EFETIVA), POIS AS TECNOLOGIAS DISPONIVEIS, ATUALMENTE, NAO PERMITEM ENTENDER QUE A REALIZACAO DO ATO JURIDICO POR MEIO AUDIOVISUAL TERIA A EFICACIA NECESSARIA, MORMENTE QUANDO SE VERIFICA QUE O ACESSO A INTERNET, NO BRASIL, AINDA E DEFEITUOSO. OUTROSSIM,A PRESERVACAO DA VIDA PREVALECE SOBRE OS PRINCIPIOS VINCULADOS A TUTELA JURISDICIONAL EFETIVA E, MAIS IMPORTANTE, SEM A SUPRESSAO DA AUDIENCIA NO PRESENTE CASO, A TUTELA JURISDICIONAL ESTARIA IMPEDIDA DE SER PRESTADA. E NESSE SENTIDO QUE,(I)COM FULCRO NO DIREITO FUNDAMENTAL PREVISTO NO ARTIGO 5, INCISO XXXV, DA CONSTITUICAO FEDERAL,E CONSEQUENTE CONCLUSAO DE QUEO PROCESSO NAO PODE SER VISTO COMO UM FIM EM SI MESMO, MAS, AO REVES, DEVE-SE ADAPTAR AS PECULIARIDADESDO DIREITO MATERIAL QUE CLAMA POR TUTELA;(II)E, TAO IMPORTANTE QUANTO, AUTORIZADO PELO LEGISLADOR, ESPECIFICAMENTE EM RELACAO AO PROCEDIMENTO ORA ANALISADO, EM RAZAO DA PREVISAO QUEIMPOE SUA REGENCIA PELOSPRINCIPIOSDA INFORMALIDADE, SIMPLICIDADE, ECONOMIA PROCESSUAL ECELERIDADE (ARTIGO 2 DA LEI N 9.099 DE 1995),(III)HAVENDO IMPOSICAO NESSE SENTIDO QUANDO SE COTEJA O ESTADO DE PANDEMIA ATUALCOMODEVER DE COOPERACAO ENTRE OS ATORES PROCESSUAISPARA A OBTENCAO DE DECISAO EM TEMPO RAZOAVEL,TUDO COM FULCRO NA BOA-FE OBJETIVA (ARTIGOS5 E 6 DO CODIGO DE PROCESSO CIVIL)E NA BUSCA POR SE ATINGIR O ESCOPO SOCIAL DA JURISDICAO (PACIFICACAO SOCIAL),DETERMINO A CITACAO DA PARTE REPARA QUE APRESENTECONTESTACAONO PRAZO DE 15 DIAS,A QUAL DEVE SERACOMPANHADA DE TODAS AS PROVAS DOCUMENTAIS (O QUE INCLUI EVENTUAIS MIDIAS COM AUDIOS OU VIDEOS RELACIONADOS AOS FATOS CONTROVERTIDOS) QUE ENTENDER NECESSARIAS AO JULGAMENTO DA LIDE, DEVENDO, A PECA DEFENSIVA, SER ACOMPANHADA POR EVENTUAL PROPOSTA DE ACORDO QUE SE JULGUE ADEQUADA AO CASO (A QUAL NAO SERVIRA, DE NENHUMA FORMA, COMO MEIO DE SE CONDICIONAR O JULGAMENTO DA LIDE EM CASO DE NAO ACEITACAO DA PROPOSTA DE ACORDO PELO AUTOR). INTIMEM-SE. CITE-SE. CUMPRAM-SE. SAO PAULO, 07 DE FEVEREIRO DE 2022.",
                "PublishDate": "2022-02-07T00:00:00",
                "CaptureDate": "2022-03-15T13:52:18"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2022-02-07T00:00:00",
                "CaptureDate": "2022-03-15T13:52:18"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2022-02-07T00:00:00",
                "CaptureDate": "2022-12-26T09:23:49"
              },
              {
                "Content": "DECISAO VISTOS. NADA NOS AUTOS SUGERE POSSIBILIDADE DE FRUSTRACAO DE EVENTUAL EXECUCAO FUTURA, CASO PROCEDENTE O PEDIDO. AUSENTES OS REQUISITOS LEGAIS, INDEFIRO O PEDIDO DE TUTELA PROVISORIA. INEGAVEL QUE, NO AMBITO DOS PROCEDIMENTOS REGULAMENTADOS POR MEIO DA LEI N 9.099/1995,A CONTESTACAO PODE SER APRESENTADA EM AUDIENCIA DE INSTRUCAO E JULGAMENTO, SENDO NECESSARIAPREVIA REALIZACAO DE AUDIENCIA DE CONCILIACAO. NO ENTANTO,PARA ALEM DA EXISTENCIA, VALIDADE E EFETIVIDADE, AS REGRAS LEGAIS DEVEM SER VOLTADAS A EFETIVIDADE, SENDO QUE, ANTES DE JUIZ, O JULGADOR E CIDADAO E, EXATAMENTE POR ISSO, SE COLOCA NA POSICAO DE SENTIR A VIDA SOCIAL, COMO PARTE E MEMBRO EFETIVO DESSE CORPO DE PESSOAS, EM LICAO TAO DIFUNDIDA PORCALAMANDREI. NAO POR ACASO, HOJE E PACIFICA A NECESSIDADE DE SE ADOTAR ENTENDIMENTOS QUE SEJAM RAZOAVEIS E PASSEM PELAS DIRETRIZES DECORRENTES DA APLICACAO, AO CASO, DA REGRA DA PROPORCIONALIDADE. NESSE SENTIDO, DEVE-SE CONSIDERAR A PANDEMIA DE COVID-19 E, CALCANDO-SE NA PRUDENCIA (ARTIGO 24 DO CODIGO DE ETICA DA MAGISTRATURA), VERIFICA-SE, NO CASO, A NECESSIDADE DE SE TEMPERAR O REGRAMENTO ESPECIFICO QUE DECORRE DO MICROSSISTEMA PROCESSUAL INSTITUIDO PELA LEI N 9.099/1995, A SE EVITAR O COMPARECIMENTO DAS PARTES EM JUIZO QUANDO TAL FOI DESNECESSARIO. A NECESSIDADE DA MEDIDA E PASSIVEL DE SER VERIFICADA PELA DIRETRIZ EXPEDIDA PELA ORGANIZACAO MUNDIAL DA SAUDE PARA QUE SE EVITE AGLOMERACOES DE PESSOAS EM AMBIENTES FECHADOS QUANDO POSSIVEL, EVITANDO-SE, ASSIM, A DISSEMINACAO DO VIRUS CUJA MUTACAO NAO FOI COMPLETAMENTE ENTENDIDA PELA COMUNIDADE CIENTIFICA (A SE VERIFICAR, POIS, A FALTA DE COMPREENSAO SUFICIENTE SOBRE A NATUREZA DO VIRUS E SUA POSSIBILIDADE DE TRANSFORMACAO). MAIS AINDA, COMPREENDE-SE QUE A MEDIDA E NECESSARIA PARA SE APOIAR OS ESFORCOS PELA MITIGACAO DO ALCANCE DE MAIS UMA DOENCA A AMEACAR OS SERES HUMANOS, COM ESPECIAIS EFEITOS SOBRE A POPULACAO MAIS IDOSA. REFERIDA MEDIDA ESTA EM CONSONANCIA COM O PLANO DE CONTINGENCIA NACIONAL PARA INFECCAO HUMANA PELO NOVOCORONAVIRUSCOVID-19 E COM O ESTADO DE EMERGENCIA INTERNACIONAL RECONHECIDO PELO ESTADO BRASILEIRO POR MEIO DO ARTIGO 8 DA LEI N 13.979/2020. MAIS IMPORTANTE, E MEDIDA DE RIGOR, POIS DETERMINADA PELOEGREGIOCONSELHO SUPERIOR DA MAGISTRATURAPOR MEIO DO SEU PROVIMENTO DE NUMERO2.549 DE 2020, BEM COMO PELA COLENDA CORREGEDORIA GERAL DE JUSTICA, POR MEIO DO SEU PROVIMENTO DE NUMERO 09, TAMBEM DE 2020. EM RELACAO A ADEQUACAO, SALIENTE-SE QUEINEXISTE OUTRO MEIO, QUE NAOA EVITACAO DE AUDIENCIAS,QUE POSSA IMPEDIR A TUTELA DAVIDAHUMANA COMA MESMA INTENSIDADE POR OUTRO ATO QUE LIMITE OS PRINCIPIOS QUE DAO AZO A REGULAMENTACAO ESPECIFICA DOS PROCEDIMENTOS PERANTE O JUIZADO ESPECIAL CIVEL (E QUE, EM ULTIMA ANALISE, CINGEM-SE A BUSCA PELA TUTELA JURISDICIONAL EFETIVA), POIS AS TECNOLOGIAS DISPONIVEIS, ATUALMENTE, NAO PERMITEM ENTENDER QUE A REALIZACAO DO ATO JURIDICO POR MEIO AUDIOVISUAL TERIA A EFICACIA NECESSARIA, MORMENTE QUANDO SE VERIFICA QUE O ACESSO A INTERNET, NO BRASIL, AINDA E DEFEITUOSO. OUTROSSIM,A PRESERVACAO DA VIDA PREVALECE SOBRE OS PRINCIPIOS VINCULADOS A TUTELA JURISDICIONAL EFETIVA E, MAIS IMPORTANTE, SEM A SUPRESSAO DA AUDIENCIA NO PRESENTE CASO, A TUTELA JURISDICIONAL ESTARIA IMPEDIDA DE SER PRESTADA. E NESSE SENTIDO QUE,(I)COM FULCRO NO DIREITO FUNDAMENTAL PREVISTO NO ARTIGO 5, INCISO XXXV, DA CONSTITUICAO FEDERAL,E CONSEQUENTE CONCLUSAO DE QUEO PROCESSO NAO PODE SER VISTO COMO UM FIM EM SI MESMO, MAS, AO REVES, DEVE-SE ADAPTAR AS PECULIARIDADESDO DIREITO MATERIAL QUE CLAMA POR TUTELA;(II)E, TAO IMPORTANTE QUANTO, AUTORIZADO PELO LEGISLADOR, ESPECIFICAMENTE EM RELACAO AO PROCEDIMENTO ORA ANALISADO, EM RAZAO DA PREVISAO QUEIMPOE SUA REGENCIA PELOSPRINCIPIOSDA INFORMALIDADE, SIMPLICIDADE, ECONOMIA PROCESSUAL ECELERIDADE (ARTIGO 2 DA LEI N 9.099 DE 1995),(III)HAVENDO IMPOSICAO NESSE SENTIDO QUANDO SE COTEJA O ESTADO DE PANDEMIA ATUALCOMODEVER DE COOPERACAO ENTRE OS ATORES PROCESSUAISPARA A OBTENCAO DE DECISAO EM TEMPO RAZOAVEL,TUDO COM FULCRO NA BOA-FE OBJETIVA (ARTIGOS5 E 6 DO CODIGO DE PROCESSO CIVIL)E NA BUSCA POR SE ATINGIR O ESCOPO SOCIAL DA JURISDICAO (PACIFICACAO SOCIAL),DETERMINO A CITACAO DA PARTE REPARA QUE APRESENTECONTESTACAONO PRAZO DE 15 DIAS,A QUAL DEVE SERACOMPANHADA DE TODAS AS PROVAS DOCUMENTAIS (O QUE INCLUI EVENTUAIS MIDIAS COM AUDIOS OU VIDEOS RELACIONADOS AOS FATOS CONTROVERTIDOS) QUE ENTENDER NECESSARIAS AO JULGAMENTO DA LIDE, DEVENDO, A PECA DEFENSIVA, SER ACOMPANHADA POR EVENTUAL PROPOSTA DE ACORDO QUE SE JULGUE ADEQUADA AO CASO (A QUAL NAO SERVIRA, DE NENHUMA FORMA, COMO MEIO DE SE CONDICIONAR O JULGAMENTO DA LIDE EM CASO DE NAO ACEITACAO DA PROPOSTA DE ACORDO PELO AUTOR). INTIMEM-SE. CITE-SE. CUMPRAM-SE. SAO PAULO, 07 DE FEVEREIRO DE 2022.",
                "PublishDate": "2022-02-07T00:00:00",
                "CaptureDate": "2022-12-26T09:23:49"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2022-02-04T00:00:00",
                "CaptureDate": "2022-03-15T13:52:18"
              }
            ],
            "Petitions": [
              {
                "Type": "CONTESTACAO",
                "Author": "",
                "CreationDate": "2022-03-04T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2022-03-05T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "INDICACAO DE PROVAS",
                "Author": "",
                "CreationDate": "2022-03-17T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "CONTESTACAO",
                "Author": "",
                "CreationDate": "2022-03-31T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2022-04-26T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2022-04-28T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "MANIFESTACAO SOBRE A CONTESTACAO",
                "Author": "",
                "CreationDate": "2022-05-03T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "MANIFESTACAO SOBRE A CONTESTACAO",
                "Author": "",
                "CreationDate": "2022-05-03T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              }
            ],
            "Decisions": [
              {
                "DecisionContent": "HOMOLOGO O RECONHECIMENTO DA PROCEDENCIA DO PEDIDO DE RESTITUICAO DO VALOR DAS COMPRAS POR PARTE DA CORRE FACI.LY SOLUCOES E TECNOLOGIA LTDA.",
                "DecisionDate": "2022-05-12T00:00:00"
              },
              {
                "DecisionContent": "JULGO IMPROCEDENTES: A) OS PEDIDOS EM FACE DE STARK BANK S/A; E B) O PEDIDO DE INDENIZACAO POR DANOS MORAIS.",
                "DecisionDate": "2022-05-12T00:00:00"
              },
              {
                "DecisionContent": "HOMOLOGO O RECONHECIMENTO DA PROCEDENCIA DO PEDIDO DE RESTITUICAO DO VALOR DAS COMPRAS POR PARTE DA CORRE FACI.LY SOLUCOES E TECNOLOGIA LTDA.",
                "DecisionDate": "2022-05-11T00:00:00"
              },
              {
                "DecisionContent": "JULGO IMPROCEDENTES: A) OS PEDIDOS EM FACE DE STARK BANK S/A; E B) O PEDIDO DE INDENIZACAO POR DANOS MORAIS.",
                "DecisionDate": "2022-05-11T00:00:00"
              },
              {
                "DecisionContent": "HOMOLOGO O RECONHECIMENTO DA PROCEDENCIA DO PEDIDO DE RESTITUICAO DO VALOR DAS COMPRAS POR PARTE DA CORRE FACI.LY SOLUCOES E TECNOLOGIA LTDA.",
                "DecisionDate": "2022-05-11T00:00:00"
              },
              {
                "DecisionContent": "JULGO IMPROCEDENTES: A) OS PEDIDOS EM FACE DE STARK BANK S/A; E B) O PEDIDO DE INDENIZACAO POR DANOS MORAIS.",
                "DecisionDate": "2022-05-11T00:00:00"
              },
              {
                "DecisionContent": "HOMOLOGO O RECONHECIMENTO DA PROCEDENCIA DO PEDIDO DE RESTITUICAO DO VALOR DAS COMPRAS POR PARTE DA CORRE FACI.LY SOLUCOES E TECNOLOGIA LTDA.",
                "DecisionDate": "2022-05-10T00:00:00"
              },
              {
                "DecisionContent": "JULGO IMPROCEDENTES: A) OS PEDIDOS EM FACE DE STARK BANK S/A; E B) O PEDIDO DE INDENIZACAO POR DANOS MORAIS.",
                "DecisionDate": "2022-05-10T00:00:00"
              },
              {
                "DecisionContent": "HOMOLOGO O RECONHECIMENTO DA PROCEDENCIA DO PEDIDO DE RESTITUICAO DO VALOR DAS COMPRAS POR PARTE DA CORRE FACI.LY SOLUCOES E TECNOLOGIA LTDA.",
                "DecisionDate": "2022-05-10T00:00:00"
              },
              {
                "DecisionContent": "JULGO IMPROCEDENTES: A) OS PEDIDOS EM FACE DE STARK BANK S/A; E B) O PEDIDO DE INDENIZACAO POR DANOS MORAIS.",
                "DecisionDate": "2022-05-10T00:00:00"
              }
            ]
          },
          {
            "Number": "10159874020228260050",
            "Type": "REPRESENTACAO CRIMINAL/NOTICIA DE CRIME",
            "MainSubject": "INVASAO DE DISPOSITIVO INFORMATICO",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "ESPECIAL CRIMINAL",
            "CourtDistrict": "SAO PAULO",
            "Judge": "JOSE FERNANDO STEINBERG",
            "JudgingBody": "VARA DO JUIZADO ESPECIAL CRIMINAL",
            "State": "SP",
            "Status": "INDEFINIDO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "INVASÃO DE DISPOSITIVO INFORMÁTICO",
            "InferredCNJSubjectNumber": 11978,
            "InferredCNJProcedureTypeName": "REPRESENTAÇÃO CRIMINAL/NOTÍCIA DE CRIME",
            "InferredBroadCNJSubjectName": "DIREITO PENAL",
            "InferredBroadCNJSubjectNumber": 287,
            "OtherSubjects": [
              "INVASAO DE DISPOSITIVO INFORMATICO"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 2450,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2022-07-26T00:00:00",
            "NoticeDate": "2022-07-18T00:00:00",
            "LastMovementDate": "2022-07-26T00:00:00",
            "CaptureDate": "2022-08-02T11:58:27",
            "LastUpdate": "2022-08-02T11:58:27",
            "NumberOfParties": 5,
            "NumberOfUpdates": 10,
            "LawSuitAge": 590,
            "AverageNumberOfUpdatesPerMonth": 0,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "28955007892",
                "IsPartyActive": true,
                "Name": "JOSE FERNANDO STEINBERG",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "OAB": "208778",
                  "State": "SP",
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2022-08-02T11:58:27"
              },
              {
                "Doc": "39943336870",
                "IsPartyActive": true,
                "Name": "ROGER MENEGHIN SCHAUN",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "QUERELANTE"
                },
                "LastCaptureDate": "2022-08-02T11:58:27"
              },
              {
                "Doc": "76067700859",
                "IsPartyActive": true,
                "Name": "VALDEK MENEGHIN SILVA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "78530",
                  "State": "SP",
                  "SpecificType": "ADVOGADO (QUERELANTE)"
                },
                "LastCaptureDate": "2022-08-02T11:58:27"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "QUERELADO"
                },
                "LastCaptureDate": "2022-08-02T11:58:27"
              },
              {
                "Doc": "35810871000155",
                "IsPartyActive": true,
                "Name": "01 PAGAMENTOS E NEGOCIOS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "QUERELADO"
                },
                "LastCaptureDate": "2022-08-02T11:58:27"
              }
            ],
            "Updates": [
              {
                "Content": "PROCESSO : 1015987-40.2022.8.26.0050 CLASSE : REPRESENTACAO CRIMINAL/NOTICIA DE CRIME QUERELANTE : ROGER MENEGHIN SCHAUN ADVOGADO : 78530/SP - VALDEK MENEGHIN SILVA QUERELADO : STARK BANK S.A. VARA : VARA DO JUIZADO ESPECIAL CRIMINAL",
                "PublishDate": "2022-07-26T00:00:00",
                "CaptureDate": "2022-08-02T11:58:27"
              },
              {
                "Content": "REMETIDOS OS AUTOS PARA O CARTORIO DISTRIBUIDOR LOCAL PARA REDISTRIBUICAO",
                "PublishDate": "2022-07-25T00:00:00",
                "CaptureDate": "2022-08-02T11:58:27"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0321/2022 TEOR DO ATO: CONFORME SE INFERE DE FOLHAS, O CRIME EM QUESTAO NAO E DE MENOR POTENCIAL OFENSIVO. POR ESTA RAZAO, REDISTRIBUA-SE O PRESENTE FEITO A UMA DAS VARAS CRIMINAIS CENTRAIS DA CAPITAL. OBSERVO QUE EVENTUAIS CRIMES CONEXOS SEGUEM A COMPETENCIA DO CRIME MAIS SEVERAMENTE APENADO, CONFORME DISPOE O ARTIGO 60,  UNICO, DA LEI 9.099/95. INTIME-SE. ADVOGADOS(S): VALDEK MENEGHIN SILVA (OAB 78530/SP)",
                "PublishDate": "2022-07-21T00:00:00",
                "CaptureDate": "2022-08-02T11:58:27"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0321/2022 DATA DA PUBLICACAO: 25/07/2022 NUMERO DO DIARIO: 3553",
                "PublishDate": "2022-07-21T00:00:00",
                "CaptureDate": "2022-08-02T11:58:27"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2022-07-20T00:00:00",
                "CaptureDate": "2022-08-02T11:58:27"
              },
              {
                "Content": "DETERMINADA A REDISTRIBUICAO DOS AUTOS CONFORME SE INFERE DE FOLHAS, O CRIME EM QUESTAO NAO E DE MENOR POTENCIAL OFENSIVO. POR ESTA RAZAO, REDISTRIBUA-SE O PRESENTE FEITO A UMA DAS VARAS CRIMINAIS CENTRAIS DA CAPITAL. OBSERVO QUE EVENTUAIS CRIMES CONEXOS SEGUEM A COMPETENCIA DO CRIME MAIS SEVERAMENTE APENADO, CONFORME DISPOE O ARTIGO 60,  UNICO, DA LEI 9.099/95. INTIME-SE.",
                "PublishDate": "2022-07-20T00:00:00",
                "CaptureDate": "2022-08-02T11:58:27"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WBFU.22.70291359-8 TIPO DA PETICAO: MANIFESTACAO DO MP DATA: 19/07/2022 17:32",
                "PublishDate": "2022-07-19T00:00:00",
                "CaptureDate": "2022-08-02T11:58:27"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2022-07-18T00:00:00",
                "CaptureDate": "2022-08-02T11:58:27"
              },
              {
                "Content": "ATO ORDINATORIO - INTIMACAO - PORTAL VISTA AO MINISTERIO PUBLICO.",
                "PublishDate": "2022-07-18T00:00:00",
                "CaptureDate": "2022-08-02T11:58:27"
              },
              {
                "Content": "CERTIDAO DE REMESSA DA INTIMACAO PARA O PORTAL ELETRONICO EXPEDIDA CERTIDAO - REMESSA DA INTIMACAO PARA O PORTAL ELETRONICO",
                "PublishDate": "2022-07-18T00:00:00",
                "CaptureDate": "2022-08-02T11:58:27"
              }
            ],
            "Petitions": [
              {
                "Type": "MANIFESTACAO DO MP",
                "Author": "",
                "CreationDate": "2022-07-19T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              }
            ],
            "Decisions": []
          },
          {
            "Number": "10091864020228260008",
            "Type": "PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL",
            "MainSubject": "INDENIZACAO POR DANO MATERIAL",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "ESPECIAL CIVEL",
            "CourtDistrict": "SAO PAULO",
            "Judge": "ERASMO SAMUEL TOZETTO",
            "JudgingBody": "1 VARA DO JUIZADO ESPECIAL CIVEL",
            "State": "SP",
            "Status": "INDEFINIDO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "INDENIZAÇÃO POR DANO MATERIAL",
            "InferredCNJSubjectNumber": 14009,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO DO JUIZADO ESPECIAL CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO TRABALHO",
            "InferredBroadCNJSubjectNumber": 864,
            "OtherSubjects": [
              "INDENIZACAO POR DANO MATERIAL",
              "INDENIZACAO POR DANO MORAL"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 8550,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2022-07-14T00:00:00",
            "NoticeDate": "2022-07-06T00:00:00",
            "LastMovementDate": "2022-07-14T00:00:00",
            "CaptureDate": "2022-08-02T17:23:14",
            "LastUpdate": "2022-08-02T17:23:14",
            "NumberOfParties": 7,
            "NumberOfUpdates": 19,
            "LawSuitAge": 602,
            "AverageNumberOfUpdatesPerMonth": 0,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "37133894890",
                "IsPartyActive": true,
                "Name": "ERASMO SAMUEL TOZETTO",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "OAB": "319862",
                  "State": "SP",
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2022-08-02T17:23:14"
              },
              {
                "Doc": "39943336870",
                "IsPartyActive": true,
                "Name": "ROGER MENEGHIN SCHAUN",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2022-08-02T17:23:14"
              },
              {
                "Doc": "39943336870",
                "IsPartyActive": true,
                "Name": "ROGER MENEGHIN SCHAUN",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "398921",
                  "State": "SP",
                  "SpecificType": "ADVOGADO (REQTE)"
                },
                "LastCaptureDate": "2022-08-02T17:23:14"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2022-08-02T17:23:14"
              },
              {
                "Doc": "35810871000155",
                "IsPartyActive": true,
                "Name": "01 PAGAMENTOS E NEGOCIOS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2022-08-02T17:23:14"
              },
              {
                "Doc": "35068411817",
                "IsPartyActive": true,
                "Name": "RAFAEL HIDEO NAZIMA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "295443",
                  "State": "SP",
                  "SpecificType": "ADVOGADO (REQDO)"
                },
                "LastCaptureDate": "2022-08-02T17:23:14"
              },
              {
                "Doc": "00298790009",
                "IsPartyActive": true,
                "Name": "GUILHERME KASCHNY BASTIAN",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "266795",
                  "State": "SP",
                  "SpecificType": "ADVOGADO (REQDO)"
                },
                "LastCaptureDate": "2022-08-02T17:23:14"
              }
            ],
            "Updates": [
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0460/2022 DATA DA PUBLICACAO: 15/07/2022 NUMERO DO DIARIO: 3547",
                "PublishDate": "2022-07-14T00:00:00",
                "CaptureDate": "2022-08-02T17:23:14"
              },
              {
                "Content": "PROCESSO 1009186-40.2022.8.26.0008 - PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL - INDENIZACAO POR DANO MATERIAL - ROGER MENEGHIN SCHAUN - STARK BANK S.A. - - 01 PAGAMENTOS E NEGOCIOS LTDA - VISTOS. 1- FLS. 55: POR ORA VERIFICO PERTINENCIA SUBJETIVA PARA MANTER A RE STARK BANK S/A NO POLO PASSIVO, FICANDO INDEFERIDO O PEDIDO DE EXCLUSAO. 2- FLS. 58/59: CONSIDERANDO O DEPOSITO JUDICIAL PELA CORRE, DEFIRO A MANUTENCAO DOS VALORES NOS AUTOS ATE O JULGAMENTO DO FEITO. 3- NO MAIS, AGUARDE-SE A AUDIENCIA DESIGNADA. INT.. - ADV: GUILHERME KASCHNY BASTIAN (OAB 266795/SP), RAFAEL HIDEO NAZIMA (OAB 295443/ SP), ROGER MENEGHIN SCHAUN (OAB 398921/SP)",
                "PublishDate": "2022-07-14T00:00:00",
                "CaptureDate": "2022-08-02T17:23:14"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2022-07-13T00:00:00",
                "CaptureDate": "2022-08-02T17:23:14"
              },
              {
                "Content": "PROFERIDAS OUTRAS DECISOES NAO ESPECIFICADAS VISTOS. 1- FLS. 55: POR ORA VERIFICO PERTINENCIA SUBJETIVA PARA MANTER A RE STARK BANK S/A NO POLO PASSIVO, FICANDO INDEFERIDO O PEDIDO DE EXCLUSAO. 2- FLS. 58/59: CONSIDERANDO O DEPOSITO JUDICIAL PELA CORRE, DEFIRO A MANUTENCAO DOS VALORES NOS AUTOS ATE O JULGAMENTO DO FEITO. 3- NO MAIS, AGUARDE-SE A AUDIENCIA DESIGNADA. INT..",
                "PublishDate": "2022-07-13T00:00:00",
                "CaptureDate": "2022-08-02T17:23:14"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0460/2022 TEOR DO ATO: VISTOS. 1- FLS. 55: POR ORA VERIFICO PERTINENCIA SUBJETIVA PARA MANTER A RE STARK BANK S/A NO POLO PASSIVO, FICANDO INDEFERIDO O PEDIDO DE EXCLUSAO. 2- FLS. 58/59: CONSIDERANDO O DEPOSITO JUDICIAL PELA CORRE, DEFIRO A MANUTENCAO DOS VALORES NOS AUTOS ATE O JULGAMENTO DO FEITO. 3- NO MAIS, AGUARDE-SE A AUDIENCIA DESIGNADA. INT.. ADVOGADOS(S): GUILHERME KASCHNY BASTIAN (OAB 266795/SP), RAFAEL HIDEO NAZIMA (OAB 295443/SP), ROGER MENEGHIN SCHAUN (OAB 398921/SP)",
                "PublishDate": "2022-07-13T00:00:00",
                "CaptureDate": "2022-08-02T17:23:14"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WTAT.22.70121471-8 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 12/07/2022 11:19",
                "PublishDate": "2022-07-12T00:00:00",
                "CaptureDate": "2022-08-02T17:23:14"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WTAT.22.70122011-4 TIPO DA PETICAO: PETICAO INTERMEDIARIA DATA: 12/07/2022 17:08",
                "PublishDate": "2022-07-12T00:00:00",
                "CaptureDate": "2022-08-02T17:23:14"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WTAT.22.70122136-6 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 12/07/2022 18:11",
                "PublishDate": "2022-07-12T00:00:00",
                "CaptureDate": "2022-08-02T17:23:14"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0444/2022 DATA DA PUBLICACAO: 12/07/2022 NUMERO DO DIARIO: 3544",
                "PublishDate": "2022-07-11T00:00:00",
                "CaptureDate": "2022-08-02T17:23:14"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WTAT.22.70120429-1 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 09/07/2022 16:06",
                "PublishDate": "2022-07-09T00:00:00",
                "CaptureDate": "2022-08-02T17:23:14"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0444/2022 TEOR DO ATO: TRATA-SE DE ACAO DE INDENIZACAO POR DANOS MATERIAIS E MORAIS COM PEDIDO DE TUTELA DE URGENCIA PARA BLOQUEIO DE VALORES. O ART. 300 DO CODIGO DE PROCESSO CIVIL ESTABELECE QUE A TUTELA DE URGENCIA SERA CONCEDIDA QUANDO HOUVER ELEMENTOS QUE EVIDENCIEM A PROBABILIDADE DO DIREITO E O PERIGO DE DANO OU O RISCO AO RESULTADO UTIL DO PROCESSO. A NARRATIVA DA INICIAL E OS DOCUMENTOS QUE A ACOMPANHAM DENOTAM FORTES INDICIOS DE FRAUDE PERPETRADA PELA EMPRESA 01 PAGAMENTOS E NEGOCIOS LTDA, COM CONTA NO BANCO STARK BANK SA, CARACTERIZANDO O RISCO DE DILAPIDACAO DE PATRIMONIO QUE AUTORIZA A MEDIDA DE ESTORNO DA TRANSACAO PLEITEADA CONTRA ESTA COMPANHIA. ASSIM, DIANTE DA PRESENCA DOS REQUISITOS DO ART. 300 DO CPC, NOTADAMENTE O RISCO DE A PROBABILIDADE DE DIREITO E RESULTADO UTIL AO PROCESSO, DEFIRO A TUTELA DE URGENCIA E DETERMINO QUE A REQUERIDA STARK BANK PROVIDENCIE O ESTORNO DAS TRANSACOES RETRATADAS NOS DOCUMENTOS DE FLS. 25 E 26, NO VALOR TOTAL DE R$ 2.450,00, NO PRAZO DE 48 HORAS. SERVIRA A PRESENTE, POR COPIA DIGITADA, COMO OFICIO, COMPETINDO AO INTERESSADO, QUANDO REPRESENTADO POR ADVOGADO NOS AUTOS, PROVIDENCIAR A IMPRESSAO E DEVIDO ENCAMINHAMENTO DA PRESENTE, COMPROVANDO NOS AUTOS, NO PRAZO DE DEZ DIAS CORRIDOS. CUMPRA-SE NA FORMA E SOB AS PENAS DA LEI.INT. ADVOGADOS(S): ROGER MENEGHIN SCHAUN (OAB 398921/SP)",
                "PublishDate": "2022-07-08T00:00:00",
                "CaptureDate": "2022-08-02T17:23:14"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0443/2022 DATA DA PUBLICACAO: 11/07/2022 NUMERO DO DIARIO: 3543",
                "PublishDate": "2022-07-08T00:00:00",
                "CaptureDate": "2022-08-02T17:23:14"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WTAT.22.70119970-0 TIPO DA PETICAO: PETICAO INTERMEDIARIA DATA: 08/07/2022 15:15",
                "PublishDate": "2022-07-08T00:00:00",
                "CaptureDate": "2022-08-02T17:23:14"
              },
              {
                "Content": "DESIGNADA AUDIENCIA DE CONCILIACAO CONCILIACAO DATA: 29/09/2022 HORA 13:30 LOCAL: SALA 17 - CONCILIACAO SITUACAO: PENDENTE",
                "PublishDate": "2022-07-07T00:00:00",
                "CaptureDate": "2022-08-02T17:23:14"
              },
              {
                "Content": "ATO ORDINATORIO FICA DESIGNADA AUDIENCIA PRESENCIAL DE CONCILIACAO PARA O DIA 29 DE SETEMBRO DE 2022, AS 13 HORAS E 30 MINUTOS (TERREO SALA 17). FICA O(A) AUTOR(A) INTIMADO POR MEIO DE SEU/SUA ADVOGADO(A), DEVENDO O(A) PATRONO(A) PROVIDENCIAR O COMPARECIMENTO DE SEU CONSTITUINTE, SOB PENA DE EXTINCAO (ART. 51, I, DA LEI 9.099/95), COM A CONDENACAO NAS CUSTAS PROCESSUAIS. CITE-SE O(A) REQUERIDO(A) E INTIME-SE A COMPARECER NA AUDIENCIA, SOB PENA DE SER DECRETADA A REVELIA.",
                "PublishDate": "2022-07-07T00:00:00",
                "CaptureDate": "2022-08-02T17:23:14"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2022-07-07T00:00:00",
                "CaptureDate": "2022-08-02T17:23:14"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0443/2022 TEOR DO ATO: FICA DESIGNADA AUDIENCIA PRESENCIAL DE CONCILIACAO PARA O DIA 29 DE SETEMBRO DE 2022, AS 13 HORAS E 30 MINUTOS (TERREO SALA 17). FICA O(A) AUTOR(A) INTIMADO POR MEIO DE SEU/SUA ADVOGADO(A), DEVENDO O(A) PATRONO(A) PROVIDENCIAR O COMPARECIMENTO DE SEU CONSTITUINTE, SOB PENA DE EXTINCAO (ART. 51, I, DA LEI 9.099/95), COM A CONDENACAO NAS CUSTAS PROCESSUAIS. CITE-SE O(A) REQUERIDO(A) E INTIME-SE A COMPARECER NA AUDIENCIA, SOB PENA DE SER DECRETADA A REVELIA. ADVOGADOS(S): ROGER MENEGHIN SCHAUN (OAB 398921/SP)",
                "PublishDate": "2022-07-07T00:00:00",
                "CaptureDate": "2022-08-02T17:23:14"
              },
              {
                "Content": "CONCEDIDA A ANTECIPACAO DE TUTELA TRATA-SE DE ACAO DE INDENIZACAO POR DANOS MATERIAIS E MORAIS COM PEDIDO DE TUTELA DE URGENCIA PARA BLOQUEIO DE VALORES. O ART. 300 DO CODIGO DE PROCESSO CIVIL ESTABELECE QUE A TUTELA DE URGENCIA SERA CONCEDIDA QUANDO HOUVER ELEMENTOS QUE EVIDENCIEM A PROBABILIDADE DO DIREITO E O PERIGO DE DANO OU O RISCO AO RESULTADO UTIL DO PROCESSO. A NARRATIVA DA INICIAL E OS DOCUMENTOS QUE A ACOMPANHAM DENOTAM FORTES INDICIOS DE FRAUDE PERPETRADA PELA EMPRESA 01 PAGAMENTOS E NEGOCIOS LTDA, COM CONTA NO BANCO STARK BANK SA, CARACTERIZANDO O RISCO DE DILAPIDACAO DE PATRIMONIO QUE AUTORIZA A MEDIDA DE ESTORNO DA TRANSACAO PLEITEADA CONTRA ESTA COMPANHIA. ASSIM, DIANTE DA PRESENCA DOS REQUISITOS DO ART. 300 DO CPC, NOTADAMENTE O RISCO DE A PROBABILIDADE DE DIREITO E RESULTADO UTIL AO PROCESSO, DEFIRO A TUTELA DE URGENCIA E DETERMINO QUE A REQUERIDA STARK BANK PROVIDENCIE O ESTORNO DAS TRANSACOES RETRATADAS NOS DOCUMENTOS DE FLS. 25 E 26, NO VALOR TOTAL DE R$ 2.450,00, NO PRAZO DE 48 HORAS. SERVIRA A PRESENTE, POR COPIA DIGITADA, COMO OFICIO, COMPETINDO AO INTERESSADO, QUANDO REPRESENTADO POR ADVOGADO NOS AUTOS, PROVIDENCIAR A IMPRESSAO E DEVIDO ENCAMINHAMENTO DA PRESENTE, COMPROVANDO NOS AUTOS, NO PRAZO DE DEZ DIAS CORRIDOS. CUMPRA-SE NA FORMA E SOB AS PENAS DA LEI.INT.",
                "PublishDate": "2022-07-07T00:00:00",
                "CaptureDate": "2022-08-02T17:23:14"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2022-07-06T00:00:00",
                "CaptureDate": "2022-08-02T17:23:14"
              }
            ],
            "Petitions": [
              {
                "Type": "PETICAO INTERMEDIARIA",
                "Author": "",
                "CreationDate": "2022-07-08T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2022-07-09T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2022-07-12T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICAO INTERMEDIARIA",
                "Author": "",
                "CreationDate": "2022-07-12T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2022-07-12T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              }
            ],
            "Decisions": [
              {
                "DecisionContent": "DEFIRO A MANUTENCAO DOS VALORES NOS AUTOS ATE O JULGAMENTO DO FEITO.",
                "DecisionDate": "2022-07-14T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO A MANUTENCAO DOS VALORES NOS AUTOS ATE O JULGAMENTO DO FEITO.",
                "DecisionDate": "2022-07-13T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO A MANUTENCAO DOS VALORES NOS AUTOS ATE O JULGAMENTO DO FEITO.",
                "DecisionDate": "2022-07-13T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO A TUTELA DE URGENCIA E DETERMINO QUE A REQUERIDA STARK BANK PROVIDENCIE O ESTORNO DAS TRANSACOES RETRATADAS NOS DOCUMENTOS DE FLS. 25 E 26, NO VALOR TOTAL DE R$ 2.450,00, NO PRAZO DE 48 HORAS.",
                "DecisionDate": "2022-07-08T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO A TUTELA DE URGENCIA E DETERMINO QUE A REQUERIDA STARK BANK PROVIDENCIE O ESTORNO DAS TRANSACOES RETRATADAS NOS DOCUMENTOS DE FLS. 25 E 26, NO VALOR TOTAL DE R$ 2.450,00, NO PRAZO DE 48 HORAS.",
                "DecisionDate": "2022-07-07T00:00:00"
              }
            ]
          },
          {
            "Number": "10251699420228260003",
            "Type": "PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL",
            "MainSubject": "INDENIZACAO POR DANO MORAL",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "ESPECIAL CIVEL",
            "CourtDistrict": "SAO PAULO",
            "Judge": "MARCOS BLANK GONCALVES",
            "JudgingBody": "1 VARA DO JUIZADO ESPECIAL CIVEL",
            "State": "SP",
            "Status": "INDEFINIDO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "INDENIZAÇÃO POR DANO MORAL",
            "InferredCNJSubjectNumber": 14010,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO DO JUIZADO ESPECIAL CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO TRABALHO",
            "InferredBroadCNJSubjectNumber": 864,
            "OtherSubjects": [
              "INDENIZACAO POR DANO MORAL",
              "INDENIZACAO POR DANO MATERIAL"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 29530.38,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2022-11-18T00:00:00",
            "NoticeDate": "2022-11-07T00:00:00",
            "LastMovementDate": "2022-11-18T00:00:00",
            "CaptureDate": "2022-11-19T15:47:50",
            "LastUpdate": "2022-11-19T15:47:50",
            "NumberOfParties": 8,
            "NumberOfUpdates": 11,
            "LawSuitAge": 478,
            "AverageNumberOfUpdatesPerMonth": 0,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "07696862812",
                "IsPartyActive": true,
                "Name": "MARCOS BLANK GONCALVES",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2022-11-19T15:47:50"
              },
              {
                "Doc": "31026687802",
                "IsPartyActive": true,
                "Name": "ROGERIA CRISTINA FURUTANI",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2022-11-19T15:47:50"
              },
              {
                "Doc": "13356065807",
                "IsPartyActive": true,
                "Name": "CLAUDIA KAZUMI OYAKAWA",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2022-11-19T15:47:50"
              },
              {
                "Doc": "33746424895",
                "IsPartyActive": true,
                "Name": "RENAN NOGUEIRA FARAH",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "274183",
                  "State": "SP",
                  "SpecificType": "ADVOGADO (REQTE)"
                },
                "LastCaptureDate": "2022-11-19T15:47:50"
              },
              {
                "Doc": "00000000000191",
                "IsPartyActive": true,
                "Name": "BANCO DO BRASIL S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2022-11-19T15:47:50"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2022-11-19T15:47:50"
              },
              {
                "IsPartyActive": true,
                "Name": "BEPAY INSTITUICAO DE PAGAMENTO S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2022-11-19T15:47:50"
              },
              {
                "Doc": "13140088000199",
                "IsPartyActive": true,
                "Name": "ACESSO SOLUCOES DE PAGAMENTO LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2022-11-19T15:47:50"
              }
            ],
            "Updates": [
              {
                "Content": "PROCESSO : 1025169-94.2022.8.26.0003 CLASSE : PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL REQTE : ROGERIA CRISTINA FURUTANI ADVOGADO : 274183/SP - RENAN NOGUEIRA FARAH REQDO : BANCO DO BRASIL S/A VARA : 1 VARA DO JUIZADO ESPECIAL CIVEL",
                "PublishDate": "2022-11-18T00:00:00",
                "CaptureDate": "2022-11-19T15:47:50"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0733/2022 DATA DA PUBLICACAO: 16/11/2022 NUMERO DO DIARIO: 3629",
                "PublishDate": "2022-11-11T00:00:00",
                "CaptureDate": "2022-11-19T15:47:51"
              },
              {
                "Content": "CARTA DE INTIMACAO EXPEDIDA PROCESSO DIGITAL - CARTA - INTIMACAO - DESPACHO-ATO ORDINATORIO - JUIZADO",
                "PublishDate": "2022-11-10T00:00:00",
                "CaptureDate": "2022-11-19T15:47:51"
              },
              {
                "Content": "CARTA DE INTIMACAO EXPEDIDA PROCESSO DIGITAL - CARTA - INTIMACAO - DESPACHO-ATO ORDINATORIO - JUIZADO",
                "PublishDate": "2022-11-10T00:00:00",
                "CaptureDate": "2022-11-19T15:47:51"
              },
              {
                "Content": "CARTA DE INTIMACAO EXPEDIDA PROCESSO DIGITAL - CARTA - INTIMACAO - DESPACHO-ATO ORDINATORIO - JUIZADO",
                "PublishDate": "2022-11-10T00:00:00",
                "CaptureDate": "2022-11-19T15:47:51"
              },
              {
                "Content": "CARTA DE INTIMACAO EXPEDIDA PROCESSO DIGITAL - CARTA - INTIMACAO - DESPACHO-ATO ORDINATORIO - JUIZADO",
                "PublishDate": "2022-11-10T00:00:00",
                "CaptureDate": "2022-11-19T15:47:51"
              },
              {
                "Content": "ATERMACAO EXPEDIDA TERMO DE AJUIZAMENTO - DANO MORAL - JUIZADO",
                "PublishDate": "2022-11-09T00:00:00",
                "CaptureDate": "2022-11-19T15:47:51"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2022-11-09T00:00:00",
                "CaptureDate": "2022-11-19T15:47:51"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE VISTOS. 1-CITE-SE E INTIME-SE A PARTE REQUERIDA PARA QUE APRESENTE DEFESA ESCRITA, NO PRAZO DE 15 DIAS UTEIS, CONTADOS DA DATA DO RECEBIMENTO DA CARTA DE CITACAO, SOB PENA DE REVELIA, PODENDO FORMALIZAR PROPOSTA DE ACORDO EM SEUS TERMOS, CASO ASSIM DESEJE. 2-SEM PREJUIZO DO ITEM 1, CASO AS PARTES TENHAM INTERESSE NA REALIZACAO DE AUDIENCIA DE CONCILIACAO, DEVERAO FAZER EXPRESSAMENTE TAL SOLICITACAO EM JUIZO, FICANDO CONCEDIDO A PARTE AUTORA O PRAZO DE CINCO DIAS. QUANTO A PARTE REQUERIDA, A MANIFESTACAO DEVERA CONSTAR DA CONTESTACAO. 3-CASO AS PARTES TENHAM INTERESSE NA PRODUCAO DE PROVA ORAL (OITIVA DE TESTEMUNHA), DEVERAO APRESENTAR O RESPECTIVO ROL, PARA POSTERIOR DESIGNACAO DE AUDIENCIA DE INSTRUCAO E JULGAMENTO. 4-CASO QUALQUER DAS PARTES NAO ESTEJA ASSISTIDA POR ADVOGADO, PODERA COMPARECER NO CARTORIO DO JUIZADO PARA APRESENTACAO DE SUA MANIFESTACAO/DEFESA/APRESENTACAO DE ROL DE TESTEMUNHA. 5-O SILENCIO QUANTO AO INTERESSE NA REALIZACAO DE AUDIENCIA DE CONCILIACAO OU DE PRODUCAO DE PROVA ORAL, SERA INTERPRETADO COMO CONCORDANCIA COM O JULGAMENTO ANTECIPADO E OS AUTOS DEVERAO VOLTAR CONCLUSOS PARA PROLACAO DE SENTENCA. INT.",
                "PublishDate": "2022-11-09T00:00:00",
                "CaptureDate": "2022-11-19T15:47:51"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0733/2022 TEOR DO ATO: VISTOS. 1-CITE-SE E INTIME-SE A PARTE REQUERIDA PARA QUE APRESENTE DEFESA ESCRITA, NO PRAZO DE 15 DIAS UTEIS, CONTADOS DA DATA DO RECEBIMENTO DA CARTA DE CITACAO, SOB PENA DE REVELIA, PODENDO FORMALIZAR PROPOSTA DE ACORDO EM SEUS TERMOS, CASO ASSIM DESEJE. 2-SEM PREJUIZO DO ITEM 1, CASO AS PARTES TENHAM INTERESSE NA REALIZACAO DE AUDIENCIA DE CONCILIACAO, DEVERAO FAZER EXPRESSAMENTE TAL SOLICITACAO EM JUIZO, FICANDO CONCEDIDO A PARTE AUTORA O PRAZO DE CINCO DIAS. QUANTO A PARTE REQUERIDA, A MANIFESTACAO DEVERA CONSTAR DA CONTESTACAO. 3-CASO AS PARTES TENHAM INTERESSE NA PRODUCAO DE PROVA ORAL (OITIVA DE TESTEMUNHA), DEVERAO APRESENTAR O RESPECTIVO ROL, PARA POSTERIOR DESIGNACAO DE AUDIENCIA DE INSTRUCAO E JULGAMENTO. 4-CASO QUALQUER DAS PARTES NAO ESTEJA ASSISTIDA POR ADVOGADO, PODERA COMPARECER NO CARTORIO DO JUIZADO PARA APRESENTACAO DE SUA MANIFESTACAO/DEFESA/APRESENTACAO DE ROL DE TESTEMUNHA. 5-O SILENCIO QUANTO AO INTERESSE NA REALIZACAO DE AUDIENCIA DE CONCILIACAO OU DE PRODUCAO DE PROVA ORAL, SERA INTERPRETADO COMO CONCORDANCIA COM O JULGAMENTO ANTECIPADO E OS AUTOS DEVERAO VOLTAR CONCLUSOS PARA PROLACAO DE SENTENCA. INT. ADVOGADOS(S): RENAN NOGUEIRA FARAH (OAB 274183/SP)",
                "PublishDate": "2022-11-09T00:00:00",
                "CaptureDate": "2022-11-19T15:47:51"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2022-11-07T00:00:00",
                "CaptureDate": "2022-11-19T15:47:51"
              }
            ],
            "Petitions": [],
            "Decisions": []
          },
          {
            "Number": "00007603120238260005",
            "Type": "PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL",
            "MainSubject": "OBRIGACOES",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "ESPECIAL CIVEL",
            "CourtDistrict": "SAO PAULO",
            "Judge": "ENIO JOSE HAUFFE",
            "JudgingBody": "1 VARA DO JUIZADO ESPECIAL CIVEL",
            "State": "SP",
            "Status": "ATIVO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectNumber": 0,
            "InferredBroadCNJSubjectNumber": 0,
            "OtherSubjects": [
              "OBRIGACOES"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 10147.9,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-01-31T00:00:00",
            "NoticeDate": "2023-01-27T00:00:00",
            "LastMovementDate": "2023-01-31T00:00:00",
            "CaptureDate": "2023-02-01T05:00:19",
            "LastUpdate": "2023-02-01T05:00:19",
            "NumberOfParties": 4,
            "NumberOfUpdates": 8,
            "LawSuitAge": 397,
            "AverageNumberOfUpdatesPerMonth": 0,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "26410005806",
                "IsPartyActive": true,
                "Name": "ENIO JOSE HAUFFE",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "OAB": "173860",
                  "State": "SP",
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-02-01T05:00:19"
              },
              {
                "Doc": "87547724868",
                "IsPartyActive": true,
                "Name": "ISRAEL DE SOUZA BARBOZA",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-02-01T05:00:19"
              },
              {
                "Doc": "36010822000109",
                "IsPartyActive": true,
                "Name": "ISTPAY SERVICOS DE PAGAMENTOS E GESTAO FINANCEIRA LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-02-01T05:00:19"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-02-01T05:00:19"
              }
            ],
            "Updates": [
              {
                "Content": "PROCESSO : 0000760-31.2023.8.26.0005 CLASSE : PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL REQTE : ISRAEL DE SOUZA BARBOZA REQDO : ISTPAY SERVICOS DE PAGAMENTOS E GESTAO FINANCEIRA LTDA VARA : 1 VARA DO JUIZADO ESPECIAL CIVEL",
                "PublishDate": "2023-01-31T00:00:00",
                "CaptureDate": "2023-02-01T05:00:19"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-01-27T00:00:00",
                "CaptureDate": "2023-02-01T05:00:20"
              },
              {
                "Content": "DESIGNADA AUDIENCIA DE CONCILIACAO CONCILIACAO DATA: 24/04/2023 HORA 16:10 LOCAL: SALA 27 - CONCILIACAO SITUACAO: PENDENTE",
                "PublishDate": "2023-01-27T00:00:00",
                "CaptureDate": "2023-02-01T05:00:20"
              },
              {
                "Content": "ATERMACAO EXPEDIDA TERMO DE AJUIZAMENTO - CONCILIACAO",
                "PublishDate": "2023-01-27T00:00:00",
                "CaptureDate": "2023-02-01T05:00:20"
              },
              {
                "Content": "AJUIZAMENTO DIGITALIZADO",
                "PublishDate": "2023-01-27T00:00:00",
                "CaptureDate": "2023-02-01T05:00:20"
              },
              {
                "Content": "DOCUMENTO JUNTADO",
                "PublishDate": "2023-01-27T00:00:00",
                "CaptureDate": "2023-02-01T05:00:20"
              },
              {
                "Content": "CARTA DE CITACAO EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO E INTIMACAO - AUDIENCIA DE CONCILIACAO - JUIZADO",
                "PublishDate": "2023-01-27T00:00:00",
                "CaptureDate": "2023-02-01T05:00:20"
              },
              {
                "Content": "CARTA DE CITACAO EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO E INTIMACAO - AUDIENCIA DE CONCILIACAO - JUIZADO",
                "PublishDate": "2023-01-27T00:00:00",
                "CaptureDate": "2023-02-01T05:00:20"
              }
            ],
            "Petitions": [],
            "Decisions": []
          },
          {
            "Number": "00025134820238260320",
            "Type": "RECLAMACAO",
            "MainSubject": "PAGAMENTO",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "LIMEIRA",
            "Judge": "GUILHERME SALVATTO WHITAKER",
            "JudgingBody": "CEJUSC (PRE-PROCESSUAL)",
            "State": "SP",
            "Status": "INDEFINIDO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "PAGAMENTO",
            "InferredCNJSubjectNumber": 14950,
            "InferredCNJProcedureTypeName": "RECLAMAÇÃO PRÉ-PROCESSUAL",
            "InferredBroadCNJSubjectName": "DIREITO TRIBUTÁRIO",
            "InferredBroadCNJSubjectNumber": 14,
            "OtherSubjects": [
              "PAGAMENTO"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": -1,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-03-16T00:00:00",
            "NoticeDate": "2023-03-14T00:00:00",
            "LastMovementDate": "2023-03-16T00:00:00",
            "CaptureDate": "2023-03-18T20:51:01",
            "LastUpdate": "2023-03-18T20:51:01",
            "NumberOfParties": 4,
            "NumberOfUpdates": 8,
            "LawSuitAge": 351,
            "AverageNumberOfUpdatesPerMonth": 0,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "27813346858",
                "IsPartyActive": true,
                "Name": "GUILHERME SALVATTO WHITAKER",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-03-18T20:51:01"
              },
              {
                "Doc": "28139626864",
                "IsPartyActive": true,
                "Name": "ALEX ENDRIGO BILATO",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "RECLAMANTE"
                },
                "LastCaptureDate": "2023-03-18T20:51:01"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "RECLAMADO"
                },
                "LastCaptureDate": "2023-03-18T20:51:01"
              },
              {
                "IsPartyActive": true,
                "Name": "FG ENTRETERIMENTO ELETRONICO LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "RECLAMADO"
                },
                "LastCaptureDate": "2023-03-18T20:51:01"
              }
            ],
            "Updates": [
              {
                "Content": "PROCESSO : 0002513-48.2023.8.26.0320 CLASSE : RECLAMACAO PRE-PROCESSUAL RECLAMANTE : ALEX ENDRIGO BILATO RECLAMADO : STARK BANK S.A. VARA : CEJUSC (PRE-PROCESSUAL)",
                "PublishDate": "2023-03-16T00:00:00",
                "CaptureDate": "2023-03-18T20:51:01"
              },
              {
                "Content": "DISTRIBUIDO POR DIRECIONAMENTO (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-03-14T00:00:00",
                "CaptureDate": "2023-03-18T20:51:01"
              },
              {
                "Content": "DESIGNADA AUDIENCIA DE CONCILIACAO CONCILIACAO DATA: 10/04/2023 HORA 15:30 LOCAL: SALA DE CONCILIACAO SITUACAO: PENDENTE",
                "PublishDate": "2023-03-14T00:00:00",
                "CaptureDate": "2023-03-18T20:51:01"
              },
              {
                "Content": "ATERMACAO EXPEDIDA TERMO DE AJUIZAMENTO - CEJUSC",
                "PublishDate": "2023-03-14T00:00:00",
                "CaptureDate": "2023-03-18T20:51:01"
              },
              {
                "Content": "CARTA EXPEDIDA RECLAMACAO DIGITAL - CARTA - CONVITE - (EXCLUSIVO CEJUSC - PRE-PROCESSUAL)",
                "PublishDate": "2023-03-14T00:00:00",
                "CaptureDate": "2023-03-18T20:51:01"
              },
              {
                "Content": "DOCUMENTO JUNTADO",
                "PublishDate": "2023-03-14T00:00:00",
                "CaptureDate": "2023-03-18T20:51:01"
              },
              {
                "Content": "DOCUMENTO JUNTADO",
                "PublishDate": "2023-03-14T00:00:00",
                "CaptureDate": "2023-03-18T20:51:01"
              },
              {
                "Content": "CARTA EXPEDIDA RECLAMACAO DIGITAL - CARTA - CONVITE - (EXCLUSIVO CEJUSC - PRE-PROCESSUAL)",
                "PublishDate": "2023-03-14T00:00:00",
                "CaptureDate": "2023-03-18T20:51:01"
              }
            ],
            "Petitions": [],
            "Decisions": []
          },
          {
            "Number": "00328555020208160021",
            "Type": "PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL",
            "MainSubject": "7698 - PERDAS E DANOS",
            "CourtName": "TJPR",
            "CourtLevel": "1",
            "CourtType": "ESPECIAL CIVEL",
            "CourtDistrict": "CASCAVEL",
            "Judge": "VALMIR ZAIAS COSECHEN",
            "JudgingBody": "2 JUIZADO ESPECIAL CIVEL DE CASCAVEL",
            "State": "PR",
            "Status": "INDEFINIDO",
            "LawsuitHostService": "OTHER",
            "InferredCNJSubjectName": "PERDAS E DANOS",
            "InferredCNJSubjectNumber": 7698,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO DO JUIZADO ESPECIAL CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO CIVIL",
            "InferredBroadCNJSubjectNumber": 899,
            "OtherSubjects": [
              "7698 - PERDAS E DANOS"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": -1,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "0001-01-01T00:00:00",
            "NoticeDate": "2020-10-20T00:00:00",
            "LastMovementDate": "2023-04-25T00:00:00",
            "CaptureDate": "2023-05-04T23:37:10",
            "LastUpdate": "2023-05-04T23:37:10",
            "NumberOfParties": 10,
            "NumberOfUpdates": 207,
            "LawSuitAge": 1226,
            "AverageNumberOfUpdatesPerMonth": 5,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "23299517953",
                "IsPartyActive": true,
                "Name": "VALMIR ZAIAS COSECHEN",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-05-04T23:37:10"
              },
              {
                "Doc": "49863100978",
                "IsPartyActive": true,
                "Name": "LEONI DA SILVA",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "POLO ATIVO"
                },
                "LastCaptureDate": "2023-05-04T23:37:10"
              },
              {
                "Doc": "03415560929",
                "IsPartyActive": true,
                "Name": "ELIANE APARECIDA DA COSTA SILVA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "49522N",
                  "State": "PR",
                  "SpecificType": "ADVOGADO (POLO ATIVO)"
                },
                "LastCaptureDate": "2023-05-04T23:37:10"
              },
              {
                "IsPartyActive": true,
                "Name": "SERGIO ROBERTO SILVA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "88135N",
                  "State": "PR",
                  "SpecificType": "ADVOGADO (POLO ATIVO)"
                },
                "LastCaptureDate": "2023-05-04T23:37:10"
              },
              {
                "Doc": "01456878999",
                "IsPartyActive": true,
                "Name": "ITANIEL CAMILO LEITE",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "86192N",
                  "State": "PR",
                  "SpecificType": "ADVOGADO (POLO ATIVO)"
                },
                "LastCaptureDate": "2023-05-04T23:37:10"
              },
              {
                "Doc": "21160553000181",
                "IsPartyActive": true,
                "Name": "FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "POLO PASSIVO"
                },
                "LastCaptureDate": "2023-05-04T23:37:10"
              },
              {
                "Doc": "10685786000181",
                "IsPartyActive": true,
                "Name": "FRI SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "POLO PASSIVO"
                },
                "LastCaptureDate": "2023-05-04T23:37:10"
              },
              {
                "Doc": "18583984875",
                "IsPartyActive": true,
                "Name": "GILBERTO KLEY SILVA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "POLO PASSIVO"
                },
                "LastCaptureDate": "2023-05-04T23:37:10"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "POLO PASSIVO"
                },
                "LastCaptureDate": "2023-05-04T23:37:10"
              },
              {
                "Doc": "35068411817",
                "IsPartyActive": true,
                "Name": "RAFAEL HIDEO NAZIMA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "295443N",
                  "State": "SP",
                  "SpecificType": "ADVOGADO (POLO PASSIVO)"
                },
                "LastCaptureDate": "2023-05-04T23:37:10"
              }
            ],
            "Updates": [
              {
                "Content": "JULGADA PROCEDENTE EM PARTE A ACAO REGISTRO EM 26/04/2023 SOB N 1.603.364.964 PROJUDI - PROCESSO: 0032855-50.2020.8.16.0021 - REF. MOV. 207.1 - ASSINADO DIGITALMENTE POR VALMIR ZAIAS COSECHEN:8288 25/04/2023: JULGADA PROCEDENTE EM PARTE A ACAO. ARQ: SENTENCA PODER JUDICIARIO DO ESTADO DO PARANA COMARCA DE CASCAVEL 2 JUIZADO ESPECIAL CIVEL DE CASCAVEL - PROJUDI AVENIDA TANCREDO NEVES, 2320 - ALTO ALEGRE - CASCAVEL/PR - CEP: 85.804-260 - FONE: (45) 3392-5068 - E-MAIL: CAS-16VJ-S@TJPR. JUS.BR AUTOS N. 0032855-50.2020.8.16.0021 PROCESSO: 0032855-50.2020.8.16.0021 CLASSE PROCESSUAL: PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL ASSUNTO PRINCIPAL: PERDAS E DANOS VALOR DA CAUSA: R$9.000,00 POLO ATIVO(S): LEONI DA SILVA POLO PASSIVO(S): FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA GILBERTO KLEY SILVA STARK BANK S.A. SENTENCA TRATA-SE DE ACAO QUE SE DESENVOLVE SOB O RITO DO JUIZADO ESPECIAL CIVEL AJUIZADA POR LEONI DA SILVAEM FACE DE FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA, FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA E GILBERTO KLEY SILVA, ALEGANDO RESUMIDAMENTE QUE EM 28.09.2019 CELEBROU UM CONTRATO DE INVESTIMENTOS FINANCEIROS (MUTUO) COM AS RES, NO VALOR DE R$ 1.000,00 (MIL REAIS). ALEGA AINDA QUE AS RES PROMETIAM O PAGAMENTO DE JUROS MENSAIS DE 10% (DEZ POR CENTO) SOBRE OS VALORES APORTADOS POR SEUS CLIENTES E, AO FINAL DO PERIODO DE 12 (DOZE) MESES, REALIZARIAM A RESTITUICAO INTEGRAL DESSAS QUANTIAS. ADUZ QUE JA SE PASSARAM OS 12 (DOZE) MESES E AS RES NAO PAGARAM OS RENDIMENTOS PROMETIDOS, DANDO CAUSA A RESCISAO E RESPECTIVA COBRANCA DOS PACTOS. POR TAIS RAZOES, A AUTORA PRETENDE DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJ5VN 7MN7L UYQTL FWWK3 COM A PRESENTE DEMANDA A DECLARACAO DE NULIDADE DO CONTRATO DE MUTUO ENTABULADO ENTRE AS PARTES, OU SUBSIDIARIAMENTE PELO RECONHECIMENTO DO INADIMPLEMENTO E DECLARACAO DE RESOLUCAO DO CONTRATO COM A DEVOLUCAO DOS VALORES, BEM COMO PELA CONDENACAO DAS RES AO PAGAMENTO DE INDENIZACAO A TITULO DE DANOS MORAIS. CITADAS E INTIMADAS (MOVS. 19.1, 184.1, 185.1 E 201.1), AS PARTES RES NAO COMPARECERAM AS AUDIENCIAS (MOVS. 192 E 205) NEM APRESENTARAM CONTESTACAO. PREJUDICADAS AS TENTATIVAS PREVIAS DE CONCILIACAO, VIERAM-ME OS AUTOS CONCLUSOS. E O BREVE RELATORIO. INSTA SALIENTAR EM RELACAO A RE FRI, QUE A MESMA FORA DEVIDAMENTE CITADA NESTES AUTOS (MOV. 19.1), E DEPOIS INTIMADA NO MESMO ENDERECO (MOV. 201.1) PARA COMPARECER A AUDIENCIA DE CONCILIACAO. EM QUE PESE A DEVOLUCAO NEGATIVA DA CARTA, REPUTO EFICAZ A INTIMACAO EXPEDIDA PARA COMPARECIMENTO A AUDIENCIA DE CONCILIACAO DO DIA 11.04.2023 (MOV. 205), NOS TERMOS DO  2 DO ART. 19 DA LEI N 9.099/95, DADO QUE A INTIMACAO FORA REALIZADA NO MESMO ENDERECO EM QUE RECEBIDA A CITACAO PELA PARTE RE FRI. PROJUDI - PROCESSO: 0032855-50.2020.8.16.0021 - REF. MOV. 207.1 - ASSINADO DIGITALMENTE POR VALMIR ZAIAS COSECHEN:8288 25/04/2023: JULGADA PROCEDENTE EM PARTE A ACAO. ARQ: SENTENCA OS REUS FORTS E GILBERTO, FORAM CITADOS E INTIMADOS (MOVS. 184.1 E 185.1), POREM, DEIXARAM DE COMPARECE A AUDIENCIA DE CONCILIACAO DESIGNADA (MOV. 192). ASSIM, CONSIDERANDO A AUSENCIA INJUSTIFICADA DAS PARTES RES AS AUDIENCIAS DE CONCILIACAO, DECRETO SUA REVELIA E PASSO AO JULGAMENTO IMEDIATO DO MERITO DO PROCESSO, CONFORME ME AUTORIZAM OS ARTS. 20 E 23, DA LEI 9.099/95. ANTES DE ADENTRAR NA ANALISE PROPRIAMENTE DITA DOS FATOS E DAS PROVAS PRODUZIDAS, REGISTRO QUE A RELACAO JURIDICA TRAVADA ENTRE AS PARTES E UMA NITIDA RELACAO DE CONSUMO, SUJEITA, POIS, AS REGRAS DO CODIGO DE DEFESA DO CONSUMIDOR. HA QUE SE OBSERVAR AINDA QUE, EM RELACAO A LEGITIMIDADE DAS PARTES QUE COMPOE O POLO PASSIVO DA PRESENTE DEMANDA, A PARTE AUTORA FIRMOU CONTRATO DE MUTUO COM A RE FRI (MOV. 1.5), SOCIEDADE DA QUAL O REU GILBERTO E O SOCIO ADMINISTRADOR (MOV. 1.11), TENDO PAGO O BOLETO DO APORTE FEITO PARA A RE FORTS (MOVS. 1.6 E 1.8). ASSIM, CONSIDERANDO A APLICACAO DA TEORIA MENOR DA PERSONALIDADE JURIDICA, NOS TERMOS DO ARTIGO 28 DO CODIGO DE DEFESA DO CONSUMIDOR, DEFIRO A DESCONSIDERACAO DA PERSONALIDADE JURIDICA PARA QUE O SOCIO ADMINISTRADOR DA RE FRI COMPONHA O POLO PASSIVO DA PRESENTE DEMANDA. POIS BEM, APRESENTA A PARTE AUTORA PRETENSAO PARA QUE SEJA DECLARADA A NULIDADE DO CONTRATO DE MUTUO ENTABULADO COM AS PARTES RES OU ENTAO SEJA RECONHECIDO O INADIMPLEMENTO E DECLARADA A RESOLUCAO DO CONTRATO (MOV. 1.5), DEVENDO AS RES RESTITUIREM DO VALOR DE R$ 1.000,00 (MIL REAIS) (MOV. 1.8) QUE FORA TRANSFERIDO PELA AUTORA A RE FORTS A TITULO DE APLICACAO, SOB A PROMESSA HAVERIA O PAGAMENTO DE JUROS MENSAIS DE 10%, E AO FINAL DO PERIODO DE DOZE MESES AS QUANTIAS SERIA RESTITUIDAS INTEGRALMENTE. AFIRMA A AUTORA QUE OS JUROS NAO LHE FORAM PAGOS, SEQUER AS QUANTIAS RESTITUIDAS. O CONTRATO ENTABULADO ENTRE AS PARTES VISOU O EMPRESTIMO DE DINHEIRO, CONSISTINDO EM UM DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJ5VN 7MN7L UYQTL FWWK3 CONTRATO DE MUTUO, POR MEIO DESTE AS RES TOMARAM O MONTANTE DE R$ 1.000,00 (MIL REAIS) DA PARTE AUTORA. O CASO EM TELA TRATA-SE DE CONTRATACAO ONEROSA, JA QUE AS RES PROMETERAM A AUTORA REMUNERACAO PELO CAPITAL QUE ESTA DISPONIBILIZOU, PARA ALEM DISSO, O PROPRIO CODIGO CIVIL EM SEU ARTIGO 591 TRAZ A PREVISAO DE QUE SENDO O MUTUO PARA FINS ECONOMICOS HA PRESUNCAO DE QUE OS JUROS SAO DEVIDOS. NO CASO EM TELA CABERIA AS RES COMPROVAREM QUE EFETUARAM O PAGAMENTO DOS JUROS, BEM COMO RESTITUIRAM O CAPITAL DISPONIBILIZADO A PARTE AUTORA (ART. 373, II, DO CPC), POREM, NAO O FIZERAM. SENDO ASSIM, REPUTO VERDADEIRA A ALEGACAO DA PARTE AUTORA DE QUE AS RES RESTARAM INADIMPLENTES, TENDO A AUTORA CUMPRIDO SUA OBRIGACAO AO EFETUAR A TRANSFERENCIA DOS R$ 1.000,00 (MIL REAIS), CONFORME COMPROVANTE (MOV. 1.8), E AS RES DEIXADO DE CUMPRIR COM SUAS CONTRAPRESTACOES, QUAL SEJA, O PAGAMENTO DOS JUROS MENSAIS E RESTITUICAO DO VALOR DO CAPITAL INVESTIDO, VISTO QUE AS RES OPTARAM POR SE SUJEITAR AOS EFEITOS MATERIAIS DA REVELIA, E NAO APRESENTARAM COMPROVANTE DE PAGAMENTO DE REFERIDOS VALORES A AUTORA. PROJUDI - PROCESSO: 0032855-50.2020.8.16.0021 - REF. MOV. 207.1 - ASSINADO DIGITALMENTE POR VALMIR ZAIAS COSECHEN:8288 25/04/2023: JULGADA PROCEDENTE EM PARTE A ACAO. ARQ: SENTENCA ASSIM, RECONHECIDO O INADIMPLEMENTO POR PARTE DAS RES, FAZ-SE MISTER ACATAR O PLEITO DA PARTE AUTORA QUANTO A DECLARACAO DE RESCISAO DO CONTRATO DE MUTUO FIRMADO, DEVENDO AS RES RESTITUIREM O VALOR DE R$ 1.000,00 (MIL REAIS). DANOS MORAIS PUGNA AINDA A PARTE AUTORA PELA INDENIZACAO A TITULO DE DANOS MORAIS. CONVEM LEMBRAR QUE OS ABALOS ALEGADOS DECORREM TAMBEM DA GANANCIA BUSCADA PELA RECLAMANTE, A BUSCA DE GANHO FACIL, NA LOTERIA FINANCEIRA, COM RISCOS EVIDENTES, POIS E DE CONHECIMENTO NOTORIO QUE ORDINARIAMENTE PROMESSAS DE GANHOS QUE EXTRAPOLAM EM MUITO AS CONDICOES MERCADOLOGICAS, POSSUEM ALTO GRAU DE INCERTEZA E GRANDE PROBABILIDADE DE SUPORTAR PREJUIZOS. POR EVIDENTE, QUE NAO FAZ JUS A DANOS MORAIS, POR FATOS QUE TIVERAM COMO CONTRIBUICAO SUA PROPRIA TORPEZA. ASSIM, REPUTO IMPROCEDENTE O PEDIDO DE DANOS MORAIS. DISPOSITIVO ANTE O EXPOSTO, JULGO PARCIALMENTE PROCEDENTES OS PEDIDOS FEITOS POR LEONI DA SILVAEM FACE DE FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA, FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA E GILBERTO KLEY SILVA, O QUE FACO DA SEGUINTE MANEIRA: A) PROCEDENTE O PEDIDO PARA DECLARAR A RESCISAO DO CONTRATO DE MUTUO ENTABULANDO, E CONSEQUENTEMENTE CONDENAR AS RES, SOLIDARIAMENTE, A RESTITUICAO DO VALOR DE R$ 1.000,00 (MIL REAIS), QUE DEVERA SER CORRIGIDO MONETARIAMENTE PELO INPC DESDE O DESEMBOLSO (MOV. 1.8), ACRESCIDO DE JUROS DE MORA DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJ5VN 7MN7L UYQTL FWWK3 DE 1% AO MES CONTADOS DA CITACAO; B) IMPROCEDENTE O PEDIDO DE INDENIZACAO A TITULO DE DANOS MORAIS. RESOLVO, ASSIM, O MERITO DO PROCESSO, NA FORMA DO ART. 487, I, DO CPC. SEM CONDENACAO EM CUSTAS OU HONORARIOS (ART. 55, LEI 9.099/95). SENTENCA PUBLICADA ELETRONICAMENTE. INTIMEM-SE. CASCAVEL (PR), DATADO ELETRONICAMENTE. VALMIR ZAIAS COSECHEN JUIZ DE DIREITO",
                "PublishDate": "2023-04-25T00:00:00",
                "CaptureDate": "2023-05-01T01:42:46"
              },
              {
                "Content": "CONCLUSOS PARA SENTENCA RESPONSAVEL: VALMIR ZAIAS COSECHEN",
                "PublishDate": "2023-04-13T00:00:00",
                "CaptureDate": "2023-05-01T01:42:54"
              },
              {
                "Content": "AUDIENCIA DE CONCILIACAO REALIZADA AUSENCIA DO REQUERIDO",
                "PublishDate": "2023-04-11T00:00:00",
                "CaptureDate": "2023-05-01T01:42:54"
              },
              {
                "Content": "JUNTADA DE PETICAO DE MANIFESTACAO DA PARTE CUMPRIMENTO DE INTIMACAO - REFERENTE AO EVENTO AUDIENCIA DE CONCILIACAO DESIGNADA (31/01/2023)",
                "PublishDate": "2023-03-14T00:00:00",
                "CaptureDate": "2023-05-01T01:42:54"
              },
              {
                "Content": "DECORRIDO PRAZO DE STARK BANK S.A. (P/ ADVGS. DE STARK BANK S.A. *REFERENTE AO EVENTO (SEQ. 194) EXTINTO O PROCESSO POR DESISTENCIA (26/01/2023) E AO EVENTO DE EXPEDICAO SEQ. 195.",
                "PublishDate": "2023-03-01T00:00:00",
                "CaptureDate": "2023-05-01T01:42:54"
              },
              {
                "Content": "JUNTADA DE PETICAO DE CUMPRIMENTO DE INTIMACAO CUMPRIMENTO DE INTIMACAO - REFERENTE AO EVENTO EXTINTO O PROCESSO POR DESISTENCIA (26/01/2023)",
                "PublishDate": "2023-02-28T00:00:00",
                "CaptureDate": "2023-05-01T01:42:54"
              },
              {
                "Content": "JUNTADA DE COMPROVANTE DEVOLUCAO SEM LEITURA - INTIMACAO EXPEDIDA EM 31/01/2023 PARA FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA - REFERENTE AO EVENTO AUDIENCIA DE CONCILIACAO DESIGNADA (31/01/2023)",
                "PublishDate": "2023-02-13T00:00:00",
                "CaptureDate": "2023-05-01T01:42:54"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA REFERENTE AO EVENTO (SEQ. 196) AUDIENCIA DE CONCILIACAO DESIGNADA (31/01/2023) E AO EVENTO DE EXPEDICAO SEQ. 197.",
                "PublishDate": "2023-02-11T00:00:00",
                "CaptureDate": "2023-05-01T01:42:54"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA REFERENTE AO EVENTO (SEQ. 194) EXTINTO O PROCESSO POR DESISTENCIA (26/01/2023) E AO EVENTO DE EXPEDICAO SEQ. 195.",
                "PublishDate": "2023-02-11T00:00:00",
                "CaptureDate": "2023-05-01T01:42:54"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO REFERENTE AO EVENTO (SEQ. 196) AUDIENCIA DE CONCILIACAO DESIGNADA (31/01/2023).",
                "PublishDate": "2023-01-31T00:00:00",
                "CaptureDate": "2023-05-01T01:42:54"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO REFERENTE AO EVENTO (SEQ. 196) AUDIENCIA DE CONCILIACAO DESIGNADA (31/01/2023).",
                "PublishDate": "2023-01-31T00:00:00",
                "CaptureDate": "2023-05-01T01:42:54"
              },
              {
                "Content": "AUDIENCIA DE CONCILIACAO DESIGNADA (AGENDADA PARA: 11 DE ABRIL DE 2023 AS 14:30, EM 2 JUIZADO ESPECIAL CIVEL DE CASCAVEL, MODALIDADE: VIRTUAL)",
                "PublishDate": "2023-01-31T00:00:00",
                "CaptureDate": "2023-05-01T01:42:54"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO REFERENTE AO EVENTO (SEQ. 194) EXTINTO O PROCESSO POR DESISTENCIA (26/01/2023).",
                "PublishDate": "2023-01-31T00:00:00",
                "CaptureDate": "2023-05-01T01:42:54"
              },
              {
                "Content": "EXTINTO O PROCESSO POR DESISTENCIA REGISTRO EM 27/01/2023 SOB N 1.564.926.636. VEICULADO NO DJEN EM 02/02/2023. PROJUDI - PROCESSO: 0032855-50.2020.8.16.0021 - REF. MOV. 194.1 - ASSINADO DIGITALMENTE POR VALMIR ZAIAS COSECHEN:8288 26/01/2023: EXTINTO O PROCESSO POR DESISTENCIA. ARQ: SENTENCA PODER JUDICIARIO DO ESTADO DO PARANA COMARCA DE CASCAVEL 2 JUIZADO ESPECIAL CIVEL DE CASCAVEL - PROJUDI AVENIDA TANCREDO NEVES, 2320 - ALTO ALEGRE - CASCAVEL/PR - CEP: 85.804-260 - FONE: (45) 3392-5068 - E-MAIL: CAS-16VJ-S@TJPR. JUS.BR AUTOS N. 0032855-50.2020.8.16.0021 PROCESSO: 0032855-50.2020.8.16.0021 CLASSE PROCESSUAL: PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL ASSUNTO PRINCIPAL: PERDAS E DANOS VALOR DA CAUSA: R$9.000,00 POLO ATIVO(S): LEONI DA SILVA POLO PASSIVO(S): FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA GILBERTO KLEY SILVA STARK BANK S.A. SENTENCA VIERAM-ME OS AUTOS CONCLUSOS APOS A REALIZACAO DA AUDIENCIA DE CONCILIACAO (MOV. 192). NA OCASIAO, A PARTE AUTORA APRESENTOU PEDIDO DE DESISTENCIA EM FACE DO REU STARK BANK S.A. E PUGNOU PELA APLICACAO DOS EFEITOS DA REVELIA E JULGAMENTO ANTECIPADO EM FACE DOS DEMAIS REU. DECIDO. DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJLWC 3YNXR T84BR GZ3NU 1. HOMOLOGOA DESISTENCIA REQUERIDA PELA PARTE AUTORA EM FACE DO REU STARK BANK S.A., DE MODO QUE JULGO PARCIALMENTE EXTINTO O PROCESSO, SEM RESOLUCAO DO MERITO, NA FORMA DO ART. 485, VIII, DO CODIGO DE PROCESSO CIVIL, TAO SOMENTE EM RELACAO AO REU STARK BANK S.A. SE FOI CONCEDIDA TUTELA PROVISORIA EM FACE DESTE REU, REVOGO-A. 2.EM RELACAO AOS DEMAIS REUS, DEIXO DE JULGAR O FEITO NESTE MOMENTO, POIS VERIFIQUEI QUE O REU FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA, CITADO NESTES AUTOS (MOV. 19.1), NAO FOI DEVIDAMENTE INTIMADO PARA COMPARECER EM NENHUMA DAS AUDIENCIAS DE CONCILIACAO REALIZADAS NO PRESENTE FEITO, JA QUE A ULTIMA INTIMACAO EXPEDIDA PARA ESTE REU (MOV. 112) FOI PARA O COMPARECIMENTO NA AUDIENCIA DE CONCILIACAO DESIGNADA PARA 01.04.2022, QUE FOI POSTERIORMENTE CANCELADA (MOV. 142). SENDO ASSIM, VISANDO EVITAR QUALQUER NULIDADE DETERMINO A DESIGNACAO DE NOVA AUDIENCIA DE CONCILIACAO ENTRE A PARTE AUTORA E A PARTE RE FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA. A INTIMACAO DA PARTE RE FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA DEVERA SER ENVIADA AO ENDERECO EM QUE A MESMA FORA CITADA (MOV. 19.1), E SERA REPUTADA EFICAZ NOS TERMOS DO ART. 19,  2, DA LEI N 9.099/95. 3.ANOTACOES E DILIGENCIAS NECESSARIAS. PROJUDI - PROCESSO: 0032855-50.2020.8.16.0021 - REF. MOV. 194.1 - ASSINADO DIGITALMENTE POR VALMIR ZAIAS COSECHEN:8288 26/01/2023: EXTINTO O PROCESSO POR DESISTENCIA. ARQ: SENTENCA 4.SEM CUSTAS OU HONORARIOS. P.R.I. CASCAVEL (PR), DATADO ELETRONICAMENTE. VALMIR ZAIAS COSECHEN JUIZ DE DIREITO DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJLWC 3YNXR T84BR GZ3NU",
                "PublishDate": "2023-01-26T00:00:00",
                "CaptureDate": "2023-05-01T01:42:54"
              },
              {
                "Content": "CONCLUSOS PARA SENTENCA RESPONSAVEL: VALMIR ZAIAS COSECHEN",
                "PublishDate": "2023-01-23T00:00:00",
                "CaptureDate": "2023-05-01T01:43:07"
              },
              {
                "Content": "AUDIENCIA DE CONCILIACAO REALIZADA REVELIA",
                "PublishDate": "2023-01-23T00:00:00",
                "CaptureDate": "2023-05-01T01:43:07"
              },
              {
                "Content": "DECORRIDO PRAZO DE LEONI DA SILVA (P/ ADVGS. DE LEONI DA SILVA *REFERENTE AO EVENTO (SEQ. 181) CONFIRMADA A COMUNICACAO ELETRONICA (04/11/2022) E AO EVENTO DE EXPEDICAO SEQ. 182.",
                "PublishDate": "2022-12-08T00:00:00",
                "CaptureDate": "2023-05-01T01:43:07"
              },
              {
                "Content": "ATO CUMPRIDO PELA PARTE OU INTERESSADO RENUNCIA DE PRAZO DE LEONI DA SILVA - REFERENTE AO EVENTO CONFIRMADA A COMUNICACAO ELETRONICA (04/11/2022)",
                "PublishDate": "2022-12-07T00:00:00",
                "CaptureDate": "2023-05-01T01:43:07"
              },
              {
                "Content": "DECORRIDO PRAZO DE STARK BANK S.A. (P/ ADVGS. DE STARK BANK S.A. *REFERENTE AO EVENTO (SEQ. 180) EMBARGOS DE DECLARACAO ACOLHIDOS (26/10/2022) E AO EVENTO DE EXPEDICAO SEQ. 183.",
                "PublishDate": "2022-12-02T00:00:00",
                "CaptureDate": "2023-05-01T01:43:07"
              },
              {
                "Content": "JUNTADA DE PETICAO DE MANIFESTACAO DA PARTE CUMPRIMENTO DE INTIMACAO - REFERENTE AO EVENTO EMBARGOS DE DECLARACAO ACOLHIDOS (26/10/2022)",
                "PublishDate": "2022-12-01T00:00:00",
                "CaptureDate": "2023-05-01T01:43:07"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA REFERENTE AO EVENTO (SEQ. 180) EMBARGOS DE DECLARACAO ACOLHIDOS (26/10/2022) E AO EVENTO DE EXPEDICAO SEQ. 183.",
                "PublishDate": "2022-11-18T00:00:00",
                "CaptureDate": "2023-05-01T01:43:07"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA REFERENTE AO EVENTO (SEQ. 181) CONFIRMADA A COMUNICACAO ELETRONICA (04/11/2022) E AO EVENTO DE EXPEDICAO SEQ. 182.",
                "PublishDate": "2022-11-15T00:00:00",
                "CaptureDate": "2023-05-01T01:43:07"
              },
              {
                "Content": "ATO CUMPRIDO PELA PARTE OU INTERESSADO LEITURA DE CITACAO REALIZADA - POR GILBERTO KLEY SILVA EM 26/10/2022 REFERENTE AO EVENTO DE EXPEDICAO SEQ. 172.",
                "PublishDate": "2022-11-08T00:00:00",
                "CaptureDate": "2023-05-01T01:43:07"
              },
              {
                "Content": "ATO CUMPRIDO PELA PARTE OU INTERESSADO LEITURA DE CITACAO REALIZADA - POR FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA EM 26/10/2022 REFERENTE AO EVENTO DE EXPEDICAO SEQ. 171.",
                "PublishDate": "2022-11-08T00:00:00",
                "CaptureDate": "2023-05-01T01:43:07"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO REFERENTE AO EVENTO (SEQ. 180) EMBARGOS DE DECLARACAO ACOLHIDOS (26/10/2022).",
                "PublishDate": "2022-11-07T00:00:00",
                "CaptureDate": "2023-05-01T01:43:07"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO REFERENTE AO EVENTO (SEQ. 181) CONFIRMADA A COMUNICACAO ELETRONICA (04/11/2022).",
                "PublishDate": "2022-11-04T00:00:00",
                "CaptureDate": "2023-05-01T01:43:07"
              },
              {
                "Content": "CONFIRMADA A COMUNICACAO ELETRONICA CARTA PRECATORIA LIDO(A) EM 28/10/2022 - REFERENTE AO EVENTO DE EXPEDICAO (SEQ. 88) EXPEDICAO DE CARTA PRECATORIA (23/11/2021 16:05:51)",
                "PublishDate": "2022-11-04T00:00:00",
                "CaptureDate": "2023-05-01T01:43:07"
              },
              {
                "Content": "EMBARGOS DE DECLARACAO ACOLHIDOS REGISTRO EM 27/10/2022 SOB N 1.536.408.537. VEICULADO NO DJEN EM 08/11/2022. PROJUDI - PROCESSO: 0032855-50.2020.8.16.0021 - REF. MOV. 180.1 - ASSINADO DIGITALMENTE POR VALMIR ZAIAS COSECHEN:8288 26/10/2022: EMBARGOS DE DECLARACAO ACOLHIDOS. ARQ: SENTENCA PODER JUDICIARIO DO ESTADO DO PARANA COMARCA DE CASCAVEL 2 JUIZADO ESPECIAL CIVEL DE CASCAVEL - PROJUDI AVENIDA TANCREDO NEVES, 2320 - ALTO ALEGRE - CASCAVEL/PR - CEP: 85.804-260 - FONE: (45) 3392-5068 - E-MAIL: CAS-16VJ-S@TJPR. JUS.BR AUTOS N. 0032855-50.2020.8.16.0021 PROCESSO: 0032855-50.2020.8.16.0021 CLASSE PROCESSUAL: PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL ASSUNTO PRINCIPAL: PERDAS E DANOS VALOR DA CAUSA: R$9.000,00 POLO ATIVO(S): LEONI DA SILVA POLO PASSIVO(S): FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA GILBERTO KLEY SILVA STARK BANK S.A. DECISAO TRATA-SE DE EMBARGOS DE DECLARACAO OPOSTOS POR STARK BANK S.A. EM FACE DA DECISAO QUE DEFERIU A DESIGNACAO DE NOVA AUDIENCIA DE CONCILIACAO, ADUZINDO QUE NA AUDIENCIA DE CONCILIACAO REALIZADA ( MOV. 157) A PARTE AUTORA DEIXOU DE COMPARECER, TENDO A EMBARGANTE FEITO PEDIDO DE EXTINCAO DO FEITO. PASSO A DECIDIR. RECONHECO A OMISSAO NA DECISAO QUE DETERMINOU O PROSSEGUIMENTO DO FEITO. CONTUDO, JA DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJSN8 85NQ8 H6L3P 7P7TD ADIANTO QUE TAL VICIO NAO E APTO AO ACOLHIMENTO DO PEDIDO DE EXTINCAO DO FEITO, TAL COMO PRETENDE O EMBARGANTE. EXPLICO. EM DATA ANTERIOR A AUDIENCIA PAUTADA (MOV. 154.1) A PARTE AUTORA APRESENTOU NOS AUTOS PEDIDO DE CANCELAMENTO, DADA A AUSENCIA DE CITACAO DOS DEMAIS DEMANDADOS. POSTERIORMENTE A TAL PETICAO, A EMBARGANTE MANIFESTOU-SE CONCORDANDO COM O PEDIDO DA PARTE AUTORA QUANTO AO CANCELAMENTO DO ATO ( MOV. 155.1). CONTUDO, DADA A PROXIMIDADE DA DATA DA AUDIENCIA, OS AUTOS NAO VIERAM CONCLUSOS E O ATO PERMANECEU NA PAUTA, SENDO REALIZADO NA DATA E HORARIO INICIALMENTE DESIGNADO (MOV. 157). EM QUE PESE A AUSENCIA DE COMPARECIMENTO DA PARTE AUTORA NA AUDIENCIA SER CASO DE EXTINCAO DO FEITO SEM RESOLUCAO DE MERITO, NOS TERMOS DO ART. 51, I, DA LEI N 9.099/95, O CASO EM TELA E DOTADO DE PARTICULARIDADE, JA QUE, O EMBARGANTE HAVIA CONCORDADO COM O PEDIDO DE CANCELAMENTO DO ATO. ADEMAIS, A AUSENCIA DO AUTOR NA AUDIENCIA NAO GEROU PREJUIZO, VISTO QUE O ATO RESTARIA PREJUDICADO DE TODA FORMA, DIANTE DA AUSENCIA DE CITACAO DOS DEMAIS REUS. AINDA, EXTINCAO DO FEITO NESTA SITUACAO ATENTARIA CONTRA OS PRINCIPIOS DA ECONOMIA E CELERIDADE PROCESSUAL. PROJUDI - PROCESSO: 0032855-50.2020.8.16.0021 - REF. MOV. 180.1 - ASSINADO DIGITALMENTE POR VALMIR ZAIAS COSECHEN:8288 26/10/2022: EMBARGOS DE DECLARACAO ACOLHIDOS. ARQ: SENTENCA COMPARTILHA DESTE ENTENDIMENTO A TURMA RECURSAL: RECURSO INOMINADO. COBRANCA. AUSENCIA DO AUTOR NA AUDIENCIA DE CONCILIACAO. EXTINCAO DO PROCESSO SEM RESOLUCAO DO MERITO. NORMA DO ARTIGO 51, I, DA LEI 9.099 /95 RELATIVIZADA, NO CASO CONCRETO. REU NAO CITADO. NECESSIDADE DE REDESIGNACAO DA AUDIENCIA. PRINCIPIOS DE ECONOMIA E CELERIDADE PROCESSUAL. SENTENCA DESCONSTITUIDA PARA OPORTUNIZAR A RETOMADA DO CURSO PROCESSUAL. RECURSO PROVIDO. (TJPR - 2 TURMA RECURSAL - 0010423-73.2019.8.16.0182 - CURITIBA - REL.: JUIZ DE DIREITO DA TURMA RECURSAL DOS JUIZADOS ESPECIAIS HELDER LUIS HENRIQUE TAGUCHI - J. 16.04.2021) ISTO POSTO, CONHECO E, NO MERITO, ACOLHO OS EMBARGOS DE DECLARACAO, E SANANDO A OMISSAO, INDEFIRO O PEDIDO DE EXTINCAO DO FEITO SEM RESOLUCAO DE MERITO, MANTENDO A DECISAO QUE DETERMINOU O PROSSEGUIMENTO DO FEITO COM A DESIGNACAO DE NOVA AUDIENCIA DE CONCILIACAO. PUBLIQUE-SE. INTIME-SE. CASCAVEL (PR), DATADO ELETRONICAMENTE. VALMIR ZAIAS COSECHEN JUIZ DE DIREITO DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJSN8 85NQ8 H6L3P 7P7TD",
                "PublishDate": "2022-10-26T00:00:00",
                "CaptureDate": "2023-05-01T01:43:07"
              },
              {
                "Content": "CONCLUSOS PARA SENTENCA - EMBARGOS DE DECLARACAO RESPONSAVEL: VALMIR ZAIAS COSECHEN",
                "PublishDate": "2022-10-24T00:00:00",
                "CaptureDate": "2023-05-01T01:43:14"
              },
              {
                "Content": "JUNTADA DE PETICAO DE EMBARGOS DE DECLARACAO CUMPRIMENTO DE INTIMACAO - REFERENTE AO EVENTO DEFERIDO O PEDIDO (07/10/2022)",
                "PublishDate": "2022-10-22T00:00:00",
                "CaptureDate": "2023-05-01T01:43:14"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA REFERENTE AO EVENTO (SEQ. 166) DEFERIDO O PEDIDO (07/10/2022) E AO EVENTO DE EXPEDICAO SEQ. 168.",
                "PublishDate": "2022-10-22T00:00:00",
                "CaptureDate": "2023-05-01T01:43:14"
              },
              {
                "Content": "JUNTADA DE PETICAO DE MANIFESTACAO DA PARTE CUMPRIMENTO DE INTIMACAO - REFERENTE AO EVENTO AUDIENCIA DE CONCILIACAO DESIGNADA (17/10/2022)",
                "PublishDate": "2022-10-18T00:00:00",
                "CaptureDate": "2023-05-01T01:43:14"
              },
              {
                "Content": "ATO CUMPRIDO PELA PARTE OU INTERESSADO RENUNCIA DE PRAZO DE LEONI DA SILVA - REFERENTE AO EVENTO DEFERIDO O PEDIDO (07/10/2022)",
                "PublishDate": "2022-10-18T00:00:00",
                "CaptureDate": "2023-05-01T01:43:14"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA REFERENTE AO EVENTO (SEQ. 169) AUDIENCIA DE CONCILIACAO DESIGNADA (17/10/2022) E AO EVENTO DE EXPEDICAO SEQ. 170.",
                "PublishDate": "2022-10-18T00:00:00",
                "CaptureDate": "2023-05-01T01:43:14"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA REFERENTE AO EVENTO (SEQ. 166) DEFERIDO O PEDIDO (07/10/2022) E AO EVENTO DE EXPEDICAO SEQ. 167.",
                "PublishDate": "2022-10-18T00:00:00",
                "CaptureDate": "2023-05-01T01:43:14"
              },
              {
                "Content": "EXPEDICAO DE CITACAO PARA GILBERTO KLEY SILVA COM PRAZO ATE 23 DE JANEIRO DE 2023 - VIA AR DIGITAL - UTILIZANDO CONTRAFE",
                "PublishDate": "2022-10-17T00:00:00",
                "CaptureDate": "2023-05-01T01:43:14"
              },
              {
                "Content": "EXPEDICAO DE CITACAO PARA FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA COM PRAZO ATE 23 DE JANEIRO DE 2023 - VIA AR DIGITAL - UTILIZANDO CONTRAFE",
                "PublishDate": "2022-10-17T00:00:00",
                "CaptureDate": "2023-05-01T01:43:14"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO REFERENTE AO EVENTO (SEQ. 169) AUDIENCIA DE CONCILIACAO DESIGNADA (17/10/2022).",
                "PublishDate": "2022-10-17T00:00:00",
                "CaptureDate": "2023-05-01T01:43:14"
              },
              {
                "Content": "AUDIENCIA DE CONCILIACAO DESIGNADA (AGENDADA PARA: 23 DE JANEIRO DE 2023 AS 15:00, EM 2 JUIZADO ESPECIAL CIVEL DE CASCAVEL, MODALIDADE: VIRTUAL)",
                "PublishDate": "2022-10-17T00:00:00",
                "CaptureDate": "2023-05-01T01:43:14"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO REFERENTE AO EVENTO (SEQ. 166) DEFERIDO O PEDIDO (07/10/2022).",
                "PublishDate": "2022-10-17T00:00:00",
                "CaptureDate": "2023-05-01T01:43:14"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO REFERENTE AO EVENTO (SEQ. 166) DEFERIDO O PEDIDO (07/10/2022).",
                "PublishDate": "2022-10-17T00:00:00",
                "CaptureDate": "2023-05-01T01:43:14"
              },
              {
                "Content": "DEFERIDO O PEDIDO . VEICULADO NO DJEN EM 18/10/2022. PROJUDI - PROCESSO: 0032855-50.2020.8.16.0021 - REF. MOV. 166.1 - ASSINADO DIGITALMENTE POR VALMIR ZAIAS COSECHEN:8288 07/10/2022: DEFERIDO O PEDIDO. ARQ: DECISAO PODER JUDICIARIO DO ESTADO DO PARANA COMARCA DE CASCAVEL 2 JUIZADO ESPECIAL CIVEL DE CASCAVEL - PROJUDI AVENIDA TANCREDO NEVES, 2320 - ALTO ALEGRE - CASCAVEL/PR - CEP: 85.804-260 - FONE: (45) 3392-5068 - E-MAIL: CAS- 16VJ-S@TJPR.JUS.BR PROCESSO: 0032855-50.2020.8.16.0021 CLASSE PROCESSUAL: PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL ASSUNTO PRINCIPAL: PERDAS E DANOS VALOR DA CAUSA: R$9.000,00 POLO ATIVO(S): LEONI DA SILVA POLO PASSIVO(S): FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA GILBERTO KLEY SILVA STARK BANK S.A. DECISAO DESIGNE-SE NOVA AUDIENCIA DE CONCILIACAO. CITEM-SE OS REUS GILBERTO E FORTS NO ENDERECO RUA BELA CINTRA, 692, SOBRELOJA, BELA VISTA, SAO PAULO-SP, CEP 01.415-000, PARA QUE COMPARECAM A AUDIENCIA. DILIGENCIE-SE. DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJY6S 9MTMQ TDVQE 6X3SB CASCAVEL (PR), DATADO ELETRONICAMENTE. VALMIR ZAIAS COSECHEN JUIZ DE DIREITO",
                "PublishDate": "2022-10-07T00:00:00",
                "CaptureDate": "2023-05-01T01:43:14"
              },
              {
                "Content": "CONCLUSOS PARA SENTENCA RESPONSAVEL: VALMIR ZAIAS COSECHEN",
                "PublishDate": "2022-09-27T00:00:00",
                "CaptureDate": "2023-05-01T01:43:24"
              },
              {
                "Content": "JUNTADA DE COMPROVANTE DEVOLUCAO SEM LEITURA - DE CARTA PRECATORIA EXPEDIDO(A) (SEQ. 152) EM 29/04/2022 - REFERENTE AO EVENTO AUDIENCIA DE CONCILIACAO DESIGNADA (13/04/2022)",
                "PublishDate": "2022-09-27T00:00:00",
                "CaptureDate": "2023-05-01T01:43:24"
              },
              {
                "Content": "CONFIRMADA A COMUNICACAO ELETRONICA OFICIO JUIZO DEPRECADO LIDO(A) EM 20/09/2022 - REFERENTE AO EVENTO DE EXPEDICAO (SEQ. 161) EXPEDICAO DE OFICIO JUIZO DEPRECADO (12/09/2022 15:26:36)",
                "PublishDate": "2022-09-21T00:00:00",
                "CaptureDate": "2023-05-01T01:43:24"
              },
              {
                "Content": "EXPEDICAO DE MALOTE DIGITAL REFERENTE AO EVENTO (SEQ. 161) EXPEDICAO DE OFICIO JUIZO DEPRECADO(12/09/2022 15:26:36). IDENTIFICADOR DO CUMPRIMENTO: 0010",
                "PublishDate": "2022-09-15T00:00:00",
                "CaptureDate": "2023-05-01T01:43:24"
              },
              {
                "Content": "EXPEDICAO DE OFICIO JUIZO DEPRECADO REFERENTE AO EVENTO (SEQ. 159) DETERMINACAO DE DILIGENCIA(29/07/2022 15:04:20). IDENTIFICADOR DO CUMPRIMENTO: 0009 - UTILIZANDO ANEXOS PROJUDI - PROCESSO: 0032855-50.2020.8.16.0021 - REF. MOV. 161.1 - ASSINADO DIGITALMENTE POR OSVALDO ALVES DA SILVA:17020 12/09/2022: EXPEDICAO DE OFICIO JUIZO DEPRECADO. ARQ: OFICIO PODER JUDICIARIO DO ESTADO DO PARANA COMARCA DE CASCAVEL 2 JUIZADO ESPECIAL CIVEL DE CASCAVEL - PROJUDI AVENIDA TANCREDO NEVES, 2320 - ALTO ALEGRE - CASCAVEL/PR - CEP: 85.804-260 - FONE: (45) 3392-5068 - E-MAIL: CAS- 16VJ-S@TJPR.JUS.BR PROCESSO: 0032855-50.2020.8.16.0021 CLASSE PROCESSUAL: PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL ASSUNTO PRINCIPAL: PERDAS E DANOS POLO ATIVO(S): LEONI DA SILVA POLO PASSIVO(S): FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA GILBERTO KLEY SILVA OFICIO JUIZO DEPRECADO N463/2022 PROCESSO 0032855-50.2020.8.16.0021.0009 JUIZADO ESPECIAL CIVEL DA COMARCA DE CORONEL FABRICIANO R. BOA VISTA, 71 CENTRO CEL. FABRICIANO  MG CEP: 35170-041 EXMO (A) JUIZ (A): A FIM DE INSTRUIR OS AUTOS SUPRACITADOS, NA ACAO ONDE FIGURA COMO RECLAMANTE LEONI DA SILVA (CPF: 498.631.009-78), E COMO RECLAMADOS FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA (CNPJ: 21.160.553/0001-81), FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA (CNPJ: 10.685.786/0001-81), GILBERTO KLEY SILVA (CPF: 185.839.848-75), VENHO ATRAVES DESTE SOLICITAR A VOSSA EXCELENCIA INFORMACOES QUANTO AO CUMPRIMENTO DA CARTA PRECATORIA N. 0032855-50.2020.8.16.0021, EXPEDIDA NA DATA DE 29/04/2022, TENDO EM VISTA O DECURSO DOS PRAZOS PREVISTOS NO ITEM 17.2.7.7 DO CODIGO DE NORMAS. DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJZSJ BVGHF 7AVW5 YYBJU A OPORTUNIDADE E PROPICIA PARA APRESENTAR A VOSSA SENHORIA PROTESTOS DE ELEVADA ESTIMA E CONSIDERACAO. CASCAVEL, DATADO ELETRONICAMENTE. OSVALDO ALVES DA SILVA JUIZ DE DIREITO ASSINADO DIGITALMENTE",
                "PublishDate": "2022-09-12T00:00:00",
                "CaptureDate": "2023-05-01T01:43:24"
              },
              {
                "Content": "JUNTADA DE PETICAO DE MANIFESTACAO DA PARTE",
                "PublishDate": "2022-08-12T00:00:00",
                "CaptureDate": "2023-05-01T01:43:33"
              },
              {
                "Content": "DETERMINACAO DE DILIGENCIA . VEICULADO NO DJEN EM 12/08/2022. PROJUDI - PROCESSO: 0032855-50.2020.8.16.0021 - REF. MOV. 159.1 - ASSINADO DIGITALMENTE POR VALMIR ZAIAS COSECHEN:8288 29/07/2022: DETERMINACAO DE DILIGENCIA. ARQ: DECISAO PODER JUDICIARIO DO ESTADO DO PARANA COMARCA DE CASCAVEL 2 JUIZADO ESPECIAL CIVEL DE CASCAVEL - PROJUDI AVENIDA TANCREDO NEVES, 2320 - ALTO ALEGRE - CASCAVEL/PR - CEP: 85.804-260 - FONE: (45) 3392-5068 - E-MAIL: CAS-16VJ-S@TJPR. JUS.BR AUTOS N. 0032855-50.2020.8.16.0021 PROCESSO: 0032855-50.2020.8.16.0021 CLASSE PROCESSUAL: PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL ASSUNTO PRINCIPAL: PERDAS E DANOS VALOR DA CAUSA: R$9.000,00 POLO ATIVO(S): LEONI DA SILVA POLO PASSIVO(S): FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA GILBERTO KLEY SILVA STARK BANK S.A. DECISAO A SECRETARIA, OFICIE-SE AO JUIZO DEPRECADO SOLICITANDO INFORMACOES SOBRE O CUMPRIMENTO DA CARTA PRECATORIA (MOV. 152). EM SEGUIDA, VOLTEM CONCLUSOS PARA ANALISE DO PEDIDO DE MOV. 154. CASCAVEL (PR), DATADO ELETRONICAMENTE. DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJTD2 FCSAB SYAZ2 457PA VALMIR ZAIAS COSECHEN JUIZ DE DIREITO",
                "PublishDate": "2022-07-29T00:00:00",
                "CaptureDate": "2023-05-01T01:43:33"
              },
              {
                "Content": "CONCLUSOS PARA SENTENCA RESPONSAVEL: VALMIR ZAIAS COSECHEN",
                "PublishDate": "2022-07-19T00:00:00",
                "CaptureDate": "2023-05-01T01:43:45"
              },
              {
                "Content": "AUDIENCIA DE CONCILIACAO REALIZADA AUSENCIA DO REQUERIDO",
                "PublishDate": "2022-07-18T00:00:00",
                "CaptureDate": "2023-05-01T01:43:45"
              },
              {
                "Content": "JUNTADA DE PETICAO DE MANIFESTACAO DA PARTE",
                "PublishDate": "2022-07-18T00:00:00",
                "CaptureDate": "2023-05-01T01:43:45"
              },
              {
                "Content": "JUNTADA DE PETICAO DE SOLICITACAO DE CANCELAMENTO DE AUDIENCIA",
                "PublishDate": "2022-07-15T00:00:00",
                "CaptureDate": "2023-05-01T01:43:45"
              },
              {
                "Content": "JUNTADA DE PETICAO DE SOLICITACAO DE CANCELAMENTO DE AUDIENCIA",
                "PublishDate": "2022-07-06T00:00:00",
                "CaptureDate": "2023-05-01T01:43:45"
              },
              {
                "Content": "EXPEDICAO DE MALOTE DIGITAL REFERENTE AO EVENTO (SEQ. 152) EXPEDICAO DE CARTA PRECATORIA(29/04/2022 15:40:56). IDENTIFICADOR DO CUMPRIMENTO: 0008",
                "PublishDate": "2022-05-04T00:00:00",
                "CaptureDate": "2023-05-01T01:43:45"
              },
              {
                "Content": "EXPEDICAO DE CARTA PRECATORIA REFERENTE AO EVENTO (SEQ. 147) AUDIENCIA DE CONCILIACAO DESIGNADA(13/04/2022 15:40:50). IDENTIFICADOR DO CUMPRIMENTO: 0006 - UTILIZANDO ANEXOS PROJUDI - PROCESSO: 0032855-50.2020.8.16.0021 - REF. MOV. 152.1 - ASSINADO DIGITALMENTE POR VALMIR ZAIAS COSECHEN:8288 29/04/2022: EXPEDICAO DE CARTA PRECATORIA. ARQ: CARTA PRECATORIA PODER JUDICIARIO DO ESTADO DO PARANA COMARCA DE CASCAVEL 2 JUIZADO ESPECIAL CIVEL DE CASCAVEL - PROJUDI AVENIDA TANCREDO NEVES, 2320 - ALTO ALEGRE - CASCAVEL/PR - CEP: 85.804-260 - FONE: (45) 3392-5068 - E-MAIL: CAS-16VJ-S@TJPR.JUS.BR CARTA PRECATORIA-AUTOS N. 0032855-50.2020.8.16.0021 PRAZO DE CUMPRIMENTO 30 DIAS JUIZO DEPRECANTE: 2 JUIZADO ESPECIAL CIVEL DA COMARCA DE CASCAVEL/ PR JUIZO DEPRECADO: JUIZADO ESPECIAL CIVEL DA COMARCA DE CORONEL FABRICIANO/MG PROCESSO: 0032855-50.2020.8.16.0021 CLASSE PROCESSUAL: PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL ASSUNTO PRINCIPAL: PERDAS E DANOS VALOR DA CAUSA: R$9.000,00 POLO ATIVO(S): LEONI DA SILVA (RG: 31446210 SSP/PR E CPF/CNPJ: 498.631.009-78) AVENIDA SENADOR SOUZA NAVES, 901 - ALVORADA DO OESTE - LINDOESTE/PR - CEP: 85.826-000 POLO PASSIVO(S): FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA (CPF/CNPJ: 21.160.553/0001-81) RUA CASTANHEIRA, 277 - FLORESTA - CORONEL FABRICIANO/MG - CEP: 35.170-230 GILBERTO KLEY SILVA (CPF/CNPJ: 185.839.848-75) RUA CASTANHEIRA, 277 - FLORESTA - CORONEL FABRICIANO/MG - CEP: 35.170-230 SENHOR (A) JUIZ (A): O EXCELENTISSIMO SENHOR DOUTOR VALMIR ZAIAS COSECHEN MM. JUIZ DE DIREITO SUPERVISOR DO 2 JUIZADO ESPECIAL CIVEL DA COMARCA DE CASCAVEL DO ESTADO DO PARANA. DEPRECA AO EXCELENTISSIMO (A) SENHOR (A) DOUTOR (A) JUIZ (A) DO JUIZADO ESPECIAL CIVEL DA COMARCA DE CORONEL FABRICIANO/MG, PARA QUE SE DIGNE DETERMINAR COM O SEU RESPEITAVEL CUMPRA-SE, SEJA PROCEDIDA A CITACAO DO INTEIRO TEOR DO PEDIDO INICIAL, (CUJA COPIA SEGUE ANEXA) DOS RECLAMADOS FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA (CNPJ: 21.160.553/0001-81) E GILBERTO KLEY SILVA (CPF: 185.839.848-75), DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJDLG YDYM9 79XTA 7R8H3 PODENDO SER LOCALIZADO NO ENDERECO RUA CASTANHEIRA, 277 - FLORESTA - CORONEL FABRICIANO/MG - CEP: 35.170-230. INTIMANDO-O, PARA COMPARECER(EM) NA MODALIDADE VIRTUAL AO FORUM DA COMARCA DE CASCAVEL SITUADO NA AVENIDA TANCREDO NEVES, 2320 - ALTO ALEGRE - CASCAVEL/PR - CEP: 85.804-260 - FONE: (45) 3392-5068 - E-MAIL: CAS-16VJ-S@TJPR.JUS.BR, PARA PARTICIPAR DE AUDIENCIA DE CONCILIACAO EM DATA 18 DE JULHO DE 2022 AS 13:00:00 - MODALIDADE: VIRTUAL - CHAVE DA AUDIENCIA: PADYX YCXAX GHU39 EKNZZ , REFERENTE AOS AUTOS EM EPIGRAFE. INTIMANDO-O TAMBEM, DE QUE O NAO COMPARECIMENTO IMPLICARA NA APLICACAO DAS PENAS DE REVELIA, SENDO CONSIDERADOS VERDADEIROS OS FATOS ALEGADOS PELO AUTOR. SEM MAIS, A OPORTUNIDADE E PROPICIA PARA RENOVAR A VOSSA EXCELENCIA RESPEITOSAMENTE MEUS CUMPRIMENTOS. AO EXCELENTISSIMO (A) SENHOR (A) DOUTOR (A) JUIZ (A) DE DIREITO JUIZADO ESPECIAL CIVEL DA COMARCA DE CORONEL FABRICIANO/MG. R. BOA VISTA, 72 - CENTRO, CEL. FABRICIANO - MG, 35170-041 VALMIR ZAIAS COSECHEN JUIZ DE DIREITO ASSINADO DIGITALMENTE",
                "PublishDate": "2022-04-29T00:00:00",
                "CaptureDate": "2023-05-01T01:43:45"
              },
              {
                "Content": "JUNTADA DE PETICAO DE CUMPRIMENTO DE INTIMACAO CUMPRIMENTO DE INTIMACAO - REFERENTE AO EVENTO AUDIENCIA DE CONCILIACAO DESIGNADA (13/04/2022)",
                "PublishDate": "2022-04-29T00:00:00",
                "CaptureDate": "2023-05-01T01:43:56"
              },
              {
                "Content": "EXPEDICAO DE ATO ORDINATORIO REFERENTE AO EVENTO (SEQ. 149) CONFIRMADA A INTIMACAO ELETRONICA(24/04/2022 00:07:27). IDENTIFICADOR DO CUMPRIMENTO: 0007",
                "PublishDate": "2022-04-28T00:00:00",
                "CaptureDate": "2023-05-01T01:43:56"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA REFERENTE AO EVENTO (SEQ. 147) AUDIENCIA DE CONCILIACAO DESIGNADA (13/04/2022) E AO EVENTO DE EXPEDICAO SEQ. 148.",
                "PublishDate": "2022-04-24T00:00:00",
                "CaptureDate": "2023-05-01T01:43:56"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO REFERENTE AO EVENTO (SEQ. 147) AUDIENCIA DE CONCILIACAO DESIGNADA (13/04/2022).",
                "PublishDate": "2022-04-13T00:00:00",
                "CaptureDate": "2023-05-01T01:43:56"
              },
              {
                "Content": "AUDIENCIA DE CONCILIACAO DESIGNADA (AGENDADA PARA: 18 DE JULHO DE 2022 AS 13:00, EM 2 JUIZADO ESPECIAL CIVEL DE CASCAVEL, MODALIDADE: VIRTUAL)",
                "PublishDate": "2022-04-13T00:00:00",
                "CaptureDate": "2023-05-01T01:43:56"
              },
              {
                "Content": "JUNTADA DE PETICAO DE REQUERIMENTO DE DILIGENCIA CUMPRIMENTO DE INTIMACOES - REFERENTE AOS EVENTOS JUNTADA DE INTIMACAO ONLINE (02/03/2022), AUDIENCIA DE CONCILIACAO CANCELADA (18/03/2022)",
                "PublishDate": "2022-03-29T00:00:00",
                "CaptureDate": "2023-05-01T01:43:56"
              },
              {
                "Content": "JUNTADA DE PETICAO DE CUMPRIMENTO DE INTIMACAO CUMPRIMENTO DE INTIMACAO - REFERENTE AO EVENTO AUDIENCIA DE CONCILIACAO DESIGNADA (10/02/2022)",
                "PublishDate": "2022-03-29T00:00:00",
                "CaptureDate": "2023-05-01T01:43:56"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA REFERENTE AO EVENTO (SEQ. 142) AUDIENCIA DE CONCILIACAO CANCELADA (18/03/2022) E AO EVENTO DE EXPEDICAO SEQ. 143.",
                "PublishDate": "2022-03-29T00:00:00",
                "CaptureDate": "2023-05-01T01:43:56"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO REFERENTE AO EVENTO (SEQ. 142) AUDIENCIA DE CONCILIACAO CANCELADA (18/03/2022).",
                "PublishDate": "2022-03-18T00:00:00",
                "CaptureDate": "2023-05-01T01:43:56"
              },
              {
                "Content": "AUDIENCIA DE CONCILIACAO CANCELADA CANCELADA",
                "PublishDate": "2022-03-18T00:00:00",
                "CaptureDate": "2023-05-01T01:43:56"
              },
              {
                "Content": "JUNTADA DE COMPROVANTE DEVOLUCAO SEM LEITURA - INTIMACAO EXPEDIDA EM 10/02/2022 PARA FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA - REFERENTE AO EVENTO AUDIENCIA DE CONCILIACAO DESIGNADA (10/02/2022)",
                "PublishDate": "2022-03-17T00:00:00",
                "CaptureDate": "2023-05-01T01:43:56"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA REFERENTE AO EVENTO (SEQ. 134) JUNTADA DE INTIMACAO ONLINE (02/03/2022) E AO EVENTO DE EXPEDICAO SEQ. 135.",
                "PublishDate": "2022-03-13T00:00:00",
                "CaptureDate": "2023-05-01T01:43:56"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA REFERENTE AO EVENTO (SEQ. 130) JUNTADA DE INTIMACAO ONLINE (02/03/2022) E AO EVENTO DE EXPEDICAO SEQ. 131.",
                "PublishDate": "2022-03-13T00:00:00",
                "CaptureDate": "2023-05-01T01:43:56"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA REFERENTE AO EVENTO (SEQ. 127) JUNTADA DE INTIMACAO ONLINE (02/03/2022) E AO EVENTO DE EXPEDICAO SEQ. 128.",
                "PublishDate": "2022-03-13T00:00:00",
                "CaptureDate": "2023-05-01T01:43:56"
              },
              {
                "Content": "JUNTADA DE COMPROVANTE DEVOLUCAO SEM LEITURA - REFERENTE A CITACAO EXPEDIDA EM 10/02/2022 PARA GILBERTO KLEY SILVA",
                "PublishDate": "2022-03-10T00:00:00",
                "CaptureDate": "2023-05-01T01:43:56"
              },
              {
                "Content": "JUNTADA DE COMPROVANTE DEVOLUCAO SEM LEITURA - REFERENTE A CITACAO EXPEDIDA EM 10/02/2022 PARA FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA",
                "PublishDate": "2022-03-10T00:00:00",
                "CaptureDate": "2023-05-01T01:43:56"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO PARA ADVOGADOS/CURADOR/DEFENSOR DE LEONI DA SILVA COM PRAZO DE 15 DIAS UTEIS - REFERENTE AO EVENTO (SEQ. 134) JUNTADA DE INTIMACAO ONLINE (02/03/2022)",
                "PublishDate": "2022-03-02T00:00:00",
                "CaptureDate": "2023-05-01T01:43:56"
              },
              {
                "Content": "JUNTADA DE INTIMACAO ONLINE",
                "PublishDate": "2022-03-02T00:00:00",
                "CaptureDate": "2023-05-01T01:43:56"
              },
              {
                "Content": "JUNTADA DE COMPROVANTE DEVOLUCAO SEM LEITURA - REFERENTE A CITACAO EXPEDIDA EM 10/02/2022 PARA GILBERTO KLEY SILVA",
                "PublishDate": "2022-03-02T00:00:00",
                "CaptureDate": "2023-05-01T01:43:56"
              },
              {
                "Content": "JUNTADA DE COMPROVANTE DEVOLUCAO SEM LEITURA - REFERENTE A CITACAO EXPEDIDA EM 10/02/2022 PARA FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA",
                "PublishDate": "2022-03-02T00:00:00",
                "CaptureDate": "2023-05-01T01:43:56"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO PARA ADVOGADOS/CURADOR/DEFENSOR DE LEONI DA SILVA COM PRAZO DE 15 DIAS UTEIS - REFERENTE AO EVENTO (SEQ. 130) JUNTADA DE INTIMACAO ONLINE (02/03/2022)",
                "PublishDate": "2022-03-02T00:00:00",
                "CaptureDate": "2023-05-01T01:43:56"
              },
              {
                "Content": "JUNTADA DE INTIMACAO ONLINE",
                "PublishDate": "2022-03-02T00:00:00",
                "CaptureDate": "2023-05-01T01:43:56"
              },
              {
                "Content": "JUNTADA DE COMPROVANTE DEVOLUCAO SEM LEITURA - REFERENTE A CITACAO EXPEDIDA EM 10/02/2022 PARA GILBERTO KLEY SILVA",
                "PublishDate": "2022-03-02T00:00:00",
                "CaptureDate": "2023-05-01T01:43:56"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO PARA ADVOGADOS/CURADOR/DEFENSOR DE LEONI DA SILVA COM PRAZO DE 15 DIAS UTEIS - REFERENTE AO EVENTO (SEQ. 127) JUNTADA DE INTIMACAO ONLINE (02/03/2022)",
                "PublishDate": "2022-03-02T00:00:00",
                "CaptureDate": "2023-05-01T01:43:56"
              },
              {
                "Content": "JUNTADA DE INTIMACAO ONLINE",
                "PublishDate": "2022-03-02T00:00:00",
                "CaptureDate": "2023-05-01T01:43:56"
              },
              {
                "Content": "JUNTADA DE COMPROVANTE DEVOLUCAO SEM LEITURA - REFERENTE A CITACAO EXPEDIDA EM 10/02/2022 PARA FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA",
                "PublishDate": "2022-03-02T00:00:00",
                "CaptureDate": "2023-05-01T01:43:56"
              },
              {
                "Content": "JUNTADA DE PETICAO DE MANIFESTACAO DA PARTE CUMPRIMENTO DE INTIMACAO - REFERENTE AO EVENTO AUDIENCIA DE CONCILIACAO DESIGNADA (10/02/2022)",
                "PublishDate": "2022-02-21T00:00:00",
                "CaptureDate": "2023-05-01T01:43:56"
              },
              {
                "Content": "ATO CUMPRIDO PELA PARTE OU INTERESSADO RENUNCIA DE PRAZO DE STARK BANK S.A. - REFERENTE AO EVENTO DEFERIDO O PEDIDO (08/02/2022)",
                "PublishDate": "2022-02-21T00:00:00",
                "CaptureDate": "2023-05-01T01:43:56"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA (PELO ADVOGADO/CURADOR/DEFENSOR DE STARK BANK S.A.) EM 21/02/2022 COM PRAZO DE 1 DE ABRIL DE 2022 *REFERENTE AO EVENTO (SEQ. 109) AUDIENCIA DE CONCILIACAO DESIGNADA (10/02/2022) E AO EVENTO DE EXPEDICAO SEQ. 111.",
                "PublishDate": "2022-02-21T00:00:00",
                "CaptureDate": "2023-05-01T01:43:56"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA (PELO ADVOGADO/CURADOR/DEFENSOR DE STARK BANK S.A.) EM 18/02/2022 COM PRAZO DE 5 DIAS UTEIS *REFERENTE AO EVENTO (SEQ. 102) DEFERIDO O PEDIDO (08/02/2022) E AO EVENTO DE EXPEDICAO SEQ. 103.",
                "PublishDate": "2022-02-19T00:00:00",
                "CaptureDate": "2023-05-01T01:43:56"
              },
              {
                "Content": "JUNTADA DE PETICAO DE CUMPRIMENTO DE INTIMACAO CUMPRIMENTO DE INTIMACAO - REFERENTE AO EVENTO DEFERIDO O PEDIDO (08/02/2022)",
                "PublishDate": "2022-02-16T00:00:00",
                "CaptureDate": "2023-05-01T01:43:56"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA (PELO ADVOGADO/CURADOR/DEFENSOR DE LEONI DA SILVA) EM 16/02/2022 COM PRAZO DE 5 DIAS UTEIS *REFERENTE AO EVENTO (SEQ. 102) DEFERIDO O PEDIDO (08/02/2022) E AO EVENTO DE EXPEDICAO SEQ. 104.",
                "PublishDate": "2022-02-16T00:00:00",
                "CaptureDate": "2023-05-01T01:43:56"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA (PELO ADVOGADO/CURADOR/DEFENSOR DE LEONI DA SILVA) EM 16/02/2022 COM PRAZO DE 1 DE ABRIL DE 2022 *REFERENTE AO EVENTO (SEQ. 109) AUDIENCIA DE CONCILIACAO DESIGNADA (10/02/2022) E AO EVENTO DE EXPEDICAO SEQ. 110.",
                "PublishDate": "2022-02-16T00:00:00",
                "CaptureDate": "2023-05-01T01:43:56"
              },
              {
                "Content": "EXPEDICAO DE CITACAO PARA GILBERTO KLEY SILVA COM PRAZO ATE 1 DE ABRIL DE 2022 - VIA AR DIGITAL - UTILIZANDO CONTRAFE",
                "PublishDate": "2022-02-10T00:00:00",
                "CaptureDate": "2023-05-01T01:43:56"
              },
              {
                "Content": "EXPEDICAO DE CITACAO PARA FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA COM PRAZO ATE 1 DE ABRIL DE 2022 - VIA AR DIGITAL - UTILIZANDO CONTRAFE",
                "PublishDate": "2022-02-10T00:00:00",
                "CaptureDate": "2023-05-01T01:43:56"
              },
              {
                "Content": "EXPEDICAO DE CITACAO PARA GILBERTO KLEY SILVA COM PRAZO ATE 1 DE ABRIL DE 2022 - VIA AR DIGITAL - UTILIZANDO CONTRAFE",
                "PublishDate": "2022-02-10T00:00:00",
                "CaptureDate": "2023-05-01T01:43:56"
              },
              {
                "Content": "EXPEDICAO DE CITACAO PARA FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA COM PRAZO ATE 1 DE ABRIL DE 2022 - VIA AR DIGITAL - UTILIZANDO CONTRAFE",
                "PublishDate": "2022-02-10T00:00:00",
                "CaptureDate": "2023-05-01T01:43:56"
              },
              {
                "Content": "EXPEDICAO DE CITACAO PARA GILBERTO KLEY SILVA COM PRAZO ATE 1 DE ABRIL DE 2022 - VIA AR DIGITAL - UTILIZANDO CONTRAFE",
                "PublishDate": "2022-02-10T00:00:00",
                "CaptureDate": "2023-05-01T01:43:56"
              },
              {
                "Content": "EXPEDICAO DE CITACAO PARA FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA COM PRAZO ATE 1 DE ABRIL DE 2022 - VIA AR DIGITAL - UTILIZANDO CONTRAFE",
                "PublishDate": "2022-02-10T00:00:00",
                "CaptureDate": "2023-05-01T01:43:56"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO PARA FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA COM PRAZO DE 1 DE ABRIL DE 2022 - REFERENTE AO EVENTO (SEQ. 109) AUDIENCIA DE CONCILIACAO DESIGNADA (10/02/2022) - VIA AR DIGITAL - UTILIZANDO ANEXOS",
                "PublishDate": "2022-02-10T00:00:00",
                "CaptureDate": "2023-05-01T01:43:56"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO PARA ADVOGADOS/CURADOR/DEFENSOR DE STARK BANK S.A. COM PRAZO DE 1 DE ABRIL DE 2022 - REFERENTE AO EVENTO (SEQ. 109) AUDIENCIA DE CONCILIACAO DESIGNADA (10/02/2022)",
                "PublishDate": "2022-02-10T00:00:00",
                "CaptureDate": "2023-05-01T01:43:56"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO PARA ADVOGADOS/CURADOR/DEFENSOR DE LEONI DA SILVA COM PRAZO DE 1 DE ABRIL DE 2022 - REFERENTE AO EVENTO (SEQ. 109) AUDIENCIA DE CONCILIACAO DESIGNADA (10/02/2022)",
                "PublishDate": "2022-02-10T00:00:00",
                "CaptureDate": "2023-05-01T01:43:56"
              },
              {
                "Content": "AUDIENCIA DE CONCILIACAO DESIGNADA (AGENDADA PARA: 01 DE ABRIL DE 2022 AS 14:31, EM 2 JUIZADO ESPECIAL CIVEL DE CASCAVEL, MODALIDADE: VIRTUAL)",
                "PublishDate": "2022-02-10T00:00:00",
                "CaptureDate": "2023-05-01T01:43:56"
              },
              {
                "Content": "AUDIENCIA DE CONCILIACAO REDESIGNADA REDESIGNADA",
                "PublishDate": "2022-02-10T00:00:00",
                "CaptureDate": "2023-05-01T01:43:56"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE . VEICULADO NO DJEN EM 11/02/2022. PROJUDI - PROCESSO: 0032855-50.2020.8.16.0021 - REF. MOV. 107.1 - ASSINADO DIGITALMENTE POR VALMIR ZAIAS COSECHEN:23299517953 10/02/2022: PROFERIDO DESPACHO DE MERO EXPEDIENTE. ARQ: DESPACHO PODER JUDICIARIO DO ESTADO DO PARANA COMARCA DE CASCAVEL 2 JUIZADO ESPECIAL CIVEL DE CASCAVEL - PROJUDI AVENIDA TANCREDO NEVES, 2320 - ALTO ALEGRE - CASCAVEL/PR - CEP: 85.804-260 - FONE: (45) 3392-5068 - E-MAIL: CAS-16VJ-S@TJPR.JUS.BR AUTOS N. 0032855-50.2020.8.16.0021 PROCESSO: 0032855-50.2020.8.16.0021 CLASSE PROCESSUAL: PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL ASSUNTO PRINCIPAL: PERDAS E DANOS VALOR DA CAUSA: R$9.000,00 POLO ATIVO(S): LEONI DA SILVA POLO PASSIVO(S): FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA GILBERTO KLEY SILVA STARK BANK S.A. DESPACHO A SECRETARIA, COM RELACAO A CARTA PRECATORIA DE MOV. 88, REGISTRO QUE O PROPRIO AUTOR TROUXE AOS AUTOS COPIA INTEGRAL DA CARTA PRECATORIA INDICANDO QUE AS CITACOES NAO FORAM REALIZADAS ( MOV. 100.2), RAZAO PELA QUAL MOSTRA-SE DESNECESSARIO AGUARDAR O RETORNO FORMAL DA CARTA PRECATORIA SE JA SE SABE QUE ELA NAO FOI CUMPRIDA. DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJDHN 7KYZX 3DR2L TE2ZU ASSIM, CUMPRA-SE A DECISAO DE MOV. 102. CASCAVEL (PR), DATADO ELETRONICAMENTE. VALMIR ZAIAS COSECHEN JUIZ DE DIREITO",
                "PublishDate": "2022-02-10T00:00:00",
                "CaptureDate": "2023-05-01T01:43:56"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO RESPONSAVEL: VALMIR ZAIAS COSECHEN",
                "PublishDate": "2022-02-08T00:00:00",
                "CaptureDate": "2023-05-01T01:44:05"
              },
              {
                "Content": "JUNTADA DE CERTIDAO",
                "PublishDate": "2022-02-08T00:00:00",
                "CaptureDate": "2023-05-01T01:44:05"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO PARA ADVOGADOS/CURADOR/DEFENSOR DE LEONI DA SILVA COM PRAZO DE 5 DIAS UTEIS - REFERENTE AO EVENTO (SEQ. 102) DEFERIDO O PEDIDO (08/02/2022)",
                "PublishDate": "2022-02-08T00:00:00",
                "CaptureDate": "2023-05-01T01:44:05"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO PARA ADVOGADOS/CURADOR/DEFENSOR DE STARK BANK S.A. COM PRAZO DE 5 DIAS UTEIS - REFERENTE AO EVENTO (SEQ. 102) DEFERIDO O PEDIDO (08/02/2022)",
                "PublishDate": "2022-02-08T00:00:00",
                "CaptureDate": "2023-05-01T01:44:05"
              },
              {
                "Content": "DEFERIDO O PEDIDO . VEICULADO NO DJEN EM 11/02/2022. PROJUDI - PROCESSO: 0032855-50.2020.8.16.0021 - REF. MOV. 102.1 - ASSINADO DIGITALMENTE POR VALMIR ZAIAS COSECHEN:23299517953 08/02/2022: DEFERIDO O PEDIDO. ARQ: DECISAO PODER JUDICIARIO DO ESTADO DO PARANA COMARCA DE CASCAVEL 2 JUIZADO ESPECIAL CIVEL DE CASCAVEL - PROJUDI AVENIDA TANCREDO NEVES, 2320 - ALTO ALEGRE - CASCAVEL/PR - CEP: 85.804-260 - FONE: (45) 3392-5068 - E-MAIL: CAS-16VJ-S@TJPR.JUS.BR AUTOS N. 0032855-50.2020.8.16.0021 PROCESSO: 0032855-50.2020.8.16.0021 CLASSE PROCESSUAL: PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL ASSUNTO PRINCIPAL: PERDAS E DANOS VALOR DA CAUSA: R$9.000,00 POLO ATIVO(S): LEONI DA SILVA POLO PASSIVO(S): FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA GILBERTO KLEY SILVA STARK BANK S.A. DECISAO 1. COMPULSANDO-SE OS AUTOS, PUDE PERCEBER QUE ATE O PRESENTE MOMENTO OS REUS FORTS CONSULTORIA E GILBERTO KLEY AINDA NAO FORAM CITADOS, ESTANDO A AUDIENCIA DE CONCILIACAO DESIGNADA PROXIMA DE OCORRER SEM A REALIZACAO DA REFERIDA CITACAO. 2. ASSIM, DETERMINO A SECRETARIA JUDICIARIA AS SEGUINTES PROVIDENCIAS: DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJTUK RDTL3 ZPH48 EHFMR A) CANCELE-SE A AUDIENCIA DE CONCILIACAO DESIGNADA, CIENTIFICANDO-SE AS PARTES; B) DESIGNE-SE NOVA AUDIENCIA DE CONCILIACAO E CITEM-SE OS REUS FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA E SEU SOCIO GILBERTO KLEY SILVA NOS ENDERECOS ABAIXO, LOCALIZADOS ATRAVES DA CONSULTA AO SISBAJUD, MEDIANTE CARTA COM AVISO DE RECEBIMENTO: - R CASTANHEIR, 277, CO FLORESTA, CEP 35170- 230, CORONEL FABRICIANO-MG; - R ROSALINA AGUIAR LENTZ, 720, 88495-500, GAROPABA-SC; - SAO CAETANO, 525, AP 506, CENTRO, 93.010- 090, SAO LEOPOLDO-RS 3. INTIME-SE, IGUALMENTE, O AUTOR PARA COMPARECIMENTO A AUDIENCIA. PROJUDI - PROCESSO: 0032855-50.2020.8.16.0021 - REF. MOV. 102.1 - ASSINADO DIGITALMENTE POR VALMIR ZAIAS COSECHEN:23299517953 08/02/2022: DEFERIDO O PEDIDO. ARQ: DECISAO 4. REGISTRO QUE, AO CONTRARIO DO QUE SUSTENTOU O AUTOR, NAO HA SE FALAR EM CITACAO PARA CONTESTAR, DEVENDO O RITO DOS JUIZADOS SER OBEDECIDO. 5. DILIGENCIAS NECESSARIAS. CASCAVEL (PR), DATADO ELETRONICAMENTE. VALMIR ZAIAS COSECHEN JUIZ DE DIREITO DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJTUK RDTL3 ZPH48 EHFMR",
                "PublishDate": "2022-02-08T00:00:00",
                "CaptureDate": "2023-05-01T01:44:05"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO RESPONSAVEL: VALMIR ZAIAS COSECHEN",
                "PublishDate": "2022-02-07T00:00:00",
                "CaptureDate": "2023-05-01T01:44:12"
              },
              {
                "Content": "JUNTADA DE PETICAO DE CUMPRIMENTO DE INTIMACAO CUMPRIMENTO DE INTIMACOES - REFERENTE AOS EVENTOS AUDIENCIA DE CONCILIACAO DESIGNADA (19/11/2021), JUNTADA DE COMPROVANTE (10/12/2021)",
                "PublishDate": "2022-02-07T00:00:00",
                "CaptureDate": "2023-05-01T01:44:12"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA (PELO ADVOGADO/CURADOR/DEFENSOR DE LEONI DA SILVA) EM 10/01/2022 COM PRAZO DE 15 DIAS UTEIS *REFERENTE AO EVENTO (SEQ. 97) JUNTADA DE COMPROVANTE (10/12/2021) E AO EVENTO DE EXPEDICAO SEQ. 98.",
                "PublishDate": "2021-12-21T00:00:00",
                "CaptureDate": "2023-05-01T01:44:12"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO PARA ADVOGADOS/CURADOR/DEFENSOR DE LEONI DA SILVA COM PRAZO DE 15 DIAS UTEIS - REFERENTE AO EVENTO (SEQ. 97) JUNTADA DE COMPROVANTE (10/12/2021)",
                "PublishDate": "2021-12-10T00:00:00",
                "CaptureDate": "2023-05-01T01:44:12"
              },
              {
                "Content": "JUNTADA DE COMPROVANTE DEVOLUCAO SEM LEITURA - INTIMACAO EXPEDIDA EM 19/11/2021 PARA FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA - REFERENTE AO EVENTO AUDIENCIA DE CONCILIACAO DESIGNADA (19/11/2021)",
                "PublishDate": "2021-12-10T00:00:00",
                "CaptureDate": "2023-05-01T01:44:12"
              },
              {
                "Content": "DECORRIDO PRAZO DE STARK BANK S.A. (P/ ADVGS. DE STARK BANK S.A. *REFERENTE AO EVENTO (SEQ. 79) DEFERIDO O PEDIDO (19/11/2021) E AO EVENTO DE EXPEDICAO SEQ. 80.",
                "PublishDate": "2021-12-03T00:00:00",
                "CaptureDate": "2023-05-01T01:44:12"
              },
              {
                "Content": "JUNTADA DE PETICAO DE MANIFESTACAO DA PARTE CUMPRIMENTO DE INTIMACAO - REFERENTE AO EVENTO DEFERIDO O PEDIDO (19/11/2021)",
                "PublishDate": "2021-11-29T00:00:00",
                "CaptureDate": "2023-05-01T01:44:12"
              },
              {
                "Content": "JUNTADA DE PETICAO DE MANIFESTACAO DA PARTE CUMPRIMENTO DE INTIMACAO - REFERENTE AO EVENTO AUDIENCIA DE CONCILIACAO DESIGNADA (19/11/2021)",
                "PublishDate": "2021-11-25T00:00:00",
                "CaptureDate": "2023-05-01T01:44:12"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA (PELO ADVOGADO/CURADOR/DEFENSOR DE STARK BANK S.A.) EM 25/11/2021 COM PRAZO DE 24 DE FEVEREIRO DE 2022 *REFERENTE AO EVENTO (SEQ. 83) AUDIENCIA DE CONCILIACAO DESIGNADA (19/11/2021) E AO EVENTO DE EXPEDICAO SEQ. 84.",
                "PublishDate": "2021-11-25T00:00:00",
                "CaptureDate": "2023-05-01T01:44:12"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA (PELO ADVOGADO/CURADOR/DEFENSOR DE STARK BANK S.A.) EM 25/11/2021 COM PRAZO DE 5 DIAS UTEIS *REFERENTE AO EVENTO (SEQ. 79) DEFERIDO O PEDIDO (19/11/2021) E AO EVENTO DE EXPEDICAO SEQ. 80.",
                "PublishDate": "2021-11-25T00:00:00",
                "CaptureDate": "2023-05-01T01:44:12"
              },
              {
                "Content": "EXPEDICAO DE MALOTE DIGITAL REFERENTE AO EVENTO (SEQ. 88) EXPEDICAO DE CARTA PRECATORIA(23/11/2021 16:05:51). IDENTIFICADOR DO CUMPRIMENTO: 0003",
                "PublishDate": "2021-11-24T00:00:00",
                "CaptureDate": "2023-05-01T01:44:12"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA (PELO ADVOGADO/CURADOR/DEFENSOR DE LEONI DA SILVA) EM 24/11/2021 COM PRAZO DE 24 DE FEVEREIRO DE 2022 *REFERENTE AO EVENTO (SEQ. 83) AUDIENCIA DE CONCILIACAO DESIGNADA (19/11/2021) E AO EVENTO DE EXPEDICAO SEQ. 85.",
                "PublishDate": "2021-11-24T00:00:00",
                "CaptureDate": "2023-05-01T01:44:12"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA (PELO ADVOGADO/CURADOR/DEFENSOR DE LEONI DA SILVA) EM 24/11/2021 COM PRAZO DE 5 DIAS UTEIS *REFERENTE AO EVENTO (SEQ. 79) DEFERIDO O PEDIDO (19/11/2021) E AO EVENTO DE EXPEDICAO SEQ. 81.",
                "PublishDate": "2021-11-24T00:00:00",
                "CaptureDate": "2023-05-01T01:44:12"
              },
              {
                "Content": "EXPEDICAO DE CARTA PRECATORIA REFERENTE AO EVENTO (SEQ. 83) AUDIENCIA DE CONCILIACAO DESIGNADA(19/11/2021 15:03:12). IDENTIFICADOR DO CUMPRIMENTO: 0002 PROJUDI - PROCESSO: 0032855-50.2020.8.16.0021 - REF. MOV. 88.1 - ASSINADO DIGITALMENTE POR VALMIR ZAIAS COSECHEN:23299517953 23/11/2021: EXPEDICAO DE CARTA PRECATORIA. ARQ: CARTA PRECATORIA PODER JUDICIARIO DO ESTADO DO PARANA COMARCA DE CASCAVEL 2 JUIZADO ESPECIAL CIVEL DE CASCAVEL - PROJUDI AVENIDA TANCREDO NEVES, 2320 - ALTO ALEGRE - CASCAVEL/PR - CEP: 85.804-260 - FONE: (45) 3392-5068 - E-MAIL: CAS-16VJ-S@TJPR.JUS.BR CARTA PRECATORIA-AUTOS N. 0032855-50.2020.8.16.0021 PRAZO DE CUMPRIMENTO 30 DIAS JUIZO DEPRECANTE: 2 JUIZADO ESPECIAL CIVEL DA COMARCA DE CASCAVEL/ PR JUIZO DEPRECADO: JUIZADO ESPECIAL CIVEL DA COMARCA DE CAMPO BOM/RS PROCESSO: 0032855-50.2020.8.16.0021 CLASSE PROCESSUAL: PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL ASSUNTO PRINCIPAL: PERDAS E DANOS VALOR DA CAUSA: R$9.000,00 POLO ATIVO(S): LEONI DA SILVA (RG: 31446210 SSP/PR E CPF/CNPJ: 498.631.009-78) AVENIDA SENADOR SOUZA NAVES, 901 - ALVORADA DO OESTE - LINDOESTE/PR - CEP: 85.826-000 POLO PASSIVO(S): FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA (CPF/CNPJ: 21.160.553/0001-81) RUA JOSE DE ANCHIETA , 288 AP 01 - IMIGRANTE DO SUL - CAMPO BOM/RS - CEP: 93.700-000 GILBERTO KLEY SILVA (CPF/CNPJ: 185.839.848-75) RUA JOSE DE ANCHIETA, 288 AP 1 - CENTRO - CAMPO BOM/RS - CEP: 93.700-000 SENHOR (A) JUIZ (A): O EXCELENTISSIMO SENHOR DOUTOR VALMIR ZAIAS COSECHEN MM. JUIZ DE DIREITO SUPERVISOR DO 2 JUIZADO ESPECIAL CIVEL DA COMARCA DE CASCAVEL DO ESTADO DO PARANA. DEPRECA AO EXCELENTISSIMO (A) SENHOR (A) DOUTOR (A) JUIZ (A) DO JUIZADO ESPECIAL CIVEL DA COMARCA DE CAMPO BOM/RS, PARA QUE SE DIGNE DETERMINAR COM O SEU RESPEITAVEL CUMPRA-SE, SEJA PROCEDIDA A CITACAO DO INTEIRO TEOR DO PEDIDO INICIAL, (CUJA COPIA SEGUE ANEXA) DOS RECLAMADOS FORTS CONSULTORIA E TECNOLOGIA EM DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJSJC R3LVF BQ2C7 L697D FINANCAS LTDA (CPF/CNPJ: 21.160.553/0001-81) E GILBERTO KLEY SILVA (CPF/CNPJ: 185.839.848-75) AMBOS PODEM SER LOCALIZADO NO ENDERECORUA JOSE DE ANCHIETA, 288 AP 1 - CENTRO - CAMPO BOM/RS - CEP: 93.700-000. INTIMANDO-O, PARA COMPARECER(EM) NA MODALIDADE VIRTUAL AO FORUM DA COMARCA DE CASCAVEL SITUADO NA AVENIDA TANCREDO NEVES, 2320 - ALTO ALEGRE - CASCAVEL/PR - CEP: 85.804-260 - FONE: (45) 3392-5068 - E-MAIL: CAS-16VJ-S@TJPR.JUS.BR, PARA PARTICIPAR DE AUDIENCIA DE CONCILIACAO EM DATA 24 DE FEVEREIRO DE 2022 AS 16:00:00 - MODALIDADE: VIRTUAL - CHAVE DA AUDIENCIA: PABF2 8ME6P 2AYKW R5X5Q, REFERENTE AOS AUTOS EM EPIGRAFE. INTIMANDO-O TAMBEM, DE QUE O NAO COMPARECIMENTO IMPLICARA NA APLICACAO DAS PENAS DE REVELIA, SENDO CONSIDERADOS VERDADEIROS OS FATOS ALEGADOS PELO AUTOR. SEM MAIS, A OPORTUNIDADE E PROPICIA PARA RENOVAR A VOSSA EXCELENCIA RESPEITOSAMENTE MEUS CUMPRIMENTOS. AO EXCELENTISSIMO (A) SENHOR (A) DOUTOR (A) JUIZ (A) DE DIREITO JUIZADO ESPECIAL CIVEL DA COMARCA DE CAMPO BOM/RS. AVENIDA DOS ESTADOS, 800 - BAIRRO VINTE E CINCO DE JULHO - CEP 93700000 VALMIR ZAIAS COSECHEN JUIZ DE DIREITO ASSINADO DIGITALMENTE",
                "PublishDate": "2021-11-23T00:00:00",
                "CaptureDate": "2023-05-01T01:44:12"
              },
              {
                "Content": "JUNTADA DE CUMPRIMENTO EFETIVADO",
                "PublishDate": "2021-11-22T00:00:00",
                "CaptureDate": "2023-05-01T01:44:19"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO PARA FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA COM PRAZO DE 5 DIAS UTEIS - REFERENTE AO EVENTO (SEQ. 83) AUDIENCIA DE CONCILIACAO DESIGNADA (19/11/2021) - VIA AR DIGITAL - UTILIZANDO ANEXOS",
                "PublishDate": "2021-11-19T00:00:00",
                "CaptureDate": "2023-05-01T01:44:19"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO PARA ADVOGADOS/CURADOR/DEFENSOR DE LEONI DA SILVA COM PRAZO DE 24 DE FEVEREIRO DE 2022 - REFERENTE AO EVENTO (SEQ. 83) AUDIENCIA DE CONCILIACAO DESIGNADA (19/11/2021)",
                "PublishDate": "2021-11-19T00:00:00",
                "CaptureDate": "2023-05-01T01:44:19"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO PARA ADVOGADOS/CURADOR/DEFENSOR DE STARK BANK S.A. COM PRAZO DE 24 DE FEVEREIRO DE 2022 - REFERENTE AO EVENTO (SEQ. 83) AUDIENCIA DE CONCILIACAO DESIGNADA (19/11/2021)",
                "PublishDate": "2021-11-19T00:00:00",
                "CaptureDate": "2023-05-01T01:44:19"
              },
              {
                "Content": "AUDIENCIA DE CONCILIACAO DESIGNADA (AGENDADA PARA: 24 DE FEVEREIRO DE 2022 AS 16:00, EM 2 JUIZADO ESPECIAL CIVEL DE CASCAVEL, MODALIDADE: VIRTUAL)",
                "PublishDate": "2021-11-19T00:00:00",
                "CaptureDate": "2023-05-01T01:44:19"
              },
              {
                "Content": "AUDIENCIA DE CONCILIACAO REDESIGNADA REDESIGNADA",
                "PublishDate": "2021-11-19T00:00:00",
                "CaptureDate": "2023-05-01T01:44:19"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO PARA ADVOGADOS/CURADOR/DEFENSOR DE LEONI DA SILVA COM PRAZO DE 5 DIAS UTEIS - REFERENTE AO EVENTO (SEQ. 79) DEFERIDO O PEDIDO (19/11/2021)",
                "PublishDate": "2021-11-19T00:00:00",
                "CaptureDate": "2023-05-01T01:44:19"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO PARA ADVOGADOS/CURADOR/DEFENSOR DE STARK BANK S.A. COM PRAZO DE 5 DIAS UTEIS - REFERENTE AO EVENTO (SEQ. 79) DEFERIDO O PEDIDO (19/11/2021)",
                "PublishDate": "2021-11-19T00:00:00",
                "CaptureDate": "2023-05-01T01:44:19"
              },
              {
                "Content": "DEFERIDO O PEDIDO . VEICULADO NO DJEN EM 22/11/2021. PROJUDI - PROCESSO: 0032855-50.2020.8.16.0021 - REF. MOV. 79.1 - ASSINADO DIGITALMENTE POR VALMIR ZAIAS COSECHEN:23299517953 19/11/2021: DEFERIDO O PEDIDO. ARQ: DECISAO PODER JUDICIARIO DO ESTADO DO PARANA COMARCA DE CASCAVEL 2 JUIZADO ESPECIAL CIVEL DE CASCAVEL - PROJUDI AVENIDA TANCREDO NEVES, 2320 - ALTO ALEGRE - CASCAVEL/PR - CEP: 85.804-260 - FONE: (45) 3392-5068 - E-MAIL: CAS-16VJ-S@TJPR.JUS.BR AUTOS N. 0032855-50.2020.8.16.0021 PROCESSO: 0032855-50.2020.8.16.0021 CLASSE PROCESSUAL: PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL ASSUNTO PRINCIPAL: PERDAS E DANOS VALOR DA CAUSA: R$9.000,00 POLO ATIVO(S): LEONI DA SILVA POLO PASSIVO(S): FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA GILBERTO KLEY SILVA STARK BANK S.A. DECISAO CONSIDERANDO QUE OS REUS FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA E GILBERTO KLEY SILVA NAO FORAM CITADOS, DEFIRO O PEDIDO DE MOV. 76 E DETERMINO O CANCELAMENTO DA AUDIENCIA DE CONCILIACAO DESIGNADA PARA O DIA 24.11.2021. ATO CONTINUO, DETERMINO SEJA DESIGNADA NOVA AUDIENCIA DE CONCILIACAO, CITANDO-SE OS REUS FORTS E GILBERTO, MEDIANTE EXPEDICAO DE CARTA PRECATORIA, NO ENDERECO RUA JOSE ANCHIETA, DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJXDU LBBKS UTA7V XSZVK N 288, APTO 01, IMIGRANTE DO SUL, CAMPO BOM-RS, CEP: 93.700- 000. DE RESTO, INTIMEM-SE AS DEMAIS PARTES PARA QUE COMPARECAM A AUDIENCIA. CASCAVEL (PR), DATADO ELETRONICAMENTE. VALMIR ZAIAS COSECHEN JUIZ DE DIREITO",
                "PublishDate": "2021-11-19T00:00:00",
                "CaptureDate": "2023-05-01T01:44:19"
              },
              {
                "Content": "JUNTADA DE PETICAO DE MANIFESTACAO DA PARTE",
                "PublishDate": "2021-11-17T00:00:00",
                "CaptureDate": "2023-05-01T01:44:26"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO RESPONSAVEL: VALMIR ZAIAS COSECHEN",
                "PublishDate": "2021-11-16T00:00:00",
                "CaptureDate": "2023-05-01T01:44:26"
              },
              {
                "Content": "JUNTADA DE PETICAO DE REQUERIMENTO DE DILIGENCIA",
                "PublishDate": "2021-11-09T00:00:00",
                "CaptureDate": "2023-05-01T01:44:26"
              },
              {
                "Content": "JUNTADA DE COMPROVANTE DEVOLUCAO SEM LEITURA - INTIMACAO EXPEDIDA EM 14/10/2021 PARA FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA - REFERENTE AO EVENTO AUDIENCIA DE CONCILIACAO DESIGNADA (14/10/2021)",
                "PublishDate": "2021-11-08T00:00:00",
                "CaptureDate": "2023-05-01T01:44:26"
              },
              {
                "Content": "JUNTADA DE COMPROVANTE DEVOLUCAO SEM LEITURA - REFERENTE A CITACAO EXPEDIDA EM 14/10/2021 PARA FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA",
                "PublishDate": "2021-11-08T00:00:00",
                "CaptureDate": "2023-05-01T01:44:26"
              },
              {
                "Content": "JUNTADA DE COMPROVANTE DEVOLUCAO SEM LEITURA - REFERENTE A CITACAO EXPEDIDA EM 14/10/2021 PARA GILBERTO KLEY SILVA",
                "PublishDate": "2021-11-08T00:00:00",
                "CaptureDate": "2023-05-01T01:44:26"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA (PELO ADVOGADO/CURADOR/DEFENSOR DE LEONI DA SILVA) EM 25/10/2021 COM PRAZO DE 24 DE NOVEMBRO DE 2021 *REFERENTE AO EVENTO (SEQ. 64) AUDIENCIA DE CONCILIACAO DESIGNADA (14/10/2021) E AO EVENTO DE EXPEDICAO SEQ. 66.",
                "PublishDate": "2021-10-25T00:00:00",
                "CaptureDate": "2023-05-01T01:44:26"
              },
              {
                "Content": "JUNTADA DE PETICAO DE MANIFESTACAO DA PARTE CUMPRIMENTO DE INTIMACAO - REFERENTE AO EVENTO AUDIENCIA DE CONCILIACAO DESIGNADA (14/10/2021)",
                "PublishDate": "2021-10-18T00:00:00",
                "CaptureDate": "2023-05-01T01:44:26"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA (PELO ADVOGADO/CURADOR/DEFENSOR DE STARK BANK S.A.) EM 18/10/2021 COM PRAZO DE 24 DE NOVEMBRO DE 2021 *REFERENTE AO EVENTO (SEQ. 64) AUDIENCIA DE CONCILIACAO DESIGNADA (14/10/2021) E AO EVENTO DE EXPEDICAO SEQ. 65.",
                "PublishDate": "2021-10-18T00:00:00",
                "CaptureDate": "2023-05-01T01:44:26"
              },
              {
                "Content": "EXPEDICAO DE CITACAO PARA GILBERTO KLEY SILVA COM PRAZO ATE 24 DE NOVEMBRO DE 2021 - VIA AR DIGITAL - UTILIZANDO CONTRAFE",
                "PublishDate": "2021-10-14T00:00:00",
                "CaptureDate": "2023-05-01T01:44:26"
              },
              {
                "Content": "EXPEDICAO DE CITACAO PARA FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA COM PRAZO ATE 24 DE NOVEMBRO DE 2021 - VIA AR DIGITAL - UTILIZANDO CONTRAFE",
                "PublishDate": "2021-10-14T00:00:00",
                "CaptureDate": "2023-05-01T01:44:26"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO PARA FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA COM PRAZO DE 24 DE NOVEMBRO DE 2021 - REFERENTE AO EVENTO (SEQ. 64) AUDIENCIA DE CONCILIACAO DESIGNADA (14/10/2021) - VIA AR DIGITAL",
                "PublishDate": "2021-10-14T00:00:00",
                "CaptureDate": "2023-05-01T01:44:26"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO PARA ADVOGADOS/CURADOR/DEFENSOR DE LEONI DA SILVA COM PRAZO DE 24 DE NOVEMBRO DE 2021 - REFERENTE AO EVENTO (SEQ. 64) AUDIENCIA DE CONCILIACAO DESIGNADA (14/10/2021)",
                "PublishDate": "2021-10-14T00:00:00",
                "CaptureDate": "2023-05-01T01:44:26"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO PARA ADVOGADOS/CURADOR/DEFENSOR DE STARK BANK S.A. COM PRAZO DE 24 DE NOVEMBRO DE 2021 - REFERENTE AO EVENTO (SEQ. 64) AUDIENCIA DE CONCILIACAO DESIGNADA (14/10/2021)",
                "PublishDate": "2021-10-14T00:00:00",
                "CaptureDate": "2023-05-01T01:44:26"
              },
              {
                "Content": "AUDIENCIA DE CONCILIACAO DESIGNADA (AGENDADA PARA: 24 DE NOVEMBRO DE 2021 AS 16:01, EM 2 JUIZADO ESPECIAL CIVEL DE CASCAVEL, MODALIDADE: VIRTUAL)",
                "PublishDate": "2021-10-14T00:00:00",
                "CaptureDate": "2023-05-01T01:44:26"
              },
              {
                "Content": "JUNTADA DE PETICAO DE MANIFESTACAO DA PARTE CUMPRIMENTO DE INTIMACAO - REFERENTE AO EVENTO INDEFERIDO O PEDIDO (12/08/2021)",
                "PublishDate": "2021-09-08T00:00:00",
                "CaptureDate": "2023-05-01T01:44:26"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA (PELO ADVOGADO/CURADOR/DEFENSOR DE LEONI DA SILVA) EM 23/08/2021 COM PRAZO DE 10 DIAS UTEIS *REFERENTE AO EVENTO (SEQ. 60) INDEFERIDO O PEDIDO (12/08/2021) E AO EVENTO DE EXPEDICAO SEQ. 61.",
                "PublishDate": "2021-08-23T00:00:00",
                "CaptureDate": "2023-05-01T01:44:26"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO PARA ADVOGADOS/CURADOR/DEFENSOR DE LEONI DA SILVA COM PRAZO DE 10 DIAS UTEIS - REFERENTE AO EVENTO (SEQ. 60) INDEFERIDO O PEDIDO (12/08/2021)",
                "PublishDate": "2021-08-12T00:00:00",
                "CaptureDate": "2023-05-01T01:44:26"
              },
              {
                "Content": "INDEFERIDO O PEDIDO . VEICULADO NO DJEN EM 13/08/2021. PROJUDI - PROCESSO: 0032855-50.2020.8.16.0021 - REF. MOV. 60.1 - ASSINADO DIGITALMENTE POR VALMIR ZAIAS COSECHEN:23299517953 12/08/2021: INDEFERIDO O PEDIDO. ARQ: DECISAO PODER JUDICIARIO DO ESTADO DO PARANA COMARCA DE CASCAVEL 2 JUIZADO ESPECIAL CIVEL DE CASCAVEL - PROJUDI AVENIDA TANCREDO NEVES, 2320 - ALTO ALEGRE - CASCAVEL/PR - CEP: 85.804-260 - FONE: (45) 3392-5068 - E-MAIL: CAS-16VJ-S@TJPR.JUS.BR AUTOS N. 0032855-50.2020.8.16.0021 PROCESSO: 0032855-50.2020.8.16.0021 CLASSE PROCESSUAL: PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL ASSUNTO PRINCIPAL: PERDAS E DANOS VALOR DA CAUSA: R$9.000,00 POLO ATIVO(S): LEONI DA SILVA POLO PASSIVO(S): FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA GILBERTO KLEY SILVA STARK BANK S.A. DECISAO TRATA-SE DE PEDIDO DE RECONSIDERACAO DE DECISAO QUE DEFERIU LIMINAR PARA REALIZACAO DE BLOQUEIO DE ATIVOS FINANCEIROS EM CONTA DA CORRE STARK BANK S.A. DECIDO. TAL COMO PONTUADO PELA PARTE AUTORA EM SUA MANIFESTACAO DE MOV. 58, O BLOQUEIO DE ATIVOS VIA SISBAJUD RESTOU NEGATIVO. LOGO, NAO HA NADA A SER RECONSIDERADO SE A LIMINAR SEQUER FOI DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJ8R7 H5PVF F3VPN MDZ4R EFETIVADA, JA QUE NAO HAVIAM ATIVOS A SER BLOQUEADOS. PORTANTO, NAO HA PREJUIZO AO REU A PONTO DE SE EXIGIR UMA RECONSIDERACAO. REJEITO, PORTANTO, O PEDIDO DE MOV. 49. IGUALMENTE, INDEFIRO O PEDIDO DO AUTOR DE MOV. 58, UMA VEZ QUE A ORDEM DE BLOQUEIO VIA SISBAJUD JA ENGLOBA AS FINTECHS. COM RELACAO AO PEDIDO DE BLOQUEIO RENAJUD, POSTERGO SUA ANALISE PARA MOMENTO POSTERIOR, UMA VEZ QUE O FEITO SE ENCONTRA PRATICAMENTE PARALISADO PORQUE OS DEMAIS REUS AINDA SEQUER FORAM CITADOS. PORTANTO, INTIME-SE O AUTOR PARA INDICAR QUAL DOS ENDERECOS, DENTRE AQUELES INDICA- DOS NA PETICAO DE MOV. 55, PRETENDE A CITACAO DOS REUS. PRAZO: 10 DIAS. INTIMEM-SE. PROJUDI - PROCESSO: 0032855-50.2020.8.16.0021 - REF. MOV. 60.1 - ASSINADO DIGITALMENTE POR VALMIR ZAIAS COSECHEN:23299517953 12/08/2021: INDEFERIDO O PEDIDO. ARQ: DECISAO CASCAVEL (PR), DATADO ELETRONICAMENTE. VALMIR ZAIAS COSECHEN JUIZ DE DIREITO DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJ8R7 H5PVF F3VPN MDZ4R",
                "PublishDate": "2021-08-12T00:00:00",
                "CaptureDate": "2023-05-01T01:44:26"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO - PEDIDO DE URGENCIA RESPONSAVEL: VALMIR ZAIAS COSECHEN",
                "PublishDate": "2021-08-10T00:00:00",
                "CaptureDate": "2023-05-01T01:44:33"
              },
              {
                "Content": "JUNTADA DE PETICAO DE REQUERIMENTO DE DILIGENCIA CUMPRIMENTO DE INTIMACAO - REFERENTE AO EVENTO DETERMINACAO DE DILIGENCIA (14/07/2021)",
                "PublishDate": "2021-08-09T00:00:00",
                "CaptureDate": "2023-05-01T01:44:33"
              },
              {
                "Content": "DEFERIDO O PEDIDO . VEICULADO NO DJEN EM 11/08/2021. PROJUDI - PROCESSO: 0032855-50.2020.8.16.0021 - REF. MOV. 57.1 - ASSINADO DIGITALMENTE POR VALMIR ZAIAS COSECHEN:23299517953 05/08/2021: DEFERIDO O PEDIDO. ARQ: DECISAO PODER JUDICIARIO DO ESTADO DO PARANA COMARCA DE CASCAVEL 2 JUIZADO ESPECIAL CIVEL DE CASCAVEL - PROJUDI AVENIDA TANCREDO NEVES, 2320 - ALTO ALEGRE - CASCAVEL/PR - CEP: 85.804-260 - FONE: (45) 3392-5068 - E-MAIL: CAS-16VJ-S@TJPR.JUS.BR CLASSE PROCESSUAL: PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL ASSUNTO PRINCIPAL: PERDAS E DANOS PROCESSO N: 0032855-50.2020.8.16.0021 POLO ATIVO(S): LEONI DA SILVA POLO PASSIVO(S): FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA GILBERTO KLEY SILVA STARK BANK S.A. CLS. CONSIDERANDO QUE O RECLAMANTE INDICOU NA SEQ. 55.1 O NOVO ENDERECO DOS RECLAMADOS FORTS CONSULTORIA E GILBERTO KLEY SILVA, DETERMINO: 1. CITEM-SE E INTIMEM-SE. 2. DILIGENCIAS NECESSARIAS. INTIMEM-SE. CASCAVEL, DATADO ELETRONICAMENTE. DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJ8G4 CLWRB 27G95 SXBZK VALMIR ZAIAS COSECHEN JUIZ DE DIREITO",
                "PublishDate": "2021-08-05T00:00:00",
                "CaptureDate": "2023-05-01T01:44:33"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO RESPONSAVEL: VALMIR ZAIAS COSECHEN",
                "PublishDate": "2021-08-04T00:00:00",
                "CaptureDate": "2023-05-01T01:44:41"
              },
              {
                "Content": "JUNTADA DE PETICAO DE REQUERIMENTO DE DILIGENCIA CUMPRIMENTO DE INTIMACAO - REFERENTE AO EVENTO DETERMINACAO DE DILIGENCIA (01/06/2021)",
                "PublishDate": "2021-08-03T00:00:00",
                "CaptureDate": "2023-05-01T01:44:41"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA (PELO ADVOGADO/CURADOR/DEFENSOR DE LEONI DA SILVA) EM 26/07/2021 COM PRAZO DE 10 DIAS UTEIS *REFERENTE AO EVENTO (SEQ. 51) DETERMINACAO DE DILIGENCIA (14/07/2021) E AO EVENTO DE EXPEDICAO SEQ. 52.",
                "PublishDate": "2021-07-25T00:00:00",
                "CaptureDate": "2023-05-01T01:44:41"
              },
              {
                "Content": "JUNTADA DE PETICAO DE SUBSTABELECIMENTO",
                "PublishDate": "2021-07-21T00:00:00",
                "CaptureDate": "2023-05-01T01:44:41"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO PARA ADVOGADOS/CURADOR/DEFENSOR DE LEONI DA SILVA COM PRAZO DE 10 DIAS UTEIS - REFERENTE AO EVENTO (SEQ. 51) DETERMINACAO DE DILIGENCIA (14/07/2021)",
                "PublishDate": "2021-07-14T00:00:00",
                "CaptureDate": "2023-05-01T01:44:41"
              },
              {
                "Content": "DETERMINACAO DE DILIGENCIA . VEICULADO NO DJEN EM 15/07/2021. PROJUDI - PROCESSO: 0032855-50.2020.8.16.0021 - REF. MOV. 51.1 - ASSINADO DIGITALMENTE POR VALMIR ZAIAS COSECHEN:23299517953 14/07/2021: DETERMINACAO DE DILIGENCIA. ARQ: DECISAO PODER JUDICIARIO DO ESTADO DO PARANA COMARCA DE CASCAVEL 2 JUIZADO ESPECIAL CIVEL DE CASCAVEL - PROJUDI AVENIDA TANCREDO NEVES, 2320 - ALTO ALEGRE - CASCAVEL/PR - CEP: 85.804-260 - FONE: (45) 3392-5068 - E-MAIL: CAS-16VJ-S@TJPR.JUS.BR AUTOS N. 0032855-50.2020.8.16.0021 PROCESSO: 0032855-50.2020.8.16.0021 CLASSE PROCESSUAL: PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL ASSUNTO PRINCIPAL: PERDAS E DANOS VALOR DA CAUSA: R$9.000,00 POLO ATIVO(S): LEONI DA SILVA POLO PASSIVO(S): FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA GILBERTO KLEY SILVA STARK BANK S.A. DESPACHO 1. INTIME-SE O AUTOR PARA NO PRAZO DE 10 (DEZ) DIAS: (I) FORNECER NOVOS ENDERECOS PARA CITACAO DOS CORREUS FORTS CONSULTORIA E GILBERTO KLEY SILVA, TENDO EM VISTA O RETORNO NEGATIVO DAS CARTAS DE CITACOES (MOVS. 22 E 23) OU REQUERER O QUE ENTENDER DE DIREITO; (II) SE MANIFESTAR SOBRE O PEDIDO DE RECONSIDERACAO FEITO PELO REU NO MOV. 49. DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJ54L GW8PA NC8CC VF5DU CASCAVEL (PR), DATADO ELETRONICAMENTE. VALMIR ZAIAS COSECHEN JUIZ DE DIREITO",
                "PublishDate": "2021-07-14T00:00:00",
                "CaptureDate": "2023-05-01T01:44:41"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO - PEDIDO DE URGENCIA RESPONSAVEL: VALMIR ZAIAS COSECHEN",
                "PublishDate": "2021-07-13T00:00:00",
                "CaptureDate": "2023-05-01T01:44:49"
              },
              {
                "Content": "JUNTADA DE PETICAO DE MANIFESTACAO DA PARTE",
                "PublishDate": "2021-07-12T00:00:00",
                "CaptureDate": "2023-05-01T01:44:49"
              },
              {
                "Content": "ATO CUMPRIDO PELA PARTE OU INTERESSADO LEITURA DE INTIMACAO REALIZADA - (PARA LEONI DA SILVA) EM 22/06/2021 COM PRAZO DE 30 DIAS UTEIS *REFERENTE AO EVENTO (SEQ. 45) DETERMINACAO DE DILIGENCIA (01/06/2021) E AO EVENTO DE EXPEDICAO SEQ. 46.",
                "PublishDate": "2021-07-06T00:00:00",
                "CaptureDate": "2023-05-01T01:44:49"
              },
              {
                "Content": "JUNTADA DE PETICAO DE REQUERIMENTO DE HABILITACAO",
                "PublishDate": "2021-06-25T00:00:00",
                "CaptureDate": "2023-05-01T01:44:49"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO PARA LEONI DA SILVA COM PRAZO DE 30 DIAS UTEIS - REFERENTE AO EVENTO (SEQ. 45) DETERMINACAO DE DILIGENCIA (01/06/2021) - VIA AR DIGITAL",
                "PublishDate": "2021-06-08T00:00:00",
                "CaptureDate": "2023-05-01T01:44:49"
              },
              {
                "Content": "DETERMINACAO DE DILIGENCIA . VEICULADO NO DJEN EM 09/06/2021. PROJUDI - PROCESSO: 0032855-50.2020.8.16.0021 - REF. MOV. 45.1 - ASSINADO DIGITALMENTE POR VALMIR ZAIAS COSECHEN:23299517953 01/06/2021: DETERMINACAO DE DILIGENCIA. ARQ: DECISAO PODER JUDICIARIO DO ESTADO DO PARANA COMARCA DE CASCAVEL 2 JUIZADO ESPECIAL CIVEL DE CASCAVEL - PROJUDI AVENIDA TANCREDO NEVES, 2320 - ALTO ALEGRE - CASCAVEL/PR - CEP: 85.804-260 - FONE: (45) 3392-5068 - E-MAIL: CAS-16VJ-S@TJPR.JUS.BR PROCESSO: 0032855-50.2020.8.16.0021 CLASSE PROCESSUAL: PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL ASSUNTO PRINCIPAL: PERDAS E DANOS VALOR DA CAUSA: R$9.000,00 POLO ATIVO(S): LEONI DA SILVA POLO PASSIVO(S): FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA GILBERTO KLEY SILVA STARK BANK S.A. DECISAO POR MEIO DA DECISAO DE MOV. 34 DETERMINEI A SUSPENSAO DO PROCESSO, UMA VEZ QUE FOI NOTICIADO QUE O PROCURADOR DA AUTORA SE ENCONTRAVA INTERNADO NA UTI, SITUACAO QUE REPUTEI COMO TIPI- CO CASO DE FORCA MAIOR. NESTA MESMA DECISAO, DETERMINEI A INTIMACAO PESSOAL DA AUTORA SOBRE A SUS- PENSAO, O QUE NAO FOI CUMPRIDO. ASSIM, A FIM DE EVITAR PREJUIZOS A AUTORA, INTIME-A PESSOALMENTE PARA INFORMAR SOBRE O ESTADO CLINICO DO SEU PROCURADOR, BEM COMO SE POSSUI INTERESSE EM CONSTITUIR NOVO ADVOGADO OU SE PERMANECERA REPRESENTADA PELO SEU ATUAL ADVOGADO CONSTITUIDO. FACA-SE CONSTAR NA INTIMACAO QUE DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJSTV RXPPH VZXVX C9WPB ESSAS INFORMACOES PODERAO SER ENVIADAS POR E-MAIL A SECRETARIA JUDICIARIA OU VIA CONTATO TELEFONICO, CONSTANDO OS DADOS NECESSARIOS PARA COMUNICACAO. PRAZO: 30 DIAS. EM SEGUIDA, VOLTEM-ME CONCLUSOS. DILIGENCIAS NECESSARIAS. CASCAVEL (PR), DATADO ELETRONICAMENTE. VALMIR ZAIAS COSECHEN JUIZ DE DIREITO",
                "PublishDate": "2021-06-01T00:00:00",
                "CaptureDate": "2023-05-01T01:44:49"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO RESPONSAVEL: VALMIR ZAIAS COSECHEN",
                "PublishDate": "2021-05-06T00:00:00",
                "CaptureDate": "2023-05-01T01:45:01"
              },
              {
                "Content": "JUNTADA DE PETICAO DE MANIFESTACAO DA PARTE",
                "PublishDate": "2021-05-05T00:00:00",
                "CaptureDate": "2023-05-01T01:45:01"
              },
              {
                "Content": "LEVANTADA A SUSPENSAO OU SOBRESTAMENTO DOS AUTOS TERMINO DA SUSPENSAO DO PROCESSO - PRAZO ENCERRADO",
                "PublishDate": "2021-05-05T00:00:00",
                "CaptureDate": "2023-05-01T01:45:01"
              },
              {
                "Content": "DECORRIDO PRAZO DE STARK BANK S.A. (P/ ADVGS. DE STARK BANK S.A. *REFERENTE AO EVENTO (SEQ. 34) PROCESSO SUSPENSO OU SOBRESTADO POR FORCA MAIOR (27/01/2021) E AO EVENTO DE EXPEDICAO SEQ. 35.",
                "PublishDate": "2021-02-19T00:00:00",
                "CaptureDate": "2023-05-01T01:45:01"
              },
              {
                "Content": "DECORRIDO PRAZO DE LEONI DA SILVA (P/ ADVGS. DE LEONI DA SILVA *REFERENTE AO EVENTO (SEQ. 34) PROCESSO SUSPENSO OU SOBRESTADO POR FORCA MAIOR (27/01/2021) E AO EVENTO DE EXPEDICAO SEQ. 36.",
                "PublishDate": "2021-02-19T00:00:00",
                "CaptureDate": "2023-05-01T01:45:01"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA (PELO ADVOGADO/CURADOR/DEFENSOR DE LEONI DA SILVA) EM 11/02/2021 COM PRAZO DE 5 DIAS UTEIS *REFERENTE AO EVENTO (SEQ. 34) PROCESSO SUSPENSO OU SOBRESTADO POR FORCA MAIOR (27/01/2021) E AO EVENTO DE EXPEDICAO SEQ. 36.",
                "PublishDate": "2021-02-12T00:00:00",
                "CaptureDate": "2023-05-01T01:45:01"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA (PELO ADVOGADO/CURADOR/DEFENSOR DE STARK BANK S.A.) EM 11/02/2021 COM PRAZO DE 5 DIAS UTEIS *REFERENTE AO EVENTO (SEQ. 34) PROCESSO SUSPENSO OU SOBRESTADO POR FORCA MAIOR (27/01/2021) E AO EVENTO DE EXPEDICAO SEQ. 35.",
                "PublishDate": "2021-02-12T00:00:00",
                "CaptureDate": "2023-05-01T01:45:01"
              },
              {
                "Content": "PROCESSO SUSPENSO POR 90 DIAS CORRIDOS A PARTIR DE 27/01/2021",
                "PublishDate": "2021-02-01T00:00:00",
                "CaptureDate": "2023-05-01T01:45:01"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO PARA ADVOGADOS/CURADOR/DEFENSOR DE LEONI DA SILVA COM PRAZO DE 5 DIAS UTEIS - REFERENTE AO EVENTO (SEQ. 34) PROCESSO SUSPENSO OU SOBRESTADO POR FORCA MAIOR (27/01/2021)",
                "PublishDate": "2021-02-01T00:00:00",
                "CaptureDate": "2023-05-01T01:45:01"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO PARA ADVOGADOS/CURADOR/DEFENSOR DE STARK BANK S.A. COM PRAZO DE 5 DIAS UTEIS - REFERENTE AO EVENTO (SEQ. 34) PROCESSO SUSPENSO OU SOBRESTADO POR FORCA MAIOR (27/01/2021)",
                "PublishDate": "2021-02-01T00:00:00",
                "CaptureDate": "2023-05-01T01:45:01"
              },
              {
                "Content": "PROCESSO SUSPENSO OU SOBRESTADO POR FORCA MAIOR . VEICULADO NO DJEN EM 02/02/2021. PROJUDI - PROCESSO: 0032855-50.2020.8.16.0021 - REF. MOV. 34.1 - ASSINADO DIGITALMENTE POR VALMIR ZAIAS COSECHEN:23299517953 27/01/2021: PROCESSO SUSPENSO OU SOBRESTADO POR FORCA MAIOR. ARQ: DECISAO PODER JUDICIARIO DO ESTADO DO PARANA COMARCA DE CASCAVEL 2 JUIZADO ESPECIAL CIVEL DE CASCAVEL - PROJUDI AVENIDA TANCREDO NEVES, 2320 - ALTO ALEGRE - CASCAVEL/PR - CEP: 85.804-260 - FONE: (45) 3392-5068 - E-MAIL: CAS-16VJ-S@TJPR.JUS.BR AUTOS N. 0032855-50.2020.8.16.0021 PROCESSO: 0032855-50.2020.8.16.0021 CLASSE PROCESSUAL: PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL ASSUNTO PRINCIPAL: PERDAS E DANOS VALOR DA CAUSA: R$9.000,00 POLO ATIVO(S): LEONI DA SILVA POLO PASSIVO(S): FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA GILBERTO KLEY SILVA STARK BANK S.A. DECISAO VISTOS. 1. POR MEIO DA PETICAO DE MOV. 33, A PARTE AUTORA NOTICIOU QUE SEU PROCURADOR SE ENCONTRA INTERNADO EM UTI DESDE 26.11.2020, FICANDO IMPOSSIBILITANDO DE CUMPRIR COM OS PRAZOS E ATOS PROCESSUAIS. POR CONTA DISSO, PEDIU A SUSPENSAO DO PROCESSO. DECIDO. 2. COM EFEITO, RESTOU DEMONSTRADO QUE O PROCURADOR DO AUTOR SE ENCONTRA INTERNADO EM UTI, CONFORME SE DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJL5C ULN28 HLVSP SJEPR VE DO ATESTADO MEDICO ANEXADO AOS AUTOS (MOV. 33.2). O IMPEDIMENTO OCASIONAL DO PROFISSIONAL ENCONTRA EFETIVA RELEVANCIA PORQUE O MANDATO LHE FOI UNICAMENTE OUTORGADO PELO AUTOR E A SITUACAO LHE IMPOSSIBILITA DE SUBSTABELECER (MOV. 1.2). LOGO, NAO HA OUTRO ADVOGADO COM PODERES PARA REPRESENTAR O AUTOR, TAMPOUCO HA COMO O PROCURADOR HABILITADO SUBSTABELECER OS PODERES. DIANTE DESSA SITUACAO, CONCLUO QUE HA TIPICO CASO DE FORCA MAIOR, QUE JUSTIFICA A SUSPENSAO DO PROCESSO, NOS TERMOS DO ART. 313, VI, DO CPC, TENDO EM VISTA A INCAPACIDADE MOMENTANEA E EXCEPCIONAL DO UNICO ADVOGADO DO AUTOR. 3. ISTO POSTO, DEFIRO O PEDIDO E DETERMINO A SUSPENSAO DO PROCESSO, PELO PRAZO DE 3 (TRES) MESES, NOS TERMOS DO ART. 313, VI, DO CPC. 4. INTIMEM-SE AS PARTES. PROJUDI - PROCESSO: 0032855-50.2020.8.16.0021 - REF. MOV. 34.1 - ASSINADO DIGITALMENTE POR VALMIR ZAIAS COSECHEN:23299517953 27/01/2021: PROCESSO SUSPENSO OU SOBRESTADO POR FORCA MAIOR. ARQ: DECISAO 5. INTIME-SE PESSOALMENTE O AUTOR A RESPEITO DA SUSPENSAO, INCLUINDO COPIA DA DECISAO. CASCAVEL (PR), DATADO ELETRONICAMENTE. VALMIR ZAIAS COSECHEN JUIZ DE DIREITO DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJL5C ULN28 HLVSP SJEPR",
                "PublishDate": "2021-01-27T00:00:00",
                "CaptureDate": "2023-05-01T01:45:01"
              },
              {
                "Content": "JUNTADA DE PETICAO DE REQUERIMENTO DE SUSPENSAO DO PROCESSO",
                "PublishDate": "2020-12-15T00:00:00",
                "CaptureDate": "2023-05-01T01:45:08"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO RESPONSAVEL: VALMIR ZAIAS COSECHEN",
                "PublishDate": "2020-12-14T00:00:00",
                "CaptureDate": "2023-05-01T01:45:08"
              },
              {
                "Content": "JUNTADA DE PETICAO DE MANIFESTACAO DA PARTE",
                "PublishDate": "2020-12-14T00:00:00",
                "CaptureDate": "2023-05-01T01:45:08"
              },
              {
                "Content": "DECORRIDO PRAZO DE LEONI DA SILVA (P/ ADVGS. DE LEONI DA SILVA *REFERENTE AO EVENTO (SEQ. 24) JUNTADA DE INTIMACAO ONLINE (09/11/2020) E AO EVENTO DE EXPEDICAO SEQ. 25.",
                "PublishDate": "2020-12-11T00:00:00",
                "CaptureDate": "2023-05-01T01:45:08"
              },
              {
                "Content": "DECORRIDO PRAZO DE FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA REFERENTE AO PRAZO PARA CUMPRIMENTO DA CITACAO (SEQ. DE EXPEDICAO 12).",
                "PublishDate": "2020-11-21T00:00:00",
                "CaptureDate": "2023-05-01T01:45:08"
              },
              {
                "Content": "ATO CUMPRIDO PELA PARTE OU INTERESSADO LEITURA DE INTIMACAO REALIZADA - (PELO ADVOGADO/CURADOR/DEFENSOR DE LEONI DA SILVA) EM 19/11/2020 COM PRAZO DE 15 DIAS UTEIS *REFERENTE AO EVENTO (SEQ. 24) JUNTADA DE INTIMACAO ONLINE (09/11/2020) E AO EVENTO DE EXPEDICAO SEQ. 25.",
                "PublishDate": "2020-11-20T00:00:00",
                "CaptureDate": "2023-05-01T01:45:08"
              },
              {
                "Content": "DECORRIDO PRAZO DE LEONI DA SILVA (P/ ADVGS. DE LEONI DA SILVA *REFERENTE AO EVENTO (SEQ. 15) DETERMINACAO DE DILIGENCIAS (23/10/2020) E AO EVENTO DE EXPEDICAO SEQ. 16.",
                "PublishDate": "2020-11-12T00:00:00",
                "CaptureDate": "2023-05-01T01:45:08"
              },
              {
                "Content": "JUNTADA DE PETICAO DE CONTESTACAO EM CUMPRIMENTO A CITACAO DE STARK BANK S.A.",
                "PublishDate": "2020-11-09T00:00:00",
                "CaptureDate": "2023-05-01T01:45:08"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO PARA ADVOGADOS/CURADOR/DEFENSOR DE LEONI DA SILVA COM PRAZO DE 15 DIAS UTEIS - REFERENTE AO EVENTO (SEQ. 24) JUNTADA DE INTIMACAO ONLINE (09/11/2020)",
                "PublishDate": "2020-11-09T00:00:00",
                "CaptureDate": "2023-05-01T01:45:08"
              },
              {
                "Content": "JUNTADA DE INTIMACAO ONLINE",
                "PublishDate": "2020-11-09T00:00:00",
                "CaptureDate": "2023-05-01T01:45:08"
              },
              {
                "Content": "JUNTADA DE COMPROVANTE DEVOLUCAO SEM LEITURA - REFERENTE A CITACAO EXPEDIDA EM 22/10/2020 PARA GILBERTO KLEY SILVA",
                "PublishDate": "2020-11-09T00:00:00",
                "CaptureDate": "2023-05-01T01:45:08"
              },
              {
                "Content": "JUNTADA DE COMPROVANTE DEVOLUCAO SEM LEITURA - REFERENTE A CITACAO EXPEDIDA EM 22/10/2020 PARA FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA",
                "PublishDate": "2020-11-09T00:00:00",
                "CaptureDate": "2023-05-01T01:45:08"
              },
              {
                "Content": "JUNTADA DE PENHORA NAO REALIZADA BACENJUD/SISBAJUD",
                "PublishDate": "2020-11-09T00:00:00",
                "CaptureDate": "2023-05-01T01:45:08"
              },
              {
                "Content": "ATO CUMPRIDO PELA PARTE OU INTERESSADO LEITURA DE CITACAO REALIZADA - POR STARK BANK S.A. EM 28/10/2020 REFERENTE AO EVENTO DE EXPEDICAO SEQ. 14.",
                "PublishDate": "2020-11-04T00:00:00",
                "CaptureDate": "2023-05-01T01:45:08"
              },
              {
                "Content": "ATO CUMPRIDO PELA PARTE OU INTERESSADO LEITURA DE CITACAO REALIZADA - POR FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA EM 28/10/2020 REFERENTE AO EVENTO DE EXPEDICAO SEQ. 12.",
                "PublishDate": "2020-11-04T00:00:00",
                "CaptureDate": "2023-05-01T01:45:08"
              },
              {
                "Content": "ATO CUMPRIDO PELA PARTE OU INTERESSADO LEITURA DE INTIMACAO REALIZADA - (PELO ADVOGADO/CURADOR/DEFENSOR DE LEONI DA SILVA) EM 04/11/2020 COM PRAZO DE 5 DIAS UTEIS *REFERENTE AO EVENTO (SEQ. 15) DETERMINACAO DE DILIGENCIAS (23/10/2020) E AO EVENTO DE EXPEDICAO SEQ. 16.",
                "PublishDate": "2020-11-03T00:00:00",
                "CaptureDate": "2023-05-01T01:45:08"
              },
              {
                "Content": "EXPEDICAO DE BLOQUEIO SISBAJUD REFERENTE AO EVENTO (SEQ. 9) CONCEDIDA A ANTECIPACAO DE TUTELA(22/10/2020 15:17:48). IDENTIFICADOR DO CUMPRIMENTO: 0001",
                "PublishDate": "2020-10-26T00:00:00",
                "CaptureDate": "2023-05-01T01:45:08"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO PARA ADVOGADOS/CURADOR/DEFENSOR DE LEONI DA SILVA COM PRAZO DE 5 DIAS UTEIS - REFERENTE AO EVENTO (SEQ. 15) DETERMINACAO DE DILIGENCIAS (23/10/2020)",
                "PublishDate": "2020-10-23T00:00:00",
                "CaptureDate": "2023-05-01T01:45:08"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE DETERMINACAO DE DILIGENCIAS PROJUDI - PROCESSO: 0032855-50.2020.8.16.0021 - REF. MOV. 15.1 - ASSINADO DIGITALMENTE POR VALMIR ZAIAS COSECHEN:23299517953 23/10/2020: PROFERIDO DESPACHO DE MERO EXPEDIENTE. ARQ: DESPACHO PODER JUDICIARIO DO ESTADO DO PARANA COMARCA DE CASCAVEL 2 JUIZADO ESPECIAL CIVEL DE CASCAVEL - PROJUDI AVENIDA TANCREDO NEVES, 2320 - ALTO ALEGRE - CASCAVEL/PR - CEP: 85.804-260 - FONE: (45) 3392-5068 - E-MAIL: CAS-16VJ-S@TJPR.JUS.BR CLASSE PROCESSUAL: PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL ASSUNTO PRINCIPAL: PERDAS E DANOS PROCESSO N: 0032855-50.2020.8.16.0021 POLO ATIVO(S): LEONI DA SILVA POLO PASSIVO(S): FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA GILBERTO KLEY SILVA STARK BANK S.A. CLS. 1.INTIME-SE O RECLAMANTE PARA, NO PRAZO DE 05 (CINCO) DIAS, MANIFESTAR-SE ACERCA DA PETICAO E DOCUMENTOS JUNTADOS EM SEQ. 6.1 A 6.16. 2.APOS, VOLTEM CONCLUSOS. INTIME-SE. CASCAVEL, DATADO ELETRONICAMENTE. VALMIR ZAIAS COSECHEN DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJV5W P6DKH SF3XQ 4LJEA JUIZ DE DIREITO",
                "PublishDate": "2020-10-23T00:00:00",
                "CaptureDate": "2023-05-01T01:45:08"
              },
              {
                "Content": "EXPEDICAO DE CITACAO PARA STARK BANK S.A. COM PRAZO DE 15 DIAS UTEIS - VIA AR DIGITAL - UTILIZANDO CONTRAFE",
                "PublishDate": "2020-10-22T00:00:00",
                "CaptureDate": "2023-05-01T01:45:17"
              },
              {
                "Content": "EXPEDICAO DE CITACAO PARA GILBERTO KLEY SILVA COM PRAZO DE 15 DIAS UTEIS - VIA AR DIGITAL - UTILIZANDO CONTRAFE",
                "PublishDate": "2020-10-22T00:00:00",
                "CaptureDate": "2023-05-01T01:45:17"
              },
              {
                "Content": "EXPEDICAO DE CITACAO PARA FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA COM PRAZO DE 15 DIAS UTEIS - VIA AR DIGITAL - UTILIZANDO CONTRAFE",
                "PublishDate": "2020-10-22T00:00:00",
                "CaptureDate": "2023-05-01T01:45:17"
              },
              {
                "Content": "EXPEDICAO DE CITACAO PARA FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA COM PRAZO DE 15 DIAS UTEIS - VIA AR DIGITAL - UTILIZANDO CONTRAFE",
                "PublishDate": "2020-10-22T00:00:00",
                "CaptureDate": "2023-05-01T01:45:17"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO - PEDIDO DE URGENCIA RESPONSAVEL: VALMIR ZAIAS COSECHEN",
                "PublishDate": "2020-10-22T00:00:00",
                "CaptureDate": "2023-05-01T01:45:17"
              },
              {
                "Content": "CONCEDIDA A ANTECIPACAO DE TUTELA PROJUDI - PROCESSO: 0032855-50.2020.8.16.0021 - REF. MOV. 9.1 - ASSINADO DIGITALMENTE POR VALMIR ZAIAS COSECHEN:23299517953 22/10/2020: CONCEDIDA A ANTECIPACAO DE TUTELA. ARQ: DECISAO PODER JUDICIARIO DO ESTADO DO PARANA COMARCA DE CASCAVEL 2 JUIZADO ESPECIAL CIVEL DE CASCAVEL - PROJUDI AVENIDA TANCREDO NEVES, 2320 - ALTO ALEGRE - CASCAVEL/PR - CEP: 85.804-260 - FONE: (45) 3392-5068 - E-MAIL: CAS-16VJ-S@TJPR.JUS.BR CLASSE PROCESSUAL: PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL ASSUNTO PRINCIPAL: PERDAS E DANOS PROCESSO N: 0032855-50.2020.8.16.0021 POLO ATIVO(S): LEONI DA SILVA POLO PASSIVO(S): FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA GILBERTO KLEY SILVA STARK BANK S.A. VISTOS E EXAMINADOS. TRATA-SE DE ACAO DECLARATORIA DE ANULACAO DE NEGOCIO JURIDICO C/C RESTITUICAO DE VALORES, INDENIZACAO POR DANOS MORAIS COM PEDIDO DE ANTECIPACAO DE TUTELA, NA QUAL O RECLAMANTE ALEGA QUE NO DIA 28/09/2019 CELEBROU UM CONTRATO DE INVESTIMENTOS FINANCEIROS (MUTUO) COM AS RECLAMADAS, NO VALOR DE R$ 1.000,00 (MIL REAIS). ALEGA AINDA QUE AS RECLAMADAS PROMETIAM O PAGAMENTO DE JUROS MENSAIS DE 10% (DEZ POR CENTO) SOBRE OS VALORES APORTADOS POR SEUS CLIENTES E, AO FINAL DO PERIODO DE 12 (DOZE) MESES, REALIZARIAM A RESTITUICAO INTEGRAL DESSAS QUANTIAS. ADUZ QUE JA SE PASSARAM OS 12 (DOZE) MESES E AS RES NAO PAGARAM OS RENDIMENTOS PROMETIDOS, DANDO CAUSA A RESCISAO E RESPECTIVA COBRANCA DOS PACTOS. A RECLAMANTE REQUER A ANTECIPACAO DE TUTELA A FIM DE DETERMINAR O BLOQUEIO VIA SISBAJUD, RENAJUD E INFOJUD EM NOME DAS RECLAMADAS, PARA SATISFACAO DO CREDITO NO VALOR DE R$ 1.000,00 (MIL REAIS). DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJ6KM HL2H9 HKAWX YGTGD DECIDO DA TUTELA ANTECIPADA: O NOVO CPC, ARTIGO 300, UNIFICOU NUM MESMO DISPOSITIVO A TUTELA SATISFATIVA ANTECIPATORIA E A TUTELA PROVISORIA CAUTELAR, ELENCANDO OS REQUISITOS MINIMOS: 1. PROBABILIDADE DO DIREITO; 2. PERIGO DE DANO OU RISCO AO RESULTADO UTIL DO PROCESSO; 3. AUSENCIA DE PERIGO DE IRREVERSIBILIDADE, PARA A TUTELA ANTECIPATORIA. O REFERIDO DISPOSITIVO, NO PARAGRAFO PRIMEIRO, DISPOE SOBRE A POSSIBILIDADE DE O JUIZ EXIGIR CAUCAO PARA RESGUARDAR A PARTE CONTRARIA DOS EVENTUAIS PREJUIZOS QUE POSSAM RESULTAR DA MEDIDA SOLICITADA, CONSIGNANDO NO PARAGRAFO SEGUNDO QUE A TUTELA DE URGENCIA PODE SER CONCEDIDA LIMINARMENTE OU APOS JUSTIFICACAO PREVIA. O PEDIDO DE BLOQUEIO DE VALORES, SE TRATA DE TUTELA DE URGENCIA DE NATUREZA CAUTELAR. CONSIDERANDO QUE O PRESENTE FEITO VERSA SOBRE CONTRATO DE INVESTIMENTO FINANCEIROS E, QUE A REALIZACAO DE BLOQUEIO DE VALORES ATRAVES DO SISTEMA SISBAJUD VISA ASSEGURAR O DIREITO DO AUTOR, GARANTINDO FUTURO RECEBIMENTO DOS VALORES PLEITEADOS, CASO SEU DIREITO SEJA COMPROVADO, RESTA CARACTERIZADA A PRESENCA DOS PRESSUPOSTOS DE PROBABILIDADE DO DIREITO E PERIGO DE DANO. PROJUDI - PROCESSO: 0032855-50.2020.8.16.0021 - REF. MOV. 9.1 - ASSINADO DIGITALMENTE POR VALMIR ZAIAS COSECHEN:23299517953 22/10/2020: CONCEDIDA A ANTECIPACAO DE TUTELA. ARQ: DECISAO POR OUTRO LADO, O DEFERIMENTO DO PEDIDO CAUTELAR NAO TEM CARATER IRREVERSIVEL E, CASO A PARTE RECLAMADA COMPROVE A INEXISTENCIA DE CULPA E/OU RESPONSABILIDADE PELO EVENTO PODERA, OPORTUNAMENTE E CASO A DECISAO FINAL LHE SEJA FAVORAVEL, TER SEU VEICULO DESBLOQUEADO. ISTO POSTO, DEFIRO O PEDIDO DE TUTELA CAUTELAR E DETERMINO: A)PROCEDA-SE O BLOQUEIO DO VALOR DE R$ 1.000,00 (MIL REAIS) NO CNPJ DOS RECLAMADOS, VIA SISTEMA SISBAJUD. B) SENDO O RECLAMADO CADASTRADO NA CITACAO ON LINE, CITE-SE CONFORME DETERMINADO NO ITEM A DA PORTARIA CONJUNTA 01/2020  DOC.5491424 CAS-17VJ-S. C) NAO SENDO O RECLAMADO CADASTRADO NA CITACAO ON LINE, PROCEDA-SE A CITACAO NOS TERMOS DO ITEM C DA PORTARIA CONJUNTA 01/2020  DOC.5491424 CAS-17VJ-S. D) OFERECIDA CONTESTACAO, INTIME(M)-SE O(S) AUTOR(ES) PARA IMPUGNAR, NO PRAZO DE 15 (QUINZE) DIAS; E) DILIGENCIAS NECESSARIAS NOS TERMOS DA PORTARIA CONJUNTA 01/2020  DOC.5491424 CAS-17VJ-S. INTIME-SE CASCAVEL, DATADO ELETRONICAMENTE. VALMIR ZAIAS COSECHEN JUIZ DE DIREITO DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJ6KM HL2H9 HKAWX YGTGD",
                "PublishDate": "2020-10-22T00:00:00",
                "CaptureDate": "2023-05-01T01:45:17"
              },
              {
                "Content": "RECEBIDOS OS AUTOS RECEBIDO DO(A) DISTRIBUIDOR",
                "PublishDate": "2020-10-21T00:00:00",
                "CaptureDate": "2023-05-01T01:45:24"
              },
              {
                "Content": "JUNTADA DE ANOTACAO DE DISTRIBUICAO",
                "PublishDate": "2020-10-21T00:00:00",
                "CaptureDate": "2023-05-01T01:45:24"
              },
              {
                "Content": "JUNTADA DE PETICAO DE MANIFESTACAO DA PARTE",
                "PublishDate": "2020-10-20T00:00:00",
                "CaptureDate": "2023-05-01T01:45:24"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO - LIMINAR RESPONSAVEL: VALMIR ZAIAS COSECHEN",
                "PublishDate": "2020-10-20T00:00:00",
                "CaptureDate": "2023-05-01T01:45:24"
              },
              {
                "Content": "RECEBIDOS OS AUTOS",
                "PublishDate": "2020-10-20T00:00:00",
                "CaptureDate": "2023-05-01T01:45:24"
              },
              {
                "Content": "REMETIDOS OS AUTOS PARA DISTRIBUIDOR REGISTRO DE DISTRIBUICAO",
                "PublishDate": "2020-10-20T00:00:00",
                "CaptureDate": "2023-05-01T01:45:24"
              },
              {
                "Content": "DISTRIBUIDO POR SORTEIO 2 JUIZADO ESPECIAL CIVEL DE CASCAVEL",
                "PublishDate": "2020-10-20T00:00:00",
                "CaptureDate": "2023-05-01T01:45:24"
              },
              {
                "Content": "JUNTADA DE PETICAO DE INICIAL",
                "PublishDate": "2020-10-20T00:00:00",
                "CaptureDate": "2023-05-01T01:45:24"
              }
            ],
            "Petitions": [],
            "Decisions": [
              {
                "DecisionContent": "DEFIRO A DESCONSIDERACAO DA PERSONALIDADE JURIDICA PARA QUE O SOCIO ADMINISTRADOR DA RE FRI COMPONHA O POLO PASSIVO DA PRESENTE DEMANDA.",
                "DecisionDate": "2023-04-25T00:00:00"
              },
              {
                "DecisionContent": "JULGO PARCIALMENTE PROCEDENTES OS PEDIDOS FEITOS POR LEONI DA SILVAEM FACE DE FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA, FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA E GILBERTO KLEY SILVA, O QUE FACO DA SEGUINTE MANEIRA: A) PROCEDENTE O PEDIDO PARA DECLARAR A RESCISAO DO CONTRATO DE MUTUO ENTABULANDO, E CONSEQUENTEMENTE CONDENAR AS RES, SOLIDARIAMENTE, A RESTITUICAO DO VALOR DE R$ 1.000,00 (MIL REAIS), QUE DEVERA SER CORRIGIDO MONETARIAMENTE PELO INPC DESDE O DESEMBOLSO (MOV.",
                "DecisionDate": "2023-04-25T00:00:00"
              },
              {
                "DecisionContent": "JULGO PARCIALMENTE EXTINTO O PROCESSO, SEM RESOLUCAO DO MERITO, NA FORMA DO ART. 485, VIII, DO CODIGO DE PROCESSO CIVIL, TAO SOMENTE EM RELACAO AO REU STARK BANK S.A.",
                "DecisionDate": "2023-01-26T00:00:00"
              },
              {
                "DecisionContent": "ACOLHO OS EMBARGOS DE DECLARACAO, E SANANDO A OMISSAO, INDEFIRO O PEDIDO DE EXTINCAO DO FEITO SEM RESOLUCAO DE MERITO, MANTENDO A DECISAO QUE DETERMINOU O PROSSEGUIMENTO DO FEITO COM A DESIGNACAO DE NOVA AUDIENCIA DE CONCILIACAO.",
                "DecisionDate": "2022-10-26T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO O PEDIDO DE MOV. 76 E DETERMINO O CANCELAMENTO DA AUDIENCIA DE CONCILIACAO DESIGNADA PARA O DIA 24.11.2021.",
                "DecisionDate": "2021-11-19T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO O PEDIDO E DETERMINO A SUSPENSAO DO PROCESSO, PELO PRAZO DE 3 (TRES) MESES, NOS TERMOS DO ART. 313, VI, DO CPC.",
                "DecisionDate": "2021-01-27T00:00:00"
              },
              {
                "DecisionContent": "DECIDO DA TUTELA ANTECIPADA: O NOVO CPC, ARTIGO 300, UNIFICOU NUM MESMO DISPOSITIVO A TUTELA SATISFATIVA ANTECIPATORIA E A TUTELA PROVISORIA CAUTELAR, ELENCANDO OS REQUISITOS MINIMOS: 1.",
                "DecisionDate": "2020-10-22T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO O PEDIDO DE TUTELA CAUTELAR E DETERMINO: A)PROCEDA-SE O BLOQUEIO DO VALOR DE R$ 1.000,00 (MIL REAIS) NO CNPJ DOS RECLAMADOS, VIA SISTEMA SISBAJUD.",
                "DecisionDate": "2020-10-22T00:00:00"
              }
            ]
          },
          {
            "Number": "10120837720238260405",
            "Type": "PROCEDIMENTO COMUM",
            "MainSubject": "INDENIZACAO POR DANO MATERIAL",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "OSASCO",
            "Judge": "LIEGE GUELDINI DE MORAES",
            "JudgingBody": "7 VARA CIVEL",
            "State": "SP",
            "Status": "INDEFINIDO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "INDENIZAÇÃO POR DANO MATERIAL",
            "InferredCNJSubjectNumber": 14009,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO TRABALHO",
            "InferredBroadCNJSubjectNumber": 864,
            "OtherSubjects": [
              "INDENIZACAO POR DANO MATERIAL"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 62489.86,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-04-28T00:00:00",
            "NoticeDate": "2023-04-25T00:00:00",
            "LastMovementDate": "2023-04-28T00:00:00",
            "CaptureDate": "2023-05-01T14:35:44",
            "LastUpdate": "2023-05-01T14:35:44",
            "NumberOfParties": 15,
            "NumberOfUpdates": 6,
            "LawSuitAge": 309,
            "AverageNumberOfUpdatesPerMonth": 0,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "29449183899",
                "IsPartyActive": true,
                "Name": "LIEGE GUELDINI DE MORAES",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "OAB": "215181",
                  "State": "SP",
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-05-01T14:35:44"
              },
              {
                "Doc": "37875618894",
                "IsPartyActive": true,
                "Name": "BRUNA BRINGEL BRAGA AMORIM",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-05-01T14:35:44"
              },
              {
                "Doc": "07446073969",
                "IsPartyActive": true,
                "Name": "TABATA RIBEIRO BRITO MIQUELETTI",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "87889",
                  "State": "PR",
                  "SpecificType": "ADVOGADA (REQTE)"
                },
                "LastCaptureDate": "2023-05-01T14:35:44"
              },
              {
                "Doc": "13492000000106",
                "IsPartyActive": true,
                "Name": "NUVEI PAYMENTEZ DO BRASIL LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-05-01T14:35:44"
              },
              {
                "Doc": "28683892000191",
                "IsPartyActive": true,
                "Name": "PAYMEE BRASIL INSTITUICAO DE PAGAMENTO S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-05-01T14:35:44"
              },
              {
                "Doc": "44783669000172",
                "IsPartyActive": true,
                "Name": "OKTO PAGAMENTOS",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-05-01T14:35:44"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-05-01T14:35:44"
              },
              {
                "Doc": "23010551000131",
                "IsPartyActive": true,
                "Name": "PAGSMILE INTERMEDIACAO E AGENCIAMENTO DE NEGOCIOS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-05-01T14:35:44"
              },
              {
                "IsPartyActive": true,
                "Name": "BANCO BONSUCESSO S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-05-01T14:35:44"
              },
              {
                "Doc": "40000142000173",
                "IsPartyActive": true,
                "Name": "ARROW 36 GESTAO DE PAGAMENTOS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-05-01T14:35:44"
              },
              {
                "Doc": "00000000000191",
                "IsPartyActive": true,
                "Name": "BANCO DO BRASIL S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-05-01T14:35:44"
              },
              {
                "Doc": "34841787000136",
                "IsPartyActive": true,
                "Name": "PAY BROKERS COBRANCA E SERVICOS EM TECNOLOGIA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-05-01T14:35:44"
              },
              {
                "Doc": "40953545000137",
                "IsPartyActive": true,
                "Name": "PIXS COBRANCA E SERVICOS EM TECNOLOGIA S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-05-01T14:35:44"
              },
              {
                "Doc": "44653282000100",
                "IsPartyActive": true,
                "Name": "VANESSA BAY SERVICOS ADMINISTRATIVOS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-05-01T14:35:44"
              },
              {
                "IsPartyActive": true,
                "Name": "BANCO PLURAL S A BANCO MULTIPLO",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-05-01T14:35:44"
              }
            ],
            "Updates": [
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0357/2023 DATA DA PUBLICACAO: 02/05/2023 NUMERO DO DIARIO: 3726",
                "PublishDate": "2023-04-28T00:00:00",
                "CaptureDate": "2023-05-01T14:35:44"
              },
              {
                "Content": "PROCESSO 1012083-77.2023.8.26.0405 - PROCEDIMENTO COMUM CIVEL - INDENIZACAO POR DANO MATERIAL - BRUNA BRINGEL BRAGA AMORIM - VISTOS. PARA A APRECIACAO DO PEDIDO DE CONCESSAO DOS BENEFICIOS DA GRATUIDADE PROCESSUAL INFORME A REQUERENTE SE ESTA PAGANDO HONORARIOS ADVOCATICIOS (NAO PRECISA DECLINAR O VALOR), SE POSSUI VEICULOS E JUNTE COPIA DA ULTIMA DECLARACAO DE IMPOSTO DE RENDA. PRAZO: DEZ DIAS, SOB PENA DE INDEFERIMENTO. INTIME-SE. - ADV: TABATA RIBEIRO BRITO MIQUELETTI (OAB 87889/PR)",
                "PublishDate": "2023-04-28T00:00:00",
                "CaptureDate": "2023-05-01T14:35:44"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0357/2023 TEOR DO ATO: VISTOS. PARA A APRECIACAO DO PEDIDO DE CONCESSAO DOS BENEFICIOS DA GRATUIDADE PROCESSUAL INFORME A REQUERENTE SE ESTA PAGANDO HONORARIOS ADVOCATICIOS (NAO PRECISA DECLINAR O VALOR), SE POSSUI VEICULOS E JUNTE COPIA DA ULTIMA DECLARACAO DE IMPOSTO DE RENDA. PRAZO: DEZ DIAS, SOB PENA DE INDEFERIMENTO. INTIME-SE. ADVOGADOS(S): TABATA RIBEIRO BRITO MIQUELETTI (OAB 87889/PR)",
                "PublishDate": "2023-04-27T00:00:00",
                "CaptureDate": "2023-05-01T14:35:44"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2023-04-26T00:00:00",
                "CaptureDate": "2023-05-01T14:35:44"
              },
              {
                "Content": "DETERMINADA A MANIFESTACAO DO REQUERENTE/EXEQUENTE VISTOS. PARA A APRECIACAO DO PEDIDO DE CONCESSAO DOS BENEFICIOS DA GRATUIDADE PROCESSUAL INFORME A REQUERENTE SE ESTA PAGANDO HONORARIOS ADVOCATICIOS (NAO PRECISA DECLINAR O VALOR), SE POSSUI VEICULOS E JUNTE COPIA DA ULTIMA DECLARACAO DE IMPOSTO DE RENDA. PRAZO: DEZ DIAS, SOB PENA DE INDEFERIMENTO. INTIME-SE.",
                "PublishDate": "2023-04-26T00:00:00",
                "CaptureDate": "2023-05-01T14:35:44"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-04-25T00:00:00",
                "CaptureDate": "2023-05-01T14:35:44"
              }
            ],
            "Petitions": [],
            "Decisions": []
          },
          {
            "Number": "00342048820208160021",
            "Type": "CUMPRIMENTO DE SENTENCA",
            "MainSubject": "7698 - PERDAS E DANOS",
            "CourtName": "TJPR",
            "CourtLevel": "1",
            "CourtType": "ESPECIAL CIVEL",
            "CourtDistrict": "CASCAVEL",
            "Judge": "JAQUELINE ALLIEVI",
            "JudgingBody": "3 JUIZADO ESPECIAL CIVEL DE CASCAVEL",
            "State": "PR",
            "Status": "TRANSITADO EM JULGADO",
            "LawsuitHostService": "OTHER",
            "InferredCNJSubjectName": "PERDAS E DANOS",
            "InferredCNJSubjectNumber": 7698,
            "InferredCNJProcedureTypeName": "CUMPRIMENTO DE SENTENÇA",
            "InferredBroadCNJSubjectName": "DIREITO CIVIL",
            "InferredBroadCNJSubjectNumber": 899,
            "OtherSubjects": [
              "7698 - PERDAS E DANOS"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": -1,
            "ResJudicataDate": "2023-02-09T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "0001-01-01T00:00:00",
            "NoticeDate": "2020-11-03T00:00:00",
            "LastMovementDate": "2023-04-29T00:00:00",
            "CaptureDate": "2023-05-03T12:34:08",
            "LastUpdate": "2023-05-03T12:34:08",
            "NumberOfParties": 10,
            "NumberOfUpdates": 197,
            "LawSuitAge": 1212,
            "AverageNumberOfUpdatesPerMonth": 4,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "88404439915",
                "IsPartyActive": true,
                "Name": "JAQUELINE ALLIEVI",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-05-03T12:34:08"
              },
              {
                "Doc": "70313350949",
                "IsPartyActive": true,
                "Name": "DIRCEU MATIELLO",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "EXEQUENTE"
                },
                "LastCaptureDate": "2023-05-03T12:34:08"
              },
              {
                "Doc": "01456878999",
                "IsPartyActive": true,
                "Name": "ITANIEL CAMILO LEITE",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "86192N",
                  "State": "PR",
                  "SpecificType": "ADVOGADO (EXEQUENTE)"
                },
                "LastCaptureDate": "2023-05-03T12:34:08"
              },
              {
                "Doc": "03415560929",
                "IsPartyActive": true,
                "Name": "ELIANE APARECIDA DA COSTA SILVA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "49522N",
                  "State": "PR",
                  "SpecificType": "ADVOGADO (EXEQUENTE)"
                },
                "LastCaptureDate": "2023-05-03T12:34:08"
              },
              {
                "IsPartyActive": true,
                "Name": "SERGIO ROBERTO SILVA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "88135N",
                  "State": "PR",
                  "SpecificType": "ADVOGADO (EXEQUENTE)"
                },
                "LastCaptureDate": "2023-05-03T12:34:08"
              },
              {
                "Doc": "21160553000181",
                "IsPartyActive": true,
                "Name": "FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "EXECUTADO"
                },
                "LastCaptureDate": "2023-05-03T12:34:08"
              },
              {
                "Doc": "10685786000181",
                "IsPartyActive": true,
                "Name": "FRI SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "EXECUTADO"
                },
                "LastCaptureDate": "2023-05-03T12:34:08"
              },
              {
                "Doc": "18583984875",
                "IsPartyActive": true,
                "Name": "GILBERTO KLEY SILVA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "EXECUTADO"
                },
                "LastCaptureDate": "2023-05-03T12:34:08"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "EXECUTADO"
                },
                "LastCaptureDate": "2023-05-03T12:34:08"
              },
              {
                "Doc": "35068411817",
                "IsPartyActive": true,
                "Name": "RAFAEL HIDEO NAZIMA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "295443N",
                  "State": "SP",
                  "SpecificType": "ADVOGADO (EXECUTADO)"
                },
                "LastCaptureDate": "2023-05-03T12:34:08"
              }
            ],
            "Updates": [
              {
                "Content": "DECORRIDO PRAZO DE FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA (PARA FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA *REFERENTE AO EVENTO (SEQ. 185) INDEFERIDO O PEDIDO (30/03/2023)",
                "PublishDate": "2023-04-29T00:00:00",
                "CaptureDate": "2023-05-03T12:34:50"
              },
              {
                "Content": "DECORRIDO PRAZO DE FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA (PARA FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA *REFERENTE AO EVENTO (SEQ. 185) INDEFERIDO O PEDIDO (30/03/2023)",
                "PublishDate": "2023-04-29T00:00:00",
                "CaptureDate": "2023-05-03T12:34:50"
              },
              {
                "Content": "DECORRIDO PRAZO DE GILBERTO KLEY SILVA (PARA GILBERTO KLEY SILVA *REFERENTE AO EVENTO (SEQ. 185) INDEFERIDO O PEDIDO (30/03/2023)",
                "PublishDate": "2023-04-29T00:00:00",
                "CaptureDate": "2023-05-03T12:34:50"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO REFERENTE AO EVENTO (SEQ. 193) JUNTADA DE CERTIDAO (26/04/2023).",
                "PublishDate": "2023-04-26T00:00:00",
                "CaptureDate": "2023-05-03T12:34:50"
              },
              {
                "Content": "JUNTADA DE CERTIDAO",
                "PublishDate": "2023-04-26T00:00:00",
                "CaptureDate": "2023-05-03T12:34:50"
              },
              {
                "Content": "ATO ORDINATORIO PRATICADO VALOR: R$14.837,12 (IMPORTACAO). CEF AG: 3983 CONTA: 1636750-5. DEPOSITO GERADO VIA CONVERSAO FISICA EM ELETRONICA ATRAVES DA CONTA JUDICIAL.",
                "PublishDate": "2023-04-26T00:00:00",
                "CaptureDate": "2023-05-03T12:34:50"
              },
              {
                "Content": "JUNTADA DE PETICAO DE REQUERIMENTO DE ALVARA DE LEVANTAMENTO DE VALORES",
                "PublishDate": "2023-04-24T00:00:00",
                "CaptureDate": "2023-05-03T12:34:50"
              },
              {
                "Content": "RECEBIDOS OS AUTOS RECEBIDO DO(A) DISTRIBUIDOR",
                "PublishDate": "2023-04-10T00:00:00",
                "CaptureDate": "2023-05-03T12:34:50"
              },
              {
                "Content": "JUNTADA DE CERTIDAO",
                "PublishDate": "2023-04-10T00:00:00",
                "CaptureDate": "2023-05-03T12:34:50"
              },
              {
                "Content": "ATO CUMPRIDO PELA PARTE OU INTERESSADO REFERENTE AO EVENTO (SEQ. 185) INDEFERIDO O PEDIDO (30/03/2023).",
                "PublishDate": "2023-04-04T00:00:00",
                "CaptureDate": "2023-05-03T12:34:50"
              },
              {
                "Content": "REMETIDOS OS AUTOS PARA DISTRIBUIDOR ANOTACOES",
                "PublishDate": "2023-04-04T00:00:00",
                "CaptureDate": "2023-05-03T12:34:50"
              },
              {
                "Content": "EVOLUIDA A CLASSE DE PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL PARA CUMPRIMENTO DE SENTENCA",
                "PublishDate": "2023-04-04T00:00:00",
                "CaptureDate": "2023-05-03T12:34:50"
              },
              {
                "Content": "INDEFERIDO O PEDIDO . VEICULADO NO DJEN EM 05/04/2023. PROJUDI - PROCESSO: 0034204-88.2020.8.16.0021 - REF. MOV. 185.1 - ASSINADO DIGITALMENTE POR JAQUELINE ALLIEVI:9260 30/03/2023: INDEFERIDO O PEDIDO. ARQ: DECISAO PODER JUDICIARIO DO ESTADO DO PARANA COMARCA DE CASCAVEL 3 JUIZADO ESPECIAL CIVEL DE CASCAVEL - PROJUDI AVENIDA TANCREDO NEVES, 2320 - FORUM - ALTO ALEGRE - CASCAVEL/PR - CEP: 85.801-900 - FONE: (45) 3392-5069 - CELULAR: (45) 3392- 5119 - E-MAIL: CAS-17VJ-S@TJPR.JUS.BR PROCESSO: 0034204-88.2020.8.16.0021 CLASSE PROCESSUAL: PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL ASSUNTO PRINCIPAL: PERDAS E DANOS VALOR DA CAUSA: R$21.000,00 POLO ATIVO(S): DIRCEU MATIELLO POLO PASSIVO(S): FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA GILBERTO KLEY SILVA STARK BANK S.A. VISTOS. 1) ALTERE-SE A CLASSE PROCESSUAL PERANTE O PROJUDI PARA CUMPRIMENTO DE SENTENCA, COMUNICANDO AO DISTRIBUIDOR. 2) INDEFIRO O PEDIDO DE TUTELA DE URGENCIA FORMULADO PELO EXEQUENTE (REF. 183.1), POIS REQUERIDO GENERICAMENTE, SEM QUALQUER DEMONSTRACAO DO PREENCHIMENTO DOS REQUISITOS LEGAIS. 3) CONSIDERANDO QUE OS REUS GILBERTO, FORTS E FRI SAO REVEIS E NAO CONSTITUIRAM ADVOGADO, CONTRA ELES CORRERAO OS PRAZOS INDEPENDENTEMENTE DE INTIMACAO, A PARTIR DA PUBLICACAO DE CADA ATO DECISORIO, NOS TERMOS DO ARTIGO 346, DO CODIGO DE PROCESSO CIVIL. 4) AGUARDE-SE, POR 15 (QUINZE) DIAS, PELO PAGAMENTO DA IMPORTANCIA DE R$ 19.614,02 (DEZENOVE MIL, SEISCENTOS E QUATORZE REAIS E DOIS CENTAVOS), ATUALIZADA E ACRESCIDA DE JUROS DE MORA, CONFORME CALCULOS DE REF. 183.2. DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJY6V RK5UC 8YC3U 6TLM3 5) NAO COMPROVADO O ADIMPLEMENTO DA OBRIGACAO, ACRESCENTE-SE AO VALOR DEVIDO A MULTA DE 10% (ART. 523, 1, DO CPC) E PROCEDA-SE A PENHORA ONLINE, DEVENDO A ORDEM SER REITERADA PELO PERIODO DE 30 (TRINTA) DIAS (\"TEIMOSINHA\"). 5.1) NAO SERA CONHECIDA IMPUGNACAO AO CUMPRIMENTO DE SENTENCA SEM PREVIA GARANTIA DO JUIZO, DEVENDO O CUMPRIMENTO PROSSEGUIR, INDEPENDENTEMENTE DE CONCLUSAO, NOS TERMOS ABAIXO. CONFORME O ENUNCIADO 117 DO FONAJE E OBRIGATORIA A SEGURANCA DO JUIZO PELA PENHORA PARA APRESENTACAO DE EMBARGOS A EXECUCAO DE TITULO JUDICIAL OU EXTRAJUDICIAL PERANTE O JUIZADO ESPECIAL. 5.2) HAVENDO PENHORA PARCIAL E/OU INSUFICIENTE DE DINHEIRO, OS AUTOS DEVERAO AGUARDAR 5 (CINCO) DIAS EM CARTORIO PELA MANIFESTACAO DO(A) DEVEDOR(A) QUANTO AS MATERIAS CONTIDAS NO ARTIGO 854, 3, I E II, DO CODIGO DE PROCESSO CIVIL. HAVENDO MANIFESTACAO, INTIME-SE O(A) EXEQUENTE PARA, QUERENDO, TAMBEM SE MANIFESTAR EM 5 (CINCO) DIAS, E O PROCESSO DEVERA SER REMETIDO A CONCLUSAO. 5.3) POREM, HAVENDO PENHORA DO VALOR INTEGRAL DO DEBITO, AGUARDE-SE POR 15 (QUINZE) DIAS PELO OFERECIMENTO DE IMPUGNACAO PELO(A) EXECUTADO(A). APRESENTADA A IMPUGNACAO, INTIME-SE O(A) EXEQUENTE PARA QUE SE MANIFESTE, NO PRAZO DE 15 (QUINZE) DIAS E REMETA-SE O FEITO CONCLUSO. 6) RESULTANDO NEGATIVA A TENTATIVA DE PENHORA ONLINE, PROCEDA-SE A PESQUISA E AO BLOQUEIO DE TRANSFERENCIA DE VEICULOS PELO SISTEMA RENAJUD, EXPEDINDO-SE O RESPECTIVO MANDADO DE PENHORA E AVALIACAO, CASO SEJAM ENCONTRADOS AUTOMOVEIS/MOTOCICLETAS LIVRES E DESEMBARACADOS. PROJUDI - PROCESSO: 0034204-88.2020.8.16.0021 - REF. MOV. 185.1 - ASSINADO DIGITALMENTE POR JAQUELINE ALLIEVI:9260 30/03/2023: INDEFERIDO O PEDIDO. ARQ: DECISAO 6.1) TENDO EM VISTA A IMPOSSIBILIDADE DE REMOCAO DOS BENS AO DEPOSITARIO PUBLICO DA COMARCA (CF. DECISAO N 7425311, DA CORREGEDORIA GERAL DA JUSTICA DO TJPR), DETERMINO, COM BASE NO ARTIGO 840, PARAGRAFO 1, DO CODIGO DE PROCESSO CIVIL, QUE O BENS MOVEIS PENHORADOS SEJAM DEPOSITADOS EM PODER DA PARTE EXEQUENTE. 6.1.1) INTIME-SE A PARTE CREDORA PARA QUE TOME CIENCIA DO ENCARGO DE DEPOSITARIO FIEL E ACOMPANHE A DILIGENCIA EFETUADA PELO OFICIAL DE JUSTICA, FICANDO CIENTE QUE, NA SUA AUSENCIA, O BEM FICARA DEPOSITADO EM PODER DA PARTE EXECUTADA. 6.2) SE FOREM LOCALIZADOS VEICULOS SOBRE OS QUAIS PENDA CONTRATO DE ALIENACAO FIDUCIARIA, PROCEDA-SE APENAS AO RESPECTIVO BLOQUEIO DE TRANSFERENCIA, INTIMANDO-SE A PARTE EXEQUENTE PARA, EM 15 (QUINZE) DIAS, REQUERER O QUE ENTENDER DE DIREITO. ATENTE-SE A SECRETARIA, PORTANTO, PARA NAO EXPEDIR MANDADO DE PENHORA DE BENS ALIENADOS FIDUCIARIAMENTE. 7) DECORRIDO IN ALBIS O PRAZO A QUE SE REFERE O ITEM ANTERIOR OU NAO ENCONTRADOS BENS PERANTE O RENAJUD, EXPECA-SE MANDADO DE PENHORA E AVALIACAO DE OUTROS BENS SUFICIENTES PARA GARANTIR A EXECUCAO, LAVRANDO- SE O RESPECTIVO AUTO E DEPOSITO NA FORMA DA LEI E DE TAIS ATOS INTIMANDO, NA MESMA OPORTUNIDADE, O EXECUTADO, ARTIGO 829,  1, DO CPC. 7.1) HAVENDO PENHORA DE VEICULOS E/OU DE OUTROS BENS, AGUARDE-SE POR 15 (QUINZE) DIAS PELO OFERECIMENTO DE IMPUGNACAO PELO(A) EXECUTADO(A). APRESENTADA A IMPUGNACAO, INTIME-SE O(A) EXEQUENTE PARA QUE SE MANIFESTE, NO PRAZO DE 15 (QUINZE) DIAS E REMETA-SE O FEITO CONCLUSO. 8) NOS MANDADOS DE PENHORA DEVERA CONSTAR: A) AUTORIZACAO DE AUXILIO DE FORCA POLICIAL (ART. 846, 1, DO CPC); E B) A INTIMACAO DO(A) EXECUTADO(A) PARA, EM 5 (CINCO) DIAS, INDICAR QUAIS SAO E ONDE ESTAO OS SEUS BENS SUJEITOS A PENHORA E OS RESPECTIVOS VALORES, SOB PENA DE INCIDENCIA DE MULTA DE ATE 20% DO VALOR ATUALIZADO DO DEBITO EM EXECUCAO POR ATO ATENTATORIO A DIGNIDADE DA JUSTICA (ART. 774, V, DO CPC). NO CASO DE O(A) DEVEDOR(A) AFIRMAR DE PRONTO QUE NAO POSSUI QUALQUER BEM, TAL INFORMACAO DEVERA SER CERTIFICADA PELO OFICIAL DE JUSTICA. DILIGENCIAS NECESSARIAS. DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJY6V RK5UC 8YC3U 6TLM3 CASCAVEL-PR, DATADO ELETRONICAMENTE. JAQUELINE ALLIEVI JUIZA DE DIREITO",
                "PublishDate": "2023-03-30T00:00:00",
                "CaptureDate": "2023-05-03T12:34:50"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO RESPONSAVEL: JAQUELINE ALLIEVI",
                "PublishDate": "2023-03-14T00:00:00",
                "CaptureDate": "2023-05-03T12:34:58"
              },
              {
                "Content": "JUNTADA DE PETICAO DE SOLICITACAO A EXECUCAO CUMPRIMENTO DE INTIMACAO - REFERENTE AO EVENTO JUNTADA DE CERTIDAO (09/02/2023)",
                "PublishDate": "2023-03-14T00:00:00",
                "CaptureDate": "2023-05-03T12:34:58"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA REFERENTE AO EVENTO (SEQ. 174) JUNTADA DE CERTIDAO (09/02/2023) E AO EVENTO DE EXPEDICAO SEQ. 175.",
                "PublishDate": "2023-02-20T00:00:00",
                "CaptureDate": "2023-05-03T12:34:58"
              },
              {
                "Content": "TRANSITADO EM JULGADO EM 09/02/2023 PARA O PROCESSO.",
                "PublishDate": "2023-02-09T00:00:00",
                "CaptureDate": "2023-05-03T12:34:58"
              },
              {
                "Content": "TRANSITADO EM JULGADO EM 09/02/2023 PARA STARK BANK S.A..",
                "PublishDate": "2023-02-09T00:00:00",
                "CaptureDate": "2023-05-03T12:34:58"
              },
              {
                "Content": "TRANSITADO EM JULGADO EM 09/02/2023 PARA GILBERTO KLEY SILVA.",
                "PublishDate": "2023-02-09T00:00:00",
                "CaptureDate": "2023-05-03T12:34:58"
              },
              {
                "Content": "TRANSITADO EM JULGADO EM 09/02/2023 PARA FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA.",
                "PublishDate": "2023-02-09T00:00:00",
                "CaptureDate": "2023-05-03T12:34:58"
              },
              {
                "Content": "TRANSITADO EM JULGADO EM 09/02/2023 PARA FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA.",
                "PublishDate": "2023-02-09T00:00:00",
                "CaptureDate": "2023-05-03T12:34:58"
              },
              {
                "Content": "TRANSITADO EM JULGADO EM 09/02/2023 PARA DIRCEU MATIELLO.",
                "PublishDate": "2023-02-09T00:00:00",
                "CaptureDate": "2023-05-03T12:34:58"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO REFERENTE AO EVENTO (SEQ. 174) JUNTADA DE CERTIDAO (09/02/2023).",
                "PublishDate": "2023-02-09T00:00:00",
                "CaptureDate": "2023-05-03T12:34:58"
              },
              {
                "Content": "JUNTADA DE CERTIDAO",
                "PublishDate": "2023-02-09T00:00:00",
                "CaptureDate": "2023-05-03T12:34:58"
              },
              {
                "Content": "DECORRIDO PRAZO DE STARK BANK S.A. (P/ ADVGS. DE STARK BANK S.A. *REFERENTE AO EVENTO (SEQ. 169) JULGADA PROCEDENTE EM PARTE A ACAO (05/12/2022) E AO EVENTO DE EXPEDICAO SEQ. 170.",
                "PublishDate": "2023-02-04T00:00:00",
                "CaptureDate": "2023-05-03T12:34:58"
              },
              {
                "Content": "DECORRIDO PRAZO DE DIRCEU MATIELLO (P/ ADVGS. DE DIRCEU MATIELLO *REFERENTE AO EVENTO (SEQ. 169) JULGADA PROCEDENTE EM PARTE A ACAO (05/12/2022) E AO EVENTO DE EXPEDICAO SEQ. 170.",
                "PublishDate": "2023-02-04T00:00:00",
                "CaptureDate": "2023-05-03T12:34:58"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA REFERENTE AO EVENTO (SEQ. 169) JULGADA PROCEDENTE EM PARTE A ACAO (05/12/2022) E AO EVENTO DE EXPEDICAO SEQ. 170.",
                "PublishDate": "2022-12-20T00:00:00",
                "CaptureDate": "2023-05-03T12:34:58"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO REFERENTE AO EVENTO (SEQ. 169) JULGADA PROCEDENTE EM PARTE A ACAO (05/12/2022).",
                "PublishDate": "2022-12-09T00:00:00",
                "CaptureDate": "2023-05-03T12:34:58"
              },
              {
                "Content": "JULGADA PROCEDENTE EM PARTE A ACAO REGISTRO EM 06/12/2022 SOB N 1.551.407.806. VEICULADO NO DJEN EM 12/12/2022. PROJUDI - PROCESSO: 0034204-88.2020.8.16.0021 - REF. MOV. 169.1 - ASSINADO DIGITALMENTE POR JAQUELINE ALLIEVI:9260 05/12/2022: JULGADA PROCEDENTE EM PARTE A ACAO. ARQ: SENTENCA PODER JUDICIARIO DO ESTADO DO PARANA COMARCA DE CASCAVEL 3 JUIZADO ESPECIAL CIVEL DE CASCAVEL - PROJUDI AVENIDA TANCREDO NEVES, 2320 - FORUM - ALTO ALEGRE - CASCAVEL/PR - CEP: 85.801-900 - FONE: (45) 3392-5069 - CELULAR: (45) 3392- 5119 - E-MAIL: CAS-17VJ-S@TJPR.JUS.BR CLASSE PROCESSUAL: PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL ASSUNTO PRINCIPAL: PERDAS E DANOS PROCESSO N: 0034204-88.2020.8.16.0021 POLO ATIVO(S): DIRCEU MATIELLO POLO PASSIVO(S): FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA GILBERTO KLEY SILVA STARK BANK S.A. VISTOS. TRATA-SE DE ACAO DECLARATORIA DE NULIDADE DE NEGOCIO JURIDICO CUMULADA COM PEDIDO DE RESTITUICAO DE VALORES E DE INDENIZACAO POR DANOS MORAIS QUE DIRCEU MATIELLO MOVE EM FACE DE FRI SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA, DE GILBERTO KLEY SILVA, DE FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA (FORTS BANK) E DE STARK BANK S/A. CONCILIACAO REJEITADA. RELATORIO DISPENSADO (ARTIGO 38 DA LEI N. 9.099/95). OS DOCUMENTOS QUE INSTRUEM OS AUTOS E AS ALEGACOES DAS PARTES SAO SUFICIENTES PARA QUE SE PROCEDA AO JULGAMENTO ANTECIPADO DO MERITO (ARTIGO 355, I DO CODIGO DE PROCESSO CIVIL). DECIDO OS FUNDAMENTOS DA SENTENCA, AINDA MAIS NO SISTEMA DOS JUIZADOS ESPECIAIS, DEVEM PRIMAR PELA OBJETIVIDADE, SIMPLICIDADE, INFORMALIDADE E PRECISAO, A FIM DE PERMITIREM CELERIDADE NA RESOLUCAO DOS DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJZL5 WB8QH UA6W6 ZTURK CONFLITOS (ART. 2 DA LEI N 9.099/95), SEM PREJUIZO DO ENFRENTAMENTO DAS QUESTOES IMPORTANTES SUSCITADAS PELAS PARTES E DA EXPOSICAO DO CONVENCIMENTO MOTIVADO DO JUIZ (ART. 371 DO CPC C/C ARTIGOS 5 E 6 DA LEI N 9.099/95). NORTEANDO-SE POR TAIS PRECEITOS, PASSA-SE A DECIDIR. 1. PRELIMINARMENTE DA ILEGITIMIDADE PASSIVA ACOLHO A PRELIMINAR DE ILEGITIMIDADE SUSCITADA PELO STARK BANK S/A, POIS SE TRATA DE UMA FINTECH QUE OPERA COM O AUXILIO DO BANCO ITAU LICITAMENTE NO MERCADO. ELA SE LIMITOU A FAZER A INTERMEDIACAO, COMO UMA AGENTE BANCARIA, PARA QUE O PAGAMENTO DO AUTOR FEITO EM BENEFICIO DA FORTS CHEGASSE A ESSA DESTINATARIA (REF. 1.6). LOGO, O STARK BANK S/A NAO FOI BENEFICIARIO DOS VALORES, NAO TINHA A OBRIGACAO DE INVESTIGAR A ORIGEM E A CAUSA DA TRANSACAO FEITA PELO AUTOR EM PROL DA DEPOSITARIA. NA INICIAL ALEGOU-SE QUE O BANCO INTERMEDIADOR INTEGRA O MESMO GRUPO ECONOMICO DAS CORRES, MAS ISSO NAO FOI MINIMAMENTE DEMONSTRADO. DIANTE DO EXPOSTO, JULGO EXTINTO O PROCESSO EM FACE DA REFERIDA RE, SEM RESOLUCAO DE MERITO. 2. MERITO O AUTOR ALEGOU, EM BREVE SINTESE, QUE EM 12/11/2019 ADERIU A UMA PROPOSTA DE INVESTIMENTOS FEITA PELA FRI SERVICOS DE CONSULTORIA E INVESTIMENTOS. DEPOSITOU EM CONTA POR ELA INDICADA, DA CORRE FORTS, O VALOR DE R$ 13.000,00 (TREZE MIL REAIS), SOB A PROMESSA DE QUE RECEBERIA CONTRAPRESTACAO MENSAL DE 10% DE JUROS, DESDE QUE NAO EFETUASSE O SAQUE DO VALOR EM DOZE MESES. DESCOBRIU, POSTERIORMENTE, POR NOTICIAS PROJUDI - PROCESSO: 0034204-88.2020.8.16.0021 - REF. MOV. 169.1 - ASSINADO DIGITALMENTE POR JAQUELINE ALLIEVI:9260 05/12/2022: JULGADA PROCEDENTE EM PARTE A ACAO. ARQ: SENTENCA NA MIDIA, QUE AS RES NAO ESTAVAM CUMPRINDO O PROMETIDO E QUE ELE HAVIA SIDO VITIMA DE UM GOLPE DE PIRAMIDE FINANCEIRA. BUSCA A DECLARACAO DE NULIDADE DO NEGOCIO JURIDICO, A RESTITUICAO DOS VALORES PAGOS, MAIS INDENIZACAO POR DANOS MORAIS. OS PEDIDOS DE NULIDADE CONTRATUAL E DE INDENIZACAO POR DANOS MATERIAIS, CONSISTENTE NA RESTITUICAO DE VALORES PAGOS/INVESTIDOS PELO AUTOR, DEVEM SER ACOLHIDOS. AS RES FRI E FORTS E SEU SOCIO GILBERTO FORAM CITADOS POR AR (REFS. 160.1), POREM NAO COMPARECERAM A AUDIENCIA DE CONCILIACAO (REF. 162.1), NEM APRESENTARAM DEFESA. ESTAO SUJEITOS, PORTANTO, AS PENAS DA REVELIA (ARTIGO 20 DA LEI N 9.099/95 C/C ART. 344 CPC), PRESUMINDO-SE VERDADEIROS OS FATOS ALEGADOS NA PETICAO INICIAL. VEJA-SE QUE OS AR DE REF. 160.1 FOI RECEBIDO PELO PROPRIO SOCIO DAS RES. ALEM DISSO, ESTA PROVADO PELO COMPROVANTE BANCARIO DE REF. 1.6, QUE NO DIA 12/11/2019, O AUTOR REALIZOU DEPOSITO DE R$ 13.000,00 (TREZE MIL REAIS) PARA CONTA BANCARIA DE TITULARIDADE DA RE FORTS, EM DECORRENCIA DA REALIZACAO UM APORTE FINANCEIRO (INVESTIMENTO), QUE PROMETIA O RETORNO DE 10% DO CAPITAL INVESTIDO AO FINAL DO PERIODO DE DOZE (12) MESES. DO ENCARTE DE PRODUTOS DAS RES (REF. 1.11), VERIFICA-SE UMA SERIE DE PROMESSAS DE LUCRO FACIL, TOTALMENTE INEXPLICADOS, SENDO EVIDENTE QUE A ORGANIZACAO DELAS ERA POR MEIO DE PIRAMIDE FINANCEIRA, OU, DE FORMA MAIS DIRETA AINDA, FUNDADA NO SIMPLES CONVENCIMENTO DE PESSOAS INCAUTAS A LHES ENTREGAREM QUANTIAS DE DINHEIRO NA ESPERANCA DE BONS LUCROS OU NEGOCIOS, PROPAGADO ATRAVES DE ILUSORIAS ATIVIDADES POR MEIO DAS MIDIAS SOCIAIS. AS RES NAO POSSUEM REGISTRO COMO INSTITUICOES FINANCEIRAS AUTORIZADAS JUNTO AO BANCO CENTRAL DO BRASIL, NEM POSSUEM AUTORIZACAO OU REGISTRO NA COMISSAO DE VALORES MOBILIARIOS (CVM), ORGAO REGULADOR DO MERCADO DE VALORES MOBILIARIOS NO BRASIL, O QUE DENOTA TEREM SIDO CONSTITUIDAS, RECENTEMENTE, PARA APARENCIA DE LEGALIDADE, COM O CLARO PROPOSITO ILICITO DE LESAR PESSOAS, SENDO O AUTOR MAIS UMA DAS VITIMAS. INEXISTINDO DUVIDAS SOBRE O GOLPE QUE AS RES, QUE AGIAM EM CONLUIO, ADMINISTRADAS PELA MESMA PESSOA, GILBERTO KLEY SILVA, EFETIVARAM EM FACE DO AUTOR, E DIANTE DA PRESUNCAO DE QUE NAO HOUVE NENHUM PAGAMENTO/RETORNO EM FAVOR DELE, QUE AGIU DE BOA-FE, REVELA-SE JUSTIFICADA A NULIFICACAO DOS CONTRATOS ENTRE AS PARTES E QUE ESTA EM POSSE DAS RES, COM A RESTITUICAO DOS VALORES PAGOS (CC, ART. 166, II E VI). NESSE SENTIDO: DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJZL5 WB8QH UA6W6 ZTURK APELACAO CIVEL. DIREITO CIVIL. NULIDADE DE NEGOCIO JURIDICO. OBJETO ILICITO. PIRAMIDE FINANCEIRA. RESTITUICAO DO VALOR DESEMBOLSADO. 1 - AS CHAMADAS PIRAMIDES FINANCEIRAS SAO PRATICAS ILICITAS DISFARCADAS DE MODELOS COMERCIAIS DE RENTABILIDADE PROPORCIONAL AO DESEMPENHO DO PARTICIPANTE. TODAVIA, O PROMETIDO GANHO FINANCEIRO REVELA-SE INVIAVEL EM RAZAO DA SATURACAO DO MEIO EMPREGADO PARA OBTENCAO DO LUCRO, PROVOCANDO, INEVITAVELMENTE, PREJUIZOS AOS PARTICIPANTES QUE INGRESSAREM POR ULTIMO NO SISTEMA. 2 - O INCISO IX DO ARTIGO 2 DA LEI 1.521/1951 CRIMINALIZA A CONDUTA DE OBTER OU TENTAR OBTER GANHOS ILICITOS EM DETRIMENTO DO POVO OU DE NUMERO INDETERMINADO DE PESSOAS MEDIANTE ESPECULACOES OU PROCESSOS FRAUDULENTOS (\"BOLA DE NEVE\", \"CADEIAS\", \"PICHARDISMO\" E QUAISQUER OUTROS EQUIVALENTES), O QUE ENQUADRA AS PIRAMIDES FINANCEIRAS. PRECEDENTES. 3 - O CODIGO CIVIL, EM SEU ARTIGO 166, DISPOE SER NULO O NEGOCIO JURIDICO CUJO OBJETO REVELAR-SE ILICITO, RAZAO PELA QUAL O NEGOCIO JURIDICO CONFIGURADO COMO PIRAMIDE FINANCEIRA NAO POSSUI VALIDADE. 4 - NOS TERMOS DO ART. 182, ANULADO O NEGOCIO JURIDICO, RESTITUIR-SE-AO AS PARTES AO ESTADO EM QUE ANTES DELE SE ACHAVAM, E, NAO SENDO POSSIVEL RESTITUI-LAS, SERAO INDENIZADAS COM O EQUIVALENTE. 5 - RECURSO DE APELACAO A QUE SE NEGA PROVIMENTO. (TJ-DF 07067683320178070001 DF 0706768- 33.2017.8.07.0001, RELATOR: GETULIO DE MORAES OLIVEIRA, DATA DE JULGAMENTO: 13/12/2017, 7 TURMA CIVEL, DATA DE PUBLICACAO: PUBLICADO NO DJE DE 23/01/2018). QUANTO AO PEDIDO DE INDENIZACAO POR DANOS MORAIS, TODAVIA, ENTENDO QUE NAO DEVE SER ACOLHIDO. PROJUDI - PROCESSO: 0034204-88.2020.8.16.0021 - REF. MOV. 169.1 - ASSINADO DIGITALMENTE POR JAQUELINE ALLIEVI:9260 05/12/2022: JULGADA PROCEDENTE EM PARTE A ACAO. ARQ: SENTENCA ISSO PORQUE, O AUTOR TEVE APENAS PREJUIZO FINANCEIRO, PERDEU DINHEIRO COM INVESTIMENTO QUE FEZ A PARTIR DE PROMESSA DE LUCRO FACIL, IRREAL PARA OS PADROES NORMAIS DE MERCADO, OU SEJA, MOVIDO EM BOA PARTE POR GANANCIA PESSOAL. NAO HOUVE EXTRAORDINARIA LESAO AOS DIREITOS DA PERSONALIDADE DELE, EM ESPECIAL A DIGNIDADE, A IMAGEM, A HONRA, A PAZ. NAO HA EVIDENCIAS DE QUE A QUANTIA INVESTIDA TENHA IMPLICADO RESTRICAO AO ORCAMENTO COTIDIANO DO AUTOR, TENHA COMPROMETIDO GASTOS COM QUALQUER BEM EXISTENCIAL. ALEM DISSO, A CONFIGURACAO DO DANO MORAL PRESSUPOE UMA GRAVE AGRESSAO OU ATENTADO A DIREITO DA PERSONALIDADE, CAPAZ DE PROVOCAR SOFRIMENTOS E HUMILHACOES INTENSOS, DESCOMPONDO O EQUILIBRIO PSICOLOGICO DO INDIVIDUO POR UM PERIODO DE TEMPO DESARRAZOADO (AGINT NO RESP 1655465/RS, REL. MINISTRA NANCY ANDRIGHI, TERCEIRA TURMA, JULGADO EM 24/04/2018, DJE 02/05/2018). COM EFEITO, SOMENTE HAVERA INDENIZACAO POR DANOS MORAIS SE, ALEM DO DESCUMPRIMENTO DO CONTRATO, FICAR DEMONSTRADA CIRCUNSTANCIA ESPECIAL CAPAZ DE ATINGIR OS DIREITOS DE PERSONALIDADE, O QUE NAO SE CONFUNDE COM O MERO DISSABOR (RESP 1599224/RS, REL. MINISTRO ANTONIO CARLOS FERREIRA, QUARTA TURMA, JULGADO EM 08/08/2017, DJE 16/08/2017). 3. DISPOSITIVO DIANTE DO EXPOSTO, RESOLVO O MERITO NA FORMA DO ARTIGO 487, I, DO CODIGO DE PROCESSO CIVIL E JULGO PARCIALMENTE PROCEDENTES OS PEDIDOS CONTIDOS NA PETICAO INICIAL, PARA OS FINS DE A) DECLARAR NULO O CONTRATO FIRMADO ENTRE O AUTOR E AS RES FRI E FORTS; E, B) CONDENAR OS REUS FRI SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA, GILBERTO KLEY SILVA, E FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA (FORTS BANK), REVEIS, SOLIDARIAMENTE, A RESTITUIREM AO AUTOR O VALOR DE R$ 13.000,00 (TREZE MIL REAIS), CORRIGIDO MONETARIAMENTE PELA MEDIA DO INPC/IGP-DI DESDE O DESEMBOLSO (12/11/2019) E A SOMAR JUROS DE MORA DE 1% AO MES A CONTAR DA CITACAO EM 05/08 /2022. JULGO EXTINTO O PROCESSO EM FACE DE STARK BANK S/A, SEM RESOLUCAO DE MERITO, NA FORMA DO ARTIGO 485, VI, DO CODIGO DE PROCESSO CIVIL. DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJZL5 WB8QH UA6W6 ZTURK REVEJO, EM PARTE, A DECISAO INTERLOCUTORIA ANTECIPATORIA DE TUTELA DE REF. 11.1, NA PARTE EM QUE PREJUDICA O STARK BANK. EM CONSEQUENCIA, DETERMINO A SECRETARIA QUE PROCEDA AO LEVANTAMENTO DAS RESTRICOES RENAJUD CONTRA VEICULOS DESSE BANCO, BEM COMO RESTITUA-SE A ELE O DEPOSITO DE REF. 18.1. HAVENDO INTERESSE EM RECORRER, A PARTE RECORRENTE E NAO BENEFICIARIA DA GRATUIDADE DA JUSTICA DEVERA PAGAR, A TITULO DE CUSTAS RECURSAIS, O VALOR EQUIVALENTE A 3% (TRES POR CENTO) DO VALOR DA CAUSA, OBSERVADOS OS LIMITES MINIMO E MAXIMO DADOS PELA LEI ESTADUAL N. 18.413/2014 E SUAS ATUALIZACOES POSTERIORES (VIDE DECRETOS NO SITE DO TJPR). PUBLIQUE-SE. REGISTRE-SE. INTIME-SE. CASCAVEL-PR, DATADO ELETRONICAMENTE. JAQUELINE ALLIEVI JUIZA DE DIREITO",
                "PublishDate": "2022-12-05T00:00:00",
                "CaptureDate": "2023-05-03T12:34:58"
              },
              {
                "Content": "CONCLUSOS PARA SENTENCA RESPONSAVEL: JAQUELINE ALLIEVI",
                "PublishDate": "2022-11-30T00:00:00",
                "CaptureDate": "2023-05-03T12:35:09"
              },
              {
                "Content": "ATO CUMPRIDO PELA PARTE OU INTERESSADO RENUNCIA DE PRAZO DE DIRCEU MATIELLO - REFERENTE AO EVENTO PROFERIDO DESPACHO DE MERO EXPEDIENTE (04/10/2022)",
                "PublishDate": "2022-10-25T00:00:00",
                "CaptureDate": "2023-05-03T12:35:09"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA REFERENTE AO EVENTO (SEQ. 164) PROFERIDO DESPACHO DE MERO EXPEDIENTE (04/10/2022) E AO EVENTO DE EXPEDICAO SEQ. 165.",
                "PublishDate": "2022-10-16T00:00:00",
                "CaptureDate": "2023-05-03T12:35:09"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO REFERENTE AO EVENTO (SEQ. 164) PROFERIDO DESPACHO DE MERO EXPEDIENTE (04/10/2022).",
                "PublishDate": "2022-10-05T00:00:00",
                "CaptureDate": "2023-05-03T12:35:09"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE . VEICULADO NO DJEN EM 06/10/2022. PROJUDI - PROCESSO: 0034204-88.2020.8.16.0021 - REF. MOV. 164.1 - ASSINADO DIGITALMENTE POR JAQUELINE ALLIEVI:9260 04/10/2022: PROFERIDO DESPACHO DE MERO EXPEDIENTE. ARQ: DESPACHO PODER JUDICIARIO DO ESTADO DO PARANA COMARCA DE CASCAVEL 3 JUIZADO ESPECIAL CIVEL DE CASCAVEL - PROJUDI AVENIDA TANCREDO NEVES, 2320 - FORUM - ALTO ALEGRE - CASCAVEL/PR - CEP: 85.801-900 - FONE: (45) 3392-5069 - CELULAR: (45) 3392- 5119 - E-MAIL: CAS-17VJ-S@TJPR.JUS.BR CLASSE PROCESSUAL: PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL ASSUNTO PRINCIPAL: PERDAS E DANOS PROCESSO N: 0034204-88.2020.8.16.0021 POLO ATIVO(S): DIRCEU MATIELLO POLO PASSIVO(S): FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA GILBERTO KLEY SILVA STARK BANK S.A. VISTOS. REPUTO OS REUS GILBERTO, FORTS E FRI CITADOS PELO AR DE REF. 160.1, HAJA VISTA TER SIDO A CARTA RECEBIDA POR AQUELE REU, QUE E TAMBEM SOCIO DESSAS RECLAMADAS. O REU STARK BANK COMPARECEU AOS AUTOS (REF. 7.1) E APRESENTOU DEFESA (REF. 12.1). INTIME-SE O AUTOR PARA, QUERENDO, APRESENTAR REPLICA, EM 15 (QUINZE) DIAS. FINDO O PRAZO, NOVA CONCLUSAO PARA SENTENCA. CASCAVEL-PR, DATADO ELETRONICAMENTE. JAQUELINE ALLIEVI JUIZA DE DIREITO DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJYUW JWAJT AV2PZ R2PLB",
                "PublishDate": "2022-10-04T00:00:00",
                "CaptureDate": "2023-05-03T12:35:09"
              },
              {
                "Content": "CONCLUSOS PARA SENTENCA RESPONSAVEL: JAQUELINE ALLIEVI",
                "PublishDate": "2022-09-27T00:00:00",
                "CaptureDate": "2023-05-03T12:35:26"
              },
              {
                "Content": "AUDIENCIA DE CONCILIACAO REALIZADA REVELIA",
                "PublishDate": "2022-09-26T00:00:00",
                "CaptureDate": "2023-05-03T12:35:26"
              },
              {
                "Content": "ATO CUMPRIDO PELA PARTE OU INTERESSADO RENUNCIA DE PRAZO DE DIRCEU MATIELLO - REFERENTE AO EVENTO AUDIENCIA DE CONCILIACAO DESIGNADA (26/07/2022)",
                "PublishDate": "2022-08-26T00:00:00",
                "CaptureDate": "2023-05-03T12:35:26"
              },
              {
                "Content": "ATO CUMPRIDO PELA PARTE OU INTERESSADO LEITURA DE CITACAO REALIZADA - POR GILBERTO KLEY SILVA EM 05/08/2022 REFERENTE AO EVENTO DE EXPEDICAO SEQ. 158.",
                "PublishDate": "2022-08-12T00:00:00",
                "CaptureDate": "2023-05-03T12:35:26"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA REFERENTE AO EVENTO (SEQ. 155) AUDIENCIA DE CONCILIACAO DESIGNADA (26/07/2022) E AO EVENTO DE EXPEDICAO SEQ. 156.",
                "PublishDate": "2022-08-06T00:00:00",
                "CaptureDate": "2023-05-03T12:35:26"
              },
              {
                "Content": "EXPEDICAO DE CITACAO PARA GILBERTO KLEY SILVA COM PRAZO ATE 23 DE SETEMBRO DE 2022 - VIA AR DIGITAL - UTILIZANDO CONTRAFE",
                "PublishDate": "2022-07-28T00:00:00",
                "CaptureDate": "2023-05-03T12:35:26"
              },
              {
                "Content": "JUNTADA DE CERTIDAO",
                "PublishDate": "2022-07-26T00:00:00",
                "CaptureDate": "2023-05-03T12:35:26"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO REFERENTE AO EVENTO (SEQ. 155) AUDIENCIA DE CONCILIACAO DESIGNADA (26/07/2022).",
                "PublishDate": "2022-07-26T00:00:00",
                "CaptureDate": "2023-05-03T12:35:26"
              },
              {
                "Content": "AUDIENCIA DE CONCILIACAO DESIGNADA (AGENDADA PARA: 23 DE SETEMBRO DE 2022 AS 15:20, EM 3 JUIZADO ESPECIAL CIVEL DE CASCAVEL, MODALIDADE: SEMIPRESENCIAL)",
                "PublishDate": "2022-07-26T00:00:00",
                "CaptureDate": "2023-05-03T12:35:26"
              },
              {
                "Content": "JUNTADA DE PETICAO DE CUMPRIMENTO DE INTIMACAO CUMPRIMENTO DE INTIMACAO - REFERENTE AO EVENTO PROFERIDO DESPACHO DE MERO EXPEDIENTE (17/05/2022)",
                "PublishDate": "2022-07-06T00:00:00",
                "CaptureDate": "2023-05-03T12:35:26"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA REFERENTE AO EVENTO (SEQ. 151) PROFERIDO DESPACHO DE MERO EXPEDIENTE (17/05/2022) E AO EVENTO DE EXPEDICAO SEQ. 152.",
                "PublishDate": "2022-05-31T00:00:00",
                "CaptureDate": "2023-05-03T12:35:26"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO REFERENTE AO EVENTO (SEQ. 151) PROFERIDO DESPACHO DE MERO EXPEDIENTE (17/05/2022).",
                "PublishDate": "2022-05-20T00:00:00",
                "CaptureDate": "2023-05-03T12:35:26"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE . VEICULADO NO DJEN EM 23/05/2022. PROJUDI - PROCESSO: 0034204-88.2020.8.16.0021 - REF. MOV. 151.1 - ASSINADO DIGITALMENTE POR JAQUELINE ALLIEVI:9260 17/05/2022: PROFERIDO DESPACHO DE MERO EXPEDIENTE. ARQ: DESPACHO PODER JUDICIARIO DO ESTADO DO PARANA COMARCA DE CASCAVEL 3 JUIZADO ESPECIAL CIVEL DE CASCAVEL - PROJUDI AVENIDA TANCREDO NEVES, 2320 - FORUM - ALTO ALEGRE - CASCAVEL/PR - CEP: 85.801-900 - FONE: (45) 3392-5069 - CELULAR: (45) 3392-5119 - E-MAIL: CAS-17VJ-S@TJPR.JUS.BR AUTOS N. 0034204-88.2020.8.16.0021 PROCESSO: 0034204-88.2020.8.16.0021 CLASSE PROCESSUAL: PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL ASSUNTO PRINCIPAL: PERDAS E DANOS VALOR DA CAUSA: R$21.000,00 POLO ATIVO(S): DIRCEU MATIELLO POLO PASSIVO(S): FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA GILBERTO KLEY SILVA STARK BANK S.A. VISTOS. DIANTE DO PETITORIO DE EV. 139.1, DEFIRO A DILACAO PELO PRAZO DE 30 (TRINTA) DIAS, PARA QUE A PARTE AUTORA APRESENTE COMPROVANTE DE ENDERECO ATUALIZADO DOS REUS NAO CITADOS, SOB PENA DE EXTINCAO DO FEITO. DILIGENCIAS NECESSARIAS. JAQUELINE ALLIEVI JUIZA DE DIREITO DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJS2J 2GQK9 EK4YF XXTUD",
                "PublishDate": "2022-05-17T00:00:00",
                "CaptureDate": "2023-05-03T12:35:26"
              },
              {
                "Content": "DECORRIDO PRAZO DE DIRCEU MATIELLO (P/ ADVGS. DE DIRCEU MATIELLO *REFERENTE AO EVENTO (SEQ. 143) AUDIENCIA DE CONCILIACAO CANCELADA (03/05/2022) E AO EVENTO DE EXPEDICAO SEQ. 144.",
                "PublishDate": "2022-05-17T00:00:00",
                "CaptureDate": "2023-05-03T12:35:40"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA REFERENTE AO EVENTO (SEQ. 143) AUDIENCIA DE CONCILIACAO CANCELADA (03/05/2022) E AO EVENTO DE EXPEDICAO SEQ. 144.",
                "PublishDate": "2022-05-14T00:00:00",
                "CaptureDate": "2023-05-03T12:35:40"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO RESPONSAVEL: JAQUELINE ALLIEVI",
                "PublishDate": "2022-05-06T00:00:00",
                "CaptureDate": "2023-05-03T12:35:40"
              },
              {
                "Content": "JUNTADA DE CERTIDAO",
                "PublishDate": "2022-05-06T00:00:00",
                "CaptureDate": "2023-05-03T12:35:40"
              },
              {
                "Content": "JUNTADA DE DEVOLUCAO DE CARTA PRECATORIA",
                "PublishDate": "2022-05-06T00:00:00",
                "CaptureDate": "2023-05-03T12:35:40"
              },
              {
                "Content": "JUNTADA DE PETICAO DE MANIFESTACAO DA PARTE",
                "PublishDate": "2022-05-06T00:00:00",
                "CaptureDate": "2023-05-03T12:35:40"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO REFERENTE AO EVENTO (SEQ. 143) AUDIENCIA DE CONCILIACAO CANCELADA (03/05/2022).",
                "PublishDate": "2022-05-03T00:00:00",
                "CaptureDate": "2023-05-03T12:35:40"
              },
              {
                "Content": "AUDIENCIA DE CONCILIACAO CANCELADA CANCELADA",
                "PublishDate": "2022-05-03T00:00:00",
                "CaptureDate": "2023-05-03T12:35:40"
              },
              {
                "Content": "JUNTADA DE PETICAO DE SOLICITACAO DE CANCELAMENTO DE AUDIENCIA",
                "PublishDate": "2022-05-02T00:00:00",
                "CaptureDate": "2023-05-03T12:35:40"
              },
              {
                "Content": "JUNTADA DE COMPROVANTE DEVOLUCAO SEM LEITURA - REFERENTE A CITACAO EXPEDIDA EM 05/04/2022 PARA GILBERTO KLEY SILVA",
                "PublishDate": "2022-05-02T00:00:00",
                "CaptureDate": "2023-05-03T12:35:40"
              },
              {
                "Content": "JUNTADA DE COMPROVANTE DEVOLUCAO SEM LEITURA - REFERENTE A CITACAO EXPEDIDA EM 05/04/2022 PARA FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA",
                "PublishDate": "2022-05-02T00:00:00",
                "CaptureDate": "2023-05-03T12:35:40"
              },
              {
                "Content": "JUNTADA DE PETICAO DE SOLICITACAO DE CANCELAMENTO DE AUDIENCIA",
                "PublishDate": "2022-05-02T00:00:00",
                "CaptureDate": "2023-05-03T12:35:40"
              },
              {
                "Content": "JUNTADA DE COMPROVANTE DEVOLUCAO SEM LEITURA - REFERENTE A CITACAO EXPEDIDA EM 05/04/2022 PARA FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA",
                "PublishDate": "2022-04-29T00:00:00",
                "CaptureDate": "2023-05-03T12:35:40"
              },
              {
                "Content": "JUNTADA DE PETICAO DE SOLICITACAO DE CANCELAMENTO DE AUDIENCIA",
                "PublishDate": "2022-04-28T00:00:00",
                "CaptureDate": "2023-05-03T12:35:40"
              },
              {
                "Content": "EXPEDICAO DE CITACAO PARA GILBERTO KLEY SILVA COM PRAZO ATE 4 DE MAIO DE 2022 - VIA AR DIGITAL - UTILIZANDO CONTRAFE",
                "PublishDate": "2022-04-05T00:00:00",
                "CaptureDate": "2023-05-03T12:35:40"
              },
              {
                "Content": "EXPEDICAO DE CITACAO PARA FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA COM PRAZO ATE 4 DE MAIO DE 2022 - VIA AR DIGITAL - UTILIZANDO CONTRAFE",
                "PublishDate": "2022-04-05T00:00:00",
                "CaptureDate": "2023-05-03T12:35:40"
              },
              {
                "Content": "EXPEDICAO DE CITACAO PARA FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA COM PRAZO ATE 4 DE MAIO DE 2022 - VIA AR DIGITAL - UTILIZANDO CONTRAFE",
                "PublishDate": "2022-04-05T00:00:00",
                "CaptureDate": "2023-05-03T12:35:40"
              },
              {
                "Content": "JUNTADA DE COMPROVANTE DEVOLUCAO SEM LEITURA - REFERENTE A CITACAO EXPEDIDA EM 25/02/2022 PARA GILBERTO KLEY SILVA",
                "PublishDate": "2022-03-22T00:00:00",
                "CaptureDate": "2023-05-03T12:35:40"
              },
              {
                "Content": "JUNTADA DE COMPROVANTE DEVOLUCAO SEM LEITURA - REFERENTE A CITACAO EXPEDIDA EM 25/02/2022 PARA FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA",
                "PublishDate": "2022-03-22T00:00:00",
                "CaptureDate": "2023-05-03T12:35:40"
              },
              {
                "Content": "JUNTADA DE COMPROVANTE DEVOLUCAO SEM LEITURA - REFERENTE A CITACAO EXPEDIDA EM 25/02/2022 PARA FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA",
                "PublishDate": "2022-03-21T00:00:00",
                "CaptureDate": "2023-05-03T12:35:40"
              },
              {
                "Content": "ATO CUMPRIDO PELA PARTE OU INTERESSADO RENUNCIA DE PRAZO DE DIRCEU MATIELLO - REFERENTE AO EVENTO AUDIENCIA DE CONCILIACAO DESIGNADA (25/02/2022)",
                "PublishDate": "2022-03-08T00:00:00",
                "CaptureDate": "2023-05-03T12:35:40"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA REFERENTE AO EVENTO (SEQ. 123) AUDIENCIA DE CONCILIACAO DESIGNADA (25/02/2022) E AO EVENTO DE EXPEDICAO SEQ. 124.",
                "PublishDate": "2022-03-08T00:00:00",
                "CaptureDate": "2023-05-03T12:35:40"
              },
              {
                "Content": "EXPEDICAO DE CITACAO PARA GILBERTO KLEY SILVA COM PRAZO ATE 4 DE MAIO DE 2022 - VIA AR DIGITAL - UTILIZANDO CONTRAFE",
                "PublishDate": "2022-02-25T00:00:00",
                "CaptureDate": "2023-05-03T12:35:40"
              },
              {
                "Content": "EXPEDICAO DE CITACAO PARA FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA COM PRAZO ATE 4 DE MAIO DE 2022 - VIA AR DIGITAL - UTILIZANDO CONTRAFE",
                "PublishDate": "2022-02-25T00:00:00",
                "CaptureDate": "2023-05-03T12:35:40"
              },
              {
                "Content": "EXPEDICAO DE CITACAO PARA FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA COM PRAZO ATE 4 DE MAIO DE 2022 - VIA AR DIGITAL - UTILIZANDO CONTRAFE",
                "PublishDate": "2022-02-25T00:00:00",
                "CaptureDate": "2023-05-03T12:35:40"
              },
              {
                "Content": "JUNTADA DE CERTIDAO",
                "PublishDate": "2022-02-25T00:00:00",
                "CaptureDate": "2023-05-03T12:35:40"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO PARA ADVOGADOS/CURADOR/DEFENSOR DE DIRCEU MATIELLO COM PRAZO DE 1 DIA UTIL - REFERENTE AO EVENTO (SEQ. 123) AUDIENCIA DE CONCILIACAO DESIGNADA (25/02/2022)",
                "PublishDate": "2022-02-25T00:00:00",
                "CaptureDate": "2023-05-03T12:35:40"
              },
              {
                "Content": "AUDIENCIA DE CONCILIACAO DESIGNADA (AGENDADA PARA: 04 DE MAIO DE 2022 AS 14:00, EM 3 JUIZADO ESPECIAL CIVEL DE CASCAVEL, MODALIDADE: SEMIPRESENCIAL)",
                "PublishDate": "2022-02-25T00:00:00",
                "CaptureDate": "2023-05-03T12:35:40"
              },
              {
                "Content": "JUNTADA DE PETICAO DE REQUERIMENTO DE DILIGENCIA",
                "PublishDate": "2022-02-23T00:00:00",
                "CaptureDate": "2023-05-03T12:35:40"
              },
              {
                "Content": "JUNTADA DE INFORMACAO",
                "PublishDate": "2022-02-07T00:00:00",
                "CaptureDate": "2023-05-03T12:35:40"
              },
              {
                "Content": "JUNTADA DE CERTIDAO",
                "PublishDate": "2022-01-25T00:00:00",
                "CaptureDate": "2023-05-03T12:35:40"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA (PELO ADVOGADO/CURADOR/DEFENSOR DE STARK BANK S.A.) EM 10/12/2021 COM PRAZO DE 2 DE DEZEMBRO DE 2021 *REFERENTE AO EVENTO (SEQ. 111) JUNTADA DE CERTIDAO (30/11/2021) E AO EVENTO DE EXPEDICAO SEQ. 113.",
                "PublishDate": "2021-12-11T00:00:00",
                "CaptureDate": "2023-05-03T12:35:40"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA (PELO ADVOGADO/CURADOR/DEFENSOR DE DIRCEU MATIELLO) EM 10/12/2021 COM PRAZO DE 2 DE DEZEMBRO DE 2021 *REFERENTE AO EVENTO (SEQ. 111) JUNTADA DE CERTIDAO (30/11/2021) E AO EVENTO DE EXPEDICAO SEQ. 112.",
                "PublishDate": "2021-12-11T00:00:00",
                "CaptureDate": "2023-05-03T12:35:40"
              },
              {
                "Content": "AUDIENCIA DE CONCILIACAO REALIZADA AGUARDA O RETORNO DA CARTA PRECATORIA",
                "PublishDate": "2021-12-02T00:00:00",
                "CaptureDate": "2023-05-03T12:35:40"
              },
              {
                "Content": "JUNTADA DE INFORMACAO",
                "PublishDate": "2021-12-02T00:00:00",
                "CaptureDate": "2023-05-03T12:35:40"
              },
              {
                "Content": "JUNTADA DE PETICAO DE SOLICITACAO DE CANCELAMENTO DE AUDIENCIA",
                "PublishDate": "2021-12-02T00:00:00",
                "CaptureDate": "2023-05-03T12:35:40"
              },
              {
                "Content": "JUNTADA DE PETICAO DE SOLICITACAO DE CANCELAMENTO DE AUDIENCIA CUMPRIMENTO DE INTIMACAO - REFERENTE AO EVENTO AUDIENCIA DE CONCILIACAO DESIGNADA (14/10/2021)",
                "PublishDate": "2021-12-01T00:00:00",
                "CaptureDate": "2023-05-03T12:35:40"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO PARA ADVOGADOS/CURADOR/DEFENSOR DE STARK BANK S.A. COM PRAZO DE 2 DE DEZEMBRO DE 2021 - REFERENTE AO EVENTO (SEQ. 111) JUNTADA DE CERTIDAO (30/11/2021)",
                "PublishDate": "2021-11-30T00:00:00",
                "CaptureDate": "2023-05-03T12:35:40"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO PARA ADVOGADOS/CURADOR/DEFENSOR DE DIRCEU MATIELLO COM PRAZO DE 2 DE DEZEMBRO DE 2021 - REFERENTE AO EVENTO (SEQ. 111) JUNTADA DE CERTIDAO (30/11/2021)",
                "PublishDate": "2021-11-30T00:00:00",
                "CaptureDate": "2023-05-03T12:35:40"
              },
              {
                "Content": "JUNTADA DE CERTIDAO",
                "PublishDate": "2021-11-30T00:00:00",
                "CaptureDate": "2023-05-03T12:35:40"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA (PELO ADVOGADO/CURADOR/DEFENSOR DE DIRCEU MATIELLO) EM 25/10/2021 COM PRAZO DE 2 DE DEZEMBRO DE 2021 *REFERENTE AO EVENTO (SEQ. 102) AUDIENCIA DE CONCILIACAO DESIGNADA (14/10/2021) E AO EVENTO DE EXPEDICAO SEQ. 103.",
                "PublishDate": "2021-10-25T00:00:00",
                "CaptureDate": "2023-05-03T12:35:40"
              },
              {
                "Content": "JUNTADA DE PETICAO DE MANIFESTACAO DA PARTE CUMPRIMENTO DE INTIMACAO - REFERENTE AO EVENTO AUDIENCIA DE CONCILIACAO DESIGNADA (14/10/2021)",
                "PublishDate": "2021-10-18T00:00:00",
                "CaptureDate": "2023-05-03T12:35:40"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA (PELO ADVOGADO/CURADOR/DEFENSOR DE STARK BANK S.A.) EM 18/10/2021 COM PRAZO DE 2 DE DEZEMBRO DE 2021 *REFERENTE AO EVENTO (SEQ. 102) AUDIENCIA DE CONCILIACAO DESIGNADA (14/10/2021) E AO EVENTO DE EXPEDICAO SEQ. 104.",
                "PublishDate": "2021-10-18T00:00:00",
                "CaptureDate": "2023-05-03T12:35:40"
              },
              {
                "Content": "CONFIRMADA A COMUNICACAO ELETRONICA CARTA PRECATORIA LIDO(A) EM 15/10/2021 - REFERENTE AO EVENTO DE EXPEDICAO (SEQ. 106) EXPEDICAO DE CARTA PRECATORIA (14/10/2021 16:08:09)",
                "PublishDate": "2021-10-15T00:00:00",
                "CaptureDate": "2023-05-03T12:35:40"
              },
              {
                "Content": "EXPEDICAO DE CARTA PRECATORIA REFERENTE AO EVENTO (SEQ. 102) AUDIENCIA DE CONCILIACAO DESIGNADA(14/10/2021 15:03:12). IDENTIFICADOR DO CUMPRIMENTO: 0002 PROJUDI - PROCESSO: 0034204-88.2020.8.16.0021 - REF. MOV. 106.1 - ASSINADO DIGITALMENTE POR OSVALDO ALVES DA SILVA:17020 14/10/2021: EXPEDICAO DE CARTA PRECATORIA. ARQ: CARTA PRECATORIA - ANAPOLIS- GO ESTADO DO PARANA PODER JUDICIARIO COMARCA DE CASCAVEL 3 JUIZADO ESPECIAL CIVEL DE CASCAVEL - PROJUDI AV. TANCREDO NEVES, N 2320  BAIRRO ALTO ALEGRE CEP: 85801-900  CASCAVEL  PR. FONE: (045) 3392-5069/5119 E FAX (045) 3392-5120 E-MAIL: CAS-17VJ-S@TJPR.JUS CARTA PRECATORIA DEPRECANTE: 3 JUIZADO ESPECIAL CIVEL DA COMARCA DE CASCAVEL-PR. DEPRECADO: JUIZADO ESPECIAL CIVEL DA COMARCA DE ANAPOLIS-GO. ORIGEM: PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL DE PERDAS E DANOS N 0034204-88.2020.8.16.0021 EM QUE E REQUENTE DIRCEU MATIELLO E REQUERIDOS FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA, FRI-SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA, GILBERTO KLEY SILVA E STARK BANK S.A. OBJETO: PARA A CITACAO DOS REQUERIDOS FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA (NA PESSOA DE SEU REPRESENTANTE LEGAL), PESSOA JURIDICA DE DIREITO PRIVADO, INSCRITA CNPJ/MF 21.160.553/0001- 81; FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA (NA PESSOA DO SOCIO ADMINISTRADOR GILBERTO KLEY SILVA), PESSOA JURIDICA DE DIREITO PRIVADO, INSCRITA CNPJ/MF 10.685.786/0001-81, E GILBERTO KLEY SILVA (PESSOA FISICA), BRASILEIRO, CASADO, EMPRESARIO, INSCRITO CPF/MF 185.839.848-75, AMBOS COM ENDERECO NA RUA FC 1, S/N QD01 LT11 CASA 2 - RESIDENCIAL FLOR DO CERRADO, COMARCA DE ANAPOLIS-GO, CEP: 75086-050; NOS TERMOS DO ART. 212,  2 DO CPC, COMBINADO COM O ART. 12 DA LEI 9.099/95, E DE TODOS OS TERMOS DA ACAO INDICADA, CIENTE QUE DEVERAO COMPARECER A AUDIENCIA DE CONCILIACAO DESIGNADA PARA 02 DE DEZEMBRO DE 2021 AS 13:00 HORAS; A SER REALIZADA POR MEIO DO SISTEMA ELETRONICO MICROSOFT TEAMS (VIRTUAL). ACESSE O SITE: HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/, E SIGA AS ORIENTACOES EM ANEXO. A CHAVE DE ACESSO E: PA4VM NYTUH SR78X 884AZ. APOS REALIZAR O PASSO A PASSO SERA DIRECIONADO A PLATAFORMA DO MICROSOFT TEAMS. SELECIONE A OPCAO CONTINUAR NESTE NAVEGADOR; DIGITE SEU NOME E CLIQUE EM INGRESSAR AGORA. O INGRESSO PRELIMINAR SERA EM UMA SALA DE ESPERA. AGUARDE! APOS OS PREPARATIVOS O (A) CONCILIADOR (A) IRA REALIZAR TRANSFERENCIA A SALA PRINCIPAL. ADVERTENCIA: O NAO COMPARECIMENTO AS AUDIENCIAS IMPORTARA EM REVELIA, CONFORME DISPOSTO NO ARTIGO 20, DA LEI 9.099/95. COMPARECENDO A PARTE PROMOVIDA (RE), E NAO OBTIDA A CONCILIACAO, PODERA A ACAO SER JULGADA ANTECIPADAMENTE, SE FOR O CASO, OU SE PROCEDER A AUDIENCIA DE INSTRUCAO E JULGAMENTO. TRATANDO-SE DE RELACAO DE CONSUMO, FICA A PARTE ADVERTIDA DE QUE PODERA SER DETERMINADA A INVERSAO DO ONUS DA PROVA A TEOR DO ART. 6, INCISO VIII DO CDC. E OBRIGATORIA, NAS DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJ8TL ZRK9L DSVPN E4BSD CAUSAS DE VALOR SUPERIOR A 20 SALARIOS MINIMOS, A PRESENCA DE ADVOGADO (ARTIGO 9, LEI 9099/95). EM SE TRATANDO DE PESSOA JURIDICA, O PREPOSTO DEVERA APRESENTAR NO ATO DA AUDIENCIA RESPECTIVA A CARTA DE PREPOSICAO, SOB PENA DE REVELIA. A PARTE FICA ADVERTIDA QUE O ONUS DA PROVA PODERA SER INVERTIDO EM SEDE DE AUDIENCIA DE INSTRUCAO, NOS TERMOS DO PARAGRAFO 1, DO ARTIGO 373, DO CODIGO DE PROCESSO CIVIL. DO TEOR DA PORTARIA N 03/2020, FICA VOSSA SENHORIA CIENTE DE QUE, EM RAZAO DO REESTABELECIMENTO DAS AUDIENCIAS SEMIPRESENCIAIS, PODERA COMPARECER PESSOALMENTE PARA O ATO DESDE QUE, PARA ISSO, FACA A COMUNICACAO A ESTE JUIZO. EM SE TRATANDO DE PREPOSTOS, A MUDANCA DO REPRESENTANTE INICIALMENTE INDICADO DEVERA SER COMUNICADA EM TEMPO HABIL, SOB PENA DE NAO SER LIBERADO O ACESSO AS DEPENDENCIAS DA UNIDADE JUDICIARIA. A COMUNICACAO PREVIA PODERA SER FEITA PELO TELEFONE: (045) 3392-5069 OU ATRAVES DO E-MAIL: CAS-17VJ-S@TJPR.JUS.BR. RESSALTA-SE QUE O COMPARECIMENTO PARA A AUDIENCIA NA MODALIDADE VIRTUAL NAO NECESSITA PREVIO AVISO. DEVENDO, NO ENTANTO, COMPARECER PARA O ATO NA SALA VIRTUAL DESIGNADA. OBSERVACAO: ESTE PROCESSO TRAMITA ATRAVES DO SISTEMA COMPUTACIONAL PROJUDI, CUJO ENDERECO NA WEB E HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/. O ACESSO AO SISTEMA PELOS ADVOGADOS DEPENDE DE PREVIO CADASTRAMENTO, O QUAL E OBRIGATORIO, DEVENDO COMPARECER A SEDE DA UNIDADE JURISDICIONAL QUE JA UTILIZE O SISTEMA ELETRONICO (OAB). HORARIO DE ATENDIMENTO: DAS 12:00 AS 18:00 HORAS. VALOR DA CAUSA: R$ 21.000,00 (VINTE E UM MIL REAIS), PARA FINS DE ALCADA. DEPRECA AO EXM SR. DR. JUIZ DE DIREITO DO JUIZADO ESPECIAL CIVEL DA COMARCA DE ANAPOLIS-GO; PARA QUE SE DIGNE DETERMINAR COM O SEU RESPEITAVEL CUMPRA-SE SEJA PROCEDIDA A CITACAO DOS REQUERIDOS, NO ENDERECO DECLINADO. CASCAVEL- PARANA, E AOS CATORZE DIAS DO MES DE OUTUBRO DE DOIS MIL E VINTE UM. EU, MIRIA JACOBOVSKI, TECNICA JUDICIARIA, DIGITEI. (ASSINADO DIGITALMENTE) OSVALDO ALVES DA SILVA JUIZ DE DIREITO SUBSTITUTO",
                "PublishDate": "2021-10-14T00:00:00",
                "CaptureDate": "2023-05-03T12:35:40"
              },
              {
                "Content": "JUNTADA DE CERTIDAO",
                "PublishDate": "2021-10-14T00:00:00",
                "CaptureDate": "2023-05-03T12:35:50"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO PARA ADVOGADOS/CURADOR/DEFENSOR DE STARK BANK S.A. COM PRAZO DE 2 DE DEZEMBRO DE 2021 - REFERENTE AO EVENTO (SEQ. 102) AUDIENCIA DE CONCILIACAO DESIGNADA (14/10/2021)",
                "PublishDate": "2021-10-14T00:00:00",
                "CaptureDate": "2023-05-03T12:35:50"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO PARA ADVOGADOS/CURADOR/DEFENSOR DE DIRCEU MATIELLO COM PRAZO DE 2 DE DEZEMBRO DE 2021 - REFERENTE AO EVENTO (SEQ. 102) AUDIENCIA DE CONCILIACAO DESIGNADA (14/10/2021)",
                "PublishDate": "2021-10-14T00:00:00",
                "CaptureDate": "2023-05-03T12:35:50"
              },
              {
                "Content": "AUDIENCIA DE CONCILIACAO DESIGNADA (AGENDADA PARA: 02 DE DEZEMBRO DE 2021 AS 13:00, EM 3 JUIZADO ESPECIAL CIVEL DE CASCAVEL, MODALIDADE: SEMIPRESENCIAL)",
                "PublishDate": "2021-10-14T00:00:00",
                "CaptureDate": "2023-05-03T12:35:50"
              },
              {
                "Content": "JUNTADA DE PETICAO DE MANIFESTACAO DA PARTE CUMPRIMENTO DE INTIMACOES - REFERENTE AO EVENTO JUNTADA DE COMPROVANTE (24/08/2021)",
                "PublishDate": "2021-09-09T00:00:00",
                "CaptureDate": "2023-05-03T12:35:50"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA (PELO ADVOGADO/CURADOR/DEFENSOR DE DIRCEU MATIELLO) EM 08/09/2021 COM PRAZO DE 1 DIA UTIL *REFERENTE AO EVENTO (SEQ. 92) JUNTADA DE COMPROVANTE (24/08/2021) E AO EVENTO DE EXPEDICAO SEQ. 95.",
                "PublishDate": "2021-09-05T00:00:00",
                "CaptureDate": "2023-05-03T12:35:50"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA (PELO ADVOGADO/CURADOR/DEFENSOR DE DIRCEU MATIELLO) EM 08/09/2021 COM PRAZO DE 1 DIA UTIL *REFERENTE AO EVENTO (SEQ. 91) JUNTADA DE COMPROVANTE (24/08/2021) E AO EVENTO DE EXPEDICAO SEQ. 94.",
                "PublishDate": "2021-09-05T00:00:00",
                "CaptureDate": "2023-05-03T12:35:50"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA (PELO ADVOGADO/CURADOR/DEFENSOR DE DIRCEU MATIELLO) EM 08/09/2021 COM PRAZO DE 1 DIA UTIL *REFERENTE AO EVENTO (SEQ. 93) JUNTADA DE COMPROVANTE (24/08/2021) E AO EVENTO DE EXPEDICAO SEQ. 96.",
                "PublishDate": "2021-09-05T00:00:00",
                "CaptureDate": "2023-05-03T12:35:50"
              },
              {
                "Content": "AUDIENCIA DE CONCILIACAO CANCELADA CANCELADA",
                "PublishDate": "2021-08-31T00:00:00",
                "CaptureDate": "2023-05-03T12:35:50"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO PARA ADVOGADOS/CURADOR/DEFENSOR DE DIRCEU MATIELLO COM PRAZO DE 1 DIA UTIL - REFERENTE AO EVENTO (SEQ. 93) JUNTADA DE COMPROVANTE (24/08/2021)",
                "PublishDate": "2021-08-25T00:00:00",
                "CaptureDate": "2023-05-03T12:35:50"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO PARA ADVOGADOS/CURADOR/DEFENSOR DE DIRCEU MATIELLO COM PRAZO DE 1 DIA UTIL - REFERENTE AO EVENTO (SEQ. 92) JUNTADA DE COMPROVANTE (24/08/2021)",
                "PublishDate": "2021-08-25T00:00:00",
                "CaptureDate": "2023-05-03T12:35:50"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO PARA ADVOGADOS/CURADOR/DEFENSOR DE DIRCEU MATIELLO COM PRAZO DE 1 DIA UTIL - REFERENTE AO EVENTO (SEQ. 91) JUNTADA DE COMPROVANTE (24/08/2021)",
                "PublishDate": "2021-08-25T00:00:00",
                "CaptureDate": "2023-05-03T12:35:50"
              },
              {
                "Content": "JUNTADA DE COMPROVANTE DEVOLUCAO SEM LEITURA - REFERENTE A CITACAO EXPEDIDA EM 23/07/2021 PARA GILBERTO KLEY SILVA",
                "PublishDate": "2021-08-24T00:00:00",
                "CaptureDate": "2023-05-03T12:35:50"
              },
              {
                "Content": "JUNTADA DE COMPROVANTE DEVOLUCAO SEM LEITURA - REFERENTE A CITACAO EXPEDIDA EM 23/07/2021 PARA FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA",
                "PublishDate": "2021-08-24T00:00:00",
                "CaptureDate": "2023-05-03T12:35:50"
              },
              {
                "Content": "JUNTADA DE COMPROVANTE DEVOLUCAO SEM LEITURA - REFERENTE A CITACAO EXPEDIDA EM 23/07/2021 PARA FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA",
                "PublishDate": "2021-08-24T00:00:00",
                "CaptureDate": "2023-05-03T12:35:50"
              },
              {
                "Content": "DECORRIDO PRAZO DE DIRCEU MATIELLO (P/ ADVGS. DE DIRCEU MATIELLO *REFERENTE AO EVENTO (SEQ. 83) AUDIENCIA DE CONCILIACAO DESIGNADA (22/07/2021) E AO EVENTO DE EXPEDICAO SEQ. 84.",
                "PublishDate": "2021-08-04T00:00:00",
                "CaptureDate": "2023-05-03T12:35:50"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA (PELO ADVOGADO/CURADOR/DEFENSOR DE DIRCEU MATIELLO) EM 02/08/2021 COM PRAZO DE 1 DIA UTIL *REFERENTE AO EVENTO (SEQ. 83) AUDIENCIA DE CONCILIACAO DESIGNADA (22/07/2021) E AO EVENTO DE EXPEDICAO SEQ. 84.",
                "PublishDate": "2021-08-02T00:00:00",
                "CaptureDate": "2023-05-03T12:35:50"
              },
              {
                "Content": "EXPEDICAO DE CITACAO PARA GILBERTO KLEY SILVA COM PRAZO ATE 1 DE SETEMBRO DE 2021 - VIA AR DIGITAL - UTILIZANDO CONTRAFE",
                "PublishDate": "2021-07-23T00:00:00",
                "CaptureDate": "2023-05-03T12:35:50"
              },
              {
                "Content": "EXPEDICAO DE CITACAO PARA FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA COM PRAZO ATE 1 DE SETEMBRO DE 2021 - VIA AR DIGITAL - UTILIZANDO CONTRAFE",
                "PublishDate": "2021-07-23T00:00:00",
                "CaptureDate": "2023-05-03T12:35:50"
              },
              {
                "Content": "EXPEDICAO DE CITACAO PARA FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA COM PRAZO ATE 1 DE SETEMBRO DE 2021 - VIA AR DIGITAL - UTILIZANDO CONTRAFE",
                "PublishDate": "2021-07-23T00:00:00",
                "CaptureDate": "2023-05-03T12:35:50"
              },
              {
                "Content": "JUNTADA DE CERTIDAO",
                "PublishDate": "2021-07-22T00:00:00",
                "CaptureDate": "2023-05-03T12:35:50"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO PARA ADVOGADOS/CURADOR/DEFENSOR DE DIRCEU MATIELLO COM PRAZO DE 1 DIA UTIL - REFERENTE AO EVENTO (SEQ. 83) AUDIENCIA DE CONCILIACAO DESIGNADA (22/07/2021)",
                "PublishDate": "2021-07-22T00:00:00",
                "CaptureDate": "2023-05-03T12:35:50"
              },
              {
                "Content": "AUDIENCIA DE CONCILIACAO DESIGNADA (AGENDADA PARA: 01 DE SETEMBRO DE 2021 AS 16:40, EM 3 JUIZADO ESPECIAL CIVEL DE CASCAVEL, MODALIDADE: SEMIPRESENCIAL)",
                "PublishDate": "2021-07-22T00:00:00",
                "CaptureDate": "2023-05-03T12:35:50"
              },
              {
                "Content": "JUNTADA DE PETICAO DE SUBSTABELECIMENTO",
                "PublishDate": "2021-07-21T00:00:00",
                "CaptureDate": "2023-05-03T12:35:50"
              },
              {
                "Content": "JUNTADA DE PETICAO DE COMPROVANTE E/OU DOCUMENTO DA PARTE",
                "PublishDate": "2021-07-20T00:00:00",
                "CaptureDate": "2023-05-03T12:35:50"
              },
              {
                "Content": "JUNTADA DE PETICAO DE REQUERIMENTO DE DILIGENCIA CUMPRIMENTO DE INTIMACAO - REFERENTE AO EVENTO PROFERIDO DESPACHO DE MERO EXPEDIENTE (07/06/2021)",
                "PublishDate": "2021-07-19T00:00:00",
                "CaptureDate": "2023-05-03T12:35:50"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA (PELO ADVOGADO/CURADOR/DEFENSOR DE DIRCEU MATIELLO) EM 12/07/2021 COM PRAZO DE 5 DIAS UTEIS *REFERENTE AO EVENTO (SEQ. 70) PROFERIDO DESPACHO DE MERO EXPEDIENTE (07/06/2021) E AO EVENTO DE EXPEDICAO SEQ. 78.",
                "PublishDate": "2021-07-12T00:00:00",
                "CaptureDate": "2023-05-03T12:35:50"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO PARA ADVOGADOS/CURADOR/DEFENSOR DE DIRCEU MATIELLO COM PRAZO DE 5 DIAS UTEIS - REFERENTE AO EVENTO (SEQ. 70) PROFERIDO DESPACHO DE MERO EXPEDIENTE (07/06/2021)",
                "PublishDate": "2021-07-01T00:00:00",
                "CaptureDate": "2023-05-03T12:35:50"
              },
              {
                "Content": "ATO ORDINATORIO PRATICADO PRAZO DECORRIDO - SEM RESPOSTA - (REFERENTE A(O) MANDADO DETERMINADO PELO EVENTO PROFERIDO DESPACHO DE MERO EXPEDIENTE(13/05/2021). PARTE: DIRCEU MATIELLO",
                "PublishDate": "2021-07-01T00:00:00",
                "CaptureDate": "2023-05-03T12:35:50"
              },
              {
                "Content": "JUNTADA DE PETICAO DE REQUERIMENTO DE HABILITACAO",
                "PublishDate": "2021-06-25T00:00:00",
                "CaptureDate": "2023-05-03T12:35:50"
              },
              {
                "Content": "ATO CUMPRIDO PELA PARTE OU INTERESSADO RENUNCIA DE PRAZO DE STARK BANK S.A. - REFERENTE AO EVENTO PROFERIDO DESPACHO DE MERO EXPEDIENTE (07/06/2021)",
                "PublishDate": "2021-06-21T00:00:00",
                "CaptureDate": "2023-05-03T12:35:50"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA (PELO ADVOGADO/CURADOR/DEFENSOR DE STARK BANK S.A.) EM 21/06/2021 COM PRAZO DE 5 DIAS UTEIS *REFERENTE AO EVENTO (SEQ. 70) PROFERIDO DESPACHO DE MERO EXPEDIENTE (07/06/2021) E AO EVENTO DE EXPEDICAO SEQ. 73.",
                "PublishDate": "2021-06-21T00:00:00",
                "CaptureDate": "2023-05-03T12:35:50"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO PARA ADVOGADOS/CURADOR/DEFENSOR DE STARK BANK S.A. COM PRAZO DE 5 DIAS UTEIS - REFERENTE AO EVENTO (SEQ. 70) PROFERIDO DESPACHO DE MERO EXPEDIENTE (07/06/2021)",
                "PublishDate": "2021-06-14T00:00:00",
                "CaptureDate": "2023-05-03T12:35:50"
              },
              {
                "Content": "CONFIRMADA A COMUNICACAO ELETRONICA MANDADO LIDO(A) EM 09/06/2021 - REFERENTE AO EVENTO DE EXPEDICAO (SEQ. 67) EXPEDICAO DE MANDADO (02/06/2021 17:45:44). PARTE: DIRCEU MATIELLO",
                "PublishDate": "2021-06-10T00:00:00",
                "CaptureDate": "2023-05-03T12:35:50"
              },
              {
                "Content": "MANDADO DEVOLVIDO REFERENTE AO EVENTO (SEQ. 67) EXPEDICAO DE MANDADO (02/06/2021 17:45:44). PARTE: DIRCEU MATIELLO",
                "PublishDate": "2021-06-09T00:00:00",
                "CaptureDate": "2023-05-03T12:35:50"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE . VEICULADO NO DJEN EM 15/06/2021. PROJUDI - PROCESSO: 0034204-88.2020.8.16.0021 - REF. MOV. 70.1 - ASSINADO DIGITALMENTE POR JAQUELINE ALLIEVI:9260 07/06/2021: PROFERIDO DESPACHO DE MERO EXPEDIENTE. ARQ: DESPACHO PODER JUDICIARIO DO ESTADO DO PARANA COMARCA DE CASCAVEL 3 JUIZADO ESPECIAL CIVEL DE CASCAVEL - PROJUDI AVENIDA TANCREDO NEVES, 2320 - FORUM - ALTO ALEGRE - CASCAVEL/PR - CEP: 85.801-900 - FONE: (45) 3392-5069 - E-MAIL: CAS-17VJ-S@TJPR.JUS.BR CLASSE PROCESSUAL: PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL ASSUNTO PRINCIPAL: PERDAS E DANOS PROCESSO N: 0034204-88.2020.8.16.0021 POLO ATIVO(S): DIRCEU MATIELLO POLO PASSIVO(S): FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA GILBERTO KLEY SILVA STARK BANK S.A. VISTOS. NADA A DEFERIR OU ESCLARECER QUANTO AO PETICIONADO NO REF. 66.1. SE O PROCURADOR DO STAR BANK S/A DESEJA SABER O MOTIVO DO APENSAMENTO DOS EMBARGOS DE TERCEIRO 750-83.2021.8.16.0021 A ESTES AUTOS, REMETE-SE A LEITURA DA PETICAO INICIAL DAQUELE FEITO E AO ARTIGO 676, DO CPC. INTIME-SE O STAR BANK S/A, APOS, AGUARDE-SE EM SECRETARIA O CUMPRIMENTO DO MANDADO RETRO. CASCAVEL-PR, DATADO ELETRONICAMENTE. JAQUELINE ALLIEVI JUIZA DE DIREITO DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJDZX ECFRF U6SKM YU5DA",
                "PublishDate": "2021-06-07T00:00:00",
                "CaptureDate": "2023-05-03T12:35:50"
              },
              {
                "Content": "CONCLUSOS PARA SENTENCA - EMBARGOS DE DECLARACAO RESPONSAVEL: JAQUELINE ALLIEVI",
                "PublishDate": "2021-06-07T00:00:00",
                "CaptureDate": "2023-05-03T12:36:07"
              },
              {
                "Content": "ATO ORDINATORIO PRATICADO DISTRIBUICAO REALIZADA REFERENTE AO MANDADO EXPEDIDO (SEQ. 67) EM 02/06/2021 17:45:44. TIPO: DISTRIBUICAO INICIAL AUTOMATICA. OFICIAL DE JUSTICA DESIGNADO: MARZELI APARECIDA SIMOES. PARTE: DIRCEU MATIELLO",
                "PublishDate": "2021-06-02T00:00:00",
                "CaptureDate": "2023-05-03T12:36:07"
              },
              {
                "Content": "EXPEDICAO DE MANDADO PRAZO DE 15 DIAS UTEIS. REFERENTE AO EVENTO (SEQ. 64) PROFERIDO DESPACHO DE MERO EXPEDIENTE(13/05/2021 21:44:54). NATUREZA: INTIMACAO DESPACHO. PARTE: DIRCEU MATIELLO. IDENTIFICADOR DO CUMPRIMENTO: 0001",
                "PublishDate": "2021-06-02T00:00:00",
                "CaptureDate": "2023-05-03T12:36:07"
              },
              {
                "Content": "JUNTADA DE PETICAO DE MANIFESTACAO DA PARTE",
                "PublishDate": "2021-06-02T00:00:00",
                "CaptureDate": "2023-05-03T12:36:07"
              },
              {
                "Content": "APENSADO AO PROCESSO 0000750-83.2021.8.16.0021",
                "PublishDate": "2021-06-01T00:00:00",
                "CaptureDate": "2023-05-03T12:36:07"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE . VEICULADO NO DJEN EM 19/05/2021. PROJUDI - PROCESSO: 0034204-88.2020.8.16.0021 - REF. MOV. 64.1 - ASSINADO DIGITALMENTE POR JAQUELINE ALLIEVI:9260 13/05/2021: PROFERIDO DESPACHO DE MERO EXPEDIENTE. ARQ: DESPACHO PODER JUDICIARIO DO ESTADO DO PARANA COMARCA DE CASCAVEL 3 JUIZADO ESPECIAL CIVEL DE CASCAVEL - PROJUDI AVENIDA TANCREDO NEVES, 2320 - FORUM - ALTO ALEGRE - CASCAVEL/PR - CEP: 85.801-900 - FONE: (45) 3392-5069 - E-MAIL: CAS-17VJ-S@TJPR.JUS.BR CLASSE PROCESSUAL: PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL ASSUNTO PRINCIPAL: PERDAS E DANOS PROCESSO N: 0034204-88.2020.8.16.0021 POLO ATIVO(S): DIRCEU MATIELLO POLO PASSIVO(S): FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA GILBERTO KLEY SILVA STARK BANK S.A. VISTOS. INTIME-SE O RECLAMANTE, PESSOALMENTE, POR AR, PARA, EM 15 (QUINZE) DIAS, MANIFESTAR-SE SOBRE O CONTEUDO DA PETICAO DE REF. 61, CUJA COPIA DEVERA INSTRUIR A CARTA. CASCAVEL-PR, DATADO ELETRONICAMENTE. JAQUELINE ALLIEVI JUIZA DE DIREITO DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJ6W5 M4BS5 59W9B 4PVAY",
                "PublishDate": "2021-05-13T00:00:00",
                "CaptureDate": "2023-05-03T12:36:07"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO RESPONSAVEL: JAQUELINE ALLIEVI",
                "PublishDate": "2021-05-11T00:00:00",
                "CaptureDate": "2023-05-03T12:36:19"
              },
              {
                "Content": "JUNTADA DE PETICAO DE MANIFESTACAO DA PARTE",
                "PublishDate": "2021-05-10T00:00:00",
                "CaptureDate": "2023-05-03T12:36:19"
              },
              {
                "Content": "JUNTADA DE PETICAO DE MANIFESTACAO DA PARTE CUMPRIMENTO DE INTIMACAO - REFERENTE AO EVENTO JUNTADA DE PETICAO DE MANIFESTACAO DA PARTE (20/04/2021)",
                "PublishDate": "2021-05-10T00:00:00",
                "CaptureDate": "2023-05-03T12:36:19"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA (PELO ADVOGADO/CURADOR/DEFENSOR DE DIRCEU MATIELLO) EM 03/05/2021 COM PRAZO DE 5 DIAS UTEIS *REFERENTE AO EVENTO (SEQ. 58) JUNTADA DE PETICAO DE MANIFESTACAO DA PARTE (20/04/2021) E AO EVENTO DE EXPEDICAO SEQ. 59.",
                "PublishDate": "2021-05-03T00:00:00",
                "CaptureDate": "2023-05-03T12:36:19"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO PARA ADVOGADOS/CURADOR/DEFENSOR DE DIRCEU MATIELLO COM PRAZO DE 5 DIAS UTEIS - REFERENTE AO EVENTO (SEQ. 58) JUNTADA DE PETICAO DE MANIFESTACAO DA PARTE (20/04/2021)",
                "PublishDate": "2021-04-22T00:00:00",
                "CaptureDate": "2023-05-03T12:36:19"
              },
              {
                "Content": "JUNTADA DE PETICAO DE MANIFESTACAO DA PARTE",
                "PublishDate": "2021-04-20T00:00:00",
                "CaptureDate": "2023-05-03T12:36:19"
              },
              {
                "Content": "DECORRIDO PRAZO DE DIRCEU MATIELLO (P/ ADVGS. DE DIRCEU MATIELLO *REFERENTE AO EVENTO (SEQ. 54) ATO ORDINATORIO PRATICADO (30/03/2021) E AO EVENTO DE EXPEDICAO SEQ. 55.",
                "PublishDate": "2021-04-17T00:00:00",
                "CaptureDate": "2023-05-03T12:36:19"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA (PELO ADVOGADO/CURADOR/DEFENSOR DE DIRCEU MATIELLO) EM 09/04/2021 COM PRAZO DE 5 DIAS UTEIS *REFERENTE AO EVENTO (SEQ. 54) ATO ORDINATORIO PRATICADO (30/03/2021) E AO EVENTO DE EXPEDICAO SEQ. 55.",
                "PublishDate": "2021-04-10T00:00:00",
                "CaptureDate": "2023-05-03T12:36:19"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO PARA ADVOGADOS/CURADOR/DEFENSOR DE DIRCEU MATIELLO COM PRAZO DE 5 DIAS UTEIS - REFERENTE AO EVENTO (SEQ. 54) ATO ORDINATORIO PRATICADO (30/03/2021)",
                "PublishDate": "2021-03-30T00:00:00",
                "CaptureDate": "2023-05-03T12:36:19"
              },
              {
                "Content": "LEVANTADA A SUSPENSAO OU SOBRESTAMENTO DOS AUTOS TERMINO DA SUSPENSAO DO PROCESSO - PRAZO ENCERRADO",
                "PublishDate": "2021-03-30T00:00:00",
                "CaptureDate": "2023-05-03T12:36:19"
              },
              {
                "Content": "DECORRIDO PRAZO DE DIRCEU MATIELLO (P/ ADVGS. DE DIRCEU MATIELLO *REFERENTE AO EVENTO (SEQ. 42) PROCESSO SUSPENSO POR MORTE OU PERDA DA CAPACIDADE (18/12/2020) E AO EVENTO DE EXPEDICAO SEQ. 43.",
                "PublishDate": "2021-01-29T00:00:00",
                "CaptureDate": "2023-05-03T12:36:19"
              },
              {
                "Content": "JUNTADA DE PETICAO DE MANIFESTACAO DA PARTE CUMPRIMENTO DE INTIMACAO - REFERENTE AO EVENTO PROCESSO SUSPENSO POR MORTE OU PERDA DA CAPACIDADE (18/12/2020)",
                "PublishDate": "2021-01-22T00:00:00",
                "CaptureDate": "2023-05-03T12:36:19"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA (PELO ADVOGADO/CURADOR/DEFENSOR DE DIRCEU MATIELLO) EM 21/01/2021 COM PRAZO DE 5 DIAS UTEIS *REFERENTE AO EVENTO (SEQ. 42) PROCESSO SUSPENSO POR MORTE OU PERDA DA CAPACIDADE (18/12/2020) E AO EVENTO DE EXPEDICAO SEQ. 43.",
                "PublishDate": "2021-01-19T00:00:00",
                "CaptureDate": "2023-05-03T12:36:19"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA (PELO ADVOGADO/CURADOR/DEFENSOR DE STARK BANK S.A.) EM 21/01/2021 COM PRAZO DE 5 DIAS UTEIS *REFERENTE AO EVENTO (SEQ. 42) PROCESSO SUSPENSO POR MORTE OU PERDA DA CAPACIDADE (18/12/2020) E AO EVENTO DE EXPEDICAO SEQ. 44.",
                "PublishDate": "2021-01-19T00:00:00",
                "CaptureDate": "2023-05-03T12:36:19"
              },
              {
                "Content": "JUNTADA DE COMPROVANTE DEVOLUCAO SEM LEITURA - REFERENTE A CITACAO EXPEDIDA EM 08/12/2020 PARA GILBERTO KLEY SILVA",
                "PublishDate": "2021-01-18T00:00:00",
                "CaptureDate": "2023-05-03T12:36:19"
              },
              {
                "Content": "JUNTADA DE COMPROVANTE DEVOLUCAO SEM LEITURA - REFERENTE A CITACAO EXPEDIDA EM 08/12/2020 PARA FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA",
                "PublishDate": "2021-01-18T00:00:00",
                "CaptureDate": "2023-05-03T12:36:19"
              },
              {
                "Content": "JUNTADA DE COMPROVANTE DEVOLUCAO SEM LEITURA - REFERENTE A CITACAO EXPEDIDA EM 08/12/2020 PARA FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA",
                "PublishDate": "2021-01-14T00:00:00",
                "CaptureDate": "2023-05-03T12:36:19"
              },
              {
                "Content": "PROCESSO SUSPENSO POR 60 DIAS CORRIDOS A PARTIR DE 08/01/2021",
                "PublishDate": "2021-01-08T00:00:00",
                "CaptureDate": "2023-05-03T12:36:19"
              },
              {
                "Content": "AUDIENCIA DE CONCILIACAO CANCELADA CANCELADA",
                "PublishDate": "2021-01-08T00:00:00",
                "CaptureDate": "2023-05-03T12:36:19"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO PARA ADVOGADOS/CURADOR/DEFENSOR DE STARK BANK S.A. COM PRAZO DE 5 DIAS UTEIS - REFERENTE AO EVENTO (SEQ. 42) PROCESSO SUSPENSO POR MORTE OU PERDA DA CAPACIDADE (18/12/2020)",
                "PublishDate": "2021-01-08T00:00:00",
                "CaptureDate": "2023-05-03T12:36:19"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO PARA ADVOGADOS/CURADOR/DEFENSOR DE DIRCEU MATIELLO COM PRAZO DE 5 DIAS UTEIS - REFERENTE AO EVENTO (SEQ. 42) PROCESSO SUSPENSO POR MORTE OU PERDA DA CAPACIDADE (18/12/2020)",
                "PublishDate": "2021-01-08T00:00:00",
                "CaptureDate": "2023-05-03T12:36:19"
              },
              {
                "Content": "PROCESSO SUSPENSO POR MORTE OU PERDA DA CAPACIDADE PROJUDI - PROCESSO: 0034204-88.2020.8.16.0021 - REF. MOV. 42.1 - ASSINADO DIGITALMENTE POR OSVALDO ALVES DA SILVA:17020 18/12/2020: PROCESSO SUSPENSO POR MORTE OU PERDA DA CAPACIDADE. ARQ: DECISAO PODER JUDICIARIO DO ESTADO DO PARANA COMARCA DE CASCAVEL 3 JUIZADO ESPECIAL CIVEL DE CASCAVEL - PROJUDI AVENIDA TANCREDO NEVES, 2320 - FORUM - ALTO ALEGRE - CASCAVEL/PR - CEP: 85.801-900 - FONE: (45) 3392-5069 - E-MAIL: CAS-17VJ-S@TJPR.JUS.BR AUTOS N. 0034204-88.2020.8.16.0021 PROCESSO: 0034204-88.2020.8.16.0021 CLASSE PROCESSUAL: PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL ASSUNTO PRINCIPAL: PERDAS E DANOS VALOR DA CAUSA: R$21.000,00 POLO ATIVO(S): DIRCEU MATIELLO (CPF/CNPJ: 703.133.509-49) LINHA JARARACA, S/N SITIO - DISTRITO DE CERRO AZUL - LINDOESTE/PR - CEP: 85.826-000 POLO PASSIVO(S): FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA (CPF/CNPJ: 21.160.553/0001-81) SETOR DE AUTARQUIAS SUL , 321 QUADRA 3 BLOCO C LOTES 2/3 - ASA SUL - BRASILIA/DF - CEP: 70.070-934 FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA (CPF/CNPJ: 10.685.786/0001-81) AVENIDA JAMARIS, 100 13 ANDAR - CONJUNTO 1302 - PLANALTO PAULISTA - SAO PAULO/SP - CEP: 04.078-000 GILBERTO KLEY SILVA (CPF/CNPJ: 185.839.848-75) AVENIDA CASTELO BRANCO, 314 SALA 708 - HORTO - IPATINGA/MG - CEP: 35.160-294 STARK BANK S.A. (CPF/CNPJ: 20.018.183/0001-80) RUA DOS INGLESES, 586 CONJUNTO 63 - MORRO DOS INGLESES - SAO PAULO/SP - CEP: 01.329-000 DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJ8L5 4QYYC GWNAG ENW4U VISTOS DIANTE DA NOTICIA DE QUE O UNICO PROCURADOR DA PARTE AUTORA ENCONTRA-SE HOSPITALIZADO NA UNIDADE DE TERAPIA INTENSIVA (UTI) (REF.40.2), SUSPENDO A TRAMITACAO DO FEITO, PELO PRAZO DE 60 (SESSENTA) DIAS, COM FULCRO NO ARTIGO 313, INCISO I, DO CODIGO DE PROCESSO CIVIL. RETIRE-SE DE PAUTA, AUDIENCIA DE CONCILIACAO DESIGNADA. CASCAVEL, DATADO ELETRONICAMENTE. OSVALDO ALVES DA SILVA JUIZ DE DIREITO",
                "PublishDate": "2020-12-18T00:00:00",
                "CaptureDate": "2023-05-03T12:36:19"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO RESPONSAVEL: OSVALDO ALVES DA SILVA",
                "PublishDate": "2020-12-18T00:00:00",
                "CaptureDate": "2023-05-03T12:36:29"
              },
              {
                "Content": "JUNTADA DE PETICAO DE REQUERIMENTO DE SUSPENSAO DO PROCESSO CUMPRIMENTO DE INTIMACOES - REFERENTE AOS EVENTOS JUNTADA DE CERTIDAO (08/12/2020), AUDIENCIA DE CONCILIACAO DESIGNADA (08/12/2020), JUNTADA DE PETICAO DE MANIFESTACAO DA PARTE (13/12/2020)",
                "PublishDate": "2020-12-17T00:00:00",
                "CaptureDate": "2023-05-03T12:36:29"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA (PELO ADVOGADO/CURADOR/DEFENSOR DE DIRCEU MATIELLO) EM 17/12/2020 COM PRAZO DE 5 DIAS UTEIS *REFERENTE AO EVENTO (SEQ. 34) JUNTADA DE PETICAO DE MANIFESTACAO DA PARTE (13/12/2020) E AO EVENTO DE EXPEDICAO SEQ. 36.",
                "PublishDate": "2020-12-17T00:00:00",
                "CaptureDate": "2023-05-03T12:36:29"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA (PELO ADVOGADO/CURADOR/DEFENSOR DE DIRCEU MATIELLO) EM 17/12/2020 COM PRAZO DE 5 DE MARCO DE 2021 *REFERENTE AO EVENTO (SEQ. 23) AUDIENCIA DE CONCILIACAO DESIGNADA (08/12/2020) E AO EVENTO DE EXPEDICAO SEQ. 24.",
                "PublishDate": "2020-12-17T00:00:00",
                "CaptureDate": "2023-05-03T12:36:29"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA (PELO ADVOGADO/CURADOR/DEFENSOR DE DIRCEU MATIELLO) EM 17/12/2020 COM PRAZO DE 5 DIAS UTEIS *REFERENTE AO EVENTO (SEQ. 26) JUNTADA DE CERTIDAO (08/12/2020) E AO EVENTO DE EXPEDICAO SEQ. 27.",
                "PublishDate": "2020-12-17T00:00:00",
                "CaptureDate": "2023-05-03T12:36:29"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO PARA ADVOGADOS/CURADOR/DEFENSOR DE DIRCEU MATIELLO COM PRAZO DE 5 DIAS UTEIS - REFERENTE AO EVENTO (SEQ. 34) JUNTADA DE PETICAO DE MANIFESTACAO DA PARTE (13/12/2020)",
                "PublishDate": "2020-12-16T00:00:00",
                "CaptureDate": "2023-05-03T12:36:29"
              },
              {
                "Content": "DECORRIDO PRAZO DE DIRCEU MATIELLO (P/ ADVGS. DE DIRCEU MATIELLO *REFERENTE AO EVENTO (SEQ. 18) JUNTADA DE PENHORA SOLICITADA BACENJUD/SISBAJUD (27/11/2020) E AO EVENTO DE EXPEDICAO SEQ. 19.",
                "PublishDate": "2020-12-16T00:00:00",
                "CaptureDate": "2023-05-03T12:36:29"
              },
              {
                "Content": "JUNTADA DE PETICAO DE MANIFESTACAO DA PARTE CUMPRIMENTO DE INTIMACOES - REFERENTE AOS EVENTOS JUNTADA DE PENHORA SOLICITADA BACENJUD/SISBAJUD (27/11/2020), JUNTADA DE CERTIDAO (08/12/2020), AUDIENCIA DE CONCILIACAO DESIGNADA (08/12/2020)",
                "PublishDate": "2020-12-13T00:00:00",
                "CaptureDate": "2023-05-03T12:36:29"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA (PELO ADVOGADO/CURADOR/DEFENSOR DE STARK BANK S.A.) EM 14/12/2020 COM PRAZO DE 5 DE MARCO DE 2021 *REFERENTE AO EVENTO (SEQ. 23) AUDIENCIA DE CONCILIACAO DESIGNADA (08/12/2020) E AO EVENTO DE EXPEDICAO SEQ. 25.",
                "PublishDate": "2020-12-13T00:00:00",
                "CaptureDate": "2023-05-03T12:36:29"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA (PELO ADVOGADO/CURADOR/DEFENSOR DE STARK BANK S.A.) EM 14/12/2020 COM PRAZO DE 5 DIAS UTEIS *REFERENTE AO EVENTO (SEQ. 26) JUNTADA DE CERTIDAO (08/12/2020) E AO EVENTO DE EXPEDICAO SEQ. 28.",
                "PublishDate": "2020-12-13T00:00:00",
                "CaptureDate": "2023-05-03T12:36:29"
              },
              {
                "Content": "EXPEDICAO DE CITACAO PARA GILBERTO KLEY SILVA COM PRAZO ATE 5 DE MARCO DE 2021 - VIA AR DIGITAL - UTILIZANDO CONTRAFE",
                "PublishDate": "2020-12-08T00:00:00",
                "CaptureDate": "2023-05-03T12:36:29"
              },
              {
                "Content": "EXPEDICAO DE CITACAO PARA FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA COM PRAZO ATE 5 DE MARCO DE 2021 - VIA AR DIGITAL - UTILIZANDO CONTRAFE",
                "PublishDate": "2020-12-08T00:00:00",
                "CaptureDate": "2023-05-03T12:36:29"
              },
              {
                "Content": "EXPEDICAO DE CITACAO PARA FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA COM PRAZO ATE 5 DE MARCO DE 2021 - VIA AR DIGITAL - UTILIZANDO CONTRAFE",
                "PublishDate": "2020-12-08T00:00:00",
                "CaptureDate": "2023-05-03T12:36:29"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO PARA ADVOGADOS/CURADOR/DEFENSOR DE STARK BANK S.A. COM PRAZO DE 5 DIAS UTEIS - REFERENTE AO EVENTO (SEQ. 26) JUNTADA DE CERTIDAO (08/12/2020)",
                "PublishDate": "2020-12-08T00:00:00",
                "CaptureDate": "2023-05-03T12:36:29"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO PARA ADVOGADOS/CURADOR/DEFENSOR DE DIRCEU MATIELLO COM PRAZO DE 5 DIAS UTEIS - REFERENTE AO EVENTO (SEQ. 26) JUNTADA DE CERTIDAO (08/12/2020)",
                "PublishDate": "2020-12-08T00:00:00",
                "CaptureDate": "2023-05-03T12:36:29"
              },
              {
                "Content": "JUNTADA DE CERTIDAO",
                "PublishDate": "2020-12-08T00:00:00",
                "CaptureDate": "2023-05-03T12:36:29"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO PARA ADVOGADOS/CURADOR/DEFENSOR DE STARK BANK S.A. COM PRAZO DE 5 DE MARCO DE 2021 - REFERENTE AO EVENTO (SEQ. 23) AUDIENCIA DE CONCILIACAO DESIGNADA (08/12/2020)",
                "PublishDate": "2020-12-08T00:00:00",
                "CaptureDate": "2023-05-03T12:36:29"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO PARA ADVOGADOS/CURADOR/DEFENSOR DE DIRCEU MATIELLO COM PRAZO DE 5 DE MARCO DE 2021 - REFERENTE AO EVENTO (SEQ. 23) AUDIENCIA DE CONCILIACAO DESIGNADA (08/12/2020)",
                "PublishDate": "2020-12-08T00:00:00",
                "CaptureDate": "2023-05-03T12:36:29"
              },
              {
                "Content": "AUDIENCIA DE CONCILIACAO DESIGNADA (AGENDADA PARA: 05 DE MARCO DE 2021 AS 15:00, EM 3 JUIZADO ESPECIAL CIVEL DE CASCAVEL, MODALIDADE: VIRTUAL)",
                "PublishDate": "2020-12-08T00:00:00",
                "CaptureDate": "2023-05-03T12:36:29"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA (PELO ADVOGADO/CURADOR/DEFENSOR DE STARK BANK S.A.) EM 07/12/2020 COM PRAZO DE 5 DIAS UTEIS *REFERENTE AO EVENTO (SEQ. 18) JUNTADA DE PENHORA SOLICITADA BACENJUD/SISBAJUD (27/11/2020) E AO EVENTO DE EXPEDICAO SEQ. 20.",
                "PublishDate": "2020-12-08T00:00:00",
                "CaptureDate": "2023-05-03T12:36:29"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA (PELO ADVOGADO/CURADOR/DEFENSOR DE DIRCEU MATIELLO) EM 07/12/2020 COM PRAZO DE 5 DIAS UTEIS *REFERENTE AO EVENTO (SEQ. 18) JUNTADA DE PENHORA SOLICITADA BACENJUD/SISBAJUD (27/11/2020) E AO EVENTO DE EXPEDICAO SEQ. 19.",
                "PublishDate": "2020-12-08T00:00:00",
                "CaptureDate": "2023-05-03T12:36:29"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO PARA ADVOGADOS/CURADOR/DEFENSOR DE STARK BANK S.A. COM PRAZO DE 5 DIAS UTEIS - REFERENTE AO EVENTO (SEQ. 18) JUNTADA DE PENHORA SOLICITADA BACENJUD/SISBAJUD (27/11/2020)",
                "PublishDate": "2020-11-27T00:00:00",
                "CaptureDate": "2023-05-03T12:36:29"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO PARA ADVOGADOS/CURADOR/DEFENSOR DE DIRCEU MATIELLO COM PRAZO DE 5 DIAS UTEIS - REFERENTE AO EVENTO (SEQ. 18) JUNTADA DE PENHORA SOLICITADA BACENJUD/SISBAJUD (27/11/2020)",
                "PublishDate": "2020-11-27T00:00:00",
                "CaptureDate": "2023-05-03T12:36:29"
              },
              {
                "Content": "JUNTADA DE PENHORA SOLICITADA BACENJUD/SISBAJUD",
                "PublishDate": "2020-11-27T00:00:00",
                "CaptureDate": "2023-05-03T12:36:29"
              },
              {
                "Content": "JUNTADA DE RESTRICAO REALIZADA NO RENAJUD",
                "PublishDate": "2020-11-06T00:00:00",
                "CaptureDate": "2023-05-03T12:36:29"
              },
              {
                "Content": "JUNTADA DE PETICAO DE MANIFESTACAO DA PARTE CUMPRIMENTO DE INTIMACAO - REFERENTE AO EVENTO CONCEDIDA EM PARTE A ANTECIPACAO DE TUTELA (05/11/2020)",
                "PublishDate": "2020-11-06T00:00:00",
                "CaptureDate": "2023-05-03T12:36:29"
              },
              {
                "Content": "ATO CUMPRIDO PELA PARTE OU INTERESSADO LEITURA DE INTIMACAO REALIZADA - (PELO ADVOGADO/CURADOR/DEFENSOR DE DIRCEU MATIELLO) EM 06/11/2020 COM PRAZO DE 5 DIAS UTEIS *REFERENTE AO EVENTO (SEQ. 11) CONCEDIDA EM PARTE A ANTECIPACAO DE TUTELA (05/11/2020) E AO EVENTO DE EXPEDICAO SEQ. 14.",
                "PublishDate": "2020-11-06T00:00:00",
                "CaptureDate": "2023-05-03T12:36:29"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO PARA ADVOGADOS/CURADOR/DEFENSOR DE DIRCEU MATIELLO COM PRAZO DE 5 DIAS UTEIS - REFERENTE AO EVENTO (SEQ. 11) CONCEDIDA EM PARTE A ANTECIPACAO DE TUTELA (05/11/2020)",
                "PublishDate": "2020-11-06T00:00:00",
                "CaptureDate": "2023-05-03T12:36:29"
              },
              {
                "Content": "JUNTADA DE PENHORA SOLICITADA BACENJUD/SISBAJUD",
                "PublishDate": "2020-11-06T00:00:00",
                "CaptureDate": "2023-05-03T12:36:29"
              },
              {
                "Content": "JUNTADA DE PETICAO DE CONTESTACAO",
                "PublishDate": "2020-11-06T00:00:00",
                "CaptureDate": "2023-05-03T12:36:29"
              },
              {
                "Content": "CONCEDIDA EM PARTE A ANTECIPACAO DE TUTELA PROJUDI - PROCESSO: 0034204-88.2020.8.16.0021 - REF. MOV. 11.1 - ASSINADO DIGITALMENTE POR JAQUELINE ALLIEVI:9260 05/11/2020: CONCEDIDA EM PARTE A ANTECIPACAO DE TUTELA. ARQ: DECISAO PODER JUDICIARIO DO ESTADO DO PARANA COMARCA DE CASCAVEL 3 JUIZADO ESPECIAL CIVEL DE CASCAVEL - PROJUDI AVENIDA TANCREDO NEVES, 2320 - FORUM - ALTO ALEGRE - CASCAVEL/PR - CEP: 85.801-900 - FONE: (45) 3392-5069 - E-MAIL: CAS-17VJ-S@TJPR.JUS.BR CLASSE PROCESSUAL: PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL ASSUNTO PRINCIPAL: PERDAS E DANOS PROCESSO N: 0034204-88.2020.8.16.0021 POLO ATIVO(S): DIRCEU MATIELLO POLO PASSIVO(S): FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA GILBERTO KLEY SILVA STARK BANK S.A. VISTOS. 1. DIANTE DO COMPARECIMENTO ESPONTANEO (ART. 239, 1, DO CODIGO DE PROCESSO CIVIL), DOU POR CITADA A RE STARK BANK S/A. ANOTE-SE NOS AUTOS. 2. DO PEDIDO DE TUTELA PROVISORIA: O ARTIGO 300, CAPUT, DO CODIGO DE PROCESSO CIVIL, ESTABELECE QUE OS REQUISITOS GERAIS PARA A CONCESSAO DE TUTELA PROVISORIA DE URGENCIA SAO: A) A PROBABILIDADE DO DIREITO (FUMUS BONI IURIS); E, B) O PERIGO DE DANO OU RISCO AO RESULTADO UTIL DO PROCESSO (PERICULUM IN MORA). NO PRESENTE CASO, O AUTOR REQUEREU A CONCESSAO DE TUTELA DE URGENCIA DE NATUREZA CAUTELAR, A FIM DE SER DETERMINADO O BLOQUEIO IMEDIATO DE BENS E VALORES DOS REUS. POIS BEM. OS RELATOS FATICOS E OS DOCUMENTOS QUE INSTRUEM A INICIAL DEMONSTRAM A PROBABILIDADE DO DIREITO DO RECLAMANTE, BEM COMO A EXISTENCIA DE PERIGO DE RISCO AO RESULTADO UTIL DO PROCESSO, POIS DAO CONTA DA CONCRETA POSSIBILIDADE DE O POSTULANTE TER SIDO VITIMA DE UMA PIRAMIDE FINANCEIRA, NAO TENDO QUALQUER PERSPECTIVA DE REAVER O DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJ8B3 4DKBA NC43R XB6D3 DINHEIRO \"APLICADO\" NO NEGOCIO QUE FIRMOU COM OS REUS. POR OUTRO LADO, O DEFERIMENTO DO PEDIDO LIMINAR NAO TEM CARATER IRREVERSIVEL, POIS O DINHEIRO EVENTUALMENTE BLOQUEADO PERMANECERA DEPOSITADO NESTE PROCESSO ATE O SEU DESFECHO, PODENDO SER DEVOLVIDO A QUALQUER TEMPO, CASO HAJA ALTERACAO FATICA E/OU JURIDICA. NAO OBSTANTE AS RAZOES E OS DOCUMENTOS TRAZIDOS PELA RE STARK (REF. 8.1 A 8.15), ENTENDO QUE, A LUZ DO CODIGO DE DEFESA DO CONSUMIDOR E DIANTE DO JUIZO DE COGNICAO SUMARIA IMPOSTO NESTA FASE DO PROCESSO, O FATO DE ELA CONSTAR COMO BENEFICIARIA DO DEPOSITO EFETUADO PELO RECLAMANTE A TITULO DE INVESTIMENTO (REF. 1.6) E SUFICIENTE PARA JUSTIFICAR QUE OS ATOS DETERMINADOS NESTA DECISAO PURAMENTE CAUTELAR TAMBEM SEJAM REALIZADOS EM SEU DESFAVOR. A EXISTENCIA E A EXTENSAO DA SUA RESPONSABILIDADE NO CASO CONCRETO SAO MATERIAS CONTROVERTIDAS E SE TRATAM DO PROPRIO MERITO DA DEMANDA, SENDO NECESSARIO PERMITIR O CONTRADITORIO E DILATAR A PRODUCAO DE PROVAS. PORQUE PRESENTES OS REQUISITOS DO ARTIGO 300, DO CODIGO DE PROCESSO CIVIL, CONCEDO PARCIALMENTE A TUTELA DE URGENCIA DE NATUREZA CAUTELAR (ART. 301, DO CPC) E DETERMINO O BLOQUEIO DAS CONTAS BANCARIAS DOS RECLAMADOS, PERANTE O SISTEMA SISBAJUD, DO VALOR BRUTO INVESTIDO PELO AUTOR (R$ 13.000,00), BEM COMO A RESTRICAO DE TRANSFERENCIA DE VEICULOS REGISTRADOS EM NOME DOS REUS PERANTE O SISTEMA RENAJUD. A FIM DE EVITAR EXCESSOS E TENDO EM VISTA A FASE EMBRIONARIA DA LIDE, INDEFIRO TODAS AS DEMAIS DILIGENCIAS EXPROPRIATORIAS REQUERIDAS. 3. CITEM-SE/INTIMEM-SE AS PARTES, CONFORME PORTARIA CONJUNTA DOS JUIZADOS DA COMARCA N 01/2020. PROJUDI - PROCESSO: 0034204-88.2020.8.16.0021 - REF. MOV. 11.1 - ASSINADO DIGITALMENTE POR JAQUELINE ALLIEVI:9260 05/11/2020: CONCEDIDA EM PARTE A ANTECIPACAO DE TUTELA. ARQ: DECISAO DILIGENCIAS NECESSARIAS. CASCAVEL, DATADO ELETRONICAMENTE. JAQUELINE ALLIEVI JUIZA DE DIREITO DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJ8B3 4DKBA NC43R XB6D3",
                "PublishDate": "2020-11-05T00:00:00",
                "CaptureDate": "2023-05-03T12:36:29"
              },
              {
                "Content": "RECEBIDOS OS AUTOS RECEBIDO DO(A) DISTRIBUIDOR",
                "PublishDate": "2020-11-04T00:00:00",
                "CaptureDate": "2023-05-03T12:36:40"
              },
              {
                "Content": "JUNTADA DE ANOTACAO DE DISTRIBUICAO",
                "PublishDate": "2020-11-04T00:00:00",
                "CaptureDate": "2023-05-03T12:36:40"
              },
              {
                "Content": "JUNTADA DE PETICAO DE APRESENTACAO DE RESPOSTA A ACUSACAO E/OU DEFESA PRELIMINAR",
                "PublishDate": "2020-11-03T00:00:00",
                "CaptureDate": "2023-05-03T12:36:40"
              },
              {
                "Content": "JUNTADA DE PETICAO DE PROCURACAO",
                "PublishDate": "2020-11-03T00:00:00",
                "CaptureDate": "2023-05-03T12:36:40"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO - LIMINAR RESPONSAVEL: JAQUELINE ALLIEVI",
                "PublishDate": "2020-11-03T00:00:00",
                "CaptureDate": "2023-05-03T12:36:40"
              },
              {
                "Content": "JUNTADA DE CERTIDAO",
                "PublishDate": "2020-11-03T00:00:00",
                "CaptureDate": "2023-05-03T12:36:40"
              },
              {
                "Content": "RECEBIDOS OS AUTOS",
                "PublishDate": "2020-11-03T00:00:00",
                "CaptureDate": "2023-05-03T12:36:40"
              },
              {
                "Content": "REMETIDOS OS AUTOS PARA DISTRIBUIDOR REGISTRO DE DISTRIBUICAO",
                "PublishDate": "2020-11-03T00:00:00",
                "CaptureDate": "2023-05-03T12:36:40"
              },
              {
                "Content": "DISTRIBUIDO POR SORTEIO 3 JUIZADO ESPECIAL CIVEL DE CASCAVEL",
                "PublishDate": "2020-11-03T00:00:00",
                "CaptureDate": "2023-05-03T12:36:40"
              },
              {
                "Content": "JUNTADA DE PETICAO DE INICIAL",
                "PublishDate": "2020-11-03T00:00:00",
                "CaptureDate": "2023-05-03T12:36:40"
              }
            ],
            "Petitions": [],
            "Decisions": [
              {
                "DecisionContent": "DECIDO OS FUNDAMENTOS DA SENTENCA, AINDA MAIS NO SISTEMA DOS JUIZADOS ESPECIAIS, DEVEM PRIMAR PELA OBJETIVIDADE, SIMPLICIDADE, INFORMALIDADE E PRECISAO, A FIM DE PERMITIREM CELERIDADE NA RESOLUCAO DOS DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJZL5 WB8QH UA6W6 ZTURK CONFLITOS (ART.",
                "DecisionDate": "2022-12-05T00:00:00"
              },
              {
                "DecisionContent": "ACOLHO A PRELIMINAR DE ILEGITIMIDADE SUSCITADA PELO STARK BANK S/A, POIS SE TRATA DE UMA FINTECH QUE OPERA COM O AUXILIO DO BANCO ITAU LICITAMENTE NO MERCADO.",
                "DecisionDate": "2022-12-05T00:00:00"
              },
              {
                "DecisionContent": "JULGO EXTINTO O PROCESSO EM FACE DA REFERIDA RE, SEM RESOLUCAO DE MERITO.",
                "DecisionDate": "2022-12-05T00:00:00"
              },
              {
                "DecisionContent": "JULGO PARCIALMENTE PROCEDENTES OS PEDIDOS CONTIDOS NA PETICAO INICIAL, PARA OS FINS DE A) DECLARAR NULO O CONTRATO FIRMADO ENTRE O AUTOR E AS RES FRI E FORTS; E, B) CONDENAR OS REUS FRI SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA, GILBERTO KLEY SILVA, E FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA (FORTS BANK), REVEIS, SOLIDARIAMENTE, A RESTITUIREM AO AUTOR O VALOR DE R$ 13.000,00 (TREZE MIL REAIS), CORRIGIDO MONETARIAMENTE PELA MEDIA DO INPC/IGP-DI DESDE O DESEMBOLSO (12/11/2019) E A SOMAR JUROS DE MORA DE 1% AO MES A CONTAR DA CITACAO EM 05/08 /2022.",
                "DecisionDate": "2022-12-05T00:00:00"
              },
              {
                "DecisionContent": "JULGO EXTINTO O PROCESSO EM FACE DE STARK BANK S/A, SEM RESOLUCAO DE MERITO, NA FORMA DO ARTIGO 485, VI, DO CODIGO DE PROCESSO CIVIL.",
                "DecisionDate": "2022-12-05T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO A DILACAO PELO PRAZO DE 30 (TRINTA) DIAS, PARA QUE A PARTE AUTORA APRESENTE COMPROVANTE DE ENDERECO ATUALIZADO DOS REUS NAO CITADOS, SOB PENA DE EXTINCAO DO FEITO.",
                "DecisionDate": "2022-05-17T00:00:00"
              }
            ]
          },
          {
            "Number": "00281882120208160021",
            "Type": "PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL",
            "MainSubject": "4701 - ATO / NEGOCIO JURIDICO",
            "CourtName": "TJPR",
            "CourtLevel": "1",
            "CourtType": "ESPECIAL CIVEL",
            "CourtDistrict": "CASCAVEL",
            "Judge": "JAQUELINE ALLIEVI",
            "JudgingBody": "3 JUIZADO ESPECIAL CIVEL DE CASCAVEL",
            "State": "PR",
            "Status": "ARQUIVADO",
            "LawsuitHostService": "OTHER",
            "InferredCNJSubjectName": "ATO / NEGÓCIO JURÍDICO",
            "InferredCNJSubjectNumber": 4701,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO DO JUIZADO ESPECIAL CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO CIVIL",
            "InferredBroadCNJSubjectNumber": 899,
            "OtherSubjects": [
              "4701 - ATO / NEGOCIO JURIDICO",
              "7768 - RESCISAO DO CONTRATO E DEVOLUCAO DO DINHEIRO"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": -1,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "2022-10-07T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "0001-01-01T00:00:00",
            "NoticeDate": "2020-09-09T00:00:00",
            "LastMovementDate": "2022-10-07T00:00:00",
            "CaptureDate": "2023-05-06T17:22:19",
            "LastUpdate": "2023-05-06T17:22:19",
            "NumberOfParties": 8,
            "NumberOfUpdates": 70,
            "LawSuitAge": 758,
            "AverageNumberOfUpdatesPerMonth": 1,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "88404439915",
                "IsPartyActive": true,
                "Name": "JAQUELINE ALLIEVI",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-05-06T17:22:19"
              },
              {
                "Doc": "02779608943",
                "IsPartyActive": true,
                "Name": "MARCELO JORGE CORREA",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "POLO ATIVO"
                },
                "LastCaptureDate": "2023-05-06T17:22:19"
              },
              {
                "Doc": "08553655954",
                "IsPartyActive": true,
                "Name": "JANAINA PAOLA DA SILVA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "86100N",
                  "State": "PR",
                  "SpecificType": "ADVOGADO (POLO ATIVO)"
                },
                "LastCaptureDate": "2023-05-06T17:22:19"
              },
              {
                "Doc": "06185628937",
                "IsPartyActive": true,
                "Name": "LAISA ROVEDA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "80437N",
                  "State": "PR",
                  "SpecificType": "ADVOGADO (POLO ATIVO)"
                },
                "LastCaptureDate": "2023-05-06T17:22:19"
              },
              {
                "Doc": "21160553000181",
                "IsPartyActive": true,
                "Name": "FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "POLO PASSIVO"
                },
                "LastCaptureDate": "2023-05-06T17:22:19"
              },
              {
                "Doc": "10685786000181",
                "IsPartyActive": true,
                "Name": "FRI SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "POLO PASSIVO"
                },
                "LastCaptureDate": "2023-05-06T17:22:19"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "POLO PASSIVO"
                },
                "LastCaptureDate": "2023-05-06T17:22:19"
              },
              {
                "Doc": "35068411817",
                "IsPartyActive": true,
                "Name": "RAFAEL HIDEO NAZIMA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "295443N",
                  "State": "SP",
                  "SpecificType": "ADVOGADO (POLO PASSIVO)"
                },
                "LastCaptureDate": "2023-05-06T17:22:19"
              }
            ],
            "Updates": [
              {
                "Content": "ARQUIVADO DEFINITIVAMENTE",
                "PublishDate": "2022-10-07T00:00:00",
                "CaptureDate": "2023-05-06T17:23:29"
              },
              {
                "Content": "JUNTADA DE INFORMACAO",
                "PublishDate": "2022-10-07T00:00:00",
                "CaptureDate": "2023-05-06T17:23:29"
              },
              {
                "Content": "EXPEDICAO DE OFICIO REFERENTE AO EVENTO (SEQ. 67) PROFERIDO DESPACHO DE MERO EXPEDIENTE(04/10/2022 20:00:34). IDENTIFICADOR DO CUMPRIMENTO: 0004",
                "PublishDate": "2022-10-06T00:00:00",
                "CaptureDate": "2023-05-06T17:23:29"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE . VEICULADO NO DJEN EM 06/10/2022. PROJUDI - PROCESSO: 0028188-21.2020.8.16.0021 - REF. MOV. 67.1 - ASSINADO DIGITALMENTE POR JAQUELINE ALLIEVI:9260 04/10/2022: PROFERIDO DESPACHO DE MERO EXPEDIENTE. ARQ: DESPACHO PODER JUDICIARIO DO ESTADO DO PARANA COMARCA DE CASCAVEL 3 JUIZADO ESPECIAL CIVEL DE CASCAVEL - PROJUDI AVENIDA TANCREDO NEVES, 2320 - FORUM - ALTO ALEGRE - CASCAVEL/PR - CEP.: 85.801-900 - FONE: (45) 3392-5069 - CELULAR: (45) 3392- 5119 - E-MAIL: CAS-17VJ-S@TJPR.JUS.BR AUTOS N. 0028188-21.2020.8.16.0021 PROCESSO: 0028188-21.2020.8.16.0021 CLASSE PROCESSUAL: PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL ASSUNTO PRINCIPAL: ATO / NEGOCIO JURIDICO VALOR DA CAUSA: R$36.000,00 POLO ATIVO(S): MARCELO JORGE CORREA POLO PASSIVO(S): FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA STARK BANK S.A. VISTOS. 1. OFICIE-SE, EM RESPOSTA AO EXPEDIENTE DE REF. 64.1, INFORMANDO QUE NAO HA VALORES BLOQUEADOS NESTE PROCESSO. DEVERA SER ANEXADO AO OFICIO COPIAS DOS REFS. 65.1, 65.2 E 65.3. 2. APOS, RETORNEM OS AUTOS AO ARQUIVO. DILIGENCIAS NECESSARIAS. CASCAVEL, DATADO ELETRONICAMENTE. JAQUELINE ALLIEVI JUIZA DE DIREITO DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJ5GU FCP6W US5DH BKDNY",
                "PublishDate": "2022-10-04T00:00:00",
                "CaptureDate": "2023-05-06T17:23:29"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO RESPONSAVEL: JAQUELINE ALLIEVI",
                "PublishDate": "2022-09-27T00:00:00",
                "CaptureDate": "2023-05-06T17:23:43"
              },
              {
                "Content": "JUNTADA DE CERTIDAO",
                "PublishDate": "2022-09-27T00:00:00",
                "CaptureDate": "2023-05-06T17:23:43"
              },
              {
                "Content": "JUNTADA DE DECISAO DE OUTROS AUTOS",
                "PublishDate": "2022-09-27T00:00:00",
                "CaptureDate": "2023-05-06T17:23:43"
              },
              {
                "Content": "PROCESSO REATIVADO",
                "PublishDate": "2022-09-27T00:00:00",
                "CaptureDate": "2023-05-06T17:23:43"
              },
              {
                "Content": "ARQUIVADO DEFINITIVAMENTE",
                "PublishDate": "2021-02-03T00:00:00",
                "CaptureDate": "2023-05-06T17:23:43"
              },
              {
                "Content": "JUNTADA DE INFORMACAO",
                "PublishDate": "2021-02-03T00:00:00",
                "CaptureDate": "2023-05-06T17:23:43"
              },
              {
                "Content": "EXPEDICAO DE OFICIO REFERENTE AO EVENTO (SEQ. 59) PROFERIDO DESPACHO DE MERO EXPEDIENTE(01/02/2021 19:58:49). IDENTIFICADOR DO CUMPRIMENTO: 0002 PROJUDI - PROCESSO: 0028188-21.2020.8.16.0021 - REF. MOV. 60.1 - ASSINADO DIGITALMENTE POR JAQUELINE ALLIEVI:9260 02/02/2021: EXPEDICAO DE OFICIO. ARQ: OFICIO PODER JUDICIARIO TRIBUNAL DE JUSTICA ESTADO DO PARANA --------------------- 3 JUIZADO ESPECIAL CIVEL COMARCA DE CASCAVEL - PARANA OF. N 74/2021 CASCAVEL, 2 DE FEVEREIRO DE 2021. AK SENHOR(A) JUIZ(A), A FIM DE INSTRUIR OS AUTOS N 0028188-21.2020.8.16.0021, MOVIDOS POR MARCELO JORGE CORREA CONTRA FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA, FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA E STARK BANK S.A ENCAMINHO A VOSSA SENHORIA A INFORMACAO DE QUE A ORDEM DE BLOQUEIO DE VALORES FOI ENCAMINHADA POR MEIO DO OFICIO DE SEQ. 16.1, PROTOCOLADO NO SISTEMA DE PROTOCOLO DIGITAL DO BANCO CENTRAL, MAS NAO OBTIVEMOS NENHUMA RESPOSTA ACERCA DO RESULTADO DA ORDEM. CONSULTADO O SISTEMA PARA ACOMPANHAR O ANDAMENTO DO OFICIO E A ULTIMA ATUALIZACAO E DATADA DE 28/10/2020, MAS NAO CONSTA INFORMACAO SOBRE O DESFECHO DA ORDEM DE BLOQUEIO (SEQ. 56.1). PELO SISBAJUD TAMBEM NADA CONSTA (A INCLUSAO DA MINUTA NAO FOI REALIZADA POR LA), CONFORME DOCUMENTOS ANEXOS. DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJVS8 UXCNR BB8QG VQTED VALHO-ME DA OPORTUNIDADE PARA APRESENTAR A VOSSA EXCELENCIA PROTESTOS DE ELEVADA ESTIMA E CONSIDERACAO. JAQUELINE ALLIEVI JUIZA DE DIREITO SUPERVISORA EXMO(A). SENHOR(A) M.M. JUIZ(A) DO 2 JUIZADO ESPECIAL CIVEL DA COMARCA DE JOINVILLE AVENIDA HERMANN AUGUST LEPPER N 980 SALA 102 BAIRRO: SAGUACU CEP 89221-902 JOINVILLE - SC ______________________________________________________________________________________________________________ AV. TANCREDO NEVES, 2320, BAIRRO ALTO ALEGRE, FONE 0**45-3321-1239, EDIFICIO DO FORUM, CASCAVEL  PR.",
                "PublishDate": "2021-02-02T00:00:00",
                "CaptureDate": "2023-05-06T17:23:43"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE . VEICULADO NO DJEN EM 03/02/2021. PROJUDI - PROCESSO: 0028188-21.2020.8.16.0021 - REF. MOV. 59.1 - ASSINADO DIGITALMENTE POR JAQUELINE ALLIEVI:9260 01/02/2021: PROFERIDO DESPACHO DE MERO EXPEDIENTE. ARQ: DESPACHO PODER JUDICIARIO DO ESTADO DO PARANA COMARCA DE CASCAVEL 3 JUIZADO ESPECIAL CIVEL DE CASCAVEL - PROJUDI AVENIDA TANCREDO NEVES, 2320 - FORUM - ALTO ALEGRE - CASCAVEL/PR - CEP: 85.801-900 - FONE: (45) 3392-5069 - E-MAIL: CAS-17VJ-S@TJPR.JUS.BR PROCESSO: 0028188-21.2020.8.16.0021 CLASSE PROCESSUAL: PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL ASSUNTO PRINCIPAL: ATO / NEGOCIO JURIDICO VALOR DA CAUSA: R$36.000,00 POLO ATIVO(S): MARCELO JORGE CORREA POLO PASSIVO(S): FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA STARK BANK S.A. VISTOS. CUMPRAM-SE OS ITENS 2 E 3, DA DECISAO DE REF. 55.1. DILIGENCIAS NECESSARIAS. CASCAVEL, DATADO ELETRONICAMENTE. JAQUELINE ALLIEVI JUIZA DE DIREITO DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJ6AM N9746 7VFY6 FAMAY",
                "PublishDate": "2021-02-01T00:00:00",
                "CaptureDate": "2023-05-06T17:24:05"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO RESPONSAVEL: JAQUELINE ALLIEVI",
                "PublishDate": "2021-02-01T00:00:00",
                "CaptureDate": "2023-05-06T17:24:30"
              },
              {
                "Content": "JUNTADA DE CERTIDAO",
                "PublishDate": "2021-02-01T00:00:00",
                "CaptureDate": "2023-05-06T17:24:30"
              },
              {
                "Content": "JUNTADA DE INFORMACAO",
                "PublishDate": "2021-02-01T00:00:00",
                "CaptureDate": "2023-05-06T17:24:30"
              },
              {
                "Content": "DETERMINADA A DISTRIBUICAO DO FEITO . VEICULADO NO DJEN EM 02/02/2021. PROJUDI - PROCESSO: 0028188-21.2020.8.16.0021 - REF. MOV. 55.1 - ASSINADO DIGITALMENTE POR JAQUELINE ALLIEVI:9260 30/01/2021: DETERMINADA A DISTRIBUICAO DO FEITO. ARQ: DECISAO PODER JUDICIARIO DO ESTADO DO PARANA COMARCA DE CASCAVEL 3 JUIZADO ESPECIAL CIVEL DE CASCAVEL - PROJUDI AVENIDA TANCREDO NEVES, 2320 - FORUM - ALTO ALEGRE - CASCAVEL/PR - CEP: 85.801-900 - FONE: (45) 3392-5069 - E-MAIL: CAS-17VJ-S@TJPR.JUS.BR CLASSE PROCESSUAL: PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL ASSUNTO PRINCIPAL: ATO / NEGOCIO JURIDICO PROCESSO N: 0028188-21.2020.8.16.0021 POLO ATIVO(S): MARCELO JORGE CORREA POLO PASSIVO(S): FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA STARK BANK S.A. VISTOS. 1. ATENDA-SE, COM URGENCIA, AO REQUERIDO PELO 2 JUIZADO ESPECIAL CIVEL DE JOINVILLE/SC (OFICIO DE REF. 53.1), OFICIANDO-SE EM RESPOSTA. 2. CASO NENHUM VALOR TENHA SIDO BLOQUEADO NESTE PROCESSO, OFICIE-SE AO JUIZO EM QUESTAO COMUNICANDO O FATO, INDEPENDENTEMENTE DE NOVA CONCLUSAO. 3. APOS, RETORNE AO ARQUIVO. DILIGENCIAS NECESSARIAS. CASCAVEL, DATADO ELETRONICAMENTE. JAQUELINE ALLIEVI JUIZA DE DIREITO DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJYWG PPPCY 4DBSC TYU9U",
                "PublishDate": "2021-01-30T00:00:00",
                "CaptureDate": "2023-05-06T17:24:30"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO RESPONSAVEL: JAQUELINE ALLIEVI",
                "PublishDate": "2021-01-29T00:00:00",
                "CaptureDate": "2023-05-06T17:24:44"
              },
              {
                "Content": "JUNTADA DE OFICIO DE OUTROS ORGAOS",
                "PublishDate": "2021-01-29T00:00:00",
                "CaptureDate": "2023-05-06T17:24:44"
              },
              {
                "Content": "PROCESSO REATIVADO",
                "PublishDate": "2021-01-29T00:00:00",
                "CaptureDate": "2023-05-06T17:24:44"
              },
              {
                "Content": "ARQUIVADO DEFINITIVAMENTE",
                "PublishDate": "2021-01-29T00:00:00",
                "CaptureDate": "2023-05-06T17:24:44"
              },
              {
                "Content": "ATO CUMPRIDO PELA PARTE OU INTERESSADO RENUNCIA DE PRAZO DE MARCELO JORGE CORREA - REFERENTE AO EVENTO INDEFERIDO O PEDIDO (25/01/2021)",
                "PublishDate": "2021-01-28T00:00:00",
                "CaptureDate": "2023-05-06T17:24:44"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA (PELO ADVOGADO/CURADOR/DEFENSOR DE MARCELO JORGE CORREA) EM 28/01/2021 COM PRAZO DE 5 DIAS UTEIS *REFERENTE AO EVENTO (SEQ. 47) INDEFERIDO O PEDIDO (25/01/2021) E AO EVENTO DE EXPEDICAO SEQ. 48.",
                "PublishDate": "2021-01-28T00:00:00",
                "CaptureDate": "2023-05-06T17:24:44"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO PARA ADVOGADOS/CURADOR/DEFENSOR DE MARCELO JORGE CORREA COM PRAZO DE 5 DIAS UTEIS - REFERENTE AO EVENTO (SEQ. 47) INDEFERIDO O PEDIDO (25/01/2021)",
                "PublishDate": "2021-01-28T00:00:00",
                "CaptureDate": "2023-05-06T17:24:44"
              },
              {
                "Content": "INDEFERIDO O PEDIDO PROJUDI - PROCESSO: 0028188-21.2020.8.16.0021 - REF. MOV. 47.1 - ASSINADO DIGITALMENTE POR JAQUELINE ALLIEVI:9260 25/01/2021: INDEFERIDO O PEDIDO. ARQ: DECISAO PODER JUDICIARIO DO ESTADO DO PARANA COMARCA DE CASCAVEL 3 JUIZADO ESPECIAL CIVEL DE CASCAVEL - PROJUDI AVENIDA TANCREDO NEVES, 2320 - FORUM - ALTO ALEGRE - CASCAVEL/PR - CEP: 85.801-900 - FONE: (45) 3392-5069 - E-MAIL: CAS-17VJ-S@TJPR.JUS.BR CLASSE PROCESSUAL: PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL ASSUNTO PRINCIPAL: ATO / NEGOCIO JURIDICO PROCESSO N: 0028188-21.2020.8.16.0021 POLO ATIVO(S): MARCELO JORGE CORREA POLO PASSIVO(S): FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA STARK BANK S.A. VISTOS. INDEFIRO O PEDIDO DE RECONSIDERACAO DE REF. 44.1, POIS NAO PODEM AS PARTES MODIFICAR A COMPETENCIA TERRITORIAL DEPOIS QUE ESTA FOI ESTABELECIDA. INTELIGENCIA DO PRINCIPIO DA PERPETUATIO JURISDICIONIS, O QUAL SE ENCONTRA POSITIVADO NO ARTIGO 43, DO CPC: \"ART. 43. DETERMINA-SE A COMPETENCIA NO MOMENTO DO REGISTRO OU DA DISTRIBUICAO DA PETICAO INICIAL, SENDO IRRELEVANTES AS MODIFICACOES DO ESTADO DE FATO OU DE DIREITO OCORRIDAS POSTERIORMENTE, SALVO QUANDO SUPRIMIREM ORGAO JUDICIARIO OU ALTERAREM A COMPETENCIA ABSOLUTA.\". OU SEJA, A MUDANCA DE DOMICILIO DAS PARTES NAO IMPLICA A MODIFICACAO DE COMPETENCIA, NAO SENDO ADMITIDO AO JURISDICIONADO PROPOR E REPROPOR AS CAUSAS TANTAS VEZES QUANTAS SE MUDE. CUMPRIDA A DECISAO DE REF. 31.1, PROCEDAM-SE AS BAIXAS E AO ARQUIVAMENTO. INTIME-SE O AUTOR. CASCAVEL-PR, DATADO ELETRONICAMENTE. DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJLNY WU2KW FDR27 GJKQA JAQUELINE ALLIEVI JUIZA DE DIREITO",
                "PublishDate": "2021-01-25T00:00:00",
                "CaptureDate": "2023-05-06T17:24:44"
              },
              {
                "Content": "CONCLUSOS PARA SENTENCA RESPONSAVEL: JAQUELINE ALLIEVI",
                "PublishDate": "2021-01-25T00:00:00",
                "CaptureDate": "2023-05-06T17:25:00"
              },
              {
                "Content": "JUNTADA DE CERTIDAO",
                "PublishDate": "2020-12-18T00:00:00",
                "CaptureDate": "2023-05-06T17:25:00"
              },
              {
                "Content": "JUNTADA DE PETICAO DE MANIFESTACAO DA PARTE CUMPRIMENTO DE INTIMACAO - REFERENTE AO EVENTO DECLARADA INCOMPETENCIA (20/10/2020)",
                "PublishDate": "2020-11-11T00:00:00",
                "CaptureDate": "2023-05-06T17:25:00"
              },
              {
                "Content": "JUNTADA DE PETICAO DE IMPUGNACAO A CONTESTACAO CUMPRIMENTO DE INTIMACAO - REFERENTE AO EVENTO JUNTADA DE PETICAO DE CONTESTACAO (06/10/2020)",
                "PublishDate": "2020-11-10T00:00:00",
                "CaptureDate": "2023-05-06T17:25:00"
              },
              {
                "Content": "ATO CUMPRIDO PELA PARTE OU INTERESSADO LEITURA DE INTIMACAO REALIZADA - (PELO ADVOGADO/CURADOR/DEFENSOR DE MARCELO JORGE CORREA) EM 04/11/2020 COM PRAZO DE 5 DIAS UTEIS *REFERENTE AO EVENTO (SEQ. 32) DECLARADA INCOMPETENCIA (20/10/2020) E AO EVENTO DE EXPEDICAO SEQ. 34.",
                "PublishDate": "2020-11-02T00:00:00",
                "CaptureDate": "2023-05-06T17:25:00"
              },
              {
                "Content": "RECEBIDOS OS AUTOS RECEBIDO DO(A) DISTRIBUIDOR",
                "PublishDate": "2020-10-29T00:00:00",
                "CaptureDate": "2023-05-06T17:25:00"
              },
              {
                "Content": "JUNTADA DE ANOTACAO DE BAIXA DEFINITIVA",
                "PublishDate": "2020-10-29T00:00:00",
                "CaptureDate": "2023-05-06T17:25:00"
              },
              {
                "Content": "ATO CUMPRIDO PELA PARTE OU INTERESSADO RENUNCIA DE PRAZO DE STARK BANK S.A. - REFERENTE AO EVENTO DECLARADA INCOMPETENCIA (20/10/2020)",
                "PublishDate": "2020-10-24T00:00:00",
                "CaptureDate": "2023-05-06T17:25:00"
              },
              {
                "Content": "ATO CUMPRIDO PELA PARTE OU INTERESSADO LEITURA DE INTIMACAO REALIZADA - (PELO ADVOGADO/CURADOR/DEFENSOR DE STARK BANK S.A.) EM 26/10/2020 COM PRAZO DE 5 DIAS UTEIS *REFERENTE AO EVENTO (SEQ. 32) DECLARADA INCOMPETENCIA (20/10/2020) E AO EVENTO DE EXPEDICAO SEQ. 33.",
                "PublishDate": "2020-10-24T00:00:00",
                "CaptureDate": "2023-05-06T17:25:00"
              },
              {
                "Content": "REMETIDOS OS AUTOS PARA DISTRIBUIDOR BAIXA",
                "PublishDate": "2020-10-23T00:00:00",
                "CaptureDate": "2023-05-06T17:25:00"
              },
              {
                "Content": "JUNTADA DE CERTIDAO",
                "PublishDate": "2020-10-23T00:00:00",
                "CaptureDate": "2023-05-06T17:25:00"
              },
              {
                "Content": "JUNTADA DE INFORMACAO",
                "PublishDate": "2020-10-23T00:00:00",
                "CaptureDate": "2023-05-06T17:25:00"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO PARA ADVOGADOS/CURADOR/DEFENSOR DE MARCELO JORGE CORREA COM PRAZO DE 5 DIAS UTEIS - REFERENTE AO EVENTO (SEQ. 32) DECLARADA INCOMPETENCIA (20/10/2020)",
                "PublishDate": "2020-10-22T00:00:00",
                "CaptureDate": "2023-05-06T17:25:00"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO PARA ADVOGADOS/CURADOR/DEFENSOR DE STARK BANK S.A. COM PRAZO DE 5 DIAS UTEIS - REFERENTE AO EVENTO (SEQ. 32) DECLARADA INCOMPETENCIA (20/10/2020)",
                "PublishDate": "2020-10-22T00:00:00",
                "CaptureDate": "2023-05-06T17:25:00"
              },
              {
                "Content": "DECLARADA INCOMPETENCIA PROJUDI - PROCESSO: 0028188-21.2020.8.16.0021 - REF. MOV. 32.1 - ASSINADO DIGITALMENTE POR JAQUELINE ALLIEVI:9260 20/10/2020: DECLARADA INCOMPETENCIA. ARQ: DECISAO PODER JUDICIARIO DO ESTADO DO PARANA COMARCA DE CASCAVEL 3 JUIZADO ESPECIAL CIVEL DE CASCAVEL - PROJUDI AVENIDA TANCREDO NEVES, 2320 - FORUM - ALTO ALEGRE - CASCAVEL/PR - CEP: 85.801-900 - FONE: (45) 3392-5069 - E-MAIL: CAS-17VJ-S@TJPR.JUS.BR CLASSE PROCESSUAL: PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL ASSUNTO PRINCIPAL: ATO / NEGOCIO JURIDICO PROCESSO N: 0028188-21.2020.8.16.0021 POLO ATIVO(S): MARCELO JORGE CORREA POLO PASSIVO(S): FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA STARK BANK S.A. VISTOS. 1. DIANTE DO COMPARECIMENTO ESPONTANEO (ART. 239, 1, DO CODIGO DE PROCESSO CIVIL), DOU POR CITADA A RE STARK BANK S/A. ANOTE-SE NOS AUTOS. 2. O FEITO VEIO CONCLUSO EM RAZAO DO PEDIDO DE RECONSIDERACAO FORMULADO PELA RECLAMADA STARK (REF. 18.1 A 18.16). ALEM DO PEDIDO DE REVOGACAO DA TUTELA PROVISORIA, A DEMANDADA NOTICIOU O FATO DE A PRESENTE DEMANDA SER IDENTICA REPETICAO DE OUTRA AJUIZADA PERANTE O 2 JUIZADO ESPECIAL CIVEL DA COMARCA DE JOINVILLE/SC (N 5027447-17.2020.8.24.0038), A QUAL FOI EXTINTA SEM RESOLUCAO DE MERITO POR DESISTENCIA. TAL FATO FOI DEMONSTRADO POR MEIO DOS DOCUMENTOS DE REF. 18.2, CUJAS DECISOES CONFIRMEI A AUTENTICIDADE (P. 18, 19 E 22). O AUTOR, POR SUA VEZ, NENHUMA LINHA DISCORREU A ESSE RESPEITO (REF. 28.1). POIS BEM. DE ACORDO COM O ARTIGO 286, INCISO II, DO CODIGO DE PROCESSO CIVIL, SERAO DISTRIBUIDAS POR DEPENDENCIA  QUANDO, TENDO SIDO EXTINTO O PROCESSO SEM RESOLUCAO DE MERITO, FOR REITERADO O PEDIDO, AINDA QUE EM LITISCONSORCIO COM OUTROS AUTORES OU QUE SEJAM PARCIALMENTE ALTERADOS OS REUS DA DEMANDA. DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJ6HS ZZDAQ TWFUT CFNVU SENDO ASSIM, DECLINO A COMPETENCIA EM FAVOR DO 2 JUIZADO ESPECIAL CIVEL DA COMARCA DE JOINVILLE/SC, A FIM DE QUE O PROCESSO SEJA DISTRIBUIDO POR DEPENDENCIA AOS AUTOS N 5027447-17.2020.8.24.0038. QUANTO A TUTELA PROVISORIA DEFERIDA NESTE PROCESSO, E DE SE APLICAR ANALOGICAMENTE O CONTIDO NO ARTIGO 64, 4, DO CODIGO DE PROCESSO CIVIL, ISTO E, CONSERVARA OS SEUS EFEITOS ATE QUE OUTRA SEJA PROFERIDA, SE FOR O CASO, PELO JUIZO COMPETENTE. 3. DETERMINO A REMESSA ELETRONICA DO PROCESSO AQUELE JUIZO (VIA MALOTE DIGITAL), COM A COMUNICACAO AO DISTRIBUIDOR, PARA AS ANOTACOES PERTINENTES. DILIGENCIAS NECESSARIAS. CASCAVEL, DATADO ELETRONICAMENTE. JAQUELINE ALLIEVI JUIZA DE DIREITO",
                "PublishDate": "2020-10-20T00:00:00",
                "CaptureDate": "2023-05-06T17:25:00"
              },
              {
                "Content": "ATO CUMPRIDO PELA PARTE OU INTERESSADO LEITURA DE INTIMACAO REALIZADA - (PELO ADVOGADO/CURADOR/DEFENSOR DE MARCELO JORGE CORREA) EM 16/10/2020 COM PRAZO DE 15 DIAS UTEIS *REFERENTE AO EVENTO (SEQ. 26) JUNTADA DE PETICAO DE CONTESTACAO (06/10/2020) E AO EVENTO DE EXPEDICAO SEQ. 27.",
                "PublishDate": "2020-10-17T00:00:00",
                "CaptureDate": "2023-05-06T17:25:16"
              },
              {
                "Content": "JUNTADA DE PETICAO DE MANIFESTACAO DA PARTE",
                "PublishDate": "2020-10-15T00:00:00",
                "CaptureDate": "2023-05-06T17:25:16"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO RESPONSAVEL: JAQUELINE ALLIEVI",
                "PublishDate": "2020-10-09T00:00:00",
                "CaptureDate": "2023-05-06T17:25:16"
              },
              {
                "Content": "JUNTADA DE PETICAO DE MANIFESTACAO DA PARTE CUMPRIMENTO DE INTIMACAO - REFERENTE AO EVENTO JUNTADA DE PETICAO DE APRESENTACAO DE RESPOSTA A ACUSACAO E/OU DEFESA PRELIMINAR (20/09/2020)",
                "PublishDate": "2020-10-08T00:00:00",
                "CaptureDate": "2023-05-06T17:25:16"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO PARA ADVOGADOS/CURADOR/DEFENSOR DE MARCELO JORGE CORREA COM PRAZO DE 15 DIAS UTEIS - REFERENTE AO EVENTO (SEQ. 26) JUNTADA DE PETICAO DE CONTESTACAO (06/10/2020)",
                "PublishDate": "2020-10-06T00:00:00",
                "CaptureDate": "2023-05-06T17:25:16"
              },
              {
                "Content": "JUNTADA DE PETICAO DE CONTESTACAO",
                "PublishDate": "2020-10-06T00:00:00",
                "CaptureDate": "2023-05-06T17:25:16"
              },
              {
                "Content": "ATO CUMPRIDO PELA PARTE OU INTERESSADO LEITURA DE INTIMACAO REALIZADA - (PELO ADVOGADO/CURADOR/DEFENSOR DE MARCELO JORGE CORREA) EM 01/10/2020 COM PRAZO DE 5 DIAS UTEIS *REFERENTE AO EVENTO (SEQ. 18) JUNTADA DE PETICAO DE APRESENTACAO DE RESPOSTA A ACUSACAO E/OU DEFESA PRELIMINAR (20/09/2020) E AO EVENTO DE EXPEDICAO SEQ. 19.",
                "PublishDate": "2020-10-02T00:00:00",
                "CaptureDate": "2023-05-06T17:25:16"
              },
              {
                "Content": "JUNTADA DE CERTIDAO",
                "PublishDate": "2020-09-23T00:00:00",
                "CaptureDate": "2023-05-06T17:25:16"
              },
              {
                "Content": "ATO CUMPRIDO PELA PARTE OU INTERESSADO RENUNCIA DE PRAZO DE MARCELO JORGE CORREA - REFERENTE AO EVENTO CONCEDIDA EM PARTE A ANTECIPACAO DE TUTELA (10/09/2020)",
                "PublishDate": "2020-09-22T00:00:00",
                "CaptureDate": "2023-05-06T17:25:16"
              },
              {
                "Content": "ATO CUMPRIDO PELA PARTE OU INTERESSADO LEITURA DE INTIMACAO REALIZADA - (PELO ADVOGADO/CURADOR/DEFENSOR DE MARCELO JORGE CORREA) EM 21/09/2020 COM PRAZO DE 5 DIAS UTEIS *REFERENTE AO EVENTO (SEQ. 13) CONCEDIDA EM PARTE A ANTECIPACAO DE TUTELA (10/09/2020) E AO EVENTO DE EXPEDICAO SEQ. 14.",
                "PublishDate": "2020-09-22T00:00:00",
                "CaptureDate": "2023-05-06T17:25:16"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE PROJUDI - PROCESSO: 0028188-21.2020.8.16.0021 - REF. MOV. 21.1 - ASSINADO DIGITALMENTE POR JAQUELINE ALLIEVI:9260 21/09/2020: PROFERIDO DESPACHO DE MERO EXPEDIENTE. ARQ: DESPACHO PODER JUDICIARIO DO ESTADO DO PARANA COMARCA DE CASCAVEL 3 JUIZADO ESPECIAL CIVEL DE CASCAVEL - PROJUDI AVENIDA TANCREDO NEVES, 2320 - FORUM - ALTO ALEGRE - CASCAVEL/PR - CEP: 85.801-900 - FONE: (45) 3392-5069 - E-MAIL: CAS-17VJ-S@TJPR.JUS.BR CLASSE PROCESSUAL: PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL ASSUNTO PRINCIPAL: ATO / NEGOCIO JURIDICO PROCESSO N: 0028188-21.2020.8.16.0021 POLO ATIVO(S): MARCELO JORGE CORREA POLO PASSIVO(S): FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA STARK BANK S.A. VISTOS. 1. AGUARDE-SE EM CARTORIO PELA MANIFESTACAO DO AUTOR OU PELO DECURSO DO PRAZO. 2. APOS, CONCLUSOS COMO \"DECISAO\". DILIGENCIAS NECESSARIAS. CASCAVEL, DATADO ELETRONICAMENTE. JAQUELINE ALLIEVI JUIZA DE DIREITO DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJTZ7 A7Z45 VQ7KW 88VRD",
                "PublishDate": "2020-09-21T00:00:00",
                "CaptureDate": "2023-05-06T17:25:16"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO - LIMINAR RESPONSAVEL: JAQUELINE ALLIEVI",
                "PublishDate": "2020-09-21T00:00:00",
                "CaptureDate": "2023-05-06T17:25:29"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO PARA ADVOGADOS/CURADOR/DEFENSOR DE MARCELO JORGE CORREA COM PRAZO DE 5 DIAS UTEIS - REFERENTE AO EVENTO (SEQ. 18) JUNTADA DE PETICAO DE APRESENTACAO DE RESPOSTA A ACUSACAO E/OU DEFESA PRELIMINAR (20/09/2020)",
                "PublishDate": "2020-09-21T00:00:00",
                "CaptureDate": "2023-05-06T17:25:29"
              },
              {
                "Content": "JUNTADA DE PETICAO DE APRESENTACAO DE RESPOSTA A ACUSACAO E/OU DEFESA PRELIMINAR",
                "PublishDate": "2020-09-20T00:00:00",
                "CaptureDate": "2023-05-06T17:25:29"
              },
              {
                "Content": "JUNTADA DE CUMPRIMENTO DE DILIGENCIA",
                "PublishDate": "2020-09-16T00:00:00",
                "CaptureDate": "2023-05-06T17:25:29"
              },
              {
                "Content": "EXPEDICAO DE OFICIO REFERENTE AO EVENTO (SEQ. 13) CONCEDIDA EM PARTE A ANTECIPACAO DE TUTELA(10/09/2020 20:25:40). IDENTIFICADOR DO CUMPRIMENTO: 0001 PROJUDI - PROCESSO: 0028188-21.2020.8.16.0021 - REF. MOV. 16.1 - ASSINADO DIGITALMENTE POR JAQUELINE ALLIEVI:9260 11/09/2020: EXPEDICAO DE OFICIO. ARQ: OFICIO 3 JUIZADO ESPECIAL CIVEL COMARCA DE CASCAVEL- ESTADO DO PARANA OF. 336/2020 CASCAVEL, 11 DE SETEMBRO DE 2020. SENHOR PRESIDENTE: A FIM DE INSTRUIR OS AUTOS N 0028188- 21.2020.8.16.0021, EM QUE E REQUERENTE MARCELO JORGE CORREA, E REQUERIDOS FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA. E OUTROS, DETERMINO O BLOQUEIO DAS CONTAS BANCARIAS DOS RECLAMADOS: - FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA. - CNPJ N. 21.160.553/0001-81; - FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA. - CNPJ N. 10.685.786/0001-81, E - STARK BANK S.A - CNPJ N. 20.018.183/0001-80, PERANTE O SISTEMA BACENJUD, DO VALOR BRUTO INVESTIDO PELO AUTOR, EQUIVALENTE A R$ 36.000,00 (TRINTA E SEIS MIL REAIS). A OPORTUNIDADE E PROPICIA PARA RENOVAR A VOSSA SENHORIA PROTESTOS DE ELEVADA ESTIMA E CONSIDERACAO. DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJSDT LU4JW 2KQ5N XLWEU JAQUELINE ALLIEVI JUIZA DE DIREITO AO SR. PRESIDENTE DO BANCO CENTRAL DO BRASIL SETOR BANCARIO SUL (SBS) QUADRA 3 BLOCO B - ED. SEDE BRASILIA - DF CEP: 70074-900 AASD",
                "PublishDate": "2020-09-11T00:00:00",
                "CaptureDate": "2023-05-06T17:25:29"
              },
              {
                "Content": "JUNTADA DE CERTIDAO",
                "PublishDate": "2020-09-11T00:00:00",
                "CaptureDate": "2023-05-06T17:25:44"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO PARA ADVOGADOS/CURADOR/DEFENSOR DE MARCELO JORGE CORREA COM PRAZO DE 5 DIAS UTEIS - REFERENTE AO EVENTO (SEQ. 13) CONCEDIDA EM PARTE A ANTECIPACAO DE TUTELA (10/09/2020)",
                "PublishDate": "2020-09-11T00:00:00",
                "CaptureDate": "2023-05-06T17:25:44"
              },
              {
                "Content": "CONCEDIDA EM PARTE A ANTECIPACAO DE TUTELA PROJUDI - PROCESSO: 0028188-21.2020.8.16.0021 - REF. MOV. 13.1 - ASSINADO DIGITALMENTE POR JAQUELINE ALLIEVI:9260 10/09/2020: CONCEDIDA EM PARTE A ANTECIPACAO DE TUTELA. ARQ: DECISAO PODER JUDICIARIO DO ESTADO DO PARANA COMARCA DE CASCAVEL 3 JUIZADO ESPECIAL CIVEL DE CASCAVEL - PROJUDI AVENIDA TANCREDO NEVES, 2320 - FORUM - ALTO ALEGRE - CASCAVEL/PR - CEP: 85.801-900 - FONE: (45) 98803-6179 - E-MAIL: CAS-17VJ-S@TJPR.JUS.BR CLASSE PROCESSUAL: PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL ASSUNTO PRINCIPAL: ATO / NEGOCIO JURIDICO PROCESSO N: 0028188-21.2020.8.16.0021 POLO ATIVO(S): MARCELO JORGE CORREA POLO PASSIVO(S): FORTS CONSULTORIA E TECNOLOGIA EM FINANCAS LTDA FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA STARK BANK S.A. VISTOS. TRATA-SE DE ACAO DECLARATORIA DE ANULACAO DE NEGOCIO JURIDICO C.C. RESTITUICAO DE VALORES. OS AUTOS VIERAM CONCLUSOS EM RAZAO DO PEDIDO DE CONCESSAO DE TUTELA DE URGENCIA. DECIDO 1. O ARTIGO 300, CAPUT, DO CODIGO DE PROCESSO CIVIL, ESTABELECE QUE OS REQUISITOS GERAIS PARA A CONCESSAO DE TUTELA PROVISORIA DE URGENCIA SAO: A) A PROBABILIDADE DO DIREITO (FUMUS BONI IURIS); E, B) O PERIGO DE DANO OU RISCO AO RESULTADO UTIL DO PROCESSO (PERICULUM IN MORA). NO PRESENTE CASO, O AUTOR REQUEREU A CONCESSAO DE TUTELA DE URGENCIA DE NATUREZA CAUTELAR, A FIM DE SER DETERMINADO O BLOQUEIO IMEDIATO DE BENS E VALORES DOS REUS. POIS BEM. OS RELATOS FATICOS E OS DOCUMENTOS QUE INSTRUEM A INICIAL DEMONSTRAM A PROBABILIDADE DO DIREITO DO RECLAMANTE, BEM COMO A EXISTENCIA DE PERIGO DE RISCO AO RESULTADO UTIL DO PROCESSO, POIS DAO CONTA DA CONCRETA POSSIBILIDADE DE O POSTULANTE TER SIDO VITIMA DE UMA PIRAMIDE FINANCEIRA. POR OUTRO LADO, O DEFERIMENTO DO PEDIDO LIMINAR NAO TEM CARATER IRREVERSIVEL, POIS O DINHEIRO EVENTUALMENTE BLOQUEADO DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJXDE HF32M 9NS78 PGQT3 PERMANECERA DEPOSITADO NESTE PROCESSO ATE O SEU DESFECHO, PODENDO SER DEVOLVIDO A QUALQUER TEMPO, CASO HAJA ALTERACAO FATICA E/OU JURIDICA. PORQUE PRESENTES OS REQUISITOS DO ARTIGO 300, DO CODIGO DE PROCESSO CIVIL, CONCEDO PARCIALMENTE A TUTELA DE URGENCIA DE NATUREZA CAUTELAR E DETERMINO O BLOQUEIO DAS CONTAS BANCARIAS DOS RECLAMADOS, PERANTE O SISTEMA BACENJUD, DO VALOR BRUTO INVESTIDO PELO AUTOR (R$ 36.000,00). A FIM DE EVITAR EXCESSOS E TENDO EM VISTA A FASE EMBRIONARIA DA LIDE, INDEFIRO TODAS AS DEMAIS DILIGENCIAS EXPROPRIATORIAS REQUERIDAS. 2. CITEM-SE/INTIMEM-SE AS PARTES, CONFORME PORTARIA CONJUNTA DOS JUIZADOS DA COMARCA N 01/2020. DILIGENCIAS NECESSARIAS. CASCAVEL, DATADO ELETRONICAMENTE. JAQUELINE ALLIEVI JUIZA DE DIREITO",
                "PublishDate": "2020-09-10T00:00:00",
                "CaptureDate": "2023-05-06T17:25:44"
              },
              {
                "Content": "RECEBIDOS OS AUTOS RECEBIDO DO(A) DISTRIBUIDOR",
                "PublishDate": "2020-09-10T00:00:00",
                "CaptureDate": "2023-05-06T17:25:59"
              },
              {
                "Content": "JUNTADA DE ANOTACAO DE DISTRIBUICAO",
                "PublishDate": "2020-09-10T00:00:00",
                "CaptureDate": "2023-05-06T17:25:59"
              },
              {
                "Content": "ATO CUMPRIDO PELA PARTE OU INTERESSADO RENUNCIA DE PRAZO DE MARCELO JORGE CORREA - REFERENTE AO EVENTO JUNTADA DE CERTIDAO (10/09/2020)",
                "PublishDate": "2020-09-10T00:00:00",
                "CaptureDate": "2023-05-06T17:25:59"
              },
              {
                "Content": "ATO CUMPRIDO PELA PARTE OU INTERESSADO LEITURA DE INTIMACAO REALIZADA - (PELO ADVOGADO/CURADOR/DEFENSOR DE MARCELO JORGE CORREA) EM 10/09/2020 COM PRAZO DE 5 DIAS UTEIS *REFERENTE AO EVENTO (SEQ. 5) JUNTADA DE CERTIDAO (10/09/2020) E AO EVENTO DE EXPEDICAO SEQ. 6.",
                "PublishDate": "2020-09-10T00:00:00",
                "CaptureDate": "2023-05-06T17:25:59"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO - LIMINAR RESPONSAVEL: JAQUELINE ALLIEVI",
                "PublishDate": "2020-09-10T00:00:00",
                "CaptureDate": "2023-05-06T17:25:59"
              },
              {
                "Content": "JUNTADA DE CERTIDAO",
                "PublishDate": "2020-09-10T00:00:00",
                "CaptureDate": "2023-05-06T17:25:59"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO PARA ADVOGADOS/CURADOR/DEFENSOR DE MARCELO JORGE CORREA COM PRAZO DE 5 DIAS UTEIS - REFERENTE AO EVENTO (SEQ. 5) JUNTADA DE CERTIDAO (10/09/2020)",
                "PublishDate": "2020-09-10T00:00:00",
                "CaptureDate": "2023-05-06T17:25:59"
              },
              {
                "Content": "JUNTADA DE CERTIDAO",
                "PublishDate": "2020-09-10T00:00:00",
                "CaptureDate": "2023-05-06T17:25:59"
              },
              {
                "Content": "RECEBIDOS OS AUTOS",
                "PublishDate": "2020-09-09T00:00:00",
                "CaptureDate": "2023-05-06T17:25:59"
              },
              {
                "Content": "REMETIDOS OS AUTOS PARA DISTRIBUIDOR REGISTRO DE DISTRIBUICAO",
                "PublishDate": "2020-09-09T00:00:00",
                "CaptureDate": "2023-05-06T17:25:59"
              },
              {
                "Content": "DISTRIBUIDO POR SORTEIO 3 JUIZADO ESPECIAL CIVEL DE CASCAVEL",
                "PublishDate": "2020-09-09T00:00:00",
                "CaptureDate": "2023-05-06T17:25:59"
              },
              {
                "Content": "JUNTADA DE PETICAO DE INICIAL",
                "PublishDate": "2020-09-09T00:00:00",
                "CaptureDate": "2023-05-06T17:25:59"
              }
            ],
            "Petitions": [],
            "Decisions": [
              {
                "DecisionContent": "DECIDO 1.",
                "DecisionDate": "2020-09-10T00:00:00"
              }
            ]
          },
          {
            "Number": "10054854720238260037",
            "Type": "PROCEDIMENTO COMUM",
            "MainSubject": "BANCARIOS",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "ARARAQUARA",
            "Judge": "PAULO LUIS APARECIDO TREVISO",
            "JudgingBody": "3 VARA CIVEL",
            "State": "SP",
            "Status": "INDEFINIDO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "BANCÁRIOS",
            "InferredCNJSubjectNumber": 7752,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "BANCARIOS",
              "CREDITO DIRETO AO CONSUMIDOR - CDC"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 21728,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-05-09T00:00:00",
            "NoticeDate": "2023-05-04T00:00:00",
            "LastMovementDate": "2023-05-10T00:00:00",
            "CaptureDate": "2023-05-11T02:40:48",
            "LastUpdate": "2023-05-11T02:40:48",
            "NumberOfParties": 6,
            "NumberOfUpdates": 9,
            "LawSuitAge": 300,
            "AverageNumberOfUpdatesPerMonth": 0,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "03209063885",
                "IsPartyActive": true,
                "Name": "PAULO LUIS APARECIDO TREVISO",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-05-11T02:40:48"
              },
              {
                "Doc": "45925182847",
                "IsPartyActive": true,
                "Name": "ALINE EDUARDA FREIRE DA SILVA",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-05-11T02:40:48"
              },
              {
                "IsPartyActive": true,
                "Name": "VINICIUS GUILHERME ANDRADE",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "471919",
                  "State": "SP",
                  "SpecificType": "ADVOGADO (REQTE)"
                },
                "LastCaptureDate": "2023-05-11T02:40:48"
              },
              {
                "Doc": "46254387808",
                "IsPartyActive": true,
                "Name": "JOSE APARECIDO BARTOLOMEU JUNIOR",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "486655",
                  "State": "SP",
                  "SpecificType": "ADVOGADO (REQTE)"
                },
                "LastCaptureDate": "2023-05-11T02:40:48"
              },
              {
                "IsPartyActive": true,
                "Name": "C6BANK",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-05-11T02:40:48"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-05-11T02:40:48"
              }
            ],
            "Updates": [
              {
                "Content": "NAO CONCEDIDA A ASSISTENCIA JUDICIARIA GRATUITA VISTOS. A AUTORA NAO OSTENTA A INSUFICIENCIA DE RECURSOS EXIGIDA PELA LEI QUE AUTORIZA A CONCESSAO DA GRATUIDADE DE JUSTICA POR ELA PLEITEADA, SOBRETUDO DIANTE DO TEOR DOS EXTRATOS DE FLS. 87/89, DO QUAL SE EXTRAI A EXISTENCIA DE MOVIMENTACOES FINANCEIRAS DE VALORES CONSIDERAVEIS, SUFICIENTES PARA CONTRADIZER A ALEGADA POBREZA, COMO POR EXEMPLO O RECEBIMENTO DE UM CREDITO DA IMPORTANCIA DE R$ 4.900,00 NO DIA 29/03/2023. A RESPEITO, CUMPRE REGISTRAR QUE O VALOR RETRO REFERIDO E ORIUNDO DE OUTRA CONTA MANTIDA PELA PROPRIA AUTORA, CUJA EXISTENCIA E EXTRATOS FORAM SONEGADOS PELA PARTE, EM QUE PESE TENHA SIDO DETERMINADO A REQUERENTE QUE PROMOVESSE A JUNTADA DOS EXTRATOS DE TODAS AS SUAS CONTAS BANCARIAS (FLS. 83). SE ISTO NAO FOSSE SUFICIENTE, DA NARRATIVA DA INICIAL SE CONSTATA QUE A DEMANDANTE PROMOVEU A TRANSFERENCIA DE VALOR SUPERIOR A R$ 11.000,00 PARA AQUISICAO DE UM PACOTE DE VIAGENS, DAI QUE CERTAMENTE NAO E POBRE, NA ACEPCAO JURIDICA DO TERMO. INDEFIRO, POIS, A GRATUIDADE DE JUSTICA A AUTORA, E A ELA CONCEDO O PRAZO DE 10 DIAS PARA O RECOLHIMENTO DAS CUSTAS INICIAIS, SOB PENA DE EXTINCAO DO PROCESSO. INTIME-SE.",
                "PublishDate": "2023-05-10T00:00:00",
                "CaptureDate": "2023-05-11T02:40:49"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0391/2023 DATA DA PUBLICACAO: 10/05/2023 NUMERO DO DIARIO: 3732",
                "PublishDate": "2023-05-09T00:00:00",
                "CaptureDate": "2023-05-11T02:40:49"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WARQ.23.70072009-2 TIPO DA PETICAO: PEDIDO DE ASSISTENCIA JUDICIARIA GRATUITA DATA: 09/05/2023 11:04",
                "PublishDate": "2023-05-09T00:00:00",
                "CaptureDate": "2023-05-11T02:40:49"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2023-05-09T00:00:00",
                "CaptureDate": "2023-05-11T02:40:49"
              },
              {
                "Content": "PROCESSO 1005485-47.2023.8.26.0037 - PROCEDIMENTO COMUM CIVEL - BANCARIOS - ALINE EDUARDA FREIRE DA SILVA - PARA QUE O PEDIDO DE ASSISTENCIA JUDICIARIA GRATUITA SEJA ANALISADO, TRAGA A AUTORA, EM 10 DIAS, OS EXTRATOS BANCARIOS DE TODAS AS MOVIMENTACOES QUE POSSUI (CONTA CORRENTE, POUPANCA, APLICACOES FINANCEIRAS, CARTOES DE CREDITO ETC) DOS ULTIMOS TRES MESES. APOS, RETORNEM. INT. - ADV: VINICIUS GUILHERME ANDRADE (OAB 471919/SP), JOSE APARECIDO BARTOLOMEU JUNIOR (OAB 486655/SP)",
                "PublishDate": "2023-05-09T00:00:00",
                "CaptureDate": "2023-05-11T02:40:48"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE PARA QUE O PEDIDO DE ASSISTENCIA JUDICIARIA GRATUITA SEJA ANALISADO, TRAGA A AUTORA, EM 10 DIAS, OS EXTRATOS BANCARIOS DE TODAS AS MOVIMENTACOES QUE POSSUI (CONTA CORRENTE, POUPANCA, APLICACOES FINANCEIRAS, CARTOES DE CREDITO ETC) DOS ULTIMOS TRES MESES. APOS, RETORNEM. INT.",
                "PublishDate": "2023-05-08T00:00:00",
                "CaptureDate": "2023-05-11T02:40:49"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0391/2023 TEOR DO ATO: PARA QUE O PEDIDO DE ASSISTENCIA JUDICIARIA GRATUITA SEJA ANALISADO, TRAGA A AUTORA, EM 10 DIAS, OS EXTRATOS BANCARIOS DE TODAS AS MOVIMENTACOES QUE POSSUI (CONTA CORRENTE, POUPANCA, APLICACOES FINANCEIRAS, CARTOES DE CREDITO ETC) DOS ULTIMOS TRES MESES. APOS, RETORNEM. INT. ADVOGADOS(S): VINICIUS GUILHERME ANDRADE (OAB 471919/SP), JOSE APARECIDO BARTOLOMEU JUNIOR (OAB 486655/SP)",
                "PublishDate": "2023-05-08T00:00:00",
                "CaptureDate": "2023-05-11T02:40:49"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2023-05-05T00:00:00",
                "CaptureDate": "2023-05-11T02:40:49"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-05-04T00:00:00",
                "CaptureDate": "2023-05-11T02:40:48"
              }
            ],
            "Petitions": [
              {
                "Type": "PEDIDO DE ASSISTENCIA JUDICIARIA GRATUITA",
                "Author": "",
                "CreationDate": "2023-05-09T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              }
            ],
            "Decisions": []
          },
          {
            "Number": "10021227920238260319",
            "Type": "PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL",
            "MainSubject": "INDENIZACAO POR DANO MATERIAL",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "",
            "CourtDistrict": "LENCOIS PAULISTA",
            "Judge": "NATASHA GABRIELLA AZEVEDO MOTTA",
            "JudgingBody": "JUIZADO ESPECIAL CIVEL E CRIMINAL",
            "State": "SP",
            "Status": "ATIVO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "INDENIZAÇÃO POR DANO MATERIAL",
            "InferredCNJSubjectNumber": 7780,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO DO JUIZADO ESPECIAL CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "INDENIZACAO POR DANO MATERIAL",
              "RESPONSABILIDADE DO FORNECEDOR"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 37163.7,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-05-16T00:00:00",
            "NoticeDate": "2023-05-08T00:00:00",
            "LastMovementDate": "2023-05-16T00:00:00",
            "CaptureDate": "2023-05-17T23:29:02",
            "LastUpdate": "2023-05-17T23:29:02",
            "NumberOfParties": 17,
            "NumberOfUpdates": 6,
            "LawSuitAge": 296,
            "AverageNumberOfUpdatesPerMonth": 0,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "25574358808",
                "IsPartyActive": true,
                "Name": "NATASHA GABRIELLA AZEVEDO MOTTA",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-05-17T23:29:02"
              },
              {
                "Doc": "35348239828",
                "IsPartyActive": true,
                "Name": "SANDRO JUNIOR FRANCISCO",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-05-17T23:29:02"
              },
              {
                "Doc": "04025975165",
                "IsPartyActive": true,
                "Name": "RUAN VICTOR FREIRE RODRIGUES",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "63187",
                  "State": "BA",
                  "SpecificType": "ADVOGADO (REQTE)"
                },
                "LastCaptureDate": "2023-05-17T23:29:02"
              },
              {
                "IsPartyActive": true,
                "Name": "VIA PAGSEGURO INTERNET S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-05-17T23:29:02"
              },
              {
                "Doc": "31531997000130",
                "IsPartyActive": true,
                "Name": "CONPAY INSTITUICAO DE PAGAMENTO E TECNOLOGIA S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-05-17T23:29:02"
              },
              {
                "Doc": "68900810000138",
                "IsPartyActive": true,
                "Name": "BANCO RENDIMENTO S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-05-17T23:29:02"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-05-17T23:29:02"
              },
              {
                "Doc": "51371108846",
                "IsPartyActive": true,
                "Name": "GUSTAVO DA SILVA ITIUBA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-05-17T23:29:02"
              },
              {
                "Doc": "06104373000199",
                "IsPartyActive": true,
                "Name": "GRAN DESIGN MOBILIARIO LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-05-17T23:29:02"
              },
              {
                "Doc": "08871968450",
                "IsPartyActive": true,
                "Name": "GLEISSON HENRIQUE DE LIMA GOMES",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-05-17T23:29:02"
              },
              {
                "IsPartyActive": true,
                "Name": "GUILHERME GOMES",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-05-17T23:29:02"
              },
              {
                "Doc": "24267881863",
                "IsPartyActive": true,
                "Name": "EMERSON XAVIER DO CARMO",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-05-17T23:29:02"
              },
              {
                "Doc": "43451185814",
                "IsPartyActive": true,
                "Name": "RAFAEL WILLIAN FERNANDES DA SILVA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-05-17T23:29:02"
              },
              {
                "Doc": "54650044871",
                "IsPartyActive": true,
                "Name": "VITOR VINICIUS ARAUJO DA SILVA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-05-17T23:29:02"
              },
              {
                "IsPartyActive": true,
                "Name": "THAIS DOS SANTOS BATISTA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDA"
                },
                "LastCaptureDate": "2023-05-17T23:29:02"
              },
              {
                "IsPartyActive": true,
                "Name": "VINICIUS GONCALVES DA SILVA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-05-17T23:29:02"
              },
              {
                "Doc": "34960959894",
                "IsPartyActive": true,
                "Name": "WELLINGTON PEREIRA TEIXEIRA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-05-17T23:29:02"
              }
            ],
            "Updates": [
              {
                "Content": "PROCESSO 1002122-79.2023.8.26.0319 - PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL - INDENIZACAO POR DANO MATERIAL - SANDRO JUNIOR FRANCISCO - VISTOS. PARA ANALISE DO PEDIDO DE TUTELA, EMENDE A PARTE AUTORA A INICIAL, INSTRUINDO OS AUTOS COM OS ENDERECOS DE TODAS AS INSTITUICOES FINANCEIRAS, BEM COMO DAS CONVERSAS QUE AFIRMA TER MANTIDO COM OS SUPOSTOS GOLPISTAS ATRAVES DAS REDES SOCIAIS. PRAZO: 15 (QUINZE) DIAS, SOB PENA DE INDEFERIMENTO DA INICIAL. OPORTUNAMENTE, TORNEM OS AUTOS CONCLUSOS COM URGENCIA. INT. - ADV: RUAN VICTOR FREIRE RODRIGUES (OAB 63187/BA)",
                "PublishDate": "2023-05-16T00:00:00",
                "CaptureDate": "2023-05-17T23:29:02"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0321/2023 TEOR DO ATO: VISTOS. PARA ANALISE DO PEDIDO DE TUTELA, EMENDE A PARTE AUTORA A INICIAL, INSTRUINDO OS AUTOS COM OS ENDERECOS DE TODAS AS INSTITUICOES FINANCEIRAS, BEM COMO DAS CONVERSAS QUE AFIRMA TER MANTIDO COM OS SUPOSTOS GOLPISTAS ATRAVES DAS REDES SOCIAIS. PRAZO: 15 (QUINZE) DIAS, SOB PENA DE INDEFERIMENTO DA INICIAL. OPORTUNAMENTE, TORNEM OS AUTOS CONCLUSOS COM URGENCIA. INT. ADVOGADOS(S): RUAN VICTOR FREIRE RODRIGUES (OAB 63187/BA)",
                "PublishDate": "2023-05-15T00:00:00",
                "CaptureDate": "2023-05-17T23:29:02"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0321/2023 DATA DA PUBLICACAO: 17/05/2023 NUMERO DO DIARIO: 3737",
                "PublishDate": "2023-05-15T00:00:00",
                "CaptureDate": "2023-05-17T23:29:02"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE VISTOS. PARA ANALISE DO PEDIDO DE TUTELA, EMENDE A PARTE AUTORA A INICIAL, INSTRUINDO OS AUTOS COM OS ENDERECOS DE TODAS AS INSTITUICOES FINANCEIRAS, BEM COMO DAS CONVERSAS QUE AFIRMA TER MANTIDO COM OS SUPOSTOS GOLPISTAS ATRAVES DAS REDES SOCIAIS. PRAZO: 15 (QUINZE) DIAS, SOB PENA DE INDEFERIMENTO DA INICIAL. OPORTUNAMENTE, TORNEM OS AUTOS CONCLUSOS COM URGENCIA. INT.",
                "PublishDate": "2023-05-12T00:00:00",
                "CaptureDate": "2023-05-17T23:29:02"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-05-08T00:00:00",
                "CaptureDate": "2023-05-17T23:29:02"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2023-05-08T00:00:00",
                "CaptureDate": "2023-05-17T23:29:02"
              }
            ],
            "Petitions": [],
            "Decisions": []
          },
          {
            "Number": "10082203420238260011",
            "Type": "PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL",
            "MainSubject": "RESPONSABILIDADE DO FORNECEDOR",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "ESPECIAL CIVEL",
            "CourtDistrict": "SAO PAULO",
            "Judge": "CLAUDIA THOME TONI",
            "JudgingBody": "1 VARA DO JUIZADO ESPECIAL CIVEL",
            "State": "SP",
            "Status": "ATIVO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "RESPONSABILIDADE DO FORNECEDOR",
            "InferredCNJSubjectNumber": 6220,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO DO JUIZADO ESPECIAL CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "RESPONSABILIDADE DO FORNECEDOR"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 6677,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-05-26T00:00:00",
            "NoticeDate": "2023-05-24T00:00:00",
            "LastMovementDate": "2023-05-26T00:00:00",
            "CaptureDate": "2023-06-11T10:12:46",
            "LastUpdate": "2023-06-11T10:12:46",
            "NumberOfParties": 4,
            "NumberOfUpdates": 6,
            "LawSuitAge": 280,
            "AverageNumberOfUpdatesPerMonth": 0,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "13054991822",
                "IsPartyActive": true,
                "Name": "CLAUDIA THOME TONI",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-06-11T10:12:46"
              },
              {
                "Doc": "07509019850",
                "IsPartyActive": true,
                "Name": "ZELIA MARIA BARRETO",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-06-11T10:12:46"
              },
              {
                "IsPartyActive": true,
                "Name": "RICARDO ALEXANDRE DE OLIVEIRA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "257273",
                  "State": "SP",
                  "SpecificType": "ADVOGADO (REQTE)"
                },
                "LastCaptureDate": "2023-06-11T10:12:46"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-06-11T10:12:46"
              }
            ],
            "Updates": [
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0379/2023 DATA DA PUBLICACAO: 29/05/2023 NUMERO DO DIARIO: 3745",
                "PublishDate": "2023-05-26T00:00:00",
                "CaptureDate": "2023-06-11T10:12:46"
              },
              {
                "Content": "PROCESSO : 1008220-34.2023.8.26.0011 CLASSE : PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL REQTE : ZELIA MARIA BARRETO ADVOGADO : 257273/SP - RICARDO ALEXANDRE DE OLIVEIRA REQDO : STARK BANK S.A. VARA : 1 VARA DO JUIZADO ESPECIAL CIVEL PROCESSO 1008220-34.2023.8.26.0011 - PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL - RESPONSABILIDADE DO FORNECEDOR - ZELIA MARIA BARRETO - INTIMACAO DA PARTE AUTORA PARA COMPROVAR O ENDERECO RESIDENCIAL ATRAVES DE CONTA DE CONSUMO ATUALIZADA DE SUA TITULARIDADE (AGUA, ENERGIA ELETRICA, TELEFONE FIXO, INTERNET RESIDENCIAL OU GAS), OBSERVANDO QUE FATURAS DE CARTAO DE CREDITO E/ OU CELULARNAOSAO VALIDAS PARA ESSE FIM. PRAZO: DEZ DIAS. - ADV: RICARDO ALEXANDRE DE OLIVEIRA (OAB 257273/SP) JUIZO DE DIREITO DA 1 VARA DO JUIZADO ESPECIAL CIVEL EDITAL DE INTIMACAO DE ADVOGADOS RELACAO N 0380/2023",
                "PublishDate": "2023-05-26T00:00:00",
                "CaptureDate": "2023-06-11T10:12:46"
              },
              {
                "Content": "ATO ORDINATORIO - INTIMACAO - DJE INTIMACAO DA PARTE AUTORA PARA COMPROVAR O ENDERECO RESIDENCIAL ATRAVES DE CONTA DE CONSUMO ATUALIZADA DE SUA TITULARIDADE (AGUA, ENERGIA ELETRICA, TELEFONE FIXO, INTERNET RESIDENCIAL OU GAS), OBSERVANDO QUE FATURAS DE CARTAO DE CREDITO E/OU CELULARNAOSAO VALIDAS PARA ESSE FIM. PRAZO: DEZ DIAS.",
                "PublishDate": "2023-05-25T00:00:00",
                "CaptureDate": "2023-06-11T10:12:46"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0379/2023 TEOR DO ATO: INTIMACAO DA PARTE AUTORA PARA COMPROVAR O ENDERECO RESIDENCIAL ATRAVES DE CONTA DE CONSUMO ATUALIZADA DE SUA TITULARIDADE (AGUA, ENERGIA ELETRICA, TELEFONE FIXO, INTERNET RESIDENCIAL OU GAS), OBSERVANDO QUE FATURAS DE CARTAO DE CREDITO E/OU CELULARNAOSAO VALIDAS PARA ESSE FIM. PRAZO: DEZ DIAS. ADVOGADOS(S): RICARDO ALEXANDRE DE OLIVEIRA (OAB 257273/SP)",
                "PublishDate": "2023-05-25T00:00:00",
                "CaptureDate": "2023-06-11T10:12:46"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WPIN.23.70103540-7 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 25/05/2023 13:26",
                "PublishDate": "2023-05-25T00:00:00",
                "CaptureDate": "2023-06-11T10:12:46"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-05-24T00:00:00",
                "CaptureDate": "2023-06-11T10:12:46"
              }
            ],
            "Petitions": [
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2023-05-25T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              }
            ],
            "Decisions": []
          },
          {
            "Number": "10710177020238260100",
            "Type": "PROCEDIMENTO COMUM",
            "MainSubject": "RESPONSABILIDADE DO FORNECEDOR",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "SAO PAULO",
            "Judge": "ROGERIO DE CAMARGO ARRUDA",
            "JudgingBody": "26 VARA CIVEL",
            "State": "SP",
            "Status": "INDEFINIDO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "RESPONSABILIDADE DO FORNECEDOR",
            "InferredCNJSubjectNumber": 6220,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "RESPONSABILIDADE DO FORNECEDOR"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 15270,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-06-06T00:00:00",
            "NoticeDate": "2023-06-01T00:00:00",
            "LastMovementDate": "2023-06-13T00:00:00",
            "CaptureDate": "2023-06-17T04:51:04",
            "LastUpdate": "2023-06-17T04:51:04",
            "NumberOfParties": 5,
            "NumberOfUpdates": 11,
            "LawSuitAge": 272,
            "AverageNumberOfUpdatesPerMonth": 1,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "IsPartyActive": true,
                "Name": "ROGERIO DE CAMARGO ARRUDA",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-06-17T04:51:04"
              },
              {
                "Doc": "11836286686",
                "IsPartyActive": true,
                "Name": "JOAO CARLOS DA SILVA AFFONSO",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-06-17T04:51:04"
              },
              {
                "IsPartyActive": true,
                "Name": "GABRIEL TRENTINI PAGNUSSAT",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "111093",
                  "State": "PR",
                  "SpecificType": "ADVOGADO (REQTE)"
                },
                "LastCaptureDate": "2023-06-17T04:51:04"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-06-17T04:51:04"
              },
              {
                "Doc": "35624319000172",
                "IsPartyActive": true,
                "Name": "MK DIGITAL BANK INSTITUICAO DE PAGAMENTO S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-06-17T04:51:04"
              }
            ],
            "Updates": [
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0506/2023 DATA DA PUBLICACAO: 14/06/2023 NUMERO DO DIARIO: 3755",
                "PublishDate": "2023-06-13T00:00:00",
                "CaptureDate": "2023-06-17T04:51:04"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2023-06-12T00:00:00",
                "CaptureDate": "2023-06-17T04:51:04"
              },
              {
                "Content": "RECEBIDA A EMENDA A INICIAL VISTOS. 1. FOLHAS 26/27: RECEBO COMO EMENDA A INICIAL. ANOTE-SE A INCLUSAO DE MK DIGITAL BANK INSTITUICAO DE PAGAMENTO S/A. 2. AGUARDE-SE O CABAL CUMPRIMENTO DE FOLHAS 22/23. CERTIFICANDO-SE EVENTUAL DECURSO. INT.",
                "PublishDate": "2023-06-12T00:00:00",
                "CaptureDate": "2023-06-17T04:51:04"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0506/2023 TEOR DO ATO: VISTOS. 1. FOLHAS 26/27: RECEBO COMO EMENDA A INICIAL. ANOTE-SE A INCLUSAO DE MK DIGITAL BANK INSTITUICAO DE PAGAMENTO S/A. 2. AGUARDE-SE O CABAL CUMPRIMENTO DE FOLHAS 22/23. CERTIFICANDO-SE EVENTUAL DECURSO. INT. ADVOGADOS(S): GABRIEL TRENTINI PAGNUSSAT (OAB 111093/PR)",
                "PublishDate": "2023-06-12T00:00:00",
                "CaptureDate": "2023-06-17T04:51:04"
              },
              {
                "Content": "MANIFESTACAO DELPOL AO JUIZ JUNTADA N PROTOCOLO: WJMJ.23.41107239-3 TIPO DA PETICAO: MANIFESTACAO DELPOL AO JUIZ DATA: 08/06/2023 15:37",
                "PublishDate": "2023-06-08T00:00:00",
                "CaptureDate": "2023-06-17T04:51:04"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0488/2023 DATA DA PUBLICACAO: 07/06/2023 NUMERO DO DIARIO: 3752",
                "PublishDate": "2023-06-06T00:00:00",
                "CaptureDate": "2023-06-17T04:51:04"
              },
              {
                "Content": "PROCESSO 1071017-70.2023.8.26.0100 - PROCEDIMENTO COMUM CIVEL - RESPONSABILIDADE DO FORNECEDOR - JOAO CARLOS DA SILVA AFFONSO - VISTOS. 1. OBSERVADO QUE A PARTE AUTORA E FUNCIONARIA PUBLICA, RECEBE SALARIO NO VALOR DE R$ 3.000,00, FEZ REMESSA DE DINHEIRO A TERCEIRO, NO VALOR DE R$ 2.635,00, ABRIU MAO DE SEU FORO DE DOMICILIO, TAUBATE/SP, E ESTA REPRESENTADA POR ADVOGADO PARTICULAR, INDEFIRO A GRATUIDADE POSTULADA. NESSE SENTIDO: RESPONSABILIDADE CIVIL. ACAO DECLARATORIA DE INEXISTENCIA DE DEBITO C.C. REPARACAO DE DANOS. ASSISTENCIA JUDICIARIA GRATUITA. INDEFERIMENTO. MANUTENCAO. NAO OBSTANTE A AUTORA AFIRME QUE E POBRE NA ACEPCAO JURIDICA DO TERMO, ESTA REPRESENTADA NOS AUTOS POR ADVOGADO CONTRATADO, DISPENSANDO OS SERVICOS PRESTADOS DE FORMA GRATUITA PELA DEFENSORIA PUBLICA AOS EFETIVAMENTE NECESSITADOS. ALEM DISSO, A AUTORA E DOMICILIADA EM OUTRA COMARCA (FRANCO DA ROCHA-SP), RENUNCIANDO AO FORO PRIVILEGIADO QUE LHE GARANTE A LEGISLACAO CONSUMERISTA. SE ABRIU MAO DE UM BENEFICIO LEGAL QUE LHE GERA CUSTOS, NAO OPTOU PELO JUIZADO ESPECIAL, E E CAPAZ DE PAGAR HONORARIOS ADVOCATICIOS, DISPENSANDO A DEFENSORIA PUBLICA, DEVE PAGAR PELAS DESPESAS PROCESSUAIS. AQUELE QUE OPTA POR NAO LEVAR EM CONSIDERACAO MEDIDAS FACILITADORAS DE ACESSO AO PODER JUDICIARIO, TAL COMO NAO PAGAR TAXA JUDICIARIA, DEIXANDO DE PROPOR A ACAO NO JUIZADO ESPECIAL, REVELA NAO ESTAR TAO HIPOSSUFICIENTE COMO ALEGA. POBRES NAO RENUNCIAM A DIREITOS; E SE O FAZEM, DEVEM SUPORTAR OS CUSTOS DE SUAS ACOES. DEFERIR O BENEFICIO POSTULADO SERIA O MESMO QUE CARREAR A POPULACAO OS ONUS QUE DEVERIAM SER PAGOS PELA AUTORA, O QUE NAO PODERIA SER ADMITIDO, POIS, EM ULTIMA ANALISE, ELE E CUSTEADO PELO ESTADO. AGRAVO NAO PROVIDO. (AG.INST. N 2298093-14.2022.8.26.0000, 12 CAMARA DE DIREITO PRIVADO, DES. REL. SANDRA GALHARDO ESTEVES, J. 21/4/2023). 2. PROVIDENCIE O AUTOR O PAGAMENTO DAS CUSTAS JUDICIAIS, NO VALOR DE R$ 171,30 E DA DESPESA DE CITACAO, NO VALOR DE R$ 29,70, NO PRAZO DE 15 DIAS, SOB PENA DE EXTINCAO. 3. NO MAIS, OBSERVADAS AS CENTENAS DE ACOES SEMELHANTES, DISTRIBUIDAS PELOS MESMOS ADVOGADOS, QUE SEQUER TEM RELACAO PROFISSIONAL APARENTE COM A LOCALIDADE DE DOMICILIO DA AUTORA, IMPORTA A ADOCAO DE ATOS PARA A CONFIRMACAO E CONTROLE DE ABUSOS NA DISTRIBUICAO DAS DEMANDAS. PORTANTO, NO MESMO PRAZO DE 15 DIAS E SOB A MESMA PENA DE EXTINCAO, DEVERA A PARTE AUTORA, MUNIDA DE PROCURACAO ESPECIFICA (COM OS DADOS DA PRESENTE), DOCUMENTO PROPRIO E ORIGINAL COM FOTO, COMPARECER PESSOALMENTE EM CARTORIO PARA RATIFICACAO DOS TERMOS DO AJUIZAMENTO, BEM COMO DA PROCURACAO OUTORGADA, CONFORME ORIENTACAO SUPERIOR, V.G.: ACAO DECLARATORIA - EXTINCAO DO FEITO SEM APRECIACAO DO MERITO - ATIPICIDADE DA DEMANDA ENQUADRADA EM COMUNICADO FEITO PELA CORREGEDORIA GERAL DE JUSTICA DO TJSP, POR MEIO DE SEU NUCLEO DE MONITORAMENTO DE PERFIS DE DEMANDA (NUMOPEDE) DETERMINACAO DADA AO AUTOR PARA COMPARECER PESSOALMENTE EM CARTORIO PARA RATIFICAR A PROCURACAO OUTORGADA AO ADVOGADO - PETICAO INICIAL INDEFERIDA - DESCUMPRIMENTO DE DILIGENCIA PELO AUTOR - ARTS. 321, PARAGRAFO UNICO E 485,I DO CPC - EXTINCAO DECRETADA RECURSO IMPROVIDO. (TJSP; APELACAO 1062650-07.2016.8.26.0002; RELATOR COUTINHO DE ARRUDA; ORGAO JULGADOR: 16 CAMARA DEDIREITO PRIVADO; JULGAMENTO: 21/08/2018; DATA DE REGISTRO: 28/10/2018). 4. CUMPRIDOS OS ITENS 2 E 3 OU DECORRIDO O PRAZO CONCEDIDO, CERTIFIQUE- SE E TORNEM CONCLUSOS, PARA RECEBIMENTO OU EXTINCAO . INT. - ADV: GABRIEL TRENTINI PAGNUSSAT (OAB 111093/PR)",
                "PublishDate": "2023-06-06T00:00:00",
                "CaptureDate": "2023-06-17T04:51:04"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0488/2023 TEOR DO ATO: VISTOS. 1. OBSERVADO QUE A PARTE AUTORA E FUNCIONARIA PUBLICA, RECEBE SALARIO NO VALOR DE R$ 3.000,00, FEZ REMESSA DE DINHEIRO A TERCEIRO, NO VALOR DE R$ 2.635,00, ABRIU MAO DE SEU FORO DE DOMICILIO, TAUBATE/SP, E ESTA REPRESENTADA POR ADVOGADO PARTICULAR, INDEFIRO A GRATUIDADE POSTULADA. NESSE SENTIDO: \"RESPONSABILIDADE CIVIL. ACAO DECLARATORIA DE INEXISTENCIA DE DEBITO C.C. REPARACAO DE DANOS. ASSISTENCIA JUDICIARIA GRATUITA. INDEFERIMENTO. MANUTENCAO. NAO OBSTANTE A AUTORA AFIRME QUE E POBRE NA ACEPCAO JURIDICA DO TERMO, ESTA REPRESENTADA NOS AUTOS POR ADVOGADO CONTRATADO, DISPENSANDO OS SERVICOS PRESTADOS DE FORMA GRATUITA PELA DEFENSORIA PUBLICA AOS EFETIVAMENTE NECESSITADOS. ALEM DISSO, A AUTORA E DOMICILIADA EM OUTRA COMARCA (FRANCO DA ROCHA-SP), RENUNCIANDO AO FORO PRIVILEGIADO QUE LHE GARANTE A LEGISLACAO CONSUMERISTA. SE ABRIU MAO DE UM BENEFICIO LEGAL QUE LHE GERA CUSTOS, NAO OPTOU PELO JUIZADO ESPECIAL, E E CAPAZ DE PAGAR HONORARIOS ADVOCATICIOS, DISPENSANDO A DEFENSORIA PUBLICA, DEVE PAGAR PELAS DESPESAS PROCESSUAIS. AQUELE QUE OPTA POR NAO LEVAR EM CONSIDERACAO MEDIDAS FACILITADORAS DE ACESSO AO PODER JUDICIARIO, TAL COMO NAO PAGAR TAXA JUDICIARIA, DEIXANDO DE PROPOR A ACAO NO JUIZADO ESPECIAL, REVELA NAO ESTAR TAO HIPOSSUFICIENTE COMO ALEGA. POBRES NAO RENUNCIAM A DIREITOS; E SE O FAZEM, DEVEM SUPORTAR OS CUSTOS DE SUAS ACOES. DEFERIR O BENEFICIO POSTULADO SERIA O MESMO QUE CARREAR A POPULACAO OS ONUS QUE DEVERIAM SER PAGOS PELA AUTORA, O QUE NAO PODERIA SER ADMITIDO, POIS, EM ULTIMA ANALISE, ELE E CUSTEADO PELO ESTADO. AGRAVO NAO PROVIDO. (AG.INST. N 2298093-14.2022.8.26.0000, 12 CAMARA DE DIREITO PRIVADO, DES. REL. SANDRA GALHARDO ESTEVES, J. 21/4/2023)\". 2. PROVIDENCIE O AUTOR O PAGAMENTO DAS CUSTAS JUDICIAIS, NO VALOR DE R$ 171,30 E DA DESPESA DE CITACAO, NO VALOR DE R$ 29,70, NO PRAZO DE 15 DIAS, SOB PENA DE EXTINCAO. 3. NO MAIS, OBSERVADAS AS CENTENAS DE ACOES SEMELHANTES, DISTRIBUIDAS PELOS MESMOS ADVOGADOS, QUE SEQUER TEM RELACAO PROFISSIONAL APARENTE COM A LOCALIDADE DE DOMICILIO DA AUTORA, IMPORTA A ADOCAO DE ATOS PARA A CONFIRMACAO E CONTROLE DE ABUSOS NA DISTRIBUICAO DAS DEMANDAS. PORTANTO, NO MESMO PRAZO DE 15 DIAS E SOB A MESMA PENA DE EXTINCAO, DEVERA A PARTE AUTORA, MUNIDA DE PROCURACAO ESPECIFICA (COM OS DADOS DA PRESENTE), DOCUMENTO PROPRIO E ORIGINAL COM FOTO, COMPARECER PESSOALMENTE EM CARTORIO PARA RATIFICACAO DOS TERMOS DO AJUIZAMENTO, BEM COMO DA PROCURACAO OUTORGADA, CONFORME ORIENTACAO SUPERIOR, V.G.: ACAO DECLARATORIA - EXTINCAO DO FEITO SEM APRECIACAO DO MERITO - ATIPICIDADE DA DEMANDA ENQUADRADA EM COMUNICADO FEITO PELA CORREGEDORIA GERAL DE JUSTICA DO TJSP, POR MEIO DE SEU NUCLEO DE MONITORAMENTO DE PERFIS DE DEMANDA (NUMOPEDE) DETERMINACAO DADA AO AUTOR PARA COMPARECER PESSOALMENTE EM CARTORIO PARA RATIFICAR A PROCURACAO OUTORGADA AO ADVOGADO - PETICAO INICIAL INDEFERIDA - DESCUMPRIMENTO DE DILIGENCIA PELO AUTOR - ARTS. 321, PARAGRAFO UNICO E 485,I DO CPC - EXTINCAO DECRETADA RECURSO IMPROVIDO. (TJSP; APELACAO 1062650-07.2016.8.26.0002; RELATOR COUTINHO DE ARRUDA; ORGAO JULGADOR: 16 CAMARA DEDIREITO PRIVADO; JULGAMENTO: 21/08/2018; DATA DE REGISTRO: 28/10/2018). 4. CUMPRIDOS OS ITENS 2 E 3 OU DECORRIDO O PRAZO CONCEDIDO, CERTIFIQUE-SE E TORNEM CONCLUSOS, PARA RECEBIMENTO OU EXTINCAO . INT. ADVOGADOS(S): GABRIEL TRENTINI PAGNUSSAT (OAB 111093/PR)",
                "PublishDate": "2023-06-05T00:00:00",
                "CaptureDate": "2023-06-17T04:51:04"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2023-06-02T00:00:00",
                "CaptureDate": "2023-06-17T04:51:04"
              },
              {
                "Content": "DECISAO DETERMINACAO VISTOS. 1. OBSERVADO QUE A PARTE AUTORA E FUNCIONARIA PUBLICA, RECEBE SALARIO NO VALOR DE R$ 3.000,00, FEZ REMESSA DE DINHEIRO A TERCEIRO, NO VALOR DE R$ 2.635,00, ABRIU MAO DE SEU FORO DE DOMICILIO, TAUBATE/SP, E ESTA REPRESENTADA POR ADVOGADO PARTICULAR, INDEFIRO A GRATUIDADE POSTULADA. NESSE SENTIDO: \"RESPONSABILIDADE CIVIL. ACAO DECLARATORIA DE INEXISTENCIA DE DEBITO C.C. REPARACAO DE DANOS. ASSISTENCIA JUDICIARIA GRATUITA. INDEFERIMENTO. MANUTENCAO. NAO OBSTANTE A AUTORA AFIRME QUE E POBRE NA ACEPCAO JURIDICA DO TERMO, ESTA REPRESENTADA NOS AUTOS POR ADVOGADO CONTRATADO, DISPENSANDO OS SERVICOS PRESTADOS DE FORMA GRATUITA PELA DEFENSORIA PUBLICA AOS EFETIVAMENTE NECESSITADOS. ALEM DISSO, A AUTORA E DOMICILIADA EM OUTRA COMARCA (FRANCO DA ROCHA-SP), RENUNCIANDO AO FORO PRIVILEGIADO QUE LHE GARANTE A LEGISLACAO CONSUMERISTA. SE ABRIU MAO DE UM BENEFICIO LEGAL QUE LHE GERA CUSTOS, NAO OPTOU PELO JUIZADO ESPECIAL, E E CAPAZ DE PAGAR HONORARIOS ADVOCATICIOS, DISPENSANDO A DEFENSORIA PUBLICA, DEVE PAGAR PELAS DESPESAS PROCESSUAIS. AQUELE QUE OPTA POR NAO LEVAR EM CONSIDERACAO MEDIDAS FACILITADORAS DE ACESSO AO PODER JUDICIARIO, TAL COMO NAO PAGAR TAXA JUDICIARIA, DEIXANDO DE PROPOR A ACAO NO JUIZADO ESPECIAL, REVELA NAO ESTAR TAO HIPOSSUFICIENTE COMO ALEGA. POBRES NAO RENUNCIAM A DIREITOS; E SE O FAZEM, DEVEM SUPORTAR OS CUSTOS DE SUAS ACOES. DEFERIR O BENEFICIO POSTULADO SERIA O MESMO QUE CARREAR A POPULACAO OS ONUS QUE DEVERIAM SER PAGOS PELA AUTORA, O QUE NAO PODERIA SER ADMITIDO, POIS, EM ULTIMA ANALISE, ELE E CUSTEADO PELO ESTADO. AGRAVO NAO PROVIDO. (AG.INST. N 2298093-14.2022.8.26.0000, 12 CAMARA DE DIREITO PRIVADO, DES. REL. SANDRA GALHARDO ESTEVES, J. 21/4/2023)\". 2. PROVIDENCIE O AUTOR O PAGAMENTO DAS CUSTAS JUDICIAIS, NO VALOR DE R$ 171,30 E DA DESPESA DE CITACAO, NO VALOR DE R$ 29,70, NO PRAZO DE 15 DIAS, SOB PENA DE EXTINCAO. 3. NO MAIS, OBSERVADAS AS CENTENAS DE ACOES SEMELHANTES, DISTRIBUIDAS PELOS MESMOS ADVOGADOS, QUE SEQUER TEM RELACAO PROFISSIONAL APARENTE COM A LOCALIDADE DE DOMICILIO DA AUTORA, IMPORTA A ADOCAO DE ATOS PARA A CONFIRMACAO E CONTROLE DE ABUSOS NA DISTRIBUICAO DAS DEMANDAS. PORTANTO, NO MESMO PRAZO DE 15 DIAS E SOB A MESMA PENA DE EXTINCAO, DEVERA A PARTE AUTORA, MUNIDA DE PROCURACAO ESPECIFICA (COM OS DADOS DA PRESENTE), DOCUMENTO PROPRIO E ORIGINAL COM FOTO, COMPARECER PESSOALMENTE EM CARTORIO PARA RATIFICACAO DOS TERMOS DO AJUIZAMENTO, BEM COMO DA PROCURACAO OUTORGADA, CONFORME ORIENTACAO SUPERIOR, V.G.: ACAO DECLARATORIA - EXTINCAO DO FEITO SEM APRECIACAO DO MERITO - ATIPICIDADE DA DEMANDA ENQUADRADA EM COMUNICADO FEITO PELA CORREGEDORIA GERAL DE JUSTICA DO TJSP, POR MEIO DE SEU NUCLEO DE MONITORAMENTO DE PERFIS DE DEMANDA (NUMOPEDE) DETERMINACAO DADA AO AUTOR PARA COMPARECER PESSOALMENTE EM CARTORIO PARA RATIFICAR A PROCURACAO OUTORGADA AO ADVOGADO - PETICAO INICIAL INDEFERIDA - DESCUMPRIMENTO DE DILIGENCIA PELO AUTOR - ARTS. 321, PARAGRAFO UNICO E 485,I DO CPC - EXTINCAO DECRETADA RECURSO IMPROVIDO. (TJSP; APELACAO 1062650-07.2016.8.26.0002; RELATOR COUTINHO DE ARRUDA; ORGAO JULGADOR: 16 CAMARA DEDIREITO PRIVADO; JULGAMENTO: 21/08/2018; DATA DE REGISTRO: 28/10/2018). 4. CUMPRIDOS OS ITENS 2 E 3 OU DECORRIDO O PRAZO CONCEDIDO, CERTIFIQUE-SE E TORNEM CONCLUSOS, PARA RECEBIMENTO OU EXTINCAO . INT.",
                "PublishDate": "2023-06-02T00:00:00",
                "CaptureDate": "2023-06-17T04:51:04"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-06-01T00:00:00",
                "CaptureDate": "2023-06-17T04:51:04"
              }
            ],
            "Petitions": [
              {
                "Type": "EMENDA A INICIAL",
                "Author": "",
                "CreationDate": "2023-06-08T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              }
            ],
            "Decisions": []
          },
          {
            "Number": "10082385620238260625",
            "Type": "PROCEDIMENTO COMUM",
            "MainSubject": "DIREITO PROCESSUAL CIVIL E DO TRABALHO",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "TAUBATE",
            "Judge": "MARCIA REZENDE BARBOSA DE OLIVEIRA",
            "JudgingBody": "3 VARA CIVEL",
            "State": "SP",
            "Status": "CANCELADO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "DIREITO PROCESSUAL CIVIL E DO TRABALHO",
            "InferredCNJSubjectNumber": 8826,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO PROCESSUAL CIVIL E DO TRABALHO",
            "InferredBroadCNJSubjectNumber": 8826,
            "OtherSubjects": [
              "DIREITO PROCESSUAL CIVIL E DO TRABALHO"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 15270,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-06-12T00:00:00",
            "NoticeDate": "2023-06-07T00:00:00",
            "LastMovementDate": "2023-06-12T00:00:00",
            "CaptureDate": "2023-06-21T08:02:33",
            "LastUpdate": "2023-06-21T08:02:33",
            "NumberOfParties": 4,
            "NumberOfUpdates": 11,
            "LawSuitAge": 266,
            "AverageNumberOfUpdatesPerMonth": 1,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "09840906810",
                "IsPartyActive": true,
                "Name": "MARCIA REZENDE BARBOSA DE OLIVEIRA",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-06-21T08:02:33"
              },
              {
                "Doc": "11836286686",
                "IsPartyActive": true,
                "Name": "JOAO CARLOS DA SILVA AFFONSO",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-06-21T08:02:33"
              },
              {
                "IsPartyActive": true,
                "Name": "GABRIEL TRENTINI PAGNUSSAT",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "111093",
                  "State": "PR",
                  "SpecificType": "ADVOGADO (REQTE)"
                },
                "LastCaptureDate": "2023-06-21T08:02:33"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-06-21T08:02:33"
              }
            ],
            "Updates": [
              {
                "Content": "REMETIDOS OS AUTOS PARA O CARTORIO DISTRIBUIDOR LOCAL PARA CANCELAMENTO DA DISTRIBUICAO",
                "PublishDate": "2023-06-12T00:00:00",
                "CaptureDate": "2023-06-21T08:02:33"
              },
              {
                "Content": "CANCELADA A DISTRIBUICAO (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR) DETERMINACAO DE FLS. 23.",
                "PublishDate": "2023-06-12T00:00:00",
                "CaptureDate": "2023-06-21T08:02:33"
              },
              {
                "Content": "PROCESSO : 1008238-56.2023.8.26.0625 CLASSE : PROCEDIMENTO COMUM CIVEL REQTE : JOAO CARLOS DA SILVA AFFONSO ADVOGADO : 111093/PR - GABRIEL TRENTINI PAGNUSSAT REQDO : STARK BANK S.A. VARA : 3 VARA CIVEL 1 VARA CIVEL JUIZO DE DIREITO DA 1 VARA CIVEL EDITAL DE INTIMACAO DE ADVOGADOS RELACAO N 0472/2023 PROCESSO 1008238-56.2023.8.26.0625 - PROCEDIMENTO COMUM CIVEL - DIREITO PROCESSUAL CIVIL E DO TRABALHO - JOAO CARLOS DA SILVA AFFONSO - JUIZ(A) DE DIREITO: DR(A). BARBARA ARAUJO MACHADO BOMFIM VISTOS. I ESTA ACAO E ORIUNDA DE PROTOCOLIZACAO EM DUPLICIDADE DE UMA MESMA DEMANDA JA DISTRIBUIDA A 26 VARA CIVEL DA COMARCA DA CAPITAL/SP, RAZAO PELA QUAL DETERMINO SEJA FEITO O CANCELAMENTO DA PRESENTE DISTRIBUICAO. II DE-SE CIENCIA A PARTE E, APOS, ENCAMINHEM-SE OS AUTOS AO DISTRIBUIDOR. III INT. - ADV: GABRIEL TRENTINI PAGNUSSAT (OAB 111093/PR)",
                "PublishDate": "2023-06-12T00:00:00",
                "CaptureDate": "2023-06-21T08:02:33"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0452/2023 DATA DA PUBLICACAO: 13/06/2023 NUMERO DO DIARIO: 3754",
                "PublishDate": "2023-06-08T00:00:00",
                "CaptureDate": "2023-06-21T08:02:33"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-06-07T00:00:00",
                "CaptureDate": "2023-06-21T08:02:33"
              },
              {
                "Content": "DOCUMENTO JUNTADO",
                "PublishDate": "2023-06-07T00:00:00",
                "CaptureDate": "2023-06-21T08:02:33"
              },
              {
                "Content": "DOCUMENTO JUNTADO",
                "PublishDate": "2023-06-07T00:00:00",
                "CaptureDate": "2023-06-21T08:02:33"
              },
              {
                "Content": "DOCUMENTO JUNTADO",
                "PublishDate": "2023-06-07T00:00:00",
                "CaptureDate": "2023-06-21T08:02:33"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2023-06-07T00:00:00",
                "CaptureDate": "2023-06-21T08:02:33"
              },
              {
                "Content": "DETERMINADO O CANCELAMENTO DA DISTRIBUICAO JUIZ(A) DE DIREITO: DR(A). BARBARA ARAUJO MACHADO BOMFIM VISTOS. I ESTA ACAO E ORIUNDA DE PROTOCOLIZACAO EM DUPLICIDADE DE UMA MESMA DEMANDA JA DISTRIBUIDA A 26 VARA CIVEL DA COMARCA DA CAPITAL/SP, RAZAO PELA QUAL DETERMINO SEJA FEITO O CANCELAMENTO DA PRESENTE DISTRIBUICAO. II DE-SE CIENCIA A PARTE E, APOS, ENCAMINHEM-SE OS AUTOS AO DISTRIBUIDOR. III INT.",
                "PublishDate": "2023-06-07T00:00:00",
                "CaptureDate": "2023-06-21T08:02:33"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0452/2023 TEOR DO ATO: JUIZ(A) DE DIREITO: DR(A). BARBARA ARAUJO MACHADO BOMFIM VISTOS. I ESTA ACAO E ORIUNDA DE PROTOCOLIZACAO EM DUPLICIDADE DE UMA MESMA DEMANDA JA DISTRIBUIDA A 26 VARA CIVEL DA COMARCA DA CAPITAL/SP, RAZAO PELA QUAL DETERMINO SEJA FEITO O CANCELAMENTO DA PRESENTE DISTRIBUICAO. II DE-SE CIENCIA A PARTE E, APOS, ENCAMINHEM-SE OS AUTOS AO DISTRIBUIDOR. III INT. ADVOGADOS(S): GABRIEL TRENTINI PAGNUSSAT (OAB 111093/PR)",
                "PublishDate": "2023-06-07T00:00:00",
                "CaptureDate": "2023-06-21T08:02:33"
              }
            ],
            "Petitions": [],
            "Decisions": []
          },
          {
            "Number": "10212631120238260602",
            "Type": "PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL",
            "MainSubject": "RESPONSABILIDADE DO FORNECEDOR",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "ESPECIAL CIVEL",
            "CourtDistrict": "SOROCABA",
            "Judge": "GUSTAVO SCAF DE MOLON",
            "JudgingBody": "1 VARA DO JUIZADO ESPECIAL CIVEL",
            "State": "SP",
            "Status": "INDEFINIDO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "RESPONSABILIDADE DO FORNECEDOR",
            "InferredCNJSubjectNumber": 6220,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO DO JUIZADO ESPECIAL CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "RESPONSABILIDADE DO FORNECEDOR"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 35400.41,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-06-13T00:00:00",
            "NoticeDate": "2023-06-07T00:00:00",
            "LastMovementDate": "2023-06-19T00:00:00",
            "CaptureDate": "2023-06-23T16:38:51",
            "LastUpdate": "2023-06-23T16:38:51",
            "NumberOfParties": 10,
            "NumberOfUpdates": 13,
            "LawSuitAge": 266,
            "AverageNumberOfUpdatesPerMonth": 1,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "21385180862",
                "IsPartyActive": true,
                "Name": "GUSTAVO SCAF DE MOLON",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-06-23T16:38:51"
              },
              {
                "Doc": "30856649805",
                "IsPartyActive": true,
                "Name": "PATRICIA ALVES FONSECA SALES",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-06-23T16:38:51"
              },
              {
                "Doc": "39911218830",
                "IsPartyActive": true,
                "Name": "ANDRE FONSECA MOYA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "351053",
                  "State": "SP",
                  "SpecificType": "ADVOGADO (REQTE)"
                },
                "LastCaptureDate": "2023-06-23T16:38:51"
              },
              {
                "Doc": "13935893000109",
                "IsPartyActive": true,
                "Name": "CELCOIN PAGAMENTOS S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-06-23T16:38:51"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-06-23T16:38:51"
              },
              {
                "IsPartyActive": true,
                "Name": "BANCO BMG S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-06-23T16:38:51"
              },
              {
                "IsPartyActive": true,
                "Name": "PIC PAY SERVICOS S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-06-23T16:38:51"
              },
              {
                "Doc": "34337707000100",
                "IsPartyActive": true,
                "Name": "BMP MONEY PLUS SOCIEDADE DE CREDITO DIRETO S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-06-23T16:38:51"
              },
              {
                "IsPartyActive": true,
                "Name": "VIA PAGSEGURO INTERNET S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-06-23T16:38:51"
              },
              {
                "Doc": "30306294000226",
                "IsPartyActive": true,
                "Name": "BANCO BTG PACTUAL S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-06-23T16:38:51"
              }
            ],
            "Updates": [
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0383/2023 DATA DA PUBLICACAO: 20/06/2023 NUMERO DO DIARIO: 3759",
                "PublishDate": "2023-06-19T00:00:00",
                "CaptureDate": "2023-06-23T16:38:51"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2023-06-16T00:00:00",
                "CaptureDate": "2023-06-23T16:38:51"
              },
              {
                "Content": "RECEBIDA A PETICAO INICIAL - CITACAO POR CARTA AR N DE ORDEM: 2023/001146 VISTOS. POR ORA, FICA DISPENSADA A DESIGNACAO DE AUDIENCIA DE CONCILIACAO, CONSIDERANDO: (I) A PEQUENA ESTRUTURA DE CONCILIADORES A DISPOSICAO DO JUIZO, (II) A EXTENSA PAUTA PARA AS AUDIENCIAS DE CONCILIACAO JA DESIGNADAS ANTERIORMENTE, (III) OS PRINCIPIOS DA CELERIDADE E INFORMALIDADE QUE REGEM O SISTEMA DOS JUIZADOS ESPECIAIS (ART. 2, LEI 9.099/95), E (IV) A OBSERVACAO COTIDIANA DE QUE A REFERIDA AUDIENCIA, EM CASOS SEMELHANTES, NAO TEM ALCANCADO RESULTADOS PROVEITOSOS PARA AS PARTES E PARA O BOM ANDAMENTO DO PROCESSO. ASSIM, CITE-SE A PARTE RE PARA APRESENTAR CONTESTACAO, NO PRAZO DE 15 DIAS, A CONTAR DA DATA DA INTIMACAO (ENUNCIADO 13 DO FONAJE), OBSERVANDO-SE QUE EM CASO DE INERCIA OS FATOS NARRADOS NA PETICAO INICIAL PODERAO SER PRESUMIDOS COMO VERDADEIROS (ART. 344, CPC/2015). ANOTO QUE A REALIZACAO DA AUDIENCIA PODE OCORRER A POSTERIORI, SE HOUVER RECIPROCO INTERESSE DAS PARTES; CASO A PARTE REQUERIDA TENHA INTERESSE CONCRETO EM REALIZAR ACORDO, PODERA APRESENTAR PROPOSTA ESPECIFICA, EM PRELIMINAR DE CONTESTACAO (SEM PREJUIZO DE EVENTUAL CONTATO DIRETO ENTRE OS ADVOGADOS). INT.",
                "PublishDate": "2023-06-16T00:00:00",
                "CaptureDate": "2023-06-23T16:38:51"
              },
              {
                "Content": "CARTA DE CITACAO EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO E INTIMACAO - APRESENTAR DEFESA ESCRITA - SEM AUDIENCIA - JUIZADO",
                "PublishDate": "2023-06-16T00:00:00",
                "CaptureDate": "2023-06-23T16:38:51"
              },
              {
                "Content": "CARTA DE CITACAO EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO E INTIMACAO - APRESENTAR DEFESA ESCRITA - SEM AUDIENCIA - JUIZADO",
                "PublishDate": "2023-06-16T00:00:00",
                "CaptureDate": "2023-06-23T16:38:51"
              },
              {
                "Content": "CARTA DE CITACAO EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO E INTIMACAO - APRESENTAR DEFESA ESCRITA - SEM AUDIENCIA - JUIZADO",
                "PublishDate": "2023-06-16T00:00:00",
                "CaptureDate": "2023-06-23T16:38:51"
              },
              {
                "Content": "CARTA DE CITACAO EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO E INTIMACAO - APRESENTAR DEFESA ESCRITA - SEM AUDIENCIA - JUIZADO",
                "PublishDate": "2023-06-16T00:00:00",
                "CaptureDate": "2023-06-23T16:38:51"
              },
              {
                "Content": "CARTA DE CITACAO EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO E INTIMACAO - APRESENTAR DEFESA ESCRITA - SEM AUDIENCIA - JUIZADO",
                "PublishDate": "2023-06-16T00:00:00",
                "CaptureDate": "2023-06-23T16:38:51"
              },
              {
                "Content": "CARTA DE CITACAO EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO E INTIMACAO - APRESENTAR DEFESA ESCRITA - SEM AUDIENCIA - JUIZADO",
                "PublishDate": "2023-06-16T00:00:00",
                "CaptureDate": "2023-06-23T16:38:51"
              },
              {
                "Content": "CARTA DE CITACAO EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO E INTIMACAO - APRESENTAR DEFESA ESCRITA - SEM AUDIENCIA - JUIZADO",
                "PublishDate": "2023-06-16T00:00:00",
                "CaptureDate": "2023-06-23T16:38:51"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0383/2023 TEOR DO ATO: N DE ORDEM: 2023/001146 VISTOS. POR ORA, FICA DISPENSADA A DESIGNACAO DE AUDIENCIA DE CONCILIACAO, CONSIDERANDO: (I) A PEQUENA ESTRUTURA DE CONCILIADORES A DISPOSICAO DO JUIZO, (II) A EXTENSA PAUTA PARA AS AUDIENCIAS DE CONCILIACAO JA DESIGNADAS ANTERIORMENTE, (III) OS PRINCIPIOS DA CELERIDADE E INFORMALIDADE QUE REGEM O SISTEMA DOS JUIZADOS ESPECIAIS (ART. 2, LEI 9.099/95), E (IV) A OBSERVACAO COTIDIANA DE QUE A REFERIDA AUDIENCIA, EM CASOS SEMELHANTES, NAO TEM ALCANCADO RESULTADOS PROVEITOSOS PARA AS PARTES E PARA O BOM ANDAMENTO DO PROCESSO. ASSIM, CITE-SE A PARTE RE PARA APRESENTAR CONTESTACAO, NO PRAZO DE 15 DIAS, A CONTAR DA DATA DA INTIMACAO (ENUNCIADO 13 DO FONAJE), OBSERVANDO-SE QUE EM CASO DE INERCIA OS FATOS NARRADOS NA PETICAO INICIAL PODERAO SER PRESUMIDOS COMO VERDADEIROS (ART. 344, CPC/2015). ANOTO QUE A REALIZACAO DA AUDIENCIA PODE OCORRER A POSTERIORI, SE HOUVER RECIPROCO INTERESSE DAS PARTES; CASO A PARTE REQUERIDA TENHA INTERESSE CONCRETO EM REALIZAR ACORDO, PODERA APRESENTAR PROPOSTA ESPECIFICA, EM PRELIMINAR DE CONTESTACAO (SEM PREJUIZO DE EVENTUAL CONTATO DIRETO ENTRE OS ADVOGADOS). INT. ADVOGADOS(S): ANDRE FONSECA MOYA (OAB 351053/SP)",
                "PublishDate": "2023-06-16T00:00:00",
                "CaptureDate": "2023-06-23T16:38:51"
              },
              {
                "Content": "PROCESSO : 1021263-11.2023.8.26.0602 CLASSE : PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL REQTE : PATRICIA ALVES FONSECA SALES ADVOGADO : 351053/SP - ANDRE FONSECA MOYA REQDO : BANCO BTG PACTUAL S.A. VARA : 1 VARA DO JUIZADO ESPECIAL CIVEL",
                "PublishDate": "2023-06-13T00:00:00",
                "CaptureDate": "2023-06-23T16:38:51"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-06-07T00:00:00",
                "CaptureDate": "2023-06-23T16:38:51"
              }
            ],
            "Petitions": [],
            "Decisions": []
          },
          {
            "Number": "15835048420198260090",
            "Type": "EXECUCAO FISCAL",
            "MainSubject": "ISS/ IMPOSTO SOBRE SERVICOS",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "TRIBUTARIA",
            "CourtDistrict": "SAO PAULO",
            "Judge": "RENATO DE ANDRADE SIQUEIRA",
            "JudgingBody": "VARA DAS EXECUCOES FISCAIS MUNICIPAIS",
            "State": "SP",
            "Status": "ARQUIVADO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "ISS/ IMPOSTO SOBRE SERVIÇOS",
            "InferredCNJSubjectNumber": 5951,
            "InferredCNJProcedureTypeName": "EXECUÇÃO FISCAL",
            "InferredBroadCNJSubjectName": "DIREITO TRIBUTÁRIO",
            "InferredBroadCNJSubjectNumber": 14,
            "OtherSubjects": [
              "ISS/ IMPOSTO SOBRE SERVICOS"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 32058,
            "ResJudicataDate": "2020-01-17T00:00:00",
            "CloseDate": "2020-01-17T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "0001-01-01T00:00:00",
            "NoticeDate": "2019-09-30T00:00:00",
            "LastMovementDate": "2020-01-17T00:00:00",
            "CaptureDate": "2023-07-07T06:02:43",
            "LastUpdate": "2023-07-07T06:02:43",
            "NumberOfParties": 3,
            "NumberOfUpdates": 11,
            "LawSuitAge": 109,
            "AverageNumberOfUpdatesPerMonth": 0,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "36876721825",
                "IsPartyActive": true,
                "Name": "RENATO DE ANDRADE SIQUEIRA",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-07-07T06:02:43"
              },
              {
                "Doc": "46395000000139",
                "IsPartyActive": true,
                "Name": "PREFEITURA MUNICIPAL DE SAO PAULO",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "EXEQTE"
                },
                "LastCaptureDate": "2023-07-07T06:02:43"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "EXECTDA"
                },
                "LastCaptureDate": "2023-07-07T06:02:43"
              }
            ],
            "Updates": [
              {
                "Content": "CERTIDAO DE TRANSITO EM JULGADO COM BAIXA EXPEDIDA CERTIDAO DE TRANSITO EM JULGADO - COM BAIXA",
                "PublishDate": "2020-01-17T00:00:00",
                "CaptureDate": "2023-06-28T07:05:59"
              },
              {
                "Content": "TRANSITO EM JULGADO AS PARTES - COM BAIXA",
                "PublishDate": "2020-01-17T00:00:00",
                "CaptureDate": "2023-06-28T07:05:59"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WEFM.19.70266485-3 TIPO DA PETICAO: PEDIDO DE EXTINCAO (ART. 924, II, DO CPC) DATA: 23/10/2019 06:47",
                "PublishDate": "2019-10-23T00:00:00",
                "CaptureDate": "2023-06-28T07:05:59"
              },
              {
                "Content": "CONCLUSOS PARA SENTENCA",
                "PublishDate": "2019-10-23T00:00:00",
                "CaptureDate": "2023-06-28T07:05:59"
              },
              {
                "Content": "EXTINTA A EXECUCAO/CUMPRIMENTO DA SENTENCA PELA SATISFACAO DA OBRIGACAO VISTOS. 1. JULGO EXTINTA A EXECUCAO, COM BASE NO ART. 924, INC. II, DO NOVO CODIGO DE PROCESSO CIVIL. SENDO O CASO, PROVIDENCIE A SERVENTIA O NECESSARIO A SUSTACAO DE LEILOES, COBRANCA DE MANDADOS, COBRANCA DE PRECATORIAS INDEPENDENTEMENTE DE CUMPRIMENTO E COMUNICACOES A SUPERIOR INSTANCIA. 2. SE OPOSTOS, MAS AINDA PENDENTES DE JULGAMENTO, FICAM, DESDE JA, EXTINTOS OS EMBARGOS A EXECUCAO, COM BASE NO ART. 485, INC. VI, DO NOVO CODIGO DE PROCESSO CIVIL, PROVIDENCIANDO A SERVENTIA O NECESSARIO A PUBLICACAO E REGISTRO DA SENTENCA NOS AUTOS RESPECTIVOS. 3. SE, OPOSTOS, OS EMBARGOS TIVEREM SIDO JULGADOS EM PRIMEIRO GRAU, FICA DESDE JA RECONHECIDA A ACEITACAO DA SENTENCA E PREJUDICADO O PROSSEGUIMENTO DE EVENTUAL RECURSO (NOVO CODIGO DE PROCESSO CIVIL, ART. 1.000, PARAGRAFO UNICO), CERTIFICANDO A SERVENTIA O TRANSITO EM JULGADO. 4. SE O CASO, DEFIRO, DESDE JA, O LEVANTAMENTO DA CONSTRICAO JUDICIAL OU OUTRAS RESTRICOES LEVADAS A EFEITO EXCLUSIVAMENTE NESTES AUTOS, ORDEM A SER CUMPRIDA DE IMEDIATO, INDEPENDENTEMENTE DA OCORRENCIA, OU NAO, DE TRANSITO EM JULGADO, NOS SEGUINTES TERMOS: A) - A PROPRIA PARTE INTERESSADA INCUMBIRA A IMPRESSAO DESTA DECISAO, POR MEIO DO SITE HTTPS://ESAJ.TJSP.JUS.BR/ESAJ, E O ENCAMINHAMENTO AO ORGAO RESPONSAVEL PELO CUMPRIMENTO DESTA ORDEM, SERVINDO A PRESENTE DECISAO COMO MANDADO/OFICIO DE LEVANTAMENTO DA CONSTRICAO. B) - A PROPRIA PARTE INTERESSADA INCUMBIRA A IMPRESSAO DESTA DECISAO, POR MEIO DO SITE HTTPS://ESAJ.TJSP.JUS.BR/ESAJ, E O ENCAMINHAMENTO A PREFEITURA, SERVINDO A PRESENTE DECISAO COMO OFICIO PARA FINS DE EXCLUSAO DO CADIN E DE EMISSAO DE CERTIDOES DE REGULARIDADE FISCAL. C) - HAVENDO VALORES DEPOSITADOS, A SERVENTIA, DEPOIS DE JUNTADO O \"PRINT\" DE PENDENCIAS, EXPEDIRA MANDADO(S) DE LEVANTAMENTO. E INDISPENSAVEL QUE O INTERESSADO PROVIDENCIE, CONFORME DETERMINADO NO COMUNICADO CONJUNTO N 474/2017, O PREENCHIMENTO DO FORMULARIO DISPONIVEL NO ENDERECO ELETRONICO HTTP://WWW.TJSP.JUS.BR/INDICESTAXASJUDICIAIS/DESPESASPROCESSUAIS (ORIENTACOES GERAIS - FORMULARIO DE MLE - MANDADO DE LEVANTAMENTO ELETRONICO), DEVENDO, AINDA, JUNTA-LO AOS AUTOS DIGITAIS. D) - HAVENDO CARTA DE FIANCA E/OU SEGURO GARANTIA, FICA DEFERIDO O IMEDIATO DESENTRANHAMENTO, MEDIANTE REPOSICAO POR COPIA NOS AUTOS. 5. COM O TRANSITO EM JULGADO, ARQUIVEM-SE. CUMPRA-SE NA FORMA E SOB AS PENAS DA LEI. P.R.I.",
                "PublishDate": "2019-10-23T00:00:00",
                "CaptureDate": "2023-06-28T07:05:59"
              },
              {
                "Content": "CERTIDAO DE REMESSA DA INTIMACAO PARA O PORTAL ELETRONICO EXPEDIDA CERTIDAO - REMESSA DA INTIMACAO PARA O PORTAL ELETRONICO",
                "PublishDate": "2019-10-23T00:00:00",
                "CaptureDate": "2023-06-28T07:05:59"
              },
              {
                "Content": "AR POSITIVO JUNTADO JUNTADA DE AR : AR013586624TJ SITUACAO : CUMPRIDO MODELO : PROCESSO DIGITAL - CARTA - CITACAO - EXECUCAO FISCAL - MUNICIPAL - CAPITAL DESTINATARIO : STARK BANK S.A. DILIGENCIA : 09/10/2019",
                "PublishDate": "2019-10-09T00:00:00",
                "CaptureDate": "2023-06-28T07:05:59"
              },
              {
                "Content": "RECEBIDA A PETICAO INICIAL - CITACAO POR CARTA AR VISTOS. 1. CITE-SE O(A) EXECUTADO(A) PARA QUE, NO PRAZO DE 05 (CINCO) DIAS, PAGUE O DEBITO, CUJO VALOR DEVERA SER CORRIGIDO MONETARIAMENTE ATE A DATA DO EFETIVO PAGAMENTO, ACRESCIDO DE MULTA, JUROS, HONORARIOS ADVOCATICIOS - ORA FIXADOS EM 10% (DEZ POR CENTO) -, CUSTAS E DESPESAS PROCESSUAIS, OU, EM IGUAL PRAZO, OFERECA BENS A PENHORA, SOB PENA DE SEREM PENHORADOS TANTOS BENS QUANTOS BASTEM PARA A GARANTIA DA EXECUCAO, FICANDO, AINDA, CIENTE DE QUE O PRAZO PARA OPOSICAO DE EMBARGOS E DE 30 (TRINTA) DIAS, CONTADOS DA INTIMACAO DA CONSTRICAO (ART. 16, DA LEI 6830/80), VALENDO A CITACAO PARA TODOS OS DEMAIS TERMOS E ATOS PROCESSUAIS, ATE FINAL LIQUIDACAO. SE NEGATIVA A CITACAO, DE-SE VISTA DOS AUTOS A FAZENDA. SE POSITIVA, AGUARDE-SE, PELO PRAZO DE CINCO (5) DIAS, O PAGAMENTO OU A NOMEACAO DE BENS; NADA SENDO PROVIDENCIADO PELO(A) EXECUTADO(A), DE-SE VISTA DOS AUTOS A EXEQUENTE. 2. SE SE TRATAR DE PESSOA JURIDICA DE DIREITO PUBLICO, CITE-SE NA FORMA DO ART. 910 DO NOVO CODIGO DE PROCESSO CIVIL. NESSE CASO, SE, EFETIVADA A CITACAO, NAO HOUVER EMBARGOS, A SOLICITACAO DE OFICIO REQUISITORIO DEVERA SER REALIZADA POR PETICIONAMENTO ELETRONICO (COMUNICADO SPI N 64/2015 (PROCESSO CPA N 2013/186913). 3. INTIME-SE.",
                "PublishDate": "2019-10-04T00:00:00",
                "CaptureDate": "2023-06-28T07:05:59"
              },
              {
                "Content": "CARTA DE CITACAO EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO - EXECUCAO FISCAL - MUNICIPAL - CAPITAL",
                "PublishDate": "2019-10-04T00:00:00",
                "CaptureDate": "2023-06-28T07:05:59"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2019-10-03T00:00:00",
                "CaptureDate": "2023-06-28T07:05:59"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2019-09-30T00:00:00",
                "CaptureDate": "2023-06-28T07:05:59"
              }
            ],
            "Petitions": [
              {
                "Type": "PEDIDO DE EXTINCAO (ART. 924, II, DO CPC)",
                "Author": "",
                "CreationDate": "2019-10-23T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              }
            ],
            "Decisions": [
              {
                "DecisionContent": "JULGO EXTINTA A EXECUCAO, COM BASE NO ART. 924, INC.",
                "DecisionDate": "2019-10-23T00:00:00"
              }
            ]
          },
          {
            "Number": "10103524920238260016",
            "Type": "PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL",
            "MainSubject": "INDENIZACAO POR DANO MATERIAL",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "ESPECIAL CIVEL",
            "CourtDistrict": "SAO PAULO",
            "JudgingBody": "2 VARA DO JUIZADO ESPECIAL CIVEL - VERGUEIRO",
            "State": "SP",
            "Status": "INDEFINIDO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "INDENIZAÇÃO POR DANO MATERIAL",
            "InferredCNJSubjectNumber": 7780,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO DO JUIZADO ESPECIAL CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "INDENIZACAO POR DANO MATERIAL",
              "INDENIZACAO POR DANO MORAL"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 68304.06,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-06-16T00:00:00",
            "NoticeDate": "2023-05-10T00:00:00",
            "LastMovementDate": "2023-06-16T00:00:00",
            "CaptureDate": "2023-06-29T05:24:19",
            "LastUpdate": "2023-06-29T05:24:19",
            "NumberOfParties": 9,
            "NumberOfUpdates": 6,
            "LawSuitAge": 294,
            "AverageNumberOfUpdatesPerMonth": 0,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "80840132034",
                "IsPartyActive": true,
                "Name": "CHANA CECCHIN ASSENCIO",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-06-29T05:24:19"
              },
              {
                "Doc": "33746424895",
                "IsPartyActive": true,
                "Name": "RENAN NOGUEIRA FARAH",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "274183",
                  "State": "SP",
                  "SpecificType": "ADVOGADO (REQTE)"
                },
                "LastCaptureDate": "2023-06-29T05:24:19"
              },
              {
                "Doc": "39358383879",
                "IsPartyActive": true,
                "Name": "ALEXANDRE JURACY ALVES DE ALMEIDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-06-29T05:24:19"
              },
              {
                "Doc": "41970199000168",
                "IsPartyActive": true,
                "Name": "ZOSMA SERVICOS DE PAGAMENTOS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-06-29T05:24:19"
              },
              {
                "Doc": "37880206000163",
                "IsPartyActive": true,
                "Name": "CORA SOCIEDADE DE CREDITO DIRETO S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-06-29T05:24:19"
              },
              {
                "Doc": "00416968000446",
                "IsPartyActive": true,
                "Name": "BANCO INTERMEDIUM S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-06-29T05:24:19"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-06-29T05:24:19"
              },
              {
                "Doc": "46189325000165",
                "IsPartyActive": true,
                "Name": "ITAU UNIBANCO S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-06-29T05:24:19"
              },
              {
                "Doc": "39505350000145",
                "IsPartyActive": true,
                "Name": "NUBANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-06-29T05:24:19"
              }
            ],
            "Updates": [
              {
                "Content": "PROCESSO 1010352-49.2023.8.26.0016 - PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL - INDENIZACAO POR DANO MATERIAL - CHANA CECCHIN ASSENCIO - FICA DESIGNADA AUDIENCIA DE CONCILIACAO POR VIDEOCONFERENCIA COM USO DA PLATAFORMA TEAMS PARA DIA 19/02/2024 AS 14:00H. O LINK DE ACESSO SERA DISPONIBILIZADO NA MOVIMENTACAO PROCESSUAL, COM ATE 24 HORAS DE ANTECEDENCIA. 3) SOLICITAMOS QUE AS PARTES ACESSEM O LINK COM 10MINUTOS DE ANTECEDENCIA E AGUARDEM NA SALA DE ESPERA. CASO NAO SEJAM ADMITIDAS, CANCELEM A ENTRADA E CLIQUEM NOVAMENTE NO LINK. 4) AS PARTES DEVERAO INFORMAR E-MAIL E CELULAR PARA EVENTUAIS ORIENTACOES. QUAISQUER INTERCORRENCIAS TECNICAS DEVERAO SER COMUNICADAS POR MEIO DE FOTOS OU PRINTS DE TELA ATRAVES DO CONTATO: VITORMORALES@TJSP.JUS.BR 5) SEM PREJUIZO DOS ITENS ACIMA, FICA A PARTE REQUERIDA INTIMADA A OFERTAR CONTESTACAO, OBSERVANDO-SE QUE, EM SEDE DE JUIZADO, EVENTUAL REVELIA SE DA POR AUSENCIA EM AUDIENCIA (ART. 20, DA LEI 9.099/95). NADA MAIS. - ADV: RENAN NOGUEIRA FARAH (OAB 274183/SP)",
                "PublishDate": "2023-06-16T00:00:00",
                "CaptureDate": "2023-06-29T05:24:19"
              },
              {
                "Content": "DESIGNADA AUDIENCIA DE CONCILIACAO CONCILIACAO DATA: 19/02/2024 HORA 14:00 LOCAL: SALA DE AUDIENCIAS - 8 ANDAR SITUACAO: PENDENTE",
                "PublishDate": "2023-06-15T00:00:00",
                "CaptureDate": "2023-06-29T05:24:19"
              },
              {
                "Content": "ATO ORDINATORIO FICA DESIGNADA AUDIENCIA DE CONCILIACAO POR VIDEOCONFERENCIA COM USO DA PLATAFORMA TEAMS PARA DIA 19/02/2024 AS 14:00H. O LINK DE ACESSO SERA DISPONIBILIZADO NA MOVIMENTACAO PROCESSUAL, COM ATE 24 HORAS DE ANTECEDENCIA. 3) SOLICITAMOS QUE AS PARTES ACESSEM O LINK COM 10MINUTOS DE ANTECEDENCIA E AGUARDEM NA SALA DE ESPERA. CASO NAO SEJAM ADMITIDAS, CANCELEM A ENTRADA E CLIQUEM NOVAMENTE NO LINK. 4) AS PARTES DEVERAO INFORMAR E-MAIL E CELULAR PARA EVENTUAIS ORIENTACOES. QUAISQUER INTERCORRENCIAS TECNICAS DEVERAO SER COMUNICADAS POR MEIO DE FOTOS OU PRINTS DE TELA ATRAVES DO CONTATO: VITORMORALES@TJSP.JUS.BR 5) SEM PREJUIZO DOS ITENS ACIMA, FICA A PARTE REQUERIDA INTIMADA A OFERTAR CONTESTACAO, OBSERVANDO-SE QUE, EM SEDE DE JUIZADO, EVENTUAL REVELIA SE DA POR AUSENCIA EM AUDIENCIA (ART. 20, DA LEI 9.099/95). NADA MAIS.",
                "PublishDate": "2023-06-15T00:00:00",
                "CaptureDate": "2023-06-29T05:24:19"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0556/2023 TEOR DO ATO: FICA DESIGNADA AUDIENCIA DE CONCILIACAO POR VIDEOCONFERENCIA COM USO DA PLATAFORMA TEAMS PARA DIA 19/02/2024 AS 14:00H. O LINK DE ACESSO SERA DISPONIBILIZADO NA MOVIMENTACAO PROCESSUAL, COM ATE 24 HORAS DE ANTECEDENCIA. 3) SOLICITAMOS QUE AS PARTES ACESSEM O LINK COM 10MINUTOS DE ANTECEDENCIA E AGUARDEM NA SALA DE ESPERA. CASO NAO SEJAM ADMITIDAS, CANCELEM A ENTRADA E CLIQUEM NOVAMENTE NO LINK. 4) AS PARTES DEVERAO INFORMAR E-MAIL E CELULAR PARA EVENTUAIS ORIENTACOES. QUAISQUER INTERCORRENCIAS TECNICAS DEVERAO SER COMUNICADAS POR MEIO DE FOTOS OU PRINTS DE TELA ATRAVES DO CONTATO: VITORMORALES@TJSP.JUS.BR 5) SEM PREJUIZO DOS ITENS ACIMA, FICA A PARTE REQUERIDA INTIMADA A OFERTAR CONTESTACAO, OBSERVANDO-SE QUE, EM SEDE DE JUIZADO, EVENTUAL REVELIA SE DA POR AUSENCIA EM AUDIENCIA (ART. 20, DA LEI 9.099/95). NADA MAIS. ADVOGADOS(S): RENAN NOGUEIRA FARAH (OAB 274183/SP)",
                "PublishDate": "2023-06-15T00:00:00",
                "CaptureDate": "2023-06-29T05:24:19"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0556/2023 DATA DA PUBLICACAO: 19/06/2023 NUMERO DO DIARIO: 3758",
                "PublishDate": "2023-06-15T00:00:00",
                "CaptureDate": "2023-06-29T05:24:19"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-05-10T00:00:00",
                "CaptureDate": "2023-06-29T05:24:19"
              }
            ],
            "Petitions": [],
            "Decisions": []
          },
          {
            "Number": "10036016620238260268",
            "Type": "PROCEDIMENTO COMUM",
            "MainSubject": "INDENIZACAO POR DANO MATERIAL",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "ITAPECERICA DA SERRA",
            "Judge": "LETICIA ANTUNES TAVARES",
            "JudgingBody": "2 VARA",
            "State": "SP",
            "Status": "ATIVO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "INDENIZAÇÃO POR DANO MATERIAL",
            "InferredCNJSubjectNumber": 7780,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "INDENIZACAO POR DANO MATERIAL",
              "INDENIZACAO POR DANO MORAL",
              "RESPONSABILIDADE DO FORNECEDOR"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 13724.38,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-06-20T00:00:00",
            "NoticeDate": "2023-06-16T00:00:00",
            "LastMovementDate": "2023-06-30T00:00:00",
            "CaptureDate": "2023-07-01T18:52:43",
            "LastUpdate": "2023-07-01T18:52:43",
            "NumberOfParties": 7,
            "NumberOfUpdates": 11,
            "LawSuitAge": 257,
            "AverageNumberOfUpdatesPerMonth": 1,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "IsPartyActive": true,
                "Name": "LETICIA ANTUNES TAVARES",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-07-01T18:52:43"
              },
              {
                "Doc": "47782745802",
                "IsPartyActive": true,
                "Name": "GUSTAVO CAMARA MENDES",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-07-01T18:52:43"
              },
              {
                "Doc": "02851772066",
                "IsPartyActive": true,
                "Name": "VITORIA DOS SANTOS TIECHER",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "115402",
                  "State": "RS",
                  "SpecificType": "ADVOGADA (REQTE)"
                },
                "LastCaptureDate": "2023-07-01T18:52:43"
              },
              {
                "Doc": "46189325000165",
                "IsPartyActive": true,
                "Name": "ITAU UNIBANCO S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-01T18:52:43"
              },
              {
                "Doc": "00416968000101",
                "IsPartyActive": true,
                "Name": "BANCO INTER S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-01T18:52:43"
              },
              {
                "Doc": "60746948000112",
                "IsPartyActive": true,
                "Name": "BANCO BRADESCO S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-01T18:52:43"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-01T18:52:43"
              }
            ],
            "Updates": [
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0520/2023 DATA DA PUBLICACAO: 03/07/2023 NUMERO DO DIARIO: 3768",
                "PublishDate": "2023-06-30T00:00:00",
                "CaptureDate": "2023-07-01T18:52:43"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0520/2023 TEOR DO ATO: VISTOS. 1. DOU POR REGULARIZADA A REPRESENTACAO DO AUTOR. 2. DE ACORDO COM O ARTIGO 98 DO CODIGO DE PROCESSO CIVIL, \"A PESSOA NATURAL OU JURIDICA, BRASILEIRA OU ESTRANGEIRA, COM INSUFICIENCIA DE RECURSOS PARA PAGAR AS CUSTAS, AS DESPESAS PROCESSUAIS E OS HONORARIOS ADVOCATICIOS TEM DIREITO A GRATUIDADE DA JUSTICA, NA FORMA DA LEI\". E, EMBORA A LEI PRESUMA VERDADEIRA A ALEGACAO DA INSUFICIENCIA FINANCEIRA, QUANDO O REQUERENTE DAS BENESSES DA JUSTICA GRATUITA ASSIM O DECLARE (ARTIGO 99, PARAGRAFO 3, DO CODIGO DE PROCESSO CIVIL), E CERTO QUE ESTA PRESUNCAO NAO E ABSOLUTA. NA HIPOTESE DOS AUTOS, AS CIRCUNSTANCIAS QUE DERAM ORIGEM AO PLEITO DEMANDAM ANALISE MAIS APROFUNDADA. ASSIM, DE ACORDO COM O ARTIGO 99, PARAGRAFO 2, DO CODIGO DE PROCESSO CIVIL, NO PRAZO DE 15 (QUINZE) DIAS, TRAGA O REQUERENTE AOS AUTOS DOCUMENTOS APTOS A COMPROVAR A ALEGADA INSUFICIENCIA DE RECURSOS, COMO COPIA DA CARTEIRA DE TRABALHO, EXTRATOS BANCARIOS E FATURAS DE CARTAO DE CREDITO, OU, NO MESMO PRAZO, RECOLHA AS CUSTAS INICIAIS, SOB PENA DE INDEFERIMENTO. INTIME-SE. ADVOGADOS(S): VITORIA DOS SANTOS TIECHER (OAB 115402/RS)",
                "PublishDate": "2023-06-29T00:00:00",
                "CaptureDate": "2023-07-01T18:52:43"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2023-06-28T00:00:00",
                "CaptureDate": "2023-07-01T18:52:43"
              },
              {
                "Content": "PROFERIDAS OUTRAS DECISOES NAO ESPECIFICADAS VISTOS. 1. DOU POR REGULARIZADA A REPRESENTACAO DO AUTOR. 2. DE ACORDO COM O ARTIGO 98 DO CODIGO DE PROCESSO CIVIL, \"A PESSOA NATURAL OU JURIDICA, BRASILEIRA OU ESTRANGEIRA, COM INSUFICIENCIA DE RECURSOS PARA PAGAR AS CUSTAS, AS DESPESAS PROCESSUAIS E OS HONORARIOS ADVOCATICIOS TEM DIREITO A GRATUIDADE DA JUSTICA, NA FORMA DA LEI\". E, EMBORA A LEI PRESUMA VERDADEIRA A ALEGACAO DA INSUFICIENCIA FINANCEIRA, QUANDO O REQUERENTE DAS BENESSES DA JUSTICA GRATUITA ASSIM O DECLARE (ARTIGO 99, PARAGRAFO 3, DO CODIGO DE PROCESSO CIVIL), E CERTO QUE ESTA PRESUNCAO NAO E ABSOLUTA. NA HIPOTESE DOS AUTOS, AS CIRCUNSTANCIAS QUE DERAM ORIGEM AO PLEITO DEMANDAM ANALISE MAIS APROFUNDADA. ASSIM, DE ACORDO COM O ARTIGO 99, PARAGRAFO 2, DO CODIGO DE PROCESSO CIVIL, NO PRAZO DE 15 (QUINZE) DIAS, TRAGA O REQUERENTE AOS AUTOS DOCUMENTOS APTOS A COMPROVAR A ALEGADA INSUFICIENCIA DE RECURSOS, COMO COPIA DA CARTEIRA DE TRABALHO, EXTRATOS BANCARIOS E FATURAS DE CARTAO DE CREDITO, OU, NO MESMO PRAZO, RECOLHA AS CUSTAS INICIAIS, SOB PENA DE INDEFERIMENTO. INTIME-SE.",
                "PublishDate": "2023-06-28T00:00:00",
                "CaptureDate": "2023-07-01T18:52:43"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WICS.23.70048239-6 TIPO DA PETICAO: PETICAO INTERMEDIARIA DATA: 27/06/2023 15:24",
                "PublishDate": "2023-06-27T00:00:00",
                "CaptureDate": "2023-07-01T18:52:43"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0485/2023 DATA DA PUBLICACAO: 21/06/2023 NUMERO DO DIARIO: 3760",
                "PublishDate": "2023-06-20T00:00:00",
                "CaptureDate": "2023-07-01T18:52:43"
              },
              {
                "Content": "PROCESSO : 1003601-66.2023.8.26.0268 CLASSE : PROCEDIMENTO COMUM CIVEL REQTE : GUSTAVO CAMARA MENDES ADVOGADO : 115402/RS - VITORIA DOS SANTOS TIECHER REQDO : STARK BANK S.A. VARA : 2 VARA PROCESSO 1003601-66.2023.8.26.0268 - PROCEDIMENTO COMUM CIVEL - INDENIZACAO POR DANO MATERIAL - GUSTAVO CAMARA MENDES - PRIMEIRAMENTE, DEVERA A PARTE AUTORA REGULARIZAR SUA REPRESENTACAO PROCESSUAL, JUNTANDO INSTRUMENTO DE MANDATO DEVIDAMENTE ASSINADO E COM FIRMA RECONHECIDA. ANOTO QUE O DOCUMENTO APRESENTADO AS FLS. 28/32 NAO PODE SER ACEITO PARA TAL FINALIDADE, POIS A ASSINATURA DIGITAL NAO CONTA COM CERTIFICACAO. NESSE SENTIDO: APELACAO - ACAO DECLARATORIA DE INEXISTENCIA DE DEBITO POR PRESCRICAO - SENTENCA QUE, RECONHECENDO A IRREGULARIDADE NA REPRESENTACAO PROCESSUAL DO AUTOR, JULGOU EXTINTO O PROCESSO, SEM RESOLUCAO DO MERITO - INSURGENCIA DO REQUERENTE - PROCURACAO ASSINADA DIGITALMENTE MEDIANTE UTILIZACAO DE CERTIFICADO CHAMADO DOCSIGN - AUSENCIA DE CERTIFICACAO POR AUTORIDADE CREDENCIADA NO AMBITO DA INFRAESTRUTURA DE CHAVES PUBLICAS BRASILEIRA - ICP-BRASIL - INVALIDADE DA RESPECTIVA ASSINATURA ELETRONICA - PRECEDENTES DESTA C. 38 CAMARA DE DIREITO PRIVADO - REQUERENTE QUE, MESMO DIANTE DE EXPRESSA DETERMINACAO PELO D. JUIZO A QUO, NAO PROCEDEU A REGULARIZACAO DE SUA REPRESENTACAO PROCESSUAL - DECRETO DE EXTINCAO REGULARMENTE PROFERIDO, NOS TERMOS DOS ARTIGOS 485, INCISO IV E 76, 1, INCISO I, DO CODIGO DE PROCESSO CIVIL - SENTENCA MANTIDA - RECURSO NAO PROVIDO.(TJSP; APELACAO CIVEL 1021445-70.2022.8.26.0007; RELATOR (A):LAVINIO DONIZETTI PASCHOALAO; ORGAO JULGADOR: 38 CAMARA DE DIREITO PRIVADO; FORO REGIONAL VII - ITAQUERA -1 VARA CIVEL; DATA DO JULGAMENTO: 31/03/2023; DATA DE REGISTRO: 31/03/2023) DA MESMA FORMA, A DECLARACAO DE POBREZA APRESENTADA PELA PARTE DEVERA SER CORRIGIDA, PARA APRECIACAO DO PEDIDO DE GRATUIDADE DE JUSTICA DEDUZIDO. PRAZO: 15 DIAS, SOB PENA DE INDEFERIMENTO. INTIME-SE. - ADV: VITORIA DOS SANTOS TIECHER (OAB 115402/RS)",
                "PublishDate": "2023-06-20T00:00:00",
                "CaptureDate": "2023-07-01T18:52:43"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2023-06-19T00:00:00",
                "CaptureDate": "2023-07-01T18:52:43"
              },
              {
                "Content": "PROFERIDAS OUTRAS DECISOES NAO ESPECIFICADAS PRIMEIRAMENTE, DEVERA A PARTE AUTORA REGULARIZAR SUA REPRESENTACAO PROCESSUAL, JUNTANDO INSTRUMENTO DE MANDATO DEVIDAMENTE ASSINADO E COM FIRMA RECONHECIDA. ANOTO QUE O DOCUMENTO APRESENTADO AS FLS. 28/32 NAO PODE SER ACEITO PARA TAL FINALIDADE, POIS A ASSINATURA DIGITAL NAO CONTA COM CERTIFICACAO. NESSE SENTIDO: APELACAO - ACAO DECLARATORIA DE INEXISTENCIA DE DEBITO POR PRESCRICAO - SENTENCA QUE, RECONHECENDO A IRREGULARIDADE NA REPRESENTACAO PROCESSUAL DO AUTOR, JULGOU EXTINTO O PROCESSO, SEM RESOLUCAO DO MERITO - INSURGENCIA DO REQUERENTE - PROCURACAO ASSINADA DIGITALMENTE MEDIANTE UTILIZACAO DE CERTIFICADO CHAMADO \"DOCSIGN\" - AUSENCIA DE CERTIFICACAO POR AUTORIDADE CREDENCIADA NO AMBITO DA INFRAESTRUTURA DE CHAVES PUBLICAS BRASILEIRA - ICP-BRASIL - INVALIDADE DA RESPECTIVA ASSINATURA ELETRONICA - PRECEDENTES DESTA C. 38 CAMARA DE DIREITO PRIVADO - REQUERENTE QUE, MESMO DIANTE DE EXPRESSA DETERMINACAO PELO D. JUIZO A QUO, NAO PROCEDEU A REGULARIZACAO DE SUA REPRESENTACAO PROCESSUAL - DECRETO DE EXTINCAO REGULARMENTE PROFERIDO, NOS TERMOS DOS ARTIGOS 485, INCISO IV E 76, 1, INCISO I, DO CODIGO DE PROCESSO CIVIL - SENTENCA MANTIDA - RECURSO NAO PROVIDO.(TJSP; APELACAO CIVEL 1021445-70.2022.8.26.0007; RELATOR (A):LAVINIO DONIZETTI PASCHOALAO; ORGAO JULGADOR: 38 CAMARA DE DIREITO PRIVADO; FORO REGIONAL VII - ITAQUERA -1 VARA CIVEL; DATA DO JULGAMENTO: 31/03/2023; DATA DE REGISTRO: 31/03/2023) DA MESMA FORMA, A DECLARACAO DE POBREZA APRESENTADA PELA PARTE DEVERA SER CORRIGIDA, PARA APRECIACAO DO PEDIDO DE GRATUIDADE DE JUSTICA DEDUZIDO. PRAZO: 15 DIAS, SOB PENA DE INDEFERIMENTO. INTIME-SE.",
                "PublishDate": "2023-06-19T00:00:00",
                "CaptureDate": "2023-07-01T18:52:43"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0485/2023 TEOR DO ATO: PRIMEIRAMENTE, DEVERA A PARTE AUTORA REGULARIZAR SUA REPRESENTACAO PROCESSUAL, JUNTANDO INSTRUMENTO DE MANDATO DEVIDAMENTE ASSINADO E COM FIRMA RECONHECIDA. ANOTO QUE O DOCUMENTO APRESENTADO AS FLS. 28/32 NAO PODE SER ACEITO PARA TAL FINALIDADE, POIS A ASSINATURA DIGITAL NAO CONTA COM CERTIFICACAO. NESSE SENTIDO: APELACAO - ACAO DECLARATORIA DE INEXISTENCIA DE DEBITO POR PRESCRICAO - SENTENCA QUE, RECONHECENDO A IRREGULARIDADE NA REPRESENTACAO PROCESSUAL DO AUTOR, JULGOU EXTINTO O PROCESSO, SEM RESOLUCAO DO MERITO - INSURGENCIA DO REQUERENTE - PROCURACAO ASSINADA DIGITALMENTE MEDIANTE UTILIZACAO DE CERTIFICADO CHAMADO \"DOCSIGN\" - AUSENCIA DE CERTIFICACAO POR AUTORIDADE CREDENCIADA NO AMBITO DA INFRAESTRUTURA DE CHAVES PUBLICAS BRASILEIRA - ICP-BRASIL - INVALIDADE DA RESPECTIVA ASSINATURA ELETRONICA - PRECEDENTES DESTA C. 38 CAMARA DE DIREITO PRIVADO - REQUERENTE QUE, MESMO DIANTE DE EXPRESSA DETERMINACAO PELO D. JUIZO A QUO, NAO PROCEDEU A REGULARIZACAO DE SUA REPRESENTACAO PROCESSUAL - DECRETO DE EXTINCAO REGULARMENTE PROFERIDO, NOS TERMOS DOS ARTIGOS 485, INCISO IV E 76, 1, INCISO I, DO CODIGO DE PROCESSO CIVIL - SENTENCA MANTIDA - RECURSO NAO PROVIDO.(TJSP; APELACAO CIVEL 1021445-70.2022.8.26.0007; RELATOR (A):LAVINIO DONIZETTI PASCHOALAO; ORGAO JULGADOR: 38 CAMARA DE DIREITO PRIVADO; FORO REGIONAL VII - ITAQUERA -1 VARA CIVEL; DATA DO JULGAMENTO: 31/03/2023; DATA DE REGISTRO: 31/03/2023) DA MESMA FORMA, A DECLARACAO DE POBREZA APRESENTADA PELA PARTE DEVERA SER CORRIGIDA, PARA APRECIACAO DO PEDIDO DE GRATUIDADE DE JUSTICA DEDUZIDO. PRAZO: 15 DIAS, SOB PENA DE INDEFERIMENTO. INTIME-SE. ADVOGADOS(S): VITORIA DOS SANTOS TIECHER (OAB 115402/RS)",
                "PublishDate": "2023-06-19T00:00:00",
                "CaptureDate": "2023-07-01T18:52:43"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-06-16T00:00:00",
                "CaptureDate": "2023-07-01T18:52:43"
              }
            ],
            "Petitions": [
              {
                "Type": "PETICAO INTERMEDIARIA",
                "Author": "",
                "CreationDate": "2023-06-27T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              }
            ],
            "Decisions": []
          },
          {
            "Number": "10781047720238260100",
            "Type": "PROCEDIMENTO COMUM",
            "MainSubject": "INDENIZACAO POR DANO MORAL",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "SAO PAULO",
            "JudgingBody": "15 VARA CIVEL",
            "State": "SP",
            "Status": "ATIVO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "INDENIZAÇÃO POR DANO MORAL",
            "InferredCNJSubjectNumber": 7779,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "INDENIZACAO POR DANO MORAL"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 20179.99,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-06-21T00:00:00",
            "NoticeDate": "2023-06-16T00:00:00",
            "LastMovementDate": "2023-06-21T00:00:00",
            "CaptureDate": "2023-07-02T12:47:04",
            "LastUpdate": "2023-07-02T12:47:04",
            "NumberOfParties": 7,
            "NumberOfUpdates": 6,
            "LawSuitAge": 257,
            "AverageNumberOfUpdatesPerMonth": 0,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "50036643890",
                "IsPartyActive": true,
                "Name": "MARIANA ARAUJO APRIGIO",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-07-02T12:47:04"
              },
              {
                "Doc": "07446073969",
                "IsPartyActive": true,
                "Name": "TABATA RIBEIRO BRITO MIQUELETTI",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "87889",
                  "State": "PR",
                  "SpecificType": "ADVOGADO (REQTE)"
                },
                "LastCaptureDate": "2023-07-02T12:47:04"
              },
              {
                "Doc": "45273682000144",
                "IsPartyActive": true,
                "Name": "INFLUENCIEI EDITORA LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-02T12:47:04"
              },
              {
                "Doc": "50080139809",
                "IsPartyActive": true,
                "Name": "GUSTAVO ALENCAR ROCHA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-02T12:47:04"
              },
              {
                "Doc": "20165400790",
                "IsPartyActive": true,
                "Name": "BRENDO DE SOUSA LOPES",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-02T12:47:04"
              },
              {
                "Doc": "36149947000378",
                "IsPartyActive": true,
                "Name": "KIWIFY EDUCACAO E TECNOLOGIA LTDA,",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-02T12:47:04"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-02T12:47:04"
              }
            ],
            "Updates": [
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0479/2023 DATA DA PUBLICACAO: 22/06/2023 NUMERO DO DIARIO: 3761",
                "PublishDate": "2023-06-21T00:00:00",
                "CaptureDate": "2023-07-02T12:47:04"
              },
              {
                "Content": "PROCESSO 1078104-77.2023.8.26.0100 - PROCEDIMENTO COMUM CIVEL - INDENIZACAO POR DANO MORAL - MARIANA ARAUJO APRIGIO - VISTOS. PARA APRECIACAO DO PEDIDO DE CONCESSAO DOS BENEFICIOS DA GRATUIDADE DA JUSTICA JUNTE A AUTORA, EM 15 DIAS, COMPROVANTE DE SUA REMUNERACAO MENSAL, DECLARACAO ATUAL DE IMPOSTO DE RENDA (COMPROVACAO DE QUE NAO CONSTA DA BASE DE DADOS DA RECEITA FEDERAL E DE REGULARIDADE DO CPF CASO SEJA ISENTO), EXTRATOS BANCARIOS E FATURAS DOS CARTOES DE CREDITO DOS ULTIMOS 3 MESES, SOB PENA DE INDEFERIMENTO DO PLEITO OU RECOLHA AS CUSTAS INICIAIS E DE CITACAO, COM A RESPECTIVA VINCULACAO DA GUIA DARE, SOB PENA DE CANCELAMENTO DA DISTRIBUICAO. NO MESMO PRAZO EMENDE A INICIAL PARA: A) REGULARIZAR SUA REPRESENTACAO PROCESSUAL SOB PENA DE EXTINCAO (NAO CONSTA ASSINATURA FISICA OU DIGITAL DA PROCURACAO DE FLS.37); B) QUANTIFICAR O PEDIDO DE DANOS MATERIAIS, ALTERANDO O VALOR DA CAUSA, SE O CASO; C) ESCLARECER DE FORMA OBJETIVA E SUCINTA A PARTICIPACAO DE CADA RE NOS FATOS DESCRITOS NA INICIAL, JA QUE NAO E POSSIVEL IDENTIFICAR QUAL A CAUSA DE PEDIR ATRIBUIDA A CADA UMA DELAS, JUNTANDO CERTIDAO DA JUCESP ATUALIZADA DE CADA RE, OBRIGACAO QUE CABE A PARTE, INDEPENDENTEMENTE DE EXPEDICAO DE OFICIO JUDICIAL; D) NARRAR CAUSA DE PEDIR QUE SE COADUNE A LEI PARA O PEDIDO DE DESCONSIDERACAO DA PERSONALIDADE JURIDICA DA CORRE INFLUENCIEI, SOB PENA DE PREVIO INDEFERIMENTO DO PROCESSAMENTO DESTE PEDIDO. TUDO CUMPRIDO, CONCLUSOS COM URGENCIA. INTIME-SE. - ADV: TABATA RIBEIRO BRITO MIQUELETTI (OAB 87889PR/)",
                "PublishDate": "2023-06-21T00:00:00",
                "CaptureDate": "2023-07-02T12:47:04"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0479/2023 TEOR DO ATO: VISTOS. PARA APRECIACAO DO PEDIDO DE CONCESSAO DOS BENEFICIOS DA GRATUIDADE DA JUSTICA JUNTE A AUTORA, EM 15 DIAS, COMPROVANTE DE SUA REMUNERACAO MENSAL, DECLARACAO ATUAL DE IMPOSTO DE RENDA (COMPROVACAO DE QUE NAO CONSTA DA BASE DE DADOS DA RECEITA FEDERAL E DE REGULARIDADE DO CPF CASO SEJA ISENTO), EXTRATOS BANCARIOS E FATURAS DOS CARTOES DE CREDITO DOS ULTIMOS 3 MESES, SOB PENA DE INDEFERIMENTO DO PLEITO OU RECOLHA AS CUSTAS INICIAIS E DE CITACAO, COM A RESPECTIVA VINCULACAO DA GUIA DARE, SOB PENA DE CANCELAMENTO DA DISTRIBUICAO. NO MESMO PRAZO EMENDE A INICIAL PARA: A) REGULARIZAR SUA REPRESENTACAO PROCESSUAL SOB PENA DE EXTINCAO (NAO CONSTA ASSINATURA FISICA OU DIGITAL DA PROCURACAO DE FLS.37); B) QUANTIFICAR O PEDIDO DE DANOS MATERIAIS, ALTERANDO O VALOR DA CAUSA, SE O CASO; C) ESCLARECER DE FORMA OBJETIVA E SUCINTA A PARTICIPACAO DE CADA RE NOS FATOS DESCRITOS NA INICIAL, JA QUE NAO E POSSIVEL IDENTIFICAR QUAL A CAUSA DE PEDIR ATRIBUIDA A CADA UMA DELAS, JUNTANDO CERTIDAO DA JUCESP ATUALIZADA DE CADA RE, OBRIGACAO QUE CABE A PARTE, INDEPENDENTEMENTE DE EXPEDICAO DE OFICIO JUDICIAL; D) NARRAR CAUSA DE PEDIR QUE SE COADUNE A LEI PARA O PEDIDO DE DESCONSIDERACAO DA PERSONALIDADE JURIDICA DA CORRE INFLUENCIEI, SOB PENA DE PREVIO INDEFERIMENTO DO PROCESSAMENTO DESTE PEDIDO. TUDO CUMPRIDO, CONCLUSOS COM URGENCIA. INTIME-SE. ADVOGADOS(S): TABATA RIBEIRO BRITO MIQUELETTI (OAB 87889PR/)",
                "PublishDate": "2023-06-20T00:00:00",
                "CaptureDate": "2023-07-02T12:47:04"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2023-06-19T00:00:00",
                "CaptureDate": "2023-07-02T12:47:04"
              },
              {
                "Content": "DETERMINADA A EMENDA A INICIAL VISTOS. PARA APRECIACAO DO PEDIDO DE CONCESSAO DOS BENEFICIOS DA GRATUIDADE DA JUSTICA JUNTE A AUTORA, EM 15 DIAS, COMPROVANTE DE SUA REMUNERACAO MENSAL, DECLARACAO ATUAL DE IMPOSTO DE RENDA (COMPROVACAO DE QUE NAO CONSTA DA BASE DE DADOS DA RECEITA FEDERAL E DE REGULARIDADE DO CPF CASO SEJA ISENTO), EXTRATOS BANCARIOS E FATURAS DOS CARTOES DE CREDITO DOS ULTIMOS 3 MESES, SOB PENA DE INDEFERIMENTO DO PLEITO OU RECOLHA AS CUSTAS INICIAIS E DE CITACAO, COM A RESPECTIVA VINCULACAO DA GUIA DARE, SOB PENA DE CANCELAMENTO DA DISTRIBUICAO. NO MESMO PRAZO EMENDE A INICIAL PARA: A) REGULARIZAR SUA REPRESENTACAO PROCESSUAL SOB PENA DE EXTINCAO (NAO CONSTA ASSINATURA FISICA OU DIGITAL DA PROCURACAO DE FLS.37); B) QUANTIFICAR O PEDIDO DE DANOS MATERIAIS, ALTERANDO O VALOR DA CAUSA, SE O CASO; C) ESCLARECER DE FORMA OBJETIVA E SUCINTA A PARTICIPACAO DE CADA RE NOS FATOS DESCRITOS NA INICIAL, JA QUE NAO E POSSIVEL IDENTIFICAR QUAL A CAUSA DE PEDIR ATRIBUIDA A CADA UMA DELAS, JUNTANDO CERTIDAO DA JUCESP ATUALIZADA DE CADA RE, OBRIGACAO QUE CABE A PARTE, INDEPENDENTEMENTE DE EXPEDICAO DE OFICIO JUDICIAL; D) NARRAR CAUSA DE PEDIR QUE SE COADUNE A LEI PARA O PEDIDO DE DESCONSIDERACAO DA PERSONALIDADE JURIDICA DA CORRE INFLUENCIEI, SOB PENA DE PREVIO INDEFERIMENTO DO PROCESSAMENTO DESTE PEDIDO. TUDO CUMPRIDO, CONCLUSOS COM URGENCIA. INTIME-SE.",
                "PublishDate": "2023-06-19T00:00:00",
                "CaptureDate": "2023-07-02T12:47:04"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-06-16T00:00:00",
                "CaptureDate": "2023-07-02T12:47:04"
              }
            ],
            "Petitions": [],
            "Decisions": []
          },
          {
            "Number": "10469651320238260002",
            "Type": "PROCEDIMENTO COMUM",
            "MainSubject": "RESPONSABILIDADE DO FORNECEDOR",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "SAO PAULO",
            "Judge": "LEONARDO FERNANDO DE SOUZA ALMEIDA",
            "JudgingBody": "2 VARA CIVEL",
            "State": "SP",
            "Status": "INDEFINIDO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "RESPONSABILIDADE DO FORNECEDOR",
            "InferredCNJSubjectNumber": 6220,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "RESPONSABILIDADE DO FORNECEDOR"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 14918.92,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-06-21T00:00:00",
            "NoticeDate": "2023-06-19T00:00:00",
            "LastMovementDate": "2023-06-22T00:00:00",
            "CaptureDate": "2023-07-02T12:53:54",
            "LastUpdate": "2023-07-02T12:53:54",
            "NumberOfParties": 7,
            "NumberOfUpdates": 6,
            "LawSuitAge": 254,
            "AverageNumberOfUpdatesPerMonth": 0,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "30035403861",
                "IsPartyActive": true,
                "Name": "LEONARDO FERNANDO DE SOUZA ALMEIDA",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-07-02T12:53:54"
              },
              {
                "Doc": "41047218836",
                "IsPartyActive": true,
                "Name": "LUIZ FERNANDES PROFETA DOOURADO",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-07-02T12:53:54"
              },
              {
                "IsPartyActive": true,
                "Name": "VANESSA CRISTINA BARBOSA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "285839",
                  "State": "SP",
                  "SpecificType": "ADVOGADA (REQTE)"
                },
                "LastCaptureDate": "2023-07-02T12:53:54"
              },
              {
                "Doc": "60872504000123",
                "IsPartyActive": true,
                "Name": "ITAU UNIBANCO HOLDING S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-02T12:53:54"
              },
              {
                "Doc": "22896431000110",
                "IsPartyActive": true,
                "Name": "PICPAY INSTITUICAO DE PAGAMENTO S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-02T12:53:54"
              },
              {
                "Doc": "13140088000199",
                "IsPartyActive": true,
                "Name": "ACESSO SOLUCOES DE PAGAMENTO S A INSTITUICAO DE PAGAMENTO",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-02T12:53:54"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-02T12:53:54"
              }
            ],
            "Updates": [
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0523/2023 DATA DA PUBLICACAO: 23/06/2023 NUMERO DO DIARIO: 3762",
                "PublishDate": "2023-06-22T00:00:00",
                "CaptureDate": "2023-07-02T12:53:55"
              },
              {
                "Content": "DETERMINADA A INCLUSAO DE PARTES NO CADASTRO DO PROCESSO DIGITAL E/OU RECATEGORIZACAO DE DOC. NA PASTA DO PROCESSO DIGI VISTOS. 1. OS DOCUMENTOS DE FLS. 29/31 PROVAM QUE A PARTE AUTORA TEM RENDIMENTO MEDIO MENSAL ACIMA DE R$ 4.000,00. ISSO REVELA QUE TEM CONDICOES DE ARCAR COM AS DESPESAS DO PROCESSO. DESTA FEITA, NEGO A GRATUIDADE DA JUSTICA. PRAZO DE 15 DIAS PARA A PARTE AUTORA COMPROVAR O RECOLHIMENTO DAS DESPESAS INICIAIS DO PROCESSO (TAXA JUDICIARIA E TAXA DE CITACAO POSTAL). 2. A CORRETA FORMACAO DOPROCESSO ELETRONICO E RESPONSABILIDADE DO ADVOGADO, NOS TERMOS DO ART. 9 DARESOLUCAO 551/2011 DO TJSP, DEVENDO, EM ESPECIAL, NOS TERMOS DO INCISO IV DO REFERIDO ARTIGO,SOB PENA DE REJEICAO: A)APRESENTAR AS PECAS E DOCUMENTOS EM CONFORMIDADECOMAS ESPECIFICACOES TECNICAS REGULAMENTADAS EM PORTARIA DA PRESIDENCIA DO TRIBUNAL DE JUSTICA DO ESTADO DE SAO PAULO (PORTARIA TJSP N 8.441/2011);B)NOMEAR AS PECAS E DOCUMENTOS DE ACORDO COM A LISTAGEM DISPONIBILIZADA NO SISTEMA INFORMATIZADO. NO CASO, NAO HOUVE A CORRETA NOMEACAO DAS PECAS E DOCUMENTOS DE FLS. 36/112. PRAZO DE 15 DIAS PARA REGULARIZACAO PELA PARTE DEMANDANTE, SOB PENA DE INDEFERIMENTO DA INICIAL. A RETIFICACAO OU INCLUSAO DEVERA SER VIA PETICIONAMENTO ELETRONICO, NO PORTAL E-SAJ: PETICIONAMENTO ELETRONICO/PETICIONE ELETRONICAMENTE/PETICIONAMENTO ELETRONICO DE 1 GRAU/COMPLEMENTO DE CADASTRO DE 1 GRAU, QUE PODERA PROCEDER A INLCUSAO DA PARTE E/OU RETIFICACAO DE PARTES NO CADASTRO PROCESSUAL E/OU RECATEGORIZACAO DE DOCUMENTOS NA PASTA DIGITAL (COMUNICADO CONJUNTO 1008/2019 DJE 22/07/2019). INTIME-SE.",
                "PublishDate": "2023-06-21T00:00:00",
                "CaptureDate": "2023-07-02T12:53:55"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0523/2023 TEOR DO ATO: VISTOS. 1. OS DOCUMENTOS DE FLS. 29/31 PROVAM QUE A PARTE AUTORA TEM RENDIMENTO MEDIO MENSAL ACIMA DE R$ 4.000,00. ISSO REVELA QUE TEM CONDICOES DE ARCAR COM AS DESPESAS DO PROCESSO. DESTA FEITA, NEGO A GRATUIDADE DA JUSTICA. PRAZO DE 15 DIAS PARA A PARTE AUTORA COMPROVAR O RECOLHIMENTO DAS DESPESAS INICIAIS DO PROCESSO (TAXA JUDICIARIA E TAXA DE CITACAO POSTAL). 2. A CORRETA FORMACAO DOPROCESSO ELETRONICO E RESPONSABILIDADE DO ADVOGADO, NOS TERMOS DO ART. 9 DARESOLUCAO 551/2011 DO TJSP, DEVENDO, EM ESPECIAL, NOS TERMOS DO INCISO IV DO REFERIDO ARTIGO,SOB PENA DE REJEICAO: A)APRESENTAR AS PECAS E DOCUMENTOS EM CONFORMIDADECOMAS ESPECIFICACOES TECNICAS REGULAMENTADAS EM PORTARIA DA PRESIDENCIA DO TRIBUNAL DE JUSTICA DO ESTADO DE SAO PAULO (PORTARIA TJSP N 8.441/2011);B)NOMEAR AS PECAS E DOCUMENTOS DE ACORDO COM A LISTAGEM DISPONIBILIZADA NO SISTEMA INFORMATIZADO. NO CASO, NAO HOUVE A CORRETA NOMEACAO DAS PECAS E DOCUMENTOS DE FLS. 36/112. PRAZO DE 15 DIAS PARA REGULARIZACAO PELA PARTE DEMANDANTE, SOB PENA DE INDEFERIMENTO DA INICIAL. A RETIFICACAO OU INCLUSAO DEVERA SER VIA PETICIONAMENTO ELETRONICO, NO PORTAL E-SAJ: PETICIONAMENTO ELETRONICO/PETICIONE ELETRONICAMENTE/PETICIONAMENTO ELETRONICO DE 1 GRAU/COMPLEMENTO DE CADASTRO DE 1 GRAU, QUE PODERA PROCEDER A INLCUSAO DA PARTE E/OU RETIFICACAO DE PARTES NO CADASTRO PROCESSUAL E/OU RECATEGORIZACAO DE DOCUMENTOS NA PASTA DIGITAL (COMUNICADO CONJUNTO 1008/2019 DJE 22/07/2019). INTIME-SE. ADVOGADOS(S): VANESSA CRISTINA BARBOSA (OAB 285839/SP)",
                "PublishDate": "2023-06-21T00:00:00",
                "CaptureDate": "2023-07-02T12:53:55"
              },
              {
                "Content": "PROCESSO : 1046965-13.2023.8.26.0002 CLASSE : PROCEDIMENTO COMUM CIVEL REQTE : LUIZ FERNANDES PROFETA DOOURADO ADVOGADO : 285839/SP - VANESSA CRISTINA BARBOSA REQDO : STARK BANK S.A. VARA : 2 VARA CIVEL",
                "PublishDate": "2023-06-21T00:00:00",
                "CaptureDate": "2023-07-02T12:53:54"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-06-19T00:00:00",
                "CaptureDate": "2023-07-02T12:53:55"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2023-06-19T00:00:00",
                "CaptureDate": "2023-07-02T12:53:55"
              }
            ],
            "Petitions": [],
            "Decisions": [
              {
                "DecisionContent": "NEGO A GRATUIDADE DA JUSTICA.",
                "DecisionDate": "2023-06-21T00:00:00"
              },
              {
                "DecisionContent": "NEGO A GRATUIDADE DA JUSTICA.",
                "DecisionDate": "2023-06-21T00:00:00"
              }
            ]
          },
          {
            "Number": "10046659320238260565",
            "Type": "PROCEDIMENTO COMUM",
            "MainSubject": "INDENIZACAO POR DANO MORAL",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "SAO CAETANO DO SUL",
            "Judge": "DAGOBERTO JERONIMO DO NASCIMENTO",
            "JudgingBody": "5 VARA CIVEL",
            "State": "SP",
            "Status": "ATIVO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "INDENIZAÇÃO POR DANO MORAL",
            "InferredCNJSubjectNumber": 7779,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "INDENIZACAO POR DANO MORAL"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 10045,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-06-22T00:00:00",
            "NoticeDate": "2023-06-20T00:00:00",
            "LastMovementDate": "2023-06-27T00:00:00",
            "CaptureDate": "2023-07-03T05:48:42",
            "LastUpdate": "2023-07-03T05:48:42",
            "NumberOfParties": 5,
            "NumberOfUpdates": 7,
            "LawSuitAge": 253,
            "AverageNumberOfUpdatesPerMonth": 0,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "02127170814",
                "IsPartyActive": true,
                "Name": "DAGOBERTO JERONIMO DO NASCIMENTO",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-07-03T05:48:42"
              },
              {
                "Doc": "51596452846",
                "IsPartyActive": true,
                "Name": "JAQUELINE CARDOSO DA COSTA",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-07-03T05:48:42"
              },
              {
                "Doc": "07446073969",
                "IsPartyActive": true,
                "Name": "TABATA RIBEIRO BRITO MIQUELETTI",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "87889",
                  "State": "PR",
                  "SpecificType": "ADVOGADA (REQTE)"
                },
                "LastCaptureDate": "2023-07-03T05:48:42"
              },
              {
                "Doc": "18490448000104",
                "IsPartyActive": true,
                "Name": "WUDI PAY CORRESPONDENTE DE INSTITUICAO FINANCEIRA LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-03T05:48:42"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-03T05:48:42"
              }
            ],
            "Updates": [
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WSCS.23.70068415-0 TIPO DA PETICAO: PETICAO INTERMEDIARIA DATA: 27/06/2023 15:51",
                "PublishDate": "2023-06-27T00:00:00",
                "CaptureDate": "2023-07-03T05:48:42"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0478/2023 TEOR DO ATO: VISTOS. PROVIDENCIE A REQUERENTE, NO PRAZO DE QUINZE(15) DIAS, JUNTANDO A PROCURACAO DEVIDAMENTE ASSINADA EM SEU NOME, SOB PENA DE INDEFERIMENTO DA INICIAL. P.INT. ADVOGADOS(S): TABATA RIBEIRO BRITO MIQUELETTI (OAB 87889/PR)",
                "PublishDate": "2023-06-22T00:00:00",
                "CaptureDate": "2023-07-03T05:48:42"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0478/2023 DATA DA PUBLICACAO: 26/06/2023 NUMERO DO DIARIO: 3763",
                "PublishDate": "2023-06-22T00:00:00",
                "CaptureDate": "2023-07-03T05:48:42"
              },
              {
                "Content": "PROCESSO : 1004665-93.2023.8.26.0565 CLASSE : PROCEDIMENTO COMUM CIVEL REQTE : JAQUELINE CARDOSO DA COSTA ADVOGADO : 87889/PR - TABATA RIBEIRO BRITO MIQUELETTI REQDO : WUDI PAY CORRESPONDENTE DE INSTITUICAO FINANCEIRA LTDA. VARA : 5 VARA CIVEL",
                "PublishDate": "2023-06-22T00:00:00",
                "CaptureDate": "2023-07-03T05:48:42"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2023-06-21T00:00:00",
                "CaptureDate": "2023-07-03T05:48:42"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE VISTOS. PROVIDENCIE A REQUERENTE, NO PRAZO DE QUINZE(15) DIAS, JUNTANDO A PROCURACAO DEVIDAMENTE ASSINADA EM SEU NOME, SOB PENA DE INDEFERIMENTO DA INICIAL. P.INT.",
                "PublishDate": "2023-06-21T00:00:00",
                "CaptureDate": "2023-07-03T05:48:42"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-06-20T00:00:00",
                "CaptureDate": "2023-07-03T05:48:42"
              }
            ],
            "Petitions": [
              {
                "Type": "PETICAO INTERMEDIARIA",
                "Author": "",
                "CreationDate": "2023-06-27T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              }
            ],
            "Decisions": []
          },
          {
            "Number": "10808069320238260100",
            "Type": "PROCEDIMENTO COMUM",
            "MainSubject": "PRATICAS ABUSIVAS",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "SAO PAULO",
            "Judge": "FELIPE POYARES MIRANDA",
            "JudgingBody": "16 VARA CIVEL",
            "State": "SP",
            "Status": "ATIVO",
            "LawsuitHostService": "ESAJ",
            "RelatedLawsuits": [
              "1113992-44.2022.8.26.0100"
            ],
            "InferredCNJSubjectName": "PRÁTICAS ABUSIVAS",
            "InferredCNJSubjectNumber": 11811,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "PRATICAS ABUSIVAS"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 77525.32,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-06-26T00:00:00",
            "NoticeDate": "2023-06-21T00:00:00",
            "LastMovementDate": "2023-06-26T00:00:00",
            "CaptureDate": "2023-07-05T08:58:04",
            "LastUpdate": "2023-07-05T08:58:04",
            "NumberOfParties": 20,
            "NumberOfUpdates": 9,
            "LawSuitAge": 252,
            "AverageNumberOfUpdatesPerMonth": 1,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "31934957860",
                "IsPartyActive": true,
                "Name": "FELIPE POYARES MIRANDA",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-07-05T08:58:04"
              },
              {
                "Doc": "26790530444",
                "IsPartyActive": true,
                "Name": "MARIA DO CARMELO VASCONCELOS DE SANTANA",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-07-05T08:58:04"
              },
              {
                "Doc": "19994691864",
                "IsPartyActive": true,
                "Name": "PAULO QUINTILIANO DA SILVA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "397894",
                  "State": "SP",
                  "SpecificType": "ADVOGADO (REQTE)"
                },
                "LastCaptureDate": "2023-07-05T08:58:04"
              },
              {
                "IsPartyActive": true,
                "Name": "RAFAEL QUINTINO DA SILVA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-05T08:58:04"
              },
              {
                "Doc": "48522279691",
                "IsPartyActive": true,
                "Name": "EDUARDO RAYMUNDO XAVIER",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-05T08:58:04"
              },
              {
                "Doc": "94005664849",
                "IsPartyActive": true,
                "Name": "FRANCISCO VASCONCELOS DA COSTA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-05T08:58:04"
              },
              {
                "Doc": "09398483840",
                "IsPartyActive": true,
                "Name": "EDUARDO ANGELO DE CASTRO",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-05T08:58:04"
              },
              {
                "IsPartyActive": true,
                "Name": "MARCOS CORREIA DA SILVA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-05T08:58:04"
              },
              {
                "Doc": "87814102472",
                "IsPartyActive": true,
                "Name": "LERINALDO ANTONIO DE OLIVEIRA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-05T08:58:04"
              },
              {
                "Doc": "36275807881",
                "IsPartyActive": true,
                "Name": "CRISTIANO SABINO DA CONCEICAO",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-05T08:58:04"
              },
              {
                "IsPartyActive": true,
                "Name": "NELSON LIMA DA SILVA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-05T08:58:04"
              },
              {
                "IsPartyActive": true,
                "Name": "RICARDO MARTINS DE LIMA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-05T08:58:04"
              },
              {
                "IsPartyActive": true,
                "Name": "BRUNO DA COSTA SANTANA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-05T08:58:04"
              },
              {
                "Doc": "44649640873",
                "IsPartyActive": true,
                "Name": "BRENO CESAR DO CARMO",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-05T08:58:04"
              },
              {
                "Doc": "14994399000188",
                "IsPartyActive": true,
                "Name": "OCTOS CONSULTORIA ESTRATEGICA LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-05T08:58:04"
              },
              {
                "Doc": "24313102000125",
                "IsPartyActive": true,
                "Name": "99PAY INSTITUICAO DE PAGAMENTOS S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-05T08:58:04"
              },
              {
                "Doc": "00000000000191",
                "IsPartyActive": true,
                "Name": "BANCO DO BRASIL S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-05T08:58:04"
              },
              {
                "IsPartyActive": true,
                "Name": "BEPAY INSTITUICAO DE PAGAMENTO",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-05T08:58:04"
              },
              {
                "Doc": "13140088000199",
                "IsPartyActive": true,
                "Name": "ACESSO SOLUCOES DE PAGAMENTO S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-05T08:58:04"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-05T08:58:04"
              }
            ],
            "Updates": [
              {
                "Content": "PROCESSO 1080806-93.2023.8.26.0100 - PROCEDIMENTO COMUM CIVEL - PRATICAS ABUSIVAS - MARIA DO CARMELO VASCONCELOS DE SANTANA - VISTOS. TRATA-SE DE ACAO DE RESTITUICAO DE VALORES C/C OBRIGACAO DE FAZER E REPARACAO DE DANOS MORAIS, EM QUE A AUTORA ALEGA TER SIDO VITIMA DE FRAUDE PERPETRADA PELOS REUS, TENDO DISTRIBUIDO A ACAO A ESTE JUIZO POR DEPENDENCIA AO PROCESSO DE N 1113992-44.2022.8.26.0100. CONFORME DISPOE O ART. 55, CAPUT , DO CODIGO DE PROCESSO CIVIL, REPUTAM-SE CONEXAS DUAS OU MAIS ACOES QUANDO LHES FOR COMUM O PEDIDO OU A CAUSA DE PEDIR. NESSE SENTIDO, O PRINCIPAL OBJETIVO DA NORMA, AO DETERMINAR A REUNIAO DE PROCESSOS, E EVITAR QUE SEJAM PROFERIDAS DECISOES CONFLITANTES, POR JUIZOS DISTINTOS, EM CASOS QUE TENHAM RELACAO. OCORRE QUE, NO PRESENTE CASO, VERIFICA-SE JA TER SIDO PROFERIDA SENTENCA NO PROCESSO DE N 11113992-44.2022.8.26.0100, E EM CONSEQUENCIA, FOI DECLARADO EXTINTO O PROCESSO COM RESOLUCAO DO MERITO, NOS TERMOS DO ARTIGO 487, INCISO I DO CODIGO DE PROCESSO CIVIL, DE MODO QUE NAO HA RAZAO PARA A REUNIAO DE PROCESSOS. PORTANTO, APLICA-SE, NA HIPOTESE, O VERBETE DA SUMULA 235 DO SUPERIOR TRIBUNAL DE JUSTICA, POSITIVADO, AGORA, NO COMANDO LEGAL DO ART. 55,  1, PARTE FINAL, DO CODIGO DE PROCESSO CIVIL, VERBIS: ART. 55. REPUTAM-SE CONEXAS 2 (DUAS) OU MAIS ACOES QUANDO LHES FOR COMUM O PEDIDO OU A CAUSA DE PEDIR.  1 OS PROCESSOS DE ACOES CONEXAS SERAO REUNIDOS PARA DECISAO CONJUNTA, SALVO SE UM DELES JA HOUVER SIDO SENTENCIADO. NESSE SENTIDO:CONFLITO NEGATIVO DE COMPETENCIA ACAO DE GUARDA COM LIMINAR DE BUSCA E APREENSAO DE MENOR POR ALIENACAO PARENTAL COM PEDIDO DE TUTELA ANTECIPADA DEMANDA DISTRIBUIDA LIVREMENTE DETERMINACAO DE REDISTRIBUICAO, POR DEPENDENCIA, EM RAZAO DE SUPOSTA CONEXAO COM ANTERIOR ACAO DE ALIMENTOS, REGULAMENTACAO DE GUARDA E PEDIDO DE DECRETACAO DE DIVORCIO CONSENSUAL, HOMOLOGADO POR SENTENCA PELO JUIZO SUSCITANTE - IMPOSSIBILIDADE DE REUNIAO DE FEITOS SE UM DELES JA HOUVER SIDO SENTENCIADO INCIDENCIA DA REGRA DO ARTIGO 55,  1, CPC E DO ENTENDIMENTO DA SUMULA 235, STJ CONFLITO CONHECIDO PARA DECLARAR A COMPETENCIA DO JUIZO SUSCITADO.(TJSP; CONFLITO DE COMPETENCIA CIVEL 0040547-19.2022.8.26.0000; RELATOR (A):FRANCISCO BRUNO (PRES. SECAO DE DIREITO CRIMINAL); ORGAO JULGADOR: CAMARA ESPECIAL; FORO DE MAIRIPORA -1 VARA; DATA DO JULGAMENTO: 21/03/2023; DATA DE REGISTRO: 21/03/2023) AGRAVO DE INSTRUMENTO. ACAO DECLARATORIA. PEDIDO DE CONEXAO. INADMISSIBILIDADE. EM NOSSO SISTEMA PROCESSUAL, NAO HA PREVENCAO A JUSTIFICAR A DISTRIBUICAO POR DEPENDENCIA DE NOVA ACAO COM OUTRA JA SENTENCIADA. AUSENCIA DE CONEXAO. ART. 55,  1, DO CPC. RECURSO NAO PROVIDO.(TJSP; AGRAVO DE INSTRUMENTO 2286190-16.2021.8.26.0000; RELATOR (A):MIGUEL PETRONI NETO; ORGAO JULGADOR: 16 CAMARA DE DIREITO PRIVADO; FORO DE FRANCA -3. VARA CIVEL; DATA DO JULGAMENTO: 24/05/2022; DATA DE REGISTRO: 29/05/2022) PELO EXPOSTO, REDISTRIBUAM-SE OS AUTOS LIVREMENTE. INT. - ADV: PAULO QUINTILIANO DA SILVA (OAB 397894/SP) PROCESSO 1080806-93.2023.8.26.0100 - PROCEDIMENTO COMUM CIVEL - PRATICAS ABUSIVAS - MARIA DO CARMELO VASCONCELOS DE SANTANA - VISTOS. POR ORA, REITERO R. DECISAO RETRO. INT. - ADV: PAULO QUINTILIANO DA SILVA (OAB 397894/SP)",
                "PublishDate": "2023-06-26T00:00:00",
                "CaptureDate": "2023-07-05T08:58:04"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0554/2023 DATA DA PUBLICACAO: 27/06/2023 NUMERO DO DIARIO: 3764",
                "PublishDate": "2023-06-24T00:00:00",
                "CaptureDate": "2023-07-05T08:58:05"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0554/2023 TEOR DO ATO: VISTOS. TRATA-SE DE ACAO DE RESTITUICAO DE VALORES C/C OBRIGACAO DE FAZER E REPARACAO DE DANOS MORAIS, EM QUE A AUTORA ALEGA TER SIDO VITIMA DE FRAUDE PERPETRADA PELOS REUS, TENDO DISTRIBUIDO A ACAO A ESTE JUIZO POR DEPENDENCIA AO PROCESSO DE N 1113992-44.2022.8.26.0100. CONFORME DISPOE O ART. 55, CAPUT , DO CODIGO DE PROCESSO CIVIL, REPUTAM-SE CONEXAS DUAS OU MAIS ACOES QUANDO LHES FOR COMUM O PEDIDO OU A CAUSA DE PEDIR. NESSE SENTIDO, O PRINCIPAL OBJETIVO DA NORMA, AO DETERMINAR A REUNIAO DE PROCESSOS, E EVITAR QUE SEJAM PROFERIDAS DECISOES CONFLITANTES, POR JUIZOS DISTINTOS, EM CASOS QUE TENHAM RELACAO. OCORRE QUE, NO PRESENTE CASO, VERIFICA-SE JA TER SIDO PROFERIDA SENTENCA NO PROCESSO DE N 11113992-44.2022.8.26.0100, E EM CONSEQUENCIA, FOI DECLARADO EXTINTO O PROCESSO COM RESOLUCAO DO MERITO, NOS TERMOS DO ARTIGO 487, INCISO I DO CODIGO DE PROCESSO CIVIL, DE MODO QUE NAO HA RAZAO PARA A REUNIAO DE PROCESSOS. PORTANTO, APLICA-SE, NA HIPOTESE, O VERBETE DA SUMULA 235 DO SUPERIOR TRIBUNAL DE JUSTICA, POSITIVADO, AGORA, NO COMANDO LEGAL DO ART. 55,  1, PARTE FINAL, DO CODIGO DE PROCESSO CIVIL, VERBIS: ART. 55. REPUTAM-SE CONEXAS 2 (DUAS) OU MAIS ACOES QUANDO LHES FOR COMUM O PEDIDO OU A CAUSA DE PEDIR.  1 OS PROCESSOS DE ACOES CONEXAS SERAO REUNIDOS PARA DECISAO CONJUNTA, SALVO SE UM DELES JA HOUVER SIDO SENTENCIADO. NESSE SENTIDO:CONFLITO NEGATIVO DE COMPETENCIA ACAO DE GUARDA COM LIMINAR DE BUSCA E APREENSAO DE MENOR POR ALIENACAO PARENTAL COM PEDIDO DE TUTELA ANTECIPADA DEMANDA DISTRIBUIDA LIVREMENTE DETERMINACAO DE REDISTRIBUICAO, POR DEPENDENCIA, EM RAZAO DE SUPOSTA CONEXAO COM ANTERIOR ACAO DE ALIMENTOS, REGULAMENTACAO DE GUARDA E PEDIDO DE DECRETACAO DE DIVORCIO CONSENSUAL, HOMOLOGADO POR SENTENCA PELO JUIZO SUSCITANTE - IMPOSSIBILIDADE DE REUNIAO DE FEITOS SE UM DELES JA HOUVER SIDO SENTENCIADO INCIDENCIA DA REGRA DO ARTIGO 55,  1, CPC E DO ENTENDIMENTO DA SUMULA 235, STJ CONFLITO CONHECIDO PARA DECLARAR A COMPETENCIA DO JUIZO SUSCITADO.(TJSP; CONFLITO DE COMPETENCIA CIVEL 0040547-19.2022.8.26.0000; RELATOR (A):FRANCISCO BRUNO (PRES. SECAO DE DIREITO CRIMINAL); ORGAO JULGADOR: CAMARA ESPECIAL; FORO DE MAIRIPORA -1 VARA; DATA DO JULGAMENTO: 21/03/2023; DATA DE REGISTRO: 21/03/2023) AGRAVO DE INSTRUMENTO. ACAO DECLARATORIA. PEDIDO DE CONEXAO. INADMISSIBILIDADE. EM NOSSO SISTEMA PROCESSUAL, NAO HA PREVENCAO A JUSTIFICAR A DISTRIBUICAO POR DEPENDENCIA DE NOVA ACAO COM OUTRA JA SENTENCIADA. AUSENCIA DE CONEXAO. ART. 55,  1, DO CPC. RECURSO NAO PROVIDO.(TJSP; AGRAVO DE INSTRUMENTO 2286190-16.2021.8.26.0000; RELATOR (A):MIGUEL PETRONI NETO; ORGAO JULGADOR: 16 CAMARA DE DIREITO PRIVADO; FORO DE FRANCA -3. VARA CIVEL; DATA DO JULGAMENTO: 24/05/2022; DATA DE REGISTRO: 29/05/2022) PELO EXPOSTO, REDISTRIBUAM-SE OS AUTOS LIVREMENTE. INT. ADVOGADOS(S): PAULO QUINTILIANO DA SILVA (OAB 397894/SP)",
                "PublishDate": "2023-06-23T00:00:00",
                "CaptureDate": "2023-07-05T08:58:05"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0554/2023 TEOR DO ATO: VISTOS. POR ORA, REITERO R. DECISAO RETRO. INT. ADVOGADOS(S): PAULO QUINTILIANO DA SILVA (OAB 397894/SP)",
                "PublishDate": "2023-06-23T00:00:00",
                "CaptureDate": "2023-07-05T08:58:05"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.23.41208024-1 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 22/06/2023 13:12",
                "PublishDate": "2023-06-22T00:00:00",
                "CaptureDate": "2023-07-05T08:58:05"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2023-06-22T00:00:00",
                "CaptureDate": "2023-07-05T08:58:05"
              },
              {
                "Content": "PROFERIDAS OUTRAS DECISOES NAO ESPECIFICADAS VISTOS. TRATA-SE DE ACAO DE RESTITUICAO DE VALORES C/C OBRIGACAO DE FAZER E REPARACAO DE DANOS MORAIS, EM QUE A AUTORA ALEGA TER SIDO VITIMA DE FRAUDE PERPETRADA PELOS REUS, TENDO DISTRIBUIDO A ACAO A ESTE JUIZO POR DEPENDENCIA AO PROCESSO DE N 1113992-44.2022.8.26.0100. CONFORME DISPOE O ART. 55, CAPUT , DO CODIGO DE PROCESSO CIVIL, REPUTAM-SE CONEXAS DUAS OU MAIS ACOES QUANDO LHES FOR COMUM O PEDIDO OU A CAUSA DE PEDIR. NESSE SENTIDO, O PRINCIPAL OBJETIVO DA NORMA, AO DETERMINAR A REUNIAO DE PROCESSOS, E EVITAR QUE SEJAM PROFERIDAS DECISOES CONFLITANTES, POR JUIZOS DISTINTOS, EM CASOS QUE TENHAM RELACAO. OCORRE QUE, NO PRESENTE CASO, VERIFICA-SE JA TER SIDO PROFERIDA SENTENCA NO PROCESSO DE N 11113992-44.2022.8.26.0100, E EM CONSEQUENCIA, FOI DECLARADO EXTINTO O PROCESSO COM RESOLUCAO DO MERITO, NOS TERMOS DO ARTIGO 487, INCISO I DO CODIGO DE PROCESSO CIVIL, DE MODO QUE NAO HA RAZAO PARA A REUNIAO DE PROCESSOS. PORTANTO, APLICA-SE, NA HIPOTESE, O VERBETE DA SUMULA 235 DO SUPERIOR TRIBUNAL DE JUSTICA, POSITIVADO, AGORA, NO COMANDO LEGAL DO ART. 55,  1, PARTE FINAL, DO CODIGO DE PROCESSO CIVIL, VERBIS: ART. 55. REPUTAM-SE CONEXAS 2 (DUAS) OU MAIS ACOES QUANDO LHES FOR COMUM O PEDIDO OU A CAUSA DE PEDIR.  1 OS PROCESSOS DE ACOES CONEXAS SERAO REUNIDOS PARA DECISAO CONJUNTA, SALVO SE UM DELES JA HOUVER SIDO SENTENCIADO. NESSE SENTIDO:CONFLITO NEGATIVO DE COMPETENCIA ACAO DE GUARDA COM LIMINAR DE BUSCA E APREENSAO DE MENOR POR ALIENACAO PARENTAL COM PEDIDO DE TUTELA ANTECIPADA DEMANDA DISTRIBUIDA LIVREMENTE DETERMINACAO DE REDISTRIBUICAO, POR DEPENDENCIA, EM RAZAO DE SUPOSTA CONEXAO COM ANTERIOR ACAO DE ALIMENTOS, REGULAMENTACAO DE GUARDA E PEDIDO DE DECRETACAO DE DIVORCIO CONSENSUAL, HOMOLOGADO POR SENTENCA PELO JUIZO SUSCITANTE - IMPOSSIBILIDADE DE REUNIAO DE FEITOS SE UM DELES JA HOUVER SIDO SENTENCIADO INCIDENCIA DA REGRA DO ARTIGO 55,  1, CPC E DO ENTENDIMENTO DA SUMULA 235, STJ CONFLITO CONHECIDO PARA DECLARAR A COMPETENCIA DO JUIZO SUSCITADO.(TJSP; CONFLITO DE COMPETENCIA CIVEL 0040547-19.2022.8.26.0000; RELATOR (A):FRANCISCO BRUNO (PRES. SECAO DE DIREITO CRIMINAL); ORGAO JULGADOR: CAMARA ESPECIAL; FORO DE MAIRIPORA -1 VARA; DATA DO JULGAMENTO: 21/03/2023; DATA DE REGISTRO: 21/03/2023) AGRAVO DE INSTRUMENTO. ACAO DECLARATORIA. PEDIDO DE CONEXAO. INADMISSIBILIDADE. EM NOSSO SISTEMA PROCESSUAL, NAO HA PREVENCAO A JUSTIFICAR A DISTRIBUICAO POR DEPENDENCIA DE NOVA ACAO COM OUTRA JA SENTENCIADA. AUSENCIA DE CONEXAO. ART. 55,  1, DO CPC. RECURSO NAO PROVIDO.(TJSP; AGRAVO DE INSTRUMENTO 2286190-16.2021.8.26.0000; RELATOR (A):MIGUEL PETRONI NETO; ORGAO JULGADOR: 16 CAMARA DE DIREITO PRIVADO; FORO DE FRANCA -3. VARA CIVEL; DATA DO JULGAMENTO: 24/05/2022; DATA DE REGISTRO: 29/05/2022) PELO EXPOSTO, REDISTRIBUAM-SE OS AUTOS LIVREMENTE. INT.",
                "PublishDate": "2023-06-22T00:00:00",
                "CaptureDate": "2023-07-05T08:58:05"
              },
              {
                "Content": "PROFERIDAS OUTRAS DECISOES NAO ESPECIFICADAS VISTOS. POR ORA, REITERO R. DECISAO RETRO. INT.",
                "PublishDate": "2023-06-22T00:00:00",
                "CaptureDate": "2023-07-05T08:58:05"
              },
              {
                "Content": "DISTRIBUIDO POR DEPENDENCIA (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR) CPC, ART. 286, I.",
                "PublishDate": "2023-06-21T00:00:00",
                "CaptureDate": "2023-07-05T08:58:05"
              }
            ],
            "Petitions": [
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2023-06-22T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              }
            ],
            "Decisions": []
          },
          {
            "Number": "10298439720238260224",
            "Type": "PROCEDIMENTO COMUM",
            "MainSubject": "INDENIZACAO POR DANO MATERIAL",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "GUARULHOS",
            "Judge": "BEATRIZ DE SOUZA CABEZAS",
            "JudgingBody": "4 VARA CIVEL",
            "State": "SP",
            "Status": "ATIVO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "INDENIZAÇÃO POR DANO MATERIAL",
            "InferredCNJSubjectNumber": 7780,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "INDENIZACAO POR DANO MATERIAL",
              "INDENIZACAO POR DANO MORAL"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 231865.5,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-06-26T00:00:00",
            "NoticeDate": "2023-06-23T00:00:00",
            "LastMovementDate": "2023-07-04T00:00:00",
            "CaptureDate": "2023-07-05T11:16:43",
            "LastUpdate": "2023-07-05T11:16:43",
            "NumberOfParties": 13,
            "NumberOfUpdates": 7,
            "LawSuitAge": 250,
            "AverageNumberOfUpdatesPerMonth": 0,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "12569655880",
                "IsPartyActive": true,
                "Name": "BEATRIZ DE SOUZA CABEZAS",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-07-05T11:16:43"
              },
              {
                "Doc": "06667756642",
                "IsPartyActive": true,
                "Name": "DANIELLE CHRISTINIE FARIA FERREIRA FERNANDES",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-07-05T11:16:43"
              },
              {
                "Doc": "45800910600",
                "IsPartyActive": true,
                "Name": "FRANCISCO DE FREITAS MOURAO",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-07-05T11:16:43"
              },
              {
                "Doc": "80741037220",
                "IsPartyActive": true,
                "Name": "INGRID LIMA NEGREIROS",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-07-05T11:16:43"
              },
              {
                "IsPartyActive": true,
                "Name": "LUIS SARAIVA FARIA FERREIRA",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-07-05T11:16:43"
              },
              {
                "Doc": "09349282666",
                "IsPartyActive": true,
                "Name": "NALLYNE RIBEIRO COSTA FERREIRA",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-07-05T11:16:43"
              },
              {
                "Doc": "38316591847",
                "IsPartyActive": true,
                "Name": "RAQUEL ROSANGELA DOS SANTOS",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-07-05T11:16:43"
              },
              {
                "Doc": "04539059866",
                "IsPartyActive": true,
                "Name": "EVERALDO TADEU QUILICI GONZALEZ",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "79617",
                  "State": "SP",
                  "SpecificType": "ADVOGADO (REQTE)"
                },
                "LastCaptureDate": "2023-07-05T11:16:43"
              },
              {
                "IsPartyActive": true,
                "Name": "GENESIS ITN BRAZIL",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-05T11:16:43"
              },
              {
                "Doc": "37512394000177",
                "IsPartyActive": true,
                "Name": "BINANCE FINTECH SERVICOS DE TECNOLOGIA LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-05T11:16:43"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-05T11:16:43"
              },
              {
                "Doc": "71027866000304",
                "IsPartyActive": true,
                "Name": "BANCO BS2 S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-05T11:16:43"
              },
              {
                "Doc": "13935893000109",
                "IsPartyActive": true,
                "Name": "CELCOIN PAGAMENTOS S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-05T11:16:43"
              }
            ],
            "Updates": [
              {
                "Content": "PEDIDO DE HABILITACAO JUNTADO N PROTOCOLO: WGRU.23.70416609-0 TIPO DA PETICAO: PEDIDO DE HABILITACAO DATA: 04/07/2023 10:56",
                "PublishDate": "2023-07-04T00:00:00",
                "CaptureDate": "2023-07-05T11:16:43"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0550/2023 DATA DA PUBLICACAO: 29/06/2023 NUMERO DO DIARIO: 3766",
                "PublishDate": "2023-06-28T00:00:00",
                "CaptureDate": "2023-07-05T11:16:43"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0550/2023 TEOR DO ATO: VISTOS. INICIALMENTE, CONCEDO O PRAZO DE QUINZE DIAS AO AUTOR PARA QUE EMENDE A PETICAO INICIAL NO SENTIDO DE INDICAR O POLO ATIVO COM QUALIFICACAO COMPLETA NA SUA PETICAO INICIAL EM ATENDIMENTO AO DISPOSTO NO ART. 319, INCISO II, DO CODIGO PROCESSUAL CIVIL, SOB PENA DE INDEFERIMENTO DA PETICAO INCIAL. NO MAIS, O ARTIGO 5, INCISO LXXIV, DA CONSTITUICAO FEDERAL, DISPOE \"O ESTADO PRESTARA ASSISTENCIA JURIDICA INTEGRAL E GRATUITA AOS QUE COMPROVAREM INSUFICIENCIA DE RECURSOS\". EMBORA PARA A CONCESSAO DA GRATUIDADE NAO SE EXIJA O ESTADO DE MISERIA ABSOLUTA, E NECESSARIA A COMPROVACAO DA IMPOSSIBILIDADE DE ARCAR COM AS CUSTAS E DESPESAS DO PROCESSO SEM PREJUIZO DE SEU SUSTENTO PROPRIO OU DE SUA FAMILIA. A DECLARACAO DE POBREZA, POR SUA VEZ, ESTABELECE MERA PRESUNCAO RELATIVA DA HIPOSSUFICIENCIA, QUE CEDE ANTE OUTROS ELEMENTOS QUE SIRVAM PARA INDICAR A CAPACIDADE FINANCEIRA. NO CASO, HA ELEMENTOS SUFICIENTES PARA AFASTAR A PRESUNCAO, EM ESPECIAL: (I) NATUREZA E OBJETO DISCUTIDOS; (II) CONTRATACAO DE ADVOGADO PARTICULAR, DISPENSANDO A ATUACAO DA DEFENSORIA. ANTES DE INDEFERIR O PEDIDO, CONTUDO, CONVEM FACULTAR AO INTERESSADO O DIREITO DE PROVAR A IMPOSSIBILIDADE DE ARCAR, SEM O SEU PROPRIO PREJUIZO OU DE SUA FAMILIA, COM AS CUSTAS E DESPESAS DO PROCESSO. ASSIM, PARA APRECIACAO DO PEDIDO DE JUSTICA GRATUITA, A PARTE AUTORA DEVERA EM 15 (QUINZE) DIAS APRESENTAR, SOB PENA DE INDEFERIMENTO DO BENEFICIO: A) COMPROVANTE DE RENDA MENSAL, E DE EVENTUAL CONJUGE; B) COPIA DOS EXTRATOS BANCARIOS DE CONTAS DE TITULARIDADE, E DE EVENTUAL CONJUGE, DOS ULTIMOS TRES MESES; C) COPIA DOS EXTRATOS DE CARTAO DE CREDITO, DOS ULTIMOS TRES MESES; D) COPIA DA ULTIMA DECLARACAO DO IMPOSTO DE RENDA APRESENTADA A SECRETARIA DA RECEITA FEDERAL. ALTERNATIVAMENTE, NO MESMO PRAZO, DEVERA RECOLHER A TAXA JUDICIARIA E DESPESAS PARA CITACAO POSTAL, SOB PENA DE CANCELAMENTO DA DISTRIBUICAO. INTIME-SE. ADVOGADOS(S): EVERALDO TADEU QUILICI GONZALEZ (OAB 79617/SP)",
                "PublishDate": "2023-06-27T00:00:00",
                "CaptureDate": "2023-07-05T11:16:43"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE VISTOS. INICIALMENTE, CONCEDO O PRAZO DE QUINZE DIAS AO AUTOR PARA QUE EMENDE A PETICAO INICIAL NO SENTIDO DE INDICAR O POLO ATIVO COM QUALIFICACAO COMPLETA NA SUA PETICAO INICIAL EM ATENDIMENTO AO DISPOSTO NO ART. 319, INCISO II, DO CODIGO PROCESSUAL CIVIL, SOB PENA DE INDEFERIMENTO DA PETICAO INCIAL. NO MAIS, O ARTIGO 5, INCISO LXXIV, DA CONSTITUICAO FEDERAL, DISPOE \"O ESTADO PRESTARA ASSISTENCIA JURIDICA INTEGRAL E GRATUITA AOS QUE COMPROVAREM INSUFICIENCIA DE RECURSOS\". EMBORA PARA A CONCESSAO DA GRATUIDADE NAO SE EXIJA O ESTADO DE MISERIA ABSOLUTA, E NECESSARIA A COMPROVACAO DA IMPOSSIBILIDADE DE ARCAR COM AS CUSTAS E DESPESAS DO PROCESSO SEM PREJUIZO DE SEU SUSTENTO PROPRIO OU DE SUA FAMILIA. A DECLARACAO DE POBREZA, POR SUA VEZ, ESTABELECE MERA PRESUNCAO RELATIVA DA HIPOSSUFICIENCIA, QUE CEDE ANTE OUTROS ELEMENTOS QUE SIRVAM PARA INDICAR A CAPACIDADE FINANCEIRA. NO CASO, HA ELEMENTOS SUFICIENTES PARA AFASTAR A PRESUNCAO, EM ESPECIAL: (I) NATUREZA E OBJETO DISCUTIDOS; (II) CONTRATACAO DE ADVOGADO PARTICULAR, DISPENSANDO A ATUACAO DA DEFENSORIA. ANTES DE INDEFERIR O PEDIDO, CONTUDO, CONVEM FACULTAR AO INTERESSADO O DIREITO DE PROVAR A IMPOSSIBILIDADE DE ARCAR, SEM O SEU PROPRIO PREJUIZO OU DE SUA FAMILIA, COM AS CUSTAS E DESPESAS DO PROCESSO. ASSIM, PARA APRECIACAO DO PEDIDO DE JUSTICA GRATUITA, A PARTE AUTORA DEVERA EM 15 (QUINZE) DIAS APRESENTAR, SOB PENA DE INDEFERIMENTO DO BENEFICIO: A) COMPROVANTE DE RENDA MENSAL, E DE EVENTUAL CONJUGE; B) COPIA DOS EXTRATOS BANCARIOS DE CONTAS DE TITULARIDADE, E DE EVENTUAL CONJUGE, DOS ULTIMOS TRES MESES; C) COPIA DOS EXTRATOS DE CARTAO DE CREDITO, DOS ULTIMOS TRES MESES; D) COPIA DA ULTIMA DECLARACAO DO IMPOSTO DE RENDA APRESENTADA A SECRETARIA DA RECEITA FEDERAL. ALTERNATIVAMENTE, NO MESMO PRAZO, DEVERA RECOLHER A TAXA JUDICIARIA E DESPESAS PARA CITACAO POSTAL, SOB PENA DE CANCELAMENTO DA DISTRIBUICAO. INTIME-SE.",
                "PublishDate": "2023-06-26T00:00:00",
                "CaptureDate": "2023-07-05T11:16:43"
              },
              {
                "Content": "PROCESSO : 1029843-97.2023.8.26.0224 CLASSE : PROCEDIMENTO COMUM CIVEL REQTE : RAQUEL ROSANGELA DOS SANTOS ADVOGADO : 79617/SP - EVERALDO TADEU QUILICI GONZALEZ REQDO : CELCOIN PAGAMENTOS S.A. VARA : 4 VARA CIVEL",
                "PublishDate": "2023-06-26T00:00:00",
                "CaptureDate": "2023-07-05T11:16:43"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-06-23T00:00:00",
                "CaptureDate": "2023-07-05T11:16:43"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2023-06-23T00:00:00",
                "CaptureDate": "2023-07-05T11:16:43"
              }
            ],
            "Petitions": [
              {
                "Type": "PEDIDO DE HABILITACAO",
                "Author": "",
                "CreationDate": "2023-07-04T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              }
            ],
            "Decisions": []
          },
          {
            "Number": "10299114720238260224",
            "Type": "PROCEDIMENTO COMUM",
            "MainSubject": "DIREITO PROCESSUAL CIVIL E DO TRABALHO",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "GUARULHOS",
            "Judge": "ARTUR PESSOA DE MELO MORAIS",
            "JudgingBody": "5 VARA CIVEL",
            "State": "SP",
            "Status": "INDEFINIDO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "DIREITO PROCESSUAL CIVIL E DO TRABALHO",
            "InferredCNJSubjectNumber": 8826,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO PROCESSUAL CIVIL E DO TRABALHO",
            "InferredBroadCNJSubjectNumber": 8826,
            "OtherSubjects": [
              "DIREITO PROCESSUAL CIVIL E DO TRABALHO"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 129286.87,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-06-27T00:00:00",
            "NoticeDate": "2023-06-23T00:00:00",
            "LastMovementDate": "2023-07-06T00:00:00",
            "CaptureDate": "2023-07-13T07:49:53",
            "LastUpdate": "2023-07-13T07:49:53",
            "NumberOfParties": 5,
            "NumberOfUpdates": 8,
            "LawSuitAge": 250,
            "AverageNumberOfUpdatesPerMonth": 0,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "08677333495",
                "IsPartyActive": true,
                "Name": "ARTUR PESSOA DE MELO MORAIS",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-07-13T07:49:53"
              },
              {
                "Doc": "00921502680",
                "IsPartyActive": true,
                "Name": "OTHON TALMELLI",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-07-13T07:49:53"
              },
              {
                "Doc": "09926718680",
                "IsPartyActive": true,
                "Name": "HELENIO ROMUALDO ALMEIDA FILHO",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "381583",
                  "State": "SP",
                  "SpecificType": "ADVOGADO (REQTE)"
                },
                "LastCaptureDate": "2023-07-13T07:49:53"
              },
              {
                "IsPartyActive": true,
                "Name": "BACK INVEST INTERMEDIACAO E AGENCIAMENTO DE SERVICOS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-13T07:49:53"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-13T07:49:53"
              }
            ],
            "Updates": [
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2023-07-06T00:00:00",
                "CaptureDate": "2023-07-13T07:49:53"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WGRU.23.70409965-1 TIPO DA PETICAO: PETICAO INTERMEDIARIA DATA: 30/06/2023 14:31",
                "PublishDate": "2023-06-30T00:00:00",
                "CaptureDate": "2023-07-13T07:49:53"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0493/2023 DATA DA PUBLICACAO: 28/06/2023 NUMERO DO DIARIO: 3765",
                "PublishDate": "2023-06-27T00:00:00",
                "CaptureDate": "2023-07-13T07:49:53"
              },
              {
                "Content": "PROCESSO : 1029911-47.2023.8.26.0224 CLASSE : PROCEDIMENTO COMUM CIVEL REQTE : OTHON TALMELLI ADVOGADO : 381583/SP - HELENIO ROMUALDO ALMEIDA FILHO REQDO : STARK BANK S.A. VARA : 5 VARA CIVEL PROCESSO 1029911-47.2023.8.26.0224 - PROCEDIMENTO COMUM CIVEL - DIREITO PROCESSUAL CIVIL E DO TRABALHO - OTHON TALMELLI - VISTOS. EMENDE O AUTOR A PETICAO INICIAL NO PRAZO DE 15 (QUINZE) DIAS, SOB PENA DE EXTINCAO, PARA O FIM DE: A) COMPROVAR O RECOLHIMENTO DA TAXA JUDICIARIA QUE DEVERA CORRESPONDER A 1% (UM POR CENTO) SOBRE O VALOR DA CAUSA. GUIA DARE-SP (DOCUMENTO DE ARRECADACAO DE RECEITAS ESTADUAIS SP) CODIGO 230-6. B) COMPROVAR O RECOLHIMENTO DA TAXA DE POSTAGEM PARA EXPEDICAO DE CARTA CITATORIA - AR DIGITAL. GUIA FEDT 120-1. DUVIDAS ACERCA DO VALOR A SER RECOLHIDO E GUIA A SER UTILIZADA PODERAO SER OBSERVADAS NA PAGINA DA INTERNET DO E. TRIBUNAL DE JUSTICA, NO SEGUINTE ENDERECO: HTTPS://WWW.TJSP.JUS. BR/INDICESTAXASJUDICIARIAS/DESPESASPROCESSUAIS C) INFORMAR O ENDERECO ELETRONICO DO(A) AUTOR(A) E PATRONO(A)(S) PARA OS FINS DO ARTIGO 270 DO CODIGO DE PROCESSO CIVIL, QUANTO A EVENTUAIS INTIMACOES. D) REALIZAR A INCLUSAO DE PAY 42 INTERMEDIACAO DE NEGOCIOS LTDA NO POLO PASSIVO. PARA A INCLUSAO DE PARTE E RECATEGORIZACAO DOS DOCUMENTOS E NECESSARIO ACESSAR A PAGINA DO TRIBUNAL DE JUSTICA (HTTP://WWW.TJSP.JUS.BR) E CLICAR NO MENU: PETICIONAMENTO ELETRONICO \\> PETICIONE ELETRONICAMENTE \\> PETICIONAMENTO ELETRONICO DE 1 GRAU \\> COMPLEMENTO DE CADASTRO DE 1 GRAU. O MANUAL COM OS PROCEDIMENTOS NECESSARIOS PARA CUMPRIMENTO DA DETERMINACAO ESTA DISPONIVEL NA PAGINA:HTTP://WWW.TJSP.JUS.BR/DOWNLOAD/PETICIONAMENTOELETRONICO/ MANUALCOMPLEMENTOCADASTROPORTAL.PDF E) REGULARIZAR SUA REPRESENTACAO PROCESSUAL COM A JUNTADA DO INSTRUMENTO DE MANDATO DEVIDAMENTE ASSINADO PELO OUTORGANTE. INT. - ADV: HELENIO ROMUALDO ALMEIDA FILHO (OAB 381583/SP)",
                "PublishDate": "2023-06-27T00:00:00",
                "CaptureDate": "2023-07-13T07:49:53"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0493/2023 TEOR DO ATO: VISTOS. EMENDE O AUTOR A PETICAO INICIAL NO PRAZO DE 15 (QUINZE) DIAS, SOB PENA DE EXTINCAO, PARA O FIM DE: A) COMPROVAR O RECOLHIMENTO DA TAXA JUDICIARIA QUE DEVERA CORRESPONDER A 1% (UM POR CENTO) SOBRE O VALOR DA CAUSA. GUIA DARE-SP (DOCUMENTO DE ARRECADACAO DE RECEITAS ESTADUAIS SP) CODIGO 230-6. B) COMPROVAR O RECOLHIMENTO DA TAXA DE POSTAGEM PARA EXPEDICAO DE CARTA CITATORIA - AR DIGITAL. GUIA FEDT 120-1. DUVIDAS ACERCA DO VALOR A SER RECOLHIDO E GUIA A SER UTILIZADA PODERAO SER OBSERVADAS NA PAGINA DA INTERNET DO E. TRIBUNAL DE JUSTICA, NO SEGUINTE ENDERECO: HTTPS://WWW.TJSP.JUS.BR/INDICESTAXASJUDICIARIAS/DESPESASPROCESSUAIS C) INFORMAR O ENDERECO ELETRONICO DO(A) AUTOR(A) E PATRONO(A)(S) PARA OS FINS DO ARTIGO 270 DO CODIGO DE PROCESSO CIVIL, QUANTO A EVENTUAIS INTIMACOES. D) REALIZAR A INCLUSAO DE PAY 42 INTERMEDIACAO DE NEGOCIOS LTDA NO POLO PASSIVO. PARA A INCLUSAO DE PARTE E RECATEGORIZACAO DOS DOCUMENTOS E NECESSARIO ACESSAR A PAGINA DO TRIBUNAL DE JUSTICA (HTTP://WWW.TJSP.JUS.BR) E CLICAR NO MENU: PETICIONAMENTO ELETRONICO > PETICIONE ELETRONICAMENTE > PETICIONAMENTO ELETRONICO DE 1 GRAU > COMPLEMENTO DE CADASTRO DE 1 GRAU. O MANUAL COM OS PROCEDIMENTOS NECESSARIOS PARA CUMPRIMENTO DA DETERMINACAO ESTA DISPONIVEL NA PAGINA:HTTP://WWW.TJSP.JUS.BR/DOWNLOAD/PETICIONAMENTOELETRONICO/MANUALCOMPLEMENTOCADASTROPORTAL.PDF E) REGULARIZAR SUA REPRESENTACAO PROCESSUAL COM A JUNTADA DO INSTRUMENTO DE MANDATO DEVIDAMENTE ASSINADO PELO OUTORGANTE. INT. ADVOGADOS(S): HELENIO ROMUALDO ALMEIDA FILHO (OAB 381583/SP)",
                "PublishDate": "2023-06-26T00:00:00",
                "CaptureDate": "2023-07-13T07:49:53"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-06-23T00:00:00",
                "CaptureDate": "2023-07-13T07:49:53"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2023-06-23T00:00:00",
                "CaptureDate": "2023-07-13T07:49:53"
              },
              {
                "Content": "DETERMINADA A INCLUSAO DE PARTES NO CADASTRO DO PROCESSO DIGITAL E/OU RECATEGORIZACAO DE DOC. NA PASTA DO PROCESSO DIGI VISTOS. EMENDE O AUTOR A PETICAO INICIAL NO PRAZO DE 15 (QUINZE) DIAS, SOB PENA DE EXTINCAO, PARA O FIM DE: A) COMPROVAR O RECOLHIMENTO DA TAXA JUDICIARIA QUE DEVERA CORRESPONDER A 1% (UM POR CENTO) SOBRE O VALOR DA CAUSA. GUIA DARE-SP (DOCUMENTO DE ARRECADACAO DE RECEITAS ESTADUAIS SP) CODIGO 230-6. B) COMPROVAR O RECOLHIMENTO DA TAXA DE POSTAGEM PARA EXPEDICAO DE CARTA CITATORIA - AR DIGITAL. GUIA FEDT 120-1. DUVIDAS ACERCA DO VALOR A SER RECOLHIDO E GUIA A SER UTILIZADA PODERAO SER OBSERVADAS NA PAGINA DA INTERNET DO E. TRIBUNAL DE JUSTICA, NO SEGUINTE ENDERECO: HTTPS://WWW.TJSP.JUS.BR/INDICESTAXASJUDICIARIAS/DESPESASPROCESSUAIS C) INFORMAR O ENDERECO ELETRONICO DO(A) AUTOR(A) E PATRONO(A)(S) PARA OS FINS DO ARTIGO 270 DO CODIGO DE PROCESSO CIVIL, QUANTO A EVENTUAIS INTIMACOES. D) REALIZAR A INCLUSAO DE PAY 42 INTERMEDIACAO DE NEGOCIOS LTDA NO POLO PASSIVO. PARA A INCLUSAO DE PARTE E RECATEGORIZACAO DOS DOCUMENTOS E NECESSARIO ACESSAR A PAGINA DO TRIBUNAL DE JUSTICA (HTTP://WWW.TJSP.JUS.BR) E CLICAR NO MENU: PETICIONAMENTO ELETRONICO > PETICIONE ELETRONICAMENTE > PETICIONAMENTO ELETRONICO DE 1 GRAU > COMPLEMENTO DE CADASTRO DE 1 GRAU. O MANUAL COM OS PROCEDIMENTOS NECESSARIOS PARA CUMPRIMENTO DA DETERMINACAO ESTA DISPONIVEL NA PAGINA:HTTP://WWW.TJSP.JUS.BR/DOWNLOAD/PETICIONAMENTOELETRONICO/MANUALCOMPLEMENTOCADASTROPORTAL.PDF E) REGULARIZAR SUA REPRESENTACAO PROCESSUAL COM A JUNTADA DO INSTRUMENTO DE MANDATO DEVIDAMENTE ASSINADO PELO OUTORGANTE. INT.",
                "PublishDate": "2023-06-23T00:00:00",
                "CaptureDate": "2023-07-13T07:49:53"
              }
            ],
            "Petitions": [
              {
                "Type": "PETICAO INTERMEDIARIA",
                "Author": "",
                "CreationDate": "2023-06-30T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              }
            ],
            "Decisions": []
          },
          {
            "Number": "10018669320238260495",
            "Type": "PROCEDIMENTO COMUM",
            "MainSubject": "INDENIZACAO POR DANO MORAL",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "REGISTRO",
            "Judge": "DIEGO MATHIAS MARCUSSI",
            "JudgingBody": "2 VARA",
            "State": "SP",
            "Status": "ATIVO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "INDENIZAÇÃO POR DANO MORAL",
            "InferredCNJSubjectNumber": 7779,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "INDENIZACAO POR DANO MORAL",
              "INDENIZACAO POR DANO MATERIAL"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 17000,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-06-30T00:00:00",
            "NoticeDate": "2023-06-28T00:00:00",
            "LastMovementDate": "2023-07-12T00:00:00",
            "CaptureDate": "2023-07-16T17:49:56",
            "LastUpdate": "2023-07-16T17:49:56",
            "NumberOfParties": 6,
            "NumberOfUpdates": 7,
            "LawSuitAge": 245,
            "AverageNumberOfUpdatesPerMonth": 0,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "01040476902",
                "IsPartyActive": true,
                "Name": "DIEGO MATHIAS MARCUSSI",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-07-16T17:49:56"
              },
              {
                "Doc": "21622940873",
                "IsPartyActive": true,
                "Name": "ELICEIA ANTUNES LIMA",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-07-16T17:49:56"
              },
              {
                "Doc": "82173605020",
                "IsPartyActive": true,
                "Name": "LETICIA SCHMIDT FILGUERAS",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "67117",
                  "State": "RS",
                  "SpecificType": "ADVOGADA (REQTE)"
                },
                "LastCaptureDate": "2023-07-16T17:49:56"
              },
              {
                "Doc": "97140909000187",
                "IsPartyActive": true,
                "Name": "J C BONETO DISTRIBUIDORA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-16T17:49:56"
              },
              {
                "Doc": "21225451000",
                "IsPartyActive": true,
                "Name": "JOSE CARLOS BONETO",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-16T17:49:56"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-16T17:49:56"
              }
            ],
            "Updates": [
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0552/2023 DATA DA PUBLICACAO: 13/07/2023 NUMERO DO DIARIO: 3776",
                "PublishDate": "2023-07-12T00:00:00",
                "CaptureDate": "2023-07-16T17:49:57"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2023-07-11T00:00:00",
                "CaptureDate": "2023-07-16T17:49:57"
              },
              {
                "Content": "PROFERIDAS OUTRAS DECISOES NAO ESPECIFICADAS VISTOS. EM VISTA DO REQUERIMENTO DE TUTELA DE URGENCIA, COMPROVE A AUTORA, NO PRAZO DE 10 DIAS, A NEGATIVA DAS REQUERIDAS QUANTO AS SOLICITACOES DE SAQUE ALEGADAS NA PETICAO INICIAL (FLS. 3/4). INT.",
                "PublishDate": "2023-07-11T00:00:00",
                "CaptureDate": "2023-07-16T17:49:57"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0552/2023 TEOR DO ATO: VISTOS. EM VISTA DO REQUERIMENTO DE TUTELA DE URGENCIA, COMPROVE A AUTORA, NO PRAZO DE 10 DIAS, A NEGATIVA DAS REQUERIDAS QUANTO AS SOLICITACOES DE SAQUE ALEGADAS NA PETICAO INICIAL (FLS. 3/4). INT. ADVOGADOS(S): LETICIA SCHMIDT FILGUERAS (OAB 67117/RS)",
                "PublishDate": "2023-07-11T00:00:00",
                "CaptureDate": "2023-07-16T17:49:57"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2023-07-10T00:00:00",
                "CaptureDate": "2023-07-16T17:49:57"
              },
              {
                "Content": "PROCESSO : 1001866-93.2023.8.26.0495 CLASSE : PROCEDIMENTO COMUM CIVEL REQTE : ELICEIA ANTUNES LIMA ADVOGADO : 67117/RS - LETICIA SCHMIDT FILGUERAS REQDO : STARK BANK S.A. VARA : 2 VARA",
                "PublishDate": "2023-06-30T00:00:00",
                "CaptureDate": "2023-07-16T17:49:56"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-06-28T00:00:00",
                "CaptureDate": "2023-07-16T17:49:57"
              }
            ],
            "Petitions": [],
            "Decisions": []
          },
          {
            "Number": "10056730220238260664",
            "Type": "PROCEDIMENTO COMUM",
            "MainSubject": "INDENIZACAO POR DANO MORAL",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "VOTUPORANGA",
            "JudgingBody": "3 VARA CIVEL",
            "State": "SP",
            "Status": "ATIVO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "INDENIZAÇÃO POR DANO MORAL",
            "InferredCNJSubjectNumber": 7779,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "INDENIZACAO POR DANO MORAL",
              "INDENIZACAO POR DANO MATERIAL"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 15000,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-06-30T00:00:00",
            "NoticeDate": "2023-06-28T00:00:00",
            "LastMovementDate": "2023-07-05T00:00:00",
            "CaptureDate": "2023-07-16T19:05:22",
            "LastUpdate": "2023-07-16T19:05:22",
            "NumberOfParties": 5,
            "NumberOfUpdates": 10,
            "LawSuitAge": 245,
            "AverageNumberOfUpdatesPerMonth": 1,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "33884141813",
                "IsPartyActive": true,
                "Name": "ADRIEL MARQUES SANTOS",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-07-16T19:05:22"
              },
              {
                "Doc": "82173605020",
                "IsPartyActive": true,
                "Name": "LETICIA SCHMIDT FILGUERAS",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "67117",
                  "State": "RS",
                  "SpecificType": "ADVOGADA (REQTE)"
                },
                "LastCaptureDate": "2023-07-16T19:05:22"
              },
              {
                "Doc": "97140909000187",
                "IsPartyActive": true,
                "Name": "J C BONETO DISTRIBUIDORA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-16T19:05:22"
              },
              {
                "Doc": "21225451000",
                "IsPartyActive": true,
                "Name": "JOSE CARLOS BONETO",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-16T19:05:22"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-16T19:05:22"
              }
            ],
            "Updates": [
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0534/2023 DATA DA PUBLICACAO: 06/07/2023 NUMERO DO DIARIO: 3771",
                "PublishDate": "2023-07-05T00:00:00",
                "CaptureDate": "2023-07-16T19:05:23"
              },
              {
                "Content": "ATO ORDINATORIO - INTIMACAO - DJE DEVERA A PARTE AUTORA CUMPRIR A R. DECISAO DE P. 114, OBSERVANDO-SE QUE O DOCUMENTO JUNTADO AS P. 117 (ATENCAO: DATA DE NASCIMENTO NAO CORRESPONDE AO CPF INFORMADO), S.M.J., NAO ATENDE AO DETERMINADO.",
                "PublishDate": "2023-07-04T00:00:00",
                "CaptureDate": "2023-07-16T19:05:23"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0534/2023 TEOR DO ATO: DEVERA A PARTE AUTORA CUMPRIR A R. DECISAO DE P. 114, OBSERVANDO-SE QUE O DOCUMENTO JUNTADO AS P. 117 (ATENCAO: DATA DE NASCIMENTO NAO CORRESPONDE AO CPF INFORMADO), S.M.J., NAO ATENDE AO DETERMINADO. ADVOGADOS(S): LETICIA SCHMIDT FILGUERAS (OAB 67117/RS)",
                "PublishDate": "2023-07-04T00:00:00",
                "CaptureDate": "2023-07-16T19:05:23"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0517/2023 DATA DA PUBLICACAO: 03/07/2023 NUMERO DO DIARIO: 3768",
                "PublishDate": "2023-06-30T00:00:00",
                "CaptureDate": "2023-07-16T19:05:23"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WVTP.23.70072069-6 TIPO DA PETICAO: PETICAO DE JUNTADA DOS DOCUMENTOS SOLICITADOS DATA: 30/06/2023 11:17",
                "PublishDate": "2023-06-30T00:00:00",
                "CaptureDate": "2023-07-16T19:05:23"
              },
              {
                "Content": "PROCESSO : 1005673-02.2023.8.26.0664 CLASSE : PROCEDIMENTO COMUM CIVEL REQTE : ADRIEL MARQUES SANTOS ADVOGADO : 67117/RS - LETICIA SCHMIDT FILGUERAS REQDO : STARK BANK S.A. VARA : 3 VARA CIVEL PROCESSO 1005673-02.2023.8.26.0664 - PROCEDIMENTO COMUM CIVEL - INDENIZACAO POR DANO MORAL - ADRIEL MARQUES SANTOS - VISTOS. COM VISTAS A COMPROVACAO DO PREENCHIMENTO DOS PRESSUPOSTOS LEGAIS PARA A CONCESSAO DE GRATUIDADE (ART. 99, 2, DO CODIGO DE PROCESSO CIVIL), TRAGA A PARTE REQUERENTE, NO PRAZO DE 15 (QUINZE) DIAS, COPIA COMPLETA DA ULTIMA DECLARACAO DE IMPOSTO DE RENDA APRESENTADA A RECEITA FEDERAL, OU A COPIA DE INEXISTENCIA DA ENTREGA RETIRADA DO SITE DA RECEITA FEDERAL, COPIA DO COMPROVANTE DE RENDA MENSAL, BEM COMO EXTRATOS DOS ULTIMOS TRES MESES DE CARTAO DE CREDITO E CONTA(S) CORRENTE(S), SOB PENA DE INDEFERIMENTO DO PEDIDO, OU RECOLHA, NO MESMO PRAZO, AS CUSTAS DE INGRESSO, SOB PENA DE CANCELAMENTO DA DISTRIBUICAO. INT. - ADV: LETICIA SCHMIDT FILGUERAS (OAB 67117/RS)",
                "PublishDate": "2023-06-30T00:00:00",
                "CaptureDate": "2023-07-16T19:05:22"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0517/2023 TEOR DO ATO: VISTOS. COM VISTAS A COMPROVACAO DO PREENCHIMENTO DOS PRESSUPOSTOS LEGAIS PARA A CONCESSAO DE GRATUIDADE (ART. 99, 2, DO CODIGO DE PROCESSO CIVIL), TRAGA A PARTE REQUERENTE, NO PRAZO DE 15 (QUINZE) DIAS, COPIA COMPLETA DA ULTIMA DECLARACAO DE IMPOSTO DE RENDA APRESENTADA A RECEITA FEDERAL, OU A COPIA DE INEXISTENCIA DA ENTREGA RETIRADA DO SITE DA RECEITA FEDERAL, COPIA DO COMPROVANTE DE RENDA MENSAL, BEM COMO EXTRATOS DOS ULTIMOS TRES MESES DE CARTAO DE CREDITO E CONTA(S) CORRENTE(S), SOB PENA DE INDEFERIMENTO DO PEDIDO, OU RECOLHA, NO MESMO PRAZO, AS CUSTAS DE INGRESSO, SOB PENA DE CANCELAMENTO DA DISTRIBUICAO. INT. ADVOGADOS(S): LETICIA SCHMIDT FILGUERAS (OAB 67117/RS)",
                "PublishDate": "2023-06-29T00:00:00",
                "CaptureDate": "2023-07-16T19:05:23"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-06-28T00:00:00",
                "CaptureDate": "2023-07-16T19:05:23"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2023-06-28T00:00:00",
                "CaptureDate": "2023-07-16T19:05:23"
              },
              {
                "Content": "PROFERIDAS OUTRAS DECISOES NAO ESPECIFICADAS VISTOS. COM VISTAS A COMPROVACAO DO PREENCHIMENTO DOS PRESSUPOSTOS LEGAIS PARA A CONCESSAO DE GRATUIDADE (ART. 99, 2, DO CODIGO DE PROCESSO CIVIL), TRAGA A PARTE REQUERENTE, NO PRAZO DE 15 (QUINZE) DIAS, COPIA COMPLETA DA ULTIMA DECLARACAO DE IMPOSTO DE RENDA APRESENTADA A RECEITA FEDERAL, OU A COPIA DE INEXISTENCIA DA ENTREGA RETIRADA DO SITE DA RECEITA FEDERAL, COPIA DO COMPROVANTE DE RENDA MENSAL, BEM COMO EXTRATOS DOS ULTIMOS TRES MESES DE CARTAO DE CREDITO E CONTA(S) CORRENTE(S), SOB PENA DE INDEFERIMENTO DO PEDIDO, OU RECOLHA, NO MESMO PRAZO, AS CUSTAS DE INGRESSO, SOB PENA DE CANCELAMENTO DA DISTRIBUICAO. INT.",
                "PublishDate": "2023-06-28T00:00:00",
                "CaptureDate": "2023-07-16T19:05:23"
              }
            ],
            "Petitions": [
              {
                "Type": "PETICAO DE JUNTADA DOS DOCUMENTOS SOLICITADOS",
                "Author": "",
                "CreationDate": "2023-06-30T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              }
            ],
            "Decisions": []
          },
          {
            "Number": "10063074720238260292",
            "Type": "PROCEDIMENTO COMUM",
            "MainSubject": "INDENIZACAO POR DANO MORAL",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "JACAREI",
            "Judge": "MAURICIO BRISQUE NEIVA",
            "JudgingBody": "2 VARA CIVEL",
            "State": "SP",
            "Status": "ATIVO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "INDENIZAÇÃO POR DANO MORAL",
            "InferredCNJSubjectNumber": 7779,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "INDENIZACAO POR DANO MORAL",
              "INDENIZACAO POR DANO MATERIAL"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 18500,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-07-03T00:00:00",
            "NoticeDate": "2023-06-28T00:00:00",
            "LastMovementDate": "2023-07-03T00:00:00",
            "CaptureDate": "2023-07-19T06:24:04",
            "LastUpdate": "2023-07-19T06:24:04",
            "NumberOfParties": 6,
            "NumberOfUpdates": 6,
            "LawSuitAge": 245,
            "AverageNumberOfUpdatesPerMonth": 0,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "26145449810",
                "IsPartyActive": true,
                "Name": "MAURICIO BRISQUE NEIVA",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-07-19T06:24:04"
              },
              {
                "Doc": "30845924893",
                "IsPartyActive": true,
                "Name": "MARCOS GOUVEIA NORONHA",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-07-19T06:24:04"
              },
              {
                "Doc": "82173605020",
                "IsPartyActive": true,
                "Name": "LETICIA SCHMIDT FILGUERAS",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "67117",
                  "State": "RS",
                  "SpecificType": "ADVOGADA (REQTE)"
                },
                "LastCaptureDate": "2023-07-19T06:24:04"
              },
              {
                "Doc": "97140909000187",
                "IsPartyActive": true,
                "Name": "J C BONETO DISTRIBUIDORA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-19T06:24:04"
              },
              {
                "Doc": "21225451000",
                "IsPartyActive": true,
                "Name": "JOSE CARLOS BONETO",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-19T06:24:04"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-19T06:24:04"
              }
            ],
            "Updates": [
              {
                "Content": "PROCESSO 1006307-47.2023.8.26.0292 - PROCEDIMENTO COMUM CIVEL - INDENIZACAO POR DANO MORAL - MARCOS GOUVEIA NORONHA - VISTOS. PARA EXAME DO PEDIDO DE JUSTICA GRATUITA, ESCLARECA E COMPROVE DOCUMENTALMENTE A PARTE AUTORA, NO PRAZO DE 15 DIAS, SOB PENA DE INDEFERIMENTO DO BENEFICIO: A) QUAL A PROFISSAO E A RENDA BRUTA MENSAL SUA E DE SEU CONJUGE (E/OU DE SEUS PAIS, EM SE TRATANDO DE MENOR OU PESSOA ATE 24 ANOS QUE COM ELES RESIDE); B) SE, POR SI E/OU SEU CONJUGE (OU PAIS, EM SE TRATANDO DE MENOR OU PESSOA ATE 24 ANOS QUE COM ELES RESIDE), POSSUI VEICULOS, IMOVEIS, APLICACOES FINANCEIRAS OU OUTROS BENS MOVEIS DE VALOR E PLANO DE SAUDE PARTICULAR; SE ESTUDA OU TEM FILHOS MATRICULADOS EM ESCOLA PRIVADA; SE ARCA COM ALGUMA DESPESA EXCEPCIONAL, INCOMUM, QUE NAO FAZ PARTE DO COTIDIANO DE TODA E QUALQUER PESSOA; DESCREVENDO E VALORANDO CADA QUAL DESSES ITENS EM CASO POSITIVO. A PROPOSITO, OBSERVO QUE A PARTE AUTORA NADA ESCLARECEU OU DEMONSTROU NOS AUTOS A RESPEITO DA ALEGADA POBREZA E CONSTITUIU CAUSIDICO PARTICULAR, CIRCUNSTANCIAS QUE DEPOE EM SEU DESFAVOR. INT. - ADV: LETICIA SCHMIDT FILGUERAS (OAB 67117/RS)",
                "PublishDate": "2023-07-03T00:00:00",
                "CaptureDate": "2023-07-19T06:24:04"
              },
              {
                "Content": "DETERMINADA A MANIFESTACAO DO REQUERENTE/EXEQUENTE VISTOS. PARA EXAME DO PEDIDO DE JUSTICA GRATUITA, ESCLARECA E COMPROVE DOCUMENTALMENTE A PARTE AUTORA, NO PRAZO DE 15 DIAS, SOB PENA DE INDEFERIMENTO DO BENEFICIO: A) QUAL A PROFISSAO E A RENDA BRUTA MENSAL SUA E DE SEU CONJUGE (E/OU DE SEUS PAIS, EM SE TRATANDO DE MENOR OU PESSOA ATE 24 ANOS QUE COM ELES RESIDE); B) SE, POR SI E/OU SEU CONJUGE (OU PAIS, EM SE TRATANDO DE MENOR OU PESSOA ATE 24 ANOS QUE COM ELES RESIDE), POSSUI VEICULOS, IMOVEIS, APLICACOES FINANCEIRAS OU OUTROS BENS MOVEIS DE VALOR E PLANO DE SAUDE PARTICULAR; SE ESTUDA OU TEM FILHOS MATRICULADOS EM ESCOLA PRIVADA; SE ARCA COM ALGUMA DESPESA EXCEPCIONAL, INCOMUM, QUE NAO FAZ PARTE DO COTIDIANO DE TODA E QUALQUER PESSOA; DESCREVENDO E VALORANDO CADA QUAL DESSES ITENS EM CASO POSITIVO. A PROPOSITO, OBSERVO QUE A PARTE AUTORA NADA ESCLARECEU OU DEMONSTROU NOS AUTOS A RESPEITO DA ALEGADA POBREZA E CONSTITUIU CAUSIDICO PARTICULAR, CIRCUNSTANCIAS QUE DEPOE EM SEU DESFAVOR. INT.",
                "PublishDate": "2023-06-30T00:00:00",
                "CaptureDate": "2023-07-19T06:24:04"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0544/2023 TEOR DO ATO: VISTOS. PARA EXAME DO PEDIDO DE JUSTICA GRATUITA, ESCLARECA E COMPROVE DOCUMENTALMENTE A PARTE AUTORA, NO PRAZO DE 15 DIAS, SOB PENA DE INDEFERIMENTO DO BENEFICIO: A) QUAL A PROFISSAO E A RENDA BRUTA MENSAL SUA E DE SEU CONJUGE (E/OU DE SEUS PAIS, EM SE TRATANDO DE MENOR OU PESSOA ATE 24 ANOS QUE COM ELES RESIDE); B) SE, POR SI E/OU SEU CONJUGE (OU PAIS, EM SE TRATANDO DE MENOR OU PESSOA ATE 24 ANOS QUE COM ELES RESIDE), POSSUI VEICULOS, IMOVEIS, APLICACOES FINANCEIRAS OU OUTROS BENS MOVEIS DE VALOR E PLANO DE SAUDE PARTICULAR; SE ESTUDA OU TEM FILHOS MATRICULADOS EM ESCOLA PRIVADA; SE ARCA COM ALGUMA DESPESA EXCEPCIONAL, INCOMUM, QUE NAO FAZ PARTE DO COTIDIANO DE TODA E QUALQUER PESSOA; DESCREVENDO E VALORANDO CADA QUAL DESSES ITENS EM CASO POSITIVO. A PROPOSITO, OBSERVO QUE A PARTE AUTORA NADA ESCLARECEU OU DEMONSTROU NOS AUTOS A RESPEITO DA ALEGADA POBREZA E CONSTITUIU CAUSIDICO PARTICULAR, CIRCUNSTANCIAS QUE DEPOE EM SEU DESFAVOR. INT. ADVOGADOS(S): LETICIA SCHMIDT FILGUERAS (OAB 67117/RS)",
                "PublishDate": "2023-06-30T00:00:00",
                "CaptureDate": "2023-07-19T06:24:04"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0544/2023 DATA DA PUBLICACAO: 04/07/2023 NUMERO DO DIARIO: 3769",
                "PublishDate": "2023-06-30T00:00:00",
                "CaptureDate": "2023-07-19T06:24:04"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2023-06-29T00:00:00",
                "CaptureDate": "2023-07-19T06:24:04"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-06-28T00:00:00",
                "CaptureDate": "2023-07-19T06:24:04"
              }
            ],
            "Petitions": [],
            "Decisions": []
          },
          {
            "Number": "10129068620238260361",
            "Type": "PROCEDIMENTO COMUM",
            "MainSubject": "DEFEITO, NULIDADE OU ANULACAO",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "MOGI DAS CRUZES",
            "Judge": "CARLOS EDUARDO XAVIER BRITO",
            "JudgingBody": "4 VARA CIVEL",
            "State": "SP",
            "Status": "ATIVO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "DEFEITO, NULIDADE OU ANULAÇÃO",
            "InferredCNJSubjectNumber": 4703,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO CIVIL",
            "InferredBroadCNJSubjectNumber": 899,
            "OtherSubjects": [
              "DEFEITO, NULIDADE OU ANULACAO",
              "INDENIZACAO POR DANO MATERIAL",
              "INDENIZACAO POR DANO MORAL"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 82115.38,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-07-03T00:00:00",
            "NoticeDate": "2023-06-29T00:00:00",
            "LastMovementDate": "2023-07-10T00:00:00",
            "CaptureDate": "2023-07-19T10:39:32",
            "LastUpdate": "2023-07-19T10:39:32",
            "NumberOfParties": 33,
            "NumberOfUpdates": 6,
            "LawSuitAge": 244,
            "AverageNumberOfUpdatesPerMonth": 0,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "13294494874",
                "IsPartyActive": true,
                "Name": "CARLOS EDUARDO XAVIER BRITO",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-07-19T10:39:32"
              },
              {
                "Doc": "32336127881",
                "IsPartyActive": true,
                "Name": "MIRIAM MARIA DA SILVA",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-07-19T10:39:32"
              },
              {
                "Doc": "13339645795",
                "IsPartyActive": true,
                "Name": "WAGNER DA SILVA MENDONCA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "206062",
                  "State": "RJ",
                  "SpecificType": "ADVOGADO (REQTE)"
                },
                "LastCaptureDate": "2023-07-19T10:39:32"
              },
              {
                "Doc": "33264668000286",
                "IsPartyActive": true,
                "Name": "BANCO XP S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-19T10:39:32"
              },
              {
                "Doc": "27415911000136",
                "IsPartyActive": true,
                "Name": "BYTEDANCE BRASIL TECNOLOGIA LTDA TIKTOK",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-19T10:39:32"
              },
              {
                "Doc": "15436940000103",
                "IsPartyActive": true,
                "Name": "AMAZON COM AMAZON SERVICOS DE VAREJO DO BRASIL LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-19T10:39:32"
              },
              {
                "Doc": "37524383000107",
                "IsPartyActive": true,
                "Name": "PERSONAL SERVICOS FINANCEIROS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-19T10:39:32"
              },
              {
                "IsPartyActive": true,
                "Name": "LUIS FELIPE OLIVEIRA LIMA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-19T10:39:32"
              },
              {
                "Doc": "44004801869",
                "IsPartyActive": true,
                "Name": "CAROLINE MOURA CAVALHEIRO",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-19T10:39:32"
              },
              {
                "IsPartyActive": true,
                "Name": "FRANCINETE DE LIMA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-19T10:39:32"
              },
              {
                "IsPartyActive": true,
                "Name": "PATRICIA GIOVANINI",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDA"
                },
                "LastCaptureDate": "2023-07-19T10:39:32"
              },
              {
                "IsPartyActive": true,
                "Name": "VINICIUS SOUZA ROBERTA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-19T10:39:32"
              },
              {
                "IsPartyActive": true,
                "Name": "BRUNO MACIEL FIGUEIREDO",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-19T10:39:32"
              },
              {
                "Doc": "89316126568",
                "IsPartyActive": true,
                "Name": "BERNARDA CRUZ DE SOUZA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-19T10:39:32"
              },
              {
                "Doc": "22713984000190",
                "IsPartyActive": true,
                "Name": "LATAM TECNOLOGIA LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-19T10:39:32"
              },
              {
                "IsPartyActive": true,
                "Name": "BRASIL CASH SOLUCOES EM PAGAMENTOS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-19T10:39:32"
              },
              {
                "Doc": "27918828000180",
                "IsPartyActive": true,
                "Name": "BRASIL BLUE GULF IMPORTACAO EXPORTACAO",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-19T10:39:32"
              },
              {
                "IsPartyActive": true,
                "Name": "CONECT WORD COMERCIO, IMPORTACAO E EXPORTACAO LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-19T10:39:32"
              },
              {
                "Doc": "06346187848",
                "IsPartyActive": true,
                "Name": "DAGMAR APARECIDA CASIMIRO",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDA"
                },
                "LastCaptureDate": "2023-07-19T10:39:32"
              },
              {
                "Doc": "52848013850",
                "IsPartyActive": true,
                "Name": "SHAYANE KAMYLE DA SILVA PAVANELLO",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDA"
                },
                "LastCaptureDate": "2023-07-19T10:39:32"
              },
              {
                "Doc": "40791538800",
                "IsPartyActive": true,
                "Name": "REGIANE CRISTINA ARAUJO DA SILVA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-19T10:39:32"
              },
              {
                "Doc": "48784245832",
                "IsPartyActive": true,
                "Name": "JACKELINE CRISTINA DA SILVA PAVANELLO",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-19T10:39:32"
              },
              {
                "Doc": "52888346877",
                "IsPartyActive": true,
                "Name": "KALYNE PATRICIA DA SILVA PAVANELLO",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-19T10:39:32"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-19T10:39:32"
              },
              {
                "Doc": "13140088000199",
                "IsPartyActive": true,
                "Name": "ACESSO SOLUCOES DE PAGAMENTO S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-19T10:39:32"
              },
              {
                "Doc": "00416968000101",
                "IsPartyActive": true,
                "Name": "BANCO INTER",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-19T10:39:32"
              },
              {
                "IsPartyActive": true,
                "Name": "PICPAY SERVICOS S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-19T10:39:32"
              },
              {
                "Doc": "71027866000304",
                "IsPartyActive": true,
                "Name": "BANCO BS2 S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-19T10:39:32"
              },
              {
                "Doc": "60872504000123",
                "IsPartyActive": true,
                "Name": "ITAU UNIBANCO HOLDING S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-19T10:39:32"
              },
              {
                "IsPartyActive": true,
                "Name": "MONEY PLUS SOC CREDITO AO MICROEMPREEND EPP",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-19T10:39:32"
              },
              {
                "IsPartyActive": true,
                "Name": "CARTEIRA DIGITAL SPOT",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-19T10:39:32"
              },
              {
                "IsPartyActive": true,
                "Name": "BINANCE HOLDINGS LIMITED",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-19T10:39:32"
              },
              {
                "Doc": "37512394000177",
                "IsPartyActive": true,
                "Name": "B FINTECH SERVICOS DE TECNOLOGIA LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-19T10:39:32"
              }
            ],
            "Updates": [
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0555/2023 DATA DA PUBLICACAO: 11/07/2023 NUMERO DO DIARIO: 3774",
                "PublishDate": "2023-07-10T00:00:00",
                "CaptureDate": "2023-07-19T10:39:32"
              },
              {
                "Content": "PROFERIDAS OUTRAS DECISOES NAO ESPECIFICADAS 1- O ART. 5, LXXIV, DA CONSTITUICAO FEDERAL, DISPOE \"O ESTADO PRESTARA ASSISTENCIA JURIDICA INTEGRAL E GRATUITA AOS QUE COMPROVAREM INSUFICIENCIA DE RECURSOS\". DESTA FORMA, E DE RIGOR A ADOCAO DO MESMO CRITERIO UTILIZADO PELA DEFENSORIA PUBLICA PARA PATROCINAR ACOES EM FAVOR DAQUELES CONSIDERADOS HIPOSSUFICIENTE ECONOMICOS. NESSE SENTIDO: AGRAVO DE INSTRUMENTO - JUSTICA GRATUITA - INSURGENCIA CONTRA O R. DESPACHO QUE INDEFERIU O REQUERIMENTO PELO MM. JUIZ \"A QUO\" - COMPROVACAO DE QUE RECEBE QUANTIA INFERIOR A 03 SALARIOS MINIMOS, SENDO ESTE CRITERIO UTILIZADO PELA DEFENSORIA PUBLICA PARA PATROCINAR AS CAUSAS DE PESSOAS QUE NAO TERIAM CONDICOES DE PAGAR OS CUSTOS DE UM ADVOGADO PARTICULAR DECISAO REFORMADA RECURSO PROVIDO. (3 CAMARA DE DIREITO PRIVADO DO TJSP - AI N 2165732-43.2016.8.26.0000; RELATOR DES. DR. MAURICIO FIORITO; DJ. 06/09/2016). DESSE MODO, CONSIDERANDO TERMOS DA DELIBERACAO CSDP N 89/2008, DA DPE/SP (ARTIGO 2, 3), E POSSIVEL OBSERVAR QUE SAO CONSIDERADOS HIPOSSUFICIENTES ECONOMICOS: ARTIGO 2. - PRESUME-SE NECESSITADA A PESSOA NATURAL INTEGRANTE DE ENTIDADE FAMILIAR QUE ATENDA, CUMULATIVAMENTE, AS SEGUINTES CONDICOES: I - AUFIRA RENDA FAMILIAR MENSAL NAO SUPERIOR A TRES SALARIOS MINIMOS FEDERAIS; II - NAO SEJA PROPRIETARIA, TITULAR DE AQUISICAO, HERDEIRA, LEGATARIA OU USUFRUTUARIA DE BENS MOVEIS, IMOVEIS OU DIREITOS, CUJOS VALORES ULTRAPASSEM A QUANTIA EQUIVALENTE A 5.000 (CINCO MIL) UNIDADES FISCAIS DO ESTADO DE SAO PAULO - UFESPS; E, III - NAO POSSUA RECURSOS FINANCEIROS EM APLICACOES OU INVESTIMENTOS EM VALOR SUPERIOR A 12 (DOZE) SALARIOS MINIMOS FEDERAIS. (DESTAQUEI). POR SEU TURNO, NOS TERMOS DO  3 DESSE ARTIGO 2, DA REFERIDA DELIBERACAO CSDP N 89/2008, CONSIDERA-SE COMO RENDA FAMILIAR:  3. - RENDA FAMILIAR E A SOMA DOS RENDIMENTOS BRUTOS AUFERIDOS MENSALMENTE PELA TOTALIDADE DOS MEMBROS DA ENTIDADE FAMILIAR, MAIORES DE DEZESSEIS ANOS, EXCLUINDO-SE OS RENDIMENTOS CONCEDIDOS POR PROGRAMAS OFICIAIS DE TRANSFERENCIA DE RENDA E DE BENEFICIOS ASSISTENCIAIS, BEM COMO O VALOR COMPROVADAMENTE PAGO A TITULO DE CONTRIBUICAO PREVIDENCIARIA OFICIAL. (DESTAQUEI). PORTANTO, A DECLARACAO DE POBREZA, POR SUA VEZ, ESTABELECE MERA PRESUNCAO RELATIVA DA HIPOSSUFICIENCIA, QUE CEDE ANTE OUTROS ELEMENTOS QUE SIRVAM PARA INDICAR A CAPACIDADE FINANCEIRA. NO CASO, HA ELEMENTOS SUFICIENTES PARA AFASTAR A PRESUNCAO, EM ESPECIAL: A) NATUREZA E OBJETO DISCUTIDOS; B) CONTRATACAO DE ADVOGADO PARTICULAR, DISPENSANDO A ATUACAO DA DEFENSORIA. ANTES DE INDEFERIR O PEDIDO, CONTUDO, CONVEM FACULTAR AO INTERESSADO O DIREITO DE PROVAR A IMPOSSIBILIDADE DE ARCAR, SEM O SEU PROPRIO PREJUIZO OU DE SUA FAMILIA, COM AS CUSTAS E DESPESAS DO PROCESSO. ASSIM, PARA APRECIACAO DO PEDIDO DE JUSTICA GRATUITA, A PARTE REQUERENTE DEVERA, EM 15 (QUINZE) DIAS, APRESENTAR, SOB PENA DE INDEFERIMENTO DO BENEFICIO: A) COMPROVANTE DE RENDA MENSAL, E DE EVENTUAL CONJUGE/COMPANHEIRO COM COPIA DA ULTIMA ANOTACAO DE VINCULO DE EMPREGO EM SUA CTPS E FOLHA SEGUINTE; B) COPIA DOS EXTRATOS BANCARIOS DE CONTAS DE TITULARIDADE, E DE EVENTUAL CONJUGE/COMPANHEIRO, DOS ULTIMOS TRES MESES; C) COPIA DOS EXTRATOS DE CARTAO DE CREDITO, DOS ULTIMOS TRES MESES; D) COPIA DA ULTIMA DECLARACAO DO IMPOSTO DE RENDA APRESENTADA A SECRETARIA DA RECEITA FEDERAL. NA HIPOTESE DE ISENCAO, VENHA CERTIDAO DE REGULARIDADE FISCAL. ACASO TODOS OS DOCUMENTOS JA TENHAM SIDO JUNTADOS, INDICAR AS FOLHAS ONDE SE ENCONTRAM. OU, AINDA, DEVERA RECOLHER AS CUSTAS JUDICIAIS E DESPESAS PROCESSUAIS, SOB PENA DE CANCELAMENTO, SEM NOVA INTIMACAO. EVENTUALMENTE, EM SE TRATANDO DE PESSOA JURIDICA, NO MESMO PRAZO E SOB PENA DE REJEICAO, TRAGA ULTIMA DECLARACAO DE IRPJ, BEM COMO ULTIMO BALANCO PATRIMONIAL E O DE RESULTADO ECONOMICO, NOS TERMOS DO ART. 1.179 DO CODIGO CIVIL. EVENTUALMENTE, EM CASO DE DUVIDA, SERA REQUISITADA A APURACAO POR MEIO DE AGENTE DE SECRETARIA FISCAL COM COMPETENCIA PARA ANALISE. A PARTE QUE REQUERER A GRATUIDADE DE MA-FE SERA APENADA COM MULTA ATE O DECUPLO DE SEU VALOR (CPC, ARTS. 80, II E 100). 2- INTIME(M)-SE.",
                "PublishDate": "2023-07-07T00:00:00",
                "CaptureDate": "2023-07-19T10:39:32"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0555/2023 TEOR DO ATO: 1- O ART. 5, LXXIV, DA CONSTITUICAO FEDERAL, DISPOE \"O ESTADO PRESTARA ASSISTENCIA JURIDICA INTEGRAL E GRATUITA AOS QUE COMPROVAREM INSUFICIENCIA DE RECURSOS\". DESTA FORMA, E DE RIGOR A ADOCAO DO MESMO CRITERIO UTILIZADO PELA DEFENSORIA PUBLICA PARA PATROCINAR ACOES EM FAVOR DAQUELES CONSIDERADOS HIPOSSUFICIENTE ECONOMICOS. NESSE SENTIDO: AGRAVO DE INSTRUMENTO - JUSTICA GRATUITA - INSURGENCIA CONTRA O R. DESPACHO QUE INDEFERIU O REQUERIMENTO PELO MM. JUIZ \"A QUO\" - COMPROVACAO DE QUE RECEBE QUANTIA INFERIOR A 03 SALARIOS MINIMOS, SENDO ESTE CRITERIO UTILIZADO PELA DEFENSORIA PUBLICA PARA PATROCINAR AS CAUSAS DE PESSOAS QUE NAO TERIAM CONDICOES DE PAGAR OS CUSTOS DE UM ADVOGADO PARTICULAR DECISAO REFORMADA RECURSO PROVIDO. (3 CAMARA DE DIREITO PRIVADO DO TJSP - AI N 2165732-43.2016.8.26.0000; RELATOR DES. DR. MAURICIO FIORITO; DJ. 06/09/2016). DESSE MODO, CONSIDERANDO TERMOS DA DELIBERACAO CSDP N 89/2008, DA DPE/SP (ARTIGO 2, 3), E POSSIVEL OBSERVAR QUE SAO CONSIDERADOS HIPOSSUFICIENTES ECONOMICOS: ARTIGO 2. - PRESUME-SE NECESSITADA A PESSOA NATURAL INTEGRANTE DE ENTIDADE FAMILIAR QUE ATENDA, CUMULATIVAMENTE, AS SEGUINTES CONDICOES: I - AUFIRA RENDA FAMILIAR MENSAL NAO SUPERIOR A TRES SALARIOS MINIMOS FEDERAIS; II - NAO SEJA PROPRIETARIA, TITULAR DE AQUISICAO, HERDEIRA, LEGATARIA OU USUFRUTUARIA DE BENS MOVEIS, IMOVEIS OU DIREITOS, CUJOS VALORES ULTRAPASSEM A QUANTIA EQUIVALENTE A 5.000 (CINCO MIL) UNIDADES FISCAIS DO ESTADO DE SAO PAULO - UFESPS; E, III - NAO POSSUA RECURSOS FINANCEIROS EM APLICACOES OU INVESTIMENTOS EM VALOR SUPERIOR A 12 (DOZE) SALARIOS MINIMOS FEDERAIS. (DESTAQUEI). POR SEU TURNO, NOS TERMOS DO  3 DESSE ARTIGO 2, DA REFERIDA DELIBERACAO CSDP N 89/2008, CONSIDERA-SE COMO RENDA FAMILIAR:  3. - RENDA FAMILIAR E A SOMA DOS RENDIMENTOS BRUTOS AUFERIDOS MENSALMENTE PELA TOTALIDADE DOS MEMBROS DA ENTIDADE FAMILIAR, MAIORES DE DEZESSEIS ANOS, EXCLUINDO-SE OS RENDIMENTOS CONCEDIDOS POR PROGRAMAS OFICIAIS DE TRANSFERENCIA DE RENDA E DE BENEFICIOS ASSISTENCIAIS, BEM COMO O VALOR COMPROVADAMENTE PAGO A TITULO DE CONTRIBUICAO PREVIDENCIARIA OFICIAL. (DESTAQUEI). PORTANTO, A DECLARACAO DE POBREZA, POR SUA VEZ, ESTABELECE MERA PRESUNCAO RELATIVA DA HIPOSSUFICIENCIA, QUE CEDE ANTE OUTROS ELEMENTOS QUE SIRVAM PARA INDICAR A CAPACIDADE FINANCEIRA. NO CASO, HA ELEMENTOS SUFICIENTES PARA AFASTAR A PRESUNCAO, EM ESPECIAL: A) NATUREZA E OBJETO DISCUTIDOS; B) CONTRATACAO DE ADVOGADO PARTICULAR, DISPENSANDO A ATUACAO DA DEFENSORIA. ANTES DE INDEFERIR O PEDIDO, CONTUDO, CONVEM FACULTAR AO INTERESSADO O DIREITO DE PROVAR A IMPOSSIBILIDADE DE ARCAR, SEM O SEU PROPRIO PREJUIZO OU DE SUA FAMILIA, COM AS CUSTAS E DESPESAS DO PROCESSO. ASSIM, PARA APRECIACAO DO PEDIDO DE JUSTICA GRATUITA, A PARTE REQUERENTE DEVERA, EM 15 (QUINZE) DIAS, APRESENTAR, SOB PENA DE INDEFERIMENTO DO BENEFICIO: A) COMPROVANTE DE RENDA MENSAL, E DE EVENTUAL CONJUGE/COMPANHEIRO COM COPIA DA ULTIMA ANOTACAO DE VINCULO DE EMPREGO EM SUA CTPS E FOLHA SEGUINTE; B) COPIA DOS EXTRATOS BANCARIOS DE CONTAS DE TITULARIDADE, E DE EVENTUAL CONJUGE/COMPANHEIRO, DOS ULTIMOS TRES MESES; C) COPIA DOS EXTRATOS DE CARTAO DE CREDITO, DOS ULTIMOS TRES MESES; D) COPIA DA ULTIMA DECLARACAO DO IMPOSTO DE RENDA APRESENTADA A SECRETARIA DA RECEITA FEDERAL. NA HIPOTESE DE ISENCAO, VENHA CERTIDAO DE REGULARIDADE FISCAL. ACASO TODOS OS DOCUMENTOS JA TENHAM SIDO JUNTADOS, INDICAR AS FOLHAS ONDE SE ENCONTRAM. OU, AINDA, DEVERA RECOLHER AS CUSTAS JUDICIAIS E DESPESAS PROCESSUAIS, SOB PENA DE CANCELAMENTO, SEM NOVA INTIMACAO. EVENTUALMENTE, EM SE TRATANDO DE PESSOA JURIDICA, NO MESMO PRAZO E SOB PENA DE REJEICAO, TRAGA ULTIMA DECLARACAO DE IRPJ, BEM COMO ULTIMO BALANCO PATRIMONIAL E O DE RESULTADO ECONOMICO, NOS TERMOS DO ART. 1.179 DO CODIGO CIVIL. EVENTUALMENTE, EM CASO DE DUVIDA, SERA REQUISITADA A APURACAO POR MEIO DE AGENTE DE SECRETARIA FISCAL COM COMPETENCIA PARA ANALISE. A PARTE QUE REQUERER A GRATUIDADE DE MA-FE SERA APENADA COM MULTA ATE O DECUPLO DE SEU VALOR (CPC, ARTS. 80, II E 100). 2- INTIME(M)-SE. ADVOGADOS(S): WAGNER DA SILVA MENDONCA (OAB 206062/RJ)",
                "PublishDate": "2023-07-07T00:00:00",
                "CaptureDate": "2023-07-19T10:39:32"
              },
              {
                "Content": "PROCESSO : 1012906-86.2023.8.26.0361 CLASSE : PROCEDIMENTO COMUM CIVEL REQTE : MIRIAM MARIA DA SILVA ADVOGADO : 206062/RJ - WAGNER DA SILVA MENDONCA REQDO : B FINTECH SERVICOS DE TECNOLOGIA LTDA. VARA : 4 VARA CIVEL",
                "PublishDate": "2023-07-03T00:00:00",
                "CaptureDate": "2023-07-19T10:39:32"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-06-29T00:00:00",
                "CaptureDate": "2023-07-19T10:39:32"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2023-06-29T00:00:00",
                "CaptureDate": "2023-07-19T10:39:32"
              }
            ],
            "Petitions": [],
            "Decisions": []
          },
          {
            "Number": "10517736120238260002",
            "Type": "PROCEDIMENTO COMUM",
            "MainSubject": "INDENIZACAO POR DANO MORAL",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "SAO PAULO",
            "Judge": "JULIANA DIAS ALMEIDA DE FILIPPO",
            "JudgingBody": "12 VARA CIVEL",
            "State": "SP",
            "Status": "ATIVO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "INDENIZAÇÃO POR DANO MORAL",
            "InferredCNJSubjectNumber": 7779,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "INDENIZACAO POR DANO MORAL"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 20000,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-07-06T00:00:00",
            "NoticeDate": "2023-07-03T00:00:00",
            "LastMovementDate": "2023-07-13T00:00:00",
            "CaptureDate": "2023-07-19T18:04:13",
            "LastUpdate": "2023-07-19T18:04:13",
            "NumberOfParties": 8,
            "NumberOfUpdates": 8,
            "LawSuitAge": 240,
            "AverageNumberOfUpdatesPerMonth": 0,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "28934753889",
                "IsPartyActive": true,
                "Name": "JULIANA DIAS ALMEIDA DE FILIPPO",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-07-19T18:04:13"
              },
              {
                "Doc": "11684957419",
                "IsPartyActive": true,
                "Name": "LUCINEIDE CARLA SANTOS MENDONCA",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-07-19T18:04:13"
              },
              {
                "Doc": "21432274856",
                "IsPartyActive": true,
                "Name": "EMMERICH RUYSAM",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "317312",
                  "State": "SP",
                  "SpecificType": "ADVOGADO (REQTE)"
                },
                "LastCaptureDate": "2023-07-19T18:04:13"
              },
              {
                "Doc": "37455286899",
                "IsPartyActive": true,
                "Name": "BRUNA MOREIRA RODRIGUES",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "352980",
                  "State": "SP",
                  "SpecificType": "ADVOGADA (REQTE)"
                },
                "LastCaptureDate": "2023-07-19T18:04:13"
              },
              {
                "Doc": "46189325000165",
                "IsPartyActive": true,
                "Name": "ITAU UNIBANCO S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-19T18:04:13"
              },
              {
                "IsPartyActive": true,
                "Name": "PGSEGURO INTERNET S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-19T18:04:13"
              },
              {
                "Doc": "13140088000199",
                "IsPartyActive": true,
                "Name": "ACESSO SOLUCOES DE PAGAMENTO S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-19T18:04:13"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-19T18:04:13"
              }
            ],
            "Updates": [
              {
                "Content": "PEDIDO DE HABILITACAO JUNTADO N PROTOCOLO: WSTA.23.70588759-9 TIPO DA PETICAO: PEDIDO DE HABILITACAO DATA: 13/07/2023 15:10",
                "PublishDate": "2023-07-13T00:00:00",
                "CaptureDate": "2023-07-19T18:04:15"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0513/2023 DATA DA PUBLICACAO: 07/07/2023 NUMERO DO DIARIO: 3772",
                "PublishDate": "2023-07-06T00:00:00",
                "CaptureDate": "2023-07-19T18:04:15"
              },
              {
                "Content": "ATO ORDINATORIO - INTIMACAO - PORTAL ATO CRIADO PARA EXPEDICAO DE DOCUMENTO.",
                "PublishDate": "2023-07-06T00:00:00",
                "CaptureDate": "2023-07-19T18:04:15"
              },
              {
                "Content": "PROCESSO 1051773-61.2023.8.26.0002 - PROCEDIMENTO COMUM CIVEL - INDENIZACAO POR DANO MORAL - LUCINEIDE CARLA SANTOS MENDONCA - VISTOS. DEFIRO O PEDIDO DE GRATUIDADE DE JUSTICA. ANOTE-SE. PEDIDO DE INDENIZACAO POR DANOS MATERIAIS E MORAIS CUMULADO COM PLEITO DE TUTELA DE URGENCIA AJUIZADO POR LUCINEIDE CARLA SANTOS MENDONCA EM FACE DE ITAU UNIBANCO S.A., PAGSEGURO INTERNET INSTITUICAO DE PAGAMENTO S.A., ACESSO SOLUCOES DE PAGAMENTO S.A. E STARK BANK S.A. EM SUMA, AFIRMA A AUTORA TER SIDO VITIMA DE UM GOLPE CONSISTENTE EM UMA PROPOSTA DE EMPREGO VIA APLICATIVO WHATSAPP, HAVENDO A GOLPISTA SE APRESENTADO COMO GERENTE DE RECURSOS HUMANOS DA EMPRESA SHEIN QUE AUXILIAVA COMERCIANTES A AUMENTAR SUAS VENDAS. NARRA A AUTORA QUE A PARTIR DA ACEITACAO DA PROPOSTA TERIA A INCUMBENCIA DE RECEBER PEDIDOS PARA APOS A CONCLUSAO RECEBER DEVIDA COMISSAO PELO LABOR PRESTADO. ALEGA QUE SUCUMBIU AO ENGODO QUE APARENTAVA CREDIBILIDADE INICIALMENTE, EFETUANDO, POR ISSO, TRANSFERENCIAS DE SUA CONTA BANCARIA PARA A VIABILIDADE DA CONCLUSAO DE TAREFAS QUE LHES FORAM PASSADAS SOB A PROMESSA DE GANHO DE FUTURA COMISSAO. EXPOE QUE CHEGOU A RECEBER UMA COMISSAO EM CONTA, REFORCANDO A APARENCIA DE ILEGALIDADE DO NEGOCIO, AINDA QUE TAL CREDITO TENHA SE VINCULADO A OBRIGACAO DE REALIZAR MAIS TRANSFERENCIAS BANCARIAS. INFORMA QUE TENTOU ENTRAR EM CONTATO COM AS INSTITUICOES FINANCEIRAS RECEBEDORAS DOS VALORES PARA TENTAR REVERTER OS DEPOSITOS QUE FEZ, ENTENDENDO QUE A PERMISSAO, PELAS RES, DE ABERTURA DE CONTA CREDORA DOS GOLPISTAS REPRESENTOU FALHA DE SEGURANCA EXIGENTE DE INDENIZACAO. REQUER, DIANTE DO CENARIO, TUTELA DE URGENCIA PARA BLOQUEIO DAS CONTAS DAS PESSOAS INDICADAS COMO GOLPISTAS. A CONCESSAO DA ORDEM DE URGENCIA EXIGE, PARA BEM INCIDIR, A PRESENCA DE ELEMENTOS LEGAIS CONSISTENTES NA PLAUSIBILIDADE DO DIREITO INVOCADO ASSOCIADA A PERIGO DE UM DANO OU RISCO AO RESULTADO UTIL DO PROCESSO, CONFORME DITA O ARTIGO300 DO CODIGO DE PROCESSO CIVIL. MAS NO CASO PRESENTE NAO HA PLAUSIBILIDADE DO DIREITO NO TOCANTE AO INTERESSE DE CONSTRICAO EM CONTAS BANCARIAS DE TERCEIROS, - SUPOSTOS GOLPISTAS -, QUE NAO COMPOEM O POLO PASSIVO DA DEMANDA. CONSIDERANDO-SE QUE A CAUSA DE PEDIR DIZ COM APARENTE FALHA DE SEGURANCA NA ATUACAO DAS RES, O BLOQUEIO PLEITEADO A TITULO DE TUTELA DE URGENCIA NAO CONDIZ COM O MERITO DO DEBATE, INEXISTINDO, DE TODO MODO, PROVA BASTANTE DA ATUACAO DAS TERCEIRAS PESSOAS INDICADAS. MAIS A MAIS, PESE EMBORA A COMPREENSAO QUANTO A FRUSTRACAO VIVENCIADA NO MOMENTO DA PERCEPCAO DO GOLPE, AS OPERACOES FINANCEIRAS DESCRITAS FORAM REALIZADAS VOLUNTARIAMENTE PELA ACIONANTE, NAO SE VISLUMBRANDO NESSE ASPECTO RELATIVO AO RECEBIMENTO DOS VALORES PELAS INSTITUICOES RES, - E ANTES DE CONTRADITORIO A DEMONSTRAR, EVENTUALMENTE, O CONLUIO COM OS GOLPISTAS -, UMA ATUACAO INDEVIDA DE PRONTO, A JUSTIFICAR A ADOCAO DA MEDIDA DE URGENCIA PLEITEADA NA INICIAL. O GOLPE EM SI, MESMO QUE PLAUSIVEL A VISTA DAS DESCRICOES DA AUTORA DE PRESUMIDA BOA-FE, NAO POSSUI AUTORIA CERTA E DETERMINADA ATE O MOMENTO, EXIGINDO A DEFINICAO DO MERITO DA ACAO, PORTANTO, EFETIVO CONTRADITORIO. NAO HA, PORTANTO, REQUISITOS LEGAIS PARA A CONCESSAO DA TUTELA BUSCADA, ANOTANDO-SE QUE OS RECEBEDORES DOS VALORES VIA TRANSFERENCIA PIX (FLAVIA MARQUES GONCALVES, TENILDA SOARES DOS SANTOS, JADER WESLEY RAMOS, LUCAS CARLOS MOREIRA DA SILVA, ELISABETE CLEONICE DE JESUS BARBOSA E AQPAGO MEIOS DE PAGAMENTO LTDA FLS. 05/06), SAO PESSOAS ESTRANHAS AO PROCESSO, CUJAS ACOES NAO ESTAO DELIMITADAS E TAMPOUCO DEFINIDAS PELOS ELEMENTOS DE PROVA ATE AQUI APRESENTADOS. INDEFIRO, PELAS RAZOES EXPOSTAS, O PEDIDO DE TUTELA DE URGENCIA. DEIXO PARA MOMENTO OPORTUNO A ANALISE DA CONVENIENCIA DA AUDIENCIA DE CONCILIACAO (CPC, ART.139,VIE ENUNCIADO N 35 DA ENFAM:ALEM DAS SITUACOES EM QUE A FLEXIBILIZACAO DO PROCEDIMENTO E AUTORIZADA PELO ART.139,VI, DOCPC/2015, PODE O JUIZ, DE OFICIO, PRESERVADA A PREVISIBILIDADE DO RITO, ADAPTA-LO AS ESPECIFICIDADES DA CAUSA, OBSERVADAS AS GARANTIAS FUNDAMENTAIS DO PROCESSO). CITEM-SE E INTIMEM-SE AS RES PARA QUE CONTESTEM O FEITO NO PRAZO DE 15 (QUINZE) DIAS UTEIS. A AUSENCIA DE CONTESTACAO IMPLICARA REVELIA E PRESUNCAO DE VERACIDADE DA MATERIA FATICA APRESENTADA NA PETICAO INICIAL. TRATANDO-SE DE PROCESSO ELETRONICO, EM PRESTIGIO AS REGRAS FUNDAMENTAIS DOS ARTIGOS4E6DOCPCFICA VEDADO O EXERCICIO DA FACULDADE PREVISTA NO ARTIGO340DOCPC. INTIMEM-SE. - ADV: BRUNA MOREIRA RODRIGUES (OAB 352980/SP), EMMERICH RUYSAM (OAB 317312/SP)",
                "PublishDate": "2023-07-06T00:00:00",
                "CaptureDate": "2023-07-19T18:04:13"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0513/2023 TEOR DO ATO: VISTOS. DEFIRO O PEDIDO DE GRATUIDADE DE JUSTICA. ANOTE-SE. PEDIDO DE INDENIZACAO POR DANOS MATERIAIS E MORAIS CUMULADO COM PLEITO DE TUTELA DE URGENCIA AJUIZADO POR LUCINEIDE CARLA SANTOS MENDONCA EM FACE DE ITAU UNIBANCO S.A., PAGSEGURO INTERNET INSTITUICAO DE PAGAMENTO S.A., ACESSO SOLUCOES DE PAGAMENTO S.A. E STARK BANK S.A. EM SUMA, AFIRMA A AUTORA TER SIDO VITIMA DE UM GOLPE CONSISTENTE EM UMA PROPOSTA DE EMPREGO VIA APLICATIVO WHATSAPP, HAVENDO A GOLPISTA SE APRESENTADO COMO GERENTE DE RECURSOS HUMANOS DA EMPRESA SHEIN QUE AUXILIAVA COMERCIANTES A AUMENTAR SUAS VENDAS. NARRA A AUTORA QUE A PARTIR DA ACEITACAO DA PROPOSTA TERIA A INCUMBENCIA DE RECEBER PEDIDOS PARA APOS A CONCLUSAO RECEBER DEVIDA COMISSAO PELO LABOR PRESTADO. ALEGA QUE SUCUMBIU AO ENGODO QUE APARENTAVA CREDIBILIDADE INICIALMENTE, EFETUANDO, POR ISSO, TRANSFERENCIAS DE SUA CONTA BANCARIA PARA A VIABILIDADE DA CONCLUSAO DE TAREFAS QUE LHES FORAM PASSADAS SOB A PROMESSA DE GANHO DE FUTURA COMISSAO. EXPOE QUE CHEGOU A RECEBER UMA COMISSAO EM CONTA, REFORCANDO A APARENCIA DE ILEGALIDADE DO NEGOCIO, AINDA QUE TAL CREDITO TENHA SE VINCULADO A OBRIGACAO DE REALIZAR MAIS TRANSFERENCIAS BANCARIAS. INFORMA QUE TENTOU ENTRAR EM CONTATO COM AS INSTITUICOES FINANCEIRAS RECEBEDORAS DOS VALORES PARA TENTAR REVERTER OS DEPOSITOS QUE FEZ, ENTENDENDO QUE A PERMISSAO, PELAS RES, DE ABERTURA DE CONTA CREDORA DOS GOLPISTAS REPRESENTOU FALHA DE SEGURANCA EXIGENTE DE INDENIZACAO. REQUER, DIANTE DO CENARIO, TUTELA DE URGENCIA PARA BLOQUEIO DAS CONTAS DAS PESSOAS INDICADAS COMO GOLPISTAS. A CONCESSAO DA ORDEM DE URGENCIA EXIGE, PARA BEM INCIDIR, A PRESENCA DE ELEMENTOS LEGAIS CONSISTENTES NA PLAUSIBILIDADE DO DIREITO INVOCADO ASSOCIADA A PERIGO DE UM DANO OU RISCO AO RESULTADO UTIL DO PROCESSO, CONFORME DITA O ARTIGO300 DO CODIGO DE PROCESSO CIVIL. MAS NO CASO PRESENTE NAO HA PLAUSIBILIDADE DO DIREITO NO TOCANTE AO INTERESSE DE CONSTRICAO EM CONTAS BANCARIAS DE TERCEIROS, - SUPOSTOS GOLPISTAS -, QUE NAO COMPOEM O POLO PASSIVO DA DEMANDA. CONSIDERANDO-SE QUE A CAUSA DE PEDIR DIZ COM APARENTE FALHA DE SEGURANCA NA ATUACAO DAS RES, O BLOQUEIO PLEITEADO A TITULO DE TUTELA DE URGENCIA NAO CONDIZ COM O MERITO DO DEBATE, INEXISTINDO, DE TODO MODO, PROVA BASTANTE DA ATUACAO DAS TERCEIRAS PESSOAS INDICADAS. MAIS A MAIS, PESE EMBORA A COMPREENSAO QUANTO A FRUSTRACAO VIVENCIADA NO MOMENTO DA PERCEPCAO DO GOLPE, AS OPERACOES FINANCEIRAS DESCRITAS FORAM REALIZADAS VOLUNTARIAMENTE PELA ACIONANTE, NAO SE VISLUMBRANDO NESSE ASPECTO RELATIVO AO RECEBIMENTO DOS VALORES PELAS INSTITUICOES RES, - E ANTES DE CONTRADITORIO A DEMONSTRAR, EVENTUALMENTE, O CONLUIO COM OS GOLPISTAS -, UMA ATUACAO INDEVIDA DE PRONTO, A JUSTIFICAR A ADOCAO DA MEDIDA DE URGENCIA PLEITEADA NA INICIAL. O GOLPE EM SI, MESMO QUE PLAUSIVEL A VISTA DAS DESCRICOES DA AUTORA DE PRESUMIDA BOA-FE, NAO POSSUI AUTORIA CERTA E DETERMINADA ATE O MOMENTO, EXIGINDO A DEFINICAO DO MERITO DA ACAO, PORTANTO, EFETIVO CONTRADITORIO. NAO HA, PORTANTO, REQUISITOS LEGAIS PARA A CONCESSAO DA TUTELA BUSCADA, ANOTANDO-SE QUE OS RECEBEDORES DOS VALORES VIA TRANSFERENCIA \"PIX\" (FLAVIA MARQUES GONCALVES, TENILDA SOARES DOS SANTOS, JADER WESLEY RAMOS, LUCAS CARLOS MOREIRA DA SILVA, ELISABETE CLEONICE DE JESUS BARBOSA E AQPAGO MEIOS DE PAGAMENTO LTDA FLS. 05/06), SAO PESSOAS ESTRANHAS AO PROCESSO, CUJAS ACOES NAO ESTAO DELIMITADAS E TAMPOUCO DEFINIDAS PELOS ELEMENTOS DE PROVA ATE AQUI APRESENTADOS. INDEFIRO, PELAS RAZOES EXPOSTAS, O PEDIDO DE TUTELA DE URGENCIA. DEIXO PARA MOMENTO OPORTUNO A ANALISE DA CONVENIENCIA DA AUDIENCIA DE CONCILIACAO (CPC, ART.139,VIE ENUNCIADO N 35 DA ENFAM:\"ALEM DAS SITUACOES EM QUE A FLEXIBILIZACAO DO PROCEDIMENTO E AUTORIZADA PELO ART.139,VI, DOCPC/2015, PODE O JUIZ, DE OFICIO, PRESERVADA A PREVISIBILIDADE DO RITO, ADAPTA-LO AS ESPECIFICIDADES DA CAUSA, OBSERVADAS AS GARANTIAS FUNDAMENTAIS DO PROCESSO\"). CITEM-SE E INTIMEM-SE AS RES PARA QUE CONTESTEM O FEITO NO PRAZO DE 15 (QUINZE) DIAS UTEIS. A AUSENCIA DE CONTESTACAO IMPLICARA REVELIA E PRESUNCAO DE VERACIDADE DA MATERIA FATICA APRESENTADA NA PETICAO INICIAL. TRATANDO-SE DE PROCESSO ELETRONICO, EM PRESTIGIO AS REGRAS FUNDAMENTAIS DOS ARTIGOS4E6DOCPCFICA VEDADO O EXERCICIO DA FACULDADE PREVISTA NO ARTIGO340DOCPC. INTIMEM-SE. ADVOGADOS(S): EMMERICH RUYSAM (OAB 317312/SP), BRUNA MOREIRA RODRIGUES (OAB 352980/SP)",
                "PublishDate": "2023-07-05T00:00:00",
                "CaptureDate": "2023-07-19T18:04:15"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2023-07-04T00:00:00",
                "CaptureDate": "2023-07-19T18:04:15"
              },
              {
                "Content": "DECISAO DETERMINACAO VISTOS. DEFIRO O PEDIDO DE GRATUIDADE DE JUSTICA. ANOTE-SE. PEDIDO DE INDENIZACAO POR DANOS MATERIAIS E MORAIS CUMULADO COM PLEITO DE TUTELA DE URGENCIA AJUIZADO POR LUCINEIDE CARLA SANTOS MENDONCA EM FACE DE ITAU UNIBANCO S.A., PAGSEGURO INTERNET INSTITUICAO DE PAGAMENTO S.A., ACESSO SOLUCOES DE PAGAMENTO S.A. E STARK BANK S.A. EM SUMA, AFIRMA A AUTORA TER SIDO VITIMA DE UM GOLPE CONSISTENTE EM UMA PROPOSTA DE EMPREGO VIA APLICATIVO WHATSAPP, HAVENDO A GOLPISTA SE APRESENTADO COMO GERENTE DE RECURSOS HUMANOS DA EMPRESA SHEIN QUE AUXILIAVA COMERCIANTES A AUMENTAR SUAS VENDAS. NARRA A AUTORA QUE A PARTIR DA ACEITACAO DA PROPOSTA TERIA A INCUMBENCIA DE RECEBER PEDIDOS PARA APOS A CONCLUSAO RECEBER DEVIDA COMISSAO PELO LABOR PRESTADO. ALEGA QUE SUCUMBIU AO ENGODO QUE APARENTAVA CREDIBILIDADE INICIALMENTE, EFETUANDO, POR ISSO, TRANSFERENCIAS DE SUA CONTA BANCARIA PARA A VIABILIDADE DA CONCLUSAO DE TAREFAS QUE LHES FORAM PASSADAS SOB A PROMESSA DE GANHO DE FUTURA COMISSAO. EXPOE QUE CHEGOU A RECEBER UMA COMISSAO EM CONTA, REFORCANDO A APARENCIA DE ILEGALIDADE DO NEGOCIO, AINDA QUE TAL CREDITO TENHA SE VINCULADO A OBRIGACAO DE REALIZAR MAIS TRANSFERENCIAS BANCARIAS. INFORMA QUE TENTOU ENTRAR EM CONTATO COM AS INSTITUICOES FINANCEIRAS RECEBEDORAS DOS VALORES PARA TENTAR REVERTER OS DEPOSITOS QUE FEZ, ENTENDENDO QUE A PERMISSAO, PELAS RES, DE ABERTURA DE CONTA CREDORA DOS GOLPISTAS REPRESENTOU FALHA DE SEGURANCA EXIGENTE DE INDENIZACAO. REQUER, DIANTE DO CENARIO, TUTELA DE URGENCIA PARA BLOQUEIO DAS CONTAS DAS PESSOAS INDICADAS COMO GOLPISTAS. A CONCESSAO DA ORDEM DE URGENCIA EXIGE, PARA BEM INCIDIR, A PRESENCA DE ELEMENTOS LEGAIS CONSISTENTES NA PLAUSIBILIDADE DO DIREITO INVOCADO ASSOCIADA A PERIGO DE UM DANO OU RISCO AO RESULTADO UTIL DO PROCESSO, CONFORME DITA O ARTIGO300 DO CODIGO DE PROCESSO CIVIL. MAS NO CASO PRESENTE NAO HA PLAUSIBILIDADE DO DIREITO NO TOCANTE AO INTERESSE DE CONSTRICAO EM CONTAS BANCARIAS DE TERCEIROS, - SUPOSTOS GOLPISTAS -, QUE NAO COMPOEM O POLO PASSIVO DA DEMANDA. CONSIDERANDO-SE QUE A CAUSA DE PEDIR DIZ COM APARENTE FALHA DE SEGURANCA NA ATUACAO DAS RES, O BLOQUEIO PLEITEADO A TITULO DE TUTELA DE URGENCIA NAO CONDIZ COM O MERITO DO DEBATE, INEXISTINDO, DE TODO MODO, PROVA BASTANTE DA ATUACAO DAS TERCEIRAS PESSOAS INDICADAS. MAIS A MAIS, PESE EMBORA A COMPREENSAO QUANTO A FRUSTRACAO VIVENCIADA NO MOMENTO DA PERCEPCAO DO GOLPE, AS OPERACOES FINANCEIRAS DESCRITAS FORAM REALIZADAS VOLUNTARIAMENTE PELA ACIONANTE, NAO SE VISLUMBRANDO NESSE ASPECTO RELATIVO AO RECEBIMENTO DOS VALORES PELAS INSTITUICOES RES, - E ANTES DE CONTRADITORIO A DEMONSTRAR, EVENTUALMENTE, O CONLUIO COM OS GOLPISTAS -, UMA ATUACAO INDEVIDA DE PRONTO, A JUSTIFICAR A ADOCAO DA MEDIDA DE URGENCIA PLEITEADA NA INICIAL. O GOLPE EM SI, MESMO QUE PLAUSIVEL A VISTA DAS DESCRICOES DA AUTORA DE PRESUMIDA BOA-FE, NAO POSSUI AUTORIA CERTA E DETERMINADA ATE O MOMENTO, EXIGINDO A DEFINICAO DO MERITO DA ACAO, PORTANTO, EFETIVO CONTRADITORIO. NAO HA, PORTANTO, REQUISITOS LEGAIS PARA A CONCESSAO DA TUTELA BUSCADA, ANOTANDO-SE QUE OS RECEBEDORES DOS VALORES VIA TRANSFERENCIA \"PIX\" (FLAVIA MARQUES GONCALVES, TENILDA SOARES DOS SANTOS, JADER WESLEY RAMOS, LUCAS CARLOS MOREIRA DA SILVA, ELISABETE CLEONICE DE JESUS BARBOSA E AQPAGO MEIOS DE PAGAMENTO LTDA FLS. 05/06), SAO PESSOAS ESTRANHAS AO PROCESSO, CUJAS ACOES NAO ESTAO DELIMITADAS E TAMPOUCO DEFINIDAS PELOS ELEMENTOS DE PROVA ATE AQUI APRESENTADOS. INDEFIRO, PELAS RAZOES EXPOSTAS, O PEDIDO DE TUTELA DE URGENCIA. DEIXO PARA MOMENTO OPORTUNO A ANALISE DA CONVENIENCIA DA AUDIENCIA DE CONCILIACAO (CPC, ART.139,VIE ENUNCIADO N 35 DA ENFAM:\"ALEM DAS SITUACOES EM QUE A FLEXIBILIZACAO DO PROCEDIMENTO E AUTORIZADA PELO ART.139,VI, DOCPC/2015, PODE O JUIZ, DE OFICIO, PRESERVADA A PREVISIBILIDADE DO RITO, ADAPTA-LO AS ESPECIFICIDADES DA CAUSA, OBSERVADAS AS GARANTIAS FUNDAMENTAIS DO PROCESSO\"). CITEM-SE E INTIMEM-SE AS RES PARA QUE CONTESTEM O FEITO NO PRAZO DE 15 (QUINZE) DIAS UTEIS. A AUSENCIA DE CONTESTACAO IMPLICARA REVELIA E PRESUNCAO DE VERACIDADE DA MATERIA FATICA APRESENTADA NA PETICAO INICIAL. TRATANDO-SE DE PROCESSO ELETRONICO, EM PRESTIGIO AS REGRAS FUNDAMENTAIS DOS ARTIGOS4E6DOCPCFICA VEDADO O EXERCICIO DA FACULDADE PREVISTA NO ARTIGO340DOCPC. INTIMEM-SE.",
                "PublishDate": "2023-07-04T00:00:00",
                "CaptureDate": "2023-07-19T18:04:15"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-07-03T00:00:00",
                "CaptureDate": "2023-07-19T18:04:15"
              }
            ],
            "Petitions": [
              {
                "Type": "PEDIDO DE HABILITACAO",
                "Author": "",
                "CreationDate": "2023-07-13T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              }
            ],
            "Decisions": [
              {
                "DecisionContent": "DEFIRO O PEDIDO DE GRATUIDADE DE JUSTICA.",
                "DecisionDate": "2023-07-06T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO O PEDIDO DE GRATUIDADE DE JUSTICA.",
                "DecisionDate": "2023-07-05T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO O PEDIDO DE GRATUIDADE DE JUSTICA.",
                "DecisionDate": "2023-07-04T00:00:00"
              }
            ]
          },
          {
            "Number": "10060796920238260099",
            "Type": "PROCEDIMENTO COMUM",
            "MainSubject": "INDENIZACAO POR DANO MORAL",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "BRAGANCA PAULISTA",
            "Judge": "RODRIGO SETTE CARVALHO",
            "JudgingBody": "4 VARA CIVEL",
            "State": "SP",
            "Status": "INDEFINIDO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "INDENIZAÇÃO POR DANO MORAL",
            "InferredCNJSubjectNumber": 7779,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "INDENIZACAO POR DANO MORAL"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 11000,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-07-04T00:00:00",
            "NoticeDate": "2023-06-29T00:00:00",
            "LastMovementDate": "2023-07-04T00:00:00",
            "CaptureDate": "2023-07-21T01:36:04",
            "LastUpdate": "2023-07-21T01:36:04",
            "NumberOfParties": 5,
            "NumberOfUpdates": 7,
            "LawSuitAge": 244,
            "AverageNumberOfUpdatesPerMonth": 0,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "26712795826",
                "IsPartyActive": true,
                "Name": "RODRIGO SETTE CARVALHO",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-07-21T01:36:04"
              },
              {
                "Doc": "40559967802",
                "IsPartyActive": true,
                "Name": "GIOVANI APARECIDO DE GODOY",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-07-21T01:36:04"
              },
              {
                "Doc": "40559967802",
                "IsPartyActive": true,
                "Name": "GIOVANI APARECIDO DE GODOY",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "431875",
                  "State": "SP",
                  "SpecificType": "ADVOGADO (REQTE)"
                },
                "LastCaptureDate": "2023-07-21T01:36:04"
              },
              {
                "Doc": "48472928000103",
                "IsPartyActive": true,
                "Name": "KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-21T01:36:04"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-21T01:36:04"
              }
            ],
            "Updates": [
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0541/2023 DATA DA PUBLICACAO: 05/07/2023 NUMERO DO DIARIO: 3770",
                "PublishDate": "2023-07-04T00:00:00",
                "CaptureDate": "2023-07-21T01:36:05"
              },
              {
                "Content": "PROCESSO 1006079-69.2023.8.26.0099 - PROCEDIMENTO COMUM CIVEL - INDENIZACAO POR DANO MORAL - GIOVANI APARECIDO DE GODOY - TRATA-SE DE ACAO PROPOSTA POR GIOVANI APARECIDO DE GODOY EM FACE DE KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA. E STAR BANK S/A, PELA QUAL PRETENDE A CONDENACAO DOS REQUERIDOS: (I) A RESTITUICAO DE VALORES INVESTIDOS (R$ 1.000,00); (II) AO PAGAMENTO DE INDENIZACAO POR DANOS MORAIS (R$ 11.300,00). NO PRAZO DE 15 (QUINZE) DIAS, EMENDE-SE A PETICAO INICIAL, A FIM DE: 1) INFORMAR A RENDA MENSAL, AINDA QUE PROVENIENTE DE TRABALHO INFORMAL, COM O OBJETIVO DE APRECIAR A JUSTICA GRATUITA, APRESENTANDO: A) COPIA DAS FATURAS DE CARTAO DE CREDITO DO REQUERENTE (INCLUSIVE DE ESPOSA/COMPANHEIRA, SE HOUVER) DOS ULTIMOS TRES MESES; B) COPIA DOS EXTRATOS BANCARIOS DO REQUERENTE (INCLUSIVE DE ESPOSA/ COMPANHEIRA, SE HOUVER) DOS ULTIMOS TRES MESES; C) COPIA COMPLETA DA ULTIMA DECLARACAO DE IMPOSTO DE RENDA DO REQUERENTE (INCLUSIVE DE ESPOSA/COMPANHEIRA, SE HOUVER); D) COPIA DOS TRES ULTIMOS HOLERITES OU COMPROVANTES DE RECEBIMENTO DE BENEFICIO PREVIDENCIARIO DO REQUERENTE (INCLUSIVE DE ESPOSA/COMPANHEIRA, SE HOUVER); 2) ESCLARECER A CAUSA DE PEDIR, ELABORANDO TABELA QUE DESCREVA: (I) TAREFA CONTRATADA, COM DATA, OBJETO E VALOR OFERTADO (INDICANDO A FOLHA COM A PROVA DOCUMENTAL DA TAREFA CONTRATADA E A DEMONSTRACAO DE SUA REALIZACAO); (II) OS VALORES DESEMBOLSADOS PELO REQUERENTE E OS PAGOS PELA PARTE REQUERIDA; 3) ESCLARECER A LEGITIMIDADE PASSIVA DO REQUERIDO STAR BANK; 4) FORNECER O SEU PROPRIO ENDERECO ELETRONICO E DA PARTE CONTRARIA, A FIM DE POSSIBILITAR A INTIMACAO PESSOAL POR ESTA MODALIDADE DE COMUNICACAO (ART. 270, CPC). FORNECER, TAMBEM, O SEU NUMERO DE WHATSAPP E DA PARTE CONTRARIA. COM A VINDA DOS E-MAIL E DOS NUMEROS DE WHATSAPP, ANOTE-SE, DISPENSADA NOVA CONCLUSAO. COM A EMENDA OU DECORRIDO O PRAZO, TORNEM OS AUTOS CONCLUSOS. INT. BRAGANCA PAULISTA, 30 DE JUNHO DE 2023. - ADV: GIOVANI APARECIDO DE GODOY (OAB 431875/SP)",
                "PublishDate": "2023-07-04T00:00:00",
                "CaptureDate": "2023-07-21T01:36:04"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0541/2023 TEOR DO ATO: TRATA-SE DE ACAO PROPOSTA POR GIOVANI APARECIDO DE GODOY EM FACE DE KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA. E STAR BANK S/A, PELA QUAL PRETENDE A CONDENACAO DOS REQUERIDOS: (I) A RESTITUICAO DE VALORES INVESTIDOS (R$ 1.000,00); (II) AO PAGAMENTO DE INDENIZACAO POR DANOS MORAIS (R$ 11.300,00). NO PRAZO DE 15 (QUINZE) DIAS, EMENDE-SE A PETICAO INICIAL, A FIM DE: 1) INFORMAR A RENDA MENSAL, AINDA QUE PROVENIENTE DE TRABALHO INFORMAL, COM O OBJETIVO DE APRECIAR A JUSTICA GRATUITA, APRESENTANDO: A) COPIA DAS FATURAS DE CARTAO DE CREDITO DO REQUERENTE (INCLUSIVE DE ESPOSA/COMPANHEIRA, SE HOUVER) DOS ULTIMOS TRES MESES; B) COPIA DOS EXTRATOS BANCARIOS DO REQUERENTE (INCLUSIVE DE ESPOSA/COMPANHEIRA, SE HOUVER) DOS ULTIMOS TRES MESES; C) COPIA COMPLETA DA ULTIMA DECLARACAO DE IMPOSTO DE RENDA DO REQUERENTE (INCLUSIVE DE ESPOSA/COMPANHEIRA, SE HOUVER); D) COPIA DOS TRES ULTIMOS HOLERITES OU COMPROVANTES DE RECEBIMENTO DE BENEFICIO PREVIDENCIARIO DO REQUERENTE (INCLUSIVE DE ESPOSA/COMPANHEIRA, SE HOUVER); 2) ESCLARECER A CAUSA DE PEDIR, ELABORANDO TABELA QUE DESCREVA: (I) TAREFA CONTRATADA, COM DATA, OBJETO E VALOR OFERTADO (INDICANDO A FOLHA COM A PROVA DOCUMENTAL DA TAREFA CONTRATADA E A DEMONSTRACAO DE SUA REALIZACAO); (II) OS VALORES DESEMBOLSADOS PELO REQUERENTE E OS PAGOS PELA PARTE REQUERIDA; 3) ESCLARECER A LEGITIMIDADE PASSIVA DO REQUERIDO STAR BANK; 4) FORNECER O SEU PROPRIO ENDERECO ELETRONICO E DA PARTE CONTRARIA, A FIM DE POSSIBILITAR A INTIMACAO PESSOAL POR ESTA MODALIDADE DE COMUNICACAO (ART. 270, CPC). FORNECER, TAMBEM, O SEU NUMERO DE WHATSAPP E DA PARTE CONTRARIA. COM A VINDA DOS E-MAIL E DOS NUMEROS DE WHATSAPP, ANOTE-SE, DISPENSADA NOVA CONCLUSAO. COM A EMENDA OU DECORRIDO O PRAZO, TORNEM OS AUTOS CONCLUSOS. INT. BRAGANCA PAULISTA, 30 DE JUNHO DE 2023. ADVOGADOS(S): GIOVANI APARECIDO DE GODOY (OAB 431875/SP)",
                "PublishDate": "2023-07-03T00:00:00",
                "CaptureDate": "2023-07-21T01:36:05"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2023-06-30T00:00:00",
                "CaptureDate": "2023-07-21T01:36:05"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2023-06-30T00:00:00",
                "CaptureDate": "2023-07-21T01:36:05"
              },
              {
                "Content": "PROFERIDAS OUTRAS DECISOES NAO ESPECIFICADAS TRATA-SE DE ACAO PROPOSTA POR GIOVANI APARECIDO DE GODOY EM FACE DE KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA. E STAR BANK S/A, PELA QUAL PRETENDE A CONDENACAO DOS REQUERIDOS: (I) A RESTITUICAO DE VALORES INVESTIDOS (R$ 1.000,00); (II) AO PAGAMENTO DE INDENIZACAO POR DANOS MORAIS (R$ 11.300,00). NO PRAZO DE 15 (QUINZE) DIAS, EMENDE-SE A PETICAO INICIAL, A FIM DE: 1) INFORMAR A RENDA MENSAL, AINDA QUE PROVENIENTE DE TRABALHO INFORMAL, COM O OBJETIVO DE APRECIAR A JUSTICA GRATUITA, APRESENTANDO: A) COPIA DAS FATURAS DE CARTAO DE CREDITO DO REQUERENTE (INCLUSIVE DE ESPOSA/COMPANHEIRA, SE HOUVER) DOS ULTIMOS TRES MESES; B) COPIA DOS EXTRATOS BANCARIOS DO REQUERENTE (INCLUSIVE DE ESPOSA/COMPANHEIRA, SE HOUVER) DOS ULTIMOS TRES MESES; C) COPIA COMPLETA DA ULTIMA DECLARACAO DE IMPOSTO DE RENDA DO REQUERENTE (INCLUSIVE DE ESPOSA/COMPANHEIRA, SE HOUVER); D) COPIA DOS TRES ULTIMOS HOLERITES OU COMPROVANTES DE RECEBIMENTO DE BENEFICIO PREVIDENCIARIO DO REQUERENTE (INCLUSIVE DE ESPOSA/COMPANHEIRA, SE HOUVER); 2) ESCLARECER A CAUSA DE PEDIR, ELABORANDO TABELA QUE DESCREVA: (I) TAREFA CONTRATADA, COM DATA, OBJETO E VALOR OFERTADO (INDICANDO A FOLHA COM A PROVA DOCUMENTAL DA TAREFA CONTRATADA E A DEMONSTRACAO DE SUA REALIZACAO); (II) OS VALORES DESEMBOLSADOS PELO REQUERENTE E OS PAGOS PELA PARTE REQUERIDA; 3) ESCLARECER A LEGITIMIDADE PASSIVA DO REQUERIDO STAR BANK; 4) FORNECER O SEU PROPRIO ENDERECO ELETRONICO E DA PARTE CONTRARIA, A FIM DE POSSIBILITAR A INTIMACAO PESSOAL POR ESTA MODALIDADE DE COMUNICACAO (ART. 270, CPC). FORNECER, TAMBEM, O SEU NUMERO DE WHATSAPP E DA PARTE CONTRARIA. COM A VINDA DOS E-MAIL E DOS NUMEROS DE WHATSAPP, ANOTE-SE, DISPENSADA NOVA CONCLUSAO. COM A EMENDA OU DECORRIDO O PRAZO, TORNEM OS AUTOS CONCLUSOS. INT. BRAGANCA PAULISTA, 30 DE JUNHO DE 2023.",
                "PublishDate": "2023-06-30T00:00:00",
                "CaptureDate": "2023-07-21T01:36:05"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-06-29T00:00:00",
                "CaptureDate": "2023-07-21T01:36:05"
              }
            ],
            "Petitions": [],
            "Decisions": []
          },
          {
            "Number": "10005222420238260060",
            "Type": "PROCEDIMENTO COMUM",
            "MainSubject": "PRATICAS ABUSIVAS",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "AURIFLAMA",
            "Judge": "TOBIAS GUIMARAES FERREIRA",
            "JudgingBody": "VARA UNICA",
            "State": "SP",
            "Status": "ATIVO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "PRÁTICAS ABUSIVAS",
            "InferredCNJSubjectNumber": 11811,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "PRATICAS ABUSIVAS"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 29999.97,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-07-03T00:00:00",
            "NoticeDate": "2023-06-24T00:00:00",
            "LastMovementDate": "2023-07-07T00:00:00",
            "CaptureDate": "2023-07-21T19:24:36",
            "LastUpdate": "2023-07-21T19:24:36",
            "NumberOfParties": 8,
            "NumberOfUpdates": 11,
            "LawSuitAge": 249,
            "AverageNumberOfUpdatesPerMonth": 1,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "34479824898",
                "IsPartyActive": true,
                "Name": "TOBIAS GUIMARAES FERREIRA",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-07-21T19:24:36"
              },
              {
                "Doc": "33139748809",
                "IsPartyActive": true,
                "Name": "DANIELLI KHALIL OLIVEIRA",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-07-21T19:24:36"
              },
              {
                "Doc": "48029166800",
                "IsPartyActive": true,
                "Name": "ISABELA SERAGUZI DONEGAR",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "471231",
                  "State": "SP",
                  "SpecificType": "ADVOGADA (REQTE)"
                },
                "LastCaptureDate": "2023-07-21T19:24:36"
              },
              {
                "IsPartyActive": true,
                "Name": "AMAZON COM BR",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-21T19:24:36"
              },
              {
                "Doc": "49187738000107",
                "IsPartyActive": true,
                "Name": "AQPAGO MEIOS DE PAGAMENTO LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-21T19:24:36"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-21T19:24:36"
              },
              {
                "Doc": "08561701000101",
                "IsPartyActive": true,
                "Name": "PAGSEGURO INTERNET S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-21T19:24:36"
              },
              {
                "IsPartyActive": true,
                "Name": "NUBANK PAGAMENTOS S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-21T19:24:36"
              }
            ],
            "Updates": [
              {
                "Content": "CONCEDIDA A MEDIDA LIMINAR VISLUMBRO A PRESENCA DOS REQUISITOS ENSEJADORES DA TUTELA DE URGENCIA (CPC, ART. 300). A PROBABILIDADE DO DIREITO SE CONSUBSTANCIA NOS DOCUMENTOS ACOSTADOS AOS AUTOS, COMPROVANDO A TRANSFERENCIA DE VALORES (FLS. 24/25), E NO REGISTRO DE BOLETIM DE OCORRENCIA (FLS. 22/23). DE OUTRA PARTE, O RISCO DE DANO IRREPARAVEL OU DE DIFICIL REPARACAO SE CONFIGURA PELA POSSIBILIDADE DE DISSIPACAO DO NUMERARIO, NO CASO DE FUTURA PROCEDENCIA DA DEMANDA, CAUSANDO PREJUIZO AO RESULTADO UTIL DO PROCESSO. ADEMAIS, NAO HA IRREVERSIBILIDADE DA MEDIDA, UMA VEZ QUE O NUMERARIO FICARA DEPOSITADO EM CONTA JUDICIAL. ASSIM, DEFIRO O PEDIDO DE TUTELA DE URGENCIA A FIM DE DETERMINAR O BLOQUEIO DO VALOR DE R$ 9.000,00 (NOVE MIL REAIS), DA CONTA DE AQPAGO MEIOS DE PAGAMENTO LTDA, CNPJ N 49.187.738/0001 (FL. 07), VIA SISTEMA SISBAJUD. PARA O BLOQUEIO DO VALOR DE R$ 999,97 (NOVECENTOS E NOVENTA E NOVE REAIS E NOVENTA E SETE CENTAVOS), DAS CONTAS BANCARIAS DE YASMIN DA SILVA FERNANDES, DEVERA A PARTE AUTORA, NO PRAZO DE 15 (QUINZE) DIAS, EMENDAR A INICIAL PARA INCLUIR NO POLO PASSIVO YASMIN DA SILVA FERNANDES, DEVIDAMENTE QUALIFICADA, SOB PENA DE REVOGACAO DA TUTELA DE URGENCIA E INDEFERIMENTO DA INICIAL. SEM PREJUIZO, DEVERA A PARTE AUTORA JUNTAR DEMONSTRATIVOS DE SUAS DESPESAS; COPIAS DOS EXTRATOS DE MOVIMENTACAO BANCARIA DOS ULTIMOS 03 MESES, BEM COMO DE CARTAO DE CREDITO, DE TODAS AS CONTAS E CARTOES EXISTENTES, TENDO A PARTE POSTULANTE COMO TITULAR; COPIAS DAS ULTIMAS FOLHAS DA CARTEIRA DE TRABALHO OU COMPROVANTE DE RENDA MENSAL ATUALIZADO; COPIA DA ULTIMA DECLARACAO DO IMPOSTO DE RENDA APRESENTADA A SECRETARIA DA RECEITA FEDERAL OU DEMONSTRATIVO DE SUA ISENCAO, OU, NO MESMO PRAZO, DEVERA RECOLHER A TAXA JUDICIARIA, SOB PENA DE REVOGACAO DA TUTELA DE URGENCIA E CANCELAMENTO DA DISTRIBUICAO, SEM NOVA INTIMACAO. EXPECAM-SE OFICIOS PARA PAGSEGURO INTERNET INSTITUICAO DE PAGAMENTO S.A., STARK BANK S.A. E AQPAGO MEIOS DE PAGAMENTOS LTDA SOLICITANDO INFORMACOES DAS TRANSFERENCIA REALIZADAS, DEVENDO, INCLUSIVE, INFORMAR OS DADOS PESSOAIS E BANCARIOS DOS DESTINATARIOS DAS TRANSFERENCIAS. INSTRUAM-SE COM COPIAS DOS COMPROVANTES DE FLS. 24/25. REGISTRO QUE OS OFICIOS FICARAO DISPONIVEIS NO SITIO DO E. TRIBUNAL DE JUSTICA DO ESTADO DE SAO PAULO PARA IMPRESSAO PELO INTERESSADO, PRESCINDINDO-SE, POIS, DE ENTREGA DO REFERIDO DOCUMENTO, DEVENDO COMPROVAR O PROTOCOLO, NO PRAZO DE 15 (QUINZE) DIAS.",
                "PublishDate": "2023-07-07T00:00:00",
                "CaptureDate": "2023-07-21T19:24:36"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0554/2023 TEOR DO ATO: VISLUMBRO A PRESENCA DOS REQUISITOS ENSEJADORES DA TUTELA DE URGENCIA (CPC, ART. 300). A PROBABILIDADE DO DIREITO SE CONSUBSTANCIA NOS DOCUMENTOS ACOSTADOS AOS AUTOS, COMPROVANDO A TRANSFERENCIA DE VALORES (FLS. 24/25), E NO REGISTRO DE BOLETIM DE OCORRENCIA (FLS. 22/23). DE OUTRA PARTE, O RISCO DE DANO IRREPARAVEL OU DE DIFICIL REPARACAO SE CONFIGURA PELA POSSIBILIDADE DE DISSIPACAO DO NUMERARIO, NO CASO DE FUTURA PROCEDENCIA DA DEMANDA, CAUSANDO PREJUIZO AO RESULTADO UTIL DO PROCESSO. ADEMAIS, NAO HA IRREVERSIBILIDADE DA MEDIDA, UMA VEZ QUE O NUMERARIO FICARA DEPOSITADO EM CONTA JUDICIAL. ASSIM, DEFIRO O PEDIDO DE TUTELA DE URGENCIA A FIM DE DETERMINAR O BLOQUEIO DO VALOR DE R$ 9.000,00 (NOVE MIL REAIS), DA CONTA DE AQPAGO MEIOS DE PAGAMENTO LTDA, CNPJ N 49.187.738/0001 (FL. 07), VIA SISTEMA SISBAJUD. PARA O BLOQUEIO DO VALOR DE R$ 999,97 (NOVECENTOS E NOVENTA E NOVE REAIS E NOVENTA E SETE CENTAVOS), DAS CONTAS BANCARIAS DE YASMIN DA SILVA FERNANDES, DEVERA A PARTE AUTORA, NO PRAZO DE 15 (QUINZE) DIAS, EMENDAR A INICIAL PARA INCLUIR NO POLO PASSIVO YASMIN DA SILVA FERNANDES, DEVIDAMENTE QUALIFICADA, SOB PENA DE REVOGACAO DA TUTELA DE URGENCIA E INDEFERIMENTO DA INICIAL. SEM PREJUIZO, DEVERA A PARTE AUTORA JUNTAR DEMONSTRATIVOS DE SUAS DESPESAS; COPIAS DOS EXTRATOS DE MOVIMENTACAO BANCARIA DOS ULTIMOS 03 MESES, BEM COMO DE CARTAO DE CREDITO, DE TODAS AS CONTAS E CARTOES EXISTENTES, TENDO A PARTE POSTULANTE COMO TITULAR; COPIAS DAS ULTIMAS FOLHAS DA CARTEIRA DE TRABALHO OU COMPROVANTE DE RENDA MENSAL ATUALIZADO; COPIA DA ULTIMA DECLARACAO DO IMPOSTO DE RENDA APRESENTADA A SECRETARIA DA RECEITA FEDERAL OU DEMONSTRATIVO DE SUA ISENCAO, OU, NO MESMO PRAZO, DEVERA RECOLHER A TAXA JUDICIARIA, SOB PENA DE REVOGACAO DA TUTELA DE URGENCIA E CANCELAMENTO DA DISTRIBUICAO, SEM NOVA INTIMACAO. EXPECAM-SE OFICIOS PARA PAGSEGURO INTERNET INSTITUICAO DE PAGAMENTO S.A., STARK BANK S.A. E AQPAGO MEIOS DE PAGAMENTOS LTDA SOLICITANDO INFORMACOES DAS TRANSFERENCIA REALIZADAS, DEVENDO, INCLUSIVE, INFORMAR OS DADOS PESSOAIS E BANCARIOS DOS DESTINATARIOS DAS TRANSFERENCIAS. INSTRUAM-SE COM COPIAS DOS COMPROVANTES DE FLS. 24/25. REGISTRO QUE OS OFICIOS FICARAO DISPONIVEIS NO SITIO DO E. TRIBUNAL DE JUSTICA DO ESTADO DE SAO PAULO PARA IMPRESSAO PELO INTERESSADO, PRESCINDINDO-SE, POIS, DE ENTREGA DO REFERIDO DOCUMENTO, DEVENDO COMPROVAR O PROTOCOLO, NO PRAZO DE 15 (QUINZE) DIAS. ADVOGADOS(S): ISABELA SERAGUZI DONEGAR (OAB 471231/SP)",
                "PublishDate": "2023-07-07T00:00:00",
                "CaptureDate": "2023-07-21T19:24:36"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0554/2023 DATA DA PUBLICACAO: 11/07/2023 NUMERO DO DIARIO: 3774",
                "PublishDate": "2023-07-07T00:00:00",
                "CaptureDate": "2023-07-21T19:24:36"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2023-07-04T00:00:00",
                "CaptureDate": "2023-07-21T19:24:36"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WAUF.23.70007245-7 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 03/07/2023 18:27",
                "PublishDate": "2023-07-03T00:00:00",
                "CaptureDate": "2023-07-21T19:24:36"
              },
              {
                "Content": "PROCESSO 1000522-24.2023.8.26.0060 - PROCEDIMENTO COMUM CIVEL - PRATICAS ABUSIVAS - DANIELLI KHALIL OLIVEIRA - NUBANK PAGAMENTOS S/A E OUTROS - DE INICIO, OBSERVO QUE A PARTE AUTORA PROPOS A PRESENTE ACAO INDICANDO, NO PREAMBULO DA INICIAL, O RITO DO JUIZADO ESPECIAL CIVEL A SER SEGUIDO, APESAR DE TER ENDERECADO A VARA CIVEL. ASSIM, NO PRAZO DE 05 (CINCO) DIAS, ESCLARECA O RITO A SER ADOTADO, BEM COMO O JUIZO EM QUE SE PRETENDE SEGUIR COM A ACAO. - ADV: ISABELA SERAGUZI DONEGAR (OAB 471231/SP)",
                "PublishDate": "2023-07-03T00:00:00",
                "CaptureDate": "2023-07-21T19:24:36"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE DE INICIO, OBSERVO QUE A PARTE AUTORA PROPOS A PRESENTE ACAO INDICANDO, NO PREAMBULO DA INICIAL, O RITO DO JUIZADO ESPECIAL CIVEL A SER SEGUIDO, APESAR DE TER ENDERECADO A VARA CIVEL. ASSIM, NO PRAZO DE 05 (CINCO) DIAS, ESCLARECA O RITO A SER ADOTADO, BEM COMO O JUIZO EM QUE SE PRETENDE SEGUIR COM A ACAO.",
                "PublishDate": "2023-06-30T00:00:00",
                "CaptureDate": "2023-07-21T19:24:36"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0531/2023 TEOR DO ATO: DE INICIO, OBSERVO QUE A PARTE AUTORA PROPOS A PRESENTE ACAO INDICANDO, NO PREAMBULO DA INICIAL, O RITO DO JUIZADO ESPECIAL CIVEL A SER SEGUIDO, APESAR DE TER ENDERECADO A VARA CIVEL. ASSIM, NO PRAZO DE 05 (CINCO) DIAS, ESCLARECA O RITO A SER ADOTADO, BEM COMO O JUIZO EM QUE SE PRETENDE SEGUIR COM A ACAO. ADVOGADOS(S): ISABELA SERAGUZI DONEGAR (OAB 471231/SP)",
                "PublishDate": "2023-06-30T00:00:00",
                "CaptureDate": "2023-07-21T19:24:36"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0531/2023 DATA DA PUBLICACAO: 04/07/2023 NUMERO DO DIARIO: 3769",
                "PublishDate": "2023-06-30T00:00:00",
                "CaptureDate": "2023-07-21T19:24:36"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2023-06-26T00:00:00",
                "CaptureDate": "2023-07-21T19:24:36"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-06-24T00:00:00",
                "CaptureDate": "2023-07-21T19:24:36"
              }
            ],
            "Petitions": [
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2023-07-03T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              }
            ],
            "Decisions": [
              {
                "DecisionContent": "DEFIRO O PEDIDO DE TUTELA DE URGENCIA A FIM DE DETERMINAR O BLOQUEIO DO VALOR DE R$ 9.000,00 (NOVE MIL REAIS), DA CONTA DE AQPAGO MEIOS DE PAGAMENTO LTDA, CNPJ N 49.187.738/0001 (FL. 07), VIA SISTEMA SISBAJUD.",
                "DecisionDate": "2023-07-07T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO O PEDIDO DE TUTELA DE URGENCIA A FIM DE DETERMINAR O BLOQUEIO DO VALOR DE R$ 9.000,00 (NOVE MIL REAIS), DA CONTA DE AQPAGO MEIOS DE PAGAMENTO LTDA, CNPJ N 49.187.738/0001 (FL. 07), VIA SISTEMA SISBAJUD.",
                "DecisionDate": "2023-07-07T00:00:00"
              }
            ]
          },
          {
            "Number": "10891636220238260100",
            "Type": "PROCEDIMENTO COMUM",
            "MainSubject": "INDENIZACAO POR DANO MATERIAL",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "SAO PAULO",
            "Judge": "REGIS DE CASTILHO BARBOSA FILHO",
            "JudgingBody": "41 VARA CIVEL",
            "State": "SP",
            "Status": "INDEFINIDO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "INDENIZAÇÃO POR DANO MATERIAL",
            "InferredCNJSubjectNumber": 7780,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "INDENIZACAO POR DANO MATERIAL"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 6000,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-07-07T00:00:00",
            "NoticeDate": "2023-07-05T00:00:00",
            "LastMovementDate": "2023-07-19T00:00:00",
            "CaptureDate": "2023-07-23T22:46:08",
            "LastUpdate": "2023-07-23T22:46:08",
            "NumberOfParties": 5,
            "NumberOfUpdates": 7,
            "LawSuitAge": 238,
            "AverageNumberOfUpdatesPerMonth": 0,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "17000330856",
                "IsPartyActive": true,
                "Name": "REGIS DE CASTILHO BARBOSA FILHO",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-07-23T22:46:08"
              },
              {
                "Doc": "13679730748",
                "IsPartyActive": true,
                "Name": "ANA PAULA DELGADO BOMTEMPO BATALHA",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-07-23T22:46:08"
              },
              {
                "Doc": "43050805838",
                "IsPartyActive": true,
                "Name": "SERGIO PAULO DE CAMARGO TARCHA JUNIOR",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "380214",
                  "State": "SP",
                  "SpecificType": "ADVOGADO (REQTE)"
                },
                "LastCaptureDate": "2023-07-23T22:46:08"
              },
              {
                "Doc": "41855342804",
                "IsPartyActive": true,
                "Name": "LUCAS BOMTEMPO CORREA LEITE",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "402172",
                  "State": "SP",
                  "SpecificType": "ADVOGADO (REQTE)"
                },
                "LastCaptureDate": "2023-07-23T22:46:08"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-23T22:46:08"
              }
            ],
            "Updates": [
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WJMJ.23.41427233-4 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 19/07/2023 09:45",
                "PublishDate": "2023-07-19T00:00:00",
                "CaptureDate": "2023-07-23T22:46:09"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0533/2023 DATA DA PUBLICACAO: 17/07/2023 NUMERO DO DIARIO: 3778",
                "PublishDate": "2023-07-14T00:00:00",
                "CaptureDate": "2023-07-23T22:46:09"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0533/2023 TEOR DO ATO: VISTOS. O ARTIGO 5, INCISO LXXIV, DA CONSTITUICAO FEDERAL PRECONIZA QUE O ESTADO PRESTARA ASSISTENCIA JUDICIARIA INTEGRAL E GRATUITA AOS QUE COMPROVAREM INSUFICIENCIA DE RECURSOS. NA MESMA LINHA, NA LEGISLACAO INFRACONSTITUCIONAL, O ARTIGO 98 DO CODIGO DE PROCESSO CIVIL DISPOE QUE A PESSOA NATURAL OU JURIDICA, BRASILEIRA OU ESTRANGEIRA, COM INSUFICIENCIA DE RECURSOS PARA PAGAR AS CUSTAS, AS DESPESAS PROCESSUAIS E OS HONORARIOS ADVOCATICIOS TEM DIREITO A GRATUIDADE DA JUSTICA, NA FORMA DA LEI. PORTANTO, HAVENDO NOS AUTOS ELEMENTOS QUE EVIDENCIAM A FALTA DOS PRESSUPOSTOS LEGAIS PARA A CONCESSAO DA GRATUIDADE (CPC, ART. 99,  2), ASSINO O PRAZO DE 15 DIAS PARA QUE A PARTE TRAGA AOS AUTOS DECLARACAO ATUALIZADA DE RENDA OBTIDA JUNTO A DELEGACIA DA RECEITA FEDERAL, OU ATESTADA DOCUMENTALMENTE SUA AUSENCIA, BEM COMO COMPROVANTES DE RENDIMENTOS, OU SEJA, HOLERITE, CARTEIRA DE TRABALHO, EXTRATOS BANCARIOS DOS 3 ULTIMOS MESES, DE CONTA CORRENTE E DE APLICACOES FINANCEIRAS, INCLUSIVE DE POUPANCA, ANOTANDO-SE O SIGILO DOS DOCUMENTOS APRESENTADOS. ALTERNATIVAMENTE, RECOLHA AS CUSTAS PROCESSUAIS DEVIDAS. INTIME-SE. ADVOGADOS(S): SERGIO PAULO DE CAMARGO TARCHA JUNIOR (OAB 380214/SP), LUCAS BOMTEMPO CORREA LEITE (OAB 402172/SP)",
                "PublishDate": "2023-07-13T00:00:00",
                "CaptureDate": "2023-07-23T22:46:08"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2023-07-12T00:00:00",
                "CaptureDate": "2023-07-23T22:46:08"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE VISTOS. O ARTIGO 5, INCISO LXXIV, DA CONSTITUICAO FEDERAL PRECONIZA QUE O ESTADO PRESTARA ASSISTENCIA JUDICIARIA INTEGRAL E GRATUITA AOS QUE COMPROVAREM INSUFICIENCIA DE RECURSOS. NA MESMA LINHA, NA LEGISLACAO INFRACONSTITUCIONAL, O ARTIGO 98 DO CODIGO DE PROCESSO CIVIL DISPOE QUE A PESSOA NATURAL OU JURIDICA, BRASILEIRA OU ESTRANGEIRA, COM INSUFICIENCIA DE RECURSOS PARA PAGAR AS CUSTAS, AS DESPESAS PROCESSUAIS E OS HONORARIOS ADVOCATICIOS TEM DIREITO A GRATUIDADE DA JUSTICA, NA FORMA DA LEI. PORTANTO, HAVENDO NOS AUTOS ELEMENTOS QUE EVIDENCIAM A FALTA DOS PRESSUPOSTOS LEGAIS PARA A CONCESSAO DA GRATUIDADE (CPC, ART. 99,  2), ASSINO O PRAZO DE 15 DIAS PARA QUE A PARTE TRAGA AOS AUTOS DECLARACAO ATUALIZADA DE RENDA OBTIDA JUNTO A DELEGACIA DA RECEITA FEDERAL, OU ATESTADA DOCUMENTALMENTE SUA AUSENCIA, BEM COMO COMPROVANTES DE RENDIMENTOS, OU SEJA, HOLERITE, CARTEIRA DE TRABALHO, EXTRATOS BANCARIOS DOS 3 ULTIMOS MESES, DE CONTA CORRENTE E DE APLICACOES FINANCEIRAS, INCLUSIVE DE POUPANCA, ANOTANDO-SE O SIGILO DOS DOCUMENTOS APRESENTADOS. ALTERNATIVAMENTE, RECOLHA AS CUSTAS PROCESSUAIS DEVIDAS. INTIME-SE.",
                "PublishDate": "2023-07-12T00:00:00",
                "CaptureDate": "2023-07-23T22:46:08"
              },
              {
                "Content": "PROCESSO : 1089163-62.2023.8.26.0100 CLASSE : PROCEDIMENTO COMUM CIVEL REQTE : ANA PAULA DELGADO BOMTEMPO BATALHA ADVOGADO : 402172/SP - LUCAS BOMTEMPO CORREA LEITE REQDO : STARK BANK S.A. VARA : 41 VARA CIVEL",
                "PublishDate": "2023-07-07T00:00:00",
                "CaptureDate": "2023-07-23T22:46:08"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-07-05T00:00:00",
                "CaptureDate": "2023-07-23T22:46:08"
              }
            ],
            "Petitions": [
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2023-07-19T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              }
            ],
            "Decisions": []
          },
          {
            "Number": "10541709320238260002",
            "Type": "PROCEDIMENTO COMUM",
            "MainSubject": "INDENIZACAO POR DANO MATERIAL",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "SAO PAULO",
            "Judge": "CAIO MOSCARIELLO RODRIGUES",
            "JudgingBody": "13 VARA CIVEL",
            "State": "SP",
            "Status": "ATIVO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "INDENIZAÇÃO POR DANO MATERIAL",
            "InferredCNJSubjectNumber": 7780,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "INDENIZACAO POR DANO MATERIAL",
              "INDENIZACAO POR DANO MORAL"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 50029,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-07-12T00:00:00",
            "NoticeDate": "2023-07-10T00:00:00",
            "LastMovementDate": "2023-07-13T00:00:00",
            "CaptureDate": "2023-07-26T09:47:25",
            "LastUpdate": "2023-07-26T09:47:25",
            "NumberOfParties": 8,
            "NumberOfUpdates": 6,
            "LawSuitAge": 233,
            "AverageNumberOfUpdatesPerMonth": 0,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "16133169842",
                "IsPartyActive": true,
                "Name": "CAIO MOSCARIELLO RODRIGUES",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-07-26T09:47:25"
              },
              {
                "Doc": "12831518717",
                "IsPartyActive": true,
                "Name": "ANDRESSA REZENDE VIANA MEDINA",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-07-26T09:47:25"
              },
              {
                "Doc": "34589076888",
                "IsPartyActive": true,
                "Name": "RAFAEL LUIZ BARBOSA MAGRI",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "301473",
                  "State": "SP",
                  "SpecificType": "ADVOGADO (REQTE)"
                },
                "LastCaptureDate": "2023-07-26T09:47:25"
              },
              {
                "IsPartyActive": true,
                "Name": "CELCOIN PAGAMENTOS S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-26T09:47:25"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-26T09:47:25"
              },
              {
                "IsPartyActive": true,
                "Name": "VIA PAGSEGURO INTERNET S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-26T09:47:25"
              },
              {
                "Doc": "30306294000145",
                "IsPartyActive": true,
                "Name": "BANCO BTG PACTUAL S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-26T09:47:25"
              },
              {
                "IsPartyActive": true,
                "Name": "NU FINANCEIRA S A SOCIEDADE DE CREDITO, FINANCIAMENTO E INVESTIMENTO",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-26T09:47:25"
              }
            ],
            "Updates": [
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0555/2023 DATA DA PUBLICACAO: 14/07/2023 NUMERO DO DIARIO: 3777",
                "PublishDate": "2023-07-13T00:00:00",
                "CaptureDate": "2023-07-26T09:47:25"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0555/2023 TEOR DO ATO: VISTOS. O ART.5, LXXIV, DA CONSTITUICAO FEDERAL, DISPOE QUE O ESTADO PRESTARA ASSISTENCIA JURIDICA INTEGRAL E GRATUITA AOS QUE COMPROVAREM INSUFICIENCIA DE RECURSOS. EMBORA PARA A CONCESSAO DA GRATUIDADE NAO SE EXIJA O ESTADO DE MISERIA ABSOLUTA, E NECESSARIA A COMPROVACAO DA IMPOSSIBILIDADE DE ARCAR COM AS CUSTAS E DESPESAS DO PROCESSO SEM PREJUIZO DE SEU SUSTENTO PROPRIO OU DE SUA FAMILIA. A DECLARACAO DE POBREZA, POR SUA VEZ, ESTABELECE MERA PRESUNCAO RELATIVA DA HIPOSSUFICIENCIA, QUE CEDE ANTE OUTROS ELEMENTOS QUE SIRVAM PARA INDICAR A CAPACIDADE FINANCEIRA. NO CASO, HA ELEMENTOS SUFICIENTES PARA AFASTAR A PRESUNCAO, EM ESPECIAL: (I) NATUREZA E OBJETO DISCUTIDOS; (II) CONTRATACAO DE ADVOGADO PARTICULAR, DISPENSANDO A ATUACAO DA DEFENSORIA. ANTES DE INDEFERIR O PEDIDO, CONTUDO, CONVEM FACULTAR AO INTERESSADO O DIREITO DE PROVAR A IMPOSSIBILIDADE DE ARCAR, SEM O SEU PROPRIO PREJUIZO OU DE SUA FAMILIA, COM AS CUSTAS E DESPESAS DO PROCESSO. ASSIM, PARA APRECIACAO DO PEDIDO DE JUSTICA GRATUITA, A PARTE REQUERENTE DEVERA, EM 15 (QUINZE) DIAS, APRESENTAR, SOB PENA DE INDEFERIMENTO DO BENEFICIO: A) COPIA DAS ULTIMAS FOLHAS DA CARTEIRA DO TRABALHO, OU COMPROVANTE DE RENDA MENSAL, E DE EVENTUAL CONJUGE; B) COPIA DOS EXTRATOS BANCARIOS DE CONTAS DE TITULARIDADE, E DE EVENTUAL CONJUGE, DOS ULTIMOS TRES MESES; C) COPIA DOS EXTRATOS DE CARTAO DE CREDITO, DOS ULTIMOS TRES MESES; D) COPIA COMPLETA DA ULTIMA DECLARACAO DO IMPOSTO DE RENDA APRESENTADA A SECRETARIA DA RECEITA FEDERAL. OU, NO MESMO PRAZO, DEVERA RECOLHER AS CUSTAS JUDICIAIS E DESPESAS PROCESSUAIS, BEM COMO A TAXA PREVIDENCIARIA RELATIVA A PROCURACAO AD JUDICIA, SOB PENA DE EXTINCAO, SEM NOVA INTIMACAO. DECORRIDO O PRAZO, TORNEM. INTIME-SE. ADVOGADOS(S): RAFAEL LUIZ BARBOSA MAGRI (OAB 301473/SP)",
                "PublishDate": "2023-07-12T00:00:00",
                "CaptureDate": "2023-07-26T09:47:25"
              },
              {
                "Content": "PROCESSO : 1054170-93.2023.8.26.0002 CLASSE : PROCEDIMENTO COMUM CIVEL REQTE : ANDRESSA REZENDE VIANA MEDINA ADVOGADO : 301473/SP - RAFAEL LUIZ BARBOSA MAGRI REQDO : NU FINANCEIRA S/A - SOCIEDADE DE CREDITO, FINANCIAMENTO E INVESTIMENTO VARA : 13 VARA CIVEL",
                "PublishDate": "2023-07-12T00:00:00",
                "CaptureDate": "2023-07-26T09:47:25"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2023-07-11T00:00:00",
                "CaptureDate": "2023-07-26T09:47:25"
              },
              {
                "Content": "PROFERIDAS OUTRAS DECISOES NAO ESPECIFICADAS VISTOS. O ART.5, LXXIV, DA CONSTITUICAO FEDERAL, DISPOE QUE O ESTADO PRESTARA ASSISTENCIA JURIDICA INTEGRAL E GRATUITA AOS QUE COMPROVAREM INSUFICIENCIA DE RECURSOS. EMBORA PARA A CONCESSAO DA GRATUIDADE NAO SE EXIJA O ESTADO DE MISERIA ABSOLUTA, E NECESSARIA A COMPROVACAO DA IMPOSSIBILIDADE DE ARCAR COM AS CUSTAS E DESPESAS DO PROCESSO SEM PREJUIZO DE SEU SUSTENTO PROPRIO OU DE SUA FAMILIA. A DECLARACAO DE POBREZA, POR SUA VEZ, ESTABELECE MERA PRESUNCAO RELATIVA DA HIPOSSUFICIENCIA, QUE CEDE ANTE OUTROS ELEMENTOS QUE SIRVAM PARA INDICAR A CAPACIDADE FINANCEIRA. NO CASO, HA ELEMENTOS SUFICIENTES PARA AFASTAR A PRESUNCAO, EM ESPECIAL: (I) NATUREZA E OBJETO DISCUTIDOS; (II) CONTRATACAO DE ADVOGADO PARTICULAR, DISPENSANDO A ATUACAO DA DEFENSORIA. ANTES DE INDEFERIR O PEDIDO, CONTUDO, CONVEM FACULTAR AO INTERESSADO O DIREITO DE PROVAR A IMPOSSIBILIDADE DE ARCAR, SEM O SEU PROPRIO PREJUIZO OU DE SUA FAMILIA, COM AS CUSTAS E DESPESAS DO PROCESSO. ASSIM, PARA APRECIACAO DO PEDIDO DE JUSTICA GRATUITA, A PARTE REQUERENTE DEVERA, EM 15 (QUINZE) DIAS, APRESENTAR, SOB PENA DE INDEFERIMENTO DO BENEFICIO: A) COPIA DAS ULTIMAS FOLHAS DA CARTEIRA DO TRABALHO, OU COMPROVANTE DE RENDA MENSAL, E DE EVENTUAL CONJUGE; B) COPIA DOS EXTRATOS BANCARIOS DE CONTAS DE TITULARIDADE, E DE EVENTUAL CONJUGE, DOS ULTIMOS TRES MESES; C) COPIA DOS EXTRATOS DE CARTAO DE CREDITO, DOS ULTIMOS TRES MESES; D) COPIA COMPLETA DA ULTIMA DECLARACAO DO IMPOSTO DE RENDA APRESENTADA A SECRETARIA DA RECEITA FEDERAL. OU, NO MESMO PRAZO, DEVERA RECOLHER AS CUSTAS JUDICIAIS E DESPESAS PROCESSUAIS, BEM COMO A TAXA PREVIDENCIARIA RELATIVA A PROCURACAO AD JUDICIA, SOB PENA DE EXTINCAO, SEM NOVA INTIMACAO. DECORRIDO O PRAZO, TORNEM. INTIME-SE.",
                "PublishDate": "2023-07-11T00:00:00",
                "CaptureDate": "2023-07-26T09:47:25"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-07-10T00:00:00",
                "CaptureDate": "2023-07-26T09:47:25"
              }
            ],
            "Petitions": [],
            "Decisions": []
          },
          {
            "Number": "10184970820238260562",
            "Type": "PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL",
            "MainSubject": "ENRIQUECIMENTO SEM CAUSA",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "ESPECIAL CIVEL",
            "CourtDistrict": "SANTOS",
            "Judge": "LUIZ FRANCISCO TROMBONI",
            "JudgingBody": "1 VARA DO JUIZADO ESPECIAL CIVEL",
            "State": "SP",
            "Status": "ATIVO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "ENRIQUECIMENTO SEM CAUSA",
            "InferredCNJSubjectNumber": 7715,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO DO JUIZADO ESPECIAL CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO CIVIL",
            "InferredBroadCNJSubjectNumber": 899,
            "OtherSubjects": [
              "ENRIQUECIMENTO SEM CAUSA",
              "INDENIZACAO POR DANO MATERIAL",
              "INDENIZACAO POR DANO MORAL"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 52800,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-07-12T00:00:00",
            "NoticeDate": "2023-07-10T00:00:00",
            "LastMovementDate": "2023-07-17T00:00:00",
            "CaptureDate": "2023-07-27T07:24:54",
            "LastUpdate": "2023-07-27T07:24:54",
            "NumberOfParties": 26,
            "NumberOfUpdates": 5,
            "LawSuitAge": 233,
            "AverageNumberOfUpdatesPerMonth": 0,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "09327197836",
                "IsPartyActive": true,
                "Name": "LUIZ FRANCISCO TROMBONI",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-07-27T07:24:54"
              },
              {
                "Doc": "35923626829",
                "IsPartyActive": true,
                "Name": "WILLIAN GHASSAN DARGHAM",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-07-27T07:24:54"
              },
              {
                "Doc": "07508997948",
                "IsPartyActive": true,
                "Name": "SALIME MAHMOUD AMIRI",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-07-27T07:24:54"
              },
              {
                "Doc": "20345973000170",
                "IsPartyActive": true,
                "Name": "WD DESIGN MOVEIS E DECORACOES EIRELI ME",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-07-27T07:24:54"
              },
              {
                "Doc": "41821072847",
                "IsPartyActive": true,
                "Name": "AMANDA THEREZA LENCI PACCOLA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "377573",
                  "State": "SP",
                  "SpecificType": "ADVOGADA (REQTE)"
                },
                "LastCaptureDate": "2023-07-27T07:24:54"
              },
              {
                "Doc": "41916011802",
                "IsPartyActive": true,
                "Name": "EMILIA GARBUIO PELEGRINI",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "383720",
                  "State": "SP",
                  "SpecificType": "ADVOGADA (REQTE)"
                },
                "LastCaptureDate": "2023-07-27T07:24:54"
              },
              {
                "Doc": "40945046000106",
                "IsPartyActive": true,
                "Name": "AFONSO COSTA GESTAO DE PAGAMENTOS EPP LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-27T07:24:54"
              },
              {
                "IsPartyActive": true,
                "Name": "ALAN RODRIGO DE SOUZA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-27T07:24:54"
              },
              {
                "IsPartyActive": true,
                "Name": "ALINE GOMES DE ARAUJO",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-27T07:24:54"
              },
              {
                "Doc": "00000000000191",
                "IsPartyActive": true,
                "Name": "BANCO DO BRASIL SA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-27T07:24:54"
              },
              {
                "IsPartyActive": true,
                "Name": "CASH PAY MEIOS DE PAGAMENTOS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-27T07:24:54"
              },
              {
                "IsPartyActive": true,
                "Name": "CELCOIN PAGAMENTOS S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-27T07:24:54"
              },
              {
                "IsPartyActive": true,
                "Name": "DANILO ZUCCO",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-27T07:24:54"
              },
              {
                "Doc": "47018560000137",
                "IsPartyActive": true,
                "Name": "FELIPE SILVA DO RAMO 33828070841",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-27T07:24:54"
              },
              {
                "Doc": "33828070841",
                "IsPartyActive": true,
                "Name": "FELIPE SILVA DO RAMO",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-27T07:24:54"
              },
              {
                "Doc": "34687453899",
                "IsPartyActive": true,
                "Name": "JONAS BISPO FERREIRA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-27T07:24:54"
              },
              {
                "Doc": "48472928000103",
                "IsPartyActive": true,
                "Name": "KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-27T07:24:54"
              },
              {
                "Doc": "08561701000101",
                "IsPartyActive": true,
                "Name": "PAGSEGURO INTERNET S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-27T07:24:54"
              },
              {
                "Doc": "04186064121",
                "IsPartyActive": true,
                "Name": "SIDNEI AFONSO DA COSTA NETO",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-27T07:24:54"
              },
              {
                "Doc": "49099767000109",
                "IsPartyActive": true,
                "Name": "49 099 767 SONIA REGINA PINA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-27T07:24:54"
              },
              {
                "Doc": "01184656860",
                "IsPartyActive": true,
                "Name": "SONIA REGINA PINA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-27T07:24:54"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-27T07:24:54"
              },
              {
                "Doc": "14345066735",
                "IsPartyActive": true,
                "Name": "SUN CHUNYANG",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-27T07:24:54"
              },
              {
                "Doc": "49219438000154",
                "IsPartyActive": true,
                "Name": "TALK COMERCIO IMPORTACAO E EXPORTACAO LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-27T07:24:54"
              },
              {
                "Doc": "32566607893",
                "IsPartyActive": true,
                "Name": "VANESSA DA CONCEICAO SOARES",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-27T07:24:54"
              },
              {
                "Doc": "16838421000207",
                "IsPartyActive": true,
                "Name": "XP INVESTIMENTOS S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-27T07:24:54"
              }
            ],
            "Updates": [
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0593/2023 DATA DA PUBLICACAO: 18/07/2023 NUMERO DO DIARIO: 3779",
                "PublishDate": "2023-07-17T00:00:00",
                "CaptureDate": "2023-07-27T07:24:54"
              },
              {
                "Content": "NAO CONCEDIDA A ANTECIPACAO DE TUTELA VISTOS. INDEFIRO A ANTECIPACAO DA TUTELA DE URGENCIA, UMA VEZ QUE NAO EXISTE PROVA SATISFATORIA DA PRETENSAO RAZOAVEL COM PROBABILIDADE DE EXITO EM JUIZO E NEM FUNDADO RECEITO DE DANO IRREPARAVEL OU DE DIFICIL REPARACAO OU RISCO AO RESULTADO UTIL DO PROCESSO. FICA INDEFERIDA A DESCONSIDERACAO DA PERSONALIDADE JURIDICA, UMA VEZ QUE DEVE SER PLEITEADA NO CUMPRIMENTO DE SENTENCA, DEVENDO O AUTOR EMENDAR A INICIAL PARA QUE CONSTE NO POLO PASSIVO SOMENTE A EMPRESA CUJO SOCIOS PRETENDE DESCONSIDERAR, BEM COMO, OS BENEFICIARIOS DAS TRANSACOES BANCARIAS E AS INSTITUICOES FINANCEIRAS, NO PRAZO DE 15 DIAS, SOB PENA DE INDEFERIMENTO DA INICIAL. INT.",
                "PublishDate": "2023-07-14T00:00:00",
                "CaptureDate": "2023-07-27T07:24:54"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0593/2023 TEOR DO ATO: VISTOS. INDEFIRO A ANTECIPACAO DA TUTELA DE URGENCIA, UMA VEZ QUE NAO EXISTE PROVA SATISFATORIA DA PRETENSAO RAZOAVEL COM PROBABILIDADE DE EXITO EM JUIZO E NEM FUNDADO RECEITO DE DANO IRREPARAVEL OU DE DIFICIL REPARACAO OU RISCO AO RESULTADO UTIL DO PROCESSO. FICA INDEFERIDA A DESCONSIDERACAO DA PERSONALIDADE JURIDICA, UMA VEZ QUE DEVE SER PLEITEADA NO CUMPRIMENTO DE SENTENCA, DEVENDO O AUTOR EMENDAR A INICIAL PARA QUE CONSTE NO POLO PASSIVO SOMENTE A EMPRESA CUJO SOCIOS PRETENDE DESCONSIDERAR, BEM COMO, OS BENEFICIARIOS DAS TRANSACOES BANCARIAS E AS INSTITUICOES FINANCEIRAS, NO PRAZO DE 15 DIAS, SOB PENA DE INDEFERIMENTO DA INICIAL. INT. ADVOGADOS(S): AMANDA THEREZA LENCI PACCOLA (OAB 377573/SP), EMILIA GARBUIO PELEGRINI (OAB 383720/SP)",
                "PublishDate": "2023-07-14T00:00:00",
                "CaptureDate": "2023-07-27T07:24:54"
              },
              {
                "Content": "PROCESSO : 1018497-08.2023.8.26.0562 CLASSE : PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL REQTE : WD DESIGN MOVEIS E DECORACOES EIRELI ME ADVOGADO : 383720/SP - EMILIA GARBUIO PELEGRINI REQDO : XP INVESTIMENTOS S.A. VARA : 1 VARA DO JUIZADO ESPECIAL CIVEL",
                "PublishDate": "2023-07-12T00:00:00",
                "CaptureDate": "2023-07-27T07:24:54"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-07-10T00:00:00",
                "CaptureDate": "2023-07-27T07:24:54"
              }
            ],
            "Petitions": [],
            "Decisions": []
          },
          {
            "Number": "10905605920238260100",
            "Type": "PROCEDIMENTO COMUM",
            "MainSubject": "DIREITO PROCESSUAL CIVIL E DO TRABALHO",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "SAO PAULO",
            "Judge": "PAULO ROGERIO SANTOS PINHEIRO",
            "JudgingBody": "43 VARA CIVEL",
            "State": "SP",
            "Status": "ATIVO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "DIREITO PROCESSUAL CIVIL E DO TRABALHO",
            "InferredCNJSubjectNumber": 8826,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO PROCESSUAL CIVIL E DO TRABALHO",
            "InferredBroadCNJSubjectNumber": 8826,
            "OtherSubjects": [
              "DIREITO PROCESSUAL CIVIL E DO TRABALHO"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 68528,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-07-13T00:00:00",
            "NoticeDate": "2023-07-07T00:00:00",
            "LastMovementDate": "2023-07-14T00:00:00",
            "CaptureDate": "2023-07-28T01:28:17",
            "LastUpdate": "2023-07-28T01:28:17",
            "NumberOfParties": 11,
            "NumberOfUpdates": 7,
            "LawSuitAge": 236,
            "AverageNumberOfUpdatesPerMonth": 0,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "25371097830",
                "IsPartyActive": true,
                "Name": "PAULO ROGERIO SANTOS PINHEIRO",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-07-28T01:28:17"
              },
              {
                "Doc": "30595915809",
                "IsPartyActive": true,
                "Name": "DANIELY ARAUJO DORO GOULART",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-07-28T01:28:17"
              },
              {
                "Doc": "30595915809",
                "IsPartyActive": true,
                "Name": "DANIELY ARAUJO DORO GOULART",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "236008",
                  "State": "SP",
                  "SpecificType": "ADVOGADA (REQTE)"
                },
                "LastCaptureDate": "2023-07-28T01:28:17"
              },
              {
                "Doc": "48472928000103",
                "IsPartyActive": true,
                "Name": "KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-28T01:28:17"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-28T01:28:17"
              },
              {
                "Doc": "49644457000128",
                "IsPartyActive": true,
                "Name": "BRISTOR COMERCIAL BRINQUEDOS LTDA EPP",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-28T01:28:17"
              },
              {
                "Doc": "36753456880",
                "IsPartyActive": true,
                "Name": "LEANDRO ALBERTO DOS SANTOS",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-28T01:28:17"
              },
              {
                "Doc": "04063310302",
                "IsPartyActive": true,
                "Name": "GUIRLANDE BEZERRA FERREIRA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDA"
                },
                "LastCaptureDate": "2023-07-28T01:28:17"
              },
              {
                "IsPartyActive": true,
                "Name": "RENATO DOMINGOS DOS SANTOS",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-28T01:28:17"
              },
              {
                "Doc": "47763100826",
                "IsPartyActive": true,
                "Name": "NATHALIA SOUZA DE CARVALHO",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDA"
                },
                "LastCaptureDate": "2023-07-28T01:28:17"
              },
              {
                "Doc": "02878774779",
                "IsPartyActive": true,
                "Name": "GILSON NICOLAU DA CONCEICAO",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-28T01:28:17"
              }
            ],
            "Updates": [
              {
                "Content": "PETICAO INTERMEDIARIA DIGITALIZACAO JUNTADA N PROTOCOLO: WJMJ.23.41400589-1 TIPO DA PETICAO: PETICAO INTERMEDIARIA - DIGITALIZACAO DATA: 14/07/2023 19:47",
                "PublishDate": "2023-07-14T00:00:00",
                "CaptureDate": "2023-07-28T01:28:18"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0610/2023 DATA DA PUBLICACAO: 14/07/2023 NUMERO DO DIARIO: 3777",
                "PublishDate": "2023-07-13T00:00:00",
                "CaptureDate": "2023-07-28T01:28:18"
              },
              {
                "Content": "PROCESSO 1090560-59.2023.8.26.0100 - PROCEDIMENTO COMUM CIVEL - DIREITO PROCESSUAL CIVIL E DO TRABALHO - DANIELY ARAUJO DORO GOULART - VISTOS. O ARTIGO 5, LXXIV, DA CONSTITUICAO FEDERAL PRECONIZA QUE O O ESTADO PRESTARA ASSISTENCIA JUDICIARIA INTEGRAL E GRATUITA AOS QUE COMPROVAREM INSUFICIENCIA DE RECURSOS (GRIFEI). E NA LEGISLACAO INFRACONSTITUCIONAL, O ARTIGO 98, CAPUT, DO CODIGO DE PROCESSO CIVIL DEFINE QUE A PESSOA NATURAL OU JURIDICA, BRASILEIRA OU ESTRANGEIRA, COM INSUFICIENCIA DE RECURSOS PARA PAGAR AS CUSTAS, AS DESPESAS PROCESSUAIS E OS HONORARIOS ADVOCATICIOS TEM DIREITO A GRATUIDADE DA JUSTICA, NA FORMA DA LEI. (GRIFEI). DESSA ARTE, ASSINO O PRAZO DE 15 DIAS PARA QUE A PARTE TRAGA AOS AUTOS: A) DOIS ULTIMOS COMPROVANTES DE RENDIMENTOS, DUAS ULTIMAS DECLARACOES DE BENS E RENDIMENTOS ENTREGUES A RECEITA FEDERAL, E OS EXTRATOS ATUALIZADOS DE CONTAS CORRENTE E DE APLICACOES FINANCEIRAS, INCLUSIVE DE POUPANCAS, NA HIPOTESE DE TRATAR-SE DE PESSOA FISICA; B) LIVRO CAIXA, A ULTIMA ESCRITURACAO CONTABIL FISCAL (ECF) OU DECLARACAO DE INFORMACOES ECONOMICO-FISCAIS (DIPJ) ENTREGUE A RECEITA FEDERAL, E O EXTRATO ATUALIZADO DE CONTA CORRENTE E DE APLICACOES FINANCEIRAS, INCLUSIVE DE POUPANCA, NA HIPOTESE DE PESSOA JURIDICA. ANOTE- SE O SIGILO DOS DOCUMENTOS APRESENTADOS. INTIME-SE - ADV: DANIELY ARAUJO DORO GOULART (OAB 236008/SP)",
                "PublishDate": "2023-07-13T00:00:00",
                "CaptureDate": "2023-07-28T01:28:17"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0610/2023 TEOR DO ATO: VISTOS. O ARTIGO 5, LXXIV, DA CONSTITUICAO FEDERAL PRECONIZA QUE O O ESTADO PRESTARA ASSISTENCIA JUDICIARIA INTEGRAL E GRATUITA AOS QUE COMPROVAREM INSUFICIENCIA DE RECURSOS (GRIFEI). E NA LEGISLACAO INFRACONSTITUCIONAL, O ARTIGO 98, CAPUT, DO CODIGO DE PROCESSO CIVIL DEFINE QUE A PESSOA NATURAL OU JURIDICA, BRASILEIRA OU ESTRANGEIRA, COM INSUFICIENCIA DE RECURSOS PARA PAGAR AS CUSTAS, AS DESPESAS PROCESSUAIS E OS HONORARIOS ADVOCATICIOS TEM DIREITO A GRATUIDADE DA JUSTICA, NA FORMA DA LEI. (GRIFEI). DESSA ARTE, ASSINO O PRAZO DE 15 DIAS PARA QUE A PARTE TRAGA AOS AUTOS: A) DOIS ULTIMOS COMPROVANTES DE RENDIMENTOS, DUAS ULTIMAS DECLARACOES DE BENS E RENDIMENTOS ENTREGUES A RECEITA FEDERAL, E OS EXTRATOS ATUALIZADOS DE CONTAS CORRENTE E DE APLICACOES FINANCEIRAS, INCLUSIVE DE POUPANCAS, NA HIPOTESE DE TRATAR-SE DE PESSOA FISICA; B) LIVRO CAIXA, A ULTIMA ESCRITURACAO CONTABIL FISCAL (ECF) OU DECLARACAO DE INFORMACOES ECONOMICO-FISCAIS (DIPJ) ENTREGUE A RECEITA FEDERAL, E O EXTRATO ATUALIZADO DE CONTA CORRENTE E DE APLICACOES FINANCEIRAS, INCLUSIVE DE POUPANCA, NA HIPOTESE DE PESSOA JURIDICA. ANOTE-SE O SIGILO DOS DOCUMENTOS APRESENTADOS. INTIME-SE ADVOGADOS(S): DANIELY ARAUJO DORO GOULART (OAB 236008/SP)",
                "PublishDate": "2023-07-12T00:00:00",
                "CaptureDate": "2023-07-28T01:28:18"
              },
              {
                "Content": "PROFERIDAS OUTRAS DECISOES NAO ESPECIFICADAS VISTOS. O ARTIGO 5, LXXIV, DA CONSTITUICAO FEDERAL PRECONIZA QUE O O ESTADO PRESTARA ASSISTENCIA JUDICIARIA INTEGRAL E GRATUITA AOS QUE COMPROVAREM INSUFICIENCIA DE RECURSOS (GRIFEI). E NA LEGISLACAO INFRACONSTITUCIONAL, O ARTIGO 98, CAPUT, DO CODIGO DE PROCESSO CIVIL DEFINE QUE A PESSOA NATURAL OU JURIDICA, BRASILEIRA OU ESTRANGEIRA, COM INSUFICIENCIA DE RECURSOS PARA PAGAR AS CUSTAS, AS DESPESAS PROCESSUAIS E OS HONORARIOS ADVOCATICIOS TEM DIREITO A GRATUIDADE DA JUSTICA, NA FORMA DA LEI. (GRIFEI). DESSA ARTE, ASSINO O PRAZO DE 15 DIAS PARA QUE A PARTE TRAGA AOS AUTOS: A) DOIS ULTIMOS COMPROVANTES DE RENDIMENTOS, DUAS ULTIMAS DECLARACOES DE BENS E RENDIMENTOS ENTREGUES A RECEITA FEDERAL, E OS EXTRATOS ATUALIZADOS DE CONTAS CORRENTE E DE APLICACOES FINANCEIRAS, INCLUSIVE DE POUPANCAS, NA HIPOTESE DE TRATAR-SE DE PESSOA FISICA; B) LIVRO CAIXA, A ULTIMA ESCRITURACAO CONTABIL FISCAL (ECF) OU DECLARACAO DE INFORMACOES ECONOMICO-FISCAIS (DIPJ) ENTREGUE A RECEITA FEDERAL, E O EXTRATO ATUALIZADO DE CONTA CORRENTE E DE APLICACOES FINANCEIRAS, INCLUSIVE DE POUPANCA, NA HIPOTESE DE PESSOA JURIDICA. ANOTE-SE O SIGILO DOS DOCUMENTOS APRESENTADOS. INTIME-SE",
                "PublishDate": "2023-07-11T00:00:00",
                "CaptureDate": "2023-07-28T01:28:18"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2023-07-10T00:00:00",
                "CaptureDate": "2023-07-28T01:28:18"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-07-07T00:00:00",
                "CaptureDate": "2023-07-28T01:28:18"
              }
            ],
            "Petitions": [
              {
                "Type": "PETICAO INTERMEDIARIA - DIGITALIZACAO",
                "Author": "",
                "CreationDate": "2023-07-14T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              }
            ],
            "Decisions": []
          },
          {
            "Number": "10541795520238260002",
            "Type": "PROCEDIMENTO COMUM",
            "MainSubject": "PRATICAS ABUSIVAS",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "SAO PAULO",
            "Judge": "RENATO SIQUEIRA DE PRETTO",
            "JudgingBody": "14 VARA CIVEL",
            "State": "SP",
            "Status": "INDEFINIDO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "PRÁTICAS ABUSIVAS",
            "InferredCNJSubjectNumber": 11811,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "PRATICAS ABUSIVAS"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 32137.51,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-07-13T00:00:00",
            "NoticeDate": "2023-07-11T00:00:00",
            "LastMovementDate": "2023-07-27T00:00:00",
            "CaptureDate": "2023-07-28T01:30:17",
            "LastUpdate": "2023-07-28T01:30:17",
            "NumberOfParties": 9,
            "NumberOfUpdates": 8,
            "LawSuitAge": 232,
            "AverageNumberOfUpdatesPerMonth": 1,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "25119030831",
                "IsPartyActive": true,
                "Name": "RENATO SIQUEIRA DE PRETTO",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-07-28T01:30:17"
              },
              {
                "Doc": "43369159899",
                "IsPartyActive": true,
                "Name": "LUANA MOREIRA SOUSA",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-07-28T01:30:17"
              },
              {
                "Doc": "25007192864",
                "IsPartyActive": true,
                "Name": "DULCINEIA NASCIMENTO ZANON TERENCIO",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "199272",
                  "State": "SP",
                  "SpecificType": "ADVOGADA (REQTE)"
                },
                "LastCaptureDate": "2023-07-28T01:30:17"
              },
              {
                "IsPartyActive": true,
                "Name": "BANCO ITER S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-28T01:30:17"
              },
              {
                "IsPartyActive": true,
                "Name": "VIA PAGSEGURO INTERNET S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-28T01:30:17"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-28T01:30:17"
              },
              {
                "Doc": "11275560000175",
                "IsPartyActive": true,
                "Name": "RECARGAPAY INSTITUICAO DE PAGAMENTO LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-28T01:30:17"
              },
              {
                "IsPartyActive": true,
                "Name": "CELCOIN PAGAMENTOS S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-28T01:30:17"
              },
              {
                "Doc": "08277965443",
                "IsPartyActive": true,
                "Name": "CAMILA DE ALMEIDA BASTOS DE MORAES REGO",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "SpecificType": "ADVOGADA (REQDO)"
                },
                "LastCaptureDate": "2023-07-28T01:30:17"
              }
            ],
            "Updates": [
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WSTA.23.70638996-7 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 27/07/2023 18:12",
                "PublishDate": "2023-07-27T00:00:00",
                "CaptureDate": "2023-07-28T01:30:18"
              },
              {
                "Content": "IMESC - OFICIO - DIVERSOS - JUNTADO N PROTOCOLO: WSTA.23.70623787-3 TIPO DA PETICAO: IMESC - OFICIO - DIVERSOS DATA: 24/07/2023 17:13",
                "PublishDate": "2023-07-24T00:00:00",
                "CaptureDate": "2023-07-28T01:30:18"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0524/2023 DATA DA PUBLICACAO: 14/07/2023 NUMERO DO DIARIO: 3777",
                "PublishDate": "2023-07-13T00:00:00",
                "CaptureDate": "2023-07-28T01:30:18"
              },
              {
                "Content": "PROCESSO : 1054179-55.2023.8.26.0002 CLASSE : PROCEDIMENTO COMUM CIVEL REQTE : LUANA MOREIRA SOUSA ADVOGADO : 199272/SP - DULCINEIA NASCIMENTO ZANON TERENCIO REQDO : CELCOIN PAGAMENTOS S.A. VARA : 14 VARA CIVEL PROCESSO 1054179-55.2023.8.26.0002 - PROCEDIMENTO COMUM CIVEL - PRATICAS ABUSIVAS - LUANA MOREIRA SOUSA - VISTOS. NO CASO PRESENTE, DEVERA A PARTE AUTORA PROVAR A INSUFICIENCIA DE RECURSOS PARA QUE LHE SEJA DEFERIDA A GRATUIDADE DA JUSTICA. DE FATO, DISPOE O CODIGO DE PROCESSO CIVIL, NO  3 DO ARTIGO 99: PRESUME-SE VERDADEIRA A ALEGACAO DE INSUFICIENCIA DEDUZIDA EXCLUSIVAMENTE POR PESSOA NATURAL. NO ENTANTO, ESSA PRESUNCAO E RELATIVA, DE MODO QUE, HAVENDO INDICIOS DE QUE A PARTE PODE PROVER COM AS CUSTAS E DESPESAS DO PROCESSO, DEVERA SER INSTADA A PROVAR A INSUFICIENCIA DE RECURSOS, NOS TERMOS DO  2 DO MESMO ARTIGO ACIMA CITADO. ALEM DISSO, A GRATUIDADE PODERA SER CONCEDIDA EM RELACAO A ALGUM OU A TODOS OS ATOS PROCESSUAIS, OU CONSISTIR NA REDUCAO PERCENTUAL DE DESPESAS PROCESSUAIS QUE O BENEFICIARIO TIVER DE ADIANTAR NO CURSO DO PROCEDIMENTO (ARTIGO 98,  5 DO CPC). ASSIM, CUMPRE AFERIR NAO SOMENTE SE A PARTE NAO DISPOE DE RECURSOS PARA PROVER AS CUSTAS, AS DESPESAS PROCESSUAIS E OS HONORARIOS ADVOCATICIOS, BEM COM O SE ESSA INCAPACIDADE E ABSOLUTA OU RELATIVA, POSTO QUE O BENEFICIO PODE SER CONCEDIDO PARCIALMENTE. ASSIM, PARA APRECIACAO DO PEDIDO DE JUSTICA GRATUITA, A PARTE REQUERENTE DEVERA, EM QUINZE DIAS, APRESENTAR, SOB PENA DE INDEFERIMENTO DO BENEFICIO: A) COPIA DAS ULTIMAS FOLHAS DA CARTEIRA DO TRABALHO, OU COMPROVANTE DE RENDA MENSAL, E DE EVENTUAL CONJUGE; B) COPIA DA ULTIMA DECLARACAO DO IMPOSTO DE RENDA APRESENTADA A SECRETARIA DA RECEITA FEDERAL. OBSERVE QUE A NAO-OBRIGATORIEDADE DA DECLARACAO ANUAL DE ISENTO NAO IMPEDE QUE SE EXTRAIAM CERTIDOES JUNTO A RECEITA FEDERAL COMPROVANDO A AUSENCIA DE DECLARACOES DE DIRPF EM NOME DO POSTULANTE, DE FORMA A CORROBORAR A VEROSSIMILHANCA DA ALEGACAO DE HIPOSSUFICIENCIA. ESSA DISPENSA, CONTUDO, NAO ELIMINA VERIFICACAO DE SITUACAO CADASTRAL DEVENDO O POSTULANTE APRESENTAR AS CERTIDOES PELO LINK: HTTPS://SERVICOS.RECEITA.FAZENDA.GOV.BR/SERVICOS/CONSREST/ATUAL. APP/PAGINAS/INDEX.ASP NAO O FAZENDO, NEM SENDO RECOLHIDA A TAXA JUDICIARIA, DEVERA O PROCESSO DE SER EXTINTO, POR AUSENCIA DESSE PRESSUPOSTO PROCESSUAL. - ADV: DULCINEIA NASCIMENTO ZANON TERENCIO (OAB 199272/SP)",
                "PublishDate": "2023-07-13T00:00:00",
                "CaptureDate": "2023-07-28T01:30:17"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0524/2023 TEOR DO ATO: VISTOS. NO CASO PRESENTE, DEVERA A PARTE AUTORA PROVAR A INSUFICIENCIA DE RECURSOS PARA QUE LHE SEJA DEFERIDA A GRATUIDADE DA JUSTICA. DE FATO, DISPOE O CODIGO DE PROCESSO CIVIL, NO  3 DO ARTIGO 99: PRESUME-SE VERDADEIRA A ALEGACAO DE INSUFICIENCIA DEDUZIDA EXCLUSIVAMENTE POR PESSOA NATURAL. NO ENTANTO, ESSA PRESUNCAO E RELATIVA, DE MODO QUE, HAVENDO INDICIOS DE QUE A PARTE PODE PROVER COM AS CUSTAS E DESPESAS DO PROCESSO, DEVERA SER INSTADA A PROVAR A INSUFICIENCIA DE RECURSOS, NOS TERMOS DO  2 DO MESMO ARTIGO ACIMA CITADO. ALEM DISSO, A GRATUIDADE PODERA SER CONCEDIDA EM RELACAO A ALGUM OU A TODOS OS ATOS PROCESSUAIS, OU CONSISTIR NA REDUCAO PERCENTUAL DE DESPESAS PROCESSUAIS QUE O BENEFICIARIO TIVER DE ADIANTAR NO CURSO DO PROCEDIMENTO (ARTIGO 98,  5 DO CPC). ASSIM, CUMPRE AFERIR NAO SOMENTE SE A PARTE NAO DISPOE DE RECURSOS PARA PROVER AS CUSTAS, AS DESPESAS PROCESSUAIS E OS HONORARIOS ADVOCATICIOS, BEM COM O SE ESSA INCAPACIDADE E ABSOLUTA OU RELATIVA, POSTO QUE O BENEFICIO PODE SER CONCEDIDO PARCIALMENTE. ASSIM, PARA APRECIACAO DO PEDIDO DE JUSTICA GRATUITA, A PARTE REQUERENTE DEVERA, EM QUINZE DIAS, APRESENTAR, SOB PENA DE INDEFERIMENTO DO BENEFICIO: A) COPIA DAS ULTIMAS FOLHAS DA CARTEIRA DO TRABALHO, OU COMPROVANTE DE RENDA MENSAL, E DE EVENTUAL CONJUGE; B) COPIA DA ULTIMA DECLARACAO DO IMPOSTO DE RENDA APRESENTADA A SECRETARIA DA RECEITA FEDERAL. OBSERVE QUE A NAO-OBRIGATORIEDADE DA DECLARACAO ANUAL DE ISENTO NAO IMPEDE QUE SE EXTRAIAM CERTIDOES JUNTO A RECEITA FEDERAL COMPROVANDO A AUSENCIA DE DECLARACOES DE DIRPF EM NOME DO POSTULANTE, DE FORMA A CORROBORAR A VEROSSIMILHANCA DA ALEGACAO DE HIPOSSUFICIENCIA. ESSA DISPENSA, CONTUDO, NAO ELIMINA VERIFICACAO DE SITUACAO CADASTRAL DEVENDO O POSTULANTE APRESENTAR AS CERTIDOES PELO LINK: HTTPS://SERVICOS.RECEITA.FAZENDA.GOV.BR/SERVICOS/CONSREST/ATUAL.APP/PAGINAS/INDEX.ASP NAO O FAZENDO, NEM SENDO RECOLHIDA A TAXA JUDICIARIA, DEVERA O PROCESSO DE SER EXTINTO, POR AUSENCIA DESSE PRESSUPOSTO PROCESSUAL. ADVOGADOS(S): DULCINEIA NASCIMENTO ZANON TERENCIO (OAB 199272/SP)",
                "PublishDate": "2023-07-12T00:00:00",
                "CaptureDate": "2023-07-28T01:30:18"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-07-11T00:00:00",
                "CaptureDate": "2023-07-28T01:30:18"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2023-07-11T00:00:00",
                "CaptureDate": "2023-07-28T01:30:18"
              },
              {
                "Content": "NAO CONCEDIDA A ASSISTENCIA JUDICIARIA GRATUITA VISTOS. NO CASO PRESENTE, DEVERA A PARTE AUTORA PROVAR A INSUFICIENCIA DE RECURSOS PARA QUE LHE SEJA DEFERIDA A GRATUIDADE DA JUSTICA. DE FATO, DISPOE O CODIGO DE PROCESSO CIVIL, NO  3 DO ARTIGO 99: PRESUME-SE VERDADEIRA A ALEGACAO DE INSUFICIENCIA DEDUZIDA EXCLUSIVAMENTE POR PESSOA NATURAL. NO ENTANTO, ESSA PRESUNCAO E RELATIVA, DE MODO QUE, HAVENDO INDICIOS DE QUE A PARTE PODE PROVER COM AS CUSTAS E DESPESAS DO PROCESSO, DEVERA SER INSTADA A PROVAR A INSUFICIENCIA DE RECURSOS, NOS TERMOS DO  2 DO MESMO ARTIGO ACIMA CITADO. ALEM DISSO, A GRATUIDADE PODERA SER CONCEDIDA EM RELACAO A ALGUM OU A TODOS OS ATOS PROCESSUAIS, OU CONSISTIR NA REDUCAO PERCENTUAL DE DESPESAS PROCESSUAIS QUE O BENEFICIARIO TIVER DE ADIANTAR NO CURSO DO PROCEDIMENTO (ARTIGO 98,  5 DO CPC). ASSIM, CUMPRE AFERIR NAO SOMENTE SE A PARTE NAO DISPOE DE RECURSOS PARA PROVER AS CUSTAS, AS DESPESAS PROCESSUAIS E OS HONORARIOS ADVOCATICIOS, BEM COM O SE ESSA INCAPACIDADE E ABSOLUTA OU RELATIVA, POSTO QUE O BENEFICIO PODE SER CONCEDIDO PARCIALMENTE. ASSIM, PARA APRECIACAO DO PEDIDO DE JUSTICA GRATUITA, A PARTE REQUERENTE DEVERA, EM QUINZE DIAS, APRESENTAR, SOB PENA DE INDEFERIMENTO DO BENEFICIO: A) COPIA DAS ULTIMAS FOLHAS DA CARTEIRA DO TRABALHO, OU COMPROVANTE DE RENDA MENSAL, E DE EVENTUAL CONJUGE; B) COPIA DA ULTIMA DECLARACAO DO IMPOSTO DE RENDA APRESENTADA A SECRETARIA DA RECEITA FEDERAL. OBSERVE QUE A NAO-OBRIGATORIEDADE DA DECLARACAO ANUAL DE ISENTO NAO IMPEDE QUE SE EXTRAIAM CERTIDOES JUNTO A RECEITA FEDERAL COMPROVANDO A AUSENCIA DE DECLARACOES DE DIRPF EM NOME DO POSTULANTE, DE FORMA A CORROBORAR A VEROSSIMILHANCA DA ALEGACAO DE HIPOSSUFICIENCIA. ESSA DISPENSA, CONTUDO, NAO ELIMINA VERIFICACAO DE SITUACAO CADASTRAL DEVENDO O POSTULANTE APRESENTAR AS CERTIDOES PELO LINK: HTTPS://SERVICOS.RECEITA.FAZENDA.GOV.BR/SERVICOS/CONSREST/ATUAL.APP/PAGINAS/INDEX.ASP NAO O FAZENDO, NEM SENDO RECOLHIDA A TAXA JUDICIARIA, DEVERA O PROCESSO DE SER EXTINTO, POR AUSENCIA DESSE PRESSUPOSTO PROCESSUAL.",
                "PublishDate": "2023-07-11T00:00:00",
                "CaptureDate": "2023-07-28T01:30:18"
              }
            ],
            "Petitions": [
              {
                "Type": "IMESC - OFICIO - DIVERSOS",
                "Author": "",
                "CreationDate": "2023-07-24T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2023-07-27T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              }
            ],
            "Decisions": []
          },
          {
            "Number": "10210351420238260577",
            "Type": "PROCEDIMENTO COMUM",
            "MainSubject": "PRATICAS ABUSIVAS",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "SAO JOSE DOS CAMPOS",
            "Judge": "HEITOR FEBELIANO DOS SANTOS COSTA",
            "JudgingBody": "4 VARA CIVEL",
            "State": "SP",
            "Status": "INDEFINIDO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "PRÁTICAS ABUSIVAS",
            "InferredCNJSubjectNumber": 11811,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "PRATICAS ABUSIVAS"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 8601.29,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-07-14T00:00:00",
            "NoticeDate": "2023-07-12T00:00:00",
            "LastMovementDate": "2023-07-27T00:00:00",
            "CaptureDate": "2023-07-29T01:17:51",
            "LastUpdate": "2023-07-29T01:17:51",
            "NumberOfParties": 6,
            "NumberOfUpdates": 11,
            "LawSuitAge": 231,
            "AverageNumberOfUpdatesPerMonth": 1,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "07242048818",
                "IsPartyActive": true,
                "Name": "HEITOR FEBELIANO DOS SANTOS COSTA",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-07-29T01:17:51"
              },
              {
                "Doc": "24864098824",
                "IsPartyActive": true,
                "Name": "PATRICIA DA PENHA BRAZ PEREIRA",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-07-29T01:17:51"
              },
              {
                "Doc": "44327460842",
                "IsPartyActive": true,
                "Name": "BIANCA VENANCIO LOPES DE OLIVEIRA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "467602",
                  "State": "SP",
                  "SpecificType": "ADVOGADA (REQTE)"
                },
                "LastCaptureDate": "2023-07-29T01:17:51"
              },
              {
                "Doc": "97140909000187",
                "IsPartyActive": true,
                "Name": "J C BONETO DISTRIBUIDORA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-29T01:17:51"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-29T01:17:51"
              },
              {
                "Doc": "10573521000191",
                "IsPartyActive": true,
                "Name": "MERCADOPAGO COM REPRESENTACOES LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDA"
                },
                "LastCaptureDate": "2023-07-29T01:17:51"
              }
            ],
            "Updates": [
              {
                "Content": "AR POSITIVO JUNTADO JUNTADA DE AR : AA556343827TJ SITUACAO : CUMPRIDO MODELO : PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC DESTINATARIO : STARK BANK S.A. DILIGENCIA : 21/07/2023",
                "PublishDate": "2023-07-27T00:00:00",
                "CaptureDate": "2023-07-29T01:17:52"
              },
              {
                "Content": "AR POSITIVO JUNTADO JUNTADA DE AR : AA556343835TJ SITUACAO : CUMPRIDO MODELO : PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC DESTINATARIO : MERCADOPAGO.COM REPRESENTACOES LTDA DILIGENCIA : 21/07/2023",
                "PublishDate": "2023-07-25T00:00:00",
                "CaptureDate": "2023-07-29T01:17:52"
              },
              {
                "Content": "CARTA EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                "PublishDate": "2023-07-17T00:00:00",
                "CaptureDate": "2023-07-29T01:17:52"
              },
              {
                "Content": "CARTA EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                "PublishDate": "2023-07-17T00:00:00",
                "CaptureDate": "2023-07-29T01:17:52"
              },
              {
                "Content": "CARTA EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                "PublishDate": "2023-07-17T00:00:00",
                "CaptureDate": "2023-07-29T01:17:52"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0618/2023 DATA DA PUBLICACAO: 17/07/2023 NUMERO DO DIARIO: 3778",
                "PublishDate": "2023-07-14T00:00:00",
                "CaptureDate": "2023-07-29T01:17:52"
              },
              {
                "Content": "PROCESSO : 1021035-14.2023.8.26.0577 CLASSE : PROCEDIMENTO COMUM CIVEL REQTE : PATRICIA DA PENHA BRAZ PEREIRA ADVOGADO : 467602/SP - BIANCA VENANCIO LOPES DE OLIVEIRA REQDO : J .C BONETO DISTRIBUIDORA VARA : 4 VARA CIVEL PROCESSO 1021035-14.2023.8.26.0577 - PROCEDIMENTO COMUM CIVEL - PRATICAS ABUSIVAS - PATRICIA DA PENHA BRAZ PEREIRA - VISTOS. 1 CONCEDO A PARTE REQUERENTE OS BENEFICIOS DE JUSTICA GRATUITA, ANOTANDO-SE O NECESSARIO. 2 PESEM, EMBORA, OS ARGUMENTOS DA REQUERENTE, REPUTO NAO PRESENTES TODOS OS REQUISITOS LEGAIS AO DEFERIMENTO DA MEDIDA DE URGENCIA PLEITEADA. REALMENTE, APESAR DA DOCUMENTACAO APRESENTADA, OS FATOS SE APRESENTAM CONTROVERTIDOS E SOMENTE PODEM SER MELHOR ANALISADOS SOB O CONTRADITORIO. NAO HA FALAR, DESTARTE, EM EXISTENCIA DE ELEMENTOS A EVIDENCIAR PROBABILIDADE DO DIREITO AFIRMADO. NAO VISLUMBRO, IGUALMENTE, PERIGO DE DANO IRREPARAVEL OU RISCO AO RESULTADO UTIL DO PROCESSO, ACASO NAO DEFERIDA LIMINARMENTE A MEDIDA. POSTO ISTO, INDEFIRO A MEDIDA DE URGENCIA. 3 DIANTE DAS ESPECIFICIDADES DA CAUSA E DE MODO A ADEQUAR O RITO PROCESSUAL AS NECESSIDADES DO CONFLITO, DEIXO PARA MOMENTO OPORTUNO A ANALISE DA CONVENIENCIA DE AUDIENCIA DE CONCILIACAO (CPC, ART. 139, VI E ENUNCIADO N.35 DA ENFAM). CITEM-SE OS REQUERIDOS PARA CONTESTAREM O FEITO NO PRAZO DE 15 (QUINZE) DIAS UTEIS, SOB PENA DE REVELIA (CPC, ART. 344). INT. - ADV: BIANCA VENANCIO LOPES DE OLIVEIRA (OAB 467602/SP)",
                "PublishDate": "2023-07-14T00:00:00",
                "CaptureDate": "2023-07-29T01:17:51"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0618/2023 TEOR DO ATO: VISTOS. 1 CONCEDO A PARTE REQUERENTE OS BENEFICIOS DE JUSTICA GRATUITA, ANOTANDO-SE O NECESSARIO. 2 PESEM, EMBORA, OS ARGUMENTOS DA REQUERENTE, REPUTO NAO PRESENTES TODOS OS REQUISITOS LEGAIS AO DEFERIMENTO DA MEDIDA DE URGENCIA PLEITEADA. REALMENTE, APESAR DA DOCUMENTACAO APRESENTADA, OS FATOS SE APRESENTAM CONTROVERTIDOS E SOMENTE PODEM SER MELHOR ANALISADOS SOB O CONTRADITORIO. NAO HA FALAR, DESTARTE, EM EXISTENCIA DE ELEMENTOS A EVIDENCIAR PROBABILIDADE DO DIREITO AFIRMADO. NAO VISLUMBRO, IGUALMENTE, PERIGO DE DANO IRREPARAVEL OU RISCO AO RESULTADO UTIL DO PROCESSO, ACASO NAO DEFERIDA LIMINARMENTE A MEDIDA. POSTO ISTO, INDEFIRO A MEDIDA DE URGENCIA. 3 DIANTE DAS ESPECIFICIDADES DA CAUSA E DE MODO A ADEQUAR O RITO PROCESSUAL AS NECESSIDADES DO CONFLITO, DEIXO PARA MOMENTO OPORTUNO A ANALISE DA CONVENIENCIA DE AUDIENCIA DE CONCILIACAO (CPC, ART. 139, VI E ENUNCIADO N.35 DA ENFAM). CITEM-SE OS REQUERIDOS PARA CONTESTAREM O FEITO NO PRAZO DE 15 (QUINZE) DIAS UTEIS, SOB PENA DE REVELIA (CPC, ART. 344). INT. ADVOGADOS(S): BIANCA VENANCIO LOPES DE OLIVEIRA (OAB 467602/SP)",
                "PublishDate": "2023-07-13T00:00:00",
                "CaptureDate": "2023-07-29T01:17:52"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-07-12T00:00:00",
                "CaptureDate": "2023-07-29T01:17:52"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2023-07-12T00:00:00",
                "CaptureDate": "2023-07-29T01:17:52"
              },
              {
                "Content": "NAO CONCEDIDA A ANTECIPACAO DE TUTELA VISTOS. 1 CONCEDO A PARTE REQUERENTE OS BENEFICIOS DE JUSTICA GRATUITA, ANOTANDO-SE O NECESSARIO. 2 PESEM, EMBORA, OS ARGUMENTOS DA REQUERENTE, REPUTO NAO PRESENTES TODOS OS REQUISITOS LEGAIS AO DEFERIMENTO DA MEDIDA DE URGENCIA PLEITEADA. REALMENTE, APESAR DA DOCUMENTACAO APRESENTADA, OS FATOS SE APRESENTAM CONTROVERTIDOS E SOMENTE PODEM SER MELHOR ANALISADOS SOB O CONTRADITORIO. NAO HA FALAR, DESTARTE, EM EXISTENCIA DE ELEMENTOS A EVIDENCIAR PROBABILIDADE DO DIREITO AFIRMADO. NAO VISLUMBRO, IGUALMENTE, PERIGO DE DANO IRREPARAVEL OU RISCO AO RESULTADO UTIL DO PROCESSO, ACASO NAO DEFERIDA LIMINARMENTE A MEDIDA. POSTO ISTO, INDEFIRO A MEDIDA DE URGENCIA. 3 DIANTE DAS ESPECIFICIDADES DA CAUSA E DE MODO A ADEQUAR O RITO PROCESSUAL AS NECESSIDADES DO CONFLITO, DEIXO PARA MOMENTO OPORTUNO A ANALISE DA CONVENIENCIA DE AUDIENCIA DE CONCILIACAO (CPC, ART. 139, VI E ENUNCIADO N.35 DA ENFAM). CITEM-SE OS REQUERIDOS PARA CONTESTAREM O FEITO NO PRAZO DE 15 (QUINZE) DIAS UTEIS, SOB PENA DE REVELIA (CPC, ART. 344). INT.",
                "PublishDate": "2023-07-12T00:00:00",
                "CaptureDate": "2023-07-29T01:17:52"
              }
            ],
            "Petitions": [],
            "Decisions": []
          },
          {
            "Number": "50006302220218080006",
            "Type": "PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL",
            "MainSubject": "DIREITO CIVIL (899) - RESPONSABILIDADE CIVIL (10431) - INDENIZACAO POR DANO MORAL (10433 DIREITO DO CONSUMIDOR (1156) - RESPONSABILIDADE DO FORNECEDOR (6220) - RESCISAO DO CONTRATO E DEVOLUCAO DO DINHEIRO (7768 DIREITO DO CONSUMIDOR (1156) - PRATICAS ABUSIVAS (11811",
            "CourtName": "TJES",
            "CourtLevel": "1",
            "CourtType": "Cível",
            "CourtDistrict": "ARACRUZ",
            "JudgingBody": "ARACRUZ - 1 JUIZADO ESPECIAL CIVEL, CRIMINAL E DA FAZENDA PUBLICA",
            "State": "ES",
            "Status": "ARQUIVADO",
            "LawsuitHostService": "PJE",
            "InferredCNJSubjectName": "RESCISÃO DO CONTRATO E DEVOLUÇÃO DO DINHEIRO",
            "InferredCNJSubjectNumber": 7768,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO DO JUIZADO ESPECIAL CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "DIREITO CIVIL (899) - RESPONSABILIDADE CIVIL (10431) - INDENIZACAO POR DANO MORAL (10433 DIREITO DO CONSUMIDOR (1156) - RESPONSABILIDADE DO FORNECEDOR (6220) - RESCISAO DO CONTRATO E DEVOLUCAO DO DINHEIRO (7768 DIREITO DO CONSUMIDOR (1156) - PRATICAS ABUSIVAS (11811"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": -1,
            "ResJudicataDate": "2021-12-08T00:00:00",
            "CloseDate": "2022-09-02T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "0001-01-01T00:00:00",
            "NoticeDate": "2021-04-20T00:00:00",
            "LastMovementDate": "2022-09-02T00:00:00",
            "CaptureDate": "2024-02-18T13:29:00",
            "LastUpdate": "2024-02-18T13:29:00",
            "NumberOfParties": 6,
            "NumberOfUpdates": 59,
            "LawSuitAge": 500,
            "AverageNumberOfUpdatesPerMonth": 1,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "08193498798",
                "IsPartyActive": true,
                "Name": "KESIAH OLIVEIRA AZEREDO SILVEIRA",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQUERENTE"
                },
                "LastCaptureDate": "2024-02-18T13:29:00"
              },
              {
                "Doc": "30883967812",
                "IsPartyActive": true,
                "Name": "VALCI TEODORO REGISTRADO CIVILMENTE COMO VALCI RIBEIRO TEODORO",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "21247",
                  "State": "ES",
                  "SpecificType": "ADVOGADO (REQUERENTE)"
                },
                "LastCaptureDate": "2024-02-18T13:29:00"
              },
              {
                "Doc": "10685786000181",
                "IsPartyActive": true,
                "Name": "FRI SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQUERIDO"
                },
                "LastCaptureDate": "2024-02-18T13:29:00"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": false,
                "Name": "HUMMINGBIRD PRODUCT STUDIO EIRELI",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQUERIDO"
                },
                "LastCaptureDate": "2023-07-31T17:07:08"
              },
              {
                "Doc": "35068411817",
                "IsPartyActive": true,
                "Name": "RAFAEL HIDEO NAZIMA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "295443",
                  "State": "SP",
                  "SpecificType": "ADVOGADO (REQUERIDO)"
                },
                "LastCaptureDate": "2024-02-18T13:29:00"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQUERIDO"
                },
                "LastCaptureDate": "2024-02-18T13:29:00"
              }
            ],
            "Updates": [
              {
                "Content": "ARQUIVADO DEFINITIVAMENTE",
                "PublishDate": "2022-09-02T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "JUNTADA DE PETICAO DE PETICAO (OUTRAS)",
                "PublishDate": "2022-09-01T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO ELETRONICA.",
                "PublishDate": "2022-08-24T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "JUNTADA DE OUTROS DOCUMENTOS",
                "PublishDate": "2022-07-27T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE ESTADO DO ESPIRITO SANTO PODER JUDICIARIO JUIZO DE ARACRUZ - 1 JUIZADO ESPECIAL CIVEL, CRIMINAL E DA FAZENDA PUBLICA RUA OSORIO DA SILVA ROCHA, 22, FORUM DESEMBARGADOR JOAO GONCALVES DE MEDEIROS, CENTRO, ARACRUZ - ES - CEP: 29190-256 TELEFONE:(27) 32561328 PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL (436) PROCESSO N: 5000630-22.2021.8.08.0006 REQUERENTE: KESIAH OLIVEIRA AZEREDO SILVEIRA ADVOGADO DO(A) REQUERENTE: VALCI RIBEIRO TEODORO - ES21247 REQUERIDO: FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA, HUMMINGBIRD PRODUCT STUDIO EIRELI ADVOGADO DO(A) REQUERIDO: RAFAEL HIDEO NAZIMA - SP295443 DESPACHO EM SIMPLES CONSULTA AO SISTEMA \"DEPOSITO JUDICIAL BANESTES\", E DE FACIL CONSTATACAO QUE HA CONTA JUDICIAL VINCULADA AOS AUTOS DE N 9632758. PROCEDA-SE COM A EXPEDICAO DA ORDEM DE TRANSFERENCIA ELETRONICA, CONFORME PETITORIO DE ID 12894228. TUDO CUMPRIDO, ARQUIVEM-SE OS AUTOS COM AS CAUTELAS DE ESTILO. DILIGENCIE-SE. ARACRUZ/ES, 22 DE JUNHO DE 2022. MARISTELA FACHETTI JUIZA DE DIREITO ASSINADO ELETRONICAMENTE POR: MARISTELA FACHETTI 22/06/2022 14:00:31 HTTPS://PJE.TJES.JUS.BR/PJE/PROCESSO/CONSULTADOCUMENTO/LISTVIEW.SEAM ID DO DOCUMENTO: 22062214003088800000014192986",
                "PublishDate": "2022-06-22T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2022-03-29T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "EXPEDICAO DE CERTIDAO.",
                "PublishDate": "2022-03-29T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "JUNTADA DE PETICAO DE PETICAO (OUTRAS)",
                "PublishDate": "2022-03-22T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO ELETRONICA.",
                "PublishDate": "2022-03-16T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "DECISAO PROFERIDA ESTADO DO ESPIRITO SANTO PODER JUDICIARIO JUIZO DE ARACRUZ - 1 JUIZADO ESPECIAL CIVEL, CRIMINAL E DA FAZENDA PUBLICA RUA OSORIO DA SILVA ROCHA, 22, FORUM DESEMBARGADOR JOAO GONCALVES DE MEDEIROS, CENTRO, ARACRUZ - ES - CEP: 29190-256 TELEFONE:(27) 32561328 PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL (436) PROCESSO N: 5000630-22.2021.8.08.0006 REQUERENTE: KESIAH OLIVEIRA AZEREDO SILVEIRA ADVOGADO DO(A) REQUERENTE: VALCI RIBEIRO TEODORO - ES21247 REQUERIDO: FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA DECISAO TRATA-SE DE PETICAO APRESENTADA EM ID 10928350 PELA EMPRESA STARK BANK S.A., POR MEIO DA QUAL ADUZ ERRO MATERIAL NA SENTENCA DE ID 10621710. A PARTE PETICIONANTE AFIRMA QUE, O ERRO DERIVA DO FATO DO PROCESSO TER SIDO EXTINTO POR AUSENCIA DA PARTE AUTORA EM AUDIENCIA, SEM QUE A LIMINAR DE BLOQUEIO DE VALOR EM SEU DESFAVOR TENHA SIDO REVOGADA. SOBRE O TEMA, O ART. 494, I DO CPC PREVE QUE, APOS PUBLICADA A SENTENCA, O JUIZ PODERA ALTERA-LA A REQUERIMENTO DA PARTE, OU DE OFICIO, PARA SANAR O ERRO MATERIAL, SENDO ESSA A HIPOTESE DOS AUTOS. ISSO PORQUE, A AUSENCIA DE INDICACAO EXPRESSA, ACERCA DA REVOGACAO DA MEDIDA LIMINAR DEFERIDA TRATA-SE DE ERRO MATERIAL, POR SER UM EQUIVOCO QUE NAO REFLETE A REALIDADE DA SITUACAO DEFINIDA EM SENTENCA, HAJA VISTA QUE, POR OBVIO, COM A EXTINCAO DO FEITO, SEM RESOLUCAO DE MERITO, INVIAVEL A PRODUCAO DE QUALQUER EFEITO EXTRAPROCESSUAL AS PARTES COM BASE NA ANALISE DA RELACAO JURIDICA CONTROVERTIDA NA ACAO, PELO QUE SE FAZ INVIAVEL A MANUTENCAO DE CONSTRICAO DE VALOR EM PROCESSO EXTINTO. SENDO ASSIM, ACOLHO O PEDIDO DE ID 10928350 PARA REVOGAR A DECISAO DE ID 660850 , SANANDO O ERRO MATERIAL DA SENTENCA DE ID 10621710. SENDO ASSIM, INTIME-SE STARK BANK S.A PARA, NO PRAZO DE 05 (CINCO) DIAS, SE DESEJA A EXPEDICAO DE ALVARA ELETRONICO OU ORDEM DE TRANSFERENCIA. 1) PARA O CASO DE ALVARA ELETRONICO, DEVERA SER INDICADO O NOME DO BENEFICIARIO E O NUMERO DO CPF DO MESMO. 2) PARA TRANSFERENCIA ELETRONICA, DEVERA SER INDICADO O NOME DO DESTINATARIO DA CONTA, SEU CPF OU CNPJ, O NOME DA INSTITUICAO FINANCEIRA DE DESTINO, O TIPO DE CONTA, O NUMERO DA AGENCIA E O NUMERO DA CONTA. FICA A PARTE BENEFICIARIA CIENTE, DESDE JA , QUE OS CUSTOS DA EVENTUAL TRANSFERENCIA ELETRONICA CORRERAO AS SUAS EXPENSAS. PRESTADA A INFORMACAO PELA PARTE, EXPECA-SE O ALVARA ELETRONICO OU A ORDEM DE TRANSFERENCIA, NOS TERMOS PLEITEADOS, INDEPENDENTE DE NOVA CONCLUSAO. TRANSCORRIDO O PRAZO RETRO IN ALBIS , FICA A SERVENTIA AUTORIZADA A EXPEDIR ALVARA ELETRONICO MODALIDADE SAQUE EM NOME DA PARTE BENEFICIARIA. AUTORIZO AINDA A SERVENTIA A RECADASTRAR A EMPRESA STARK BANK S.A, PARA O FIEL CUMPRIMENTO DO DESPACHO, CASO NECESSARIO. TUDO CUMPRIDO, ARQUIVEM-SE OS AUTOS COM AS CAUTELAS DE ESTILO. DILIGENCIE-SE. ARACRUZ/ES, 15 DE MARCO DE 2022. MARISTELA FACHETTI JUIZA DE DIREITO ASSINADO ELETRONICAMENTE POR: MARISTELA FACHETTI 15/03/2022 13:50:48 HTTPS://PJE.TJES.JUS.BR/PJE/PROCESSO/CONSULTADOCUMENTO/LISTVIEW.SEAM ID DO DOCUMENTO: 22031513504860500000011398599",
                "PublishDate": "2022-03-15T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2021-12-08T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "PROCESSO REATIVADO",
                "PublishDate": "2021-12-08T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "JUNTADA DE PETICAO DE DESARQUIVAMENTO/REATIVACAO",
                "PublishDate": "2021-12-07T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "ARQUIVADO DEFINITIVAMENTE",
                "PublishDate": "2021-12-01T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "TRANSITADO EM JULGADO EM 23/11/2021 PARA KESIAH OLIVEIRA AZEREDO SILVEIRA - CPF: 081.934.987-98 (REQUERENTE).",
                "PublishDate": "2021-12-01T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "DECORRIDO PRAZO DE KESIAH OLIVEIRA AZEREDO SILVEIRA EM 23/11/2021 23:59.",
                "PublishDate": "2021-11-25T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO ELETRONICA.",
                "PublishDate": "2021-11-24T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "EXTINTO O PROCESSO POR AUSENCIA DO AUTOR A AUDIENCIA ESTADO DO ESPIRITO SANTO PODER JUDICIARIO JUIZO DE ARACRUZ - 1 JUIZADO ESPECIAL CIVEL, CRIMINAL E DA FAZENDA PUBLICA RUA OSORIO DA SILVA ROCHA, 22, FORUM DESEMBARGADOR JOAO GONCALVES DE MEDEIROS, CENTRO, ARACRUZ - ES - CEP: 29190-256 TELEFONE:(27) 32561328 PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL (436) PROCESSO N: 5000630-22.2021.8.08.0006 REQUERENTE: KESIAH OLIVEIRA AZEREDO SILVEIRA ADVOGADO DO(A) REQUERENTE: VALCI RIBEIRO TEODORO - ES21247 REQUERIDO: FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA SENTENCA DISPENSADO O RELATORIO, NA FORMA DO ARTIGO 38 DA LEI N 9.099/95. PREFACIALMENTE, DEFIRO O PEDIDO DE GRATUIDADE DA JUSTICA EM FAVOR DA PARTE AUTORA. CONSTATO QUE A PARTE DEMANDANTE, EMBORA DEVIDAMENTE INTIMADA, NAO COMPARECEU A AUDIENCIA REALIZADA EM 22/11/2021, CONFORME ATA JUNTADA NO ID N. 10507368. DIANTE DA AUSENCIA DA PARTE REQUERENTE EM AUDIENCIA, APESAR DE DEVIDAMENTE INTIMADA, JULGO EXTINTO O PRESENTE PROCESSO SEM RESOLUCAO DE MERITO , COM FULCRO NO ART. 51, INCISO I DA LEI N. 9.099/95. SENTENCA, DESDE JA, REGISTRADA E PUBLICADA NO SISTEMA PJE. COM BASE NAS ORIENTACOES DA EGREGIA CORREGEDORIA GERAL DE JUSTICA (PROVIMENTO 037/2005) E ENUNCIADO 28 DO FONAJE, CONDENO A PARTE AUTORA AO PAGAMENTO DAS CUSTAS PROCESSUAIS. TODAVIA, FICA SUSPENSA A EXIGIBILIDADE DA OBRIGACAO NOS TERMOS DO ART. 98, 3 DO CPC. INTIME-SE. APOS O TRANSITO EM JULGADO, NAO HAVENDO PENDENCIAS, ARQUIVE-SE. EM CASO DE INTERPOSICAO DE RECURSO INOMINADO, CERTIFIQUE-SE QUANTO A TEMPESTIVIDADE E O PREPARO RECURSAL (CASO NAO HAJA PEDIDO DE ASSISTENCIA JUDICIARIA GRATUITA). APOS, INTIME-SE A PARTE ADVERSA PARA APRESENTACAO DAS CONTRARRAZOES, NO PRAZO DE 10 DIAS, NA FORMA DO ART. 42 DA LEI N 9.099/95. POR FIM, HAVENDO OU NAO A APRESENTACAO DE CONTRARRAZOES, REMETAM-SE OS AUTOS A COLENDA TURMA RECURSAL INDEPENDENTEMENTE DE CONCLUSAO, EM CONFORMIDADE A ORIENTACAO DO CNJ, CONSTANTE DO MANUAL DE PROCEDIMENTOS DOS JUIZADOS ESPECIAIS CIVEIS. DILIGENCIE-SE. ARACRUZ/ES, 24 DE NOVEMBRO DE 2021 MARISTELA FACHETTI JUIZA DE DIREITO ASSINADO ELETRONICAMENTE POR: MARISTELA FACHETTI 24/11/2021 16:26:47 HTTPS://PJE.TJES.JUS.BR/PJE/PROCESSO/CONSULTADOCUMENTO/LISTVIEW.SEAM ID DO DOCUMENTO: 21112416264758200000010241856",
                "PublishDate": "2021-11-24T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "CONCLUSOS PARA JULGAMENTO",
                "PublishDate": "2021-11-24T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "AUDIENCIA CONCILIACAO REALIZADA PARA 22/11/2021 13:15 ARACRUZ - 1 JUIZADO ESPECIAL CIVEL, CRIMINAL E DA FAZENDA PUBLICA.",
                "PublishDate": "2021-11-24T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "EXPEDICAO DE TERMO DE AUDIENCIA.",
                "PublishDate": "2021-11-24T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO ELETRONICA.",
                "PublishDate": "2021-11-04T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO ELETRONICA.",
                "PublishDate": "2021-10-25T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE ESTADO DO ESPIRITO SANTO PODER JUDICIARIO JUIZO DE ARACRUZ - 1 JUIZADO ESPECIAL CIVEL, CRIMINAL E DA FAZENDA PUBLICA RUA OSORIO DA SILVA ROCHA, 22, FORUM DESEMBARGADOR JOAO GONCALVES DE MEDEIROS, CENTRO, ARACRUZ - ES - CEP: 29190-256 TELEFONE:(27) 32561328 PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL (436) PROCESSO N: 5000630-22.2021.8.08.0006 REQUERENTE: KESIAH OLIVEIRA AZEREDO SILVEIRA ADVOGADO DO(A) REQUERENTE: VALCI RIBEIRO TEODORO - ES21247 REQUERIDO: FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA DESPACHO INTIME-SE A PARTE AUTORA PARA, NO PRAZO DE 30 DIAS , FORNECER O NOVO ENDERECO DA PARTE SUPLICADA E/OU REQUERER O QUE ENTENDER DE DIREITO, SOB PENA DE EXTINCAO DO PROCESSO. SENDO FORNECIDO O ENDERECO, CITE-SE E INTIME-SE A PARTE REQUERIDA PARA A AUDIENCIA DE CONCILIACAO JA DESIGNADA. TODAVIA, CASO NAO HAJA TEMPO HABIL PARA O DEVIDO CUMPRIMENTO, AUTORIZO, DESDE JA, A SERVENTIA A REDESIGNAR O ATO CONCILIATORIO, DEVENDO OS AUTOS VIREM CONCLUSOS EM SEGUIDA. DILIGENCIE-SE. ARACRUZ/ES, 25 DE OUTUBRO DE 2021 MARISTELA FACHETTI JUIZA DE DIREITO ASSINADO ELETRONICAMENTE POR: MARISTELA FACHETTI 25/10/2021 17:49:37 HTTPS://PJE.TJES.JUS.BR/PJE/PROCESSO/CONSULTADOCUMENTO/LISTVIEW.SEAM ID DO DOCUMENTO: 21102517493703400000009631884",
                "PublishDate": "2021-10-25T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2021-10-18T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "JUNTADA DE AVISO DE RECEBIMENTO",
                "PublishDate": "2021-10-06T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE ESTADO DO ESPIRITO SANTO PODER JUDICIARIO JUIZO DE ARACRUZ - 1 JUIZADO ESPECIAL CIVEL, CRIMINAL E DA FAZENDA PUBLICA RUA OSORIO DA SILVA ROCHA, 22, FORUM DESEMBARGADOR JOAO GONCALVES DE MEDEIROS, CENTRO, ARACRUZ - ES - CEP: 29190-256 TELEFONE:(27) 32561328 PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL (436) PROCESSO N: 5000630-22.2021.8.08.0006 REQUERENTE: KESIAH OLIVEIRA AZEREDO SILVEIRA ADVOGADO DO(A) REQUERENTE: VALCI RIBEIRO TEODORO - ES21247 REQUERIDO: FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA, HUMMINGBIRD PRODUCT STUDIO EIRELI DESPACHO COMPULSANDO OS AUTOS, VERIFICO QUE A PARTE AUTORA FORA DEVIDAMENTE INTIMADA PARA INFORMAR O NOVO ENDERECO DA REQUERIDA, HUMMINGBIRD PRODUCT STUDIO EIRELI, SENDO ADVERTIDA, AINDA, QUE SUA INERCIA IMPORTARIA NA EXCLUSAO DA SUPLICADA SUSO MENCIONADA DO POLO PASSIVO DA LIDE. ASSIM, DIANTE DA INERCIA DA PARTE DEMANDANTE, EXCLUA-SE A PARTE REQUERIDA ACIMA REFERIDA DO POLO PASSIVO DA LIDE. APOS, AGUARDE-SE A AUDIENCIA OUTRORA DESIGNADA. DILIGENCIE-SE. ARACRUZ/ES, 4 DE OUTUBRO DE 2021 MARISTELA FACHETTI JUIZA DE DIREITO ASSINADO ELETRONICAMENTE POR: MARISTELA FACHETTI 04/10/2021 14:30:46 HTTPS://PJE.TJES.JUS.BR/PJE/PROCESSO/CONSULTADOCUMENTO/LISTVIEW.SEAM ID DO DOCUMENTO: 21100414304539000000009207784",
                "PublishDate": "2021-10-04T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2021-10-02T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "DECORRIDO PRAZO DE KESIAH OLIVEIRA AZEREDO SILVEIRA EM 20/09/2021 23:59.",
                "PublishDate": "2021-09-28T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "JUNTADA DE OUTROS DOCUMENTOS",
                "PublishDate": "2021-09-14T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "EXPEDICAO DE CARTA POSTAL - CITACAO.",
                "PublishDate": "2021-09-03T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO ELETRONICA.",
                "PublishDate": "2021-09-03T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE ESTADO DO ESPIRITO SANTO PODER JUDICIARIO JUIZO DE ARACRUZ - 1 JUIZADO ESPECIAL CIVEL, CRIMINAL E DA FAZENDA PUBLICA RUA OSORIO DA SILVA ROCHA, 22, FORUM DESEMBARGADOR JOAO GONCALVES DE MEDEIROS, CENTRO, ARACRUZ - ES - CEP: 29190-256 TELEFONE:(27) 32561328 PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL (436) PROCESSO N: 5000630-22.2021.8.08.0006 REQUERENTE: KESIAH OLIVEIRA AZEREDO SILVEIRA ADVOGADO DO(A) REQUERENTE: VALCI RIBEIRO TEODORO - ES21247 REQUERIDO: FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA, HUMMINGBIRD PRODUCT STUDIO EIRELI DESPACHO INTIME-SE A PARTE AUTORA PARA, NO PRAZO DE 05 (CINCO) DIAS, INFORMAR O NOVO ENDERECO DA REQUERIDA, HUMMINGBIRD PRODUCT STUDIO EIRELI, IMPLICANDO SUA INERCIA EM EXCLUSAO DESTA DO POLO PASSIVO DA LIDE. SENDO FORNECIDO O ENDERECO, CITE-SE E INTIME-SE. CITE-SE A REQUERIDA FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA, NO ENDERECO INDICADO PELO AUTOR EM ID 8439189, BEM COMO INTIMEM-SE AS PARTES PARA CIENCIA DE QUE A AUDIENCIA CONCILIATORIA, DESIGNADA NOS PRESENTES AUTOS, OCORRERA POR MEIO VIRTUAL, SOB A PLATAFORMA ZOOM: TIPO: AUDIENCIA DE CONCILIACAO - REUNIAO ZOOM DO 1 JECCF ARACRUZ ENTRAR NA REUNIAO ZOOM, ATRAVES DO LINK: HTTPS://TJES-JUS-BR.ZOOM.US/J/89462169860?PWD=OWVBZML3WVFXSHHXENH1QNPUY1PWQT09 ID DA REUNIAO: 894 6216 9860 SENHA DE ACESSO: 54202679 FICAM ADVERTIDAS AS PARTES QUE DEVERAO ACESSAR A SALA DE AUDIENCIA ELETRONICA PONTUALMENTE NO HORARIO AGENDADO, DEVENDO AGUARDAR A AUTORIZACAO DO ADMINISTRADOR. A SALA PODERA SER ACESSADA DE QUALQUER DISPOSITIVO MOVEL OU FIXO, COM DISPONIBILIDADE DE CAMERA PARA VISUALIZACAO DOS PARTICIPANTES, DEVENDO A PARTE BUSCAR LOCAL ADEQUADO PARA QUALIDADE DO SINAL DE INTERNET. FICAM ADVERTIDAS, AINDA, QUE O NAO COMPARECIMENTO PODERA ENSEJAR O ARQUIVAMENTO DO PROCESSO OU MESMO O RECONHECIMENTO DA REVELIA. POR FIM, FICAM AS PARTES CIENTES DE QUE, NAO POSSUINDO OS MEIOS TECNICOS NECESSARIOS A REALIZACAO DA AUDIENCIA VIRTUAL, DEVERAO INFORMAR NOS AUTOS COM ANTECEDENCIA MINIMA DE 05 (CINCO) DIAS DA DATA DA AUDIENCIA DESIGNADA NOS AUTOS. DILIGENCIE-SE. ARACRUZ/ES, 2 DE SETEMBRO DE 2021 MARISTELA FACHETTI JUIZA DE DIREITO ASSINADO ELETRONICAMENTE POR: MARISTELA FACHETTI 02/09/2021 17:11:24 HTTPS://PJE.TJES.JUS.BR/PJE/PROCESSO/CONSULTADOCUMENTO/LISTVIEW.SEAM ID DO DOCUMENTO: 21090217112415700000008626018",
                "PublishDate": "2021-09-02T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2021-08-10T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "AUDIENCIA CONCILIACAO DESIGNADA PARA 22/11/2021 13:15 ARACRUZ - 1 JUIZADO ESPECIAL CIVEL, CRIMINAL E DA FAZENDA PUBLICA.",
                "PublishDate": "2021-08-10T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "JUNTADA DE PETICAO DE PETICAO (OUTRAS)",
                "PublishDate": "2021-08-09T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO ELETRONICA.",
                "PublishDate": "2021-06-18T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "AUDIENCIA CONCILIACAO CANCELADA PARA 29/06/2021 15:45 ARACRUZ - 1 JUIZADO ESPECIAL CIVEL, CRIMINAL E DA FAZENDA PUBLICA.",
                "PublishDate": "2021-06-18T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE ESTADO DO ESPIRITO SANTO PODER JUDICIARIO JUIZO DE ARACRUZ - 1 JUIZADO ESPECIAL CIVEL, CRIMINAL E DA FAZENDA PUBLICA RUA OSORIO DA SILVA ROCHA, 22, FORUM DESEMBARGADOR JOAO GONCALVES DE MEDEIROS, CENTRO, ARACRUZ - ES - CEP: 29190-256 TELEFONE:(27) 32561328 PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL (436) PROCESSO N: 5000630-22.2021.8.08.0006 REQUERENTE: KESIAH OLIVEIRA AZEREDO SILVEIRA ADVOGADO DO(A) REQUERENTE: VALCI RIBEIRO TEODORO - ES21247 REQUERIDO: FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA, HUMMINGBIRD PRODUCT STUDIO EIRELI DESPACHO INTIME-SE A PARTE AUTORA PARA, NO PRAZO DE 30 DIAS , FORNECER O NOVO ENDERECO DAS PARTES SUPLICADAS E/OU REQUERER O QUE ENTENDER DE DIREITO, SOB PENA DE EXTINCAO DO PROCESSO. CONSIDERANDO, AINDA, A PROXIMIDADE DO ATO CONCILIATORIO DESIGNADO, CANCELE-O. SENDO FORNECIDO OS ENDERECOS, DESIGNE-SE AUDIENCIA DE CONCILIACAO, VINDO OS AUTOS CONCLUSOS, EM SEGUIDA, PARA DILIGENCIAS. DILIGENCIE-SE. ARACRUZ/ES, 17 DE JUNHO DE 2021 MARISTELA FACHETTI JUIZA DE DIREITO ASSINADO ELETRONICAMENTE POR: MARISTELA FACHETTI 17/06/2021 15:54:28 HTTPS://PJE.TJES.JUS.BR/PJE/PROCESSO/CONSULTADOCUMENTO/LISTVIEW.SEAM ID DO DOCUMENTO: 21061715542808900000007168153",
                "PublishDate": "2021-06-17T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2021-06-11T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "JUNTADA DE AVISO DE RECEBIMENTO",
                "PublishDate": "2021-06-09T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "JUNTADA DE OUTROS DOCUMENTOS",
                "PublishDate": "2021-05-28T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "JUNTADA DE AVISO DE RECEBIMENTO",
                "PublishDate": "2021-05-26T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "EXPEDICAO DE CARTA POSTAL - CITACAO.",
                "PublishDate": "2021-05-25T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "JUNTADA DE PETICAO DE PETICAO (OUTRAS)",
                "PublishDate": "2021-05-24T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "JUNTADA DE AVISO DE RECEBIMENTO",
                "PublishDate": "2021-05-20T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO ELETRONICA.",
                "PublishDate": "2021-05-07T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "JUNTADA DE AVISO DE RECEBIMENTO",
                "PublishDate": "2021-05-07T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "JUNTADA DE OUTROS DOCUMENTOS",
                "PublishDate": "2021-04-28T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "EXPEDICAO DE CARTA POSTAL - CITACAO.",
                "PublishDate": "2021-04-26T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO - DIARIO.",
                "PublishDate": "2021-04-26T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "EXPEDICAO DE CARTA POSTAL - CITACAO.",
                "PublishDate": "2021-04-26T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "EXPEDICAO DE CARTA POSTAL - CITACAO.",
                "PublishDate": "2021-04-26T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "EXPEDICAO DE CARTA POSTAL - CITACAO.",
                "PublishDate": "2021-04-26T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "CONCEDIDA A ANTECIPACAO DE TUTELA ESTADO DO ESPIRITO SANTO PODER JUDICIARIO JUIZO DE ARACRUZ - 1 JUIZADO ESPECIAL CIVEL, CRIMINAL E DA FAZENDA PUBLICA RUA OSORIO DA SILVA ROCHA, 22, FORUM DESEMBARGADOR JOAO GONCALVES DE MEDEIROS, CENTRO, ARACRUZ - ES - CEP: 29190-256 TELEFONE:(27) 32561328 PROCESSO N 5000630-22.2021.8.08.0006 PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL (436) REQUERENTE: KESIAH OLIVEIRA AZEREDO SILVEIRA REQUERIDO: FRI - SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA, HUMMINGBIRD PRODUCT STUDIO EIRELI ADVOGADO DO(A) REQUERENTE: VALCI RIBEIRO TEODORO - ES21247 DECISAO TRATA-SE DE ACAO RESSARCITORIA C/C RESCISAO CONTRATUAL E INDENIZACAO POR DANOS MORAIS AJUIZADA POR KESIAH OLIVEIRA AZEREDO, EM FACE DE FRI  SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA E STAR BANK S/A , POR MEIO DA QUAL, PRETENDE, EM SEDE LIMINAR, QUE SEJA REALIZADO PELO JUIZO O BLOQUEIO DE VALOR EM FACE DAS REQUERIDAS, NO IMPORTE DE R$ 6.000,00. NO MERITO, A CONFIRMACAO DO PLEITO LIMINAR, PARA FINS DA DEMANDANTE SER INDENIZADA A TITULO DE DANOS MATERIAIS, NO VALOR SUSO MENCIONADO. ADUZ A REQUERENTE QUE, NA DATA DE 03/04/2020, AS SUPLICADAS OFERTARAM UMA PROPOSTA DE INVESTIMENTO FINANCEIRO, NA QUAL, APOS UM APORTE FINANCEIRO VINCULADO A UM CONTRATO DE OPERACAO DE MUTUO, OS JUROS DO APORTE, GERARIAM UM PAGAMENTO MENSAL A AUTORA. SUSTENTA QUE SE TRATAVA DE UMA ESPECIE DE CONTRATO DE MUTUO, NO QUAL, A PARTIR DO APORTE FINANCEIRO, O CLIENTE POSSUIRIA UM RETORNO MENSAL NO PERCENTUAL DE 10% (DEZ POR CENTO) SOBRE A QUANTIA APORTADA. INFORMA A PARTE DEMANDANTE QUE PACTUOU O CONTRATO DE MUTUO, COM AS REQUERIDAS, NO DIA 17/03/2020, SENDO REALIZADO DOIS DEPOSITOS NA CONTA DA PRIMEIRA REQUERIDA, UM NO VALOR DE R$ 5.000,00 E OUTRO NO VALOR DE R$ 1.000,00, AMBOS, JUNTO AO BANCO DO BRASIL  AGENCIA: 0722-6, CONTA: 56717-5, DE SUA TITULARIDADE. ARGUMENTA, AINDA, QUE CONFORME PACTUADO, O RESULTADO DA PORCENTAGEM DO CONTRATO DE MUTUO (R$ 600,00) TRARIA A REQUERENTE UMA RENDA MINIMA NO PERIODO DA PANDEMIA, TENDO ACREDITADO QUE, COM O APORTE REALIZADO EM MARCO/2020, O PAGAMENTO DOS JUROS OCORRERIA A PARTIR DE ABRIL/2020, O QUE NAO OCORREU SUSTENTA QUE FORA INFORMADA QUE OS PAGAMENTOS FICARIAM SUSPENSOS POR EQUIVOCO NO SISTEMA. ASSEVERA QUE, APOS A CONTRACAO DOS SERVICOS DAS REQUERIDAS E DO APORTE FINANCEIRO NO VALOR DE R$ 6.000,00, TENTOU POR DIVERSAS VEZES ACESSAR O SISTEMA DA PRIMEIRA REQUERIDA, SEM EXITO, POR ESTAR INOPERANTE. NO INTUITO DE SOLUCIONAR A QUESTAO, ACIONOU O SETOR FINANCEIRO DA EMPRESA, SENDO INFORMADA QUE O QUADRO DE FUNCIONARIOS RESPONSAVEL PELO SETOR DE RENEGOCIACAO DA PRIMEIRA SUPLICADA NAO MAIS FAZIA PARTE DA MESMA. A O MESMO TEMPO, INFORMA QUE A PLATAFORMA DE ACESSO DOS CLIENTES FOI EXTINTA, RETIRANDO AS INFORMACOES DOS MESMOS, A FIM DE QUE FOSSEM CONSTRANGIDOS A ACEITAR OS TERMOS PROPOSTOS PELA EMPRESA. ADUZ QUE DIANTE DAS EVASIVAS DA PRIMEIRA REQUERIDA, REGISTROU, NO DIA 11/11/2020, BOLETIM UNIFICADO, N.: 43610293, JUNTO A DELEGACIA DE ARACRUZ, POR DESCONFIAR SE TRATAR DE FRAUDE. CONFORME DISPOSTO NO ENUNCIADO N. 26 DO FONAJE: \"SAO CABIVEIS A TUTELA ACAUTELATORIA E A ANTECIPATORIA NOS JUIZADOS ESPECIAIS CIVEIS, EM CARATER EXCEPCIONAL.\" DEVE, PARA TANTO, SER OBSERVADO O DISPOSTO NO ARTIGO 300 DO CODIGO DE PROCESSO CIVIL. NESSE SENTIDO, PARA CONCESSAO DO PEDIDO ANTECIPATORIO, DEVEM ESTAR PRESENTES: A) PROVA INEQUIVOCA CAPAZ DE CONVENCER O JUIZ DA VEROSSIMILHANCA DAS ALEGACOES; B) FUNDADO RECEIO DE DANO IRREPARAVEL OU DE DIFICIL REPARACAO; E C) INEXISTENCIA DE RISCO DE IRREVERSIBILIDADE DO PROVIMENTO ANTECIPADO. E EM COMPLEMENTACAO, O ART. 301 ESTABELECE QUE:  A TUTELA DE URGENCIA DE NATUREZA CAUTELAR PODE SER EFETIVADA MEDIANTE ARRESTO, SEQUESTRO, ARROLAMENTO DE BENS, REGISTRO DE PROTESTO CONTRA ALIENACAO DE BEM E QUALQUER OUTRA MEDIDA IDONEA PARA ASSEGURACAO DO DIREITO . FACE AOS REQUISITOS LEGAIS ACIMA DESCRITOS, ENTENDO QUE A SITUACAO EM TELA E APTA A DEMONSTRAR O PREENCHIMENTO DOS REQUISITOS AUTORIZATIVOS A CONCESSAO DO PLEITO LIMINAR, HAJA VISTA AS PROVAS DOS AUTOS DEMONSTRAREM A VEROSSIMILHANCA DAS ALEGACOES AUTORAIS, BEM COMO A PROBABILIDADE DO DIREITO ALEGADO. ISSO PORQUE, A SUPLICANTE APRESENTOU O \"PRINT\" DA CONVERSA COM O SETOR FINANCEIRO DA PRIMEIRA SUPLICADA, ONDE RESTOU, A PRIORI, DEMONSTRADO QUE ESTA INFORMOU QUE O QUADRO DE FUNCIONARIOS RESPONSAVEL PELO SETOR JA NAO FAZIA MAIS PARTE DA EMPRESA, SENDO INFORMADA, AINDA, PELA SEGUNDA DEMANDADA QUE OS PROCEDIMENTOS ANTERIORMENTE REALIZADOS FORAM ANULADOS POR PARTE DA PRIMEIRA SUPLICADA. CARREOU, AINDA, COMPROVANTE DE TRANSFERENCIA BANCARIA E DEPOSITO BANCARIO A TITULO DE PAGAMENTO PELO APORTE FINANCEIRO REALIZADO JUNTO AS REQUERIDAS, SENDO TAIS DOCUMENTOS APTOS A EVIDENCIAR QUE, MESMO TENDO PAGO O VALOR SOLICITADO PARA FINS DE OBTENCAO DE RENDA NO IMPORTE DE 10% SOBRE O VALOR APORTADO, ATE O MOMENTO DO AJUIZAMENTO DA PRESENTE DEMANDA TAL OPERACAO NAO SE CONCRETIZOU. ADEMAIS, A PROBABILIDADE DO DIREITO TAMBEM E EVIDENCIADA PELA COPIA DO PROCESSO TRABALHISTA AJUIZADO CONTRA AS SUPLICADAS, EM ESPECIAL A SENTENCA CARREADA EM ID N 6594938, ONDE CONSTA INFORMACAO DE QUE ESTAS DEMITIRAM O FUNCIONARIO QUE OCUPAVA O CARGO DE DIRETOR DAS EMPRESAS REQUERIDAS, SENDO INCLUSIVE REVEIS NOS AUTOS DA ACAO TRABALHISTA, FATOS ESTES QUE ENTENDO COMO SUFICIENTES, PARA EVIDENCIAR, NESSE MOMENTO PROCESSUAL, QUE HA SUSPEITA DE FRAUDE, INCLUSIVE POR NAO TER SIDO REALIZADO A DEVOLUCAO DO VALOR INVESTIDO PELA PARTE DEMANDANTE ATE O MOMENTO. QUANTO AO PERIGO DE DANO OU O RISCO AO RESULTADO UTIL DO PROCESSO, ENTENDO QUE TAMBEM RESTA PREENCHIDO, VEZ QUE, EM SE TRATANDO DE SUPOSTA FRAUDE, HA PROBABILIDADE DE DILAPIDACAO DE PATRIMONIO POR PARTE DAS REQUERIDAS, FATO APTO A TORNAR DEVIDO O BLOQUEIO DE VALORES, ANTE A EVIDENCIA DE POSSIVEL RISCO DE INSOLVENCIA. ANTE O EXPOSTO, DEFIRO A TUTELA ANTECIPADA , PELO QUE PROCEDI O REGISTRO ORDEM DE BLOQUEIO DE VALOR VIA SISTEMA SISBAJUD, NA QUANTIA DE R$ R$6.000,00, EM DESFAVOR DE FRI  SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA E STAR BANK S/A, DA QUAL OBTIVE RESPOST A POSITIVA, RAZAO PELA QUAL PENHOREI REFERIDO VALOR, CONFORME GUIA PROTOCOLADA E RESPECTIVA RESPOSTA EM ANEXO. C ITEM-SE AS REQUERIDAS, BEM COMO INTIMEM-SE AS PARTES PARA CIENCIA DESTA DECISAO E DE QUE A AUDIENCIA CONCILIATORIA, DESIGNADA NOS PRESENTES AUTOS, OCORRERA POR MEIO VIRTUAL, SOB A PLATAFORMA ZOOM: TIPO: AUDIENCIA DE CONCILIACAO - REUNIAO ZOOM DO 1 JECCF ARACRUZ ENTRAR NA REUNIAO ZOOM, ATRAVES DO LINK: HTTPS://US02WEB.ZOOM.US/J/83430287453?PWD=WGGXZ2DIZHRKS2VRMUFLD2LLUDJDUT09 ID DA REUNIAO: 834 3028 7453 SENHA DE ACESSO: 931141 FICAM ADVERTIDAS AS PARTES QUE DEVERAO ACESSAR A SALA DE AUDIENCIA ELETRONICA PONTUALMENTE NO HORARIO AGENDADO, DEVENDO AGUARDAR A AUTORIZACAO DO ADMINISTRADOR. A SALA PODERA SER ACESSADA DE QUALQUER DISPOSITIVO MOVEL OU FIXO, COM DISPONIBILIDADE DE CAMERA PARA VISUALIZACAO DOS PARTICIPANTES, DEVENDO A PARTE BUSCAR LOCAL ADEQUADO PARA QUALIDADE DO SINAL DE INTERNET. FICAM ADVERTIDAS, AINDA, QUE O NAO COMPARECIMENTO PODERA ENSEJAR O ARQUIVAMENTO DO PROCESSO OU MESMO O RECONHECIMENTO DA REVELIA. POR FIM, FICAM AS PARTES CIENTES DE QUE, NAO POSSUINDO OS MEIOS TECNICOS NECESSARIOS A REALIZACAO DA AUDIENCIA VIRTUAL, DEVERAO INFORMAR NOS AUTOS COM ANTECEDENCIA MINIMA DE 05 (CINCO) DIAS DA DATA DA AUDIENCIA DESIGNADA NOS AUTOS. DILIGENCIE-SE. ARACRUZ-ES, 26 DE ABRIL DE 2021. MARISTELA FACHETTI JUIZA DE DIREITO ASSINADO ELETRONICAMENTE POR: MARISTELA FACHETTI 26/04/2021 15:23:46 HTTPS://PJE.TJES.JUS.BR/PJE/PROCESSO/CONSULTADOCUMENTO/LISTVIEW.SEAM ID DO DOCUMENTO: 21042615234642200000006382417",
                "PublishDate": "2021-04-26T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2021-04-22T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "EXPEDICAO DE CERTIDAO.",
                "PublishDate": "2021-04-22T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "AUDIENCIA CONCILIACAO DESIGNADA PARA 29/06/2021 15:45 ARACRUZ - 1 JUIZADO ESPECIAL CIVEL, CRIMINAL E DA FAZENDA PUBLICA.",
                "PublishDate": "2021-04-20T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              },
              {
                "Content": "DISTRIBUIDO POR SORTEIO",
                "PublishDate": "2021-04-20T00:00:00",
                "CaptureDate": "2023-07-30T16:05:35"
              }
            ],
            "Petitions": [],
            "Decisions": [
              {
                "DecisionContent": "ACOLHO O PEDIDO DE ID 10928350 PARA REVOGAR A DECISAO DE ID 660850 , SANANDO O ERRO MATERIAL DA SENTENCA DE ID 10621710.",
                "DecisionDate": "2022-03-15T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO O PEDIDO DE GRATUIDADE DA JUSTICA EM FAVOR DA PARTE AUTORA.",
                "DecisionDate": "2021-11-24T00:00:00"
              },
              {
                "DecisionContent": "JULGO EXTINTO O PRESENTE PROCESSO SEM RESOLUCAO DE MERITO , COM FULCRO NO ART. 51, INCISO I DA LEI N.",
                "DecisionDate": "2021-11-24T00:00:00"
              },
              {
                "DecisionContent": "CONDENO A PARTE AUTORA AO PAGAMENTO DAS CUSTAS PROCESSUAIS.",
                "DecisionDate": "2021-11-24T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO A TUTELA ANTECIPADA , PELO QUE PROCEDI O REGISTRO ORDEM DE BLOQUEIO DE VALOR VIA SISTEMA SISBAJUD, NA QUANTIA DE R$ R$6.000,00, EM DESFAVOR DE FRI  SERVICOS DE CONSULTORIA E INVESTIMENTO FINANCEIRO LTDA E STAR BANK S/A, DA QUAL OBTIVE RESPOST A POSITIVA, RAZAO PELA QUAL PENHOREI REFERIDO VALOR, CONFORME GUIA PROTOCOLADA E RESPECTIVA RESPOSTA EM ANEXO.",
                "DecisionDate": "2021-04-26T00:00:00"
              }
            ]
          },
          {
            "Number": "10177828720238260554",
            "Type": "PROCEDIMENTO COMUM",
            "MainSubject": "PRATICAS ABUSIVAS",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "SANTO ANDRE",
            "Judge": "DANIEL LEITE SEIFFERT SIMOES",
            "JudgingBody": "4 VARA CIVEL",
            "State": "SP",
            "Status": "ATIVO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "PRÁTICAS ABUSIVAS",
            "InferredCNJSubjectNumber": 11811,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "PRATICAS ABUSIVAS"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 21378,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-07-17T00:00:00",
            "NoticeDate": "2023-07-13T00:00:00",
            "LastMovementDate": "2023-07-26T00:00:00",
            "CaptureDate": "2023-07-30T23:33:24",
            "LastUpdate": "2023-07-30T23:33:24",
            "NumberOfParties": 6,
            "NumberOfUpdates": 7,
            "LawSuitAge": 230,
            "AverageNumberOfUpdatesPerMonth": 0,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "40995248842",
                "IsPartyActive": true,
                "Name": "DANIEL LEITE SEIFFERT SIMOES",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-07-30T23:33:24"
              },
              {
                "Doc": "36799877811",
                "IsPartyActive": true,
                "Name": "PAMELA FABRI OLIVEIRA",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-07-30T23:33:24"
              },
              {
                "Doc": "06016026840",
                "IsPartyActive": true,
                "Name": "CASSIA COSTA BUCCIERI",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "236747",
                  "State": "SP",
                  "SpecificType": "ADVOGADA (REQTE)"
                },
                "LastCaptureDate": "2023-07-30T23:33:24"
              },
              {
                "Doc": "15436940000103",
                "IsPartyActive": true,
                "Name": "AMAZON COM BR AMAZON SERVICOS DE VAREJO DO BRASIL LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-30T23:33:24"
              },
              {
                "Doc": "14994399000188",
                "IsPartyActive": true,
                "Name": "OCTOS CONSULTORIA ESTRATEGICA LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-30T23:33:24"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-07-30T23:33:24"
              }
            ],
            "Updates": [
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0636/2023 DATA DA PUBLICACAO: 27/07/2023 NUMERO DO DIARIO: 3786",
                "PublishDate": "2023-07-26T00:00:00",
                "CaptureDate": "2023-07-30T23:33:24"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WSNE.23.70256072-6 TIPO DA PETICAO: PETICAO INTERMEDIARIA DATA: 26/07/2023 23:33",
                "PublishDate": "2023-07-26T00:00:00",
                "CaptureDate": "2023-07-30T23:33:24"
              },
              {
                "Content": "DETERMINADA A EMENDA A INICIAL VISTOS. DEFIRO A GRATUIDADE DA JUSTICA. VERIFICO QUE NEM TODAS AS TRANSFERENCIAS BANCARIAS FORAM REALIZADAS PELA AUTORA, CONFORME SE DEPREENDE, POR EXEMPLO, DO DOCUMENTO DE FL. 19. NAO SE TRATANDO DE HIPOTESE DE LEGITIMACAO EXTRAORDINARIA, DEVERA A AUTORA DELIMITAR O PEDIDO A FIM DE QUE COMPREENDA SOMENTE AS TRANSACOES DE SUA RESPONSABILIDADE. INTIME-SE.",
                "PublishDate": "2023-07-25T00:00:00",
                "CaptureDate": "2023-07-30T23:33:24"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0636/2023 TEOR DO ATO: VISTOS. DEFIRO A GRATUIDADE DA JUSTICA. VERIFICO QUE NEM TODAS AS TRANSFERENCIAS BANCARIAS FORAM REALIZADAS PELA AUTORA, CONFORME SE DEPREENDE, POR EXEMPLO, DO DOCUMENTO DE FL. 19. NAO SE TRATANDO DE HIPOTESE DE LEGITIMACAO EXTRAORDINARIA, DEVERA A AUTORA DELIMITAR O PEDIDO A FIM DE QUE COMPREENDA SOMENTE AS TRANSACOES DE SUA RESPONSABILIDADE. INTIME-SE. ADVOGADOS(S): CASSIA COSTA BUCCIERI (OAB 236747/SP)",
                "PublishDate": "2023-07-25T00:00:00",
                "CaptureDate": "2023-07-30T23:33:24"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2023-07-18T00:00:00",
                "CaptureDate": "2023-07-30T23:33:24"
              },
              {
                "Content": "PROCESSO : 1017782-87.2023.8.26.0554 CLASSE : PROCEDIMENTO COMUM CIVEL REQTE : PAMELA FABRI OLIVEIRA ADVOGADO : 236747/SP - CASSIA COSTA BUCCIERI REQDO : STARK BANK S.A. VARA : 4 VARA CIVEL",
                "PublishDate": "2023-07-17T00:00:00",
                "CaptureDate": "2023-07-30T23:33:24"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-07-13T00:00:00",
                "CaptureDate": "2023-07-30T23:33:24"
              }
            ],
            "Petitions": [
              {
                "Type": "PETICAO INTERMEDIARIA",
                "Author": "",
                "CreationDate": "2023-07-26T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              }
            ],
            "Decisions": [
              {
                "DecisionContent": "DEFIRO A GRATUIDADE DA JUSTICA.",
                "DecisionDate": "2023-07-25T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO A GRATUIDADE DA JUSTICA.",
                "DecisionDate": "2023-07-25T00:00:00"
              }
            ]
          },
          {
            "Number": "10953672520238260100",
            "Type": "PROCEDIMENTO COMUM",
            "MainSubject": "INDENIZACAO POR DANO MATERIAL",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "SAO PAULO",
            "Judge": "DANIELA DEJUSTE DE PAULA",
            "JudgingBody": "29 VARA CIVEL",
            "State": "SP",
            "Status": "ATIVO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "INDENIZAÇÃO POR DANO MATERIAL",
            "InferredCNJSubjectNumber": 7780,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "INDENIZACAO POR DANO MATERIAL",
              "INDENIZACAO POR DANO MORAL"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 14379.94,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-07-19T00:00:00",
            "NoticeDate": "2023-07-17T00:00:00",
            "LastMovementDate": "2023-07-20T00:00:00",
            "CaptureDate": "2023-08-05T06:27:53",
            "LastUpdate": "2023-08-05T06:27:53",
            "NumberOfParties": 9,
            "NumberOfUpdates": 6,
            "LawSuitAge": 226,
            "AverageNumberOfUpdatesPerMonth": 0,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "21870447859",
                "IsPartyActive": true,
                "Name": "DANIELA DEJUSTE DE PAULA",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-08-05T06:27:53"
              },
              {
                "Doc": "21783955899",
                "IsPartyActive": true,
                "Name": "GISLAINE SANTANA DA GAMA",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-08-05T06:27:53"
              },
              {
                "Doc": "01697856373",
                "IsPartyActive": true,
                "Name": "MATTEO BASSO FILHO",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "38321",
                  "State": "CE",
                  "SpecificType": "ADVOGADO (REQTE)"
                },
                "LastCaptureDate": "2023-08-05T06:27:53"
              },
              {
                "Doc": "49867203844",
                "IsPartyActive": true,
                "Name": "TAMIRES SILVA DE ABREU",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDA"
                },
                "LastCaptureDate": "2023-08-05T06:27:53"
              },
              {
                "Doc": "49187738000107",
                "IsPartyActive": true,
                "Name": "AQPAGO MEIOS DE PAGAMENTO LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-08-05T06:27:53"
              },
              {
                "Doc": "82879702534",
                "IsPartyActive": true,
                "Name": "LUCIANO FORTUNA DOS SANTOS",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-08-05T06:27:53"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-08-05T06:27:53"
              },
              {
                "Doc": "70736199454",
                "IsPartyActive": true,
                "Name": "AQUILA LEAL SANTANA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-08-05T06:27:53"
              },
              {
                "IsPartyActive": true,
                "Name": "CARLOS ALBERTO SANTANA DOS SANTOS",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-08-05T06:27:53"
              }
            ],
            "Updates": [
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0576/2023 DATA DA PUBLICACAO: 21/07/2023 NUMERO DO DIARIO: 3782",
                "PublishDate": "2023-07-20T00:00:00",
                "CaptureDate": "2023-08-05T06:27:53"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0576/2023 TEOR DO ATO: VISTOS. PARA APRECIACAO DO PEDIDO DE GRATUIDADE, OBJETIVANDO RESGUARDAR O INTERESSE PUBLICO, A PARTE REQUERENTE DEVERA APRESENTAR, EM 15 (QUINZE) DIAS, SOB PENA DE INDEFERIMENTO: A) COPIA DAS ULTIMAS FOLHAS DA CARTEIRA DO TRABALHO, OU COMPROVANTE DE RENDA MENSAL, E DE EVENTUAL CONJUGE; B) COPIA DOS EXTRATOS BANCARIOS DE CONTAS DE TITULARIDADE, E DE EVENTUAL CONJUGE, DOS ULTIMOS TRES MESES; C) COPIA DOS EXTRATOS DE CARTAO DE CREDITO, DOS ULTIMOS TRES MESES; D) COPIA DA ULTIMA DECLARACAO DO IMPOSTO DE RENDA APRESENTADA A SECRETARIA DA RECEITA FEDERAL. OU, NO MESMO PRAZO, DEVERA RECOLHER AS CUSTAS JUDICIAIS E DESPESAS PROCESSUAIS, BEM COMO A TAXA PREVIDENCIARIA RELATIVA A PROCURACAO AD JUDICIA, SOB PENA DE EXTINCAO, SEM NOVA INTIMACAO. INT. ADVOGADOS(S): MATTEO BASSO FILHO (OAB 38321CE/)",
                "PublishDate": "2023-07-19T00:00:00",
                "CaptureDate": "2023-08-05T06:27:53"
              },
              {
                "Content": "PROCESSO : 1095367-25.2023.8.26.0100 CLASSE : PROCEDIMENTO COMUM CIVEL REQTE : GISLAINE SANTANA DA GAMA ADVOGADO : 38321CE/ - MATTEO BASSO FILHO REQDO : CARLOS ALBERTO SANTANA DOS SANTOS VARA : 29 VARA CIVEL",
                "PublishDate": "2023-07-19T00:00:00",
                "CaptureDate": "2023-08-05T06:27:53"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2023-07-18T00:00:00",
                "CaptureDate": "2023-08-05T06:27:53"
              },
              {
                "Content": "PROFERIDAS OUTRAS DECISOES NAO ESPECIFICADAS VISTOS. PARA APRECIACAO DO PEDIDO DE GRATUIDADE, OBJETIVANDO RESGUARDAR O INTERESSE PUBLICO, A PARTE REQUERENTE DEVERA APRESENTAR, EM 15 (QUINZE) DIAS, SOB PENA DE INDEFERIMENTO: A) COPIA DAS ULTIMAS FOLHAS DA CARTEIRA DO TRABALHO, OU COMPROVANTE DE RENDA MENSAL, E DE EVENTUAL CONJUGE; B) COPIA DOS EXTRATOS BANCARIOS DE CONTAS DE TITULARIDADE, E DE EVENTUAL CONJUGE, DOS ULTIMOS TRES MESES; C) COPIA DOS EXTRATOS DE CARTAO DE CREDITO, DOS ULTIMOS TRES MESES; D) COPIA DA ULTIMA DECLARACAO DO IMPOSTO DE RENDA APRESENTADA A SECRETARIA DA RECEITA FEDERAL. OU, NO MESMO PRAZO, DEVERA RECOLHER AS CUSTAS JUDICIAIS E DESPESAS PROCESSUAIS, BEM COMO A TAXA PREVIDENCIARIA RELATIVA A PROCURACAO AD JUDICIA, SOB PENA DE EXTINCAO, SEM NOVA INTIMACAO. INT.",
                "PublishDate": "2023-07-18T00:00:00",
                "CaptureDate": "2023-08-05T06:27:53"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-07-17T00:00:00",
                "CaptureDate": "2023-08-05T06:27:53"
              }
            ],
            "Petitions": [],
            "Decisions": []
          },
          {
            "Number": "10076926420238260604",
            "Type": "PROCEDIMENTO COMUM",
            "MainSubject": "PERDAS E DANOS",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "SUMARE",
            "Judge": "GUSTAVO PISAREWSKI MOISES",
            "JudgingBody": "4 VARA CIVEL",
            "State": "SP",
            "Status": "INDEFINIDO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "PERDAS E DANOS",
            "InferredCNJSubjectNumber": 7698,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO CIVIL",
            "InferredBroadCNJSubjectNumber": 899,
            "OtherSubjects": [
              "PERDAS E DANOS",
              "INDENIZACAO POR DANO MATERIAL",
              "INDENIZACAO POR DANO MATERIAL",
              "INDENIZACAO POR DANO MORAL",
              "INDENIZACAO POR DANO MORAL"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 39070,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-07-25T00:00:00",
            "NoticeDate": "2023-07-22T00:00:00",
            "LastMovementDate": "2023-08-08T00:00:00",
            "CaptureDate": "2023-08-08T14:59:42",
            "LastUpdate": "2023-08-08T14:59:42",
            "NumberOfParties": 11,
            "NumberOfUpdates": 19,
            "LawSuitAge": 221,
            "AverageNumberOfUpdatesPerMonth": 2,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "15581400857",
                "IsPartyActive": true,
                "Name": "GUSTAVO PISAREWSKI MOISES",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-08-08T14:59:42"
              },
              {
                "Doc": "34430968837",
                "IsPartyActive": true,
                "Name": "IZALENE PINTO DOS SANTOS",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-08-08T14:59:42"
              },
              {
                "Doc": "21602370869",
                "IsPartyActive": true,
                "Name": "ANDERSON VINICIUS GORDO GONZALES",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "386592",
                  "State": "SP",
                  "SpecificType": "ADVOGADO (REQTE)"
                },
                "LastCaptureDate": "2023-08-08T14:59:42"
              },
              {
                "Doc": "14994399000188",
                "IsPartyActive": true,
                "Name": "OCTOS CONSULTORIA ESTRATEGICA LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-08-08T14:59:42"
              },
              {
                "Doc": "52930588861",
                "IsPartyActive": true,
                "Name": "RENAN BUIQUE DELMONDES, REGISTRADO CIVILMENTE COMO RENAN BUIQUE DELMONDES",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-08-08T14:59:42"
              },
              {
                "Doc": "50989843866",
                "IsPartyActive": true,
                "Name": "LUCAS SILVA, REGISTRADO CIVILMENTE COMO LUCAS SILVA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-08-08T14:59:42"
              },
              {
                "Doc": "10698085710",
                "IsPartyActive": true,
                "Name": "RAPHAEL ISAAC BANDEIRA, REGISTRADO CIVILMENTE COMO RAPHAEL ISAAC BANDEIRA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-08-08T14:59:42"
              },
              {
                "Doc": "00416968000101",
                "IsPartyActive": true,
                "Name": "BANCO INTER S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-08-08T14:59:42"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-08-08T14:59:42"
              },
              {
                "IsPartyActive": true,
                "Name": "STONES INSTUICAO DE PAGAMENTOS S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-08-08T14:59:42"
              },
              {
                "Doc": "41970199000168",
                "IsPartyActive": true,
                "Name": "ZOSMA SERVICOS DE PAGAMENTOS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-08-08T14:59:42"
              }
            ],
            "Updates": [
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0324/2023 DATA DA PUBLICACAO: 09/08/2023 NUMERO DO DIARIO: 3795",
                "PublishDate": "2023-08-08T00:00:00",
                "CaptureDate": "2023-08-08T14:59:43"
              },
              {
                "Content": "RECEBIDA A PETICAO INICIAL VISTOS. I. CITE(M)-SE O(S) REU(S), PESSOALMENTE, NA FORMA DA LEI, PRAZO DE 15 DIAS PARA RESPOSTA, PENA DE REVELIA E COM A PRESUNCAO DE VERACIDADE DOS FATOS VEICULADOS NA INICIAL, EXPECA-SE E PROVIDENCIE-SE O NECESSARIO. FICA DESDE LOGO CONSIGNADO QUE A CITACAO DEVE SER FEITA PRIMEIRA E EXCLUSIVAMENTE PELOS CORREIOS (VIA CARTA AR), EXPEDINDO-SE O NECESSARIO, COM A OBSERVACAO DE QUE A CITACAO POR MANDADO AGORA E EX VI LEGIS APENAS E EXCLUSIVAMENTE SUBSIDIARIA E CABIVEL NA ESPECIE SOMENTE SE FRUSTRADA AQUELA PRIMEIRA, A SE AVERIGUAR OPORTUNAMENTE, CONFORME VIER A SER O CASO, E ISSO INDEPENDENTE DE QUALQUER OPCAO, ESCOLHA, CONCORDANCIA OU REQUERIMENTO DA PARTE AUTORA. II. SEM DESIGNACAO DE AUDIENCIA PREVIA DE TENTATIVA DE CONCILIACAO, NAO SE VISLUMBRANDO NELA MAIOR UTILIDADE PRATICA NESTA FASE E NESTE MOMENTO DO PROCESSO, SEM PREJUIZO DE SUA DESIGNACAO EM OCASIAO OPORTUNA, SE E CONFORME VIER A SER O CASO. III. INDEFIRO O PEDIDO DE TUTELA DE URGENCIA, POIS AUSENTES SEUS REQUISITOS LEGAIS. COM EFEITO, NAO SE EXTRAI DOS AUTOS ELEMENTOS DE CONVICCAO QUE PERMITAM AO JUIZO RECONHECER, DE PLANO, TER HAVIDO ADOCAO DE EXPEDIENTE FRAUDULENTO OU DELITIVO NAS TRANSFERENCIAS QUE A PARTE AUTORA VOLUNTARIAMENTE INFORMOU TER FEITO, AINDA QUE, EM SEU ENTENDER AGORA, TENHA SIDO INDUZIDA A ERRO, MENOS AINDA SE EXTRAI DA INICIAL QUADRO DE MANIFESTO NEXO CAUSAL ENTRE TAL EVENTO DANOSO E AS INSTITUICOES FINANCEIRAS DEMANDADAS, TUDO A RECOMENDAR A MELHOR APURACAO NO CURSO DO PROCESSO, APOS A ABERTURA DO REGULAR CONTRADITORIO E, SE O CASO, DE EVENTUAL INSTRUCAO. IV. DEFIRO A GRATUIDADE, ANOTE-SE. INTIME-SE.",
                "PublishDate": "2023-08-07T00:00:00",
                "CaptureDate": "2023-08-08T14:59:43"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0324/2023 TEOR DO ATO: VISTOS. I. CITE(M)-SE O(S) REU(S), PESSOALMENTE, NA FORMA DA LEI, PRAZO DE 15 DIAS PARA RESPOSTA, PENA DE REVELIA E COM A PRESUNCAO DE VERACIDADE DOS FATOS VEICULADOS NA INICIAL, EXPECA-SE E PROVIDENCIE-SE O NECESSARIO. FICA DESDE LOGO CONSIGNADO QUE A CITACAO DEVE SER FEITA PRIMEIRA E EXCLUSIVAMENTE PELOS CORREIOS (VIA CARTA AR), EXPEDINDO-SE O NECESSARIO, COM A OBSERVACAO DE QUE A CITACAO POR MANDADO AGORA E EX VI LEGIS APENAS E EXCLUSIVAMENTE SUBSIDIARIA E CABIVEL NA ESPECIE SOMENTE SE FRUSTRADA AQUELA PRIMEIRA, A SE AVERIGUAR OPORTUNAMENTE, CONFORME VIER A SER O CASO, E ISSO INDEPENDENTE DE QUALQUER OPCAO, ESCOLHA, CONCORDANCIA OU REQUERIMENTO DA PARTE AUTORA. II. SEM DESIGNACAO DE AUDIENCIA PREVIA DE TENTATIVA DE CONCILIACAO, NAO SE VISLUMBRANDO NELA MAIOR UTILIDADE PRATICA NESTA FASE E NESTE MOMENTO DO PROCESSO, SEM PREJUIZO DE SUA DESIGNACAO EM OCASIAO OPORTUNA, SE E CONFORME VIER A SER O CASO. III. INDEFIRO O PEDIDO DE TUTELA DE URGENCIA, POIS AUSENTES SEUS REQUISITOS LEGAIS. COM EFEITO, NAO SE EXTRAI DOS AUTOS ELEMENTOS DE CONVICCAO QUE PERMITAM AO JUIZO RECONHECER, DE PLANO, TER HAVIDO ADOCAO DE EXPEDIENTE FRAUDULENTO OU DELITIVO NAS TRANSFERENCIAS QUE A PARTE AUTORA VOLUNTARIAMENTE INFORMOU TER FEITO, AINDA QUE, EM SEU ENTENDER AGORA, TENHA SIDO INDUZIDA A ERRO, MENOS AINDA SE EXTRAI DA INICIAL QUADRO DE MANIFESTO NEXO CAUSAL ENTRE TAL EVENTO DANOSO E AS INSTITUICOES FINANCEIRAS DEMANDADAS, TUDO A RECOMENDAR A MELHOR APURACAO NO CURSO DO PROCESSO, APOS A ABERTURA DO REGULAR CONTRADITORIO E, SE O CASO, DE EVENTUAL INSTRUCAO. IV. DEFIRO A GRATUIDADE, ANOTE-SE. INTIME-SE. ADVOGADOS(S): ANDERSON VINICIUS GORDO GONZALES (OAB 386592/SP)",
                "PublishDate": "2023-08-07T00:00:00",
                "CaptureDate": "2023-08-08T14:59:43"
              },
              {
                "Content": "CARTA EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                "PublishDate": "2023-08-07T00:00:00",
                "CaptureDate": "2023-08-08T14:59:43"
              },
              {
                "Content": "CARTA EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                "PublishDate": "2023-08-07T00:00:00",
                "CaptureDate": "2023-08-08T14:59:43"
              },
              {
                "Content": "CARTA EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                "PublishDate": "2023-08-07T00:00:00",
                "CaptureDate": "2023-08-08T14:59:43"
              },
              {
                "Content": "CARTA EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                "PublishDate": "2023-08-07T00:00:00",
                "CaptureDate": "2023-08-08T14:59:43"
              },
              {
                "Content": "CARTA EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                "PublishDate": "2023-08-07T00:00:00",
                "CaptureDate": "2023-08-08T14:59:43"
              },
              {
                "Content": "CARTA EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                "PublishDate": "2023-08-07T00:00:00",
                "CaptureDate": "2023-08-08T14:59:43"
              },
              {
                "Content": "CARTA EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                "PublishDate": "2023-08-07T00:00:00",
                "CaptureDate": "2023-08-08T14:59:43"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2023-08-06T00:00:00",
                "CaptureDate": "2023-08-08T14:59:43"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2023-07-31T00:00:00",
                "CaptureDate": "2023-08-08T14:59:43"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WSMR.23.70075689-5 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 28/07/2023 16:17",
                "PublishDate": "2023-07-28T00:00:00",
                "CaptureDate": "2023-08-08T14:59:43"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0291/2023 DATA DA PUBLICACAO: 28/07/2023 NUMERO DO DIARIO: 3787",
                "PublishDate": "2023-07-27T00:00:00",
                "CaptureDate": "2023-08-08T14:59:43"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0291/2023 TEOR DO ATO: VISTOS. PARA APRECIACAO DO PEDIDO DE GRATUIDADE, DEVERA A PARTE AUTORA TRAZER AOS AUTOS COPIA DA SUA ULTIMA DECLARACAO DE BENS E RENDA ENVIADA A DRF, A SER JUNTADA COMO 'DOCUMENTO SIGILOSO', BEM COMO, E SEM PREJUIZO, DE OUTROS DOCUMENTOS QUE REPUTAR ADEQUADOS A DEMONSTRAR, DE PLANO, A POBREZA ALEGADA. PRAZO DE 15 DIAS, PENA DE INDEFERIMENTO. APOS, TORNEM OS AUTOS CONCLUSOS PARA O QUE DE DIREITO. INT. ADVOGADOS(S): ANDERSON VINICIUS GORDO GONZALES (OAB 386592S/P)",
                "PublishDate": "2023-07-26T00:00:00",
                "CaptureDate": "2023-08-08T14:59:43"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2023-07-25T00:00:00",
                "CaptureDate": "2023-08-08T14:59:43"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE VISTOS. PARA APRECIACAO DO PEDIDO DE GRATUIDADE, DEVERA A PARTE AUTORA TRAZER AOS AUTOS COPIA DA SUA ULTIMA DECLARACAO DE BENS E RENDA ENVIADA A DRF, A SER JUNTADA COMO 'DOCUMENTO SIGILOSO', BEM COMO, E SEM PREJUIZO, DE OUTROS DOCUMENTOS QUE REPUTAR ADEQUADOS A DEMONSTRAR, DE PLANO, A POBREZA ALEGADA. PRAZO DE 15 DIAS, PENA DE INDEFERIMENTO. APOS, TORNEM OS AUTOS CONCLUSOS PARA O QUE DE DIREITO. INT.",
                "PublishDate": "2023-07-25T00:00:00",
                "CaptureDate": "2023-08-08T14:59:43"
              },
              {
                "Content": "PROCESSO : 1007692-64.2023.8.26.0604 CLASSE : PROCEDIMENTO COMUM CIVEL REQTE : IZALENE PINTO DOS SANTOS ADVOGADO : 386592/SP - ANDERSON VINICIUS GORDO GONZALES REQDO : ZOSMA SERVICOS DE PAGAMENTOS LTDA VARA : 4 VARA CIVEL",
                "PublishDate": "2023-07-25T00:00:00",
                "CaptureDate": "2023-08-08T14:59:42"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-07-22T00:00:00",
                "CaptureDate": "2023-08-08T14:59:43"
              }
            ],
            "Petitions": [
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2023-07-28T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              }
            ],
            "Decisions": [
              {
                "DecisionContent": "DEFIRO A GRATUIDADE, ANOTE-SE.",
                "DecisionDate": "2023-08-07T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO A GRATUIDADE, ANOTE-SE.",
                "DecisionDate": "2023-08-07T00:00:00"
              }
            ]
          },
          {
            "Number": "10094704020238260161",
            "Type": "PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL",
            "MainSubject": "INDENIZACAO POR DANO MATERIAL",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "ESPECIAL CIVEL",
            "CourtDistrict": "DIADEMA",
            "Judge": "LUIZ FERNANDO PARREIRA MILENA",
            "JudgingBody": "VARA DO JUIZADO ESPECIAL CIVEL",
            "State": "SP",
            "Status": "ATIVO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "INDENIZAÇÃO POR DANO MATERIAL",
            "InferredCNJSubjectNumber": 7780,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO DO JUIZADO ESPECIAL CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "INDENIZACAO POR DANO MATERIAL",
              "INDENIZACAO POR DANO MORAL"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 39499.97,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-07-25T00:00:00",
            "NoticeDate": "2023-07-19T00:00:00",
            "LastMovementDate": "2023-08-03T00:00:00",
            "CaptureDate": "2023-08-08T19:38:06",
            "LastUpdate": "2023-08-08T19:38:06",
            "NumberOfParties": 15,
            "NumberOfUpdates": 8,
            "LawSuitAge": 224,
            "AverageNumberOfUpdatesPerMonth": 1,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "09180382860",
                "IsPartyActive": true,
                "Name": "LUIZ FERNANDO PARREIRA MILENA",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-08-08T19:38:06"
              },
              {
                "Doc": "36695074852",
                "IsPartyActive": true,
                "Name": "ALLAN TEIXEIRA FLORES TAKEBAYASHI",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-08-08T19:38:06"
              },
              {
                "Doc": "01450067603",
                "IsPartyActive": true,
                "Name": "MARIANA PRATES DE SOUSA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "430803",
                  "State": "SP",
                  "SpecificType": "ADVOGADA (REQTE)"
                },
                "LastCaptureDate": "2023-08-08T19:38:06"
              },
              {
                "Doc": "10341411000102",
                "IsPartyActive": true,
                "Name": "BANCO SANTANDER S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-08-08T19:38:06"
              },
              {
                "Doc": "60746948000112",
                "IsPartyActive": true,
                "Name": "BANCO BRADESCO S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-08-08T19:38:06"
              },
              {
                "IsPartyActive": true,
                "Name": "VIA PAGSEGURO INTERNET S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-08-08T19:38:06"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-08-08T19:38:06"
              },
              {
                "IsPartyActive": true,
                "Name": "CELCOIN PAGAMENTOS S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-08-08T19:38:06"
              },
              {
                "Doc": "35624319000172",
                "IsPartyActive": true,
                "Name": "MK DIGITAL BANK INSTITUICAO DE PAGAMENTO S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-08-08T19:38:06"
              },
              {
                "IsPartyActive": true,
                "Name": "CASH PAY MEIOS DE PAGAMENTOS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-08-08T19:38:06"
              },
              {
                "Doc": "49099767000109",
                "IsPartyActive": true,
                "Name": "49 099 767 SONIA REGINA PINA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-08-08T19:38:06"
              },
              {
                "Doc": "40945046000106",
                "IsPartyActive": true,
                "Name": "AFONSO COSTA GESTAO DE PAGAMENTOS EPP LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-08-08T19:38:06"
              },
              {
                "Doc": "48472928000103",
                "IsPartyActive": true,
                "Name": "KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-08-08T19:38:06"
              },
              {
                "Doc": "47018560000137",
                "IsPartyActive": true,
                "Name": "FELIPE SILVA DO RAMO 33828070841",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-08-08T19:38:06"
              },
              {
                "Doc": "50579369000179",
                "IsPartyActive": true,
                "Name": "SAMUEL APARECIDO DE SOUZA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-08-08T19:38:06"
              }
            ],
            "Updates": [
              {
                "Content": "CONTESTACAO JUNTADA N PROTOCOLO: WDDA.23.70130907-8 TIPO DA PETICAO: CONTESTACAO DATA: 03/08/2023 10:55",
                "PublishDate": "2023-08-03T00:00:00",
                "CaptureDate": "2023-08-08T19:38:07"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WDDA.23.70129528-0 TIPO DA PETICAO: PETICAO INTERMEDIARIA DATA: 01/08/2023 16:59",
                "PublishDate": "2023-08-01T00:00:00",
                "CaptureDate": "2023-08-08T19:38:07"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0436/2023 DATA DA PUBLICACAO: 26/07/2023 NUMERO DO DIARIO: 3785",
                "PublishDate": "2023-07-25T00:00:00",
                "CaptureDate": "2023-08-08T19:38:07"
              },
              {
                "Content": "PROCESSO 1009470-40.2023.8.26.0161 - PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL - INDENIZACAO POR DANO MATERIAL - ALLAN TEIXEIRA FLORES TAKEBAYASHI - VISTOS. ESCLARECA A PARTE AUTORA, NO PRAZO DE CINCO DIAS, A QUAL CONTRATO DE EMPRESTIMO SE REFERE, QUANTO AO PLEITO DE ANTECIPACAO PARCIAL DA TUTELA, BEM COMO O QUE PRETENDE, AO FINAL, EM RELACAO A REFERIDO CONTRATO. COM AS INFORMACOES, TORNEM. INT. - ADV: MARIANA PRATES DE SOUSA (OAB 430803/SP)",
                "PublishDate": "2023-07-25T00:00:00",
                "CaptureDate": "2023-08-08T19:38:06"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0436/2023 TEOR DO ATO: VISTOS. ESCLARECA A PARTE AUTORA, NO PRAZO DE CINCO DIAS, A QUAL CONTRATO DE EMPRESTIMO SE REFERE, QUANTO AO PLEITO DE ANTECIPACAO PARCIAL DA TUTELA, BEM COMO O QUE PRETENDE, AO FINAL, EM RELACAO A REFERIDO CONTRATO. COM AS INFORMACOES, TORNEM. INT. ADVOGADOS(S): MARIANA PRATES DE SOUSA (OAB 430803/SP)",
                "PublishDate": "2023-07-24T00:00:00",
                "CaptureDate": "2023-08-08T19:38:07"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE VISTOS. ESCLARECA A PARTE AUTORA, NO PRAZO DE CINCO DIAS, A QUAL CONTRATO DE EMPRESTIMO SE REFERE, QUANTO AO PLEITO DE ANTECIPACAO PARCIAL DA TUTELA, BEM COMO O QUE PRETENDE, AO FINAL, EM RELACAO A REFERIDO CONTRATO. COM AS INFORMACOES, TORNEM. INT.",
                "PublishDate": "2023-07-21T00:00:00",
                "CaptureDate": "2023-08-08T19:38:07"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2023-07-20T00:00:00",
                "CaptureDate": "2023-08-08T19:38:07"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-07-19T00:00:00",
                "CaptureDate": "2023-08-08T19:38:07"
              }
            ],
            "Petitions": [
              {
                "Type": "PETICAO INTERMEDIARIA",
                "Author": "",
                "CreationDate": "2023-08-01T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              },
              {
                "Type": "CONTESTACAO",
                "Author": "",
                "CreationDate": "2023-08-03T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              }
            ],
            "Decisions": []
          },
          {
            "Number": "02004934220238060099",
            "Type": "PROCEDIMENTO COMUM",
            "MainSubject": "FRAUDE",
            "CourtName": "TJCE",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "ITAITINGA",
            "JudgingBody": "2 VARA DA COMARCA DE ITAITINGA - ITAITINGA CIVEL",
            "State": "CE",
            "Status": "ATIVO",
            "LawsuitHostService": "OTHER",
            "InferredCNJSubjectNumber": 0,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
            "InferredBroadCNJSubjectNumber": 0,
            "OtherSubjects": [
              "FRAUDE",
              "INDENIZACAO POR DANO MORAL",
              "INDENIZACAO POR DANO MATERIAL"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": -1,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-08-02T00:00:00",
            "NoticeDate": "2023-06-15T18:01:34",
            "LastMovementDate": "2023-08-10T16:18:11",
            "CaptureDate": "2023-08-18T12:18:34",
            "LastUpdate": "2023-08-18T12:18:34",
            "NumberOfParties": 16,
            "NumberOfUpdates": 64,
            "LawSuitAge": 258,
            "AverageNumberOfUpdatesPerMonth": 7,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "22647360898",
                "IsPartyActive": true,
                "Name": "PATRICK LOPES LEONE",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQUERIDO"
                },
                "LastCaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Doc": "08561701000101",
                "IsPartyActive": true,
                "Name": "PAG SEGURO INTERNET S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQUERIDO"
                },
                "LastCaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQUERIDO"
                },
                "LastCaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Doc": "22647451850",
                "IsPartyActive": true,
                "Name": "ELIANE GOMES DO NASCIMENTO",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQUERIDO"
                },
                "LastCaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Doc": "39408183568",
                "IsPartyActive": true,
                "Name": "LUCIANO FORTUNA SANTOS",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQUERIDO"
                },
                "LastCaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Doc": "43729879000110",
                "IsPartyActive": true,
                "Name": "PATRICK EMPRESA CO LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQUERIDO"
                },
                "LastCaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Doc": "49187738000107",
                "IsPartyActive": true,
                "Name": "AQPAGO MEIOS DE PAGAMENTOS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQUERIDO"
                },
                "LastCaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Doc": "41994424800",
                "IsPartyActive": true,
                "Name": "THAYNA OLIVEIRA SILVA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQUERIDO"
                },
                "LastCaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Doc": "00377239000185",
                "IsPartyActive": true,
                "Name": "AQBANK INSTITUICAO DE PAGAMENTO LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQUERIDO"
                },
                "LastCaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Doc": "43434847000197",
                "IsPartyActive": true,
                "Name": "ELIANE EMPRESA CO LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQUERIDO"
                },
                "LastCaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Doc": "41821072847",
                "IsPartyActive": true,
                "Name": "AMANDA THEREZA LENCI PACCOLA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "SpecificType": "ADVOGADO (REQUERENTE)"
                },
                "LastCaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Doc": "05787345320",
                "IsPartyActive": true,
                "Name": "NATALLY SOUZA DA SILVA",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQUERENTE"
                },
                "LastCaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Doc": "77857119768",
                "IsPartyActive": true,
                "Name": "JOAO THOMAZ PRAZERES GONDIM",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "SpecificType": "ADVOGADO (REQUERIDO)"
                },
                "LastCaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Doc": "35068411817",
                "IsPartyActive": true,
                "Name": "RAFAEL HIDEO NAZIMA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "SpecificType": "ADVOGADO (REQUERIDO)"
                },
                "LastCaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Doc": "47019020801",
                "IsPartyActive": true,
                "Name": "GIOVANNA MURBACH ANTONIO GUILHERMONI",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "SpecificType": "ADVOGADO (REQUERIDO)"
                },
                "LastCaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Doc": "39055320854",
                "IsPartyActive": true,
                "Name": "SINDY SELLEN TEIXEIRA ABETINI",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "SpecificType": "ADVOGADO (REQUERIDO)"
                },
                "LastCaptureDate": "2023-08-18T12:18:34"
              }
            ],
            "Updates": [
              {
                "Content": "JUNTADA DE PETICAO | N PROTOCOLO: WITA.23.01804911-0 TIPO DA PETICAO: PETICOES INTERMEDIARIAS DIVERSAS DATA: 10/08/2023 11:54",
                "PublishDate": "2023-08-10T16:18:11",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "CONCLUSO PARA SENTENCA",
                "PublishDate": "2023-08-09T15:41:23",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "CONCLUSO PARA DESPACHO",
                "PublishDate": "2023-08-08T13:28:08",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "JUNTADA DE PETICAO | N PROTOCOLO: WITA.23.01804841-5 TIPO DA PETICAO: ULTIMAS DECLARACOES DATA: 08/08/2023 09:24",
                "PublishDate": "2023-08-08T12:49:29",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "JUNTADA DE PETICAO | N PROTOCOLO: WITA.23.01804834-2 TIPO DA PETICAO: PETICOES INTERMEDIARIAS DIVERSAS DATA: 07/08/2023 19:50",
                "PublishDate": "2023-08-07T23:15:09",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "JUNTADA DE AVISO DE RECEBIMENTO (AR)",
                "PublishDate": "2023-08-07T17:31:57",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "CERTIDAO EMITIDA",
                "PublishDate": "2023-08-07T17:31:19",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "JUNTADA DE AVISO DE RECEBIMENTO (AR)",
                "PublishDate": "2023-08-07T17:28:39",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "DESPACHO/DECISAO DISPONIBILIZADO NO DIARIO DE JUSTICA ELETRONICO | RELACAO: 1650/2023 DATA DA PUBLICACAO: 03/08/2023 NUMERO DO DIARIO: 3130",
                "PublishDate": "2023-08-03T01:30:16",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "ADV: JOAO THOMAZ PRAZERES GONDIM (OAB 18694ES/), ADV: GIOVANNA MURBACH ANTONIO GUILHERMONI (OAB 471410S/P), ADV: SINDY SELLEN TEIXEIRA ABETINI (OAB 404594S/P), ADV: RAFAEL HIDEO NAZIMA (OAB 295443S/P) - PROCESSO 0200493-42.2023.8.06.0099 - PROCEDIMENTO COMUM CIVEL - FRAUDE - REQUERIDO: PAG SEGURO INTERNET S/A - STARK BANK S.A. - AQPAGO MEIOS DE PAGAMENTOS LTDA E OUTROS - R. HOJE, ESPECIFIQUEM AS PARTES, POR SEUS ADVOGADOS, NO PRAZO DE QUINZE DIAS (ART. 357,  1O, DO CPC), AS PROVAS PRETENDEM PRODUZIR EM EVENTUAL FASE INSTRUTORIA, JUSTIFICANDO CONCRETAMENTE A NECESSIDADE DE COLHEITA DE CADA PROVA REQUERIDA, SUA UTILIDADE E SOBRE QUAL FATO DEVERA RECAIR OU SE QUEREM E ENTENDEM CABIVEL O JULGAMENTO ANTECIPADO DA LIDE, QUE RESTA DESDE LOGO ANUNCIADO EM CASO DE INERCIA OU CONCORDANCIA DOS LITIGANTES. EXPEDIENTES NECESSARIOS.",
                "PublishDate": "2023-08-02T00:00:00",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "ENCAMINHADO EDITAL/RELACAO PARA PUBLICACAO | RELACAO: 1650/2023 TEOR DO ATO: R. HOJE, ESPECIFIQUEM AS PARTES, POR SEUS ADVOGADOS, NO PRAZO DE QUINZE DIAS (ART. 357,  1O, DO CPC), AS PROVAS PRETENDEM PRODUZIR EM EVENTUAL FASE INSTRUTORIA, JUSTIFICANDO CONCRETAMENTE A NECESSIDADE DE COLHEITA DE CADA PROVA REQUERIDA, SUA UTILIDADE E SOBRE QUAL FATO DEVERA RECAIR OU SE QUEREM E ENTENDEM CABIVEL",
                "PublishDate": "2023-08-01T05:26:47",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE | R. HOJE, ESPECIFIQUEM AS PARTES, POR SEUS ADVOGADOS, NO PRAZO DE QUINZE DIAS (ART. 357,  1O, DO CPC), AS PROVAS PRETENDEM PRODUZIR EM EVENTUAL FASE INSTRUTORIA, JUSTIFICANDO CONCRETAMENTE A NECESSIDADE DE COLHEITA DE CADA PROVA REQUERIDA, SUA UTILIDADE E SOBRE QUAL FATO DEVERA RECAIR OU SE QUEREM E ENTENDEM CABIVEL O JULGAMENTO ANTECIPADO DA LIDE,",
                "PublishDate": "2023-07-31T11:52:01",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "CONCLUSO PARA DESPACHO",
                "PublishDate": "2023-07-28T12:02:08",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "JUNTADA DE PETICAO | N PROTOCOLO: WITA.23.01804575-0 TIPO DA PETICAO: CONTESTACAO DATA: 27/07/2023 19:44",
                "PublishDate": "2023-07-27T23:13:30",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "JUNTADA DE PETICAO | N PROTOCOLO: WITA.23.01804343-0 TIPO DA PETICAO: CONTESTACAO DATA: 19/07/2023 18:02",
                "PublishDate": "2023-07-19T21:29:17",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "JUNTADA DE AVISO DE RECEBIMENTO (AR)",
                "PublishDate": "2023-07-19T12:31:30",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "JUNTADA DE PETICAO | N PROTOCOLO: WITA.23.01804318-9 TIPO DA PETICAO: CONTRARRAZOES RECURSAIS DATA: 18/07/2023 19:36",
                "PublishDate": "2023-07-18T23:12:15",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "JUNTADA DE PETICAO | N PROTOCOLO: WITA.23.01804296-4 TIPO DA PETICAO: PETICOES INTERMEDIARIAS DIVERSAS DATA: 18/07/2023 12:54",
                "PublishDate": "2023-07-18T16:13:45",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "JUNTADA DE AVISO DE RECEBIMENTO (AR)",
                "PublishDate": "2023-07-17T12:32:29",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "CERTIDAO EMITIDA",
                "PublishDate": "2023-07-17T12:31:21",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "JUNTADA DE AVISO DE RECEBIMENTO (AR)",
                "PublishDate": "2023-07-17T11:42:00",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "CERTIDAO EMITIDA",
                "PublishDate": "2023-07-17T11:40:00",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "JUNTADA DE AVISO DE RECEBIMENTO (AR)",
                "PublishDate": "2023-07-12T17:48:27",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "CERTIDAO EMITIDA",
                "PublishDate": "2023-07-12T17:48:25",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "JUNTADA DE AVISO DE RECEBIMENTO (AR)",
                "PublishDate": "2023-07-11T16:03:16",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "CERTIDAO EMITIDA",
                "PublishDate": "2023-07-11T16:01:52",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "JUNTADA DE PETICAO | N PROTOCOLO: WITA.23.01803997-1 TIPO DA PETICAO: CONTRARRAZOES RECURSAIS DATA: 06/07/2023 11:22",
                "PublishDate": "2023-07-06T14:38:29",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "CONCLUSO PARA DESPACHO",
                "PublishDate": "2023-07-05T17:49:16",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "JUNTADA DE PETICAO | N PROTOCOLO: WITA.23.01803960-2 TIPO DA PETICAO: CONTRARRAZOES RECURSAIS DATA: 05/07/2023 13:30",
                "PublishDate": "2023-07-05T16:49:27",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "CERTIDAO EMITIDA",
                "PublishDate": "2023-06-29T15:33:42",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "CERTIDAO EMITIDA",
                "PublishDate": "2023-06-29T15:27:06",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "CERTIDAO EMITIDA",
                "PublishDate": "2023-06-29T15:22:25",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "EXPEDICAO DE CARTA",
                "PublishDate": "2023-06-26T18:24:28",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "EXPEDICAO DE CARTA",
                "PublishDate": "2023-06-26T18:24:01",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "EXPEDICAO DE CARTA",
                "PublishDate": "2023-06-26T18:23:56",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "EXPEDICAO DE CARTA",
                "PublishDate": "2023-06-26T18:23:53",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "EXPEDICAO DE CARTA",
                "PublishDate": "2023-06-26T18:23:21",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "EXPEDICAO DE CARTA",
                "PublishDate": "2023-06-26T18:23:17",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "EXPEDICAO DE CARTA",
                "PublishDate": "2023-06-26T18:23:14",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "EXPEDICAO DE CARTA",
                "PublishDate": "2023-06-26T18:22:55",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE | A PARTE CONTRARIA, PARA QUE, CASO QUEIRA, APRESENTE MANIFESTACAO ACERCA DOS EMBARGOS DE DECLARACAO DE PAGINAS 114/118, NO PRAZO DE 05 (CINCO) DIAS. EXPEDIENTES NECESSARIOS. ITAITINGA, 21 DE JUNHO DE 2023. ANA CELIA PINHO CARNEIRO JUIZA DE DIREITO",
                "PublishDate": "2023-06-22T20:02:23",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "CONCLUSO PARA DESPACHO",
                "PublishDate": "2023-06-21T17:21:12",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "JUNTADA DE PETICAO | N PROTOCOLO: WITA.23.01803642-5 TIPO DA PETICAO: EMBARGOS DE DECLARACAO CIVEL DATA: 21/06/2023 13:32",
                "PublishDate": "2023-06-21T16:52:34",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "PROCESSO ENTRANHADO | ENTRANHADO O PROCESSO 0200493-42.2023.8.06.0099/01 - CLASSE: EMBARGOS DE DECLARACAO CIVEL EM PROCEDIMENTO COMUM CIVEL - ASSUNTO PRINCIPAL: FRAUDE",
                "PublishDate": "2023-06-21T16:52:29",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "RECURSO INTERPOSTO | SEQ.: 01 - EMBARGOS DE DECLARACAO CIVEL",
                "PublishDate": "2023-06-21T16:52:11",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "CERTIDAO EMITIDA",
                "PublishDate": "2023-06-21T11:20:32",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "CERTIDAO EMITIDA",
                "PublishDate": "2023-06-21T11:19:33",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "CERTIDAO EMITIDA",
                "PublishDate": "2023-06-21T11:18:27",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "CERTIDAO EMITIDA",
                "PublishDate": "2023-06-21T11:17:33",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "CERTIDAO EMITIDA",
                "PublishDate": "2023-06-21T11:16:36",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "CERTIDAO EMITIDA",
                "PublishDate": "2023-06-21T11:15:44",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "CERTIDAO EMITIDA",
                "PublishDate": "2023-06-21T11:14:48",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "CERTIDAO EMITIDA",
                "PublishDate": "2023-06-21T11:13:44",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "EXPEDICAO DE CARTA",
                "PublishDate": "2023-06-20T12:05:09",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "EXPEDICAO DE CARTA",
                "PublishDate": "2023-06-20T12:04:54",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "EXPEDICAO DE CARTA",
                "PublishDate": "2023-06-20T12:04:39",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "EXPEDICAO DE CARTA",
                "PublishDate": "2023-06-20T12:04:27",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "EXPEDICAO DE CARTA",
                "PublishDate": "2023-06-20T12:04:13",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "EXPEDICAO DE CARTA",
                "PublishDate": "2023-06-20T12:04:00",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "EXPEDICAO DE CARTA",
                "PublishDate": "2023-06-20T12:03:47",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "EXPEDICAO DE CARTA",
                "PublishDate": "2023-06-20T12:03:33",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE | R.H DEFIRO OS BENEFICIO DA JUSTICA GRATUITA. CITE-SE. EXPEDIENTES NECESSARIOS ITAITINGA, 15 DE JUNHO DE 2023. ANA CELIA PINHO CARNEIRO JUIZA DE DIREITO",
                "PublishDate": "2023-06-16T21:19:44",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "CONCLUSOS",
                "PublishDate": "2023-06-15T18:01:38",
                "CaptureDate": "2023-08-18T12:18:34"
              },
              {
                "Content": "PROCESSO DISTRIBUIDO POR SORTEIO",
                "PublishDate": "2023-06-15T18:01:34",
                "CaptureDate": "2023-08-18T12:18:34"
              }
            ],
            "Petitions": [],
            "Decisions": [
              {
                "DecisionContent": "DEFIRO OS BENEFICIO DA JUSTICA GRATUITA.",
                "DecisionDate": "2023-06-16T21:19:44"
              }
            ]
          },
          {
            "Number": "10036058220238260663",
            "Type": "PETICAO",
            "MainSubject": "PETICAO INTERMEDIARIA",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "",
            "CourtDistrict": "VOTORANTIM",
            "Judge": "BARBARA SYUFFI MONTES",
            "JudgingBody": "VARA DO ANEXO DO JUIZADO ESPECIAL CIVEL E CRIMINAL",
            "State": "SP",
            "Status": "INDEFINIDO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectNumber": 0,
            "InferredCNJProcedureTypeName": "PETIÇÃO CÍVEL",
            "InferredBroadCNJSubjectNumber": 0,
            "OtherSubjects": [
              "PETICAO INTERMEDIARIA"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 35568.24,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-08-07T00:00:00",
            "NoticeDate": "2023-08-02T00:00:00",
            "LastMovementDate": "2023-08-15T00:00:00",
            "CaptureDate": "2023-08-18T19:09:43",
            "LastUpdate": "2023-08-18T19:09:43",
            "NumberOfParties": 6,
            "NumberOfUpdates": 13,
            "LawSuitAge": 210,
            "AverageNumberOfUpdatesPerMonth": 1,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "28642003847",
                "IsPartyActive": true,
                "Name": "BARBARA SYUFFI MONTES",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-08-18T19:09:43"
              },
              {
                "Doc": "42893919820",
                "IsPartyActive": true,
                "Name": "JOSE AUGUSTO ANTUNES OBRELLI",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-08-18T19:09:43"
              },
              {
                "Doc": "12733332686",
                "IsPartyActive": true,
                "Name": "SOFIA SOARES VILLAS BOAS",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "214770",
                  "State": "MG",
                  "SpecificType": "ADVOGADA (REQTE)"
                },
                "LastCaptureDate": "2023-08-18T19:09:43"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-08-18T19:09:43"
              },
              {
                "Doc": "71027866000304",
                "IsPartyActive": true,
                "Name": "BANCO BS2 S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-08-18T19:09:43"
              },
              {
                "IsPartyActive": true,
                "Name": "CELCOIN PAGAMENTOS S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-08-18T19:09:43"
              }
            ],
            "Updates": [
              {
                "Content": "AR POSITIVO JUNTADO JUNTADA DE AR : AA545136639TJ SITUACAO : CUMPRIDO MODELO : PROCESSO DIGITAL - CARTA - CITACAO E INTIMACAO - APRESENTAR DEFESA ESCRITA - SEM AUDIENCIA - JUIZADO DESTINATARIO : STARK BANK S.A. DILIGENCIA : 09/08/2023",
                "PublishDate": "2023-08-15T00:00:00",
                "CaptureDate": "2023-08-18T19:09:44"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WVTR.23.70040736-0 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 14/08/2023 18:41",
                "PublishDate": "2023-08-14T00:00:00",
                "CaptureDate": "2023-08-18T19:09:44"
              },
              {
                "Content": "AR NEGATIVO JUNTADO - NAO EXISTE NUMERO INDICADO JUNTADA DE AR : AA545136642TJ SITUACAO : NAO EXISTE N INDICADO MODELO : PROCESSO DIGITAL - CARTA - CITACAO E INTIMACAO - APRESENTAR DEFESA ESCRITA - SEM AUDIENCIA - JUIZADO DESTINATARIO : BANCO BS2 S.A.",
                "PublishDate": "2023-08-13T00:00:00",
                "CaptureDate": "2023-08-18T19:09:44"
              },
              {
                "Content": "AR POSITIVO JUNTADO JUNTADA DE AR : AA545136656TJ SITUACAO : CUMPRIDO MODELO : PROCESSO DIGITAL - CARTA - CITACAO E INTIMACAO - APRESENTAR DEFESA ESCRITA - SEM AUDIENCIA - JUIZADO DESTINATARIO : CELCOIN PAGAMENTOS S.A. DILIGENCIA : 09/08/2023",
                "PublishDate": "2023-08-11T00:00:00",
                "CaptureDate": "2023-08-18T19:09:44"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0409/2023 DATA DA PUBLICACAO: 08/08/2023 NUMERO DO DIARIO: 3794",
                "PublishDate": "2023-08-07T00:00:00",
                "CaptureDate": "2023-08-18T19:09:44"
              },
              {
                "Content": "PROCESSO 1003605-82.2023.8.26.0663 - PETICAO CIVEL - PETICAO INTERMEDIARIA - JOSE AUGUSTO ANTUNES OBRELLI - 1. AS REGRAS DE EXPERIENCIA INDICAM QUE, EM CASOS SIMILARES A HIPOTESE DOS PRESENTES AUTOS, A AUDIENCIA DE CONCILIACAO COSTUMA SER INFRUTIFERA. ASSIM, A VISTA DOS PRINCIPIOS INFORMATIVOS DO JUIZADO ESPECIAL CIVEL, RAZOAVEL QUE SE DISPENSE A REALIZACAO DA AUDIENCIA ACIMA REFERIDA, O QUE NAO OBSTA EVENTUAL COMPOSICAO NO CURSO DA DEMANDA. DO EXPOSTO, CITE-SE A PARTE RE PARA APRESENTAR CONTESTACAO, NO PRAZO DE 15 DIAS, A CONTAR DA DATA DA INTIMACAO (ENUNCIADO 13 DO FONAJE), OBSERVANDO-SE QUE EM CASO DE INERCIA OS FATOS NARRADOS NA PETICAO INICIAL PODERAO SER PRESUMIDOS COMO VERDADEIROS (ART. 344, CPC). 2. CASO A PARTE REQUERIDA MANIFESTE INTERESSE CONCRETO EM REALIZAR ACORDO, PODERA APRESENTAR PROPOSTA ESPECIFICA EM PRELIMINAR DE CONTESTACAO, SEM QUE ISTO IMPLIQUE EM RECONHECIMENTO DO PEDIDO. HAVENDO PROPOSTA ESPECIFICA, INTIME-SE A PARTE AUTORA, IMEDIATAMENTE, PARA MANIFESTACAO A RESPEITO DO ACORDO PROPOSTO, BEM COMO EM REPLICA, INDEPENDENTEMENTE DE NOVO DESPACHO, VINDO CONCLUSOS OS AUTOS, AO FINAL, COM CELERIDADE. 3. EM CASO DE OFERECIMENTO DE CONTESTACAO SEM PROPOSTA DE ACORDO, INTIME-SE A PARTE AUTORA PARA MANIFESTAR-SE EM REPLICA, INCLUSIVE QUANTO AO(S) DOCUMENTO(S) JUNTADO(S), NO PRAZO DE 15 DIAS, COMPROVANDO DESDE LOGO O QUE VIER EVENTUALMENTE A ALEGAR. COM A JUNTADA DE DOCUMENTOS, CIENCIA A PARTE CONTRARIA PARA EVENTUAL MANIFESTACAO NO PRAZO DE 15 DIAS (ART. 437,  1., DO CPC). A SEGUIR, CONCLUSOS PARA SENTENCA. INT. - ADV: SOFIA SOARES VILLAS BOAS (OAB 214770/ MG) JUIZO DE DIREITO DA VARA DO ANEXO DO JUIZADO ESPECIAL CIVEL E CRIMINAL EDITAL DE INTIMACAO DE ADVOGADOS RELACAO N 0410/2023",
                "PublishDate": "2023-08-07T00:00:00",
                "CaptureDate": "2023-08-18T19:09:43"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0409/2023 TEOR DO ATO: 1. AS REGRAS DE EXPERIENCIA INDICAM QUE, EM CASOS SIMILARES A HIPOTESE DOS PRESENTES AUTOS, A AUDIENCIA DE CONCILIACAO COSTUMA SER INFRUTIFERA. ASSIM, A VISTA DOS PRINCIPIOS INFORMATIVOS DO JUIZADO ESPECIAL CIVEL, RAZOAVEL QUE SE DISPENSE A REALIZACAO DA AUDIENCIA ACIMA REFERIDA, O QUE NAO OBSTA EVENTUAL COMPOSICAO NO CURSO DA DEMANDA. DO EXPOSTO, CITE-SE A PARTE RE PARA APRESENTAR CONTESTACAO, NO PRAZO DE 15 DIAS, A CONTAR DA DATA DA INTIMACAO (ENUNCIADO 13 DO FONAJE), OBSERVANDO-SE QUE EM CASO DE INERCIA OS FATOS NARRADOS NA PETICAO INICIAL PODERAO SER PRESUMIDOS COMO VERDADEIROS (ART. 344, CPC). 2. CASO A PARTE REQUERIDA MANIFESTE INTERESSE CONCRETO EM REALIZAR ACORDO, PODERA APRESENTAR PROPOSTA ESPECIFICA EM PRELIMINAR DE CONTESTACAO, SEM QUE ISTO IMPLIQUE EM RECONHECIMENTO DO PEDIDO. HAVENDO PROPOSTA ESPECIFICA, INTIME-SE A PARTE AUTORA, IMEDIATAMENTE, PARA MANIFESTACAO A RESPEITO DO ACORDO PROPOSTO, BEM COMO EM REPLICA, INDEPENDENTEMENTE DE NOVO DESPACHO, VINDO CONCLUSOS OS AUTOS, AO FINAL, COM CELERIDADE. 3. EM CASO DE OFERECIMENTO DE CONTESTACAO SEM PROPOSTA DE ACORDO, INTIME-SE A PARTE AUTORA PARA MANIFESTAR-SE EM REPLICA, INCLUSIVE QUANTO AO(S) DOCUMENTO(S) JUNTADO(S), NO PRAZO DE 15 DIAS, COMPROVANDO DESDE LOGO O QUE VIER EVENTUALMENTE A ALEGAR. COM A JUNTADA DE DOCUMENTOS, CIENCIA A PARTE CONTRARIA PARA EVENTUAL MANIFESTACAO NO PRAZO DE 15 DIAS (ART. 437,  1., DO CPC). A SEGUIR, CONCLUSOS PARA SENTENCA. INT. ADVOGADOS(S): SOFIA SOARES VILLAS BOAS (OAB 214770/MG)",
                "PublishDate": "2023-08-04T00:00:00",
                "CaptureDate": "2023-08-18T19:09:44"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2023-08-03T00:00:00",
                "CaptureDate": "2023-08-18T19:09:44"
              },
              {
                "Content": "RECEBIDA A PETICAO INICIAL - CITACAO POR CARTA AR 1. AS REGRAS DE EXPERIENCIA INDICAM QUE, EM CASOS SIMILARES A HIPOTESE DOS PRESENTES AUTOS, A AUDIENCIA DE CONCILIACAO COSTUMA SER INFRUTIFERA. ASSIM, A VISTA DOS PRINCIPIOS INFORMATIVOS DO JUIZADO ESPECIAL CIVEL, RAZOAVEL QUE SE DISPENSE A REALIZACAO DA AUDIENCIA ACIMA REFERIDA, O QUE NAO OBSTA EVENTUAL COMPOSICAO NO CURSO DA DEMANDA. DO EXPOSTO, CITE-SE A PARTE RE PARA APRESENTAR CONTESTACAO, NO PRAZO DE 15 DIAS, A CONTAR DA DATA DA INTIMACAO (ENUNCIADO 13 DO FONAJE), OBSERVANDO-SE QUE EM CASO DE INERCIA OS FATOS NARRADOS NA PETICAO INICIAL PODERAO SER PRESUMIDOS COMO VERDADEIROS (ART. 344, CPC). 2. CASO A PARTE REQUERIDA MANIFESTE INTERESSE CONCRETO EM REALIZAR ACORDO, PODERA APRESENTAR PROPOSTA ESPECIFICA EM PRELIMINAR DE CONTESTACAO, SEM QUE ISTO IMPLIQUE EM RECONHECIMENTO DO PEDIDO. HAVENDO PROPOSTA ESPECIFICA, INTIME-SE A PARTE AUTORA, IMEDIATAMENTE, PARA MANIFESTACAO A RESPEITO DO ACORDO PROPOSTO, BEM COMO EM REPLICA, INDEPENDENTEMENTE DE NOVO DESPACHO, VINDO CONCLUSOS OS AUTOS, AO FINAL, COM CELERIDADE. 3. EM CASO DE OFERECIMENTO DE CONTESTACAO SEM PROPOSTA DE ACORDO, INTIME-SE A PARTE AUTORA PARA MANIFESTAR-SE EM REPLICA, INCLUSIVE QUANTO AO(S) DOCUMENTO(S) JUNTADO(S), NO PRAZO DE 15 DIAS, COMPROVANDO DESDE LOGO O QUE VIER EVENTUALMENTE A ALEGAR. COM A JUNTADA DE DOCUMENTOS, CIENCIA A PARTE CONTRARIA PARA EVENTUAL MANIFESTACAO NO PRAZO DE 15 DIAS (ART. 437,  1., DO CPC). A SEGUIR, CONCLUSOS PARA SENTENCA. INT.",
                "PublishDate": "2023-08-03T00:00:00",
                "CaptureDate": "2023-08-18T19:09:44"
              },
              {
                "Content": "CARTA DE CITACAO EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO E INTIMACAO - APRESENTAR DEFESA ESCRITA - SEM AUDIENCIA - JUIZADO",
                "PublishDate": "2023-08-03T00:00:00",
                "CaptureDate": "2023-08-18T19:09:44"
              },
              {
                "Content": "CARTA DE CITACAO EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO E INTIMACAO - APRESENTAR DEFESA ESCRITA - SEM AUDIENCIA - JUIZADO",
                "PublishDate": "2023-08-03T00:00:00",
                "CaptureDate": "2023-08-18T19:09:44"
              },
              {
                "Content": "CARTA DE CITACAO EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO E INTIMACAO - APRESENTAR DEFESA ESCRITA - SEM AUDIENCIA - JUIZADO",
                "PublishDate": "2023-08-03T00:00:00",
                "CaptureDate": "2023-08-18T19:09:44"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-08-02T00:00:00",
                "CaptureDate": "2023-08-18T19:09:44"
              }
            ],
            "Petitions": [
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2023-08-14T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              }
            ],
            "Decisions": []
          },
          {
            "Number": "11057254920238260100",
            "Type": "PROCEDIMENTO COMUM",
            "MainSubject": "RESPONSABILIDADE DO FORNECEDOR",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "SAO PAULO",
            "Judge": "FLAVIA POYARES MIRANDA",
            "JudgingBody": "28 VARA CIVEL",
            "State": "SP",
            "Status": "INDEFINIDO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "RESPONSABILIDADE DO FORNECEDOR",
            "InferredCNJSubjectNumber": 6220,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "RESPONSABILIDADE DO FORNECEDOR"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 13854,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-08-07T00:00:00",
            "NoticeDate": "2023-08-03T00:00:00",
            "LastMovementDate": "2023-08-15T00:00:00",
            "CaptureDate": "2023-08-19T05:45:20",
            "LastUpdate": "2023-08-19T05:45:20",
            "NumberOfParties": 5,
            "NumberOfUpdates": 9,
            "LawSuitAge": 209,
            "AverageNumberOfUpdatesPerMonth": 1,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "28978824846",
                "IsPartyActive": true,
                "Name": "FLAVIA POYARES MIRANDA",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-08-19T05:45:20"
              },
              {
                "Doc": "33723431828",
                "IsPartyActive": true,
                "Name": "CARINA ALVES PACHECO",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-08-19T05:45:20"
              },
              {
                "Doc": "48561184809",
                "IsPartyActive": true,
                "Name": "TIAGO BAPTISTA VALIM",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "485964",
                  "State": "SP",
                  "SpecificType": "ADVOGADO (REQTE)"
                },
                "LastCaptureDate": "2023-08-19T05:45:20"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-08-19T05:45:20"
              },
              {
                "Doc": "49187738000107",
                "IsPartyActive": true,
                "Name": "AQPAGO MEIOS DE PAGAMENTOS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-08-19T05:45:20"
              }
            ],
            "Updates": [
              {
                "Content": "AR POSITIVO JUNTADO JUNTADA DE AR : AA560685425TJ SITUACAO : CUMPRIDO MODELO : PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC DESTINATARIO : AQPAGO MEIOS DE PAGAMENTOS LTDA DILIGENCIA : 10/08/2023",
                "PublishDate": "2023-08-15T00:00:00",
                "CaptureDate": "2023-08-19T05:45:21"
              },
              {
                "Content": "PROCESSO : 1105725-49.2023.8.26.0100 CLASSE : PROCEDIMENTO COMUM CIVEL REQTE : CARINA ALVES PACHECO ADVOGADO : 485964/SP - TIAGO BAPTISTA VALIM REQDO : AQPAGO MEIOS DE PAGAMENTOS LTDA VARA : 28 VARA CIVEL PROCESSO 1105725-49.2023.8.26.0100 - PROCEDIMENTO COMUM CIVEL - RESPONSABILIDADE DO FORNECEDOR - CARINA ALVES PACHECO - VISTOS. 1- CONCEDO OS BENEFICIOS DA GRATUIDADE PROCESSUAL. ANOTE-SE. 2- DEIXO DE DESIGNAR AUDIENCIA DE CONCILIACAO (ART. 334 DO CPC), POIS NAO VISLUMBRO, NESTE MOMENTO, UTILIDADE DA MEDIDA, EM PROL DO PRINCIPIO DA DURACAO RAZOAVEL DO PROCESSO. 3- CITE-SE PARA O OFERECIMENTO DE CONTESTACAO NO PRAZO DE 15 (QUINZE) DIAS UTEIS (ART. 335 DO CPC), SOB PENA DE SEREM PRESUMIDAS COMO VERDADEIRAS AS ALEGACOES DE FATO ARTICULADAS NA PETICAO INICIAL (ART. 344 DO CPC). INTIME-SE. - ADV: TIAGO BAPTISTA VALIM (OAB 485964/SP)",
                "PublishDate": "2023-08-07T00:00:00",
                "CaptureDate": "2023-08-19T05:45:20"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0695/2023 DATA DA PUBLICACAO: 08/08/2023 NUMERO DO DIARIO: 3794",
                "PublishDate": "2023-08-05T00:00:00",
                "CaptureDate": "2023-08-19T05:45:21"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2023-08-04T00:00:00",
                "CaptureDate": "2023-08-19T05:45:21"
              },
              {
                "Content": "RECEBIDA A PETICAO INICIAL - CITACAO POR CARTA AR VISTOS. 1- CONCEDO OS BENEFICIOS DA GRATUIDADE PROCESSUAL. ANOTE-SE. 2- DEIXO DE DESIGNAR AUDIENCIA DE CONCILIACAO (ART. 334 DO CPC), POIS NAO VISLUMBRO, NESTE MOMENTO, UTILIDADE DA MEDIDA, EM PROL DO PRINCIPIO DA DURACAO RAZOAVEL DO PROCESSO. 3- CITE-SE PARA O OFERECIMENTO DE CONTESTACAO NO PRAZO DE 15 (QUINZE) DIAS UTEIS (ART. 335 DO CPC), SOB PENA DE SEREM PRESUMIDAS COMO VERDADEIRAS AS ALEGACOES DE FATO ARTICULADAS NA PETICAO INICIAL (ART. 344 DO CPC). INTIME-SE.",
                "PublishDate": "2023-08-04T00:00:00",
                "CaptureDate": "2023-08-19T05:45:21"
              },
              {
                "Content": "CARTA EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                "PublishDate": "2023-08-04T00:00:00",
                "CaptureDate": "2023-08-19T05:45:21"
              },
              {
                "Content": "CARTA EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                "PublishDate": "2023-08-04T00:00:00",
                "CaptureDate": "2023-08-19T05:45:21"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0695/2023 TEOR DO ATO: VISTOS. 1- CONCEDO OS BENEFICIOS DA GRATUIDADE PROCESSUAL. ANOTE-SE. 2- DEIXO DE DESIGNAR AUDIENCIA DE CONCILIACAO (ART. 334 DO CPC), POIS NAO VISLUMBRO, NESTE MOMENTO, UTILIDADE DA MEDIDA, EM PROL DO PRINCIPIO DA DURACAO RAZOAVEL DO PROCESSO. 3- CITE-SE PARA O OFERECIMENTO DE CONTESTACAO NO PRAZO DE 15 (QUINZE) DIAS UTEIS (ART. 335 DO CPC), SOB PENA DE SEREM PRESUMIDAS COMO VERDADEIRAS AS ALEGACOES DE FATO ARTICULADAS NA PETICAO INICIAL (ART. 344 DO CPC). INTIME-SE. ADVOGADOS(S): TIAGO BAPTISTA VALIM (OAB 485964/SP)",
                "PublishDate": "2023-08-04T00:00:00",
                "CaptureDate": "2023-08-19T05:45:21"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-08-03T00:00:00",
                "CaptureDate": "2023-08-19T05:45:21"
              }
            ],
            "Petitions": [],
            "Decisions": []
          },
          {
            "Number": "00017440220238260462",
            "Type": "RECLAMACAO",
            "MainSubject": "OUTROS",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "POA",
            "Judge": "EDUARDO MESSIAS ALTEMANI",
            "JudgingBody": "CEJUSC (PRE-PROCESSUAL)",
            "State": "SP",
            "Status": "INDEFINIDO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "OUTROS",
            "InferredCNJSubjectNumber": 12901,
            "InferredCNJProcedureTypeName": "RECLAMAÇÃO PRÉ-PROCESSUAL",
            "InferredBroadCNJSubjectName": "DIREITO À EDUCAÇÃO",
            "InferredBroadCNJSubjectNumber": 12775,
            "OtherSubjects": [
              "OUTROS"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": -1,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-07-28T00:00:00",
            "NoticeDate": "2023-07-25T00:00:00",
            "LastMovementDate": "2023-08-17T00:00:00",
            "CaptureDate": "2023-08-19T17:06:47",
            "LastUpdate": "2023-08-19T17:06:47",
            "NumberOfParties": 8,
            "NumberOfUpdates": 18,
            "LawSuitAge": 218,
            "AverageNumberOfUpdatesPerMonth": 2,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "22360630830",
                "IsPartyActive": true,
                "Name": "EDUARDO MESSIAS ALTEMANI",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-08-19T17:06:47"
              },
              {
                "Doc": "42818019877",
                "IsPartyActive": true,
                "Name": "RAIZA REGINA RODRIGUES MARTINS",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "RECLAMANTE"
                },
                "LastCaptureDate": "2023-08-19T17:06:47"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "RECLAMADO"
                },
                "LastCaptureDate": "2023-08-19T17:06:47"
              },
              {
                "IsPartyActive": true,
                "Name": "MK DIGITAL BANK",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "RECLAMADO"
                },
                "LastCaptureDate": "2023-08-19T17:06:47"
              },
              {
                "Doc": "48564621000124",
                "IsPartyActive": true,
                "Name": "G3 PAG LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "RECLAMADO"
                },
                "LastCaptureDate": "2023-08-19T17:06:47"
              },
              {
                "IsPartyActive": true,
                "Name": "HOLDING ELETRONIC GAMING EXPRESS",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "RECLAMADO"
                },
                "LastCaptureDate": "2023-08-19T17:06:47"
              },
              {
                "Doc": "48472928000103",
                "IsPartyActive": true,
                "Name": "KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "RECLAMADO"
                },
                "LastCaptureDate": "2023-08-19T17:06:47"
              },
              {
                "IsPartyActive": true,
                "Name": "CASH PAY MEIOS DE PAGAMENTOS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "RECLAMADO"
                },
                "LastCaptureDate": "2023-08-19T17:06:47"
              }
            ],
            "Updates": [
              {
                "Content": "CARTA DE INTIMACAO EXPEDIDA PROCESSO DIGITAL - CARTA - INTIMACAO - AUDIENCIA DE TENTATIVA DE CONCILIACAO - (EXCLUSIVO CEJUSC)",
                "PublishDate": "2023-08-17T00:00:00",
                "CaptureDate": "2023-08-19T17:06:48"
              },
              {
                "Content": "AR POSITIVO JUNTADO JUNTADA DE AR : AA535831427TJ SITUACAO : CUMPRIDO MODELO : RECLAMACAO DIGITAL - CARTA - CONVITE - (EXCLUSIVO CEJUSC - PRE-PROCESSUAL) DESTINATARIO : MK DIGITAL BANK DILIGENCIA : 03/08/2023",
                "PublishDate": "2023-08-11T00:00:00",
                "CaptureDate": "2023-08-19T17:06:48"
              },
              {
                "Content": "DOCUMENTO JUNTADO",
                "PublishDate": "2023-08-11T00:00:00",
                "CaptureDate": "2023-08-19T17:06:48"
              },
              {
                "Content": "AR NEGATIVO JUNTADO - RECUSADO JUNTADA DE AR : AA535831461TJ SITUACAO : RECUSADO MODELO : RECLAMACAO DIGITAL - CARTA - CONVITE - (EXCLUSIVO CEJUSC - PRE-PROCESSUAL) DESTINATARIO : KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA",
                "PublishDate": "2023-08-09T00:00:00",
                "CaptureDate": "2023-08-19T17:06:48"
              },
              {
                "Content": "AR POSITIVO JUNTADO JUNTADA DE AR : AA535831475TJ SITUACAO : CUMPRIDO MODELO : RECLAMACAO DIGITAL - CARTA - CONVITE - (EXCLUSIVO CEJUSC - PRE-PROCESSUAL) DESTINATARIO : CASH PAY MEIOS DE PAGAMENTOS LTDA DILIGENCIA : 03/08/2023",
                "PublishDate": "2023-08-09T00:00:00",
                "CaptureDate": "2023-08-19T17:06:48"
              },
              {
                "Content": "AR POSITIVO JUNTADO JUNTADA DE AR : AA535831400TJ SITUACAO : CUMPRIDO MODELO : RECLAMACAO DIGITAL - CARTA - CONVITE - (EXCLUSIVO CEJUSC - PRE-PROCESSUAL) DESTINATARIO : STARK BANK S.A. DILIGENCIA : 01/08/2023",
                "PublishDate": "2023-08-05T00:00:00",
                "CaptureDate": "2023-08-19T17:06:48"
              },
              {
                "Content": "AR POSITIVO JUNTADO JUNTADA DE AR : AA535831444TJ SITUACAO : CUMPRIDO MODELO : RECLAMACAO DIGITAL - CARTA - CONVITE - (EXCLUSIVO CEJUSC - PRE-PROCESSUAL) DESTINATARIO : G3 PAG LTDA DILIGENCIA : 01/08/2023",
                "PublishDate": "2023-08-04T00:00:00",
                "CaptureDate": "2023-08-19T17:06:48"
              },
              {
                "Content": "PROCESSO : 0001744-02.2023.8.26.0462 CLASSE : RECLAMACAO PRE-PROCESSUAL RECLAMANTE : RAIZA REGINA RODRIGUES MARTINS RECLAMADO : STARK BANK S.A. VARA : CEJUSC (PRE-PROCESSUAL)",
                "PublishDate": "2023-07-28T00:00:00",
                "CaptureDate": "2023-08-19T17:06:47"
              },
              {
                "Content": "CARTA EXPEDIDA RECLAMACAO DIGITAL - CARTA - CONVITE - (EXCLUSIVO CEJUSC - PRE-PROCESSUAL)",
                "PublishDate": "2023-07-26T00:00:00",
                "CaptureDate": "2023-08-19T17:06:48"
              },
              {
                "Content": "CARTA EXPEDIDA RECLAMACAO DIGITAL - CARTA - CONVITE - (EXCLUSIVO CEJUSC - PRE-PROCESSUAL)",
                "PublishDate": "2023-07-26T00:00:00",
                "CaptureDate": "2023-08-19T17:06:48"
              },
              {
                "Content": "CARTA EXPEDIDA RECLAMACAO DIGITAL - CARTA - CONVITE - (EXCLUSIVO CEJUSC - PRE-PROCESSUAL)",
                "PublishDate": "2023-07-26T00:00:00",
                "CaptureDate": "2023-08-19T17:06:48"
              },
              {
                "Content": "CARTA EXPEDIDA RECLAMACAO DIGITAL - CARTA - CONVITE - (EXCLUSIVO CEJUSC - PRE-PROCESSUAL)",
                "PublishDate": "2023-07-26T00:00:00",
                "CaptureDate": "2023-08-19T17:06:48"
              },
              {
                "Content": "CARTA EXPEDIDA RECLAMACAO DIGITAL - CARTA - CONVITE - (EXCLUSIVO CEJUSC - PRE-PROCESSUAL)",
                "PublishDate": "2023-07-26T00:00:00",
                "CaptureDate": "2023-08-19T17:06:48"
              },
              {
                "Content": "CARTA EXPEDIDA RECLAMACAO DIGITAL - CARTA - CONVITE - (EXCLUSIVO CEJUSC - PRE-PROCESSUAL)",
                "PublishDate": "2023-07-26T00:00:00",
                "CaptureDate": "2023-08-19T17:06:48"
              },
              {
                "Content": "DOCUMENTO JUNTADO",
                "PublishDate": "2023-07-26T00:00:00",
                "CaptureDate": "2023-08-19T17:06:48"
              },
              {
                "Content": "DISTRIBUIDO POR DIRECIONAMENTO (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-07-25T00:00:00",
                "CaptureDate": "2023-08-19T17:06:48"
              },
              {
                "Content": "DESIGNADA AUDIENCIA DE CONCILIACAO CONCILIACAO DATA: 15/09/2023 HORA 13:30 LOCAL: SALA DE AUDIENCIA 01 SITUACAO: PENDENTE",
                "PublishDate": "2023-07-25T00:00:00",
                "CaptureDate": "2023-08-19T17:06:48"
              },
              {
                "Content": "ATERMACAO EXPEDIDA TERMO DE AJUIZAMENTO - CEJUSC",
                "PublishDate": "2023-07-25T00:00:00",
                "CaptureDate": "2023-08-19T17:06:48"
              }
            ],
            "Petitions": [],
            "Decisions": []
          },
          {
            "Number": "10072514620238260099",
            "Type": "TUTELA",
            "MainSubject": "INDENIZACAO POR DANO MORAL",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "BRAGANCA PAULISTA",
            "Judge": "RODRIGO SETTE CARVALHO",
            "JudgingBody": "4 VARA CIVEL",
            "State": "SP",
            "Status": "INDEFINIDO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "INDENIZAÇÃO POR DANO MORAL",
            "InferredCNJSubjectNumber": 7779,
            "InferredCNJProcedureTypeName": "TUTELA CAUTELAR ANTECEDENTE",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "INDENIZACAO POR DANO MORAL",
              "BLOQUEIO / DESBLOQUEIO DE VALORES",
              "INDENIZACAO POR DANO MATERIAL",
              "LIMINAR"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 11000,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-08-04T00:00:00",
            "NoticeDate": "2023-08-01T00:00:00",
            "LastMovementDate": "2023-08-04T00:00:00",
            "CaptureDate": "2023-08-20T14:41:35",
            "LastUpdate": "2023-08-20T14:41:35",
            "NumberOfParties": 5,
            "NumberOfUpdates": 13,
            "LawSuitAge": 211,
            "AverageNumberOfUpdatesPerMonth": 1,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "26712795826",
                "IsPartyActive": true,
                "Name": "RODRIGO SETTE CARVALHO",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-08-20T14:41:35"
              },
              {
                "Doc": "40559967802",
                "IsPartyActive": true,
                "Name": "GIOVANI APARECIDO DE GODOY",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-08-20T14:41:35"
              },
              {
                "Doc": "40559967802",
                "IsPartyActive": true,
                "Name": "GIOVANI APARECIDO DE GODOY",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "431875",
                  "State": "SP",
                  "SpecificType": "ADVOGADO (REQTE)"
                },
                "LastCaptureDate": "2023-08-20T14:41:35"
              },
              {
                "Doc": "48472928000103",
                "IsPartyActive": true,
                "Name": "KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-08-20T14:41:35"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-08-20T14:41:35"
              }
            ],
            "Updates": [
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0648/2023 DATA DA PUBLICACAO: 07/08/2023 NUMERO DO DIARIO: 3793",
                "PublishDate": "2023-08-04T00:00:00",
                "CaptureDate": "2023-08-20T14:41:36"
              },
              {
                "Content": "PROCESSO 1007251-46.2023.8.26.0099 - TUTELA CAUTELAR ANTECEDENTE - INDENIZACAO POR DANO MORAL - GIOVANI APARECIDO DE GODOY - SENTENCA TRATA-SE DE ACAO PROPOSTA POR GIOVANI APARECIDO DE GODOY EM FACE DE KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA. E STARK BANK S.A., POR MEIO DA QUAL PRETENDE A CONDENACAO SOLIDARIA DA PARTE REQUERIDA: (I) A RESTITUICAO DA QUANTIA DE R$ 1.000,00 INVESTIDA EM PLATAFORMA DIGITAL; (II) AO PAGAMENTO DE INDENIZACAO POR DANOS MORAIS, NO IMPORTE DE R$ 11.300,00. MELHOR COMPULSANDO OS AUTOS E EM PESQUISA REALIZADA PELO SISTEMA SAJ, VERIFICA-SE QUE O LITIGIO ENTRE AS PARTES E OBJETO DE ACAO QUE TRAMITA PERANTE ESTE JUIZO (AUTOS N 1006079-69.2023), A QUAL FOI DISTRIBUIDA EM 29 DE JUNHO DE 2023, ANTERIOR A ESTE FEITO, SENDO QUE EM 27 DE JULHO DE 2023 FOI PROLATADA SENTENCA DE EXTINCAO DO PROCESSO, NOS TERMOS DO ARTIGO 485, INCISO I, DO CODIGO DE PROCESSO CIVIL, AINDA NAO TRANSITADA EM JULGADO. DESSE MODO, RECONHECO A LITISPENDENCIA, VISTO QUE O PEDIDO FORMULADO NA PRESENTE ACAO JA ESTA SOB ANALISE DESTE JUIZO. ANTE O EXPOSTO, JULGO EXTINTO O PRESENTE FEITO, SEM EXAME DO MERITO, NOS TERMOS DO ART. 485, V, DO CODIGO DE PROCESSO CIVIL. SEM CONDENACAO AO PAGAMENTO DAS CUSTAS E DESPESAS PROCESSUAIS. DEIXO DE CONDENAR EM HONORARIOS ADVOCATICIOS EM RAZAO DA NAO PARTICIPACAO DA PARTE CONTRARIA. COM O TRANSITO EM JULGADO, ARQUIVEM-SE OS AUTOS, COM AS CAUTELAS DE PRAXE. ALERTE-SE AS PARTES QUE EMBARGOS DECLARATORIOS NAO SE PRESTAM A REVISAO DE FATOS E PROVAS, NEM A IMPUGNACAO DA JUSTICA DA DECISAO, CABENDO SUA INTERPOSICAO NOS ESTREITOS LIMITES PREVISTOS NOS ARTIGOS 1.022 DO CPC.A INTERPOSICAO DE EMBARGOS DECLARATORIOS MERAMENTE PROTELATORIOS ENSEJARA A APLICACAO DE MULTA, NOS TERMOS DO ARTIGO 1.026,  2, DO CPC. E SERA CONSIDERADO ATO PROTELATORIO A INTERPOSICAO DE EMBARGOS PREQUESTIONADORES, ANTE O CARATER DEVOLUTIVO DO RECURSO DE APELACAO. NA HIPOTESE DE INTERPOSICAO DE RECURSO DE APELACAO, POR NAO HAVER MAIS JUIZO DE ADMISSIBILIDADE A SER EXERCIDO PELO JUIZO A QUO (ART. 1010 NCPC), SEM NOVA CONCLUSAO, INTIME-SE A PARTE CONTRARIA, CASO POSSUA ADVOGADO, PARA OFERECER RESPOSTA, NO PRAZO DE 15 DIAS. EM HAVENDO RECURSO ADESIVO, TAMBEM DEVE SER INTIMADA A PARTE CONTRARIA PARA OFERECER CONTRARRAZOES. APOS, REMETAM-SE OS AUTOS A SUPERIOR INSTANCIA, PARA APRECIACAO DO RECURSO DE APELACAO. ANTES DA REMESSA DOS AUTOS AO TRIBUNAL, DEVERA A SERVENTIA:A)INDICAR, OBRIGATORIAMENTE, NA CERTIDAO DE REMESSA, A INCLUSAO DE MIDIA(S), OU SUA EVENTUAL INEXISTENCIA;B) CERTIFICAR O VALOR DO PREPARO E A QUANTIA EFETIVAMENTE RECOLHIDA COM A VINCULACAO DA UTILIZACAO DO DOCUMENTO AO NUMERO DO PROCESSO, NOS TERMOS DO ART. 1093 DAS NSCGJ, DEIXANDO PARA APRECIACAO DA INSTANCIA SUPERIOR EVENTUAIS IRREGULARIDADES (ARTS. 102 E 1275 DAS NSGJ). PARA TANTO, DEVERA SER UTILIZADO O MODELO DE CERTIDAO DO SAJ 505792. INT. - ADV: GIOVANI APARECIDO DE GODOY (OAB 431875/SP)",
                "PublishDate": "2023-08-04T00:00:00",
                "CaptureDate": "2023-08-20T14:41:35"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0648/2023 TEOR DO ATO: SENTENCA TRATA-SE DE ACAO PROPOSTA POR GIOVANI APARECIDO DE GODOY EM FACE DE KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA. E STARK BANK S.A., POR MEIO DA QUAL PRETENDE A CONDENACAO SOLIDARIA DA PARTE REQUERIDA: (I) A RESTITUICAO DA QUANTIA DE R$ 1.000,00 INVESTIDA EM PLATAFORMA DIGITAL; (II) AO PAGAMENTO DE INDENIZACAO POR DANOS MORAIS, NO IMPORTE DE R$ 11.300,00. MELHOR COMPULSANDO OS AUTOS E EM PESQUISA REALIZADA PELO SISTEMA SAJ, VERIFICA-SE QUE O LITIGIO ENTRE AS PARTES E OBJETO DE ACAO QUE TRAMITA PERANTE ESTE JUIZO (AUTOS N 1006079-69.2023), A QUAL FOI DISTRIBUIDA EM 29 DE JUNHO DE 2023, ANTERIOR A ESTE FEITO, SENDO QUE EM 27 DE JULHO DE 2023 FOI PROLATADA SENTENCA DE EXTINCAO DO PROCESSO, NOS TERMOS DO ARTIGO 485, INCISO I, DO CODIGO DE PROCESSO CIVIL, AINDA NAO TRANSITADA EM JULGADO. DESSE MODO, RECONHECO A LITISPENDENCIA, VISTO QUE O PEDIDO FORMULADO NA PRESENTE ACAO JA ESTA SOB ANALISE DESTE JUIZO. ANTE O EXPOSTO, JULGO EXTINTO O PRESENTE FEITO, SEM EXAME DO MERITO, NOS TERMOS DO ART. 485, V, DO CODIGO DE PROCESSO CIVIL. SEM CONDENACAO AO PAGAMENTO DAS CUSTAS E DESPESAS PROCESSUAIS. DEIXO DE CONDENAR EM HONORARIOS ADVOCATICIOS EM RAZAO DA NAO PARTICIPACAO DA PARTE CONTRARIA. COM O TRANSITO EM JULGADO, ARQUIVEM-SE OS AUTOS, COM AS CAUTELAS DE PRAXE. ALERTE-SE AS PARTES QUE EMBARGOS DECLARATORIOS NAO SE PRESTAM A REVISAO DE FATOS E PROVAS, NEM A IMPUGNACAO DA JUSTICA DA DECISAO, CABENDO SUA INTERPOSICAO NOS ESTREITOS LIMITES PREVISTOS NOS ARTIGOS 1.022 DO CPC.A INTERPOSICAO DE EMBARGOS DECLARATORIOS MERAMENTE PROTELATORIOS ENSEJARA A APLICACAO DE MULTA, NOS TERMOS DO ARTIGO 1.026,  2, DO CPC. E SERA CONSIDERADO ATO PROTELATORIO A INTERPOSICAO DE EMBARGOS PREQUESTIONADORES, ANTE O CARATER DEVOLUTIVO DO RECURSO DE APELACAO. NA HIPOTESE DE INTERPOSICAO DE RECURSO DE APELACAO, POR NAO HAVER MAIS JUIZO DE ADMISSIBILIDADE A SER EXERCIDO PELO JUIZO \"A QUO\" (ART. 1010 NCPC), SEM NOVA CONCLUSAO, INTIME-SE A PARTE CONTRARIA, CASO POSSUA ADVOGADO, PARA OFERECER RESPOSTA, NO PRAZO DE 15 DIAS. EM HAVENDO RECURSO ADESIVO, TAMBEM DEVE SER INTIMADA A PARTE CONTRARIA PARA OFERECER CONTRARRAZOES. APOS, REMETAM-SE OS AUTOS A SUPERIOR INSTANCIA, PARA APRECIACAO DO RECURSO DE APELACAO. ANTES DA REMESSA DOS AUTOS AO TRIBUNAL, DEVERA A SERVENTIA:A)INDICAR, OBRIGATORIAMENTE, NA CERTIDAO DE REMESSA, A INCLUSAO DE MIDIA(S), OU SUA EVENTUAL INEXISTENCIA;B) CERTIFICAR O VALOR DO PREPARO E A QUANTIA EFETIVAMENTE RECOLHIDA COM A VINCULACAO DA UTILIZACAO DO DOCUMENTO AO NUMERO DO PROCESSO, NOS TERMOS DO ART. 1093 DAS NSCGJ, DEIXANDO PARA APRECIACAO DA INSTANCIA SUPERIOR EVENTUAIS IRREGULARIDADES (ARTS. 102 E 1275 DAS NSGJ). PARA TANTO, DEVERA SER UTILIZADO O MODELO DE CERTIDAO DO SAJ 505792. INT. ADVOGADOS(S): GIOVANI APARECIDO DE GODOY (OAB 431875/SP)",
                "PublishDate": "2023-08-03T00:00:00",
                "CaptureDate": "2023-08-20T14:41:36"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0645/2023 DATA DA PUBLICACAO: 04/08/2023 NUMERO DO DIARIO: 3792",
                "PublishDate": "2023-08-03T00:00:00",
                "CaptureDate": "2023-08-20T14:41:36"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2023-08-02T00:00:00",
                "CaptureDate": "2023-08-20T14:41:35"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0645/2023 TEOR DO ATO: TRATA-SE DE ACAO PROPOSTA POR GIOVANI APARECIDO DE GODOY EM FACE DE KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA. E STARK BANK S.A., POR MEIO DA QUAL PRETENDE A CONDENACAO SOLIDARIA DA PARTE REQUERIDA: (I) A RESTITUICAO DA QUANTIA DE R$ 1.000,00 INVESTIDA EM PLATAFORMA DIGITAL; (II) AO PAGAMENTO DE INDENIZACAO POR DANOS MORAIS, NO IMPORTE DE R$ 11.300,00. EM SINTESE, O REQUERENTE ALEGA QUE, EM 28 DE JUNHO DE 2023, RECEBEU MENSAGEM, VIA APLICATIVO WHATSAPP, DE UMA PESSOA QUE SE IDENTIFICOU COMO CAMILA, ESPECIALISTA EM RH DA EMPRESA KALRAY S.A., A QUAL LHE OFERECEU TRABALHO EM PLATAFORMA DIGITAL, CONSISTENTE EM AVALIACAO DE EMPRESAS A SER REALIZADA NO SITE DE BUSCA GOOGLE, MEDIANTE REMUNERACAO. O REQUERENTE ACEITOU O TRABALHO E FEZ ALGUMAS AVALIACOES, SENDO QUE OS PAGAMENTOS FORAM DEVIDAMENTE EFETUADOS, O QUE LHE TROUXE CREDIBILIDADE. PASSADA ESSA FASE, SURGIRAM TAREFAS PARA SEREM CUMPRIDAS, CONSISTENTES EM DEPOSITOS DE VALORES A SEREM REALIZADOS POR MEIO DO SITE HTTP://WWW.HAPVIP.TOP, SENDO QUE A QUANTIA INVESTIDA SERIA DEVOLVIDA COM UM ACRESCIMO DE 30% A 60%. NO INICIO, AS TRANSACOES OCORRERAM CORRETAMENTE, MAS, A PARTIR DA TAREFA DE NUMERO 15, CUJA OPCAO DE INVESTIMENTO ESCOLHIDA PELO REQUERENTE FOI DE R$ 1.000,00 (FLS. 41/50), NAO HOUVE O RETORNO PROMETIDO DE R$ 1.600,00, O QUAL FICOU CONDICIONADO AO DEPOSITO DE MAIS R$ 3.600,00, SEM O QUE A TAREFA NAO SERIA CONCLUIDA E O VALOR NAO LHE SERIA REEMBOLSADO. O DEPOSITO FOI EFETUADO PELO REQUERENTE EM FAVOR DA EMPRESA KENDO, PRIMEIRA REQUERIDA, EM CONTA MANTIDA PERANTE A INSTITUICAO BANCARIA STARK BANK S.A, SEGUNDA REQUERIDA (FL. 10). SOMENTE NESSE MOMENTO, O REQUERENTE SE DEU CONTA DE QUE SE TRATAVA DE GOLPE, NAO CONSEGUINDO CONTATO COM A INSTITUICAO FINANCEIRA REQUERIDA. FORMULOU PEDIDO DE TUTELA ANTECIPADA PARA BLOQUEIO TOTAL DAS CONTAS BANCARIAS DA PARTE REQUERIDA E, SUBSIDIARIAMENTE, O BLOQUEIO DA QUANTIA DE R$ 11.000,00 OU, AINDA, DA QUANTIA DE R$ 1.000,00, A FIM DE GARANTIR A DEVOLUCAO DO VALOR DEPOSITADO. FORAM JUNTADOS PRINTS DAS CONVERSAS ENTABULADAS ENTRE O REQUERENTE E A REPRESENTANTE DA PRIMEIRA REQUERIDA, VIA WHATSAPP, NA QUAL CONSTAM AS NEGOCIACOES (FLS. 20/50), BEM COMO DE ALGUNS REGISTROS NO SITE \"RECLAME AQUI\" COM RELACAO A EMPRESA REQUERIDA (FLS. 51/52). OBSERVA-SE QUE O REQUERENTE TROUXE COPIA DE SUA CARTEIRA DE TRABALHO (FLS. 12/15) E DAS FATURAS DE CARTAO DE CREDITO DOS MESES DE FEVEREIRO A JUNHO DE 2023 (FLS. 59/82). ANOTE-SE O ENDERECO ELETRONICO E O NUMERO DO WHATSAPP DO REQUERENTE, INDICADOS NA PETICAO INICIAL (FL. 1). NO PRAZO DE 15 (QUINZE) DIAS, EMENDE-SE A PETICAO INICIAL, A FIM DE: 1) INFORMAR A RENDA MENSAL FAMILIAR, AINDA QUE PROVENIENTE DE TRABALHO INFORMAL, COM O OBJETIVO DE APRECIAR A JUSTICA GRATUITA, APRESENTANDO: A) A FATURA DE CARTAO DE CREDITO DO REQUERENTE DO MES DE JULHO DE 2023; B) EXTRATOS BANCARIOS DO REQUERENTE DE TODAS AS SUAS CONTAS, ESPECIALMENTE DA MANTIDA PERANTE A INSTITUICAO FINANCEIRA NUBANK, DOS ULTIMOS TRES MESES; C) APRESENTAR DECLARACAO DE HIPOSSUFICIENCIA FINANCEIRA, DEVIDAMENTE ASSINADA; 2) RETIFICAR O VALOR DA CAUSA, O QUAL DEVE CORRESPONDER AO PROVEITO ECONOMICO A SER OBTIDO OU SEJA, A SOMA DO VALOR A SER RESSARCIDO MAIS A QUANTIA QUE PRETENDE RECEBER A TITULO DE INDENIZACAO POR DANOS MORAIS (R$ 1.000,00 R$ 11.300,00 = R$ 12.300,00); 3) FORNECER O ENDERECO ELETRONICO DA PARTE CONTRARIA, REQUISITO DA PETICAO INICIAL (ART. 319, II, CPC), BEM COMO OS NUMEROS DE WHATSAPP, A FIM DE POSSIBILITAR A CITACAO/INTIMACAO POR ESSA MODALIDADE DE COMUNICACAO (ART. 270, CPC). COM A VINDA DOS E-MAILS E NUMEROS DE WHATSAPP, ANOTE-SE, FICANDO DISPENSADA NOVA CONCLUSAO. COM A EMENDA OU DECORRIDO O PRAZO EM SILENCIO, O QUE DEVERA SER CERTIFICADO PELO CARTORIO, VOLTEM CONCLUSOS. INT. ADVOGADOS(S): GIOVANI APARECIDO DE GODOY (OAB 431875/SP)",
                "PublishDate": "2023-08-02T00:00:00",
                "CaptureDate": "2023-08-20T14:41:35"
              },
              {
                "Content": "CONCLUSOS PARA SENTENCA",
                "PublishDate": "2023-08-02T00:00:00",
                "CaptureDate": "2023-08-20T14:41:36"
              },
              {
                "Content": "EXTINTO O PROCESSO SEM RESOLUCAO DO MERITO POR PEREMPCAO, LITISPENDENCIA OU COISA JULGADA SENTENCA TRATA-SE DE ACAO PROPOSTA POR GIOVANI APARECIDO DE GODOY EM FACE DE KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA. E STARK BANK S.A., POR MEIO DA QUAL PRETENDE A CONDENACAO SOLIDARIA DA PARTE REQUERIDA: (I) A RESTITUICAO DA QUANTIA DE R$ 1.000,00 INVESTIDA EM PLATAFORMA DIGITAL; (II) AO PAGAMENTO DE INDENIZACAO POR DANOS MORAIS, NO IMPORTE DE R$ 11.300,00. MELHOR COMPULSANDO OS AUTOS E EM PESQUISA REALIZADA PELO SISTEMA SAJ, VERIFICA-SE QUE O LITIGIO ENTRE AS PARTES E OBJETO DE ACAO QUE TRAMITA PERANTE ESTE JUIZO (AUTOS N 1006079-69.2023), A QUAL FOI DISTRIBUIDA EM 29 DE JUNHO DE 2023, ANTERIOR A ESTE FEITO, SENDO QUE EM 27 DE JULHO DE 2023 FOI PROLATADA SENTENCA DE EXTINCAO DO PROCESSO, NOS TERMOS DO ARTIGO 485, INCISO I, DO CODIGO DE PROCESSO CIVIL, AINDA NAO TRANSITADA EM JULGADO. DESSE MODO, RECONHECO A LITISPENDENCIA, VISTO QUE O PEDIDO FORMULADO NA PRESENTE ACAO JA ESTA SOB ANALISE DESTE JUIZO. ANTE O EXPOSTO, JULGO EXTINTO O PRESENTE FEITO, SEM EXAME DO MERITO, NOS TERMOS DO ART. 485, V, DO CODIGO DE PROCESSO CIVIL. SEM CONDENACAO AO PAGAMENTO DAS CUSTAS E DESPESAS PROCESSUAIS. DEIXO DE CONDENAR EM HONORARIOS ADVOCATICIOS EM RAZAO DA NAO PARTICIPACAO DA PARTE CONTRARIA. COM O TRANSITO EM JULGADO, ARQUIVEM-SE OS AUTOS, COM AS CAUTELAS DE PRAXE. ALERTE-SE AS PARTES QUE EMBARGOS DECLARATORIOS NAO SE PRESTAM A REVISAO DE FATOS E PROVAS, NEM A IMPUGNACAO DA JUSTICA DA DECISAO, CABENDO SUA INTERPOSICAO NOS ESTREITOS LIMITES PREVISTOS NOS ARTIGOS 1.022 DO CPC.A INTERPOSICAO DE EMBARGOS DECLARATORIOS MERAMENTE PROTELATORIOS ENSEJARA A APLICACAO DE MULTA, NOS TERMOS DO ARTIGO 1.026,  2, DO CPC. E SERA CONSIDERADO ATO PROTELATORIO A INTERPOSICAO DE EMBARGOS PREQUESTIONADORES, ANTE O CARATER DEVOLUTIVO DO RECURSO DE APELACAO. NA HIPOTESE DE INTERPOSICAO DE RECURSO DE APELACAO, POR NAO HAVER MAIS JUIZO DE ADMISSIBILIDADE A SER EXERCIDO PELO JUIZO \"A QUO\" (ART. 1010 NCPC), SEM NOVA CONCLUSAO, INTIME-SE A PARTE CONTRARIA, CASO POSSUA ADVOGADO, PARA OFERECER RESPOSTA, NO PRAZO DE 15 DIAS. EM HAVENDO RECURSO ADESIVO, TAMBEM DEVE SER INTIMADA A PARTE CONTRARIA PARA OFERECER CONTRARRAZOES. APOS, REMETAM-SE OS AUTOS A SUPERIOR INSTANCIA, PARA APRECIACAO DO RECURSO DE APELACAO. ANTES DA REMESSA DOS AUTOS AO TRIBUNAL, DEVERA A SERVENTIA:A)INDICAR, OBRIGATORIAMENTE, NA CERTIDAO DE REMESSA, A INCLUSAO DE MIDIA(S), OU SUA EVENTUAL INEXISTENCIA;B) CERTIFICAR O VALOR DO PREPARO E A QUANTIA EFETIVAMENTE RECOLHIDA COM A VINCULACAO DA UTILIZACAO DO DOCUMENTO AO NUMERO DO PROCESSO, NOS TERMOS DO ART. 1093 DAS NSCGJ, DEIXANDO PARA APRECIACAO DA INSTANCIA SUPERIOR EVENTUAIS IRREGULARIDADES (ARTS. 102 E 1275 DAS NSGJ). PARA TANTO, DEVERA SER UTILIZADO O MODELO DE CERTIDAO DO SAJ 505792. INT.",
                "PublishDate": "2023-08-02T00:00:00",
                "CaptureDate": "2023-08-20T14:41:36"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-08-01T00:00:00",
                "CaptureDate": "2023-08-20T14:41:35"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2023-08-01T00:00:00",
                "CaptureDate": "2023-08-20T14:41:35"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2023-08-01T00:00:00",
                "CaptureDate": "2023-08-20T14:41:35"
              },
              {
                "Content": "PROFERIDAS OUTRAS DECISOES NAO ESPECIFICADAS TRATA-SE DE ACAO PROPOSTA POR GIOVANI APARECIDO DE GODOY EM FACE DE KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA. E STARK BANK S.A., POR MEIO DA QUAL PRETENDE A CONDENACAO SOLIDARIA DA PARTE REQUERIDA: (I) A RESTITUICAO DA QUANTIA DE R$ 1.000,00 INVESTIDA EM PLATAFORMA DIGITAL; (II) AO PAGAMENTO DE INDENIZACAO POR DANOS MORAIS, NO IMPORTE DE R$ 11.300,00. EM SINTESE, O REQUERENTE ALEGA QUE, EM 28 DE JUNHO DE 2023, RECEBEU MENSAGEM, VIA APLICATIVO WHATSAPP, DE UMA PESSOA QUE SE IDENTIFICOU COMO CAMILA, ESPECIALISTA EM RH DA EMPRESA KALRAY S.A., A QUAL LHE OFERECEU TRABALHO EM PLATAFORMA DIGITAL, CONSISTENTE EM AVALIACAO DE EMPRESAS A SER REALIZADA NO SITE DE BUSCA GOOGLE, MEDIANTE REMUNERACAO. O REQUERENTE ACEITOU O TRABALHO E FEZ ALGUMAS AVALIACOES, SENDO QUE OS PAGAMENTOS FORAM DEVIDAMENTE EFETUADOS, O QUE LHE TROUXE CREDIBILIDADE. PASSADA ESSA FASE, SURGIRAM TAREFAS PARA SEREM CUMPRIDAS, CONSISTENTES EM DEPOSITOS DE VALORES A SEREM REALIZADOS POR MEIO DO SITE HTTP://WWW.HAPVIP.TOP, SENDO QUE A QUANTIA INVESTIDA SERIA DEVOLVIDA COM UM ACRESCIMO DE 30% A 60%. NO INICIO, AS TRANSACOES OCORRERAM CORRETAMENTE, MAS, A PARTIR DA TAREFA DE NUMERO 15, CUJA OPCAO DE INVESTIMENTO ESCOLHIDA PELO REQUERENTE FOI DE R$ 1.000,00 (FLS. 41/50), NAO HOUVE O RETORNO PROMETIDO DE R$ 1.600,00, O QUAL FICOU CONDICIONADO AO DEPOSITO DE MAIS R$ 3.600,00, SEM O QUE A TAREFA NAO SERIA CONCLUIDA E O VALOR NAO LHE SERIA REEMBOLSADO. O DEPOSITO FOI EFETUADO PELO REQUERENTE EM FAVOR DA EMPRESA KENDO, PRIMEIRA REQUERIDA, EM CONTA MANTIDA PERANTE A INSTITUICAO BANCARIA STARK BANK S.A, SEGUNDA REQUERIDA (FL. 10). SOMENTE NESSE MOMENTO, O REQUERENTE SE DEU CONTA DE QUE SE TRATAVA DE GOLPE, NAO CONSEGUINDO CONTATO COM A INSTITUICAO FINANCEIRA REQUERIDA. FORMULOU PEDIDO DE TUTELA ANTECIPADA PARA BLOQUEIO TOTAL DAS CONTAS BANCARIAS DA PARTE REQUERIDA E, SUBSIDIARIAMENTE, O BLOQUEIO DA QUANTIA DE R$ 11.000,00 OU, AINDA, DA QUANTIA DE R$ 1.000,00, A FIM DE GARANTIR A DEVOLUCAO DO VALOR DEPOSITADO. FORAM JUNTADOS PRINTS DAS CONVERSAS ENTABULADAS ENTRE O REQUERENTE E A REPRESENTANTE DA PRIMEIRA REQUERIDA, VIA WHATSAPP, NA QUAL CONSTAM AS NEGOCIACOES (FLS. 20/50), BEM COMO DE ALGUNS REGISTROS NO SITE \"RECLAME AQUI\" COM RELACAO A EMPRESA REQUERIDA (FLS. 51/52). OBSERVA-SE QUE O REQUERENTE TROUXE COPIA DE SUA CARTEIRA DE TRABALHO (FLS. 12/15) E DAS FATURAS DE CARTAO DE CREDITO DOS MESES DE FEVEREIRO A JUNHO DE 2023 (FLS. 59/82). ANOTE-SE O ENDERECO ELETRONICO E O NUMERO DO WHATSAPP DO REQUERENTE, INDICADOS NA PETICAO INICIAL (FL. 1). NO PRAZO DE 15 (QUINZE) DIAS, EMENDE-SE A PETICAO INICIAL, A FIM DE: 1) INFORMAR A RENDA MENSAL FAMILIAR, AINDA QUE PROVENIENTE DE TRABALHO INFORMAL, COM O OBJETIVO DE APRECIAR A JUSTICA GRATUITA, APRESENTANDO: A) A FATURA DE CARTAO DE CREDITO DO REQUERENTE DO MES DE JULHO DE 2023; B) EXTRATOS BANCARIOS DO REQUERENTE DE TODAS AS SUAS CONTAS, ESPECIALMENTE DA MANTIDA PERANTE A INSTITUICAO FINANCEIRA NUBANK, DOS ULTIMOS TRES MESES; C) APRESENTAR DECLARACAO DE HIPOSSUFICIENCIA FINANCEIRA, DEVIDAMENTE ASSINADA; 2) RETIFICAR O VALOR DA CAUSA, O QUAL DEVE CORRESPONDER AO PROVEITO ECONOMICO A SER OBTIDO OU SEJA, A SOMA DO VALOR A SER RESSARCIDO MAIS A QUANTIA QUE PRETENDE RECEBER A TITULO DE INDENIZACAO POR DANOS MORAIS (R$ 1.000,00 R$ 11.300,00 = R$ 12.300,00); 3) FORNECER O ENDERECO ELETRONICO DA PARTE CONTRARIA, REQUISITO DA PETICAO INICIAL (ART. 319, II, CPC), BEM COMO OS NUMEROS DE WHATSAPP, A FIM DE POSSIBILITAR A CITACAO/INTIMACAO POR ESSA MODALIDADE DE COMUNICACAO (ART. 270, CPC). COM A VINDA DOS E-MAILS E NUMEROS DE WHATSAPP, ANOTE-SE, FICANDO DISPENSADA NOVA CONCLUSAO. COM A EMENDA OU DECORRIDO O PRAZO EM SILENCIO, O QUE DEVERA SER CERTIFICADO PELO CARTORIO, VOLTEM CONCLUSOS. INT.",
                "PublishDate": "2023-08-01T00:00:00",
                "CaptureDate": "2023-08-20T14:41:35"
              },
              {
                "Content": "EMENDA A INICIAL JUNTADA N PROTOCOLO: WBGP.23.70101977-0 TIPO DA PETICAO: EMENDA A INICIAL DATA: 01/08/2023 18:11",
                "PublishDate": "2023-08-01T00:00:00",
                "CaptureDate": "2023-08-20T14:41:35"
              }
            ],
            "Petitions": [
              {
                "Type": "EMENDA A INICIAL",
                "Author": "",
                "CreationDate": "2023-08-01T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              }
            ],
            "Decisions": [
              {
                "DecisionContent": "JULGO EXTINTO O PRESENTE FEITO, SEM EXAME DO MERITO, NOS TERMOS DO ART. 485, V, DO CODIGO DE PROCESSO CIVIL.",
                "DecisionDate": "2023-08-04T00:00:00"
              },
              {
                "DecisionContent": "JULGO EXTINTO O PRESENTE FEITO, SEM EXAME DO MERITO, NOS TERMOS DO ART. 485, V, DO CODIGO DE PROCESSO CIVIL.",
                "DecisionDate": "2023-08-03T00:00:00"
              },
              {
                "DecisionContent": "JULGO EXTINTO O PRESENTE FEITO, SEM EXAME DO MERITO, NOS TERMOS DO ART. 485, V, DO CODIGO DE PROCESSO CIVIL.",
                "DecisionDate": "2023-08-02T00:00:00"
              }
            ]
          },
          {
            "Number": "00142895320238260576",
            "Type": "PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL",
            "MainSubject": "RESCISAO DO CONTRATO E DEVOLUCAO DO DINHEIRO",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "ESPECIAL CIVEL",
            "CourtDistrict": "SAO JOSE DO RIO PRETO",
            "Judge": "EDUARDO GARCIA ALBUQUERQUE",
            "JudgingBody": "VARA DO JUIZADO ESPECIAL CIVEL",
            "State": "SP",
            "Status": "INDEFINIDO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "RESCISÃO DO CONTRATO E DEVOLUÇÃO DO DINHEIRO",
            "InferredCNJSubjectNumber": 7768,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO DO JUIZADO ESPECIAL CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "RESCISAO DO CONTRATO E DEVOLUCAO DO DINHEIRO"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 97.98,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-09-05T00:00:00",
            "NoticeDate": "2023-09-01T00:00:00",
            "LastMovementDate": "2023-09-05T00:00:00",
            "CaptureDate": "2023-09-06T03:16:01",
            "LastUpdate": "2023-09-06T03:16:01",
            "NumberOfParties": 4,
            "NumberOfUpdates": 8,
            "LawSuitAge": 180,
            "AverageNumberOfUpdatesPerMonth": 1,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "22396434802",
                "IsPartyActive": true,
                "Name": "EDUARDO GARCIA ALBUQUERQUE",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-09-06T03:16:01"
              },
              {
                "IsPartyActive": true,
                "Name": "LUIZ ANTONIO DE MIRANDA",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-09-06T03:16:01"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-09-06T03:16:01"
              },
              {
                "IsPartyActive": true,
                "Name": "ISTPAY SERVICOS DE PAGAMENTO E GESTAO FINANCEIRA LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-09-06T03:16:01"
              }
            ],
            "Updates": [
              {
                "Content": "PROCESSO : 0014289-53.2023.8.26.0576 CLASSE : PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL REQTE : LUIZ ANTONIO DE MIRANDA REQDO : STARK BANK S.A. VARA : VARA DO JUIZADO ESPECIAL CIVEL",
                "PublishDate": "2023-09-05T00:00:00",
                "CaptureDate": "2023-09-06T03:16:01"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-09-01T00:00:00",
                "CaptureDate": "2023-09-06T03:16:01"
              },
              {
                "Content": "ATERMACAO EXPEDIDA TERMO DE AJUIZAMENTO - GERAL - JUIZADO",
                "PublishDate": "2023-09-01T00:00:00",
                "CaptureDate": "2023-09-06T03:16:02"
              },
              {
                "Content": "AJUIZAMENTO DIGITALIZADO",
                "PublishDate": "2023-09-01T00:00:00",
                "CaptureDate": "2023-09-06T03:16:02"
              },
              {
                "Content": "DOCUMENTO JUNTADO",
                "PublishDate": "2023-09-01T00:00:00",
                "CaptureDate": "2023-09-06T03:16:02"
              },
              {
                "Content": "RECIBO JUNTADO",
                "PublishDate": "2023-09-01T00:00:00",
                "CaptureDate": "2023-09-06T03:16:02"
              },
              {
                "Content": "CARTA DE CITACAO EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO E INTIMACAO - APRESENTAR DEFESA ESCRITA - SEM AUDIENCIA - JUIZADO",
                "PublishDate": "2023-09-01T00:00:00",
                "CaptureDate": "2023-09-06T03:16:02"
              },
              {
                "Content": "CARTA DE CITACAO EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO E INTIMACAO - APRESENTAR DEFESA ESCRITA - SEM AUDIENCIA - JUIZADO",
                "PublishDate": "2023-09-01T00:00:00",
                "CaptureDate": "2023-09-06T03:16:02"
              }
            ],
            "Petitions": [],
            "Decisions": []
          },
          {
            "Number": "10426578320238260114",
            "Type": "PROCEDIMENTO COMUM",
            "MainSubject": "PRATICAS ABUSIVAS",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "CAMPINAS",
            "Judge": "PAULO CESAR BATISTA DOS SANTOS",
            "JudgingBody": "5 VARA CIVEL",
            "State": "SP",
            "Status": "INDEFINIDO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "PRÁTICAS ABUSIVAS",
            "InferredCNJSubjectNumber": 11811,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "PRATICAS ABUSIVAS",
              "INDENIZACAO POR DANO MATERIAL",
              "INDENIZACAO POR DANO MORAL",
              "RESCISAO DO CONTRATO E DEVOLUCAO DO DINHEIRO",
              "RESPONSABILIDADE DO FORNECEDOR"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 73343.2,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-09-19T00:00:00",
            "NoticeDate": "2023-09-16T00:00:00",
            "LastMovementDate": "2023-09-19T00:00:00",
            "CaptureDate": "2023-09-20T04:15:38",
            "LastUpdate": "2023-09-20T04:15:38",
            "NumberOfParties": 25,
            "NumberOfUpdates": 3,
            "LawSuitAge": 165,
            "AverageNumberOfUpdatesPerMonth": 0,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "IsPartyActive": true,
                "Name": "PAULO CESAR BATISTA DOS SANTOS",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-09-20T04:15:38"
              },
              {
                "IsPartyActive": true,
                "Name": "SAFIRA LIMA DA SILVA",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-09-20T04:15:38"
              },
              {
                "Doc": "12651292826",
                "IsPartyActive": true,
                "Name": "ROSANA ANTONIACCI PLATERO",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "SpecificType": "ADVOGADA (REQTE)"
                },
                "LastCaptureDate": "2023-09-20T04:15:38"
              },
              {
                "Doc": "10341411000102",
                "IsPartyActive": true,
                "Name": "BANCO SANTANDER S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-09-20T04:15:38"
              },
              {
                "IsPartyActive": true,
                "Name": "NUBANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-09-20T04:15:38"
              },
              {
                "IsPartyActive": true,
                "Name": "NU FINANCEIRA S A SOCIEDADE DE CREDITO, FINANCIAMENTO E INVESTIMENTO",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-09-20T04:15:38"
              },
              {
                "Doc": "00416968000101",
                "IsPartyActive": true,
                "Name": "BANCO INTER S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-09-20T04:15:38"
              },
              {
                "Doc": "59285411000113",
                "IsPartyActive": true,
                "Name": "BANCO PAN S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-09-20T04:15:38"
              },
              {
                "IsPartyActive": true,
                "Name": "PANAMERICANO ARRENDAMENTO MERCANTIL S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-09-20T04:15:38"
              },
              {
                "IsPartyActive": true,
                "Name": "RECARGAPAY PAGAMENTOS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-09-20T04:15:38"
              },
              {
                "Doc": "22896431000110",
                "IsPartyActive": true,
                "Name": "PIC PAY INSTITUICAO DE PAGAMENTO S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-09-20T04:15:38"
              },
              {
                "Doc": "48689840000130",
                "IsPartyActive": true,
                "Name": "CASH PAY MEIOS DE PAGAMENTO LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-09-20T04:15:38"
              },
              {
                "Doc": "48472928000103",
                "IsPartyActive": true,
                "Name": "KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-09-20T04:15:38"
              },
              {
                "Doc": "35624319000172",
                "IsPartyActive": true,
                "Name": "MK DIGITAL BANK INSTITUICAO DE PAGAMENTO S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-09-20T04:15:38"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-09-20T04:15:38"
              },
              {
                "IsPartyActive": true,
                "Name": "LATAM TECNOLOGIA EIRELI",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-09-20T04:15:38"
              },
              {
                "IsPartyActive": true,
                "Name": "FITBANK PAGAMENTOS E S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-09-20T04:15:38"
              },
              {
                "Doc": "03751794000113",
                "IsPartyActive": true,
                "Name": "TERRA INVESTIMENTOS DISTRIBUIDORA DE TITULOS E VALORES MOBILIARIOS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-09-20T04:15:38"
              },
              {
                "Doc": "13347016000117",
                "IsPartyActive": true,
                "Name": "FACEBOOK SERVICOS ONLINE DO BRASIL LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-09-20T04:15:38"
              },
              {
                "Doc": "09637176000123",
                "IsPartyActive": true,
                "Name": "LEONARDI SOCIEDADE DE ADVOGADOS",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-09-20T04:15:38"
              },
              {
                "Doc": "30027416801",
                "IsPartyActive": true,
                "Name": "JULIANO CESAR PERINA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-09-20T04:15:38"
              },
              {
                "IsPartyActive": true,
                "Name": "ADRIANO DE JESUS SANTOS",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-09-20T04:15:38"
              },
              {
                "IsPartyActive": true,
                "Name": "PATRICIA RAMOS PINTO",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-09-20T04:15:38"
              },
              {
                "Doc": "31407671880",
                "IsPartyActive": true,
                "Name": "ELY OSMAR ALVES DA SILVA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-09-20T04:15:38"
              },
              {
                "IsPartyActive": true,
                "Name": "PGSEGURO INTERNET S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-09-20T04:15:38"
              }
            ],
            "Updates": [
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2023-09-19T00:00:00",
                "CaptureDate": "2023-09-20T04:15:39"
              },
              {
                "Content": "PROCESSO : 1042657-83.2023.8.26.0114 CLASSE : PROCEDIMENTO COMUM CIVEL REQTE : SAFIRA LIMA DA SILVA ADVOGADO : 189344/SP - ROSANA ANTONIACCI PLATERO REQDO : ELY OSMAR ALVES DA SILVA VARA : 5 VARA CIVEL",
                "PublishDate": "2023-09-19T00:00:00",
                "CaptureDate": "2023-09-20T04:15:38"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-09-16T00:00:00",
                "CaptureDate": "2023-09-20T04:15:39"
              }
            ],
            "Petitions": [],
            "Decisions": []
          },
          {
            "Number": "10105689020238260248",
            "Type": "PROCEDIMENTO COMUM",
            "MainSubject": "BANCARIOS",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "INDAIATUBA",
            "Judge": "LUIZ FELIPE VALENTE DA SILVA REHFELDT",
            "JudgingBody": "3 VARA CIVEL",
            "State": "SP",
            "Status": "ATIVO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "BANCÁRIOS",
            "InferredCNJSubjectNumber": 7752,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "BANCARIOS"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 77934,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-09-20T00:00:00",
            "NoticeDate": "2023-09-18T00:00:00",
            "LastMovementDate": "2023-09-20T00:00:00",
            "CaptureDate": "2023-09-21T02:26:22",
            "LastUpdate": "2023-09-21T02:26:22",
            "NumberOfParties": 6,
            "NumberOfUpdates": 12,
            "LawSuitAge": 163,
            "AverageNumberOfUpdatesPerMonth": 2,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "11199459763",
                "IsPartyActive": true,
                "Name": "LUIZ FELIPE VALENTE DA SILVA REHFELDT",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-09-21T02:26:22"
              },
              {
                "Doc": "08739599736",
                "IsPartyActive": true,
                "Name": "LUANA SARDINHA FERREIRA",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-09-21T02:26:22"
              },
              {
                "Doc": "08739599736",
                "IsPartyActive": true,
                "Name": "LUANA SARDINHA FERREIRA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "141316",
                  "State": "RJ",
                  "SpecificType": "ADVOGADA (REQTE)"
                },
                "LastCaptureDate": "2023-09-21T02:26:22"
              },
              {
                "Doc": "48689840000130",
                "IsPartyActive": true,
                "Name": "CASH PAY MEIOS DE PAGAMENTO LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-09-21T02:26:22"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-09-21T02:26:22"
              },
              {
                "Doc": "35068411817",
                "IsPartyActive": true,
                "Name": "RAFAEL HIDEO NAZIMA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "SpecificType": "ADVOGADO (REQDO)"
                },
                "LastCaptureDate": "2023-09-21T02:26:22"
              }
            ],
            "Updates": [
              {
                "Content": "PEDIDO DE LIMINAR/TUTELA ANTECIPADA JUNTADO N PROTOCOLO: WIDU.23.70125619-5 TIPO DA PETICAO: PEDIDO DE LIMINAR/ANTECIPACAO DE TUTELA DATA: 20/09/2023 04:16",
                "PublishDate": "2023-09-20T00:00:00",
                "CaptureDate": "2023-09-21T02:26:22"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0782/2023 DATA DA PUBLICACAO: 21/09/2023 NUMERO DO DIARIO: 3824",
                "PublishDate": "2023-09-20T00:00:00",
                "CaptureDate": "2023-09-21T02:26:22"
              },
              {
                "Content": "DOCUMENTO JUNTADO",
                "PublishDate": "2023-09-20T00:00:00",
                "CaptureDate": "2023-09-21T02:26:22"
              },
              {
                "Content": "DOCUMENTO JUNTADO",
                "PublishDate": "2023-09-20T00:00:00",
                "CaptureDate": "2023-09-21T02:26:22"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2023-09-20T00:00:00",
                "CaptureDate": "2023-09-21T02:26:22"
              },
              {
                "Content": "PROCESSO : 1010568-90.2023.8.26.0248 CLASSE : PROCEDIMENTO COMUM CIVEL REQTE : LUANA SARDINHA FERREIRA ADVOGADO : 141316/RJ - LUANA SARDINHA FERREIRA REQDO : STARK BANK S.A. VARA : 3 VARA CIVEL PROCESSO 1010568-90.2023.8.26.0248 - PROCEDIMENTO COMUM CIVEL - BANCARIOS - LUANA SARDINHA FERREIRA - DEFIRO OS BENEFICIOS DA JG A PARTE AUTORA. ANOTE-SE. ANALISANDO A INICIAL E OS DOCUMENTOS QUE A ACOMPANHAM, VERIFICO PRESENTES ELEMENTOS PROBATORIOS APTOS A DEMONSTRAR, INITIO LITIS, A PRESENCA DOS PRESSUPOSTOS PROCESSUAIS PREVISTOS NO ART. 300 DO CPC, O QUE AUTORIZA O DEFERIMENTO DA TUTELA DE URGENCIA ALMEJADA. OS DOCUMENTOS TRAZIDOS DEMONSTRAM QUE A PARTE AUTORA, NOS TERMOS EM QUE DESCRITO NA INICIAL, ACABOU SUCUMBINDO AO ENGODO DESCRITO E TRANSFERINDO NUMERARIOS AO REQUERIDO. OS PRINTS DE CONVERSAS E OS COMPROVANTES DE PAGAMENTOS IGUALMENTE COMPROVAM O DESCRITO E OS VALORES DESPENDIDOS. DESTA FORMA, DEFIRO A TUTELA DE URGENCIA REQUERIDA PARA O FIM DE DETERMINAR QUE ESTA ZELOSA SERVENTIA PROCEDA AO ARRESTO, VIA SISBAJUD, NAS CONTAS DE TITULARIDADE DE STARK BANK S.A, CNPJ 20.018.183/0001-80 E CASH PAY MEIOS DE PAGAMENTO LTDA, CNPJ 48.689.840/0001-30, NOS VALORES DE R$ 28.844,00 (VINTE E OITO MIL OITOCENTOS E QUARENTA E QUATRO REAIS) E 49.090,00 (QUARENTA E NOVE MIL E NOVENTA REAIS), RESPECTIVAMENTE. DIANTE DAS ESPECIFICIDADES DA CAUSA E DE MODO A ADEQUAR O RITO PROCESSUAL AS NECESSIDADES DO CONFLITO, DEIXO PARA MOMENTO OPORTUNO A ANALISE DA CONVENIENCIA DA AUDIENCIA DE CONCILIACAO. (CPC, ART.139, VI E ENUNCIADO N.35 DA ENFAM). CITE-SE E INTIME-SE A PARTE RE PARA CONTESTAR O FEITO NO PRAZO DE 15 (QUINZE) DIAS UTEIS. A AUSENCIA DE CONTESTACAO IMPLICARA REVELIA E PRESUNCAO DE VERACIDADE DA MATERIA FATICA APRESENTADA NA PETICAO INICIAL. A PRESENTE CITACAO E ACOMPANHADA DE SENHA PARA ACESSO AO PROCESSO DIGITAL, QUE CONTEM A INTEGRA DA PETICAO INICIAL E DOS DOCUMENTOS. TRATANDO-SE DE PROCESSO ELETRONICO, EM PRESTIGIO AS REGRAS FUNDAMENTAIS DOS ARTIGOS 4 E 6 DO CPC FICA VEDADO O EXERCICIO DA FACULDADE PREVISTA NO ARTIGO 340 DO CPC. OBSERVO QUE A CORRETA CLASSIFICACAO DO DOCUMENTO QUANDO DO PETICIONAMENTO ELETRONICO CONFERE MAIOR AGILIDADE NA SUA IDENTIFICACAO NO FLUXO DE TRABALHO, CABENDO AO ADVOGADO CADASTRAR A PETICAO COM O TIPO APROPRIADO (38001 CONTESTACAO OU 7848 CONTESTACAO COM RECONVENCAO). SERVIRA O PRESENTE, POR COPIA DIGITADA, COMO MANDADO/CARTA/OFICIO, INCLUSIVE PARA SER ENVIADO A PARTE RE PELA PARTE AUTORA PARA FINS DE CIENCIA E CUMPRIMENTO DA PRESENTE DECISAO. CUMPRA-SE NA FORMA E SOB AS PENAS DA LEI. INTIMEM-SE. - ADV: LUANA SARDINHA FERREIRA (OAB 141316/RJ)",
                "PublishDate": "2023-09-20T00:00:00",
                "CaptureDate": "2023-09-21T02:26:22"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0782/2023 TEOR DO ATO: DEFIRO OS BENEFICIOS DA JG A PARTE AUTORA. ANOTE-SE. ANALISANDO A INICIAL E OS DOCUMENTOS QUE A ACOMPANHAM, VERIFICO PRESENTES ELEMENTOS PROBATORIOS APTOS A DEMONSTRAR, INITIO LITIS, A PRESENCA DOS PRESSUPOSTOS PROCESSUAIS PREVISTOS NO ART. 300 DO CPC, O QUE AUTORIZA O DEFERIMENTO DA TUTELA DE URGENCIA ALMEJADA. OS DOCUMENTOS TRAZIDOS DEMONSTRAM QUE A PARTE AUTORA, NOS TERMOS EM QUE DESCRITO NA INICIAL, ACABOU SUCUMBINDO AO ENGODO DESCRITO E TRANSFERINDO NUMERARIOS AO REQUERIDO. OS PRINTS DE CONVERSAS E OS COMPROVANTES DE PAGAMENTOS IGUALMENTE COMPROVAM O DESCRITO E OS VALORES DESPENDIDOS. DESTA FORMA, DEFIRO A TUTELA DE URGENCIA REQUERIDA PARA O FIM DE DETERMINAR QUE ESTA ZELOSA SERVENTIA PROCEDA AO ARRESTO, VIA SISBAJUD, NAS CONTAS DE TITULARIDADE DE STARK BANK S.A, CNPJ 20.018.183/0001-80 E CASH PAY MEIOS DE PAGAMENTO LTDA, CNPJ 48.689.840/0001-30, NOS VALORES DE R$ 28.844,00 (VINTE E OITO MIL OITOCENTOS E QUARENTA E QUATRO REAIS) E 49.090,00 (QUARENTA E NOVE MIL E NOVENTA REAIS), RESPECTIVAMENTE. DIANTE DAS ESPECIFICIDADES DA CAUSA E DE MODO A ADEQUAR O RITO PROCESSUAL AS NECESSIDADES DO CONFLITO, DEIXO PARA MOMENTO OPORTUNO A ANALISE DA CONVENIENCIA DA AUDIENCIA DE CONCILIACAO. (CPC, ART.139, VI E ENUNCIADO N.35 DA ENFAM). CITE-SE E INTIME-SE A PARTE RE PARA CONTESTAR O FEITO NO PRAZO DE 15 (QUINZE) DIAS UTEIS. A AUSENCIA DE CONTESTACAO IMPLICARA REVELIA E PRESUNCAO DE VERACIDADE DA MATERIA FATICA APRESENTADA NA PETICAO INICIAL. A PRESENTE CITACAO E ACOMPANHADA DE SENHA PARA ACESSO AO PROCESSO DIGITAL, QUE CONTEM A INTEGRA DA PETICAO INICIAL E DOS DOCUMENTOS. TRATANDO-SE DE PROCESSO ELETRONICO, EM PRESTIGIO AS REGRAS FUNDAMENTAIS DOS ARTIGOS 4 E 6 DO CPC FICA VEDADO O EXERCICIO DA FACULDADE PREVISTA NO ARTIGO 340 DO CPC. OBSERVO QUE A CORRETA CLASSIFICACAO DO DOCUMENTO QUANDO DO PETICIONAMENTO ELETRONICO CONFERE MAIOR AGILIDADE NA SUA IDENTIFICACAO NO FLUXO DE TRABALHO, CABENDO AO ADVOGADO CADASTRAR A PETICAO COM O TIPO APROPRIADO (38001 CONTESTACAO OU 7848 CONTESTACAO COM RECONVENCAO). SERVIRA O PRESENTE, POR COPIA DIGITADA, COMO MANDADO/CARTA/OFICIO, INCLUSIVE PARA SER ENVIADO A PARTE RE PELA PARTE AUTORA PARA FINS DE CIENCIA E CUMPRIMENTO DA PRESENTE DECISAO. CUMPRA-SE NA FORMA E SOB AS PENAS DA LEI. INTIMEM-SE. ADVOGADOS(S): LUANA SARDINHA FERREIRA (OAB 141316/RJ)",
                "PublishDate": "2023-09-19T00:00:00",
                "CaptureDate": "2023-09-21T02:26:22"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-09-18T00:00:00",
                "CaptureDate": "2023-09-21T02:26:22"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2023-09-18T00:00:00",
                "CaptureDate": "2023-09-21T02:26:22"
              },
              {
                "Content": "CONCEDIDA A MEDIDA LIMINAR DEFIRO OS BENEFICIOS DA JG A PARTE AUTORA. ANOTE-SE. ANALISANDO A INICIAL E OS DOCUMENTOS QUE A ACOMPANHAM, VERIFICO PRESENTES ELEMENTOS PROBATORIOS APTOS A DEMONSTRAR, INITIO LITIS, A PRESENCA DOS PRESSUPOSTOS PROCESSUAIS PREVISTOS NO ART. 300 DO CPC, O QUE AUTORIZA O DEFERIMENTO DA TUTELA DE URGENCIA ALMEJADA. OS DOCUMENTOS TRAZIDOS DEMONSTRAM QUE A PARTE AUTORA, NOS TERMOS EM QUE DESCRITO NA INICIAL, ACABOU SUCUMBINDO AO ENGODO DESCRITO E TRANSFERINDO NUMERARIOS AO REQUERIDO. OS PRINTS DE CONVERSAS E OS COMPROVANTES DE PAGAMENTOS IGUALMENTE COMPROVAM O DESCRITO E OS VALORES DESPENDIDOS. DESTA FORMA, DEFIRO A TUTELA DE URGENCIA REQUERIDA PARA O FIM DE DETERMINAR QUE ESTA ZELOSA SERVENTIA PROCEDA AO ARRESTO, VIA SISBAJUD, NAS CONTAS DE TITULARIDADE DE STARK BANK S.A, CNPJ 20.018.183/0001-80 E CASH PAY MEIOS DE PAGAMENTO LTDA, CNPJ 48.689.840/0001-30, NOS VALORES DE R$ 28.844,00 (VINTE E OITO MIL OITOCENTOS E QUARENTA E QUATRO REAIS) E 49.090,00 (QUARENTA E NOVE MIL E NOVENTA REAIS), RESPECTIVAMENTE. DIANTE DAS ESPECIFICIDADES DA CAUSA E DE MODO A ADEQUAR O RITO PROCESSUAL AS NECESSIDADES DO CONFLITO, DEIXO PARA MOMENTO OPORTUNO A ANALISE DA CONVENIENCIA DA AUDIENCIA DE CONCILIACAO. (CPC, ART.139, VI E ENUNCIADO N.35 DA ENFAM). CITE-SE E INTIME-SE A PARTE RE PARA CONTESTAR O FEITO NO PRAZO DE 15 (QUINZE) DIAS UTEIS. A AUSENCIA DE CONTESTACAO IMPLICARA REVELIA E PRESUNCAO DE VERACIDADE DA MATERIA FATICA APRESENTADA NA PETICAO INICIAL. A PRESENTE CITACAO E ACOMPANHADA DE SENHA PARA ACESSO AO PROCESSO DIGITAL, QUE CONTEM A INTEGRA DA PETICAO INICIAL E DOS DOCUMENTOS. TRATANDO-SE DE PROCESSO ELETRONICO, EM PRESTIGIO AS REGRAS FUNDAMENTAIS DOS ARTIGOS 4 E 6 DO CPC FICA VEDADO O EXERCICIO DA FACULDADE PREVISTA NO ARTIGO 340 DO CPC. OBSERVO QUE A CORRETA CLASSIFICACAO DO DOCUMENTO QUANDO DO PETICIONAMENTO ELETRONICO CONFERE MAIOR AGILIDADE NA SUA IDENTIFICACAO NO FLUXO DE TRABALHO, CABENDO AO ADVOGADO CADASTRAR A PETICAO COM O TIPO APROPRIADO (38001 CONTESTACAO OU 7848 CONTESTACAO COM RECONVENCAO). SERVIRA O PRESENTE, POR COPIA DIGITADA, COMO MANDADO/CARTA/OFICIO, INCLUSIVE PARA SER ENVIADO A PARTE RE PELA PARTE AUTORA PARA FINS DE CIENCIA E CUMPRIMENTO DA PRESENTE DECISAO. CUMPRA-SE NA FORMA E SOB AS PENAS DA LEI. INTIMEM-SE.",
                "PublishDate": "2023-09-18T00:00:00",
                "CaptureDate": "2023-09-21T02:26:22"
              },
              {
                "Content": "CARTA EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                "PublishDate": "2023-09-18T00:00:00",
                "CaptureDate": "2023-09-21T02:26:22"
              },
              {
                "Content": "CARTA EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                "PublishDate": "2023-09-18T00:00:00",
                "CaptureDate": "2023-09-21T02:26:22"
              }
            ],
            "Petitions": [
              {
                "Type": "PEDIDO DE LIMINAR/ANTECIPACAO DE TUTELA",
                "Author": "",
                "CreationDate": "2023-09-20T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              }
            ],
            "Decisions": [
              {
                "DecisionContent": "DEFIRO OS BENEFICIOS DA JG A PARTE AUTORA.",
                "DecisionDate": "2023-09-20T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO A TUTELA DE URGENCIA REQUERIDA PARA O FIM DE DETERMINAR QUE ESTA ZELOSA SERVENTIA PROCEDA AO ARRESTO, VIA SISBAJUD, NAS CONTAS DE TITULARIDADE DE STARK BANK S.A, CNPJ 20.018.183/0001-80 E CASH PAY MEIOS DE PAGAMENTO LTDA, CNPJ 48.689.840/0001-30, NOS VALORES DE R$ 28.844,00 (VINTE E OITO MIL OITOCENTOS E QUARENTA E QUATRO REAIS) E 49.090,00 (QUARENTA E NOVE MIL E NOVENTA REAIS), RESPECTIVAMENTE.",
                "DecisionDate": "2023-09-20T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO OS BENEFICIOS DA JG A PARTE AUTORA.",
                "DecisionDate": "2023-09-19T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO A TUTELA DE URGENCIA REQUERIDA PARA O FIM DE DETERMINAR QUE ESTA ZELOSA SERVENTIA PROCEDA AO ARRESTO, VIA SISBAJUD, NAS CONTAS DE TITULARIDADE DE STARK BANK S.A, CNPJ 20.018.183/0001-80 E CASH PAY MEIOS DE PAGAMENTO LTDA, CNPJ 48.689.840/0001-30, NOS VALORES DE R$ 28.844,00 (VINTE E OITO MIL OITOCENTOS E QUARENTA E QUATRO REAIS) E 49.090,00 (QUARENTA E NOVE MIL E NOVENTA REAIS), RESPECTIVAMENTE.",
                "DecisionDate": "2023-09-19T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO OS BENEFICIOS DA JG A PARTE AUTORA.",
                "DecisionDate": "2023-09-18T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO A TUTELA DE URGENCIA REQUERIDA PARA O FIM DE DETERMINAR QUE ESTA ZELOSA SERVENTIA PROCEDA AO ARRESTO, VIA SISBAJUD, NAS CONTAS DE TITULARIDADE DE STARK BANK S.A, CNPJ 20.018.183/0001-80 E CASH PAY MEIOS DE PAGAMENTO LTDA, CNPJ 48.689.840/0001-30, NOS VALORES DE R$ 28.844,00 (VINTE E OITO MIL OITOCENTOS E QUARENTA E QUATRO REAIS) E 49.090,00 (QUARENTA E NOVE MIL E NOVENTA REAIS), RESPECTIVAMENTE.",
                "DecisionDate": "2023-09-18T00:00:00"
              }
            ]
          },
          {
            "Number": "10095562420238260286",
            "Type": "PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL",
            "MainSubject": "INDENIZACAO POR DANO MATERIAL",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "ESPECIAL CIVEL",
            "CourtDistrict": "ITU",
            "Judge": "MARCOS SOARES MACHADO",
            "JudgingBody": "JUIZADO ESPECIAL CIVEL",
            "State": "SP",
            "Status": "INDEFINIDO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "INDENIZAÇÃO POR DANO MATERIAL",
            "InferredCNJSubjectNumber": 7780,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO DO JUIZADO ESPECIAL CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "INDENIZACAO POR DANO MATERIAL",
              "INDENIZACAO POR DANO MORAL"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 35270,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-09-20T00:00:00",
            "NoticeDate": "2023-09-18T00:00:00",
            "LastMovementDate": "2023-09-20T00:00:00",
            "CaptureDate": "2023-09-21T02:44:50",
            "LastUpdate": "2023-09-21T02:44:50",
            "NumberOfParties": 10,
            "NumberOfUpdates": 4,
            "LawSuitAge": 163,
            "AverageNumberOfUpdatesPerMonth": 0,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "IsPartyActive": true,
                "Name": "MARCOS SOARES MACHADO",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-09-21T02:44:50"
              },
              {
                "Doc": "29784971810",
                "IsPartyActive": true,
                "Name": "ROBERTO DO COUTO NORI",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-09-21T02:44:50"
              },
              {
                "IsPartyActive": true,
                "Name": "VICTOR CAPELETTI BALDY",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "SpecificType": "ADVOGADO (REQTE)"
                },
                "LastCaptureDate": "2023-09-21T02:44:50"
              },
              {
                "Doc": "05557553800",
                "IsPartyActive": true,
                "Name": "ROSINALVA STECCA SILVEIRA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "SpecificType": "ADVOGADA (REQTE)"
                },
                "LastCaptureDate": "2023-09-21T02:44:50"
              },
              {
                "Doc": "04170295862",
                "IsPartyActive": true,
                "Name": "HAMILTON RENE SILVEIRA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "SpecificType": "ADVOGADO (REQTE)"
                },
                "LastCaptureDate": "2023-09-21T02:44:50"
              },
              {
                "Doc": "38142101823",
                "IsPartyActive": true,
                "Name": "LAIS SILVEIRA BALDY",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "SpecificType": "ADVOGADA (REQTE)"
                },
                "LastCaptureDate": "2023-09-21T02:44:50"
              },
              {
                "Doc": "51880512000120",
                "IsPartyActive": true,
                "Name": "PAYWAY CONSULTORIA E SERVICOS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-09-21T02:44:50"
              },
              {
                "Doc": "48689840000130",
                "IsPartyActive": true,
                "Name": "CASH PAY MEIOS DE PAGAMENTO LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-09-21T02:44:50"
              },
              {
                "Doc": "35624319000172",
                "IsPartyActive": true,
                "Name": "MK DIGITAL BANK INSTITUICAO DE PAGAMENTO S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-09-21T02:44:50"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-09-21T02:44:50"
              }
            ],
            "Updates": [
              {
                "Content": "PROCESSO : 1009556-24.2023.8.26.0286 CLASSE : PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL REQTE : ROBERTO DO COUTO NORI ADVOGADO : 407613/SP - LAIS SILVEIRA BALDY REQDO : STARK BANK S.A. VARA : JUIZADO ESPECIAL CIVEL",
                "PublishDate": "2023-09-20T00:00:00",
                "CaptureDate": "2023-09-21T02:44:50"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2023-09-19T00:00:00",
                "CaptureDate": "2023-09-21T02:44:50"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2023-09-19T00:00:00",
                "CaptureDate": "2023-09-21T02:44:50"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-09-18T00:00:00",
                "CaptureDate": "2023-09-21T02:44:50"
              }
            ],
            "Petitions": [],
            "Decisions": []
          },
          {
            "Number": "10294139520238260564",
            "Type": "TUTELA ANTECIPADA ANTECEDENTE",
            "MainSubject": "INDENIZACAO DO PREJUIZO",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "SAO BERNARDO DO CAMPO",
            "JudgingBody": "8 VARA CIVEL",
            "State": "SP",
            "Status": "ATIVO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "INDENIZAÇÃO DO PREJUÍZO",
            "InferredCNJSubjectNumber": 9524,
            "InferredCNJProcedureTypeName": "TUTELA ANTECIPADA ANTECEDENTE",
            "InferredBroadCNJSubjectName": "DIREITO PROCESSUAL CIVIL E DO TRABALHO",
            "InferredBroadCNJSubjectNumber": 8826,
            "OtherSubjects": [
              "INDENIZACAO DO PREJUIZO",
              "BLOQUEIO / DESBLOQUEIO DE VALORES"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 20342,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-09-21T00:00:00",
            "NoticeDate": "2023-09-19T00:00:00",
            "LastMovementDate": "2023-09-21T00:00:00",
            "CaptureDate": "2023-09-22T05:29:48",
            "LastUpdate": "2023-09-22T05:29:48",
            "NumberOfParties": 7,
            "NumberOfUpdates": 12,
            "LawSuitAge": 162,
            "AverageNumberOfUpdatesPerMonth": 2,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "16169101865",
                "IsPartyActive": true,
                "Name": "RONALDO RYIOTI OGUCHI",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-09-22T05:29:48"
              },
              {
                "Doc": "16169101865",
                "IsPartyActive": true,
                "Name": "RONALDO RYIOTI OGUCHI",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "393918",
                  "State": "SP",
                  "SpecificType": "ADVOGADO (REQTE)"
                },
                "LastCaptureDate": "2023-09-22T05:29:48"
              },
              {
                "Doc": "35624319000172",
                "IsPartyActive": true,
                "Name": "MK DIGITAL BANK INSTITUICAO DE PAGAMENTO S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-09-22T05:29:48"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-09-22T05:29:48"
              },
              {
                "Doc": "46961625000110",
                "IsPartyActive": true,
                "Name": "BELLAPAY NEGOCIOS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-09-22T05:29:48"
              },
              {
                "Doc": "48472928000103",
                "IsPartyActive": true,
                "Name": "KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-09-22T05:29:48"
              },
              {
                "Doc": "48689840000130",
                "IsPartyActive": true,
                "Name": "CASH PAY MEIOS DE PAGAMENTO LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-09-22T05:29:48"
              }
            ],
            "Updates": [
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0827/2023 DATA DA PUBLICACAO: 22/09/2023 NUMERO DO DIARIO: 3825",
                "PublishDate": "2023-09-21T00:00:00",
                "CaptureDate": "2023-09-22T05:29:49"
              },
              {
                "Content": "PETICAO INTERMEDIARIA DIGITALIZACAO JUNTADA N PROTOCOLO: WSBO.23.70374425-1 TIPO DA PETICAO: PETICAO INTERMEDIARIA - DIGITALIZACAO DATA: 21/09/2023 13:59",
                "PublishDate": "2023-09-21T00:00:00",
                "CaptureDate": "2023-09-22T05:29:49"
              },
              {
                "Content": "CARTA PRECATORIA EXPEDIDA PROCESSO DIGITAL - CARTA PRECATORIA - CITACAO - RITO COMUM - SEM AUDIENCIA - NOVO CPC",
                "PublishDate": "2023-09-21T00:00:00",
                "CaptureDate": "2023-09-22T05:29:49"
              },
              {
                "Content": "PROCESSO : 1029413-95.2023.8.26.0564 CLASSE : TUTELA ANTECIPADA ANTECEDENTE REQTE : RONALDO RYIOTI OGUCHI ADVOGADO : 393918/SP - RONALDO RYIOTI OGUCHI REQDO : CASH PAY MEIOS DE PAGAMENTO LTDA VARA : 8 VARA CIVEL PROCESSO 1029413-95.2023.8.26.0564 - TUTELA ANTECIPADA ANTECEDENTE - INDENIZACAO DO PREJUIZO - RONALDO RYIOTI OGUCHI - TRATA-SE DE ACAO DE INDENIZACAO C/C DANOS MATERIAIS COM PEDIDO DE TUTELA ANTECIPADA AJUIZADA POR RONALDO RYIOTI OGUCHI CONTRA MK DIGITAL BANK INSTITUICAO DE PAGAMENTO S/A, STARK BANK S.A., BELLAPAY NEGOCIOS LTDA., KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA. E CASH PAY MEIOS DE PAGAMENTO LTDA. A PARTE AUTORA ALEGA QUE, EM 31/08/2023 ENTRARAM EM CONTATO CONSIGO VIA WHATSAPP, OFERECENDO-LHE SERVICO DE AVALIACAO DE HOTEIS, COM A PROMESSA DE RENDA EXTRA PELO SERVICO. APOS, COMECARAM A PEDIR VALORES PARA CUMPRIR AS TAREFAS, PROMETENDO DEVOLVER O DINHEIRO NA MESMA HORA, COM LUCRO. AS TAREFAS DE AVALIACAO DOS HOTEIS ERAM PASSADAS PELA ELENA E APOS A FINALIZACAO DAS MESMAS, ERAM DIRECIONADOS PARA O TULIO QUE PASSAVA AS TAREFAS DE INVESTIMENTO COM LUCRO IMPONDO CONDICOES PARA QUE O RESGATE FOSSE EFETUADO. EM 01/09/023 A PARTE AUTORA FEZ 5 PAGAMENTOS VIA PIX, NOS VALORES DE R$120,00; R$320,00; R$60,00; R$550,00 E R$1.500,00. EM 13/09/23 FEZ 2 PAGAMENTOS VIA PIX NOS VALORES DE R$ 3.992,00; R$ 13.800.00 PARA AS EMPRESAS CASH PAY MEIOS DE PAGAMENTO LTDA E KENDO SERVICOS DIGITAIS E INTERMEDIACOES DE NEGOCIOS LTDA. QUE POSSUEM CONTA NAS INSTITUICOES MK DIGITAL BANK E STARK BANK S.A., RESPECTIVAMENTE. AO TENTAR RESGATAR OS VALORES, FOI-LHE INFORMADO QUE DEVERIA PAGAR MAIS R$ 30.000,00, QUANDO ENTAO TOMOU CIENCIA DA FRAUDE. NESTE MOMENTO, CESSOU AS TRANSFERENCIAS E FEZ BOLETIM DE OCORRENCIA. ASSIM, REQUER A CONCESSAO DE TUTELA PROVISORIA DE URGENCIA PARA QUE SE PROCEDA AO BLOQUEIO JUDICIAL, VIA SISBAJUD, DAS CONTAS BANCARIAS DE TITULARIDADE DOS RECEBEDORES DE VALORES DO AUTOR: KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA, CASH PAY MEIO DE PAGAMENTO LTDA E BELLAPAY NEGOCIOS LTDA. JUNTOU DOCUMENTOS EM FLS. 15/83. BO EM FLS. 15/16. COMPROVANTES DE TRANSFERENCIA EM FLS. 19/32. PRINTS DAS CONVERSAS EM FLS. 65/69. E O RELATORIO, DECIDO. CONCEDO A GRATUIDADE DA JUSTICA AO AUTOR. ANOTE-SE. POIS BEM, O AUTOR PLEITEIA A CONCESSAO DE TUTELA PROVISORIA DE URGENCIA PARA QUE SEJAM BLOQUEADOS R$ 20.342,00 (VINTE MIL, TREZENTOS E QUARENTA E DOIS REAIS) A FIM DE QUE, AO FINAL, POSSA SER RESSARCIDO PELOS SUPOSTOS PREJUIZOS. PARA A CONCESSAO DA TUTELA PROVISORIA DE URGENCIA, NECESSARIO O PREENCHIMENTO DOS SEGUINTES REQUISITOS: (I) A PROBABILIDADE DO DIREITO; E (II) O PERIGO DE DANO OU O RISCO AO RESULTADO UTIL DO PROCESSO (ART. 300 DO CPC). NO CASO EM TELA, OS REQUISITOS FORAM PREENCHIDOS. A FORMA DE AGIR DAS RES KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA. E CASH PAY MEIOS DE PAGAMENTO LTDA., AO MENOS EM ANALISE UNILATERAL E SUMARIA, APARENTA INDICIOS DE PRATICA DE FRAUDE, NA MODALIDADE PIRAMIDE FINANCEIRA. ASSIM, PRESENTE A PROBABILIDADE DO DIREITO, EIS QUE O CONSUMIDOR TERIA SIDO VITIMA DE PRATICAS ABUSIVAS. NO MESMO SENTIDO, HA EFETIVO RISCO DE QUE OS VALORES TRANSFERIDOS AS RES SEJAM DISSIPADOS, DE MODO QUE O TEMPO NECESSARIO PARA A INSTRUCAO PROCESSUAL COLOCARIA EM RISCO O DIREITO DO AUTOR. PORTANTO, DEFIRO EM PARTE O PEDIDO LIMINAR PARA DETERMINAR O ARRESTO CAUTELAR DO MONTANTE DE R$ 20.342,00 (VINTE MIL, TREZENTOS E QUARENTA E DOIS REAIS) EXCLUSIVAMENTE NAS CONTAS BANCARIAS DAS RES KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA. E CASH PAY MEIOS DE PAGAMENTO LTDA., DESTINATARIAS DAS TRANSFERENCIAS FEITAS PELO AUTOR E COMPROVADAS EM FLS. 19/32, POR MEIO DO SISBAJUD, PERMANECENDO O DEPOSITO NOS AUTOS ATE PROVIMENTO FINAL E O TRANSITO EM JULGADO INDEFIRO OS PEDIDOS RELACIONADOS AS PARTES RES MK DIGITAL BANK INSTITUICAO DE PAGAMENTO S/A, STARK BANK S.A., BELLAPAY NEGOCIOS LTDA., EIS QUE NAO FORAM DESTINATARIOS DE QUAISQUER VALORES TRANSFERIDOS PELO AUTOR. INTIME-SE O AUTOR PARA, NO PRAZO DE 5 DIAS, ESCLARECER A INCLUSAO DE TAIS PARTES NO POLO PASSIVO, RETIFICANDO-SE, CASO NECESSARIO. EM PARALELO, CITEM-SE AS RES KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA. E CASH PAY MEIOS DE PAGAMENTO LTDA., POR CARTA E PRECATORIA, RESPECTIVAMENTE, PARA RESPOSTA, NO PRAZO DE 15 (QUINZE) DIAS, COM ADVERTENCIA DE QUE, NAO O FAZENDO, SERA CONSIDERADO REVEL, PRESUMINDO-SE VERDADEIRAS AS ALEGACOES DE FATO FORMULADAS PELO AUTOR (ART. 344, CPC). DEIXO DE DESIGNAR AUDIENCIA DE CONCILIACAO OU DE MEDIACAO, MEDIDA QUE, PODENDO SER IMPLEMENTADA NO CURSO DA DEMANDA, MELHOR SE AFINA COM O PRINCIPIO DA DURACAO RAZOAVEL DO PROCESSO (ART. 139, II E VI, CPC). O PRAZO PARA RESPOSTA OBSERVARA O DISPOSTO NO ART. 335, III, CODIGO DE PROCESSO CIVIL. O PROCESSO TRAMITA ELETRONICAMENTE E A VISUALIZACAO DA PETICAO INICIAL E DOCUMENTOS DA-SE POR MEIO DE ACESSO AO SITIO DO TRIBUNAL DE JUSTICA DO ESTADO DE SAO PAULO (WWW.TJSP. JUS.BR). O ACESSO A INTEGRA DO PROCESSO SERA CONSIDERADO VISTA PESSOAL (ART. 9,  1, LEI FEDERAL N 11.419/2006), PROVIDENCIA QUE DISPENSA A ANEXACAO DE PAPEIS E/OU DOCUMENTOS. PARA VISUALIZACAO DO INTEIRO TEOR DO PROCESSO, SEGUE, EM ANEXO, SENHA PESSOAL E INTRANSFERIVEL. CONSTITUI DEVER DAS PARTES DECLINAR, NO PRIMEIRO MOMENTO QUE LHES COUBER FALAR NOS AUTOS, O ENDERECO RESIDENCIAL OU PROFISSIONAL ONDE RECEBERAO INTIMACOES, ATUALIZANDO ESSA INFORMACAO SEMPRE QUE OCORRER QUALQUER MODIFICACAO TEMPORARIA OU DEFINITIVA (ART. 77, IV, CPC). DECISAO ASSINADA DIGITALMENTE, A QUAL SERVIRA DE OFICIO/MANDADO (CUMPRIRA AO AUTOR O ENCAMINHAMENTO, COMPROVANDO-SE NOS AUTOS). INT. - ADV: RONALDO RYIOTI OGUCHI (OAB 393918/SP)",
                "PublishDate": "2023-09-21T00:00:00",
                "CaptureDate": "2023-09-22T05:29:48"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0827/2023 TEOR DO ATO: TRATA-SE DE ACAO DE INDENIZACAO C/C DANOS MATERIAIS COM PEDIDO DE TUTELA ANTECIPADA AJUIZADA POR RONALDO RYIOTI OGUCHI CONTRA MK DIGITAL BANK INSTITUICAO DE PAGAMENTO S/A, STARK BANK S.A., BELLAPAY NEGOCIOS LTDA., KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA. E CASH PAY MEIOS DE PAGAMENTO LTDA. A PARTE AUTORA ALEGA QUE, EM 31/08/2023 ENTRARAM EM CONTATO CONSIGO VIA WHATSAPP, OFERECENDO-LHE SERVICO DE AVALIACAO DE HOTEIS, COM A PROMESSA DE RENDA EXTRA PELO SERVICO. APOS, COMECARAM A PEDIR VALORES PARA CUMPRIR AS TAREFAS, PROMETENDO DEVOLVER O DINHEIRO NA MESMA HORA, COM LUCRO. AS TAREFAS DE AVALIACAO DOS HOTEIS ERAM PASSADAS PELA ELENA E APOS A FINALIZACAO DAS MESMAS, ERAM DIRECIONADOS PARA O TULIO QUE PASSAVA AS TAREFAS DE \"INVESTIMENTO COM LUCRO IMPONDO CONDICOES PARA QUE O RESGATE FOSSE EFETUADO. EM 01/09/023 A PARTE AUTORA FEZ 5 PAGAMENTOS VIA PIX, NOS VALORES DE R$120,00; R$320,00; R$60,00; R$550,00 E R$1.500,00. EM 13/09/23 FEZ 2 PAGAMENTOS VIA PIX NOS VALORES DE R$ 3.992,00; R$ 13.800.00 PARA AS EMPRESAS CASH PAY MEIOS DE PAGAMENTO LTDA E KENDO SERVICOS DIGITAIS E INTERMEDIACOES DE NEGOCIOS LTDA. QUE POSSUEM CONTA NAS INSTITUICOES MK DIGITAL BANK E STARK BANK S.A., RESPECTIVAMENTE. AO TENTAR RESGATAR OS VALORES, FOI-LHE INFORMADO QUE DEVERIA PAGAR MAIS R$ 30.000,00, QUANDO ENTAO TOMOU CIENCIA DA FRAUDE. NESTE MOMENTO, CESSOU AS TRANSFERENCIAS E FEZ BOLETIM DE OCORRENCIA. ASSIM, REQUER A CONCESSAO DE TUTELA PROVISORIA DE URGENCIA PARA QUE SE PROCEDA AO BLOQUEIO JUDICIAL, VIA SISBAJUD, DAS CONTAS BANCARIAS DE TITULARIDADE DOS RECEBEDORES DE VALORES DO AUTOR: KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA, CASH PAY MEIO DE PAGAMENTO LTDA E BELLAPAY NEGOCIOS LTDA. JUNTOU DOCUMENTOS EM FLS. 15/83. BO EM FLS. 15/16. COMPROVANTES DE TRANSFERENCIA EM FLS. 19/32. PRINTS DAS CONVERSAS EM FLS. 65/69. E O RELATORIO, DECIDO. CONCEDO A GRATUIDADE DA JUSTICA AO AUTOR. ANOTE-SE. POIS BEM, O AUTOR PLEITEIA A CONCESSAO DE TUTELA PROVISORIA DE URGENCIA PARA QUE SEJAM BLOQUEADOS R$ 20.342,00 (VINTE MIL, TREZENTOS E QUARENTA E DOIS REAIS) A FIM DE QUE, AO FINAL, POSSA SER RESSARCIDO PELOS SUPOSTOS PREJUIZOS. PARA A CONCESSAO DA TUTELA PROVISORIA DE URGENCIA, NECESSARIO O PREENCHIMENTO DOS SEGUINTES REQUISITOS: (I) A PROBABILIDADE DO DIREITO; E (II) O PERIGO DE DANO OU O RISCO AO RESULTADO UTIL DO PROCESSO (ART. 300 DO CPC). NO CASO EM TELA, OS REQUISITOS FORAM PREENCHIDOS. A FORMA DE AGIR DAS RES KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA. E CASH PAY MEIOS DE PAGAMENTO LTDA., AO MENOS EM ANALISE UNILATERAL E SUMARIA, APARENTA INDICIOS DE PRATICA DE FRAUDE, NA MODALIDADE PIRAMIDE FINANCEIRA. ASSIM, PRESENTE A PROBABILIDADE DO DIREITO, EIS QUE O CONSUMIDOR TERIA SIDO VITIMA DE PRATICAS ABUSIVAS. NO MESMO SENTIDO, HA EFETIVO RISCO DE QUE OS VALORES TRANSFERIDOS AS RES SEJAM DISSIPADOS, DE MODO QUE O TEMPO NECESSARIO PARA A INSTRUCAO PROCESSUAL COLOCARIA EM RISCO O DIREITO DO AUTOR. PORTANTO, DEFIRO EM PARTE O PEDIDO LIMINAR PARA DETERMINAR O ARRESTO CAUTELAR DO MONTANTE DE R$ 20.342,00 (VINTE MIL, TREZENTOS E QUARENTA E DOIS REAIS) EXCLUSIVAMENTE NAS CONTAS BANCARIAS DAS RES KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA. E CASH PAY MEIOS DE PAGAMENTO LTDA., DESTINATARIAS DAS TRANSFERENCIAS FEITAS PELO AUTOR E COMPROVADAS EM FLS. 19/32, POR MEIO DO SISBAJUD, PERMANECENDO O DEPOSITO NOS AUTOS ATE PROVIMENTO FINAL E O TRANSITO EM JULGADO INDEFIRO OS PEDIDOS RELACIONADOS AS PARTES RES MK DIGITAL BANK INSTITUICAO DE PAGAMENTO S/A, STARK BANK S.A., BELLAPAY NEGOCIOS LTDA., EIS QUE NAO FORAM DESTINATARIOS DE QUAISQUER VALORES TRANSFERIDOS PELO AUTOR. INTIME-SE O AUTOR PARA, NO PRAZO DE 5 DIAS, ESCLARECER A INCLUSAO DE TAIS PARTES NO POLO PASSIVO, RETIFICANDO-SE, CASO NECESSARIO. EM PARALELO, CITEM-SE AS RES KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA. E CASH PAY MEIOS DE PAGAMENTO LTDA., POR CARTA E PRECATORIA, RESPECTIVAMENTE, PARA RESPOSTA, NO PRAZO DE 15 (QUINZE) DIAS, COM ADVERTENCIA DE QUE, NAO O FAZENDO, SERA CONSIDERADO REVEL, PRESUMINDO-SE VERDADEIRAS AS ALEGACOES DE FATO FORMULADAS PELO AUTOR (ART. 344, CPC). DEIXO DE DESIGNAR AUDIENCIA DE CONCILIACAO OU DE MEDIACAO, MEDIDA QUE, PODENDO SER IMPLEMENTADA NO CURSO DA DEMANDA, MELHOR SE AFINA COM O PRINCIPIO DA DURACAO RAZOAVEL DO PROCESSO (ART. 139, II E VI, CPC). O PRAZO PARA RESPOSTA OBSERVARA O DISPOSTO NO ART. 335, III, CODIGO DE PROCESSO CIVIL. O PROCESSO TRAMITA ELETRONICAMENTE E A VISUALIZACAO DA PETICAO INICIAL E DOCUMENTOS DA-SE POR MEIO DE ACESSO AO SITIO DO TRIBUNAL DE JUSTICA DO ESTADO DE SAO PAULO (WWW.TJSP.JUS.BR). O ACESSO A INTEGRA DO PROCESSO SERA CONSIDERADO VISTA PESSOAL (ART. 9,  1, LEI FEDERAL N 11.419/2006), PROVIDENCIA QUE DISPENSA A ANEXACAO DE PAPEIS E/OU DOCUMENTOS. PARA VISUALIZACAO DO INTEIRO TEOR DO PROCESSO, SEGUE, EM ANEXO, SENHA PESSOAL E INTRANSFERIVEL. CONSTITUI DEVER DAS PARTES DECLINAR, NO PRIMEIRO MOMENTO QUE LHES COUBER FALAR NOS AUTOS, O ENDERECO RESIDENCIAL OU PROFISSIONAL ONDE RECEBERAO INTIMACOES, ATUALIZANDO ESSA INFORMACAO SEMPRE QUE OCORRER QUALQUER MODIFICACAO TEMPORARIA OU DEFINITIVA (ART. 77, IV, CPC). DECISAO ASSINADA DIGITALMENTE, A QUAL SERVIRA DE OFICIO/MANDADO (CUMPRIRA AO AUTOR O ENCAMINHAMENTO, COMPROVANDO-SE NOS AUTOS). INT. ADVOGADOS(S): RONALDO RYIOTI OGUCHI (OAB 393918/SP)",
                "PublishDate": "2023-09-20T00:00:00",
                "CaptureDate": "2023-09-22T05:29:49"
              },
              {
                "Content": "CERTIDAO DE CARTORIO EXPEDIDA CERTIDAO - GENERICA",
                "PublishDate": "2023-09-20T00:00:00",
                "CaptureDate": "2023-09-22T05:29:49"
              },
              {
                "Content": "CARTA EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                "PublishDate": "2023-09-20T00:00:00",
                "CaptureDate": "2023-09-22T05:29:49"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-09-19T00:00:00",
                "CaptureDate": "2023-09-22T05:29:48"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2023-09-19T00:00:00",
                "CaptureDate": "2023-09-22T05:29:49"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2023-09-19T00:00:00",
                "CaptureDate": "2023-09-22T05:29:49"
              },
              {
                "Content": "CONCEDIDA EM PARTE A ANTECIPACAO DE TUTELA TRATA-SE DE ACAO DE INDENIZACAO C/C DANOS MATERIAIS COM PEDIDO DE TUTELA ANTECIPADA AJUIZADA POR RONALDO RYIOTI OGUCHI CONTRA MK DIGITAL BANK INSTITUICAO DE PAGAMENTO S/A, STARK BANK S.A., BELLAPAY NEGOCIOS LTDA., KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA. E CASH PAY MEIOS DE PAGAMENTO LTDA. A PARTE AUTORA ALEGA QUE, EM 31/08/2023 ENTRARAM EM CONTATO CONSIGO VIA WHATSAPP, OFERECENDO-LHE SERVICO DE AVALIACAO DE HOTEIS, COM A PROMESSA DE RENDA EXTRA PELO SERVICO. APOS, COMECARAM A PEDIR VALORES PARA CUMPRIR AS TAREFAS, PROMETENDO DEVOLVER O DINHEIRO NA MESMA HORA, COM LUCRO. AS TAREFAS DE AVALIACAO DOS HOTEIS ERAM PASSADAS PELA ELENA E APOS A FINALIZACAO DAS MESMAS, ERAM DIRECIONADOS PARA O TULIO QUE PASSAVA AS TAREFAS DE \"INVESTIMENTO COM LUCRO IMPONDO CONDICOES PARA QUE O RESGATE FOSSE EFETUADO. EM 01/09/023 A PARTE AUTORA FEZ 5 PAGAMENTOS VIA PIX, NOS VALORES DE R$120,00; R$320,00; R$60,00; R$550,00 E R$1.500,00. EM 13/09/23 FEZ 2 PAGAMENTOS VIA PIX NOS VALORES DE R$ 3.992,00; R$ 13.800.00 PARA AS EMPRESAS CASH PAY MEIOS DE PAGAMENTO LTDA E KENDO SERVICOS DIGITAIS E INTERMEDIACOES DE NEGOCIOS LTDA. QUE POSSUEM CONTA NAS INSTITUICOES MK DIGITAL BANK E STARK BANK S.A., RESPECTIVAMENTE. AO TENTAR RESGATAR OS VALORES, FOI-LHE INFORMADO QUE DEVERIA PAGAR MAIS R$ 30.000,00, QUANDO ENTAO TOMOU CIENCIA DA FRAUDE. NESTE MOMENTO, CESSOU AS TRANSFERENCIAS E FEZ BOLETIM DE OCORRENCIA. ASSIM, REQUER A CONCESSAO DE TUTELA PROVISORIA DE URGENCIA PARA QUE SE PROCEDA AO BLOQUEIO JUDICIAL, VIA SISBAJUD, DAS CONTAS BANCARIAS DE TITULARIDADE DOS RECEBEDORES DE VALORES DO AUTOR: KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA, CASH PAY MEIO DE PAGAMENTO LTDA E BELLAPAY NEGOCIOS LTDA. JUNTOU DOCUMENTOS EM FLS. 15/83. BO EM FLS. 15/16. COMPROVANTES DE TRANSFERENCIA EM FLS. 19/32. PRINTS DAS CONVERSAS EM FLS. 65/69. E O RELATORIO, DECIDO. CONCEDO A GRATUIDADE DA JUSTICA AO AUTOR. ANOTE-SE. POIS BEM, O AUTOR PLEITEIA A CONCESSAO DE TUTELA PROVISORIA DE URGENCIA PARA QUE SEJAM BLOQUEADOS R$ 20.342,00 (VINTE MIL, TREZENTOS E QUARENTA E DOIS REAIS) A FIM DE QUE, AO FINAL, POSSA SER RESSARCIDO PELOS SUPOSTOS PREJUIZOS. PARA A CONCESSAO DA TUTELA PROVISORIA DE URGENCIA, NECESSARIO O PREENCHIMENTO DOS SEGUINTES REQUISITOS: (I) A PROBABILIDADE DO DIREITO; E (II) O PERIGO DE DANO OU O RISCO AO RESULTADO UTIL DO PROCESSO (ART. 300 DO CPC). NO CASO EM TELA, OS REQUISITOS FORAM PREENCHIDOS. A FORMA DE AGIR DAS RES KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA. E CASH PAY MEIOS DE PAGAMENTO LTDA., AO MENOS EM ANALISE UNILATERAL E SUMARIA, APARENTA INDICIOS DE PRATICA DE FRAUDE, NA MODALIDADE PIRAMIDE FINANCEIRA. ASSIM, PRESENTE A PROBABILIDADE DO DIREITO, EIS QUE O CONSUMIDOR TERIA SIDO VITIMA DE PRATICAS ABUSIVAS. NO MESMO SENTIDO, HA EFETIVO RISCO DE QUE OS VALORES TRANSFERIDOS AS RES SEJAM DISSIPADOS, DE MODO QUE O TEMPO NECESSARIO PARA A INSTRUCAO PROCESSUAL COLOCARIA EM RISCO O DIREITO DO AUTOR. PORTANTO, DEFIRO EM PARTE O PEDIDO LIMINAR PARA DETERMINAR O ARRESTO CAUTELAR DO MONTANTE DE R$ 20.342,00 (VINTE MIL, TREZENTOS E QUARENTA E DOIS REAIS) EXCLUSIVAMENTE NAS CONTAS BANCARIAS DAS RES KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA. E CASH PAY MEIOS DE PAGAMENTO LTDA., DESTINATARIAS DAS TRANSFERENCIAS FEITAS PELO AUTOR E COMPROVADAS EM FLS. 19/32, POR MEIO DO SISBAJUD, PERMANECENDO O DEPOSITO NOS AUTOS ATE PROVIMENTO FINAL E O TRANSITO EM JULGADO INDEFIRO OS PEDIDOS RELACIONADOS AS PARTES RES MK DIGITAL BANK INSTITUICAO DE PAGAMENTO S/A, STARK BANK S.A., BELLAPAY NEGOCIOS LTDA., EIS QUE NAO FORAM DESTINATARIOS DE QUAISQUER VALORES TRANSFERIDOS PELO AUTOR. INTIME-SE O AUTOR PARA, NO PRAZO DE 5 DIAS, ESCLARECER A INCLUSAO DE TAIS PARTES NO POLO PASSIVO, RETIFICANDO-SE, CASO NECESSARIO. EM PARALELO, CITEM-SE AS RES KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA. E CASH PAY MEIOS DE PAGAMENTO LTDA., POR CARTA E PRECATORIA, RESPECTIVAMENTE, PARA RESPOSTA, NO PRAZO DE 15 (QUINZE) DIAS, COM ADVERTENCIA DE QUE, NAO O FAZENDO, SERA CONSIDERADO REVEL, PRESUMINDO-SE VERDADEIRAS AS ALEGACOES DE FATO FORMULADAS PELO AUTOR (ART. 344, CPC). DEIXO DE DESIGNAR AUDIENCIA DE CONCILIACAO OU DE MEDIACAO, MEDIDA QUE, PODENDO SER IMPLEMENTADA NO CURSO DA DEMANDA, MELHOR SE AFINA COM O PRINCIPIO DA DURACAO RAZOAVEL DO PROCESSO (ART. 139, II E VI, CPC). O PRAZO PARA RESPOSTA OBSERVARA O DISPOSTO NO ART. 335, III, CODIGO DE PROCESSO CIVIL. O PROCESSO TRAMITA ELETRONICAMENTE E A VISUALIZACAO DA PETICAO INICIAL E DOCUMENTOS DA-SE POR MEIO DE ACESSO AO SITIO DO TRIBUNAL DE JUSTICA DO ESTADO DE SAO PAULO (WWW.TJSP.JUS.BR). O ACESSO A INTEGRA DO PROCESSO SERA CONSIDERADO VISTA PESSOAL (ART. 9,  1, LEI FEDERAL N 11.419/2006), PROVIDENCIA QUE DISPENSA A ANEXACAO DE PAPEIS E/OU DOCUMENTOS. PARA VISUALIZACAO DO INTEIRO TEOR DO PROCESSO, SEGUE, EM ANEXO, SENHA PESSOAL E INTRANSFERIVEL. CONSTITUI DEVER DAS PARTES DECLINAR, NO PRIMEIRO MOMENTO QUE LHES COUBER FALAR NOS AUTOS, O ENDERECO RESIDENCIAL OU PROFISSIONAL ONDE RECEBERAO INTIMACOES, ATUALIZANDO ESSA INFORMACAO SEMPRE QUE OCORRER QUALQUER MODIFICACAO TEMPORARIA OU DEFINITIVA (ART. 77, IV, CPC). DECISAO ASSINADA DIGITALMENTE, A QUAL SERVIRA DE OFICIO/MANDADO (CUMPRIRA AO AUTOR O ENCAMINHAMENTO, COMPROVANDO-SE NOS AUTOS). INT.",
                "PublishDate": "2023-09-19T00:00:00",
                "CaptureDate": "2023-09-22T05:29:49"
              },
              {
                "Content": "DOCUMENTO JUNTADO",
                "PublishDate": "2023-09-19T00:00:00",
                "CaptureDate": "2023-09-22T05:29:49"
              }
            ],
            "Petitions": [
              {
                "Type": "PETICAO INTERMEDIARIA - DIGITALIZACAO",
                "Author": "",
                "CreationDate": "2023-09-21T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              }
            ],
            "Decisions": [
              {
                "DecisionContent": "DEFIRO EM PARTE O PEDIDO LIMINAR PARA DETERMINAR O ARRESTO CAUTELAR DO MONTANTE DE R$ 20.342,00 (VINTE MIL, TREZENTOS E QUARENTA E DOIS REAIS) EXCLUSIVAMENTE NAS CONTAS BANCARIAS DAS RES KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA.",
                "DecisionDate": "2023-09-21T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO EM PARTE O PEDIDO LIMINAR PARA DETERMINAR O ARRESTO CAUTELAR DO MONTANTE DE R$ 20.342,00 (VINTE MIL, TREZENTOS E QUARENTA E DOIS REAIS) EXCLUSIVAMENTE NAS CONTAS BANCARIAS DAS RES KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA.",
                "DecisionDate": "2023-09-20T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO EM PARTE O PEDIDO LIMINAR PARA DETERMINAR O ARRESTO CAUTELAR DO MONTANTE DE R$ 20.342,00 (VINTE MIL, TREZENTOS E QUARENTA E DOIS REAIS) EXCLUSIVAMENTE NAS CONTAS BANCARIAS DAS RES KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA.",
                "DecisionDate": "2023-09-19T00:00:00"
              }
            ]
          },
          {
            "Number": "10306352320238260007",
            "Type": "PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL",
            "MainSubject": "BANCARIOS",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "ESPECIAL CIVEL",
            "CourtDistrict": "SAO PAULO",
            "Judge": "EDUARDO FRANCISCO MARCONDES",
            "JudgingBody": "VARA DO JUIZADO ESPECIAL CIVEL",
            "State": "SP",
            "Status": "INDEFINIDO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "BANCÁRIOS",
            "InferredCNJSubjectNumber": 7752,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO DO JUIZADO ESPECIAL CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "BANCARIOS"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 31350,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-09-22T00:00:00",
            "NoticeDate": "2023-09-20T00:00:00",
            "LastMovementDate": "2023-09-22T00:00:00",
            "CaptureDate": "2023-09-23T01:57:01",
            "LastUpdate": "2023-09-23T01:57:01",
            "NumberOfParties": 9,
            "NumberOfUpdates": 2,
            "LawSuitAge": 161,
            "AverageNumberOfUpdatesPerMonth": 0,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "07675066855",
                "IsPartyActive": true,
                "Name": "EDUARDO FRANCISCO MARCONDES",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-09-23T01:57:01"
              },
              {
                "Doc": "24763079808",
                "IsPartyActive": true,
                "Name": "EDINALVA DE SOUSA ARAUJO",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-09-23T01:57:01"
              },
              {
                "Doc": "40515927821",
                "IsPartyActive": true,
                "Name": "JULIANA MOREIRA FERNANDES RODRIGUES",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "SpecificType": "ADVOGADA (REQTE)"
                },
                "LastCaptureDate": "2023-09-23T01:57:01"
              },
              {
                "Doc": "48472928000103",
                "IsPartyActive": true,
                "Name": "KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-09-23T01:57:01"
              },
              {
                "Doc": "48689840000130",
                "IsPartyActive": true,
                "Name": "CASH PAY MEIOS DE PAGAMENTO LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-09-23T01:57:01"
              },
              {
                "Doc": "18490448000104",
                "IsPartyActive": true,
                "Name": "WUDI PAY CORRESPONDENTE DE INSTITUICAO FINANCEIRA LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-09-23T01:57:01"
              },
              {
                "Doc": "31861005000132",
                "IsPartyActive": true,
                "Name": "PRIMEPAG SOLUCOES EM PAGAMENTOS ELETRONICOS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-09-23T01:57:01"
              },
              {
                "Doc": "35624319000172",
                "IsPartyActive": true,
                "Name": "MK DIGITAL BANK INSTITUICAO DE PAGAMENTO S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-09-23T01:57:01"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-09-23T01:57:01"
              }
            ],
            "Updates": [
              {
                "Content": "PROCESSO : 1030635-23.2023.8.26.0007 CLASSE : PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL REQTE : EDINALVA DE SOUSA ARAUJO ADVOGADO : 344036/SP - JULIANA MOREIRA FERNANDES RODRIGUES REQDO : STARK BANK S.A. VARA : VARA DO JUIZADO ESPECIAL CIVEL",
                "PublishDate": "2023-09-22T00:00:00",
                "CaptureDate": "2023-09-23T01:57:01"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-09-20T00:00:00",
                "CaptureDate": "2023-09-23T01:57:02"
              }
            ],
            "Petitions": [],
            "Decisions": []
          },
          {
            "Number": "10047127720238260400",
            "Type": "PROCEDIMENTO COMUM",
            "MainSubject": "INDENIZACAO POR DANO MORAL",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "OLIMPIA",
            "Judge": "MARIA HELOISA NOGUEIRA RIBEIRO MACHADO SOARES",
            "JudgingBody": "3 VARA CIVEL",
            "State": "SP",
            "Status": "ATIVO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "INDENIZAÇÃO POR DANO MORAL",
            "InferredCNJSubjectNumber": 7779,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "INDENIZACAO POR DANO MORAL",
              "INDENIZACAO POR DANO MATERIAL"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 11137,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-09-22T00:00:00",
            "NoticeDate": "2023-09-15T00:00:00",
            "LastMovementDate": "2023-09-22T00:00:00",
            "CaptureDate": "2023-09-23T03:08:32",
            "LastUpdate": "2023-09-23T03:08:32",
            "NumberOfParties": 6,
            "NumberOfUpdates": 7,
            "LawSuitAge": 166,
            "AverageNumberOfUpdatesPerMonth": 1,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "14554597806",
                "IsPartyActive": true,
                "Name": "MARIA HELOISA NOGUEIRA RIBEIRO MACHADO SOARES",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-09-23T03:08:32"
              },
              {
                "Doc": "10953071855",
                "IsPartyActive": true,
                "Name": "SOLANGE APARECIDA DOS SANTOS",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-09-23T03:08:32"
              },
              {
                "Doc": "36580982870",
                "IsPartyActive": true,
                "Name": "DIEGO ANDRE DE SOUZA EMILIO",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "440227",
                  "State": "SP",
                  "SpecificType": "ADVOGADO (REQTE)"
                },
                "LastCaptureDate": "2023-09-23T03:08:32"
              },
              {
                "Doc": "43301459870",
                "IsPartyActive": true,
                "Name": "MARCOS AUGUSTO SARTORI FILHO",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "439112",
                  "State": "SP",
                  "SpecificType": "ADVOGADO (REQTE)"
                },
                "LastCaptureDate": "2023-09-23T03:08:32"
              },
              {
                "Doc": "49187738000107",
                "IsPartyActive": true,
                "Name": "AQPAGO MEIOS DE PAGAMENTOS LTDA,",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-09-23T03:08:32"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-09-23T03:08:32"
              }
            ],
            "Updates": [
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0845/2023 DATA DA PUBLICACAO: 25/09/2023 NUMERO DO DIARIO: 3826",
                "PublishDate": "2023-09-22T00:00:00",
                "CaptureDate": "2023-09-23T03:08:32"
              },
              {
                "Content": "PROCESSO 1004712-77.2023.8.26.0400 - PROCEDIMENTO COMUM CIVEL - INDENIZACAO POR DANO MORAL - SOLANGE APARECIDA DOS SANTOS - VISTOS, O ART.5, LXXIV, DA CONSTITUICAO FEDERAL, DISPOE O ESTADO PRESTARA ASSISTENCIA JURIDICA INTEGRAL E GRATUITA AOS QUE COMPROVAREM INSUFICIENCIA DE RECURSOS. EMBORA PARA A CONCESSAO DA GRATUIDADE NAO SE EXIJA O ESTADO DE MISERIA ABSOLUTA, E NECESSARIA A COMPROVACAO DA IMPOSSIBILIDADE DE ARCAR COM AS CUSTAS E DESPESAS DO PROCESSO SEM PREJUIZO DE SEU SUSTENTO PROPRIO OU DE SUA FAMILIA. A DECLARACAO DE POBREZA, POR SUA VEZ, ESTABELECE MERA PRESUNCAO RELATIVA DA HIPOSSUFICIENCIA, QUE CEDE ANTE OUTROS ELEMENTOS QUE SIRVAM PARA INDICAR A CAPACIDADE FINANCEIRA. NO CASO, HA ELEMENTOS SUFICIENTES PARA AFASTAR A PRESUNCAO, EM ESPECIAL: (I) NATUREZA E OBJETO DISCUTIDOS; (II) CONTRATACAO DE ADVOGADO PARTICULAR, DISPENSANDO A ATUACAO DA DEFENSORIA. ANTES DE INDEFERIR O PEDIDO, CONTUDO, CONVEM FACULTAR AO INTERESSADO O DIREITO DE PROVAR A IMPOSSIBILIDADE DE ARCAR, SEM O SEU PROPRIO PREJUIZO OU DE SUA FAMILIA, COM AS CUSTAS E DESPESAS DO PROCESSO. ASSIM, PARA APRECIACAO DO PEDIDO DE JUSTICA GRATUITA, A PARTE REQUERENTE DEVERA, EM 10 (DEZ) DIAS, APRESENTAR, SOB PENA DE INDEFERIMENTO DO BENEFICIO: A) COPIA DOS EXTRATOS BANCARIOS DE CONTAS DE TITULARIDADE, E DE EVENTUAL CONJUGE, DOS ULTIMOS TRES MESES; B) COPIA DOS EXTRATOS DE CARTAO DE CREDITO, DOS ULTIMOS TRES MESES E D) COPIA DA ULTIMA DECLARACAO DO IMPOSTO DE RENDA APRESENTADA A SECRETARIA DA RECEITA FEDERAL OU COMPROVACAO ISENCAO. OU, NO MESMO PRAZO, DEVERA RECOLHER AS CUSTAS JUDICIAIS E DESPESAS PROCESSUAIS, SOB PENA DE EXTINCAO, SEM NOVA INTIMACAO. INTIME(M)-SE. - ADV: MARCOS AUGUSTO SARTORI FILHO (OAB 439112/SP), DIEGO ANDRE DE SOUZA EMILIO (OAB 440227/SP)",
                "PublishDate": "2023-09-22T00:00:00",
                "CaptureDate": "2023-09-23T03:08:32"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0845/2023 TEOR DO ATO: VISTOS, O ART.5, LXXIV, DA CONSTITUICAO FEDERAL, DISPOE \"O ESTADO PRESTARA ASSISTENCIA JURIDICA INTEGRAL E GRATUITA AOS QUE COMPROVAREM INSUFICIENCIA DE RECURSOS\". EMBORA PARA A CONCESSAO DA GRATUIDADE NAO SE EXIJA O ESTADO DE MISERIA ABSOLUTA, E NECESSARIA A COMPROVACAO DA IMPOSSIBILIDADE DE ARCAR COM AS CUSTAS E DESPESAS DO PROCESSO SEM PREJUIZO DE SEU SUSTENTO PROPRIO OU DE SUA FAMILIA. A DECLARACAO DE POBREZA, POR SUA VEZ, ESTABELECE MERA PRESUNCAO RELATIVA DA HIPOSSUFICIENCIA, QUE CEDE ANTE OUTROS ELEMENTOS QUE SIRVAM PARA INDICAR A CAPACIDADE FINANCEIRA. NO CASO, HA ELEMENTOS SUFICIENTES PARA AFASTAR A PRESUNCAO, EM ESPECIAL: (I) NATUREZA E OBJETO DISCUTIDOS; (II) CONTRATACAO DE ADVOGADO PARTICULAR, DISPENSANDO A ATUACAO DA DEFENSORIA. ANTES DE INDEFERIR O PEDIDO, CONTUDO, CONVEM FACULTAR AO INTERESSADO O DIREITO DE PROVAR A IMPOSSIBILIDADE DE ARCAR, SEM O SEU PROPRIO PREJUIZO OU DE SUA FAMILIA, COM AS CUSTAS E DESPESAS DO PROCESSO. ASSIM, PARA APRECIACAO DO PEDIDO DE JUSTICA GRATUITA, A PARTE REQUERENTE DEVERA, EM 10 (DEZ) DIAS, APRESENTAR, SOB PENA DE INDEFERIMENTO DO BENEFICIO: A) COPIA DOS EXTRATOS BANCARIOS DE CONTAS DE TITULARIDADE, E DE EVENTUAL CONJUGE, DOS ULTIMOS TRES MESES; B) COPIA DOS EXTRATOS DE CARTAO DE CREDITO, DOS ULTIMOS TRES MESES E D) COPIA DA ULTIMA DECLARACAO DO IMPOSTO DE RENDA APRESENTADA A SECRETARIA DA RECEITA FEDERAL OU COMPROVACAO ISENCAO. OU, NO MESMO PRAZO, DEVERA RECOLHER AS CUSTAS JUDICIAIS E DESPESAS PROCESSUAIS, SOB PENA DE EXTINCAO, SEM NOVA INTIMACAO. INTIME(M)-SE. ADVOGADOS(S): MARCOS AUGUSTO SARTORI FILHO (OAB 439112/SP), DIEGO ANDRE DE SOUZA EMILIO (OAB 440227/SP)",
                "PublishDate": "2023-09-21T00:00:00",
                "CaptureDate": "2023-09-23T03:08:32"
              },
              {
                "Content": "DETERMINADA A EMENDA A INICIAL VISTOS, O ART.5, LXXIV, DA CONSTITUICAO FEDERAL, DISPOE \"O ESTADO PRESTARA ASSISTENCIA JURIDICA INTEGRAL E GRATUITA AOS QUE COMPROVAREM INSUFICIENCIA DE RECURSOS\". EMBORA PARA A CONCESSAO DA GRATUIDADE NAO SE EXIJA O ESTADO DE MISERIA ABSOLUTA, E NECESSARIA A COMPROVACAO DA IMPOSSIBILIDADE DE ARCAR COM AS CUSTAS E DESPESAS DO PROCESSO SEM PREJUIZO DE SEU SUSTENTO PROPRIO OU DE SUA FAMILIA. A DECLARACAO DE POBREZA, POR SUA VEZ, ESTABELECE MERA PRESUNCAO RELATIVA DA HIPOSSUFICIENCIA, QUE CEDE ANTE OUTROS ELEMENTOS QUE SIRVAM PARA INDICAR A CAPACIDADE FINANCEIRA. NO CASO, HA ELEMENTOS SUFICIENTES PARA AFASTAR A PRESUNCAO, EM ESPECIAL: (I) NATUREZA E OBJETO DISCUTIDOS; (II) CONTRATACAO DE ADVOGADO PARTICULAR, DISPENSANDO A ATUACAO DA DEFENSORIA. ANTES DE INDEFERIR O PEDIDO, CONTUDO, CONVEM FACULTAR AO INTERESSADO O DIREITO DE PROVAR A IMPOSSIBILIDADE DE ARCAR, SEM O SEU PROPRIO PREJUIZO OU DE SUA FAMILIA, COM AS CUSTAS E DESPESAS DO PROCESSO. ASSIM, PARA APRECIACAO DO PEDIDO DE JUSTICA GRATUITA, A PARTE REQUERENTE DEVERA, EM 10 (DEZ) DIAS, APRESENTAR, SOB PENA DE INDEFERIMENTO DO BENEFICIO: A) COPIA DOS EXTRATOS BANCARIOS DE CONTAS DE TITULARIDADE, E DE EVENTUAL CONJUGE, DOS ULTIMOS TRES MESES; B) COPIA DOS EXTRATOS DE CARTAO DE CREDITO, DOS ULTIMOS TRES MESES E D) COPIA DA ULTIMA DECLARACAO DO IMPOSTO DE RENDA APRESENTADA A SECRETARIA DA RECEITA FEDERAL OU COMPROVACAO ISENCAO. OU, NO MESMO PRAZO, DEVERA RECOLHER AS CUSTAS JUDICIAIS E DESPESAS PROCESSUAIS, SOB PENA DE EXTINCAO, SEM NOVA INTIMACAO. INTIME(M)-SE.",
                "PublishDate": "2023-09-20T00:00:00",
                "CaptureDate": "2023-09-23T03:08:32"
              },
              {
                "Content": "CERTIDAO DE CARTORIO EXPEDIDA CERTIDAO - GENERICA",
                "PublishDate": "2023-09-18T00:00:00",
                "CaptureDate": "2023-09-23T03:08:32"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2023-09-18T00:00:00",
                "CaptureDate": "2023-09-23T03:08:32"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-09-15T00:00:00",
                "CaptureDate": "2023-09-23T03:08:32"
              }
            ],
            "Petitions": [],
            "Decisions": []
          },
          {
            "Number": "10145084120238260223",
            "Type": "PROCEDIMENTO COMUM",
            "MainSubject": "INDENIZACAO POR DANO MORAL",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "GUARUJA",
            "Judge": "RICARDO FERNANDES PIMENTA JUSTO",
            "JudgingBody": "1 VARA CIVEL",
            "State": "SP",
            "Status": "ATIVO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "INDENIZAÇÃO POR DANO MORAL",
            "InferredCNJSubjectNumber": 7779,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "INDENIZACAO POR DANO MORAL"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 20498,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-09-28T00:00:00",
            "NoticeDate": "2023-09-26T00:00:00",
            "LastMovementDate": "2023-09-28T00:00:00",
            "CaptureDate": "2023-09-29T02:58:10",
            "LastUpdate": "2023-09-29T02:58:10",
            "NumberOfParties": 7,
            "NumberOfUpdates": 2,
            "LawSuitAge": 155,
            "AverageNumberOfUpdatesPerMonth": 0,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "21412567807",
                "IsPartyActive": true,
                "Name": "RICARDO FERNANDES PIMENTA JUSTO",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-09-29T02:58:10"
              },
              {
                "IsPartyActive": true,
                "Name": "VALDECI DA SILVA",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-09-29T02:58:10"
              },
              {
                "Doc": "07446073969",
                "IsPartyActive": true,
                "Name": "TABATA RIBEIRO BRITO MIQUELETTI",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "SpecificType": "ADVOGADA (REQTE)"
                },
                "LastCaptureDate": "2023-09-29T02:58:10"
              },
              {
                "Doc": "48472928000103",
                "IsPartyActive": true,
                "Name": "KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-09-29T02:58:10"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-09-29T02:58:10"
              },
              {
                "Doc": "48689840000130",
                "IsPartyActive": true,
                "Name": "CASH PAY MEIOS DE PAGAMENTO LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-09-29T02:58:10"
              },
              {
                "Doc": "35624319000172",
                "IsPartyActive": true,
                "Name": "MK DIGITAL BANK INSTITUICAO DE PAGAMENTO S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-09-29T02:58:10"
              }
            ],
            "Updates": [
              {
                "Content": "PROCESSO : 1014508-41.2023.8.26.0223 CLASSE : PROCEDIMENTO COMUM CIVEL REQTE : VALDECI DA SILVA ADVOGADO : 87889/PR - TABATA RIBEIRO BRITO MIQUELETTI REQDO : MK DIGITAL BANK INSTITUICAO DE PAGAMENTO S.A VARA : 1 VARA CIVEL 1 VARA CIVEL JUIZO DE DIREITO DA 1 VARA CIVEL EDITAL DE INTIMACAO DE ADVOGADOS RELACAO N 0794/2023",
                "PublishDate": "2023-09-28T00:00:00",
                "CaptureDate": "2023-09-29T02:58:10"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-09-26T00:00:00",
                "CaptureDate": "2023-09-29T02:58:10"
              }
            ],
            "Petitions": [],
            "Decisions": []
          },
          {
            "Number": "10052264120238260073",
            "Type": "PROCEDIMENTO COMUM",
            "MainSubject": "INDENIZACAO POR DANO MORAL",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "AVARE",
            "Judge": "LUCIANO JOSE FORSTER JUNIOR",
            "JudgingBody": "2 VARA CIVEL",
            "State": "SP",
            "Status": "ATIVO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "INDENIZAÇÃO POR DANO MORAL",
            "InferredCNJSubjectNumber": 7779,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "INDENIZACAO POR DANO MORAL",
              "IRREGULARIDADE NO ATENDIMENTO"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 40526,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-10-02T00:00:00",
            "NoticeDate": "2023-09-27T00:00:00",
            "LastMovementDate": "2023-10-02T00:00:00",
            "CaptureDate": "2023-10-02T23:18:04",
            "LastUpdate": "2023-10-02T23:18:04",
            "NumberOfParties": 6,
            "NumberOfUpdates": 7,
            "LawSuitAge": 154,
            "AverageNumberOfUpdatesPerMonth": 1,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "27393655861",
                "IsPartyActive": true,
                "Name": "LUCIANO JOSE FORSTER JUNIOR",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-10-02T23:18:04"
              },
              {
                "IsPartyActive": true,
                "Name": "NADIA CRISTINA DA SILVA",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-10-02T23:18:04"
              },
              {
                "Doc": "54018633904",
                "IsPartyActive": true,
                "Name": "GLAUCO LUCIANO RAMOS",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "19211",
                  "State": "PR",
                  "SpecificType": "ADVOGADO (REQTE)"
                },
                "LastCaptureDate": "2023-10-02T23:18:04"
              },
              {
                "IsPartyActive": true,
                "Name": "NU FINANCEIRA S A SOCIEDADE DE CREDITO, FINANCIAMENTO E INVESTIMENTO",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-10-02T23:18:04"
              },
              {
                "Doc": "35624319000172",
                "IsPartyActive": true,
                "Name": "MK DIGITAL BANK INSTITUICAO DE PAGAMENTO S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-10-02T23:18:04"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-10-02T23:18:04"
              }
            ],
            "Updates": [
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0754/2023 DATA DA PUBLICACAO: 03/10/2023 NUMERO DO DIARIO: 3832",
                "PublishDate": "2023-10-02T00:00:00",
                "CaptureDate": "2023-10-02T23:18:05"
              },
              {
                "Content": "PROCESSO : 1005226-41.2023.8.26.0073 CLASSE : PROCEDIMENTO COMUM CIVEL REQTE : NADIA CRISTINA DA SILVA ADVOGADO : 19211/PR - GLAUCO LUCIANO RAMOS REQDO : STARK BANK S.A. VARA : 2 VARA CIVEL PROCESSO 1005226-41.2023.8.26.0073 - PROCEDIMENTO COMUM CIVEL - INDENIZACAO POR DANO MORAL - NADIA CRISTINA DA SILVA - VISTOS. PARA ANALISE DO PEDIDO DE GRATUIDADE PROCESSUAL, INFORME A REQUERENTE A SUA ATIVIDADE LABORATIVA E SEUS VENCIMENTOS, BEM COMO BENS IMOVEIS QUE PORVENTURA POSSUA, ALEM DE COPIA DA ULTIMA DECLARACAO DE IMPOSTO DE RENDA APRESENTADA JUNTO A RECEITA FEDERAL, ESTANDO CIENTE DAS PENALIDADES CABIVEIS EM CASO DE FALSIDADE. INT. - ADV: GLAUCO LUCIANO RAMOS (OAB 19211/PR)",
                "PublishDate": "2023-10-02T00:00:00",
                "CaptureDate": "2023-10-02T23:18:04"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0754/2023 TEOR DO ATO: VISTOS. PARA ANALISE DO PEDIDO DE GRATUIDADE PROCESSUAL, INFORME A REQUERENTE A SUA ATIVIDADE LABORATIVA E SEUS VENCIMENTOS, BEM COMO BENS IMOVEIS QUE PORVENTURA POSSUA, ALEM DE COPIA DA ULTIMA DECLARACAO DE IMPOSTO DE RENDA APRESENTADA JUNTO A RECEITA FEDERAL, ESTANDO CIENTE DAS PENALIDADES CABIVEIS EM CASO DE FALSIDADE. INT. ADVOGADOS(S): GLAUCO LUCIANO RAMOS (OAB 19211/PR)",
                "PublishDate": "2023-09-29T00:00:00",
                "CaptureDate": "2023-10-02T23:18:05"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2023-09-28T00:00:00",
                "CaptureDate": "2023-10-02T23:18:05"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE VISTOS. PARA ANALISE DO PEDIDO DE GRATUIDADE PROCESSUAL, INFORME A REQUERENTE A SUA ATIVIDADE LABORATIVA E SEUS VENCIMENTOS, BEM COMO BENS IMOVEIS QUE PORVENTURA POSSUA, ALEM DE COPIA DA ULTIMA DECLARACAO DE IMPOSTO DE RENDA APRESENTADA JUNTO A RECEITA FEDERAL, ESTANDO CIENTE DAS PENALIDADES CABIVEIS EM CASO DE FALSIDADE. INT.",
                "PublishDate": "2023-09-28T00:00:00",
                "CaptureDate": "2023-10-02T23:18:05"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-09-27T00:00:00",
                "CaptureDate": "2023-10-02T23:18:05"
              },
              {
                "Content": "EMENDA A INICIAL JUNTADA N PROTOCOLO: WAVR.23.70074120-0 TIPO DA PETICAO: EMENDA A INICIAL DATA: 27/09/2023 17:05",
                "PublishDate": "2023-09-27T00:00:00",
                "CaptureDate": "2023-10-02T23:18:05"
              }
            ],
            "Petitions": [
              {
                "Type": "EMENDA A INICIAL",
                "Author": "",
                "CreationDate": "2023-09-27T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              }
            ],
            "Decisions": []
          },
          {
            "Number": "10243761820238260005",
            "Type": "PROCEDIMENTO COMUM",
            "MainSubject": "PRATICAS ABUSIVAS",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "SAO PAULO",
            "Judge": "ADRIANA BERTIER BENEDITO",
            "JudgingBody": "4 VARA CIVEL",
            "State": "SP",
            "Status": "INDEFINIDO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "PRÁTICAS ABUSIVAS",
            "InferredCNJSubjectNumber": 11811,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "PRATICAS ABUSIVAS"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 12270,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-10-03T00:00:00",
            "NoticeDate": "2023-09-29T00:00:00",
            "LastMovementDate": "2023-10-04T00:00:00",
            "CaptureDate": "2023-10-04T08:11:13",
            "LastUpdate": "2023-10-04T08:11:13",
            "NumberOfParties": 7,
            "NumberOfUpdates": 10,
            "LawSuitAge": 152,
            "AverageNumberOfUpdatesPerMonth": 1,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "25336179892",
                "IsPartyActive": true,
                "Name": "ADRIANA BERTIER BENEDITO",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-10-04T08:11:13"
              },
              {
                "IsPartyActive": true,
                "Name": "SIMONE ALVES SILVA",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-10-04T08:11:13"
              },
              {
                "IsPartyActive": true,
                "Name": "FRANCISCO DE ASSIS MOTA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "329751",
                  "State": "SP",
                  "SpecificType": "ADVOGADO (REQTE)"
                },
                "LastCaptureDate": "2023-10-04T08:11:13"
              },
              {
                "Doc": "46961625000110",
                "IsPartyActive": true,
                "Name": "BELLAPAY NEGOCIOS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-10-04T08:11:13"
              },
              {
                "Doc": "48472928000103",
                "IsPartyActive": true,
                "Name": "KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-10-04T08:11:13"
              },
              {
                "IsPartyActive": true,
                "Name": "CELCOIN PAGAMENTOS S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-10-04T08:11:13"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-10-04T08:11:13"
              }
            ],
            "Updates": [
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0936/2023 DATA DA PUBLICACAO: 05/10/2023 NUMERO DO DIARIO: 3834",
                "PublishDate": "2023-10-04T00:00:00",
                "CaptureDate": "2023-10-04T08:11:14"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0936/2023 TEOR DO ATO: VISTOS, DEFIRO A GRATUIDADE DA JUSTICA AO (A) AUTOR(A).ANOTE-SE. INICIALMENTE, COMO FORMA DE ECONOMIA E CELERIDADE PROCESSUAL, BEM COMO DIANTE DAS ESPECIFICIDADES DA CAUSA E DE MODO A ADEQUAR O RITO PROCESSUAL AS NECESSIDADES DO CONFLITO, OBSERVADAS AS GARANTIAS FUNDAMENTAIS DO PROCESSO, DEIXO PARA MOMENTO OPORTUNO A ANALISE DA CONVENIENCIA DA AUDIENCIA DE CONCILIACAO.(CPC, ART.139, VI E ENUNCIADO N.35 DA ENFAM). NADA IMPEDIRA, CONTUDO, QUE AS PARTES SE CONCILIEM APOS A CITACAO, POR INICIATIVA PROPRIA OU COM A INTERVENCAO DO JUIZO, NO DECORRER DO PROCESSO, NAO HAVENDO PREJUIZO A DEFESA DE QUAISQUER DAS PARTES LITIGANTES. POSTO ISSO, POR ORA, CITE-SE A PARTE RE PARA CONTESTAR O FEITO NO PRAZO DE 15 (QUINZE) DIAS UTEIS. RESULTANDO NEGATIVA A DILIGENCIA E MEDIANTE REQUERIMENTO, FICA DESDE LOGO DEFERIDA AS PESQUISAS DE ENDERECO ATRAVES DOS SISTEMAS SISBAJUD E INFOSEG, POR SEREM OS SISTEMAS MAIS EFICAZES PARA BUSCA DE ENDERECOS, DEVENDO A PARTE AUTORA MANIFESTAR-SE, JUNTANDO AS RESPECTIVAS DESPESAS, SALVO SE BENEFICIARIA DA GRATUIDADE PROCESSUAL. APONTADOS ENDERECOS A SEREM DILIGENCIADOS, PROVIDENCIE A PARTE O RECOLHIMENTO DAS DESPESAS PROCESSUAIS PERTINENTES E EXPECA-SE O NECESSARIO, SEM NECESSIDADE DE NOVA CONCLUSAO. SERVIRA A PRESENTE POR COPIA DIGITADA COMO MANDADO (BEM COMO PARA EXPEDICAO DE CARTA), NOS TERMOS DO ARTIGO 250 DO CODIGO DE PROCESSO CIVIL, A SER CUMPRIDO PELO SR. OFICIAL DE JUSTICA DESIGNADO. INT. SAO PAULO, 02 DE OUTUBRO DE 2023. ADVOGADOS(S): FRANCISCO DE ASSIS MOTA (OAB 329751/SP)",
                "PublishDate": "2023-10-03T00:00:00",
                "CaptureDate": "2023-10-04T08:11:14"
              },
              {
                "Content": "PROCESSO : 1024376-18.2023.8.26.0005 CLASSE : PROCEDIMENTO COMUM CIVEL REQTE : SIMONE ALVES SILVA ADVOGADO : 329751/SP - FRANCISCO DE ASSIS MOTA REQDO : BELLAPAY NEGOCIOS LTDA VARA : 4 VARA CIVEL",
                "PublishDate": "2023-10-03T00:00:00",
                "CaptureDate": "2023-10-04T08:11:13"
              },
              {
                "Content": "RECEBIDA A PETICAO INICIAL - CITACAO POR CARTA AR VISTOS, DEFIRO A GRATUIDADE DA JUSTICA AO (A) AUTOR(A).ANOTE-SE. INICIALMENTE, COMO FORMA DE ECONOMIA E CELERIDADE PROCESSUAL, BEM COMO DIANTE DAS ESPECIFICIDADES DA CAUSA E DE MODO A ADEQUAR O RITO PROCESSUAL AS NECESSIDADES DO CONFLITO, OBSERVADAS AS GARANTIAS FUNDAMENTAIS DO PROCESSO, DEIXO PARA MOMENTO OPORTUNO A ANALISE DA CONVENIENCIA DA AUDIENCIA DE CONCILIACAO.(CPC, ART.139, VI E ENUNCIADO N.35 DA ENFAM). NADA IMPEDIRA, CONTUDO, QUE AS PARTES SE CONCILIEM APOS A CITACAO, POR INICIATIVA PROPRIA OU COM A INTERVENCAO DO JUIZO, NO DECORRER DO PROCESSO, NAO HAVENDO PREJUIZO A DEFESA DE QUAISQUER DAS PARTES LITIGANTES. POSTO ISSO, POR ORA, CITE-SE A PARTE RE PARA CONTESTAR O FEITO NO PRAZO DE 15 (QUINZE) DIAS UTEIS. RESULTANDO NEGATIVA A DILIGENCIA E MEDIANTE REQUERIMENTO, FICA DESDE LOGO DEFERIDA AS PESQUISAS DE ENDERECO ATRAVES DOS SISTEMAS SISBAJUD E INFOSEG, POR SEREM OS SISTEMAS MAIS EFICAZES PARA BUSCA DE ENDERECOS, DEVENDO A PARTE AUTORA MANIFESTAR-SE, JUNTANDO AS RESPECTIVAS DESPESAS, SALVO SE BENEFICIARIA DA GRATUIDADE PROCESSUAL. APONTADOS ENDERECOS A SEREM DILIGENCIADOS, PROVIDENCIE A PARTE O RECOLHIMENTO DAS DESPESAS PROCESSUAIS PERTINENTES E EXPECA-SE O NECESSARIO, SEM NECESSIDADE DE NOVA CONCLUSAO. SERVIRA A PRESENTE POR COPIA DIGITADA COMO MANDADO (BEM COMO PARA EXPEDICAO DE CARTA), NOS TERMOS DO ARTIGO 250 DO CODIGO DE PROCESSO CIVIL, A SER CUMPRIDO PELO SR. OFICIAL DE JUSTICA DESIGNADO. INT. SAO PAULO, 02 DE OUTUBRO DE 2023.",
                "PublishDate": "2023-10-02T00:00:00",
                "CaptureDate": "2023-10-04T08:11:14"
              },
              {
                "Content": "CARTA EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                "PublishDate": "2023-10-02T00:00:00",
                "CaptureDate": "2023-10-04T08:11:14"
              },
              {
                "Content": "CARTA EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                "PublishDate": "2023-10-02T00:00:00",
                "CaptureDate": "2023-10-04T08:11:14"
              },
              {
                "Content": "CARTA EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                "PublishDate": "2023-10-02T00:00:00",
                "CaptureDate": "2023-10-04T08:11:14"
              },
              {
                "Content": "CARTA EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                "PublishDate": "2023-10-02T00:00:00",
                "CaptureDate": "2023-10-04T08:11:14"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-09-29T00:00:00",
                "CaptureDate": "2023-10-04T08:11:14"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2023-09-29T00:00:00",
                "CaptureDate": "2023-10-04T08:11:14"
              }
            ],
            "Petitions": [],
            "Decisions": [
              {
                "DecisionContent": "DEFIRO A GRATUIDADE DA JUSTICA AO (A) AUTOR(A).ANOTE-SE.",
                "DecisionDate": "2023-10-03T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO A GRATUIDADE DA JUSTICA AO (A) AUTOR(A).ANOTE-SE.",
                "DecisionDate": "2023-10-02T00:00:00"
              }
            ]
          },
          {
            "Number": "10167572820238260008",
            "Type": "PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL",
            "MainSubject": "BANCARIOS",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "ESPECIAL CIVEL",
            "CourtDistrict": "SAO PAULO",
            "JudgingBody": "1 VARA DO JUIZADO ESPECIAL CIVEL",
            "State": "SP",
            "Status": "INDEFINIDO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "BANCÁRIOS",
            "InferredCNJSubjectNumber": 7752,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO DO JUIZADO ESPECIAL CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "BANCARIOS"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 35770,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-10-03T00:00:00",
            "NoticeDate": "2023-09-30T00:00:00",
            "LastMovementDate": "2023-10-04T00:00:00",
            "CaptureDate": "2023-10-04T08:22:06",
            "LastUpdate": "2023-10-04T08:22:06",
            "NumberOfParties": 7,
            "NumberOfUpdates": 15,
            "LawSuitAge": 151,
            "AverageNumberOfUpdatesPerMonth": 2,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "39522502871",
                "IsPartyActive": true,
                "Name": "GUILHERME BATOCHIO ROSA",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-10-04T08:22:06"
              },
              {
                "Doc": "01429031670",
                "IsPartyActive": true,
                "Name": "RAPHAEL PEREIRA DE SOUZA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "130203",
                  "State": "MG",
                  "SpecificType": "ADVOGADO (REQTE)"
                },
                "LastCaptureDate": "2023-10-04T08:22:06"
              },
              {
                "Doc": "46189325000165",
                "IsPartyActive": true,
                "Name": "ITAU UNIBANCO S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-10-04T08:22:06"
              },
              {
                "Doc": "48689840000130",
                "IsPartyActive": true,
                "Name": "CASH PAY MEIOS DE PAGAMENTO LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-10-04T08:22:06"
              },
              {
                "Doc": "48472928000103",
                "IsPartyActive": true,
                "Name": "KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-10-04T08:22:06"
              },
              {
                "Doc": "35624319000172",
                "IsPartyActive": true,
                "Name": "MK DIGITAL BANK INSTITUICAO DE PAGAMENTO S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-10-04T08:22:06"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-10-04T08:22:06"
              }
            ],
            "Updates": [
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0725/2023 DATA DA PUBLICACAO: 05/10/2023 NUMERO DO DIARIO: 3834",
                "PublishDate": "2023-10-04T00:00:00",
                "CaptureDate": "2023-10-04T08:22:07"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0725/2023 TEOR DO ATO: VISTOS. TRATA-SE DE ACAO INDENIZATORIA. EM SEDE DE COGNICAO SUMARIA E TRANSITORIA DA LIDE, INDEFIRO O PEDIDO DE TUTELA PROVISORIA, NA MEDIDA EM QUE OS DOCUMENTOS ORA ANEXADOS AOS AUTOS SAO INSUFICIENTES A DEMONSTRAR A PROBABILIDADE DO DIREITO INVOCADO. RELATA O AUTOR TER SIDO LUDIBRIADO POR TERCEIRO(S), VINDO A REALIZAR AS TRANSACOES ELENCADAS NA PETICAO INICIAL VISANDO RETORNO FINANCEIRO. OCORRE QUE, APESAR DO QUANDO NARRADO PELO REQUERENTE, NAO HA NOS AUTOS ELEMENTOS CONCRETOS SUFICIENTES A DEMONSTRAR QUE A SEGUNDA E A TERCEIRA REQUERIDAS CORRESPONDAM AS REAIS BENEFICIARIAS FINAIS DO NARRADO GOLPE, JA QUE SAO EMPRESAS DE INTERMEDIACAO DE SERVICOS FINANCEIROS E DE COBRANCA, COMO SE PODE CONSULTAR ATRAVES DO SITE DA RFB. ALEM DISSO, OS EXTRATOS PROCESSUAIS DE FLS. 18/9 NAO SE PRESTAM A DEMONSTRAR INDICIOS DE DILAPIDACAO PATRIMONIAL. PORTANTO, E CONSIDERANDO QUE AS TRANSACOES QUESTIONADAS FORAM FEITAS PELO PROPRIO DEMANDANTE, RECOMENDA A CAUTELA QUE SE AGUARDE O CONTRADITORIO PARA QUE MELHOR SE APURE A CONCORRENCIA DE TAIS REQUERIDAS PARA O PREJUIZO DESCRITO NOS AUTOS. NOTE-SE TAMBEM QUE O PRIMEIRO REQUERIDO APONTOU ADMINISTRATIVAMENTE A IMPOSSIBILIDADE DE SE RECUPERAR O MONTANTE PORQUE JA LEVANTADO/RETIRADO DAS CONTAS AS QUAIS O MESMO FOI DESTINADO (FLS. 47). NO MAIS, A QUEBRA DE SIGILO BANCARIO E MEDIDA EXCEPCIONAL, NAO COMPORTANDO DEFERIMENTO NESTA FASE DA DEMANDA. PROSSIGA-SE COM A CITACAO, CONFORME FLS. 57. INTIME-SE. ADVOGADOS(S): RAPHAEL PEREIRA DE SOUZA (OAB 130203MG)",
                "PublishDate": "2023-10-03T00:00:00",
                "CaptureDate": "2023-10-04T08:22:07"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0722/2023 DATA DA PUBLICACAO: 04/10/2023 NUMERO DO DIARIO: 3833",
                "PublishDate": "2023-10-03T00:00:00",
                "CaptureDate": "2023-10-04T08:22:07"
              },
              {
                "Content": "CARTA DE CITACAO EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO E INTIMACAO - AUDIENCIA DE CONCILIACAO - JUIZADO",
                "PublishDate": "2023-10-03T00:00:00",
                "CaptureDate": "2023-10-04T08:22:07"
              },
              {
                "Content": "CARTA DE CITACAO EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO E INTIMACAO - AUDIENCIA DE CONCILIACAO - JUIZADO",
                "PublishDate": "2023-10-03T00:00:00",
                "CaptureDate": "2023-10-04T08:22:07"
              },
              {
                "Content": "CARTA DE CITACAO EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO E INTIMACAO - AUDIENCIA DE CONCILIACAO - JUIZADO",
                "PublishDate": "2023-10-03T00:00:00",
                "CaptureDate": "2023-10-04T08:22:07"
              },
              {
                "Content": "CARTA DE CITACAO EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO E INTIMACAO - AUDIENCIA DE CONCILIACAO - JUIZADO",
                "PublishDate": "2023-10-03T00:00:00",
                "CaptureDate": "2023-10-04T08:22:07"
              },
              {
                "Content": "CARTA DE CITACAO EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO E INTIMACAO - AUDIENCIA DE CONCILIACAO - JUIZADO",
                "PublishDate": "2023-10-03T00:00:00",
                "CaptureDate": "2023-10-04T08:22:07"
              },
              {
                "Content": "PROCESSO : 1016757-28.2023.8.26.0008 CLASSE : PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL REQTE : GUILHERME BATOCHIO ROSA ADVOGADO : 130203MG - RAPHAEL PEREIRA DE SOUZA REQDO : STARK BANK S.A. VARA : 1 VARA DO JUIZADO ESPECIAL CIVEL PROCESSO 1016757-28.2023.8.26.0008 - PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL - BANCARIOS - GUILHERME BATOCHIO ROSA - FICA DESIGNADA AUDIENCIA PRESENCIAL DE CONCILIACAO PARA O DIA 30 DE JANEIRO DE 2024, AS 13 HORAS E 30 MINUTOS (TERREO SALA 17). FICA O(A) AUTOR(A) INTIMADO POR MEIO DE SEU/SUA ADVOGADO(A), DEVENDO O(A) PATRONO(A) PROVIDENCIAR O COMPARECIMENTO DE SEU CONSTITUINTE, SOB PENA DE EXTINCAO (ART. 51, I, DA LEI 9.099/95), COM A CONDENACAO NAS CUSTAS PROCESSUAIS. CITE-SE O(A) REQUERIDO(A) E INTIME-SE A COMPARECER NA AUDIENCIA, SOB PENA DE SER DECRETADA A REVELIA. - ADV: RAPHAEL PEREIRA DE SOUZA (OAB 130203MG) JUIZO DE DIREITO DA 1 VARA DO JUIZADO ESPECIAL CIVEL EDITAL DE INTIMACAO DE ADVOGADOS RELACAO N 0723/2023",
                "PublishDate": "2023-10-03T00:00:00",
                "CaptureDate": "2023-10-04T08:22:06"
              },
              {
                "Content": "DESIGNADA AUDIENCIA DE CONCILIACAO CONCILIACAO DATA: 30/01/2024 HORA 13:30 LOCAL: SALA 17 - CONCILIACAO SITUACAO: PENDENTE",
                "PublishDate": "2023-10-02T00:00:00",
                "CaptureDate": "2023-10-04T08:22:06"
              },
              {
                "Content": "ATO ORDINATORIO FICA DESIGNADA AUDIENCIA PRESENCIAL DE CONCILIACAO PARA O DIA 30 DE JANEIRO DE 2024, AS 13 HORAS E 30 MINUTOS (TERREO SALA 17). FICA O(A) AUTOR(A) INTIMADO POR MEIO DE SEU/SUA ADVOGADO(A), DEVENDO O(A) PATRONO(A) PROVIDENCIAR O COMPARECIMENTO DE SEU CONSTITUINTE, SOB PENA DE EXTINCAO (ART. 51, I, DA LEI 9.099/95), COM A CONDENACAO NAS CUSTAS PROCESSUAIS. CITE-SE O(A) REQUERIDO(A) E INTIME-SE A COMPARECER NA AUDIENCIA, SOB PENA DE SER DECRETADA A REVELIA.",
                "PublishDate": "2023-10-02T00:00:00",
                "CaptureDate": "2023-10-04T08:22:06"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2023-10-02T00:00:00",
                "CaptureDate": "2023-10-04T08:22:06"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0722/2023 TEOR DO ATO: FICA DESIGNADA AUDIENCIA PRESENCIAL DE CONCILIACAO PARA O DIA 30 DE JANEIRO DE 2024, AS 13 HORAS E 30 MINUTOS (TERREO SALA 17). FICA O(A) AUTOR(A) INTIMADO POR MEIO DE SEU/SUA ADVOGADO(A), DEVENDO O(A) PATRONO(A) PROVIDENCIAR O COMPARECIMENTO DE SEU CONSTITUINTE, SOB PENA DE EXTINCAO (ART. 51, I, DA LEI 9.099/95), COM A CONDENACAO NAS CUSTAS PROCESSUAIS. CITE-SE O(A) REQUERIDO(A) E INTIME-SE A COMPARECER NA AUDIENCIA, SOB PENA DE SER DECRETADA A REVELIA. ADVOGADOS(S): RAPHAEL PEREIRA DE SOUZA (OAB 130203MG)",
                "PublishDate": "2023-10-02T00:00:00",
                "CaptureDate": "2023-10-04T08:22:06"
              },
              {
                "Content": "NAO CONCEDIDA A ANTECIPACAO DE TUTELA VISTOS. TRATA-SE DE ACAO INDENIZATORIA. EM SEDE DE COGNICAO SUMARIA E TRANSITORIA DA LIDE, INDEFIRO O PEDIDO DE TUTELA PROVISORIA, NA MEDIDA EM QUE OS DOCUMENTOS ORA ANEXADOS AOS AUTOS SAO INSUFICIENTES A DEMONSTRAR A PROBABILIDADE DO DIREITO INVOCADO. RELATA O AUTOR TER SIDO LUDIBRIADO POR TERCEIRO(S), VINDO A REALIZAR AS TRANSACOES ELENCADAS NA PETICAO INICIAL VISANDO RETORNO FINANCEIRO. OCORRE QUE, APESAR DO QUANDO NARRADO PELO REQUERENTE, NAO HA NOS AUTOS ELEMENTOS CONCRETOS SUFICIENTES A DEMONSTRAR QUE A SEGUNDA E A TERCEIRA REQUERIDAS CORRESPONDAM AS REAIS BENEFICIARIAS FINAIS DO NARRADO GOLPE, JA QUE SAO EMPRESAS DE INTERMEDIACAO DE SERVICOS FINANCEIROS E DE COBRANCA, COMO SE PODE CONSULTAR ATRAVES DO SITE DA RFB. ALEM DISSO, OS EXTRATOS PROCESSUAIS DE FLS. 18/9 NAO SE PRESTAM A DEMONSTRAR INDICIOS DE DILAPIDACAO PATRIMONIAL. PORTANTO, E CONSIDERANDO QUE AS TRANSACOES QUESTIONADAS FORAM FEITAS PELO PROPRIO DEMANDANTE, RECOMENDA A CAUTELA QUE SE AGUARDE O CONTRADITORIO PARA QUE MELHOR SE APURE A CONCORRENCIA DE TAIS REQUERIDAS PARA O PREJUIZO DESCRITO NOS AUTOS. NOTE-SE TAMBEM QUE O PRIMEIRO REQUERIDO APONTOU ADMINISTRATIVAMENTE A IMPOSSIBILIDADE DE SE RECUPERAR O MONTANTE PORQUE JA LEVANTADO/RETIRADO DAS CONTAS AS QUAIS O MESMO FOI DESTINADO (FLS. 47). NO MAIS, A QUEBRA DE SIGILO BANCARIO E MEDIDA EXCEPCIONAL, NAO COMPORTANDO DEFERIMENTO NESTA FASE DA DEMANDA. PROSSIGA-SE COM A CITACAO, CONFORME FLS. 57. INTIME-SE.",
                "PublishDate": "2023-10-02T00:00:00",
                "CaptureDate": "2023-10-04T08:22:07"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-09-30T00:00:00",
                "CaptureDate": "2023-10-04T08:22:06"
              }
            ],
            "Petitions": [],
            "Decisions": []
          },
          {
            "Number": "10272773420238260562",
            "Type": "PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL",
            "MainSubject": "BANCARIOS",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "ESPECIAL CIVEL",
            "CourtDistrict": "SANTOS",
            "Judge": "LUIZ FRANCISCO TROMBONI",
            "JudgingBody": "1 VARA DO JUIZADO ESPECIAL CIVEL",
            "State": "SP",
            "Status": "INDEFINIDO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "BANCÁRIOS",
            "InferredCNJSubjectNumber": 7752,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO DO JUIZADO ESPECIAL CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "BANCARIOS"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 27820,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-10-05T00:00:00",
            "NoticeDate": "2023-10-03T00:00:00",
            "LastMovementDate": "2023-10-05T00:00:00",
            "CaptureDate": "2023-10-05T16:51:00",
            "LastUpdate": "2023-10-05T16:51:00",
            "NumberOfParties": 5,
            "NumberOfUpdates": 8,
            "LawSuitAge": 148,
            "AverageNumberOfUpdatesPerMonth": 1,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "09327197836",
                "IsPartyActive": true,
                "Name": "LUIZ FRANCISCO TROMBONI",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-10-05T16:51:00"
              },
              {
                "Doc": "06996756855",
                "IsPartyActive": true,
                "Name": "SANDRA HELENA DA SILVA FRAGNAN",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-10-05T16:51:00"
              },
              {
                "Doc": "36820576846",
                "IsPartyActive": true,
                "Name": "DANILO MARQUES PARDI",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "384895",
                  "State": "SP",
                  "SpecificType": "ADVOGADO (REQTE)"
                },
                "LastCaptureDate": "2023-10-05T16:51:00"
              },
              {
                "Doc": "35624319000172",
                "IsPartyActive": true,
                "Name": "MK DIGITAL BANK INSTITUICAO DE PAGAMENTO S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-10-05T16:51:00"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-10-05T16:51:00"
              }
            ],
            "Updates": [
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0855/2023 DATA DA PUBLICACAO: 06/10/2023 NUMERO DO DIARIO: 3835",
                "PublishDate": "2023-10-05T00:00:00",
                "CaptureDate": "2023-10-05T16:51:01"
              },
              {
                "Content": "PROCESSO : 1027277-34.2023.8.26.0562 CLASSE : PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL REQTE : SANDRA HELENA DA SILVA FRAGNAN ADVOGADO : 384895/SP - DANILO MARQUES PARDI REQDO : STARK BANK S.A. VARA : 1 VARA DO JUIZADO ESPECIAL CIVEL PROCESSO 1027277-34.2023.8.26.0562 - PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL - BANCARIOS - SANDRA HELENA DA SILVA FRAGNAN - VISTOS. DEIXO DE DESIGNAR AUDIENCIA UNICA DE CONCILIACAO, QUE PODERA SER REQUERIDA PELAS PARTES, CASO DESEJEM CONCILIAR, DEVENDO AGUARDAR A AUDIENCIA UNICA DE CONCILIACAO, SANEAMENTO, INSTRUCAO E JULGAMENTO. CITE-SE A REQUERIDA PARA RESPONDER, NO PRAZO DE 15 (QUINZE) DIAS, SOB AS PENAS DA LEI, NOS EXATOS TERMOS DO ART. 335, III DO CPC. CONSIGNE-SE NO MANDADO/DESPACHO QUE, NAO SENDO CONTESTADA A ACAO, PRESUMIR-SE-AO ACEITOS COMO VERDADEIROS OS FATOS ARTICULADOS PELA PARTE REQUERENTE (ART. 20 DA LEI N 9.099/95 E ART. 344 DO CPC). CONSIDERANDO A RESTRICAO DE ACESSO DE PESSOAS AOS PREDIOS DOS FORUNS EM RAZAO DA PANDEMIA DE COVID-19, A AUDIENCIA DE CONCILIACAO E/OU CONCILIACAO, INSTRUCAO E JULGAMENTO SERA REALIZADA POR MEIO DE VIDEOCONFERENCIA, UTILIZANDO-SE A FERRAMENTA MICROSOFT TEAMS, VIA COMPUTADOR OU SMARTPHONE, NOS TERMOS DO COMUNICADO N 284/2020. INFORMEM AS PARTES, PREPOSTOS, ADVOGADOS E TESTEMUNHAS OS ENDERECOS DE E-MAIL PARA QUE OS CONVITES SEJAM OPORTUNAMENTE ENVIADOS. A PARTE SEM ADVOGADO DEVERA INFORMAR O SEU E-MAIL, BEM COMO O E-MAIL DE EVENTUAL TESTEMUNHA, ATRAVES DO PETICIONAMENTO ELETRONICO NO SITE (WWW.TJSP.JUS.BR), CASO POSSUA CERTIFICADO DIGITAL, OU POR PETICAO APRESENTADA EM CARTORIO, DE ACORDO COM PROVIMENTO CG N 09/2023, ARTIGOS 1 E 3 E COMUNICADO CG N 949/2020. NA HIPOTESE DE INTIMACAO ATRAVES DE MANDADO, O/A SR(A). OFICIAL DE JUSTICA DEVERA ANOTAR (DE FORMA LEGIVEL) O E-MAIL DA PARTE OU DA TESTEMUNHA INTIMADA. O NAO COMPARECIMENTO INJUSTIFICADO DAS PARTES IMPLICARA EM ATO ATENTATORIO A DIGNIDADE DA JUSTICA E NA APLICACAO DA MULTA ESTABELECIDA NO  8, BEM COMO, NOS TERMOS DA LEI 9.099/95, NA EXTINCAO DO PROCESSO COM RELACAO AO AUTOR E EM REVELIA COM RELACAO AO REU. AS PARTES REQUERENTE E REQUERIDA DEVERAO APRESENTAR OS DOCUMENTOS DIGITALIZADOS, QUE DEVERAO ACOMPANHAR NECESSARIAMENTE A INICIAL E A RESPOSTA, SOB PENA DE PRECLUSAO (ART. 434 DO CPC). APOS A RESPOSTA, AS PARTES DEVERAO ESPECIFICAR AS PROVAS QUE PRETENDEM PRODUZIR, FUNDAMENTADAMENTE, SOB PENA DE PRECLUSAO, NAO SERVINDO O PROTESTO GENERICO PELA PRODUCAO DE TODAS AS PROVAS PARA A FINALIDADE PRETENDIDA, O QUE ACARRETARA TAMBEM EM PRECLUSAO. SERVIRA O PRESENTE DESPACHO COMO MANDADO. INT. - ADV: DANILO MARQUES PARDI (OAB 384895/SP)",
                "PublishDate": "2023-10-05T00:00:00",
                "CaptureDate": "2023-10-05T16:51:00"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE VISTOS. DEIXO DE DESIGNAR AUDIENCIA UNICA DE CONCILIACAO, QUE PODERA SER REQUERIDA PELAS PARTES, CASO DESEJEM CONCILIAR, DEVENDO AGUARDAR A AUDIENCIA UNICA DE CONCILIACAO, SANEAMENTO, INSTRUCAO E JULGAMENTO. CITE-SE A REQUERIDA PARA RESPONDER, NO PRAZO DE 15 (QUINZE) DIAS, SOB AS PENAS DA LEI, NOS EXATOS TERMOS DO ART. 335, III DO CPC. CONSIGNE-SE NO MANDADO/DESPACHO QUE, NAO SENDO CONTESTADA A ACAO, PRESUMIR-SE-AO ACEITOS COMO VERDADEIROS OS FATOS ARTICULADOS PELA PARTE REQUERENTE (ART. 20 DA LEI N 9.099/95 E ART. 344 DO CPC). CONSIDERANDO A RESTRICAO DE ACESSO DE PESSOAS AOS PREDIOS DOS FORUNS EM RAZAO DA PANDEMIA DE COVID-19, A AUDIENCIA DE CONCILIACAO E/OU CONCILIACAO, INSTRUCAO E JULGAMENTO SERA REALIZADA POR MEIO DE VIDEOCONFERENCIA, UTILIZANDO-SE A FERRAMENTA MICROSOFT TEAMS, VIA COMPUTADOR OU SMARTPHONE, NOS TERMOS DO COMUNICADO N 284/2020. INFORMEM AS PARTES, PREPOSTOS, ADVOGADOS E TESTEMUNHAS OS ENDERECOS DE E-MAIL PARA QUE OS CONVITES SEJAM OPORTUNAMENTE ENVIADOS. A PARTE SEM ADVOGADO DEVERA INFORMAR O SEU E-MAIL, BEM COMO O E-MAIL DE EVENTUAL TESTEMUNHA, ATRAVES DO PETICIONAMENTO ELETRONICO NO SITE (WWW.TJSP.JUS.BR), CASO POSSUA CERTIFICADO DIGITAL, OU POR PETICAO APRESENTADA EM CARTORIO, DE ACORDO COM PROVIMENTO CG N 09/2023, ARTIGOS 1 E 3 E COMUNICADO CG N 949/2020. NA HIPOTESE DE INTIMACAO ATRAVES DE MANDADO, O/A SR(A). OFICIAL DE JUSTICA DEVERA ANOTAR (DE FORMA LEGIVEL) O E-MAIL DA PARTE OU DA TESTEMUNHA INTIMADA. O NAO COMPARECIMENTO INJUSTIFICADO DAS PARTES IMPLICARA EM ATO ATENTATORIO A DIGNIDADE DA JUSTICA E NA APLICACAO DA MULTA ESTABELECIDA NO  8, BEM COMO, NOS TERMOS DA LEI 9.099/95, NA EXTINCAO DO PROCESSO COM RELACAO AO AUTOR E EM REVELIA COM RELACAO AO REU. AS PARTES REQUERENTE E REQUERIDA DEVERAO APRESENTAR OS DOCUMENTOS DIGITALIZADOS, QUE DEVERAO ACOMPANHAR NECESSARIAMENTE A INICIAL E A RESPOSTA, SOB PENA DE PRECLUSAO (ART. 434 DO CPC). APOS A RESPOSTA, AS PARTES DEVERAO ESPECIFICAR AS PROVAS QUE PRETENDEM PRODUZIR, FUNDAMENTADAMENTE, SOB PENA DE PRECLUSAO, NAO SERVINDO O PROTESTO GENERICO PELA PRODUCAO DE TODAS AS PROVAS PARA A FINALIDADE PRETENDIDA, O QUE ACARRETARA TAMBEM EM PRECLUSAO. SERVIRA O PRESENTE DESPACHO COMO MANDADO. INT.",
                "PublishDate": "2023-10-04T00:00:00",
                "CaptureDate": "2023-10-05T16:51:01"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0855/2023 TEOR DO ATO: VISTOS. DEIXO DE DESIGNAR AUDIENCIA UNICA DE CONCILIACAO, QUE PODERA SER REQUERIDA PELAS PARTES, CASO DESEJEM CONCILIAR, DEVENDO AGUARDAR A AUDIENCIA UNICA DE CONCILIACAO, SANEAMENTO, INSTRUCAO E JULGAMENTO. CITE-SE A REQUERIDA PARA RESPONDER, NO PRAZO DE 15 (QUINZE) DIAS, SOB AS PENAS DA LEI, NOS EXATOS TERMOS DO ART. 335, III DO CPC. CONSIGNE-SE NO MANDADO/DESPACHO QUE, NAO SENDO CONTESTADA A ACAO, PRESUMIR-SE-AO ACEITOS COMO VERDADEIROS OS FATOS ARTICULADOS PELA PARTE REQUERENTE (ART. 20 DA LEI N 9.099/95 E ART. 344 DO CPC). CONSIDERANDO A RESTRICAO DE ACESSO DE PESSOAS AOS PREDIOS DOS FORUNS EM RAZAO DA PANDEMIA DE COVID-19, A AUDIENCIA DE CONCILIACAO E/OU CONCILIACAO, INSTRUCAO E JULGAMENTO SERA REALIZADA POR MEIO DE VIDEOCONFERENCIA, UTILIZANDO-SE A FERRAMENTA MICROSOFT TEAMS, VIA COMPUTADOR OU SMARTPHONE, NOS TERMOS DO COMUNICADO N 284/2020. INFORMEM AS PARTES, PREPOSTOS, ADVOGADOS E TESTEMUNHAS OS ENDERECOS DE E-MAIL PARA QUE OS CONVITES SEJAM OPORTUNAMENTE ENVIADOS. A PARTE SEM ADVOGADO DEVERA INFORMAR O SEU E-MAIL, BEM COMO O E-MAIL DE EVENTUAL TESTEMUNHA, ATRAVES DO PETICIONAMENTO ELETRONICO NO SITE (WWW.TJSP.JUS.BR), CASO POSSUA CERTIFICADO DIGITAL, OU POR PETICAO APRESENTADA EM CARTORIO, DE ACORDO COM PROVIMENTO CG N 09/2023, ARTIGOS 1 E 3 E COMUNICADO CG N 949/2020. NA HIPOTESE DE INTIMACAO ATRAVES DE MANDADO, O/A SR(A). OFICIAL DE JUSTICA DEVERA ANOTAR (DE FORMA LEGIVEL) O E-MAIL DA PARTE OU DA TESTEMUNHA INTIMADA. O NAO COMPARECIMENTO INJUSTIFICADO DAS PARTES IMPLICARA EM ATO ATENTATORIO A DIGNIDADE DA JUSTICA E NA APLICACAO DA MULTA ESTABELECIDA NO  8, BEM COMO, NOS TERMOS DA LEI 9.099/95, NA EXTINCAO DO PROCESSO COM RELACAO AO AUTOR E EM REVELIA COM RELACAO AO REU. AS PARTES REQUERENTE E REQUERIDA DEVERAO APRESENTAR OS DOCUMENTOS DIGITALIZADOS, QUE DEVERAO ACOMPANHAR NECESSARIAMENTE A INICIAL E A RESPOSTA, SOB PENA DE PRECLUSAO (ART. 434 DO CPC). APOS A RESPOSTA, AS PARTES DEVERAO ESPECIFICAR AS PROVAS QUE PRETENDEM PRODUZIR, FUNDAMENTADAMENTE, SOB PENA DE PRECLUSAO, NAO SERVINDO O PROTESTO GENERICO PELA PRODUCAO DE TODAS AS PROVAS PARA A FINALIDADE PRETENDIDA, O QUE ACARRETARA TAMBEM EM PRECLUSAO. SERVIRA O PRESENTE DESPACHO COMO MANDADO. INT. ADVOGADOS(S): DANILO MARQUES PARDI (OAB 384895/SP)",
                "PublishDate": "2023-10-04T00:00:00",
                "CaptureDate": "2023-10-05T16:51:01"
              },
              {
                "Content": "CARTA DE CITACAO EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO E INTIMACAO - APRESENTAR DEFESA ESCRITA - SEM AUDIENCIA - JUIZADO",
                "PublishDate": "2023-10-04T00:00:00",
                "CaptureDate": "2023-10-05T16:51:01"
              },
              {
                "Content": "CARTA DE CITACAO EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO E INTIMACAO - APRESENTAR DEFESA ESCRITA - SEM AUDIENCIA - JUIZADO",
                "PublishDate": "2023-10-04T00:00:00",
                "CaptureDate": "2023-10-05T16:51:01"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-10-03T00:00:00",
                "CaptureDate": "2023-10-05T16:51:01"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2023-10-03T00:00:00",
                "CaptureDate": "2023-10-05T16:51:01"
              }
            ],
            "Petitions": [],
            "Decisions": []
          },
          {
            "Number": "10021329220238260103",
            "Type": "PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL",
            "MainSubject": "BANCARIOS",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "",
            "CourtDistrict": "CACONDE",
            "Judge": "GUILHERME MARTINS DAMINI",
            "JudgingBody": "JUIZADO ESPECIAL CIVEL E CRIMINAL",
            "State": "SP",
            "Status": "INDEFINIDO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "BANCÁRIOS",
            "InferredCNJSubjectNumber": 7752,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO DO JUIZADO ESPECIAL CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "BANCARIOS",
              "INDENIZACAO POR DANO MORAL"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 9960,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-10-05T00:00:00",
            "NoticeDate": "2023-10-03T00:00:00",
            "LastMovementDate": "2023-10-05T00:00:00",
            "CaptureDate": "2023-10-05T18:03:46",
            "LastUpdate": "2023-10-05T18:03:46",
            "NumberOfParties": 6,
            "NumberOfUpdates": 11,
            "LawSuitAge": 148,
            "AverageNumberOfUpdatesPerMonth": 2,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "10381073696",
                "IsPartyActive": true,
                "Name": "GUILHERME MARTINS DAMINI",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-10-05T18:03:46"
              },
              {
                "Doc": "36402341894",
                "IsPartyActive": true,
                "Name": "ELISABETE CRISTINA NEVES MACHADO",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-10-05T18:03:46"
              },
              {
                "Doc": "07022916683",
                "IsPartyActive": true,
                "Name": "JULIO CESAR FERNANDES SIQUEIRA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "468077",
                  "State": "SP",
                  "SpecificType": "ADVOGADO (REQTE)"
                },
                "LastCaptureDate": "2023-10-05T18:03:46"
              },
              {
                "Doc": "46189325000165",
                "IsPartyActive": true,
                "Name": "ITAU UNIBANCO S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-10-05T18:03:46"
              },
              {
                "Doc": "35624319000172",
                "IsPartyActive": true,
                "Name": "MK DIGITAL BANK INSTITUICAO DE PAGAMENTO S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-10-05T18:03:46"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-10-05T18:03:46"
              }
            ],
            "Updates": [
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0657/2023 DATA DA PUBLICACAO: 06/10/2023 NUMERO DO DIARIO: 3835",
                "PublishDate": "2023-10-05T00:00:00",
                "CaptureDate": "2023-10-05T18:03:47"
              },
              {
                "Content": "CARTA DE CITACAO EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO E INTIMACAO - APRESENTAR DEFESA ESCRITA - SEM AUDIENCIA - JUIZADO",
                "PublishDate": "2023-10-05T00:00:00",
                "CaptureDate": "2023-10-05T18:03:47"
              },
              {
                "Content": "CARTA DE CITACAO EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO E INTIMACAO - APRESENTAR DEFESA ESCRITA - SEM AUDIENCIA - JUIZADO",
                "PublishDate": "2023-10-05T00:00:00",
                "CaptureDate": "2023-10-05T18:03:47"
              },
              {
                "Content": "MANDADO DE CITACAO EXPEDIDO MANDADO N: 103.2023/005662-6 SITUACAO: AGUARDANDO CUMPRIMENTO EM 05/10/2023 13:00:57 LOCAL: CARTORIO DO JUIZADO ESPECIAL CIVEL E CRIMINAL",
                "PublishDate": "2023-10-05T00:00:00",
                "CaptureDate": "2023-10-05T18:03:47"
              },
              {
                "Content": "PROCESSO 1002132-92.2023.8.26.0103 - PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL - BANCARIOS - ELISABETE CRISTINA NEVES MACHADO - VISTOS. DIANTE DAS ESPECIFICIDADES DA CAUSA E DE MODO A ADEQUAR O RITO PROCESSUAL AS NECESSIDADES DO CONFLITO, DEIXO PARA MOMENTO OPORTUNO A ANALISE DA CONVENIENCIA DA AUDIENCIA DE CONCILIACAO (ART. 139, VI, CPC E ENUNCIADO N. 35, ENFAM). CITE(M)-SE O(A)(S) RE(U)(S), COM AS ADVERTENCIAS DE PRAXE, PARA APRESENTAR CONTESTACAO, NO PRAZO DE 15 (QUINZE) DIAS, CONTADOS DA DATA DA CITACAO. A AUSENCIA DE CONTESTACAO IMPLICARA REVELIA E PRESUNCAO DE VERACIDADE DA MATERIA FATICA APRESENTADA NA PETICAO INICIAL. TRATANDO-SE DE PROCESSO ELETRONICO, EM PRESTIGIO AS REGRAS FUNDAMENTAIS DOS ARTS. 4 E 6 DO CPC, FICA VEDADO O EXERCICIO DA FACULDADE PREVISTA NO ART. 340 DO CPC. DECORRIDO O PRAZO, DEVERA A PARTE AUTORA, EM 15 (QUINZE) DIAS, IMPUGNAR A CONTESTACAO. NA CONTESTACAO E EM REPLICA AS PARTES DEVERAO ESPECIFICAR AS PROVAS QUE EFETIVAMENTE PRETENDEM PRODUZIR, JUSTIFICANDO A SUA PERTINENCIA E RELEVANCIA, DE MANEIRA ESPECIFICA E FUNDAMENTADA, BEM COMO QUAL O PONTO CONTROVERTIDO QUE PRETENDEM ESCLARECER COM A SUA PRODUCAO, OU DIGAM EXPRESSAMENTE SOBRE EVENTUAL JULGAMENTO ANTECIPADO DA LIDE, SOB PENA DE PRECLUSAO. REQUERIMENTOS GENERICOS E SEM MOTIVACAO CONCRETA NAO SERAO ADMITIDOS, MAS INTERPRETADOS COMO ANUENCIA AO JULGAMENTO ANTECIPADO. EM HAVENDO INTERESSE NA PRODUCAO DE PROVA TESTEMUNHAL, SOB PENA DE PRECLUSAO, APRESENTE-SE, NA MESMA OPORTUNIDADE, O RESPECTIVO ROL, EM NUMERO NAO SUPERIOR A 3 (TRES) TESTEMUNHAS, RESSALVADA LIMITACAO POSTERIOR, LEVANDO-SE EM CONTA A COMPLEXIDADE DA CAUSA E DOS FATOS INDIVIDUALMENTE CONSIDERADOS, PARA FINS DE ORGANIZACAO DA PAUTA DE AUDIENCIAS DESTE JUIZO. AO FINAL, DEPOIS DE VERIFICADA PELO CARTORIO A INEXISTENCIA DE PENDENCIAS, RETORNEM OS AUTOS CONCLUSOS. NO MAIS, EM PRESTIGIO A CELERIDADE PROCESSUAL E AO DEVER DE COOPERACAO, DEVERAO AS PARTES NO DECORRER DO PROCESSO OBSERVAR A CORRETA CATEGORIZACAO DOS PETICIONAMENTOS ELETRONICOS, CONFORME MANUAL CONTIDO NO LINK: HTTPS://WWW.TJSP. JUS.BR/DOWNLOAD/PETICIONAMENTOELETRONICO/MANUALCOMPLEMENTOCADASTROPORTAL_V2.PDF. P.I. - ADV: JULIO CESAR FERNANDES SIQUEIRA (OAB 468077/SP)",
                "PublishDate": "2023-10-05T00:00:00",
                "CaptureDate": "2023-10-05T18:03:46"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0657/2023 TEOR DO ATO: VISTOS. DIANTE DAS ESPECIFICIDADES DA CAUSA E DE MODO A ADEQUAR O RITO PROCESSUAL AS NECESSIDADES DO CONFLITO, DEIXO PARA MOMENTO OPORTUNO A ANALISE DA CONVENIENCIA DA AUDIENCIA DE CONCILIACAO (ART. 139, VI, CPC E ENUNCIADO N. 35, ENFAM). CITE(M)-SE O(A)(S) RE(U)(S), COM AS ADVERTENCIAS DE PRAXE, PARA APRESENTAR CONTESTACAO, NO PRAZO DE 15 (QUINZE) DIAS, CONTADOS DA DATA DA CITACAO. A AUSENCIA DE CONTESTACAO IMPLICARA REVELIA E PRESUNCAO DE VERACIDADE DA MATERIA FATICA APRESENTADA NA PETICAO INICIAL. TRATANDO-SE DE PROCESSO ELETRONICO, EM PRESTIGIO AS REGRAS FUNDAMENTAIS DOS ARTS. 4 E 6 DO CPC, FICA VEDADO O EXERCICIO DA FACULDADE PREVISTA NO ART. 340 DO CPC. DECORRIDO O PRAZO, DEVERA A PARTE AUTORA, EM 15 (QUINZE) DIAS, IMPUGNAR A CONTESTACAO. NA CONTESTACAO E EM REPLICA AS PARTES DEVERAO ESPECIFICAR AS PROVAS QUE EFETIVAMENTE PRETENDEM PRODUZIR, JUSTIFICANDO A SUA PERTINENCIA E RELEVANCIA, DE MANEIRA ESPECIFICA E FUNDAMENTADA, BEM COMO QUAL O PONTO CONTROVERTIDO QUE PRETENDEM ESCLARECER COM A SUA PRODUCAO, OU DIGAM EXPRESSAMENTE SOBRE EVENTUAL JULGAMENTO ANTECIPADO DA LIDE, SOB PENA DE PRECLUSAO. REQUERIMENTOS GENERICOS E SEM MOTIVACAO CONCRETA NAO SERAO ADMITIDOS, MAS INTERPRETADOS COMO ANUENCIA AO JULGAMENTO ANTECIPADO. EM HAVENDO INTERESSE NA PRODUCAO DE PROVA TESTEMUNHAL, SOB PENA DE PRECLUSAO, APRESENTE-SE, NA MESMA OPORTUNIDADE, O RESPECTIVO ROL, EM NUMERO NAO SUPERIOR A 3 (TRES) TESTEMUNHAS, RESSALVADA LIMITACAO POSTERIOR, LEVANDO-SE EM CONTA A COMPLEXIDADE DA CAUSA E DOS FATOS INDIVIDUALMENTE CONSIDERADOS, PARA FINS DE ORGANIZACAO DA PAUTA DE AUDIENCIAS DESTE JUIZO. AO FINAL, DEPOIS DE VERIFICADA PELO CARTORIO A INEXISTENCIA DE PENDENCIAS, RETORNEM OS AUTOS CONCLUSOS. NO MAIS, EM PRESTIGIO A CELERIDADE PROCESSUAL E AO DEVER DE COOPERACAO, DEVERAO AS PARTES NO DECORRER DO PROCESSO OBSERVAR A CORRETA CATEGORIZACAO DOS PETICIONAMENTOS ELETRONICOS, CONFORME MANUAL CONTIDO NO LINK: HTTPS://WWW.TJSP.JUS.BR/DOWNLOAD/PETICIONAMENTOELETRONICO/MANUALCOMPLEMENTOCADASTROPORTAL_V2.PDF. P.I. ADVOGADOS(S): JULIO CESAR FERNANDES SIQUEIRA (OAB 468077/SP)",
                "PublishDate": "2023-10-04T00:00:00",
                "CaptureDate": "2023-10-05T18:03:47"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-10-03T00:00:00",
                "CaptureDate": "2023-10-05T18:03:47"
              },
              {
                "Content": "CERTIDAO DE CARTORIO EXPEDIDA CERTIFICO E DOU FE QUE NAO ENCONTREI DIVERGENCIA ENTRE OS DADOS LANCADOS NO CADASTRO E OS CONSTANTES DA PETICAO INICIAL/DOCUMENTOS. NADA MAIS.",
                "PublishDate": "2023-10-03T00:00:00",
                "CaptureDate": "2023-10-05T18:03:47"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2023-10-03T00:00:00",
                "CaptureDate": "2023-10-05T18:03:47"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2023-10-03T00:00:00",
                "CaptureDate": "2023-10-05T18:03:47"
              },
              {
                "Content": "RECEBIDA A PETICAO INICIAL - CITACAO POR CARTA AR VISTOS. DIANTE DAS ESPECIFICIDADES DA CAUSA E DE MODO A ADEQUAR O RITO PROCESSUAL AS NECESSIDADES DO CONFLITO, DEIXO PARA MOMENTO OPORTUNO A ANALISE DA CONVENIENCIA DA AUDIENCIA DE CONCILIACAO (ART. 139, VI, CPC E ENUNCIADO N. 35, ENFAM). CITE(M)-SE O(A)(S) RE(U)(S), COM AS ADVERTENCIAS DE PRAXE, PARA APRESENTAR CONTESTACAO, NO PRAZO DE 15 (QUINZE) DIAS, CONTADOS DA DATA DA CITACAO. A AUSENCIA DE CONTESTACAO IMPLICARA REVELIA E PRESUNCAO DE VERACIDADE DA MATERIA FATICA APRESENTADA NA PETICAO INICIAL. TRATANDO-SE DE PROCESSO ELETRONICO, EM PRESTIGIO AS REGRAS FUNDAMENTAIS DOS ARTS. 4 E 6 DO CPC, FICA VEDADO O EXERCICIO DA FACULDADE PREVISTA NO ART. 340 DO CPC. DECORRIDO O PRAZO, DEVERA A PARTE AUTORA, EM 15 (QUINZE) DIAS, IMPUGNAR A CONTESTACAO. NA CONTESTACAO E EM REPLICA AS PARTES DEVERAO ESPECIFICAR AS PROVAS QUE EFETIVAMENTE PRETENDEM PRODUZIR, JUSTIFICANDO A SUA PERTINENCIA E RELEVANCIA, DE MANEIRA ESPECIFICA E FUNDAMENTADA, BEM COMO QUAL O PONTO CONTROVERTIDO QUE PRETENDEM ESCLARECER COM A SUA PRODUCAO, OU DIGAM EXPRESSAMENTE SOBRE EVENTUAL JULGAMENTO ANTECIPADO DA LIDE, SOB PENA DE PRECLUSAO. REQUERIMENTOS GENERICOS E SEM MOTIVACAO CONCRETA NAO SERAO ADMITIDOS, MAS INTERPRETADOS COMO ANUENCIA AO JULGAMENTO ANTECIPADO. EM HAVENDO INTERESSE NA PRODUCAO DE PROVA TESTEMUNHAL, SOB PENA DE PRECLUSAO, APRESENTE-SE, NA MESMA OPORTUNIDADE, O RESPECTIVO ROL, EM NUMERO NAO SUPERIOR A 3 (TRES) TESTEMUNHAS, RESSALVADA LIMITACAO POSTERIOR, LEVANDO-SE EM CONTA A COMPLEXIDADE DA CAUSA E DOS FATOS INDIVIDUALMENTE CONSIDERADOS, PARA FINS DE ORGANIZACAO DA PAUTA DE AUDIENCIAS DESTE JUIZO. AO FINAL, DEPOIS DE VERIFICADA PELO CARTORIO A INEXISTENCIA DE PENDENCIAS, RETORNEM OS AUTOS CONCLUSOS. NO MAIS, EM PRESTIGIO A CELERIDADE PROCESSUAL E AO DEVER DE COOPERACAO, DEVERAO AS PARTES NO DECORRER DO PROCESSO OBSERVAR A CORRETA CATEGORIZACAO DOS PETICIONAMENTOS ELETRONICOS, CONFORME MANUAL CONTIDO NO LINK: HTTPS://WWW.TJSP.JUS.BR/DOWNLOAD/PETICIONAMENTOELETRONICO/MANUALCOMPLEMENTOCADASTROPORTAL_V2.PDF. P.I.",
                "PublishDate": "2023-10-03T00:00:00",
                "CaptureDate": "2023-10-05T18:03:47"
              }
            ],
            "Petitions": [],
            "Decisions": []
          },
          {
            "Number": "10133183520238260161",
            "Type": "PROCEDIMENTO COMUM",
            "MainSubject": "PRATICAS ABUSIVAS",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "DIADEMA",
            "Judge": "ANDRE PASQUALE ROCCO SCAVONE",
            "JudgingBody": "2 VARA CIVEL",
            "State": "SP",
            "Status": "ATIVO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "PRÁTICAS ABUSIVAS",
            "InferredCNJSubjectNumber": 11811,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "PRATICAS ABUSIVAS",
              "PERDAS E DANOS"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 28190,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-10-06T00:00:00",
            "NoticeDate": "2023-10-03T00:00:00",
            "LastMovementDate": "2023-10-06T00:00:00",
            "CaptureDate": "2023-10-06T21:22:34",
            "LastUpdate": "2023-10-06T21:22:34",
            "NumberOfParties": 7,
            "NumberOfUpdates": 9,
            "LawSuitAge": 148,
            "AverageNumberOfUpdatesPerMonth": 1,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "08226519802",
                "IsPartyActive": true,
                "Name": "ANDRE PASQUALE ROCCO SCAVONE",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-10-06T21:22:34"
              },
              {
                "Doc": "43458275827",
                "IsPartyActive": true,
                "Name": "FABIO ALVES DE SOUZA",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-10-06T21:22:34"
              },
              {
                "IsPartyActive": true,
                "Name": "GUILHERME RIBEIRO SILVA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "476452",
                  "State": "SP",
                  "SpecificType": "ADVOGADO (REQTE)"
                },
                "LastCaptureDate": "2023-10-06T21:22:34"
              },
              {
                "Doc": "48472928000103",
                "IsPartyActive": true,
                "Name": "KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-10-06T21:22:34"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-10-06T21:22:34"
              },
              {
                "Doc": "48689840000130",
                "IsPartyActive": true,
                "Name": "CASH PAY MEIOS DE PAGAMENTO LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-10-06T21:22:34"
              },
              {
                "Doc": "35624319000172",
                "IsPartyActive": true,
                "Name": "MK DIGITAL BANK INSTITUICAO DE PAGAMENTO S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-10-06T21:22:34"
              }
            ],
            "Updates": [
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0762/2023 DATA DA PUBLICACAO: 09/10/2023 NUMERO DO DIARIO: 3836",
                "PublishDate": "2023-10-06T00:00:00",
                "CaptureDate": "2023-10-06T21:22:35"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2023-10-06T00:00:00",
                "CaptureDate": "2023-10-06T21:22:35"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE FLS. 73/4: TENDO EM VISTA A MANIFESTACAO RETRO, REMETA-SE AO DISTRIBUIDOR PARA REDISTRIBUICAO A UMA DAS VARAS CIVEIS DO FORO REGIONAL DE JABAQUARA, DOMICILIO DO AUTOR. INT.",
                "PublishDate": "2023-10-06T00:00:00",
                "CaptureDate": "2023-10-06T21:22:35"
              },
              {
                "Content": "PROCESSO 1013318-35.2023.8.26.0161 - PROCEDIMENTO COMUM CIVEL - PRATICAS ABUSIVAS - FABIO ALVES DE SOUZA - JUNTE O AUTOR COMPROVANTE DE RESIDENCIA NESTA COMARCA, TENDO EM VISTA QUE O CEP INDICADO NA INICIAL E DE SAO PAULO (CONFORME DOCUMENTO DE FLS.28). PRAZO: 05 DIAS. INT. - ADV: GUILHERME RIBEIRO SILVA (OAB 476452/SP)",
                "PublishDate": "2023-10-06T00:00:00",
                "CaptureDate": "2023-10-06T21:22:34"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0762/2023 TEOR DO ATO: JUNTE O AUTOR COMPROVANTE DE RESIDENCIA NESTA COMARCA, TENDO EM VISTA QUE O CEP INDICADO NA INICIAL E DE SAO PAULO (CONFORME DOCUMENTO DE FLS.28). PRAZO: 05 DIAS. INT. ADVOGADOS(S): GUILHERME RIBEIRO SILVA (OAB 476452/SP)",
                "PublishDate": "2023-10-05T00:00:00",
                "CaptureDate": "2023-10-06T21:22:35"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WDDA.23.70171873-3 TIPO DA PETICAO: PETICAO INTERMEDIARIA DATA: 04/10/2023 17:14",
                "PublishDate": "2023-10-05T00:00:00",
                "CaptureDate": "2023-10-06T21:22:35"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2023-10-04T00:00:00",
                "CaptureDate": "2023-10-06T21:22:35"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE JUNTE O AUTOR COMPROVANTE DE RESIDENCIA NESTA COMARCA, TENDO EM VISTA QUE O CEP INDICADO NA INICIAL E DE SAO PAULO (CONFORME DOCUMENTO DE FLS.28). PRAZO: 05 DIAS. INT.",
                "PublishDate": "2023-10-04T00:00:00",
                "CaptureDate": "2023-10-06T21:22:35"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-10-03T00:00:00",
                "CaptureDate": "2023-10-06T21:22:35"
              }
            ],
            "Petitions": [
              {
                "Type": "PETICAO INTERMEDIARIA",
                "Author": "",
                "CreationDate": "2023-10-04T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              }
            ],
            "Decisions": []
          },
          {
            "Number": "10133547720238260161",
            "Type": "PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL",
            "MainSubject": "INDENIZACAO POR DANO MORAL",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "ESPECIAL CIVEL",
            "CourtDistrict": "DIADEMA",
            "Judge": "LUIZ FERNANDO PARREIRA MILENA",
            "JudgingBody": "VARA DO JUIZADO ESPECIAL CIVEL",
            "State": "SP",
            "Status": "INDEFINIDO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "INDENIZAÇÃO POR DANO MORAL",
            "InferredCNJSubjectNumber": 7779,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO DO JUIZADO ESPECIAL CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "INDENIZACAO POR DANO MORAL",
              "INDENIZACAO POR DANO MATERIAL"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 13580,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-10-10T00:00:00",
            "NoticeDate": "2023-10-04T00:00:00",
            "LastMovementDate": "2023-10-10T00:00:00",
            "CaptureDate": "2023-10-10T19:44:56",
            "LastUpdate": "2023-10-10T19:44:56",
            "NumberOfParties": 11,
            "NumberOfUpdates": 6,
            "LawSuitAge": 147,
            "AverageNumberOfUpdatesPerMonth": 1,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "09180382860",
                "IsPartyActive": true,
                "Name": "LUIZ FERNANDO PARREIRA MILENA",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-10-10T19:44:56"
              },
              {
                "Doc": "30567342824",
                "IsPartyActive": true,
                "Name": "REGINA PEREIRA",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-10-10T19:44:56"
              },
              {
                "IsPartyActive": true,
                "Name": "GILSON DE OLIVEIRA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "366478",
                  "State": "SP",
                  "SpecificType": "ADVOGADO (REQTE)"
                },
                "LastCaptureDate": "2023-10-10T19:44:56"
              },
              {
                "Doc": "30651405866",
                "IsPartyActive": true,
                "Name": "FABIANA DE ABREU FARIAS OLIVEIRA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "SpecificType": "ADVOGADA (REQTE)"
                },
                "LastCaptureDate": "2023-10-10T19:44:56"
              },
              {
                "IsPartyActive": true,
                "Name": "FERNANDO OLIVEIRA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "264308",
                  "State": "SP",
                  "SpecificType": "ADVOGADO (REQTE)"
                },
                "LastCaptureDate": "2023-10-10T19:44:56"
              },
              {
                "IsPartyActive": true,
                "Name": "PICPAY INTITUICAO DE PAGAMENTO S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-10-10T19:44:56"
              },
              {
                "IsPartyActive": true,
                "Name": "XP INVESTIMENTOS CORRETORA DE CAMBIOS, TITULOS E VALORES MOBILIARIOS S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-10-10T19:44:56"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-10-10T19:44:56"
              },
              {
                "Doc": "35624319000172",
                "IsPartyActive": true,
                "Name": "MK DIGITAL BANK INSTITUICAO DE PAGAMENTO S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-10-10T19:44:56"
              },
              {
                "Doc": "48472928000103",
                "IsPartyActive": true,
                "Name": "KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-10-10T19:44:56"
              },
              {
                "Doc": "48689840000130",
                "IsPartyActive": true,
                "Name": "CASH PAY MEIOS DE PAGAMENTO LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-10-10T19:44:56"
              }
            ],
            "Updates": [
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0603/2023 DATA DA PUBLICACAO: 11/10/2023 NUMERO DO DIARIO: 3838",
                "PublishDate": "2023-10-10T00:00:00",
                "CaptureDate": "2023-10-10T19:44:57"
              },
              {
                "Content": "PROCESSO 1013354-77.2023.8.26.0161 - PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL - INDENIZACAO POR DANO MORAL - REGINA PEREIRA - INDEFIRO A TUTELA ANTECIPADA, JA QUE NAO HA QUE SE FALAR EM PROBABILIDADE DO DIREITO A EMBASAR, AO MENOS POR ORA, A CONCESSAO DA MEDIDA PLEITEADA. ADEMAIS, OS FATOS ARTICULADOS NA PETICAO INICIAL DEPENDEM DE COGNICAO MAIS ABRANGENTE, SOMENTE OBTIDA ATRAVES DA INSTRUCAO REGULAR. NO MAIS, DEVERA A PARTE AUTORA, NO PRAZO DE 5 DIAS, JUNTAR AOS AUTOS COMPROVANTE ATUALIZADO E EM NOME PROPRIO DE SEU ENDERECO, SOB PENA DE EXTINCAO. APOS, TORNEM - ADV: FERNANDO OLIVEIRA (OAB 264308/SP), GILSON DE OLIVEIRA (OAB 366478/SP)",
                "PublishDate": "2023-10-10T00:00:00",
                "CaptureDate": "2023-10-10T19:44:56"
              },
              {
                "Content": "NAO CONCEDIDA A ANTECIPACAO DE TUTELA INDEFIRO A TUTELA ANTECIPADA, JA QUE NAO HA QUE SE FALAR EM PROBABILIDADE DO DIREITO A EMBASAR, AO MENOS POR ORA, A CONCESSAO DA MEDIDA PLEITEADA. ADEMAIS, OS FATOS ARTICULADOS NA PETICAO INICIAL DEPENDEM DE COGNICAO MAIS ABRANGENTE, SOMENTE OBTIDA ATRAVES DA INSTRUCAO REGULAR. NO MAIS, DEVERA A PARTE AUTORA, NO PRAZO DE 5 DIAS, JUNTAR AOS AUTOS COMPROVANTE ATUALIZADO E EM NOME PROPRIO DE SEU ENDERECO, SOB PENA DE EXTINCAO. APOS, TORNEM",
                "PublishDate": "2023-10-09T00:00:00",
                "CaptureDate": "2023-10-10T19:44:57"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0603/2023 TEOR DO ATO: INDEFIRO A TUTELA ANTECIPADA, JA QUE NAO HA QUE SE FALAR EM PROBABILIDADE DO DIREITO A EMBASAR, AO MENOS POR ORA, A CONCESSAO DA MEDIDA PLEITEADA. ADEMAIS, OS FATOS ARTICULADOS NA PETICAO INICIAL DEPENDEM DE COGNICAO MAIS ABRANGENTE, SOMENTE OBTIDA ATRAVES DA INSTRUCAO REGULAR. NO MAIS, DEVERA A PARTE AUTORA, NO PRAZO DE 5 DIAS, JUNTAR AOS AUTOS COMPROVANTE ATUALIZADO E EM NOME PROPRIO DE SEU ENDERECO, SOB PENA DE EXTINCAO. APOS, TORNEM ADVOGADOS(S): FERNANDO OLIVEIRA (OAB 264308/SP), GILSON DE OLIVEIRA (OAB 366478/SP)",
                "PublishDate": "2023-10-09T00:00:00",
                "CaptureDate": "2023-10-10T19:44:57"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2023-10-06T00:00:00",
                "CaptureDate": "2023-10-10T19:44:57"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-10-04T00:00:00",
                "CaptureDate": "2023-10-10T19:44:57"
              }
            ],
            "Petitions": [],
            "Decisions": []
          },
          {
            "Number": "10010275520238260370",
            "Type": "PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL",
            "MainSubject": "RESCISAO DO CONTRATO E DEVOLUCAO DO DINHEIRO",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "",
            "CourtDistrict": "MONTE AZUL PAULISTA",
            "Judge": "AYMAN RAMADAN",
            "JudgingBody": "JUIZADO ESPECIAL CIVEL E CRIMINAL",
            "State": "SP",
            "Status": "ATIVO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "RESCISÃO DO CONTRATO E DEVOLUÇÃO DO DINHEIRO",
            "InferredCNJSubjectNumber": 7768,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO DO JUIZADO ESPECIAL CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "RESCISAO DO CONTRATO E DEVOLUCAO DO DINHEIRO"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 20000,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-10-11T00:00:00",
            "NoticeDate": "2023-10-02T00:00:00",
            "LastMovementDate": "2023-10-11T00:00:00",
            "CaptureDate": "2023-10-12T05:00:08",
            "LastUpdate": "2023-10-12T05:00:08",
            "NumberOfParties": 6,
            "NumberOfUpdates": 10,
            "LawSuitAge": 149,
            "AverageNumberOfUpdatesPerMonth": 2,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "29591772823",
                "IsPartyActive": true,
                "Name": "AYMAN RAMADAN",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-10-12T05:00:08"
              },
              {
                "Doc": "40427638801",
                "IsPartyActive": true,
                "Name": "ALESSANDRA PEREIRA DA SILVA SOARES FERREIRA",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-10-12T05:00:08"
              },
              {
                "Doc": "21324830867",
                "IsPartyActive": true,
                "Name": "RICARDO FAJAN TONELLI",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "343425",
                  "State": "SP",
                  "SpecificType": "ADVOGADO (REQTE)"
                },
                "LastCaptureDate": "2023-10-12T05:00:08"
              },
              {
                "Doc": "21225451000",
                "IsPartyActive": true,
                "Name": "JOSE CARLOS BONETO",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-10-12T05:00:08"
              },
              {
                "Doc": "97140909000187",
                "IsPartyActive": true,
                "Name": "J C BONETO DISTRIBUIDORA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-10-12T05:00:08"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-10-12T05:00:08"
              }
            ],
            "Updates": [
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0507/2023 DATA DA PUBLICACAO: 16/10/2023 NUMERO DO DIARIO: 3839",
                "PublishDate": "2023-10-11T00:00:00",
                "CaptureDate": "2023-10-12T05:00:08"
              },
              {
                "Content": "DESIGNADA AUDIENCIA DE CONCILIACAO CONCILIACAO DATA: 30/11/2023 HORA 14:10 LOCAL: SALA DE AUDIENCIA DO JUIZADO ESPECIAL SITUACAO: PENDENTE",
                "PublishDate": "2023-10-11T00:00:00",
                "CaptureDate": "2023-10-12T05:00:08"
              },
              {
                "Content": "CARTA DE CITACAO EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO E INTIMACAO - AUDIENCIA VIRTUAL DE CONCILIACAO - JUIZADO",
                "PublishDate": "2023-10-11T00:00:00",
                "CaptureDate": "2023-10-12T05:00:08"
              },
              {
                "Content": "CARTA DE CITACAO EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO E INTIMACAO - AUDIENCIA VIRTUAL DE CONCILIACAO - JUIZADO",
                "PublishDate": "2023-10-11T00:00:00",
                "CaptureDate": "2023-10-12T05:00:08"
              },
              {
                "Content": "CARTA DE CITACAO EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO E INTIMACAO - AUDIENCIA VIRTUAL DE CONCILIACAO - JUIZADO",
                "PublishDate": "2023-10-11T00:00:00",
                "CaptureDate": "2023-10-12T05:00:08"
              },
              {
                "Content": "PROCESSO 1001027-55.2023.8.26.0370 - PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL - RESCISAO DO CONTRATO E DEVOLUCAO DO DINHEIRO - ALESSANDRA PEREIRA DA SILVA SOARES FERREIRA - DESTA FEITA, INDEFIRO, POR ORA, O PEDIDO DE TUTELA DE URGENCIA. CONSIDERANDO O DISPOSTO NO COMUNICADO N 284/2020, EMITIDO PELO TRIBUNAL DE JUSTICA DO ESTADO DE SAO PAULO, AS AUDIENCIAS PODERAO SER REALIZADAS POR MEIO DE VIDEOCONFERENCIA, A CRITERIO DO MAGISTRADO RESPONSAVEL, UTILIZANDO A FERRAMENTA MICROSOFT TEAMS (QUE NAO PRECISA ESTAR INSTALADA NO COMPUTADOR DAS PARTES, ADVOGADOS E TESTEMUNHAS), VIA COMPUTADOR OU SMARTPHONE, OBSERVANDO- SE QUE A ANUENCIA DAS PARTES PODERA SER DISPENSADA, A CRITERIO DO MAGISTRADO, NA HIPOTESE DE PERECIMENTO DE DIREITO, DESIGNO A AUDIENCIA DE CONCILIACAO PARA O DIA 30 DE NOVEMBRO DE 2023, AS 14:10 HORAS, POR MEIO DE VIDEO CONFERENCIA, OPORTUNIDADE EM QUE O(A)(S) REQUERIDO(A)(S) PODERA(AO) OFERECER CONTESTACAO, SOB PENA DE REVELIA. CITEM-SE O(A)(S) REQUERIDO(A)(S) DOS TERMOS DA ACAO, EXPEDINDO-SE CARTA DE CITACAO E INTIMACAO. INTIME-SE. - ADV: RICARDO FAJAN TONELLI (OAB 343425/SP)",
                "PublishDate": "2023-10-11T00:00:00",
                "CaptureDate": "2023-10-12T05:00:08"
              },
              {
                "Content": "NAO CONCEDIDA A ANTECIPACAO DE TUTELA DESTA FEITA, INDEFIRO, POR ORA, O PEDIDO DE TUTELA DE URGENCIA. CONSIDERANDO O DISPOSTO NO COMUNICADO N 284/2020, EMITIDO PELO TRIBUNAL DE JUSTICA DO ESTADO DE SAO PAULO, AS AUDIENCIAS PODERAO SER REALIZADAS POR MEIO DE VIDEOCONFERENCIA, A CRITERIO DO MAGISTRADO RESPONSAVEL, UTILIZANDO A FERRAMENTA MICROSOFT TEAMS (QUE NAO PRECISA ESTAR INSTALADA NO COMPUTADOR DAS PARTES, ADVOGADOS E TESTEMUNHAS), VIA COMPUTADOR OU SMARTPHONE, OBSERVANDO-SE QUE A ANUENCIA DAS PARTES PODERA SER DISPENSADA, A CRITERIO DO MAGISTRADO, NA HIPOTESE DE PERECIMENTO DE DIREITO, DESIGNO A AUDIENCIA DE CONCILIACAO PARA O DIA 30 DE NOVEMBRO DE 2023, AS 14:10 HORAS, POR MEIO DE VIDEO CONFERENCIA, OPORTUNIDADE EM QUE O(A)(S) REQUERIDO(A)(S) PODERA(AO) OFERECER CONTESTACAO, SOB PENA DE REVELIA. CITEM-SE O(A)(S) REQUERIDO(A)(S) DOS TERMOS DA ACAO, EXPEDINDO-SE CARTA DE CITACAO E INTIMACAO. INTIME-SE.",
                "PublishDate": "2023-10-10T00:00:00",
                "CaptureDate": "2023-10-12T05:00:08"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0507/2023 TEOR DO ATO: DESTA FEITA, INDEFIRO, POR ORA, O PEDIDO DE TUTELA DE URGENCIA. CONSIDERANDO O DISPOSTO NO COMUNICADO N 284/2020, EMITIDO PELO TRIBUNAL DE JUSTICA DO ESTADO DE SAO PAULO, AS AUDIENCIAS PODERAO SER REALIZADAS POR MEIO DE VIDEOCONFERENCIA, A CRITERIO DO MAGISTRADO RESPONSAVEL, UTILIZANDO A FERRAMENTA MICROSOFT TEAMS (QUE NAO PRECISA ESTAR INSTALADA NO COMPUTADOR DAS PARTES, ADVOGADOS E TESTEMUNHAS), VIA COMPUTADOR OU SMARTPHONE, OBSERVANDO-SE QUE A ANUENCIA DAS PARTES PODERA SER DISPENSADA, A CRITERIO DO MAGISTRADO, NA HIPOTESE DE PERECIMENTO DE DIREITO, DESIGNO A AUDIENCIA DE CONCILIACAO PARA O DIA 30 DE NOVEMBRO DE 2023, AS 14:10 HORAS, POR MEIO DE VIDEO CONFERENCIA, OPORTUNIDADE EM QUE O(A)(S) REQUERIDO(A)(S) PODERA(AO) OFERECER CONTESTACAO, SOB PENA DE REVELIA. CITEM-SE O(A)(S) REQUERIDO(A)(S) DOS TERMOS DA ACAO, EXPEDINDO-SE CARTA DE CITACAO E INTIMACAO. INTIME-SE. ADVOGADOS(S): RICARDO FAJAN TONELLI (OAB 343425/SP)",
                "PublishDate": "2023-10-10T00:00:00",
                "CaptureDate": "2023-10-12T05:00:08"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2023-10-03T00:00:00",
                "CaptureDate": "2023-10-12T05:00:08"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-10-02T00:00:00",
                "CaptureDate": "2023-10-12T05:00:08"
              }
            ],
            "Petitions": [],
            "Decisions": []
          },
          {
            "Number": "10010267020238260370",
            "Type": "PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL",
            "MainSubject": "RESCISAO DO CONTRATO E DEVOLUCAO DO DINHEIRO",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "",
            "CourtDistrict": "MONTE AZUL PAULISTA",
            "Judge": "AYMAN RAMADAN",
            "JudgingBody": "JUIZADO ESPECIAL CIVEL E CRIMINAL",
            "State": "SP",
            "Status": "ATIVO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "RESCISÃO DO CONTRATO E DEVOLUÇÃO DO DINHEIRO",
            "InferredCNJSubjectNumber": 7768,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO DO JUIZADO ESPECIAL CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "RESCISAO DO CONTRATO E DEVOLUCAO DO DINHEIRO"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 30000,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-10-11T00:00:00",
            "NoticeDate": "2023-10-02T00:00:00",
            "LastMovementDate": "2023-10-11T00:00:00",
            "CaptureDate": "2023-10-12T05:02:02",
            "LastUpdate": "2023-10-12T05:02:02",
            "NumberOfParties": 6,
            "NumberOfUpdates": 10,
            "LawSuitAge": 149,
            "AverageNumberOfUpdatesPerMonth": 2,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "29591772823",
                "IsPartyActive": true,
                "Name": "AYMAN RAMADAN",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-10-12T05:02:02"
              },
              {
                "Doc": "39676508802",
                "IsPartyActive": true,
                "Name": "DIONE HENRIQUE BEME TREVISAN",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-10-12T05:02:02"
              },
              {
                "Doc": "21324830867",
                "IsPartyActive": true,
                "Name": "RICARDO FAJAN TONELLI",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "343425",
                  "State": "SP",
                  "SpecificType": "ADVOGADO (REQTE)"
                },
                "LastCaptureDate": "2023-10-12T05:02:02"
              },
              {
                "Doc": "21225451000",
                "IsPartyActive": true,
                "Name": "JOSE CARLOS BONETO",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-10-12T05:02:02"
              },
              {
                "Doc": "97140909000187",
                "IsPartyActive": true,
                "Name": "J C BONETO DISTRIBUIDORA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-10-12T05:02:02"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-10-12T05:02:02"
              }
            ],
            "Updates": [
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0506/2023 DATA DA PUBLICACAO: 16/10/2023 NUMERO DO DIARIO: 3839",
                "PublishDate": "2023-10-11T00:00:00",
                "CaptureDate": "2023-10-12T05:02:02"
              },
              {
                "Content": "DESIGNADA AUDIENCIA DE CONCILIACAO CONCILIACAO DATA: 30/11/2023 HORA 14:00 LOCAL: SALA DE AUDIENCIA DO JUIZADO ESPECIAL SITUACAO: PENDENTE",
                "PublishDate": "2023-10-11T00:00:00",
                "CaptureDate": "2023-10-12T05:02:02"
              },
              {
                "Content": "CARTA DE CITACAO EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO E INTIMACAO - AUDIENCIA VIRTUAL DE CONCILIACAO - JUIZADO",
                "PublishDate": "2023-10-11T00:00:00",
                "CaptureDate": "2023-10-12T05:02:02"
              },
              {
                "Content": "CARTA DE CITACAO EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO E INTIMACAO - AUDIENCIA VIRTUAL DE CONCILIACAO - JUIZADO",
                "PublishDate": "2023-10-11T00:00:00",
                "CaptureDate": "2023-10-12T05:02:02"
              },
              {
                "Content": "CARTA DE CITACAO EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO E INTIMACAO - AUDIENCIA VIRTUAL DE CONCILIACAO - JUIZADO",
                "PublishDate": "2023-10-11T00:00:00",
                "CaptureDate": "2023-10-12T05:02:02"
              },
              {
                "Content": "PROCESSO 1001026-70.2023.8.26.0370 - PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL - RESCISAO DO CONTRATO E DEVOLUCAO DO DINHEIRO - DIONE HENRIQUE BEME TREVISAN - DESTA FEITA, INDEFIRO, POR ORA, O PEDIDO DE TUTELA DE URGENCIA. CONSIDERANDO O DISPOSTO NO COMUNICADO N 284/2020, EMITIDO PELO TRIBUNAL DE JUSTICA DO ESTADO DE SAO PAULO, AS AUDIENCIAS PODERAO SER REALIZADAS POR MEIO DE VIDEOCONFERENCIA, A CRITERIO DO MAGISTRADO RESPONSAVEL, UTILIZANDO A FERRAMENTA MICROSOFT TEAMS (QUE NAO PRECISA ESTAR INSTALADA NO COMPUTADOR DAS PARTES, ADVOGADOS E TESTEMUNHAS), VIA COMPUTADOR OU SMARTPHONE, OBSERVANDO- SE QUE A ANUENCIA DAS PARTES PODERA SER DISPENSADA, A CRITERIO DO MAGISTRADO, NA HIPOTESE DE PERECIMENTO DE DIREITO, DESIGNO A AUDIENCIA DE CONCILIACAO PARA O DIA 30 DE NOVEMBRO DE 2023, AS 14:00 HORAS, POR MEIO DE VIDEO CONFERENCIA, OPORTUNIDADE EM QUE O(A)(S) REQUERIDO(A)(S) PODERA(AO) OFERECER CONTESTACAO, SOB PENA DE REVELIA. CITEM-SE O(A)(S) REQUERIDO(A)(S) DOS TERMOS DA ACAO, EXPEDINDO-SE CARTA DE CITACAO E INTIMACAO. INTIME-SE. - ADV: RICARDO FAJAN TONELLI (OAB 343425/SP)",
                "PublishDate": "2023-10-11T00:00:00",
                "CaptureDate": "2023-10-12T05:02:02"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0506/2023 TEOR DO ATO: DESTA FEITA, INDEFIRO, POR ORA, O PEDIDO DE TUTELA DE URGENCIA. CONSIDERANDO O DISPOSTO NO COMUNICADO N 284/2020, EMITIDO PELO TRIBUNAL DE JUSTICA DO ESTADO DE SAO PAULO, AS AUDIENCIAS PODERAO SER REALIZADAS POR MEIO DE VIDEOCONFERENCIA, A CRITERIO DO MAGISTRADO RESPONSAVEL, UTILIZANDO A FERRAMENTA MICROSOFT TEAMS (QUE NAO PRECISA ESTAR INSTALADA NO COMPUTADOR DAS PARTES, ADVOGADOS E TESTEMUNHAS), VIA COMPUTADOR OU SMARTPHONE, OBSERVANDO-SE QUE A ANUENCIA DAS PARTES PODERA SER DISPENSADA, A CRITERIO DO MAGISTRADO, NA HIPOTESE DE PERECIMENTO DE DIREITO, DESIGNO A AUDIENCIA DE CONCILIACAO PARA O DIA 30 DE NOVEMBRO DE 2023, AS 14:00 HORAS, POR MEIO DE VIDEO CONFERENCIA, OPORTUNIDADE EM QUE O(A)(S) REQUERIDO(A)(S) PODERA(AO) OFERECER CONTESTACAO, SOB PENA DE REVELIA. CITEM-SE O(A)(S) REQUERIDO(A)(S) DOS TERMOS DA ACAO, EXPEDINDO-SE CARTA DE CITACAO E INTIMACAO. INTIME-SE. ADVOGADOS(S): RICARDO FAJAN TONELLI (OAB 343425/SP)",
                "PublishDate": "2023-10-10T00:00:00",
                "CaptureDate": "2023-10-12T05:02:02"
              },
              {
                "Content": "NAO CONCEDIDA A ANTECIPACAO DE TUTELA DESTA FEITA, INDEFIRO, POR ORA, O PEDIDO DE TUTELA DE URGENCIA. CONSIDERANDO O DISPOSTO NO COMUNICADO N 284/2020, EMITIDO PELO TRIBUNAL DE JUSTICA DO ESTADO DE SAO PAULO, AS AUDIENCIAS PODERAO SER REALIZADAS POR MEIO DE VIDEOCONFERENCIA, A CRITERIO DO MAGISTRADO RESPONSAVEL, UTILIZANDO A FERRAMENTA MICROSOFT TEAMS (QUE NAO PRECISA ESTAR INSTALADA NO COMPUTADOR DAS PARTES, ADVOGADOS E TESTEMUNHAS), VIA COMPUTADOR OU SMARTPHONE, OBSERVANDO-SE QUE A ANUENCIA DAS PARTES PODERA SER DISPENSADA, A CRITERIO DO MAGISTRADO, NA HIPOTESE DE PERECIMENTO DE DIREITO, DESIGNO A AUDIENCIA DE CONCILIACAO PARA O DIA 30 DE NOVEMBRO DE 2023, AS 14:00 HORAS, POR MEIO DE VIDEO CONFERENCIA, OPORTUNIDADE EM QUE O(A)(S) REQUERIDO(A)(S) PODERA(AO) OFERECER CONTESTACAO, SOB PENA DE REVELIA. CITEM-SE O(A)(S) REQUERIDO(A)(S) DOS TERMOS DA ACAO, EXPEDINDO-SE CARTA DE CITACAO E INTIMACAO. INTIME-SE.",
                "PublishDate": "2023-10-09T00:00:00",
                "CaptureDate": "2023-10-12T05:02:02"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2023-10-03T00:00:00",
                "CaptureDate": "2023-10-12T05:02:02"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-10-02T00:00:00",
                "CaptureDate": "2023-10-12T05:02:02"
              }
            ],
            "Petitions": [],
            "Decisions": []
          },
          {
            "Number": "10048442420238260663",
            "Type": "PROCEDIMENTO COMUM",
            "MainSubject": "RESPONSABILIDADE DO FORNECEDOR",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "VOTORANTIM",
            "Judge": "GRAZIELA GOMES DOS SANTOS BIAZZIM",
            "JudgingBody": "2 VARA CIVEL",
            "State": "SP",
            "Status": "ATIVO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "RESPONSABILIDADE DO FORNECEDOR",
            "InferredCNJSubjectNumber": 6220,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "RESPONSABILIDADE DO FORNECEDOR"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 19457,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-10-11T00:00:00",
            "NoticeDate": "2023-10-04T00:00:00",
            "LastMovementDate": "2023-10-11T00:00:00",
            "CaptureDate": "2023-10-12T13:08:57",
            "LastUpdate": "2023-10-12T13:08:57",
            "NumberOfParties": 8,
            "NumberOfUpdates": 6,
            "LawSuitAge": 147,
            "AverageNumberOfUpdatesPerMonth": 1,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "19727473806",
                "IsPartyActive": true,
                "Name": "GRAZIELA GOMES DOS SANTOS BIAZZIM",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-10-12T13:08:57"
              },
              {
                "Doc": "08724118850",
                "IsPartyActive": true,
                "Name": "OSCAR LUIZ CARDOSO",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-10-12T13:08:57"
              },
              {
                "Doc": "11879738660",
                "IsPartyActive": true,
                "Name": "JAISSON FELIPE DE SOUZA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "208168",
                  "State": "MG",
                  "SpecificType": "ADVOGADO (REQTE)"
                },
                "LastCaptureDate": "2023-10-12T13:08:57"
              },
              {
                "Doc": "48472928000103",
                "IsPartyActive": true,
                "Name": "KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-10-12T13:08:57"
              },
              {
                "IsPartyActive": true,
                "Name": "DANILO ZUCCO",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-10-12T13:08:57"
              },
              {
                "Doc": "48689840000130",
                "IsPartyActive": true,
                "Name": "CASH PAY MEIOS DE PAGAMENTO LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-10-12T13:08:57"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-10-12T13:08:57"
              },
              {
                "Doc": "35624319000172",
                "IsPartyActive": true,
                "Name": "MK DIGITAL BANK INSTITUICAO DE PAGAMENTO S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-10-12T13:08:57"
              }
            ],
            "Updates": [
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0828/2023 DATA DA PUBLICACAO: 16/10/2023 NUMERO DO DIARIO: 3839",
                "PublishDate": "2023-10-11T00:00:00",
                "CaptureDate": "2023-10-12T13:08:58"
              },
              {
                "Content": "PROCESSO 1004844-24.2023.8.26.0663 - PROCEDIMENTO COMUM CIVEL - RESPONSABILIDADE DO FORNECEDOR - OSCAR LUIZ CARDOSO - VISTOS. EMBORA PARA A CONCESSAO DA GRATUIDADE NAO SE EXIJA O ESTADO DE MISERIA ABSOLUTA, E NECESSARIA A COMPROVACAO DA IMPOSSIBILIDADE DE ARCAR COM AS CUSTAS E DESPESAS DO PROCESSO SEM PREJUIZO DE SEU SUSTENTO PROPRIO OU DE SUA FAMILIA. A DECLARACAO DE POBREZA, POR SUA VEZ, ESTABELECE MERA PRESUNCAO RELATIVA DA HIPOSSUFICIENCIA, QUE CEDE ANTE OUTROS ELEMENTOS QUE SIRVAM PARA INDICAR A CAPACIDADE FINANCEIRA. NO CASO, HA ELEMENTOS SUFICIENTES PARA AFASTAR A PRESUNCAO, EM ESPECIAL: (I) NATUREZA E OBJETO DISCUTIDOS; (II) CONTRATACAO DE ADVOGADO PARTICULAR, DISPENSANDO A ATUACAO DA DEFENSORIA. ANTES DE INDEFERIR O PEDIDO, CONTUDO, CONVEM FACULTAR AO INTERESSADO O DIREITO DE PROVAR A IMPOSSIBILIDADE DE ARCAR, SEM O SEU PROPRIO PREJUIZO OU DE SUA FAMILIA, COM AS CUSTAS E DESPESAS DO PROCESSO. ASSIM, NO PRAZO DA EMENDA, A PARTE REQUERENTE DEVERA APRESENTAR, SOB PENA DE INDEFERIMENTO DO BENEFICIO: A) COPIA DA ULTIMA DECLARACAO DO IMPOSTO DE RENDA APRESENTADA A SECRETARIA DA RECEITA FEDERAL. OU, NO MESMO PRAZO, DEVERA RECOLHER AS CUSTAS JUDICIAIS E DESPESAS PROCESSUAIS, SOB PENA DE CANCELAMENTO DA DISTRIBUICAO SEM NOVA INTIMACAO. INT. - ADV: JAISSON FELIPE DE SOUZA (OAB 208168/MG)",
                "PublishDate": "2023-10-11T00:00:00",
                "CaptureDate": "2023-10-12T13:08:57"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0828/2023 TEOR DO ATO: VISTOS. EMBORA PARA A CONCESSAO DA GRATUIDADE NAO SE EXIJA O ESTADO DE MISERIA ABSOLUTA, E NECESSARIA A COMPROVACAO DA IMPOSSIBILIDADE DE ARCAR COM AS CUSTAS E DESPESAS DO PROCESSO SEM PREJUIZO DE SEU SUSTENTO PROPRIO OU DE SUA FAMILIA. A DECLARACAO DE POBREZA, POR SUA VEZ, ESTABELECE MERA PRESUNCAO RELATIVA DA HIPOSSUFICIENCIA, QUE CEDE ANTE OUTROS ELEMENTOS QUE SIRVAM PARA INDICAR A CAPACIDADE FINANCEIRA. NO CASO, HA ELEMENTOS SUFICIENTES PARA AFASTAR A PRESUNCAO, EM ESPECIAL: (I) NATUREZA E OBJETO DISCUTIDOS; (II) CONTRATACAO DE ADVOGADO PARTICULAR, DISPENSANDO A ATUACAO DA DEFENSORIA. ANTES DE INDEFERIR O PEDIDO, CONTUDO, CONVEM FACULTAR AO INTERESSADO O DIREITO DE PROVAR A IMPOSSIBILIDADE DE ARCAR, SEM O SEU PROPRIO PREJUIZO OU DE SUA FAMILIA, COM AS CUSTAS E DESPESAS DO PROCESSO. ASSIM, NO PRAZO DA EMENDA, A PARTE REQUERENTE DEVERA APRESENTAR, SOB PENA DE INDEFERIMENTO DO BENEFICIO: A) COPIA DA ULTIMA DECLARACAO DO IMPOSTO DE RENDA APRESENTADA A SECRETARIA DA RECEITA FEDERAL. OU, NO MESMO PRAZO, DEVERA RECOLHER AS CUSTAS JUDICIAIS E DESPESAS PROCESSUAIS, SOB PENA DE CANCELAMENTO DA DISTRIBUICAO SEM NOVA INTIMACAO. INT. ADVOGADOS(S): JAISSON FELIPE DE SOUZA (OAB 208168/MG)",
                "PublishDate": "2023-10-10T00:00:00",
                "CaptureDate": "2023-10-12T13:08:58"
              },
              {
                "Content": "RECEBIDA A EMENDA A INICIAL VISTOS. EMBORA PARA A CONCESSAO DA GRATUIDADE NAO SE EXIJA O ESTADO DE MISERIA ABSOLUTA, E NECESSARIA A COMPROVACAO DA IMPOSSIBILIDADE DE ARCAR COM AS CUSTAS E DESPESAS DO PROCESSO SEM PREJUIZO DE SEU SUSTENTO PROPRIO OU DE SUA FAMILIA. A DECLARACAO DE POBREZA, POR SUA VEZ, ESTABELECE MERA PRESUNCAO RELATIVA DA HIPOSSUFICIENCIA, QUE CEDE ANTE OUTROS ELEMENTOS QUE SIRVAM PARA INDICAR A CAPACIDADE FINANCEIRA. NO CASO, HA ELEMENTOS SUFICIENTES PARA AFASTAR A PRESUNCAO, EM ESPECIAL: (I) NATUREZA E OBJETO DISCUTIDOS; (II) CONTRATACAO DE ADVOGADO PARTICULAR, DISPENSANDO A ATUACAO DA DEFENSORIA. ANTES DE INDEFERIR O PEDIDO, CONTUDO, CONVEM FACULTAR AO INTERESSADO O DIREITO DE PROVAR A IMPOSSIBILIDADE DE ARCAR, SEM O SEU PROPRIO PREJUIZO OU DE SUA FAMILIA, COM AS CUSTAS E DESPESAS DO PROCESSO. ASSIM, NO PRAZO DA EMENDA, A PARTE REQUERENTE DEVERA APRESENTAR, SOB PENA DE INDEFERIMENTO DO BENEFICIO: A) COPIA DA ULTIMA DECLARACAO DO IMPOSTO DE RENDA APRESENTADA A SECRETARIA DA RECEITA FEDERAL. OU, NO MESMO PRAZO, DEVERA RECOLHER AS CUSTAS JUDICIAIS E DESPESAS PROCESSUAIS, SOB PENA DE CANCELAMENTO DA DISTRIBUICAO SEM NOVA INTIMACAO. INT.",
                "PublishDate": "2023-10-09T00:00:00",
                "CaptureDate": "2023-10-12T13:08:58"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2023-10-05T00:00:00",
                "CaptureDate": "2023-10-12T13:08:58"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-10-04T00:00:00",
                "CaptureDate": "2023-10-12T13:08:58"
              }
            ],
            "Petitions": [],
            "Decisions": []
          },
          {
            "Number": "07012779420238010003",
            "Type": "PROCEDIMENTO COMUM",
            "MainSubject": "PERDAS E DANOS",
            "CourtName": "TJAC",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "BRASILEIA",
            "Judge": "JORGE LUIZ LIMA DA SILVA FILHO",
            "JudgingBody": "VARA CIVEL",
            "State": "AC",
            "Status": "INDEFINIDO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "PERDAS E DANOS",
            "InferredCNJSubjectNumber": 7698,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO CIVIL",
            "InferredBroadCNJSubjectNumber": 899,
            "OtherSubjects": [
              "PERDAS E DANOS",
              "ANTECIPACAO DE TUTELA / TUTELA ESPECIFICA",
              "INADIMPLEMENTO",
              "OBRIGACOES"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 20345,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-10-16T00:00:00",
            "NoticeDate": "2023-10-02T00:00:00",
            "LastMovementDate": "2023-10-16T00:00:00",
            "CaptureDate": "2023-10-17T00:12:59",
            "LastUpdate": "2023-10-17T00:12:59",
            "NumberOfParties": 5,
            "NumberOfUpdates": 6,
            "LawSuitAge": 149,
            "AverageNumberOfUpdatesPerMonth": 1,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "01074744330",
                "IsPartyActive": true,
                "Name": "JORGE LUIZ LIMA DA SILVA FILHO",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-10-17T00:12:59"
              },
              {
                "Doc": "05176605201",
                "IsPartyActive": true,
                "Name": "LEANDRO MENEZES PEIXOTO",
                "Polarity": "ACTIVE",
                "Type": "AUTHOR",
                "PartyDetails": {
                  "SpecificType": "AUTOR"
                },
                "LastCaptureDate": "2023-10-17T00:12:59"
              },
              {
                "Doc": "07446073969",
                "IsPartyActive": true,
                "Name": "TABATA RIBEIRO BRITO MIQUELETTI",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "87889",
                  "State": "PR",
                  "SpecificType": "ADVOGADA (AUTOR)"
                },
                "LastCaptureDate": "2023-10-17T00:12:59"
              },
              {
                "Doc": "48472928000103",
                "IsPartyActive": true,
                "Name": "KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA,",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQUERIDO"
                },
                "LastCaptureDate": "2023-10-17T00:12:59"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQUERIDO"
                },
                "LastCaptureDate": "2023-10-17T00:12:59"
              }
            ],
            "Updates": [
              {
                "Content": "PUBLICADO ATO JUDICIAL RELACAO: 0803/2023 DATA DA DISPONIBILIZACAO: 16/10/2023 DATA DA PUBLICACAO: 17/10/2023 NUMERO DO DIARIO: 7403 PAGINA: 103",
                "PublishDate": "2023-10-16T00:00:00",
                "CaptureDate": "2023-10-17T00:12:59"
              },
              {
                "Content": "0701277-94.2023.8.01.0003 - PROCEDIMENTO COMUM CIVEL - PERDAS E DANOS - DO APF N 3595/2023). POIS BEM. ANALISANDO OS AUTOS, ENTENDO QUE ASSISTE RA- AUTOR: LEANDRO MENEZES PEIXOTO - RECEBO A INICIAL. DEFIRO OS BENEFICIOS DA ZAO A DEFESA NO PLEITO DE LIBERDADE PROVISORIA DO INVESTIGADO GIRALDO, PORQUAN- ASSISTENCIA JUDICIARIA EM FAVOR DA AUTORA. ANOTE-SE. A PARTE AUTORA MANIFESTA TO AUSENTE OS ELEMENTOS JUSTIFICADORES DA MEDIDA EXTREMA. NESSE SENTIDO, E SEU DESINTERESSE NA REALIZACAO DE AUDIENCIA DE CONCILIACAO/MEDIACAO. ASSIM, IMPORTANTE DESTACAR QUE A PRISAO PREVENTIVA E A ULTIMA RATIO, OU SEJA, SOMENTE CITE-SE A PARTE REQUERIDA, CONFORME REQUERIDO NA EXORDIAL PARA QUE, NO PRAZO DE SE JUSTIFICA EM SITUACOES EXCEPCIONAIS EM QUE AS MEDIDAS CAUTELARES DO ART. 15 (QUINZE) DIAS, APRESENTE AOS AUTOS A CONTESTACAO, NOS TERMOS DO ART. 335, 319 DO CPP SE MOSTRAREM INEFICAZES. IN CASU, OBSERVA-SE QUE O AUTO DE PRISAO DO CODIGO DE PROCESSO CIVIL, SOB PENA DE INCORRER NOS EFEITOS DA REVELIA (ART. EM FLAGRANTE IMPUTA AO REQUERENTE A PRATICA DO CRIME DE PORTE ILEGAL DE ARMA 344, CPC). CUMPRA-SE. DE FOGO DE USO RESTRITO, TENDO EM VISTA A APREENSAO DA ARMA (TERMO DE APRE- ENSAO FLS. 28/29). QUANTO AOS PRESSUPOSTOS DA MEDIDA SEGREGACIONAL, DEPOIS ADV: ROGERIO JUSTINO ALVES REIS (OAB 3505/AC) - PROCESSO 0701289- DE UM ESTUDO DETALHADO DOS AUTOS NAO VISLUMBRO QUE SE MOSTRA NECESSARIA 11.2023.8.01.0003 - PROCEDIMENTO COMUM CIVEL - RECONHECIMENTO / DISSOLU- A SEGREGACAO. AINDA, A CONSTITUICAO FEDERAL, EM SEU ARTIGO 5., INCISO LXVI, CAO - REQUERENTE: MARIA DELZIMAR PEREIRA DE OLIVEIRA - DEFIROOS BENEFICIOS ASSEGURA, IN VERBIS: QUE NINGUEM SERA LEVADO A PRISAO OU NELA MANTIDO, QUANDO DA GRATUIDADE DA JUSTICA, ANTE AFIRMACAO DE LEI, NOS TERMOS DO ARTIGO 98 DO LEI ADMITIR A LIBERDADE PROVISORIA COM OU SEM FIANCA. E CONTINUO NESSA TOADA NOVO CODIGO DE PROCESSO CIVIL. ANOTE-SE. PROCESSE-SE EM SEGREDO DE JUSTI- PARA REGISTRAR QUE, O ARTIGO 282,  6 DO CPP, ASSIM DISPOE: A PRISAO PREVENTIVA CA, NOS TERMOS DO ART. 189, II, DO CPC. A ACAO DECLARATORIA DE UNIAO ESTAVEL SERA DETERMINADA QUANDO NAO FOR CABIVEL A SUA SUBSTITUICAO POR OUTRA MEDIDA ENCONTRA-SE INSERIDA NO NOVO CODIGO DE PROCESSO CIVIL NO CAPITULO DESTINADO CAUTELAR. OCORRE QUE, ENTENDO QUE A INSTRUCAO CRIMINAL NAO CORRE QUALQUER AS ACOES DE FAMILIA, AS QUAIS, DE ACORDO COM O ARTIGO 695 DO REFERIDO DIPLOMA RISCO COM A SOLTURA DO INVESTIGADO, SOBRETUDO POR NAO HAVER ELEMENTOS NOS LEGAL, SERAO RECEBIDAS E, APOS TOMADAS AS PROVIDENCIAS REFERENTES A TUTELA AUTOS A POSSIBILITAR CONCLUSAO DIVERSA. OUTROSSIM, PARA DECRETACAO DA PRISAO PROVISORIA, SE O CASO, SERA ORDENADA A CITACAO DO REU PARA COMPARECIMENTO PREVENTIVA NAO BASTA A GRAVIDADE EM CONCRETA DA CONDUTA, MAS A DEMONSTRA- NA AUDIENCIA DE MEDIACAO E CONCILIACAO. OCORRE, POREM, QUE A PRETENSAO DA CAO REAL DO PERICULUM LIBERTATIS. O FUMUS COMISSI DELICTI DEFLUI DA APREENSAO AUTORA CINGE-SE NA DECLARACAO DE UNIAO ESTAVEL HAVIDA ENTRE ELA E SEU FALECIDO DA ARMA DE FOGO. TODAVIA, NAO VISLUMBRO EM QUE CONSISTE O PERIGO AO NATURAL COMPANHEIRO, ONDE NAO HA NENHUM DIREITO DISPONIVEL A TRANSIGIR NEM DIREITO DESENVOLVIMENTO DO INQUERITO E DO PROCESSO EM MANTE-LO EM LIBERDADE. COR- INDISPONIVEL QUE ACEITA ALGUM TIPO DE TRANSACAO, CARECENDO DE COMPROVACAO E ROBORANDO COM O EXPOSTO, NAO PODEMOS IGNORAR AS CIRCUNSTANCIAS PESSOAIS MAIOR DILACAO PROBATORIA PARA A DECLARACAO JUDICIAL DA EXISTENCIA DA UNIAO ES- FAVORAVEIS AO REQUERENTE, VISTO SER PRIMARIO, DE BONS ANTECEDENTES, POSSUIR TAVEL ALEGADA E SUA DURACAO, SENDO DESNECESSARIA E INOCUA A DESIGNACAO DE TRABALHO LICITO E TER RESIDENCIA FIXA EM SEU PAIS (PERU), TUDO ISSO ATRELADA A AUDIENCIA DE CONCILIACAO OU MEDIACAO. NESTAS CONDICOES, DETERMINO A CITACAO AUSENCIA DE ELEMENTOS CONCRETOS DE SER PESSOA PERIGOSA E COM PROBABILIDADE DARE PARA, QUERENDO, OFERECER CONTESTACAO NO PRAZO DE 15 (QUINZE) DIAS, CON- DE REITERACAO CRIMINOSA. ASSIM, CONSIDERANDO AS CIRCUNSTANCIAS PESSOAIS FAVO- TADOS NA FORMA PREVISTA NO ARTIGO 231 DO CODIGO DE PROCESSO CIVIL (NCPC, ART. RAVEIS DO REQUERENTE SOMADA A AUSENCIA DE ELEMENTOS CONCRETOS DA PROBABILI- 335, III),, SOB AS ADVERTENCIAS DE LEI (CPC/2015, ART. 334 E 344); CITEM-SE OS DADE DE REITERACAO DA CONDUTA DELITIVA, ENTENDO QUE A CONCESSAO DA LIBERDADE POSSIVEIS HERDEIROS, POR EDITAL, COM PRAZO DE 20 (VINTE) DIAS, PARA, QUERENDO, PROVISORIA CUMULADA COM AS MEDIDAS CAUTELARES E A MEDIDA MAIS ADEQUADA AO CONTESTAREM A PRESENTE ACAO, EM 15 (QUINZE) DIAS; DE-SE CIENCIA AO MINISTERIO CASO CONCRETO. NESSA LINHA DE RACIOCINIO, MISTER TRAZERMOS O ENTENDIMENTO DO PUBLICO. CUMPRA-SE. SUPERIOR TRIBUNAL DE JUSTICA EM CASO ANALOGO: RECURSO EM HABEAS COR- PUS. TRAFICO DE DROGAS. PRISAO PREVENTIVA. ART. 312 DO CPP. PE- ADV: EDIVALDO RODRIGUES DA SILVA (OAB 3193/AC) - PROCESSO 0701468- RICULUM LIBERTATIS. MOTIVACAO INIDONEA. RECURSO PROVIDO. 1. A",
                "PublishDate": "2023-10-16T00:00:00",
                "CaptureDate": "2023-10-17T00:12:59"
              },
              {
                "Content": "EXPEDIDA/CERTIFICADA RELACAO: 0803/2023 TEOR DO ATO: RECEBO A INICIAL. DEFIRO OS BENEFICIOS DA ASSISTENCIA JUDICIARIA EM FAVOR DA AUTORA. ANOTE-SE. A PARTE AUTORA MANIFESTA SEU DESINTERESSE NA REALIZACAO DE AUDIENCIA DE CONCILIACAO/MEDIACAO. ASSIM, CITE-SE A PARTE REQUERIDA, CONFORME REQUERIDO NA EXORDIAL PARA QUE, NO PRAZO DE 15 (QUINZE) DIAS, APRESENTE AOS AUTOS A CONTESTACAO, NOS TERMOS DO ART. 335, DO CODIGO DE PROCESSO CIVIL, SOB PENA DE INCORRER NOS EFEITOS DA REVELIA (ART. 344, CPC). CUMPRA-SE. ADVOGADOS(S): TABATA RIBEIRO BRITO MIQUELETTI (OAB 87889/PR)",
                "PublishDate": "2023-10-11T00:00:00",
                "CaptureDate": "2023-10-17T00:12:59"
              },
              {
                "Content": "MERO EXPEDIENTE RECEBO A INICIAL. DEFIRO OS BENEFICIOS DA ASSISTENCIA JUDICIARIA EM FAVOR DA AUTORA. ANOTE-SE. A PARTE AUTORA MANIFESTA SEU DESINTERESSE NA REALIZACAO DE AUDIENCIA DE CONCILIACAO/MEDIACAO. ASSIM, CITE-SE A PARTE REQUERIDA, CONFORME REQUERIDO NA EXORDIAL PARA QUE, NO PRAZO DE 15 (QUINZE) DIAS, APRESENTE AOS AUTOS A CONTESTACAO, NOS TERMOS DO ART. 335, DO CODIGO DE PROCESSO CIVIL, SOB PENA DE INCORRER NOS EFEITOS DA REVELIA (ART. 344, CPC). CUMPRA-SE.",
                "PublishDate": "2023-10-05T00:00:00",
                "CaptureDate": "2023-10-17T00:12:59"
              },
              {
                "Content": "DISTRIBUIDO POR SORTEIO",
                "PublishDate": "2023-10-02T00:00:00",
                "CaptureDate": "2023-10-17T00:12:59"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2023-10-02T00:00:00",
                "CaptureDate": "2023-10-17T00:12:59"
              }
            ],
            "Petitions": [],
            "Decisions": [
              {
                "DecisionContent": "DEFIRO OS BENEFICIOS DA ZAO A DEFESA NO PLEITO DE LIBERDADE PROVISORIA DO INVESTIGADO GIRALDO, PORQUAN- ASSISTENCIA JUDICIARIA EM FAVOR DA AUTORA.",
                "DecisionDate": "2023-10-16T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO OS BENEFICIOS DA ASSISTENCIA JUDICIARIA EM FAVOR DA AUTORA.",
                "DecisionDate": "2023-10-11T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO OS BENEFICIOS DA ASSISTENCIA JUDICIARIA EM FAVOR DA AUTORA.",
                "DecisionDate": "2023-10-05T00:00:00"
              }
            ]
          },
          {
            "Number": "00033381620238160014",
            "Type": "PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL",
            "MainSubject": "11811 - PRATICAS ABUSIVAS",
            "CourtName": "TJPR",
            "CourtLevel": "1",
            "CourtType": "ESPECIAL CIVEL",
            "CourtDistrict": "LONDRINA",
            "Judge": "RODRIGO AFONSO BRESSAN",
            "JudgingBody": "2 JUIZADO ESPECIAL CIVEL DE LONDRINA",
            "State": "PR",
            "Status": "EM GRAU DE RECURSO",
            "LawsuitHostService": "OTHER",
            "InferredCNJSubjectName": "PRÁTICAS ABUSIVAS",
            "InferredCNJSubjectNumber": 11811,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO DO JUIZADO ESPECIAL CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "11811 - PRATICAS ABUSIVAS"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": -1,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-10-26T00:00:00",
            "NoticeDate": "2023-01-23T00:00:00",
            "LastMovementDate": "2023-08-12T00:00:00",
            "CaptureDate": "2023-10-28T01:59:01",
            "LastUpdate": "2023-10-28T01:59:01",
            "NumberOfParties": 6,
            "NumberOfUpdates": 40,
            "LawSuitAge": 401,
            "AverageNumberOfUpdatesPerMonth": 2,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "87631067953",
                "IsPartyActive": true,
                "Name": "RODRIGO AFONSO BRESSAN",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-10-28T01:59:01"
              },
              {
                "Doc": "90850890934",
                "IsPartyActive": true,
                "Name": "ADEMIR MARTINS",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "POLO ATIVO"
                },
                "LastCaptureDate": "2023-10-28T01:59:01"
              },
              {
                "Doc": "34996214953",
                "IsPartyActive": true,
                "Name": "MARCELINO BISPO DOS SANTOS",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "24190N",
                  "State": "PR",
                  "SpecificType": "ADVOGADO (POLO ATIVO)"
                },
                "LastCaptureDate": "2023-10-28T01:59:01"
              },
              {
                "Doc": "36010822000109",
                "IsPartyActive": true,
                "Name": "ISTPAY SERVICOS DE PAGAMENTOS E GESTAO FINANCEIRA LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "POLO PASSIVO"
                },
                "LastCaptureDate": "2023-10-28T01:59:01"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "POLO PASSIVO"
                },
                "LastCaptureDate": "2023-10-28T01:59:01"
              },
              {
                "Doc": "35068411817",
                "IsPartyActive": true,
                "Name": "RAFAEL HIDEO NAZIMA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "295443N",
                  "State": "SP",
                  "SpecificType": "ADVOGADO (POLO PASSIVO)"
                },
                "LastCaptureDate": "2023-10-28T01:59:01"
              }
            ],
            "Updates": [
              {
                "Content": "DECORRIDO PRAZO DE STARK BANK S.A. (P/ ADVGS. DE STARK BANK S.A. *REFERENTE AO EVENTO (SEQ. 36) REMETIDOS OS AUTOS PARA AREA RECURSAL (25/07/2023) E AO EVENTO DE EXPEDICAO SEQ. 37.",
                "PublishDate": "2023-08-12T00:00:00",
                "CaptureDate": "2023-10-28T01:59:17"
              },
              {
                "Content": "JUNTADA DE PETICAO DE CUMPRIMENTO DE INTIMACAO CUMPRIMENTO DE INTIMACAO - REFERENTE AO EVENTO REMETIDOS OS AUTOS PARA AREA RECURSAL (25/07/2023)",
                "PublishDate": "2023-08-11T00:00:00",
                "CaptureDate": "2023-10-28T01:59:17"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA REFERENTE AO EVENTO (SEQ. 36) REMETIDOS OS AUTOS PARA AREA RECURSAL (25/07/2023) E AO EVENTO DE EXPEDICAO SEQ. 37.",
                "PublishDate": "2023-08-05T00:00:00",
                "CaptureDate": "2023-10-28T01:59:17"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO REFERENTE AO EVENTO (SEQ. 36) REMETIDOS OS AUTOS PARA AREA RECURSAL (25/07/2023).",
                "PublishDate": "2023-07-25T00:00:00",
                "CaptureDate": "2023-10-28T01:59:17"
              },
              {
                "Content": "REMETIDOS OS AUTOS PARA AREA RECURSAL CENTRO DE APOIO AS TURMAS RECURSAIS",
                "PublishDate": "2023-07-25T00:00:00",
                "CaptureDate": "2023-10-28T01:59:17"
              },
              {
                "Content": "ATO CUMPRIDO PELA PARTE OU INTERESSADO VINCULACAO DE GUIA DE RECOLHIMENTO DE CUSTAS - N DOCUMENTO: 57131602-5 - JUSTICA GRATUITA: SIM - VALOR DA GUIA: R$ 473,49 - UNIDADE ARRECADADORA: FORO CENTRAL DA COMARCA DA REGIAO METROPOLITANA DE LONDRINA - 2 SECRETARIA DO JUIZADO ESPECIAL CIVEL E CRIMINAL - TIPO DA GUIA: JUIZADO ESPECIAL E TURMAS RECURSAIS - IDENTIFICADOR: PROCESSO (NUMERO UNICO) - CONVENIO: CEF 342290 (FUNJUS) - AG:3162 CC:120-0",
                "PublishDate": "2023-07-25T00:00:00",
                "CaptureDate": "2023-10-28T01:59:17"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE . VEICULADO NO DJEN EM 26/07/2023.|PROJUDI - PROCESSO: 0003338-16.2023.8.16.0014 - REF. MOV. 34.1 - ASSINADO DIGITALMENTE POR RODRIGO AFONSO BRESSAN 12/07/2023: PROFERIDO DESPACHO DE MERO EXPEDIENTE. ARQ: DESPACHO AUTOS N. 0003338-16.2023.8.16.0014 CONCEDO A PARTE RECORRENTE OS BENEFICIOS DA GRATUIDADE DA JUSTICA. RECEBO O RECURSO SEM EFEITO SUSPENSIVO. REMETAM-SE OS AUTOS A TURMA RECURSAL COM AS HOMENAGENS DESTE JUIZO. INTIMEM-SE. LONDRINA, 12 DE JULHO DE 2023. RODRIGO AFONSO BRESSAN JUIZ DE DIREITO DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJDJ8 ZMNHG AYQE9 SUUBB",
                "PublishDate": "2023-07-12T00:00:00",
                "CaptureDate": "2023-10-28T01:59:17"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO - ANALISE DE RECURSO RESPONSAVEL: RODRIGO AFONSO BRESSAN. ENVIO DO CONCLUSO AGENDADO POR RAFAEL DAGUIS (ANALISTA JUDICIARIO)",
                "PublishDate": "2023-07-12T00:00:00",
                "CaptureDate": "2023-10-28T01:59:22"
              },
              {
                "Content": "JUNTADA DE PETICAO DE CONTRARRAZOES CUMPRIMENTO DE INTIMACAO - REFERENTE AO EVENTO JUNTADA DE ATO ORDINATORIO (15/06/2023)",
                "PublishDate": "2023-07-10T00:00:00",
                "CaptureDate": "2023-10-28T01:59:22"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA REFERENTE AO EVENTO (SEQ. 29) JUNTADA DE ATO ORDINATORIO (15/06/2023) E AO EVENTO DE EXPEDICAO SEQ. 30.",
                "PublishDate": "2023-06-26T00:00:00",
                "CaptureDate": "2023-10-28T01:59:22"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO REFERENTE AO EVENTO (SEQ. 29) JUNTADA DE ATO ORDINATORIO (15/06/2023).",
                "PublishDate": "2023-06-15T00:00:00",
                "CaptureDate": "2023-10-28T01:59:22"
              },
              {
                "Content": "JUNTADA DE ATO ORDINATORIO",
                "PublishDate": "2023-06-15T00:00:00",
                "CaptureDate": "2023-10-28T01:59:22"
              },
              {
                "Content": "DECORRIDO PRAZO DE STARK BANK S.A. (P/ ADVGS. DE STARK BANK S.A. *REFERENTE AO EVENTO (SEQ. 22) JULGADA IMPROCEDENTE A ACAO (10/05/2023) E AO EVENTO DE EXPEDICAO SEQ. 23.",
                "PublishDate": "2023-06-13T00:00:00",
                "CaptureDate": "2023-10-28T01:59:22"
              },
              {
                "Content": "JUNTADA DE PETICAO DE INTERPOSICAO DE RECURSO CUMPRIMENTO DE INTIMACAO - REFERENTE AO EVENTO JULGADA IMPROCEDENTE A ACAO (10/05/2023)",
                "PublishDate": "2023-05-30T00:00:00",
                "CaptureDate": "2023-10-28T01:59:22"
              },
              {
                "Content": "DECORRIDO PRAZO DE ISTPAY SERVICOS DE PAGAMENTOS E GESTAO FINANCEIRA LTDA (PARA ISTPAY SERVICOS DE PAGAMENTOS E GESTAO FINANCEIRA LTDA *REFERENTE AO EVENTO (SEQ. 22) JULGADA IMPROCEDENTE A ACAO (10/05/2023)",
                "PublishDate": "2023-05-30T00:00:00",
                "CaptureDate": "2023-10-28T01:59:22"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA REFERENTE AO EVENTO (SEQ. 22) JULGADA IMPROCEDENTE A ACAO (10/05/2023) E AO EVENTO DE EXPEDICAO SEQ. 23.",
                "PublishDate": "2023-05-26T00:00:00",
                "CaptureDate": "2023-10-28T01:59:22"
              },
              {
                "Content": "ATO CUMPRIDO PELA PARTE OU INTERESSADO REFERENTE AO EVENTO (SEQ. 22) JULGADA IMPROCEDENTE A ACAO (10/05/2023).",
                "PublishDate": "2023-05-15T00:00:00",
                "CaptureDate": "2023-10-28T01:59:22"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO REFERENTE AO EVENTO (SEQ. 22) JULGADA IMPROCEDENTE A ACAO (10/05/2023).",
                "PublishDate": "2023-05-15T00:00:00",
                "CaptureDate": "2023-10-28T01:59:22"
              },
              {
                "Content": "JULGADA IMPROCEDENTE A ACAO REGISTRO EM 11/05/2023 SOB N 1.610.425.277. VEICULADO NO DJEN EM 16/05/2023.|PROJUDI - PROCESSO: 0003338-16.2023.8.16.0014 - REF. MOV. 22.1 - ASSINADO DIGITALMENTE POR RODRIGO AFONSO BRESSAN:9490 10/05/2023: JULGADA IMPROCEDENTE A ACAO. ARQ: SENTENCA PODER JUDICIARIO DO ESTADO DO PARANA COMARCA DA REGIAO METROPOLITANA DE LONDRINA - FORO CENTRAL DE LONDRINA 2 JUIZADO ESPECIAL CIVEL DE LONDRINA - PROJUDI AV. DUQUE DE CAXIAS, 689 - CAICARAS - LONDRINA/PR - CEP: 86.015-902 - FONE: (43) 3572-3208 - E-MAIL: LON-25VJ-S@TJPR.JUS.BR AUTOS N. 0003338-16.2023.8.16.0014 PROCESSO: 0003338-16.2023.8.16.0014 CLASSE PROCESSUAL: PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL ASSUNTO PRINCIPAL: PRATICAS ABUSIVAS VALOR DA CAUSA: R$13.200,00 POLO ATIVO(S): ADEMIR MARTINS POLO PASSIVO(S): ISTPAY SERVICOS DE PAGAMENTOS E GESTAO FINANCEIRA LTDA STARK BANK S.A. A PARTE AUTORA ALEGA QUE NO DIA 03 DE NOVEMBRO DE 2022 REALIZOU A COMPRA DE UMA ESCADA; QUE O PAGAMENTO FOI FEITO EM FAVOR DAS RES E QUE ATE O MOMENTO O PRODUTO NAO FOI ENTREGUE E OS VALOR PAGO NAO FOI DEVOLVIDO. ASSIM, PEDE A ENTREGA DA ESCADA MAIS INDENIZACAO PELOS DANOS MORAIS SOFRIDOS. A PARTE RE, CITADA, NAO COMPARECEU A AUDIENCIA DESIGNADA, TORNANDO-SE REVEL. NO ENTANTO, APESAR DA REVELIA VERIFICADA, O PEDIDO NAO MERECE SER ACOLHIDO. DE ACORDO COM OS DOCUMENTOS DO MOV. 1.6 E 1.7, A PARTE AUTORA ADQUIRIU O PRODUTO ATRAVES DO SITE DA REALEZA SHOP, UTILIZANDO O SERVICO DE GESTAO DE PAGAMENTO DA RE STARK BANK, RESPONSAVEL PELA DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJ8YQ PR5KZ DJ9ZH B8P9B EMISSAO DO BOLETO. NOTE-SE QUE A RE ISTPAY[1] CONSISTE EM MERA PLATAFORMA DE PAGAMENTO (TAIS COMO PAGSEGURO, MERCADO PAGO, PAYPAL, ENTRE OUTRAS). DESTA FORMA, NAO HA COMO RESPONSABILIZAR OS REUS POR EVENTUAL FALHA PRATICADA PELA LOJA VIRTUAL DE NAO ENTREGAR O PRODUTO E DE NAO ESTORNAR O VALOR DA COMPRA. ISSO PORQUE A ATIVIDADE DAS RES LIMITOU-SE A INTERMEDIAR O PAGAMENTO DO PRODUTO. NOTE-SE AINDA QUE NESSE TIPO DE OPERACAO A PLATAFORMA ENVIA OS VALORES DIRETAMENTE PARA A CONTA DOS USUARIOS, EIS QUE SUA REMUNERACAO OCORRE ATRAVES DO PAGAMENTO DE TAXAS. ASSIM, NAO HA MOTIVO PARA QUE AS RES RESPONDAM POR EVENTUAIS DANOS CAUSADOS A PARTE AUTORA, ATE PORQUE, AO QUE TUDO INDICA, PRESTARAM REGULAR SERVICO, FACILITANDO E INTERMEDIANDO O PAGAMENTO DA COMPRA. DIANTE DO EXPOSTO, E NOS TERMOS DO ARTIGO 487, INCISO I DO CPC, JULGO IMPROCEDENTE O PEDIDO INICIAL. PROJUDI - PROCESSO: 0003338-16.2023.8.16.0014 - REF. MOV. 22.1 - ASSINADO DIGITALMENTE POR RODRIGO AFONSO BRESSAN:9490 10/05/2023: JULGADA IMPROCEDENTE A ACAO. ARQ: SENTENCA PUBLIQUE-SE. REGISTRE-SE. INTIMEM-SE. LONDRINA, 05 DE MAIO DE 2023. RODRIGO AFONSO BRESSAN JUIZ DE DIREITO [1] HTTPS://ISTPAY.COM.BR/ DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJ8YQ PR5KZ DJ9ZH B8P9B",
                "PublishDate": "2023-05-10T00:00:00",
                "CaptureDate": "2023-10-28T01:59:22"
              },
              {
                "Content": "JUNTADA DE PETICAO DE CONTESTACAO",
                "PublishDate": "2023-04-25T00:00:00",
                "CaptureDate": "2023-10-28T01:59:28"
              },
              {
                "Content": "JUNTADA DE PETICAO DE REQUERIMENTO DE HABILITACAO",
                "PublishDate": "2023-04-04T00:00:00",
                "CaptureDate": "2023-10-28T01:59:28"
              },
              {
                "Content": "JUNTADA DE PETICAO DE CUMPRIMENTO DE INTIMACAO CUMPRIMENTO DE INTIMACAO - REFERENTE AO EVENTO JUNTADA DE ATO ORDINATORIO (09/03/2023)",
                "PublishDate": "2023-03-27T00:00:00",
                "CaptureDate": "2023-10-28T01:59:28"
              },
              {
                "Content": "CONCLUSOS PARA SENTENCA RESPONSAVEL: RODRIGO AFONSO BRESSAN. ENVIO DO CONCLUSO AGENDADO POR BRUNO DA SILVA SCARPILLE (ANALISTA JUDICIARIO)",
                "PublishDate": "2023-03-23T00:00:00",
                "CaptureDate": "2023-10-28T01:59:28"
              },
              {
                "Content": "AUDIENCIA DE CONCILIACAO REALIZADA AUSENCIA DO REQUERIDO",
                "PublishDate": "2023-03-21T00:00:00",
                "CaptureDate": "2023-10-28T01:59:28"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA REFERENTE AO EVENTO (SEQ. 14) JUNTADA DE ATO ORDINATORIO (09/03/2023) E AO EVENTO DE EXPEDICAO SEQ. 15.",
                "PublishDate": "2023-03-20T00:00:00",
                "CaptureDate": "2023-10-28T01:59:28"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO REFERENTE AO EVENTO (SEQ. 14) JUNTADA DE ATO ORDINATORIO (09/03/2023).",
                "PublishDate": "2023-03-09T00:00:00",
                "CaptureDate": "2023-10-28T01:59:28"
              },
              {
                "Content": "JUNTADA DE ATO ORDINATORIO",
                "PublishDate": "2023-03-09T00:00:00",
                "CaptureDate": "2023-10-28T01:59:28"
              },
              {
                "Content": "JUNTADA DE COMPROVANTE DEVOLUCAO SEM LEITURA - REFERENTE A CITACAO EXPEDIDA EM 10/02/2023 PARA STARK BANK S.A.",
                "PublishDate": "2023-03-09T00:00:00",
                "CaptureDate": "2023-10-28T01:59:28"
              },
              {
                "Content": "ATO CUMPRIDO PELA PARTE OU INTERESSADO LEITURA DE CITACAO REALIZADA - POR ISTPAY SERVICOS DE PAGAMENTOS E GESTAO FINANCEIRA LTDA EM 17/02/2023 REFERENTE AO EVENTO DE EXPEDICAO SEQ. 10.",
                "PublishDate": "2023-03-09T00:00:00",
                "CaptureDate": "2023-10-28T01:59:28"
              },
              {
                "Content": "EXPEDICAO DE CITACAO PARA STARK BANK S.A. COM PRAZO ATE 21 DE MARCO DE 2023 - VIA AR DIGITAL - UTILIZANDO CONTRAFE",
                "PublishDate": "2023-02-10T00:00:00",
                "CaptureDate": "2023-10-28T01:59:28"
              },
              {
                "Content": "EXPEDICAO DE CITACAO PARA ISTPAY SERVICOS DE PAGAMENTOS E GESTAO FINANCEIRA LTDA COM PRAZO ATE 21 DE MARCO DE 2023 - VIA AR DIGITAL - UTILIZANDO CONTRAFE",
                "PublishDate": "2023-02-10T00:00:00",
                "CaptureDate": "2023-10-28T01:59:28"
              },
              {
                "Content": "RECEBIDOS OS AUTOS RECEBIDO DO(A) DISTRIBUIDOR",
                "PublishDate": "2023-01-24T00:00:00",
                "CaptureDate": "2023-10-28T01:59:28"
              },
              {
                "Content": "JUNTADA DE ANOTACAO DE DISTRIBUICAO",
                "PublishDate": "2023-01-24T00:00:00",
                "CaptureDate": "2023-10-28T01:59:28"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA REFERENTE AO EVENTO (SEQ. 6) AUDIENCIA DE CONCILIACAO DESIGNADA (23/01/2023).",
                "PublishDate": "2023-01-23T00:00:00",
                "CaptureDate": "2023-10-28T01:59:28"
              },
              {
                "Content": "AUDIENCIA DE CONCILIACAO DESIGNADA (AGENDADA PARA: 21 DE MARCO DE 2023 AS 16:46, EM 2 JUIZADO ESPECIAL CIVEL DE LONDRINA, MODALIDADE: VIRTUAL)",
                "PublishDate": "2023-01-23T00:00:00",
                "CaptureDate": "2023-10-28T01:59:28"
              },
              {
                "Content": "RECEBIDOS OS AUTOS",
                "PublishDate": "2023-01-23T00:00:00",
                "CaptureDate": "2023-10-28T01:59:28"
              },
              {
                "Content": "REMETIDOS OS AUTOS PARA DISTRIBUIDOR REGISTRO DE DISTRIBUICAO",
                "PublishDate": "2023-01-23T00:00:00",
                "CaptureDate": "2023-10-28T01:59:28"
              },
              {
                "Content": "DISTRIBUIDO POR SORTEIO 2 JUIZADO ESPECIAL CIVEL DE LONDRINA",
                "PublishDate": "2023-01-23T00:00:00",
                "CaptureDate": "2023-10-28T01:59:28"
              },
              {
                "Content": "AUTOS INCLUIDOS NO JUIZO 100% DIGITAL",
                "PublishDate": "2023-01-23T00:00:00",
                "CaptureDate": "2023-10-28T01:59:28"
              },
              {
                "Content": "JUNTADA DE PETICAO DE INICIAL",
                "PublishDate": "2023-01-23T00:00:00",
                "CaptureDate": "2023-10-28T01:59:28"
              }
            ],
            "Petitions": [],
            "Decisions": [
              {
                "DecisionContent": "JULGO IMPROCEDENTE O PEDIDO INICIAL.",
                "DecisionDate": "2023-05-10T00:00:00"
              }
            ]
          },
          {
            "Number": "10107969720238260302",
            "Type": "PROCEDIMENTO COMUM",
            "MainSubject": "INDENIZACAO POR DANO MORAL",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "JAU",
            "Judge": "GUILHERME EDUARDO MENDES TARCIA E FAZZIO",
            "JudgingBody": "4 VARA CIVEL",
            "State": "SP",
            "Status": "ATIVO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "INDENIZAÇÃO POR DANO MORAL",
            "InferredCNJSubjectNumber": 7779,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "INDENIZACAO POR DANO MORAL"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 20218,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-10-27T00:00:00",
            "NoticeDate": "2023-10-25T00:00:00",
            "LastMovementDate": "2023-10-27T00:00:00",
            "CaptureDate": "2023-10-28T04:21:18",
            "LastUpdate": "2023-10-28T04:21:18",
            "NumberOfParties": 7,
            "NumberOfUpdates": 6,
            "LawSuitAge": 126,
            "AverageNumberOfUpdatesPerMonth": 1,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "21455709859",
                "IsPartyActive": true,
                "Name": "GUILHERME EDUARDO MENDES TARCIA E FAZZIO",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-10-28T04:21:18"
              },
              {
                "IsPartyActive": true,
                "Name": "SAMUEL FERREIRA DA SILVA",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-10-28T04:21:18"
              },
              {
                "Doc": "07446073969",
                "IsPartyActive": true,
                "Name": "TABATA RIBEIRO BRITO MIQUELETTI",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "87889",
                  "State": "PR",
                  "SpecificType": "ADVOGADA (REQTE)"
                },
                "LastCaptureDate": "2023-10-28T04:21:18"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-10-28T04:21:18"
              },
              {
                "Doc": "35624319000172",
                "IsPartyActive": true,
                "Name": "MK DIGITAL BANK INSTITUICAO DE PAGAMENTO S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-10-28T04:21:18"
              },
              {
                "Doc": "51754899000179",
                "IsPartyActive": true,
                "Name": "CASH PAY MEIOS DE PAGAMENTOS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-10-28T04:21:18"
              },
              {
                "Doc": "48472928000103",
                "IsPartyActive": true,
                "Name": "KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-10-28T04:21:18"
              }
            ],
            "Updates": [
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0958/2023 DATA DA PUBLICACAO: 30/10/2023 NUMERO DO DIARIO: 3849",
                "PublishDate": "2023-10-27T00:00:00",
                "CaptureDate": "2023-10-28T04:21:18"
              },
              {
                "Content": "PROCESSO 1010796-97.2023.8.26.0302 - PROCEDIMENTO COMUM CIVEL - INDENIZACAO POR DANO MORAL - SAMUEL FERREIRA DA SILVA - VISTOS. RECEBO A INICIAL. INDEFIRO A GRATUIDADE. A NATUREZA DO NEGOCIO REALIZADO INDICA CAPACIDADE FINANCEIRA SUFICIENTE PARA PAGAMENTO DAS CUSTAS E DESPESAS JUDICIAIS, O QUE POR SI, ELIDE A PRESUNCAO DE POBREZA. ALEM DISSO, A PARTE AUTORA NAO INFORMA AUTOS SUA PROFISSAO NEM INDICA SEUS RENDIMENTOS. SEM COMPROVANTE EFETIVO DA INCAPACIDADE FINANCEIRA, COM A DEVIDA VENIA, NAO SE VERIFICA PRESENTE A PRESUNCAO DE POBREZA DO AUTOR. ASSIM, AUSENTES ELEMENTOS QUE JUSTIFIQUEM A CONCESSAO DA BENESSE, INDEFERIDA A GRATUIDADE JUDICIARIA. FACULTO A COMPROVACAO DA NECESSIDADE POR DOCUMENTO IDONEO(HOLERITES, DECLARACAO DE IRPF DOS ULTIMOS 03 ANOS, EXTRATO DE MOVIMENTACAO BANCARIA E GASTOS COM CARTAO DE CREDITO DOS ULTIMOS 03 MESES), OU O RECOLHIMENTO DAS CUSTAS INICIAIS NO PRAZO DE 15 DIAS, SOB PENA DE CANCELAMENTO DA DISTRIBUICAO. APOS, VOLTEM CONCLUSOS COM A ANOTACAO INICIAL LIMINAR. INTIME-SE. - ADV: TABATA RIBEIRO BRITO MIQUELETTI (OAB 87889/PR)",
                "PublishDate": "2023-10-27T00:00:00",
                "CaptureDate": "2023-10-28T04:21:18"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0958/2023 TEOR DO ATO: VISTOS. RECEBO A INICIAL. INDEFIRO A GRATUIDADE. A NATUREZA DO NEGOCIO REALIZADO INDICA CAPACIDADE FINANCEIRA SUFICIENTE PARA PAGAMENTO DAS CUSTAS E DESPESAS JUDICIAIS, O QUE POR SI, ELIDE A PRESUNCAO DE POBREZA. ALEM DISSO, A PARTE AUTORA NAO INFORMA AUTOS SUA PROFISSAO NEM INDICA SEUS RENDIMENTOS. SEM COMPROVANTE EFETIVO DA INCAPACIDADE FINANCEIRA, COM A DEVIDA VENIA, NAO SE VERIFICA PRESENTE A PRESUNCAO DE POBREZA DO AUTOR. ASSIM, AUSENTES ELEMENTOS QUE JUSTIFIQUEM A CONCESSAO DA BENESSE, INDEFERIDA A GRATUIDADE JUDICIARIA. FACULTO A COMPROVACAO DA NECESSIDADE POR DOCUMENTO IDONEO(HOLERITES, DECLARACAO DE IRPF DOS ULTIMOS 03 ANOS, EXTRATO DE MOVIMENTACAO BANCARIA E GASTOS COM CARTAO DE CREDITO DOS ULTIMOS 03 MESES), OU O RECOLHIMENTO DAS CUSTAS INICIAIS NO PRAZO DE 15 DIAS, SOB PENA DE CANCELAMENTO DA DISTRIBUICAO. APOS, VOLTEM CONCLUSOS COM A ANOTACAO INICIAL LIMINAR. INTIME-SE. ADVOGADOS(S): TABATA RIBEIRO BRITO MIQUELETTI (OAB 87889/PR)",
                "PublishDate": "2023-10-26T00:00:00",
                "CaptureDate": "2023-10-28T04:21:18"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-10-25T00:00:00",
                "CaptureDate": "2023-10-28T04:21:18"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2023-10-25T00:00:00",
                "CaptureDate": "2023-10-28T04:21:18"
              },
              {
                "Content": "PROFERIDAS OUTRAS DECISOES NAO ESPECIFICADAS VISTOS. RECEBO A INICIAL. INDEFIRO A GRATUIDADE. A NATUREZA DO NEGOCIO REALIZADO INDICA CAPACIDADE FINANCEIRA SUFICIENTE PARA PAGAMENTO DAS CUSTAS E DESPESAS JUDICIAIS, O QUE POR SI, ELIDE A PRESUNCAO DE POBREZA. ALEM DISSO, A PARTE AUTORA NAO INFORMA AUTOS SUA PROFISSAO NEM INDICA SEUS RENDIMENTOS. SEM COMPROVANTE EFETIVO DA INCAPACIDADE FINANCEIRA, COM A DEVIDA VENIA, NAO SE VERIFICA PRESENTE A PRESUNCAO DE POBREZA DO AUTOR. ASSIM, AUSENTES ELEMENTOS QUE JUSTIFIQUEM A CONCESSAO DA BENESSE, INDEFERIDA A GRATUIDADE JUDICIARIA. FACULTO A COMPROVACAO DA NECESSIDADE POR DOCUMENTO IDONEO(HOLERITES, DECLARACAO DE IRPF DOS ULTIMOS 03 ANOS, EXTRATO DE MOVIMENTACAO BANCARIA E GASTOS COM CARTAO DE CREDITO DOS ULTIMOS 03 MESES), OU O RECOLHIMENTO DAS CUSTAS INICIAIS NO PRAZO DE 15 DIAS, SOB PENA DE CANCELAMENTO DA DISTRIBUICAO. APOS, VOLTEM CONCLUSOS COM A ANOTACAO INICIAL LIMINAR. INTIME-SE.",
                "PublishDate": "2023-10-25T00:00:00",
                "CaptureDate": "2023-10-28T04:21:18"
              }
            ],
            "Petitions": [],
            "Decisions": []
          },
          {
            "Number": "10056065320238260400",
            "Type": "PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL",
            "MainSubject": "INDENIZACAO POR DANO MATERIAL",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "",
            "CourtDistrict": "OLIMPIA",
            "Judge": "ANDRE DA FONSECA TAVARES",
            "JudgingBody": "VARA DO JUIZADO ESPECIAL CIVEL E CRIMINAL",
            "State": "SP",
            "Status": "ATIVO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "INDENIZAÇÃO POR DANO MATERIAL",
            "InferredCNJSubjectNumber": 7780,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO DO JUIZADO ESPECIAL CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "INDENIZACAO POR DANO MATERIAL",
              "INDENIZACAO POR DANO MORAL"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 7270,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-10-30T00:00:00",
            "NoticeDate": "2023-10-26T00:00:00",
            "LastMovementDate": "2023-10-30T00:00:00",
            "CaptureDate": "2023-10-31T10:33:38",
            "LastUpdate": "2023-10-31T10:33:38",
            "NumberOfParties": 8,
            "NumberOfUpdates": 3,
            "LawSuitAge": 125,
            "AverageNumberOfUpdatesPerMonth": 0,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "01118961692",
                "IsPartyActive": true,
                "Name": "ANDRE DA FONSECA TAVARES",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-10-31T10:33:38"
              },
              {
                "Doc": "44927866866",
                "IsPartyActive": true,
                "Name": "HIAGO VIEIRA PANELLA",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-10-31T10:33:38"
              },
              {
                "Doc": "13665997801",
                "IsPartyActive": true,
                "Name": "CAIA AIDAR PITON",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "SpecificType": "ADVOGADO (REQTE)"
                },
                "LastCaptureDate": "2023-10-31T10:33:38"
              },
              {
                "Doc": "48472928000103",
                "IsPartyActive": true,
                "Name": "KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-10-31T10:33:38"
              },
              {
                "Doc": "51754899000179",
                "IsPartyActive": true,
                "Name": "CASH PAY MEIOS DE PAGAMENTOS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-10-31T10:33:38"
              },
              {
                "Doc": "35624319000172",
                "IsPartyActive": true,
                "Name": "MK DIGITAL BANK INSTITUICAO DE PAGAMENTO S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-10-31T10:33:38"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-10-31T10:33:38"
              },
              {
                "Doc": "18236120000158",
                "IsPartyActive": true,
                "Name": "NU PAGAMENTOS S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-10-31T10:33:38"
              }
            ],
            "Updates": [
              {
                "Content": "PROCESSO : 1005606-53.2023.8.26.0400 CLASSE : PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL REQTE : HIAGO VIEIRA PANELLA ADVOGADO : 125154/SP - CAIA AIDAR PITON REQDO : NU PAGAMENTOS S.A. VARA : VARA DO JUIZADO ESPECIAL CIVEL E CRIMINAL",
                "PublishDate": "2023-10-30T00:00:00",
                "CaptureDate": "2023-10-31T10:33:38"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2023-10-27T00:00:00",
                "CaptureDate": "2023-10-31T10:33:39"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-10-26T00:00:00",
                "CaptureDate": "2023-10-31T10:33:39"
              }
            ],
            "Petitions": [],
            "Decisions": []
          },
          {
            "Number": "11514133420238260100",
            "Type": "PROCEDIMENTO COMUM",
            "MainSubject": "INDENIZACAO POR DANO MORAL",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "SAO PAULO",
            "Judge": "MARCELO STABEL DE CARVALHO HANNOUN",
            "JudgingBody": "8 VARA CIVEL",
            "State": "SP",
            "Status": "ATIVO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "INDENIZAÇÃO POR DANO MORAL",
            "InferredCNJSubjectNumber": 7779,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "INDENIZACAO POR DANO MORAL"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 20500,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-10-31T00:00:00",
            "NoticeDate": "2023-10-27T00:00:00",
            "LastMovementDate": "2023-10-31T00:00:00",
            "CaptureDate": "2023-11-02T01:35:29",
            "LastUpdate": "2023-11-02T01:35:29",
            "NumberOfParties": 5,
            "NumberOfUpdates": 6,
            "LawSuitAge": 124,
            "AverageNumberOfUpdatesPerMonth": 1,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "34367783898",
                "IsPartyActive": true,
                "Name": "MARCELO STABEL DE CARVALHO HANNOUN",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-11-02T01:35:29"
              },
              {
                "IsPartyActive": true,
                "Name": "BEATRIZ ANDRADE DA SILVA",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-11-02T01:35:29"
              },
              {
                "Doc": "07446073969",
                "IsPartyActive": true,
                "Name": "TABATA RIBEIRO BRITO MIQUELETTI",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "87889",
                  "State": "PR",
                  "SpecificType": "ADVOGADO (REQTE)"
                },
                "LastCaptureDate": "2023-11-02T01:35:29"
              },
              {
                "Doc": "48472928000103",
                "IsPartyActive": true,
                "Name": "KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-11-02T01:35:29"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-11-02T01:35:29"
              }
            ],
            "Updates": [
              {
                "Content": "REMETIDO AO DJE RELACAO: 0918/2023 TEOR DO ATO: VISTOS. CONFORME ARTIGO 1,  2, III, \"A\", DA LEI N 11.419/06, A ASSINATURA ELETRONICA DEVE SER BASEADA EM CERTIFICADO DIGITAL EMITIDO POR AUTORIDADE CERTIFICADORA CREDENCIADA. EM CONSULTA AO SITE DA EMPRESA ZAPSIGN, VERIFICA-SE QUE AS ASSINATURAS DIGITAIS FIRMADAS ATRAVES DA MESMA SAO REALIZADAS ATRAVES DE LINKS ENCAMINHADOS AOS SIGNATARIOS. ALEM DISSO, VERIFICA-SE QUE TAL ENTIDADE NAO SE ENCONTRA CREDENCIADA A ICP-BRASIL (HTTPS://ESTRUTURA.ITI.GOV.BR). SOBRE O TEMA, JA SE PRONUNCIOU A CGJ DO E. TJSP: NORMAS DE SERVICO. EXPEDIENTE FORMADO A PARTIR DE OFICIO DA COMISSAO DE DIREITOS E PRERROGATIVAS DA ORDEM DOS ADVOGADOS DO BRASIL SECAO DE SAO PAULO - VEICULANDO RECLAMACAO APRESENTADA POR ADVOGADO ACERCA DA CONDUTA DE MAGISTRADO QUE TERIA SE RECUSADO A ACEITAR PROCURACAO ASSINADA ELETRONICAMENTE, EMBORA NAO POR MEIO DE CERTIFICADO DIGITAL HIPOTESE EM QUE A PROCURACAO REFERIDA FOI ASSINADA PELA OUTORGANTE DE FORMA ELETRONICA, SEM CERTIFICADO DIGITAL, POR MEIO DE UMA PLATAFORMA DE SOFTWARE DE ASSINATURA ELETRONICA DENOMINADA PANDA.DOC.COM CARACTERIZACAO DE ASSINATURA ELETRONICA AVANCADA, QUE NAO SE CONFUNDE COM ASSINATURA ELETRONICA QUALIFICADA OU ASSINATURA DIGITAL, NA DEFINICAO DA LEI N 14.063/2020 INCIDENCIA DO ART. 10,  1 E 2 DA MEDIDA PROVISORIA N 2.200-2/2001 DE 24/08/2001 (VIGENTE POR FORCA DA EC N 32/2001), DA LEI N 11.419/06 E DO ART. 5 E  1 DA RESOLUCAO N 551 DO C. ORGAO ESPECIAL - PROCURACAO QUE, SE ASSINADA DE FORMA ELETRONICA, SOMENTE TERA VALIDADE NO PROCESSO ELETRONICO SE SE TRATAR DE ASSINATURA ELETRONICA QUALIFICADA, OU SEJA, SE TIVER SIDO ASSINADA ELETRONICAMENTE MEDIANTE USO DE CERTIFICADO DIGITAL - MATERIA ESTRITAMENTE JURISDICIONAL PLEITO DE ENCAMINHAMENTO DE ORIENTACAO INTERNA AOS MAGISTRADOS PARA QUE SE ATENTEM AS PRERROGATIVAS DA ADVOCACIA DESNECESSIDADE INEXISTENCIA DE VIOLACAO DAS PRERROGATIVAS DESNECESSIDADE, OUTROSSIM, DE QUAISQUER ALTERACOES OU COMPLEMENTACOES DAS NORMAS DE SERVICO DESTA CORREGEDORIA GERAL DA JUSTICA, QUE REGULAM A QUESTAO DE FORMA COMPLETA E EXAURIENTE, E EM CONFORMIDADE COM AS DISPOSICOES LEGAIS PERTINENTES PARECER PELO INDEFERIMENTO DOS PEDIDOS.\" (PROCESSO DIGITAL N. 2021/00100891, 26.01.2022) PORTANTO, NECESSARIA A APRESENTACAO DE NOVO MANDATO, NO PRAZO DE QUINZE DIAS, SOB PENA DE EXTINCAO. 2 - A ANALISE DO REQUERIMENTO DE GRATUIDADE DE JUSTICA DEMANDA, NO CASO CONCRETO, A COMPROVACAO DA CONDICAO DE HIPOSSUFICIENCIA DA PARTE AUTORA. A DECLARACAO FORMULADA POR PESSOA NATURAL E PREVISTA NO ART. 99, 3, DO CODIGO DE PROCESSO CIVIL NAO ENCERRA PRESUNCAO ABSOLUTA QUANTO AO ALEGADO PELA PARTE, CUMPRINDO AO JUIZ REALIZAR CONTROLE RIGOROSO PARA A CONCESSAO DA BENESSE CASO EVIDENCIADA A FALTA DOS PRESSUPOSTOS LEGAIS PARA O DEFERIMENTO DA GRATUIDADE, COMO FACULTADO PELO 2 DO ART. 99 DO MESMO DIPLOMA. NESSE SENTIDO, CONFIRA-SE A INTERPRETACAO DA MAIS RECENTE E ABALIZADA DOUTRINA. HA UM LEVE GRAU DE COLIDENCIA ENTRE ESSE 3 (QUE APONTA A PRESUNCAO DE NECESSIDADE) E O 2 DO ART. 99 (QUE AFIRMA SER POSSIVEL AO JUIZ INDEFERIR DE OFICIO, APOS A OITIVA DA PARTE). OU SEJA, APESAR DE EXISTIR A PRESUNCAO DE NECESSIDADE, TRATA-SE DE PRESUNCAO RELATIVA, POIS O JUIZ PODE, CONFORME SUA ANALISE DA CAUSA, INDEFERIR O BENEFICIO E NESSE CASO A PRESUNCAO DE GRATUIDADE SERA AFASTADA PELA ANALISE DO MAGISTRADO EM RELACAO AO QUE CONSTA DOS AUTOS. (GAJARDONI, DELLORE, ROQUE E OLIVEIRA JR. TEORIA GERAL DO PROCESSO COMENTARIOS AO CPC DE 2015: PARTE GERAL. 1 ED. SAO PAULO: FORENSE, 2015) NA ESPECIE, OBSERVO QUE A PARTE NAO RELATA DESEMPREGO E CONTRATOU ADVOGADO PARTICULAR QUE NAO DECLARA ATUAR PRO BONO OU AD EXITUM. CONSIDERADAS COLETIVAMENTE, TAIS CIRCUNSTANCIAS INDICAM QUE, A PRINCIPIO, A PARTE NAO E ECONOMICAMENTE HIPOSSUFICIENTE PARA QUE RECEBA O BENEPLACITO DA GRATUIDADE. NAO SE DESCONHECE QUE O CODIGO DE PROCESSO CIVIL ADMITE A CONCESSAO DA GRATUIDADE PARA AQUELES QUE CONTRATAM ADVOGADO PARTICULAR PARA PATROCINIO DE SUA CAUSA (ART. 99, 4). ENTRETANTO, NADA IMPEDE QUE TAIS ELEMENTOS SEJAM CONSIDERADOS NA ANALISE JUDICIAL PARA VERIFICAR SE O POSTULANTE DE FATO POSSUI OU NAO RECURSOS SUFICIENTES PARA ARCAR COM AS DESPESAS PROCESSUAIS, CONSIDERANDO QUE O BENEFICIO, POR EXPRESSA PREVISAO CONSTITUCIONAL E LEGAL, E RESERVADO AQUELES QUE REALMENTE COLOCARIAM EM RISCO SUA PROPRIA SUBSISTENCIA SE TIVESSEM DE DESEMBOLSAR OS VALORES EM VOGA (CONSTITUICAO FEDERAL, ART. 5, INC. LXXIV E CODIGO DE PROCESSO CIVIL, ART. 98, CAPUT). EM SINTESE, AS CIRCUNSTANCIAS SUPRAMENCIONADAS INDICAM, ANALISADAS EM CONJUNTO, QUE A PARTE PODE NAO SER HIPOSSUFICIENTE PARA OS FINS ALMEJADOS, O QUE DEMANDA A DILACAO PROBATORIA INICIAL PARA O ESCORREITO JULGAMENTO DO REQUERIMENTO. ANTE O EXPOSTO, APRESENTE A PARTE AUTORA, NO PRAZO DE CINCO DIAS, COPIA DE SUAS DUAS ULTIMAS DIRPF E HOLERITES DE SALARIO/INSS, E SE CASADA FOR, TAMBEM A DE SEU CONJUGE. EM CASO DE ISENCAO QUANTO A DECLARACAO PERANTE A RECEITA FEDERAL, DEVERA A PARTE JUNTAR, ALEM DE SEUS COMPROVANTES DE RENDA, TAMBEM A COMPROVACAO DE REGULARIDADE PERANTE O FISCO. O SILENCIO SERA INTERPRETADO COMO DESISTENCIA DO REQUERIMENTO DA BENESSE. 3 - PASSO A APRECIAR O PEDIDO LIMINAR, A FIM DE EVITAR O PERECIMENTO DO DIREITO. A TUTELA ANTECIPADA DE URGENCIA SERA CONCEDIDA QUANDO HOUVER ELEMENTOS QUE EVIDENCIEM A PROBABILIDADE DO DIREITO E O PERIGO DE DANO OU O RISCO AO RESULTADO UTIL DO PROCESSO (CODIGO DE PROCESSO CIVIL, ART. 300). A ANALISE DOS REQUERIMENTOS DE TAL ESPECIE E FEITA A PARTIR DE UM JUIZO DE COGNICAO SUMARIA, CARACTERISTICO DAS MEDIDAS A SEREM APRECIADAS LIMINARMENTE. NA ESPECIE, NAO VISLUMBRO A PRESENCA DOS ALUDIDOS REQUISITOS NECESSARIOS A ANTECIPACAO DOS EFEITOS DA TUTELA JURISDICIONAL. CONFORME PRINTS DE CONVERSA REALIZADA ENTRE A AUTORA E A SUPOSTA ESTELIONATARIA, VERIFICA-SE QUE HOUVE A PROMESSA DE RENTABILIDADE DE R$ 1.700,00 LOGO APOS O APORTE REALIZADO. CONSTA DA FLS. 34 QUE HOUVE O ENVIO DE TRANSFERENCIA NO IMPORTE DE R$ 2.200,00 PARA A CHAVE PIX INDICADA, NAO HAVENDO, NOS AUTOS, OUTROS DOCUMENTOS QUE COMPROVEM O NAO RECEBIMENTO DA TRANSFERENCIA. DESSA FORMA, RECOMENDAVEL A INSTAURACAO DO CONTRADITORIO PARA MELHOR ESCLARECIMENTOS DOS FATOS NARRADOS. ANTE O EXPOSTO, INDEFIRO A TUTELA DE URGENCIA. COM A REGULARIZACAO DO FEITO, TORNEM CONCLUSOS. INTIME-SE. ADVOGADOS(S): TABATA RIBEIRO BRITO MIQUELETTI (OAB 87889/PR)",
                "PublishDate": "2023-10-31T00:00:00",
                "CaptureDate": "2023-11-02T01:35:30"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0918/2023 DATA DA PUBLICACAO: 06/11/2023 NUMERO DO DIARIO: 3852",
                "PublishDate": "2023-10-31T00:00:00",
                "CaptureDate": "2023-11-02T01:35:30"
              },
              {
                "Content": "PROCESSO : 1151413-34.2023.8.26.0100 CLASSE : PROCEDIMENTO COMUM CIVEL REQTE : BEATRIZ ANDRADE DA SILVA ADVOGADO : 87889/PR - TABATA RIBEIRO BRITO MIQUELETTI REQDO : KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA VARA : 8 VARA CIVEL",
                "PublishDate": "2023-10-31T00:00:00",
                "CaptureDate": "2023-11-02T01:35:29"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2023-10-30T00:00:00",
                "CaptureDate": "2023-11-02T01:35:30"
              },
              {
                "Content": "PROFERIDAS OUTRAS DECISOES NAO ESPECIFICADAS VISTOS. CONFORME ARTIGO 1,  2, III, \"A\", DA LEI N 11.419/06, A ASSINATURA ELETRONICA DEVE SER BASEADA EM CERTIFICADO DIGITAL EMITIDO POR AUTORIDADE CERTIFICADORA CREDENCIADA. EM CONSULTA AO SITE DA EMPRESA ZAPSIGN, VERIFICA-SE QUE AS ASSINATURAS DIGITAIS FIRMADAS ATRAVES DA MESMA SAO REALIZADAS ATRAVES DE LINKS ENCAMINHADOS AOS SIGNATARIOS. ALEM DISSO, VERIFICA-SE QUE TAL ENTIDADE NAO SE ENCONTRA CREDENCIADA A ICP-BRASIL (HTTPS://ESTRUTURA.ITI.GOV.BR). SOBRE O TEMA, JA SE PRONUNCIOU A CGJ DO E. TJSP: NORMAS DE SERVICO. EXPEDIENTE FORMADO A PARTIR DE OFICIO DA COMISSAO DE DIREITOS E PRERROGATIVAS DA ORDEM DOS ADVOGADOS DO BRASIL SECAO DE SAO PAULO - VEICULANDO RECLAMACAO APRESENTADA POR ADVOGADO ACERCA DA CONDUTA DE MAGISTRADO QUE TERIA SE RECUSADO A ACEITAR PROCURACAO ASSINADA ELETRONICAMENTE, EMBORA NAO POR MEIO DE CERTIFICADO DIGITAL HIPOTESE EM QUE A PROCURACAO REFERIDA FOI ASSINADA PELA OUTORGANTE DE FORMA ELETRONICA, SEM CERTIFICADO DIGITAL, POR MEIO DE UMA PLATAFORMA DE SOFTWARE DE ASSINATURA ELETRONICA DENOMINADA PANDA.DOC.COM CARACTERIZACAO DE ASSINATURA ELETRONICA AVANCADA, QUE NAO SE CONFUNDE COM ASSINATURA ELETRONICA QUALIFICADA OU ASSINATURA DIGITAL, NA DEFINICAO DA LEI N 14.063/2020 INCIDENCIA DO ART. 10,  1 E 2 DA MEDIDA PROVISORIA N 2.200-2/2001 DE 24/08/2001 (VIGENTE POR FORCA DA EC N 32/2001), DA LEI N 11.419/06 E DO ART. 5 E  1 DA RESOLUCAO N 551 DO C. ORGAO ESPECIAL - PROCURACAO QUE, SE ASSINADA DE FORMA ELETRONICA, SOMENTE TERA VALIDADE NO PROCESSO ELETRONICO SE SE TRATAR DE ASSINATURA ELETRONICA QUALIFICADA, OU SEJA, SE TIVER SIDO ASSINADA ELETRONICAMENTE MEDIANTE USO DE CERTIFICADO DIGITAL - MATERIA ESTRITAMENTE JURISDICIONAL PLEITO DE ENCAMINHAMENTO DE ORIENTACAO INTERNA AOS MAGISTRADOS PARA QUE SE ATENTEM AS PRERROGATIVAS DA ADVOCACIA DESNECESSIDADE INEXISTENCIA DE VIOLACAO DAS PRERROGATIVAS DESNECESSIDADE, OUTROSSIM, DE QUAISQUER ALTERACOES OU COMPLEMENTACOES DAS NORMAS DE SERVICO DESTA CORREGEDORIA GERAL DA JUSTICA, QUE REGULAM A QUESTAO DE FORMA COMPLETA E EXAURIENTE, E EM CONFORMIDADE COM AS DISPOSICOES LEGAIS PERTINENTES PARECER PELO INDEFERIMENTO DOS PEDIDOS.\" (PROCESSO DIGITAL N. 2021/00100891, 26.01.2022) PORTANTO, NECESSARIA A APRESENTACAO DE NOVO MANDATO, NO PRAZO DE QUINZE DIAS, SOB PENA DE EXTINCAO. 2 - A ANALISE DO REQUERIMENTO DE GRATUIDADE DE JUSTICA DEMANDA, NO CASO CONCRETO, A COMPROVACAO DA CONDICAO DE HIPOSSUFICIENCIA DA PARTE AUTORA. A DECLARACAO FORMULADA POR PESSOA NATURAL E PREVISTA NO ART. 99, 3, DO CODIGO DE PROCESSO CIVIL NAO ENCERRA PRESUNCAO ABSOLUTA QUANTO AO ALEGADO PELA PARTE, CUMPRINDO AO JUIZ REALIZAR CONTROLE RIGOROSO PARA A CONCESSAO DA BENESSE CASO EVIDENCIADA A FALTA DOS PRESSUPOSTOS LEGAIS PARA O DEFERIMENTO DA GRATUIDADE, COMO FACULTADO PELO 2 DO ART. 99 DO MESMO DIPLOMA. NESSE SENTIDO, CONFIRA-SE A INTERPRETACAO DA MAIS RECENTE E ABALIZADA DOUTRINA. HA UM LEVE GRAU DE COLIDENCIA ENTRE ESSE 3 (QUE APONTA A PRESUNCAO DE NECESSIDADE) E O 2 DO ART. 99 (QUE AFIRMA SER POSSIVEL AO JUIZ INDEFERIR DE OFICIO, APOS A OITIVA DA PARTE). OU SEJA, APESAR DE EXISTIR A PRESUNCAO DE NECESSIDADE, TRATA-SE DE PRESUNCAO RELATIVA, POIS O JUIZ PODE, CONFORME SUA ANALISE DA CAUSA, INDEFERIR O BENEFICIO E NESSE CASO A PRESUNCAO DE GRATUIDADE SERA AFASTADA PELA ANALISE DO MAGISTRADO EM RELACAO AO QUE CONSTA DOS AUTOS. (GAJARDONI, DELLORE, ROQUE E OLIVEIRA JR. TEORIA GERAL DO PROCESSO COMENTARIOS AO CPC DE 2015: PARTE GERAL. 1 ED. SAO PAULO: FORENSE, 2015) NA ESPECIE, OBSERVO QUE A PARTE NAO RELATA DESEMPREGO E CONTRATOU ADVOGADO PARTICULAR QUE NAO DECLARA ATUAR PRO BONO OU AD EXITUM. CONSIDERADAS COLETIVAMENTE, TAIS CIRCUNSTANCIAS INDICAM QUE, A PRINCIPIO, A PARTE NAO E ECONOMICAMENTE HIPOSSUFICIENTE PARA QUE RECEBA O BENEPLACITO DA GRATUIDADE. NAO SE DESCONHECE QUE O CODIGO DE PROCESSO CIVIL ADMITE A CONCESSAO DA GRATUIDADE PARA AQUELES QUE CONTRATAM ADVOGADO PARTICULAR PARA PATROCINIO DE SUA CAUSA (ART. 99, 4). ENTRETANTO, NADA IMPEDE QUE TAIS ELEMENTOS SEJAM CONSIDERADOS NA ANALISE JUDICIAL PARA VERIFICAR SE O POSTULANTE DE FATO POSSUI OU NAO RECURSOS SUFICIENTES PARA ARCAR COM AS DESPESAS PROCESSUAIS, CONSIDERANDO QUE O BENEFICIO, POR EXPRESSA PREVISAO CONSTITUCIONAL E LEGAL, E RESERVADO AQUELES QUE REALMENTE COLOCARIAM EM RISCO SUA PROPRIA SUBSISTENCIA SE TIVESSEM DE DESEMBOLSAR OS VALORES EM VOGA (CONSTITUICAO FEDERAL, ART. 5, INC. LXXIV E CODIGO DE PROCESSO CIVIL, ART. 98, CAPUT). EM SINTESE, AS CIRCUNSTANCIAS SUPRAMENCIONADAS INDICAM, ANALISADAS EM CONJUNTO, QUE A PARTE PODE NAO SER HIPOSSUFICIENTE PARA OS FINS ALMEJADOS, O QUE DEMANDA A DILACAO PROBATORIA INICIAL PARA O ESCORREITO JULGAMENTO DO REQUERIMENTO. ANTE O EXPOSTO, APRESENTE A PARTE AUTORA, NO PRAZO DE CINCO DIAS, COPIA DE SUAS DUAS ULTIMAS DIRPF E HOLERITES DE SALARIO/INSS, E SE CASADA FOR, TAMBEM A DE SEU CONJUGE. EM CASO DE ISENCAO QUANTO A DECLARACAO PERANTE A RECEITA FEDERAL, DEVERA A PARTE JUNTAR, ALEM DE SEUS COMPROVANTES DE RENDA, TAMBEM A COMPROVACAO DE REGULARIDADE PERANTE O FISCO. O SILENCIO SERA INTERPRETADO COMO DESISTENCIA DO REQUERIMENTO DA BENESSE. 3 - PASSO A APRECIAR O PEDIDO LIMINAR, A FIM DE EVITAR O PERECIMENTO DO DIREITO. A TUTELA ANTECIPADA DE URGENCIA SERA CONCEDIDA QUANDO HOUVER ELEMENTOS QUE EVIDENCIEM A PROBABILIDADE DO DIREITO E O PERIGO DE DANO OU O RISCO AO RESULTADO UTIL DO PROCESSO (CODIGO DE PROCESSO CIVIL, ART. 300). A ANALISE DOS REQUERIMENTOS DE TAL ESPECIE E FEITA A PARTIR DE UM JUIZO DE COGNICAO SUMARIA, CARACTERISTICO DAS MEDIDAS A SEREM APRECIADAS LIMINARMENTE. NA ESPECIE, NAO VISLUMBRO A PRESENCA DOS ALUDIDOS REQUISITOS NECESSARIOS A ANTECIPACAO DOS EFEITOS DA TUTELA JURISDICIONAL. CONFORME PRINTS DE CONVERSA REALIZADA ENTRE A AUTORA E A SUPOSTA ESTELIONATARIA, VERIFICA-SE QUE HOUVE A PROMESSA DE RENTABILIDADE DE R$ 1.700,00 LOGO APOS O APORTE REALIZADO. CONSTA DA FLS. 34 QUE HOUVE O ENVIO DE TRANSFERENCIA NO IMPORTE DE R$ 2.200,00 PARA A CHAVE PIX INDICADA, NAO HAVENDO, NOS AUTOS, OUTROS DOCUMENTOS QUE COMPROVEM O NAO RECEBIMENTO DA TRANSFERENCIA. DESSA FORMA, RECOMENDAVEL A INSTAURACAO DO CONTRADITORIO PARA MELHOR ESCLARECIMENTOS DOS FATOS NARRADOS. ANTE O EXPOSTO, INDEFIRO A TUTELA DE URGENCIA. COM A REGULARIZACAO DO FEITO, TORNEM CONCLUSOS. INTIME-SE.",
                "PublishDate": "2023-10-30T00:00:00",
                "CaptureDate": "2023-11-02T01:35:30"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-10-27T00:00:00",
                "CaptureDate": "2023-11-02T01:35:30"
              }
            ],
            "Petitions": [],
            "Decisions": []
          },
          {
            "Number": "10114609520238260604",
            "Type": "PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL",
            "MainSubject": "BANCARIOS",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "",
            "CourtDistrict": "SUMARE",
            "Judge": "ROBERTA STEINDORFF MALHEIROS",
            "JudgingBody": "VARA DO JUIZADO ESPECIAL CIVEL E CRIMINAL",
            "State": "SP",
            "Status": "INDEFINIDO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "BANCÁRIOS",
            "InferredCNJSubjectNumber": 7752,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO DO JUIZADO ESPECIAL CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "BANCARIOS"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 16800,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-10-31T00:00:00",
            "NoticeDate": "2023-10-27T00:00:00",
            "LastMovementDate": "2023-10-31T00:00:00",
            "CaptureDate": "2023-11-02T03:23:35",
            "LastUpdate": "2023-11-02T03:23:35",
            "NumberOfParties": 5,
            "NumberOfUpdates": 3,
            "LawSuitAge": 124,
            "AverageNumberOfUpdatesPerMonth": 0,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "80607020091",
                "IsPartyActive": true,
                "Name": "ROBERTA STEINDORFF MALHEIROS",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-11-02T03:23:35"
              },
              {
                "Doc": "41532492898",
                "IsPartyActive": true,
                "Name": "HEVERTON MAROSTICA",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-11-02T03:23:35"
              },
              {
                "Doc": "01450067603",
                "IsPartyActive": true,
                "Name": "MARIANA PRATES DE SOUSA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "SpecificType": "ADVOGADA (REQTE)"
                },
                "LastCaptureDate": "2023-11-02T03:23:35"
              },
              {
                "Doc": "46189325000165",
                "IsPartyActive": true,
                "Name": "ITAU UNIBANCO S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-11-02T03:23:35"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-11-02T03:23:35"
              }
            ],
            "Updates": [
              {
                "Content": "PROCESSO : 1011460-95.2023.8.26.0604 CLASSE : PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL REQTE : HEVERTON MAROSTICA ADVOGADO : 430803/SP - MARIANA PRATES DE SOUSA REQDO : STARK BANK S.A. VARA : VARA DO JUIZADO ESPECIAL CIVEL E CRIMINAL",
                "PublishDate": "2023-10-31T00:00:00",
                "CaptureDate": "2023-11-02T03:23:35"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2023-10-30T00:00:00",
                "CaptureDate": "2023-11-02T03:23:36"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-10-27T00:00:00",
                "CaptureDate": "2023-11-02T03:23:36"
              }
            ],
            "Petitions": [],
            "Decisions": []
          },
          {
            "Number": "10056203720238260400",
            "Type": "PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL",
            "MainSubject": "INDENIZACAO POR DANO MATERIAL",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "",
            "CourtDistrict": "OLIMPIA",
            "Judge": "ANDRE DA FONSECA TAVARES",
            "JudgingBody": "VARA DO JUIZADO ESPECIAL CIVEL E CRIMINAL",
            "State": "SP",
            "Status": "ATIVO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "INDENIZAÇÃO POR DANO MATERIAL",
            "InferredCNJSubjectNumber": 7780,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO DO JUIZADO ESPECIAL CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "INDENIZACAO POR DANO MATERIAL",
              "INDENIZACAO POR DANO MORAL"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 7740,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-11-01T00:00:00",
            "NoticeDate": "2023-10-27T00:00:00",
            "LastMovementDate": "2023-11-01T00:00:00",
            "CaptureDate": "2023-11-02T10:30:10",
            "LastUpdate": "2023-11-02T10:30:10",
            "NumberOfParties": 6,
            "NumberOfUpdates": 6,
            "LawSuitAge": 124,
            "AverageNumberOfUpdatesPerMonth": 1,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "01118961692",
                "IsPartyActive": true,
                "Name": "ANDRE DA FONSECA TAVARES",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-11-02T10:30:10"
              },
              {
                "Doc": "44927866866",
                "IsPartyActive": true,
                "Name": "HIAGO VIEIRA PANELLA",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-11-02T10:30:10"
              },
              {
                "Doc": "13665997801",
                "IsPartyActive": true,
                "Name": "CAIA AIDAR PITON",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "125154",
                  "State": "SP",
                  "SpecificType": "ADVOGADO (REQTE)"
                },
                "LastCaptureDate": "2023-11-02T10:30:10"
              },
              {
                "Doc": "48472928000103",
                "IsPartyActive": true,
                "Name": "KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-11-02T10:30:10"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-11-02T10:30:10"
              },
              {
                "Doc": "10341411000102",
                "IsPartyActive": true,
                "Name": "BANCO SANTANDER S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-11-02T10:30:10"
              }
            ],
            "Updates": [
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0716/2023 DATA DA PUBLICACAO: 06/11/2023 NUMERO DO DIARIO: 3852",
                "PublishDate": "2023-11-01T00:00:00",
                "CaptureDate": "2023-11-02T10:30:11"
              },
              {
                "Content": "PROCESSO 1005620-37.2023.8.26.0400 - PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL - INDENIZACAO POR DANO MATERIAL - HIAGO VIEIRA PANELLA - VISTOS. RECEBO A PETICAO INICIAL. DEFIRO AO AUTOR OS BENEFICIOS DA GRATUIDADE PROCESSUAL. ANOTE-SE. PASSO A ANALISAR O PEDIDO DE TUTELA DE URGENCIA EM JUIZO DE COGNICAO SUMARIA, NOS TERMOS DO ARTIGO 300 DO CODIGO DE PROCESSO CIVIL EM VIGOR (ART. 300. A TUTELA DE URGENCIA SERA CONCEDIDA QUANDO HOUVER ELEMENTOS QUE EVIDENCIEM A PROBABILIDADE DO DIREITO E O PERIGO DE DANO OU O RISCO AO RESULTADO UTIL DO PROCESSO). A ALEGACAO CONSTANTE DA INICIAL E VEROSSIMIL, HAVENDO ALTA PROBABILIDADE DO DIREITO ALEGADO PELO REQUERENTE E RISCO DE DANO PELA DEMORA INERENTE AO PROCESSO. OS DOCUMENTOS JUNTADOS NA EXORDIAL CORROBORAM A NARRATIVA DA EXISTENCIA DE FRAUDE POR MEIO DA INDUCAO DO AUTOR A REALIZAR TAREFAS MEDIANTE TRANSFERENCIAS BANCARIAS COM PROMESSAS DE RETORNO IMEDIATO IRREAIS DE 60% SOBRE O VALOR TRANSFERIDO, SENDO LHE EXIGIDA A TRANSFERENCIA DE NOVOS VALORES PARA LIBERACAO DE SALDO. POR OUTRO LADO, NAO SE VERIFICA, A PRIORI, RESPONSABILIDADE DAS INSTITUICOES FINANCEIRAS QUE FIGURARAM APENAS COMO INTERMEDIADORAS DOS PAGAMENTOS, SITUACAO QUE DEMANDA UMA ANALISE MAIS PROFUNDA E DO PREVIO CONTRADITORIO. ANTE O EXPOSTO, NOS TERMOS DO ARTIGO 300 DO CODIGO DE PROCESSO CIVIL, DEFIRO PARCIALMENTE A LIMINAR PARA DETERMINAR O BLOQUEIO NAS CONTAS BANCARIAS DA REQUERIDA ABAIXO, VIA SISBAJUD, NO VALOR DE R$ 2.740,00, ATE O DESFECHO DO FEITO: KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA, CNPJ 48.472.928/0001-03. NO MAIS, CITE-SE E INTIME-SE O(A) REQUERIDO(A) PARA QUE, CASO QUEIRA, OFERECA CONTESTACAO NO PRAZO DE 15 DIAS, SOB PENA DE REVELIA. HAVENDO PROPOSTA DE ACORDO PARA O CASO EM PAUTA, A PARTE RE DEVERA TRAZE-LA NA PROPRIA CONTESTACAO, LEMBRANDO-SE QUE A APRESENTACAO DE PROPOSTA DE CONCILIACAO PELO REU NAO INDUZ A CONFISSAO (ENUNCIADO DE N 76 DO FONAJEF). SEM PREJUIZO, AS PARTES PODEM EFETUAR TRANSACOES EXTRAJUDICIALMENTE INDEPENDENTEMENTE DA INTERVENCAO DO PODER JUDICIARIO, COMUNICANDO NOS AUTOS O TEOR DO ATO. AS PARTES DEVERAO COMUNICAR AO JUIZO AS MUDANCAS DE ENDERECO OCORRIDAS NO CURSO DO PROCESSO, REPUTANDO-SE EFICAZES AS INTIMACOES ENVIADAS AO LOCAL ANTERIORMENTE INDICADO (ART. 19,  2, DA LEI N 9.099/95). INT. OLIMPIA - ADV: CAIA AIDAR PITON (OAB 125154/SP)",
                "PublishDate": "2023-11-01T00:00:00",
                "CaptureDate": "2023-11-02T10:30:10"
              },
              {
                "Content": "CONCEDIDA EM PARTE A ANTECIPACAO DE TUTELA VISTOS. RECEBO A PETICAO INICIAL. DEFIRO AO AUTOR OS BENEFICIOS DA GRATUIDADE PROCESSUAL. ANOTE-SE. PASSO A ANALISAR O PEDIDO DE TUTELA DE URGENCIA EM JUIZO DE COGNICAO SUMARIA, NOS TERMOS DO ARTIGO 300 DO CODIGO DE PROCESSO CIVIL EM VIGOR (ART. 300. A TUTELA DE URGENCIA SERA CONCEDIDA QUANDO HOUVER ELEMENTOS QUE EVIDENCIEM A PROBABILIDADE DO DIREITO E O PERIGO DE DANO OU O RISCO AO RESULTADO UTIL DO PROCESSO). A ALEGACAO CONSTANTE DA INICIAL E VEROSSIMIL, HAVENDO ALTA PROBABILIDADE DO DIREITO ALEGADO PELO REQUERENTE E RISCO DE DANO PELA DEMORA INERENTE AO PROCESSO. OS DOCUMENTOS JUNTADOS NA EXORDIAL CORROBORAM A NARRATIVA DA EXISTENCIA DE FRAUDE POR MEIO DA INDUCAO DO AUTOR A REALIZAR \"TAREFAS\" MEDIANTE TRANSFERENCIAS BANCARIAS COM PROMESSAS DE RETORNO IMEDIATO IRREAIS DE 60% SOBRE O VALOR TRANSFERIDO, SENDO LHE EXIGIDA A TRANSFERENCIA DE NOVOS VALORES PARA LIBERACAO DE SALDO. POR OUTRO LADO, NAO SE VERIFICA, A PRIORI, RESPONSABILIDADE DAS INSTITUICOES FINANCEIRAS QUE FIGURARAM APENAS COMO INTERMEDIADORAS DOS PAGAMENTOS, SITUACAO QUE DEMANDA UMA ANALISE MAIS PROFUNDA E DO PREVIO CONTRADITORIO. ANTE O EXPOSTO, NOS TERMOS DO ARTIGO 300 DO CODIGO DE PROCESSO CIVIL, DEFIRO PARCIALMENTE A LIMINAR PARA DETERMINAR O BLOQUEIO NAS CONTAS BANCARIAS DA REQUERIDA ABAIXO, VIA SISBAJUD, NO VALOR DE R$ 2.740,00, ATE O DESFECHO DO FEITO: KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA, CNPJ 48.472.928/0001-03. NO MAIS, CITE-SE E INTIME-SE O(A) REQUERIDO(A) PARA QUE, CASO QUEIRA, OFERECA CONTESTACAO NO PRAZO DE 15 DIAS, SOB PENA DE REVELIA. HAVENDO PROPOSTA DE ACORDO PARA O CASO EM PAUTA, A PARTE RE DEVERA TRAZE-LA NA PROPRIA CONTESTACAO, LEMBRANDO-SE QUE \"A APRESENTACAO DE PROPOSTA DE CONCILIACAO PELO REU NAO INDUZ A CONFISSAO\" (ENUNCIADO DE N 76 DO FONAJEF). SEM PREJUIZO, AS PARTES PODEM EFETUAR TRANSACOES EXTRAJUDICIALMENTE INDEPENDENTEMENTE DA INTERVENCAO DO PODER JUDICIARIO, COMUNICANDO NOS AUTOS O TEOR DO ATO. AS PARTES DEVERAO COMUNICAR AO JUIZO AS MUDANCAS DE ENDERECO OCORRIDAS NO CURSO DO PROCESSO, REPUTANDO-SE EFICAZES AS INTIMACOES ENVIADAS AO LOCAL ANTERIORMENTE INDICADO (ART. 19,  2, DA LEI N 9.099/95). INT. OLIMPIA",
                "PublishDate": "2023-10-31T00:00:00",
                "CaptureDate": "2023-11-02T10:30:11"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0716/2023 TEOR DO ATO: VISTOS. RECEBO A PETICAO INICIAL. DEFIRO AO AUTOR OS BENEFICIOS DA GRATUIDADE PROCESSUAL. ANOTE-SE. PASSO A ANALISAR O PEDIDO DE TUTELA DE URGENCIA EM JUIZO DE COGNICAO SUMARIA, NOS TERMOS DO ARTIGO 300 DO CODIGO DE PROCESSO CIVIL EM VIGOR (ART. 300. A TUTELA DE URGENCIA SERA CONCEDIDA QUANDO HOUVER ELEMENTOS QUE EVIDENCIEM A PROBABILIDADE DO DIREITO E O PERIGO DE DANO OU O RISCO AO RESULTADO UTIL DO PROCESSO). A ALEGACAO CONSTANTE DA INICIAL E VEROSSIMIL, HAVENDO ALTA PROBABILIDADE DO DIREITO ALEGADO PELO REQUERENTE E RISCO DE DANO PELA DEMORA INERENTE AO PROCESSO. OS DOCUMENTOS JUNTADOS NA EXORDIAL CORROBORAM A NARRATIVA DA EXISTENCIA DE FRAUDE POR MEIO DA INDUCAO DO AUTOR A REALIZAR \"TAREFAS\" MEDIANTE TRANSFERENCIAS BANCARIAS COM PROMESSAS DE RETORNO IMEDIATO IRREAIS DE 60% SOBRE O VALOR TRANSFERIDO, SENDO LHE EXIGIDA A TRANSFERENCIA DE NOVOS VALORES PARA LIBERACAO DE SALDO. POR OUTRO LADO, NAO SE VERIFICA, A PRIORI, RESPONSABILIDADE DAS INSTITUICOES FINANCEIRAS QUE FIGURARAM APENAS COMO INTERMEDIADORAS DOS PAGAMENTOS, SITUACAO QUE DEMANDA UMA ANALISE MAIS PROFUNDA E DO PREVIO CONTRADITORIO. ANTE O EXPOSTO, NOS TERMOS DO ARTIGO 300 DO CODIGO DE PROCESSO CIVIL, DEFIRO PARCIALMENTE A LIMINAR PARA DETERMINAR O BLOQUEIO NAS CONTAS BANCARIAS DA REQUERIDA ABAIXO, VIA SISBAJUD, NO VALOR DE R$ 2.740,00, ATE O DESFECHO DO FEITO: KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA, CNPJ 48.472.928/0001-03. NO MAIS, CITE-SE E INTIME-SE O(A) REQUERIDO(A) PARA QUE, CASO QUEIRA, OFERECA CONTESTACAO NO PRAZO DE 15 DIAS, SOB PENA DE REVELIA. HAVENDO PROPOSTA DE ACORDO PARA O CASO EM PAUTA, A PARTE RE DEVERA TRAZE-LA NA PROPRIA CONTESTACAO, LEMBRANDO-SE QUE \"A APRESENTACAO DE PROPOSTA DE CONCILIACAO PELO REU NAO INDUZ A CONFISSAO\" (ENUNCIADO DE N 76 DO FONAJEF). SEM PREJUIZO, AS PARTES PODEM EFETUAR TRANSACOES EXTRAJUDICIALMENTE INDEPENDENTEMENTE DA INTERVENCAO DO PODER JUDICIARIO, COMUNICANDO NOS AUTOS O TEOR DO ATO. AS PARTES DEVERAO COMUNICAR AO JUIZO AS MUDANCAS DE ENDERECO OCORRIDAS NO CURSO DO PROCESSO, REPUTANDO-SE EFICAZES AS INTIMACOES ENVIADAS AO LOCAL ANTERIORMENTE INDICADO (ART. 19,  2, DA LEI N 9.099/95). INT. OLIMPIA ADVOGADOS(S): CAIA AIDAR PITON (OAB 125154/SP)",
                "PublishDate": "2023-10-31T00:00:00",
                "CaptureDate": "2023-11-02T10:30:11"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2023-10-30T00:00:00",
                "CaptureDate": "2023-11-02T10:30:11"
              },
              {
                "Content": "DISTRIBUIDO POR DIRECIONAMENTO (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR) HA SUSPEITA DE REPETICAO DA ACAO. CONFRONTE OS DADOS DO PROCESSO DISTRIBUIDO COM OS DADOS DO PROCESSO : 1005606-53.2023.8.26.0400.",
                "PublishDate": "2023-10-27T00:00:00",
                "CaptureDate": "2023-11-02T10:30:11"
              }
            ],
            "Petitions": [],
            "Decisions": [
              {
                "DecisionContent": "DEFIRO AO AUTOR OS BENEFICIOS DA GRATUIDADE PROCESSUAL.",
                "DecisionDate": "2023-11-01T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO PARCIALMENTE A LIMINAR PARA DETERMINAR O BLOQUEIO NAS CONTAS BANCARIAS DA REQUERIDA ABAIXO, VIA SISBAJUD, NO VALOR DE R$ 2.740,00, ATE O DESFECHO DO FEITO: KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA, CNPJ 48.472.928/0001-03.",
                "DecisionDate": "2023-11-01T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO AO AUTOR OS BENEFICIOS DA GRATUIDADE PROCESSUAL.",
                "DecisionDate": "2023-10-31T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO PARCIALMENTE A LIMINAR PARA DETERMINAR O BLOQUEIO NAS CONTAS BANCARIAS DA REQUERIDA ABAIXO, VIA SISBAJUD, NO VALOR DE R$ 2.740,00, ATE O DESFECHO DO FEITO: KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA, CNPJ 48.472.928/0001-03.",
                "DecisionDate": "2023-10-31T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO AO AUTOR OS BENEFICIOS DA GRATUIDADE PROCESSUAL.",
                "DecisionDate": "2023-10-31T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO PARCIALMENTE A LIMINAR PARA DETERMINAR O BLOQUEIO NAS CONTAS BANCARIAS DA REQUERIDA ABAIXO, VIA SISBAJUD, NO VALOR DE R$ 2.740,00, ATE O DESFECHO DO FEITO: KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA, CNPJ 48.472.928/0001-03.",
                "DecisionDate": "2023-10-31T00:00:00"
              }
            ]
          },
          {
            "Number": "50269951620238080048",
            "Type": "PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL",
            "MainSubject": "DIREITO CIVIL (899) - RESPONSABILIDADE CIVIL (10431) - INDENIZACAO POR DANO MATERIAL (10439 DIREITO CIVIL (899) - RESPONSABILIDADE CIVIL (10431) - INDENIZACAO POR DANO MORAL (10433 DIREITO PROCESSUAL CIVIL E DO TRABALHO (8826) - LIQUIDACAO / CUMPRIMENTO / EXECUCAO (9148) - OBRIGACAO DE FAZER / NAO FAZER (10671",
            "CourtName": "TJES",
            "CourtLevel": "1",
            "CourtType": "ESPECIAL CIVEL",
            "CourtDistrict": "SERRA",
            "JudgingBody": "SERRA - COMARCA DA CAPITAL - 3 JUIZADO ESPECIAL CIVEL",
            "State": "ES",
            "Status": "INDEFINIDO",
            "LawsuitHostService": "PJE",
            "InferredCNJSubjectName": "OBRIGAÇÃO DE FAZER / NÃO FAZER",
            "InferredCNJSubjectNumber": 10671,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO DO JUIZADO ESPECIAL CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO PROCESSUAL CIVIL E DO TRABALHO",
            "InferredBroadCNJSubjectNumber": 8826,
            "OtherSubjects": [
              "DIREITO CIVIL (899) - RESPONSABILIDADE CIVIL (10431) - INDENIZACAO POR DANO MATERIAL (10439 DIREITO CIVIL (899) - RESPONSABILIDADE CIVIL (10431) - INDENIZACAO POR DANO MORAL (10433 DIREITO PROCESSUAL CIVIL E DO TRABALHO (8826) - LIQUIDACAO / CUMPRIMENTO / EXECUCAO (9148) - OBRIGACAO DE FAZER / NAO FAZER (10671"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": -1,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-11-06T00:00:00",
            "NoticeDate": "2023-10-30T00:00:00",
            "LastMovementDate": "2023-11-07T00:00:00",
            "CaptureDate": "2023-11-13T13:02:44",
            "LastUpdate": "2023-11-13T13:02:44",
            "NumberOfParties": 12,
            "NumberOfUpdates": 8,
            "LawSuitAge": 121,
            "AverageNumberOfUpdatesPerMonth": 1,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "10025325744",
                "IsPartyActive": true,
                "Name": "VALDISON MORAES PIMENTEL JUNIOR",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQUERENTE"
                },
                "LastCaptureDate": "2023-11-13T13:02:44"
              },
              {
                "Doc": "97963771953",
                "IsPartyActive": true,
                "Name": "DEBORA YANAI",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "100499",
                  "State": "PR",
                  "SpecificType": "ADVOGADO (REQUERENTE)"
                },
                "LastCaptureDate": "2023-11-13T13:02:44"
              },
              {
                "Doc": "05533524746",
                "IsPartyActive": true,
                "Name": "JEFFERSON RIBEIRO SCHULZ",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "33231",
                  "State": "ES",
                  "SpecificType": "ADVOGADO (REQUERENTE)"
                },
                "LastCaptureDate": "2023-11-13T13:02:44"
              },
              {
                "Doc": "08561701000101",
                "IsPartyActive": true,
                "Name": "PAGSEGURO INTERNET LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQUERIDO"
                },
                "LastCaptureDate": "2023-11-13T13:02:44"
              },
              {
                "Doc": "31872495000172",
                "IsPartyActive": true,
                "Name": "BANCO C6 S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQUERIDO"
                },
                "LastCaptureDate": "2023-11-13T13:02:44"
              },
              {
                "Doc": "35624319000172",
                "IsPartyActive": true,
                "Name": "MK DIGITAL BANK INSTITUICAO DE PAGAMENTO S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQUERIDO"
                },
                "LastCaptureDate": "2023-11-13T13:02:44"
              },
              {
                "Doc": "48689840000130",
                "IsPartyActive": true,
                "Name": "CASH PAY MEIOS DE PAGAMENTO LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQUERIDO"
                },
                "LastCaptureDate": "2023-11-13T13:02:44"
              },
              {
                "Doc": "51880512000120",
                "IsPartyActive": true,
                "Name": "PAYWAY CONSULTORIA E SERVICOS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQUERIDO"
                },
                "LastCaptureDate": "2023-11-13T13:02:44"
              },
              {
                "IsPartyActive": true,
                "Name": "LUCAS PEREIRA DA SILVA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQUERIDO"
                },
                "LastCaptureDate": "2023-11-13T13:02:44"
              },
              {
                "IsPartyActive": true,
                "Name": "ANA BEATRIZ MENEZES DA SILVA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQUERIDO"
                },
                "LastCaptureDate": "2023-11-13T13:02:44"
              },
              {
                "Doc": "07472068306",
                "IsPartyActive": true,
                "Name": "LARYSSA BARBOSA ALVES",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQUERIDO"
                },
                "LastCaptureDate": "2023-11-13T13:02:44"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQUERIDO"
                },
                "LastCaptureDate": "2023-11-13T13:02:44"
              }
            ],
            "Updates": [
              {
                "Content": "PUBLICADO INTIMACAO - DIARIO EM 07/11/2023.",
                "PublishDate": "2023-11-07T00:00:00",
                "CaptureDate": "2023-11-13T13:02:44"
              },
              {
                "Content": "DISPONIBILIZADO NO DJ ELETRONICO EM 06/11/2023",
                "PublishDate": "2023-11-07T00:00:00",
                "CaptureDate": "2023-11-13T13:02:44"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO - DIARIO.",
                "PublishDate": "2023-11-01T00:00:00",
                "CaptureDate": "2023-11-13T13:02:44"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE . ESTADO DO ESPIRITO SANTO PODER JUDICIARIO JUIZO DE SERRA - COMARCA DA CAPITAL - 3 JUIZADO ESPECIAL CIVEL AVENIDA CARAPEBUS, 226, FORUM DESEMBARGADOR ANTONIO JOSE MIGUEL FEU ROSA, SAO GERALDO/CARAPINA, SERRA - ES - CEP: 29163-392 TELEFONE:(27) 33574861 PROCESSO N 5026995-16.2023.8.08.0048 REQUERENTE: VALDISON MORAES PIMENTEL JUNIOR ADVOGADOS DO(A) REQUERENTE: JEFFERSON RIBEIRO SCHULZ - ES33231, DEBORA YANAI - PR100499 REQUERIDO: PAGSEGURO INTERNET LTDA, ANA BEATRIZ MENEZES DA SILVA, BANCO C6 S.A., MK DIGITAL BANK INSTITUICAO DE PAGAMENTO S/A, CASH PAY MEIOS DE PAGAMENTO LTDA, PAYWAY CONSULTORIA E SERVICOS LTDA, LUCAS PEREIRA DA SILVA, LARYSSA BARBOSA ALVES, STARK BANK S.A. DESPACHO NARRA O DEMANDANTE, EM SINTESE, QUE RECEBEU UM CONVITE, ATRAVES DO APLICATIVO DE MENSAGENS WHATSAPP , PARA TRABALHAR ONLINE , REALIZANDO ALGUMAS TAREFAS PREDETERMINADAS, MEDIANTE O RECEBIMENTO DE VALORES A TITULO DE BONUS. PARA TANTO, DEVERIA SEGUIR CONTAS NA REDE SOCIAL INSTAGRAM , VISANDO AUMENTAR O NUMERO DE SEGUIDORES DOS SEUS TITULARES. NESTE CONTEXTO, RELATA QUE, SEGUINDO AS ORIENTACOES QUE LHE FORAM TRANSMITIDAS, FOI DIRECIONADO PARA O APLICATIVO TELEGRAM , ATRAVES DO QUAL PASSOU A RECEBER A LISTA DE TAREFAS A SEREM CUMPRIDAS, DOS CONTATOS IDENTIFICADOS COMO @ANALYST0004 E @LOVEDTON. ADUZ, AINDA, QUE, INICIALMENTE, LOGROU SER RECOMPENSADO PELOS DESAFIOS EXECUTADOS, SENDO O CONTROLE DE SUAS ATIVIDADES REALIZADO POR MEIO DO SITIO ELETRONICO BTCINVESTD.COM. CONTUDO, ASSEVERA QUE, APOS DETERMINADO LAPSO TEMPORAL, NOTOU QUE NAO ESTAVA MAIS OBTENDO NENHUM LUCRO, NAO OBSTANTE AS TAREFAS EFETIVADAS EM FAVOR DOS BENEFICIARIOS A ELE INDICADOS, DESCOBRINDO TER SIDO VITIMA DE UMA FRAUDE. ADEMAIS, APONTA TER SOFRIDO UM PREJUIZO DE R$ 12.799,79 (DOZE MIL, SETECENTOS E NOVENTA E NOVE REAIS E SETENTA E NOVE CENTAVOS), EM VIRTUDE DE TRANSFERENCIAS POR ELE EFETIVADAS EM FAVOR DAS PESSOAS FISICAS REQUERIDAS E DA EMPRESA CORRE CASH PAY MEIOS DE PAGAMENTO LTDA. ACRESCENTA QUE NOTICIOU OS FATOS A AUTORIDADE POLICIAL, BEM COMO BUSCOU REAVER A QUANTIA POR ELE DESPENDIDA, INCLUSIVE MEDIANTE O AUXILIO DA FINTECH PICPAY (PROTOCOLO N 30150268) E DO BANCO CENTRAL DO BRASIL (RECLAMACOES NS 2023710680 E 2023711175), SEM EXITO. DESSA FORMA, REQUER O POSTULANTE, EM SEDE DE TUTELA DE URGENCIA DE NATUREZA CAUTELAR, SEJA REALIZADO O BLOQUEIO ELETRONICO DE ATIVOS FINANCEIROS DE TITULARIDADE DOS DEMANDADOS , HABEIS A SATISFACAO DO DEBITO ORA PERSEGUIDO. NAO OBSTANTE ISSO, ROGA, DE IGUAL FORMA, PELA INDISPONIBILIDADE DE VALORES NAS CONTAS DOS BENEFICIARIOS DAS TRANSFERENCIAS DE QUANTIAS POR ELE EFETIVADAS, A SABER, DAS PESSOAS FISICAS SUPLICADAS E DA EMPRESA REQUERIDA CASH PAY MEIOS DE PAGAMENTO LTDA, BEM COMO PELA QUEBRA DO SEU SIGILO BANCARIO PELOS ENTES JURIDICOS CORREUS PAGSEGURO INTERNET INSTITUICAO DE PAGAMENTO S/A, BANCO C6 S/A E MK DIGITAL BANK INSTITUICAO DE PAGAMENTO S/A, COMPELINDO-OS A FORNECER A QUALIFICACAO DAQUELES CORRENTISTAS, SOB PENA DE SEREM RESPONSABILIZADOS SOLIDARIAMENTE PELO PREJUIZO RECLAMADO . POIS BEM. DE PRONTO, VERIFICA-SE QUE SEQUER E POSSIVEL IDENTIFICAR, DA NARRATIVA AUTORAL, A EMPRESA COM A QUAL O REQUERENTE CELEBROU A AVENCA OBJURGADA, LIMITANDO-SE A REFERIDA PARTE A APONTAR QUE FOI ORIENTADO PELOS CONTATOS @ANALYST0004 E @LOVEDTON. OUTROSSIM, OS REGISTROS DE CONVERSAS ELETRONICAS CARREADOS AO ID 33149261 NAO FORAM COLACIONADOS AO FEITO EM SUA INTEGRA, NAO SENDO APRESENTADOS, DE IGUAL MANEIRA, OS TERMOS E CONDICOES DE USO DA PLATAFORMA BTCINVESTD.COM. NAO BASTASSE ISSO, NAO SE VISLUMBRA, DOS ELEMENTOS DE PROVA COLACIONADOS AO FEITO, ESTAREM AS TRANSFERENCIAS DE QUANTIAS EFETIVADAS PELO POSTULANTE VINCULADAS A O NEGOCIO JURIDICO CONTROVERTIDO . FINALMENTE, NAO E POSSIVEL AFERIR, POR ORA, A LEGITIMIDADE PASSIVA AD CAUSAM DAS INSTITUICOES DE PAGAMENTO DEMANDADAS , NAO SENDO, PRIMA FACIE, A MANUTENCAO DAS CONTAS CORRENTES DESTINATARIAS DE TAIS NUMERARIOS POR ELAS, POR SI SO, HABEIS PARA TANTO. DESTARTE, DIANTE DO DISPOSTO NOS ARTS. 320 E 321 DO CPC/15, INTIME-SE O SUPLICANTE PARA, NO PRAZO DE 15 (QUINZE) DIAS, DILIGENCIAR EM CONSONANCIA COM O ACIMA APONTADO, SOB PENA D E INDEFERIMENTO DA SUA EXORDIAL (PARAGRAFO UNICO, DO ART. 321 DO CPC/15). TRANSCORRIDO O REFERIDO LAPSO TEMPORAL, RETORNEM OS AUTOS CONCLUSOS, PARA A ADOCAO DA MEDIDA CABIVEL. DILIGENCIE-SE. SERRA, 31 DE OUTUBRO DE 2023. LETICIA PIMENTEL JUIZA DE DIREITO ASSINADO ELETRONICAMENTE POR: LETICIA PIMENTEL 31/10/2023 18:08:12 HTTPS://PJE.TJES.JUS.BR/PJE/PROCESSO/CONSULTADOCUMENTO/LISTVIEW.SEAM ID DO DOCUMENTO: 23103118081276200000031810246",
                "PublishDate": "2023-10-31T00:00:00",
                "CaptureDate": "2023-11-13T13:02:44"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2023-10-30T00:00:00",
                "CaptureDate": "2023-11-13T13:02:44"
              },
              {
                "Content": "EXPEDICAO DE CERTIDAO.",
                "PublishDate": "2023-10-30T00:00:00",
                "CaptureDate": "2023-11-13T13:02:44"
              },
              {
                "Content": "AUDIENCIA CONCILIACAO DESIGNADA PARA 13/12/2023 16:30 SERRA - COMARCA DA CAPITAL - 3 JUIZADO ESPECIAL CIVEL.",
                "PublishDate": "2023-10-30T00:00:00",
                "CaptureDate": "2023-11-13T13:02:44"
              },
              {
                "Content": "DISTRIBUIDO POR SORTEIO",
                "PublishDate": "2023-10-30T00:00:00",
                "CaptureDate": "2023-11-13T13:02:44"
              }
            ],
            "Petitions": [],
            "Decisions": []
          },
          {
            "Number": "10591145420238260224",
            "Type": "PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL",
            "MainSubject": "BANCARIOS",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "ESPECIAL CIVEL",
            "CourtDistrict": "GUARULHOS",
            "Judge": "VERA LUCIA CALVINO DE CAMPOS",
            "JudgingBody": "2 VARA DO JUIZADO ESPECIAL CIVEL",
            "State": "SP",
            "Status": "INDEFINIDO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "BANCÁRIOS",
            "InferredCNJSubjectNumber": 7752,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO DO JUIZADO ESPECIAL CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "BANCARIOS"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 39210,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-11-29T00:00:00",
            "NoticeDate": "2023-11-25T00:00:00",
            "LastMovementDate": "2023-11-29T00:00:00",
            "CaptureDate": "2023-11-30T14:20:11",
            "LastUpdate": "2023-11-30T14:20:11",
            "NumberOfParties": 9,
            "NumberOfUpdates": 2,
            "LawSuitAge": 95,
            "AverageNumberOfUpdatesPerMonth": 0,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "09044217836",
                "IsPartyActive": true,
                "Name": "VERA LUCIA CALVINO DE CAMPOS",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-11-30T14:20:11"
              },
              {
                "Doc": "41093969806",
                "IsPartyActive": true,
                "Name": "VANESSA BARRETO DA COSTA",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-11-30T14:20:11"
              },
              {
                "Doc": "01450067603",
                "IsPartyActive": true,
                "Name": "MARIANA PRATES DE SOUSA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "SpecificType": "ADVOGADA (REQTE)"
                },
                "LastCaptureDate": "2023-11-30T14:20:11"
              },
              {
                "Doc": "46189325000165",
                "IsPartyActive": true,
                "Name": "ITAU UNIBANCO S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-11-30T14:20:11"
              },
              {
                "Doc": "61472676000172",
                "IsPartyActive": true,
                "Name": "BANCO SANTANDER BRASIL S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-11-30T14:20:11"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-11-30T14:20:11"
              },
              {
                "Doc": "35624319000172",
                "IsPartyActive": true,
                "Name": "MK DIGITAL BANK INSTITUICAO DE PAGAMENTO S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-11-30T14:20:11"
              },
              {
                "Doc": "48689840000130",
                "IsPartyActive": true,
                "Name": "CASH PAY MEIOS DE PAGAMENTO LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-11-30T14:20:11"
              },
              {
                "Doc": "51880512000120",
                "IsPartyActive": true,
                "Name": "PAYWAY CONSULTORIA E SERVICOS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-11-30T14:20:11"
              }
            ],
            "Updates": [
              {
                "Content": "PROCESSO : 1059114-54.2023.8.26.0224 CLASSE : PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL REQTE : VANESSA BARRETO DA COSTA ADVOGADO : 430803/SP - MARIANA PRATES DE SOUSA REQDO : PAYWAY CONSULTORIA E SERVICOS LTDA. VARA : 2 VARA DO JUIZADO ESPECIAL CIVEL",
                "PublishDate": "2023-11-29T00:00:00",
                "CaptureDate": "2023-11-30T14:20:11"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-11-25T00:00:00",
                "CaptureDate": "2023-11-30T14:20:11"
              }
            ],
            "Petitions": [],
            "Decisions": []
          },
          {
            "Number": "10283798020238260016",
            "Type": "PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL",
            "MainSubject": "INDENIZACAO POR DANO MORAL",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "ESPECIAL CIVEL",
            "CourtDistrict": "SAO PAULO",
            "Judge": "GABRIELA AFONSO ADAMO OHANIAN",
            "JudgingBody": "2 VARA DO JUIZADO ESPECIAL CIVEL - VERGUEIRO",
            "State": "SP",
            "Status": "INDEFINIDO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "INDENIZAÇÃO POR DANO MORAL",
            "InferredCNJSubjectNumber": 7779,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO DO JUIZADO ESPECIAL CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "INDENIZACAO POR DANO MORAL"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 30000,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-12-04T00:00:00",
            "NoticeDate": "2023-11-20T00:00:00",
            "LastMovementDate": "2023-12-04T00:00:00",
            "CaptureDate": "2023-12-05T08:54:41",
            "LastUpdate": "2023-12-05T08:54:41",
            "NumberOfParties": 5,
            "NumberOfUpdates": 2,
            "LawSuitAge": 100,
            "AverageNumberOfUpdatesPerMonth": 0,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "39998199875",
                "IsPartyActive": true,
                "Name": "GABRIELA AFONSO ADAMO OHANIAN",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-12-05T08:54:41"
              },
              {
                "Doc": "34219944800",
                "IsPartyActive": true,
                "Name": "LEONARD ALEXANDER DIAS",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-12-05T08:54:41"
              },
              {
                "IsPartyActive": true,
                "Name": "LUIZ ANTONIO PEREIRA DE LIRA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "SpecificType": "ADVOGADO (REQTE)"
                },
                "LastCaptureDate": "2023-12-05T08:54:41"
              },
              {
                "Doc": "10573521000191",
                "IsPartyActive": true,
                "Name": "MERCADO PAGO INSTITUICAO DE PAGAMENTO LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-12-05T08:54:41"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-12-05T08:54:41"
              }
            ],
            "Updates": [
              {
                "Content": "PROCESSO : 1028379-80.2023.8.26.0016 CLASSE : PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL REQTE : LEONARD ALEXANDER DIAS ADVOGADO : 11663/RN - LUIZ ANTONIO PEREIRA DE LIRA REQDO : STARK BANK S.A. VARA : 2 VARA DO JUIZADO ESPECIAL CIVEL - VERGUEIRO",
                "PublishDate": "2023-12-04T00:00:00",
                "CaptureDate": "2023-12-05T08:54:41"
              },
              {
                "Content": "DISTRIBUIDO POR DIRECIONAMENTO (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR) HA SUSPEITA DE REPETICAO DA ACAO. CONFRONTE OS DADOS DO PROCESSO DISTRIBUIDO COM OS DADOS DO PROCESSO : 1028374-58.2023.8.26.0016.",
                "PublishDate": "2023-11-20T00:00:00",
                "CaptureDate": "2023-12-05T08:54:42"
              }
            ],
            "Petitions": [],
            "Decisions": []
          },
          {
            "Number": "10283806520238260016",
            "Type": "PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL",
            "MainSubject": "INDENIZACAO POR DANO MORAL",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "ESPECIAL CIVEL",
            "CourtDistrict": "SAO PAULO",
            "Judge": "GABRIELA AFONSO ADAMO OHANIAN",
            "JudgingBody": "2 VARA DO JUIZADO ESPECIAL CIVEL - VERGUEIRO",
            "State": "SP",
            "Status": "INDEFINIDO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "INDENIZAÇÃO POR DANO MORAL",
            "InferredCNJSubjectNumber": 7779,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO DO JUIZADO ESPECIAL CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "INDENIZACAO POR DANO MORAL"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 14140,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-12-04T00:00:00",
            "NoticeDate": "2023-11-20T00:00:00",
            "LastMovementDate": "2023-12-04T00:00:00",
            "CaptureDate": "2023-12-05T08:58:35",
            "LastUpdate": "2023-12-05T08:58:35",
            "NumberOfParties": 5,
            "NumberOfUpdates": 2,
            "LawSuitAge": 100,
            "AverageNumberOfUpdatesPerMonth": 0,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "39998199875",
                "IsPartyActive": true,
                "Name": "GABRIELA AFONSO ADAMO OHANIAN",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-12-05T08:58:35"
              },
              {
                "Doc": "34219944800",
                "IsPartyActive": true,
                "Name": "LEONARD ALEXANDER DIAS",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-12-05T08:58:35"
              },
              {
                "IsPartyActive": true,
                "Name": "LUIZ ANTONIO PEREIRA DE LIRA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "SpecificType": "ADVOGADO (REQTE)"
                },
                "LastCaptureDate": "2023-12-05T08:58:35"
              },
              {
                "Doc": "18236120000158",
                "IsPartyActive": true,
                "Name": "NU PAGAMENTOS S A INSTITUICAO DE PAGAMENTO",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-12-05T08:58:35"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-12-05T08:58:35"
              }
            ],
            "Updates": [
              {
                "Content": "PROCESSO : 1028380-65.2023.8.26.0016 CLASSE : PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL REQTE : LEONARD ALEXANDER DIAS ADVOGADO : 11663/RN - LUIZ ANTONIO PEREIRA DE LIRA REQDO : STARK BANK S.A. VARA : 2 VARA DO JUIZADO ESPECIAL CIVEL - VERGUEIRO",
                "PublishDate": "2023-12-04T00:00:00",
                "CaptureDate": "2023-12-05T08:58:35"
              },
              {
                "Content": "DISTRIBUIDO POR DIRECIONAMENTO (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR) HA SUSPEITA DE REPETICAO DA ACAO. CONFRONTE OS DADOS DO PROCESSO DISTRIBUIDO COM OS DADOS DO PROCESSO : 1028374-58.2023.8.26.0016.",
                "PublishDate": "2023-11-20T00:00:00",
                "CaptureDate": "2023-12-05T08:58:35"
              }
            ],
            "Petitions": [],
            "Decisions": []
          },
          {
            "Number": "10283745820238260016",
            "Type": "PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL",
            "MainSubject": "INDENIZACAO POR DANO MORAL",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "ESPECIAL CIVEL",
            "CourtDistrict": "SAO PAULO",
            "Judge": "GABRIELA AFONSO ADAMO OHANIAN",
            "JudgingBody": "2 VARA DO JUIZADO ESPECIAL CIVEL - VERGUEIRO",
            "State": "SP",
            "Status": "INDEFINIDO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "INDENIZAÇÃO POR DANO MORAL",
            "InferredCNJSubjectNumber": 7779,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO DO JUIZADO ESPECIAL CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "INDENIZACAO POR DANO MORAL"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 37000,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-12-04T00:00:00",
            "NoticeDate": "2023-11-20T00:00:00",
            "LastMovementDate": "2023-12-04T00:00:00",
            "CaptureDate": "2023-12-05T08:59:05",
            "LastUpdate": "2023-12-05T08:59:05",
            "NumberOfParties": 5,
            "NumberOfUpdates": 2,
            "LawSuitAge": 100,
            "AverageNumberOfUpdatesPerMonth": 0,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "39998199875",
                "IsPartyActive": true,
                "Name": "GABRIELA AFONSO ADAMO OHANIAN",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-12-05T08:59:05"
              },
              {
                "Doc": "34219944800",
                "IsPartyActive": true,
                "Name": "LEONARD ALEXANDER DIAS",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-12-05T08:59:05"
              },
              {
                "IsPartyActive": true,
                "Name": "LUIZ ANTONIO PEREIRA DE LIRA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "SpecificType": "ADVOGADO (REQTE)"
                },
                "LastCaptureDate": "2023-12-05T08:59:05"
              },
              {
                "Doc": "22896431000110",
                "IsPartyActive": true,
                "Name": "PICPAY INSTITUICAO DE PAGAMENTO S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-12-05T08:59:05"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-12-05T08:59:05"
              }
            ],
            "Updates": [
              {
                "Content": "PROCESSO : 1028374-58.2023.8.26.0016 CLASSE : PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL REQTE : LEONARD ALEXANDER DIAS ADVOGADO : 11663/RN - LUIZ ANTONIO PEREIRA DE LIRA REQDO : STARK BANK S.A. VARA : 2 VARA DO JUIZADO ESPECIAL CIVEL - VERGUEIRO",
                "PublishDate": "2023-12-04T00:00:00",
                "CaptureDate": "2023-12-05T08:59:05"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-11-20T00:00:00",
                "CaptureDate": "2023-12-05T08:59:06"
              }
            ],
            "Petitions": [],
            "Decisions": []
          },
          {
            "Number": "00419899820238160182",
            "Type": "PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL",
            "MainSubject": "7779 - INDENIZACAO POR DANO MORAL",
            "CourtName": "TJPR",
            "CourtLevel": "1",
            "CourtType": "ESPECIAL CIVEL",
            "CourtDistrict": "CURITIBA",
            "Judge": "MAURICIO MAINGUE SIGWALT",
            "JudgingBody": "1 JUIZADO ESPECIAL CIVEL DE CURITIBA (MATERIA BANCARIA)",
            "State": "PR",
            "Status": "INDEFINIDO",
            "LawsuitHostService": "OTHER",
            "InferredCNJSubjectName": "INDENIZAÇÃO POR DANO MORAL",
            "InferredCNJSubjectNumber": 7779,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO DO JUIZADO ESPECIAL CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "7779 - INDENIZACAO POR DANO MORAL",
              "7780 - INDENIZACAO POR DANO MATERIAL"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": -1,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-12-04T00:00:00",
            "NoticeDate": "2023-11-08T00:00:00",
            "LastMovementDate": "2023-12-04T00:00:00",
            "CaptureDate": "2023-12-05T16:42:35",
            "LastUpdate": "2023-12-05T16:42:35",
            "NumberOfParties": 4,
            "NumberOfUpdates": 24,
            "LawSuitAge": 112,
            "AverageNumberOfUpdatesPerMonth": 6,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "67681212949",
                "IsPartyActive": true,
                "Name": "MAURICIO MAINGUE SIGWALT",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-12-05T16:42:35"
              },
              {
                "IsPartyActive": true,
                "Name": "VANDERLEIA DE FATIMA PEREIRA",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "POLO ATIVO"
                },
                "LastCaptureDate": "2023-12-05T16:42:35"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "POLO PASSIVO"
                },
                "LastCaptureDate": "2023-12-05T16:42:35"
              },
              {
                "Doc": "35624319000172",
                "IsPartyActive": true,
                "Name": "MK DIGITAL BANK INSTITUICAO DE PAGAMENTO S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "POLO PASSIVO"
                },
                "LastCaptureDate": "2023-12-05T16:42:35"
              }
            ],
            "Updates": [
              {
                "Content": "PODER JUDICIARIO DO ESTADO DO PARANA COMARCA DA REGIAO METROPOLITANA DE CURITIBA - FORO CENTRAL DE CURITIBA 1 JUIZADO ESPECIAL CIVEL DE CURITIBA (MATERIA BANCARIA) - PROJUDI AV. ANITA GARIBALDI, 750 - BLOCO DOS JUIZADOS ESPECIAIS - CABRAL - CURITIBA/PR - CEP: 80.540-900 - FONE: (41) 3312-6001 - E-MAIL: CTBA-76VJ-S@TJPR.JUS.BR VISTOS, ETC. RENOVE-SE A DILIGENCIA (EV. 15.1), OBSERVANDO O ENDERECO APONTADO NO EV. 20.7. DILIGENCIAS NECESSARIAS. CURITIBA, 01 DE DEZEMBRO DE 2023. MAURICIO MAINGUE SIGWALT JUIZ SUPERVISOR",
                "PublishDate": "2023-12-04T00:00:00",
                "CaptureDate": "2023-12-05T16:42:35"
              },
              {
                "Content": "EXPEDICAO DE CITACAO PARA STARK BANK S.A. COM PRAZO ATE 16 DE FEVEREIRO DE 2024 - VIA AR DIGITAL - UTILIZANDO CONTRAFE",
                "PublishDate": "2023-12-01T00:00:00",
                "CaptureDate": "2023-12-05T16:42:50"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE . VEICULADO NO DJEN EM 04/12/2023.|PROJUDI - PROCESSO: 0041989-98.2023.8.16.0182 - REF. MOV. 22.1 - ASSINADO DIGITALMENTE POR MAURICIO MAINGUE SIGWALT 01/12/2023: PROFERIDO DESPACHO DE MERO EXPEDIENTE. ARQ: DESPACHO PODER JUDICIARIO DO ESTADO DO PARANA COMARCA DA REGIAO METROPOLITANA DE CURITIBA - FORO CENTRAL DE CURITIBA 1 JUIZADO ESPECIAL CIVEL DE CURITIBA (MATERIA BANCARIA) - PROJUDI AV. ANITA GARIBALDI, 750 - BLOCO DOS JUIZADOS ESPECIAIS - CABRAL - CURITIBA/PR - CEP: 80.540-900 - FONE: (41) 3312-6001 - E-MAIL: CTBA-76VJ-S@TJPR.JUS.BR VISTOS, ETC. RENOVE-SE A DILIGENCIA (EV. 15.1), OBSERVANDO O ENDERECO APONTADO NO EV. 20.7. DILIGENCIAS NECESSARIAS. CURITIBA, 01 DE DEZEMBRO DE 2023. MAURICIO MAINGUE SIGWALT JUIZ SUPERVISOR DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJL7D KK3NJ GKXPE 9EFCA",
                "PublishDate": "2023-12-01T00:00:00",
                "CaptureDate": "2023-12-05T16:42:50"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO RESPONSAVEL: MAURICIO MAINGUE SIGWALT",
                "PublishDate": "2023-11-30T00:00:00",
                "CaptureDate": "2023-12-05T16:42:56"
              },
              {
                "Content": "JUNTADA DE PETICAO DE MANIFESTACAO DA PARTE",
                "PublishDate": "2023-11-30T00:00:00",
                "CaptureDate": "2023-12-05T16:42:56"
              },
              {
                "Content": "DECORRIDO PRAZO DE VANDERLEIA DE FATIMA PEREIRA (PARA VANDERLEIA DE FATIMA PEREIRA *REFERENTE AO EVENTO (SEQ. 15) JUNTADA DE COMPROVANTE (22/11/2023) E AO EVENTO DE EXPEDICAO SEQ. 17.",
                "PublishDate": "2023-11-30T00:00:00",
                "CaptureDate": "2023-12-05T16:42:56"
              },
              {
                "Content": "ATO CUMPRIDO PELA PARTE OU INTERESSADO REFERENTE AO EVENTO (SEQ. 15) JUNTADA DE COMPROVANTE (22/11/2023) E AO EVENTO DE EXPEDICAO SEQ. 17.",
                "PublishDate": "2023-11-22T00:00:00",
                "CaptureDate": "2023-12-05T16:42:56"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO REFERENTE AO EVENTO (SEQ. 15) JUNTADA DE COMPROVANTE (22/11/2023).",
                "PublishDate": "2023-11-22T00:00:00",
                "CaptureDate": "2023-12-05T16:42:56"
              },
              {
                "Content": "ATO CUMPRIDO PELA PARTE OU INTERESSADO LEITURA DE CITACAO REALIZADA - POR MK DIGITAL BANK INSTITUICAO DE PAGAMENTO S/A EM 16/11/2023 REFERENTE AO EVENTO DE EXPEDICAO SEQ. 12.",
                "PublishDate": "2023-11-22T00:00:00",
                "CaptureDate": "2023-12-05T16:42:56"
              },
              {
                "Content": "JUNTADA DE COMPROVANTE DEVOLUCAO SEM LEITURA - REFERENTE A CITACAO EXPEDIDA EM 09/11/2023 PARA STARK BANK S.A.",
                "PublishDate": "2023-11-22T00:00:00",
                "CaptureDate": "2023-12-05T16:42:56"
              },
              {
                "Content": "JUNTADA DE TERMO DE ADESAO AO WHATSAPP",
                "PublishDate": "2023-11-14T00:00:00",
                "CaptureDate": "2023-12-05T16:42:56"
              },
              {
                "Content": "JUNTADA DE INTIMACAO CUMPRIDA",
                "PublishDate": "2023-11-14T00:00:00",
                "CaptureDate": "2023-12-05T16:42:56"
              },
              {
                "Content": "EXPEDICAO DE CITACAO PARA MK DIGITAL BANK INSTITUICAO DE PAGAMENTO S/A COM PRAZO ATE 16 DE FEVEREIRO DE 2024 - VIA AR DIGITAL - UTILIZANDO CONTRAFE",
                "PublishDate": "2023-11-09T00:00:00",
                "CaptureDate": "2023-12-05T16:42:56"
              },
              {
                "Content": "EXPEDICAO DE CITACAO PARA STARK BANK S.A. COM PRAZO ATE 16 DE FEVEREIRO DE 2024 - VIA AR DIGITAL - UTILIZANDO CONTRAFE",
                "PublishDate": "2023-11-09T00:00:00",
                "CaptureDate": "2023-12-05T16:42:56"
              },
              {
                "Content": "RECEBIDOS OS AUTOS RECEBIDO DO(A) DISTRIBUIDOR",
                "PublishDate": "2023-11-09T00:00:00",
                "CaptureDate": "2023-12-05T16:42:56"
              },
              {
                "Content": "JUNTADA DE ANOTACAO DE DISTRIBUICAO",
                "PublishDate": "2023-11-09T00:00:00",
                "CaptureDate": "2023-12-05T16:42:56"
              },
              {
                "Content": "JUNTADA DE CERTIDAO",
                "PublishDate": "2023-11-08T00:00:00",
                "CaptureDate": "2023-12-05T16:42:56"
              },
              {
                "Content": "AUTOS INCLUIDOS NO JUIZO 100% DIGITAL",
                "PublishDate": "2023-11-08T00:00:00",
                "CaptureDate": "2023-12-05T16:42:56"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA REFERENTE AO EVENTO (SEQ. 5) AUDIENCIA DE CONCILIACAO DESIGNADA (08/11/2023).",
                "PublishDate": "2023-11-08T00:00:00",
                "CaptureDate": "2023-12-05T16:42:56"
              },
              {
                "Content": "AUDIENCIA DE CONCILIACAO DESIGNADA (AGENDADA PARA: 16 DE FEVEREIRO DE 2024 AS 15:00, EM CECON CURITIBA - JUIZADOS ESPECIAIS, MODALIDADE: PRESENCIAL)",
                "PublishDate": "2023-11-08T00:00:00",
                "CaptureDate": "2023-12-05T16:42:56"
              },
              {
                "Content": "RECEBIDOS OS AUTOS",
                "PublishDate": "2023-11-08T00:00:00",
                "CaptureDate": "2023-12-05T16:42:56"
              },
              {
                "Content": "REMETIDOS OS AUTOS PARA DISTRIBUIDOR REGISTRO DE DISTRIBUICAO",
                "PublishDate": "2023-11-08T00:00:00",
                "CaptureDate": "2023-12-05T16:42:56"
              },
              {
                "Content": "ATO ORDINATORIO PRATICADO PROCESSO ENCAMINHADO - 1 JUIZADO ESPECIAL CIVEL DE CURITIBA (MATERIA BANCARIA)",
                "PublishDate": "2023-11-08T00:00:00",
                "CaptureDate": "2023-12-05T16:42:56"
              },
              {
                "Content": "JUNTADA DE PETICAO DE INICIAL",
                "PublishDate": "2023-11-08T00:00:00",
                "CaptureDate": "2023-12-05T16:42:56"
              }
            ],
            "Petitions": [],
            "Decisions": []
          },
          {
            "Number": "02808501220238060001",
            "Type": "PROCEDIMENTO COMUM",
            "MainSubject": "INDENIZACAO POR DANO MORAL",
            "CourtName": "TJCE",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "FORTALEZA",
            "JudgingBody": "22 VARA CIVEL (SEJUD 1 GRAU) - FORTALEZA CIVEL",
            "State": "CE",
            "Status": "ATIVO",
            "LawsuitHostService": "OTHER",
            "InferredCNJSubjectName": "INDENIZAÇÃO POR DANO MORAL",
            "InferredCNJSubjectNumber": 7779,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "INDENIZACAO POR DANO MORAL"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": -1,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-12-05T00:00:00",
            "NoticeDate": "2023-12-01T14:31:00",
            "LastMovementDate": "2023-12-01T15:56:10",
            "CaptureDate": "2023-12-06T00:16:25",
            "LastUpdate": "2023-12-06T00:16:25",
            "NumberOfParties": 4,
            "NumberOfUpdates": 3,
            "LawSuitAge": 89,
            "AverageNumberOfUpdatesPerMonth": 1,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "60746948000112",
                "IsPartyActive": true,
                "Name": "BANCO BRADESCO S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQUERIDO"
                },
                "LastCaptureDate": "2023-12-06T00:16:25"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQUERIDO"
                },
                "LastCaptureDate": "2023-12-06T00:16:25"
              },
              {
                "Doc": "07806555404",
                "IsPartyActive": true,
                "Name": "LUIZ ANTONIO PEREIRA DE LIRA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "11663",
                  "State": "RN",
                  "SpecificType": "ADVOGADO (REQUERENTE)"
                },
                "LastCaptureDate": "2023-12-06T00:16:25"
              },
              {
                "Doc": "00469294361",
                "IsPartyActive": true,
                "Name": "PEDRO HERMANO MARTINS DA SILVA FROTA",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQUERENTE"
                },
                "LastCaptureDate": "2023-12-06T00:16:25"
              }
            ],
            "Updates": [
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE | VISTO,. OBSERVA-SE QUE NAO HA NOS AUTOS APRESENTACAO DE DOCUMENTOS ATUALIZADOS PERTINENTES A CONDICAO ECONOMICA DO REQUERENTE. LOGO, DETERMINO A INTIMACAO DA PARTE AUTORA, NO UNICO PRAZO DE 15 (QUINZE) DIAS, PARA COMPROVAR O RECOLHIMENTO DAS CUSTAS OU A HIPOSSUFICIENCIA ECONOMICA ALEGADA, ATRAVES DAS ULTIMAS 03 (TRES) DECLARACOES DO IMPOSTO DE REND",
                "PublishDate": "2023-12-01T15:56:10",
                "CaptureDate": "2023-12-06T00:16:25"
              },
              {
                "Content": "CONCLUSOS",
                "PublishDate": "2023-12-01T14:31:03",
                "CaptureDate": "2023-12-06T00:16:25"
              },
              {
                "Content": "PROCESSO DISTRIBUIDO POR SORTEIO",
                "PublishDate": "2023-12-01T14:31:00",
                "CaptureDate": "2023-12-06T00:16:25"
              }
            ],
            "Petitions": [],
            "Decisions": []
          },
          {
            "Number": "10376666420238260405",
            "Type": "PROCEDIMENTO COMUM",
            "MainSubject": "BANCARIOS",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "OSASCO",
            "Judge": "RICARDO CUNHA DE PAULA",
            "JudgingBody": "4 VARA CIVEL",
            "State": "SP",
            "Status": "INDEFINIDO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "BANCÁRIOS",
            "InferredCNJSubjectNumber": 7752,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "BANCARIOS"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 6572,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-12-05T00:00:00",
            "NoticeDate": "2023-11-30T00:00:00",
            "LastMovementDate": "2023-12-05T00:00:00",
            "CaptureDate": "2023-12-06T03:12:33",
            "LastUpdate": "2023-12-06T03:12:33",
            "NumberOfParties": 6,
            "NumberOfUpdates": 6,
            "LawSuitAge": 90,
            "AverageNumberOfUpdatesPerMonth": 1,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "IsPartyActive": true,
                "Name": "RICARDO CUNHA DE PAULA",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-12-06T03:12:33"
              },
              {
                "IsPartyActive": true,
                "Name": "ALINE DE ALMEIDA SILVA",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-12-06T03:12:33"
              },
              {
                "Doc": "48561184809",
                "IsPartyActive": true,
                "Name": "TIAGO BAPTISTA VALIM",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "485964",
                  "State": "SP",
                  "SpecificType": "ADVOGADO (REQTE)"
                },
                "LastCaptureDate": "2023-12-06T03:12:33"
              },
              {
                "Doc": "60746948000112",
                "IsPartyActive": true,
                "Name": "BANCO BRADESCO S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-12-06T03:12:33"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-12-06T03:12:33"
              },
              {
                "Doc": "51880512000120",
                "IsPartyActive": true,
                "Name": "PAYWAY CONSULTORIA E SERVICOS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-12-06T03:12:33"
              }
            ],
            "Updates": [
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 1075/2023 DATA DA PUBLICACAO: 06/12/2023 NUMERO DO DIARIO: 3872",
                "PublishDate": "2023-12-05T00:00:00",
                "CaptureDate": "2023-12-06T03:12:34"
              },
              {
                "Content": "PROCESSO 1037666-64.2023.8.26.0405 - PROCEDIMENTO COMUM CIVEL - BANCARIOS - ALINE DE ALMEIDA SILVA - VISTOS. A PETICAO INICIAL NAO PREENCHE OS REQUISITOS DOS ARTIGOS 319 E 320 DO CPCE APRESENTA DEFEITOS E IRREGULARIDADES CAPAZES DE DIFICULTAR O JULGAMENTO DE MERITO. ASSIM, NA FORMA DO ARTIGO 321 DO CPC, DEVERA A PARTE AUTORA EMENDA-LA. DEVERA A PARTE AUTORA PROMOVER A JUNTADA DE COMPROVANTE DE RESIDENCIA ATUALIZADO (EXPEDIDO NOS ULTIMOS TRES MESES). SE ESTIVEREM EM NOME DE TERCEIRO, DEVE SER ACOMPANHADO DE DECLARACAO DE PROPRIO PUNHO DO TITULAR DO COMPROVANTE A INDICAR QUE A PARTE AUTORA RESIDE NAQUELE ENDERECO, IDENTIFICANDO-SE COM RG E CPF. DISPOE A LEI QUE A PETICAO INICIAL INDICARA (...) OS NOMES, OS PRENOMES, O ESTADO CIVIL, A EXISTENCIA DE UNIAO ESTAVEL, A PROFISSAO, O NUMERO DE INSCRICAO NO CADASTRO DE PESSOAS FISICAS OU NO CADASTRO NACIONAL DA PESSOA JURIDICA, O ENDERECO ELETRONICO, O DOMICILIO E A RESIDENCIA DO AUTOR E DO REU (ART. 319 DO CPC). ASSIM, DEVERA A PARTE AUTORA SER QUALIFICADA DE DE MODO COMPLETO, PARA INCLUIR SEU ENDERECO ELETRONICO (E-MAIL). ESCLARECA IGUALMENTE A PARTE AUTORA A DIVERGENCIA DE ENDERECO E CNPJS CADASTRADOS NO SISTEMA COM OS APONTADOS NA EXORDIAL DO REQUERIDO PAY WAY, CORRIGINDO-OS. ESTABELECE A LEI QUE O ADVOGADO NAO SERA ADMITIDO A POSTULAR EM JUIZO SEM PROCURACAO, SALVO PARA EVITAR PRECLUSAO, DECADENCIA OU PRESCRICAO, OU PARA PRATICAR ATO CONSIDERADO URGENTE (ART. 104 DO CPC). NOS TERMOS DA JURISPRUDENCIA DO E. TRIBUNAL DE JUSTICA DE SAO PAULO, EM SE TRATANDO DE DEMANDA DE MASSA, ENVOLVENDO CAUSAS DE PEDIR E PEDIDOS IDENTICOS (COMO A PRESENTE), TALVEZ COM CARATER PREDATORIO, DEVE O JUIZ TOMAR ESPECIAL ATENCAO PARA GARANTIR QUE AS PARTES ESTEJAM ASSISTIDAS POR ADVOGADO DEVIDAMENTE HABILITADO PELA ORDEM DOS ADVOGADOS DO BRASIL, OUTORGANDO A ELES, ATRAVES DE PROCURACAO, PODERES PARA DEFESA DE SEUS DIREITOS EM JUIZO, DEVENDO CONSTAR DO INSTRUMENTO DE MANDATO, DENTRE OUTROS ELEMENTOS, O OBJETIVO DA OUTORGA COM A DESIGNACAO E A EXTENSAO DOS PODERES CONFERIDOS (TJSP, AGRAVO DE INSTRUMENTO 2189052-78.2023.8.26.0000, RELATOR DES. ERNANI DESCO FILHO, 18 CAMARA DE DIREITO PRIVADO, J. 23/11/2023). ASSIM, PARA ASSEGURAR QUE A PARTE AUTORA TEM CONHECIMENTO DE QUE SEU DIREITO ESTA SENDO DEFENDIDO EM JUIZO PELO(A) PROCURADOR(A) QUE CONSTITUIU, TRATANDO-SE DE INCONTROVERSA E INDUVIDOSA RELACAO DE CONFIANCA, DEVE A PARTE TRAZER (I) DECLARACAO DE PROPRIO PUNHO DATADA EM QUE SE DEMONSTRA A PARTE AUTORA ESTAR CIENTE DA EXISTENCIA DESTA ACAO, DEVENDO CONSTAR O NUMERO DESTE FEITO, SEU OBJETO E QUE EFETIVAMENTE CONTRATOU E RECONHECE O(A) ADVOGADO(A); E (II) PROCURACAO DATADA E ATUAL, COM RECONHECIMENTO DE FIRMA, QUE PREENCHA OS REQUISITOS DO 1 DO ART. 654 DO CODIGO CIVIL, COM A DESIGNACAO E A EXTENSAO DOS PODERES CONFERIDOS, A INDICACAO DO LUGAR ONDE FOI PASSADO, A QUALIFICACAO DO OUTORGANTE E DO OUTORGADO, A DATA E O OBJETIVO DA OUTORGA. NESSE SENTIDO: AGRAVO DE INSTRUMENTO. ACAO DECLARATORIA DE PRESCRICAO C/C INDENIZATORIA. INSURGENCIA CONTRA DECISAO QUE DETERMINOU A APRESENTACAO DE PROCURACAO ATUAL, DATADA E COM RECONHECIMENTO DE FIRMA POR AUTENTICIDADE, ALEM DE DECLARACAO DE PROPRIO PUNHO EM QUE SE DEMONSTRE A PARTE AUTORA TER CONHECIMENTO DA EXISTENCIA DA ACAO. O EXERCICIO DO DIREITO DE ACAO, MATERIALIZADO NA SEARA PROCESSUAL, TAMBEM RECLAMA A PRESENCA DE REQUISITOS DE VALIDADE E DE EXISTENCIA, COMUMENTE DENOMINADOS DE PRESSUPOSTOS PROCESSUAIS. RELATIVAMENTE AO CRITERIO SUBJETIVO, IMPENDE DESTACAR A CAPACIDADE POSTULATORIA, SEGUNDO O QUAL AS PARTES DEVEM SER ASSISTIDAS POR ADVOGADO DEVIDAMENTE HABILITADO PELA ORDEM DOS ADVOGADOS DO BRASIL, OUTORGANDO A ELES, ATRAVES DE PROCURACAO, PODERES PARA DEFESA DE SEUS DIREITOS EM JUIZO, DEVENDO CONSTAR DO INSTRUMENTO DE MANDATO, DENTRE OUTROS ELEMENTOS, O OBJETIVO DA OUTORGA COM A DESIGNACAO E A EXTENSAO DOS PODERES CONFERIDOS. NO CASO CONCRETO, A FIM DE SE AFERIR A CAPACIDADE POSTULATORIA DA AGRAVANTE, MATERIALIZADA PELA PROCURACAO QUE OUTORGOU A SUA PROCURADORA, RAZOAVEL AS EXIGENCIAS FORMULADAS PELO JUIZO A QUO. CUIDA-SE DE MEDIDA QUE VISA APENAS ASSEGURAR QUE A AGRAVANTE TEM CONHECIMENTO DE QUE SEU DIREITO ESTA SENDO DEFENDIDO EM JUIZO PELA PROCURADORA QUE CONSTITUIU. ADEMAIS, TRATANDO-SE DE INCONTROVERSA E INDUVIDOSA RELACAO DE CONFIANCA, AS DETERMINACOES SAO DE FACEIS CUMPRIMENTO, INCLUSIVE SEM CUSTOS A AGRAVANTE, CONSIDERANDO SUA CONDICAO DE HIPOSSUFICIENTE FINANCEIRA. DECISAO MANTIDA. RECURSO NAO PROVIDO (TJSP, AGRAVO DE INSTRUMENTO 2189052-78.2023.8.26.0000, RELATOR DES. ERNANI DESCO FILHO, 18 CAMARA DE DIREITO PRIVADO, J. 23/11/2023) DIANTE DOS ELEMENTOS CONSTANTES DOS AUTOS NOTADAMENTE REPRESENTACAO POR ADVOGADO CONSTITUIDO, DA RENUNCIA AO DIREITO DE LITIGAR NO FORO DE SEU DOMICILIO PREVISTA NO CDC, DE SEU ENDERECO RESIDENCIAL E DE SUA PROFISSAO (OPERADORA DE CAIXA) DEVERA A PARTE AUTORA COMPROVAR, JUNTANDO DOCUMENTACAO IDONEA, O ENQUADRAMENTO NA SITUACAO DEFINIDA PELO ARTIGO 5, INCISO LXXIV, DA CONSTITUICAO FEDERAL, SOB PENA DE INDEFERIMENTO DO PEDIDO DE CONCESSAO DO BENEFICIO DA ASSISTENCIA JUDICIARIA GRATUITA. ASSIM, DEVERA TRAZER AOS AUTOS OS SEGUINTES DOCUMENTOS (TODOS): (I) RELATORIO DE CONTAS E RELACIONAMENTOS (CCS) OBTIDO EM CONSULTA AO PORTAL REGISTRATO DO BANCO CENTRAL DO BRASIL (HTTPS://REGISTRATO.BCB. GOV.BR/REGISTRATO/RELATORIOS/CCS). (II) EXTRATOS DOS ULTIMOS TRES MESES DE TODAS AS CONTAS QUE NAO CONSTEM COMO ENCERRADAS NO RELATORIO. CASO NAO RECONHECA ALGUMA CONTA OU RELACIONAMENTO DISPOSTA NO RELATORIO, DEVERA COMPROVAR QUE ENTROU EM CONTATO COM O BANCO OU INSTITUICAO INFORMADA SOLICITANDO AS INFORMACOES E QUE NAO OBTEVE RESPOSTA ATE O FIM DO PRAZO. (III) FATURAS DOS ULTIMOS TRES MESES DE TODOS OS CARTOES DE CREDITO ABERTOS EM SEU NOME. CASO NAO POSSUA CARTOES DE CREDITO EM SEU NOME, DEVERA TRAZER DECLARACAO ESCRITA INFORMANDO QUE, SOB AS PENAS DA LEI, INCLUINDO A RESPONSABILIZACAO CRIMINAL, DECLARA QUE NAO HA CARTOES DE CREDITO EM SEU NOME (NESTES TERMOS). (IV) COPIA INTEGRAL DAS DUAS ULTIMAS DECLARACOES DE BENS E RENDIMENTOS APRESENTADAS A RECEITA FEDERAL. NO CASO DE ISENCAO DO PAGAMENTO DO TRIBUTO, DEVERA APRESENTAR COPIA DE PRINT DO SITIO DA RECEITA FEDERAL, NOTICIANDO NAO HAVER DECLARACOES, BENS E RENDIMENTOS, TOMANDO EM CONTA O CPF DA PARTE, EM SUA BASE DE DADOS COM RELACAO AOS DOIS ULTIMOS EXERCICIOS (HTTPS://WWW.GOV.BR/RECEITAFEDERAL/PT-BR/ASSUNTOS/MEU-IMPOSTO-DE- RENDA/RESTITUICAO/SITUACOES). PRAZO: 15 DIAS. POR EXPRESSA DISPOSICAO LEGAL, TODOS OS SUJEITOS DO PROCESSO DEVEM COOPERAR ENTRE SI PARA QUE SE OBTENHA, EM TEMPO RAZOAVEL, DECISAO DE MERITO JUSTA E EFETIVA (ART. 6 DO CPC). O PRAZO CONCEDIDO -QUE E ESTABELECIDO EM LEI (ARTIGO 321 DO CPC)- E MAIS DO QUE O SUFICIENTE PARA A OBTENCAO DA DOCUMENTACAO. ASSIM, PARA GARANTIR A RAZOAVEL DURACAO DO PROCESSO E OS MEIOS QUE GARANTAM A CELERIDADE DE SUA TRAMITACAO (ART. 5, LXXVIII, DA CF), DESDE JA SE ANTECIPA QUE O PRAZO NAO SERA PRORROGADO. EM CASO DE INTERPOSICAO DE EMBARGOS DE DECLARACAO MERAMENTE PROTELATORIOS EM FACE DA PRESENTE DECISAO (COM NITIDO CARATER INFRINGENTE), O RECURSO NAO SERA SEQUER CONHECIDO E SERA O EMBARGANTE SANCIONADO COM MULTA POR LITIGANCIA DE MA-FE. DEVE O(A) ADVOGADO(A), AO PROCEDER A EMENDA A PETICAO INICIAL, POR MEIO DO LINK DE PETICAO INTERMEDIARIA DE 1 GRAU, CADASTRA-LA NA CATEGORIA PETICOES DIVERSAS, TIPO DE PETICAO: 8431 - EMENDA A INICIAL, A FIM DE CONFERIR MAIOR AGILIDADE NA IDENTIFICACAO NO FLUXO DE TRABALHO, ONDE SE PROCESSAM OS AUTOS DIGITAIS. INTIME-SE. - ADV: TIAGO BAPTISTA VALIM (OAB 485964/SP)",
                "PublishDate": "2023-12-05T00:00:00",
                "CaptureDate": "2023-12-06T03:12:33"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 1075/2023 TEOR DO ATO: VISTOS. A PETICAO INICIAL NAO PREENCHE OS REQUISITOS DOS ARTIGOS 319 E 320 DO CPCE APRESENTA DEFEITOS E IRREGULARIDADES CAPAZES DE DIFICULTAR O JULGAMENTO DE MERITO. ASSIM, NA FORMA DO ARTIGO 321 DO CPC, DEVERA A PARTE AUTORA EMENDA-LA. DEVERA A PARTE AUTORA PROMOVER A JUNTADA DE COMPROVANTE DE RESIDENCIA ATUALIZADO (EXPEDIDO NOS ULTIMOS TRES MESES). SE ESTIVEREM EM NOME DE TERCEIRO, DEVE SER ACOMPANHADO DE DECLARACAO DE PROPRIO PUNHO DO TITULAR DO COMPROVANTE A INDICAR QUE A PARTE AUTORA RESIDE NAQUELE ENDERECO, IDENTIFICANDO-SE COM RG E CPF. DISPOE A LEI QUE \"A PETICAO INICIAL INDICARA (...) OS NOMES, OS PRENOMES, O ESTADO CIVIL, A EXISTENCIA DE UNIAO ESTAVEL, A PROFISSAO, O NUMERO DE INSCRICAO NO CADASTRO DE PESSOAS FISICAS OU NO CADASTRO NACIONAL DA PESSOA JURIDICA, O ENDERECO ELETRONICO, O DOMICILIO E A RESIDENCIA DO AUTOR E DO REU\" (ART. 319 DO CPC). ASSIM, DEVERA A PARTE AUTORA SER QUALIFICADA DE DE MODO COMPLETO, PARA INCLUIR SEU ENDERECO ELETRONICO (E-MAIL). ESCLARECA IGUALMENTE A PARTE AUTORA A DIVERGENCIA DE ENDERECO E CNPJS CADASTRADOS NO SISTEMA COM OS APONTADOS NA EXORDIAL DO REQUERIDO PAY WAY, CORRIGINDO-OS. ESTABELECE A LEI QUE \"O ADVOGADO NAO SERA ADMITIDO A POSTULAR EM JUIZO SEM PROCURACAO, SALVO PARA EVITAR PRECLUSAO, DECADENCIA OU PRESCRICAO, OU PARA PRATICAR ATO CONSIDERADO URGENTE\" (ART. 104 DO CPC). NOS TERMOS DA JURISPRUDENCIA DO E. TRIBUNAL DE JUSTICA DE SAO PAULO, EM SE TRATANDO DE \"DEMANDA DE MASSA\", ENVOLVENDO CAUSAS DE PEDIR E PEDIDOS IDENTICOS (COMO A PRESENTE), TALVEZ COM CARATER PREDATORIO, DEVE O JUIZ TOMAR ESPECIAL ATENCAO PARA GARANTIR QUE AS PARTES ESTEJAM \"ASSISTIDAS POR ADVOGADO DEVIDAMENTE HABILITADO PELA ORDEM DOS ADVOGADOS DO BRASIL, OUTORGANDO A ELES, ATRAVES DE PROCURACAO, PODERES PARA DEFESA DE SEUS DIREITOS EM JUIZO, DEVENDO CONSTAR DO INSTRUMENTO DE MANDATO, DENTRE OUTROS ELEMENTOS, O OBJETIVO DA OUTORGA COM A DESIGNACAO E A EXTENSAO DOS PODERES CONFERIDOS\" (TJSP, AGRAVO DE INSTRUMENTO 2189052-78.2023.8.26.0000, RELATOR DES. ERNANI DESCO FILHO, 18 CAMARA DE DIREITO PRIVADO, J. 23/11/2023). ASSIM, PARA ASSEGURAR QUE A PARTE AUTORA TEM CONHECIMENTO DE QUE SEU DIREITO ESTA SENDO DEFENDIDO EM JUIZO PELO(A) PROCURADOR(A) QUE CONSTITUIU, TRATANDO-SE DE INCONTROVERSA E INDUVIDOSA RELACAO DE CONFIANCA, DEVE A PARTE TRAZER (I) DECLARACAO DE PROPRIO PUNHO DATADA EM QUE SE DEMONSTRA A PARTE AUTORA ESTAR CIENTE DA EXISTENCIA DESTA ACAO, DEVENDO CONSTAR O NUMERO DESTE FEITO, SEU OBJETO E QUE EFETIVAMENTE CONTRATOU E RECONHECE O(A) ADVOGADO(A); E (II) PROCURACAO DATADA E ATUAL, COM RECONHECIMENTO DE FIRMA, QUE PREENCHA OS REQUISITOS DO 1 DO ART. 654 DO CODIGO CIVIL, COM A DESIGNACAO E A EXTENSAO DOS PODERES CONFERIDOS, A INDICACAO DO LUGAR ONDE FOI PASSADO, A QUALIFICACAO DO OUTORGANTE E DO OUTORGADO, A DATA E O OBJETIVO DA OUTORGA. NESSE SENTIDO: AGRAVO DE INSTRUMENTO. ACAO DECLARATORIA DE PRESCRICAO C/C INDENIZATORIA. INSURGENCIA CONTRA DECISAO QUE DETERMINOU A APRESENTACAO DE PROCURACAO ATUAL, DATADA E COM RECONHECIMENTO DE FIRMA POR AUTENTICIDADE, ALEM DE DECLARACAO DE PROPRIO PUNHO EM QUE SE DEMONSTRE A PARTE AUTORA TER CONHECIMENTO DA EXISTENCIA DA ACAO. O EXERCICIO DO DIREITO DE ACAO, MATERIALIZADO NA SEARA PROCESSUAL, TAMBEM RECLAMA A PRESENCA DE REQUISITOS DE VALIDADE E DE EXISTENCIA, COMUMENTE DENOMINADOS DE PRESSUPOSTOS PROCESSUAIS. RELATIVAMENTE AO CRITERIO SUBJETIVO, IMPENDE DESTACAR A CAPACIDADE POSTULATORIA, SEGUNDO O QUAL AS PARTES DEVEM SER ASSISTIDAS POR ADVOGADO DEVIDAMENTE HABILITADO PELA ORDEM DOS ADVOGADOS DO BRASIL, OUTORGANDO A ELES, ATRAVES DE PROCURACAO, PODERES PARA DEFESA DE SEUS DIREITOS EM JUIZO, DEVENDO CONSTAR DO INSTRUMENTO DE MANDATO, DENTRE OUTROS ELEMENTOS, O OBJETIVO DA OUTORGA COM A DESIGNACAO E A EXTENSAO DOS PODERES CONFERIDOS. NO CASO CONCRETO, A FIM DE SE AFERIR A CAPACIDADE POSTULATORIA DA AGRAVANTE, MATERIALIZADA PELA PROCURACAO QUE OUTORGOU A SUA PROCURADORA, RAZOAVEL AS EXIGENCIAS FORMULADAS PELO JUIZO \"A QUO\". CUIDA-SE DE MEDIDA QUE VISA APENAS ASSEGURAR QUE A AGRAVANTE TEM CONHECIMENTO DE QUE SEU DIREITO ESTA SENDO DEFENDIDO EM JUIZO PELA PROCURADORA QUE CONSTITUIU. ADEMAIS, TRATANDO-SE DE INCONTROVERSA E INDUVIDOSA RELACAO DE CONFIANCA, AS DETERMINACOES SAO DE FACEIS CUMPRIMENTO, INCLUSIVE SEM CUSTOS A AGRAVANTE, CONSIDERANDO SUA CONDICAO DE HIPOSSUFICIENTE FINANCEIRA. DECISAO MANTIDA. RECURSO NAO PROVIDO (TJSP, AGRAVO DE INSTRUMENTO 2189052-78.2023.8.26.0000, RELATOR DES. ERNANI DESCO FILHO, 18 CAMARA DE DIREITO PRIVADO, J. 23/11/2023) DIANTE DOS ELEMENTOS CONSTANTES DOS AUTOS NOTADAMENTE REPRESENTACAO POR ADVOGADO CONSTITUIDO, DA RENUNCIA AO DIREITO DE LITIGAR NO FORO DE SEU DOMICILIO PREVISTA NO CDC, DE SEU ENDERECO RESIDENCIAL E DE SUA PROFISSAO (OPERADORA DE CAIXA) DEVERA A PARTE AUTORA COMPROVAR, JUNTANDO DOCUMENTACAO IDONEA, O ENQUADRAMENTO NA SITUACAO DEFINIDA PELO ARTIGO 5, INCISO LXXIV, DA CONSTITUICAO FEDERAL, SOB PENA DE INDEFERIMENTO DO PEDIDO DE CONCESSAO DO BENEFICIO DA ASSISTENCIA JUDICIARIA GRATUITA. ASSIM, DEVERA TRAZER AOS AUTOS OS SEGUINTES DOCUMENTOS (TODOS): (I) RELATORIO DE CONTAS E RELACIONAMENTOS (CCS) OBTIDO EM CONSULTA AO PORTAL REGISTRATO DO BANCO CENTRAL DO BRASIL (HTTPS://REGISTRATO.BCB.GOV.BR/REGISTRATO/RELATORIOS/CCS). (II) EXTRATOS DOS ULTIMOS TRES MESES DE TODAS AS CONTAS QUE NAO CONSTEM COMO ENCERRADAS NO RELATORIO. CASO NAO RECONHECA ALGUMA CONTA OU RELACIONAMENTO DISPOSTA NO RELATORIO, DEVERA COMPROVAR QUE ENTROU EM CONTATO COM O BANCO OU INSTITUICAO INFORMADA SOLICITANDO AS INFORMACOES E QUE NAO OBTEVE RESPOSTA ATE O FIM DO PRAZO. (III) FATURAS DOS ULTIMOS TRES MESES DE TODOS OS CARTOES DE CREDITO ABERTOS EM SEU NOME. CASO NAO POSSUA CARTOES DE CREDITO EM SEU NOME, DEVERA TRAZER DECLARACAO ESCRITA INFORMANDO QUE, SOB AS PENAS DA LEI, INCLUINDO A RESPONSABILIZACAO CRIMINAL, DECLARA QUE NAO HA CARTOES DE CREDITO EM SEU NOME (NESTES TERMOS). (IV) COPIA INTEGRAL DAS DUAS ULTIMAS DECLARACOES DE BENS E RENDIMENTOS APRESENTADAS A RECEITA FEDERAL. NO CASO DE ISENCAO DO PAGAMENTO DO TRIBUTO, DEVERA APRESENTAR COPIA DE PRINT DO SITIO DA RECEITA FEDERAL, NOTICIANDO NAO HAVER DECLARACOES, BENS E RENDIMENTOS, TOMANDO EM CONTA O CPF DA PARTE, EM SUA BASE DE DADOS COM RELACAO AOS DOIS ULTIMOS EXERCICIOS (HTTPS://WWW.GOV.BR/RECEITAFEDERAL/PT-BR/ASSUNTOS/MEU-IMPOSTO-DE-RENDA/RESTITUICAO/SITUACOES). PRAZO: 15 DIAS. POR EXPRESSA DISPOSICAO LEGAL, \"TODOS OS SUJEITOS DO PROCESSO DEVEM COOPERAR ENTRE SI PARA QUE SE OBTENHA, EM TEMPO RAZOAVEL, DECISAO DE MERITO JUSTA E EFETIVA\" (ART. 6 DO CPC). O PRAZO CONCEDIDO --QUE E ESTABELECIDO EM LEI (ARTIGO 321 DO CPC)-- E MAIS DO QUE O SUFICIENTE PARA A OBTENCAO DA DOCUMENTACAO. ASSIM, PARA GARANTIR A \"RAZOAVEL DURACAO DO PROCESSO E OS MEIOS QUE GARANTAM A CELERIDADE DE SUA TRAMITACAO\" (ART. 5, LXXVIII, DA CF), DESDE JA SE ANTECIPA QUE O PRAZO NAO SERA PRORROGADO. EM CASO DE INTERPOSICAO DE EMBARGOS DE DECLARACAO MERAMENTE PROTELATORIOS EM FACE DA PRESENTE DECISAO (COM NITIDO CARATER INFRINGENTE), O RECURSO NAO SERA SEQUER CONHECIDO E SERA O EMBARGANTE SANCIONADO COM MULTA POR LITIGANCIA DE MA-FE. DEVE O(A) ADVOGADO(A), AO PROCEDER A EMENDA A PETICAO INICIAL, POR MEIO DO LINK DE \"PETICAO INTERMEDIARIA DE 1 GRAU\", CADASTRA-LA NA CATEGORIA \"PETICOES DIVERSAS\", TIPO DE PETICAO: \"8431 - EMENDA A INICIAL\", A FIM DE CONFERIR MAIOR AGILIDADE NA IDENTIFICACAO NO FLUXO DE TRABALHO, ONDE SE PROCESSAM OS AUTOS DIGITAIS. INTIME-SE. ADVOGADOS(S): TIAGO BAPTISTA VALIM (OAB 485964/SP)",
                "PublishDate": "2023-12-04T00:00:00",
                "CaptureDate": "2023-12-06T03:12:34"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2023-12-01T00:00:00",
                "CaptureDate": "2023-12-06T03:12:34"
              },
              {
                "Content": "DETERMINADA A EMENDA A INICIAL VISTOS. A PETICAO INICIAL NAO PREENCHE OS REQUISITOS DOS ARTIGOS 319 E 320 DO CPCE APRESENTA DEFEITOS E IRREGULARIDADES CAPAZES DE DIFICULTAR O JULGAMENTO DE MERITO. ASSIM, NA FORMA DO ARTIGO 321 DO CPC, DEVERA A PARTE AUTORA EMENDA-LA. DEVERA A PARTE AUTORA PROMOVER A JUNTADA DE COMPROVANTE DE RESIDENCIA ATUALIZADO (EXPEDIDO NOS ULTIMOS TRES MESES). SE ESTIVEREM EM NOME DE TERCEIRO, DEVE SER ACOMPANHADO DE DECLARACAO DE PROPRIO PUNHO DO TITULAR DO COMPROVANTE A INDICAR QUE A PARTE AUTORA RESIDE NAQUELE ENDERECO, IDENTIFICANDO-SE COM RG E CPF. DISPOE A LEI QUE \"A PETICAO INICIAL INDICARA (...) OS NOMES, OS PRENOMES, O ESTADO CIVIL, A EXISTENCIA DE UNIAO ESTAVEL, A PROFISSAO, O NUMERO DE INSCRICAO NO CADASTRO DE PESSOAS FISICAS OU NO CADASTRO NACIONAL DA PESSOA JURIDICA, O ENDERECO ELETRONICO, O DOMICILIO E A RESIDENCIA DO AUTOR E DO REU\" (ART. 319 DO CPC). ASSIM, DEVERA A PARTE AUTORA SER QUALIFICADA DE DE MODO COMPLETO, PARA INCLUIR SEU ENDERECO ELETRONICO (E-MAIL). ESCLARECA IGUALMENTE A PARTE AUTORA A DIVERGENCIA DE ENDERECO E CNPJS CADASTRADOS NO SISTEMA COM OS APONTADOS NA EXORDIAL DO REQUERIDO PAY WAY, CORRIGINDO-OS. ESTABELECE A LEI QUE \"O ADVOGADO NAO SERA ADMITIDO A POSTULAR EM JUIZO SEM PROCURACAO, SALVO PARA EVITAR PRECLUSAO, DECADENCIA OU PRESCRICAO, OU PARA PRATICAR ATO CONSIDERADO URGENTE\" (ART. 104 DO CPC). NOS TERMOS DA JURISPRUDENCIA DO E. TRIBUNAL DE JUSTICA DE SAO PAULO, EM SE TRATANDO DE \"DEMANDA DE MASSA\", ENVOLVENDO CAUSAS DE PEDIR E PEDIDOS IDENTICOS (COMO A PRESENTE), TALVEZ COM CARATER PREDATORIO, DEVE O JUIZ TOMAR ESPECIAL ATENCAO PARA GARANTIR QUE AS PARTES ESTEJAM \"ASSISTIDAS POR ADVOGADO DEVIDAMENTE HABILITADO PELA ORDEM DOS ADVOGADOS DO BRASIL, OUTORGANDO A ELES, ATRAVES DE PROCURACAO, PODERES PARA DEFESA DE SEUS DIREITOS EM JUIZO, DEVENDO CONSTAR DO INSTRUMENTO DE MANDATO, DENTRE OUTROS ELEMENTOS, O OBJETIVO DA OUTORGA COM A DESIGNACAO E A EXTENSAO DOS PODERES CONFERIDOS\" (TJSP, AGRAVO DE INSTRUMENTO 2189052-78.2023.8.26.0000, RELATOR DES. ERNANI DESCO FILHO, 18 CAMARA DE DIREITO PRIVADO, J. 23/11/2023). ASSIM, PARA ASSEGURAR QUE A PARTE AUTORA TEM CONHECIMENTO DE QUE SEU DIREITO ESTA SENDO DEFENDIDO EM JUIZO PELO(A) PROCURADOR(A) QUE CONSTITUIU, TRATANDO-SE DE INCONTROVERSA E INDUVIDOSA RELACAO DE CONFIANCA, DEVE A PARTE TRAZER (I) DECLARACAO DE PROPRIO PUNHO DATADA EM QUE SE DEMONSTRA A PARTE AUTORA ESTAR CIENTE DA EXISTENCIA DESTA ACAO, DEVENDO CONSTAR O NUMERO DESTE FEITO, SEU OBJETO E QUE EFETIVAMENTE CONTRATOU E RECONHECE O(A) ADVOGADO(A); E (II) PROCURACAO DATADA E ATUAL, COM RECONHECIMENTO DE FIRMA, QUE PREENCHA OS REQUISITOS DO 1 DO ART. 654 DO CODIGO CIVIL, COM A DESIGNACAO E A EXTENSAO DOS PODERES CONFERIDOS, A INDICACAO DO LUGAR ONDE FOI PASSADO, A QUALIFICACAO DO OUTORGANTE E DO OUTORGADO, A DATA E O OBJETIVO DA OUTORGA. NESSE SENTIDO: AGRAVO DE INSTRUMENTO. ACAO DECLARATORIA DE PRESCRICAO C/C INDENIZATORIA. INSURGENCIA CONTRA DECISAO QUE DETERMINOU A APRESENTACAO DE PROCURACAO ATUAL, DATADA E COM RECONHECIMENTO DE FIRMA POR AUTENTICIDADE, ALEM DE DECLARACAO DE PROPRIO PUNHO EM QUE SE DEMONSTRE A PARTE AUTORA TER CONHECIMENTO DA EXISTENCIA DA ACAO. O EXERCICIO DO DIREITO DE ACAO, MATERIALIZADO NA SEARA PROCESSUAL, TAMBEM RECLAMA A PRESENCA DE REQUISITOS DE VALIDADE E DE EXISTENCIA, COMUMENTE DENOMINADOS DE PRESSUPOSTOS PROCESSUAIS. RELATIVAMENTE AO CRITERIO SUBJETIVO, IMPENDE DESTACAR A CAPACIDADE POSTULATORIA, SEGUNDO O QUAL AS PARTES DEVEM SER ASSISTIDAS POR ADVOGADO DEVIDAMENTE HABILITADO PELA ORDEM DOS ADVOGADOS DO BRASIL, OUTORGANDO A ELES, ATRAVES DE PROCURACAO, PODERES PARA DEFESA DE SEUS DIREITOS EM JUIZO, DEVENDO CONSTAR DO INSTRUMENTO DE MANDATO, DENTRE OUTROS ELEMENTOS, O OBJETIVO DA OUTORGA COM A DESIGNACAO E A EXTENSAO DOS PODERES CONFERIDOS. NO CASO CONCRETO, A FIM DE SE AFERIR A CAPACIDADE POSTULATORIA DA AGRAVANTE, MATERIALIZADA PELA PROCURACAO QUE OUTORGOU A SUA PROCURADORA, RAZOAVEL AS EXIGENCIAS FORMULADAS PELO JUIZO \"A QUO\". CUIDA-SE DE MEDIDA QUE VISA APENAS ASSEGURAR QUE A AGRAVANTE TEM CONHECIMENTO DE QUE SEU DIREITO ESTA SENDO DEFENDIDO EM JUIZO PELA PROCURADORA QUE CONSTITUIU. ADEMAIS, TRATANDO-SE DE INCONTROVERSA E INDUVIDOSA RELACAO DE CONFIANCA, AS DETERMINACOES SAO DE FACEIS CUMPRIMENTO, INCLUSIVE SEM CUSTOS A AGRAVANTE, CONSIDERANDO SUA CONDICAO DE HIPOSSUFICIENTE FINANCEIRA. DECISAO MANTIDA. RECURSO NAO PROVIDO (TJSP, AGRAVO DE INSTRUMENTO 2189052-78.2023.8.26.0000, RELATOR DES. ERNANI DESCO FILHO, 18 CAMARA DE DIREITO PRIVADO, J. 23/11/2023) DIANTE DOS ELEMENTOS CONSTANTES DOS AUTOS NOTADAMENTE REPRESENTACAO POR ADVOGADO CONSTITUIDO, DA RENUNCIA AO DIREITO DE LITIGAR NO FORO DE SEU DOMICILIO PREVISTA NO CDC, DE SEU ENDERECO RESIDENCIAL E DE SUA PROFISSAO (OPERADORA DE CAIXA) DEVERA A PARTE AUTORA COMPROVAR, JUNTANDO DOCUMENTACAO IDONEA, O ENQUADRAMENTO NA SITUACAO DEFINIDA PELO ARTIGO 5, INCISO LXXIV, DA CONSTITUICAO FEDERAL, SOB PENA DE INDEFERIMENTO DO PEDIDO DE CONCESSAO DO BENEFICIO DA ASSISTENCIA JUDICIARIA GRATUITA. ASSIM, DEVERA TRAZER AOS AUTOS OS SEGUINTES DOCUMENTOS (TODOS): (I) RELATORIO DE CONTAS E RELACIONAMENTOS (CCS) OBTIDO EM CONSULTA AO PORTAL REGISTRATO DO BANCO CENTRAL DO BRASIL (HTTPS://REGISTRATO.BCB.GOV.BR/REGISTRATO/RELATORIOS/CCS). (II) EXTRATOS DOS ULTIMOS TRES MESES DE TODAS AS CONTAS QUE NAO CONSTEM COMO ENCERRADAS NO RELATORIO. CASO NAO RECONHECA ALGUMA CONTA OU RELACIONAMENTO DISPOSTA NO RELATORIO, DEVERA COMPROVAR QUE ENTROU EM CONTATO COM O BANCO OU INSTITUICAO INFORMADA SOLICITANDO AS INFORMACOES E QUE NAO OBTEVE RESPOSTA ATE O FIM DO PRAZO. (III) FATURAS DOS ULTIMOS TRES MESES DE TODOS OS CARTOES DE CREDITO ABERTOS EM SEU NOME. CASO NAO POSSUA CARTOES DE CREDITO EM SEU NOME, DEVERA TRAZER DECLARACAO ESCRITA INFORMANDO QUE, SOB AS PENAS DA LEI, INCLUINDO A RESPONSABILIZACAO CRIMINAL, DECLARA QUE NAO HA CARTOES DE CREDITO EM SEU NOME (NESTES TERMOS). (IV) COPIA INTEGRAL DAS DUAS ULTIMAS DECLARACOES DE BENS E RENDIMENTOS APRESENTADAS A RECEITA FEDERAL. NO CASO DE ISENCAO DO PAGAMENTO DO TRIBUTO, DEVERA APRESENTAR COPIA DE PRINT DO SITIO DA RECEITA FEDERAL, NOTICIANDO NAO HAVER DECLARACOES, BENS E RENDIMENTOS, TOMANDO EM CONTA O CPF DA PARTE, EM SUA BASE DE DADOS COM RELACAO AOS DOIS ULTIMOS EXERCICIOS (HTTPS://WWW.GOV.BR/RECEITAFEDERAL/PT-BR/ASSUNTOS/MEU-IMPOSTO-DE-RENDA/RESTITUICAO/SITUACOES). PRAZO: 15 DIAS. POR EXPRESSA DISPOSICAO LEGAL, \"TODOS OS SUJEITOS DO PROCESSO DEVEM COOPERAR ENTRE SI PARA QUE SE OBTENHA, EM TEMPO RAZOAVEL, DECISAO DE MERITO JUSTA E EFETIVA\" (ART. 6 DO CPC). O PRAZO CONCEDIDO --QUE E ESTABELECIDO EM LEI (ARTIGO 321 DO CPC)-- E MAIS DO QUE O SUFICIENTE PARA A OBTENCAO DA DOCUMENTACAO. ASSIM, PARA GARANTIR A \"RAZOAVEL DURACAO DO PROCESSO E OS MEIOS QUE GARANTAM A CELERIDADE DE SUA TRAMITACAO\" (ART. 5, LXXVIII, DA CF), DESDE JA SE ANTECIPA QUE O PRAZO NAO SERA PRORROGADO. EM CASO DE INTERPOSICAO DE EMBARGOS DE DECLARACAO MERAMENTE PROTELATORIOS EM FACE DA PRESENTE DECISAO (COM NITIDO CARATER INFRINGENTE), O RECURSO NAO SERA SEQUER CONHECIDO E SERA O EMBARGANTE SANCIONADO COM MULTA POR LITIGANCIA DE MA-FE. DEVE O(A) ADVOGADO(A), AO PROCEDER A EMENDA A PETICAO INICIAL, POR MEIO DO LINK DE \"PETICAO INTERMEDIARIA DE 1 GRAU\", CADASTRA-LA NA CATEGORIA \"PETICOES DIVERSAS\", TIPO DE PETICAO: \"8431 - EMENDA A INICIAL\", A FIM DE CONFERIR MAIOR AGILIDADE NA IDENTIFICACAO NO FLUXO DE TRABALHO, ONDE SE PROCESSAM OS AUTOS DIGITAIS. INTIME-SE.",
                "PublishDate": "2023-12-01T00:00:00",
                "CaptureDate": "2023-12-06T03:12:34"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-11-30T00:00:00",
                "CaptureDate": "2023-12-06T03:12:34"
              }
            ],
            "Petitions": [],
            "Decisions": []
          },
          {
            "Number": "11012201820238260002",
            "Type": "PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL",
            "MainSubject": "INDENIZACAO POR DANO MATERIAL",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "ESPECIAL CIVEL",
            "CourtDistrict": "SAO PAULO",
            "Judge": "TAIS HELENA FIORINI BARBOSA",
            "JudgingBody": "1 VARA DO JUIZADO ESPECIAL CIVEL",
            "State": "SP",
            "Status": "INDEFINIDO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "INDENIZAÇÃO POR DANO MATERIAL",
            "InferredCNJSubjectNumber": 7780,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO DO JUIZADO ESPECIAL CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "INDENIZACAO POR DANO MATERIAL",
              "INDENIZACAO POR DANO MORAL"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 54880,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-12-05T00:00:00",
            "NoticeDate": "2023-12-02T00:00:00",
            "LastMovementDate": "2023-12-05T00:00:00",
            "CaptureDate": "2023-12-06T03:26:10",
            "LastUpdate": "2023-12-06T03:26:10",
            "NumberOfParties": 5,
            "NumberOfUpdates": 2,
            "LawSuitAge": 88,
            "AverageNumberOfUpdatesPerMonth": 0,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "27195642810",
                "IsPartyActive": true,
                "Name": "TAIS HELENA FIORINI BARBOSA",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-12-06T03:26:10"
              },
              {
                "IsPartyActive": true,
                "Name": "CAIO PEREIRA DE OLIVEIRA",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-12-06T03:26:10"
              },
              {
                "IsPartyActive": true,
                "Name": "ANDREZA RODRIGUES COSTA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "SpecificType": "ADVOGADA (REQTE)"
                },
                "LastCaptureDate": "2023-12-06T03:26:10"
              },
              {
                "Doc": "35624319000172",
                "IsPartyActive": true,
                "Name": "MK DIGITAL BANK INSTITUICAO DE PAGAMENTO S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-12-06T03:26:10"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-12-06T03:26:10"
              }
            ],
            "Updates": [
              {
                "Content": "PROCESSO : 1101220-18.2023.8.26.0002 CLASSE : PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL REQTE : CAIO PEREIRA DE OLIVEIRA ADVOGADO : 501020/SP - ANDREZA RODRIGUES COSTA REQDO : STARK BANK S.A. VARA : 1 VARA DO JUIZADO ESPECIAL CIVEL",
                "PublishDate": "2023-12-05T00:00:00",
                "CaptureDate": "2023-12-06T03:26:10"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-12-02T00:00:00",
                "CaptureDate": "2023-12-06T03:26:10"
              }
            ],
            "Petitions": [],
            "Decisions": []
          },
          {
            "Number": "10316868120238260003",
            "Type": "PROCEDIMENTO COMUM",
            "MainSubject": "BANCARIOS",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "SAO PAULO",
            "Judge": "MICHELLE FABIOLA DITTERT PUPULIM",
            "JudgingBody": "6 VARA CIVEL",
            "State": "SP",
            "Status": "INDEFINIDO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "BANCÁRIOS",
            "InferredCNJSubjectNumber": 7752,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "BANCARIOS",
              "RESPONSABILIDADE DO FORNECEDOR"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 13980,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-12-05T00:00:00",
            "NoticeDate": "2023-11-29T00:00:00",
            "LastMovementDate": "2023-12-05T00:00:00",
            "CaptureDate": "2023-12-06T03:30:12",
            "LastUpdate": "2023-12-06T03:30:12",
            "NumberOfParties": 6,
            "NumberOfUpdates": 5,
            "LawSuitAge": 91,
            "AverageNumberOfUpdatesPerMonth": 1,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "02992151998",
                "IsPartyActive": true,
                "Name": "MICHELLE FABIOLA DITTERT PUPULIM",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-12-06T03:30:12"
              },
              {
                "IsPartyActive": true,
                "Name": "ALINE DE ALMEIDA SILVA",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-12-06T03:30:12"
              },
              {
                "Doc": "48561184809",
                "IsPartyActive": true,
                "Name": "TIAGO BAPTISTA VALIM",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "485964",
                  "State": "SP",
                  "SpecificType": "ADVOGADO (REQTE)"
                },
                "LastCaptureDate": "2023-12-06T03:30:12"
              },
              {
                "Doc": "46189325000165",
                "IsPartyActive": true,
                "Name": "ITAU UNIBANCO S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-12-06T03:30:12"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-12-06T03:30:12"
              },
              {
                "Doc": "48689840000130",
                "IsPartyActive": true,
                "Name": "CASH PAY MEIOS DE PAGAMENTO LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-12-06T03:30:12"
              }
            ],
            "Updates": [
              {
                "Content": "PROCESSO : 1031686-81.2023.8.26.0003 CLASSE : PROCEDIMENTO COMUM CIVEL REQTE : ALINE DE ALMEIDA SILVA ADVOGADO : 485964/SP - TIAGO BAPTISTA VALIM REQDO : ITAU UNIBANCO S.A. VARA : 6 VARA CIVEL",
                "PublishDate": "2023-12-05T00:00:00",
                "CaptureDate": "2023-12-06T03:30:12"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0692/2023 TEOR DO ATO: VISTOS. QUINZE DIAS PARA A AUTORA PROVIDENCIAR O RECOLHIMENTO DAS CUSTAS INICIAIS DEVIDAS AO ESTADO E DA TAXA PARA CITACAO POSTAL (VIDE COMUNICADO CG N 1817/2016, DA EGREGIA CORREGEDORIA GERAL DA JUSTICA). INT. ADVOGADOS(S): TIAGO BAPTISTA VALIM (OAB 485964/SP)",
                "PublishDate": "2023-12-04T00:00:00",
                "CaptureDate": "2023-12-06T03:30:13"
              },
              {
                "Content": "DETERMINADA A EMENDA A INICIAL VISTOS. QUINZE DIAS PARA A AUTORA PROVIDENCIAR O RECOLHIMENTO DAS CUSTAS INICIAIS DEVIDAS AO ESTADO E DA TAXA PARA CITACAO POSTAL (VIDE COMUNICADO CG N 1817/2016, DA EGREGIA CORREGEDORIA GERAL DA JUSTICA). INT.",
                "PublishDate": "2023-12-01T00:00:00",
                "CaptureDate": "2023-12-06T03:30:13"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2023-11-30T00:00:00",
                "CaptureDate": "2023-12-06T03:30:13"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-11-29T00:00:00",
                "CaptureDate": "2023-12-06T03:30:13"
              }
            ],
            "Petitions": [],
            "Decisions": []
          },
          {
            "Number": "10096198520238260565",
            "Type": "PROCEDIMENTO COMUM",
            "MainSubject": "RESCISAO DO CONTRATO E DEVOLUCAO DO DINHEIRO",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "SAO CAETANO DO SUL",
            "Judge": "JOSE FRANCISCO MATOS",
            "JudgingBody": "4 VARA CIVEL",
            "State": "SP",
            "Status": "ATIVO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "RESCISÃO DO CONTRATO E DEVOLUÇÃO DO DINHEIRO",
            "InferredCNJSubjectNumber": 7768,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "RESCISAO DO CONTRATO E DEVOLUCAO DO DINHEIRO"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 147999.94,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-12-06T00:00:00",
            "NoticeDate": "2023-12-04T00:00:00",
            "LastMovementDate": "2023-12-06T00:00:00",
            "CaptureDate": "2023-12-07T07:34:07",
            "LastUpdate": "2023-12-07T07:34:07",
            "NumberOfParties": 8,
            "NumberOfUpdates": 5,
            "LawSuitAge": 86,
            "AverageNumberOfUpdatesPerMonth": 1,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "IsPartyActive": true,
                "Name": "JOSE FRANCISCO MATOS",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-12-07T07:34:07"
              },
              {
                "IsPartyActive": true,
                "Name": "ANTONIO HENRIQUE DE OLIVEIRA",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-12-07T07:34:07"
              },
              {
                "Doc": "40838980899",
                "IsPartyActive": true,
                "Name": "LARISSA SIOLLA BILLA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "442827",
                  "State": "SP",
                  "SpecificType": "ADVOGADA (REQTE)"
                },
                "LastCaptureDate": "2023-12-07T07:34:07"
              },
              {
                "Doc": "48472928000103",
                "IsPartyActive": true,
                "Name": "KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-12-07T07:34:07"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-12-07T07:34:07"
              },
              {
                "Doc": "48689840000130",
                "IsPartyActive": true,
                "Name": "CASH PAY MEIOS DE PAGAMENTO LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-12-07T07:34:07"
              },
              {
                "Doc": "35624319000172",
                "IsPartyActive": true,
                "Name": "MK DIGITAL BANK INSTITUICAO DE PAGAMENTO S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-12-07T07:34:07"
              },
              {
                "IsPartyActive": true,
                "Name": "CECI CECILIA DE OLIVEIRA DUARTE MARIANO",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDA"
                },
                "LastCaptureDate": "2023-12-07T07:34:07"
              }
            ],
            "Updates": [
              {
                "Content": "ATO ORDINATORIO VISTA A PARTE INTERESSADA PARA: PROVIDENCIAR A JUNTADA NA INTEGRA DE SUAS TRES ULTIMAS DECLARACOES DE IMPOSTO DE RENDA E EXTRATO DE TODAS AS SUAS CONTAS BANCARIAS DOS ULTIMOS TRES MESES A FIM DE SER APRECIADO O PEDIDO DE RECOLHIMENTO DAS CUSTAS PROCESSUAIS AO FINAL DA ACAO, SOB PENA DE INDEFERIMENTO.",
                "PublishDate": "2023-12-06T00:00:00",
                "CaptureDate": "2023-12-07T07:34:07"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0999/2023 TEOR DO ATO: VISTA A PARTE INTERESSADA PARA: PROVIDENCIAR A JUNTADA NA INTEGRA DE SUAS TRES ULTIMAS DECLARACOES DE IMPOSTO DE RENDA E EXTRATO DE TODAS AS SUAS CONTAS BANCARIAS DOS ULTIMOS TRES MESES A FIM DE SER APRECIADO O PEDIDO DE RECOLHIMENTO DAS CUSTAS PROCESSUAIS AO FINAL DA ACAO, SOB PENA DE INDEFERIMENTO. ADVOGADOS(S): LARISSA SIOLLA BILLA (OAB 442827/SP)",
                "PublishDate": "2023-12-06T00:00:00",
                "CaptureDate": "2023-12-07T07:34:07"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0999/2023 DATA DA PUBLICACAO: 11/12/2023 NUMERO DO DIARIO: 3874",
                "PublishDate": "2023-12-06T00:00:00",
                "CaptureDate": "2023-12-07T07:34:07"
              },
              {
                "Content": "PROCESSO : 1009619-85.2023.8.26.0565 CLASSE : PROCEDIMENTO COMUM CIVEL REQTE : ANTONIO HENRIQUE DE OLIVEIRA ADVOGADO : 442827/SP - LARISSA SIOLLA BILLA REQDA : CECI CECILIA DE OLIVEIRA DUARTE MARIANO VARA : 4 VARA CIVEL",
                "PublishDate": "2023-12-06T00:00:00",
                "CaptureDate": "2023-12-07T07:34:07"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-12-04T00:00:00",
                "CaptureDate": "2023-12-07T07:34:07"
              }
            ],
            "Petitions": [],
            "Decisions": []
          },
          {
            "Number": "10245955120238260451",
            "Type": "PROCEDIMENTO COMUM",
            "MainSubject": "INDENIZACAO POR DANO MORAL",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "PIRACICABA",
            "Judge": "FABIOLA GIOVANNA BARREA MORETTI",
            "JudgingBody": "3 VARA CIVEL",
            "State": "SP",
            "Status": "INDEFINIDO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "INDENIZAÇÃO POR DANO MORAL",
            "InferredCNJSubjectNumber": 7779,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "INDENIZACAO POR DANO MORAL"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 20440,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-12-06T00:00:00",
            "NoticeDate": "2023-11-30T00:00:00",
            "LastMovementDate": "2023-12-06T00:00:00",
            "CaptureDate": "2023-12-07T19:50:16",
            "LastUpdate": "2023-12-07T19:50:16",
            "NumberOfParties": 7,
            "NumberOfUpdates": 15,
            "LawSuitAge": 90,
            "AverageNumberOfUpdatesPerMonth": 4,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "29943457813",
                "IsPartyActive": true,
                "Name": "FABIOLA GIOVANNA BARREA MORETTI",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-12-07T19:50:16"
              },
              {
                "Doc": "21849416893",
                "IsPartyActive": true,
                "Name": "ADILIA DOMINGOS DA SILVA",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-12-07T19:50:16"
              },
              {
                "Doc": "07446073969",
                "IsPartyActive": true,
                "Name": "TABATA RIBEIRO BRITO MIQUELETTI",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "505978",
                  "State": "SP",
                  "SpecificType": "ADVOGADA (REQTE)"
                },
                "LastCaptureDate": "2023-12-07T19:50:16"
              },
              {
                "Doc": "51753968000120",
                "IsPartyActive": true,
                "Name": "ONE WAY CONSULTORIA E SERVICOS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-12-07T19:50:16"
              },
              {
                "IsPartyActive": true,
                "Name": "DELCRED SCD S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-12-07T19:50:16"
              },
              {
                "Doc": "51880512000120",
                "IsPartyActive": true,
                "Name": "PAYWAY CONSULTORIA E SERVICOS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-12-07T19:50:16"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-12-07T19:50:16"
              }
            ],
            "Updates": [
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 1076/2023 DATA DA PUBLICACAO: 07/12/2023 NUMERO DO DIARIO: 3873",
                "PublishDate": "2023-12-06T00:00:00",
                "CaptureDate": "2023-12-07T19:50:17"
              },
              {
                "Content": "CERTIDAO JUNTADA CERTIDAO DE CARTA RECEBIDA PELOS CORREIOS",
                "PublishDate": "2023-12-06T00:00:00",
                "CaptureDate": "2023-12-07T19:50:17"
              },
              {
                "Content": "CERTIDAO JUNTADA CERTIDAO DE CARTA RECEBIDA PELOS CORREIOS",
                "PublishDate": "2023-12-06T00:00:00",
                "CaptureDate": "2023-12-07T19:50:17"
              },
              {
                "Content": "CERTIDAO JUNTADA CERTIDAO DE CARTA RECEBIDA PELOS CORREIOS",
                "PublishDate": "2023-12-06T00:00:00",
                "CaptureDate": "2023-12-07T19:50:17"
              },
              {
                "Content": "CERTIDAO JUNTADA CERTIDAO DE CARTA RECEBIDA PELOS CORREIOS",
                "PublishDate": "2023-12-06T00:00:00",
                "CaptureDate": "2023-12-07T19:50:17"
              },
              {
                "Content": "PROCESSO : 1024595-51.2023.8.26.0451 CLASSE : PROCEDIMENTO COMUM CIVEL REQTE : ADILIA DOMINGOS DA SILVA ADVOGADO : 505978/SP - TABATA RIBEIRO BRITO MIQUELETTI REQDO : ONE WAY CONSULTORIA E SERVICOS LTDA VARA : 3 VARA CIVEL PROCESSO 1024595-51.2023.8.26.0451 - PROCEDIMENTO COMUM CIVEL - INDENIZACAO POR DANO MORAL - ADILIA DOMINGOS DA SILVA - VISTOS. DEFIRO A GRATUIDADE DA JUSTICA A AUTORA. ANOTE-SE. INDEFIRO O PEDIDO DE TUTELA DE URGENCIA, POIS AUSENTE O REQUISITO DA PROBABILIDADE DO DIREITO EM JUIZO DE COGNICAO SUMARIA. DIANTE DAS ESPECIFICIDADES DA CAUSA E DE MODO A ADEQUAR O RITO PROCESSUAL AS NECESSIDADES DO CONFLITO, BEM COMO DIANTE DA CONSTATACAO DO BAIXISSIMO INDICE DE EXITO NAS AUDIENCIAS PREVIAS DE CONCILIACAO DESIGNADAS POR ESTE JUIZO APOS A VIGENCIA DO ATUAL CPC, TRANSCORRIDO PRATICAMENTE UM ANO DE SUA APLICACAO E O QUE ESTA, ATUALMENTE, SOMENTE A ACARRETAR MAIOR DELONGA NO TRAMITE PROCESSUAL E MAIOR CARGA DE TRABALHO A UNIDADE JUDICIAL JA SOBRECARREGADA, EM CONFRONTO AO DIREITO FUNDAMENTAL CONSTITUCIONAL DAS PARTES A DURACAO RAZOAVEL DO PROCESSO E DOS MEIOS QUE GARANTAM SUA CELERIDADE DE TRAMITACAO (ART.5., LXXVIII, DA CARTA MAGNA), DEIXO PARA MOMENTO OPORTUNO A ANALISE DA CONVENIENCIA DA AUDIENCIA DE CONCILIACAO (CPC, ART.139, VI E ENUNCIADO NO.35 DA ENFAM). CITE(M)-SE PARA APRESENTAR RESPOSTA (NECESSARIAMENTE POR MEIO DE ADVOGADO), NO PRAZO DE QUINZE (15) DIAS, SOB PENA DE SE PRESUMIREM VERDADEIROS OS FATOS NARRADOS PELO(S) AUTOR(ES). INTIME-SE. - ADV: TABATA RIBEIRO BRITO MIQUELETTI (OAB 505978/SP)",
                "PublishDate": "2023-12-06T00:00:00",
                "CaptureDate": "2023-12-07T19:50:16"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 1076/2023 TEOR DO ATO: VISTOS. DEFIRO A GRATUIDADE DA JUSTICA A AUTORA. ANOTE-SE. INDEFIRO O PEDIDO DE TUTELA DE URGENCIA, POIS AUSENTE O REQUISITO DA PROBABILIDADE DO DIREITO EM JUIZO DE COGNICAO SUMARIA. DIANTE DAS ESPECIFICIDADES DA CAUSA E DE MODO A ADEQUAR O RITO PROCESSUAL AS NECESSIDADES DO CONFLITO, BEM COMO DIANTE DA CONSTATACAO DO BAIXISSIMO INDICE DE EXITO NAS AUDIENCIAS PREVIAS DE CONCILIACAO DESIGNADAS POR ESTE JUIZO APOS A VIGENCIA DO ATUAL CPC, TRANSCORRIDO PRATICAMENTE UM ANO DE SUA APLICACAO E O QUE ESTA, ATUALMENTE, SOMENTE A ACARRETAR MAIOR DELONGA NO TRAMITE PROCESSUAL E MAIOR CARGA DE TRABALHO A UNIDADE JUDICIAL JA SOBRECARREGADA, EM CONFRONTO AO DIREITO FUNDAMENTAL CONSTITUCIONAL DAS PARTES A DURACAO RAZOAVEL DO PROCESSO E DOS MEIOS QUE GARANTAM SUA CELERIDADE DE TRAMITACAO (ART.5., LXXVIII, DA CARTA MAGNA), DEIXO PARA MOMENTO OPORTUNO A ANALISE DA CONVENIENCIA DA AUDIENCIA DE CONCILIACAO (CPC, ART.139, VI E ENUNCIADO NO.35 DA ENFAM). CITE(M)-SE PARA APRESENTAR RESPOSTA (NECESSARIAMENTE POR MEIO DE ADVOGADO), NO PRAZO DE QUINZE (15) DIAS, SOB PENA DE SE PRESUMIREM VERDADEIROS OS FATOS NARRADOS PELO(S) AUTOR(ES). INTIME-SE. ADVOGADOS(S): TABATA RIBEIRO BRITO MIQUELETTI (OAB 505978/SP)",
                "PublishDate": "2023-12-05T00:00:00",
                "CaptureDate": "2023-12-07T19:50:17"
              },
              {
                "Content": "CARTA EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                "PublishDate": "2023-12-05T00:00:00",
                "CaptureDate": "2023-12-07T19:50:17"
              },
              {
                "Content": "CARTA EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                "PublishDate": "2023-12-05T00:00:00",
                "CaptureDate": "2023-12-07T19:50:17"
              },
              {
                "Content": "CARTA EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                "PublishDate": "2023-12-05T00:00:00",
                "CaptureDate": "2023-12-07T19:50:17"
              },
              {
                "Content": "CARTA EXPEDIDA PROCESSO DIGITAL - CARTA - CITACAO - RITO COMUM - SEM AUDIENCIA - CIVEL - NOVO CPC",
                "PublishDate": "2023-12-05T00:00:00",
                "CaptureDate": "2023-12-07T19:50:17"
              },
              {
                "Content": "PROFERIDAS OUTRAS DECISOES NAO ESPECIFICADAS VISTOS. DEFIRO A GRATUIDADE DA JUSTICA A AUTORA. ANOTE-SE. INDEFIRO O PEDIDO DE TUTELA DE URGENCIA, POIS AUSENTE O REQUISITO DA PROBABILIDADE DO DIREITO EM JUIZO DE COGNICAO SUMARIA. DIANTE DAS ESPECIFICIDADES DA CAUSA E DE MODO A ADEQUAR O RITO PROCESSUAL AS NECESSIDADES DO CONFLITO, BEM COMO DIANTE DA CONSTATACAO DO BAIXISSIMO INDICE DE EXITO NAS AUDIENCIAS PREVIAS DE CONCILIACAO DESIGNADAS POR ESTE JUIZO APOS A VIGENCIA DO ATUAL CPC, TRANSCORRIDO PRATICAMENTE UM ANO DE SUA APLICACAO E O QUE ESTA, ATUALMENTE, SOMENTE A ACARRETAR MAIOR DELONGA NO TRAMITE PROCESSUAL E MAIOR CARGA DE TRABALHO A UNIDADE JUDICIAL JA SOBRECARREGADA, EM CONFRONTO AO DIREITO FUNDAMENTAL CONSTITUCIONAL DAS PARTES A DURACAO RAZOAVEL DO PROCESSO E DOS MEIOS QUE GARANTAM SUA CELERIDADE DE TRAMITACAO (ART.5., LXXVIII, DA CARTA MAGNA), DEIXO PARA MOMENTO OPORTUNO A ANALISE DA CONVENIENCIA DA AUDIENCIA DE CONCILIACAO (CPC, ART.139, VI E ENUNCIADO NO.35 DA ENFAM). CITE(M)-SE PARA APRESENTAR RESPOSTA (NECESSARIAMENTE POR MEIO DE ADVOGADO), NO PRAZO DE QUINZE (15) DIAS, SOB PENA DE SE PRESUMIREM VERDADEIROS OS FATOS NARRADOS PELO(S) AUTOR(ES). INTIME-SE.",
                "PublishDate": "2023-12-04T00:00:00",
                "CaptureDate": "2023-12-07T19:50:17"
              },
              {
                "Content": "MUDANCA DE MAGISTRADO TITULAR 02 VAGA 2 (3 VARA CIVEL) PARA O(A) JUIZ(A) FABIOLA GIOVANNA BARREA MORETTI. MOTIVO: REMESSA - AUXILIO CONCLUSAO - FINAL 04.",
                "PublishDate": "2023-12-01T00:00:00",
                "CaptureDate": "2023-12-07T19:50:17"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2023-12-01T00:00:00",
                "CaptureDate": "2023-12-07T19:50:17"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-11-30T00:00:00",
                "CaptureDate": "2023-12-07T19:50:17"
              }
            ],
            "Petitions": [],
            "Decisions": [
              {
                "DecisionContent": "DEFIRO A GRATUIDADE DA JUSTICA A AUTORA.",
                "DecisionDate": "2023-12-06T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO A GRATUIDADE DA JUSTICA A AUTORA.",
                "DecisionDate": "2023-12-05T00:00:00"
              },
              {
                "DecisionContent": "DEFIRO A GRATUIDADE DA JUSTICA A AUTORA.",
                "DecisionDate": "2023-12-04T00:00:00"
              }
            ]
          },
          {
            "Number": "10242741620238260451",
            "Type": "PROCEDIMENTO COMUM",
            "MainSubject": "BANCARIOS",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "PIRACICABA",
            "Judge": "MARCOS DOUGLAS VELOSO BALBINO DA SILVA",
            "JudgingBody": "2 VARA CIVEL",
            "State": "SP",
            "Status": "INDEFINIDO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "BANCÁRIOS",
            "InferredCNJSubjectNumber": 7752,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "BANCARIOS"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 27467.69,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-12-07T00:00:00",
            "NoticeDate": "2023-11-28T00:00:00",
            "LastMovementDate": "2023-12-07T00:00:00",
            "CaptureDate": "2023-12-08T10:54:42",
            "LastUpdate": "2023-12-08T10:54:42",
            "NumberOfParties": 8,
            "NumberOfUpdates": 8,
            "LawSuitAge": 92,
            "AverageNumberOfUpdatesPerMonth": 2,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "10176871888",
                "IsPartyActive": true,
                "Name": "MARCOS DOUGLAS VELOSO BALBINO DA SILVA",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-12-08T10:54:42"
              },
              {
                "Doc": "73067385187",
                "IsPartyActive": true,
                "Name": "JULIA MARIA MARTINELLI MASSONETO",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-12-08T10:54:42"
              },
              {
                "Doc": "12026806667",
                "IsPartyActive": true,
                "Name": "VIVIAN MURTA LUEDY",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "72451",
                  "State": "BA",
                  "SpecificType": "ADVOGADA (REQTE)"
                },
                "LastCaptureDate": "2023-12-08T10:54:42"
              },
              {
                "IsPartyActive": true,
                "Name": "NU FINANCEIRA S A SOCIEDADE DE CREDITO, FINANCIAMENTO E INVESTIMENTO",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-12-08T10:54:42"
              },
              {
                "IsPartyActive": true,
                "Name": "VIA PAGSEGURO INTERNET S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-12-08T10:54:42"
              },
              {
                "IsPartyActive": true,
                "Name": "LIQUNPAY LDTA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-12-08T10:54:42"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-12-08T10:54:42"
              },
              {
                "Doc": "48689840000130",
                "IsPartyActive": true,
                "Name": "CASH PAY MEIOS DE PAGAMENTO LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-12-08T10:54:42"
              }
            ],
            "Updates": [
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 1083/2023 DATA DA PUBLICACAO: 11/12/2023 NUMERO DO DIARIO: 3874",
                "PublishDate": "2023-12-07T00:00:00",
                "CaptureDate": "2023-12-08T10:54:42"
              },
              {
                "Content": "INCIDENTE PROCESSUAL INSTAURADO 0011492-91.2023.8.26.0451 - EXIBICAO DE DOCUMENTO OU COISA CIVEL",
                "PublishDate": "2023-12-07T00:00:00",
                "CaptureDate": "2023-12-08T10:54:42"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2023-12-07T00:00:00",
                "CaptureDate": "2023-12-08T10:54:42"
              },
              {
                "Content": "PROCESSO 1024274-16.2023.8.26.0451 - PROCEDIMENTO COMUM CIVEL - BANCARIOS - JULIA MARIA MARTINELLI MASSONETO - VISTOS. PARA FINS DE CONCESSAO DOS BENEFICIOS DA ASSISTENCIA JUDICIARIA DEVERA A AUTORA COMPROVAR A INSUFICIENCIA DE RECURSOS, COMO EXIGIDO NO ART. 5, LXXIV, DA CONSTITUICAO FEDERAL E NA PARTE FINAL DO 2 DO ART. 99 DO CPC, JUNTANDO AOS AUTOS, NO PRAZO DE 15 (QUINZE) DIAS, COMO DOCUMENTOS SIGILOSOS, COPIA INTEGRAL DE SUA ULTIMA DECLARACAO DO IMPOSTO DE RENDA OU DE SEU CONJUGE / COMPANHEIRO ACASO DESTE DEPENDENTE, OU, CASO SEJA(M) ISENTO(S), DE EXTRATOS BANCARIOS DE TODAS AS SUAS CONTAS DOS 3 (TRES) ULTIMOS MESES, TENDO QUE VISTA QUE PELO EXTRATO BANCARIO JUNTADO AS FLS. 31/39 INFERE-SE QUE A AUTORA TAMBEM POSSUI CONTA NO ITAU UNIBANCO. APOS, VOLTEM CONCLUSOS. INTIME-SE. - ADV: VIVIAN MURTA LUEDY (OAB 72451/BA)",
                "PublishDate": "2023-12-07T00:00:00",
                "CaptureDate": "2023-12-08T10:54:42"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 1083/2023 TEOR DO ATO: VISTOS. PARA FINS DE CONCESSAO DOS BENEFICIOS DA ASSISTENCIA JUDICIARIA DEVERA A AUTORA COMPROVAR A INSUFICIENCIA DE RECURSOS, COMO EXIGIDO NO ART. 5, LXXIV, DA CONSTITUICAO FEDERAL E NA PARTE FINAL DO 2 DO ART. 99 DO CPC, JUNTANDO AOS AUTOS, NO PRAZO DE 15 (QUINZE) DIAS, COMO DOCUMENTOS SIGILOSOS, COPIA INTEGRAL DE SUA ULTIMA DECLARACAO DO IMPOSTO DE RENDA OU DE SEU CONJUGE / COMPANHEIRO ACASO DESTE DEPENDENTE, OU, CASO SEJA(M) ISENTO(S), DE EXTRATOS BANCARIOS DE TODAS AS SUAS CONTAS DOS 3 (TRES) ULTIMOS MESES, TENDO QUE VISTA QUE PELO EXTRATO BANCARIO JUNTADO AS FLS. 31/39 INFERE-SE QUE A AUTORA TAMBEM POSSUI CONTA NO ITAU UNIBANCO. APOS, VOLTEM CONCLUSOS. INTIME-SE. ADVOGADOS(S): VIVIAN MURTA LUEDY (OAB 72451/BA)",
                "PublishDate": "2023-12-06T00:00:00",
                "CaptureDate": "2023-12-08T10:54:42"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2023-12-05T00:00:00",
                "CaptureDate": "2023-12-08T10:54:42"
              },
              {
                "Content": "PROFERIDAS OUTRAS DECISOES NAO ESPECIFICADAS VISTOS. PARA FINS DE CONCESSAO DOS BENEFICIOS DA ASSISTENCIA JUDICIARIA DEVERA A AUTORA COMPROVAR A INSUFICIENCIA DE RECURSOS, COMO EXIGIDO NO ART. 5, LXXIV, DA CONSTITUICAO FEDERAL E NA PARTE FINAL DO 2 DO ART. 99 DO CPC, JUNTANDO AOS AUTOS, NO PRAZO DE 15 (QUINZE) DIAS, COMO DOCUMENTOS SIGILOSOS, COPIA INTEGRAL DE SUA ULTIMA DECLARACAO DO IMPOSTO DE RENDA OU DE SEU CONJUGE / COMPANHEIRO ACASO DESTE DEPENDENTE, OU, CASO SEJA(M) ISENTO(S), DE EXTRATOS BANCARIOS DE TODAS AS SUAS CONTAS DOS 3 (TRES) ULTIMOS MESES, TENDO QUE VISTA QUE PELO EXTRATO BANCARIO JUNTADO AS FLS. 31/39 INFERE-SE QUE A AUTORA TAMBEM POSSUI CONTA NO ITAU UNIBANCO. APOS, VOLTEM CONCLUSOS. INTIME-SE.",
                "PublishDate": "2023-12-05T00:00:00",
                "CaptureDate": "2023-12-08T10:54:42"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-11-28T00:00:00",
                "CaptureDate": "2023-12-08T10:54:42"
              }
            ],
            "Petitions": [],
            "Decisions": []
          },
          {
            "Number": "11025660420238260002",
            "Type": "PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL",
            "MainSubject": "INDENIZACAO POR DANO MORAL",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "ESPECIAL CIVEL",
            "CourtDistrict": "SAO PAULO",
            "Judge": "DEBORA ROMANO MENEZES",
            "JudgingBody": "1 VARA DO JUIZADO ESPECIAL CIVEL",
            "State": "SP",
            "Status": "INDEFINIDO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "INDENIZAÇÃO POR DANO MORAL",
            "InferredCNJSubjectNumber": 7779,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO DO JUIZADO ESPECIAL CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "INDENIZACAO POR DANO MORAL"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 15550,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-12-11T00:00:00",
            "NoticeDate": "2023-12-06T00:00:00",
            "LastMovementDate": "2023-12-11T00:00:00",
            "CaptureDate": "2023-12-12T05:56:50",
            "LastUpdate": "2023-12-12T05:56:50",
            "NumberOfParties": 8,
            "NumberOfUpdates": 8,
            "LawSuitAge": 84,
            "AverageNumberOfUpdatesPerMonth": 2,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "15354810809",
                "IsPartyActive": true,
                "Name": "DEBORA ROMANO MENEZES",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-12-12T05:56:50"
              },
              {
                "Doc": "49439273860",
                "IsPartyActive": true,
                "Name": "JESSICA APARECIDA DE FREITAS MOREIRA",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-12-12T05:56:50"
              },
              {
                "Doc": "11601274688",
                "IsPartyActive": true,
                "Name": "MARCOS DE ANDRADE CARDOSO",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "191982",
                  "State": "MG",
                  "SpecificType": "ADVOGADO (REQTE)"
                },
                "LastCaptureDate": "2023-12-12T05:56:50"
              },
              {
                "IsPartyActive": true,
                "Name": "DAIANE PEREIRA DE OLIVEIRA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDA"
                },
                "LastCaptureDate": "2023-12-12T05:56:50"
              },
              {
                "Doc": "40891248000104",
                "IsPartyActive": true,
                "Name": "VOLT INSTITUICAO DE PAGAMENTO LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-12-12T05:56:50"
              },
              {
                "Doc": "60872504000123",
                "IsPartyActive": true,
                "Name": "ITAU UNIBANCO HOLDING S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-12-12T05:56:50"
              },
              {
                "IsPartyActive": true,
                "Name": "ASTRO INSTITUICAO DE PAGAMENTO LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-12-12T05:56:50"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-12-12T05:56:50"
              }
            ],
            "Updates": [
              {
                "Content": "PROCESSO 1102566-04.2023.8.26.0002 - PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL - INDENIZACAO POR DANO MORAL - JESSICA APARECIDA DE FREITAS MOREIRA - VISTOS. 1) A MEDIDA CONSTRITIVA PRETENDIDA EM SEDE DE TUTELA PROVISORIA CONFIGURA ARRESTO, INCABIVEL NO JUIZADO, JA QUE PODE VIR A DEMANDAR CITACAO POR EDITAL, CONFORME ENUNCIADO N 43 DO COMUNICADO N 116/2010 DO CONSELHO SUPERVISOR DO SISTEMA DE JUIZADOS ESPECIAIS (DJE 07/12/2010): NA EXECUCAO DE TITULO EXTRAJUDICIAL NAO E POSSIVEL O ARRESTO POR ENVOLVER CITACAO POR EDITAL, VEDADA PELA LEI 9.099/95. PELAS RAZOES EXPOSTAS, INDEFIRO O PEDIDO DE TUTELA ANTECIPADA. 2) CERTIDAO RETRO: EM QUE PESE SEU TEOR, OBSERVO QUE A MENCIONADA CORRE RESIDE EM AREA RURAL, DE MODO QUE APARENTEMENTE NAO HA IRREGULARIDADE DO ENDERECO. TODAVIA, NO QUE TANGE A REPRESENTACAO PROCESSUAL, DEVERA A AUTORA REGULARIZA-LA EM 5 DIAS, SOB PENA DE EXTINCAO. 3) UMA VEZ CUMPRIDO O ACIMA DETERMINADO, EM ATENCAO AO PRINCIPIO DA CELERIDADE E AO MANIFESTO DESINTERESSE DA PARTE AUTORA NA REALIZACAO DO ATO, DISPENSA-SE A AUDIENCIA DE CONCILIACAO NOS PRESENTES AUTOS E, PONDERANDO-SE QUE A FINALIDADE PRIMORDIAL DO JUIZADO E A TENTATIVA DE COMPOSICAO ENTRE AS PARTES, FACULTO AS PARTES REQUERIDAS A APRESENTACAO DE EVENTUAL PROPOSTA DE ACORDO, NO PRAZO DE QUINZE DIAS. FICA AUTORIZADO A Z. SERVENTIA INFORMAR AS PLATAFORMAS DE ACORDO CREDENCIADAS PELO TJ ACERCA DO AJUIZAMENTO DO PRESENTE FEITO, COM VISTAS A TENTATIVA DE COMPOSICAO AMIGAVEL ENTRE AS PARTES, CASO AS PARTES REQUERIDAS SE TRATEM DE EMPRESAS CONVENIADAS. NAO HAVENDO ANUENCIA DE QUALQUER DAS PARTES QUANTO A DISPENSA DO ATO EM QUESTAO, DEVERA SE MANIFESTAR EM IGUAL PRAZO, SOB PENA DE SE PRESUMIR A CONCORDANCIA. NO CASO DE CONCORDANCIA DA DISPENSA DA AUDIENCIA DE TENTATIVA DE CONCILIACAO, BEM COMO AUSENCIA DE PROPOSTA DE ACORDO PELAS RES, NO MESMO PRAZO DE 15 DIAS, AS REQUERIDAS DEVERAO OFERECER CONTESTACAO, SOB PENA DE REVELIA. DECORRIDO, TORNEM OS AUTOS CONCLUSOS. CITEM-SE E INTIMEM-SE AS PARTES. - ADV: MARCOS DE ANDRADE CARDOSO (OAB 191982/MG)",
                "PublishDate": "2023-12-11T00:00:00",
                "CaptureDate": "2023-12-12T05:56:50"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0912/2023 DATA DA PUBLICACAO: 12/12/2023 NUMERO DO DIARIO: 3875",
                "PublishDate": "2023-12-08T00:00:00",
                "CaptureDate": "2023-12-12T05:56:50"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2023-12-07T00:00:00",
                "CaptureDate": "2023-12-12T05:56:50"
              },
              {
                "Content": "CERTIDAO DE CARTORIO EXPEDIDA CERTIDAO - GENERICA",
                "PublishDate": "2023-12-07T00:00:00",
                "CaptureDate": "2023-12-12T05:56:50"
              },
              {
                "Content": "NAO CONCEDIDA A MEDIDA LIMINAR VISTOS. 1) A MEDIDA CONSTRITIVA PRETENDIDA EM SEDE DE TUTELA PROVISORIA CONFIGURA ARRESTO, INCABIVEL NO JUIZADO, JA QUE PODE VIR A DEMANDAR CITACAO POR EDITAL, CONFORME ENUNCIADO N 43 DO COMUNICADO N 116/2010 DO CONSELHO SUPERVISOR DO SISTEMA DE JUIZADOS ESPECIAIS (DJE 07/12/2010): NA EXECUCAO DE TITULO EXTRAJUDICIAL NAO E POSSIVEL O ARRESTO POR ENVOLVER CITACAO POR EDITAL, VEDADA PELA LEI 9.099/95. PELAS RAZOES EXPOSTAS, INDEFIRO O PEDIDO DE TUTELA ANTECIPADA. 2) CERTIDAO RETRO: EM QUE PESE SEU TEOR, OBSERVO QUE A MENCIONADA CORRE RESIDE EM AREA RURAL, DE MODO QUE APARENTEMENTE NAO HA IRREGULARIDADE DO ENDERECO. TODAVIA, NO QUE TANGE A REPRESENTACAO PROCESSUAL, DEVERA A AUTORA REGULARIZA-LA EM 5 DIAS, SOB PENA DE EXTINCAO. 3) UMA VEZ CUMPRIDO O ACIMA DETERMINADO, EM ATENCAO AO PRINCIPIO DA CELERIDADE E AO MANIFESTO DESINTERESSE DA PARTE AUTORA NA REALIZACAO DO ATO, DISPENSA-SE A AUDIENCIA DE CONCILIACAO NOS PRESENTES AUTOS E, PONDERANDO-SE QUE A FINALIDADE PRIMORDIAL DO JUIZADO E A TENTATIVA DE COMPOSICAO ENTRE AS PARTES, FACULTO AS PARTES REQUERIDAS A APRESENTACAO DE EVENTUAL PROPOSTA DE ACORDO, NO PRAZO DE QUINZE DIAS. FICA AUTORIZADO A Z. SERVENTIA INFORMAR AS PLATAFORMAS DE ACORDO CREDENCIADAS PELO TJ ACERCA DO AJUIZAMENTO DO PRESENTE FEITO, COM VISTAS A TENTATIVA DE COMPOSICAO AMIGAVEL ENTRE AS PARTES, CASO AS PARTES REQUERIDAS SE TRATEM DE EMPRESAS CONVENIADAS. NAO HAVENDO ANUENCIA DE QUALQUER DAS PARTES QUANTO A DISPENSA DO ATO EM QUESTAO, DEVERA SE MANIFESTAR EM IGUAL PRAZO, SOB PENA DE SE PRESUMIR A CONCORDANCIA. NO CASO DE CONCORDANCIA DA DISPENSA DA AUDIENCIA DE TENTATIVA DE CONCILIACAO, BEM COMO AUSENCIA DE PROPOSTA DE ACORDO PELAS RES, NO MESMO PRAZO DE 15 DIAS, AS REQUERIDAS DEVERAO OFERECER CONTESTACAO, SOB PENA DE REVELIA. DECORRIDO, TORNEM OS AUTOS CONCLUSOS. CITEM-SE E INTIMEM-SE AS PARTES.",
                "PublishDate": "2023-12-07T00:00:00",
                "CaptureDate": "2023-12-12T05:56:50"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0912/2023 TEOR DO ATO: VISTOS. 1) A MEDIDA CONSTRITIVA PRETENDIDA EM SEDE DE TUTELA PROVISORIA CONFIGURA ARRESTO, INCABIVEL NO JUIZADO, JA QUE PODE VIR A DEMANDAR CITACAO POR EDITAL, CONFORME ENUNCIADO N 43 DO COMUNICADO N 116/2010 DO CONSELHO SUPERVISOR DO SISTEMA DE JUIZADOS ESPECIAIS (DJE 07/12/2010): NA EXECUCAO DE TITULO EXTRAJUDICIAL NAO E POSSIVEL O ARRESTO POR ENVOLVER CITACAO POR EDITAL, VEDADA PELA LEI 9.099/95. PELAS RAZOES EXPOSTAS, INDEFIRO O PEDIDO DE TUTELA ANTECIPADA. 2) CERTIDAO RETRO: EM QUE PESE SEU TEOR, OBSERVO QUE A MENCIONADA CORRE RESIDE EM AREA RURAL, DE MODO QUE APARENTEMENTE NAO HA IRREGULARIDADE DO ENDERECO. TODAVIA, NO QUE TANGE A REPRESENTACAO PROCESSUAL, DEVERA A AUTORA REGULARIZA-LA EM 5 DIAS, SOB PENA DE EXTINCAO. 3) UMA VEZ CUMPRIDO O ACIMA DETERMINADO, EM ATENCAO AO PRINCIPIO DA CELERIDADE E AO MANIFESTO DESINTERESSE DA PARTE AUTORA NA REALIZACAO DO ATO, DISPENSA-SE A AUDIENCIA DE CONCILIACAO NOS PRESENTES AUTOS E, PONDERANDO-SE QUE A FINALIDADE PRIMORDIAL DO JUIZADO E A TENTATIVA DE COMPOSICAO ENTRE AS PARTES, FACULTO AS PARTES REQUERIDAS A APRESENTACAO DE EVENTUAL PROPOSTA DE ACORDO, NO PRAZO DE QUINZE DIAS. FICA AUTORIZADO A Z. SERVENTIA INFORMAR AS PLATAFORMAS DE ACORDO CREDENCIADAS PELO TJ ACERCA DO AJUIZAMENTO DO PRESENTE FEITO, COM VISTAS A TENTATIVA DE COMPOSICAO AMIGAVEL ENTRE AS PARTES, CASO AS PARTES REQUERIDAS SE TRATEM DE EMPRESAS CONVENIADAS. NAO HAVENDO ANUENCIA DE QUALQUER DAS PARTES QUANTO A DISPENSA DO ATO EM QUESTAO, DEVERA SE MANIFESTAR EM IGUAL PRAZO, SOB PENA DE SE PRESUMIR A CONCORDANCIA. NO CASO DE CONCORDANCIA DA DISPENSA DA AUDIENCIA DE TENTATIVA DE CONCILIACAO, BEM COMO AUSENCIA DE PROPOSTA DE ACORDO PELAS RES, NO MESMO PRAZO DE 15 DIAS, AS REQUERIDAS DEVERAO OFERECER CONTESTACAO, SOB PENA DE REVELIA. DECORRIDO, TORNEM OS AUTOS CONCLUSOS. CITEM-SE E INTIMEM-SE AS PARTES. ADVOGADOS(S): MARCOS DE ANDRADE CARDOSO (OAB 191982/MG)",
                "PublishDate": "2023-12-07T00:00:00",
                "CaptureDate": "2023-12-12T05:56:50"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WSTA.23.71081532-0 TIPO DA PETICAO: PETICOES DIVERSAS DATA: 07/12/2023 16:48",
                "PublishDate": "2023-12-07T00:00:00",
                "CaptureDate": "2023-12-12T05:56:50"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-12-06T00:00:00",
                "CaptureDate": "2023-12-12T05:56:50"
              }
            ],
            "Petitions": [
              {
                "Type": "PETICOES DIVERSAS",
                "Author": "",
                "CreationDate": "2023-12-07T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              }
            ],
            "Decisions": []
          },
          {
            "Number": "10040427620238260323",
            "Type": "PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL",
            "MainSubject": "INDENIZACAO POR DANO MORAL",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "",
            "CourtDistrict": "LORENA",
            "Judge": "VALDIR MARINS ALVES",
            "JudgingBody": "JUIZADO ESPECIAL CIVEL E CRIMINAL",
            "State": "SP",
            "Status": "ATIVO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "INDENIZAÇÃO POR DANO MORAL",
            "InferredCNJSubjectNumber": 7779,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO DO JUIZADO ESPECIAL CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "INDENIZACAO POR DANO MORAL",
              "INDENIZACAO POR DANO MATERIAL"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 13633.04,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-12-11T00:00:00",
            "NoticeDate": "2023-12-06T00:00:00",
            "LastMovementDate": "2023-12-11T00:00:00",
            "CaptureDate": "2023-12-12T14:25:15",
            "LastUpdate": "2023-12-12T14:25:15",
            "NumberOfParties": 6,
            "NumberOfUpdates": 8,
            "LawSuitAge": 84,
            "AverageNumberOfUpdatesPerMonth": 2,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "11289882835",
                "IsPartyActive": true,
                "Name": "VALDIR MARINS ALVES",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-12-12T14:25:15"
              },
              {
                "Doc": "44195668840",
                "IsPartyActive": true,
                "Name": "ESTEFANIA MARIA DE CAMARGO OLIVEIRA",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2023-12-12T14:25:15"
              },
              {
                "Doc": "16540339798",
                "IsPartyActive": true,
                "Name": "LORENA VIEIRA CURTY OLIVEIRA",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "484343",
                  "State": "SP",
                  "SpecificType": "ADVOGADA (REQTE)"
                },
                "LastCaptureDate": "2023-12-12T14:25:15"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-12-12T14:25:15"
              },
              {
                "Doc": "26690373000125",
                "IsPartyActive": true,
                "Name": "SIMPLIC FUNDO DE INVESTIMENTO EM DIREITOS CREDITORIOS NAO PADRONIZADOS",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-12-12T14:25:15"
              },
              {
                "IsPartyActive": true,
                "Name": "SOROCRED CREDITO FINANCIAMENTO E INVESTIMENTO S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2023-12-12T14:25:15"
              }
            ],
            "Updates": [
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2023-12-11T00:00:00",
                "CaptureDate": "2023-12-12T14:25:16"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0767/2023 DATA DA PUBLICACAO: 13/12/2023 NUMERO DO DIARIO: 3876",
                "PublishDate": "2023-12-11T00:00:00",
                "CaptureDate": "2023-12-12T14:25:16"
              },
              {
                "Content": "PROCESSO : 1004042-76.2023.8.26.0323 CLASSE : PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL REQTE : ESTEFANIA MARIA DE CAMARGO OLIVEIRA ADVOGADO : 484343/SP - LORENA VIEIRA CURTY OLIVEIRA REQDO : SOROCRED CREDITO FINANCIAMENTO E INVESTIMENTO S/A VARA : JUIZADO ESPECIAL CIVEL E CRIMINAL",
                "PublishDate": "2023-12-11T00:00:00",
                "CaptureDate": "2023-12-12T14:25:15"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0767/2023 TEOR DO ATO: ANTE O EXPOSTO, INDEFIRO A TUTELA PRETENDIDA. DISPENSO A REALIZACAO DE AUDIENCIA DE CONCILIACAO POR REPUTA-LA INOCUA NO PRESENTE MOMENTO. NOS TERMOS DO ARTIGO 335 DO CODIGO DE PROCESSO CIVIL, CITEM-SE AS PARTES REQUERIDAS, OBSERVANDO AS ADVERTENCIAS DE PRAXE, AS QUAIS PODERAO APRESENTAR CONTESTACAO NO PRAZO ESTABELECIDO POR LEI. SALIENTA-SE QUE A AUSENCIA DE CONTESTACAO ACARRETARA A CONFIGURACAO DA REVELIA E, CONSEQUENTEMENTE, A PRESUNCAO DE VERACIDADE DAS ALEGACOES DE FATO FORMULADAS PELA PARTE AUTORA. SERVIRA A PRESENTE DECISAO, ASSINADA, COMO MANDADO. CITEM-SE. INTIMEM-SE. ADVOGADOS(S): LORENA VIEIRA CURTY OLIVEIRA (OAB 484343/SP)",
                "PublishDate": "2023-12-08T00:00:00",
                "CaptureDate": "2023-12-12T14:25:16"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2023-12-07T00:00:00",
                "CaptureDate": "2023-12-12T14:25:16"
              },
              {
                "Content": "NAO CONCEDIDA A ANTECIPACAO DE TUTELA ANTE O EXPOSTO, INDEFIRO A TUTELA PRETENDIDA. DISPENSO A REALIZACAO DE AUDIENCIA DE CONCILIACAO POR REPUTA-LA INOCUA NO PRESENTE MOMENTO. NOS TERMOS DO ARTIGO 335 DO CODIGO DE PROCESSO CIVIL, CITEM-SE AS PARTES REQUERIDAS, OBSERVANDO AS ADVERTENCIAS DE PRAXE, AS QUAIS PODERAO APRESENTAR CONTESTACAO NO PRAZO ESTABELECIDO POR LEI. SALIENTA-SE QUE A AUSENCIA DE CONTESTACAO ACARRETARA A CONFIGURACAO DA REVELIA E, CONSEQUENTEMENTE, A PRESUNCAO DE VERACIDADE DAS ALEGACOES DE FATO FORMULADAS PELA PARTE AUTORA. SERVIRA A PRESENTE DECISAO, ASSINADA, COMO MANDADO. CITEM-SE. INTIMEM-SE.",
                "PublishDate": "2023-12-07T00:00:00",
                "CaptureDate": "2023-12-12T14:25:16"
              },
              {
                "Content": "EMENDA A INICIAL JUNTADA N PROTOCOLO: WLNA.23.70057823-7 TIPO DA PETICAO: EMENDA A INICIAL DATA: 07/12/2023 19:04",
                "PublishDate": "2023-12-07T00:00:00",
                "CaptureDate": "2023-12-12T14:25:16"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-12-06T00:00:00",
                "CaptureDate": "2023-12-12T14:25:16"
              }
            ],
            "Petitions": [
              {
                "Type": "EMENDA A INICIAL",
                "Author": "",
                "CreationDate": "2023-12-07T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              }
            ],
            "Decisions": []
          },
          {
            "Number": "00194300620238160035",
            "Type": "PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL",
            "MainSubject": "10439 - INDENIZACAO POR DANO MATERIAL",
            "CourtName": "TJPR",
            "CourtLevel": "1",
            "CourtType": "ESPECIAL CIVEL",
            "CourtDistrict": "PINHAIS",
            "Judge": "MOACIR ANTONIO DALA COSTA",
            "JudgingBody": "1 JUIZADO ESPECIAL CIVEL DE SAO JOSE DOS PINHAIS",
            "State": "PR",
            "Status": "INDEFINIDO",
            "LawsuitHostService": "OTHER",
            "InferredCNJSubjectName": "INDENIZAÇÃO POR DANO MATERIAL",
            "InferredCNJSubjectNumber": 7780,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO DO JUIZADO ESPECIAL CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "10439 - INDENIZACAO POR DANO MATERIAL"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": -1,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2023-12-07T00:00:00",
            "NoticeDate": "2023-10-30T00:00:00",
            "LastMovementDate": "2023-12-07T00:00:00",
            "CaptureDate": "2023-12-16T14:36:42",
            "LastUpdate": "2023-12-16T14:36:42",
            "NumberOfParties": 6,
            "NumberOfUpdates": 21,
            "LawSuitAge": 121,
            "AverageNumberOfUpdatesPerMonth": 5,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "IsPartyActive": true,
                "Name": "MOACIR ANTONIO DALA COSTA",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2023-12-16T14:36:42"
              },
              {
                "IsPartyActive": true,
                "Name": "JESSICA CHAGAS",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "POLO ATIVO"
                },
                "LastCaptureDate": "2023-12-16T14:36:42"
              },
              {
                "Doc": "42871760900",
                "IsPartyActive": true,
                "Name": "ADYR TACLA FILHO",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "18688N",
                  "State": "PR",
                  "SpecificType": "ADVOGADO (POLO ATIVO)"
                },
                "LastCaptureDate": "2023-12-16T14:36:42"
              },
              {
                "Doc": "13347016000117",
                "IsPartyActive": true,
                "Name": "FACEBOOK SERVICOS ONLINE DO BRASIL LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "POLO PASSIVO"
                },
                "LastCaptureDate": "2023-12-16T14:36:42"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "POLO PASSIVO"
                },
                "LastCaptureDate": "2023-12-16T14:36:42"
              },
              {
                "IsPartyActive": true,
                "Name": "YCFSHOP TECNOLOGIA EM COMMERCE LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "POLO PASSIVO"
                },
                "LastCaptureDate": "2023-12-16T14:36:42"
              }
            ],
            "Updates": [
              {
                "Content": "PODER JUDICIARIO DO ESTADO DO PARANA COMARCA DA REGIAO METROPOLITANA DE CURITIBA - FORO REGIONAL DE SAO JOSE DOS PINHAIS 1 JUIZADO ESPECIAL CIVEL DE SAO JOSE DOS PINHAIS - PROJUDI RUA JOAO ANGELO CORDEIRO, S/N - CENTRO - SAO JOSE DOS PINHAIS/PR - CEP: 83.005-570 - FONE: 41 34348478 - E-MAIL: SJP1JE@TJPR.JUS.BR AUTOS N. 0019430-06.2023.8.16.0035 PROCESSO: 0019430-06.2023.8.16.0035 CLASSE PROCESSUAL: PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL ASSUNTO PRINCIPAL: INDENIZACAO POR DANO MATERIAL VALOR DA CAUSA: R$2.775,00 POLO ATIVO(S): JESSICA CHAGAS POLO PASSIVO(S): FACEBOOK SERVICOS ONLINE DO BRASIL LTDA STARK BANK S.A. YCFSHOP TECNOLOGIA EM COMMERCE LTDA CONCEDO O PRAZO ADICIONAL DE 10 (DEZ) DIAS A AUTORA PARA OS FINS REQUERIDOS NO PETITORIO DE EVENTO N. 17. INTIMACOES E DILIGENCIAS NECESSARIAS. SAO JOSE DOS PINHAIS, 06 DE DEZEMBRO DE 2023. MOACIR ANTONIO DALA COSTA JUIZ DE DIREITO",
                "PublishDate": "2023-12-07T00:00:00",
                "CaptureDate": "2023-12-16T14:36:42"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA REFERENTE AO EVENTO (SEQ. 18) DEFERIDO O PEDIDO (06/12/2023) E AO EVENTO DE EXPEDICAO SEQ. 19.",
                "PublishDate": "2023-12-06T00:00:00",
                "CaptureDate": "2023-12-16T14:36:58"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO REFERENTE AO EVENTO (SEQ. 18) DEFERIDO O PEDIDO (06/12/2023).",
                "PublishDate": "2023-12-06T00:00:00",
                "CaptureDate": "2023-12-16T14:36:58"
              },
              {
                "Content": "DEFERIDO O PEDIDO . VEICULADO NO DJEN EM 07/12/2023.|PROJUDI - PROCESSO: 0019430-06.2023.8.16.0035 - REF. MOV. 18.1 - ASSINADO DIGITALMENTE POR MOACIR ANTONIO DALLA COSTA:44135483968 06/12/2023: DEFERIDO O PEDIDO. ARQ: DECISAO PODER JUDICIARIO DO ESTADO DO PARANA COMARCA DA REGIAO METROPOLITANA DE CURITIBA - FORO REGIONAL DE SAO JOSE DOS PINHAIS 1 JUIZADO ESPECIAL CIVEL DE SAO JOSE DOS PINHAIS - PROJUDI RUA JOAO ANGELO CORDEIRO, S/N - CENTRO - SAO JOSE DOS PINHAIS/PR - CEP: 83.005-570 - FONE: 41 34348478 - E-MAIL: SJP1JE@TJPR. JUS.BR AUTOS N. 0019430-06.2023.8.16.0035 PROCESSO: 0019430-06.2023.8.16.0035 CLASSE PROCESSUAL: PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL ASSUNTO PRINCIPAL: INDENIZACAO POR DANO MATERIAL VALOR DA CAUSA: R$2.775,00 POLO ATIVO(S): JESSICA CHAGAS POLO PASSIVO(S): FACEBOOK SERVICOS ONLINE DO BRASIL LTDA STARK BANK S.A. YCFSHOP TECNOLOGIA EM COMMERCE LTDA CONCEDO O PRAZO ADICIONAL DE 10 (DEZ) DIAS A AUTORA PARA OS FINS REQUERIDOS NO PETITORIO DE EVENTO N. 17. INTIMACOES E DILIGENCIAS NECESSARIAS. SAO JOSE DOS PINHAIS, 06 DE DEZEMBRO DE 2023. MOACIR ANTONIO DALA COSTA JUIZ DE DIREITO DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJ8QT 9MP7X FD5UM 2PBJB",
                "PublishDate": "2023-12-06T00:00:00",
                "CaptureDate": "2023-12-16T14:36:58"
              },
              {
                "Content": "JUNTADA DE PETICAO DE CUMPRIMENTO DE INTIMACAO CUMPRIMENTO DE INTIMACAO - REFERENTE AO EVENTO PROFERIDO DESPACHO DE MERO EXPEDIENTE (08/11/2023)",
                "PublishDate": "2023-11-30T00:00:00",
                "CaptureDate": "2023-12-16T14:37:04"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO RESPONSAVEL: MOACIR ANTONIO DALA COSTA",
                "PublishDate": "2023-11-29T00:00:00",
                "CaptureDate": "2023-12-16T14:37:04"
              },
              {
                "Content": "EXPEDICAO DE TERMO DE AUDIENCIA REFERENTE AO EVENTO (SEQ. 14) AUDIENCIA DE CONCILIACAO REALIZADA(29/11/2023 09:51:36). IDENTIFICADOR DO CUMPRIMENTO: 0001|PROJUDI - PROCESSO: 0019430-06.2023.8.16.0035 - REF. MOV. 15.1 - ASSINADO DIGITALMENTE POR MOACIR ANTONIO DALLA COSTA:44135483968 29/11/2023: EXPEDICAO DE TERMO DE AUDIENCIA. ARQ: TERMO DE AUDIENCIA PROJUDI - PROCESSO: 0019430-06.2023.8.16.0035 - REF. MOV. 14.1 - ASSINADO DIGITALMENTE POR BRUNO BERTONCELLI SOSSAI 29/11/2023: AUDIENCIA DE CONCILIACAO REALIZADA. ARQ: TERMO DE AUDIENCIA PODER JUDICIARIO DO ESTADO DO PARANA 9 VARA JUDICIAL  JUIZADO ESPECIAL CIVEL FORO REGIONAL DE SAO JOSE DOS PINHAIS RUA JOAO ANGELO CORDEIRO, S/N, FORUM, CENTRO, SAO JOSE DOS PINHAIS (PR) CEP: 83.005-570 FONE/ FAX (41) 3035-8414. AUDIENCIA DE CONCILIACAO VIRTUAL DATA: 29/11/2023 HORARIO: 9:31 HORAS. LOCAL: SALA DE AUDIENCIAS DE CONCILIACAO VIRTUAL DO JUIZADO ESPECIAL CIVEL AUTOS N..: 0019430-06.2023.8.16.0035 PROMOVENTE: JESSICA CHAGAS CPF:012.385.419-92 ADVOGADO: OAB 18688N-PR - ADYR TACLA FILHO PROMOVIDOS: FACEBOOK SERVICOS ONLINE DO BRASIL LTDA CNPJ: ACEBOOK SERVICOS ONLINE DO BRASIL LTDA STARK BANK S.A. CNPJ: 20.018.183/0001-80 YCFSHOP TECNOLOGIA EM COMMERCE LTDA CNPJ 46.558.143/0001-14 SEM ADVOGADOS CONCILIADOR: BRUNO BERTONCELLI SOSSAI DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJ5D8 8XXR6 PUVV4 3GH5D JUIZ SUPERVISOR: DR. MOACIR ANTONIO DALA COSTA. DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJV3G 34SJC BC8XF NVZ7B ABERTA A AUDIENCIA, REALIZADA LIGACAO DE VIDEO VIA APLICATIVO WHATSAPP AS 09 HORAS E 32MINUTOS, VERIFICOU-SE O COMPARECIMENTO DOS ACIMA NOMINADO E A AUSENCIA DOS PROMOVIDOS. OCORREU, EM SEGUIDA, O PROCEDIMENTO ABAIXO MENCIONADO. 1. COMPOSICAO: INICIALMENTE FORAM AS PARTES ESCLARECIDAS SOBRE AS VANTAGENS DA CONCILIACAO, SENDO DEMONSTRADOS OS RISCOS E AS CONSEQUENCIAS DO LITIGIO (LEI N 9.099/95, ART. 21). NA SEQUENCIA, PROPOSTA A CONCILIACAO, RESULTOU INFRUTIFERA, FACE A AUSENCIA DE ACORDO ENTRE AS PARTES. 2 .MANIFESTACAO DO PROMOVENTE: EXPECA CITACAO CONFORME ENDERECO INDICADO NA INICIAL PARA POSTERIOR REDESIGNACAO DO ATO. 3 DELIBERACOES PELO MM JUIZ SUPERVISOR: PROJUDI - PROCESSO: 0019430-06.2023.8.16.0035 - REF. MOV. 15.1 - ASSINADO DIGITALMENTE POR MOACIR ANTONIO DALLA COSTA:44135483968 29/11/2023: EXPEDICAO DE TERMO DE AUDIENCIA. ARQ: TERMO DE AUDIENCIA PROJUDI - PROCESSO: 0019430-06.2023.8.16.0035 - REF. MOV. 14.1 - ASSINADO DIGITALMENTE POR BRUNO BERTONCELLI SOSSAI 29/11/2023: AUDIENCIA DE CONCILIACAO REALIZADA. ARQ: TERMO DE AUDIENCIA A) PROMOVA A SECRETARIA A INCLUSAO DESTE TERMO, AO PROJUDI, DEVIDAMENTE DIGITALIZADO EM FORMATO PDF, CERTIFICANDO-SE. B) CASO AS PARTES AINDA NAO TENHAM JUNTADOS DOCUMENTOS DE REPRESENTACAO, COMO PROCURACAO E/OU SUBSTABELECIMENTO, CARTA DE PREPOSICAO E OS ATOS CONSTITUTIVOS SE PESSOA JURIDICA, CONCEDO O PRAZO DE CINCO DIAS PARA TAL PROPOSITO, O QUE SE FARA EXCLUSIVAMENTE POR DILIGENCIA DA PARTE JUNTO AO SISTEMA PROJUDI. C) VENHAM OS AUTOS CONCLUSOS PARA ANALISE DO(S) PEDIDO(S) REALIZADO(S). FICAM OS PRESENTES INTIMADOS NESTA OPORTUNIDADE. NADA MAIS. ENCERROU-SE A PRESENTE AUDIENCIA AS 09:33 HORAS COM AS FORMALIDADES LEGAIS123. *A PRESENTE ATA DEVIDAMENTE ASSINADA PELO CONCILIADOR SERVE COMO DECLARACAO DE COMPARECIMENTO PARA FINS TRABALHISTAS. DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJ5D8 8XXR6 PUVV4 3GH5D DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJV3G 34SJC BC8XF NVZ7B 1 FICAM ADVERTIDAS AS PARTES QUE HAVENDO NECESSIDADE DE ANEXAR DOCUMENTOS AO PROCESSO, ESTE DEVERA SER VIA PROJUDI, PODENDO A PARTE PESSOALMENTE REQUERER A JUNTADA DO DOCUMENTO UTILIZANDO-SE DO SETOR DE TRIAGEM E CASO A PARTE ESTEJA ASSISTIDA POR ADVOGADO, DEVERA ESTE PROCEDER AS SUAS CUSTAS A INCLUSAO DO DOCUMENTO. 2 FICAM ADVERTIDAS AS PARTES QUE PODERAO SER REALIZADAS INTIMACAO REFERENTES AO PROCESSO VIA EMAIL INFORMADO NESTA OCASIAO E CADASTRADOS NO PROCESSO. 3 FICA CIENTE A PARTE PROMOVIDA QUE PODERA APRESENTAR CONTESTACAO DE FORMA ORAL NA AUDIENCIA DE INSTRUCAO E JULGAMENTO, OU, SENDO A CONTESTACAO ESCRITA, DEVERA ELA SER JUNTADA AO PROCESSO EXCLUSIVAMENTE VIA PROJUDI IMPRETERIVELMENTE ATE A ABERTURA DA AUDIENCIA DE INSTRUCAO E JULGAMENTO E NAO NO DECORRER DESTA.",
                "PublishDate": "2023-11-29T00:00:00",
                "CaptureDate": "2023-12-16T14:37:04"
              },
              {
                "Content": "AUDIENCIA DE CONCILIACAO REALIZADA CONCLUSAO",
                "PublishDate": "2023-11-29T00:00:00",
                "CaptureDate": "2023-12-16T14:37:11"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA REFERENTE AO EVENTO (SEQ. 11) PROFERIDO DESPACHO DE MERO EXPEDIENTE (08/11/2023) E AO EVENTO DE EXPEDICAO SEQ. 12.",
                "PublishDate": "2023-11-08T00:00:00",
                "CaptureDate": "2023-12-16T14:37:11"
              },
              {
                "Content": "EXPEDICAO DE INTIMACAO REFERENTE AO EVENTO (SEQ. 11) PROFERIDO DESPACHO DE MERO EXPEDIENTE (08/11/2023).",
                "PublishDate": "2023-11-08T00:00:00",
                "CaptureDate": "2023-12-16T14:37:11"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE . VEICULADO NO DJEN EM 09/11/2023.|PROJUDI - PROCESSO: 0019430-06.2023.8.16.0035 - REF. MOV. 11.1 - ASSINADO DIGITALMENTE POR MOACIR ANTONIO DALLA COSTA:44135483968 08/11/2023: PROFERIDO DESPACHO DE MERO EXPEDIENTE. ARQ: DESPACHO PODER JUDICIARIO DO ESTADO DO PARANA COMARCA DA REGIAO METROPOLITANA DE CURITIBA - FORO REGIONAL DE SAO JOSE DOS PINHAIS 1 JUIZADO ESPECIAL CIVEL DE SAO JOSE DOS PINHAIS - PROJUDI RUA JOAO ANGELO CORDEIRO, S/N - CENTRO - SAO JOSE DOS PINHAIS/PR - CEP: 83.005-570 - FONE: 41 34348478 - E-MAIL: SJP1JE@TJPR.JUS.BR AUTOS N. 0019430-06.2023.8.16.0035 PROCESSO: 0019430-06.2023.8.16.0035 CLASSE PROCESSUAL: PROCEDIMENTO DO JUIZADO ESPECIAL CIVEL ASSUNTO PRINCIPAL: INDENIZACAO POR DANO MATERIAL VALOR DA CAUSA: R$2.775,00 POLO ATIVO(S): JESSICA CHAGAS POLO PASSIVO(S): FACEBOOK SERVICOS ONLINE DO BRASIL LTDA STARK BANK S.A. YCFSHOP TECNOLOGIA EM COMMERCE LTDA PRIMEIRAMENTE, INTIME-SE A PARTE AUTORA PARA APRESENTAR COMPROVANTE IDONEO DE RESIDENCIA ATUALIZADO, BEM COMO OS DOCUMENTOS PESSOAIS NO PRAZO DE 15 (QUINZE) DIAS, SOB PENA DE INDEFERIMENTO DA INICIAL (ART. 321 DO CPC). CUMPRIDA A DETERMINACAO SUPRA, VENHAM-ME OS AUTOS CONCLUSOS PARA DELIBERACOES. CANCELE-SE A AUDIENCIA ORA DESIGNADA EM RAZAO DA AUSENCIA DE TEMPO HABIL PARA CITACAO DOS REUS. INTIMACOES E DILIGENCIAS NECESSARIAS. DOCUMENTO ASSINADO DIGITALMENTE, CONFORME MP N 2.200-2/2001, LEI 11.419/2006, RESOLUCAO DO PROJUDI, TJPR/OE VALIDACAO DESTE EM HTTPS://PROJUDI.TJPR.JUS.BR/PROJUDI/ - IDENTIFICADOR: PJ5LC C2ZEQ S597U 2AZTB SAO JOSE DOS PINHAIS, 08 DE NOVEMBRO DE 2023. MOACIR ANTONIO DALA COSTA JUIZ DE DIREITO",
                "PublishDate": "2023-11-08T00:00:00",
                "CaptureDate": "2023-12-16T14:37:11"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO RESPONSAVEL: MOACIR ANTONIO DALA COSTA",
                "PublishDate": "2023-11-07T00:00:00",
                "CaptureDate": "2023-12-16T14:37:17"
              },
              {
                "Content": "RECEBIDOS OS AUTOS RECEBIDO DO(A) DISTRIBUIDOR",
                "PublishDate": "2023-10-31T00:00:00",
                "CaptureDate": "2023-12-16T14:37:17"
              },
              {
                "Content": "JUNTADA DE ANOTACAO DE DISTRIBUICAO",
                "PublishDate": "2023-10-31T00:00:00",
                "CaptureDate": "2023-12-16T14:37:17"
              },
              {
                "Content": "CONFIRMADA A INTIMACAO ELETRONICA REFERENTE AO EVENTO (SEQ. 6) AUDIENCIA DE CONCILIACAO DESIGNADA (30/10/2023).",
                "PublishDate": "2023-10-30T00:00:00",
                "CaptureDate": "2023-12-16T14:37:17"
              },
              {
                "Content": "AUDIENCIA DE CONCILIACAO DESIGNADA (AGENDADA PARA: 29 DE NOVEMBRO DE 2023 AS 11:00, EM 1 JUIZADO ESPECIAL CIVEL DE SAO JOSE DOS PINHAIS, MODALIDADE: VIRTUAL)",
                "PublishDate": "2023-10-30T00:00:00",
                "CaptureDate": "2023-12-16T14:37:17"
              },
              {
                "Content": "RECEBIDOS OS AUTOS",
                "PublishDate": "2023-10-30T00:00:00",
                "CaptureDate": "2023-12-16T14:37:17"
              },
              {
                "Content": "REMETIDOS OS AUTOS PARA DISTRIBUIDOR REGISTRO DE DISTRIBUICAO",
                "PublishDate": "2023-10-30T00:00:00",
                "CaptureDate": "2023-12-16T14:37:17"
              },
              {
                "Content": "DISTRIBUIDO POR SORTEIO 1 JUIZADO ESPECIAL CIVEL DE SAO JOSE DOS PINHAIS",
                "PublishDate": "2023-10-30T00:00:00",
                "CaptureDate": "2023-12-16T14:37:17"
              },
              {
                "Content": "AUTOS INCLUIDOS NO JUIZO 100% DIGITAL",
                "PublishDate": "2023-10-30T00:00:00",
                "CaptureDate": "2023-12-16T14:37:17"
              },
              {
                "Content": "JUNTADA DE PETICAO DE INICIAL",
                "PublishDate": "2023-10-30T00:00:00",
                "CaptureDate": "2023-12-16T14:37:17"
              }
            ],
            "Petitions": [],
            "Decisions": []
          },
          {
            "Number": "10442807620238260602",
            "Type": "PROCEDIMENTO COMUM",
            "MainSubject": "INDENIZACAO POR DANO MORAL",
            "CourtName": "TJSP",
            "CourtLevel": "1",
            "CourtType": "CIVEL",
            "CourtDistrict": "SOROCABA",
            "Judge": "CECILIA DE CARVALHO CONTRERA MASSAGLI",
            "JudgingBody": "3 VARA CIVEL",
            "State": "SP",
            "Status": "ATIVO",
            "LawsuitHostService": "ESAJ",
            "InferredCNJSubjectName": "INDENIZAÇÃO POR DANO MORAL",
            "InferredCNJSubjectNumber": 7779,
            "InferredCNJProcedureTypeName": "PROCEDIMENTO COMUM CÍVEL",
            "InferredBroadCNJSubjectName": "DIREITO DO CONSUMIDOR",
            "InferredBroadCNJSubjectNumber": 1156,
            "OtherSubjects": [
              "INDENIZACAO POR DANO MORAL"
            ],
            "NumberOfVolumes": 0,
            "NumberOfPages": 0,
            "Value": 70949.6,
            "ResJudicataDate": "0001-01-01T00:00:00",
            "CloseDate": "0001-01-01T00:00:00",
            "RedistributionDate": "0001-01-01T00:00:00",
            "PublicationDate": "2024-01-10T00:00:00",
            "NoticeDate": "2023-11-20T00:00:00",
            "LastMovementDate": "2024-01-11T00:00:00",
            "CaptureDate": "2024-01-12T02:09:18",
            "LastUpdate": "2024-01-12T02:09:18",
            "NumberOfParties": 7,
            "NumberOfUpdates": 12,
            "LawSuitAge": 100,
            "AverageNumberOfUpdatesPerMonth": 3,
            "ReasonForConcealedData": 0,
            "Parties": [
              {
                "Doc": "22541393806",
                "IsPartyActive": true,
                "Name": "CECILIA DE CARVALHO CONTRERA MASSAGLI",
                "Polarity": "NEUTRAL",
                "Type": "REPORTER",
                "PartyDetails": {
                  "SpecificType": "JUIZ"
                },
                "LastCaptureDate": "2024-01-12T02:09:18"
              },
              {
                "IsPartyActive": true,
                "Name": "MARCELO NUNES DE LIMA",
                "Polarity": "ACTIVE",
                "Type": "CLAIMANT",
                "PartyDetails": {
                  "SpecificType": "REQTE"
                },
                "LastCaptureDate": "2024-01-12T02:09:18"
              },
              {
                "Doc": "07446073969",
                "IsPartyActive": true,
                "Name": "TABATA RIBEIRO BRITO MIQUELETTI",
                "Polarity": "NEUTRAL",
                "Type": "LAWYER",
                "PartyDetails": {
                  "OAB": "87889",
                  "State": "PR",
                  "SpecificType": "ADVOGADA (REQTE)"
                },
                "LastCaptureDate": "2024-01-12T02:09:18"
              },
              {
                "Doc": "48472928000103",
                "IsPartyActive": true,
                "Name": "KENDO SERVICOS DIGITAIS E INTERMEDIACAO DE NEGOCIOS LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2024-01-12T02:09:18"
              },
              {
                "Doc": "20018183000180",
                "IsPartyActive": true,
                "Name": "STARK BANK S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2024-01-12T02:09:18"
              },
              {
                "Doc": "48689840000130",
                "IsPartyActive": true,
                "Name": "CASH PAY MEIOS DE PAGAMENTO LTDA",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2024-01-12T02:09:18"
              },
              {
                "Doc": "35624319000172",
                "IsPartyActive": true,
                "Name": "MK DIGITAL BANK INSTITUICAO DE PAGAMENTO S A",
                "Polarity": "PASSIVE",
                "Type": "CLAIMED",
                "PartyDetails": {
                  "SpecificType": "REQDO"
                },
                "LastCaptureDate": "2024-01-12T02:09:18"
              }
            ],
            "Updates": [
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0002/2024 DATA DA PUBLICACAO: 22/01/2024 NUMERO DO DIARIO: 3884",
                "PublishDate": "2024-01-11T00:00:00",
                "CaptureDate": "2024-01-12T02:09:18"
              },
              {
                "Content": "PROCESSO 1044280-76.2023.8.26.0602 - PROCEDIMENTO COMUM CIVEL - INDENIZACAO POR DANO MORAL - MARCELO NUNES DE LIMA - VISTOS. VISTOS. FLS. 109: INDEFIRO O BENEFICIO DA GRATUIDADE DA JUSTICA, UMA VEZ QUE AUSENTES OS REQUISITOS AUTORIZADORES. A DECLARACAO DE POBREZA GERA APENAS PRESUNCAO RELATIVA DE QUE A PARTE NAO DISPOE DE RECURSOS PARA ARCAR COM AS CUSTAS E DESPESAS PROCESSUAIS, PRESUNCAO QUE PODE SER ILIDIDA DIANTE DE INDICIOS DA EXISTENCIA DE CAPACIDADE FINANCEIRA. CUMPRE SALIENTAR, QUE A DEFENSORIA PUBLICA DO ESTADO DE SAO PAULO, UTILIZA COMO CRITERIO BASILAR A CONCESSAO DA ASSISTENCIA JURIDICA GRATUITA, A PERCEPCAO, POR PESSOA DO GRUPO FAMILIAR, DE TRES SALARIOS MINIMOS MENSAIS. NESSE SENTIDO E A JURISPRUDENCIA DO TRIBUNAL DE JUSTICA DO ESTADO DE SAO PAULO: AGRAVO DE INSTRUMENTO. CUMPRIMENTO DE SENTENCA. ACAO DE REINTEGRACAO DE POSSE CUMULADA COM OBRIGACAO DE FAZER. DECISAO QUE INDEFERIU A GRATUIDADE DA JUSTICA. INCONFORMISMO DA PARTE AGRAVANTE. DOCUMENTOS CARREADOS AOS AUTOS QUE DEMONSTRAM RENDIMENTOS SUPERIORES A TRES SALARIOS MINIMOS, TETO ESSE EXERCIDO PELA DEFENSORIA PUBLICA DO ESTADO DE SAO PAULO PARA O PATROCINIO DE PESSOAS FINANCEIRAMENTE HIPOSSUFICIENTES. DECISAO MANTIDA. RECURSO DESPROVIDO.(TJSP; AGRAVO DE INSTRUMENTO 2210175-35.2023.8.26.0000; RELATOR (A):ROGERIO MURILLO PEREIRA CIMINO; ORGAO JULGADOR: 27 CAMARA DE DIREITO PRIVADO; FORO DE PAULINIA -1 VARA; DATA DO JULGAMENTO: 28/09/2023; DATA DE REGISTRO: 28/09/2023) NO CASO DOS AUTOS, FOI JUNTADO EXTRATO QUE DEMONSTRA QUE O REQUERENTE AUFERIU EM NOVEMBRO DE 2023 O VALOR DE R$2.601,78 A TITULO DE SALARIO E TEVE DEPOSITOS NO MONTANTE DE R$5.755,56, QUANTIA SUPERIOR AQUELA SUPRAMENCIONADA. DIANTE DO EXPOSTO, PROVIDENCIE A PARTE AUTORA, NO PRAZO DE 15 (QUINZE) DIAS, O RECOLHIMENTO DAS CUSTAS PROCESSUAIS. NO SILENCIO, REMETAM- SE OS AUTOS AO DISTRIBUIDOR PARA CANCELAMENTO DA DISTRIBUICAO. INTIME-SE. INT.. - ADV: TABATA RIBEIRO BRITO MIQUELETTI (OAB 505978/SP)",
                "PublishDate": "2024-01-10T00:00:00",
                "CaptureDate": "2024-01-12T02:09:18"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0002/2024 TEOR DO ATO: VISTOS. VISTOS. FLS. 109: INDEFIRO O BENEFICIO DA GRATUIDADE DA JUSTICA, UMA VEZ QUE AUSENTES OS REQUISITOS AUTORIZADORES. A DECLARACAO DE POBREZA GERA APENAS PRESUNCAO RELATIVA DE QUE A PARTE NAO DISPOE DE RECURSOS PARA ARCAR COM AS CUSTAS E DESPESAS PROCESSUAIS, PRESUNCAO QUE PODE SER ILIDIDA DIANTE DE INDICIOS DA EXISTENCIA DE CAPACIDADE FINANCEIRA. CUMPRE SALIENTAR, QUE A DEFENSORIA PUBLICA DO ESTADO DE SAO PAULO, UTILIZA COMO CRITERIO BASILAR A CONCESSAO DA ASSISTENCIA JURIDICA GRATUITA, A PERCEPCAO, POR PESSOA DO GRUPO FAMILIAR, DE TRES SALARIOS MINIMOS MENSAIS. NESSE SENTIDO E A JURISPRUDENCIA DO TRIBUNAL DE JUSTICA DO ESTADO DE SAO PAULO: \"AGRAVO DE INSTRUMENTO. CUMPRIMENTO DE SENTENCA. ACAO DE REINTEGRACAO DE POSSE CUMULADA COM OBRIGACAO DE FAZER. DECISAO QUE INDEFERIU A GRATUIDADE DA JUSTICA. INCONFORMISMO DA PARTE AGRAVANTE. DOCUMENTOS CARREADOS AOS AUTOS QUE DEMONSTRAM RENDIMENTOS SUPERIORES A TRES SALARIOS MINIMOS, TETO ESSE EXERCIDO PELA DEFENSORIA PUBLICA DO ESTADO DE SAO PAULO PARA O PATROCINIO DE PESSOAS FINANCEIRAMENTE HIPOSSUFICIENTES. DECISAO MANTIDA. RECURSO DESPROVIDO.\"(TJSP; AGRAVO DE INSTRUMENTO 2210175-35.2023.8.26.0000; RELATOR (A):ROGERIO MURILLO PEREIRA CIMINO; ORGAO JULGADOR: 27 CAMARA DE DIREITO PRIVADO; FORO DE PAULINIA -1 VARA; DATA DO JULGAMENTO: 28/09/2023; DATA DE REGISTRO: 28/09/2023) NO CASO DOS AUTOS, FOI JUNTADO EXTRATO QUE DEMONSTRA QUE O REQUERENTE AUFERIU EM NOVEMBRO DE 2023 O VALOR DE R$2.601,78 A TITULO DE SALARIO E TEVE DEPOSITOS NO MONTANTE DE R$5.755,56, QUANTIA SUPERIOR AQUELA SUPRAMENCIONADA. DIANTE DO EXPOSTO, PROVIDENCIE A PARTE AUTORA, NO PRAZO DE 15 (QUINZE) DIAS, O RECOLHIMENTO DAS CUSTAS PROCESSUAIS. NO SILENCIO, REMETAM-SE OS AUTOS AO DISTRIBUIDOR PARA CANCELAMENTO DA DISTRIBUICAO. INTIME-SE. INT.. ADVOGADOS(S): TABATA RIBEIRO BRITO MIQUELETTI (OAB 505978/SP)",
                "PublishDate": "2024-01-08T00:00:00",
                "CaptureDate": "2024-01-12T02:09:18"
              },
              {
                "Content": "PROFERIDAS OUTRAS DECISOES NAO ESPECIFICADAS VISTOS. VISTOS. FLS. 109: INDEFIRO O BENEFICIO DA GRATUIDADE DA JUSTICA, UMA VEZ QUE AUSENTES OS REQUISITOS AUTORIZADORES. A DECLARACAO DE POBREZA GERA APENAS PRESUNCAO RELATIVA DE QUE A PARTE NAO DISPOE DE RECURSOS PARA ARCAR COM AS CUSTAS E DESPESAS PROCESSUAIS, PRESUNCAO QUE PODE SER ILIDIDA DIANTE DE INDICIOS DA EXISTENCIA DE CAPACIDADE FINANCEIRA. CUMPRE SALIENTAR, QUE A DEFENSORIA PUBLICA DO ESTADO DE SAO PAULO, UTILIZA COMO CRITERIO BASILAR A CONCESSAO DA ASSISTENCIA JURIDICA GRATUITA, A PERCEPCAO, POR PESSOA DO GRUPO FAMILIAR, DE TRES SALARIOS MINIMOS MENSAIS. NESSE SENTIDO E A JURISPRUDENCIA DO TRIBUNAL DE JUSTICA DO ESTADO DE SAO PAULO: \"AGRAVO DE INSTRUMENTO. CUMPRIMENTO DE SENTENCA. ACAO DE REINTEGRACAO DE POSSE CUMULADA COM OBRIGACAO DE FAZER. DECISAO QUE INDEFERIU A GRATUIDADE DA JUSTICA. INCONFORMISMO DA PARTE AGRAVANTE. DOCUMENTOS CARREADOS AOS AUTOS QUE DEMONSTRAM RENDIMENTOS SUPERIORES A TRES SALARIOS MINIMOS, TETO ESSE EXERCIDO PELA DEFENSORIA PUBLICA DO ESTADO DE SAO PAULO PARA O PATROCINIO DE PESSOAS FINANCEIRAMENTE HIPOSSUFICIENTES. DECISAO MANTIDA. RECURSO DESPROVIDO.\"(TJSP; AGRAVO DE INSTRUMENTO 2210175-35.2023.8.26.0000; RELATOR (A):ROGERIO MURILLO PEREIRA CIMINO; ORGAO JULGADOR: 27 CAMARA DE DIREITO PRIVADO; FORO DE PAULINIA -1 VARA; DATA DO JULGAMENTO: 28/09/2023; DATA DE REGISTRO: 28/09/2023) NO CASO DOS AUTOS, FOI JUNTADO EXTRATO QUE DEMONSTRA QUE O REQUERENTE AUFERIU EM NOVEMBRO DE 2023 O VALOR DE R$2.601,78 A TITULO DE SALARIO E TEVE DEPOSITOS NO MONTANTE DE R$5.755,56, QUANTIA SUPERIOR AQUELA SUPRAMENCIONADA. DIANTE DO EXPOSTO, PROVIDENCIE A PARTE AUTORA, NO PRAZO DE 15 (QUINZE) DIAS, O RECOLHIMENTO DAS CUSTAS PROCESSUAIS. NO SILENCIO, REMETAM-SE OS AUTOS AO DISTRIBUIDOR PARA CANCELAMENTO DA DISTRIBUICAO. INTIME-SE. INT..",
                "PublishDate": "2023-12-19T00:00:00",
                "CaptureDate": "2024-01-12T02:09:18"
              },
              {
                "Content": "CONCLUSOS PARA DECISAO",
                "PublishDate": "2023-12-15T00:00:00",
                "CaptureDate": "2024-01-12T02:09:18"
              },
              {
                "Content": "PETICAO JUNTADA N PROTOCOLO: WSCB.23.70537137-1 TIPO DA PETICAO: PETICAO INTERMEDIARIA DATA: 14/12/2023 13:12",
                "PublishDate": "2023-12-14T00:00:00",
                "CaptureDate": "2024-01-12T02:09:18"
              },
              {
                "Content": "CERTIDAO DE PUBLICACAO EXPEDIDA RELACAO: 0914/2023 DATA DA PUBLICACAO: 24/11/2023 NUMERO DO DIARIO: 3864",
                "PublishDate": "2023-11-23T00:00:00",
                "CaptureDate": "2024-01-12T02:09:18"
              },
              {
                "Content": "REMETIDO AO DJE RELACAO: 0914/2023 TEOR DO ATO: VISTOS. A DECLARACAO DE POBREZA GERA APENAS PRESUNCAO RELATIVA DE QUE A PARTE NAO DISPOE DE RECURSOS PARA ARCAR COM AS CUSTAS E DESPESAS PROCESSUAIS, PRESUNCAO QUE PODE SER ILIDIDA DIANTE DE INDICIOS DA EXISTENCIA DE CAPACIDADE FINANCEIRA. PARA A ANALISE DO PEDIDO DE JUSTICA GRATUITA PROVIDENCIE A PARTE AUTORA A APRESENTACAO DE COMPROVANTE DE SUA RENDA MENSAL, DOS TRES ULTIMOS MESES, BEM COMO A COPIA DE SUA ULTIMA DECLARACAO DE IMPOSTO DE RENDA (OU COMPROVAR A CONDICAO DE ISENTA), NOS TERMOS DO ARTIGO 99, PARAGRAFO 2, DO CPC, SOB PENA DE INDEFERIMENTO DO BENEFICIO. PRAZO DE 15 DIAS, SOB PENA DE PRECLUSAO. NO MESMO PRAZO, CASO DESISTA DO PEDIDO DE ASSISTENCIA, PODERA A AUTORA PROCEDER AO RECOLHIMENTO DA CUSTAS INICIAIS (1% SOBRE O VALOR DA CAUSA, OBSERVANDO-SE O VALOR MINIMO DE 5 UFESPS, DEVENDO INDICAR O NUMERO DA GUIA DARE NO MOMENTO DO PETICIONAMENTO PARA INUTILIZACAO AUTOMATICA DA GUIA) E DESPESAS PROCESSUAIS PARA CITACAO (AR DIGITAL -ARTIGO 247, CAPUT, DO CPC), SEM NOVA INTIMACAO. INT. ADVOGADOS(S): TABATA RIBEIRO BRITO MIQUELETTI (OAB 87889/PR)",
                "PublishDate": "2023-11-22T00:00:00",
                "CaptureDate": "2024-01-12T02:09:18"
              },
              {
                "Content": "DOCUMENTO JUNTADO",
                "PublishDate": "2023-11-21T00:00:00",
                "CaptureDate": "2024-01-12T02:09:18"
              },
              {
                "Content": "CONCLUSOS PARA DESPACHO",
                "PublishDate": "2023-11-21T00:00:00",
                "CaptureDate": "2024-01-12T02:09:18"
              },
              {
                "Content": "PROFERIDO DESPACHO DE MERO EXPEDIENTE VISTOS. A DECLARACAO DE POBREZA GERA APENAS PRESUNCAO RELATIVA DE QUE A PARTE NAO DISPOE DE RECURSOS PARA ARCAR COM AS CUSTAS E DESPESAS PROCESSUAIS, PRESUNCAO QUE PODE SER ILIDIDA DIANTE DE INDICIOS DA EXISTENCIA DE CAPACIDADE FINANCEIRA. PARA A ANALISE DO PEDIDO DE JUSTICA GRATUITA PROVIDENCIE A PARTE AUTORA A APRESENTACAO DE COMPROVANTE DE SUA RENDA MENSAL, DOS TRES ULTIMOS MESES, BEM COMO A COPIA DE SUA ULTIMA DECLARACAO DE IMPOSTO DE RENDA (OU COMPROVAR A CONDICAO DE ISENTA), NOS TERMOS DO ARTIGO 99, PARAGRAFO 2, DO CPC, SOB PENA DE INDEFERIMENTO DO BENEFICIO. PRAZO DE 15 DIAS, SOB PENA DE PRECLUSAO. NO MESMO PRAZO, CASO DESISTA DO PEDIDO DE ASSISTENCIA, PODERA A AUTORA PROCEDER AO RECOLHIMENTO DA CUSTAS INICIAIS (1% SOBRE O VALOR DA CAUSA, OBSERVANDO-SE O VALOR MINIMO DE 5 UFESPS, DEVENDO INDICAR O NUMERO DA GUIA DARE NO MOMENTO DO PETICIONAMENTO PARA INUTILIZACAO AUTOMATICA DA GUIA) E DESPESAS PROCESSUAIS PARA CITACAO (AR DIGITAL -ARTIGO 247, CAPUT, DO CPC), SEM NOVA INTIMACAO. INT.",
                "PublishDate": "2023-11-21T00:00:00",
                "CaptureDate": "2024-01-12T02:09:18"
              },
              {
                "Content": "DISTRIBUIDO LIVREMENTE (POR SORTEIO) (MOVIMENTACAO EXCLUSIVA DO DISTRIBUIDOR)",
                "PublishDate": "2023-11-20T00:00:00",
                "CaptureDate": "2024-01-12T02:09:18"
              }
            ],
            "Petitions": [
              {
                "Type": "PETICAO INTERMEDIARIA",
                "Author": "",
                "CreationDate": "2023-12-14T00:00:00",
                "JoinedDate": "0001-01-01T00:00:00"
              }
            ],
            "Decisions": []
          }
        ],
        "TotalLawsuits": 552,
        "TotalLawsuitsAsAuthor": 19,
        "TotalLawsuitsAsDefendant": 528,
        "TotalLawsuitsAsOther": 5,
        "FirstLawsuitDate": "2018-11-15T00:00:00",
        "LastLawsuitDate": "2023-12-06T00:00:00",
        "Last30DaysLawsuits": 0,
        "Last90DaysLawsuits": 5,
        "Last180DaysLawsuits": 35,
        "Last365DaysLawsuits": 39,
        "NextPageId": "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE3MDkxNjM5NzUsIlBhZ2luYXRpb25JZCI6IjIiLCJQYWdpbmF0aW9uVHlwZSI6ImludCIsIlVzZXJOYW1lIjoiIiwiUXVlcnlJbnB1dCI6IjIwMDE4MTgzMDAwMTgwIiwiTGltaXQiOjEwMCwiVG90YWxQcm9jZXNzZWQiOjAsIlRvdGFsIjo1NTJ9._wNn1o7HIL9f83nS97qT88AxnoTqha4rK6sHaico6kU"
      },
      "createdAt": "2024-02-28T20:46:17.992Z",
      "updatedAt": "2024-02-28T20:46:17.992Z"
    },
    "cade": {
      "_id": "65df9bc459af913ca758ded4",
      "emailClient": "superadmin@gueno.com",
      "email": "superadmin@gueno.com",
      "status": "IN_PROGRESS",
      "type": "CADE",
      "entity": "BUSINESS",
      "checkDetails": {
        "information": "Check CADE out of service, please contact support team."
      },
      "createdAt": "2024-02-28T20:47:00.487Z",
      "updatedAt": "2024-02-28T20:47:00.487Z"
    }
  }
}

export default kybDetails;
